/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: DateTime; output: DateTime };
  JSON: { input: any; output: any };
  bigint: { input: number; output: number };
  date: { input: string; output: string };
  float8: { input: number; output: number };
  jsonb: { input: any; output: any };
  numeric: { input: number; output: number };
  timestamp: { input: string; output: string };
  timestamptz: { input: string; output: string };
  uuid: { input: string; output: string };
  vector: { input: any; output: any };
};

export type AcceptAutofillReportOutput = {
  report_question_ids: Array<ReportQuestionId>;
};

export type ActionImpactDataOutput = {
  action_id: Scalars['Int']['output'];
  co2_abatement_costs: Scalars['Float']['output'];
  modification_impact: ModificationImpactUnion;
  payback_period: Scalars['Float']['output'];
  total_estimated_cost: Scalars['Float']['output'];
  total_floor_area?: Maybe<Scalars['Float']['output']>;
  total_renovation_cost: Scalars['Float']['output'];
  total_subsidy_cost: Scalars['Float']['output'];
};

export type ActionParametersUnion =
  | CreateVentilationRenovationParametersUnionMember
  | CustomActionParametersUnionMember
  | EnergySystemRouteParametersUnionMember
  | EnvelopeParametersUnionMember
  | ExclusionNoteParametersUnionMember
  | HydraulicBalancingParametersUnionMember
  | MaintenanceActionParametersUnionMember
  | SolarParametersUnionMember
  | SystemParametersUnionMember
  | VentilationRenovationParametersUnionMember;

export type ActionPlanImpactDataOutput = {
  cost_by_renovation_category?: Maybe<CostByRenovationCategoryOutput>;
  implementation_to: Scalars['DateTime']['output'];
  modification_impact: ModificationImpactUnion;
  total_estimated_cost: Scalars['Float']['output'];
  total_floor_area?: Maybe<Scalars['Float']['output']>;
  total_renovation_cost: Scalars['Float']['output'];
  total_subsidy_cost: Scalars['Float']['output'];
};

export type ActionPlanImpactTrendsAnnotationOutput = {
  action_id?: Maybe<Scalars['Int']['output']>;
  annotation_type: action_plan_impact_trends_annotation_enum;
  value: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type ActionPlanImpactTrendsOutput = {
  co2_emissions: ActionPlanImpactTrendsUnion;
  custom_targets?: Maybe<CustomTargetResult>;
  final_energy: ActionPlanImpactTrendsUnion;
  primary_energy: ActionPlanImpactTrendsWithoutTargetPathOutput;
  total_investment_cost: Scalars['Float']['output'];
  trend_start_year: Scalars['Int']['output'];
};

export type ActionPlanImpactTrendsStrandingYearsOutput = {
  end_year: Scalars['Int']['output'];
  start_year: Scalars['Int']['output'];
};

export type ActionPlanImpactTrendsUnion =
  | ActionPlanImpactTrendsWithTargetPathOutput
  | ActionPlanImpactTrendsWithoutTargetPathOutput;

export type ActionPlanImpactTrendsWithTargetPathOutput = {
  after_actions_path: Array<Scalars['Float']['output']>;
  annotations: Array<ActionPlanImpactTrendsAnnotationOutput>;
  before_actions_path: Array<Scalars['Float']['output']>;
  exclusion_note_implementation_year?: Maybe<Scalars['Int']['output']>;
  stranding_ranges: Array<ActionPlanImpactTrendsStrandingYearsOutput>;
  target_path: Array<Scalars['Float']['output']>;
  type: action_plan_impact_type_enum;
};

export type ActionPlanImpactTrendsWithoutTargetPathOutput = {
  after_actions_path: Array<Scalars['Float']['output']>;
  annotations: Array<ActionPlanImpactTrendsAnnotationOutput>;
  before_actions_path: Array<Scalars['Float']['output']>;
  exclusion_note_implementation_year?: Maybe<Scalars['Int']['output']>;
  type: action_plan_impact_type_enum;
};

export type ActionPlanInconsistenciesOutput = {
  energy_supplier_inconsistencies: Array<emission_certificate_energy_source_type_enum>;
};

export type ActionPlanListOrderByInput = {
  street?: InputMaybe<OrderDirection>;
};

export type ActionPlanListOutput = {
  action_plans: Array<ActionPlanListRow>;
  count: Scalars['Int']['output'];
};

export type ActionPlanListRow = {
  action_plan?: Maybe<action_plan>;
  id: Scalars['Int']['output'];
  modification_impact: ModificationImpactActionPlan;
};

export type ActionPlanMetricsOutput = {
  action_plan: ActionPlanImpactDataOutput;
  actions: Array<ActionImpactDataOutput>;
};

export type AllPerspectivesScope123Co2EmissionsOutput = {
  landlord?: Maybe<Scope123Co2EmissionsOutput>;
  tenant?: Maybe<Scope123Co2EmissionsOutput>;
  wholeBuilding?: Maybe<Scope123Co2EmissionsOutput>;
};

export type AnalyzeBuildingCrremAnalysisOutput = {
  buildingModelTransitions: Array<BuildingModelTransitionOutput>;
  co2Emissions: Scalars['Float']['output'];
  co2Path: PathOutput;
  co2TargetPath: Array<Scalars['Float']['output']>;
  cumulativeExcessEmissions: Scalars['Float']['output'];
  energyPath: PathOutput;
  energyTargetPath: Array<Scalars['Float']['output']>;
  excessEmissionCostPath: Array<Scalars['Float']['output']>;
  scope123Co2Emissions: AllPerspectivesScope123Co2EmissionsOutput;
  strandingYear?: Maybe<Scalars['Int']['output']>;
  yearOfExcedance?: Maybe<Scalars['Int']['output']>;
};

export type AnalyzeBuildingCrremOutput = {
  analysisType: emission_factor_type_enum;
  climateRisks: Array<ClimateRiskOutput>;
  co2CostDistributionPath: Co2CostDistributionOutput;
  co2CostPath: PathOutput;
  crremAnalysis: AnalyzeBuildingCrremAnalysisOutput;
  customTargetPath?: Maybe<CustomTargetPathOutput>;
  customTargets?: Maybe<CustomTargetResult>;
  efficiencyClass: efficiency_class_enum;
  energyConsumers: Array<EnergyConsumerBuildingDataOutput>;
  energyCostPath: PathOutput;
  euTaxonomyCompliance: eu_taxonomy_compliance_enum;
  finalEnergy: Scalars['Float']['output'];
  floorAreaByClassOfUse: Array<FloorAreaByClassOfUseOutput>;
  heatingDemand?: Maybe<Scalars['Float']['output']>;
  primaryEnergy: Scalars['Float']['output'];
  slfAnalysis: SlfComplianceAnalysisOutput;
  taxBracket: tax_bracket_enum;
};

export type AnalyzeBuildingNationalEnergyLawAnalysisOutput = {
  buildingModelTransitions: Array<BuildingModelTransitionOutput>;
  co2Emissions: Scalars['Float']['output'];
  co2Path: PathOutput;
  energyPath: PathOutput;
};

export type AnalyzeBuildingNationalEnergyLawOutput = {
  analysisType: emission_factor_type_enum;
  climateRisks: Array<ClimateRiskOutput>;
  co2CostDistributionPath: Co2CostDistributionOutput;
  co2CostPath: PathOutput;
  customTargets?: Maybe<CustomTargetResult>;
  efficiencyClass: efficiency_class_enum;
  energyConsumers: Array<EnergyConsumerBuildingDataOutput>;
  energyCostPath: PathOutput;
  euTaxonomyCompliance: eu_taxonomy_compliance_enum;
  finalEnergy: Scalars['Float']['output'];
  floorAreaByClassOfUse: Array<FloorAreaByClassOfUseOutput>;
  heatingDemand?: Maybe<Scalars['Float']['output']>;
  nationalEnergyLawAnalysis: AnalyzeBuildingNationalEnergyLawAnalysisOutput;
  primaryEnergy: Scalars['Float']['output'];
  slfAnalysis: SlfComplianceAnalysisOutput;
  taxBracket: tax_bracket_enum;
};

export type AnalyzeBuildingOutputUnion = AnalyzeBuildingCrremOutput | AnalyzeBuildingNationalEnergyLawOutput;

export type AnalyzeBuildingsAnalysisOutputUnion =
  | AnalyzeBuildingsCrremAnalysisResultOutput
  | AnalyzeBuildingsNationalEnergyLawAnalysisResultOutput;

export type AnalyzeBuildingsCoreOutput = {
  analysisType: emission_factor_type_enum;
  analyzedBuildingsCount: Scalars['Int']['output'];
  buildingsWithoutEnergyPaths: Scalars['Int']['output'];
  economicUnitsCount: Scalars['Int']['output'];
  floorAreaByClassOfUse: Array<FloorAreaByClassOfUseOutput>;
  minConstructionYear?: Maybe<Scalars['Int']['output']>;
};

export type AnalyzeBuildingsCostPathsOutput = {
  co2CostDistributionPath: Co2CostDistributionOutput;
  energyCostPath: PathOutput;
};

export type AnalyzeBuildingsCrremAnalysisOutput = {
  averageCo2Emissions: Scalars['Float']['output'];
  co2Path: PathOutput;
  co2TargetPath: Array<Scalars['Float']['output']>;
  cumulativeExcessEmissions: Scalars['Float']['output'];
  energyPath: PathOutput;
  energyTargetPath: Array<Scalars['Float']['output']>;
  excessEmissionCostPath: Array<Scalars['Float']['output']>;
  scope123Co2Emissions: AllPerspectivesScope123Co2EmissionsOutput;
  strandingData: Array<StrandingDataOutput>;
  strandingYear?: Maybe<Scalars['Int']['output']>;
  yearOfExcedance?: Maybe<Scalars['Int']['output']>;
};

export type AnalyzeBuildingsCrremAnalysisResultOutput = {
  analysisType: emission_factor_type_enum;
  crremAnalysis: AnalyzeBuildingsCrremAnalysisOutput;
  customTargetPath?: Maybe<CustomTargetPathOutput>;
  customTargets?: Maybe<CustomTargetResult>;
};

export type AnalyzeBuildingsKpisOutput = {
  averageCo2Emissions: Scalars['Float']['output'];
  averageFinalEnergy: Scalars['Float']['output'];
  averageHeatingDemand?: Maybe<Scalars['Float']['output']>;
  averagePrimaryEnergy: Scalars['Float']['output'];
  co2CostAtYear: Scalars['Float']['output'];
};

export type AnalyzeBuildingsNationalEnergyLawAnalysisOutput = {
  averageCo2Emissions: Scalars['Float']['output'];
  co2Path: PathOutput;
  energyPath: PathOutput;
};

export type AnalyzeBuildingsNationalEnergyLawAnalysisResultOutput = {
  analysisType: emission_factor_type_enum;
  customTargets?: Maybe<CustomTargetResult>;
  nationalEnergyLawAnalysis: AnalyzeBuildingsNationalEnergyLawAnalysisOutput;
};

export type AnalyzeBuildingsSlfComplianceOutput = {
  slfCompliantBuildingsCount: Scalars['Int']['output'];
  slfCompliantEconomicUnitsCount: Scalars['Int']['output'];
  slfFullAssessmentBuildingsCount: Scalars['Int']['output'];
};

export type AnalyzeScenarioOutput = {
  building_count?: Maybe<Scalars['Int']['output']>;
  co2_abatement_cost?: Maybe<Scalars['Float']['output']>;
  cost_total?: Maybe<Scalars['Float']['output']>;
  modification_impact: ScenarioModificationImpact;
  total_floor_area?: Maybe<Scalars['Float']['output']>;
};

export type AnswerParamsInput = {
  evidences?: InputMaybe<Array<EvidenceInput>>;
  report_question_id: Scalars['Int']['input'];
  selected_option_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AnswerQuestionsOutput = {
  report_answer_ids: Array<ReportAnswerId>;
};

export type ApplyBuildingModelMutationsOutput = {
  final_energy: Scalars['Float']['output'];
  final_energy_scaled: Scalars['Float']['output'];
  heating_demand_envelope?: Maybe<Scalars['Float']['output']>;
  heating_demand_system?: Maybe<Scalars['Float']['output']>;
  scaling_successful: Scalars['Boolean']['output'];
};

export type AreaUpdateInput = {
  area_system_id?: InputMaybe<area_system_type_enum>;
  area_type_id?: InputMaybe<area_type_enum>;
  class_of_use_id?: InputMaybe<class_of_use_enum>;
  create: Scalars['Boolean']['input'];
  delete: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  energy_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  energy_rating_score?: InputMaybe<Scalars['Float']['input']>;
  enev_year?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  file_id?: InputMaybe<Scalars['Int']['input']>;
  geg_reference_value?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_rented?: InputMaybe<Scalars['Boolean']['input']>;
  reference_value_electricity?: InputMaybe<Scalars['Float']['input']>;
  reference_value_heating_hot_water?: InputMaybe<Scalars['Float']['input']>;
  type_of_use_id?: InputMaybe<type_of_use_enum>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type AreaUpdateResponse = {
  efficiencyClassDeviation?: Maybe<EfficiencyClassDeviationResult>;
  scalingResult?: Maybe<ApplyBuildingModelMutationsOutput>;
  success: Scalars['Boolean']['output'];
};

export type AssignBuildingAddressInput = {
  areaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  buildingId: Scalars['Int']['input'];
};

export type AssociatedActionPlan = {
  action_plan?: Maybe<action_plan>;
  action_plan_id: Scalars['Int']['output'];
  building?: Maybe<building>;
  building_id: Scalars['Int']['output'];
  scenario_id: Scalars['Int']['output'];
  stable_id: Scalars['Int']['output'];
};

export type AssociatedActionPlansOutput = {
  action_plans: Array<AssociatedActionPlan>;
  count: Scalars['Int']['output'];
};

export type AssociatedBuilding = {
  building?: Maybe<building>;
  building_id: Scalars['Int']['output'];
};

export type AssociatedBuildingsOutput = {
  buildings: Array<AssociatedBuilding>;
  count: Scalars['Int']['output'];
};

export type BaseEnergyValuesCRREMOutput = {
  analysisType: emission_factor_type_enum;
  co2_emissions: Scalars['Float']['output'];
  co2_emissions_total: Scalars['Float']['output'];
  co2_tax_cost: Scalars['Float']['output'];
  efficiency_class: efficiency_class_enum;
  energy_final: Scalars['Float']['output'];
  energy_final_cost: Scalars['Float']['output'];
  energy_final_total: Scalars['Float']['output'];
  energy_primary: Scalars['Float']['output'];
  energy_primary_total: Scalars['Float']['output'];
  heating_demand?: Maybe<Scalars['Float']['output']>;
  heating_demand_total?: Maybe<Scalars['Float']['output']>;
  renovation_costs?: Maybe<Scalars['Float']['output']>;
  stranding_date: Scalars['DateTime']['output'];
};

export type BaseEnergyValuesNationalEnergyLawOutput = {
  analysisType: emission_factor_type_enum;
  co2_emissions: Scalars['Float']['output'];
  co2_emissions_total: Scalars['Float']['output'];
  co2_tax_cost: Scalars['Float']['output'];
  efficiency_class: efficiency_class_enum;
  energy_final: Scalars['Float']['output'];
  energy_final_cost: Scalars['Float']['output'];
  energy_final_total: Scalars['Float']['output'];
  energy_primary: Scalars['Float']['output'];
  energy_primary_total: Scalars['Float']['output'];
  heating_demand?: Maybe<Scalars['Float']['output']>;
  heating_demand_total?: Maybe<Scalars['Float']['output']>;
  renovation_costs?: Maybe<Scalars['Float']['output']>;
};

export type BaseEnergyValuesOutputUnion = BaseEnergyValuesCRREMOutput | BaseEnergyValuesNationalEnergyLawOutput;

export type BeforeAfterDataWithImpactOutput = {
  after?: Maybe<Scalars['Float']['output']>;
  after_total?: Maybe<Scalars['Float']['output']>;
  before?: Maybe<Scalars['Float']['output']>;
  before_total?: Maybe<Scalars['Float']['output']>;
  impact?: Maybe<Scalars['Float']['output']>;
  impact_total?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_comparison_exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BreadcrumbItem = {
  folderTypeId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum BuildingActiveStateFilter {
  BOTH = 'BOTH',
  ONLY_ACTIVE = 'ONLY_ACTIVE',
  ONLY_INACTIVE = 'ONLY_INACTIVE',
}

export type BuildingCompleteGeolocation = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mapboxBuildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  numberOfFloors?: InputMaybe<Scalars['Int']['input']>;
};

export type BuildingCompleteOutput = {
  areaUsable: Scalars['Float']['output'];
  areaUsableDataSource: data_source_type_enum;
  energyData: Array<EnergyDataOutput>;
  energyDataSource: data_source_type_enum;
  typeOfUse: type_of_use_enum;
  typeOfUseDataSource: data_source_type_enum;
  units: Scalars['Int']['output'];
  unitsDataSource: data_source_type_enum;
  yearConstructed: Scalars['Int']['output'];
  yearConstructedDataSource: data_source_type_enum;
};

export type BuildingCreateActionPlanSearchListOutput = {
  buildings: Array<BuildingCreateActionPlanSearchResultOutput>;
  count: Scalars['Int']['output'];
};

export type BuildingCreateActionPlanSearchResultOutput = {
  action_planning_available: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  country: country_enum;
  customer_external_identifier?: Maybe<Scalars['String']['output']>;
  efficiency_class?: Maybe<efficiency_class_enum>;
  has_energy_data: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_new_construction: Scalars['Boolean']['output'];
  postal_code: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type BuildingCreationFromBuildingDraftOutput = {
  buildingId: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type BuildingEnergyData = {
  co2_costs: Scalars['Float']['output'];
  co2_costs_total: Scalars['Float']['output'];
  co2_emissions: Scalars['Float']['output'];
  co2_emissions_total: Scalars['Float']['output'];
  efficiency_class: efficiency_class_enum;
  efficiency_class_order: Scalars['Int']['output'];
  energy_final: Scalars['Float']['output'];
  energy_final_total: Scalars['Float']['output'];
  energy_primary: Scalars['Float']['output'];
  energy_primary_total: Scalars['Float']['output'];
  eu_taxonomy_compliance: eu_taxonomy_compliance_enum;
  eu_taxonomy_compliance_order: Scalars['Int']['output'];
  slf_compliant?: Maybe<BuildingRowSlfComplianceOutput>;
};

export type BuildingExportOrderByInput = {
  direction: OrderDirection;
  orderBy: BuildingExportOrderByInputField;
};

export enum BuildingExportOrderByInputField {
  city = 'city',
  economic_unit_created_at = 'economic_unit_created_at',
  economic_unit_customer_identifier = 'economic_unit_customer_identifier',
  economic_unit_name = 'economic_unit_name',
  has_gml_ids = 'has_gml_ids',
  postal_code = 'postal_code',
  state = 'state',
  street = 'street',
  year_constructed = 'year_constructed',
}

export type BuildingExportOutput = {
  body: Scalars['String']['output'];
};

export type BuildingImportOutput = {
  buildingId: Scalars['Int']['output'];
};

export type BuildingInput = {
  buildingCustomData: Scalars['JSON']['input'];
  externalId: Scalars['String']['input'];
};

export type BuildingListOutput = {
  buildings: Array<BuildingRowOutput>;
  count: Scalars['Int']['output'];
};

export type BuildingModelMutation = {
  annual_heating_days?: InputMaybe<Scalars['Float']['input']>;
  heating_demand?: InputMaybe<Scalars['Float']['input']>;
  internal_temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type BuildingModelTransitionOutput = {
  co2Intensity: Scalars['Float']['output'];
  energyIntensity: Scalars['Float']['output'];
  validFrom: Scalars['DateTime']['output'];
};

export type BuildingModelTwinOutput = {
  buildingModelId: Scalars['Int']['output'];
};

export enum BuildingOrderBy {
  city = 'city',
  co2_costs = 'co2_costs',
  co2_costs_total = 'co2_costs_total',
  co2_emissions = 'co2_emissions',
  co2_emissions_total = 'co2_emissions_total',
  economic_unit_created_at = 'economic_unit_created_at',
  economic_unit_customer_identifier = 'economic_unit_customer_identifier',
  economic_unit_name = 'economic_unit_name',
  efficiency_class_order = 'efficiency_class_order',
  energy_final = 'energy_final',
  energy_final_total = 'energy_final_total',
  energy_primary = 'energy_primary',
  energy_primary_total = 'energy_primary_total',
  eu_taxonomy_compliance_order = 'eu_taxonomy_compliance_order',
  first_stranding_year = 'first_stranding_year',
  has_gml_ids = 'has_gml_ids',
  postal_code = 'postal_code',
  slf_compliant = 'slf_compliant',
  state = 'state',
  street = 'street',
  year_constructed = 'year_constructed',
}

export type BuildingOrderByInput = {
  direction: OrderDirection;
  orderBy: BuildingOrderBy;
};

export type BuildingPdfFileOutput = {
  createdAt: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  energyCertificateId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uploading: Scalars['Boolean']['output'];
};

/** This is a workaround to fix the typing of the relation between BuildingRowOutput & building table. */
export type BuildingRowOutput = {
  building: building;
  city: Scalars['String']['output'];
  country: country_enum;
  energy_certificate_types: Array<energy_certificate_type_enum>;
  energy_data?: Maybe<BuildingEnergyData>;
  first_stranding_year?: Maybe<Scalars['Int']['output']>;
  has_gml_ids: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inactive_building?: Maybe<inactive_buildings>;
  is_new_construction: Scalars['Boolean']['output'];
  postal_code: Scalars['String']['output'];
  street: Scalars['String']['output'];
  types_of_use: Array<type_of_use_enum>;
  year_constructed?: Maybe<Scalars['Int']['output']>;
};

export type BuildingRowSlfComplianceOutput = {
  full_check?: Maybe<BuildingRowSlfFullCheckOutput>;
  quick_check: Scalars['Boolean']['output'];
};

export type BuildingRowSlfFullCheckOutput = {
  issued_at: Scalars['DateTime']['output'];
  report_id: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type BuildingSearchListOutput = {
  buildings: Array<BuildingSearchResultOutput>;
  count: Scalars['Int']['output'];
};

export type BuildingSearchResultOutput = {
  city: Scalars['String']['output'];
  country: country_enum;
  customer_external_identifier?: Maybe<Scalars['String']['output']>;
  has_energy_data: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_new_construction: Scalars['Boolean']['output'];
  postal_code: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type BuildingWhere = {
  action_planning_available?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  active_state_filter?: InputMaybe<BuildingActiveStateFilter>;
  building_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  building_states?: InputMaybe<Array<building_state_enum>>;
  class_of_uses?: InputMaybe<Array<class_of_use_enum>>;
  co2_emissions?: InputMaybe<RangeInput>;
  district_heating_availability?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  economic_unit_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  economic_unit_responsible_user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  economic_unit_search_string?: InputMaybe<Scalars['String']['input']>;
  efficiency_classes?: InputMaybe<Array<efficiency_class_enum>>;
  energy_certificate_none?: InputMaybe<Scalars['Boolean']['input']>;
  energy_certificate_types?: InputMaybe<Array<energy_certificate_type_enum>>;
  energy_final?: InputMaybe<RangeInput>;
  energy_primary?: InputMaybe<RangeInput>;
  energy_source_types?: InputMaybe<Array<energy_source_type_enum>>;
  eu_taxonomy_compliances?: InputMaybe<Array<eu_taxonomy_compliance_enum>>;
  exclude_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  excluded_economic_unit_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  has_consumption_data?: InputMaybe<Scalars['Boolean']['input']>;
  heritage_district?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  include_new_construction?: InputMaybe<Scalars['Boolean']['input']>;
  is_lod2?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  leasehold?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  milieu_protection?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  monument_protection?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  perspective?: InputMaybe<scope_perspective_enum>;
  portfolio_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  responsible_user_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  slf_compliant?: InputMaybe<Scalars['Boolean']['input']>;
  stranding_year?: InputMaybe<RangeInput>;
  tax_brackets?: InputMaybe<Array<tax_bracket_enum>>;
  type_of_uses?: InputMaybe<Array<type_of_use_enum>>;
};

export type BuildingsBenchmarkCrremAnalysisOutput = {
  averageCo2Emissions: Scalars['Float']['output'];
  strandingYear?: Maybe<Scalars['Int']['output']>;
  yearOfExcedance?: Maybe<Scalars['Int']['output']>;
};

export type BuildingsBenchmarkCrremOutput = {
  analysisType: emission_factor_type_enum;
  averageCo2Costs: Scalars['Float']['output'];
  averageEnergyCosts: Scalars['Float']['output'];
  averageFinalEnergy: Scalars['Float']['output'];
  averageHeatingDemand?: Maybe<Scalars['Float']['output']>;
  averagePrimaryEnergy: Scalars['Float']['output'];
  crremAnalysis: BuildingsBenchmarkCrremAnalysisOutput;
};

export type BuildingsBenchmarkNationalEnergyLawAnalysisOutput = {
  averageCo2Emissions: Scalars['Float']['output'];
};

export type BuildingsBenchmarkNationalEnergyLawOutput = {
  analysisType: emission_factor_type_enum;
  averageCo2Costs: Scalars['Float']['output'];
  averageEnergyCosts: Scalars['Float']['output'];
  averageFinalEnergy: Scalars['Float']['output'];
  averageHeatingDemand?: Maybe<Scalars['Float']['output']>;
  averagePrimaryEnergy: Scalars['Float']['output'];
  nationalEnergyLawAnalysis: BuildingsBenchmarkNationalEnergyLawAnalysisOutput;
};

export type BuildingsBenchmarkOutputUnion = BuildingsBenchmarkCrremOutput | BuildingsBenchmarkNationalEnergyLawOutput;

export type BuildingsByEUTaxonomyComplianceOutput = {
  count: Scalars['Int']['output'];
  euTaxonomyCompliance: eu_taxonomy_compliance_enum;
};

export type BuildingsByEfficiencyClassOutput = {
  count: Scalars['Int']['output'];
  efficiencyClass: efficiency_class_enum;
};

export type BuildingsByEnergySourceTypeOutput = {
  count: Scalars['Int']['output'];
  energySourceType: energy_source_type_enum;
};

export type BuildingsByTaxBracketOutput = {
  count: Scalars['Int']['output'];
  taxBracket: tax_bracket_enum;
};

export type BuildingsGeneralDataOutput = {
  address: Scalars['String']['output'];
  area: Scalars['Float']['output'];
  buildingId: Scalars['Int']['output'];
  co2Intensity: Scalars['Float']['output'];
  country: country_enum;
  economicUnitId: Scalars['Int']['output'];
  finalEnergy: Scalars['Float']['output'];
  mainEnergySourceType: energy_source_type_enum;
  typeOfUse: Array<type_of_use_enum>;
  year: Scalars['Int']['output'];
};

export type BulkActionEditInput = {
  bulkActionId: Scalars['Int']['input'];
  customCosts?: InputMaybe<CustomCostInput>;
  implementationDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<BulkActionParametersInput>;
};

export type BulkActionInput = {
  buildingWhere: BuildingWhere;
  customCosts?: InputMaybe<CustomCostInput>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  implementationDate: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  parameters: BulkActionParametersInput;
  scenarioId: Scalars['Int']['input'];
};

export type BulkActionParametersInput = {
  create_exclusion_note_parameter?: InputMaybe<ExclusionNoteParameterInput>;
  create_ventilation_renovation_parameter?: InputMaybe<CreateVentilationRenovationParameterInput>;
  custom_action_renovation_parameter?: InputMaybe<CustomActionRenovationParameterInput>;
  energy_system_route_renovation_parameter?: InputMaybe<EnergySystemRouteRenovationParameterInput>;
  envelope_renovation_parameter?: InputMaybe<EnvelopeRenovationParameterInput>;
  hydraulic_balancing_renovation_parameter?: InputMaybe<HydraulicBalancingRenovationParameterInput>;
  lighting_renovation_parameter?: InputMaybe<LightingRenovationForBulkActionParameterInput>;
  maintenance_action_parameter?: InputMaybe<MaintenanceActionParameterInput>;
  solar_renovation_parameter?: InputMaybe<SolarRenovationForBulkActionParameterInput>;
  system_renovation_parameter?: InputMaybe<SystemRenovationParameterInput>;
  ventilation_renovation_parameter?: InputMaybe<CreateVentilationRenovationParameterInput>;
};

export type BulkActionParametersUnion =
  | CreateVentilationRenovationParametersUnionMember
  | CustomBulkActionParametersUnionMember
  | EnergySystemRouteParametersBulkUnionMember
  | EnvelopeParametersBulkUnionMember
  | ExclusionNoteParametersUnionMember
  | HydraulicBalancingParametersBulkUnionMember
  | LightingParametersBulkUnionMember
  | MaintenanceActionParametersUnionMember
  | SolarParametersBulkUnionMember
  | SystemParametersBulkUnionMember
  | VentilationRenovationParametersUnionMember;

export type BulkDeleteActionPlansInput = {
  actionPlanIds: Array<Scalars['Int']['input']>;
  buildingWhere?: InputMaybe<BuildingWhere>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  scenarioId: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  selectAll: Scalars['Boolean']['input'];
};

export type BulkDeleteActionPlansResponse = {
  deletedCount: Scalars['Int']['output'];
};

export type CBIAddressInput = {
  id: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type CBIAddressOutput = {
  id: Scalars['Int']['output'];
};

export type CBIExportOutput = {
  cbi_export?: Maybe<cbi_export>;
  id: Scalars['Int']['output'];
};

export type CBIInboxConfiguration = {
  id: Scalars['Int']['output'];
  inbox?: Maybe<cbi_inbox>;
};

export enum CBIInvoiceField {
  amountPayable = 'amountPayable',
  co2FeeGross = 'co2FeeGross',
  invoiceNumber = 'invoiceNumber',
  invoiceReference = 'invoiceReference',
  invoiceType = 'invoiceType',
  lines = 'lines',
  operationalControl = 'operationalControl',
  provider = 'provider',
  totalCostGross = 'totalCostGross',
}

export type CBIInvoiceIssue = {
  field: CBIInvoiceField;
  ruleName: CBIInvoiceRuleName;
  type: CBIValidationIssueType;
};

export enum CBIInvoiceRuleName {
  amountPayable = 'amountPayable',
  atLeastOneLine = 'atLeastOneLine',
  co2CostsForHeating = 'co2CostsForHeating',
  invoiceNumber = 'invoiceNumber',
  invoiceReferenceForbiddenForRegularInvoice = 'invoiceReferenceForbiddenForRegularInvoice',
  invoiceReferenceRequiredForCancellationOrCorrection = 'invoiceReferenceRequiredForCancellationOrCorrection',
  invoiceType = 'invoiceType',
  noCancellationOrCorrection = 'noCancellationOrCorrection',
  noFeeNoticeCorrection = 'noFeeNoticeCorrection',
  operationalControl = 'operationalControl',
  provider = 'provider',
  totalCostGross = 'totalCostGross',
}

export enum CBILineField {
  address = 'address',
  consumptionAmount = 'consumptionAmount',
  consumptionEndDate = 'consumptionEndDate',
  consumptionStartDate = 'consumptionStartDate',
  consumptionType = 'consumptionType',
  energySource = 'energySource',
  marketLocationId = 'marketLocationId',
  meterNumber = 'meterNumber',
  referenceArea = 'referenceArea',
  renewableEnergyPercentage = 'renewableEnergyPercentage',
  unit = 'unit',
  wasteSubType = 'wasteSubType',
  waterSubType = 'waterSubType',
}

export type CBILineIssue = {
  field: CBILineField;
  lineIndex: Scalars['Int']['output'];
  ruleName: CBILineRuleName;
  type: CBIValidationIssueType;
};

export enum CBILineRuleName {
  addressAlwaysThereRule = 'addressAlwaysThereRule',
  consumptionAmountThere = 'consumptionAmountThere',
  consumptionPeriodNotInverted = 'consumptionPeriodNotInverted',
  consumptionTypeThere = 'consumptionTypeThere',
  consumptionUnitMatchesEnergySource = 'consumptionUnitMatchesEnergySource',
  consumptionUnitThere = 'consumptionUnitThere',
  electricityEnergySource = 'electricityEnergySource',
  electricityEnergySourceThere = 'electricityEnergySourceThere',
  electricityUnitCompatible = 'electricityUnitCompatible',
  endDateThere = 'endDateThere',
  heatingEnergySource = 'heatingEnergySource',
  maloIdForElectricity = 'maloIdForElectricity',
  maloIdLength = 'maloIdLength',
  meterIdIsThere = 'meterIdIsThere',
  pieceOnlyForBulkWaste = 'pieceOnlyForBulkWaste',
  referenceAreaThere = 'referenceAreaThere',
  renewableEnergyForDistrictHeating = 'renewableEnergyForDistrictHeating',
  startDateThere = 'startDateThere',
  wasteCollection = 'wasteCollection',
  wasteSubType = 'wasteSubType',
  waterSubType = 'waterSubType',
}

export enum CBISkipKind {
  AREA_RESOLUTION = 'AREA_RESOLUTION',
  EXCLUDED = 'EXCLUDED',
  INVALID_VALUE = 'INVALID_VALUE',
  MISSING_FIELD = 'MISSING_FIELD',
}

export type CBISnapshotIssues = {
  invoice: Array<CBIInvoiceIssue>;
  lines: Array<CBILineIssue>;
};

export enum CBIValidationIssueType {
  missing = 'missing',
  unexpected = 'unexpected',
}

export type CRREMConfigurationUnion = CRREMCustomConfigurationObject | CRREMDefaultConfigurationObject;

export type CRREMCustomConfigurationObject = {
  id: Scalars['Int']['output'];
  setFor: SetForObject;
  title: Scalars['String']['output'];
};

export type CRREMDefaultConfigurationObject = {
  emissionFactorType: emission_factor_type_enum;
  setFor: SetForObject;
};

export type Certificate = {
  id: Scalars['Int']['output'];
};

export type CertificateSlfComplianceAnalysisOutput = {
  certificateType: certificate_type_enum;
  level?: Maybe<certificate_level_type_enum>;
  score?: Maybe<Scalars['Int']['output']>;
  type: slf_compliance_factor_enum;
};

export enum CheckAccess {
  READ = 'READ',
  WRITE = 'WRITE',
}

export type ClimateRiskOutput = {
  timespan?: Maybe<Scalars['String']['output']>;
  type: climate_risk_type_enum;
  value: Scalars['Float']['output'];
};

export type ClimateRiskV2Data = {
  periods: Array<ClimateRiskV2Details>;
  riskName: Scalars['String']['output'];
};

export type ClimateRiskV2Details = {
  percentage: Scalars['Float']['output'];
  range: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  valuationAtRisk?: Maybe<Scalars['Float']['output']>;
};

export type ClimateRiskV2ReportFile = {
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  publicPath: Scalars['String']['output'];
};

export type ClimateScenarioV2Data = {
  risks: Array<ClimateRiskV2Data>;
  type: Scalars['String']['output'];
};

export type Co2CostDistributionOutput = {
  landlordPath: PathOutput;
  tenantPath: PathOutput;
};

export type Co2EmissionsImpactTrendOutput = {
  after: Array<Scalars['Float']['output']>;
  before: Array<Scalars['Float']['output']>;
  custom_target: Array<CustomTargetMetrics>;
  startYear: Scalars['Int']['output'];
  target_path: Array<Scalars['Float']['output']>;
};

export type Co2EmissionsOutput = {
  co2Emissions: Scalars['Float']['output'];
  co2EmissionsTotal: Scalars['Float']['output'];
};

export type Co2PriceAnchor = {
  pricePerTon: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type Co2PriceAnchorInput = {
  pricePerTon: Scalars['Float']['input'];
  year: Scalars['Int']['input'];
};

export type Co2PriceCurveConfig = {
  anchors?: Maybe<Array<Co2PriceAnchor>>;
  growthAnnualPercent?: Maybe<Scalars['Float']['output']>;
  growthStartValue?: Maybe<Scalars['Float']['output']>;
  kind: co2_price_curve_kind_enum;
};

export type ColumnBuildingExportOptions = {
  buildingWhere?: InputMaybe<BuildingWhere>;
  consumptionYearRange?: InputMaybe<ExcelExportConsumptionYearRangeInput>;
  orderBy: BuildingExportOrderByInput;
  selectedColumnIds: Array<Scalars['String']['input']>;
};

export type ConfirmDriveUploadInput = {
  fileId: Scalars['Int']['input'];
};

export type ConfirmDriveUploadOutput = {
  fileId: Scalars['Int']['output'];
};

export type ConfirmFileUploadInput = {
  fileId: Scalars['Int']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmFileUploadOutput = {
  fileId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ConsumptionAllocation = {
  carbonEmissions?: Maybe<ConsumptionAllocationCarbonEmissionUnion>;
  co2Tax?: Maybe<ConsumptionAllocationTax>;
  energyConsumptions: Array<ConsumptionAllocationEnergyConsumption>;
};

export type ConsumptionAllocationByPerspective = {
  carbonEmissions?: Maybe<ConsumptionAllocationCarbonEmissionUnion>;
};

export type ConsumptionAllocationCarbonEmissionScope = {
  percentage: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type ConsumptionAllocationCarbonEmissionUnion =
  | ConsumptionAllocationCrremCarbonEmission
  | ConsumptionAllocationNationalEnergyLawCarbonEmission;

export type ConsumptionAllocationCrremCarbonEmission = {
  analysisType: emission_factor_type_enum;
  intensity: Scalars['Float']['output'];
  intensityAbsolute: Scalars['Float']['output'];
  scope1: ConsumptionAllocationCarbonEmissionScope;
  scope2: ConsumptionAllocationCarbonEmissionScope;
  scope3: ConsumptionAllocationCarbonEmissionScope;
};

export type ConsumptionAllocationEnergyConsumption = {
  items: Array<ConsumptionAllocationEnergyConsumptionItem>;
  total: Scalars['Float']['output'];
  totalAbsolute: Scalars['Float']['output'];
  type: energy_consumption_type_enum;
};

export type ConsumptionAllocationEnergyConsumptionItem = {
  percentage: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  valueAbsolute: Scalars['Float']['output'];
};

export type ConsumptionAllocationNationalEnergyLawCarbonEmission = {
  analysisType: emission_factor_type_enum;
  intensity: Scalars['Float']['output'];
  intensityAbsolute: Scalars['Float']['output'];
};

export type ConsumptionAllocationTax = {
  costShare: Scalars['Float']['output'];
  forecastItems: Array<ConsumptionAllocationTaxForecast>;
  total: Scalars['Float']['output'];
  totalAbsolute: Scalars['Float']['output'];
};

export type ConsumptionAllocationTaxForecast = {
  landlordShare: Scalars['Float']['output'];
  landlordShareAbsolute: Scalars['Float']['output'];
  landlordSharePercentage: Scalars['Float']['output'];
  tenantShare: Scalars['Float']['output'];
  tenantShareAbsolute: Scalars['Float']['output'];
  tenantSharePercentage: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type ConsumptionAnalysis = {
  data: Array<ConsumptionAnalysisItem>;
};

export type ConsumptionAnalysisChart = {
  count: Scalars['Int']['output'];
  from: Scalars['Float']['output'];
  sum: Scalars['Float']['output'];
  sumAbsolute: Scalars['Float']['output'];
  to: Scalars['Float']['output'];
};

export type ConsumptionAnalysisItem = {
  average: Scalars['Float']['output'];
  averageAbsolute: Scalars['Float']['output'];
  series: Array<ConsumptionAnalysisChart>;
  type: consumption_type_enum;
};

export type ConsumptionBuildingListOutput = {
  buildings: Array<ConsumptionBuildingRow>;
  count: Scalars['Int']['output'];
};

export enum ConsumptionBuildingOrderBy {
  city = 'city',
  co2_intensity = 'co2_intensity',
  co2_tax = 'co2_tax',
  deviation_from_demand = 'deviation_from_demand',
  final_energy = 'final_energy',
  postal_code = 'postal_code',
  primary_energy = 'primary_energy',
  street = 'street',
}

export type ConsumptionBuildingOrderByInput = {
  direction: OrderDirection;
  orderBy: ConsumptionBuildingOrderBy;
};

export type ConsumptionBuildingRow = {
  city: Scalars['String']['output'];
  co2Relative?: Maybe<Scalars['Float']['output']>;
  co2TaxRelative?: Maybe<Scalars['Float']['output']>;
  co2TaxTotal?: Maybe<Scalars['Float']['output']>;
  co2Total?: Maybe<Scalars['Float']['output']>;
  country: country_enum;
  deviationFromDemand?: Maybe<Scalars['Float']['output']>;
  finalEnergyRelative?: Maybe<Scalars['Float']['output']>;
  finalEnergyTotal?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isNewConstruction: Scalars['Boolean']['output'];
  postalCode: Scalars['String']['output'];
  primaryEnergyRelative?: Maybe<Scalars['Float']['output']>;
  primaryEnergyTotal?: Maybe<Scalars['Float']['output']>;
  street: Scalars['String']['output'];
  typesOfUse: Array<type_of_use_enum>;
};

export type ConsumptionCO2IntensityDevelopmentItem = {
  valueAbsolute: Scalars['Float']['output'];
  valueRelative: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type ConsumptionCRREMPathsOutput = {
  co2PathRelative: Array<Scalars['Float']['output']>;
  co2TargetPathRelative: Array<Scalars['Float']['output']>;
  energyPathRelative: Array<Scalars['Float']['output']>;
  energyTargetPathRelative: Array<Scalars['Float']['output']>;
  excessEmissionCostPath: Array<Scalars['Float']['output']>;
  strandingData: Array<ConsumptionStrandingDataItem>;
  strandingYear?: Maybe<Scalars['Int']['output']>;
  yearOfExcedance?: Maybe<Scalars['Int']['output']>;
};

export type ConsumptionCoverageOutput = {
  buildingsWithoutConsumptionData: Scalars['Int']['output'];
  totalBuildings: Scalars['Int']['output'];
};

export type ConsumptionDeviationFromDemandOutput = {
  gt_30: Scalars['Int']['output'];
  lt_neg_30: Scalars['Int']['output'];
  neg_10_10: Scalars['Int']['output'];
  neg_30_neg_10: Scalars['Int']['output'];
  pos_10_30: Scalars['Int']['output'];
};

export type ConsumptionDraftInput = {
  areaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  consumptionTypeId?: InputMaybe<consumption_type_enum>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  wasteDetails?: InputMaybe<ConsumptionDraftWasteDetailsInput>;
};

export type ConsumptionDraftMutationOutput = {
  consumption_draft?: Maybe<consumption_draft>;
  id: Scalars['Int']['output'];
};

export type ConsumptionDraftWasteDetailsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
  frequency?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export type ConsumptionEnergySourceBreakdownItem = {
  energySourceType: energy_source_type_enum;
  percentage: Scalars['Float']['output'];
  valueAbsolute: Scalars['Float']['output'];
  valueRelative: Scalars['Float']['output'];
};

export type ConsumptionEnergySourceBuildingCountItem = {
  count: Scalars['Int']['output'];
  energySourceType: energy_source_type_enum;
  percentage: Scalars['Float']['output'];
};

export type ConsumptionFinalEnergyDevelopmentBreakdownItem = {
  percentage: Scalars['Float']['output'];
  valueAbsolute: Scalars['Float']['output'];
  valueRelative: Scalars['Float']['output'];
};

export type ConsumptionFinalEnergyDevelopmentItem = {
  electricityBreakdown: ConsumptionFinalEnergyDevelopmentBreakdownItem;
  heatingBreakdown: ConsumptionFinalEnergyDevelopmentBreakdownItem;
  totalAbsolute: Scalars['Float']['output'];
  totalRelative: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type ConsumptionGapAnnotatedInterval = {
  areaId: Scalars['Int']['output'];
  areaName: Scalars['String']['output'];
  areaType: area_type_enum;
  consumptionType: consumption_type_enum;
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
};

export type ConsumptionGapAreaRow = {
  areaId: Scalars['Int']['output'];
  areaName: Scalars['String']['output'];
  areaType: area_type_enum;
  completeness: Scalars['Float']['output'];
  coverage: ConsumptionGapTypeCoverage;
  gaps: ConsumptionGapTypeIntervals;
};

export type ConsumptionGapBuildingRow = {
  areas: Array<ConsumptionGapAreaRow>;
  building?: Maybe<building>;
  buildingId: Scalars['Int']['output'];
  completeness: Scalars['Float']['output'];
  coverage: ConsumptionGapTypeCoverage;
  gaps: Array<ConsumptionGapAnnotatedInterval>;
};

export type ConsumptionGapInterval = {
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
};

export type ConsumptionGapMatrixOutput = {
  buildings: Array<ConsumptionGapBuildingRow>;
  count: Scalars['Int']['output'];
  total: ConsumptionGapMatrixTotal;
};

export type ConsumptionGapMatrixTotal = {
  buildings: Scalars['Int']['output'];
  completeness: Scalars['Float']['output'];
  needsReview: Scalars['Int']['output'];
};

export type ConsumptionGapTypeCoverage = {
  electricity: Scalars['Float']['output'];
  heating: Scalars['Float']['output'];
  waste: Scalars['Float']['output'];
  water: Scalars['Float']['output'];
};

export type ConsumptionGapTypeIntervals = {
  electricity: Array<ConsumptionGapInterval>;
  heating: Array<ConsumptionGapInterval>;
  waste: Array<ConsumptionGapInterval>;
  water: Array<ConsumptionGapInterval>;
};

export type ConsumptionInput = {
  areaIds: Array<Scalars['Int']['input']>;
  consumptionTypeId: consumption_type_enum;
  cost?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  from: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
  to: Scalars['DateTime']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
  wasteDetails?: InputMaybe<ConsumptionWasteDetailsInput>;
};

export type ConsumptionLineInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  advancePayments?: InputMaybe<Scalars['Float']['input']>;
  amountPayable?: InputMaybe<Scalars['Float']['input']>;
  basePriceNet?: InputMaybe<Scalars['Float']['input']>;
  co2FeeGross?: InputMaybe<Scalars['Float']['input']>;
  co2FeeNet?: InputMaybe<Scalars['Float']['input']>;
  consumptionAmount?: InputMaybe<Scalars['Float']['input']>;
  consumptionEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  consumptionStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  consumptionType?: InputMaybe<consumption_type_enum>;
  costGross?: InputMaybe<Scalars['Float']['input']>;
  costNet?: InputMaybe<Scalars['Float']['input']>;
  creditAmount?: InputMaybe<Scalars['Float']['input']>;
  emissionFactorMarketBased?: InputMaybe<Scalars['Float']['input']>;
  energySource?: InputMaybe<cbi_energy_source_type_enum>;
  isAdvancePayment?: InputMaybe<Scalars['Boolean']['input']>;
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>;
  marketLocationId?: InputMaybe<Scalars['String']['input']>;
  meterNumber?: InputMaybe<Scalars['String']['input']>;
  otherChargesNet?: InputMaybe<Scalars['Float']['input']>;
  outstandingBalance?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  referenceArea?: InputMaybe<cbi_reference_area_enum>;
  renewableEnergyPercentage?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<cbi_consumption_unit_enum>;
  vatAmount?: InputMaybe<Scalars['Float']['input']>;
  vatPercentage?: InputMaybe<Scalars['Float']['input']>;
  wasteAdditionalCollectionsTotal?: InputMaybe<Scalars['Float']['input']>;
  wasteCollectionFrequency?: InputMaybe<Scalars['Float']['input']>;
  wasteCollectionFrequencyPeriod?: InputMaybe<cbi_waste_container_frequency_period_enum>;
  wasteCollectionFrequencyRaw?: InputMaybe<Scalars['String']['input']>;
  wasteCollectionsTotal?: InputMaybe<Scalars['Float']['input']>;
  wasteContainerCount?: InputMaybe<Scalars['Float']['input']>;
  wasteContainerSize?: InputMaybe<Scalars['Float']['input']>;
  wasteContainerSizeUnit?: InputMaybe<cbi_waste_container_size_unit_enum>;
  wasteEwcCode?: InputMaybe<Scalars['String']['input']>;
  wasteQuantity?: InputMaybe<Scalars['Float']['input']>;
  wasteQuantityUnit?: InputMaybe<cbi_waste_quantity_unit_enum>;
  wasteSubType?: InputMaybe<cbi_waste_sub_type_enum>;
  waterSubType?: InputMaybe<cbi_water_sub_type_enum>;
  workingPriceNet?: InputMaybe<Scalars['Float']['input']>;
};

export type ConsumptionMutationOutput = {
  consumption?: Maybe<consumption>;
  id: Scalars['Int']['output'];
};

export type ConsumptionOverviewListOutput = {
  count: Scalars['Int']['output'];
  rows: Array<ConsumptionOverviewRow>;
};

export enum ConsumptionOverviewOrderBy {
  consumption_type = 'consumption_type',
  file_name = 'file_name',
  from = 'from',
  invoice_number = 'invoice_number',
  invoice_type = 'invoice_type',
  last_edited = 'last_edited',
  provider = 'provider',
  reference_area = 'reference_area',
  source_name = 'source_name',
  status = 'status',
  street = 'street',
  sub_type = 'sub_type',
  to = 'to',
  value = 'value',
}

export type ConsumptionOverviewOrderByInput = {
  direction: OrderDirection;
  orderBy: ConsumptionOverviewOrderBy;
};

export type ConsumptionOverviewRow = {
  areaName?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['Int']['output']>;
  cbiConsumptionLineId?: Maybe<Scalars['Int']['output']>;
  cbiInvoiceId?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  consumptionId?: Maybe<Scalars['Int']['output']>;
  consumptionType?: Maybe<consumption_type_enum>;
  displayUnitValue?: Maybe<Scalars['String']['output']>;
  economicUnitName?: Maybe<Scalars['String']['output']>;
  energySourceType?: Maybe<energy_source_type_enum>;
  fileName?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoiceType?: Maybe<cbi_invoice_type_enum>;
  lastEdited?: Maybe<Scalars['DateTime']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  referenceAreaType?: Maybe<cbi_reference_area_enum>;
  source: source_consumption_enum;
  sourceName?: Maybe<Scalars['String']['output']>;
  status: status_consumption_enum;
  street?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<consumption_sub_type_enum>;
  to?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ConsumptionOverviewWhere = {
  addressSearch?: InputMaybe<Scalars['String']['input']>;
  areaName?: InputMaybe<StringContainsInput>;
  buildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  consumptionTypes?: InputMaybe<Array<consumption_type_enum>>;
  economicUnitSearch?: InputMaybe<Scalars['String']['input']>;
  energySourceTypes?: InputMaybe<Array<energy_source_type_enum>>;
  fileName?: InputMaybe<StringContainsInput>;
  from?: InputMaybe<DateRangeInput>;
  lastEdited?: InputMaybe<DateRangeInput>;
  provider?: InputMaybe<StringContainsInput>;
  referenceAreaTypes?: InputMaybe<Array<cbi_reference_area_enum>>;
  sourceName?: InputMaybe<StringContainsInput>;
  sources?: InputMaybe<Array<source_consumption_enum>>;
  statuses?: InputMaybe<Array<status_consumption_enum>>;
  subTypes?: InputMaybe<Array<consumption_sub_type_enum>>;
  to?: InputMaybe<DateRangeInput>;
  value?: InputMaybe<FloatRangeInput>;
};

export type ConsumptionPortfolioKPIsOutput = {
  co2Relative?: Maybe<Scalars['Float']['output']>;
  co2TaxRelative?: Maybe<Scalars['Float']['output']>;
  co2TaxTotal?: Maybe<Scalars['Float']['output']>;
  co2Total?: Maybe<Scalars['Float']['output']>;
  energyCostRelative?: Maybe<Scalars['Float']['output']>;
  energyCostTotal?: Maybe<Scalars['Float']['output']>;
  finalEnergyRelative?: Maybe<Scalars['Float']['output']>;
  finalEnergyTotal?: Maybe<Scalars['Float']['output']>;
  primaryEnergyRelative?: Maybe<Scalars['Float']['output']>;
  primaryEnergyTotal?: Maybe<Scalars['Float']['output']>;
};

export type ConsumptionStrandingDataItem = {
  count: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type ConsumptionSummary = {
  consumptionCategories: Array<YearlyConsumption>;
};

export type ConsumptionWasteDetailsDraftMutationOutput = {
  consumption_waste_details_draft?: Maybe<consumption_waste_details_draft>;
  id: Scalars['Int']['output'];
};

export type ConsumptionWasteDetailsInput = {
  amount: Scalars['Float']['input'];
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
  frequency: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  volume: Scalars['Float']['input'];
};

export type ConsumptionWasteDetailsMutationOutput = {
  consumption_waste_details?: Maybe<consumption_waste_details>;
  id: Scalars['Int']['output'];
};

export type ConvertFileToEnergyCertificateInput = {
  economicUnitId?: InputMaybe<Scalars['Int']['input']>;
  fileId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
};

export type ConvertFileToEnergyCertificateOutput = {
  buildingDraftId: Scalars['Int']['output'];
  energyCertificateDraftId: Scalars['Int']['output'];
};

export type ConvertFilesToEnergyCertificatesInput = {
  economicUnitId?: InputMaybe<Scalars['Int']['input']>;
  fileId: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
};

export type ConvertFilesToEnergyCertificatesOutput = {
  success: Scalars['Boolean']['output'];
};

export type Coordinates = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CostByRenovationCategoryLegend = {
  actionsCount: Scalars['Int']['output'];
  name: renovation_category_enum;
  percentage: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type CostByRenovationCategoryOutput = {
  legend: Array<CostByRenovationCategoryLegend>;
  series: Array<CostByRenovationCategorySeries>;
  startYear: Scalars['Int']['output'];
};

export type CostByRenovationCategorySeries = {
  data: ScenarioAnalysisCostByRenovationCategorySeriesData;
  name: renovation_category_enum;
};

export type CreateActionPlanInput = {
  building_id: Scalars['Int']['input'];
  scenario_id: Scalars['Int']['input'];
};

export type CreateActionPlanResponse = {
  stable_id: Scalars['Int']['output'];
};

export type CreateBuildingModelTwinOutput = {
  buildingModelId?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCertificate = {
  condition?: InputMaybe<Scalars['Boolean']['input']>;
  fileId?: InputMaybe<Scalars['Int']['input']>;
  levelType?: InputMaybe<certificate_level_type_enum>;
  score?: InputMaybe<Scalars['Int']['input']>;
  type: certificate_type_enum;
};

export type CreateCertificateFileResponse = {
  fileId: Scalars['Int']['output'];
  uploadURL: Scalars['String']['output'];
};

export type CreateConsumptionInvoiceDraftOutput = {
  CreateConsumptionInvoiceDraftOutput?: Maybe<consumption_invoice_draft>;
  consumption_invoice_draft_id: Scalars['Int']['output'];
  upload_url: Scalars['String']['output'];
};

export type CreateConsumptionInvoiceFromDraftOutput = {
  CreateConsumptionInvoiceFromDraftOutput?: Maybe<consumption_invoice>;
  consumption_invoice_id: Scalars['Int']['output'];
};

export type CreateCustomFieldOutput = {
  id: Scalars['Int']['output'];
};

export type CreateEmissionCertificateDraftWithFileOutput = {
  file_id: Scalars['Int']['output'];
  upload_url: Scalars['String']['output'];
};

export type CreateEmissionCertificateDraftWithoutFileInput = {
  emission_certificate_document_type_id?: InputMaybe<emission_certificate_document_type_enum>;
  emission_certificate_energy_source_type_id?: InputMaybe<emission_certificate_energy_source_type_enum>;
  emission_factor?: InputMaybe<Scalars['Float']['input']>;
  emission_factor_active_value_type: energy_supplier_value_type_enum;
  emission_factor_progressive?: InputMaybe<Array<EnergySupplierValueProgressiveDraftInput>>;
  issuer: Scalars['String']['input'];
  primary_energy_factor?: InputMaybe<Scalars['Float']['input']>;
  primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
  primary_energy_factor_progressive?: InputMaybe<Array<EnergySupplierValueProgressiveDraftInput>>;
  valid_from?: InputMaybe<Scalars['DateTime']['input']>;
  valid_until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateEmissionCertificateDraftWithoutFileOutput = {
  CreateEmissionCertificateDraftWithoutFileOutput?: Maybe<emission_certificate_draft>;
  emission_certificate_draft_id: Scalars['Int']['output'];
};

export type CreateEmissionCertificateInput = {
  emission_certificate_document_type_id: emission_certificate_document_type_enum;
  emission_certificate_energy_source_type_id: emission_certificate_energy_source_type_enum;
  emission_factor?: InputMaybe<Scalars['Float']['input']>;
  emission_factor_active_value_type: energy_supplier_value_type_enum;
  emission_factor_progressive?: InputMaybe<Array<EnergySupplierValueProgressiveInput>>;
  file_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  issuer: Scalars['String']['input'];
  primary_energy_factor?: InputMaybe<Scalars['Float']['input']>;
  primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
  primary_energy_factor_progressive?: InputMaybe<Array<EnergySupplierValueProgressiveInput>>;
  valid_from?: InputMaybe<Scalars['DateTime']['input']>;
  valid_until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateEmissionCertificateOutput = {
  CreateEmissionCertificateOutput?: Maybe<emission_certificate>;
  emission_certificate_id: Scalars['Int']['output'];
};

export type CreateEvidenceOutput = {
  CreateEvidenceOutput: Array<report_evidence>;
  evidence_id: Scalars['Int']['output'];
  upload_url: Scalars['String']['output'];
};

export type CreateEvidenceOutputCreateEvidenceOutputArgs = {
  distinct_on?: InputMaybe<Array<report_evidence_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_evidence_order_by>>;
  where?: InputMaybe<report_evidence_bool_exp>;
};

export type CreateFolderInput = {
  name: Scalars['String']['input'];
  parentId: Scalars['Int']['input'];
};

export type CreateReportOutput = {
  CreateReportOutput?: Maybe<report>;
  report_id: Scalars['Int']['output'];
};

export type CreateScenarioInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateVentilationRenovationParameterInput = {
  consumer_technology_type: ventilation_supported_technology_enum;
  efficiency?: InputMaybe<Scalars['Float']['input']>;
  final_energy: Scalars['Float']['input'];
  number_of_units?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateVentilationRenovationParameterObject = {
  consumer_technology_type: ventilation_supported_technology_enum;
  efficiency?: Maybe<Scalars['Float']['output']>;
  final_energy: Scalars['Float']['output'];
  number_of_units?: Maybe<Scalars['Int']['output']>;
};

export type CreateVentilationRenovationParameterOutput = {
  final_energy: Scalars['Float']['output'];
  number_of_units?: Maybe<Scalars['Int']['output']>;
  ventilation_consumer_technology_type: ventilation_supported_technology_enum;
  ventilation_efficiency?: Maybe<Scalars['Float']['output']>;
};

export type CreateVentilationRenovationParametersUnionMember = {
  createVentilationRenovationParameters: CreateVentilationRenovationParameterObject;
};

export type CrremOrgPreferences = {
  activeCRREMConfiguration: CRREMConfigurationUnion;
  crremVersion: crrem_version_type_enum;
  emissionFactorType: emission_factor_type_enum;
};

export type CustomActionParametersUnion =
  | EnergySourceCustomActionParametersUnionMember
  | SystemCustomActionParametersUnionMember;

export type CustomActionParametersUnionMember = {
  customActionParameters: CustomActionParametersUnion;
};

export type CustomActionRenovationParameterInput = {
  custom_name: Scalars['String']['input'];
  energy_source_type?: InputMaybe<energy_source_type_enum>;
  fraction: Scalars['Float']['input'];
  renovation_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  system_type?: InputMaybe<energy_system_type_enum>;
};

export type CustomBulkActionParametersUnion =
  | EnergySourceCustomBulkActionParametersUnionMember
  | SystemCustomBulkActionParametersUnionMember;

export type CustomBulkActionParametersUnionMember = {
  customActionParameters: CustomBulkActionParametersUnion;
};

export type CustomCostInput = {
  cost_per_m2_custom?: InputMaybe<Scalars['Float']['input']>;
  cost_total_custom?: InputMaybe<Scalars['Float']['input']>;
  use_custom_cost?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomField = {
  entity: custom_field_entity_enum;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: custom_field_type_enum;
};

export type CustomTarget = {
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  target_definitions: Array<TargetDefinition>;
};

export type CustomTargetMetrics = {
  reached: Scalars['Boolean']['output'];
  targetValue: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type CustomTargetPathItemOutput = {
  intersectionYear: Scalars['Int']['output'];
  targetPath: Array<Scalars['Float']['output']>;
};

export type CustomTargetPathLineOutput = {
  targetPath?: Maybe<Array<Scalars['Float']['output']>>;
};

export type CustomTargetPathOutput = {
  co2?: Maybe<CustomTargetPathItemOutput>;
};

export type CustomTargetResult = {
  co2_emissions: Array<CustomTargetMetrics>;
  final_energy: Array<CustomTargetMetrics>;
  name: Scalars['String']['output'];
  primary_energy: Array<CustomTargetMetrics>;
};

export type DateRangeInput = {
  max?: InputMaybe<Scalars['DateTime']['input']>;
  min?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteActionPlanResponse = {
  stable_id: Scalars['Int']['output'];
};

export type DeleteAllBuildingsOutput = {
  success: Scalars['Boolean']['output'];
};

export type DeleteBuildingModelTwinOutput = {
  buildingModelId: Scalars['Int']['output'];
  newBuildingModelId?: Maybe<Scalars['Int']['output']>;
};

export type DeleteCertificate = {
  id: Scalars['Int']['input'];
};

export type DeleteCustomFieldOutput = {
  success: Scalars['Boolean']['output'];
};

export type DeleteEmissionCertificateOutput = {
  success: Scalars['Boolean']['output'];
};

export type DeleteFolderInput = {
  folderId: Scalars['Int']['input'];
};

export type DeleteScenarioInput = {
  scenario_id: Scalars['Int']['input'];
};

export type DeleteTwinBuildingModelOutput = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DriveFileBuildingDraftRef = {
  id: Scalars['Int']['output'];
};

export type DriveFileConsumptionInvoiceDraftRef = {
  buildingId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type DriveFileConsumptionInvoiceRef = {
  buildingId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type DriveFileEmissionCertificateDraftRef = {
  id: Scalars['Int']['output'];
};

export type DriveFileEmissionCertificateRef = {
  id: Scalars['Int']['output'];
};

export type DriveFileEnergyCertificateDraftRef = {
  buildingDraft: DriveFileBuildingDraftRef;
  id: Scalars['Int']['output'];
};

export type DriveFileEnergyCertificateRef = {
  buildingDraftId?: Maybe<Scalars['Int']['output']>;
  buildingId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type DriveFileMembershipOutput = {
  createdAt: Scalars['String']['output'];
  file: DriveFileOutput;
  fileId: Scalars['Int']['output'];
  folderId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type DriveFileOutput = {
  consumptionInvoiceDrafts: Array<DriveFileConsumptionInvoiceDraftRef>;
  consumptionInvoices: Array<DriveFileConsumptionInvoiceRef>;
  createdAt: Scalars['String']['output'];
  emissionCertificateDrafts: Array<DriveFileEmissionCertificateDraftRef>;
  emissionCertificates: Array<DriveFileEmissionCertificateRef>;
  energyCertificateDrafts: Array<DriveFileEnergyCertificateDraftRef>;
  energyCertificates: Array<DriveFileEnergyCertificateRef>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uploading: Scalars['Boolean']['output'];
};

export type DriveFolderOutput = {
  buildingId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  economicUnitId?: Maybe<Scalars['Int']['output']>;
  folderTypeId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['Int']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  portfolioId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type DriveFolderTreeNodeOutput = {
  childCount: Scalars['Int']['output'];
  folderTypeId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
};

export type DriveMutationOutput = {
  fileId: Scalars['Int']['output'];
};

export type DuplicateScenarioInput = {
  copy_name_suffix: Scalars['String']['input'];
  scenario_id: Scalars['Int']['input'];
};

export type EconomicUnitAmount = {
  amount: Scalars['Int']['output'];
};

export type EconomicUnitOutput = {
  ids: Array<Scalars['Int']['output']>;
};

/** This is a workaround to fix the typing of the relation between EconomicUnits & economic_unit table. */
export type EconomicUnits = {
  economicUnit: economic_unit;
  id: Scalars['Int']['output'];
};

export enum EconomicUnitsOrderByFields {
  city = 'city',
  economic_unit_created_at = 'economic_unit_created_at',
  economic_unit_customer_identifier = 'economic_unit_customer_identifier',
  economic_unit_name = 'economic_unit_name',
  postal_code = 'postal_code',
  state = 'state',
}

export type EconomicUnitsOrderByInput = {
  direction: OrderDirection;
  orderBy: EconomicUnitsOrderByFields;
};

export type EconomicUnitsOutput = {
  count: Scalars['Int']['output'];
  economicUnits: Array<EconomicUnits>;
};

export type EditActionOutput = {
  error?: Maybe<action_mutation_error_enum>;
  message?: Maybe<Scalars['String']['output']>;
};

export type EditBulkActionOutput = {
  message: Scalars['String']['output'];
};

export type EditCertificate = {
  condition?: InputMaybe<Scalars['Boolean']['input']>;
  fileId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  levelType?: InputMaybe<certificate_level_type_enum>;
  score?: InputMaybe<Scalars['Int']['input']>;
  type: certificate_type_enum;
};

export type EditCertificateResponse = {
  certificates: Array<Certificate>;
};

export type EditCustomFieldOutput = {
  id: Scalars['Int']['output'];
};

export type EditInvoiceSnapshotData = {
  advancePayments?: InputMaybe<Scalars['Float']['input']>;
  amountPayable?: InputMaybe<Scalars['Float']['input']>;
  co2FeeGross?: InputMaybe<Scalars['Float']['input']>;
  co2FeeNet?: InputMaybe<Scalars['Float']['input']>;
  creditAmount?: InputMaybe<Scalars['Float']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceReference?: InputMaybe<Scalars['String']['input']>;
  invoiceType?: InputMaybe<cbi_invoice_type_enum>;
  isActive: Scalars['Boolean']['input'];
  lines: Array<ConsumptionLineInput>;
  operationalControl?: InputMaybe<cbi_operational_control_enum>;
  outstandingBalance?: InputMaybe<Scalars['Float']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  totalCostGross?: InputMaybe<Scalars['Float']['input']>;
  totalCostNet?: InputMaybe<Scalars['Float']['input']>;
  vatAmount?: InputMaybe<Scalars['Float']['input']>;
  vatPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type EfficiencyClassDeviationResult = {
  newEfficiencyClass: efficiency_class_enum;
  previousEfficiencyClass: efficiency_class_enum;
};

export type EfficiencyClassOutput = {
  after?: Maybe<efficiency_class_enum>;
  before?: Maybe<efficiency_class_enum>;
};

export type EfficiencyClassSlfComplianceAnalysisOutput = {
  efficiencyClass: efficiency_class_enum;
  type: slf_compliance_factor_enum;
};

export type EfficiencyClassSplitDevelopmentOutput = {
  data: Array<EfficiencyClassSplitPath>;
  startYear: Scalars['Int']['output'];
};

export type EfficiencyClassSplitPath = {
  efficiencyClass: efficiency_class_enum;
  path: Array<Scalars['Int']['output']>;
};

export type EmissionCertificateDraftListOutput = {
  count: Scalars['Int']['output'];
  drafts: Array<EmissionCertificateDraftWithConvertedValues>;
};

export enum EmissionCertificateDraftOrderBy {
  created_at = 'created_at',
  issuer = 'issuer',
}

export type EmissionCertificateDraftOrderByInput = {
  direction: OrderDirection;
  orderBy: EmissionCertificateDraftOrderBy;
};

export type EmissionCertificateDraftWhereInput = {
  issuerSearch?: InputMaybe<Scalars['String']['input']>;
};

export type EmissionCertificateDraftWithConvertedValues = {
  created_at: Scalars['DateTime']['output'];
  emission_certificate_document_type_id?: Maybe<Scalars['String']['output']>;
  emission_certificate_energy_source_type_id?: Maybe<Scalars['String']['output']>;
  emission_factor?: Maybe<Scalars['Float']['output']>;
  emission_factor_active_value_type: Scalars['String']['output'];
  emission_factor_progressive?: Maybe<Array<YearValueWithNull>>;
  file?: Maybe<FileInfo>;
  id: Scalars['Int']['output'];
  issuer: Scalars['String']['output'];
  org_id: Scalars['Int']['output'];
  primary_energy_factor?: Maybe<Scalars['Float']['output']>;
  primary_energy_factor_active_value_type: Scalars['String']['output'];
  primary_energy_factor_progressive?: Maybe<Array<YearValueWithNull>>;
  updated_at: Scalars['DateTime']['output'];
  valid_from?: Maybe<Scalars['DateTime']['output']>;
  valid_until?: Maybe<Scalars['DateTime']['output']>;
};

export type EmissionCertificateListItem = {
  associated_action_plans_count?: Maybe<Scalars['Int']['output']>;
  associated_buildings_count?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['DateTime']['output'];
  emission_certificate_energy_source_type_id?: Maybe<emission_certificate_energy_source_type_enum>;
  emission_certificate_value_path?: Maybe<EmissionCertificateValuePath>;
  emission_factor: Scalars['Float']['output'];
  emission_factor_active_value_type: energy_supplier_value_type_enum;
  id: Scalars['Int']['output'];
  issuer: Scalars['String']['output'];
  primary_energy_factor?: Maybe<Scalars['Float']['output']>;
  primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
  valid_until?: Maybe<Scalars['DateTime']['output']>;
};

export type EmissionCertificateListOutput = {
  certificates: Array<EmissionCertificateListItem>;
  count: Scalars['Int']['output'];
};

export type EmissionCertificateMutation = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum EmissionCertificateOrderBy {
  created_at = 'created_at',
  emission_certificate_energy_source_type_id = 'emission_certificate_energy_source_type_id',
  emission_factor = 'emission_factor',
  issuer = 'issuer',
  primary_energy_factor = 'primary_energy_factor',
  valid_until = 'valid_until',
}

export type EmissionCertificateOrderByInput = {
  direction: OrderDirection;
  orderBy: EmissionCertificateOrderBy;
};

export enum EmissionCertificateStatusFilter {
  ALL = 'ALL',
  EXPIRED = 'EXPIRED',
  VALID = 'VALID',
}

export type EmissionCertificateValuePath = {
  emission_factor: Array<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  primary_energy_factor: Array<Scalars['Float']['output']>;
};

export type EmissionCertificateWhereInput = {
  issuerSearch?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmissionCertificateStatusFilter>;
};

export type EmissionFactorsObject = {
  BIO_GAS: Array<ProgressiveFactor>;
  COAL: Array<ProgressiveFactor>;
  DISTRICT_HEATING_CHP_FOSSIL_COAL: Array<ProgressiveFactor>;
  DISTRICT_HEATING_CHP_FOSSIL_GAS: Array<ProgressiveFactor>;
  DISTRICT_HEATING_CHP_RENEWABLE: Array<ProgressiveFactor>;
  DISTRICT_HEATING_PLANTS_FOSSIL_COAL: Array<ProgressiveFactor>;
  DISTRICT_HEATING_PLANTS_FOSSIL_GAS: Array<ProgressiveFactor>;
  DISTRICT_HEATING_PLANTS_RENEWABLE: Array<ProgressiveFactor>;
  ELECTRICITY_GREEN: Array<ProgressiveFactor>;
  ELECTRICITY_MIX: Array<ProgressiveFactor>;
  FUEL_OIL: Array<ProgressiveFactor>;
  LIGNITE: Array<ProgressiveFactor>;
  LPG: Array<ProgressiveFactor>;
  NATURAL_GAS: Array<ProgressiveFactor>;
  SOLAR: Array<ProgressiveFactor>;
  UNSPECIFIED: Array<ProgressiveFactor>;
  WOOD: Array<ProgressiveFactor>;
  WOODEN_PELLETS: Array<ProgressiveFactor>;
};

export type EnergyCertificateDraftTransformOutput = {
  EnergyCertificateDraftTransformOutput?: Maybe<energy_certificate>;
  energyCertificateId?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EnergyConsumerBuildingDataOutput = {
  energyConsumptionM2: Scalars['Float']['output'];
  energyConsumptionTotal: Scalars['Float']['output'];
  energySourceType: energy_source_type_enum;
};

export type EnergyConsumerMutation = {
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  efficiency?: InputMaybe<Scalars['Float']['input']>;
  energy_consumer_technology_type_id?: InputMaybe<energy_consumer_technology_type_enum>;
  energy_consumer_type_id?: InputMaybe<energy_consumer_type_enum>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EnergyDataInput = {
  energySource?: InputMaybe<energy_source_type_enum>;
  energySystemType: energy_system_type_enum;
  finalEnergyDemand?: InputMaybe<Scalars['Float']['input']>;
};

export type EnergyDataOutput = {
  energySource: energy_source_type_enum;
  energySystemType: energy_system_type_enum;
  finalEnergyDemand: Scalars['Float']['output'];
};

export type EnergyDistributionMutation = {
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  energy_distribution_type_id?: InputMaybe<energy_distribution_type_enum>;
  heat_distribution_loss?: InputMaybe<Scalars['Float']['input']>;
  heat_transfer_loss?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  last_balancing_set_to_never?: InputMaybe<Scalars['Boolean']['input']>;
  last_hydraulic_balancing?: InputMaybe<Scalars['DateTime']['input']>;
  recoverable_heat_loss?: InputMaybe<Scalars['Float']['input']>;
};

export type EnergyProducerMutation = {
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  energy_source_type?: InputMaybe<energy_source_type_enum>;
  id: Scalars['Int']['input'];
  module_angle?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nominal_power?: InputMaybe<Scalars['Float']['input']>;
  solar_active_area?: InputMaybe<Scalars['Float']['input']>;
};

export type EnergyProducerRouteMutation = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  energy_produced?: InputMaybe<Scalars['Float']['input']>;
  energy_producer_id?: InputMaybe<Scalars['Int']['input']>;
  energy_source_type?: InputMaybe<energy_source_type_enum>;
  energy_system_id?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type EnergySourceCustomActionParametersUnionMember = {
  energySourceCustomActionParameters: EnergySourceCustomActionRenovationParameterObject;
};

export type EnergySourceCustomActionRenovationParameterObject = {
  custom_name: Scalars['String']['output'];
  energy_source_type: energy_source_type_enum;
  fraction: Scalars['Float']['output'];
  renovation_ids?: Maybe<Array<Scalars['String']['output']>>;
};

export type EnergySourceCustomBulkActionParametersUnionMember = {
  energySourceCustomActionParameters: EnergySourceCustomBulkActionRenovationParameterObject;
};

export type EnergySourceCustomBulkActionRenovationParameterObject = {
  custom_name: Scalars['String']['output'];
  energy_source_type: energy_source_type_enum;
  fraction: Scalars['Float']['output'];
};

export type EnergyStorageMutation = {
  annual_heat_loss?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  energy_storage_type_id?: InputMaybe<energy_storage_type_enum>;
  id: Scalars['Int']['input'];
  recoverable_heat_loss?: InputMaybe<Scalars['Float']['input']>;
};

export type EnergySupplierValueProgressiveDraftInput = {
  value?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};

export type EnergySupplierValueProgressiveInput = {
  value: Scalars['Float']['input'];
  year: Scalars['Int']['input'];
};

export type EnergySystemMutation = {
  create?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  energy_producer_route_mutations?: InputMaybe<Array<EnergyProducerRouteMutation>>;
  energy_system_route_mutations?: InputMaybe<Array<EnergySystemRouteMutation>>;
  energy_system_type_id?: InputMaybe<energy_system_type_enum>;
  id: Scalars['Int']['input'];
};

export type EnergySystemRouteBulkRenovationParameterObject = {
  emission_certificate_id?: Maybe<Scalars['Int']['output']>;
  energy_source_type: energy_source_type_enum;
};

export type EnergySystemRouteMutation = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  emission_certificate?: InputMaybe<EmissionCertificateMutation>;
  energy_consumer_id?: InputMaybe<Scalars['Int']['input']>;
  energy_distribution_id?: InputMaybe<Scalars['Int']['input']>;
  energy_final?: InputMaybe<Scalars['Float']['input']>;
  energy_source_type?: InputMaybe<energy_source_type_enum>;
  energy_storage_id?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  primary_energy_factor_emission_certificate?: InputMaybe<EmissionCertificateMutation>;
  use_renewable_energy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnergySystemRouteParametersBulkUnionMember = {
  energySystemRouteParameters: EnergySystemRouteBulkRenovationParameterObject;
};

export type EnergySystemRouteParametersUnionMember = {
  energySystemRouteParameters: EnergySystemRouteRenovationParameterObject;
};

export type EnergySystemRouteRenovationParameterInput = {
  emission_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  energy_source_type: energy_source_type_enum;
};

export type EnergySystemRouteRenovationParameterObject = {
  emission_certificate_id?: Maybe<Scalars['Int']['output']>;
  energy_source_type: energy_source_type_enum;
};

export type EnergySystemRouteRenovationParameterOutput = {
  energy_source_type: energy_source_type_enum;
};

export type EnergyValuesCRREMOutput = {
  analysisType: emission_factor_type_enum;
  co2_abatement_costs: Scalars['Float']['output'];
  co2_emissions: Scalars['Float']['output'];
  co2_emissions_total: Scalars['Float']['output'];
  co2_tax_cost: Scalars['Float']['output'];
  efficiency_class: efficiency_class_enum;
  energy_final: Scalars['Float']['output'];
  energy_final_cost: Scalars['Float']['output'];
  energy_final_total: Scalars['Float']['output'];
  energy_primary: Scalars['Float']['output'];
  energy_primary_total: Scalars['Float']['output'];
  heating_demand?: Maybe<Scalars['Float']['output']>;
  heating_demand_total?: Maybe<Scalars['Float']['output']>;
  payback_period: Scalars['Float']['output'];
  renovation_costs?: Maybe<Scalars['Float']['output']>;
  stranding_date: Scalars['DateTime']['output'];
};

export type EnergyValuesNationalEnergyLawOutput = {
  analysisType: emission_factor_type_enum;
  co2_abatement_costs: Scalars['Float']['output'];
  co2_emissions: Scalars['Float']['output'];
  co2_emissions_total: Scalars['Float']['output'];
  co2_tax_cost: Scalars['Float']['output'];
  efficiency_class: efficiency_class_enum;
  energy_final: Scalars['Float']['output'];
  energy_final_cost: Scalars['Float']['output'];
  energy_final_total: Scalars['Float']['output'];
  energy_primary: Scalars['Float']['output'];
  energy_primary_total: Scalars['Float']['output'];
  heating_demand?: Maybe<Scalars['Float']['output']>;
  heating_demand_total?: Maybe<Scalars['Float']['output']>;
  payback_period: Scalars['Float']['output'];
  renovation_costs?: Maybe<Scalars['Float']['output']>;
};

export type EnergyValuesOutputUnion = EnergyValuesCRREMOutput | EnergyValuesNationalEnergyLawOutput;

export type EnvelopeBulkRenovationParameterObject = {
  envelope_type: envelope_type_enum;
  insulation_lambda?: Maybe<Scalars['Float']['output']>;
  insulation_material_category?: Maybe<insulation_material_category_enum>;
  insulation_method?: Maybe<insulation_method_enum>;
  insulation_thickness?: Maybe<Scalars['Float']['output']>;
  material_name: Scalars['String']['output'];
  u_value?: Maybe<Scalars['Float']['output']>;
};

export type EnvelopeMutation = {
  area?: InputMaybe<Scalars['Float']['input']>;
  base_construction_lambda?: InputMaybe<Scalars['Float']['input']>;
  base_construction_material_name?: InputMaybe<Scalars['String']['input']>;
  base_construction_thickness?: InputMaybe<Scalars['Float']['input']>;
  create?: InputMaybe<Scalars['Boolean']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  envelope_type?: InputMaybe<envelope_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inclination?: InputMaybe<Scalars['Float']['input']>;
  insulation_lambda?: InputMaybe<Scalars['Float']['input']>;
  insulation_material_category?: InputMaybe<insulation_material_category_enum>;
  insulation_material_name?: InputMaybe<Scalars['String']['input']>;
  insulation_method?: InputMaybe<insulation_method_enum>;
  insulation_thickness?: InputMaybe<Scalars['Float']['input']>;
  orientation?: InputMaybe<Scalars['Float']['input']>;
  u_value?: InputMaybe<Scalars['Float']['input']>;
};

export type EnvelopeParametersBulkUnionMember = {
  envelopeParameters: EnvelopeBulkRenovationParameterObject;
};

export type EnvelopeParametersUnionMember = {
  envelopeParameters: EnvelopeRenovationParameterObject;
};

export type EnvelopeRenovationParameterInput = {
  envelope_type: envelope_type_enum;
  insulation_lambda?: InputMaybe<Scalars['Float']['input']>;
  insulation_material_category?: InputMaybe<insulation_material_category_enum>;
  insulation_method?: InputMaybe<insulation_method_enum>;
  insulation_thickness?: InputMaybe<Scalars['Float']['input']>;
  material_name: Scalars['String']['input'];
  renovation_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  u_value?: InputMaybe<Scalars['Float']['input']>;
};

export type EnvelopeRenovationParameterObject = {
  envelope_type: envelope_type_enum;
  insulation_lambda?: Maybe<Scalars['Float']['output']>;
  insulation_material_category?: Maybe<insulation_material_category_enum>;
  insulation_method?: Maybe<insulation_method_enum>;
  insulation_thickness?: Maybe<Scalars['Float']['output']>;
  material_name: Scalars['String']['output'];
  renovation_ids?: Maybe<Array<Scalars['String']['output']>>;
  u_value?: Maybe<Scalars['Float']['output']>;
};

export type EnvelopeRenovationParameterOutput = {
  envelope_type: envelope_type_enum;
  insulation_lambda?: Maybe<Scalars['Float']['output']>;
  insulation_material_category?: Maybe<insulation_material_category_enum>;
  insulation_method?: Maybe<insulation_method_enum>;
  insulation_thickness?: Maybe<Scalars['Float']['output']>;
  material_name: Scalars['String']['output'];
  u_value?: Maybe<Scalars['Float']['output']>;
};

export type EsgConsumptionAnalysis = {
  co2Intensity?: Maybe<Scalars['Float']['output']>;
  co2IntensityAbsolute?: Maybe<Scalars['Float']['output']>;
  co2Tax?: Maybe<Scalars['Float']['output']>;
  co2TaxAbsolute?: Maybe<Scalars['Float']['output']>;
  efficiencyClass?: Maybe<efficiency_class_enum>;
  energyCost?: Maybe<Scalars['Float']['output']>;
  energyCostAbsolute?: Maybe<Scalars['Float']['output']>;
  euTaxonomy?: Maybe<eu_taxonomy_compliance_enum>;
  finalEnergy?: Maybe<Scalars['Float']['output']>;
  finalEnergyAbsolute?: Maybe<Scalars['Float']['output']>;
  primaryEnergy?: Maybe<Scalars['Float']['output']>;
  primaryEnergyAbsolute?: Maybe<Scalars['Float']['output']>;
};

export type EuTaxonomyComplianceAnalysisOutput = {
  euTaxonomyCompliance: eu_taxonomy_compliance_enum;
  type: slf_compliance_factor_enum;
};

export type EvidenceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type ExcelExportConsumptionYearRangeInput = {
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export type ExcelExportOutput = {
  body: Scalars['String']['output'];
};

export type ExcelScenarioExportOptions = {
  action_plan_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
};

export enum ExcelSheetType {
  CRREM_PATH = 'CRREM_PATH',
  ENVELOPE = 'ENVELOPE',
  ESG_ANALYSIS_CONSUMPTION = 'ESG_ANALYSIS_CONSUMPTION',
  ESG_ANALYSIS_DEMAND = 'ESG_ANALYSIS_DEMAND',
  SYSTEM = 'SYSTEM',
}

export type ExclusionNoteParameterInput = {
  note: Scalars['String']['input'];
};

export type ExclusionNoteParameterObject = {
  note: Scalars['String']['output'];
};

export type ExclusionNoteParametersUnionMember = {
  exclusionNoteParameters: ExclusionNoteParameterObject;
};

export type ExportClimateRiskV2ReportOutput = {
  body: Scalars['String']['output'];
};

export enum ExportEntityType {
  ACTION_PLAN = 'ACTION_PLAN',
  BUILDING = 'BUILDING',
  SCENARIO = 'SCENARIO',
}

export type ExportFileInput = {
  entityIds: Array<Scalars['Float']['input']>;
  excelBuildingColumnOptions?: InputMaybe<ColumnBuildingExportOptions>;
  excelBuildingTemplateOptions?: InputMaybe<TemplateBuildingExportOptions>;
  excelScenarioOptions?: InputMaybe<ExcelScenarioExportOptions>;
  exportType: ExportEntityType;
  format: ExportFormat;
};

export type ExportFileOutput = {
  fileName: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum ExportFormat {
  EXCEL = 'EXCEL',
  PDF = 'PDF',
}

export type ExportReportAsPdfAsyncOutput = {
  asyncJobId: Scalars['Int']['output'];
};

export type FetchLastUsedTypesOfUseOutput = {
  data: Array<type_of_use_enum>;
};

export type FileInfo = {
  created_at: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type FilePreviewOutput = {
  downloadUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type FillBuildingDraftOutput = {
  BuildingDraftId: Array<building_draft>;
  BuildingDraftId_aggregate: building_draft_aggregate;
  buildingDraftId: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FillBuildingDraftOutputBuildingDraftIdArgs = {
  distinct_on?: InputMaybe<Array<building_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_order_by>>;
  where?: InputMaybe<building_draft_bool_exp>;
};

export type FillBuildingDraftOutputBuildingDraftId_aggregateArgs = {
  distinct_on?: InputMaybe<Array<building_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_order_by>>;
  where?: InputMaybe<building_draft_bool_exp>;
};

export type FinalEnergyImpactTrendOutput = {
  after: Array<Scalars['Float']['output']>;
  before: Array<Scalars['Float']['output']>;
  custom_target: Array<CustomTargetMetrics>;
  startYear: Scalars['Int']['output'];
  target_path: Array<Scalars['Float']['output']>;
};

export type FloatRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_array_comparison_exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Float']['input']>>;
  _eq?: InputMaybe<Array<Scalars['Float']['input']>>;
  _gt?: InputMaybe<Array<Scalars['Float']['input']>>;
  _gte?: InputMaybe<Array<Scalars['Float']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['Float']['input']>>;
  _lte?: InputMaybe<Array<Scalars['Float']['input']>>;
  _neq?: InputMaybe<Array<Scalars['Float']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Float']['input']>>>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_comparison_exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloorAreaByClassOfUseOutput = {
  area: Scalars['Float']['output'];
  classOfUse: class_of_use_enum;
};

export type FloorAreaDevelopmentOutput = {
  area: Array<Scalars['Float']['output']>;
  excludedSincePreviousYear: Array<Scalars['Int']['output']>;
  newConstructionBuildings: Array<Scalars['Int']['output']>;
  startYear: Scalars['Int']['output'];
  totalBuildings: Array<Scalars['Int']['output']>;
};

export type FolderBreadcrumbOutput = {
  breadcrumb: Array<BreadcrumbItem>;
};

export type FolderMutationOutput = {
  folderId: Scalars['Int']['output'];
};

export type GetActionPlanByStableIdResponse = {
  action_plan?: Maybe<action_plan>;
  void: Scalars['Boolean']['output'];
};

export type GetBuildingCRREMConsumptionAnalysisOutput = {
  co2Path: PathOutput;
  co2TargetPath: Array<Scalars['Float']['output']>;
  cumulativeExcessEmissions: Scalars['Float']['output'];
  energyPath: PathOutput;
  energyTargetPath: Array<Scalars['Float']['output']>;
  excessEmissionCostPath: Array<Scalars['Float']['output']>;
  scope1Path: PathOutput;
  scope2Path: PathOutput;
  strandingYear?: Maybe<Scalars['Int']['output']>;
  yearOfExcedance?: Maybe<Scalars['Int']['output']>;
};

export type GetBuildingFolderOutput = {
  folderId?: Maybe<Scalars['Int']['output']>;
};

export type GetBuildingModelMutationAvailabilityActionPlan = {
  id: Scalars['Int']['output'];
  scenario_id: Scalars['Int']['output'];
  scenario_name: Scalars['String']['output'];
  scenario_updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type GetBuildingModelMutationAvailabilityOutput = {
  affected_action_plans: Array<GetBuildingModelMutationAvailabilityActionPlan>;
};

export type GetBuildingPdfFilesOutput = {
  files: Array<BuildingPdfFileOutput>;
};

export type GetFileIdByAsyncJobIdOutput = {
  fileId: Scalars['Int']['output'];
};

export type GetFolderChildrenOutput = {
  folders: Array<DriveFolderTreeNodeOutput>;
};

export type GetFolderContentsOutput = {
  fileMemberships: Array<DriveFileMembershipOutput>;
  folders: Array<DriveFolderOutput>;
};

export type GetOrgCustomFieldsOutput = {
  customFields: Array<CustomField>;
};

export type GetRootFolderForTreeOutput = {
  rootFolder?: Maybe<DriveFolderTreeNodeOutput>;
};

export type GetSessionDataOutput = {
  enabledFeatureFlags: Array<Scalars['String']['output']>;
  firstBuildingId?: Maybe<Scalars['Int']['output']>;
  hasPortfolioWithWriteAccess: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  org: SessionDataOrg;
  user: SessionDataUser;
};

export type GetUserLoginHistoryOutput = {
  events: Array<LoginHistoryEvent>;
  lastIp?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  loginsCount?: Maybe<Scalars['Int']['output']>;
};

export type GlbAccessResponse = {
  signedUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type HeatingEnergySourceDevelopmentOutput = {
  data: Array<HeatingEnergySourceDevelopmentPath>;
  startYear: Scalars['Int']['output'];
};

export type HeatingEnergySourceDevelopmentPath = {
  path: Array<Scalars['Int']['output']>;
  type: main_energy_source_type_enum;
};

export type HydraulicBalancingBulkRenovationParameterObject = {
  costs_with_components?: Maybe<Scalars['Boolean']['output']>;
  last_hydraulic_balancing: Scalars['DateTime']['output'];
};

export type HydraulicBalancingParametersBulkUnionMember = {
  hydraulicBalancingParameters: HydraulicBalancingBulkRenovationParameterObject;
};

export type HydraulicBalancingParametersUnionMember = {
  hydraulicBalancingParameters: HydraulicBalancingRenovationParameterObject;
};

export type HydraulicBalancingRenovationParameterInput = {
  costs_with_components?: InputMaybe<Scalars['Boolean']['input']>;
  last_hydraulic_balancing: Scalars['DateTime']['input'];
};

export type HydraulicBalancingRenovationParameterObject = {
  costs_with_components?: Maybe<Scalars['Boolean']['output']>;
  last_hydraulic_balancing: Scalars['DateTime']['output'];
};

export type HydraulicBalancingRenovationParameterOutput = {
  costs_with_components?: Maybe<Scalars['Boolean']['output']>;
  last_hydraulic_balancing: Scalars['DateTime']['output'];
};

export type ImplementActionOutput = {
  ImplementActionOutput?: Maybe<action>;
  action_id: Scalars['Int']['output'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_comparison_exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvestmentCostOutput = {
  cost: Array<Scalars['Float']['output']>;
  startYear: Scalars['Int']['output'];
};

export type InvoiceOutput = {
  InvoiceID?: Maybe<cbi_invoice>;
  invoiceId: Scalars['Int']['output'];
};

export type InvoiceSnapshotInput = {
  id: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoiceSnapshotOutput = {
  id: Scalars['Int']['output'];
  invoice_snapshot: Array<cbi_invoice_snapshot>;
  invoice_snapshot_aggregate: cbi_invoice_snapshot_aggregate;
};

export type InvoiceSnapshotOutputinvoice_snapshotArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_snapshot_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_snapshot_order_by>>;
  where?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
};

export type InvoiceSnapshotOutputinvoice_snapshot_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_snapshot_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_snapshot_order_by>>;
  where?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
};

export type LightingBulkRenovationParameterObject = {
  efficiency: Scalars['Float']['output'];
};

export type LightingParametersBulkUnionMember = {
  lightingParameters: LightingBulkRenovationParameterObject;
};

export type LightingRenovationForBulkActionParameterInput = {
  efficiency: Scalars['Float']['input'];
};

export type LocationInfo = {
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
};

export type LoginHistoryEvent = {
  clientName?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  locationInfo?: Maybe<LocationInfo>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type MaintenanceActionParameterInput = {
  custom_name: Scalars['String']['input'];
};

export type MaintenanceActionParametersUnionMember = {
  maintenanceActionParameters: MaintenanceActionRenovationParameterObject;
};

export type MaintenanceActionRenovationParameterObject = {
  custom_name: Scalars['String']['output'];
};

export enum ManualConsumptionSourceTypeEnum {
  ESTIMATION = 'ESTIMATION',
  MANUAL_ENTRY = 'MANUAL_ENTRY',
}

export type ModificationImpactActionPlan = {
  co2_emissions: BeforeAfterDataWithImpactOutput;
  efficiency_class: EfficiencyClassOutput;
  final_energy: BeforeAfterDataWithImpactOutput;
  primary_energy: BeforeAfterDataWithImpactOutput;
};

export type ModificationImpactCrrem = {
  analysisType: emission_factor_type_enum;
  co2_cost_total: BeforeAfterDataWithImpactOutput;
  co2_emissions: BeforeAfterDataWithImpactOutput;
  efficiency_class: EfficiencyClassOutput;
  energy_cost_total: BeforeAfterDataWithImpactOutput;
  final_energy: BeforeAfterDataWithImpactOutput;
  heating_demand?: Maybe<BeforeAfterDataWithImpactOutput>;
  primary_energy: BeforeAfterDataWithImpactOutput;
  stranding_date: StrandingDateOutput;
};

export type ModificationImpactNationalEnergyLaw = {
  analysisType: emission_factor_type_enum;
  co2_cost_total: BeforeAfterDataWithImpactOutput;
  co2_emissions: BeforeAfterDataWithImpactOutput;
  efficiency_class: EfficiencyClassOutput;
  energy_cost_total: BeforeAfterDataWithImpactOutput;
  final_energy: BeforeAfterDataWithImpactOutput;
  heating_demand?: Maybe<BeforeAfterDataWithImpactOutput>;
  primary_energy: BeforeAfterDataWithImpactOutput;
};

export type ModificationImpactUnion = ModificationImpactCrrem | ModificationImpactNationalEnergyLaw;

export type MoveAllBuildingsOutput = {
  success: Scalars['Boolean']['output'];
};

export type MoveFileToFolderInput = {
  fileId: Scalars['Int']['input'];
  sourceFolderId: Scalars['Int']['input'];
  targetFolderId: Scalars['Int']['input'];
};

export type MoveFolderInput = {
  folderId: Scalars['Int']['input'];
  newParentId: Scalars['Int']['input'];
};

export type NationalEnergyLawOrgPreferences = {
  emissionFactorType: emission_factor_type_enum;
};

export enum OrderDirection {
  asc = 'asc',
  desc = 'desc',
}

export type OrgEmissionFactorPreferencesUnion = CrremOrgPreferences | NationalEnergyLawOrgPreferences;

export type OrgPreferences = {
  activeEmissionFactorPreferences: OrgEmissionFactorPreferencesUnion;
  availableReportingYears: Array<Scalars['Int']['output']>;
  co2PriceCurveConfig?: Maybe<Co2PriceCurveConfig>;
  co2PriceDefaultCurve: Array<Scalars['Float']['output']>;
  crremConfigurations: Array<CRREMConfigurationUnion>;
  euTaxonomyDatasource: eu_taxonomy_datasource_enum;
  isAutomaticActionCostUpdateToggled: Scalars['Boolean']['output'];
  isEconomicUnitsInFileDriveToggled: Scalars['Boolean']['output'];
  isEconomicUnitsToggled: Scalars['Boolean']['output'];
  isSSOAutoCreateUser: Scalars['Boolean']['output'];
  isSSOEnabled: Scalars['Boolean']['output'];
  userLogoutIdleTimeout?: Maybe<Scalars['Int']['output']>;
};

export type ParameterOutput =
  | CreateVentilationRenovationParameterOutput
  | EnergySystemRouteRenovationParameterOutput
  | EnvelopeRenovationParameterOutput
  | HydraulicBalancingRenovationParameterOutput
  | SolarRenovationParameterOutput
  | SystemRenovationParameterOutput
  | UpdateVentilationRenovationParameterOutput;

export type PathOutput = {
  m2: Array<Scalars['Float']['output']>;
  total: Array<Scalars['Float']['output']>;
};

export type PrimaryEnergyImpactTrendOutput = {
  after: Array<Scalars['Float']['output']>;
  before: Array<Scalars['Float']['output']>;
  custom_target: Array<CustomTargetMetrics>;
  startYear: Scalars['Int']['output'];
};

export type ProgressiveFactor = {
  factor: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type QueueBatchEsgAnalysisPdfExportOutput = {
  asyncJobId: Scalars['Int']['output'];
  totalBuildings: Scalars['Int']['output'];
};

export type QueueEsgAnalysisPdfExportOutput = {
  asyncJobId: Scalars['Int']['output'];
};

export type QueueSummaryOnePagerPdfExportOutput = {
  asyncJobId: Scalars['Int']['output'];
};

export type QueuedExportActionPlanAsPdfOutput = {
  asyncJobId: Scalars['Int']['output'];
};

export type RangeInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type ReadClimateRiskV2AssetOutput = {
  id: Scalars['String']['output'];
};

export type ReadClimateRiskV2ReportOutput = {
  data?: Maybe<ReadClimateRiskV2ReportOutputData>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ReadClimateRiskV2ReportOutputData = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files: Array<ClimateRiskV2ReportFile>;
  id: Scalars['String']['output'];
  modelVersion?: Maybe<Scalars['String']['output']>;
  scenarios: Array<ClimateScenarioV2Data>;
  status: api_response_status_enum;
};

export type RecommendActionsOutput = {
  recommendedActions: Array<RecommendedAction>;
};

export type RecommendedAction = {
  actionImpact: RecommendedActionImpactUnion;
  parameters: ParameterOutput;
};

export type RecommendedActionImpactCrremOutput = {
  analysisType: emission_factor_type_enum;
  co2_abatement_costs: Scalars['Float']['output'];
  co2_cost_total: BeforeAfterDataWithImpactOutput;
  co2_emissions: BeforeAfterDataWithImpactOutput;
  efficiency_class: EfficiencyClassOutput;
  energy_cost_total: BeforeAfterDataWithImpactOutput;
  final_energy: BeforeAfterDataWithImpactOutput;
  heating_demand?: Maybe<BeforeAfterDataWithImpactOutput>;
  payback_period: Scalars['Float']['output'];
  primary_energy: BeforeAfterDataWithImpactOutput;
  stranding_date: StrandingDateOutput;
  total_estimated_cost: Scalars['Float']['output'];
};

export type RecommendedActionImpactNationalEnergyLawOutput = {
  analysisType: emission_factor_type_enum;
  co2_abatement_costs: Scalars['Float']['output'];
  co2_cost_total: BeforeAfterDataWithImpactOutput;
  co2_emissions: BeforeAfterDataWithImpactOutput;
  efficiency_class: EfficiencyClassOutput;
  energy_cost_total: BeforeAfterDataWithImpactOutput;
  final_energy: BeforeAfterDataWithImpactOutput;
  heating_demand?: Maybe<BeforeAfterDataWithImpactOutput>;
  payback_period: Scalars['Float']['output'];
  primary_energy: BeforeAfterDataWithImpactOutput;
  total_estimated_cost: Scalars['Float']['output'];
};

export type RecommendedActionImpactUnion =
  | RecommendedActionImpactCrremOutput
  | RecommendedActionImpactNationalEnergyLawOutput;

export type RemoveFileFromFolderInput = {
  fileId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
};

export type RenameFileInput = {
  fileId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type RenameFolderInput = {
  folderId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type ReportAnswerId = {
  ReportAnswerId?: Maybe<report_answer>;
  id: Scalars['Int']['output'];
};

export type ReportInstantiationOptionsInput = {
  buildings: Array<Scalars['Int']['input']>;
  due_date: Scalars['DateTime']['input'];
  end_date: Scalars['DateTime']['input'];
  report_template_id: Scalars['Int']['input'];
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  start_date: Scalars['DateTime']['input'];
};

export type ReportQuestionId = {
  ReportQuestionId?: Maybe<report_template_question>;
  id: Scalars['Int']['output'];
};

export type ReportSlfComplianceAnalysisOutput = {
  issuedAt: Scalars['DateTime']['output'];
  reportId: Scalars['String']['output'];
  type: slf_compliance_factor_enum;
};

export type ReportTemplateOutput = {
  description: Scalars['String']['output'];
  description_en?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  org_id?: Maybe<Scalars['Int']['output']>;
  single_building: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ResetBuildingDraftOutput = {
  buildingDraft?: Maybe<building_draft>;
  buildingDraftId: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RevalidateNeedsReviewOutput = {
  approved: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updatedReason: Scalars['Int']['output'];
};

export type ScenarioActionPlanAndActionsCountsOutput = {
  action_plan_count: Scalars['Int']['output'];
  scenario_actions_count: Scalars['Int']['output'];
};

export type ScenarioAnalysisCostByRenovationCategorySeriesData = {
  actionsCount: Array<Scalars['Int']['output']>;
  values: Array<Scalars['Float']['output']>;
};

export type ScenarioCostVersion = {
  status: Scalars['String']['output'];
  valid_from: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type ScenarioListItemOutput = {
  action_plan_count: Scalars['Int']['output'];
  can_edit: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duplication_in_progress: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: ScenarioOwner;
  portfolio?: Maybe<ScenarioPortfolio>;
  total_investment?: Maybe<Scalars['Float']['output']>;
};

export type ScenarioListOutput = {
  count: Scalars['Int']['output'];
  scenarios: Array<ScenarioListItemOutput>;
};

export type ScenarioModificationImpact = {
  co2_emissions: BeforeAfterDataWithImpactOutput;
  final_energy: BeforeAfterDataWithImpactOutput;
  primary_energy: BeforeAfterDataWithImpactOutput;
};

export type ScenarioMutationOutput = {
  id: Scalars['Int']['output'];
};

export type ScenarioOrderByInput = {
  created_at?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
};

export type ScenarioOutput = {
  building_count?: Maybe<Scalars['Int']['output']>;
  can_edit: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duplication_in_progress: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: ScenarioOwner;
  portfolio?: Maybe<ScenarioPortfolio>;
  scenario_versions: Array<ScenarioVersion>;
  updated_at: Scalars['DateTime']['output'];
};

export type ScenarioOwner = {
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
};

export type ScenarioPortfolio = {
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ScenarioVersion = {
  cost_version?: Maybe<ScenarioCostVersion>;
  id: Scalars['Int']['output'];
  status: scenario_version_status_enum;
};

export type ScenarioWhere = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  is_whole_org?: InputMaybe<Scalars['Boolean']['input']>;
  portfolio_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search_string?: InputMaybe<Scalars['String']['input']>;
};

export type Scope123Co2EmissionsOutput = {
  scope1: Co2EmissionsOutput;
  scope2: Co2EmissionsOutput;
  scope3: Co2EmissionsOutput;
};

export type SessionDataInput = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type SessionDataOrg = {
  id: Scalars['Int']['output'];
  isEconomicUnitsToggled: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orgSectorTypeId: org_sector_type_enum;
  orgTypeId: org_type_enum;
  statusTypeId: org_status_type_enum;
  userLogoutIdleTimeout?: Maybe<Scalars['Int']['output']>;
};

export type SessionDataUser = {
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  language: language_enum;
  lastName: Scalars['String']['output'];
  roleDescription: Scalars['String']['output'];
  userRole: role_enum;
};

export type SetActiveBuildingModelOutput = {
  success: Scalars['Boolean']['output'];
};

export type SetCommonOrgPreferencesInput = {
  isAutomaticActionCostUpdateToggled?: InputMaybe<Scalars['Boolean']['input']>;
  isEconomicUnitsInFileDriveToggled?: InputMaybe<Scalars['Boolean']['input']>;
  isEconomicUnitsToggled?: InputMaybe<Scalars['Boolean']['input']>;
  userLogoutIdleTimeout?: InputMaybe<Scalars['Int']['input']>;
};

export type SetForObject = {
  org: Scalars['Boolean']['output'];
  portfolios: Array<SetForObject_Portfolio>;
};

export type SetForObject_Portfolio = {
  id: Scalars['Int']['output'];
  portfolio?: Maybe<portfolio>;
};

export type SetOrgCo2PriceCurveInput = {
  anchors?: InputMaybe<Array<Co2PriceAnchorInput>>;
  growthAnnualPercent?: InputMaybe<Scalars['Float']['input']>;
  growthStartValue?: InputMaybe<Scalars['Float']['input']>;
  kind?: InputMaybe<co2_price_curve_kind_enum>;
};

export type SetOrgEmissionFactorPreferencesInput = {
  crrem_config_id?: InputMaybe<Scalars['Int']['input']>;
  crrem_type?: InputMaybe<emission_factor_type_enum>;
  crrem_version?: InputMaybe<crrem_version_type_enum>;
  emissionFactorType: emission_factor_type_enum;
};

export type SetOrgEuTaxonomyDatasourceInput = {
  euTaxonomyDatasource: eu_taxonomy_datasource_enum;
};

export type SharedBuildingSnapshotDataOutput = {
  created_at: Scalars['DateTime']['output'];
  data: Scalars['JSON']['output'];
};

export type SharedBuildingSnapshotOutput = {
  hash: Scalars['String']['output'];
};

export type SimulateActionOutput = {
  error?: Maybe<action_mutation_error_enum>;
  result?: Maybe<EnergyValuesOutputUnion>;
};

export type SimulateActionStatusQuoOutput = {
  error?: Maybe<action_mutation_error_enum>;
  result?: Maybe<BaseEnergyValuesOutputUnion>;
};

export type SlfComplianceAnalysisCompliantOutput =
  | CertificateSlfComplianceAnalysisOutput
  | EfficiencyClassSlfComplianceAnalysisOutput
  | EuTaxonomyComplianceAnalysisOutput
  | ReportSlfComplianceAnalysisOutput;

export type SlfComplianceAnalysisOutput = {
  compliantFactors: Array<SlfComplianceAnalysisCompliantOutput>;
  lastSlfReport?: Maybe<SlfLastReportSummaryOutput>;
  notCompliantFactors: Array<CertificateSlfComplianceAnalysisOutput>;
  ongoingReportId?: Maybe<Scalars['String']['output']>;
};

export type SlfLastReportSummaryOutput = {
  issuedAt: Scalars['DateTime']['output'];
  reportId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type SmartMeterIntegrationBuildingOutput = {
  integration_building_id: Scalars['Int']['output'];
};

export type SmartMeterIntegrationOutput = {
  integration_id: Scalars['Int']['output'];
};

export enum SmartMeterIntegrationRunState {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
}

export type SmartMeterOutput = {
  meter_id: Scalars['Int']['output'];
};

export type SolarBulkRenovationParameterObject = {
  module_angle: Scalars['Float']['output'];
  module_peak_power: Scalars['Float']['output'];
  roof_area_ratio: Scalars['Float']['output'];
  technology_name: Scalars['String']['output'];
};

export type SolarParametersBulkUnionMember = {
  solarParameters: SolarBulkRenovationParameterObject;
};

export type SolarParametersUnionMember = {
  solarParameters: SolarRenovationParameterObject;
};

export type SolarRenovationForBulkActionParameterInput = {
  module_angle: Scalars['Float']['input'];
  module_peak_power: Scalars['Float']['input'];
  roof_area_ratio: Scalars['Float']['input'];
  technology_name: Scalars['String']['input'];
};

export type SolarRenovationParameterInput = {
  module_angle: Scalars['Float']['input'];
  module_peak_power: Scalars['Float']['input'];
  roof_area_ratio: Scalars['Float']['input'];
  solar_active_area: Scalars['Float']['input'];
  technology_name: Scalars['String']['input'];
};

export type SolarRenovationParameterObject = {
  module_angle: Scalars['Float']['output'];
  module_peak_power: Scalars['Float']['output'];
  roof_area_ratio: Scalars['Float']['output'];
  solar_active_area: Scalars['Float']['output'];
  technology_name: Scalars['String']['output'];
};

export type SolarRenovationParameterOutput = {
  module_angle: Scalars['Float']['output'];
  module_peak_power: Scalars['Float']['output'];
  roof_area_ratio: Scalars['Float']['output'];
  solar_active_area: Scalars['Float']['output'];
  technology_name: Scalars['String']['output'];
};

export type StrandingDataOutput = {
  count: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type StrandingDateOutput = {
  after?: Maybe<Scalars['DateTime']['output']>;
  before: Scalars['DateTime']['output'];
  impact?: Maybe<Scalars['Int']['output']>;
};

export type StrandingYearDistributionOutput = {
  after: Array<Scalars['Int']['output']>;
  before: Array<Scalars['Int']['output']>;
  buildingCounts: Array<Scalars['Int']['output']>;
  startYear: Scalars['Int']['output'];
};

export type StringContainsInput = {
  contains: Scalars['String']['input'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_array_comparison_exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_comparison_exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type SubsidyInput = {
  id: Scalars['Int']['input'];
  type: action_subsidy_value_type_enum;
  value: Scalars['Float']['input'];
};

export type SyncConsumptionsForCbiInvoiceResult = {
  createdConsumptionIds: Array<Scalars['Int']['output']>;
  skippedLines: Array<SyncedConsumptionSkippedLine>;
};

export type SyncedConsumptionSkippedLine = {
  kind: CBISkipKind;
  lineId: Scalars['Int']['output'];
};

export type SystemBulkRenovationParameterObject = {
  consumer_technology_type: energy_consumer_technology_type_enum;
  efficiency: Scalars['Float']['output'];
  emission_certificate_id?: Maybe<Scalars['Int']['output']>;
  energy_source_type: energy_source_type_enum;
  system_type: energy_system_type_enum;
  technology_name: Scalars['String']['output'];
};

export type SystemCustomActionParametersUnionMember = {
  systemCustomActionParameters: SystemCustomActionRenovationParameterObject;
};

export type SystemCustomActionRenovationParameterObject = {
  custom_name: Scalars['String']['output'];
  fraction: Scalars['Float']['output'];
  renovation_ids?: Maybe<Array<Scalars['String']['output']>>;
  system_type: energy_system_type_enum;
};

export type SystemCustomBulkActionParametersUnionMember = {
  systemCustomActionParameters: SystemCustomBulkActionRenovationParameterObject;
};

export type SystemCustomBulkActionRenovationParameterObject = {
  custom_name: Scalars['String']['output'];
  fraction: Scalars['Float']['output'];
  system_type: energy_system_type_enum;
};

export type SystemParametersBulkUnionMember = {
  systemParameters: SystemBulkRenovationParameterObject;
};

export type SystemParametersUnionMember = {
  systemParameters: SystemRenovationParameterObject;
};

export type SystemRenovationParameterInput = {
  consumer_technology_type: energy_consumer_technology_type_enum;
  efficiency: Scalars['Float']['input'];
  emission_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  energy_source_type: energy_source_type_enum;
  renovation_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  system_type: energy_system_type_enum;
  technology_name: Scalars['String']['input'];
};

export type SystemRenovationParameterObject = {
  consumer_technology_type: energy_consumer_technology_type_enum;
  efficiency: Scalars['Float']['output'];
  emission_certificate_id?: Maybe<Scalars['Int']['output']>;
  energy_source_type: energy_source_type_enum;
  renovation_ids?: Maybe<Array<Scalars['String']['output']>>;
  system_type: energy_system_type_enum;
  technology_name: Scalars['String']['output'];
};

export type SystemRenovationParameterOutput = {
  consumer_technology_type: energy_consumer_technology_type_enum;
  efficiency: Scalars['Float']['output'];
  energy_source_type: energy_source_type_enum;
  system_type: energy_system_type_enum;
  technology_name: Scalars['String']['output'];
};

export type TargetDefinition = {
  id: Scalars['Int']['output'];
  target_definition_type: target_definition_type_enum;
  value: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type TargetDefinitionInput = {
  target_definition_type: target_definition_type_enum;
  value: Scalars['Float']['input'];
  year: Scalars['Int']['input'];
};

export type TemplateBuildingExportOptions = {
  buildingWhere?: InputMaybe<BuildingWhere>;
  export_template_id: Scalars['Int']['input'];
  orderBy: BuildingExportOrderByInput;
  sheets?: InputMaybe<Array<ExcelSheetType>>;
};

export type UpdateConsumptionInvoiceDraftOutput = {
  UpdateConsumptionInvoiceDraftOutput?: Maybe<consumption_invoice_draft>;
  consumptionInvoiceDraftId: Scalars['Int']['output'];
};

export type UpdateConsumptionInvoiceOutput = {
  UpdateConsumptionInvoiceOutput?: Maybe<consumption_invoice>;
  consumptionInvoiceId: Scalars['Int']['output'];
};

export type UpdateCustomDataResponse = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateDuplicate = {
  duplicateOf: Scalars['Int']['input'];
  duplicateReason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmissionCertificateDraftWithFileOutput = {
  file_id: Scalars['Int']['output'];
  upload_url: Scalars['String']['output'];
};

export type UpdateEmissionCertificateDraftWithoutFileInput = {
  emission_certificate_document_type_id?: InputMaybe<emission_certificate_document_type_enum>;
  emission_certificate_energy_source_type_id?: InputMaybe<emission_certificate_energy_source_type_enum>;
  emission_factor?: InputMaybe<Scalars['Float']['input']>;
  emission_factor_active_value_type: energy_supplier_value_type_enum;
  emission_factor_progressive?: InputMaybe<Array<EnergySupplierValueProgressiveDraftInput>>;
  id: Scalars['Int']['input'];
  issuer: Scalars['String']['input'];
  primary_energy_factor?: InputMaybe<Scalars['Float']['input']>;
  primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
  primary_energy_factor_progressive?: InputMaybe<Array<EnergySupplierValueProgressiveDraftInput>>;
  valid_from?: InputMaybe<Scalars['DateTime']['input']>;
  valid_until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateEmissionCertificateDraftWithoutFileOutput = {
  emission_certificate_draft_id: Scalars['Int']['output'];
};

export type UpdateEmissionCertificateFileOutput = {
  file_id: Scalars['Int']['output'];
  upload_url: Scalars['String']['output'];
};

export type UpdateEmissionCertificateWithoutFileInput = {
  emission_certificate_document_type_id: emission_certificate_document_type_enum;
  emission_factor?: InputMaybe<Scalars['Float']['input']>;
  emission_factor_active_value_type: energy_supplier_value_type_enum;
  emission_factor_progressive?: InputMaybe<Array<EnergySupplierValueProgressiveInput>>;
  id: Scalars['Int']['input'];
  issuer: Scalars['String']['input'];
  primary_energy_factor?: InputMaybe<Scalars['Float']['input']>;
  primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
  primary_energy_factor_progressive?: InputMaybe<Array<EnergySupplierValueProgressiveInput>>;
  valid_from?: InputMaybe<Scalars['DateTime']['input']>;
  valid_until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateEmissionCertificateWithoutFileOutput = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdatePortfolioSettingsType = {
  baseEmissionFactorType?: InputMaybe<emission_factor_type_enum>;
  crremConfigId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateScenarioInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scenario_id: Scalars['Int']['input'];
};

export type UpdateSelectedIdsOutput = {
  building?: Maybe<building>;
  buildingId: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedIds: Array<Scalars['String']['output']>;
};

export type UpdateVentilationRenovationParameterOutput = {
  final_energy: Scalars['Float']['output'];
  number_of_units?: Maybe<Scalars['Int']['output']>;
  renovation_ids?: Maybe<Array<Scalars['String']['output']>>;
  ventilation_consumer_technology_type: ventilation_supported_technology_enum;
  ventilation_efficiency?: Maybe<Scalars['Float']['output']>;
};

export type UploadEnergyCertificateDraftOutput = {
  UploadEnergyCertificateDraftId?: Maybe<energy_certificate_draft>;
  energyCertificateDraftId?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type UploadFileToDriveFolderInput = {
  fileName: Scalars['String']['input'];
  folderId: Scalars['Int']['input'];
};

export type UploadFileToDriveFolderOutput = {
  fileId: Scalars['Int']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UpsertEconomicUnitWithBuildingsExternalOutput = {
  createdBuildingDraftsIds: Array<Scalars['Int']['output']>;
  externalEconomicUnitId: Scalars['String']['output'];
  updatedBuildingDraftsIds: Array<Scalars['Int']['output']>;
  updatedBuildingsIds: Array<Scalars['Int']['output']>;
};

export type UserId = {
  UserId?: Maybe<user>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type VentilationRenovationParameterInput = {
  consumer_technology_type: ventilation_supported_technology_enum;
  efficiency?: InputMaybe<Scalars['Float']['input']>;
  final_energy: Scalars['Float']['input'];
  number_of_units?: InputMaybe<Scalars['Int']['input']>;
  renovation_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VentilationRenovationParameterObject = {
  consumer_technology_type: ventilation_supported_technology_enum;
  efficiency?: Maybe<Scalars['Float']['output']>;
  final_energy: Scalars['Float']['output'];
  number_of_units?: Maybe<Scalars['Int']['output']>;
  renovation_ids?: Maybe<Array<Scalars['String']['output']>>;
};

export type VentilationRenovationParametersUnionMember = {
  ventilationRenovationParameters: VentilationRenovationParameterObject;
};

export type WasteDetailsInlineInput = {
  amount: Scalars['Float']['input'];
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
  frequency: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  volume: Scalars['Float']['input'];
};

export type YearValueWithNull = {
  value?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};

export type YearlyConsumption = {
  consumption_type: consumption_type_enum;
  cost: Scalars['Float']['output'];
  providers: Array<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

/** A single renovation measure (e.g., insulate roof, replace heating) within an action plan, with implementation dates and parameters. */
export type action = {
  /** An object relationship */
  action_plan: action_plan;
  /** An array relationship */
  building_models: Array<building_model>;
  /** An object relationship */
  bulk_action?: Maybe<bulk_action>;
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** Optional custom action type for actions outside standard renovation categories. */
  custom_action_type_id?: Maybe<custom_action_type_enum>;
  /** Optional user-defined name overriding the default action type label. */
  custom_name?: Maybe<Scalars['String']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  /** Start date of the renovation measure implementation. */
  implementation_from: Scalars['timestamptz']['output'];
  /** End date of the renovation measure implementation. */
  implementation_to: Scalars['timestamptz']['output'];
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order: Scalars['Int']['output'];
  parameters: ActionParametersUnion;
  /** An array relationship */
  renovations: Array<renovation>;
  /** An array relationship */
  renovations_energy_consumer: Array<renovation_energy_consumer>;
  /** An array relationship */
  renovations_energy_producer: Array<renovation_energy_producer>;
  /** An array relationship */
  renovations_energy_routes: Array<renovation_energy_system_route>;
  /** An array relationship */
  renovations_envelope: Array<renovation_envelope>;
  /** An array relationship */
  subsidies: Array<action_subsidy>;
  updated_at: Scalars['timestamptz']['output'];
};

/** A single renovation measure (e.g., insulate roof, replace heating) within an action plan, with implementation dates and parameters. */
export type actionbuilding_modelsArgs = {
  distinct_on?: InputMaybe<Array<building_model_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_model_order_by>>;
  where?: InputMaybe<building_model_bool_exp>;
};

/** A single renovation measure (e.g., insulate roof, replace heating) within an action plan, with implementation dates and parameters. */
export type actionrenovationsArgs = {
  distinct_on?: InputMaybe<Array<renovation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_order_by>>;
  where?: InputMaybe<renovation_bool_exp>;
};

/** A single renovation measure (e.g., insulate roof, replace heating) within an action plan, with implementation dates and parameters. */
export type actionrenovations_energy_consumerArgs = {
  distinct_on?: InputMaybe<Array<renovation_energy_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_energy_consumer_order_by>>;
  where?: InputMaybe<renovation_energy_consumer_bool_exp>;
};

/** A single renovation measure (e.g., insulate roof, replace heating) within an action plan, with implementation dates and parameters. */
export type actionrenovations_energy_producerArgs = {
  distinct_on?: InputMaybe<Array<renovation_energy_producer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_energy_producer_order_by>>;
  where?: InputMaybe<renovation_energy_producer_bool_exp>;
};

/** A single renovation measure (e.g., insulate roof, replace heating) within an action plan, with implementation dates and parameters. */
export type actionrenovations_energy_routesArgs = {
  distinct_on?: InputMaybe<Array<renovation_energy_system_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_energy_system_route_order_by>>;
  where?: InputMaybe<renovation_energy_system_route_bool_exp>;
};

/** A single renovation measure (e.g., insulate roof, replace heating) within an action plan, with implementation dates and parameters. */
export type actionrenovations_envelopeArgs = {
  distinct_on?: InputMaybe<Array<renovation_envelope_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_envelope_order_by>>;
  where?: InputMaybe<renovation_envelope_bool_exp>;
};

/** A single renovation measure (e.g., insulate roof, replace heating) within an action plan, with implementation dates and parameters. */
export type actionsubsidiesArgs = {
  distinct_on?: InputMaybe<Array<action_subsidy_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_subsidy_order_by>>;
  where?: InputMaybe<action_subsidy_bool_exp>;
};

/** aggregated selection of "action" */
export type action_aggregate = {
  aggregate?: Maybe<action_aggregate_fields>;
  nodes: Array<action>;
};

export type action_aggregate_bool_exp = {
  count?: InputMaybe<action_aggregate_bool_exp_count>;
};

export type action_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<action_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<action_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "action" */
export type action_aggregate_fields = {
  avg?: Maybe<action_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<action_max_fields>;
  min?: Maybe<action_min_fields>;
  stddev?: Maybe<action_stddev_fields>;
  stddev_pop?: Maybe<action_stddev_pop_fields>;
  stddev_samp?: Maybe<action_stddev_samp_fields>;
  sum?: Maybe<action_sum_fields>;
  var_pop?: Maybe<action_var_pop_fields>;
  var_samp?: Maybe<action_var_samp_fields>;
  variance?: Maybe<action_variance_fields>;
};

/** aggregate fields of "action" */
export type action_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<action_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "action" */
export type action_aggregate_order_by = {
  avg?: InputMaybe<action_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<action_max_order_by>;
  min?: InputMaybe<action_min_order_by>;
  stddev?: InputMaybe<action_stddev_order_by>;
  stddev_pop?: InputMaybe<action_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<action_stddev_samp_order_by>;
  sum?: InputMaybe<action_sum_order_by>;
  var_pop?: InputMaybe<action_var_pop_order_by>;
  var_samp?: InputMaybe<action_var_samp_order_by>;
  variance?: InputMaybe<action_variance_order_by>;
};

/** aggregate avg on columns */
export type action_avg_fields = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "action" */
export type action_avg_order_by = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<order_by>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "action". All fields are combined with a logical 'AND'. */
export type action_bool_exp = {
  _and?: InputMaybe<Array<action_bool_exp>>;
  _not?: InputMaybe<action_bool_exp>;
  _or?: InputMaybe<Array<action_bool_exp>>;
  action_plan?: InputMaybe<action_plan_bool_exp>;
  building_models?: InputMaybe<building_model_bool_exp>;
  bulk_action?: InputMaybe<bulk_action_bool_exp>;
  bulk_action_id?: InputMaybe<Int_comparison_exp>;
  cost_total?: InputMaybe<float8_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  custom_action_type_id?: InputMaybe<custom_action_type_enum_comparison_exp>;
  custom_name?: InputMaybe<String_comparison_exp>;
  custom_saving_fraction?: InputMaybe<Float_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  implementation_from?: InputMaybe<timestamptz_comparison_exp>;
  implementation_to?: InputMaybe<timestamptz_comparison_exp>;
  order?: InputMaybe<Int_comparison_exp>;
  renovations?: InputMaybe<renovation_bool_exp>;
  renovations_energy_consumer?: InputMaybe<renovation_energy_consumer_bool_exp>;
  renovations_energy_producer?: InputMaybe<renovation_energy_producer_bool_exp>;
  renovations_energy_routes?: InputMaybe<renovation_energy_system_route_bool_exp>;
  renovations_envelope?: InputMaybe<renovation_envelope_bool_exp>;
  subsidies?: InputMaybe<action_subsidy_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type action_max_fields = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Optional user-defined name overriding the default action type label. */
  custom_name?: Maybe<Scalars['String']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Start date of the renovation measure implementation. */
  implementation_from?: Maybe<Scalars['timestamptz']['output']>;
  /** End date of the renovation measure implementation. */
  implementation_to?: Maybe<Scalars['timestamptz']['output']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "action" */
export type action_max_order_by = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Optional user-defined name overriding the default action type label. */
  custom_name?: InputMaybe<order_by>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Start date of the renovation measure implementation. */
  implementation_from?: InputMaybe<order_by>;
  /** End date of the renovation measure implementation. */
  implementation_to?: InputMaybe<order_by>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type action_min_fields = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Optional user-defined name overriding the default action type label. */
  custom_name?: Maybe<Scalars['String']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Start date of the renovation measure implementation. */
  implementation_from?: Maybe<Scalars['timestamptz']['output']>;
  /** End date of the renovation measure implementation. */
  implementation_to?: Maybe<Scalars['timestamptz']['output']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "action" */
export type action_min_order_by = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Optional user-defined name overriding the default action type label. */
  custom_name?: InputMaybe<order_by>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Start date of the renovation measure implementation. */
  implementation_from?: InputMaybe<order_by>;
  /** End date of the renovation measure implementation. */
  implementation_to?: InputMaybe<order_by>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

export enum action_mutation_error_enum {
  ACTION_PLAN_INCONSISTENT = 'ACTION_PLAN_INCONSISTENT',
  MUTATION_NOT_POSSIBLE = 'MUTATION_NOT_POSSIBLE',
}

/** Ordering options when selecting data from "action". */
export type action_order_by = {
  action_plan?: InputMaybe<action_plan_order_by>;
  building_models_aggregate?: InputMaybe<building_model_aggregate_order_by>;
  bulk_action?: InputMaybe<bulk_action_order_by>;
  bulk_action_id?: InputMaybe<order_by>;
  cost_total?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  custom_action_type_id?: InputMaybe<order_by>;
  custom_name?: InputMaybe<order_by>;
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  implementation_from?: InputMaybe<order_by>;
  implementation_to?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovations_aggregate?: InputMaybe<renovation_aggregate_order_by>;
  renovations_energy_consumer_aggregate?: InputMaybe<renovation_energy_consumer_aggregate_order_by>;
  renovations_energy_producer_aggregate?: InputMaybe<renovation_energy_producer_aggregate_order_by>;
  renovations_energy_routes_aggregate?: InputMaybe<renovation_energy_system_route_aggregate_order_by>;
  renovations_envelope_aggregate?: InputMaybe<renovation_envelope_aggregate_order_by>;
  subsidies_aggregate?: InputMaybe<action_subsidy_aggregate_order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** An ordered sequence of renovation actions for a single building within a scenario version. */
export type action_plan = {
  action_plan_inconsistencies: ActionPlanInconsistenciesOutput;
  /** An array relationship */
  actions: Array<action>;
  /** An aggregate relationship */
  actions_aggregate: action_aggregate;
  /** An object relationship */
  active_scenario?: Maybe<active_action_plans>;
  /** An object relationship */
  building: building;
  /** The building this action plan applies to. */
  building_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** Whether this action plan is currently being recalculated. */
  processing: Scalars['Boolean']['output'];
  /** An object relationship */
  scenario_version: scenario_version;
  /** The scenario version this action plan belongs to. */
  scenario_version_id: Scalars['Int']['output'];
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id: Scalars['Int']['output'];
};

/** An ordered sequence of renovation actions for a single building within a scenario version. */
export type action_planactionsArgs = {
  distinct_on?: InputMaybe<Array<action_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_order_by>>;
  where?: InputMaybe<action_bool_exp>;
};

/** An ordered sequence of renovation actions for a single building within a scenario version. */
export type action_planactions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<action_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_order_by>>;
  where?: InputMaybe<action_bool_exp>;
};

/** order by aggregate values of table "action_plan" */
export type action_plan_aggregate_order_by = {
  avg?: InputMaybe<action_plan_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<action_plan_max_order_by>;
  min?: InputMaybe<action_plan_min_order_by>;
  stddev?: InputMaybe<action_plan_stddev_order_by>;
  stddev_pop?: InputMaybe<action_plan_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<action_plan_stddev_samp_order_by>;
  sum?: InputMaybe<action_plan_sum_order_by>;
  var_pop?: InputMaybe<action_plan_var_pop_order_by>;
  var_samp?: InputMaybe<action_plan_var_samp_order_by>;
  variance?: InputMaybe<action_plan_variance_order_by>;
};

/** order by avg() on columns of table "action_plan" */
export type action_plan_avg_order_by = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<order_by>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "action_plan". All fields are combined with a logical 'AND'. */
export type action_plan_bool_exp = {
  _and?: InputMaybe<Array<action_plan_bool_exp>>;
  _not?: InputMaybe<action_plan_bool_exp>;
  _or?: InputMaybe<Array<action_plan_bool_exp>>;
  actions?: InputMaybe<action_bool_exp>;
  actions_aggregate?: InputMaybe<action_aggregate_bool_exp>;
  active_scenario?: InputMaybe<active_action_plans_bool_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  processing?: InputMaybe<Boolean_comparison_exp>;
  scenario_version?: InputMaybe<scenario_version_bool_exp>;
  scenario_version_id?: InputMaybe<Int_comparison_exp>;
  stable_id?: InputMaybe<Int_comparison_exp>;
};

export enum action_plan_impact_trends_annotation_enum {
  ACTION = 'ACTION',
  AFTER_ACTIONS_STRANDING_YEAR = 'AFTER_ACTIONS_STRANDING_YEAR',
  BEFORE_ACTIONS_STRANDING_YEAR = 'BEFORE_ACTIONS_STRANDING_YEAR',
}

export enum action_plan_impact_type_enum {
  WITHOUT_TARGET_AND_STRANDING_RANGES = 'WITHOUT_TARGET_AND_STRANDING_RANGES',
  WITH_TARGET_AND_STRANDING_RANGES = 'WITH_TARGET_AND_STRANDING_RANGES',
}

/** order by max() on columns of table "action_plan" */
export type action_plan_max_order_by = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<order_by>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "action_plan" */
export type action_plan_min_order_by = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<order_by>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "action_plan". */
export type action_plan_order_by = {
  actions_aggregate?: InputMaybe<action_aggregate_order_by>;
  active_scenario?: InputMaybe<active_action_plans_order_by>;
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  processing?: InputMaybe<order_by>;
  scenario_version?: InputMaybe<scenario_version_order_by>;
  scenario_version_id?: InputMaybe<order_by>;
  stable_id?: InputMaybe<order_by>;
};

/** select columns of table "action_plan" */
export enum action_plan_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  processing = 'processing',
  /** column name */
  scenario_version_id = 'scenario_version_id',
  /** column name */
  stable_id = 'stable_id',
}

/** order by stddev() on columns of table "action_plan" */
export type action_plan_stddev_order_by = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<order_by>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "action_plan" */
export type action_plan_stddev_pop_order_by = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<order_by>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "action_plan" */
export type action_plan_stddev_samp_order_by = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<order_by>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "action_plan" */
export type action_plan_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: action_plan_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type action_plan_stream_cursor_value_input = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this action plan is currently being recalculated. */
  processing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<Scalars['Int']['input']>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "action_plan" */
export type action_plan_sum_order_by = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<order_by>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "action_plan" */
export type action_plan_var_pop_order_by = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<order_by>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "action_plan" */
export type action_plan_var_samp_order_by = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<order_by>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "action_plan" */
export type action_plan_variance_order_by = {
  /** The building this action plan applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The scenario version this action plan belongs to. */
  scenario_version_id?: InputMaybe<order_by>;
  /** A persistent identifier that remains constant across scenario version duplications, used to track the same logical action plan. */
  stable_id?: InputMaybe<order_by>;
};

/** select columns of table "action" */
export enum action_select_column {
  /** column name */
  bulk_action_id = 'bulk_action_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  custom_action_type_id = 'custom_action_type_id',
  /** column name */
  custom_name = 'custom_name',
  /** column name */
  custom_saving_fraction = 'custom_saving_fraction',
  /** column name */
  id = 'id',
  /** column name */
  implementation_from = 'implementation_from',
  /** column name */
  implementation_to = 'implementation_to',
  /** column name */
  order = 'order',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate stddev on columns */
export type action_stddev_fields = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "action" */
export type action_stddev_order_by = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<order_by>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type action_stddev_pop_fields = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "action" */
export type action_stddev_pop_order_by = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<order_by>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type action_stddev_samp_fields = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "action" */
export type action_stddev_samp_order_by = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<order_by>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "action" */
export type action_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: action_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type action_stream_cursor_value_input = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Optional custom action type for actions outside standard renovation categories. */
  custom_action_type_id?: InputMaybe<custom_action_type_enum>;
  /** Optional user-defined name overriding the default action type label. */
  custom_name?: InputMaybe<Scalars['String']['input']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Start date of the renovation measure implementation. */
  implementation_from?: InputMaybe<Scalars['timestamptz']['input']>;
  /** End date of the renovation measure implementation. */
  implementation_to?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Links a government subsidy to a specific action, recording the subsidy amount as either a percentage or absolute value. */
export type action_subsidy = {
  /** An object relationship */
  action: action;
  /** The action this subsidy is applied to. */
  action_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  subsidy: subsidy;
  /** The subsidy program being applied. */
  subsidy_id: Scalars['Int']['output'];
  /** Whether the subsidy value is a percentage of costs or an absolute monetary amount. */
  type: action_subsidy_value_type_enum;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value: Scalars['numeric']['output'];
};

/** order by aggregate values of table "action_subsidy" */
export type action_subsidy_aggregate_order_by = {
  avg?: InputMaybe<action_subsidy_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<action_subsidy_max_order_by>;
  min?: InputMaybe<action_subsidy_min_order_by>;
  stddev?: InputMaybe<action_subsidy_stddev_order_by>;
  stddev_pop?: InputMaybe<action_subsidy_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<action_subsidy_stddev_samp_order_by>;
  sum?: InputMaybe<action_subsidy_sum_order_by>;
  var_pop?: InputMaybe<action_subsidy_var_pop_order_by>;
  var_samp?: InputMaybe<action_subsidy_var_samp_order_by>;
  variance?: InputMaybe<action_subsidy_variance_order_by>;
};

/** order by avg() on columns of table "action_subsidy" */
export type action_subsidy_avg_order_by = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<order_by>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "action_subsidy". All fields are combined with a logical 'AND'. */
export type action_subsidy_bool_exp = {
  _and?: InputMaybe<Array<action_subsidy_bool_exp>>;
  _not?: InputMaybe<action_subsidy_bool_exp>;
  _or?: InputMaybe<Array<action_subsidy_bool_exp>>;
  action?: InputMaybe<action_bool_exp>;
  action_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  subsidy?: InputMaybe<subsidy_bool_exp>;
  subsidy_id?: InputMaybe<Int_comparison_exp>;
  type?: InputMaybe<action_subsidy_value_type_enum_comparison_exp>;
  value?: InputMaybe<numeric_comparison_exp>;
};

/** order by max() on columns of table "action_subsidy" */
export type action_subsidy_max_order_by = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<order_by>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<order_by>;
};

/** order by min() on columns of table "action_subsidy" */
export type action_subsidy_min_order_by = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<order_by>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "action_subsidy". */
export type action_subsidy_order_by = {
  action?: InputMaybe<action_order_by>;
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  subsidy?: InputMaybe<subsidy_order_by>;
  subsidy_id?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "action_subsidy" */
export enum action_subsidy_select_column {
  /** column name */
  action_id = 'action_id',
  /** column name */
  id = 'id',
  /** column name */
  subsidy_id = 'subsidy_id',
  /** column name */
  type = 'type',
  /** column name */
  value = 'value',
}

/** order by stddev() on columns of table "action_subsidy" */
export type action_subsidy_stddev_order_by = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<order_by>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "action_subsidy" */
export type action_subsidy_stddev_pop_order_by = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<order_by>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "action_subsidy" */
export type action_subsidy_stddev_samp_order_by = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<order_by>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "action_subsidy" */
export type action_subsidy_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: action_subsidy_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type action_subsidy_stream_cursor_value_input = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the subsidy value is a percentage of costs or an absolute monetary amount. */
  type?: InputMaybe<action_subsidy_value_type_enum>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "action_subsidy" */
export type action_subsidy_sum_order_by = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<order_by>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<order_by>;
};

export enum action_subsidy_value_type_enum {
  absolute = 'absolute',
  percentage = 'percentage',
}

/** Boolean expression to compare columns of type "action_subsidy_value_type_enum". All fields are combined with logical 'AND'. */
export type action_subsidy_value_type_enum_comparison_exp = {
  _eq?: InputMaybe<action_subsidy_value_type_enum>;
  _in?: InputMaybe<Array<action_subsidy_value_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<action_subsidy_value_type_enum>;
  _nin?: InputMaybe<Array<action_subsidy_value_type_enum>>;
};

/** order by var_pop() on columns of table "action_subsidy" */
export type action_subsidy_var_pop_order_by = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<order_by>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "action_subsidy" */
export type action_subsidy_var_samp_order_by = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<order_by>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "action_subsidy" */
export type action_subsidy_variance_order_by = {
  /** The action this subsidy is applied to. */
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The subsidy program being applied. */
  subsidy_id?: InputMaybe<order_by>;
  /** The numeric subsidy value, interpreted as percentage or absolute amount depending on the type. */
  value?: InputMaybe<order_by>;
};

/** aggregate sum on columns */
export type action_sum_fields = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "action" */
export type action_sum_order_by = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<order_by>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type action_var_pop_fields = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "action" */
export type action_var_pop_order_by = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<order_by>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type action_var_samp_fields = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "action" */
export type action_var_samp_order_by = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<order_by>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type action_variance_fields = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "action_total_cost" */
  cost_total?: Maybe<Scalars['float8']['output']>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "action" */
export type action_variance_order_by = {
  /** If this action was created via a bulk action, references the parent bulk action. */
  bulk_action_id?: InputMaybe<order_by>;
  /** User-defined energy saving percentage for custom action types, since no simulation model exists for them. */
  custom_saving_fraction?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Execution order within the action plan; actions are applied sequentially to the building model. */
  order?: InputMaybe<order_by>;
};

/** View: Action plans belonging to the currently active scenario version for each scenario. */
export type active_action_plans = {
  /** An object relationship */
  action_plan?: Maybe<action_plan>;
  /** An object relationship */
  building?: Maybe<building>;
  /** An object relationship */
  scenario?: Maybe<scenario>;
};

/** aggregated selection of "active_action_plans" */
export type active_action_plans_aggregate = {
  aggregate?: Maybe<active_action_plans_aggregate_fields>;
  nodes: Array<active_action_plans>;
};

/** aggregate fields of "active_action_plans" */
export type active_action_plans_aggregate_fields = {
  count: Scalars['Int']['output'];
};

/** aggregate fields of "active_action_plans" */
export type active_action_plans_aggregate_fieldscountArgs = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "active_action_plans" */
export type active_action_plans_aggregate_order_by = {
  count?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "active_action_plans". All fields are combined with a logical 'AND'. */
export type active_action_plans_bool_exp = {
  _and?: InputMaybe<Array<active_action_plans_bool_exp>>;
  _not?: InputMaybe<active_action_plans_bool_exp>;
  _or?: InputMaybe<Array<active_action_plans_bool_exp>>;
  action_plan?: InputMaybe<action_plan_bool_exp>;
  building?: InputMaybe<building_bool_exp>;
  scenario?: InputMaybe<scenario_bool_exp>;
};

/** Ordering options when selecting data from "active_action_plans". */
export type active_action_plans_order_by = {
  action_plan?: InputMaybe<action_plan_order_by>;
  building?: InputMaybe<building_order_by>;
  scenario?: InputMaybe<scenario_order_by>;
};

/** View: Bulk actions belonging to the currently active scenario version for each scenario. */
export type active_bulk_actions = {
  /** An object relationship */
  bulk_action?: Maybe<bulk_action>;
  /** An object relationship */
  scenario?: Maybe<scenario>;
};

/** aggregated selection of "active_bulk_actions" */
export type active_bulk_actions_aggregate = {
  aggregate?: Maybe<active_bulk_actions_aggregate_fields>;
  nodes: Array<active_bulk_actions>;
};

/** aggregate fields of "active_bulk_actions" */
export type active_bulk_actions_aggregate_fields = {
  count: Scalars['Int']['output'];
};

/** aggregate fields of "active_bulk_actions" */
export type active_bulk_actions_aggregate_fieldscountArgs = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "active_bulk_actions". All fields are combined with a logical 'AND'. */
export type active_bulk_actions_bool_exp = {
  _and?: InputMaybe<Array<active_bulk_actions_bool_exp>>;
  _not?: InputMaybe<active_bulk_actions_bool_exp>;
  _or?: InputMaybe<Array<active_bulk_actions_bool_exp>>;
  bulk_action?: InputMaybe<bulk_action_bool_exp>;
  scenario?: InputMaybe<scenario_bool_exp>;
};

/** Ordering options when selecting data from "active_bulk_actions". */
export type active_bulk_actions_order_by = {
  bulk_action?: InputMaybe<bulk_action_order_by>;
  scenario?: InputMaybe<scenario_order_by>;
};

/** Physical address and geospatial metadata for a building, including 3D model references. */
export type address = {
  /** GML IDs linking this building to its 3D model in the CityGML/3DCityDB database. */
  building_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs linking this building to its LOD1 (block model) representation in the LOD1 database. */
  building_lod1_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** An array relationship */
  buildings: Array<building>;
  /** An aggregate relationship */
  buildings_aggregate: building_aggregate;
  city: Scalars['String']['output'];
  /** Climate region used for energy demand calculations and weather normalization. */
  climate_region_id?: Maybe<climate_region_enum>;
  /** Country where the building is located. References country. */
  country_id: country_enum;
  /** Federal state or administrative region where the building is located. */
  country_state_id: country_state_enum;
  /** A computed field, executes function "has_gml_ids" */
  has_gml_ids?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  /** Camera bearing angle for the saved Mapbox 3D view of this building. */
  mapbox_bearing?: Maybe<Scalars['float8']['output']>;
  /** Mapbox feature IDs identifying this building's footprint on the map. */
  mapbox_building_ids: Array<Scalars['String']['output']>;
  /** Camera pitch angle for the saved Mapbox 3D view of this building. */
  mapbox_pitch?: Maybe<Scalars['float8']['output']>;
  /** Zoom level for the saved Mapbox 3D view of this building. */
  mapbox_zoom?: Maybe<Scalars['float8']['output']>;
  /** GML IDs of neighboring buildings in the 3DCityDB, used for contextual 3D rendering. */
  neighbor_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs of neighboring buildings in the LOD1 database, used for contextual 3D rendering. */
  neighbor_lod1_ids?: Maybe<Array<Scalars['String']['output']>>;
  postal_code: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

/** Physical address and geospatial metadata for a building, including 3D model references. */
export type addressbuildingsArgs = {
  distinct_on?: InputMaybe<Array<building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_order_by>>;
  where?: InputMaybe<building_bool_exp>;
};

/** Physical address and geospatial metadata for a building, including 3D model references. */
export type addressbuildings_aggregateArgs = {
  distinct_on?: InputMaybe<Array<building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_order_by>>;
  where?: InputMaybe<building_bool_exp>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type address_bool_exp = {
  _and?: InputMaybe<Array<address_bool_exp>>;
  _not?: InputMaybe<address_bool_exp>;
  _or?: InputMaybe<Array<address_bool_exp>>;
  building_citydb_gml_ids?: InputMaybe<String_array_comparison_exp>;
  building_lod1_ids?: InputMaybe<String_array_comparison_exp>;
  buildings?: InputMaybe<building_bool_exp>;
  buildings_aggregate?: InputMaybe<building_aggregate_bool_exp>;
  city?: InputMaybe<String_comparison_exp>;
  climate_region_id?: InputMaybe<climate_region_enum_comparison_exp>;
  country_id?: InputMaybe<country_enum_comparison_exp>;
  country_state_id?: InputMaybe<country_state_enum_comparison_exp>;
  has_gml_ids?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  latitude?: InputMaybe<numeric_comparison_exp>;
  longitude?: InputMaybe<numeric_comparison_exp>;
  mapbox_bearing?: InputMaybe<float8_comparison_exp>;
  mapbox_building_ids?: InputMaybe<String_array_comparison_exp>;
  mapbox_pitch?: InputMaybe<float8_comparison_exp>;
  mapbox_zoom?: InputMaybe<float8_comparison_exp>;
  neighbor_citydb_gml_ids?: InputMaybe<String_array_comparison_exp>;
  neighbor_lod1_ids?: InputMaybe<String_array_comparison_exp>;
  postal_code?: InputMaybe<String_comparison_exp>;
  street?: InputMaybe<String_comparison_exp>;
};

/** response of any mutation on the table "address" */
export type address_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<address>;
};

/** Ordering options when selecting data from "address". */
export type address_order_by = {
  building_citydb_gml_ids?: InputMaybe<order_by>;
  building_lod1_ids?: InputMaybe<order_by>;
  buildings_aggregate?: InputMaybe<building_aggregate_order_by>;
  city?: InputMaybe<order_by>;
  climate_region_id?: InputMaybe<order_by>;
  country_id?: InputMaybe<order_by>;
  country_state_id?: InputMaybe<order_by>;
  has_gml_ids?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  mapbox_bearing?: InputMaybe<order_by>;
  mapbox_building_ids?: InputMaybe<order_by>;
  mapbox_pitch?: InputMaybe<order_by>;
  mapbox_zoom?: InputMaybe<order_by>;
  neighbor_citydb_gml_ids?: InputMaybe<order_by>;
  neighbor_lod1_ids?: InputMaybe<order_by>;
  postal_code?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
};

/** primary key columns input for table: address */
export type address_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "address" */
export enum address_select_column {
  /** column name */
  building_citydb_gml_ids = 'building_citydb_gml_ids',
  /** column name */
  building_lod1_ids = 'building_lod1_ids',
  /** column name */
  city = 'city',
  /** column name */
  climate_region_id = 'climate_region_id',
  /** column name */
  country_id = 'country_id',
  /** column name */
  country_state_id = 'country_state_id',
  /** column name */
  id = 'id',
  /** column name */
  latitude = 'latitude',
  /** column name */
  longitude = 'longitude',
  /** column name */
  mapbox_bearing = 'mapbox_bearing',
  /** column name */
  mapbox_building_ids = 'mapbox_building_ids',
  /** column name */
  mapbox_pitch = 'mapbox_pitch',
  /** column name */
  mapbox_zoom = 'mapbox_zoom',
  /** column name */
  neighbor_citydb_gml_ids = 'neighbor_citydb_gml_ids',
  /** column name */
  neighbor_lod1_ids = 'neighbor_lod1_ids',
  /** column name */
  postal_code = 'postal_code',
  /** column name */
  street = 'street',
}

/** input type for updating data in table "address" */
export type address_set_input = {
  city?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "address" */
export type address_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: address_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type address_stream_cursor_value_input = {
  /** GML IDs linking this building to its 3D model in the CityGML/3DCityDB database. */
  building_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs linking this building to its LOD1 (block model) representation in the LOD1 database. */
  building_lod1_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** Climate region used for energy demand calculations and weather normalization. */
  climate_region_id?: InputMaybe<climate_region_enum>;
  /** Country where the building is located. References country. */
  country_id?: InputMaybe<country_enum>;
  /** Federal state or administrative region where the building is located. */
  country_state_id?: InputMaybe<country_state_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  /** Camera bearing angle for the saved Mapbox 3D view of this building. */
  mapbox_bearing?: InputMaybe<Scalars['float8']['input']>;
  /** Mapbox feature IDs identifying this building's footprint on the map. */
  mapbox_building_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Camera pitch angle for the saved Mapbox 3D view of this building. */
  mapbox_pitch?: InputMaybe<Scalars['float8']['input']>;
  /** Zoom level for the saved Mapbox 3D view of this building. */
  mapbox_zoom?: InputMaybe<Scalars['float8']['input']>;
  /** GML IDs of neighboring buildings in the 3DCityDB, used for contextual 3D rendering. */
  neighbor_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of neighboring buildings in the LOD1 database, used for contextual 3D rendering. */
  neighbor_lod1_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type address_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<address_set_input>;
  /** filter the rows which have to be updated */
  where: address_bool_exp;
};

/** Tracks an AI extraction session with the Alpha Prompt service for a specific invoice snapshot. */
export type alpha_prompt_interaction = {
  /** External analysis identifier returned by the Alpha Prompt service. */
  analysis_id?: Maybe<Scalars['String']['output']>;
  /** When the AI analysis phase began after file upload. */
  analysis_started_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  cbi_invoice_snapshot: cbi_invoice_snapshot;
  created_at: Scalars['timestamptz']['output'];
  /** Raw JSON response from the AI extraction service before transformation. */
  extracted_raw_data?: Maybe<Scalars['jsonb']['output']>;
  /** Name of the uploaded invoice file sent to the extraction service. */
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id: Scalars['Int']['output'];
  /** When the interaction was initiated. */
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  /** When the file was successfully uploaded to the extraction service. */
  uploaded_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Tracks an AI extraction session with the Alpha Prompt service for a specific invoice snapshot. */
export type alpha_prompt_interactionextracted_raw_dataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_aggregate_order_by = {
  avg?: InputMaybe<alpha_prompt_interaction_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<alpha_prompt_interaction_max_order_by>;
  min?: InputMaybe<alpha_prompt_interaction_min_order_by>;
  stddev?: InputMaybe<alpha_prompt_interaction_stddev_order_by>;
  stddev_pop?: InputMaybe<alpha_prompt_interaction_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<alpha_prompt_interaction_stddev_samp_order_by>;
  sum?: InputMaybe<alpha_prompt_interaction_sum_order_by>;
  var_pop?: InputMaybe<alpha_prompt_interaction_var_pop_order_by>;
  var_samp?: InputMaybe<alpha_prompt_interaction_var_samp_order_by>;
  variance?: InputMaybe<alpha_prompt_interaction_variance_order_by>;
};

/** order by avg() on columns of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "alpha_prompt_interaction". All fields are combined with a logical 'AND'. */
export type alpha_prompt_interaction_bool_exp = {
  _and?: InputMaybe<Array<alpha_prompt_interaction_bool_exp>>;
  _not?: InputMaybe<alpha_prompt_interaction_bool_exp>;
  _or?: InputMaybe<Array<alpha_prompt_interaction_bool_exp>>;
  analysis_id?: InputMaybe<String_comparison_exp>;
  analysis_started_at?: InputMaybe<timestamptz_comparison_exp>;
  cbi_invoice_snapshot?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  extracted_raw_data?: InputMaybe<jsonb_comparison_exp>;
  filename?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  snapshot_id?: InputMaybe<Int_comparison_exp>;
  started_at?: InputMaybe<timestamptz_comparison_exp>;
  uploaded_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_max_order_by = {
  /** External analysis identifier returned by the Alpha Prompt service. */
  analysis_id?: InputMaybe<order_by>;
  /** When the AI analysis phase began after file upload. */
  analysis_started_at?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Name of the uploaded invoice file sent to the extraction service. */
  filename?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<order_by>;
  /** When the interaction was initiated. */
  started_at?: InputMaybe<order_by>;
  /** When the file was successfully uploaded to the extraction service. */
  uploaded_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_min_order_by = {
  /** External analysis identifier returned by the Alpha Prompt service. */
  analysis_id?: InputMaybe<order_by>;
  /** When the AI analysis phase began after file upload. */
  analysis_started_at?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Name of the uploaded invoice file sent to the extraction service. */
  filename?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<order_by>;
  /** When the interaction was initiated. */
  started_at?: InputMaybe<order_by>;
  /** When the file was successfully uploaded to the extraction service. */
  uploaded_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "alpha_prompt_interaction". */
export type alpha_prompt_interaction_order_by = {
  analysis_id?: InputMaybe<order_by>;
  analysis_started_at?: InputMaybe<order_by>;
  cbi_invoice_snapshot?: InputMaybe<cbi_invoice_snapshot_order_by>;
  created_at?: InputMaybe<order_by>;
  extracted_raw_data?: InputMaybe<order_by>;
  filename?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  started_at?: InputMaybe<order_by>;
  uploaded_at?: InputMaybe<order_by>;
};

/** select columns of table "alpha_prompt_interaction" */
export enum alpha_prompt_interaction_select_column {
  /** column name */
  analysis_id = 'analysis_id',
  /** column name */
  analysis_started_at = 'analysis_started_at',
  /** column name */
  created_at = 'created_at',
  /** column name */
  extracted_raw_data = 'extracted_raw_data',
  /** column name */
  filename = 'filename',
  /** column name */
  id = 'id',
  /** column name */
  snapshot_id = 'snapshot_id',
  /** column name */
  started_at = 'started_at',
  /** column name */
  uploaded_at = 'uploaded_at',
}

/** order by stddev() on columns of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: alpha_prompt_interaction_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type alpha_prompt_interaction_stream_cursor_value_input = {
  /** External analysis identifier returned by the Alpha Prompt service. */
  analysis_id?: InputMaybe<Scalars['String']['input']>;
  /** When the AI analysis phase began after file upload. */
  analysis_started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Raw JSON response from the AI extraction service before transformation. */
  extracted_raw_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** Name of the uploaded invoice file sent to the extraction service. */
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<Scalars['Int']['input']>;
  /** When the interaction was initiated. */
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** When the file was successfully uploaded to the extraction service. */
  uploaded_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "alpha_prompt_interaction" */
export type alpha_prompt_interaction_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** The CBI invoice snapshot being processed by the AI extraction. */
  snapshot_id?: InputMaybe<order_by>;
};

export enum analysis_reference_area_enum {
  BGF = 'BGF',
  EBF = 'EBF',
  MF = 'MF',
  NGF = 'NGF',
}

export enum api_response_status_enum {
  /** The 3rd party service has determined the final response */
  COMPLETED = 'COMPLETED',
  /** The request has somehow failed. */
  FAILED = 'FAILED',
  /** The asset has been created but no asynchronous request has yet been initialized. */
  NOT_INITIALIZED = 'NOT_INITIALIZED',
  /** The request has been issued but no final response or error has been returned yet. */
  PENDING = 'PENDING',
}

/** Boolean expression to compare columns of type "api_response_status_enum". All fields are combined with logical 'AND'. */
export type api_response_status_enum_comparison_exp = {
  _eq?: InputMaybe<api_response_status_enum>;
  _in?: InputMaybe<Array<api_response_status_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<api_response_status_enum>;
  _nin?: InputMaybe<Array<api_response_status_enum>>;
};

/** A distinct floor area within a building, used for energy reference calculations, tenant tracking, and consumption allocation. */
export type area = {
  /** Which area classification system/standard is used (e.g., PREDIUM_2024). Different from area_type which classifies the area itself. */
  area_system_id: area_system_type_enum;
  /** Measurement standard: EBF (energy reference area), NF (usable area), or BGF (gross floor area). */
  area_type_id: area_type_enum;
  /** An object relationship */
  building: building;
  /** The building this area belongs to. */
  building_id: Scalars['Int']['output'];
  /** Whether this area is available for rental. */
  can_be_rented: Scalars['Boolean']['output'];
  /** Detailed usage classification of this area. */
  class_of_use_id: class_of_use_enum;
  /** An object relationship */
  consumption_areas?: Maybe<consumption_area>;
  /** Origin of the area data (e.g., manual entry, import, estimation). */
  data_source_id: data_source_type_enum;
  /** Additional details about the area. */
  description: Scalars['String']['output'];
  /** An object relationship */
  energy_certificate?: Maybe<energy_certificate>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Int']['output']>;
  energy_rating_score?: Maybe<Scalars['numeric']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Int']['output']>;
  /** External identifier for the area (the "ID" field in the Mietfläche modal). */
  external_id: Scalars['String']['output'];
  /** An object relationship */
  file?: Maybe<file>;
  file_id?: Maybe<Scalars['Int']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['Int']['output'];
  /** Whether this area is currently rented out. */
  is_rented: Scalars['Boolean']['output'];
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['numeric']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['numeric']['output']>;
  /** Primary usage type of this area. */
  type_of_use_id: type_of_use_enum;
  /** Area size in square meters. */
  value: Scalars['float8']['output'];
};

/** aggregated selection of "area" */
export type area_aggregate = {
  aggregate?: Maybe<area_aggregate_fields>;
  nodes: Array<area>;
};

export type area_aggregate_bool_exp = {
  avg?: InputMaybe<area_aggregate_bool_exp_avg>;
  bool_and?: InputMaybe<area_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<area_aggregate_bool_exp_bool_or>;
  corr?: InputMaybe<area_aggregate_bool_exp_corr>;
  count?: InputMaybe<area_aggregate_bool_exp_count>;
  covar_samp?: InputMaybe<area_aggregate_bool_exp_covar_samp>;
  max?: InputMaybe<area_aggregate_bool_exp_max>;
  min?: InputMaybe<area_aggregate_bool_exp_min>;
  stddev_samp?: InputMaybe<area_aggregate_bool_exp_stddev_samp>;
  sum?: InputMaybe<area_aggregate_bool_exp_sum>;
  var_samp?: InputMaybe<area_aggregate_bool_exp_var_samp>;
};

export type area_aggregate_bool_exp_avg = {
  arguments: area_select_column_area_aggregate_bool_exp_avg_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: float8_comparison_exp;
};

export type area_aggregate_bool_exp_bool_and = {
  arguments: area_select_column_area_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type area_aggregate_bool_exp_bool_or = {
  arguments: area_select_column_area_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type area_aggregate_bool_exp_corr = {
  arguments: area_aggregate_bool_exp_corr_arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: float8_comparison_exp;
};

export type area_aggregate_bool_exp_corr_arguments = {
  X: area_select_column_area_aggregate_bool_exp_corr_arguments_columns;
  Y: area_select_column_area_aggregate_bool_exp_corr_arguments_columns;
};

export type area_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<area_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: Int_comparison_exp;
};

export type area_aggregate_bool_exp_covar_samp = {
  arguments: area_aggregate_bool_exp_covar_samp_arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: float8_comparison_exp;
};

export type area_aggregate_bool_exp_covar_samp_arguments = {
  X: area_select_column_area_aggregate_bool_exp_covar_samp_arguments_columns;
  Y: area_select_column_area_aggregate_bool_exp_covar_samp_arguments_columns;
};

export type area_aggregate_bool_exp_max = {
  arguments: area_select_column_area_aggregate_bool_exp_max_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: float8_comparison_exp;
};

export type area_aggregate_bool_exp_min = {
  arguments: area_select_column_area_aggregate_bool_exp_min_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: float8_comparison_exp;
};

export type area_aggregate_bool_exp_stddev_samp = {
  arguments: area_select_column_area_aggregate_bool_exp_stddev_samp_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: float8_comparison_exp;
};

export type area_aggregate_bool_exp_sum = {
  arguments: area_select_column_area_aggregate_bool_exp_sum_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: float8_comparison_exp;
};

export type area_aggregate_bool_exp_var_samp = {
  arguments: area_select_column_area_aggregate_bool_exp_var_samp_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<area_bool_exp>;
  predicate: float8_comparison_exp;
};

/** aggregate fields of "area" */
export type area_aggregate_fields = {
  avg?: Maybe<area_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<area_max_fields>;
  min?: Maybe<area_min_fields>;
  stddev?: Maybe<area_stddev_fields>;
  stddev_pop?: Maybe<area_stddev_pop_fields>;
  stddev_samp?: Maybe<area_stddev_samp_fields>;
  sum?: Maybe<area_sum_fields>;
  var_pop?: Maybe<area_var_pop_fields>;
  var_samp?: Maybe<area_var_samp_fields>;
  variance?: Maybe<area_variance_fields>;
};

/** aggregate fields of "area" */
export type area_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<area_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "area" */
export type area_aggregate_order_by = {
  avg?: InputMaybe<area_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<area_max_order_by>;
  min?: InputMaybe<area_min_order_by>;
  stddev?: InputMaybe<area_stddev_order_by>;
  stddev_pop?: InputMaybe<area_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<area_stddev_samp_order_by>;
  sum?: InputMaybe<area_sum_order_by>;
  var_pop?: InputMaybe<area_var_pop_order_by>;
  var_samp?: InputMaybe<area_var_samp_order_by>;
  variance?: InputMaybe<area_variance_order_by>;
};

/** aggregate avg on columns */
export type area_avg_fields = {
  /** The building this area belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Float']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  /** Area size in square meters. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "area" */
export type area_avg_order_by = {
  /** The building this area belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "area". All fields are combined with a logical 'AND'. */
export type area_bool_exp = {
  _and?: InputMaybe<Array<area_bool_exp>>;
  _not?: InputMaybe<area_bool_exp>;
  _or?: InputMaybe<Array<area_bool_exp>>;
  area_system_id?: InputMaybe<area_system_type_enum_comparison_exp>;
  area_type_id?: InputMaybe<area_type_enum_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  can_be_rented?: InputMaybe<Boolean_comparison_exp>;
  class_of_use_id?: InputMaybe<class_of_use_enum_comparison_exp>;
  consumption_areas?: InputMaybe<consumption_area_bool_exp>;
  data_source_id?: InputMaybe<data_source_type_enum_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  energy_certificate?: InputMaybe<energy_certificate_bool_exp>;
  energy_certificate_id?: InputMaybe<Int_comparison_exp>;
  energy_rating_score?: InputMaybe<numeric_comparison_exp>;
  enev_year?: InputMaybe<Int_comparison_exp>;
  external_id?: InputMaybe<String_comparison_exp>;
  file?: InputMaybe<file_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  geg_reference_value?: InputMaybe<numeric_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  is_rented?: InputMaybe<Boolean_comparison_exp>;
  reference_value_electricity?: InputMaybe<numeric_comparison_exp>;
  reference_value_heating_hot_water?: InputMaybe<numeric_comparison_exp>;
  type_of_use_id?: InputMaybe<type_of_use_enum_comparison_exp>;
  value?: InputMaybe<float8_comparison_exp>;
};

/** aggregate max on columns */
export type area_max_fields = {
  /** The building this area belongs to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Additional details about the area. */
  description?: Maybe<Scalars['String']['output']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Int']['output']>;
  energy_rating_score?: Maybe<Scalars['numeric']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Int']['output']>;
  /** External identifier for the area (the "ID" field in the Mietfläche modal). */
  external_id?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['numeric']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['numeric']['output']>;
  /** Area size in square meters. */
  value?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "area" */
export type area_max_order_by = {
  /** The building this area belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Additional details about the area. */
  description?: InputMaybe<order_by>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<order_by>;
  /** External identifier for the area (the "ID" field in the Mietfläche modal). */
  external_id?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type area_min_fields = {
  /** The building this area belongs to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Additional details about the area. */
  description?: Maybe<Scalars['String']['output']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Int']['output']>;
  energy_rating_score?: Maybe<Scalars['numeric']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Int']['output']>;
  /** External identifier for the area (the "ID" field in the Mietfläche modal). */
  external_id?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['numeric']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['numeric']['output']>;
  /** Area size in square meters. */
  value?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "area" */
export type area_min_order_by = {
  /** The building this area belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Additional details about the area. */
  description?: InputMaybe<order_by>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<order_by>;
  /** External identifier for the area (the "ID" field in the Mietfläche modal). */
  external_id?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "area". */
export type area_order_by = {
  area_system_id?: InputMaybe<order_by>;
  area_type_id?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  can_be_rented?: InputMaybe<order_by>;
  class_of_use_id?: InputMaybe<order_by>;
  consumption_areas?: InputMaybe<consumption_area_order_by>;
  data_source_id?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  energy_certificate?: InputMaybe<energy_certificate_order_by>;
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  file?: InputMaybe<file_order_by>;
  file_id?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  is_rented?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  type_of_use_id?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "area" */
export enum area_select_column {
  /** column name */
  area_system_id = 'area_system_id',
  /** column name */
  area_type_id = 'area_type_id',
  /** column name */
  building_id = 'building_id',
  /** column name */
  can_be_rented = 'can_be_rented',
  /** column name */
  class_of_use_id = 'class_of_use_id',
  /** column name */
  data_source_id = 'data_source_id',
  /** column name */
  description = 'description',
  /** column name */
  energy_certificate_id = 'energy_certificate_id',
  /** column name */
  energy_rating_score = 'energy_rating_score',
  /** column name */
  enev_year = 'enev_year',
  /** column name */
  external_id = 'external_id',
  /** column name */
  file_id = 'file_id',
  /** column name */
  geg_reference_value = 'geg_reference_value',
  /** column name */
  id = 'id',
  /** column name */
  is_rented = 'is_rented',
  /** column name */
  reference_value_electricity = 'reference_value_electricity',
  /** column name */
  reference_value_heating_hot_water = 'reference_value_heating_hot_water',
  /** column name */
  type_of_use_id = 'type_of_use_id',
  /** column name */
  value = 'value',
}

/** select "area_aggregate_bool_exp_avg_arguments_columns" columns of table "area" */
export enum area_select_column_area_aggregate_bool_exp_avg_arguments_columns {
  /** column name */
  value = 'value',
}

/** select "area_aggregate_bool_exp_bool_and_arguments_columns" columns of table "area" */
export enum area_select_column_area_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  can_be_rented = 'can_be_rented',
  /** column name */
  is_rented = 'is_rented',
}

/** select "area_aggregate_bool_exp_bool_or_arguments_columns" columns of table "area" */
export enum area_select_column_area_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  can_be_rented = 'can_be_rented',
  /** column name */
  is_rented = 'is_rented',
}

/** select "area_aggregate_bool_exp_corr_arguments_columns" columns of table "area" */
export enum area_select_column_area_aggregate_bool_exp_corr_arguments_columns {
  /** column name */
  value = 'value',
}

/** select "area_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "area" */
export enum area_select_column_area_aggregate_bool_exp_covar_samp_arguments_columns {
  /** column name */
  value = 'value',
}

/** select "area_aggregate_bool_exp_max_arguments_columns" columns of table "area" */
export enum area_select_column_area_aggregate_bool_exp_max_arguments_columns {
  /** column name */
  value = 'value',
}

/** select "area_aggregate_bool_exp_min_arguments_columns" columns of table "area" */
export enum area_select_column_area_aggregate_bool_exp_min_arguments_columns {
  /** column name */
  value = 'value',
}

/** select "area_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "area" */
export enum area_select_column_area_aggregate_bool_exp_stddev_samp_arguments_columns {
  /** column name */
  value = 'value',
}

/** select "area_aggregate_bool_exp_sum_arguments_columns" columns of table "area" */
export enum area_select_column_area_aggregate_bool_exp_sum_arguments_columns {
  /** column name */
  value = 'value',
}

/** select "area_aggregate_bool_exp_var_samp_arguments_columns" columns of table "area" */
export enum area_select_column_area_aggregate_bool_exp_var_samp_arguments_columns {
  /** column name */
  value = 'value',
}

/** aggregate stddev on columns */
export type area_stddev_fields = {
  /** The building this area belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Float']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  /** Area size in square meters. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "area" */
export type area_stddev_order_by = {
  /** The building this area belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type area_stddev_pop_fields = {
  /** The building this area belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Float']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  /** Area size in square meters. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "area" */
export type area_stddev_pop_order_by = {
  /** The building this area belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type area_stddev_samp_fields = {
  /** The building this area belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Float']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  /** Area size in square meters. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "area" */
export type area_stddev_samp_order_by = {
  /** The building this area belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "area" */
export type area_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: area_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type area_stream_cursor_value_input = {
  /** Which area classification system/standard is used (e.g., PREDIUM_2024). Different from area_type which classifies the area itself. */
  area_system_id?: InputMaybe<area_system_type_enum>;
  /** Measurement standard: EBF (energy reference area), NF (usable area), or BGF (gross floor area). */
  area_type_id?: InputMaybe<area_type_enum>;
  /** The building this area belongs to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this area is available for rental. */
  can_be_rented?: InputMaybe<Scalars['Boolean']['input']>;
  /** Detailed usage classification of this area. */
  class_of_use_id?: InputMaybe<class_of_use_enum>;
  /** Origin of the area data (e.g., manual entry, import, estimation). */
  data_source_id?: InputMaybe<data_source_type_enum>;
  /** Additional details about the area. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  energy_rating_score?: InputMaybe<Scalars['numeric']['input']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<Scalars['Int']['input']>;
  /** External identifier for the area (the "ID" field in the Mietfläche modal). */
  external_id?: InputMaybe<Scalars['String']['input']>;
  file_id?: InputMaybe<Scalars['Int']['input']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this area is currently rented out. */
  is_rented?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<Scalars['numeric']['input']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<Scalars['numeric']['input']>;
  /** Primary usage type of this area. */
  type_of_use_id?: InputMaybe<type_of_use_enum>;
  /** Area size in square meters. */
  value?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type area_sum_fields = {
  /** The building this area belongs to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Int']['output']>;
  energy_rating_score?: Maybe<Scalars['numeric']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Int']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['numeric']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['numeric']['output']>;
  /** Area size in square meters. */
  value?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "area" */
export type area_sum_order_by = {
  /** The building this area belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Area size in square meters. */
  value?: InputMaybe<order_by>;
};

export enum area_system_type_enum {
  PREDIUM_2024 = 'PREDIUM_2024',
}

/** Boolean expression to compare columns of type "area_system_type_enum". All fields are combined with logical 'AND'. */
export type area_system_type_enum_comparison_exp = {
  _eq?: InputMaybe<area_system_type_enum>;
  _in?: InputMaybe<Array<area_system_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<area_system_type_enum>;
  _nin?: InputMaybe<Array<area_system_type_enum>>;
};

export enum area_type_enum {
  AF = 'AF',
  BGF = 'BGF',
  EBF = 'EBF',
  IPMS_2 = 'IPMS_2',
  MF = 'MF',
  NGF = 'NGF',
}

/** Boolean expression to compare columns of type "area_type_enum". All fields are combined with logical 'AND'. */
export type area_type_enum_comparison_exp = {
  _eq?: InputMaybe<area_type_enum>;
  _in?: InputMaybe<Array<area_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<area_type_enum>;
  _nin?: InputMaybe<Array<area_type_enum>>;
};

/** aggregate var_pop on columns */
export type area_var_pop_fields = {
  /** The building this area belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Float']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  /** Area size in square meters. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "area" */
export type area_var_pop_order_by = {
  /** The building this area belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type area_var_samp_fields = {
  /** The building this area belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Float']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  /** Area size in square meters. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "area" */
export type area_var_samp_order_by = {
  /** The building this area belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type area_variance_fields = {
  /** The building this area belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: Maybe<Scalars['Float']['output']>;
  file_id?: Maybe<Scalars['Float']['output']>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  /** Area size in square meters. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "area" */
export type area_variance_order_by = {
  /** The building this area belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Energy certificate this area data was extracted from, if applicable. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year applicable to this area. */
  enev_year?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  /** GEG reference value for this specific area. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference value for electricity in kWh/(m2.a) for this area. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water in kWh/(m2.a) for this area. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** Tracks a long-running background operation (e.g., Excel import, energy analysis, bulk update) with progress and status. */
export type async_job = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Detailed description or error message for the job. */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Int']['output']>;
  exportedFileId?: Maybe<GetFileIdByAsyncJobIdOutput>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  org?: Maybe<org>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** Current job status (e.g., PENDING, IN_PROGRESS, COMPLETED, FAILED). */
  status_id: async_job_status_type_enum;
  /** Human-readable title describing the job. */
  title: Scalars['String']['output'];
  /** Total number of sub-tasks created for this job. */
  total_jobs_created: Scalars['Int']['output'];
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<user>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "async_job" */
export type async_job_aggregate = {
  aggregate?: Maybe<async_job_aggregate_fields>;
  nodes: Array<async_job>;
};

/** aggregate fields of "async_job" */
export type async_job_aggregate_fields = {
  avg?: Maybe<async_job_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<async_job_max_fields>;
  min?: Maybe<async_job_min_fields>;
  stddev?: Maybe<async_job_stddev_fields>;
  stddev_pop?: Maybe<async_job_stddev_pop_fields>;
  stddev_samp?: Maybe<async_job_stddev_samp_fields>;
  sum?: Maybe<async_job_sum_fields>;
  var_pop?: Maybe<async_job_var_pop_fields>;
  var_samp?: Maybe<async_job_var_samp_fields>;
  variance?: Maybe<async_job_variance_fields>;
};

/** aggregate fields of "async_job" */
export type async_job_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<async_job_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type async_job_avg_fields = {
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: Maybe<Scalars['Float']['output']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "async_job". All fields are combined with a logical 'AND'. */
export type async_job_bool_exp = {
  _and?: InputMaybe<Array<async_job_bool_exp>>;
  _not?: InputMaybe<async_job_bool_exp>;
  _or?: InputMaybe<Array<async_job_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  entity_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  status_id?: InputMaybe<async_job_status_type_enum_comparison_exp>;
  title?: InputMaybe<String_comparison_exp>;
  total_jobs_created?: InputMaybe<Int_comparison_exp>;
  total_jobs_finished?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<Int_comparison_exp>;
};

/** aggregate max on columns */
export type async_job_max_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Detailed description or error message for the job. */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** Human-readable title describing the job. */
  title?: Maybe<Scalars['String']['output']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: Maybe<Scalars['Int']['output']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type async_job_min_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Detailed description or error message for the job. */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** Human-readable title describing the job. */
  title?: Maybe<Scalars['String']['output']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: Maybe<Scalars['Int']['output']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "async_job". */
export type async_job_order_by = {
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  entity_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  status_id?: InputMaybe<order_by>;
  title?: InputMaybe<order_by>;
  total_jobs_created?: InputMaybe<order_by>;
  total_jobs_finished?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_id?: InputMaybe<order_by>;
};

/** select columns of table "async_job" */
export enum async_job_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  entity_id = 'entity_id',
  /** column name */
  id = 'id',
  /** column name */
  org_id = 'org_id',
  /** column name */
  status_id = 'status_id',
  /** column name */
  title = 'title',
  /** column name */
  total_jobs_created = 'total_jobs_created',
  /** column name */
  total_jobs_finished = 'total_jobs_finished',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  user_id = 'user_id',
}

export enum async_job_status_type_enum {
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
}

/** Boolean expression to compare columns of type "async_job_status_type_enum". All fields are combined with logical 'AND'. */
export type async_job_status_type_enum_comparison_exp = {
  _eq?: InputMaybe<async_job_status_type_enum>;
  _in?: InputMaybe<Array<async_job_status_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<async_job_status_type_enum>;
  _nin?: InputMaybe<Array<async_job_status_type_enum>>;
};

/** aggregate stddev on columns */
export type async_job_stddev_fields = {
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: Maybe<Scalars['Float']['output']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type async_job_stddev_pop_fields = {
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: Maybe<Scalars['Float']['output']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type async_job_stddev_samp_fields = {
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: Maybe<Scalars['Float']['output']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "async_job" */
export type async_job_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: async_job_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type async_job_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Detailed description or error message for the job. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization the job belongs to. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Current job status (e.g., PENDING, IN_PROGRESS, COMPLETED, FAILED). */
  status_id?: InputMaybe<async_job_status_type_enum>;
  /** Human-readable title describing the job. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: InputMaybe<Scalars['Int']['input']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** User who initiated the job. */
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type async_job_sum_fields = {
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: Maybe<Scalars['Int']['output']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: Maybe<Scalars['Int']['output']>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type async_job_var_pop_fields = {
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: Maybe<Scalars['Float']['output']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type async_job_var_samp_fields = {
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: Maybe<Scalars['Float']['output']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type async_job_variance_fields = {
  /** ID of the primary entity this job operates on (e.g., building_id, report_id). */
  entity_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization the job belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Total number of sub-tasks created for this job. */
  total_jobs_created?: Maybe<Scalars['Float']['output']>;
  /** Number of sub-tasks completed so far, used to calculate progress. */
  total_jobs_finished?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the job. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type bigint_comparison_exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type building = {
  /** An array relationship */
  action_plans: Array<action_plan>;
  /** An array relationship */
  active_action_plans: Array<active_action_plans>;
  /** An aggregate relationship */
  active_action_plans_aggregate: active_action_plans_aggregate;
  /** An object relationship */
  active_building_model?: Maybe<building_model>;
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  address: address;
  /** Physical location and geospatial metadata for this building. */
  address_id: Scalars['Int']['output'];
  /** An array relationship */
  areas: Array<area>;
  /** An aggregate relationship */
  areas_aggregate: area_aggregate;
  base_emission_factors: EmissionFactorsObject;
  /** An array relationship */
  building_models: Array<building_model>;
  /** Lifecycle state of the building (e.g. INVENTORY, RENOVATION). References building_state. */
  building_state_id: building_state_enum;
  /** An array relationship */
  building_valuations: Array<building_valuation>;
  /** An array relationship */
  certificates: Array<certificate>;
  /** An aggregate relationship */
  certificates_aggregate: certificate_aggregate;
  /** An array relationship */
  climate_risks: Array<climate_risk>;
  /** An aggregate relationship */
  climate_risks_aggregate: climate_risk_aggregate;
  /** An array relationship */
  climate_risks_v2: Array<climate_risk_v2>;
  /** An aggregate relationship */
  climate_risks_v2_aggregate: climate_risk_v2_aggregate;
  /** An array relationship */
  consumption_drafts: Array<consumption_draft>;
  /** An aggregate relationship */
  consumption_drafts_aggregate: consumption_draft_aggregate;
  /** An array relationship */
  consumptions: Array<consumption>;
  /** An aggregate relationship */
  consumptions_aggregate: consumption_aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** JSON object holding customer-defined custom fields for this building. */
  custom_data: Scalars['jsonb']['output'];
  /** External identifier assigned by the customer, used for cross-system referencing. */
  customer_external_identifier?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  /** An object relationship */
  district_heating_availability_status?: Maybe<building_with_district_heating_status>;
  /** An object relationship */
  economic_unit: economic_unit;
  /** The economic unit this building belongs to. */
  economic_unit_id: Scalars['Int']['output'];
  /** An array relationship */
  energy_certificates: Array<energy_certificate>;
  /** An object relationship */
  folder?: Maybe<folder>;
  /** A computed field, executes function "has_building_write_permission" */
  has_write_permission: Scalars['Boolean']['output'];
  /** Whether the building is located in a designated heritage district. */
  heritage_district: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** A computed field, executes function "building_is_missing_energy_data" */
  is_missing_energy_data?: Maybe<Scalars['Boolean']['output']>;
  is_new_construction: Scalars['Boolean']['output'];
  /** Whether the building is on leasehold land (Erbbaurecht) rather than owned freehold. */
  leasehold: Scalars['Boolean']['output'];
  /** Whether the building is in a milieu protection zone (Milieuschutzgebiet), restricting modernization to prevent displacement. */
  milieu_protection: Scalars['Boolean']['output'];
  /** Whether the building is under monument/heritage protection, which restricts renovation options. */
  monument_protection: Scalars['Boolean']['output'];
  /** An array relationship */
  report_buildings: Array<report_building>;
  /** An aggregate relationship */
  report_buildings_aggregate: report_building_aggregate;
  /** An object relationship */
  responsible_user: user;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id: Scalars['Int']['output'];
  /** Soft-delete state of the building record (ACTIVE or DELETED). References entity_state_type. */
  state: entity_state_type_enum;
  /** An array relationship */
  subsidies: Array<building_subsidy>;
  /** Timestamp of the last update to subsidy/funding eligibility data for this building. */
  subsidies_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units: Scalars['Int']['output'];
  /** How the unit count was determined (e.g. MANUAL, APPROXIMATED). References data_source_type. */
  units_data_source: data_source_type_enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  user_building_permissions: Array<user_building_permission>;
  /** An array relationship */
  user_permissions: Array<building_permissions>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed: Scalars['Int']['output'];
  /** How the construction year was determined (e.g. MANUAL, APPROXIMATED). References data_source_type. */
  year_data_source: data_source_type_enum;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingaction_plansArgs = {
  distinct_on?: InputMaybe<Array<action_plan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_plan_order_by>>;
  where?: InputMaybe<action_plan_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingactive_action_plansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_action_plans_order_by>>;
  where?: InputMaybe<active_action_plans_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingactive_action_plans_aggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_action_plans_order_by>>;
  where?: InputMaybe<active_action_plans_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingareasArgs = {
  distinct_on?: InputMaybe<Array<area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<area_order_by>>;
  where?: InputMaybe<area_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingareas_aggregateArgs = {
  distinct_on?: InputMaybe<Array<area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<area_order_by>>;
  where?: InputMaybe<area_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingbuilding_modelsArgs = {
  distinct_on?: InputMaybe<Array<building_model_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_model_order_by>>;
  where?: InputMaybe<building_model_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingbuilding_valuationsArgs = {
  distinct_on?: InputMaybe<Array<building_valuation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_valuation_order_by>>;
  where?: InputMaybe<building_valuation_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingcertificatesArgs = {
  distinct_on?: InputMaybe<Array<certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<certificate_order_by>>;
  where?: InputMaybe<certificate_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingcertificates_aggregateArgs = {
  distinct_on?: InputMaybe<Array<certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<certificate_order_by>>;
  where?: InputMaybe<certificate_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingclimate_risksArgs = {
  distinct_on?: InputMaybe<Array<climate_risk_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_order_by>>;
  where?: InputMaybe<climate_risk_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingclimate_risks_aggregateArgs = {
  distinct_on?: InputMaybe<Array<climate_risk_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_order_by>>;
  where?: InputMaybe<climate_risk_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingclimate_risks_v2Args = {
  distinct_on?: InputMaybe<Array<climate_risk_v2_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_v2_order_by>>;
  where?: InputMaybe<climate_risk_v2_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingclimate_risks_v2_aggregateArgs = {
  distinct_on?: InputMaybe<Array<climate_risk_v2_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_v2_order_by>>;
  where?: InputMaybe<climate_risk_v2_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingconsumption_draftsArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_order_by>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingconsumption_drafts_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_order_by>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingconsumptionsArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingconsumptions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingcustom_dataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingenergy_certificatesArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_order_by>>;
  where?: InputMaybe<energy_certificate_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingreport_buildingsArgs = {
  distinct_on?: InputMaybe<Array<report_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_order_by>>;
  where?: InputMaybe<report_building_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingreport_buildings_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_order_by>>;
  where?: InputMaybe<report_building_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildingsubsidiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_subsidy_order_by>>;
  where?: InputMaybe<building_subsidy_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildinguser_building_permissionsArgs = {
  distinct_on?: InputMaybe<Array<user_building_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_building_permission_order_by>>;
  where?: InputMaybe<user_building_permission_bool_exp>;
};

/** A physical building tracked on the platform, containing energy systems, envelope data, and consumption records. */
export type buildinguser_permissionsArgs = {
  distinct_on?: InputMaybe<Array<building_permissions_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_permissions_order_by>>;
  where?: InputMaybe<building_permissions_bool_exp>;
};

/** aggregated selection of "building" */
export type building_aggregate = {
  aggregate?: Maybe<building_aggregate_fields>;
  nodes: Array<building>;
};

export type building_aggregate_bool_exp = {
  bool_and?: InputMaybe<building_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<building_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<building_aggregate_bool_exp_count>;
};

export type building_aggregate_bool_exp_bool_and = {
  arguments: building_select_column_building_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<building_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type building_aggregate_bool_exp_bool_or = {
  arguments: building_select_column_building_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<building_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type building_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<building_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<building_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "building" */
export type building_aggregate_fields = {
  avg?: Maybe<building_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<building_max_fields>;
  min?: Maybe<building_min_fields>;
  stddev?: Maybe<building_stddev_fields>;
  stddev_pop?: Maybe<building_stddev_pop_fields>;
  stddev_samp?: Maybe<building_stddev_samp_fields>;
  sum?: Maybe<building_sum_fields>;
  var_pop?: Maybe<building_var_pop_fields>;
  var_samp?: Maybe<building_var_samp_fields>;
  variance?: Maybe<building_variance_fields>;
};

/** aggregate fields of "building" */
export type building_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<building_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "building" */
export type building_aggregate_order_by = {
  avg?: InputMaybe<building_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<building_max_order_by>;
  min?: InputMaybe<building_min_order_by>;
  stddev?: InputMaybe<building_stddev_order_by>;
  stddev_pop?: InputMaybe<building_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<building_stddev_samp_order_by>;
  sum?: InputMaybe<building_sum_order_by>;
  var_pop?: InputMaybe<building_var_pop_order_by>;
  var_samp?: InputMaybe<building_var_samp_order_by>;
  variance?: InputMaybe<building_variance_order_by>;
};

/** aggregate avg on columns */
export type building_avg_fields = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Float']['output']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: Maybe<Scalars['Float']['output']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "building" */
export type building_avg_order_by = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<order_by>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<order_by>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "building". All fields are combined with a logical 'AND'. */
export type building_bool_exp = {
  _and?: InputMaybe<Array<building_bool_exp>>;
  _not?: InputMaybe<building_bool_exp>;
  _or?: InputMaybe<Array<building_bool_exp>>;
  action_plans?: InputMaybe<action_plan_bool_exp>;
  active_action_plans?: InputMaybe<active_action_plans_bool_exp>;
  active_building_model?: InputMaybe<building_model_bool_exp>;
  active_building_model_id?: InputMaybe<Int_comparison_exp>;
  address?: InputMaybe<address_bool_exp>;
  address_id?: InputMaybe<Int_comparison_exp>;
  areas?: InputMaybe<area_bool_exp>;
  areas_aggregate?: InputMaybe<area_aggregate_bool_exp>;
  building_models?: InputMaybe<building_model_bool_exp>;
  building_state_id?: InputMaybe<building_state_enum_comparison_exp>;
  building_valuations?: InputMaybe<building_valuation_bool_exp>;
  certificates?: InputMaybe<certificate_bool_exp>;
  certificates_aggregate?: InputMaybe<certificate_aggregate_bool_exp>;
  climate_risks?: InputMaybe<climate_risk_bool_exp>;
  climate_risks_aggregate?: InputMaybe<climate_risk_aggregate_bool_exp>;
  climate_risks_v2?: InputMaybe<climate_risk_v2_bool_exp>;
  climate_risks_v2_aggregate?: InputMaybe<climate_risk_v2_aggregate_bool_exp>;
  consumption_drafts?: InputMaybe<consumption_draft_bool_exp>;
  consumption_drafts_aggregate?: InputMaybe<consumption_draft_aggregate_bool_exp>;
  consumptions?: InputMaybe<consumption_bool_exp>;
  consumptions_aggregate?: InputMaybe<consumption_aggregate_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  custom_data?: InputMaybe<jsonb_comparison_exp>;
  customer_external_identifier?: InputMaybe<String_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  district_heating_availability_status?: InputMaybe<building_with_district_heating_status_bool_exp>;
  economic_unit?: InputMaybe<economic_unit_bool_exp>;
  economic_unit_id?: InputMaybe<Int_comparison_exp>;
  energy_certificates?: InputMaybe<energy_certificate_bool_exp>;
  folder?: InputMaybe<folder_bool_exp>;
  has_write_permission?: InputMaybe<Boolean_comparison_exp>;
  heritage_district?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  is_missing_energy_data?: InputMaybe<Boolean_comparison_exp>;
  is_new_construction?: InputMaybe<Boolean_comparison_exp>;
  leasehold?: InputMaybe<Boolean_comparison_exp>;
  milieu_protection?: InputMaybe<Boolean_comparison_exp>;
  monument_protection?: InputMaybe<Boolean_comparison_exp>;
  report_buildings?: InputMaybe<report_building_bool_exp>;
  report_buildings_aggregate?: InputMaybe<report_building_aggregate_bool_exp>;
  responsible_user?: InputMaybe<user_bool_exp>;
  responsible_user_id?: InputMaybe<Int_comparison_exp>;
  state?: InputMaybe<entity_state_type_enum_comparison_exp>;
  subsidies?: InputMaybe<building_subsidy_bool_exp>;
  subsidies_updated_at?: InputMaybe<timestamptz_comparison_exp>;
  units?: InputMaybe<Int_comparison_exp>;
  units_data_source?: InputMaybe<data_source_type_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_building_permissions?: InputMaybe<user_building_permission_bool_exp>;
  user_permissions?: InputMaybe<building_permissions_bool_exp>;
  year_constructed?: InputMaybe<Int_comparison_exp>;
  year_data_source?: InputMaybe<data_source_type_enum_comparison_exp>;
};

/** Records whether and when district heating becomes available at a building location. */
export type building_district_heating_availability = {
  /** Year when district heating is or will be available at the building location. */
  availability_year?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  building: building;
  /** The building. */
  building_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "building_district_heating_availability". All fields are combined with a logical 'AND'. */
export type building_district_heating_availability_bool_exp = {
  _and?: InputMaybe<Array<building_district_heating_availability_bool_exp>>;
  _not?: InputMaybe<building_district_heating_availability_bool_exp>;
  _or?: InputMaybe<Array<building_district_heating_availability_bool_exp>>;
  availability_year?: InputMaybe<Int_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "building_district_heating_availability" */
export enum building_district_heating_availability_constraint {
  /** unique or primary key constraint on columns "building_id" */
  building_district_heating_availability_pkey = 'building_district_heating_availability_pkey',
}

/** input type for incrementing numeric columns in table "building_district_heating_availability" */
export type building_district_heating_availability_inc_input = {
  /** Year when district heating is or will be available at the building location. */
  availability_year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "building_district_heating_availability" */
export type building_district_heating_availability_insert_input = {
  /** Year when district heating is or will be available at the building location. */
  availability_year?: InputMaybe<Scalars['Int']['input']>;
  /** The building. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
};

/** response of any mutation on the table "building_district_heating_availability" */
export type building_district_heating_availability_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<building_district_heating_availability>;
};

/** on_conflict condition type for table "building_district_heating_availability" */
export type building_district_heating_availability_on_conflict = {
  constraint: building_district_heating_availability_constraint;
  update_columns?: Array<building_district_heating_availability_update_column>;
  where?: InputMaybe<building_district_heating_availability_bool_exp>;
};

/** Ordering options when selecting data from "building_district_heating_availability". */
export type building_district_heating_availability_order_by = {
  availability_year?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** primary key columns input for table: building_district_heating_availability */
export type building_district_heating_availability_pk_columns_input = {
  /** The building. */
  building_id: Scalars['Int']['input'];
};

/** select columns of table "building_district_heating_availability" */
export enum building_district_heating_availability_select_column {
  /** column name */
  availability_year = 'availability_year',
  /** column name */
  building_id = 'building_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  updated_at = 'updated_at',
}

/** input type for updating data in table "building_district_heating_availability" */
export type building_district_heating_availability_set_input = {
  /** Year when district heating is or will be available at the building location. */
  availability_year?: InputMaybe<Scalars['Int']['input']>;
};

/** Streaming cursor of the table "building_district_heating_availability" */
export type building_district_heating_availability_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: building_district_heating_availability_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type building_district_heating_availability_stream_cursor_value_input = {
  /** Year when district heating is or will be available at the building location. */
  availability_year?: InputMaybe<Scalars['Int']['input']>;
  /** The building. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "building_district_heating_availability" */
export enum building_district_heating_availability_update_column {
  /** column name */
  availability_year = 'availability_year',
}

export type building_district_heating_availability_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<building_district_heating_availability_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<building_district_heating_availability_set_input>;
  /** filter the rows which have to be updated */
  where: building_district_heating_availability_bool_exp;
};

/** A building that is being set up but has not yet been finalized. Contains preliminary data collected during the building creation wizard. */
export type building_draft = {
  assign_responsible_user_as_transaction_manager?: Maybe<Scalars['Boolean']['output']>;
  /** GML IDs linking to the 3D model in the CityGML/3DCityDB database. */
  building_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** An array relationship */
  building_draft_areas: Array<building_draft_area>;
  /** An array relationship */
  building_draft_consumers: Array<building_draft_consumer>;
  /** An array relationship */
  building_draft_valuations: Array<building_draft_valuation>;
  /** IDs linking to the LOD1 block model representation. */
  building_lod1_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** Intended lifecycle state for the building once created. References building_state. */
  building_state_id?: Maybe<building_state_enum>;
  /** An array relationship */
  certificates: Array<certificate>;
  /** An aggregate relationship */
  certificates_aggregate: certificate_aggregate;
  city: Scalars['String']['output'];
  /** Country where the drafted building is located. */
  country_id: country_enum;
  created_at: Scalars['timestamptz']['output'];
  /** JSON object holding customer-defined custom fields. */
  custom_data: Scalars['jsonb']['output'];
  /** An object relationship */
  economic_unit?: Maybe<economic_unit>;
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  energy_certificate_drafts: Array<energy_certificate_draft>;
  /** An aggregate relationship */
  energy_certificate_drafts_aggregate: energy_certificate_draft_aggregate;
  /** An array relationship */
  energy_certificates: Array<energy_certificate>;
  /** External identifier assigned by the customer for cross-system referencing. */
  external_id?: Maybe<Scalars['String']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Int']['output']>;
  /** Whether the building is located in a designated heritage district. */
  heritage_district: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['numeric']['output']>;
  /** Whether the building is on leasehold land (Erbbaurecht). */
  leasehold: Scalars['Boolean']['output'];
  longitude?: Maybe<Scalars['numeric']['output']>;
  /** Mapbox feature IDs selected during building placement on the map. */
  mapbox_building_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the building is in a milieu protection zone (Milieuschutzgebiet). */
  milieu_protection: Scalars['Boolean']['output'];
  /** Whether the building is under monument/heritage protection. */
  monument_protection: Scalars['Boolean']['output'];
  /** GML IDs of neighboring buildings in the 3DCityDB for contextual rendering. */
  neighbor_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs of neighboring buildings in the LOD1 database. */
  neighbor_lod1_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** An object relationship */
  portfolio: portfolio;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id: Scalars['Int']['output'];
  postal_code: Scalars['String']['output'];
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  street: Scalars['String']['output'];
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<user>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
};

/** A building that is being set up but has not yet been finalized. Contains preliminary data collected during the building creation wizard. */
export type building_draftbuilding_draft_areasArgs = {
  distinct_on?: InputMaybe<Array<building_draft_area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_area_order_by>>;
  where?: InputMaybe<building_draft_area_bool_exp>;
};

/** A building that is being set up but has not yet been finalized. Contains preliminary data collected during the building creation wizard. */
export type building_draftbuilding_draft_consumersArgs = {
  distinct_on?: InputMaybe<Array<building_draft_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_consumer_order_by>>;
  where?: InputMaybe<building_draft_consumer_bool_exp>;
};

/** A building that is being set up but has not yet been finalized. Contains preliminary data collected during the building creation wizard. */
export type building_draftbuilding_draft_valuationsArgs = {
  distinct_on?: InputMaybe<Array<building_draft_valuation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_valuation_order_by>>;
  where?: InputMaybe<building_draft_valuation_bool_exp>;
};

/** A building that is being set up but has not yet been finalized. Contains preliminary data collected during the building creation wizard. */
export type building_draftcertificatesArgs = {
  distinct_on?: InputMaybe<Array<certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<certificate_order_by>>;
  where?: InputMaybe<certificate_bool_exp>;
};

/** A building that is being set up but has not yet been finalized. Contains preliminary data collected during the building creation wizard. */
export type building_draftcertificates_aggregateArgs = {
  distinct_on?: InputMaybe<Array<certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<certificate_order_by>>;
  where?: InputMaybe<certificate_bool_exp>;
};

/** A building that is being set up but has not yet been finalized. Contains preliminary data collected during the building creation wizard. */
export type building_draftcustom_dataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A building that is being set up but has not yet been finalized. Contains preliminary data collected during the building creation wizard. */
export type building_draftenergy_certificate_draftsArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_draft_order_by>>;
  where?: InputMaybe<energy_certificate_draft_bool_exp>;
};

/** A building that is being set up but has not yet been finalized. Contains preliminary data collected during the building creation wizard. */
export type building_draftenergy_certificate_drafts_aggregateArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_draft_order_by>>;
  where?: InputMaybe<energy_certificate_draft_bool_exp>;
};

/** A building that is being set up but has not yet been finalized. Contains preliminary data collected during the building creation wizard. */
export type building_draftenergy_certificatesArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_order_by>>;
  where?: InputMaybe<energy_certificate_bool_exp>;
};

/** aggregated selection of "building_draft" */
export type building_draft_aggregate = {
  aggregate?: Maybe<building_draft_aggregate_fields>;
  nodes: Array<building_draft>;
};

export type building_draft_aggregate_bool_exp = {
  bool_and?: InputMaybe<building_draft_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<building_draft_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<building_draft_aggregate_bool_exp_count>;
};

export type building_draft_aggregate_bool_exp_bool_and = {
  arguments: building_draft_select_column_building_draft_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<building_draft_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type building_draft_aggregate_bool_exp_bool_or = {
  arguments: building_draft_select_column_building_draft_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<building_draft_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type building_draft_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<building_draft_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<building_draft_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "building_draft" */
export type building_draft_aggregate_fields = {
  avg?: Maybe<building_draft_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<building_draft_max_fields>;
  min?: Maybe<building_draft_min_fields>;
  stddev?: Maybe<building_draft_stddev_fields>;
  stddev_pop?: Maybe<building_draft_stddev_pop_fields>;
  stddev_samp?: Maybe<building_draft_stddev_samp_fields>;
  sum?: Maybe<building_draft_sum_fields>;
  var_pop?: Maybe<building_draft_var_pop_fields>;
  var_samp?: Maybe<building_draft_var_samp_fields>;
  variance?: Maybe<building_draft_variance_fields>;
};

/** aggregate fields of "building_draft" */
export type building_draft_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<building_draft_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "building_draft" */
export type building_draft_aggregate_order_by = {
  avg?: InputMaybe<building_draft_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<building_draft_max_order_by>;
  min?: InputMaybe<building_draft_min_order_by>;
  stddev?: InputMaybe<building_draft_stddev_order_by>;
  stddev_pop?: InputMaybe<building_draft_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<building_draft_stddev_samp_order_by>;
  sum?: InputMaybe<building_draft_sum_order_by>;
  var_pop?: InputMaybe<building_draft_var_pop_order_by>;
  var_samp?: InputMaybe<building_draft_var_samp_order_by>;
  variance?: InputMaybe<building_draft_variance_order_by>;
};

/** Area/usage zone defined during building creation, specifying the type of use and floor area before the building is finalized. */
export type building_draft_area = {
  /** The measurement standard for this area (e.g. net floor area, gross floor area). */
  area_type_id: area_type_enum;
  /** An object relationship */
  building_draft: building_draft;
  /** An array relationship */
  building_draft_consumers: Array<building_draft_consumer>;
  /** The building draft this area belongs to. */
  building_draft_id: Scalars['Int']['output'];
  /** An object relationship */
  energy_certificate?: Maybe<energy_certificate>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: Maybe<Scalars['Int']['output']>;
  energy_rating_score?: Maybe<Scalars['numeric']['output']>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: Maybe<Scalars['Int']['output']>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['Int']['output'];
  /** Optional display name for this area zone. */
  name: Scalars['String']['output'];
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: Maybe<Scalars['numeric']['output']>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: Maybe<Scalars['numeric']['output']>;
  /** The usage category for this area (e.g. residential, office, retail). */
  type_of_use_id?: Maybe<type_of_use_enum>;
  /** The floor area size in square meters. */
  value?: Maybe<Scalars['float8']['output']>;
};

/** Area/usage zone defined during building creation, specifying the type of use and floor area before the building is finalized. */
export type building_draft_areabuilding_draft_consumersArgs = {
  distinct_on?: InputMaybe<Array<building_draft_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_consumer_order_by>>;
  where?: InputMaybe<building_draft_consumer_bool_exp>;
};

/** order by aggregate values of table "building_draft_area" */
export type building_draft_area_aggregate_order_by = {
  avg?: InputMaybe<building_draft_area_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<building_draft_area_max_order_by>;
  min?: InputMaybe<building_draft_area_min_order_by>;
  stddev?: InputMaybe<building_draft_area_stddev_order_by>;
  stddev_pop?: InputMaybe<building_draft_area_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<building_draft_area_stddev_samp_order_by>;
  sum?: InputMaybe<building_draft_area_sum_order_by>;
  var_pop?: InputMaybe<building_draft_area_var_pop_order_by>;
  var_samp?: InputMaybe<building_draft_area_var_samp_order_by>;
  variance?: InputMaybe<building_draft_area_variance_order_by>;
};

/** input type for inserting array relation for remote table "building_draft_area" */
export type building_draft_area_arr_rel_insert_input = {
  data: Array<building_draft_area_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<building_draft_area_on_conflict>;
};

/** order by avg() on columns of table "building_draft_area" */
export type building_draft_area_avg_order_by = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<order_by>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** The floor area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "building_draft_area". All fields are combined with a logical 'AND'. */
export type building_draft_area_bool_exp = {
  _and?: InputMaybe<Array<building_draft_area_bool_exp>>;
  _not?: InputMaybe<building_draft_area_bool_exp>;
  _or?: InputMaybe<Array<building_draft_area_bool_exp>>;
  area_type_id?: InputMaybe<area_type_enum_comparison_exp>;
  building_draft?: InputMaybe<building_draft_bool_exp>;
  building_draft_consumers?: InputMaybe<building_draft_consumer_bool_exp>;
  building_draft_id?: InputMaybe<Int_comparison_exp>;
  energy_certificate?: InputMaybe<energy_certificate_bool_exp>;
  energy_certificate_id?: InputMaybe<Int_comparison_exp>;
  energy_rating_score?: InputMaybe<numeric_comparison_exp>;
  enev_year?: InputMaybe<Int_comparison_exp>;
  geg_reference_value?: InputMaybe<numeric_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  reference_value_electricity?: InputMaybe<numeric_comparison_exp>;
  reference_value_heating_hot_water?: InputMaybe<numeric_comparison_exp>;
  type_of_use_id?: InputMaybe<type_of_use_enum_comparison_exp>;
  value?: InputMaybe<float8_comparison_exp>;
};

/** unique or primary key constraints on table "building_draft_area" */
export enum building_draft_area_constraint {
  /** unique or primary key constraint on columns "id" */
  building_draft_area_pkey = 'building_draft_area_pkey',
}

/** input type for incrementing numeric columns in table "building_draft_area" */
export type building_draft_area_inc_input = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  energy_rating_score?: InputMaybe<Scalars['numeric']['input']>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<Scalars['Int']['input']>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<Scalars['numeric']['input']>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<Scalars['numeric']['input']>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<Scalars['numeric']['input']>;
  /** The floor area size in square meters. */
  value?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "building_draft_area" */
export type building_draft_area_insert_input = {
  building_draft?: InputMaybe<building_draft_obj_rel_insert_input>;
  building_draft_consumers?: InputMaybe<building_draft_consumer_arr_rel_insert_input>;
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  energy_rating_score?: InputMaybe<Scalars['numeric']['input']>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<Scalars['Int']['input']>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<Scalars['numeric']['input']>;
  /** Optional display name for this area zone. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<Scalars['numeric']['input']>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<Scalars['numeric']['input']>;
  /** The usage category for this area (e.g. residential, office, retail). */
  type_of_use_id?: InputMaybe<type_of_use_enum>;
  /** The floor area size in square meters. */
  value?: InputMaybe<Scalars['float8']['input']>;
};

/** order by max() on columns of table "building_draft_area" */
export type building_draft_area_max_order_by = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<order_by>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Optional display name for this area zone. */
  name?: InputMaybe<order_by>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** The floor area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** order by min() on columns of table "building_draft_area" */
export type building_draft_area_min_order_by = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<order_by>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Optional display name for this area zone. */
  name?: InputMaybe<order_by>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** The floor area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** response of any mutation on the table "building_draft_area" */
export type building_draft_area_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<building_draft_area>;
};

/** on_conflict condition type for table "building_draft_area" */
export type building_draft_area_on_conflict = {
  constraint: building_draft_area_constraint;
  update_columns?: Array<building_draft_area_update_column>;
  where?: InputMaybe<building_draft_area_bool_exp>;
};

/** Ordering options when selecting data from "building_draft_area". */
export type building_draft_area_order_by = {
  area_type_id?: InputMaybe<order_by>;
  building_draft?: InputMaybe<building_draft_order_by>;
  building_draft_consumers_aggregate?: InputMaybe<building_draft_consumer_aggregate_order_by>;
  building_draft_id?: InputMaybe<order_by>;
  energy_certificate?: InputMaybe<energy_certificate_order_by>;
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  type_of_use_id?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** primary key columns input for table: building_draft_area */
export type building_draft_area_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "building_draft_area" */
export enum building_draft_area_select_column {
  /** column name */
  area_type_id = 'area_type_id',
  /** column name */
  building_draft_id = 'building_draft_id',
  /** column name */
  energy_certificate_id = 'energy_certificate_id',
  /** column name */
  energy_rating_score = 'energy_rating_score',
  /** column name */
  enev_year = 'enev_year',
  /** column name */
  geg_reference_value = 'geg_reference_value',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  reference_value_electricity = 'reference_value_electricity',
  /** column name */
  reference_value_heating_hot_water = 'reference_value_heating_hot_water',
  /** column name */
  type_of_use_id = 'type_of_use_id',
  /** column name */
  value = 'value',
}

/** input type for updating data in table "building_draft_area" */
export type building_draft_area_set_input = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  energy_rating_score?: InputMaybe<Scalars['numeric']['input']>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<Scalars['Int']['input']>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<Scalars['numeric']['input']>;
  /** Optional display name for this area zone. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<Scalars['numeric']['input']>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<Scalars['numeric']['input']>;
  /** The usage category for this area (e.g. residential, office, retail). */
  type_of_use_id?: InputMaybe<type_of_use_enum>;
  /** The floor area size in square meters. */
  value?: InputMaybe<Scalars['float8']['input']>;
};

/** order by stddev() on columns of table "building_draft_area" */
export type building_draft_area_stddev_order_by = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<order_by>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** The floor area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "building_draft_area" */
export type building_draft_area_stddev_pop_order_by = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<order_by>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** The floor area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "building_draft_area" */
export type building_draft_area_stddev_samp_order_by = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<order_by>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** The floor area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "building_draft_area" */
export type building_draft_area_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: building_draft_area_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type building_draft_area_stream_cursor_value_input = {
  /** The measurement standard for this area (e.g. net floor area, gross floor area). */
  area_type_id?: InputMaybe<area_type_enum>;
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  energy_rating_score?: InputMaybe<Scalars['numeric']['input']>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<Scalars['Int']['input']>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Optional display name for this area zone. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<Scalars['numeric']['input']>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<Scalars['numeric']['input']>;
  /** The usage category for this area (e.g. residential, office, retail). */
  type_of_use_id?: InputMaybe<type_of_use_enum>;
  /** The floor area size in square meters. */
  value?: InputMaybe<Scalars['float8']['input']>;
};

/** order by sum() on columns of table "building_draft_area" */
export type building_draft_area_sum_order_by = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<order_by>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** The floor area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** update columns of table "building_draft_area" */
export enum building_draft_area_update_column {
  /** column name */
  building_draft_id = 'building_draft_id',
  /** column name */
  energy_certificate_id = 'energy_certificate_id',
  /** column name */
  energy_rating_score = 'energy_rating_score',
  /** column name */
  enev_year = 'enev_year',
  /** column name */
  geg_reference_value = 'geg_reference_value',
  /** column name */
  name = 'name',
  /** column name */
  reference_value_electricity = 'reference_value_electricity',
  /** column name */
  reference_value_heating_hot_water = 'reference_value_heating_hot_water',
  /** column name */
  type_of_use_id = 'type_of_use_id',
  /** column name */
  value = 'value',
}

export type building_draft_area_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<building_draft_area_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<building_draft_area_set_input>;
  /** filter the rows which have to be updated */
  where: building_draft_area_bool_exp;
};

/** order by var_pop() on columns of table "building_draft_area" */
export type building_draft_area_var_pop_order_by = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<order_by>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** The floor area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "building_draft_area" */
export type building_draft_area_var_samp_order_by = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<order_by>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** The floor area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "building_draft_area" */
export type building_draft_area_variance_order_by = {
  /** The building draft this area belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Energy certificate associated with this area, if one was uploaded during drafting. */
  energy_certificate_id?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** The EnEV (German Energy Saving Ordinance) reference year used for benchmark values. */
  enev_year?: InputMaybe<order_by>;
  /** Reference energy value from the German Building Energy Act (GEG) for this usage type. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Benchmark electricity consumption in kWh/m2a for this usage type. */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Benchmark energy consumption for heating and hot water in kWh/m2a for this usage type. */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** The floor area size in square meters. */
  value?: InputMaybe<order_by>;
};

/** input type for inserting array relation for remote table "building_draft" */
export type building_draft_arr_rel_insert_input = {
  data: Array<building_draft_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<building_draft_on_conflict>;
};

/** aggregate avg on columns */
export type building_draft_avg_fields = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "building_draft" */
export type building_draft_avg_order_by = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<order_by>;
  /** Number of floors in the building. */
  floors?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<order_by>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "building_draft". All fields are combined with a logical 'AND'. */
export type building_draft_bool_exp = {
  _and?: InputMaybe<Array<building_draft_bool_exp>>;
  _not?: InputMaybe<building_draft_bool_exp>;
  _or?: InputMaybe<Array<building_draft_bool_exp>>;
  assign_responsible_user_as_transaction_manager?: InputMaybe<Boolean_comparison_exp>;
  building_citydb_gml_ids?: InputMaybe<String_array_comparison_exp>;
  building_draft_areas?: InputMaybe<building_draft_area_bool_exp>;
  building_draft_consumers?: InputMaybe<building_draft_consumer_bool_exp>;
  building_draft_valuations?: InputMaybe<building_draft_valuation_bool_exp>;
  building_lod1_ids?: InputMaybe<String_array_comparison_exp>;
  building_state_id?: InputMaybe<building_state_enum_comparison_exp>;
  certificates?: InputMaybe<certificate_bool_exp>;
  certificates_aggregate?: InputMaybe<certificate_aggregate_bool_exp>;
  city?: InputMaybe<String_comparison_exp>;
  country_id?: InputMaybe<country_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  custom_data?: InputMaybe<jsonb_comparison_exp>;
  economic_unit?: InputMaybe<economic_unit_bool_exp>;
  economic_unit_id?: InputMaybe<Int_comparison_exp>;
  energy_certificate_drafts?: InputMaybe<energy_certificate_draft_bool_exp>;
  energy_certificate_drafts_aggregate?: InputMaybe<energy_certificate_draft_aggregate_bool_exp>;
  energy_certificates?: InputMaybe<energy_certificate_bool_exp>;
  external_id?: InputMaybe<String_comparison_exp>;
  floors?: InputMaybe<Int_comparison_exp>;
  heritage_district?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  latitude?: InputMaybe<numeric_comparison_exp>;
  leasehold?: InputMaybe<Boolean_comparison_exp>;
  longitude?: InputMaybe<numeric_comparison_exp>;
  mapbox_building_ids?: InputMaybe<String_array_comparison_exp>;
  milieu_protection?: InputMaybe<Boolean_comparison_exp>;
  monument_protection?: InputMaybe<Boolean_comparison_exp>;
  neighbor_citydb_gml_ids?: InputMaybe<String_array_comparison_exp>;
  neighbor_lod1_ids?: InputMaybe<String_array_comparison_exp>;
  portfolio?: InputMaybe<portfolio_bool_exp>;
  portfolio_id?: InputMaybe<Int_comparison_exp>;
  postal_code?: InputMaybe<String_comparison_exp>;
  responsible_user_id?: InputMaybe<Int_comparison_exp>;
  street?: InputMaybe<String_comparison_exp>;
  units?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  year_constructed?: InputMaybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "building_draft" */
export enum building_draft_constraint {
  /** unique or primary key constraint on columns "id" */
  building_draft_pkey = 'building_draft_pkey',
}

/** Energy consumer entry for a building draft, representing a specific energy system and source combination during building import. */
export type building_draft_consumer = {
  /** An object relationship */
  building_draft: building_draft;
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: Maybe<Scalars['Int']['output']>;
  /** The building draft this consumer belongs to. */
  building_draft_id: Scalars['Int']['output'];
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: Maybe<Scalars['Float']['output']>;
  /** Energy source (e.g., natural gas, electricity, district heating). */
  energy_source_type_id?: Maybe<energy_source_type_enum>;
  /** Type of energy system (e.g., boiler, heat pump, CHP). */
  energy_system_type_id: energy_system_type_enum;
  id: Scalars['Int']['output'];
};

/** order by aggregate values of table "building_draft_consumer" */
export type building_draft_consumer_aggregate_order_by = {
  avg?: InputMaybe<building_draft_consumer_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<building_draft_consumer_max_order_by>;
  min?: InputMaybe<building_draft_consumer_min_order_by>;
  stddev?: InputMaybe<building_draft_consumer_stddev_order_by>;
  stddev_pop?: InputMaybe<building_draft_consumer_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<building_draft_consumer_stddev_samp_order_by>;
  sum?: InputMaybe<building_draft_consumer_sum_order_by>;
  var_pop?: InputMaybe<building_draft_consumer_var_pop_order_by>;
  var_samp?: InputMaybe<building_draft_consumer_var_samp_order_by>;
  variance?: InputMaybe<building_draft_consumer_variance_order_by>;
};

/** input type for inserting array relation for remote table "building_draft_consumer" */
export type building_draft_consumer_arr_rel_insert_input = {
  data: Array<building_draft_consumer_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<building_draft_consumer_on_conflict>;
};

/** order by avg() on columns of table "building_draft_consumer" */
export type building_draft_consumer_avg_order_by = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<order_by>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "building_draft_consumer". All fields are combined with a logical 'AND'. */
export type building_draft_consumer_bool_exp = {
  _and?: InputMaybe<Array<building_draft_consumer_bool_exp>>;
  _not?: InputMaybe<building_draft_consumer_bool_exp>;
  _or?: InputMaybe<Array<building_draft_consumer_bool_exp>>;
  building_draft?: InputMaybe<building_draft_bool_exp>;
  building_draft_area_id?: InputMaybe<Int_comparison_exp>;
  building_draft_id?: InputMaybe<Int_comparison_exp>;
  energy_final?: InputMaybe<Float_comparison_exp>;
  energy_source_type_id?: InputMaybe<energy_source_type_enum_comparison_exp>;
  energy_system_type_id?: InputMaybe<energy_system_type_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "building_draft_consumer" */
export enum building_draft_consumer_constraint {
  /** unique or primary key constraint on columns "id" */
  building_draft_consumer_pkey = 'building_draft_consumer_pkey',
}

/** input type for incrementing numeric columns in table "building_draft_consumer" */
export type building_draft_consumer_inc_input = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<Scalars['Int']['input']>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "building_draft_consumer" */
export type building_draft_consumer_insert_input = {
  building_draft?: InputMaybe<building_draft_obj_rel_insert_input>;
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<Scalars['Int']['input']>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<Scalars['Float']['input']>;
  /** Energy source (e.g., natural gas, electricity, district heating). */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  /** Type of energy system (e.g., boiler, heat pump, CHP). */
  energy_system_type_id?: InputMaybe<energy_system_type_enum>;
};

/** order by max() on columns of table "building_draft_consumer" */
export type building_draft_consumer_max_order_by = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<order_by>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "building_draft_consumer" */
export type building_draft_consumer_min_order_by = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<order_by>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** response of any mutation on the table "building_draft_consumer" */
export type building_draft_consumer_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<building_draft_consumer>;
};

/** on_conflict condition type for table "building_draft_consumer" */
export type building_draft_consumer_on_conflict = {
  constraint: building_draft_consumer_constraint;
  update_columns?: Array<building_draft_consumer_update_column>;
  where?: InputMaybe<building_draft_consumer_bool_exp>;
};

/** Ordering options when selecting data from "building_draft_consumer". */
export type building_draft_consumer_order_by = {
  building_draft?: InputMaybe<building_draft_order_by>;
  building_draft_area_id?: InputMaybe<order_by>;
  building_draft_id?: InputMaybe<order_by>;
  energy_final?: InputMaybe<order_by>;
  energy_source_type_id?: InputMaybe<order_by>;
  energy_system_type_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** primary key columns input for table: building_draft_consumer */
export type building_draft_consumer_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "building_draft_consumer" */
export enum building_draft_consumer_select_column {
  /** column name */
  building_draft_area_id = 'building_draft_area_id',
  /** column name */
  building_draft_id = 'building_draft_id',
  /** column name */
  energy_final = 'energy_final',
  /** column name */
  energy_source_type_id = 'energy_source_type_id',
  /** column name */
  energy_system_type_id = 'energy_system_type_id',
  /** column name */
  id = 'id',
}

/** input type for updating data in table "building_draft_consumer" */
export type building_draft_consumer_set_input = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<Scalars['Int']['input']>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<Scalars['Float']['input']>;
  /** Energy source (e.g., natural gas, electricity, district heating). */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  /** Type of energy system (e.g., boiler, heat pump, CHP). */
  energy_system_type_id?: InputMaybe<energy_system_type_enum>;
};

/** order by stddev() on columns of table "building_draft_consumer" */
export type building_draft_consumer_stddev_order_by = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<order_by>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "building_draft_consumer" */
export type building_draft_consumer_stddev_pop_order_by = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<order_by>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "building_draft_consumer" */
export type building_draft_consumer_stddev_samp_order_by = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<order_by>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "building_draft_consumer" */
export type building_draft_consumer_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: building_draft_consumer_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type building_draft_consumer_stream_cursor_value_input = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<Scalars['Int']['input']>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<Scalars['Float']['input']>;
  /** Energy source (e.g., natural gas, electricity, district heating). */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  /** Type of energy system (e.g., boiler, heat pump, CHP). */
  energy_system_type_id?: InputMaybe<energy_system_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "building_draft_consumer" */
export type building_draft_consumer_sum_order_by = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<order_by>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** update columns of table "building_draft_consumer" */
export enum building_draft_consumer_update_column {
  /** column name */
  building_draft_area_id = 'building_draft_area_id',
  /** column name */
  building_draft_id = 'building_draft_id',
  /** column name */
  energy_final = 'energy_final',
  /** column name */
  energy_source_type_id = 'energy_source_type_id',
  /** column name */
  energy_system_type_id = 'energy_system_type_id',
}

export type building_draft_consumer_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<building_draft_consumer_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<building_draft_consumer_set_input>;
  /** filter the rows which have to be updated */
  where: building_draft_consumer_bool_exp;
};

/** order by var_pop() on columns of table "building_draft_consumer" */
export type building_draft_consumer_var_pop_order_by = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<order_by>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "building_draft_consumer" */
export type building_draft_consumer_var_samp_order_by = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<order_by>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "building_draft_consumer" */
export type building_draft_consumer_variance_order_by = {
  /** Optional area within the draft building this consumer is allocated to. */
  building_draft_area_id?: InputMaybe<order_by>;
  /** The building draft this consumer belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/a for this consumer. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** input type for incrementing numeric columns in table "building_draft" */
export type building_draft_inc_input = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<Scalars['Int']['input']>;
  /** Number of floors in the building. */
  floors?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<Scalars['Int']['input']>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "building_draft" */
export type building_draft_insert_input = {
  assign_responsible_user_as_transaction_manager?: InputMaybe<Scalars['Boolean']['input']>;
  /** GML IDs linking to the 3D model in the CityGML/3DCityDB database. */
  building_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  building_draft_areas?: InputMaybe<building_draft_area_arr_rel_insert_input>;
  building_draft_consumers?: InputMaybe<building_draft_consumer_arr_rel_insert_input>;
  building_draft_valuations?: InputMaybe<building_draft_valuation_arr_rel_insert_input>;
  /** IDs linking to the LOD1 block model representation. */
  building_lod1_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Intended lifecycle state for the building once created. References building_state. */
  building_state_id?: InputMaybe<building_state_enum>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country where the drafted building is located. */
  country_id?: InputMaybe<country_enum>;
  economic_unit?: InputMaybe<economic_unit_obj_rel_insert_input>;
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<Scalars['Int']['input']>;
  /** External identifier assigned by the customer for cross-system referencing. */
  external_id?: InputMaybe<Scalars['String']['input']>;
  /** Number of floors in the building. */
  floors?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the building is located in a designated heritage district. */
  heritage_district?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  /** Whether the building is on leasehold land (Erbbaurecht). */
  leasehold?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  /** Mapbox feature IDs selected during building placement on the map. */
  mapbox_building_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the building is in a milieu protection zone (Milieuschutzgebiet). */
  milieu_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the building is under monument/heritage protection. */
  monument_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** GML IDs of neighboring buildings in the 3DCityDB for contextual rendering. */
  neighbor_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of neighboring buildings in the LOD1 database. */
  neighbor_lod1_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<Scalars['Int']['input']>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type building_draft_max_fields = {
  /** GML IDs linking to the 3D model in the CityGML/3DCityDB database. */
  building_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs linking to the LOD1 block model representation. */
  building_lod1_ids?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  /** External identifier assigned by the customer for cross-system referencing. */
  external_id?: Maybe<Scalars['String']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  /** Mapbox feature IDs selected during building placement on the map. */
  mapbox_building_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** GML IDs of neighboring buildings in the 3DCityDB for contextual rendering. */
  neighbor_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs of neighboring buildings in the LOD1 database. */
  neighbor_lod1_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "building_draft" */
export type building_draft_max_order_by = {
  /** GML IDs linking to the 3D model in the CityGML/3DCityDB database. */
  building_citydb_gml_ids?: InputMaybe<order_by>;
  /** IDs linking to the LOD1 block model representation. */
  building_lod1_ids?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<order_by>;
  /** External identifier assigned by the customer for cross-system referencing. */
  external_id?: InputMaybe<order_by>;
  /** Number of floors in the building. */
  floors?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  /** Mapbox feature IDs selected during building placement on the map. */
  mapbox_building_ids?: InputMaybe<order_by>;
  /** GML IDs of neighboring buildings in the 3DCityDB for contextual rendering. */
  neighbor_citydb_gml_ids?: InputMaybe<order_by>;
  /** IDs of neighboring buildings in the LOD1 database. */
  neighbor_lod1_ids?: InputMaybe<order_by>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<order_by>;
  postal_code?: InputMaybe<order_by>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type building_draft_min_fields = {
  /** GML IDs linking to the 3D model in the CityGML/3DCityDB database. */
  building_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs linking to the LOD1 block model representation. */
  building_lod1_ids?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  /** External identifier assigned by the customer for cross-system referencing. */
  external_id?: Maybe<Scalars['String']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  /** Mapbox feature IDs selected during building placement on the map. */
  mapbox_building_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** GML IDs of neighboring buildings in the 3DCityDB for contextual rendering. */
  neighbor_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs of neighboring buildings in the LOD1 database. */
  neighbor_lod1_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "building_draft" */
export type building_draft_min_order_by = {
  /** GML IDs linking to the 3D model in the CityGML/3DCityDB database. */
  building_citydb_gml_ids?: InputMaybe<order_by>;
  /** IDs linking to the LOD1 block model representation. */
  building_lod1_ids?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<order_by>;
  /** External identifier assigned by the customer for cross-system referencing. */
  external_id?: InputMaybe<order_by>;
  /** Number of floors in the building. */
  floors?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  /** Mapbox feature IDs selected during building placement on the map. */
  mapbox_building_ids?: InputMaybe<order_by>;
  /** GML IDs of neighboring buildings in the 3DCityDB for contextual rendering. */
  neighbor_citydb_gml_ids?: InputMaybe<order_by>;
  /** IDs of neighboring buildings in the LOD1 database. */
  neighbor_lod1_ids?: InputMaybe<order_by>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<order_by>;
  postal_code?: InputMaybe<order_by>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<order_by>;
};

/** response of any mutation on the table "building_draft" */
export type building_draft_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<building_draft>;
};

/** input type for inserting object relation for remote table "building_draft" */
export type building_draft_obj_rel_insert_input = {
  data: building_draft_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<building_draft_on_conflict>;
};

/** on_conflict condition type for table "building_draft" */
export type building_draft_on_conflict = {
  constraint: building_draft_constraint;
  update_columns?: Array<building_draft_update_column>;
  where?: InputMaybe<building_draft_bool_exp>;
};

/** Ordering options when selecting data from "building_draft". */
export type building_draft_order_by = {
  assign_responsible_user_as_transaction_manager?: InputMaybe<order_by>;
  building_citydb_gml_ids?: InputMaybe<order_by>;
  building_draft_areas_aggregate?: InputMaybe<building_draft_area_aggregate_order_by>;
  building_draft_consumers_aggregate?: InputMaybe<building_draft_consumer_aggregate_order_by>;
  building_draft_valuations_aggregate?: InputMaybe<building_draft_valuation_aggregate_order_by>;
  building_lod1_ids?: InputMaybe<order_by>;
  building_state_id?: InputMaybe<order_by>;
  certificates_aggregate?: InputMaybe<certificate_aggregate_order_by>;
  city?: InputMaybe<order_by>;
  country_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  custom_data?: InputMaybe<order_by>;
  economic_unit?: InputMaybe<economic_unit_order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_drafts_aggregate?: InputMaybe<energy_certificate_draft_aggregate_order_by>;
  energy_certificates_aggregate?: InputMaybe<energy_certificate_aggregate_order_by>;
  external_id?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  heritage_district?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  leasehold?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  mapbox_building_ids?: InputMaybe<order_by>;
  milieu_protection?: InputMaybe<order_by>;
  monument_protection?: InputMaybe<order_by>;
  neighbor_citydb_gml_ids?: InputMaybe<order_by>;
  neighbor_lod1_ids?: InputMaybe<order_by>;
  portfolio?: InputMaybe<portfolio_order_by>;
  portfolio_id?: InputMaybe<order_by>;
  postal_code?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  year_constructed?: InputMaybe<order_by>;
};

/** primary key columns input for table: building_draft */
export type building_draft_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "building_draft" */
export enum building_draft_select_column {
  /** column name */
  assign_responsible_user_as_transaction_manager = 'assign_responsible_user_as_transaction_manager',
  /** column name */
  building_citydb_gml_ids = 'building_citydb_gml_ids',
  /** column name */
  building_lod1_ids = 'building_lod1_ids',
  /** column name */
  building_state_id = 'building_state_id',
  /** column name */
  city = 'city',
  /** column name */
  country_id = 'country_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  custom_data = 'custom_data',
  /** column name */
  economic_unit_id = 'economic_unit_id',
  /** column name */
  external_id = 'external_id',
  /** column name */
  floors = 'floors',
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  id = 'id',
  /** column name */
  latitude = 'latitude',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  longitude = 'longitude',
  /** column name */
  mapbox_building_ids = 'mapbox_building_ids',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
  /** column name */
  neighbor_citydb_gml_ids = 'neighbor_citydb_gml_ids',
  /** column name */
  neighbor_lod1_ids = 'neighbor_lod1_ids',
  /** column name */
  portfolio_id = 'portfolio_id',
  /** column name */
  postal_code = 'postal_code',
  /** column name */
  responsible_user_id = 'responsible_user_id',
  /** column name */
  street = 'street',
  /** column name */
  units = 'units',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  year_constructed = 'year_constructed',
}

/** select "building_draft_aggregate_bool_exp_bool_and_arguments_columns" columns of table "building_draft" */
export enum building_draft_select_column_building_draft_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  assign_responsible_user_as_transaction_manager = 'assign_responsible_user_as_transaction_manager',
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
}

/** select "building_draft_aggregate_bool_exp_bool_or_arguments_columns" columns of table "building_draft" */
export enum building_draft_select_column_building_draft_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  assign_responsible_user_as_transaction_manager = 'assign_responsible_user_as_transaction_manager',
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
}

/** input type for updating data in table "building_draft" */
export type building_draft_set_input = {
  assign_responsible_user_as_transaction_manager?: InputMaybe<Scalars['Boolean']['input']>;
  /** GML IDs linking to the 3D model in the CityGML/3DCityDB database. */
  building_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs linking to the LOD1 block model representation. */
  building_lod1_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Intended lifecycle state for the building once created. References building_state. */
  building_state_id?: InputMaybe<building_state_enum>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country where the drafted building is located. */
  country_id?: InputMaybe<country_enum>;
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<Scalars['Int']['input']>;
  /** External identifier assigned by the customer for cross-system referencing. */
  external_id?: InputMaybe<Scalars['String']['input']>;
  /** Number of floors in the building. */
  floors?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the building is located in a designated heritage district. */
  heritage_district?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  /** Whether the building is on leasehold land (Erbbaurecht). */
  leasehold?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  /** Mapbox feature IDs selected during building placement on the map. */
  mapbox_building_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the building is in a milieu protection zone (Milieuschutzgebiet). */
  milieu_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the building is under monument/heritage protection. */
  monument_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** GML IDs of neighboring buildings in the 3DCityDB for contextual rendering. */
  neighbor_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of neighboring buildings in the LOD1 database. */
  neighbor_lod1_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<Scalars['Int']['input']>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type building_draft_stddev_fields = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "building_draft" */
export type building_draft_stddev_order_by = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<order_by>;
  /** Number of floors in the building. */
  floors?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<order_by>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type building_draft_stddev_pop_fields = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "building_draft" */
export type building_draft_stddev_pop_order_by = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<order_by>;
  /** Number of floors in the building. */
  floors?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<order_by>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type building_draft_stddev_samp_fields = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "building_draft" */
export type building_draft_stddev_samp_order_by = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<order_by>;
  /** Number of floors in the building. */
  floors?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<order_by>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "building_draft" */
export type building_draft_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: building_draft_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type building_draft_stream_cursor_value_input = {
  assign_responsible_user_as_transaction_manager?: InputMaybe<Scalars['Boolean']['input']>;
  /** GML IDs linking to the 3D model in the CityGML/3DCityDB database. */
  building_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs linking to the LOD1 block model representation. */
  building_lod1_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Intended lifecycle state for the building once created. References building_state. */
  building_state_id?: InputMaybe<building_state_enum>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country where the drafted building is located. */
  country_id?: InputMaybe<country_enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** JSON object holding customer-defined custom fields. */
  custom_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<Scalars['Int']['input']>;
  /** External identifier assigned by the customer for cross-system referencing. */
  external_id?: InputMaybe<Scalars['String']['input']>;
  /** Number of floors in the building. */
  floors?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the building is located in a designated heritage district. */
  heritage_district?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  /** Whether the building is on leasehold land (Erbbaurecht). */
  leasehold?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  /** Mapbox feature IDs selected during building placement on the map. */
  mapbox_building_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the building is in a milieu protection zone (Milieuschutzgebiet). */
  milieu_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the building is under monument/heritage protection. */
  monument_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** GML IDs of neighboring buildings in the 3DCityDB for contextual rendering. */
  neighbor_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of neighboring buildings in the LOD1 database. */
  neighbor_lod1_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type building_draft_sum_fields = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Int']['output']>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "building_draft" */
export type building_draft_sum_order_by = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<order_by>;
  /** Number of floors in the building. */
  floors?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<order_by>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<order_by>;
};

/** update columns of table "building_draft" */
export enum building_draft_update_column {
  /** column name */
  assign_responsible_user_as_transaction_manager = 'assign_responsible_user_as_transaction_manager',
  /** column name */
  building_citydb_gml_ids = 'building_citydb_gml_ids',
  /** column name */
  building_lod1_ids = 'building_lod1_ids',
  /** column name */
  building_state_id = 'building_state_id',
  /** column name */
  city = 'city',
  /** column name */
  country_id = 'country_id',
  /** column name */
  economic_unit_id = 'economic_unit_id',
  /** column name */
  external_id = 'external_id',
  /** column name */
  floors = 'floors',
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  latitude = 'latitude',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  longitude = 'longitude',
  /** column name */
  mapbox_building_ids = 'mapbox_building_ids',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
  /** column name */
  neighbor_citydb_gml_ids = 'neighbor_citydb_gml_ids',
  /** column name */
  neighbor_lod1_ids = 'neighbor_lod1_ids',
  /** column name */
  portfolio_id = 'portfolio_id',
  /** column name */
  postal_code = 'postal_code',
  /** column name */
  responsible_user_id = 'responsible_user_id',
  /** column name */
  street = 'street',
  /** column name */
  units = 'units',
  /** column name */
  year_constructed = 'year_constructed',
}

export type building_draft_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<building_draft_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<building_draft_set_input>;
  /** filter the rows which have to be updated */
  where: building_draft_bool_exp;
};

/** Draft version of a building valuation, used during building import or creation. */
export type building_draft_valuation = {
  /** An object relationship */
  building_draft?: Maybe<building_draft>;
  /** The building draft this valuation belongs to. */
  building_draft_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  energy_certificate_draft?: Maybe<energy_certificate_draft>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Date when the valuation was performed or is effective. */
  valuation_at: Scalars['timestamptz']['output'];
  /** Monetary valuation amount. */
  value: Scalars['numeric']['output'];
};

/** order by aggregate values of table "building_draft_valuation" */
export type building_draft_valuation_aggregate_order_by = {
  avg?: InputMaybe<building_draft_valuation_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<building_draft_valuation_max_order_by>;
  min?: InputMaybe<building_draft_valuation_min_order_by>;
  stddev?: InputMaybe<building_draft_valuation_stddev_order_by>;
  stddev_pop?: InputMaybe<building_draft_valuation_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<building_draft_valuation_stddev_samp_order_by>;
  sum?: InputMaybe<building_draft_valuation_sum_order_by>;
  var_pop?: InputMaybe<building_draft_valuation_var_pop_order_by>;
  var_samp?: InputMaybe<building_draft_valuation_var_samp_order_by>;
  variance?: InputMaybe<building_draft_valuation_variance_order_by>;
};

/** input type for inserting array relation for remote table "building_draft_valuation" */
export type building_draft_valuation_arr_rel_insert_input = {
  data: Array<building_draft_valuation_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<building_draft_valuation_on_conflict>;
};

/** order by avg() on columns of table "building_draft_valuation" */
export type building_draft_valuation_avg_order_by = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "building_draft_valuation". All fields are combined with a logical 'AND'. */
export type building_draft_valuation_bool_exp = {
  _and?: InputMaybe<Array<building_draft_valuation_bool_exp>>;
  _not?: InputMaybe<building_draft_valuation_bool_exp>;
  _or?: InputMaybe<Array<building_draft_valuation_bool_exp>>;
  building_draft?: InputMaybe<building_draft_bool_exp>;
  building_draft_id?: InputMaybe<Int_comparison_exp>;
  energy_certificate_draft?: InputMaybe<energy_certificate_draft_bool_exp>;
  energy_certificate_draft_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  valuation_at?: InputMaybe<timestamptz_comparison_exp>;
  value?: InputMaybe<numeric_comparison_exp>;
};

/** unique or primary key constraints on table "building_draft_valuation" */
export enum building_draft_valuation_constraint {
  /** unique or primary key constraint on columns "id" */
  building_draft_valuation_pkey = 'building_draft_valuation_pkey',
}

/** input type for incrementing numeric columns in table "building_draft_valuation" */
export type building_draft_valuation_inc_input = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Monetary valuation amount. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "building_draft_valuation" */
export type building_draft_valuation_insert_input = {
  building_draft?: InputMaybe<building_draft_obj_rel_insert_input>;
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Date when the valuation was performed or is effective. */
  valuation_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Monetary valuation amount. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by max() on columns of table "building_draft_valuation" */
export type building_draft_valuation_max_order_by = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Date when the valuation was performed or is effective. */
  valuation_at?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** order by min() on columns of table "building_draft_valuation" */
export type building_draft_valuation_min_order_by = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Date when the valuation was performed or is effective. */
  valuation_at?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** response of any mutation on the table "building_draft_valuation" */
export type building_draft_valuation_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<building_draft_valuation>;
};

/** on_conflict condition type for table "building_draft_valuation" */
export type building_draft_valuation_on_conflict = {
  constraint: building_draft_valuation_constraint;
  update_columns?: Array<building_draft_valuation_update_column>;
  where?: InputMaybe<building_draft_valuation_bool_exp>;
};

/** Ordering options when selecting data from "building_draft_valuation". */
export type building_draft_valuation_order_by = {
  building_draft?: InputMaybe<building_draft_order_by>;
  building_draft_id?: InputMaybe<order_by>;
  energy_certificate_draft?: InputMaybe<energy_certificate_draft_order_by>;
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  valuation_at?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** primary key columns input for table: building_draft_valuation */
export type building_draft_valuation_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "building_draft_valuation" */
export enum building_draft_valuation_select_column {
  /** column name */
  building_draft_id = 'building_draft_id',
  /** column name */
  energy_certificate_draft_id = 'energy_certificate_draft_id',
  /** column name */
  id = 'id',
  /** column name */
  valuation_at = 'valuation_at',
  /** column name */
  value = 'value',
}

/** input type for updating data in table "building_draft_valuation" */
export type building_draft_valuation_set_input = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Date when the valuation was performed or is effective. */
  valuation_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Monetary valuation amount. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by stddev() on columns of table "building_draft_valuation" */
export type building_draft_valuation_stddev_order_by = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "building_draft_valuation" */
export type building_draft_valuation_stddev_pop_order_by = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "building_draft_valuation" */
export type building_draft_valuation_stddev_samp_order_by = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "building_draft_valuation" */
export type building_draft_valuation_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: building_draft_valuation_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type building_draft_valuation_stream_cursor_value_input = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Date when the valuation was performed or is effective. */
  valuation_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Monetary valuation amount. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "building_draft_valuation" */
export type building_draft_valuation_sum_order_by = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** update columns of table "building_draft_valuation" */
export enum building_draft_valuation_update_column {
  /** column name */
  building_draft_id = 'building_draft_id',
  /** column name */
  energy_certificate_draft_id = 'energy_certificate_draft_id',
  /** column name */
  valuation_at = 'valuation_at',
  /** column name */
  value = 'value',
}

export type building_draft_valuation_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<building_draft_valuation_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<building_draft_valuation_set_input>;
  /** filter the rows which have to be updated */
  where: building_draft_valuation_bool_exp;
};

/** order by var_pop() on columns of table "building_draft_valuation" */
export type building_draft_valuation_var_pop_order_by = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "building_draft_valuation" */
export type building_draft_valuation_var_samp_order_by = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "building_draft_valuation" */
export type building_draft_valuation_variance_order_by = {
  /** The building draft this valuation belongs to. */
  building_draft_id?: InputMaybe<order_by>;
  /** Associated energy certificate draft, if the valuation was extracted alongside it. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type building_draft_var_pop_fields = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "building_draft" */
export type building_draft_var_pop_order_by = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<order_by>;
  /** Number of floors in the building. */
  floors?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<order_by>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type building_draft_var_samp_fields = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "building_draft" */
export type building_draft_var_samp_order_by = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<order_by>;
  /** Number of floors in the building. */
  floors?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<order_by>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type building_draft_variance_fields = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  /** Number of floors in the building. */
  floors?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building. */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was originally constructed. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "building_draft" */
export type building_draft_variance_order_by = {
  /** The economic unit this building will belong to once finalized. */
  economic_unit_id?: InputMaybe<order_by>;
  /** Number of floors in the building. */
  floors?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  /** The portfolio this building will be added to once finalized. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact for this building draft. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building. */
  units?: InputMaybe<order_by>;
  /** The year the building was originally constructed. */
  year_constructed?: InputMaybe<order_by>;
};

/** input type for incrementing numeric columns in table "building" */
export type building_inc_input = {
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type building_max_fields = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Int']['output']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** External identifier assigned by the customer, used for cross-system referencing. */
  customer_external_identifier?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last update to subsidy/funding eligibility data for this building. */
  subsidies_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "building" */
export type building_max_order_by = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<order_by>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** External identifier assigned by the customer, used for cross-system referencing. */
  customer_external_identifier?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Timestamp of the last update to subsidy/funding eligibility data for this building. */
  subsidies_updated_at?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type building_min_fields = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Int']['output']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** External identifier assigned by the customer, used for cross-system referencing. */
  customer_external_identifier?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  /** Timestamp of the last update to subsidy/funding eligibility data for this building. */
  subsidies_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "building" */
export type building_min_order_by = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<order_by>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** External identifier assigned by the customer, used for cross-system referencing. */
  customer_external_identifier?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Timestamp of the last update to subsidy/funding eligibility data for this building. */
  subsidies_updated_at?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
};

/** Digital twin snapshot of a building's physical and energy properties at a specific point in time, linking the envelope representation, system representation, and thermal model. Each building can have multiple models representing different states (baseline, post-renovation, etc.). */
export type building_model = {
  /** An object relationship */
  action?: Maybe<action>;
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: Maybe<Scalars['Int']['output']>;
  /** Whether the thermal scaling succeeded for this model, which is required before it can be used for action planning. */
  action_planning_available: Scalars['Boolean']['output'];
  /** An object relationship */
  active_for_building?: Maybe<building>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration: Scalars['Float']['output'];
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days: Scalars['Float']['output'];
  /** An object relationship */
  building?: Maybe<building>;
  /** Reference to the building this model represents. */
  building_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  efficiency_class_id?: Maybe<efficiency_class_enum>;
  /** An array relationship */
  energy_consumers: Array<energy_consumer>;
  /** An array relationship */
  energy_distributions: Array<energy_distribution>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: Maybe<Scalars['Float']['output']>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: Maybe<Scalars['Float']['output']>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: Maybe<Scalars['Float']['output']>;
  /** An array relationship */
  energy_producers: Array<energy_producer>;
  /** An array relationship */
  energy_storages: Array<energy_storage>;
  /** An array relationship */
  energy_systems: Array<energy_system>;
  /** An array relationship */
  envelope_units: Array<envelope>;
  eu_taxonomy_compliance_id?: Maybe<eu_taxonomy_compliance_enum>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature: Scalars['Float']['output'];
  heat_transfer_by_ventilation: Scalars['Float']['output'];
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature: Scalars['Float']['output'];
  /** True for in-progress digital-twin drafts (work-in-progress edits not yet promoted to a published building model version). A building may have multiple drafts. */
  is_draft: Scalars['Boolean']['output'];
  /** Whether energy calculations are currently being computed for this model. */
  processing: Scalars['Boolean']['output'];
  tax_bracket_id?: Maybe<tax_bracket_enum>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging: Scalars['Float']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** Start date from which this model's state is considered effective. */
  valid_from: Scalars['timestamptz']['output'];
};

/** Digital twin snapshot of a building's physical and energy properties at a specific point in time, linking the envelope representation, system representation, and thermal model. Each building can have multiple models representing different states (baseline, post-renovation, etc.). */
export type building_modelenergy_consumersArgs = {
  distinct_on?: InputMaybe<Array<energy_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_consumer_order_by>>;
  where?: InputMaybe<energy_consumer_bool_exp>;
};

/** Digital twin snapshot of a building's physical and energy properties at a specific point in time, linking the envelope representation, system representation, and thermal model. Each building can have multiple models representing different states (baseline, post-renovation, etc.). */
export type building_modelenergy_distributionsArgs = {
  distinct_on?: InputMaybe<Array<energy_distribution_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_distribution_order_by>>;
  where?: InputMaybe<energy_distribution_bool_exp>;
};

/** Digital twin snapshot of a building's physical and energy properties at a specific point in time, linking the envelope representation, system representation, and thermal model. Each building can have multiple models representing different states (baseline, post-renovation, etc.). */
export type building_modelenergy_producersArgs = {
  distinct_on?: InputMaybe<Array<energy_producer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_producer_order_by>>;
  where?: InputMaybe<energy_producer_bool_exp>;
};

/** Digital twin snapshot of a building's physical and energy properties at a specific point in time, linking the envelope representation, system representation, and thermal model. Each building can have multiple models representing different states (baseline, post-renovation, etc.). */
export type building_modelenergy_storagesArgs = {
  distinct_on?: InputMaybe<Array<energy_storage_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_storage_order_by>>;
  where?: InputMaybe<energy_storage_bool_exp>;
};

/** Digital twin snapshot of a building's physical and energy properties at a specific point in time, linking the envelope representation, system representation, and thermal model. Each building can have multiple models representing different states (baseline, post-renovation, etc.). */
export type building_modelenergy_systemsArgs = {
  distinct_on?: InputMaybe<Array<energy_system_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_order_by>>;
  where?: InputMaybe<energy_system_bool_exp>;
};

/** Digital twin snapshot of a building's physical and energy properties at a specific point in time, linking the envelope representation, system representation, and thermal model. Each building can have multiple models representing different states (baseline, post-renovation, etc.). */
export type building_modelenvelope_unitsArgs = {
  distinct_on?: InputMaybe<Array<envelope_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<envelope_order_by>>;
  where?: InputMaybe<envelope_bool_exp>;
};

/** order by aggregate values of table "building_model" */
export type building_model_aggregate_order_by = {
  avg?: InputMaybe<building_model_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<building_model_max_order_by>;
  min?: InputMaybe<building_model_min_order_by>;
  stddev?: InputMaybe<building_model_stddev_order_by>;
  stddev_pop?: InputMaybe<building_model_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<building_model_stddev_samp_order_by>;
  sum?: InputMaybe<building_model_sum_order_by>;
  var_pop?: InputMaybe<building_model_var_pop_order_by>;
  var_samp?: InputMaybe<building_model_var_samp_order_by>;
  variance?: InputMaybe<building_model_variance_order_by>;
};

/** order by avg() on columns of table "building_model" */
export type building_model_avg_order_by = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<order_by>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<order_by>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<order_by>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<order_by>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<order_by>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<order_by>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<order_by>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "building_model". All fields are combined with a logical 'AND'. */
export type building_model_bool_exp = {
  _and?: InputMaybe<Array<building_model_bool_exp>>;
  _not?: InputMaybe<building_model_bool_exp>;
  _or?: InputMaybe<Array<building_model_bool_exp>>;
  action?: InputMaybe<action_bool_exp>;
  action_id?: InputMaybe<Int_comparison_exp>;
  action_planning_available?: InputMaybe<Boolean_comparison_exp>;
  active_for_building?: InputMaybe<building_bool_exp>;
  air_change_rate_by_infiltration?: InputMaybe<Float_comparison_exp>;
  annual_heating_days?: InputMaybe<Float_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  energy_consumers?: InputMaybe<energy_consumer_bool_exp>;
  energy_distributions?: InputMaybe<energy_distribution_bool_exp>;
  energy_effective?: InputMaybe<Float_comparison_exp>;
  energy_final?: InputMaybe<Float_comparison_exp>;
  energy_primary?: InputMaybe<Float_comparison_exp>;
  energy_producers?: InputMaybe<energy_producer_bool_exp>;
  energy_storages?: InputMaybe<energy_storage_bool_exp>;
  energy_systems?: InputMaybe<energy_system_bool_exp>;
  envelope_units?: InputMaybe<envelope_bool_exp>;
  external_temperature?: InputMaybe<Float_comparison_exp>;
  heating_demand?: InputMaybe<Float_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  internal_temperature?: InputMaybe<Float_comparison_exp>;
  is_draft?: InputMaybe<Boolean_comparison_exp>;
  processing?: InputMaybe<Boolean_comparison_exp>;
  thermal_bridging?: InputMaybe<Float_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  valid_from?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "building_model" */
export type building_model_max_order_by = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<order_by>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<order_by>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<order_by>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<order_by>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<order_by>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<order_by>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Start date from which this model's state is considered effective. */
  valid_from?: InputMaybe<order_by>;
};

/** order by min() on columns of table "building_model" */
export type building_model_min_order_by = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<order_by>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<order_by>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<order_by>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<order_by>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<order_by>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<order_by>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Start date from which this model's state is considered effective. */
  valid_from?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "building_model". */
export type building_model_order_by = {
  action?: InputMaybe<action_order_by>;
  action_id?: InputMaybe<order_by>;
  action_planning_available?: InputMaybe<order_by>;
  active_for_building?: InputMaybe<building_order_by>;
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  annual_heating_days?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  energy_consumers_aggregate?: InputMaybe<energy_consumer_aggregate_order_by>;
  energy_distributions_aggregate?: InputMaybe<energy_distribution_aggregate_order_by>;
  energy_effective?: InputMaybe<order_by>;
  energy_final?: InputMaybe<order_by>;
  energy_primary?: InputMaybe<order_by>;
  energy_producers_aggregate?: InputMaybe<energy_producer_aggregate_order_by>;
  energy_storages_aggregate?: InputMaybe<energy_storage_aggregate_order_by>;
  energy_systems_aggregate?: InputMaybe<energy_system_aggregate_order_by>;
  envelope_units_aggregate?: InputMaybe<envelope_aggregate_order_by>;
  external_temperature?: InputMaybe<order_by>;
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  internal_temperature?: InputMaybe<order_by>;
  is_draft?: InputMaybe<order_by>;
  processing?: InputMaybe<order_by>;
  thermal_bridging?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  valid_from?: InputMaybe<order_by>;
};

/** select columns of table "building_model" */
export enum building_model_select_column {
  /** column name */
  action_id = 'action_id',
  /** column name */
  action_planning_available = 'action_planning_available',
  /** column name */
  air_change_rate_by_infiltration = 'air_change_rate_by_infiltration',
  /** column name */
  annual_heating_days = 'annual_heating_days',
  /** column name */
  building_id = 'building_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  energy_effective = 'energy_effective',
  /** column name */
  energy_final = 'energy_final',
  /** column name */
  energy_primary = 'energy_primary',
  /** column name */
  external_temperature = 'external_temperature',
  /** column name */
  heating_demand = 'heating_demand',
  /** column name */
  id = 'id',
  /** column name */
  internal_temperature = 'internal_temperature',
  /** column name */
  is_draft = 'is_draft',
  /** column name */
  processing = 'processing',
  /** column name */
  thermal_bridging = 'thermal_bridging',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  valid_from = 'valid_from',
}

/** order by stddev() on columns of table "building_model" */
export type building_model_stddev_order_by = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<order_by>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<order_by>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<order_by>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<order_by>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<order_by>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<order_by>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<order_by>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "building_model" */
export type building_model_stddev_pop_order_by = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<order_by>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<order_by>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<order_by>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<order_by>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<order_by>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<order_by>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<order_by>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "building_model" */
export type building_model_stddev_samp_order_by = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<order_by>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<order_by>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<order_by>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<order_by>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<order_by>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<order_by>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<order_by>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "building_model" */
export type building_model_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: building_model_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type building_model_stream_cursor_value_input = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the thermal scaling succeeded for this model, which is required before it can be used for action planning. */
  action_planning_available?: InputMaybe<Scalars['Boolean']['input']>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<Scalars['Float']['input']>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<Scalars['Float']['input']>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<Scalars['Float']['input']>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<Scalars['Float']['input']>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<Scalars['Float']['input']>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<Scalars['Float']['input']>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<Scalars['Float']['input']>;
  /** True for in-progress digital-twin drafts (work-in-progress edits not yet promoted to a published building model version). A building may have multiple drafts. */
  is_draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether energy calculations are currently being computed for this model. */
  processing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Start date from which this model's state is considered effective. */
  valid_from?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "building_model" */
export type building_model_sum_order_by = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<order_by>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<order_by>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<order_by>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<order_by>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<order_by>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<order_by>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<order_by>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "building_model" */
export type building_model_var_pop_order_by = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<order_by>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<order_by>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<order_by>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<order_by>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<order_by>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<order_by>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<order_by>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "building_model" */
export type building_model_var_samp_order_by = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<order_by>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<order_by>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<order_by>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<order_by>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<order_by>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<order_by>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<order_by>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "building_model" */
export type building_model_variance_order_by = {
  /** Reference to the action that produced this model. NULL for the baseline (as-is) model. */
  action_id?: InputMaybe<order_by>;
  /** Rate of uncontrolled air exchange through the building envelope in 1/h, used in ventilation heat loss calculations. One of the parameters adjusted during thermal scaling. */
  air_change_rate_by_infiltration?: InputMaybe<order_by>;
  /** Number of days per year when heating is required, derived from climate data and building thermal properties. One of the parameters adjusted during thermal scaling. */
  annual_heating_days?: InputMaybe<order_by>;
  /** Reference to the building this model represents. */
  building_id?: InputMaybe<order_by>;
  /** Total effective (useful) energy demand in kWh/(m2a), the net energy needed to maintain indoor conditions before system losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total final energy demand (Endenergiebedarf) in kWh/(m2a), the energy delivered to the building boundary after upstream losses. */
  energy_final?: InputMaybe<order_by>;
  /** Total primary energy demand in kWh/(m2a), including upstream energy losses from extraction and delivery. */
  energy_primary?: InputMaybe<order_by>;
  /** Average external temperature in degrees C during the heating period, derived from climate data. */
  external_temperature?: InputMaybe<order_by>;
  /** Calculated space heating demand (Heizwaermebedarf) in kWh/(m2a) based on the EN ISO 13790 seasonal method, the net heat needed to maintain indoor conditions before system losses. */
  heating_demand?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Assumed indoor set-point temperature in degrees C used for energy demand calculations. */
  internal_temperature?: InputMaybe<order_by>;
  /** Thermal bridging surcharge (Waermebrueckenzuschlag) in W/(m2K), additional heat loss through construction junctions. One of the parameters adjusted during thermal scaling. */
  thermal_bridging?: InputMaybe<order_by>;
};

/** response of any mutation on the table "building" */
export type building_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<building>;
};

/** Ordering options when selecting data from "building". */
export type building_order_by = {
  action_plans_aggregate?: InputMaybe<action_plan_aggregate_order_by>;
  active_action_plans_aggregate?: InputMaybe<active_action_plans_aggregate_order_by>;
  active_building_model?: InputMaybe<building_model_order_by>;
  active_building_model_id?: InputMaybe<order_by>;
  address?: InputMaybe<address_order_by>;
  address_id?: InputMaybe<order_by>;
  areas_aggregate?: InputMaybe<area_aggregate_order_by>;
  building_models_aggregate?: InputMaybe<building_model_aggregate_order_by>;
  building_state_id?: InputMaybe<order_by>;
  building_valuations_aggregate?: InputMaybe<building_valuation_aggregate_order_by>;
  certificates_aggregate?: InputMaybe<certificate_aggregate_order_by>;
  climate_risks_aggregate?: InputMaybe<climate_risk_aggregate_order_by>;
  climate_risks_v2_aggregate?: InputMaybe<climate_risk_v2_aggregate_order_by>;
  consumption_drafts_aggregate?: InputMaybe<consumption_draft_aggregate_order_by>;
  consumptions_aggregate?: InputMaybe<consumption_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  custom_data?: InputMaybe<order_by>;
  customer_external_identifier?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  district_heating_availability_status?: InputMaybe<building_with_district_heating_status_order_by>;
  economic_unit?: InputMaybe<economic_unit_order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificates_aggregate?: InputMaybe<energy_certificate_aggregate_order_by>;
  folder?: InputMaybe<folder_order_by>;
  has_write_permission?: InputMaybe<order_by>;
  heritage_district?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  is_missing_energy_data?: InputMaybe<order_by>;
  is_new_construction?: InputMaybe<order_by>;
  leasehold?: InputMaybe<order_by>;
  milieu_protection?: InputMaybe<order_by>;
  monument_protection?: InputMaybe<order_by>;
  report_buildings_aggregate?: InputMaybe<report_building_aggregate_order_by>;
  responsible_user?: InputMaybe<user_order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  subsidies_aggregate?: InputMaybe<building_subsidy_aggregate_order_by>;
  subsidies_updated_at?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  units_data_source?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_building_permissions_aggregate?: InputMaybe<user_building_permission_aggregate_order_by>;
  user_permissions_aggregate?: InputMaybe<building_permissions_aggregate_order_by>;
  year_constructed?: InputMaybe<order_by>;
  year_data_source?: InputMaybe<order_by>;
};

/** View: Aggregated read/write permissions for each user-building combination, combining portfolio-level and building-level grants. */
export type building_permissions = {
  /** An object relationship */
  building?: Maybe<building>;
  building_id?: Maybe<Scalars['Int']['output']>;
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  user?: Maybe<user>;
  user_id?: Maybe<Scalars['Int']['output']>;
  write?: Maybe<Scalars['Boolean']['output']>;
};

/** order by aggregate values of table "building_permissions" */
export type building_permissions_aggregate_order_by = {
  avg?: InputMaybe<building_permissions_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<building_permissions_max_order_by>;
  min?: InputMaybe<building_permissions_min_order_by>;
  stddev?: InputMaybe<building_permissions_stddev_order_by>;
  stddev_pop?: InputMaybe<building_permissions_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<building_permissions_stddev_samp_order_by>;
  sum?: InputMaybe<building_permissions_sum_order_by>;
  var_pop?: InputMaybe<building_permissions_var_pop_order_by>;
  var_samp?: InputMaybe<building_permissions_var_samp_order_by>;
  variance?: InputMaybe<building_permissions_variance_order_by>;
};

/** order by avg() on columns of table "building_permissions" */
export type building_permissions_avg_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "building_permissions". All fields are combined with a logical 'AND'. */
export type building_permissions_bool_exp = {
  _and?: InputMaybe<Array<building_permissions_bool_exp>>;
  _not?: InputMaybe<building_permissions_bool_exp>;
  _or?: InputMaybe<Array<building_permissions_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  portfolio_id?: InputMaybe<Int_comparison_exp>;
  read?: InputMaybe<Boolean_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<Int_comparison_exp>;
  write?: InputMaybe<Boolean_comparison_exp>;
};

/** order by max() on columns of table "building_permissions" */
export type building_permissions_max_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "building_permissions" */
export type building_permissions_min_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "building_permissions". */
export type building_permissions_order_by = {
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  read?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_id?: InputMaybe<order_by>;
  write?: InputMaybe<order_by>;
};

/** select columns of table "building_permissions" */
export enum building_permissions_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  portfolio_id = 'portfolio_id',
  /** column name */
  read = 'read',
  /** column name */
  user_id = 'user_id',
  /** column name */
  write = 'write',
}

/** order by stddev() on columns of table "building_permissions" */
export type building_permissions_stddev_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "building_permissions" */
export type building_permissions_stddev_pop_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "building_permissions" */
export type building_permissions_stddev_samp_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "building_permissions" */
export type building_permissions_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: building_permissions_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type building_permissions_stream_cursor_value_input = {
  building_id?: InputMaybe<Scalars['Int']['input']>;
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  write?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "building_permissions" */
export type building_permissions_sum_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "building_permissions" */
export type building_permissions_var_pop_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "building_permissions" */
export type building_permissions_var_samp_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "building_permissions" */
export type building_permissions_variance_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  user_id?: InputMaybe<order_by>;
};

/** primary key columns input for table: building */
export type building_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "building" */
export enum building_select_column {
  /** column name */
  active_building_model_id = 'active_building_model_id',
  /** column name */
  address_id = 'address_id',
  /** column name */
  building_state_id = 'building_state_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  custom_data = 'custom_data',
  /** column name */
  customer_external_identifier = 'customer_external_identifier',
  /** column name */
  description = 'description',
  /** column name */
  economic_unit_id = 'economic_unit_id',
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  id = 'id',
  /** column name */
  is_new_construction = 'is_new_construction',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
  /** column name */
  responsible_user_id = 'responsible_user_id',
  /** column name */
  state = 'state',
  /** column name */
  subsidies_updated_at = 'subsidies_updated_at',
  /** column name */
  units = 'units',
  /** column name */
  units_data_source = 'units_data_source',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  year_constructed = 'year_constructed',
  /** column name */
  year_data_source = 'year_data_source',
}

/** select "building_aggregate_bool_exp_bool_and_arguments_columns" columns of table "building" */
export enum building_select_column_building_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  is_new_construction = 'is_new_construction',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
}

/** select "building_aggregate_bool_exp_bool_or_arguments_columns" columns of table "building" */
export enum building_select_column_building_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  is_new_construction = 'is_new_construction',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
}

/** input type for updating data in table "building" */
export type building_set_input = {
  /** Lifecycle state of the building (e.g. INVENTORY, RENOVATION). References building_state. */
  building_state_id?: InputMaybe<building_state_enum>;
  /** External identifier assigned by the customer, used for cross-system referencing. */
  customer_external_identifier?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the building is located in a designated heritage district. */
  heritage_district?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the building is on leasehold land (Erbbaurecht) rather than owned freehold. */
  leasehold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the building is in a milieu protection zone (Milieuschutzgebiet), restricting modernization to prevent displacement. */
  milieu_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the building is under monument/heritage protection, which restricts renovation options. */
  monument_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Soft-delete state of the building record (ACTIVE or DELETED). References entity_state_type. */
  state?: InputMaybe<entity_state_type_enum>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<Scalars['Int']['input']>;
  /** How the unit count was determined (e.g. MANUAL, APPROXIMATED). References data_source_type. */
  units_data_source?: InputMaybe<data_source_type_enum>;
};

export enum building_state_enum {
  ACQUISITION = 'ACQUISITION',
  INVENTORY = 'INVENTORY',
}

/** Boolean expression to compare columns of type "building_state_enum". All fields are combined with logical 'AND'. */
export type building_state_enum_comparison_exp = {
  _eq?: InputMaybe<building_state_enum>;
  _in?: InputMaybe<Array<building_state_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<building_state_enum>;
  _nin?: InputMaybe<Array<building_state_enum>>;
};

/** aggregate stddev on columns */
export type building_stddev_fields = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Float']['output']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: Maybe<Scalars['Float']['output']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "building" */
export type building_stddev_order_by = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<order_by>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<order_by>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type building_stddev_pop_fields = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Float']['output']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: Maybe<Scalars['Float']['output']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "building" */
export type building_stddev_pop_order_by = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<order_by>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<order_by>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type building_stddev_samp_fields = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Float']['output']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: Maybe<Scalars['Float']['output']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "building" */
export type building_stddev_samp_order_by = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<order_by>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<order_by>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "building" */
export type building_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: building_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type building_stream_cursor_value_input = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<Scalars['Int']['input']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<Scalars['Int']['input']>;
  /** Lifecycle state of the building (e.g. INVENTORY, RENOVATION). References building_state. */
  building_state_id?: InputMaybe<building_state_enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** JSON object holding customer-defined custom fields for this building. */
  custom_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** External identifier assigned by the customer, used for cross-system referencing. */
  customer_external_identifier?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the building is located in a designated heritage district. */
  heritage_district?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_new_construction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the building is on leasehold land (Erbbaurecht) rather than owned freehold. */
  leasehold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the building is in a milieu protection zone (Milieuschutzgebiet), restricting modernization to prevent displacement. */
  milieu_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the building is under monument/heritage protection, which restricts renovation options. */
  monument_protection?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Soft-delete state of the building record (ACTIVE or DELETED). References entity_state_type. */
  state?: InputMaybe<entity_state_type_enum>;
  /** Timestamp of the last update to subsidy/funding eligibility data for this building. */
  subsidies_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<Scalars['Int']['input']>;
  /** How the unit count was determined (e.g. MANUAL, APPROXIMATED). References data_source_type. */
  units_data_source?: InputMaybe<data_source_type_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<Scalars['Int']['input']>;
  /** How the construction year was determined (e.g. MANUAL, APPROXIMATED). References data_source_type. */
  year_data_source?: InputMaybe<data_source_type_enum>;
};

/** Junction table linking eligible subsidies to specific buildings. */
export type building_subsidy = {
  /** An object relationship */
  building: building;
  /** An object relationship */
  subsidy: subsidy;
};

/** order by aggregate values of table "building_subsidy" */
export type building_subsidy_aggregate_order_by = {
  count?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "building_subsidy". All fields are combined with a logical 'AND'. */
export type building_subsidy_bool_exp = {
  _and?: InputMaybe<Array<building_subsidy_bool_exp>>;
  _not?: InputMaybe<building_subsidy_bool_exp>;
  _or?: InputMaybe<Array<building_subsidy_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  subsidy?: InputMaybe<subsidy_bool_exp>;
};

/** Ordering options when selecting data from "building_subsidy". */
export type building_subsidy_order_by = {
  building?: InputMaybe<building_order_by>;
  subsidy?: InputMaybe<subsidy_order_by>;
};

/** aggregate sum on columns */
export type building_sum_fields = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Int']['output']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: Maybe<Scalars['Int']['output']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: Maybe<Scalars['Int']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "building" */
export type building_sum_order_by = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<order_by>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<order_by>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
};

export type building_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<building_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<building_set_input>;
  /** filter the rows which have to be updated */
  where: building_bool_exp;
};

/** Market or appraised valuation of a building at a specific point in time. */
export type building_valuation = {
  /** An object relationship */
  building: building;
  /** The building being valued. */
  building_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Date when the valuation was performed or is effective. */
  valuation_at: Scalars['timestamptz']['output'];
  /** Monetary valuation amount. */
  value: Scalars['numeric']['output'];
};

/** order by aggregate values of table "building_valuation" */
export type building_valuation_aggregate_order_by = {
  avg?: InputMaybe<building_valuation_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<building_valuation_max_order_by>;
  min?: InputMaybe<building_valuation_min_order_by>;
  stddev?: InputMaybe<building_valuation_stddev_order_by>;
  stddev_pop?: InputMaybe<building_valuation_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<building_valuation_stddev_samp_order_by>;
  sum?: InputMaybe<building_valuation_sum_order_by>;
  var_pop?: InputMaybe<building_valuation_var_pop_order_by>;
  var_samp?: InputMaybe<building_valuation_var_samp_order_by>;
  variance?: InputMaybe<building_valuation_variance_order_by>;
};

/** order by avg() on columns of table "building_valuation" */
export type building_valuation_avg_order_by = {
  /** The building being valued. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "building_valuation". All fields are combined with a logical 'AND'. */
export type building_valuation_bool_exp = {
  _and?: InputMaybe<Array<building_valuation_bool_exp>>;
  _not?: InputMaybe<building_valuation_bool_exp>;
  _or?: InputMaybe<Array<building_valuation_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  valuation_at?: InputMaybe<timestamptz_comparison_exp>;
  value?: InputMaybe<numeric_comparison_exp>;
};

/** unique or primary key constraints on table "building_valuation" */
export enum building_valuation_constraint {
  /** unique or primary key constraint on columns "id" */
  building_valuation_pkey = 'building_valuation_pkey',
  /** unique or primary key constraint on columns "building_id", "value", "valuation_at" */
  unique_building_valuation = 'unique_building_valuation',
}

/** input type for incrementing numeric columns in table "building_valuation" */
export type building_valuation_inc_input = {
  /** The building being valued. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** Monetary valuation amount. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "building_valuation" */
export type building_valuation_insert_input = {
  /** The building being valued. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Date when the valuation was performed or is effective. */
  valuation_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Monetary valuation amount. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by max() on columns of table "building_valuation" */
export type building_valuation_max_order_by = {
  /** The building being valued. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Date when the valuation was performed or is effective. */
  valuation_at?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** order by min() on columns of table "building_valuation" */
export type building_valuation_min_order_by = {
  /** The building being valued. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Date when the valuation was performed or is effective. */
  valuation_at?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** response of any mutation on the table "building_valuation" */
export type building_valuation_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<building_valuation>;
};

/** on_conflict condition type for table "building_valuation" */
export type building_valuation_on_conflict = {
  constraint: building_valuation_constraint;
  update_columns?: Array<building_valuation_update_column>;
  where?: InputMaybe<building_valuation_bool_exp>;
};

/** Ordering options when selecting data from "building_valuation". */
export type building_valuation_order_by = {
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  valuation_at?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** primary key columns input for table: building_valuation */
export type building_valuation_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "building_valuation" */
export enum building_valuation_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  id = 'id',
  /** column name */
  valuation_at = 'valuation_at',
  /** column name */
  value = 'value',
}

/** input type for updating data in table "building_valuation" */
export type building_valuation_set_input = {
  /** The building being valued. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** Date when the valuation was performed or is effective. */
  valuation_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Monetary valuation amount. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by stddev() on columns of table "building_valuation" */
export type building_valuation_stddev_order_by = {
  /** The building being valued. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "building_valuation" */
export type building_valuation_stddev_pop_order_by = {
  /** The building being valued. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "building_valuation" */
export type building_valuation_stddev_samp_order_by = {
  /** The building being valued. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "building_valuation" */
export type building_valuation_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: building_valuation_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type building_valuation_stream_cursor_value_input = {
  /** The building being valued. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Date when the valuation was performed or is effective. */
  valuation_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Monetary valuation amount. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "building_valuation" */
export type building_valuation_sum_order_by = {
  /** The building being valued. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** update columns of table "building_valuation" */
export enum building_valuation_update_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  valuation_at = 'valuation_at',
  /** column name */
  value = 'value',
}

export type building_valuation_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<building_valuation_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<building_valuation_set_input>;
  /** filter the rows which have to be updated */
  where: building_valuation_bool_exp;
};

/** order by var_pop() on columns of table "building_valuation" */
export type building_valuation_var_pop_order_by = {
  /** The building being valued. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "building_valuation" */
export type building_valuation_var_samp_order_by = {
  /** The building being valued. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "building_valuation" */
export type building_valuation_variance_order_by = {
  /** The building being valued. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Monetary valuation amount. */
  value?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type building_var_pop_fields = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Float']['output']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: Maybe<Scalars['Float']['output']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "building" */
export type building_var_pop_order_by = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<order_by>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<order_by>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type building_var_samp_fields = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Float']['output']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: Maybe<Scalars['Float']['output']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "building" */
export type building_var_samp_order_by = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<order_by>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<order_by>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type building_variance_fields = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: Maybe<Scalars['Float']['output']>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: Maybe<Scalars['Float']['output']>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "building" */
export type building_variance_order_by = {
  /** The currently active digital twin (building model) representing this building's energy systems and envelope. */
  active_building_model_id?: InputMaybe<order_by>;
  /** Physical location and geospatial metadata for this building. */
  address_id?: InputMaybe<order_by>;
  /** The economic unit this building belongs to. */
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this building. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Number of rentable or countable units in the building (e.g. apartments, commercial spaces). */
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
};

/** View: Buildings enriched with their district heating availability status and year. */
export type building_with_district_heating_status = {
  /** An object relationship */
  building?: Maybe<building>;
  building_id?: Maybe<Scalars['Int']['output']>;
  district_heating_status?: Maybe<Scalars['String']['output']>;
  district_heating_year?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Boolean expression to filter rows from the table "building_with_district_heating_status". All fields are combined with a logical 'AND'. */
export type building_with_district_heating_status_bool_exp = {
  _and?: InputMaybe<Array<building_with_district_heating_status_bool_exp>>;
  _not?: InputMaybe<building_with_district_heating_status_bool_exp>;
  _or?: InputMaybe<Array<building_with_district_heating_status_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  district_heating_status?: InputMaybe<String_comparison_exp>;
  district_heating_year?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Ordering options when selecting data from "building_with_district_heating_status". */
export type building_with_district_heating_status_order_by = {
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  district_heating_status?: InputMaybe<order_by>;
  district_heating_year?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "building_with_district_heating_status" */
export enum building_with_district_heating_status_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  district_heating_status = 'district_heating_status',
  /** column name */
  district_heating_year = 'district_heating_year',
  /** column name */
  updated_at = 'updated_at',
}

/** Streaming cursor of the table "building_with_district_heating_status" */
export type building_with_district_heating_status_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: building_with_district_heating_status_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type building_with_district_heating_status_stream_cursor_value_input = {
  building_id?: InputMaybe<Scalars['Int']['input']>;
  district_heating_status?: InputMaybe<Scalars['String']['input']>;
  district_heating_year?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** This is a workaround to fix the typing of the relation between BuildingModelDraft & building_with_models table. */
export type building_with_models = {
  building: building;
  building_model: building_model;
};

/** A renovation measure applied to multiple buildings within a scenario at once (Sammelmassnahme). After creation, individual actions in each building's action plan can be edited separately. */
export type bulk_action = {
  created_at: Scalars['timestamptz']['output'];
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['float8']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['float8']['output']>;
  id: Scalars['Int']['output'];
  /** The target implementation date for this bulk renovation measure. */
  implementation_date: Scalars['timestamptz']['output'];
  name: Scalars['String']['output'];
  params: BulkActionParametersUnion;
  /** An object relationship */
  scenario_version: scenario_version;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id: Scalars['Int']['output'];
  /** An object relationship */
  summary?: Maybe<bulk_action_summary>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "bulk_action" */
export type bulk_action_aggregate = {
  aggregate?: Maybe<bulk_action_aggregate_fields>;
  nodes: Array<bulk_action>;
};

/** aggregate fields of "bulk_action" */
export type bulk_action_aggregate_fields = {
  avg?: Maybe<bulk_action_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<bulk_action_max_fields>;
  min?: Maybe<bulk_action_min_fields>;
  stddev?: Maybe<bulk_action_stddev_fields>;
  stddev_pop?: Maybe<bulk_action_stddev_pop_fields>;
  stddev_samp?: Maybe<bulk_action_stddev_samp_fields>;
  sum?: Maybe<bulk_action_sum_fields>;
  var_pop?: Maybe<bulk_action_var_pop_fields>;
  var_samp?: Maybe<bulk_action_var_samp_fields>;
  variance?: Maybe<bulk_action_variance_fields>;
};

/** aggregate fields of "bulk_action" */
export type bulk_action_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<bulk_action_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type bulk_action_avg_fields = {
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['Float']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "bulk_action". All fields are combined with a logical 'AND'. */
export type bulk_action_bool_exp = {
  _and?: InputMaybe<Array<bulk_action_bool_exp>>;
  _not?: InputMaybe<bulk_action_bool_exp>;
  _or?: InputMaybe<Array<bulk_action_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  custom_costs?: InputMaybe<float8_comparison_exp>;
  custom_costs_per_m2?: InputMaybe<float8_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  implementation_date?: InputMaybe<timestamptz_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  scenario_version?: InputMaybe<scenario_version_bool_exp>;
  scenario_version_id?: InputMaybe<Int_comparison_exp>;
  summary?: InputMaybe<bulk_action_summary_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type bulk_action_max_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['float8']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The target implementation date for this bulk renovation measure. */
  implementation_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type bulk_action_min_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['float8']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The target implementation date for this bulk renovation measure. */
  implementation_date?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "bulk_action". */
export type bulk_action_order_by = {
  created_at?: InputMaybe<order_by>;
  custom_costs?: InputMaybe<order_by>;
  custom_costs_per_m2?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  implementation_date?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  scenario_version?: InputMaybe<scenario_version_order_by>;
  scenario_version_id?: InputMaybe<order_by>;
  summary?: InputMaybe<bulk_action_summary_order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "bulk_action" */
export enum bulk_action_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  custom_costs = 'custom_costs',
  /** column name */
  custom_costs_per_m2 = 'custom_costs_per_m2',
  /** column name */
  id = 'id',
  /** column name */
  implementation_date = 'implementation_date',
  /** column name */
  name = 'name',
  /** column name */
  scenario_version_id = 'scenario_version_id',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate stddev on columns */
export type bulk_action_stddev_fields = {
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['Float']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type bulk_action_stddev_pop_fields = {
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['Float']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type bulk_action_stddev_samp_fields = {
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['Float']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "bulk_action" */
export type bulk_action_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: bulk_action_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type bulk_action_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: InputMaybe<Scalars['float8']['input']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The target implementation date for this bulk renovation measure. */
  implementation_date?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type bulk_action_sum_fields = {
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['float8']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: Maybe<Scalars['Int']['output']>;
};

/** View: Aggregated counts and total cost per bulk action (planned, pending, failed, etc.). */
export type bulk_action_summary = {
  /** An object relationship */
  bulk_action?: Maybe<bulk_action>;
  deletion_failed_count?: Maybe<Scalars['bigint']['output']>;
  deletion_pending_count?: Maybe<Scalars['bigint']['output']>;
  failed_count?: Maybe<Scalars['bigint']['output']>;
  pending_count?: Maybe<Scalars['bigint']['output']>;
  planned_count?: Maybe<Scalars['bigint']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "bulk_action_summary" */
export type bulk_action_summary_aggregate = {
  aggregate?: Maybe<bulk_action_summary_aggregate_fields>;
  nodes: Array<bulk_action_summary>;
};

/** aggregate fields of "bulk_action_summary" */
export type bulk_action_summary_aggregate_fields = {
  avg?: Maybe<bulk_action_summary_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<bulk_action_summary_max_fields>;
  min?: Maybe<bulk_action_summary_min_fields>;
  stddev?: Maybe<bulk_action_summary_stddev_fields>;
  stddev_pop?: Maybe<bulk_action_summary_stddev_pop_fields>;
  stddev_samp?: Maybe<bulk_action_summary_stddev_samp_fields>;
  sum?: Maybe<bulk_action_summary_sum_fields>;
  var_pop?: Maybe<bulk_action_summary_var_pop_fields>;
  var_samp?: Maybe<bulk_action_summary_var_samp_fields>;
  variance?: Maybe<bulk_action_summary_variance_fields>;
};

/** aggregate fields of "bulk_action_summary" */
export type bulk_action_summary_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<bulk_action_summary_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type bulk_action_summary_avg_fields = {
  deletion_failed_count?: Maybe<Scalars['Float']['output']>;
  deletion_pending_count?: Maybe<Scalars['Float']['output']>;
  failed_count?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
  planned_count?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "bulk_action_summary". All fields are combined with a logical 'AND'. */
export type bulk_action_summary_bool_exp = {
  _and?: InputMaybe<Array<bulk_action_summary_bool_exp>>;
  _not?: InputMaybe<bulk_action_summary_bool_exp>;
  _or?: InputMaybe<Array<bulk_action_summary_bool_exp>>;
  bulk_action?: InputMaybe<bulk_action_bool_exp>;
  deletion_failed_count?: InputMaybe<bigint_comparison_exp>;
  deletion_pending_count?: InputMaybe<bigint_comparison_exp>;
  failed_count?: InputMaybe<bigint_comparison_exp>;
  pending_count?: InputMaybe<bigint_comparison_exp>;
  planned_count?: InputMaybe<bigint_comparison_exp>;
  total_cost?: InputMaybe<Float_comparison_exp>;
  total_count?: InputMaybe<bigint_comparison_exp>;
};

/** aggregate max on columns */
export type bulk_action_summary_max_fields = {
  deletion_failed_count?: Maybe<Scalars['bigint']['output']>;
  deletion_pending_count?: Maybe<Scalars['bigint']['output']>;
  failed_count?: Maybe<Scalars['bigint']['output']>;
  pending_count?: Maybe<Scalars['bigint']['output']>;
  planned_count?: Maybe<Scalars['bigint']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type bulk_action_summary_min_fields = {
  deletion_failed_count?: Maybe<Scalars['bigint']['output']>;
  deletion_pending_count?: Maybe<Scalars['bigint']['output']>;
  failed_count?: Maybe<Scalars['bigint']['output']>;
  pending_count?: Maybe<Scalars['bigint']['output']>;
  planned_count?: Maybe<Scalars['bigint']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "bulk_action_summary". */
export type bulk_action_summary_order_by = {
  bulk_action?: InputMaybe<bulk_action_order_by>;
  deletion_failed_count?: InputMaybe<order_by>;
  deletion_pending_count?: InputMaybe<order_by>;
  failed_count?: InputMaybe<order_by>;
  pending_count?: InputMaybe<order_by>;
  planned_count?: InputMaybe<order_by>;
  total_cost?: InputMaybe<order_by>;
  total_count?: InputMaybe<order_by>;
};

/** select columns of table "bulk_action_summary" */
export enum bulk_action_summary_select_column {
  /** column name */
  deletion_failed_count = 'deletion_failed_count',
  /** column name */
  deletion_pending_count = 'deletion_pending_count',
  /** column name */
  failed_count = 'failed_count',
  /** column name */
  pending_count = 'pending_count',
  /** column name */
  planned_count = 'planned_count',
  /** column name */
  total_cost = 'total_cost',
  /** column name */
  total_count = 'total_count',
}

/** aggregate stddev on columns */
export type bulk_action_summary_stddev_fields = {
  deletion_failed_count?: Maybe<Scalars['Float']['output']>;
  deletion_pending_count?: Maybe<Scalars['Float']['output']>;
  failed_count?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
  planned_count?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type bulk_action_summary_stddev_pop_fields = {
  deletion_failed_count?: Maybe<Scalars['Float']['output']>;
  deletion_pending_count?: Maybe<Scalars['Float']['output']>;
  failed_count?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
  planned_count?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type bulk_action_summary_stddev_samp_fields = {
  deletion_failed_count?: Maybe<Scalars['Float']['output']>;
  deletion_pending_count?: Maybe<Scalars['Float']['output']>;
  failed_count?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
  planned_count?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "bulk_action_summary" */
export type bulk_action_summary_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: bulk_action_summary_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type bulk_action_summary_stream_cursor_value_input = {
  deletion_failed_count?: InputMaybe<Scalars['bigint']['input']>;
  deletion_pending_count?: InputMaybe<Scalars['bigint']['input']>;
  failed_count?: InputMaybe<Scalars['bigint']['input']>;
  pending_count?: InputMaybe<Scalars['bigint']['input']>;
  planned_count?: InputMaybe<Scalars['bigint']['input']>;
  total_cost?: InputMaybe<Scalars['Float']['input']>;
  total_count?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type bulk_action_summary_sum_fields = {
  deletion_failed_count?: Maybe<Scalars['bigint']['output']>;
  deletion_pending_count?: Maybe<Scalars['bigint']['output']>;
  failed_count?: Maybe<Scalars['bigint']['output']>;
  pending_count?: Maybe<Scalars['bigint']['output']>;
  planned_count?: Maybe<Scalars['bigint']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type bulk_action_summary_var_pop_fields = {
  deletion_failed_count?: Maybe<Scalars['Float']['output']>;
  deletion_pending_count?: Maybe<Scalars['Float']['output']>;
  failed_count?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
  planned_count?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type bulk_action_summary_var_samp_fields = {
  deletion_failed_count?: Maybe<Scalars['Float']['output']>;
  deletion_pending_count?: Maybe<Scalars['Float']['output']>;
  failed_count?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
  planned_count?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type bulk_action_summary_variance_fields = {
  deletion_failed_count?: Maybe<Scalars['Float']['output']>;
  deletion_pending_count?: Maybe<Scalars['Float']['output']>;
  failed_count?: Maybe<Scalars['Float']['output']>;
  pending_count?: Maybe<Scalars['Float']['output']>;
  planned_count?: Maybe<Scalars['Float']['output']>;
  total_cost?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type bulk_action_var_pop_fields = {
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['Float']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type bulk_action_var_samp_fields = {
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['Float']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type bulk_action_variance_fields = {
  /** Optional user-defined total cost override, bypassing the cost model. */
  custom_costs?: Maybe<Scalars['Float']['output']>;
  /** Optional user-defined cost per square meter override. */
  custom_costs_per_m2?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The scenario version this bulk action belongs to. */
  scenario_version_id?: Maybe<Scalars['Float']['output']>;
};

/** View: Bulk actions with their per-action-plan processing statuses. */
export type bulk_actions_overview = {
  /** An object relationship */
  action_plan?: Maybe<action_plan>;
  action_plan_id?: Maybe<Scalars['Int']['output']>;
  action_plan_status?: Maybe<Scalars['String']['output']>;
  building_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  bulk_action?: Maybe<bulk_action>;
  bulk_action_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "bulk_actions_overview" */
export type bulk_actions_overview_aggregate = {
  aggregate?: Maybe<bulk_actions_overview_aggregate_fields>;
  nodes: Array<bulk_actions_overview>;
};

/** aggregate fields of "bulk_actions_overview" */
export type bulk_actions_overview_aggregate_fields = {
  avg?: Maybe<bulk_actions_overview_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<bulk_actions_overview_max_fields>;
  min?: Maybe<bulk_actions_overview_min_fields>;
  stddev?: Maybe<bulk_actions_overview_stddev_fields>;
  stddev_pop?: Maybe<bulk_actions_overview_stddev_pop_fields>;
  stddev_samp?: Maybe<bulk_actions_overview_stddev_samp_fields>;
  sum?: Maybe<bulk_actions_overview_sum_fields>;
  var_pop?: Maybe<bulk_actions_overview_var_pop_fields>;
  var_samp?: Maybe<bulk_actions_overview_var_samp_fields>;
  variance?: Maybe<bulk_actions_overview_variance_fields>;
};

/** aggregate fields of "bulk_actions_overview" */
export type bulk_actions_overview_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<bulk_actions_overview_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type bulk_actions_overview_avg_fields = {
  action_plan_id?: Maybe<Scalars['Float']['output']>;
  building_id?: Maybe<Scalars['Float']['output']>;
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "bulk_actions_overview". All fields are combined with a logical 'AND'. */
export type bulk_actions_overview_bool_exp = {
  _and?: InputMaybe<Array<bulk_actions_overview_bool_exp>>;
  _not?: InputMaybe<bulk_actions_overview_bool_exp>;
  _or?: InputMaybe<Array<bulk_actions_overview_bool_exp>>;
  action_plan?: InputMaybe<action_plan_bool_exp>;
  action_plan_id?: InputMaybe<Int_comparison_exp>;
  action_plan_status?: InputMaybe<String_comparison_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  bulk_action?: InputMaybe<bulk_action_bool_exp>;
  bulk_action_id?: InputMaybe<Int_comparison_exp>;
};

/** aggregate max on columns */
export type bulk_actions_overview_max_fields = {
  action_plan_id?: Maybe<Scalars['Int']['output']>;
  action_plan_status?: Maybe<Scalars['String']['output']>;
  building_id?: Maybe<Scalars['Int']['output']>;
  bulk_action_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type bulk_actions_overview_min_fields = {
  action_plan_id?: Maybe<Scalars['Int']['output']>;
  action_plan_status?: Maybe<Scalars['String']['output']>;
  building_id?: Maybe<Scalars['Int']['output']>;
  bulk_action_id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "bulk_actions_overview". */
export type bulk_actions_overview_order_by = {
  action_plan?: InputMaybe<action_plan_order_by>;
  action_plan_id?: InputMaybe<order_by>;
  action_plan_status?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  bulk_action?: InputMaybe<bulk_action_order_by>;
  bulk_action_id?: InputMaybe<order_by>;
};

/** select columns of table "bulk_actions_overview" */
export enum bulk_actions_overview_select_column {
  /** column name */
  action_plan_id = 'action_plan_id',
  /** column name */
  action_plan_status = 'action_plan_status',
  /** column name */
  building_id = 'building_id',
  /** column name */
  bulk_action_id = 'bulk_action_id',
}

/** aggregate stddev on columns */
export type bulk_actions_overview_stddev_fields = {
  action_plan_id?: Maybe<Scalars['Float']['output']>;
  building_id?: Maybe<Scalars['Float']['output']>;
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type bulk_actions_overview_stddev_pop_fields = {
  action_plan_id?: Maybe<Scalars['Float']['output']>;
  building_id?: Maybe<Scalars['Float']['output']>;
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type bulk_actions_overview_stddev_samp_fields = {
  action_plan_id?: Maybe<Scalars['Float']['output']>;
  building_id?: Maybe<Scalars['Float']['output']>;
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "bulk_actions_overview" */
export type bulk_actions_overview_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: bulk_actions_overview_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type bulk_actions_overview_stream_cursor_value_input = {
  action_plan_id?: InputMaybe<Scalars['Int']['input']>;
  action_plan_status?: InputMaybe<Scalars['String']['input']>;
  building_id?: InputMaybe<Scalars['Int']['input']>;
  bulk_action_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type bulk_actions_overview_sum_fields = {
  action_plan_id?: Maybe<Scalars['Int']['output']>;
  building_id?: Maybe<Scalars['Int']['output']>;
  bulk_action_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type bulk_actions_overview_var_pop_fields = {
  action_plan_id?: Maybe<Scalars['Float']['output']>;
  building_id?: Maybe<Scalars['Float']['output']>;
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type bulk_actions_overview_var_samp_fields = {
  action_plan_id?: Maybe<Scalars['Float']['output']>;
  building_id?: Maybe<Scalars['Float']['output']>;
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type bulk_actions_overview_variance_fields = {
  action_plan_id?: Maybe<Scalars['Float']['output']>;
  building_id?: Maybe<Scalars['Float']['output']>;
  bulk_action_id?: Maybe<Scalars['Float']['output']>;
};

/** A unique delivery address string encountered across CBI invoices. Used to match invoice line items to buildings. */
export type cbi_address = {
  /** Raw address text as extracted from invoices. */
  address_string: Scalars['String']['output'];
  /** An array relationship */
  assignments: Array<cbi_address_assignment>;
  /** An aggregate relationship */
  assignments_aggregate: cbi_address_assignment_aggregate;
  /** An array relationship */
  consumption_lines: Array<cbi_consumption_line>;
  /** An aggregate relationship */
  consumption_lines_aggregate: cbi_consumption_line_aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  org: org;
  /** Organization that owns this address record. */
  org_id: Scalars['Int']['output'];
  /** An array relationship */
  potential_matches: Array<cbi_potential_building_match>;
  updated_at: Scalars['timestamptz']['output'];
};

/** A unique delivery address string encountered across CBI invoices. Used to match invoice line items to buildings. */
export type cbi_addressassignmentsArgs = {
  distinct_on?: InputMaybe<Array<cbi_address_assignment_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_address_assignment_order_by>>;
  where?: InputMaybe<cbi_address_assignment_bool_exp>;
};

/** A unique delivery address string encountered across CBI invoices. Used to match invoice line items to buildings. */
export type cbi_addressassignments_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_address_assignment_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_address_assignment_order_by>>;
  where?: InputMaybe<cbi_address_assignment_bool_exp>;
};

/** A unique delivery address string encountered across CBI invoices. Used to match invoice line items to buildings. */
export type cbi_addressconsumption_linesArgs = {
  distinct_on?: InputMaybe<Array<cbi_consumption_line_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_consumption_line_order_by>>;
  where?: InputMaybe<cbi_consumption_line_bool_exp>;
};

/** A unique delivery address string encountered across CBI invoices. Used to match invoice line items to buildings. */
export type cbi_addressconsumption_lines_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_consumption_line_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_consumption_line_order_by>>;
  where?: InputMaybe<cbi_consumption_line_bool_exp>;
};

/** A unique delivery address string encountered across CBI invoices. Used to match invoice line items to buildings. */
export type cbi_addresspotential_matchesArgs = {
  distinct_on?: InputMaybe<Array<cbi_potential_building_match_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_potential_building_match_order_by>>;
  where?: InputMaybe<cbi_potential_building_match_bool_exp>;
};

/** aggregated selection of "cbi_address" */
export type cbi_address_aggregate = {
  aggregate?: Maybe<cbi_address_aggregate_fields>;
  nodes: Array<cbi_address>;
};

/** aggregate fields of "cbi_address" */
export type cbi_address_aggregate_fields = {
  avg?: Maybe<cbi_address_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<cbi_address_max_fields>;
  min?: Maybe<cbi_address_min_fields>;
  stddev?: Maybe<cbi_address_stddev_fields>;
  stddev_pop?: Maybe<cbi_address_stddev_pop_fields>;
  stddev_samp?: Maybe<cbi_address_stddev_samp_fields>;
  sum?: Maybe<cbi_address_sum_fields>;
  var_pop?: Maybe<cbi_address_var_pop_fields>;
  var_samp?: Maybe<cbi_address_var_samp_fields>;
  variance?: Maybe<cbi_address_variance_fields>;
};

/** aggregate fields of "cbi_address" */
export type cbi_address_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<cbi_address_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Confirmed mapping of a CBI address to a specific building and optional area. Created by user confirmation or auto-assignment. */
export type cbi_address_assignment = {
  /** An object relationship */
  area?: Maybe<area>;
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  building: building;
  /** The building this address is assigned to. */
  building_id: Scalars['Int']['output'];
  /** An object relationship */
  cbi_address: cbi_address;
  /** The CBI address being assigned. */
  cbi_address_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "cbi_address_assignment" */
export type cbi_address_assignment_aggregate = {
  aggregate?: Maybe<cbi_address_assignment_aggregate_fields>;
  nodes: Array<cbi_address_assignment>;
};

export type cbi_address_assignment_aggregate_bool_exp = {
  count?: InputMaybe<cbi_address_assignment_aggregate_bool_exp_count>;
};

export type cbi_address_assignment_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<cbi_address_assignment_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_address_assignment_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "cbi_address_assignment" */
export type cbi_address_assignment_aggregate_fields = {
  avg?: Maybe<cbi_address_assignment_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<cbi_address_assignment_max_fields>;
  min?: Maybe<cbi_address_assignment_min_fields>;
  stddev?: Maybe<cbi_address_assignment_stddev_fields>;
  stddev_pop?: Maybe<cbi_address_assignment_stddev_pop_fields>;
  stddev_samp?: Maybe<cbi_address_assignment_stddev_samp_fields>;
  sum?: Maybe<cbi_address_assignment_sum_fields>;
  var_pop?: Maybe<cbi_address_assignment_var_pop_fields>;
  var_samp?: Maybe<cbi_address_assignment_var_samp_fields>;
  variance?: Maybe<cbi_address_assignment_variance_fields>;
};

/** aggregate fields of "cbi_address_assignment" */
export type cbi_address_assignment_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<cbi_address_assignment_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cbi_address_assignment" */
export type cbi_address_assignment_aggregate_order_by = {
  avg?: InputMaybe<cbi_address_assignment_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<cbi_address_assignment_max_order_by>;
  min?: InputMaybe<cbi_address_assignment_min_order_by>;
  stddev?: InputMaybe<cbi_address_assignment_stddev_order_by>;
  stddev_pop?: InputMaybe<cbi_address_assignment_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<cbi_address_assignment_stddev_samp_order_by>;
  sum?: InputMaybe<cbi_address_assignment_sum_order_by>;
  var_pop?: InputMaybe<cbi_address_assignment_var_pop_order_by>;
  var_samp?: InputMaybe<cbi_address_assignment_var_samp_order_by>;
  variance?: InputMaybe<cbi_address_assignment_variance_order_by>;
};

/** aggregate avg on columns */
export type cbi_address_assignment_avg_fields = {
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Float']['output']>;
  /** The building this address is assigned to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The CBI address being assigned. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cbi_address_assignment" */
export type cbi_address_assignment_avg_order_by = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<order_by>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "cbi_address_assignment". All fields are combined with a logical 'AND'. */
export type cbi_address_assignment_bool_exp = {
  _and?: InputMaybe<Array<cbi_address_assignment_bool_exp>>;
  _not?: InputMaybe<cbi_address_assignment_bool_exp>;
  _or?: InputMaybe<Array<cbi_address_assignment_bool_exp>>;
  area?: InputMaybe<area_bool_exp>;
  area_id?: InputMaybe<Int_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  cbi_address?: InputMaybe<cbi_address_bool_exp>;
  cbi_address_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type cbi_address_assignment_max_fields = {
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Int']['output']>;
  /** The building this address is assigned to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** The CBI address being assigned. */
  cbi_address_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cbi_address_assignment" */
export type cbi_address_assignment_max_order_by = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<order_by>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type cbi_address_assignment_min_fields = {
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Int']['output']>;
  /** The building this address is assigned to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** The CBI address being assigned. */
  cbi_address_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cbi_address_assignment" */
export type cbi_address_assignment_min_order_by = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<order_by>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "cbi_address_assignment". */
export type cbi_address_assignment_order_by = {
  area?: InputMaybe<area_order_by>;
  area_id?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  cbi_address?: InputMaybe<cbi_address_order_by>;
  cbi_address_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "cbi_address_assignment" */
export enum cbi_address_assignment_select_column {
  /** column name */
  area_id = 'area_id',
  /** column name */
  building_id = 'building_id',
  /** column name */
  cbi_address_id = 'cbi_address_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate stddev on columns */
export type cbi_address_assignment_stddev_fields = {
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Float']['output']>;
  /** The building this address is assigned to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The CBI address being assigned. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cbi_address_assignment" */
export type cbi_address_assignment_stddev_order_by = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<order_by>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type cbi_address_assignment_stddev_pop_fields = {
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Float']['output']>;
  /** The building this address is assigned to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The CBI address being assigned. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cbi_address_assignment" */
export type cbi_address_assignment_stddev_pop_order_by = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<order_by>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type cbi_address_assignment_stddev_samp_fields = {
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Float']['output']>;
  /** The building this address is assigned to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The CBI address being assigned. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cbi_address_assignment" */
export type cbi_address_assignment_stddev_samp_order_by = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<order_by>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "cbi_address_assignment" */
export type cbi_address_assignment_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_address_assignment_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_address_assignment_stream_cursor_value_input = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<Scalars['Int']['input']>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type cbi_address_assignment_sum_fields = {
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Int']['output']>;
  /** The building this address is assigned to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** The CBI address being assigned. */
  cbi_address_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cbi_address_assignment" */
export type cbi_address_assignment_sum_order_by = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<order_by>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type cbi_address_assignment_var_pop_fields = {
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Float']['output']>;
  /** The building this address is assigned to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The CBI address being assigned. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cbi_address_assignment" */
export type cbi_address_assignment_var_pop_order_by = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<order_by>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type cbi_address_assignment_var_samp_fields = {
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Float']['output']>;
  /** The building this address is assigned to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The CBI address being assigned. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cbi_address_assignment" */
export type cbi_address_assignment_var_samp_order_by = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<order_by>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type cbi_address_assignment_variance_fields = {
  /** Optional specific area within the building this address maps to. */
  area_id?: Maybe<Scalars['Float']['output']>;
  /** The building this address is assigned to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The CBI address being assigned. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cbi_address_assignment" */
export type cbi_address_assignment_variance_order_by = {
  /** Optional specific area within the building this address maps to. */
  area_id?: InputMaybe<order_by>;
  /** The building this address is assigned to. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address being assigned. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate avg on columns */
export type cbi_address_avg_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this address record. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cbi_address". All fields are combined with a logical 'AND'. */
export type cbi_address_bool_exp = {
  _and?: InputMaybe<Array<cbi_address_bool_exp>>;
  _not?: InputMaybe<cbi_address_bool_exp>;
  _or?: InputMaybe<Array<cbi_address_bool_exp>>;
  address_string?: InputMaybe<String_comparison_exp>;
  assignments?: InputMaybe<cbi_address_assignment_bool_exp>;
  assignments_aggregate?: InputMaybe<cbi_address_assignment_aggregate_bool_exp>;
  consumption_lines?: InputMaybe<cbi_consumption_line_bool_exp>;
  consumption_lines_aggregate?: InputMaybe<cbi_consumption_line_aggregate_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  potential_matches?: InputMaybe<cbi_potential_building_match_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type cbi_address_max_fields = {
  /** Raw address text as extracted from invoices. */
  address_string?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization that owns this address record. */
  org_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type cbi_address_min_fields = {
  /** Raw address text as extracted from invoices. */
  address_string?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization that owns this address record. */
  org_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "cbi_address". */
export type cbi_address_order_by = {
  address_string?: InputMaybe<order_by>;
  assignments_aggregate?: InputMaybe<cbi_address_assignment_aggregate_order_by>;
  consumption_lines_aggregate?: InputMaybe<cbi_consumption_line_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  potential_matches_aggregate?: InputMaybe<cbi_potential_building_match_aggregate_order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "cbi_address" */
export enum cbi_address_select_column {
  /** column name */
  address_string = 'address_string',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  org_id = 'org_id',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate stddev on columns */
export type cbi_address_stddev_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this address record. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type cbi_address_stddev_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this address record. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type cbi_address_stddev_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this address record. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "cbi_address" */
export type cbi_address_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_address_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_address_stream_cursor_value_input = {
  /** Raw address text as extracted from invoices. */
  address_string?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization that owns this address record. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type cbi_address_sum_fields = {
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization that owns this address record. */
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type cbi_address_var_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this address record. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type cbi_address_var_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this address record. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type cbi_address_variance_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this address record. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "cbi_billable_event" */
export type cbi_billable_event = {
  billing_period_id: Scalars['Int']['output'];
  /** An object relationship */
  cbi_billing_period: cbi_billing_period;
  /** An object relationship */
  cbi_invoice_snapshot?: Maybe<cbi_invoice_snapshot>;
  created_at: Scalars['timestamptz']['output'];
  event_type: cbi_billable_event_type_enum;
  id: Scalars['Int']['output'];
  invoice_id?: Maybe<Scalars['Int']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Int']['output']>;
  snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  void_reason_type?: Maybe<cbi_billable_event_void_type_enum>;
  voided_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "cbi_billable_event" */
export type cbi_billable_event_aggregate = {
  aggregate?: Maybe<cbi_billable_event_aggregate_fields>;
  nodes: Array<cbi_billable_event>;
};

export type cbi_billable_event_aggregate_bool_exp = {
  count?: InputMaybe<cbi_billable_event_aggregate_bool_exp_count>;
};

export type cbi_billable_event_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<cbi_billable_event_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_billable_event_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "cbi_billable_event" */
export type cbi_billable_event_aggregate_fields = {
  avg?: Maybe<cbi_billable_event_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<cbi_billable_event_max_fields>;
  min?: Maybe<cbi_billable_event_min_fields>;
  stddev?: Maybe<cbi_billable_event_stddev_fields>;
  stddev_pop?: Maybe<cbi_billable_event_stddev_pop_fields>;
  stddev_samp?: Maybe<cbi_billable_event_stddev_samp_fields>;
  sum?: Maybe<cbi_billable_event_sum_fields>;
  var_pop?: Maybe<cbi_billable_event_var_pop_fields>;
  var_samp?: Maybe<cbi_billable_event_var_samp_fields>;
  variance?: Maybe<cbi_billable_event_variance_fields>;
};

/** aggregate fields of "cbi_billable_event" */
export type cbi_billable_event_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<cbi_billable_event_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cbi_billable_event" */
export type cbi_billable_event_aggregate_order_by = {
  avg?: InputMaybe<cbi_billable_event_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<cbi_billable_event_max_order_by>;
  min?: InputMaybe<cbi_billable_event_min_order_by>;
  stddev?: InputMaybe<cbi_billable_event_stddev_order_by>;
  stddev_pop?: InputMaybe<cbi_billable_event_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<cbi_billable_event_stddev_samp_order_by>;
  sum?: InputMaybe<cbi_billable_event_sum_order_by>;
  var_pop?: InputMaybe<cbi_billable_event_var_pop_order_by>;
  var_samp?: InputMaybe<cbi_billable_event_var_samp_order_by>;
  variance?: InputMaybe<cbi_billable_event_variance_order_by>;
};

/** aggregate avg on columns */
export type cbi_billable_event_avg_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Float']['output']>;
  snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cbi_billable_event" */
export type cbi_billable_event_avg_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "cbi_billable_event". All fields are combined with a logical 'AND'. */
export type cbi_billable_event_bool_exp = {
  _and?: InputMaybe<Array<cbi_billable_event_bool_exp>>;
  _not?: InputMaybe<cbi_billable_event_bool_exp>;
  _or?: InputMaybe<Array<cbi_billable_event_bool_exp>>;
  billing_period_id?: InputMaybe<Int_comparison_exp>;
  cbi_billing_period?: InputMaybe<cbi_billing_period_bool_exp>;
  cbi_invoice_snapshot?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  event_type?: InputMaybe<cbi_billable_event_type_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  invoice_id?: InputMaybe<Int_comparison_exp>;
  invoice_id_persistent?: InputMaybe<Int_comparison_exp>;
  snapshot_id?: InputMaybe<Int_comparison_exp>;
  snapshot_id_persistent?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  void_reason_type?: InputMaybe<cbi_billable_event_void_type_enum_comparison_exp>;
  voided_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type cbi_billable_event_max_fields = {
  billing_period_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoice_id?: Maybe<Scalars['Int']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Int']['output']>;
  snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  voided_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cbi_billable_event" */
export type cbi_billable_event_max_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  voided_at?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type cbi_billable_event_min_fields = {
  billing_period_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoice_id?: Maybe<Scalars['Int']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Int']['output']>;
  snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  voided_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cbi_billable_event" */
export type cbi_billable_event_min_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  voided_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "cbi_billable_event". */
export type cbi_billable_event_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  cbi_billing_period?: InputMaybe<cbi_billing_period_order_by>;
  cbi_invoice_snapshot?: InputMaybe<cbi_invoice_snapshot_order_by>;
  created_at?: InputMaybe<order_by>;
  event_type?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  snapshot_id_persistent?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  void_reason_type?: InputMaybe<order_by>;
  voided_at?: InputMaybe<order_by>;
};

/** select columns of table "cbi_billable_event" */
export enum cbi_billable_event_select_column {
  /** column name */
  billing_period_id = 'billing_period_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  event_type = 'event_type',
  /** column name */
  id = 'id',
  /** column name */
  invoice_id = 'invoice_id',
  /** column name */
  invoice_id_persistent = 'invoice_id_persistent',
  /** column name */
  snapshot_id = 'snapshot_id',
  /** column name */
  snapshot_id_persistent = 'snapshot_id_persistent',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  void_reason_type = 'void_reason_type',
  /** column name */
  voided_at = 'voided_at',
}

/** aggregate stddev on columns */
export type cbi_billable_event_stddev_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Float']['output']>;
  snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cbi_billable_event" */
export type cbi_billable_event_stddev_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type cbi_billable_event_stddev_pop_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Float']['output']>;
  snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cbi_billable_event" */
export type cbi_billable_event_stddev_pop_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type cbi_billable_event_stddev_samp_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Float']['output']>;
  snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cbi_billable_event" */
export type cbi_billable_event_stddev_samp_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "cbi_billable_event" */
export type cbi_billable_event_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_billable_event_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_billable_event_stream_cursor_value_input = {
  billing_period_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<cbi_billable_event_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<Scalars['Int']['input']>;
  snapshot_id?: InputMaybe<Scalars['Int']['input']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  void_reason_type?: InputMaybe<cbi_billable_event_void_type_enum>;
  voided_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type cbi_billable_event_sum_fields = {
  billing_period_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoice_id?: Maybe<Scalars['Int']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Int']['output']>;
  snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cbi_billable_event" */
export type cbi_billable_event_sum_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<order_by>;
};

export enum cbi_billable_event_type_enum {
  DIRECT_UPLOAD_RECEIVED = 'DIRECT_UPLOAD_RECEIVED',
  EMAIL_RECEIVED = 'EMAIL_RECEIVED',
  USER_BATCH_RETRY = 'USER_BATCH_RETRY',
  USER_RETRY = 'USER_RETRY',
}

/** Boolean expression to compare columns of type "cbi_billable_event_type_enum". All fields are combined with logical 'AND'. */
export type cbi_billable_event_type_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_billable_event_type_enum>;
  _in?: InputMaybe<Array<cbi_billable_event_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_billable_event_type_enum>;
  _nin?: InputMaybe<Array<cbi_billable_event_type_enum>>;
};

/** aggregate var_pop on columns */
export type cbi_billable_event_var_pop_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Float']['output']>;
  snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cbi_billable_event" */
export type cbi_billable_event_var_pop_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type cbi_billable_event_var_samp_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Float']['output']>;
  snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cbi_billable_event" */
export type cbi_billable_event_var_samp_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type cbi_billable_event_variance_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: Maybe<Scalars['Float']['output']>;
  snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cbi_billable_event" */
export type cbi_billable_event_variance_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  /** Persists the original invoice_id in case of an invoice deletion. */
  invoice_id_persistent?: InputMaybe<order_by>;
  snapshot_id?: InputMaybe<order_by>;
  /** Persists the original snapshot_id in case of a snapshot deletion. */
  snapshot_id_persistent?: InputMaybe<order_by>;
};

export enum cbi_billable_event_void_type_enum {
  EXTRACTION_FAILED = 'EXTRACTION_FAILED',
  MANUALLY_VOIDED = 'MANUALLY_VOIDED',
}

/** Boolean expression to compare columns of type "cbi_billable_event_void_type_enum". All fields are combined with logical 'AND'. */
export type cbi_billable_event_void_type_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_billable_event_void_type_enum>;
  _in?: InputMaybe<Array<cbi_billable_event_void_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_billable_event_void_type_enum>;
  _nin?: InputMaybe<Array<cbi_billable_event_void_type_enum>>;
};

/** columns and relationships of "cbi_billing_increment_event" */
export type cbi_billing_increment_event = {
  billing_period_id: Scalars['Int']['output'];
  /** An object relationship */
  cbi_billing_period: cbi_billing_period;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  new_limit: Scalars['Int']['output'];
  previous_limit: Scalars['Int']['output'];
};

/** aggregated selection of "cbi_billing_increment_event" */
export type cbi_billing_increment_event_aggregate = {
  aggregate?: Maybe<cbi_billing_increment_event_aggregate_fields>;
  nodes: Array<cbi_billing_increment_event>;
};

export type cbi_billing_increment_event_aggregate_bool_exp = {
  count?: InputMaybe<cbi_billing_increment_event_aggregate_bool_exp_count>;
};

export type cbi_billing_increment_event_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<cbi_billing_increment_event_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_billing_increment_event_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "cbi_billing_increment_event" */
export type cbi_billing_increment_event_aggregate_fields = {
  avg?: Maybe<cbi_billing_increment_event_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<cbi_billing_increment_event_max_fields>;
  min?: Maybe<cbi_billing_increment_event_min_fields>;
  stddev?: Maybe<cbi_billing_increment_event_stddev_fields>;
  stddev_pop?: Maybe<cbi_billing_increment_event_stddev_pop_fields>;
  stddev_samp?: Maybe<cbi_billing_increment_event_stddev_samp_fields>;
  sum?: Maybe<cbi_billing_increment_event_sum_fields>;
  var_pop?: Maybe<cbi_billing_increment_event_var_pop_fields>;
  var_samp?: Maybe<cbi_billing_increment_event_var_samp_fields>;
  variance?: Maybe<cbi_billing_increment_event_variance_fields>;
};

/** aggregate fields of "cbi_billing_increment_event" */
export type cbi_billing_increment_event_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<cbi_billing_increment_event_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_aggregate_order_by = {
  avg?: InputMaybe<cbi_billing_increment_event_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<cbi_billing_increment_event_max_order_by>;
  min?: InputMaybe<cbi_billing_increment_event_min_order_by>;
  stddev?: InputMaybe<cbi_billing_increment_event_stddev_order_by>;
  stddev_pop?: InputMaybe<cbi_billing_increment_event_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<cbi_billing_increment_event_stddev_samp_order_by>;
  sum?: InputMaybe<cbi_billing_increment_event_sum_order_by>;
  var_pop?: InputMaybe<cbi_billing_increment_event_var_pop_order_by>;
  var_samp?: InputMaybe<cbi_billing_increment_event_var_samp_order_by>;
  variance?: InputMaybe<cbi_billing_increment_event_variance_order_by>;
};

/** aggregate avg on columns */
export type cbi_billing_increment_event_avg_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  new_limit?: Maybe<Scalars['Float']['output']>;
  previous_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_avg_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "cbi_billing_increment_event". All fields are combined with a logical 'AND'. */
export type cbi_billing_increment_event_bool_exp = {
  _and?: InputMaybe<Array<cbi_billing_increment_event_bool_exp>>;
  _not?: InputMaybe<cbi_billing_increment_event_bool_exp>;
  _or?: InputMaybe<Array<cbi_billing_increment_event_bool_exp>>;
  billing_period_id?: InputMaybe<Int_comparison_exp>;
  cbi_billing_period?: InputMaybe<cbi_billing_period_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  new_limit?: InputMaybe<Int_comparison_exp>;
  previous_limit?: InputMaybe<Int_comparison_exp>;
};

/** aggregate max on columns */
export type cbi_billing_increment_event_max_fields = {
  billing_period_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  new_limit?: Maybe<Scalars['Int']['output']>;
  previous_limit?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_max_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type cbi_billing_increment_event_min_fields = {
  billing_period_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  new_limit?: Maybe<Scalars['Int']['output']>;
  previous_limit?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_min_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "cbi_billing_increment_event". */
export type cbi_billing_increment_event_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  cbi_billing_period?: InputMaybe<cbi_billing_period_order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** select columns of table "cbi_billing_increment_event" */
export enum cbi_billing_increment_event_select_column {
  /** column name */
  billing_period_id = 'billing_period_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  new_limit = 'new_limit',
  /** column name */
  previous_limit = 'previous_limit',
}

/** aggregate stddev on columns */
export type cbi_billing_increment_event_stddev_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  new_limit?: Maybe<Scalars['Float']['output']>;
  previous_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_stddev_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type cbi_billing_increment_event_stddev_pop_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  new_limit?: Maybe<Scalars['Float']['output']>;
  previous_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_stddev_pop_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type cbi_billing_increment_event_stddev_samp_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  new_limit?: Maybe<Scalars['Float']['output']>;
  previous_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_stddev_samp_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_billing_increment_event_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_billing_increment_event_stream_cursor_value_input = {
  billing_period_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  new_limit?: InputMaybe<Scalars['Int']['input']>;
  previous_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type cbi_billing_increment_event_sum_fields = {
  billing_period_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  new_limit?: Maybe<Scalars['Int']['output']>;
  previous_limit?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_sum_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type cbi_billing_increment_event_var_pop_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  new_limit?: Maybe<Scalars['Float']['output']>;
  previous_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_var_pop_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type cbi_billing_increment_event_var_samp_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  new_limit?: Maybe<Scalars['Float']['output']>;
  previous_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_var_samp_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type cbi_billing_increment_event_variance_fields = {
  billing_period_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  new_limit?: Maybe<Scalars['Float']['output']>;
  previous_limit?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cbi_billing_increment_event" */
export type cbi_billing_increment_event_variance_order_by = {
  billing_period_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_limit?: InputMaybe<order_by>;
  previous_limit?: InputMaybe<order_by>;
};

/** columns and relationships of "cbi_billing_period" */
export type cbi_billing_period = {
  /** An array relationship */
  cbi_billable_events: Array<cbi_billable_event>;
  /** An aggregate relationship */
  cbi_billable_events_aggregate: cbi_billable_event_aggregate;
  /** An array relationship */
  cbi_billing_increment_events: Array<cbi_billing_increment_event>;
  /** An aggregate relationship */
  cbi_billing_increment_events_aggregate: cbi_billing_increment_event_aggregate;
  current_quota_limit: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  initial_quota: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  /** An object relationship */
  org: org;
  org_id: Scalars['Int']['output'];
  percentage_increment: Scalars['Int']['output'];
  period_end: Scalars['timestamptz']['output'];
  period_start: Scalars['timestamptz']['output'];
};

/** columns and relationships of "cbi_billing_period" */
export type cbi_billing_periodcbi_billable_eventsArgs = {
  distinct_on?: InputMaybe<Array<cbi_billable_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billable_event_order_by>>;
  where?: InputMaybe<cbi_billable_event_bool_exp>;
};

/** columns and relationships of "cbi_billing_period" */
export type cbi_billing_periodcbi_billable_events_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_billable_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billable_event_order_by>>;
  where?: InputMaybe<cbi_billable_event_bool_exp>;
};

/** columns and relationships of "cbi_billing_period" */
export type cbi_billing_periodcbi_billing_increment_eventsArgs = {
  distinct_on?: InputMaybe<Array<cbi_billing_increment_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billing_increment_event_order_by>>;
  where?: InputMaybe<cbi_billing_increment_event_bool_exp>;
};

/** columns and relationships of "cbi_billing_period" */
export type cbi_billing_periodcbi_billing_increment_events_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_billing_increment_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billing_increment_event_order_by>>;
  where?: InputMaybe<cbi_billing_increment_event_bool_exp>;
};

/** aggregated selection of "cbi_billing_period" */
export type cbi_billing_period_aggregate = {
  aggregate?: Maybe<cbi_billing_period_aggregate_fields>;
  nodes: Array<cbi_billing_period>;
};

/** aggregate fields of "cbi_billing_period" */
export type cbi_billing_period_aggregate_fields = {
  avg?: Maybe<cbi_billing_period_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<cbi_billing_period_max_fields>;
  min?: Maybe<cbi_billing_period_min_fields>;
  stddev?: Maybe<cbi_billing_period_stddev_fields>;
  stddev_pop?: Maybe<cbi_billing_period_stddev_pop_fields>;
  stddev_samp?: Maybe<cbi_billing_period_stddev_samp_fields>;
  sum?: Maybe<cbi_billing_period_sum_fields>;
  var_pop?: Maybe<cbi_billing_period_var_pop_fields>;
  var_samp?: Maybe<cbi_billing_period_var_samp_fields>;
  variance?: Maybe<cbi_billing_period_variance_fields>;
};

/** aggregate fields of "cbi_billing_period" */
export type cbi_billing_period_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<cbi_billing_period_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type cbi_billing_period_avg_fields = {
  current_quota_limit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_quota?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
  percentage_increment?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cbi_billing_period". All fields are combined with a logical 'AND'. */
export type cbi_billing_period_bool_exp = {
  _and?: InputMaybe<Array<cbi_billing_period_bool_exp>>;
  _not?: InputMaybe<cbi_billing_period_bool_exp>;
  _or?: InputMaybe<Array<cbi_billing_period_bool_exp>>;
  cbi_billable_events?: InputMaybe<cbi_billable_event_bool_exp>;
  cbi_billable_events_aggregate?: InputMaybe<cbi_billable_event_aggregate_bool_exp>;
  cbi_billing_increment_events?: InputMaybe<cbi_billing_increment_event_bool_exp>;
  cbi_billing_increment_events_aggregate?: InputMaybe<cbi_billing_increment_event_aggregate_bool_exp>;
  current_quota_limit?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  initial_quota?: InputMaybe<Int_comparison_exp>;
  is_active?: InputMaybe<Boolean_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  percentage_increment?: InputMaybe<Int_comparison_exp>;
  period_end?: InputMaybe<timestamptz_comparison_exp>;
  period_start?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type cbi_billing_period_max_fields = {
  current_quota_limit?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initial_quota?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  percentage_increment?: Maybe<Scalars['Int']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type cbi_billing_period_min_fields = {
  current_quota_limit?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initial_quota?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  percentage_increment?: Maybe<Scalars['Int']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "cbi_billing_period". */
export type cbi_billing_period_order_by = {
  cbi_billable_events_aggregate?: InputMaybe<cbi_billable_event_aggregate_order_by>;
  cbi_billing_increment_events_aggregate?: InputMaybe<cbi_billing_increment_event_aggregate_order_by>;
  current_quota_limit?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  initial_quota?: InputMaybe<order_by>;
  is_active?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  percentage_increment?: InputMaybe<order_by>;
  period_end?: InputMaybe<order_by>;
  period_start?: InputMaybe<order_by>;
};

/** select columns of table "cbi_billing_period" */
export enum cbi_billing_period_select_column {
  /** column name */
  current_quota_limit = 'current_quota_limit',
  /** column name */
  id = 'id',
  /** column name */
  initial_quota = 'initial_quota',
  /** column name */
  is_active = 'is_active',
  /** column name */
  org_id = 'org_id',
  /** column name */
  percentage_increment = 'percentage_increment',
  /** column name */
  period_end = 'period_end',
  /** column name */
  period_start = 'period_start',
}

/** aggregate stddev on columns */
export type cbi_billing_period_stddev_fields = {
  current_quota_limit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_quota?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
  percentage_increment?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type cbi_billing_period_stddev_pop_fields = {
  current_quota_limit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_quota?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
  percentage_increment?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type cbi_billing_period_stddev_samp_fields = {
  current_quota_limit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_quota?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
  percentage_increment?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "cbi_billing_period" */
export type cbi_billing_period_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_billing_period_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_billing_period_stream_cursor_value_input = {
  current_quota_limit?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  initial_quota?: InputMaybe<Scalars['Int']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  org_id?: InputMaybe<Scalars['Int']['input']>;
  percentage_increment?: InputMaybe<Scalars['Int']['input']>;
  period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  period_start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type cbi_billing_period_sum_fields = {
  current_quota_limit?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initial_quota?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
  percentage_increment?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type cbi_billing_period_var_pop_fields = {
  current_quota_limit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_quota?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
  percentage_increment?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type cbi_billing_period_var_samp_fields = {
  current_quota_limit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_quota?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
  percentage_increment?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type cbi_billing_period_variance_fields = {
  current_quota_limit?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  initial_quota?: Maybe<Scalars['Float']['output']>;
  org_id?: Maybe<Scalars['Float']['output']>;
  percentage_increment?: Maybe<Scalars['Float']['output']>;
};

/** An individual consumption line item extracted from an invoice snapshot, representing metered usage for a specific energy source, period, and address. */
export type cbi_consumption_line = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['numeric']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['numeric']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['numeric']['output']>;
  /** Raw address string as extracted from the invoice, before matching to a known building. */
  building_address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  cbi_address?: Maybe<cbi_address>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  cbi_invoice_snapshot: cbi_invoice_snapshot;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id: Scalars['Int']['output'];
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['numeric']['output']>;
  /** End of the metering period for this line item. */
  consumption_end_date?: Maybe<Scalars['date']['output']>;
  /** Start of the metering period for this line item. */
  consumption_start_date?: Maybe<Scalars['date']['output']>;
  /** Category of consumption (e.g., electricity, heating, water, waste). */
  consumption_type?: Maybe<consumption_type_enum>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['numeric']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['numeric']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['numeric']['output']>;
  /** Energy source type (e.g., natural gas, district heating, electricity). */
  energy_source?: Maybe<cbi_energy_source_type_enum>;
  /** JSON map of per-field AI extraction confidence scores returned by Alpha Prompt. */
  field_confidence_scores?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['Int']['output'];
  /** Whether this line represents an advance payment rather than a final settlement. */
  is_advance_payment?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the consumption amount is an estimate rather than a meter reading. */
  is_estimated?: Maybe<Scalars['Boolean']['output']>;
  line_index: Scalars['Int']['output'];
  /** German Marktlokations-ID (MaLo ID), an 11-digit identifier for an energy metering/delivery point. */
  market_location_id?: Maybe<Scalars['String']['output']>;
  /** Utility meter identifier as shown on the invoice. */
  meter_number?: Maybe<Scalars['String']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['numeric']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['numeric']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Which area measurement the consumption is normalized against (e.g., EBF, NF). */
  reference_area?: Maybe<cbi_reference_area_enum>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['numeric']['output']>;
  /** Unit of measurement for the consumption amount (e.g., kWh, m3). */
  unit?: Maybe<cbi_consumption_unit_enum>;
  updated_at: Scalars['timestamptz']['output'];
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['numeric']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['numeric']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['numeric']['output']>;
  waste_collection_frequency?: Maybe<Scalars['numeric']['output']>;
  waste_collection_frequency_period?: Maybe<cbi_waste_container_frequency_period_enum>;
  waste_collection_frequency_raw?: Maybe<Scalars['String']['output']>;
  waste_collections_total?: Maybe<Scalars['numeric']['output']>;
  waste_container_count?: Maybe<Scalars['numeric']['output']>;
  waste_container_size?: Maybe<Scalars['numeric']['output']>;
  waste_container_size_unit?: Maybe<cbi_waste_container_size_unit_enum>;
  waste_ewc_code?: Maybe<Scalars['String']['output']>;
  waste_quantity?: Maybe<Scalars['numeric']['output']>;
  waste_quantity_unit?: Maybe<cbi_waste_quantity_unit_enum>;
  waste_sub_type?: Maybe<cbi_waste_sub_type_enum>;
  /** Subcategory for water consumption (e.g., fresh water, wastewater). */
  water_sub_type?: Maybe<cbi_water_sub_type_enum>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['numeric']['output']>;
};

/** An individual consumption line item extracted from an invoice snapshot, representing metered usage for a specific energy source, period, and address. */
export type cbi_consumption_linefield_confidence_scoresArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cbi_consumption_line" */
export type cbi_consumption_line_aggregate = {
  aggregate?: Maybe<cbi_consumption_line_aggregate_fields>;
  nodes: Array<cbi_consumption_line>;
};

export type cbi_consumption_line_aggregate_bool_exp = {
  bool_and?: InputMaybe<cbi_consumption_line_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<cbi_consumption_line_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<cbi_consumption_line_aggregate_bool_exp_count>;
};

export type cbi_consumption_line_aggregate_bool_exp_bool_and = {
  arguments: cbi_consumption_line_select_column_cbi_consumption_line_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_consumption_line_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type cbi_consumption_line_aggregate_bool_exp_bool_or = {
  arguments: cbi_consumption_line_select_column_cbi_consumption_line_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_consumption_line_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type cbi_consumption_line_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<cbi_consumption_line_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_consumption_line_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "cbi_consumption_line" */
export type cbi_consumption_line_aggregate_fields = {
  avg?: Maybe<cbi_consumption_line_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<cbi_consumption_line_max_fields>;
  min?: Maybe<cbi_consumption_line_min_fields>;
  stddev?: Maybe<cbi_consumption_line_stddev_fields>;
  stddev_pop?: Maybe<cbi_consumption_line_stddev_pop_fields>;
  stddev_samp?: Maybe<cbi_consumption_line_stddev_samp_fields>;
  sum?: Maybe<cbi_consumption_line_sum_fields>;
  var_pop?: Maybe<cbi_consumption_line_var_pop_fields>;
  var_samp?: Maybe<cbi_consumption_line_var_samp_fields>;
  variance?: Maybe<cbi_consumption_line_variance_fields>;
};

/** aggregate fields of "cbi_consumption_line" */
export type cbi_consumption_line_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<cbi_consumption_line_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cbi_consumption_line" */
export type cbi_consumption_line_aggregate_order_by = {
  avg?: InputMaybe<cbi_consumption_line_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<cbi_consumption_line_max_order_by>;
  min?: InputMaybe<cbi_consumption_line_min_order_by>;
  stddev?: InputMaybe<cbi_consumption_line_stddev_order_by>;
  stddev_pop?: InputMaybe<cbi_consumption_line_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<cbi_consumption_line_stddev_samp_order_by>;
  sum?: InputMaybe<cbi_consumption_line_sum_order_by>;
  var_pop?: InputMaybe<cbi_consumption_line_var_pop_order_by>;
  var_samp?: InputMaybe<cbi_consumption_line_var_samp_order_by>;
  variance?: InputMaybe<cbi_consumption_line_variance_order_by>;
};

/** aggregate avg on columns */
export type cbi_consumption_line_avg_fields = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['Float']['output']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['Float']['output']>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_index?: Maybe<Scalars['Float']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Float']['output']>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_collection_frequency?: Maybe<Scalars['Float']['output']>;
  waste_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_container_count?: Maybe<Scalars['Float']['output']>;
  waste_container_size?: Maybe<Scalars['Float']['output']>;
  waste_quantity?: Maybe<Scalars['Float']['output']>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cbi_consumption_line" */
export type cbi_consumption_line_avg_order_by = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<order_by>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<order_by>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<order_by>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<order_by>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<order_by>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<order_by>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<order_by>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<order_by>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<order_by>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<order_by>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<order_by>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<order_by>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "cbi_consumption_line". All fields are combined with a logical 'AND'. */
export type cbi_consumption_line_bool_exp = {
  _and?: InputMaybe<Array<cbi_consumption_line_bool_exp>>;
  _not?: InputMaybe<cbi_consumption_line_bool_exp>;
  _or?: InputMaybe<Array<cbi_consumption_line_bool_exp>>;
  advance_payments?: InputMaybe<numeric_comparison_exp>;
  amount_payable?: InputMaybe<numeric_comparison_exp>;
  base_price_net?: InputMaybe<numeric_comparison_exp>;
  building_address?: InputMaybe<String_comparison_exp>;
  cbi_address?: InputMaybe<cbi_address_bool_exp>;
  cbi_address_id?: InputMaybe<Int_comparison_exp>;
  cbi_invoice_snapshot?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  cbi_invoice_snapshot_id?: InputMaybe<Int_comparison_exp>;
  co2_fee_gross?: InputMaybe<numeric_comparison_exp>;
  co2_fee_net?: InputMaybe<numeric_comparison_exp>;
  consumption_amount?: InputMaybe<numeric_comparison_exp>;
  consumption_end_date?: InputMaybe<date_comparison_exp>;
  consumption_start_date?: InputMaybe<date_comparison_exp>;
  consumption_type?: InputMaybe<consumption_type_enum_comparison_exp>;
  cost_gross?: InputMaybe<numeric_comparison_exp>;
  cost_net?: InputMaybe<numeric_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  credit_amount?: InputMaybe<numeric_comparison_exp>;
  emission_factor_market_based?: InputMaybe<numeric_comparison_exp>;
  energy_source?: InputMaybe<cbi_energy_source_type_enum_comparison_exp>;
  field_confidence_scores?: InputMaybe<jsonb_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  is_advance_payment?: InputMaybe<Boolean_comparison_exp>;
  is_estimated?: InputMaybe<Boolean_comparison_exp>;
  line_index?: InputMaybe<Int_comparison_exp>;
  market_location_id?: InputMaybe<String_comparison_exp>;
  meter_number?: InputMaybe<String_comparison_exp>;
  other_charges_net?: InputMaybe<numeric_comparison_exp>;
  outstanding_balance?: InputMaybe<numeric_comparison_exp>;
  position?: InputMaybe<Int_comparison_exp>;
  reference_area?: InputMaybe<cbi_reference_area_enum_comparison_exp>;
  renewable_energy_percentage?: InputMaybe<numeric_comparison_exp>;
  unit?: InputMaybe<cbi_consumption_unit_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  vat_amount?: InputMaybe<numeric_comparison_exp>;
  vat_percentage?: InputMaybe<numeric_comparison_exp>;
  waste_additional_collections_total?: InputMaybe<numeric_comparison_exp>;
  waste_collection_frequency?: InputMaybe<numeric_comparison_exp>;
  waste_collection_frequency_period?: InputMaybe<cbi_waste_container_frequency_period_enum_comparison_exp>;
  waste_collection_frequency_raw?: InputMaybe<String_comparison_exp>;
  waste_collections_total?: InputMaybe<numeric_comparison_exp>;
  waste_container_count?: InputMaybe<numeric_comparison_exp>;
  waste_container_size?: InputMaybe<numeric_comparison_exp>;
  waste_container_size_unit?: InputMaybe<cbi_waste_container_size_unit_enum_comparison_exp>;
  waste_ewc_code?: InputMaybe<String_comparison_exp>;
  waste_quantity?: InputMaybe<numeric_comparison_exp>;
  waste_quantity_unit?: InputMaybe<cbi_waste_quantity_unit_enum_comparison_exp>;
  waste_sub_type?: InputMaybe<cbi_waste_sub_type_enum_comparison_exp>;
  water_sub_type?: InputMaybe<cbi_water_sub_type_enum_comparison_exp>;
  working_price_net?: InputMaybe<numeric_comparison_exp>;
};

/** aggregate max on columns */
export type cbi_consumption_line_max_fields = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['numeric']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['numeric']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['numeric']['output']>;
  /** Raw address string as extracted from the invoice, before matching to a known building. */
  building_address?: Maybe<Scalars['String']['output']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Int']['output']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['numeric']['output']>;
  /** End of the metering period for this line item. */
  consumption_end_date?: Maybe<Scalars['date']['output']>;
  /** Start of the metering period for this line item. */
  consumption_start_date?: Maybe<Scalars['date']['output']>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['numeric']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['numeric']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  line_index?: Maybe<Scalars['Int']['output']>;
  /** German Marktlokations-ID (MaLo ID), an 11-digit identifier for an energy metering/delivery point. */
  market_location_id?: Maybe<Scalars['String']['output']>;
  /** Utility meter identifier as shown on the invoice. */
  meter_number?: Maybe<Scalars['String']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['numeric']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['numeric']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['numeric']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['numeric']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['numeric']['output']>;
  waste_collection_frequency?: Maybe<Scalars['numeric']['output']>;
  waste_collection_frequency_raw?: Maybe<Scalars['String']['output']>;
  waste_collections_total?: Maybe<Scalars['numeric']['output']>;
  waste_container_count?: Maybe<Scalars['numeric']['output']>;
  waste_container_size?: Maybe<Scalars['numeric']['output']>;
  waste_ewc_code?: Maybe<Scalars['String']['output']>;
  waste_quantity?: Maybe<Scalars['numeric']['output']>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "cbi_consumption_line" */
export type cbi_consumption_line_max_order_by = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<order_by>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<order_by>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<order_by>;
  /** Raw address string as extracted from the invoice, before matching to a known building. */
  building_address?: InputMaybe<order_by>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<order_by>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<order_by>;
  /** End of the metering period for this line item. */
  consumption_end_date?: InputMaybe<order_by>;
  /** Start of the metering period for this line item. */
  consumption_start_date?: InputMaybe<order_by>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<order_by>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<order_by>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  /** German Marktlokations-ID (MaLo ID), an 11-digit identifier for an energy metering/delivery point. */
  market_location_id?: InputMaybe<order_by>;
  /** Utility meter identifier as shown on the invoice. */
  meter_number?: InputMaybe<order_by>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<order_by>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<order_by>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<order_by>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collection_frequency_raw?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_ewc_code?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type cbi_consumption_line_min_fields = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['numeric']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['numeric']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['numeric']['output']>;
  /** Raw address string as extracted from the invoice, before matching to a known building. */
  building_address?: Maybe<Scalars['String']['output']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Int']['output']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['numeric']['output']>;
  /** End of the metering period for this line item. */
  consumption_end_date?: Maybe<Scalars['date']['output']>;
  /** Start of the metering period for this line item. */
  consumption_start_date?: Maybe<Scalars['date']['output']>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['numeric']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['numeric']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  line_index?: Maybe<Scalars['Int']['output']>;
  /** German Marktlokations-ID (MaLo ID), an 11-digit identifier for an energy metering/delivery point. */
  market_location_id?: Maybe<Scalars['String']['output']>;
  /** Utility meter identifier as shown on the invoice. */
  meter_number?: Maybe<Scalars['String']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['numeric']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['numeric']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['numeric']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['numeric']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['numeric']['output']>;
  waste_collection_frequency?: Maybe<Scalars['numeric']['output']>;
  waste_collection_frequency_raw?: Maybe<Scalars['String']['output']>;
  waste_collections_total?: Maybe<Scalars['numeric']['output']>;
  waste_container_count?: Maybe<Scalars['numeric']['output']>;
  waste_container_size?: Maybe<Scalars['numeric']['output']>;
  waste_ewc_code?: Maybe<Scalars['String']['output']>;
  waste_quantity?: Maybe<Scalars['numeric']['output']>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "cbi_consumption_line" */
export type cbi_consumption_line_min_order_by = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<order_by>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<order_by>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<order_by>;
  /** Raw address string as extracted from the invoice, before matching to a known building. */
  building_address?: InputMaybe<order_by>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<order_by>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<order_by>;
  /** End of the metering period for this line item. */
  consumption_end_date?: InputMaybe<order_by>;
  /** Start of the metering period for this line item. */
  consumption_start_date?: InputMaybe<order_by>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<order_by>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<order_by>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  /** German Marktlokations-ID (MaLo ID), an 11-digit identifier for an energy metering/delivery point. */
  market_location_id?: InputMaybe<order_by>;
  /** Utility meter identifier as shown on the invoice. */
  meter_number?: InputMaybe<order_by>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<order_by>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<order_by>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<order_by>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collection_frequency_raw?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_ewc_code?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "cbi_consumption_line". */
export type cbi_consumption_line_order_by = {
  advance_payments?: InputMaybe<order_by>;
  amount_payable?: InputMaybe<order_by>;
  base_price_net?: InputMaybe<order_by>;
  building_address?: InputMaybe<order_by>;
  cbi_address?: InputMaybe<cbi_address_order_by>;
  cbi_address_id?: InputMaybe<order_by>;
  cbi_invoice_snapshot?: InputMaybe<cbi_invoice_snapshot_order_by>;
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  co2_fee_gross?: InputMaybe<order_by>;
  co2_fee_net?: InputMaybe<order_by>;
  consumption_amount?: InputMaybe<order_by>;
  consumption_end_date?: InputMaybe<order_by>;
  consumption_start_date?: InputMaybe<order_by>;
  consumption_type?: InputMaybe<order_by>;
  cost_gross?: InputMaybe<order_by>;
  cost_net?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  credit_amount?: InputMaybe<order_by>;
  emission_factor_market_based?: InputMaybe<order_by>;
  energy_source?: InputMaybe<order_by>;
  field_confidence_scores?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  is_advance_payment?: InputMaybe<order_by>;
  is_estimated?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  market_location_id?: InputMaybe<order_by>;
  meter_number?: InputMaybe<order_by>;
  other_charges_net?: InputMaybe<order_by>;
  outstanding_balance?: InputMaybe<order_by>;
  position?: InputMaybe<order_by>;
  reference_area?: InputMaybe<order_by>;
  renewable_energy_percentage?: InputMaybe<order_by>;
  unit?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  vat_amount?: InputMaybe<order_by>;
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collection_frequency_period?: InputMaybe<order_by>;
  waste_collection_frequency_raw?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_container_size_unit?: InputMaybe<order_by>;
  waste_ewc_code?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  waste_quantity_unit?: InputMaybe<order_by>;
  waste_sub_type?: InputMaybe<order_by>;
  water_sub_type?: InputMaybe<order_by>;
  working_price_net?: InputMaybe<order_by>;
};

/** select columns of table "cbi_consumption_line" */
export enum cbi_consumption_line_select_column {
  /** column name */
  advance_payments = 'advance_payments',
  /** column name */
  amount_payable = 'amount_payable',
  /** column name */
  base_price_net = 'base_price_net',
  /** column name */
  building_address = 'building_address',
  /** column name */
  cbi_address_id = 'cbi_address_id',
  /** column name */
  cbi_invoice_snapshot_id = 'cbi_invoice_snapshot_id',
  /** column name */
  co2_fee_gross = 'co2_fee_gross',
  /** column name */
  co2_fee_net = 'co2_fee_net',
  /** column name */
  consumption_amount = 'consumption_amount',
  /** column name */
  consumption_end_date = 'consumption_end_date',
  /** column name */
  consumption_start_date = 'consumption_start_date',
  /** column name */
  consumption_type = 'consumption_type',
  /** column name */
  cost_gross = 'cost_gross',
  /** column name */
  cost_net = 'cost_net',
  /** column name */
  created_at = 'created_at',
  /** column name */
  credit_amount = 'credit_amount',
  /** column name */
  emission_factor_market_based = 'emission_factor_market_based',
  /** column name */
  energy_source = 'energy_source',
  /** column name */
  field_confidence_scores = 'field_confidence_scores',
  /** column name */
  id = 'id',
  /** column name */
  is_advance_payment = 'is_advance_payment',
  /** column name */
  is_estimated = 'is_estimated',
  /** column name */
  line_index = 'line_index',
  /** column name */
  market_location_id = 'market_location_id',
  /** column name */
  meter_number = 'meter_number',
  /** column name */
  other_charges_net = 'other_charges_net',
  /** column name */
  outstanding_balance = 'outstanding_balance',
  /** column name */
  position = 'position',
  /** column name */
  reference_area = 'reference_area',
  /** column name */
  renewable_energy_percentage = 'renewable_energy_percentage',
  /** column name */
  unit = 'unit',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  vat_amount = 'vat_amount',
  /** column name */
  vat_percentage = 'vat_percentage',
  /** column name */
  waste_additional_collections_total = 'waste_additional_collections_total',
  /** column name */
  waste_collection_frequency = 'waste_collection_frequency',
  /** column name */
  waste_collection_frequency_period = 'waste_collection_frequency_period',
  /** column name */
  waste_collection_frequency_raw = 'waste_collection_frequency_raw',
  /** column name */
  waste_collections_total = 'waste_collections_total',
  /** column name */
  waste_container_count = 'waste_container_count',
  /** column name */
  waste_container_size = 'waste_container_size',
  /** column name */
  waste_container_size_unit = 'waste_container_size_unit',
  /** column name */
  waste_ewc_code = 'waste_ewc_code',
  /** column name */
  waste_quantity = 'waste_quantity',
  /** column name */
  waste_quantity_unit = 'waste_quantity_unit',
  /** column name */
  waste_sub_type = 'waste_sub_type',
  /** column name */
  water_sub_type = 'water_sub_type',
  /** column name */
  working_price_net = 'working_price_net',
}

/** select "cbi_consumption_line_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cbi_consumption_line" */
export enum cbi_consumption_line_select_column_cbi_consumption_line_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  is_advance_payment = 'is_advance_payment',
  /** column name */
  is_estimated = 'is_estimated',
}

/** select "cbi_consumption_line_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cbi_consumption_line" */
export enum cbi_consumption_line_select_column_cbi_consumption_line_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  is_advance_payment = 'is_advance_payment',
  /** column name */
  is_estimated = 'is_estimated',
}

/** aggregate stddev on columns */
export type cbi_consumption_line_stddev_fields = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['Float']['output']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['Float']['output']>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_index?: Maybe<Scalars['Float']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Float']['output']>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_collection_frequency?: Maybe<Scalars['Float']['output']>;
  waste_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_container_count?: Maybe<Scalars['Float']['output']>;
  waste_container_size?: Maybe<Scalars['Float']['output']>;
  waste_quantity?: Maybe<Scalars['Float']['output']>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cbi_consumption_line" */
export type cbi_consumption_line_stddev_order_by = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<order_by>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<order_by>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<order_by>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<order_by>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<order_by>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<order_by>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<order_by>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<order_by>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<order_by>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<order_by>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<order_by>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<order_by>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type cbi_consumption_line_stddev_pop_fields = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['Float']['output']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['Float']['output']>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_index?: Maybe<Scalars['Float']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Float']['output']>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_collection_frequency?: Maybe<Scalars['Float']['output']>;
  waste_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_container_count?: Maybe<Scalars['Float']['output']>;
  waste_container_size?: Maybe<Scalars['Float']['output']>;
  waste_quantity?: Maybe<Scalars['Float']['output']>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cbi_consumption_line" */
export type cbi_consumption_line_stddev_pop_order_by = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<order_by>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<order_by>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<order_by>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<order_by>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<order_by>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<order_by>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<order_by>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<order_by>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<order_by>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<order_by>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<order_by>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<order_by>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type cbi_consumption_line_stddev_samp_fields = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['Float']['output']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['Float']['output']>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_index?: Maybe<Scalars['Float']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Float']['output']>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_collection_frequency?: Maybe<Scalars['Float']['output']>;
  waste_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_container_count?: Maybe<Scalars['Float']['output']>;
  waste_container_size?: Maybe<Scalars['Float']['output']>;
  waste_quantity?: Maybe<Scalars['Float']['output']>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cbi_consumption_line" */
export type cbi_consumption_line_stddev_samp_order_by = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<order_by>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<order_by>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<order_by>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<order_by>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<order_by>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<order_by>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<order_by>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<order_by>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<order_by>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<order_by>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<order_by>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<order_by>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "cbi_consumption_line" */
export type cbi_consumption_line_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_consumption_line_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_consumption_line_stream_cursor_value_input = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<Scalars['numeric']['input']>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<Scalars['numeric']['input']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<Scalars['numeric']['input']>;
  /** Raw address string as extracted from the invoice, before matching to a known building. */
  building_address?: InputMaybe<Scalars['String']['input']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<Scalars['Int']['input']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<Scalars['Int']['input']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<Scalars['numeric']['input']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<Scalars['numeric']['input']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<Scalars['numeric']['input']>;
  /** End of the metering period for this line item. */
  consumption_end_date?: InputMaybe<Scalars['date']['input']>;
  /** Start of the metering period for this line item. */
  consumption_start_date?: InputMaybe<Scalars['date']['input']>;
  /** Category of consumption (e.g., electricity, heating, water, waste). */
  consumption_type?: InputMaybe<consumption_type_enum>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<Scalars['numeric']['input']>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<Scalars['numeric']['input']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<Scalars['numeric']['input']>;
  /** Energy source type (e.g., natural gas, district heating, electricity). */
  energy_source?: InputMaybe<cbi_energy_source_type_enum>;
  /** JSON map of per-field AI extraction confidence scores returned by Alpha Prompt. */
  field_confidence_scores?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this line represents an advance payment rather than a final settlement. */
  is_advance_payment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the consumption amount is an estimate rather than a meter reading. */
  is_estimated?: InputMaybe<Scalars['Boolean']['input']>;
  line_index?: InputMaybe<Scalars['Int']['input']>;
  /** German Marktlokations-ID (MaLo ID), an 11-digit identifier for an energy metering/delivery point. */
  market_location_id?: InputMaybe<Scalars['String']['input']>;
  /** Utility meter identifier as shown on the invoice. */
  meter_number?: InputMaybe<Scalars['String']['input']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<Scalars['numeric']['input']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<Scalars['numeric']['input']>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Which area measurement the consumption is normalized against (e.g., EBF, NF). */
  reference_area?: InputMaybe<cbi_reference_area_enum>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<Scalars['numeric']['input']>;
  /** Unit of measurement for the consumption amount (e.g., kWh, m3). */
  unit?: InputMaybe<cbi_consumption_unit_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<Scalars['numeric']['input']>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<Scalars['numeric']['input']>;
  waste_additional_collections_total?: InputMaybe<Scalars['numeric']['input']>;
  waste_collection_frequency?: InputMaybe<Scalars['numeric']['input']>;
  waste_collection_frequency_period?: InputMaybe<cbi_waste_container_frequency_period_enum>;
  waste_collection_frequency_raw?: InputMaybe<Scalars['String']['input']>;
  waste_collections_total?: InputMaybe<Scalars['numeric']['input']>;
  waste_container_count?: InputMaybe<Scalars['numeric']['input']>;
  waste_container_size?: InputMaybe<Scalars['numeric']['input']>;
  waste_container_size_unit?: InputMaybe<cbi_waste_container_size_unit_enum>;
  waste_ewc_code?: InputMaybe<Scalars['String']['input']>;
  waste_quantity?: InputMaybe<Scalars['numeric']['input']>;
  waste_quantity_unit?: InputMaybe<cbi_waste_quantity_unit_enum>;
  waste_sub_type?: InputMaybe<cbi_waste_sub_type_enum>;
  /** Subcategory for water consumption (e.g., fresh water, wastewater). */
  water_sub_type?: InputMaybe<cbi_water_sub_type_enum>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type cbi_consumption_line_sum_fields = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['numeric']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['numeric']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['numeric']['output']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Int']['output']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['numeric']['output']>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['numeric']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['numeric']['output']>;
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['numeric']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  line_index?: Maybe<Scalars['Int']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['numeric']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['numeric']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['numeric']['output']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['numeric']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['numeric']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['numeric']['output']>;
  waste_collection_frequency?: Maybe<Scalars['numeric']['output']>;
  waste_collections_total?: Maybe<Scalars['numeric']['output']>;
  waste_container_count?: Maybe<Scalars['numeric']['output']>;
  waste_container_size?: Maybe<Scalars['numeric']['output']>;
  waste_quantity?: Maybe<Scalars['numeric']['output']>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "cbi_consumption_line" */
export type cbi_consumption_line_sum_order_by = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<order_by>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<order_by>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<order_by>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<order_by>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<order_by>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<order_by>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<order_by>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<order_by>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<order_by>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<order_by>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<order_by>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<order_by>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type cbi_consumption_line_var_pop_fields = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['Float']['output']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['Float']['output']>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_index?: Maybe<Scalars['Float']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Float']['output']>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_collection_frequency?: Maybe<Scalars['Float']['output']>;
  waste_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_container_count?: Maybe<Scalars['Float']['output']>;
  waste_container_size?: Maybe<Scalars['Float']['output']>;
  waste_quantity?: Maybe<Scalars['Float']['output']>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cbi_consumption_line" */
export type cbi_consumption_line_var_pop_order_by = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<order_by>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<order_by>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<order_by>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<order_by>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<order_by>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<order_by>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<order_by>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<order_by>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<order_by>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<order_by>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<order_by>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<order_by>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type cbi_consumption_line_var_samp_fields = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['Float']['output']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['Float']['output']>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_index?: Maybe<Scalars['Float']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Float']['output']>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_collection_frequency?: Maybe<Scalars['Float']['output']>;
  waste_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_container_count?: Maybe<Scalars['Float']['output']>;
  waste_container_size?: Maybe<Scalars['Float']['output']>;
  waste_quantity?: Maybe<Scalars['Float']['output']>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cbi_consumption_line" */
export type cbi_consumption_line_var_samp_order_by = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<order_by>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<order_by>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<order_by>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<order_by>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<order_by>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<order_by>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<order_by>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<order_by>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<order_by>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<order_by>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<order_by>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<order_by>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type cbi_consumption_line_variance_fields = {
  /** Advance payments allocated to this line item. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final payable amount for this line item. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: Maybe<Scalars['Float']['output']>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: Maybe<Scalars['Float']['output']>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: Maybe<Scalars['Float']['output']>;
  /** Line item cost including tax. */
  cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Line item cost before tax. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** Credit applied to this line item. */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  line_index?: Maybe<Scalars['Float']['output']>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance for this line item. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Order of this line item within the invoice. */
  position?: Maybe<Scalars['Float']['output']>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** VAT rate for this line item. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
  waste_additional_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_collection_frequency?: Maybe<Scalars['Float']['output']>;
  waste_collections_total?: Maybe<Scalars['Float']['output']>;
  waste_container_count?: Maybe<Scalars['Float']['output']>;
  waste_container_size?: Maybe<Scalars['Float']['output']>;
  waste_quantity?: Maybe<Scalars['Float']['output']>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cbi_consumption_line" */
export type cbi_consumption_line_variance_order_by = {
  /** Advance payments allocated to this line item. */
  advance_payments?: InputMaybe<order_by>;
  /** Final payable amount for this line item. */
  amount_payable?: InputMaybe<order_by>;
  /** Fixed base price (Grundpreis) before tax, independent of consumption. */
  base_price_net?: InputMaybe<order_by>;
  /** Matched CBI address record for this line item. */
  cbi_address_id?: InputMaybe<order_by>;
  /** The invoice snapshot this line belongs to. */
  cbi_invoice_snapshot_id?: InputMaybe<order_by>;
  /** CO2 levy including tax for this line item. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy before tax for this line item. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Measured consumption quantity for this line item. */
  consumption_amount?: InputMaybe<order_by>;
  /** Line item cost including tax. */
  cost_gross?: InputMaybe<order_by>;
  /** Line item cost before tax. */
  cost_net?: InputMaybe<order_by>;
  /** Credit applied to this line item. */
  credit_amount?: InputMaybe<order_by>;
  /** Market-based CO2 emission factor from the supplier, in kg CO2/kWh. */
  emission_factor_market_based?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  line_index?: InputMaybe<order_by>;
  /** Additional charges before tax not covered by base or working price. */
  other_charges_net?: InputMaybe<order_by>;
  /** Remaining balance for this line item. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Order of this line item within the invoice. */
  position?: InputMaybe<order_by>;
  /** Share of renewable energy in the energy mix for this supply, as stated on the invoice. */
  renewable_energy_percentage?: InputMaybe<order_by>;
  /** Absolute VAT amount for this line item. */
  vat_amount?: InputMaybe<order_by>;
  /** VAT rate for this line item. */
  vat_percentage?: InputMaybe<order_by>;
  waste_additional_collections_total?: InputMaybe<order_by>;
  waste_collection_frequency?: InputMaybe<order_by>;
  waste_collections_total?: InputMaybe<order_by>;
  waste_container_count?: InputMaybe<order_by>;
  waste_container_size?: InputMaybe<order_by>;
  waste_quantity?: InputMaybe<order_by>;
  /** Per-unit price (Arbeitspreis) before tax, multiplied by consumption. */
  working_price_net?: InputMaybe<order_by>;
};

export enum cbi_consumption_unit_enum {
  GJ = 'GJ',
  J = 'J',
  KG = 'KG',
  KJ = 'KJ',
  KWH = 'KWH',
  L = 'L',
  M2 = 'M2',
  M3 = 'M3',
  MJ = 'MJ',
  MWH = 'MWH',
  T = 'T',
}

/** Boolean expression to compare columns of type "cbi_consumption_unit_enum". All fields are combined with logical 'AND'. */
export type cbi_consumption_unit_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_consumption_unit_enum>;
  _in?: InputMaybe<Array<cbi_consumption_unit_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_consumption_unit_enum>;
  _nin?: InputMaybe<Array<cbi_consumption_unit_enum>>;
};

export enum cbi_duplicate_reason_type_enum {
  CHECKSUM = 'CHECKSUM',
  INVOICE_NUMBER = 'INVOICE_NUMBER',
  MANUAL = 'MANUAL',
}

/** Boolean expression to compare columns of type "cbi_duplicate_reason_type_enum". All fields are combined with logical 'AND'. */
export type cbi_duplicate_reason_type_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_duplicate_reason_type_enum>;
  _in?: InputMaybe<Array<cbi_duplicate_reason_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_duplicate_reason_type_enum>;
  _nin?: InputMaybe<Array<cbi_duplicate_reason_type_enum>>;
};

/** Raw emails received by a CBI inbox. Each email may contain one or more invoice attachments. */
export type cbi_email = {
  /** The inbox that received this email. */
  cbi_inbox_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** Sender email address. */
  from: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  inbox: cbi_inbox;
  /** An array relationship */
  invoices: Array<cbi_invoice>;
  /** An aggregate relationship */
  invoices_aggregate: cbi_invoice_aggregate;
  /** Unique email Message-ID header, used for deduplication. */
  message_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  org: org;
  /** Organization that owns this email record. */
  org_id: Scalars['Int']['output'];
  /** Timestamp when the email was received by the mail server. */
  received_at?: Maybe<Scalars['timestamptz']['output']>;
  /** S3 object key for the stored raw email file. */
  s3_key: Scalars['String']['output'];
  /** Email subject line. */
  subject?: Maybe<Scalars['String']['output']>;
  /** Plain text body of the email. */
  text?: Maybe<Scalars['String']['output']>;
  /** Recipient email address. */
  to: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Raw emails received by a CBI inbox. Each email may contain one or more invoice attachments. */
export type cbi_emailinvoicesArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_order_by>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

/** Raw emails received by a CBI inbox. Each email may contain one or more invoice attachments. */
export type cbi_emailinvoices_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_order_by>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

/** order by aggregate values of table "cbi_email" */
export type cbi_email_aggregate_order_by = {
  avg?: InputMaybe<cbi_email_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<cbi_email_max_order_by>;
  min?: InputMaybe<cbi_email_min_order_by>;
  stddev?: InputMaybe<cbi_email_stddev_order_by>;
  stddev_pop?: InputMaybe<cbi_email_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<cbi_email_stddev_samp_order_by>;
  sum?: InputMaybe<cbi_email_sum_order_by>;
  var_pop?: InputMaybe<cbi_email_var_pop_order_by>;
  var_samp?: InputMaybe<cbi_email_var_samp_order_by>;
  variance?: InputMaybe<cbi_email_variance_order_by>;
};

/** order by avg() on columns of table "cbi_email" */
export type cbi_email_avg_order_by = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "cbi_email". All fields are combined with a logical 'AND'. */
export type cbi_email_bool_exp = {
  _and?: InputMaybe<Array<cbi_email_bool_exp>>;
  _not?: InputMaybe<cbi_email_bool_exp>;
  _or?: InputMaybe<Array<cbi_email_bool_exp>>;
  cbi_inbox_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  from?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  inbox?: InputMaybe<cbi_inbox_bool_exp>;
  invoices?: InputMaybe<cbi_invoice_bool_exp>;
  invoices_aggregate?: InputMaybe<cbi_invoice_aggregate_bool_exp>;
  message_id?: InputMaybe<String_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  received_at?: InputMaybe<timestamptz_comparison_exp>;
  s3_key?: InputMaybe<String_comparison_exp>;
  subject?: InputMaybe<String_comparison_exp>;
  text?: InputMaybe<String_comparison_exp>;
  to?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "cbi_email" */
export type cbi_email_max_order_by = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Sender email address. */
  from?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Unique email Message-ID header, used for deduplication. */
  message_id?: InputMaybe<order_by>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<order_by>;
  /** Timestamp when the email was received by the mail server. */
  received_at?: InputMaybe<order_by>;
  /** S3 object key for the stored raw email file. */
  s3_key?: InputMaybe<order_by>;
  /** Email subject line. */
  subject?: InputMaybe<order_by>;
  /** Plain text body of the email. */
  text?: InputMaybe<order_by>;
  /** Recipient email address. */
  to?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "cbi_email" */
export type cbi_email_min_order_by = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Sender email address. */
  from?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Unique email Message-ID header, used for deduplication. */
  message_id?: InputMaybe<order_by>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<order_by>;
  /** Timestamp when the email was received by the mail server. */
  received_at?: InputMaybe<order_by>;
  /** S3 object key for the stored raw email file. */
  s3_key?: InputMaybe<order_by>;
  /** Email subject line. */
  subject?: InputMaybe<order_by>;
  /** Plain text body of the email. */
  text?: InputMaybe<order_by>;
  /** Recipient email address. */
  to?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "cbi_email". */
export type cbi_email_order_by = {
  cbi_inbox_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  from?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  inbox?: InputMaybe<cbi_inbox_order_by>;
  invoices_aggregate?: InputMaybe<cbi_invoice_aggregate_order_by>;
  message_id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  received_at?: InputMaybe<order_by>;
  s3_key?: InputMaybe<order_by>;
  subject?: InputMaybe<order_by>;
  text?: InputMaybe<order_by>;
  to?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "cbi_email" */
export enum cbi_email_select_column {
  /** column name */
  cbi_inbox_id = 'cbi_inbox_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  from = 'from',
  /** column name */
  id = 'id',
  /** column name */
  message_id = 'message_id',
  /** column name */
  org_id = 'org_id',
  /** column name */
  received_at = 'received_at',
  /** column name */
  s3_key = 's3_key',
  /** column name */
  subject = 'subject',
  /** column name */
  text = 'text',
  /** column name */
  to = 'to',
  /** column name */
  updated_at = 'updated_at',
}

/** order by stddev() on columns of table "cbi_email" */
export type cbi_email_stddev_order_by = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "cbi_email" */
export type cbi_email_stddev_pop_order_by = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "cbi_email" */
export type cbi_email_stddev_samp_order_by = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "cbi_email" */
export type cbi_email_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_email_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_email_stream_cursor_value_input = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Sender email address. */
  from?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Unique email Message-ID header, used for deduplication. */
  message_id?: InputMaybe<Scalars['String']['input']>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Timestamp when the email was received by the mail server. */
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** S3 object key for the stored raw email file. */
  s3_key?: InputMaybe<Scalars['String']['input']>;
  /** Email subject line. */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Plain text body of the email. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Recipient email address. */
  to?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "cbi_email" */
export type cbi_email_sum_order_by = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "cbi_email" */
export type cbi_email_var_pop_order_by = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "cbi_email" */
export type cbi_email_var_samp_order_by = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "cbi_email" */
export type cbi_email_variance_order_by = {
  /** The inbox that received this email. */
  cbi_inbox_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this email record. */
  org_id?: InputMaybe<order_by>;
};

export enum cbi_energy_source_type_enum {
  BIO_GAS = 'BIO_GAS',
  COAL = 'COAL',
  DISTRICT_HEATING = 'DISTRICT_HEATING',
  ELECTRICITY_GREEN = 'ELECTRICITY_GREEN',
  ELECTRICITY_MIX = 'ELECTRICITY_MIX',
  FUEL_OIL = 'FUEL_OIL',
  LIGNITE = 'LIGNITE',
  LPG = 'LPG',
  NATURAL_GAS = 'NATURAL_GAS',
  SOLAR = 'SOLAR',
  WOOD = 'WOOD',
  WOODEN_PELLETS = 'WOODEN_PELLETS',
}

/** Boolean expression to compare columns of type "cbi_energy_source_type_enum". All fields are combined with logical 'AND'. */
export type cbi_energy_source_type_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_energy_source_type_enum>;
  _in?: InputMaybe<Array<cbi_energy_source_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_energy_source_type_enum>;
  _nin?: InputMaybe<Array<cbi_energy_source_type_enum>>;
};

/** Tracks bulk exports of CBI invoice data to Excel files. */
export type cbi_export = {
  /** Timestamp when the export finished processing. */
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  downloadUrl: Scalars['String']['output'];
  /** An object relationship */
  file?: Maybe<file>;
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  org: org;
  /** Organization requesting the export. */
  org_id: Scalars['Int']['output'];
  /** Current status of the export job. */
  status_id: cbi_export_status_type_enum;
  /** An object relationship */
  user?: Maybe<user>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "cbi_export" */
export type cbi_export_aggregate = {
  aggregate?: Maybe<cbi_export_aggregate_fields>;
  nodes: Array<cbi_export>;
};

export type cbi_export_aggregate_bool_exp = {
  count?: InputMaybe<cbi_export_aggregate_bool_exp_count>;
};

export type cbi_export_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<cbi_export_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_export_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "cbi_export" */
export type cbi_export_aggregate_fields = {
  avg?: Maybe<cbi_export_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<cbi_export_max_fields>;
  min?: Maybe<cbi_export_min_fields>;
  stddev?: Maybe<cbi_export_stddev_fields>;
  stddev_pop?: Maybe<cbi_export_stddev_pop_fields>;
  stddev_samp?: Maybe<cbi_export_stddev_samp_fields>;
  sum?: Maybe<cbi_export_sum_fields>;
  var_pop?: Maybe<cbi_export_var_pop_fields>;
  var_samp?: Maybe<cbi_export_var_samp_fields>;
  variance?: Maybe<cbi_export_variance_fields>;
};

/** aggregate fields of "cbi_export" */
export type cbi_export_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<cbi_export_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cbi_export" */
export type cbi_export_aggregate_order_by = {
  avg?: InputMaybe<cbi_export_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<cbi_export_max_order_by>;
  min?: InputMaybe<cbi_export_min_order_by>;
  stddev?: InputMaybe<cbi_export_stddev_order_by>;
  stddev_pop?: InputMaybe<cbi_export_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<cbi_export_stddev_samp_order_by>;
  sum?: InputMaybe<cbi_export_sum_order_by>;
  var_pop?: InputMaybe<cbi_export_var_pop_order_by>;
  var_samp?: InputMaybe<cbi_export_var_samp_order_by>;
  variance?: InputMaybe<cbi_export_variance_order_by>;
};

/** aggregate avg on columns */
export type cbi_export_avg_fields = {
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization requesting the export. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cbi_export" */
export type cbi_export_avg_order_by = {
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<order_by>;
  /** User who initiated the export. */
  user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "cbi_export". All fields are combined with a logical 'AND'. */
export type cbi_export_bool_exp = {
  _and?: InputMaybe<Array<cbi_export_bool_exp>>;
  _not?: InputMaybe<cbi_export_bool_exp>;
  _or?: InputMaybe<Array<cbi_export_bool_exp>>;
  completed_at?: InputMaybe<timestamptz_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  file?: InputMaybe<file_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  status_id?: InputMaybe<cbi_export_status_type_enum_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<Int_comparison_exp>;
};

/** aggregate max on columns */
export type cbi_export_max_fields = {
  /** Timestamp when the export finished processing. */
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization requesting the export. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "cbi_export" */
export type cbi_export_max_order_by = {
  /** Timestamp when the export finished processing. */
  completed_at?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<order_by>;
  /** User who initiated the export. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type cbi_export_min_fields = {
  /** Timestamp when the export finished processing. */
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization requesting the export. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "cbi_export" */
export type cbi_export_min_order_by = {
  /** Timestamp when the export finished processing. */
  completed_at?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<order_by>;
  /** User who initiated the export. */
  user_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "cbi_export". */
export type cbi_export_order_by = {
  completed_at?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  file?: InputMaybe<file_order_by>;
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  status_id?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_id?: InputMaybe<order_by>;
};

/** select columns of table "cbi_export" */
export enum cbi_export_select_column {
  /** column name */
  completed_at = 'completed_at',
  /** column name */
  created_at = 'created_at',
  /** column name */
  file_id = 'file_id',
  /** column name */
  id = 'id',
  /** column name */
  org_id = 'org_id',
  /** column name */
  status_id = 'status_id',
  /** column name */
  user_id = 'user_id',
}

export enum cbi_export_status_type_enum {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
}

/** Boolean expression to compare columns of type "cbi_export_status_type_enum". All fields are combined with logical 'AND'. */
export type cbi_export_status_type_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_export_status_type_enum>;
  _in?: InputMaybe<Array<cbi_export_status_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_export_status_type_enum>;
  _nin?: InputMaybe<Array<cbi_export_status_type_enum>>;
};

/** aggregate stddev on columns */
export type cbi_export_stddev_fields = {
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization requesting the export. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cbi_export" */
export type cbi_export_stddev_order_by = {
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<order_by>;
  /** User who initiated the export. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type cbi_export_stddev_pop_fields = {
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization requesting the export. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cbi_export" */
export type cbi_export_stddev_pop_order_by = {
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<order_by>;
  /** User who initiated the export. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type cbi_export_stddev_samp_fields = {
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization requesting the export. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cbi_export" */
export type cbi_export_stddev_samp_order_by = {
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<order_by>;
  /** User who initiated the export. */
  user_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "cbi_export" */
export type cbi_export_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_export_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_export_stream_cursor_value_input = {
  /** Timestamp when the export finished processing. */
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Current status of the export job. */
  status_id?: InputMaybe<cbi_export_status_type_enum>;
  /** User who initiated the export. */
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type cbi_export_sum_fields = {
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization requesting the export. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cbi_export" */
export type cbi_export_sum_order_by = {
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<order_by>;
  /** User who initiated the export. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type cbi_export_var_pop_fields = {
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization requesting the export. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cbi_export" */
export type cbi_export_var_pop_order_by = {
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<order_by>;
  /** User who initiated the export. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type cbi_export_var_samp_fields = {
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization requesting the export. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cbi_export" */
export type cbi_export_var_samp_order_by = {
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<order_by>;
  /** User who initiated the export. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type cbi_export_variance_fields = {
  /** Reference to the generated export file, available once completed. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization requesting the export. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** User who initiated the export. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cbi_export" */
export type cbi_export_variance_order_by = {
  /** Reference to the generated export file, available once completed. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization requesting the export. */
  org_id?: InputMaybe<order_by>;
  /** User who initiated the export. */
  user_id?: InputMaybe<order_by>;
};

export enum cbi_extraction_state_enum {
  AUTOMATIC_APPROVAL = 'AUTOMATIC_APPROVAL',
  AUTOMATIC_REJECTION = 'AUTOMATIC_REJECTION',
  FAILED = 'FAILED',
  MANUAL_APPROVAL = 'MANUAL_APPROVAL',
  MANUAL_REJECTION = 'MANUAL_REJECTION',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
}

/** Boolean expression to compare columns of type "cbi_extraction_state_enum". All fields are combined with logical 'AND'. */
export type cbi_extraction_state_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_extraction_state_enum>;
  _in?: InputMaybe<Array<cbi_extraction_state_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_extraction_state_enum>;
  _nin?: InputMaybe<Array<cbi_extraction_state_enum>>;
};

export enum cbi_extraction_type_enum {
  ALPHA_PROMPT = 'ALPHA_PROMPT',
  MANUAL = 'MANUAL',
  PREDIUM = 'PREDIUM',
}

/** Boolean expression to compare columns of type "cbi_extraction_type_enum". All fields are combined with logical 'AND'. */
export type cbi_extraction_type_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_extraction_type_enum>;
  _in?: InputMaybe<Array<cbi_extraction_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_extraction_type_enum>;
  _nin?: InputMaybe<Array<cbi_extraction_type_enum>>;
};

/** Mailbox configuration for the Consumption Bill Inbox (CBI) system. Each inbox has a unique receiver email address tied to an organization. */
export type cbi_inbox = {
  /** List of email addresses or domains permitted to send invoices to this inbox. Emails from other senders are rejected. */
  allowed_senders?: Maybe<Array<Scalars['String']['output']>>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  emails: Array<cbi_email>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  org: org;
  /** Organization that owns this inbox. */
  org_id: Scalars['Int']['output'];
  /** The dedicated email address where consumption invoices are sent for automated processing. */
  receiver_email: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Mailbox configuration for the Consumption Bill Inbox (CBI) system. Each inbox has a unique receiver email address tied to an organization. */
export type cbi_inboxemailsArgs = {
  distinct_on?: InputMaybe<Array<cbi_email_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_email_order_by>>;
  where?: InputMaybe<cbi_email_bool_exp>;
};

/** Boolean expression to filter rows from the table "cbi_inbox". All fields are combined with a logical 'AND'. */
export type cbi_inbox_bool_exp = {
  _and?: InputMaybe<Array<cbi_inbox_bool_exp>>;
  _not?: InputMaybe<cbi_inbox_bool_exp>;
  _or?: InputMaybe<Array<cbi_inbox_bool_exp>>;
  allowed_senders?: InputMaybe<String_array_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  emails?: InputMaybe<cbi_email_bool_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  receiver_email?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Ordering options when selecting data from "cbi_inbox". */
export type cbi_inbox_order_by = {
  allowed_senders?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  emails_aggregate?: InputMaybe<cbi_email_aggregate_order_by>;
  id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  receiver_email?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "cbi_inbox" */
export enum cbi_inbox_select_column {
  /** column name */
  allowed_senders = 'allowed_senders',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  org_id = 'org_id',
  /** column name */
  receiver_email = 'receiver_email',
  /** column name */
  updated_at = 'updated_at',
}

/** Streaming cursor of the table "cbi_inbox" */
export type cbi_inbox_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_inbox_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_inbox_stream_cursor_value_input = {
  /** List of email addresses or domains permitted to send invoices to this inbox. Emails from other senders are rejected. */
  allowed_senders?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization that owns this inbox. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** The dedicated email address where consumption invoices are sent for automated processing. */
  receiver_email?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** A consumption invoice document extracted from a CBI email. May have multiple snapshots representing extraction revisions. */
export type cbi_invoice = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  cbi_invoice_snapshots: Array<cbi_invoice_snapshot>;
  /** An aggregate relationship */
  cbi_invoice_snapshots_aggregate: cbi_invoice_snapshot_aggregate;
  cbi_invoice_source_id: cbi_invoice_source_enum;
  created_at: Scalars['timestamptz']['output'];
  downloadUrl: Scalars['String']['output'];
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Int']['output']>;
  /** Human-readable explanation of the duplicate detection reason. */
  duplicate_reason?: Maybe<Scalars['String']['output']>;
  /** Classification of why this invoice was flagged as a duplicate. */
  duplicate_reason_type?: Maybe<cbi_duplicate_reason_type_enum>;
  /** An array relationship */
  duplicates: Array<cbi_invoice>;
  /** An aggregate relationship */
  duplicates_aggregate: cbi_invoice_aggregate;
  /** An object relationship */
  email?: Maybe<cbi_email>;
  /** An object relationship */
  file: file;
  /** Reference to the uploaded invoice file (PDF). */
  file_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  org: org;
  /** Organization that owns this invoice. */
  org_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** A consumption invoice document extracted from a CBI email. May have multiple snapshots representing extraction revisions. */
export type cbi_invoicecbi_invoice_snapshotsArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_snapshot_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_snapshot_order_by>>;
  where?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
};

/** A consumption invoice document extracted from a CBI email. May have multiple snapshots representing extraction revisions. */
export type cbi_invoicecbi_invoice_snapshots_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_snapshot_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_snapshot_order_by>>;
  where?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
};

/** A consumption invoice document extracted from a CBI email. May have multiple snapshots representing extraction revisions. */
export type cbi_invoiceduplicatesArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_order_by>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

/** A consumption invoice document extracted from a CBI email. May have multiple snapshots representing extraction revisions. */
export type cbi_invoiceduplicates_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_order_by>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

/** aggregated selection of "cbi_invoice" */
export type cbi_invoice_aggregate = {
  aggregate?: Maybe<cbi_invoice_aggregate_fields>;
  nodes: Array<cbi_invoice>;
};

export type cbi_invoice_aggregate_bool_exp = {
  count?: InputMaybe<cbi_invoice_aggregate_bool_exp_count>;
};

export type cbi_invoice_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<cbi_invoice_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "cbi_invoice" */
export type cbi_invoice_aggregate_fields = {
  avg?: Maybe<cbi_invoice_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<cbi_invoice_max_fields>;
  min?: Maybe<cbi_invoice_min_fields>;
  stddev?: Maybe<cbi_invoice_stddev_fields>;
  stddev_pop?: Maybe<cbi_invoice_stddev_pop_fields>;
  stddev_samp?: Maybe<cbi_invoice_stddev_samp_fields>;
  sum?: Maybe<cbi_invoice_sum_fields>;
  var_pop?: Maybe<cbi_invoice_var_pop_fields>;
  var_samp?: Maybe<cbi_invoice_var_samp_fields>;
  variance?: Maybe<cbi_invoice_variance_fields>;
};

/** aggregate fields of "cbi_invoice" */
export type cbi_invoice_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<cbi_invoice_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cbi_invoice" */
export type cbi_invoice_aggregate_order_by = {
  avg?: InputMaybe<cbi_invoice_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<cbi_invoice_max_order_by>;
  min?: InputMaybe<cbi_invoice_min_order_by>;
  stddev?: InputMaybe<cbi_invoice_stddev_order_by>;
  stddev_pop?: InputMaybe<cbi_invoice_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<cbi_invoice_stddev_samp_order_by>;
  sum?: InputMaybe<cbi_invoice_sum_order_by>;
  var_pop?: InputMaybe<cbi_invoice_var_pop_order_by>;
  var_samp?: InputMaybe<cbi_invoice_var_samp_order_by>;
  variance?: InputMaybe<cbi_invoice_variance_order_by>;
};

/** aggregate avg on columns */
export type cbi_invoice_avg_fields = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Float']['output']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this invoice. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cbi_invoice" */
export type cbi_invoice_avg_order_by = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<order_by>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "cbi_invoice". All fields are combined with a logical 'AND'. */
export type cbi_invoice_bool_exp = {
  _and?: InputMaybe<Array<cbi_invoice_bool_exp>>;
  _not?: InputMaybe<cbi_invoice_bool_exp>;
  _or?: InputMaybe<Array<cbi_invoice_bool_exp>>;
  cbi_email_id?: InputMaybe<Int_comparison_exp>;
  cbi_invoice_snapshots?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  cbi_invoice_snapshots_aggregate?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp>;
  cbi_invoice_source_id?: InputMaybe<cbi_invoice_source_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  duplicate_of_id?: InputMaybe<Int_comparison_exp>;
  duplicate_reason?: InputMaybe<String_comparison_exp>;
  duplicate_reason_type?: InputMaybe<cbi_duplicate_reason_type_enum_comparison_exp>;
  duplicates?: InputMaybe<cbi_invoice_bool_exp>;
  duplicates_aggregate?: InputMaybe<cbi_invoice_aggregate_bool_exp>;
  email?: InputMaybe<cbi_email_bool_exp>;
  file?: InputMaybe<file_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type cbi_invoice_max_fields = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Int']['output']>;
  /** Human-readable explanation of the duplicate detection reason. */
  duplicate_reason?: Maybe<Scalars['String']['output']>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization that owns this invoice. */
  org_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cbi_invoice" */
export type cbi_invoice_max_order_by = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<order_by>;
  /** Human-readable explanation of the duplicate detection reason. */
  duplicate_reason?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type cbi_invoice_min_fields = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Int']['output']>;
  /** Human-readable explanation of the duplicate detection reason. */
  duplicate_reason?: Maybe<Scalars['String']['output']>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization that owns this invoice. */
  org_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cbi_invoice" */
export type cbi_invoice_min_order_by = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<order_by>;
  /** Human-readable explanation of the duplicate detection reason. */
  duplicate_reason?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "cbi_invoice". */
export type cbi_invoice_order_by = {
  cbi_email_id?: InputMaybe<order_by>;
  cbi_invoice_snapshots_aggregate?: InputMaybe<cbi_invoice_snapshot_aggregate_order_by>;
  cbi_invoice_source_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  duplicate_of_id?: InputMaybe<order_by>;
  duplicate_reason?: InputMaybe<order_by>;
  duplicate_reason_type?: InputMaybe<order_by>;
  duplicates_aggregate?: InputMaybe<cbi_invoice_aggregate_order_by>;
  email?: InputMaybe<cbi_email_order_by>;
  file?: InputMaybe<file_order_by>;
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "cbi_invoice" */
export enum cbi_invoice_select_column {
  /** column name */
  cbi_email_id = 'cbi_email_id',
  /** column name */
  cbi_invoice_source_id = 'cbi_invoice_source_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  duplicate_of_id = 'duplicate_of_id',
  /** column name */
  duplicate_reason = 'duplicate_reason',
  /** column name */
  duplicate_reason_type = 'duplicate_reason_type',
  /** column name */
  file_id = 'file_id',
  /** column name */
  id = 'id',
  /** column name */
  org_id = 'org_id',
  /** column name */
  updated_at = 'updated_at',
}

/** A versioned extraction result for a CBI invoice. Each edit or re-extraction creates a new snapshot; only one is active at a time. */
export type cbi_invoice_snapshot = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  alpha_prompt_interactions: Array<alpha_prompt_interaction>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  cbi_consumption_lines: Array<cbi_consumption_line>;
  /** An aggregate relationship */
  cbi_consumption_lines_aggregate: cbi_consumption_line_aggregate;
  /** An object relationship */
  cbi_invoice: cbi_invoice;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id: Scalars['Int']['output'];
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['numeric']['output']>;
  /** User-provided reason for creating this edited snapshot. */
  edit_reason?: Maybe<Scalars['String']['output']>;
  /** JSON describing why extraction was flagged for review. Keys: sampling (random QA sample), multipleVerbrauchsstelle (multiple meter locations detected). */
  extraction_needs_review_reason?: Maybe<Scalars['jsonb']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['float8']['output']>;
  /** Current state of the extraction process (e.g., pending, completed, failed). */
  extraction_state: cbi_extraction_state_enum;
  /** Method used to extract data (e.g., AI-based, manual). */
  extraction_type: cbi_extraction_type_enum;
  id: Scalars['Int']['output'];
  /** Date the invoice was issued. */
  invoice_date?: Maybe<Scalars['date']['output']>;
  /** Invoice number as printed on the document. */
  invoice_number?: Maybe<Scalars['String']['output']>;
  invoice_reference?: Maybe<Scalars['String']['output']>;
  /** Type of invoice: STANDARD, CORRECTION, or CANCELLATION. */
  invoice_type?: Maybe<cbi_invoice_type_enum>;
  /** Whether this is the currently active snapshot for the invoice. Only one snapshot per invoice should be active. */
  is_active: Scalars['Boolean']['output'];
  /** Who has operational control over the utility: LANDLORD_CONTROLLED or TENANT_CONTROLLED. Used for GHG Protocol emission scope classification. */
  operational_control?: Maybe<cbi_operational_control_enum>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['numeric']['output']>;
  /** Name of the energy or utility provider that issued the invoice. */
  provider?: Maybe<Scalars['String']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['numeric']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<user>;
  validationIssues: CBISnapshotIssues;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['numeric']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['numeric']['output']>;
};

/** A versioned extraction result for a CBI invoice. Each edit or re-extraction creates a new snapshot; only one is active at a time. */
export type cbi_invoice_snapshotalpha_prompt_interactionsArgs = {
  distinct_on?: InputMaybe<Array<alpha_prompt_interaction_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<alpha_prompt_interaction_order_by>>;
  where?: InputMaybe<alpha_prompt_interaction_bool_exp>;
};

/** A versioned extraction result for a CBI invoice. Each edit or re-extraction creates a new snapshot; only one is active at a time. */
export type cbi_invoice_snapshotcbi_consumption_linesArgs = {
  distinct_on?: InputMaybe<Array<cbi_consumption_line_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_consumption_line_order_by>>;
  where?: InputMaybe<cbi_consumption_line_bool_exp>;
};

/** A versioned extraction result for a CBI invoice. Each edit or re-extraction creates a new snapshot; only one is active at a time. */
export type cbi_invoice_snapshotcbi_consumption_lines_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_consumption_line_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_consumption_line_order_by>>;
  where?: InputMaybe<cbi_consumption_line_bool_exp>;
};

/** A versioned extraction result for a CBI invoice. Each edit or re-extraction creates a new snapshot; only one is active at a time. */
export type cbi_invoice_snapshotextraction_needs_review_reasonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_aggregate = {
  aggregate?: Maybe<cbi_invoice_snapshot_aggregate_fields>;
  nodes: Array<cbi_invoice_snapshot>;
};

export type cbi_invoice_snapshot_aggregate_bool_exp = {
  avg?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_avg>;
  bool_and?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_bool_or>;
  corr?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_corr>;
  count?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_count>;
  covar_samp?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_covar_samp>;
  max?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_max>;
  min?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_min>;
  stddev_samp?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_stddev_samp>;
  sum?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_sum>;
  var_samp?: InputMaybe<cbi_invoice_snapshot_aggregate_bool_exp_var_samp>;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_avg = {
  arguments: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_avg_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: float8_comparison_exp;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_bool_and = {
  arguments: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_bool_or = {
  arguments: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_corr = {
  arguments: cbi_invoice_snapshot_aggregate_bool_exp_corr_arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: float8_comparison_exp;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_corr_arguments = {
  X: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_corr_arguments_columns;
  Y: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_corr_arguments_columns;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<cbi_invoice_snapshot_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: Int_comparison_exp;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_covar_samp = {
  arguments: cbi_invoice_snapshot_aggregate_bool_exp_covar_samp_arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: float8_comparison_exp;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_covar_samp_arguments = {
  X: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_covar_samp_arguments_columns;
  Y: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_covar_samp_arguments_columns;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_max = {
  arguments: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_max_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: float8_comparison_exp;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_min = {
  arguments: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_min_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: float8_comparison_exp;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_stddev_samp = {
  arguments: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_stddev_samp_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: float8_comparison_exp;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_sum = {
  arguments: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_sum_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: float8_comparison_exp;
};

export type cbi_invoice_snapshot_aggregate_bool_exp_var_samp = {
  arguments: cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_var_samp_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  predicate: float8_comparison_exp;
};

/** aggregate fields of "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_aggregate_fields = {
  avg?: Maybe<cbi_invoice_snapshot_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<cbi_invoice_snapshot_max_fields>;
  min?: Maybe<cbi_invoice_snapshot_min_fields>;
  stddev?: Maybe<cbi_invoice_snapshot_stddev_fields>;
  stddev_pop?: Maybe<cbi_invoice_snapshot_stddev_pop_fields>;
  stddev_samp?: Maybe<cbi_invoice_snapshot_stddev_samp_fields>;
  sum?: Maybe<cbi_invoice_snapshot_sum_fields>;
  var_pop?: Maybe<cbi_invoice_snapshot_var_pop_fields>;
  var_samp?: Maybe<cbi_invoice_snapshot_var_samp_fields>;
  variance?: Maybe<cbi_invoice_snapshot_variance_fields>;
};

/** aggregate fields of "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<cbi_invoice_snapshot_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_aggregate_order_by = {
  avg?: InputMaybe<cbi_invoice_snapshot_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<cbi_invoice_snapshot_max_order_by>;
  min?: InputMaybe<cbi_invoice_snapshot_min_order_by>;
  stddev?: InputMaybe<cbi_invoice_snapshot_stddev_order_by>;
  stddev_pop?: InputMaybe<cbi_invoice_snapshot_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<cbi_invoice_snapshot_stddev_samp_order_by>;
  sum?: InputMaybe<cbi_invoice_snapshot_sum_order_by>;
  var_pop?: InputMaybe<cbi_invoice_snapshot_var_pop_order_by>;
  var_samp?: InputMaybe<cbi_invoice_snapshot_var_samp_order_by>;
  variance?: InputMaybe<cbi_invoice_snapshot_variance_order_by>;
};

/** aggregate avg on columns */
export type cbi_invoice_snapshot_avg_fields = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_avg_order_by = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<order_by>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<order_by>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<order_by>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<order_by>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<order_by>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<order_by>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<order_by>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<order_by>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<order_by>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<order_by>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "cbi_invoice_snapshot". All fields are combined with a logical 'AND'. */
export type cbi_invoice_snapshot_bool_exp = {
  _and?: InputMaybe<Array<cbi_invoice_snapshot_bool_exp>>;
  _not?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
  _or?: InputMaybe<Array<cbi_invoice_snapshot_bool_exp>>;
  advance_payments?: InputMaybe<numeric_comparison_exp>;
  alpha_prompt_interactions?: InputMaybe<alpha_prompt_interaction_bool_exp>;
  amount_payable?: InputMaybe<numeric_comparison_exp>;
  cbi_consumption_lines?: InputMaybe<cbi_consumption_line_bool_exp>;
  cbi_consumption_lines_aggregate?: InputMaybe<cbi_consumption_line_aggregate_bool_exp>;
  cbi_invoice?: InputMaybe<cbi_invoice_bool_exp>;
  cbi_invoice_id?: InputMaybe<Int_comparison_exp>;
  co2_fee_gross?: InputMaybe<numeric_comparison_exp>;
  co2_fee_net?: InputMaybe<numeric_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  created_by_user_id?: InputMaybe<Int_comparison_exp>;
  credit_amount?: InputMaybe<numeric_comparison_exp>;
  edit_reason?: InputMaybe<String_comparison_exp>;
  extraction_needs_review_reason?: InputMaybe<jsonb_comparison_exp>;
  extraction_score?: InputMaybe<float8_comparison_exp>;
  extraction_state?: InputMaybe<cbi_extraction_state_enum_comparison_exp>;
  extraction_type?: InputMaybe<cbi_extraction_type_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  invoice_date?: InputMaybe<date_comparison_exp>;
  invoice_number?: InputMaybe<String_comparison_exp>;
  invoice_reference?: InputMaybe<String_comparison_exp>;
  invoice_type?: InputMaybe<cbi_invoice_type_enum_comparison_exp>;
  is_active?: InputMaybe<Boolean_comparison_exp>;
  operational_control?: InputMaybe<cbi_operational_control_enum_comparison_exp>;
  original_snapshot_id?: InputMaybe<Int_comparison_exp>;
  outstanding_balance?: InputMaybe<numeric_comparison_exp>;
  provider?: InputMaybe<String_comparison_exp>;
  total_cost_gross?: InputMaybe<numeric_comparison_exp>;
  total_cost_net?: InputMaybe<numeric_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  vat_amount?: InputMaybe<numeric_comparison_exp>;
  vat_percentage?: InputMaybe<numeric_comparison_exp>;
};

/** aggregate max on columns */
export type cbi_invoice_snapshot_max_fields = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['numeric']['output']>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['numeric']['output']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: Maybe<Scalars['Int']['output']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['numeric']['output']>;
  /** User-provided reason for creating this edited snapshot. */
  edit_reason?: Maybe<Scalars['String']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Date the invoice was issued. */
  invoice_date?: Maybe<Scalars['date']['output']>;
  /** Invoice number as printed on the document. */
  invoice_number?: Maybe<Scalars['String']['output']>;
  invoice_reference?: Maybe<Scalars['String']['output']>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['numeric']['output']>;
  /** Name of the energy or utility provider that issued the invoice. */
  provider?: Maybe<Scalars['String']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['numeric']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['numeric']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_max_order_by = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<order_by>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<order_by>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<order_by>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<order_by>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<order_by>;
  /** User-provided reason for creating this edited snapshot. */
  edit_reason?: InputMaybe<order_by>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Date the invoice was issued. */
  invoice_date?: InputMaybe<order_by>;
  /** Invoice number as printed on the document. */
  invoice_number?: InputMaybe<order_by>;
  invoice_reference?: InputMaybe<order_by>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<order_by>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Name of the energy or utility provider that issued the invoice. */
  provider?: InputMaybe<order_by>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<order_by>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<order_by>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type cbi_invoice_snapshot_min_fields = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['numeric']['output']>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['numeric']['output']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: Maybe<Scalars['Int']['output']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['numeric']['output']>;
  /** User-provided reason for creating this edited snapshot. */
  edit_reason?: Maybe<Scalars['String']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Date the invoice was issued. */
  invoice_date?: Maybe<Scalars['date']['output']>;
  /** Invoice number as printed on the document. */
  invoice_number?: Maybe<Scalars['String']['output']>;
  invoice_reference?: Maybe<Scalars['String']['output']>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['numeric']['output']>;
  /** Name of the energy or utility provider that issued the invoice. */
  provider?: Maybe<Scalars['String']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['numeric']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['numeric']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['numeric']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_min_order_by = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<order_by>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<order_by>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<order_by>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<order_by>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<order_by>;
  /** User-provided reason for creating this edited snapshot. */
  edit_reason?: InputMaybe<order_by>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Date the invoice was issued. */
  invoice_date?: InputMaybe<order_by>;
  /** Invoice number as printed on the document. */
  invoice_number?: InputMaybe<order_by>;
  invoice_reference?: InputMaybe<order_by>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<order_by>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Name of the energy or utility provider that issued the invoice. */
  provider?: InputMaybe<order_by>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<order_by>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<order_by>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "cbi_invoice_snapshot". */
export type cbi_invoice_snapshot_order_by = {
  advance_payments?: InputMaybe<order_by>;
  alpha_prompt_interactions_aggregate?: InputMaybe<alpha_prompt_interaction_aggregate_order_by>;
  amount_payable?: InputMaybe<order_by>;
  cbi_consumption_lines_aggregate?: InputMaybe<cbi_consumption_line_aggregate_order_by>;
  cbi_invoice?: InputMaybe<cbi_invoice_order_by>;
  cbi_invoice_id?: InputMaybe<order_by>;
  co2_fee_gross?: InputMaybe<order_by>;
  co2_fee_net?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  created_by_user_id?: InputMaybe<order_by>;
  credit_amount?: InputMaybe<order_by>;
  edit_reason?: InputMaybe<order_by>;
  extraction_needs_review_reason?: InputMaybe<order_by>;
  extraction_score?: InputMaybe<order_by>;
  extraction_state?: InputMaybe<order_by>;
  extraction_type?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_date?: InputMaybe<order_by>;
  invoice_number?: InputMaybe<order_by>;
  invoice_reference?: InputMaybe<order_by>;
  invoice_type?: InputMaybe<order_by>;
  is_active?: InputMaybe<order_by>;
  operational_control?: InputMaybe<order_by>;
  original_snapshot_id?: InputMaybe<order_by>;
  outstanding_balance?: InputMaybe<order_by>;
  provider?: InputMaybe<order_by>;
  total_cost_gross?: InputMaybe<order_by>;
  total_cost_net?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  vat_amount?: InputMaybe<order_by>;
  vat_percentage?: InputMaybe<order_by>;
};

/** select columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column {
  /** column name */
  advance_payments = 'advance_payments',
  /** column name */
  amount_payable = 'amount_payable',
  /** column name */
  cbi_invoice_id = 'cbi_invoice_id',
  /** column name */
  co2_fee_gross = 'co2_fee_gross',
  /** column name */
  co2_fee_net = 'co2_fee_net',
  /** column name */
  created_at = 'created_at',
  /** column name */
  created_by_user_id = 'created_by_user_id',
  /** column name */
  credit_amount = 'credit_amount',
  /** column name */
  edit_reason = 'edit_reason',
  /** column name */
  extraction_needs_review_reason = 'extraction_needs_review_reason',
  /** column name */
  extraction_score = 'extraction_score',
  /** column name */
  extraction_state = 'extraction_state',
  /** column name */
  extraction_type = 'extraction_type',
  /** column name */
  id = 'id',
  /** column name */
  invoice_date = 'invoice_date',
  /** column name */
  invoice_number = 'invoice_number',
  /** column name */
  invoice_reference = 'invoice_reference',
  /** column name */
  invoice_type = 'invoice_type',
  /** column name */
  is_active = 'is_active',
  /** column name */
  operational_control = 'operational_control',
  /** column name */
  original_snapshot_id = 'original_snapshot_id',
  /** column name */
  outstanding_balance = 'outstanding_balance',
  /** column name */
  provider = 'provider',
  /** column name */
  total_cost_gross = 'total_cost_gross',
  /** column name */
  total_cost_net = 'total_cost_net',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  vat_amount = 'vat_amount',
  /** column name */
  vat_percentage = 'vat_percentage',
}

/** select "cbi_invoice_snapshot_aggregate_bool_exp_avg_arguments_columns" columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_avg_arguments_columns {
  /** column name */
  extraction_score = 'extraction_score',
}

/** select "cbi_invoice_snapshot_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  is_active = 'is_active',
}

/** select "cbi_invoice_snapshot_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  is_active = 'is_active',
}

/** select "cbi_invoice_snapshot_aggregate_bool_exp_corr_arguments_columns" columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_corr_arguments_columns {
  /** column name */
  extraction_score = 'extraction_score',
}

/** select "cbi_invoice_snapshot_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_covar_samp_arguments_columns {
  /** column name */
  extraction_score = 'extraction_score',
}

/** select "cbi_invoice_snapshot_aggregate_bool_exp_max_arguments_columns" columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_max_arguments_columns {
  /** column name */
  extraction_score = 'extraction_score',
}

/** select "cbi_invoice_snapshot_aggregate_bool_exp_min_arguments_columns" columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_min_arguments_columns {
  /** column name */
  extraction_score = 'extraction_score',
}

/** select "cbi_invoice_snapshot_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_stddev_samp_arguments_columns {
  /** column name */
  extraction_score = 'extraction_score',
}

/** select "cbi_invoice_snapshot_aggregate_bool_exp_sum_arguments_columns" columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_sum_arguments_columns {
  /** column name */
  extraction_score = 'extraction_score',
}

/** select "cbi_invoice_snapshot_aggregate_bool_exp_var_samp_arguments_columns" columns of table "cbi_invoice_snapshot" */
export enum cbi_invoice_snapshot_select_column_cbi_invoice_snapshot_aggregate_bool_exp_var_samp_arguments_columns {
  /** column name */
  extraction_score = 'extraction_score',
}

/** aggregate stddev on columns */
export type cbi_invoice_snapshot_stddev_fields = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_stddev_order_by = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<order_by>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<order_by>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<order_by>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<order_by>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<order_by>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<order_by>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<order_by>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<order_by>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<order_by>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<order_by>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type cbi_invoice_snapshot_stddev_pop_fields = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_stddev_pop_order_by = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<order_by>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<order_by>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<order_by>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<order_by>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<order_by>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<order_by>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<order_by>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<order_by>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<order_by>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<order_by>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type cbi_invoice_snapshot_stddev_samp_fields = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_stddev_samp_order_by = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<order_by>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<order_by>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<order_by>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<order_by>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<order_by>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<order_by>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<order_by>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<order_by>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<order_by>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<order_by>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_invoice_snapshot_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_invoice_snapshot_stream_cursor_value_input = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<Scalars['numeric']['input']>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<Scalars['numeric']['input']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<Scalars['Int']['input']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<Scalars['numeric']['input']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<Scalars['numeric']['input']>;
  /** User-provided reason for creating this edited snapshot. */
  edit_reason?: InputMaybe<Scalars['String']['input']>;
  /** JSON describing why extraction was flagged for review. Keys: sampling (random QA sample), multipleVerbrauchsstelle (multiple meter locations detected). */
  extraction_needs_review_reason?: InputMaybe<Scalars['jsonb']['input']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<Scalars['float8']['input']>;
  /** Current state of the extraction process (e.g., pending, completed, failed). */
  extraction_state?: InputMaybe<cbi_extraction_state_enum>;
  /** Method used to extract data (e.g., AI-based, manual). */
  extraction_type?: InputMaybe<cbi_extraction_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Date the invoice was issued. */
  invoice_date?: InputMaybe<Scalars['date']['input']>;
  /** Invoice number as printed on the document. */
  invoice_number?: InputMaybe<Scalars['String']['input']>;
  invoice_reference?: InputMaybe<Scalars['String']['input']>;
  /** Type of invoice: STANDARD, CORRECTION, or CANCELLATION. */
  invoice_type?: InputMaybe<cbi_invoice_type_enum>;
  /** Whether this is the currently active snapshot for the invoice. Only one snapshot per invoice should be active. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Who has operational control over the utility: LANDLORD_CONTROLLED or TENANT_CONTROLLED. Used for GHG Protocol emission scope classification. */
  operational_control?: InputMaybe<cbi_operational_control_enum>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<Scalars['Int']['input']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<Scalars['numeric']['input']>;
  /** Name of the energy or utility provider that issued the invoice. */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<Scalars['numeric']['input']>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<Scalars['numeric']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<Scalars['numeric']['input']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type cbi_invoice_snapshot_sum_fields = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['numeric']['output']>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['numeric']['output']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: Maybe<Scalars['Int']['output']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['numeric']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Int']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['numeric']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['numeric']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['numeric']['output']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['numeric']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_sum_order_by = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<order_by>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<order_by>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<order_by>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<order_by>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<order_by>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<order_by>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<order_by>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<order_by>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<order_by>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<order_by>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type cbi_invoice_snapshot_var_pop_fields = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_var_pop_order_by = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<order_by>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<order_by>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<order_by>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<order_by>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<order_by>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<order_by>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<order_by>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<order_by>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<order_by>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<order_by>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type cbi_invoice_snapshot_var_samp_fields = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_var_samp_order_by = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<order_by>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<order_by>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<order_by>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<order_by>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<order_by>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<order_by>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<order_by>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<order_by>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<order_by>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<order_by>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type cbi_invoice_snapshot_variance_fields = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: Maybe<Scalars['Float']['output']>;
  /** Final amount the customer must pay. */
  amount_payable?: Maybe<Scalars['Float']['output']>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: Maybe<Scalars['Float']['output']>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: Maybe<Scalars['Float']['output']>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount including tax. */
  total_cost_gross?: Maybe<Scalars['Float']['output']>;
  /** Total invoice amount before tax. */
  total_cost_net?: Maybe<Scalars['Float']['output']>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: Maybe<Scalars['Float']['output']>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cbi_invoice_snapshot" */
export type cbi_invoice_snapshot_variance_order_by = {
  /** Sum of advance payments already made for this billing period. */
  advance_payments?: InputMaybe<order_by>;
  /** Final amount the customer must pay. */
  amount_payable?: InputMaybe<order_by>;
  /** The invoice this snapshot belongs to. */
  cbi_invoice_id?: InputMaybe<order_by>;
  /** CO2 levy amount including tax. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** CO2 levy amount before tax, as mandated by carbon pricing regulations. */
  co2_fee_net?: InputMaybe<order_by>;
  /** User who created this snapshot (null for AI-generated snapshots). */
  created_by_user_id?: InputMaybe<order_by>;
  /** Credit amount applied to the invoice (e.g., overpayment from prior period). */
  credit_amount?: InputMaybe<order_by>;
  /** Overall AI extraction confidence score for the invoice snapshot (0.0 to 1.0 scale). */
  extraction_score?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** For edited snapshots, references the snapshot this was derived from. */
  original_snapshot_id?: InputMaybe<order_by>;
  /** Remaining balance due after accounting for advance payments. */
  outstanding_balance?: InputMaybe<order_by>;
  /** Total invoice amount including tax. */
  total_cost_gross?: InputMaybe<order_by>;
  /** Total invoice amount before tax. */
  total_cost_net?: InputMaybe<order_by>;
  /** Absolute VAT amount on the invoice. */
  vat_amount?: InputMaybe<order_by>;
  /** Value-added tax rate applied to the invoice. */
  vat_percentage?: InputMaybe<order_by>;
};

export enum cbi_invoice_source_enum {
  DIRECT_UPLOAD = 'DIRECT_UPLOAD',
  EMAIL = 'EMAIL',
}

/** Boolean expression to compare columns of type "cbi_invoice_source_enum". All fields are combined with logical 'AND'. */
export type cbi_invoice_source_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_invoice_source_enum>;
  _in?: InputMaybe<Array<cbi_invoice_source_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_invoice_source_enum>;
  _nin?: InputMaybe<Array<cbi_invoice_source_enum>>;
};

/** aggregate stddev on columns */
export type cbi_invoice_stddev_fields = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Float']['output']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this invoice. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cbi_invoice" */
export type cbi_invoice_stddev_order_by = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<order_by>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type cbi_invoice_stddev_pop_fields = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Float']['output']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this invoice. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cbi_invoice" */
export type cbi_invoice_stddev_pop_order_by = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<order_by>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type cbi_invoice_stddev_samp_fields = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Float']['output']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this invoice. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cbi_invoice" */
export type cbi_invoice_stddev_samp_order_by = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<order_by>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "cbi_invoice" */
export type cbi_invoice_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_invoice_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_invoice_stream_cursor_value_input = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<Scalars['Int']['input']>;
  cbi_invoice_source_id?: InputMaybe<cbi_invoice_source_enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<Scalars['Int']['input']>;
  /** Human-readable explanation of the duplicate detection reason. */
  duplicate_reason?: InputMaybe<Scalars['String']['input']>;
  /** Classification of why this invoice was flagged as a duplicate. */
  duplicate_reason_type?: InputMaybe<cbi_duplicate_reason_type_enum>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type cbi_invoice_sum_fields = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Int']['output']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Int']['output']>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization that owns this invoice. */
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cbi_invoice" */
export type cbi_invoice_sum_order_by = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<order_by>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<order_by>;
};

export enum cbi_invoice_type_enum {
  CANCELLATION = 'CANCELLATION',
  CORRECTION = 'CORRECTION',
  FEE_NOTICE = 'FEE_NOTICE',
  FEE_NOTICE_CORRECTION = 'FEE_NOTICE_CORRECTION',
  INVOICE = 'INVOICE',
}

/** Boolean expression to compare columns of type "cbi_invoice_type_enum". All fields are combined with logical 'AND'. */
export type cbi_invoice_type_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_invoice_type_enum>;
  _in?: InputMaybe<Array<cbi_invoice_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_invoice_type_enum>;
  _nin?: InputMaybe<Array<cbi_invoice_type_enum>>;
};

/** aggregate var_pop on columns */
export type cbi_invoice_var_pop_fields = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Float']['output']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this invoice. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cbi_invoice" */
export type cbi_invoice_var_pop_order_by = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<order_by>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type cbi_invoice_var_samp_fields = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Float']['output']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this invoice. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cbi_invoice" */
export type cbi_invoice_var_samp_order_by = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<order_by>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type cbi_invoice_variance_fields = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: Maybe<Scalars['Float']['output']>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this invoice. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cbi_invoice" */
export type cbi_invoice_variance_order_by = {
  /** The email this invoice was extracted from. */
  cbi_email_id?: InputMaybe<order_by>;
  /** If this invoice is a duplicate, references the original invoice. */
  duplicate_of_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice file (PDF). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this invoice. */
  org_id?: InputMaybe<order_by>;
};

export enum cbi_manual_review_state_enum {
  MANUAL_APPROVAL = 'MANUAL_APPROVAL',
  MANUAL_REJECTION = 'MANUAL_REJECTION',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
}

export enum cbi_operational_control_enum {
  LANDLORD_CONTROLLED = 'LANDLORD_CONTROLLED',
  TENANT_CONTROLLED = 'TENANT_CONTROLLED',
}

/** Boolean expression to compare columns of type "cbi_operational_control_enum". All fields are combined with logical 'AND'. */
export type cbi_operational_control_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_operational_control_enum>;
  _in?: InputMaybe<Array<cbi_operational_control_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_operational_control_enum>;
  _nin?: InputMaybe<Array<cbi_operational_control_enum>>;
};

/** AI-suggested candidate matches between a CBI address and buildings, ranked by similarity score. Awaits user confirmation. */
export type cbi_potential_building_match = {
  /** Optional candidate area within the building. */
  area_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  building: building;
  /** Candidate building for the match. */
  building_id: Scalars['Int']['output'];
  /** An object relationship */
  cbi_address: cbi_address;
  /** The CBI address to be matched. */
  cbi_address_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** Whether the system automatically confirmed this match based on a high confidence score. */
  is_auto_assigned: Scalars['Boolean']['output'];
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score: Scalars['float8']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "cbi_potential_building_match" */
export type cbi_potential_building_match_aggregate_order_by = {
  avg?: InputMaybe<cbi_potential_building_match_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<cbi_potential_building_match_max_order_by>;
  min?: InputMaybe<cbi_potential_building_match_min_order_by>;
  stddev?: InputMaybe<cbi_potential_building_match_stddev_order_by>;
  stddev_pop?: InputMaybe<cbi_potential_building_match_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<cbi_potential_building_match_stddev_samp_order_by>;
  sum?: InputMaybe<cbi_potential_building_match_sum_order_by>;
  var_pop?: InputMaybe<cbi_potential_building_match_var_pop_order_by>;
  var_samp?: InputMaybe<cbi_potential_building_match_var_samp_order_by>;
  variance?: InputMaybe<cbi_potential_building_match_variance_order_by>;
};

/** order by avg() on columns of table "cbi_potential_building_match" */
export type cbi_potential_building_match_avg_order_by = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<order_by>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "cbi_potential_building_match". All fields are combined with a logical 'AND'. */
export type cbi_potential_building_match_bool_exp = {
  _and?: InputMaybe<Array<cbi_potential_building_match_bool_exp>>;
  _not?: InputMaybe<cbi_potential_building_match_bool_exp>;
  _or?: InputMaybe<Array<cbi_potential_building_match_bool_exp>>;
  area_id?: InputMaybe<Int_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  cbi_address?: InputMaybe<cbi_address_bool_exp>;
  cbi_address_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  is_auto_assigned?: InputMaybe<Boolean_comparison_exp>;
  score?: InputMaybe<float8_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "cbi_potential_building_match" */
export type cbi_potential_building_match_max_order_by = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<order_by>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "cbi_potential_building_match" */
export type cbi_potential_building_match_min_order_by = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<order_by>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "cbi_potential_building_match". */
export type cbi_potential_building_match_order_by = {
  area_id?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  cbi_address?: InputMaybe<cbi_address_order_by>;
  cbi_address_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  is_auto_assigned?: InputMaybe<order_by>;
  score?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "cbi_potential_building_match" */
export enum cbi_potential_building_match_select_column {
  /** column name */
  area_id = 'area_id',
  /** column name */
  building_id = 'building_id',
  /** column name */
  cbi_address_id = 'cbi_address_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  is_auto_assigned = 'is_auto_assigned',
  /** column name */
  score = 'score',
  /** column name */
  updated_at = 'updated_at',
}

/** order by stddev() on columns of table "cbi_potential_building_match" */
export type cbi_potential_building_match_stddev_order_by = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<order_by>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "cbi_potential_building_match" */
export type cbi_potential_building_match_stddev_pop_order_by = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<order_by>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "cbi_potential_building_match" */
export type cbi_potential_building_match_stddev_samp_order_by = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<order_by>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "cbi_potential_building_match" */
export type cbi_potential_building_match_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cbi_potential_building_match_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cbi_potential_building_match_stream_cursor_value_input = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<Scalars['Int']['input']>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the system automatically confirmed this match based on a high confidence score. */
  is_auto_assigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "cbi_potential_building_match" */
export type cbi_potential_building_match_sum_order_by = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<order_by>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "cbi_potential_building_match" */
export type cbi_potential_building_match_var_pop_order_by = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<order_by>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "cbi_potential_building_match" */
export type cbi_potential_building_match_var_samp_order_by = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<order_by>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "cbi_potential_building_match" */
export type cbi_potential_building_match_variance_order_by = {
  /** Optional candidate area within the building. */
  area_id?: InputMaybe<order_by>;
  /** Candidate building for the match. */
  building_id?: InputMaybe<order_by>;
  /** The CBI address to be matched. */
  cbi_address_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Similarity score between the CBI address and the building address, from 0 to 1. */
  score?: InputMaybe<order_by>;
};

export enum cbi_reference_area_enum {
  COMMON_AREA = 'COMMON_AREA',
  TENANT_AREA = 'TENANT_AREA',
  WHOLE_BUILDING = 'WHOLE_BUILDING',
}

/** Boolean expression to compare columns of type "cbi_reference_area_enum". All fields are combined with logical 'AND'. */
export type cbi_reference_area_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_reference_area_enum>;
  _in?: InputMaybe<Array<cbi_reference_area_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_reference_area_enum>;
  _nin?: InputMaybe<Array<cbi_reference_area_enum>>;
};

export enum cbi_waste_container_frequency_period_enum {
  BIWEEKLY = 'BIWEEKLY',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  ONCE = 'ONCE',
  QUARTERLY = 'QUARTERLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY',
}

/** Boolean expression to compare columns of type "cbi_waste_container_frequency_period_enum". All fields are combined with logical 'AND'. */
export type cbi_waste_container_frequency_period_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_waste_container_frequency_period_enum>;
  _in?: InputMaybe<Array<cbi_waste_container_frequency_period_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_waste_container_frequency_period_enum>;
  _nin?: InputMaybe<Array<cbi_waste_container_frequency_period_enum>>;
};

export enum cbi_waste_container_size_unit_enum {
  L = 'L',
  M3 = 'M3',
}

/** Boolean expression to compare columns of type "cbi_waste_container_size_unit_enum". All fields are combined with logical 'AND'. */
export type cbi_waste_container_size_unit_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_waste_container_size_unit_enum>;
  _in?: InputMaybe<Array<cbi_waste_container_size_unit_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_waste_container_size_unit_enum>;
  _nin?: InputMaybe<Array<cbi_waste_container_size_unit_enum>>;
};

export enum cbi_waste_quantity_unit_enum {
  KG = 'KG',
  L = 'L',
  M3 = 'M3',
  PIECE = 'PIECE',
  T = 'T',
}

/** Boolean expression to compare columns of type "cbi_waste_quantity_unit_enum". All fields are combined with logical 'AND'. */
export type cbi_waste_quantity_unit_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_waste_quantity_unit_enum>;
  _in?: InputMaybe<Array<cbi_waste_quantity_unit_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_waste_quantity_unit_enum>;
  _nin?: InputMaybe<Array<cbi_waste_quantity_unit_enum>>;
};

export enum cbi_waste_sub_type_enum {
  BULKY = 'BULKY',
  CONSTRUCTION_AND_EXCAVATION = 'CONSTRUCTION_AND_EXCAVATION',
  ELECTRONIC_EQUIPMENT = 'ELECTRONIC_EQUIPMENT',
  GLASS = 'GLASS',
  ORGANIC = 'ORGANIC',
  OTHER_NON_RECYCLABLES = 'OTHER_NON_RECYCLABLES',
  OTHER_RECYCLABLES = 'OTHER_RECYCLABLES',
  PACKAGING = 'PACKAGING',
  PAPER = 'PAPER',
  RESIDUAL_WASTE = 'RESIDUAL_WASTE',
  WOOD = 'WOOD',
}

/** Boolean expression to compare columns of type "cbi_waste_sub_type_enum". All fields are combined with logical 'AND'. */
export type cbi_waste_sub_type_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_waste_sub_type_enum>;
  _in?: InputMaybe<Array<cbi_waste_sub_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_waste_sub_type_enum>;
  _nin?: InputMaybe<Array<cbi_waste_sub_type_enum>>;
};

export enum cbi_water_sub_type_enum {
  DRINKING_WATER = 'DRINKING_WATER',
  RAINWATER = 'RAINWATER',
  WASTEWATER = 'WASTEWATER',
}

/** Boolean expression to compare columns of type "cbi_water_sub_type_enum". All fields are combined with logical 'AND'. */
export type cbi_water_sub_type_enum_comparison_exp = {
  _eq?: InputMaybe<cbi_water_sub_type_enum>;
  _in?: InputMaybe<Array<cbi_water_sub_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cbi_water_sub_type_enum>;
  _nin?: InputMaybe<Array<cbi_water_sub_type_enum>>;
};

/** A sustainability or green building certificate (e.g., DGNB, LEED, BREEAM) awarded to a building. */
export type certificate = {
  /** An object relationship */
  building?: Maybe<building>;
  /** An object relationship */
  building_draft?: Maybe<building_draft>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Int']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Certification level achieved (e.g., Gold, Platinum, Outstanding). */
  certificate_level_type?: Maybe<certificate_level_type_enum>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Int']['output']>;
  /** Certification scheme (e.g., DGNB, LEED, BREEAM). */
  certificate_type: certificate_type_enum;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file?: Maybe<file>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

/** aggregated selection of "certificate" */
export type certificate_aggregate = {
  aggregate?: Maybe<certificate_aggregate_fields>;
  nodes: Array<certificate>;
};

export type certificate_aggregate_bool_exp = {
  count?: InputMaybe<certificate_aggregate_bool_exp_count>;
};

export type certificate_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<certificate_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<certificate_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "certificate" */
export type certificate_aggregate_fields = {
  avg?: Maybe<certificate_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<certificate_max_fields>;
  min?: Maybe<certificate_min_fields>;
  stddev?: Maybe<certificate_stddev_fields>;
  stddev_pop?: Maybe<certificate_stddev_pop_fields>;
  stddev_samp?: Maybe<certificate_stddev_samp_fields>;
  sum?: Maybe<certificate_sum_fields>;
  var_pop?: Maybe<certificate_var_pop_fields>;
  var_samp?: Maybe<certificate_var_samp_fields>;
  variance?: Maybe<certificate_variance_fields>;
};

/** aggregate fields of "certificate" */
export type certificate_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<certificate_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "certificate" */
export type certificate_aggregate_order_by = {
  avg?: InputMaybe<certificate_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<certificate_max_order_by>;
  min?: InputMaybe<certificate_min_order_by>;
  stddev?: InputMaybe<certificate_stddev_order_by>;
  stddev_pop?: InputMaybe<certificate_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<certificate_stddev_samp_order_by>;
  sum?: InputMaybe<certificate_sum_order_by>;
  var_pop?: InputMaybe<certificate_var_pop_order_by>;
  var_samp?: InputMaybe<certificate_var_samp_order_by>;
  variance?: InputMaybe<certificate_variance_order_by>;
};

/** aggregate avg on columns */
export type certificate_avg_fields = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Float']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "certificate" */
export type certificate_avg_order_by = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<order_by>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "certificate". All fields are combined with a logical 'AND'. */
export type certificate_bool_exp = {
  _and?: InputMaybe<Array<certificate_bool_exp>>;
  _not?: InputMaybe<certificate_bool_exp>;
  _or?: InputMaybe<Array<certificate_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_draft?: InputMaybe<building_draft_bool_exp>;
  building_draft_id?: InputMaybe<Int_comparison_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  certificate_level_type?: InputMaybe<certificate_level_type_enum_comparison_exp>;
  certificate_score?: InputMaybe<Int_comparison_exp>;
  certificate_type?: InputMaybe<certificate_type_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  file?: InputMaybe<file_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
};

export enum certificate_level_type_enum {
  /** BREEAM */
  BREEAM_EXCELLENT = 'BREEAM_EXCELLENT',
  /** BREEAM */
  BREEAM_GOOD = 'BREEAM_GOOD',
  /** BREEAM */
  BREEAM_OUTSTANDING = 'BREEAM_OUTSTANDING',
  /** BREEAM */
  BREEAM_PASS = 'BREEAM_PASS',
  /** BREEAM */
  BREEAM_UNCLASSIFIED = 'BREEAM_UNCLASSIFIED',
  /** BREEAM */
  BREEAM_VERY_GOOD = 'BREEAM_VERY_GOOD',
  /** DGNB */
  DGNB_BRONZE = 'DGNB_BRONZE',
  /** DGNB */
  DGNB_GOLD = 'DGNB_GOLD',
  /** DGNB */
  DGNB_PLATINUM = 'DGNB_PLATINUM',
  /** DGNB */
  DGNB_SILVER = 'DGNB_SILVER',
  /** HQE */
  HQE_EXCELLENT = 'HQE_EXCELLENT',
  /** HQE */
  HQE_GOOD = 'HQE_GOOD',
  /** HQE */
  HQE_OUTSTANDING = 'HQE_OUTSTANDING',
  /** HQE */
  HQE_VERY_GOOD = 'HQE_VERY_GOOD',
  /** LEED */
  LEED_CERTIFIED = 'LEED_CERTIFIED',
  /** LEED */
  LEED_GOLD = 'LEED_GOLD',
  /** LEED */
  LEED_PLATINUM = 'LEED_PLATINUM',
  /** LEED */
  LEED_SILVER = 'LEED_SILVER',
}

/** Boolean expression to compare columns of type "certificate_level_type_enum". All fields are combined with logical 'AND'. */
export type certificate_level_type_enum_comparison_exp = {
  _eq?: InputMaybe<certificate_level_type_enum>;
  _in?: InputMaybe<Array<certificate_level_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<certificate_level_type_enum>;
  _nin?: InputMaybe<Array<certificate_level_type_enum>>;
};

/** aggregate max on columns */
export type certificate_max_fields = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Int']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "certificate" */
export type certificate_max_order_by = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<order_by>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type certificate_min_fields = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Int']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "certificate" */
export type certificate_min_order_by = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<order_by>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "certificate". */
export type certificate_order_by = {
  building?: InputMaybe<building_order_by>;
  building_draft?: InputMaybe<building_draft_order_by>;
  building_draft_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  certificate_level_type?: InputMaybe<order_by>;
  certificate_score?: InputMaybe<order_by>;
  certificate_type?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  file?: InputMaybe<file_order_by>;
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** select columns of table "certificate" */
export enum certificate_select_column {
  /** column name */
  building_draft_id = 'building_draft_id',
  /** column name */
  building_id = 'building_id',
  /** column name */
  certificate_level_type = 'certificate_level_type',
  /** column name */
  certificate_score = 'certificate_score',
  /** column name */
  certificate_type = 'certificate_type',
  /** column name */
  created_at = 'created_at',
  /** column name */
  file_id = 'file_id',
  /** column name */
  id = 'id',
}

/** aggregate stddev on columns */
export type certificate_stddev_fields = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Float']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "certificate" */
export type certificate_stddev_order_by = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<order_by>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type certificate_stddev_pop_fields = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Float']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "certificate" */
export type certificate_stddev_pop_order_by = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<order_by>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type certificate_stddev_samp_fields = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Float']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "certificate" */
export type certificate_stddev_samp_order_by = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<order_by>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "certificate" */
export type certificate_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: certificate_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type certificate_stream_cursor_value_input = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** Certification level achieved (e.g., Gold, Platinum, Outstanding). */
  certificate_level_type?: InputMaybe<certificate_level_type_enum>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<Scalars['Int']['input']>;
  /** Certification scheme (e.g., DGNB, LEED, BREEAM). */
  certificate_type?: InputMaybe<certificate_type_enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type certificate_sum_fields = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Int']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Int']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "certificate" */
export type certificate_sum_order_by = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<order_by>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

export enum certificate_type_enum {
  BREEAM = 'BREEAM',
  DGNB = 'DGNB',
  ENERGY_STAR_SCORE = 'ENERGY_STAR_SCORE',
  HQE = 'HQE',
  LEED = 'LEED',
  LIVING_FUTURE_ZERO_CARBON = 'LIVING_FUTURE_ZERO_CARBON',
  LIVING_FUTURE_ZERO_ENERGY = 'LIVING_FUTURE_ZERO_ENERGY',
}

/** Boolean expression to compare columns of type "certificate_type_enum". All fields are combined with logical 'AND'. */
export type certificate_type_enum_comparison_exp = {
  _eq?: InputMaybe<certificate_type_enum>;
  _in?: InputMaybe<Array<certificate_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<certificate_type_enum>;
  _nin?: InputMaybe<Array<certificate_type_enum>>;
};

/** aggregate var_pop on columns */
export type certificate_var_pop_fields = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Float']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "certificate" */
export type certificate_var_pop_order_by = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<order_by>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type certificate_var_samp_fields = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Float']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "certificate" */
export type certificate_var_samp_order_by = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<order_by>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type certificate_variance_fields = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Float']['output']>;
  /** The building that holds this certificate. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "certificate" */
export type certificate_variance_order_by = {
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building that holds this certificate. */
  building_id?: InputMaybe<order_by>;
  /** Numeric score achieved in the certification assessment. Scale depends on the certificate type (e.g., DGNB, LEED, BREEAM each use different scoring scales). */
  certificate_score?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

export enum class_of_use_enum {
  COMMERCIAL = 'COMMERCIAL',
  RESIDENTIAL = 'RESIDENTIAL',
}

/** Boolean expression to compare columns of type "class_of_use_enum". All fields are combined with logical 'AND'. */
export type class_of_use_enum_comparison_exp = {
  _eq?: InputMaybe<class_of_use_enum>;
  _in?: InputMaybe<Array<class_of_use_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<class_of_use_enum>;
  _nin?: InputMaybe<Array<class_of_use_enum>>;
};

export enum climate_region_enum {
  AT_NATIONAL = 'AT_NATIONAL',
  BE_NATIONAL = 'BE_NATIONAL',
  CZ_NATIONAL = 'CZ_NATIONAL',
  DE_EASTERN = 'DE_EASTERN',
  DE_NATIONAL = 'DE_NATIONAL',
  FR_NATIONAL = 'FR_NATIONAL',
  PL_NATIONAL = 'PL_NATIONAL',
  UK_NATIONAL = 'UK_NATIONAL',
}

/** Boolean expression to compare columns of type "climate_region_enum". All fields are combined with logical 'AND'. */
export type climate_region_enum_comparison_exp = {
  _eq?: InputMaybe<climate_region_enum>;
  _in?: InputMaybe<Array<climate_region_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<climate_region_enum>;
  _nin?: InputMaybe<Array<climate_region_enum>>;
};

/** Legacy climate risk assessment result for a building, storing a single risk value per type and timespan. */
export type climate_risk = {
  /** An object relationship */
  building: building;
  /** The building assessed. */
  building_id: Scalars['Int']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  /** Time horizon for the risk assessment (e.g., 2030, 2050, 2080). */
  timespan?: Maybe<Scalars['String']['output']>;
  /** Type of climate risk (e.g., flooding, heat stress, storm). */
  type: climate_risk_type_enum;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty: Scalars['Int']['output'];
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value: Scalars['Int']['output'];
};

/** aggregated selection of "climate_risk" */
export type climate_risk_aggregate = {
  aggregate?: Maybe<climate_risk_aggregate_fields>;
  nodes: Array<climate_risk>;
};

export type climate_risk_aggregate_bool_exp = {
  count?: InputMaybe<climate_risk_aggregate_bool_exp_count>;
};

export type climate_risk_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<climate_risk_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<climate_risk_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "climate_risk" */
export type climate_risk_aggregate_fields = {
  avg?: Maybe<climate_risk_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<climate_risk_max_fields>;
  min?: Maybe<climate_risk_min_fields>;
  stddev?: Maybe<climate_risk_stddev_fields>;
  stddev_pop?: Maybe<climate_risk_stddev_pop_fields>;
  stddev_samp?: Maybe<climate_risk_stddev_samp_fields>;
  sum?: Maybe<climate_risk_sum_fields>;
  var_pop?: Maybe<climate_risk_var_pop_fields>;
  var_samp?: Maybe<climate_risk_var_samp_fields>;
  variance?: Maybe<climate_risk_variance_fields>;
};

/** aggregate fields of "climate_risk" */
export type climate_risk_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<climate_risk_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "climate_risk" */
export type climate_risk_aggregate_order_by = {
  avg?: InputMaybe<climate_risk_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<climate_risk_max_order_by>;
  min?: InputMaybe<climate_risk_min_order_by>;
  stddev?: InputMaybe<climate_risk_stddev_order_by>;
  stddev_pop?: InputMaybe<climate_risk_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<climate_risk_stddev_samp_order_by>;
  sum?: InputMaybe<climate_risk_sum_order_by>;
  var_pop?: InputMaybe<climate_risk_var_pop_order_by>;
  var_samp?: InputMaybe<climate_risk_var_samp_order_by>;
  variance?: InputMaybe<climate_risk_variance_order_by>;
};

/** aggregate avg on columns */
export type climate_risk_avg_fields = {
  /** The building assessed. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: Maybe<Scalars['Float']['output']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "climate_risk" */
export type climate_risk_avg_order_by = {
  /** The building assessed. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<order_by>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "climate_risk". All fields are combined with a logical 'AND'. */
export type climate_risk_bool_exp = {
  _and?: InputMaybe<Array<climate_risk_bool_exp>>;
  _not?: InputMaybe<climate_risk_bool_exp>;
  _or?: InputMaybe<Array<climate_risk_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  timespan?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<climate_risk_type_enum_comparison_exp>;
  uncertainty?: InputMaybe<Int_comparison_exp>;
  value?: InputMaybe<Int_comparison_exp>;
};

/** aggregate max on columns */
export type climate_risk_max_fields = {
  /** The building assessed. */
  building_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Time horizon for the risk assessment (e.g., 2030, 2050, 2080). */
  timespan?: Maybe<Scalars['String']['output']>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: Maybe<Scalars['Int']['output']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "climate_risk" */
export type climate_risk_max_order_by = {
  /** The building assessed. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Time horizon for the risk assessment (e.g., 2030, 2050, 2080). */
  timespan?: InputMaybe<order_by>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<order_by>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type climate_risk_min_fields = {
  /** The building assessed. */
  building_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Time horizon for the risk assessment (e.g., 2030, 2050, 2080). */
  timespan?: Maybe<Scalars['String']['output']>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: Maybe<Scalars['Int']['output']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "climate_risk" */
export type climate_risk_min_order_by = {
  /** The building assessed. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Time horizon for the risk assessment (e.g., 2030, 2050, 2080). */
  timespan?: InputMaybe<order_by>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<order_by>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "climate_risk". */
export type climate_risk_order_by = {
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  timespan?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  uncertainty?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "climate_risk" */
export enum climate_risk_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  timespan = 'timespan',
  /** column name */
  type = 'type',
  /** column name */
  uncertainty = 'uncertainty',
  /** column name */
  value = 'value',
}

/** aggregate stddev on columns */
export type climate_risk_stddev_fields = {
  /** The building assessed. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: Maybe<Scalars['Float']['output']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "climate_risk" */
export type climate_risk_stddev_order_by = {
  /** The building assessed. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<order_by>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type climate_risk_stddev_pop_fields = {
  /** The building assessed. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: Maybe<Scalars['Float']['output']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "climate_risk" */
export type climate_risk_stddev_pop_order_by = {
  /** The building assessed. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<order_by>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type climate_risk_stddev_samp_fields = {
  /** The building assessed. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: Maybe<Scalars['Float']['output']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "climate_risk" */
export type climate_risk_stddev_samp_order_by = {
  /** The building assessed. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<order_by>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "climate_risk" */
export type climate_risk_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: climate_risk_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type climate_risk_stream_cursor_value_input = {
  /** The building assessed. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Time horizon for the risk assessment (e.g., 2030, 2050, 2080). */
  timespan?: InputMaybe<Scalars['String']['input']>;
  /** Type of climate risk (e.g., flooding, heat stress, storm). */
  type?: InputMaybe<climate_risk_type_enum>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<Scalars['Int']['input']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type climate_risk_sum_fields = {
  /** The building assessed. */
  building_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: Maybe<Scalars['Int']['output']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "climate_risk" */
export type climate_risk_sum_order_by = {
  /** The building assessed. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<order_by>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<order_by>;
};

export enum climate_risk_type_enum {
  EARTHQUAKE = 'EARTHQUAKE',
  FOREST_FIRE = 'FOREST_FIRE',
  HAIL = 'HAIL',
  HEAT = 'HEAT',
  HEAVY_RAIN = 'HEAVY_RAIN',
  LIGHTNING_STRIKE = 'LIGHTNING_STRIKE',
  SNOW_LOAD = 'SNOW_LOAD',
  WINTER_STORM = 'WINTER_STORM',
}

/** Boolean expression to compare columns of type "climate_risk_type_enum". All fields are combined with logical 'AND'. */
export type climate_risk_type_enum_comparison_exp = {
  _eq?: InputMaybe<climate_risk_type_enum>;
  _in?: InputMaybe<Array<climate_risk_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<climate_risk_type_enum>;
  _nin?: InputMaybe<Array<climate_risk_type_enum>>;
};

/** Climate risk assessment from an external API (v2). Stores the full API response and tracks request/callback lifecycle. */
export type climate_risk_v2 = {
  /** Current status of the API request lifecycle. */
  api_response_status_id: api_response_status_enum;
  /** An object relationship */
  building: building;
  /** An object relationship */
  file?: Maybe<file>;
  id: Scalars['Int']['output'];
};

/** aggregated selection of "climate_risk_v2" */
export type climate_risk_v2_aggregate = {
  aggregate?: Maybe<climate_risk_v2_aggregate_fields>;
  nodes: Array<climate_risk_v2>;
};

export type climate_risk_v2_aggregate_bool_exp = {
  count?: InputMaybe<climate_risk_v2_aggregate_bool_exp_count>;
};

export type climate_risk_v2_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<climate_risk_v2_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<climate_risk_v2_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "climate_risk_v2" */
export type climate_risk_v2_aggregate_fields = {
  avg?: Maybe<climate_risk_v2_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<climate_risk_v2_max_fields>;
  min?: Maybe<climate_risk_v2_min_fields>;
  stddev?: Maybe<climate_risk_v2_stddev_fields>;
  stddev_pop?: Maybe<climate_risk_v2_stddev_pop_fields>;
  stddev_samp?: Maybe<climate_risk_v2_stddev_samp_fields>;
  sum?: Maybe<climate_risk_v2_sum_fields>;
  var_pop?: Maybe<climate_risk_v2_var_pop_fields>;
  var_samp?: Maybe<climate_risk_v2_var_samp_fields>;
  variance?: Maybe<climate_risk_v2_variance_fields>;
};

/** aggregate fields of "climate_risk_v2" */
export type climate_risk_v2_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<climate_risk_v2_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "climate_risk_v2" */
export type climate_risk_v2_aggregate_order_by = {
  avg?: InputMaybe<climate_risk_v2_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<climate_risk_v2_max_order_by>;
  min?: InputMaybe<climate_risk_v2_min_order_by>;
  stddev?: InputMaybe<climate_risk_v2_stddev_order_by>;
  stddev_pop?: InputMaybe<climate_risk_v2_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<climate_risk_v2_stddev_samp_order_by>;
  sum?: InputMaybe<climate_risk_v2_sum_order_by>;
  var_pop?: InputMaybe<climate_risk_v2_var_pop_order_by>;
  var_samp?: InputMaybe<climate_risk_v2_var_samp_order_by>;
  variance?: InputMaybe<climate_risk_v2_variance_order_by>;
};

/** aggregate avg on columns */
export type climate_risk_v2_avg_fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "climate_risk_v2" */
export type climate_risk_v2_avg_order_by = {
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "climate_risk_v2". All fields are combined with a logical 'AND'. */
export type climate_risk_v2_bool_exp = {
  _and?: InputMaybe<Array<climate_risk_v2_bool_exp>>;
  _not?: InputMaybe<climate_risk_v2_bool_exp>;
  _or?: InputMaybe<Array<climate_risk_v2_bool_exp>>;
  api_response_status_id?: InputMaybe<api_response_status_enum_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  file?: InputMaybe<file_bool_exp>;
  id?: InputMaybe<Int_comparison_exp>;
};

/** aggregate max on columns */
export type climate_risk_v2_max_fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "climate_risk_v2" */
export type climate_risk_v2_max_order_by = {
  id?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type climate_risk_v2_min_fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "climate_risk_v2" */
export type climate_risk_v2_min_order_by = {
  id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "climate_risk_v2". */
export type climate_risk_v2_order_by = {
  api_response_status_id?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  file?: InputMaybe<file_order_by>;
  id?: InputMaybe<order_by>;
};

/** select columns of table "climate_risk_v2" */
export enum climate_risk_v2_select_column {
  /** column name */
  api_response_status_id = 'api_response_status_id',
  /** column name */
  id = 'id',
}

/** aggregate stddev on columns */
export type climate_risk_v2_stddev_fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "climate_risk_v2" */
export type climate_risk_v2_stddev_order_by = {
  id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type climate_risk_v2_stddev_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "climate_risk_v2" */
export type climate_risk_v2_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type climate_risk_v2_stddev_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "climate_risk_v2" */
export type climate_risk_v2_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "climate_risk_v2" */
export type climate_risk_v2_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: climate_risk_v2_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type climate_risk_v2_stream_cursor_value_input = {
  /** Current status of the API request lifecycle. */
  api_response_status_id?: InputMaybe<api_response_status_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type climate_risk_v2_sum_fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "climate_risk_v2" */
export type climate_risk_v2_sum_order_by = {
  id?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type climate_risk_v2_var_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "climate_risk_v2" */
export type climate_risk_v2_var_pop_order_by = {
  id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type climate_risk_v2_var_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "climate_risk_v2" */
export type climate_risk_v2_var_samp_order_by = {
  id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type climate_risk_v2_variance_fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "climate_risk_v2" */
export type climate_risk_v2_variance_order_by = {
  id?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type climate_risk_var_pop_fields = {
  /** The building assessed. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: Maybe<Scalars['Float']['output']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "climate_risk" */
export type climate_risk_var_pop_order_by = {
  /** The building assessed. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<order_by>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type climate_risk_var_samp_fields = {
  /** The building assessed. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: Maybe<Scalars['Float']['output']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "climate_risk" */
export type climate_risk_var_samp_order_by = {
  /** The building assessed. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<order_by>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type climate_risk_variance_fields = {
  /** The building assessed. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: Maybe<Scalars['Float']['output']>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "climate_risk" */
export type climate_risk_variance_order_by = {
  /** The building assessed. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Uncertainty level of the risk assessment, integer 1-5 (enforced by CHECK constraint). */
  uncertainty?: InputMaybe<order_by>;
  /** Climate risk score, integer 0-100 (enforced by CHECK constraint). */
  value?: InputMaybe<order_by>;
};

export enum co2_price_curve_kind_enum {
  ANCHORS = 'ANCHORS',
  GROWTH = 'GROWTH',
}

/** Finalized energy, water, or waste usage records for a building over a specific time period. */
export type consumption = {
  /** When the row was last archived; NULL while ACTIVE. Maintained by the set_consumption_archived_at trigger — never write it directly. */
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  building: building;
  /** The building this consumption belongs to. */
  building_id: Scalars['Int']['output'];
  /** An object relationship */
  cbi_consumption_line?: Maybe<cbi_consumption_line>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  consumption_areas: Array<consumption_area>;
  /** An object relationship */
  consumption_invoice?: Maybe<consumption_invoice>;
  /** Category of consumption: HEATING, ELECTRICITY, WATER, or WASTE. */
  consumption_type_id: consumption_type_enum;
  /** An object relationship */
  consumption_waste_detail?: Maybe<consumption_waste_details>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['numeric']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<user>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  displayValue?: Maybe<Scalars['Float']['output']>;
  /** Unit used for displaying the consumption value in the UI (e.g. kWh, MWh, m3). */
  display_unit_value?: Maybe<consumption_unit_enum>;
  /** Specific energy source (e.g. natural gas, district heating) for HEATING or ELECTRICITY consumption types. */
  energy_source_type_id?: Maybe<energy_source_type_enum>;
  /** Start date of the consumption measurement period. */
  from: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Int']['output']>;
  /** Market location ID (MaLo-ID) of the metering point; mirrors cbi_consumption_line.market_location_id. */
  market_location_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  meter?: Maybe<smart_meter>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Int']['output']>;
  /** Meter number the consumption was read from; mirrors cbi_consumption_line.meter_number. */
  meter_number?: Maybe<Scalars['String']['output']>;
  /** Name of the energy or utility provider. */
  provider?: Maybe<Scalars['String']['output']>;
  /** How the data was obtained: MANUAL entry, ESTIMATED, METER reading, etc. */
  source_type_id: consumption_source_type_enum;
  /** Lifecycle state as a consumption_state id. ARCHIVED rows are excluded from calculations. */
  state: consumption_state_enum;
  /** Sub-category within WATER or WASTE consumption types (e.g. hot water, residual waste). */
  sub_type_id?: Maybe<consumption_sub_type_enum>;
  /** End date of the consumption measurement period. */
  to: Scalars['timestamptz']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['numeric']['output']>;
};

/** Finalized energy, water, or waste usage records for a building over a specific time period. */
export type consumptionconsumption_areasArgs = {
  distinct_on?: InputMaybe<Array<consumption_area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_area_order_by>>;
  where?: InputMaybe<consumption_area_bool_exp>;
};

/** aggregated selection of "consumption" */
export type consumption_aggregate = {
  aggregate?: Maybe<consumption_aggregate_fields>;
  nodes: Array<consumption>;
};

export type consumption_aggregate_bool_exp = {
  count?: InputMaybe<consumption_aggregate_bool_exp_count>;
};

export type consumption_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<consumption_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<consumption_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "consumption" */
export type consumption_aggregate_fields = {
  avg?: Maybe<consumption_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<consumption_max_fields>;
  min?: Maybe<consumption_min_fields>;
  stddev?: Maybe<consumption_stddev_fields>;
  stddev_pop?: Maybe<consumption_stddev_pop_fields>;
  stddev_samp?: Maybe<consumption_stddev_samp_fields>;
  sum?: Maybe<consumption_sum_fields>;
  var_pop?: Maybe<consumption_var_pop_fields>;
  var_samp?: Maybe<consumption_var_samp_fields>;
  variance?: Maybe<consumption_variance_fields>;
};

/** aggregate fields of "consumption" */
export type consumption_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<consumption_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "consumption" */
export type consumption_aggregate_order_by = {
  avg?: InputMaybe<consumption_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<consumption_max_order_by>;
  min?: InputMaybe<consumption_min_order_by>;
  stddev?: InputMaybe<consumption_stddev_order_by>;
  stddev_pop?: InputMaybe<consumption_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<consumption_stddev_samp_order_by>;
  sum?: InputMaybe<consumption_sum_order_by>;
  var_pop?: InputMaybe<consumption_var_pop_order_by>;
  var_samp?: InputMaybe<consumption_var_samp_order_by>;
  variance?: InputMaybe<consumption_variance_order_by>;
};

/** Junction table linking finalized consumption entries to the building areas they apply to. */
export type consumption_area = {
  /** An object relationship */
  area: area;
  area_id: Scalars['Int']['output'];
  /** An object relationship */
  building: building;
  building_id: Scalars['Int']['output'];
  /** An object relationship */
  consumption: consumption;
  consumption_id: Scalars['Int']['output'];
};

/** order by aggregate values of table "consumption_area" */
export type consumption_area_aggregate_order_by = {
  avg?: InputMaybe<consumption_area_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<consumption_area_max_order_by>;
  min?: InputMaybe<consumption_area_min_order_by>;
  stddev?: InputMaybe<consumption_area_stddev_order_by>;
  stddev_pop?: InputMaybe<consumption_area_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<consumption_area_stddev_samp_order_by>;
  sum?: InputMaybe<consumption_area_sum_order_by>;
  var_pop?: InputMaybe<consumption_area_var_pop_order_by>;
  var_samp?: InputMaybe<consumption_area_var_samp_order_by>;
  variance?: InputMaybe<consumption_area_variance_order_by>;
};

/** order by avg() on columns of table "consumption_area" */
export type consumption_area_avg_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "consumption_area". All fields are combined with a logical 'AND'. */
export type consumption_area_bool_exp = {
  _and?: InputMaybe<Array<consumption_area_bool_exp>>;
  _not?: InputMaybe<consumption_area_bool_exp>;
  _or?: InputMaybe<Array<consumption_area_bool_exp>>;
  area?: InputMaybe<area_bool_exp>;
  area_id?: InputMaybe<Int_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  consumption?: InputMaybe<consumption_bool_exp>;
  consumption_id?: InputMaybe<Int_comparison_exp>;
};

/** order by max() on columns of table "consumption_area" */
export type consumption_area_max_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "consumption_area" */
export type consumption_area_min_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "consumption_area". */
export type consumption_area_order_by = {
  area?: InputMaybe<area_order_by>;
  area_id?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  consumption?: InputMaybe<consumption_order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** select columns of table "consumption_area" */
export enum consumption_area_select_column {
  /** column name */
  area_id = 'area_id',
  /** column name */
  building_id = 'building_id',
  /** column name */
  consumption_id = 'consumption_id',
}

/** order by stddev() on columns of table "consumption_area" */
export type consumption_area_stddev_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "consumption_area" */
export type consumption_area_stddev_pop_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "consumption_area" */
export type consumption_area_stddev_samp_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "consumption_area" */
export type consumption_area_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: consumption_area_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type consumption_area_stream_cursor_value_input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  building_id?: InputMaybe<Scalars['Int']['input']>;
  consumption_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "consumption_area" */
export type consumption_area_sum_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "consumption_area" */
export type consumption_area_var_pop_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "consumption_area" */
export type consumption_area_var_samp_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "consumption_area" */
export type consumption_area_variance_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_id?: InputMaybe<order_by>;
};

/** aggregate avg on columns */
export type consumption_avg_fields = {
  /** The building this consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Float']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "consumption" */
export type consumption_avg_order_by = {
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<order_by>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<order_by>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<order_by>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "consumption". All fields are combined with a logical 'AND'. */
export type consumption_bool_exp = {
  _and?: InputMaybe<Array<consumption_bool_exp>>;
  _not?: InputMaybe<consumption_bool_exp>;
  _or?: InputMaybe<Array<consumption_bool_exp>>;
  archived_at?: InputMaybe<timestamptz_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  cbi_consumption_line?: InputMaybe<cbi_consumption_line_bool_exp>;
  co2_fee_gross?: InputMaybe<numeric_comparison_exp>;
  co2_fee_net?: InputMaybe<numeric_comparison_exp>;
  consumption_areas?: InputMaybe<consumption_area_bool_exp>;
  consumption_invoice?: InputMaybe<consumption_invoice_bool_exp>;
  consumption_type_id?: InputMaybe<consumption_type_enum_comparison_exp>;
  consumption_waste_detail?: InputMaybe<consumption_waste_details_bool_exp>;
  cost?: InputMaybe<numeric_comparison_exp>;
  cost_net?: InputMaybe<numeric_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  created_by_user?: InputMaybe<user_bool_exp>;
  created_by_user_id?: InputMaybe<Int_comparison_exp>;
  display_unit_value?: InputMaybe<consumption_unit_enum_comparison_exp>;
  energy_source_type_id?: InputMaybe<energy_source_type_enum_comparison_exp>;
  from?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  invoice_id?: InputMaybe<Int_comparison_exp>;
  market_location_id?: InputMaybe<String_comparison_exp>;
  meter?: InputMaybe<smart_meter_bool_exp>;
  meter_id?: InputMaybe<Int_comparison_exp>;
  meter_number?: InputMaybe<String_comparison_exp>;
  provider?: InputMaybe<String_comparison_exp>;
  source_type_id?: InputMaybe<consumption_source_type_enum_comparison_exp>;
  state?: InputMaybe<consumption_state_enum_comparison_exp>;
  sub_type_id?: InputMaybe<consumption_sub_type_enum_comparison_exp>;
  to?: InputMaybe<timestamptz_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  value?: InputMaybe<numeric_comparison_exp>;
};

/** In-progress consumption entries that have not yet been finalized. Fields are nullable to allow partial data entry. */
export type consumption_draft = {
  /** An object relationship */
  building: building;
  /** The building this draft consumption belongs to. */
  building_id: Scalars['Int']['output'];
  /** An array relationship */
  consumption_draft_areas: Array<consumption_draft_area>;
  /** An object relationship */
  consumption_invoice_draft?: Maybe<consumption_invoice_draft>;
  /** Category of consumption: HEATING, ELECTRICITY, WATER, or WASTE. */
  consumption_type_id?: Maybe<consumption_type_enum>;
  /** An object relationship */
  consumption_waste_details_draft?: Maybe<consumption_waste_details_draft>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<user>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  displayValue?: Maybe<Scalars['Float']['output']>;
  /** Unit used for displaying the consumption value in the UI. */
  display_unit_value?: Maybe<consumption_unit_enum>;
  /** Specific energy source (e.g. natural gas, district heating) for HEATING or ELECTRICITY types. */
  energy_source_type_id?: Maybe<energy_source_type_enum>;
  /** Start date of the consumption measurement period. */
  from?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Int']['output']>;
  /** Name of the energy or utility provider. */
  provider?: Maybe<Scalars['String']['output']>;
  /** How the data was obtained: MANUAL entry, ESTIMATED, METER reading, etc. */
  source_type_id: consumption_source_type_enum;
  /** Sub-category within WATER or WASTE consumption types. */
  sub_type_id?: Maybe<consumption_sub_type_enum>;
  /** End date of the consumption measurement period. */
  to?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['numeric']['output']>;
};

/** In-progress consumption entries that have not yet been finalized. Fields are nullable to allow partial data entry. */
export type consumption_draftconsumption_draft_areasArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_area_order_by>>;
  where?: InputMaybe<consumption_draft_area_bool_exp>;
};

/** aggregated selection of "consumption_draft" */
export type consumption_draft_aggregate = {
  aggregate?: Maybe<consumption_draft_aggregate_fields>;
  nodes: Array<consumption_draft>;
};

export type consumption_draft_aggregate_bool_exp = {
  count?: InputMaybe<consumption_draft_aggregate_bool_exp_count>;
};

export type consumption_draft_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<consumption_draft_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<consumption_draft_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "consumption_draft" */
export type consumption_draft_aggregate_fields = {
  avg?: Maybe<consumption_draft_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<consumption_draft_max_fields>;
  min?: Maybe<consumption_draft_min_fields>;
  stddev?: Maybe<consumption_draft_stddev_fields>;
  stddev_pop?: Maybe<consumption_draft_stddev_pop_fields>;
  stddev_samp?: Maybe<consumption_draft_stddev_samp_fields>;
  sum?: Maybe<consumption_draft_sum_fields>;
  var_pop?: Maybe<consumption_draft_var_pop_fields>;
  var_samp?: Maybe<consumption_draft_var_samp_fields>;
  variance?: Maybe<consumption_draft_variance_fields>;
};

/** aggregate fields of "consumption_draft" */
export type consumption_draft_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<consumption_draft_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "consumption_draft" */
export type consumption_draft_aggregate_order_by = {
  avg?: InputMaybe<consumption_draft_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<consumption_draft_max_order_by>;
  min?: InputMaybe<consumption_draft_min_order_by>;
  stddev?: InputMaybe<consumption_draft_stddev_order_by>;
  stddev_pop?: InputMaybe<consumption_draft_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<consumption_draft_stddev_samp_order_by>;
  sum?: InputMaybe<consumption_draft_sum_order_by>;
  var_pop?: InputMaybe<consumption_draft_var_pop_order_by>;
  var_samp?: InputMaybe<consumption_draft_var_samp_order_by>;
  variance?: InputMaybe<consumption_draft_variance_order_by>;
};

/** Junction table linking draft consumption entries to the building areas they apply to. */
export type consumption_draft_area = {
  /** An object relationship */
  area: area;
  area_id: Scalars['Int']['output'];
  /** An object relationship */
  building: building;
  building_id: Scalars['Int']['output'];
  /** An object relationship */
  consumption_draft: consumption_draft;
  consumption_draft_id: Scalars['Int']['output'];
};

/** order by aggregate values of table "consumption_draft_area" */
export type consumption_draft_area_aggregate_order_by = {
  avg?: InputMaybe<consumption_draft_area_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<consumption_draft_area_max_order_by>;
  min?: InputMaybe<consumption_draft_area_min_order_by>;
  stddev?: InputMaybe<consumption_draft_area_stddev_order_by>;
  stddev_pop?: InputMaybe<consumption_draft_area_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<consumption_draft_area_stddev_samp_order_by>;
  sum?: InputMaybe<consumption_draft_area_sum_order_by>;
  var_pop?: InputMaybe<consumption_draft_area_var_pop_order_by>;
  var_samp?: InputMaybe<consumption_draft_area_var_samp_order_by>;
  variance?: InputMaybe<consumption_draft_area_variance_order_by>;
};

/** order by avg() on columns of table "consumption_draft_area" */
export type consumption_draft_area_avg_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "consumption_draft_area". All fields are combined with a logical 'AND'. */
export type consumption_draft_area_bool_exp = {
  _and?: InputMaybe<Array<consumption_draft_area_bool_exp>>;
  _not?: InputMaybe<consumption_draft_area_bool_exp>;
  _or?: InputMaybe<Array<consumption_draft_area_bool_exp>>;
  area?: InputMaybe<area_bool_exp>;
  area_id?: InputMaybe<Int_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  consumption_draft?: InputMaybe<consumption_draft_bool_exp>;
  consumption_draft_id?: InputMaybe<Int_comparison_exp>;
};

/** order by max() on columns of table "consumption_draft_area" */
export type consumption_draft_area_max_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "consumption_draft_area" */
export type consumption_draft_area_min_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "consumption_draft_area". */
export type consumption_draft_area_order_by = {
  area?: InputMaybe<area_order_by>;
  area_id?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft?: InputMaybe<consumption_draft_order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** select columns of table "consumption_draft_area" */
export enum consumption_draft_area_select_column {
  /** column name */
  area_id = 'area_id',
  /** column name */
  building_id = 'building_id',
  /** column name */
  consumption_draft_id = 'consumption_draft_id',
}

/** order by stddev() on columns of table "consumption_draft_area" */
export type consumption_draft_area_stddev_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "consumption_draft_area" */
export type consumption_draft_area_stddev_pop_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "consumption_draft_area" */
export type consumption_draft_area_stddev_samp_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "consumption_draft_area" */
export type consumption_draft_area_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: consumption_draft_area_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type consumption_draft_area_stream_cursor_value_input = {
  area_id?: InputMaybe<Scalars['Int']['input']>;
  building_id?: InputMaybe<Scalars['Int']['input']>;
  consumption_draft_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "consumption_draft_area" */
export type consumption_draft_area_sum_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "consumption_draft_area" */
export type consumption_draft_area_var_pop_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "consumption_draft_area" */
export type consumption_draft_area_var_samp_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "consumption_draft_area" */
export type consumption_draft_area_variance_order_by = {
  area_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_id?: InputMaybe<order_by>;
};

/** aggregate avg on columns */
export type consumption_draft_avg_fields = {
  /** The building this draft consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "consumption_draft" */
export type consumption_draft_avg_order_by = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<order_by>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "consumption_draft". All fields are combined with a logical 'AND'. */
export type consumption_draft_bool_exp = {
  _and?: InputMaybe<Array<consumption_draft_bool_exp>>;
  _not?: InputMaybe<consumption_draft_bool_exp>;
  _or?: InputMaybe<Array<consumption_draft_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  consumption_draft_areas?: InputMaybe<consumption_draft_area_bool_exp>;
  consumption_invoice_draft?: InputMaybe<consumption_invoice_draft_bool_exp>;
  consumption_type_id?: InputMaybe<consumption_type_enum_comparison_exp>;
  consumption_waste_details_draft?: InputMaybe<consumption_waste_details_draft_bool_exp>;
  cost?: InputMaybe<numeric_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  created_by_user?: InputMaybe<user_bool_exp>;
  created_by_user_id?: InputMaybe<Int_comparison_exp>;
  display_unit_value?: InputMaybe<consumption_unit_enum_comparison_exp>;
  energy_source_type_id?: InputMaybe<energy_source_type_enum_comparison_exp>;
  from?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  invoice_draft_id?: InputMaybe<Int_comparison_exp>;
  provider?: InputMaybe<String_comparison_exp>;
  source_type_id?: InputMaybe<consumption_source_type_enum_comparison_exp>;
  sub_type_id?: InputMaybe<consumption_sub_type_enum_comparison_exp>;
  to?: InputMaybe<timestamptz_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  value?: InputMaybe<numeric_comparison_exp>;
};

/** aggregate max on columns */
export type consumption_draft_max_fields = {
  /** The building this draft consumption belongs to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** Start date of the consumption measurement period. */
  from?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Int']['output']>;
  /** Name of the energy or utility provider. */
  provider?: Maybe<Scalars['String']['output']>;
  /** End date of the consumption measurement period. */
  to?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "consumption_draft" */
export type consumption_draft_max_order_by = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<order_by>;
  /** Start date of the consumption measurement period. */
  from?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<order_by>;
  /** Name of the energy or utility provider. */
  provider?: InputMaybe<order_by>;
  /** End date of the consumption measurement period. */
  to?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type consumption_draft_min_fields = {
  /** The building this draft consumption belongs to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** Start date of the consumption measurement period. */
  from?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Int']['output']>;
  /** Name of the energy or utility provider. */
  provider?: Maybe<Scalars['String']['output']>;
  /** End date of the consumption measurement period. */
  to?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "consumption_draft" */
export type consumption_draft_min_order_by = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<order_by>;
  /** Start date of the consumption measurement period. */
  from?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<order_by>;
  /** Name of the energy or utility provider. */
  provider?: InputMaybe<order_by>;
  /** End date of the consumption measurement period. */
  to?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<order_by>;
};

/** response of any mutation on the table "consumption_draft" */
export type consumption_draft_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<consumption_draft>;
};

/** Ordering options when selecting data from "consumption_draft". */
export type consumption_draft_order_by = {
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_draft_areas_aggregate?: InputMaybe<consumption_draft_area_aggregate_order_by>;
  consumption_invoice_draft?: InputMaybe<consumption_invoice_draft_order_by>;
  consumption_type_id?: InputMaybe<order_by>;
  consumption_waste_details_draft?: InputMaybe<consumption_waste_details_draft_order_by>;
  cost?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  created_by_user?: InputMaybe<user_order_by>;
  created_by_user_id?: InputMaybe<order_by>;
  display_unit_value?: InputMaybe<order_by>;
  energy_source_type_id?: InputMaybe<order_by>;
  from?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_draft_id?: InputMaybe<order_by>;
  provider?: InputMaybe<order_by>;
  source_type_id?: InputMaybe<order_by>;
  sub_type_id?: InputMaybe<order_by>;
  to?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "consumption_draft" */
export enum consumption_draft_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  consumption_type_id = 'consumption_type_id',
  /** column name */
  cost = 'cost',
  /** column name */
  created_at = 'created_at',
  /** column name */
  created_by_user_id = 'created_by_user_id',
  /** column name */
  display_unit_value = 'display_unit_value',
  /** column name */
  energy_source_type_id = 'energy_source_type_id',
  /** column name */
  from = 'from',
  /** column name */
  id = 'id',
  /** column name */
  invoice_draft_id = 'invoice_draft_id',
  /** column name */
  provider = 'provider',
  /** column name */
  source_type_id = 'source_type_id',
  /** column name */
  sub_type_id = 'sub_type_id',
  /** column name */
  to = 'to',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  value = 'value',
}

/** aggregate stddev on columns */
export type consumption_draft_stddev_fields = {
  /** The building this draft consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "consumption_draft" */
export type consumption_draft_stddev_order_by = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<order_by>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type consumption_draft_stddev_pop_fields = {
  /** The building this draft consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "consumption_draft" */
export type consumption_draft_stddev_pop_order_by = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<order_by>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type consumption_draft_stddev_samp_fields = {
  /** The building this draft consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "consumption_draft" */
export type consumption_draft_stddev_samp_order_by = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<order_by>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "consumption_draft" */
export type consumption_draft_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: consumption_draft_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type consumption_draft_stream_cursor_value_input = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** Category of consumption: HEATING, ELECTRICITY, WATER, or WASTE. */
  consumption_type_id?: InputMaybe<consumption_type_enum>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Unit used for displaying the consumption value in the UI. */
  display_unit_value?: InputMaybe<consumption_unit_enum>;
  /** Specific energy source (e.g. natural gas, district heating) for HEATING or ELECTRICITY types. */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  /** Start date of the consumption measurement period. */
  from?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the energy or utility provider. */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** How the data was obtained: MANUAL entry, ESTIMATED, METER reading, etc. */
  source_type_id?: InputMaybe<consumption_source_type_enum>;
  /** Sub-category within WATER or WASTE consumption types. */
  sub_type_id?: InputMaybe<consumption_sub_type_enum>;
  /** End date of the consumption measurement period. */
  to?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type consumption_draft_sum_fields = {
  /** The building this draft consumption belongs to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['numeric']['output']>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Int']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "consumption_draft" */
export type consumption_draft_sum_order_by = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<order_by>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type consumption_draft_var_pop_fields = {
  /** The building this draft consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "consumption_draft" */
export type consumption_draft_var_pop_order_by = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<order_by>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type consumption_draft_var_samp_fields = {
  /** The building this draft consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "consumption_draft" */
export type consumption_draft_var_samp_order_by = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<order_by>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type consumption_draft_variance_fields = {
  /** The building this draft consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** The user who created this draft. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: Maybe<Scalars['Float']['output']>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "consumption_draft" */
export type consumption_draft_variance_order_by = {
  /** The building this draft consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** The user who created this draft. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the parent consumption_invoice_draft. */
  invoice_draft_id?: InputMaybe<order_by>;
  /** Measured consumption amount in the base unit for the consumption type. */
  value?: InputMaybe<order_by>;
};

/** Enum table for how often consumption data is recorded (e.g. MONTHLY, YEARLY). */
export type consumption_frequency_type = {
  id: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "consumption_frequency_type". All fields are combined with a logical 'AND'. */
export type consumption_frequency_type_bool_exp = {
  _and?: InputMaybe<Array<consumption_frequency_type_bool_exp>>;
  _not?: InputMaybe<consumption_frequency_type_bool_exp>;
  _or?: InputMaybe<Array<consumption_frequency_type_bool_exp>>;
  id?: InputMaybe<String_comparison_exp>;
};

export enum consumption_frequency_type_enum {
  BIWEEKLY = 'BIWEEKLY',
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
  MONTHLY = 'MONTHLY',
  ONCE = 'ONCE',
  QUARTER_HOURLY = 'QUARTER_HOURLY',
  QUARTER_YEARLY = 'QUARTER_YEARLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY',
}

/** Boolean expression to compare columns of type "consumption_frequency_type_enum". All fields are combined with logical 'AND'. */
export type consumption_frequency_type_enum_comparison_exp = {
  _eq?: InputMaybe<consumption_frequency_type_enum>;
  _in?: InputMaybe<Array<consumption_frequency_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<consumption_frequency_type_enum>;
  _nin?: InputMaybe<Array<consumption_frequency_type_enum>>;
};

/** Ordering options when selecting data from "consumption_frequency_type". */
export type consumption_frequency_type_order_by = {
  id?: InputMaybe<order_by>;
};

/** select columns of table "consumption_frequency_type" */
export enum consumption_frequency_type_select_column {
  /** column name */
  id = 'id',
}

/** Streaming cursor of the table "consumption_frequency_type" */
export type consumption_frequency_type_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: consumption_frequency_type_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type consumption_frequency_type_stream_cursor_value_input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** A finalized utility invoice document that groups one or more consumption entries for a building. */
export type consumption_invoice = {
  /** An object relationship */
  building: building;
  /** The building this invoice relates to. */
  building_id: Scalars['Int']['output'];
  /** An array relationship */
  consumptions: Array<consumption>;
  /** An aggregate relationship */
  consumptions_aggregate: consumption_aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** Date of the invoice as stated on the document. */
  date: Scalars['timestamptz']['output'];
  /** An object relationship */
  file?: Maybe<file>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Who pays this invoice: LANDLORD or TENANT. */
  invoice_payer: invoice_payer_type_enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** A finalized utility invoice document that groups one or more consumption entries for a building. */
export type consumption_invoiceconsumptionsArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

/** A finalized utility invoice document that groups one or more consumption entries for a building. */
export type consumption_invoiceconsumptions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

/** order by aggregate values of table "consumption_invoice" */
export type consumption_invoice_aggregate_order_by = {
  avg?: InputMaybe<consumption_invoice_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<consumption_invoice_max_order_by>;
  min?: InputMaybe<consumption_invoice_min_order_by>;
  stddev?: InputMaybe<consumption_invoice_stddev_order_by>;
  stddev_pop?: InputMaybe<consumption_invoice_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<consumption_invoice_stddev_samp_order_by>;
  sum?: InputMaybe<consumption_invoice_sum_order_by>;
  var_pop?: InputMaybe<consumption_invoice_var_pop_order_by>;
  var_samp?: InputMaybe<consumption_invoice_var_samp_order_by>;
  variance?: InputMaybe<consumption_invoice_variance_order_by>;
};

/** order by avg() on columns of table "consumption_invoice" */
export type consumption_invoice_avg_order_by = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "consumption_invoice". All fields are combined with a logical 'AND'. */
export type consumption_invoice_bool_exp = {
  _and?: InputMaybe<Array<consumption_invoice_bool_exp>>;
  _not?: InputMaybe<consumption_invoice_bool_exp>;
  _or?: InputMaybe<Array<consumption_invoice_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  consumptions?: InputMaybe<consumption_bool_exp>;
  consumptions_aggregate?: InputMaybe<consumption_aggregate_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  date?: InputMaybe<timestamptz_comparison_exp>;
  file?: InputMaybe<file_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  invoice_payer?: InputMaybe<invoice_payer_type_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** An in-progress invoice that has not yet been finalized. Converted to a consumption_invoice upon confirmation. */
export type consumption_invoice_draft = {
  /** An object relationship */
  building: building;
  /** The building this invoice draft relates to. */
  building_id: Scalars['Int']['output'];
  /** An array relationship */
  consumption_drafts: Array<consumption_draft>;
  /** An aggregate relationship */
  consumption_drafts_aggregate: consumption_draft_aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** Date of the invoice. Nullable in drafts. */
  date?: Maybe<Scalars['timestamptz']['output']>;
  /** Current lifecycle state of the draft (e.g. pending review, ready for confirmation). */
  draft_status: draft_status_enum;
  /** An object relationship */
  file?: Maybe<file>;
  /** Reference to the uploaded invoice document. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Who pays this invoice: LANDLORD or TENANT. Nullable in drafts. */
  invoice_payer?: Maybe<invoice_payer_type_enum>;
  updated_at: Scalars['timestamptz']['output'];
};

/** An in-progress invoice that has not yet been finalized. Converted to a consumption_invoice upon confirmation. */
export type consumption_invoice_draftconsumption_draftsArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_order_by>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

/** An in-progress invoice that has not yet been finalized. Converted to a consumption_invoice upon confirmation. */
export type consumption_invoice_draftconsumption_drafts_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_order_by>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

/** order by aggregate values of table "consumption_invoice_draft" */
export type consumption_invoice_draft_aggregate_order_by = {
  avg?: InputMaybe<consumption_invoice_draft_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<consumption_invoice_draft_max_order_by>;
  min?: InputMaybe<consumption_invoice_draft_min_order_by>;
  stddev?: InputMaybe<consumption_invoice_draft_stddev_order_by>;
  stddev_pop?: InputMaybe<consumption_invoice_draft_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<consumption_invoice_draft_stddev_samp_order_by>;
  sum?: InputMaybe<consumption_invoice_draft_sum_order_by>;
  var_pop?: InputMaybe<consumption_invoice_draft_var_pop_order_by>;
  var_samp?: InputMaybe<consumption_invoice_draft_var_samp_order_by>;
  variance?: InputMaybe<consumption_invoice_draft_variance_order_by>;
};

/** order by avg() on columns of table "consumption_invoice_draft" */
export type consumption_invoice_draft_avg_order_by = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "consumption_invoice_draft". All fields are combined with a logical 'AND'. */
export type consumption_invoice_draft_bool_exp = {
  _and?: InputMaybe<Array<consumption_invoice_draft_bool_exp>>;
  _not?: InputMaybe<consumption_invoice_draft_bool_exp>;
  _or?: InputMaybe<Array<consumption_invoice_draft_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  consumption_drafts?: InputMaybe<consumption_draft_bool_exp>;
  consumption_drafts_aggregate?: InputMaybe<consumption_draft_aggregate_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  date?: InputMaybe<timestamptz_comparison_exp>;
  draft_status?: InputMaybe<draft_status_enum_comparison_exp>;
  file?: InputMaybe<file_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  invoice_payer?: InputMaybe<invoice_payer_type_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "consumption_invoice_draft" */
export type consumption_invoice_draft_max_order_by = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Date of the invoice. Nullable in drafts. */
  date?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "consumption_invoice_draft" */
export type consumption_invoice_draft_min_order_by = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Date of the invoice. Nullable in drafts. */
  date?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** response of any mutation on the table "consumption_invoice_draft" */
export type consumption_invoice_draft_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<consumption_invoice_draft>;
};

/** Ordering options when selecting data from "consumption_invoice_draft". */
export type consumption_invoice_draft_order_by = {
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  consumption_drafts_aggregate?: InputMaybe<consumption_draft_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  draft_status?: InputMaybe<order_by>;
  file?: InputMaybe<file_order_by>;
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_payer?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** primary key columns input for table: consumption_invoice_draft */
export type consumption_invoice_draft_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "consumption_invoice_draft" */
export enum consumption_invoice_draft_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  date = 'date',
  /** column name */
  draft_status = 'draft_status',
  /** column name */
  file_id = 'file_id',
  /** column name */
  id = 'id',
  /** column name */
  invoice_payer = 'invoice_payer',
  /** column name */
  updated_at = 'updated_at',
}

/** input type for updating data in table "consumption_invoice_draft" */
export type consumption_invoice_draft_set_input = {
  /** Current lifecycle state of the draft (e.g. pending review, ready for confirmation). */
  draft_status?: InputMaybe<draft_status_enum>;
};

/** order by stddev() on columns of table "consumption_invoice_draft" */
export type consumption_invoice_draft_stddev_order_by = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "consumption_invoice_draft" */
export type consumption_invoice_draft_stddev_pop_order_by = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "consumption_invoice_draft" */
export type consumption_invoice_draft_stddev_samp_order_by = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "consumption_invoice_draft" */
export type consumption_invoice_draft_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: consumption_invoice_draft_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type consumption_invoice_draft_stream_cursor_value_input = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Date of the invoice. Nullable in drafts. */
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Current lifecycle state of the draft (e.g. pending review, ready for confirmation). */
  draft_status?: InputMaybe<draft_status_enum>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Who pays this invoice: LANDLORD or TENANT. Nullable in drafts. */
  invoice_payer?: InputMaybe<invoice_payer_type_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "consumption_invoice_draft" */
export type consumption_invoice_draft_sum_order_by = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

export type consumption_invoice_draft_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<consumption_invoice_draft_set_input>;
  /** filter the rows which have to be updated */
  where: consumption_invoice_draft_bool_exp;
};

/** order by var_pop() on columns of table "consumption_invoice_draft" */
export type consumption_invoice_draft_var_pop_order_by = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "consumption_invoice_draft" */
export type consumption_invoice_draft_var_samp_order_by = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "consumption_invoice_draft" */
export type consumption_invoice_draft_variance_order_by = {
  /** The building this invoice draft relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by max() on columns of table "consumption_invoice" */
export type consumption_invoice_max_order_by = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Date of the invoice as stated on the document. */
  date?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "consumption_invoice" */
export type consumption_invoice_min_order_by = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Date of the invoice as stated on the document. */
  date?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** response of any mutation on the table "consumption_invoice" */
export type consumption_invoice_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<consumption_invoice>;
};

/** Ordering options when selecting data from "consumption_invoice". */
export type consumption_invoice_order_by = {
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  consumptions_aggregate?: InputMaybe<consumption_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  date?: InputMaybe<order_by>;
  file?: InputMaybe<file_order_by>;
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_payer?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "consumption_invoice" */
export enum consumption_invoice_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  date = 'date',
  /** column name */
  file_id = 'file_id',
  /** column name */
  id = 'id',
  /** column name */
  invoice_payer = 'invoice_payer',
  /** column name */
  updated_at = 'updated_at',
}

/** order by stddev() on columns of table "consumption_invoice" */
export type consumption_invoice_stddev_order_by = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "consumption_invoice" */
export type consumption_invoice_stddev_pop_order_by = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "consumption_invoice" */
export type consumption_invoice_stddev_samp_order_by = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "consumption_invoice" */
export type consumption_invoice_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: consumption_invoice_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type consumption_invoice_stream_cursor_value_input = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Date of the invoice as stated on the document. */
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Who pays this invoice: LANDLORD or TENANT. */
  invoice_payer?: InputMaybe<invoice_payer_type_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "consumption_invoice" */
export type consumption_invoice_sum_order_by = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "consumption_invoice" */
export type consumption_invoice_var_pop_order_by = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "consumption_invoice" */
export type consumption_invoice_var_samp_order_by = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "consumption_invoice" */
export type consumption_invoice_variance_order_by = {
  /** The building this invoice relates to. */
  building_id?: InputMaybe<order_by>;
  /** Reference to the uploaded invoice document (PDF, image, etc.). */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** aggregate max on columns */
export type consumption_max_fields = {
  /** When the row was last archived; NULL while ACTIVE. Maintained by the set_consumption_archived_at trigger — never write it directly. */
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The building this consumption belongs to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['numeric']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** Start date of the consumption measurement period. */
  from?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Int']['output']>;
  /** Market location ID (MaLo-ID) of the metering point; mirrors cbi_consumption_line.market_location_id. */
  market_location_id?: Maybe<Scalars['String']['output']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Int']['output']>;
  /** Meter number the consumption was read from; mirrors cbi_consumption_line.meter_number. */
  meter_number?: Maybe<Scalars['String']['output']>;
  /** Name of the energy or utility provider. */
  provider?: Maybe<Scalars['String']['output']>;
  /** End date of the consumption measurement period. */
  to?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "consumption" */
export type consumption_max_order_by = {
  /** When the row was last archived; NULL while ACTIVE. Maintained by the set_consumption_archived_at trigger — never write it directly. */
  archived_at?: InputMaybe<order_by>;
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<order_by>;
  /** Start date of the consumption measurement period. */
  from?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<order_by>;
  /** Market location ID (MaLo-ID) of the metering point; mirrors cbi_consumption_line.market_location_id. */
  market_location_id?: InputMaybe<order_by>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<order_by>;
  /** Meter number the consumption was read from; mirrors cbi_consumption_line.meter_number. */
  meter_number?: InputMaybe<order_by>;
  /** Name of the energy or utility provider. */
  provider?: InputMaybe<order_by>;
  /** End date of the consumption measurement period. */
  to?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type consumption_min_fields = {
  /** When the row was last archived; NULL while ACTIVE. Maintained by the set_consumption_archived_at trigger — never write it directly. */
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The building this consumption belongs to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['numeric']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** Start date of the consumption measurement period. */
  from?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Int']['output']>;
  /** Market location ID (MaLo-ID) of the metering point; mirrors cbi_consumption_line.market_location_id. */
  market_location_id?: Maybe<Scalars['String']['output']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Int']['output']>;
  /** Meter number the consumption was read from; mirrors cbi_consumption_line.meter_number. */
  meter_number?: Maybe<Scalars['String']['output']>;
  /** Name of the energy or utility provider. */
  provider?: Maybe<Scalars['String']['output']>;
  /** End date of the consumption measurement period. */
  to?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "consumption" */
export type consumption_min_order_by = {
  /** When the row was last archived; NULL while ACTIVE. Maintained by the set_consumption_archived_at trigger — never write it directly. */
  archived_at?: InputMaybe<order_by>;
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<order_by>;
  /** Start date of the consumption measurement period. */
  from?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<order_by>;
  /** Market location ID (MaLo-ID) of the metering point; mirrors cbi_consumption_line.market_location_id. */
  market_location_id?: InputMaybe<order_by>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<order_by>;
  /** Meter number the consumption was read from; mirrors cbi_consumption_line.meter_number. */
  meter_number?: InputMaybe<order_by>;
  /** Name of the energy or utility provider. */
  provider?: InputMaybe<order_by>;
  /** End date of the consumption measurement period. */
  to?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<order_by>;
};

/** response of any mutation on the table "consumption" */
export type consumption_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<consumption>;
};

/** Ordering options when selecting data from "consumption". */
export type consumption_order_by = {
  archived_at?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  cbi_consumption_line?: InputMaybe<cbi_consumption_line_order_by>;
  co2_fee_gross?: InputMaybe<order_by>;
  co2_fee_net?: InputMaybe<order_by>;
  consumption_areas_aggregate?: InputMaybe<consumption_area_aggregate_order_by>;
  consumption_invoice?: InputMaybe<consumption_invoice_order_by>;
  consumption_type_id?: InputMaybe<order_by>;
  consumption_waste_detail?: InputMaybe<consumption_waste_details_order_by>;
  cost?: InputMaybe<order_by>;
  cost_net?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  created_by_user?: InputMaybe<user_order_by>;
  created_by_user_id?: InputMaybe<order_by>;
  display_unit_value?: InputMaybe<order_by>;
  energy_source_type_id?: InputMaybe<order_by>;
  from?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  invoice_id?: InputMaybe<order_by>;
  market_location_id?: InputMaybe<order_by>;
  meter?: InputMaybe<smart_meter_order_by>;
  meter_id?: InputMaybe<order_by>;
  meter_number?: InputMaybe<order_by>;
  provider?: InputMaybe<order_by>;
  source_type_id?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  sub_type_id?: InputMaybe<order_by>;
  to?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "consumption" */
export enum consumption_select_column {
  /** column name */
  archived_at = 'archived_at',
  /** column name */
  building_id = 'building_id',
  /** column name */
  co2_fee_gross = 'co2_fee_gross',
  /** column name */
  co2_fee_net = 'co2_fee_net',
  /** column name */
  consumption_type_id = 'consumption_type_id',
  /** column name */
  cost = 'cost',
  /** column name */
  cost_net = 'cost_net',
  /** column name */
  created_at = 'created_at',
  /** column name */
  created_by_user_id = 'created_by_user_id',
  /** column name */
  display_unit_value = 'display_unit_value',
  /** column name */
  energy_source_type_id = 'energy_source_type_id',
  /** column name */
  from = 'from',
  /** column name */
  id = 'id',
  /** column name */
  invoice_id = 'invoice_id',
  /** column name */
  market_location_id = 'market_location_id',
  /** column name */
  meter_id = 'meter_id',
  /** column name */
  meter_number = 'meter_number',
  /** column name */
  provider = 'provider',
  /** column name */
  source_type_id = 'source_type_id',
  /** column name */
  state = 'state',
  /** column name */
  sub_type_id = 'sub_type_id',
  /** column name */
  to = 'to',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  value = 'value',
}

export enum consumption_source_type_enum {
  API_ENTRY = 'API_ENTRY',
  ESTIMATION = 'ESTIMATION',
  INVOICE = 'INVOICE',
  MANUAL_ENTRY = 'MANUAL_ENTRY',
  METER_READING = 'METER_READING',
}

/** Boolean expression to compare columns of type "consumption_source_type_enum". All fields are combined with logical 'AND'. */
export type consumption_source_type_enum_comparison_exp = {
  _eq?: InputMaybe<consumption_source_type_enum>;
  _in?: InputMaybe<Array<consumption_source_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<consumption_source_type_enum>;
  _nin?: InputMaybe<Array<consumption_source_type_enum>>;
};

export enum consumption_state_enum {
  /** The consumption is included in all calculations. */
  ACTIVE = 'ACTIVE',
  /** The consumption is excluded from calculations but still visible in list views. Reversible. */
  ARCHIVED = 'ARCHIVED',
}

/** Boolean expression to compare columns of type "consumption_state_enum". All fields are combined with logical 'AND'. */
export type consumption_state_enum_comparison_exp = {
  _eq?: InputMaybe<consumption_state_enum>;
  _in?: InputMaybe<Array<consumption_state_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<consumption_state_enum>;
  _nin?: InputMaybe<Array<consumption_state_enum>>;
};

/** aggregate stddev on columns */
export type consumption_stddev_fields = {
  /** The building this consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Float']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "consumption" */
export type consumption_stddev_order_by = {
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<order_by>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<order_by>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<order_by>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type consumption_stddev_pop_fields = {
  /** The building this consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Float']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "consumption" */
export type consumption_stddev_pop_order_by = {
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<order_by>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<order_by>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<order_by>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type consumption_stddev_samp_fields = {
  /** The building this consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Float']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "consumption" */
export type consumption_stddev_samp_order_by = {
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<order_by>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<order_by>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<order_by>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "consumption" */
export type consumption_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: consumption_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type consumption_stream_cursor_value_input = {
  /** When the row was last archived; NULL while ACTIVE. Maintained by the set_consumption_archived_at trigger — never write it directly. */
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<Scalars['numeric']['input']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<Scalars['numeric']['input']>;
  /** Category of consumption: HEATING, ELECTRICITY, WATER, or WASTE. */
  consumption_type_id?: InputMaybe<consumption_type_enum>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<Scalars['numeric']['input']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Unit used for displaying the consumption value in the UI (e.g. kWh, MWh, m3). */
  display_unit_value?: InputMaybe<consumption_unit_enum>;
  /** Specific energy source (e.g. natural gas, district heating) for HEATING or ELECTRICITY consumption types. */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  /** Start date of the consumption measurement period. */
  from?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<Scalars['Int']['input']>;
  /** Market location ID (MaLo-ID) of the metering point; mirrors cbi_consumption_line.market_location_id. */
  market_location_id?: InputMaybe<Scalars['String']['input']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<Scalars['Int']['input']>;
  /** Meter number the consumption was read from; mirrors cbi_consumption_line.meter_number. */
  meter_number?: InputMaybe<Scalars['String']['input']>;
  /** Name of the energy or utility provider. */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** How the data was obtained: MANUAL entry, ESTIMATED, METER reading, etc. */
  source_type_id?: InputMaybe<consumption_source_type_enum>;
  /** Lifecycle state as a consumption_state id. ARCHIVED rows are excluded from calculations. */
  state?: InputMaybe<consumption_state_enum>;
  /** Sub-category within WATER or WASTE consumption types (e.g. hot water, residual waste). */
  sub_type_id?: InputMaybe<consumption_sub_type_enum>;
  /** End date of the consumption measurement period. */
  to?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<Scalars['numeric']['input']>;
};

export enum consumption_sub_type_enum {
  WASTE_CONSTRUCTION_AND_EXCAVATION = 'WASTE_CONSTRUCTION_AND_EXCAVATION',
  WASTE_ELECTRONIC_EQUIPMENT = 'WASTE_ELECTRONIC_EQUIPMENT',
  WASTE_GLASS = 'WASTE_GLASS',
  WASTE_MUNICIPAL = 'WASTE_MUNICIPAL',
  WASTE_ORGANIC = 'WASTE_ORGANIC',
  WASTE_OTHER_NOT_RECYCLEABLE = 'WASTE_OTHER_NOT_RECYCLEABLE',
  WASTE_OTHER_RECYCLEABLE = 'WASTE_OTHER_RECYCLEABLE',
  WASTE_PACKAGING = 'WASTE_PACKAGING',
  WASTE_PAPER = 'WASTE_PAPER',
  WASTE_RESIDUAL = 'WASTE_RESIDUAL',
  WASTE_WOOD = 'WASTE_WOOD',
  WATER_DRINKING = 'WATER_DRINKING',
  WATER_RAINWATER = 'WATER_RAINWATER',
  WATER_SEWAGE = 'WATER_SEWAGE',
}

/** Boolean expression to compare columns of type "consumption_sub_type_enum". All fields are combined with logical 'AND'. */
export type consumption_sub_type_enum_comparison_exp = {
  _eq?: InputMaybe<consumption_sub_type_enum>;
  _in?: InputMaybe<Array<consumption_sub_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<consumption_sub_type_enum>;
  _nin?: InputMaybe<Array<consumption_sub_type_enum>>;
};

/** aggregate sum on columns */
export type consumption_sum_fields = {
  /** The building this consumption belongs to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['numeric']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['numeric']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['numeric']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['numeric']['output']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Int']['output']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Int']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "consumption" */
export type consumption_sum_order_by = {
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<order_by>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<order_by>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<order_by>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<order_by>;
};

export enum consumption_type_enum {
  ELECTRICITY = 'ELECTRICITY',
  HEATING = 'HEATING',
  WASTE = 'WASTE',
  WATER = 'WATER',
}

/** Boolean expression to compare columns of type "consumption_type_enum". All fields are combined with logical 'AND'. */
export type consumption_type_enum_comparison_exp = {
  _eq?: InputMaybe<consumption_type_enum>;
  _in?: InputMaybe<Array<consumption_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<consumption_type_enum>;
  _nin?: InputMaybe<Array<consumption_type_enum>>;
};

export enum consumption_unit_enum {
  KWH = 'KWH',
  M3 = 'M3',
  MWh = 'MWh',
  T = 'T',
  WH = 'WH',
  kg = 'kg',
  l = 'l',
}

/** Boolean expression to compare columns of type "consumption_unit_enum". All fields are combined with logical 'AND'. */
export type consumption_unit_enum_comparison_exp = {
  _eq?: InputMaybe<consumption_unit_enum>;
  _in?: InputMaybe<Array<consumption_unit_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<consumption_unit_enum>;
  _nin?: InputMaybe<Array<consumption_unit_enum>>;
};

/** aggregate var_pop on columns */
export type consumption_var_pop_fields = {
  /** The building this consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Float']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "consumption" */
export type consumption_var_pop_order_by = {
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<order_by>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<order_by>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<order_by>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type consumption_var_samp_fields = {
  /** The building this consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Float']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "consumption" */
export type consumption_var_samp_order_by = {
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<order_by>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<order_by>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<order_by>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type consumption_variance_fields = {
  /** The building this consumption belongs to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: Maybe<Scalars['Float']['output']>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: Maybe<Scalars['Float']['output']>;
  /** Monetary cost associated with this consumption entry. */
  cost?: Maybe<Scalars['Float']['output']>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: Maybe<Scalars['Float']['output']>;
  /** The user who created this consumption entry. */
  created_by_user_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: Maybe<Scalars['Float']['output']>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: Maybe<Scalars['Float']['output']>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "consumption" */
export type consumption_variance_order_by = {
  /** The building this consumption belongs to. */
  building_id?: InputMaybe<order_by>;
  /** Gross CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_gross. */
  co2_fee_gross?: InputMaybe<order_by>;
  /** Net CO2/carbon tax, only relevant for heating consumptions; mirrors cbi_consumption_line.co2_fee_net. */
  co2_fee_net?: InputMaybe<order_by>;
  /** Monetary cost associated with this consumption entry. */
  cost?: InputMaybe<order_by>;
  /** Net cost of the consumption (cost holds the gross amount); mirrors cbi_consumption_line.cost_net. */
  cost_net?: InputMaybe<order_by>;
  /** The user who created this consumption entry. */
  created_by_user_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to the consumption_invoice this entry was extracted from. */
  invoice_id?: InputMaybe<order_by>;
  /** Reference to the meter that automatically recorded this consumption, if applicable. */
  meter_id?: InputMaybe<order_by>;
  /** Consumption amount stored in canonical/standard units (kWh for energy). Converted from user input on save; use display_unit_value to convert back for display. */
  value?: InputMaybe<order_by>;
};

/** Additional waste-specific data for finalized WASTE consumption entries (container details and pickup schedule). */
export type consumption_waste_details = {
  /** Number of waste containers. */
  amount: Scalars['numeric']['output'];
  /** An object relationship */
  consumption: consumption;
  /** Unit for the pickup frequency display (e.g. per week, per month). */
  display_unit_frequency?: Maybe<consumption_frequency_type_enum>;
  /** Unit for the container volume display (e.g. liters, m3). */
  display_unit_volume?: Maybe<consumption_unit_enum>;
  /** Number of waste pickups per period. */
  frequency: Scalars['numeric']['output'];
  id: Scalars['Int']['output'];
  /** Cost per container or per pickup. */
  price: Scalars['numeric']['output'];
  /** Volume of the waste container. */
  volume: Scalars['numeric']['output'];
};

/** Boolean expression to filter rows from the table "consumption_waste_details". All fields are combined with a logical 'AND'. */
export type consumption_waste_details_bool_exp = {
  _and?: InputMaybe<Array<consumption_waste_details_bool_exp>>;
  _not?: InputMaybe<consumption_waste_details_bool_exp>;
  _or?: InputMaybe<Array<consumption_waste_details_bool_exp>>;
  amount?: InputMaybe<numeric_comparison_exp>;
  consumption?: InputMaybe<consumption_bool_exp>;
  display_unit_frequency?: InputMaybe<consumption_frequency_type_enum_comparison_exp>;
  display_unit_volume?: InputMaybe<consumption_unit_enum_comparison_exp>;
  frequency?: InputMaybe<numeric_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  price?: InputMaybe<numeric_comparison_exp>;
  volume?: InputMaybe<numeric_comparison_exp>;
};

/** Draft version of waste-specific consumption details. Nullable fields allow partial entry before finalization. */
export type consumption_waste_details_draft = {
  amount?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  consumption_draft: consumption_draft;
  display_unit_frequency?: Maybe<consumption_frequency_type_enum>;
  display_unit_volume?: Maybe<consumption_unit_enum>;
  frequency?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['numeric']['output']>;
  volume?: Maybe<Scalars['numeric']['output']>;
};

/** Boolean expression to filter rows from the table "consumption_waste_details_draft". All fields are combined with a logical 'AND'. */
export type consumption_waste_details_draft_bool_exp = {
  _and?: InputMaybe<Array<consumption_waste_details_draft_bool_exp>>;
  _not?: InputMaybe<consumption_waste_details_draft_bool_exp>;
  _or?: InputMaybe<Array<consumption_waste_details_draft_bool_exp>>;
  amount?: InputMaybe<numeric_comparison_exp>;
  consumption_draft?: InputMaybe<consumption_draft_bool_exp>;
  display_unit_frequency?: InputMaybe<consumption_frequency_type_enum_comparison_exp>;
  display_unit_volume?: InputMaybe<consumption_unit_enum_comparison_exp>;
  frequency?: InputMaybe<numeric_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  price?: InputMaybe<numeric_comparison_exp>;
  volume?: InputMaybe<numeric_comparison_exp>;
};

/** response of any mutation on the table "consumption_waste_details_draft" */
export type consumption_waste_details_draft_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<consumption_waste_details_draft>;
};

/** Ordering options when selecting data from "consumption_waste_details_draft". */
export type consumption_waste_details_draft_order_by = {
  amount?: InputMaybe<order_by>;
  consumption_draft?: InputMaybe<consumption_draft_order_by>;
  display_unit_frequency?: InputMaybe<order_by>;
  display_unit_volume?: InputMaybe<order_by>;
  frequency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  price?: InputMaybe<order_by>;
  volume?: InputMaybe<order_by>;
};

/** select columns of table "consumption_waste_details_draft" */
export enum consumption_waste_details_draft_select_column {
  /** column name */
  amount = 'amount',
  /** column name */
  display_unit_frequency = 'display_unit_frequency',
  /** column name */
  display_unit_volume = 'display_unit_volume',
  /** column name */
  frequency = 'frequency',
  /** column name */
  id = 'id',
  /** column name */
  price = 'price',
  /** column name */
  volume = 'volume',
}

/** Streaming cursor of the table "consumption_waste_details_draft" */
export type consumption_waste_details_draft_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: consumption_waste_details_draft_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type consumption_waste_details_draft_stream_cursor_value_input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  display_unit_frequency?: InputMaybe<consumption_frequency_type_enum>;
  display_unit_volume?: InputMaybe<consumption_unit_enum>;
  frequency?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  volume?: InputMaybe<Scalars['numeric']['input']>;
};

/** response of any mutation on the table "consumption_waste_details" */
export type consumption_waste_details_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<consumption_waste_details>;
};

/** Ordering options when selecting data from "consumption_waste_details". */
export type consumption_waste_details_order_by = {
  amount?: InputMaybe<order_by>;
  consumption?: InputMaybe<consumption_order_by>;
  display_unit_frequency?: InputMaybe<order_by>;
  display_unit_volume?: InputMaybe<order_by>;
  frequency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  price?: InputMaybe<order_by>;
  volume?: InputMaybe<order_by>;
};

/** select columns of table "consumption_waste_details" */
export enum consumption_waste_details_select_column {
  /** column name */
  amount = 'amount',
  /** column name */
  display_unit_frequency = 'display_unit_frequency',
  /** column name */
  display_unit_volume = 'display_unit_volume',
  /** column name */
  frequency = 'frequency',
  /** column name */
  id = 'id',
  /** column name */
  price = 'price',
  /** column name */
  volume = 'volume',
}

/** Streaming cursor of the table "consumption_waste_details" */
export type consumption_waste_details_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: consumption_waste_details_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type consumption_waste_details_stream_cursor_value_input = {
  /** Number of waste containers. */
  amount?: InputMaybe<Scalars['numeric']['input']>;
  /** Unit for the pickup frequency display (e.g. per week, per month). */
  display_unit_frequency?: InputMaybe<consumption_frequency_type_enum>;
  /** Unit for the container volume display (e.g. liters, m3). */
  display_unit_volume?: InputMaybe<consumption_unit_enum>;
  /** Number of waste pickups per period. */
  frequency?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Cost per container or per pickup. */
  price?: InputMaybe<Scalars['numeric']['input']>;
  /** Volume of the waste container. */
  volume?: InputMaybe<Scalars['numeric']['input']>;
};

/** A versioned set of renovation cost assumptions valid for a specific time period, used to price actions in scenarios. */
export type cost_version = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  scenario_versions: Array<scenario_version>;
  /** An aggregate relationship */
  scenario_versions_aggregate: scenario_version_aggregate;
  /** The lifecycle status of this cost version. */
  status: cost_version_status_enum;
  updated_at: Scalars['timestamptz']['output'];
  /** Start date from which this cost version's prices are applicable. */
  valid_from: Scalars['timestamptz']['output'];
  /** End date until which this cost version's prices are applicable. */
  valid_to?: Maybe<Scalars['timestamptz']['output']>;
  /** Unique version identifier in semver format (e.g., 1.0.0). */
  version: Scalars['String']['output'];
};

/** A versioned set of renovation cost assumptions valid for a specific time period, used to price actions in scenarios. */
export type cost_versionscenario_versionsArgs = {
  distinct_on?: InputMaybe<Array<scenario_version_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_version_order_by>>;
  where?: InputMaybe<scenario_version_bool_exp>;
};

/** A versioned set of renovation cost assumptions valid for a specific time period, used to price actions in scenarios. */
export type cost_versionscenario_versions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<scenario_version_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_version_order_by>>;
  where?: InputMaybe<scenario_version_bool_exp>;
};

/** Boolean expression to filter rows from the table "cost_version". All fields are combined with a logical 'AND'. */
export type cost_version_bool_exp = {
  _and?: InputMaybe<Array<cost_version_bool_exp>>;
  _not?: InputMaybe<cost_version_bool_exp>;
  _or?: InputMaybe<Array<cost_version_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  scenario_versions?: InputMaybe<scenario_version_bool_exp>;
  scenario_versions_aggregate?: InputMaybe<scenario_version_aggregate_bool_exp>;
  status?: InputMaybe<cost_version_status_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  valid_from?: InputMaybe<timestamptz_comparison_exp>;
  valid_to?: InputMaybe<timestamptz_comparison_exp>;
  version?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "cost_version". */
export type cost_version_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  scenario_versions_aggregate?: InputMaybe<scenario_version_aggregate_order_by>;
  status?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  valid_from?: InputMaybe<order_by>;
  valid_to?: InputMaybe<order_by>;
  version?: InputMaybe<order_by>;
};

/** select columns of table "cost_version" */
export enum cost_version_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  status = 'status',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  valid_from = 'valid_from',
  /** column name */
  valid_to = 'valid_to',
  /** column name */
  version = 'version',
}

export enum cost_version_status_enum {
  CREATED = 'CREATED',
  RELEASED = 'RELEASED',
  ROLLED_OUT = 'ROLLED_OUT',
}

/** Boolean expression to compare columns of type "cost_version_status_enum". All fields are combined with logical 'AND'. */
export type cost_version_status_enum_comparison_exp = {
  _eq?: InputMaybe<cost_version_status_enum>;
  _in?: InputMaybe<Array<cost_version_status_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<cost_version_status_enum>;
  _nin?: InputMaybe<Array<cost_version_status_enum>>;
};

/** Streaming cursor of the table "cost_version" */
export type cost_version_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: cost_version_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cost_version_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The lifecycle status of this cost version. */
  status?: InputMaybe<cost_version_status_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Start date from which this cost version's prices are applicable. */
  valid_from?: InputMaybe<Scalars['timestamptz']['input']>;
  /** End date until which this cost version's prices are applicable. */
  valid_to?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Unique version identifier in semver format (e.g., 1.0.0). */
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum country_enum {
  AT = 'AT',
  BE = 'BE',
  CZ = 'CZ',
  DE = 'DE',
  FR = 'FR',
  PL = 'PL',
  UK = 'UK',
}

/** Boolean expression to compare columns of type "country_enum". All fields are combined with logical 'AND'. */
export type country_enum_comparison_exp = {
  _eq?: InputMaybe<country_enum>;
  _in?: InputMaybe<Array<country_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<country_enum>;
  _nin?: InputMaybe<Array<country_enum>>;
};

export enum country_state_enum {
  AT_BURGENLAND = 'AT_BURGENLAND',
  AT_CARINTHIA = 'AT_CARINTHIA',
  AT_LOWER_AUSTRIA = 'AT_LOWER_AUSTRIA',
  AT_SALZBURG = 'AT_SALZBURG',
  AT_STYRIA = 'AT_STYRIA',
  AT_TYROL = 'AT_TYROL',
  AT_UPPER_AUSTRIA = 'AT_UPPER_AUSTRIA',
  AT_VIENNA = 'AT_VIENNA',
  AT_VORARLBERG = 'AT_VORARLBERG',
  BE_BRUSSELS = 'BE_BRUSSELS',
  BE_FLANDERS = 'BE_FLANDERS',
  BE_WALLONIA = 'BE_WALLONIA',
  CZ_JIHOCESKY = 'CZ_JIHOCESKY',
  CZ_JIHOMORAVSKY = 'CZ_JIHOMORAVSKY',
  CZ_KARLOVARSKY = 'CZ_KARLOVARSKY',
  CZ_KRALOVEHRADECKY = 'CZ_KRALOVEHRADECKY',
  CZ_LIBERECKY = 'CZ_LIBERECKY',
  CZ_MORAVSKOSLEZSKY = 'CZ_MORAVSKOSLEZSKY',
  CZ_OLOMOUCKY = 'CZ_OLOMOUCKY',
  CZ_PARDUBICKY = 'CZ_PARDUBICKY',
  CZ_PLZENSKY = 'CZ_PLZENSKY',
  CZ_PRAHA = 'CZ_PRAHA',
  CZ_STREDOCESKY = 'CZ_STREDOCESKY',
  CZ_USTECKY = 'CZ_USTECKY',
  CZ_VYSOCINA = 'CZ_VYSOCINA',
  CZ_ZLINSKY = 'CZ_ZLINSKY',
  DE_BADEN_WUERTTEMBERG = 'DE_BADEN_WUERTTEMBERG',
  DE_BAYERN = 'DE_BAYERN',
  DE_BERLIN = 'DE_BERLIN',
  DE_BRANDENBURG = 'DE_BRANDENBURG',
  DE_BREMEN = 'DE_BREMEN',
  DE_HAMBURG = 'DE_HAMBURG',
  DE_HESSEN = 'DE_HESSEN',
  DE_MECKLENBURG_VORPOMMERN = 'DE_MECKLENBURG_VORPOMMERN',
  DE_NIEDERSACHSEN = 'DE_NIEDERSACHSEN',
  DE_NORDRHEIN_WESTFALEN = 'DE_NORDRHEIN_WESTFALEN',
  DE_RHEINLAND_PFALZ = 'DE_RHEINLAND_PFALZ',
  DE_SAARLAND = 'DE_SAARLAND',
  DE_SACHSEN = 'DE_SACHSEN',
  DE_SACHSEN_ANHALT = 'DE_SACHSEN_ANHALT',
  DE_SCHLESWIG_HOLSTEIN = 'DE_SCHLESWIG_HOLSTEIN',
  DE_THUERINGEN = 'DE_THUERINGEN',
  FR_AUVERGNE_RHONE_ALPES = 'FR_AUVERGNE_RHONE_ALPES',
  FR_BOURGOGNE_FRANCHE_COMTE = 'FR_BOURGOGNE_FRANCHE_COMTE',
  FR_BRETAGNE = 'FR_BRETAGNE',
  FR_CENTRE_VAL_DE_LOIRE = 'FR_CENTRE_VAL_DE_LOIRE',
  FR_CORSE = 'FR_CORSE',
  FR_GRAND_EST = 'FR_GRAND_EST',
  FR_GUADELOUPE = 'FR_GUADELOUPE',
  FR_GUYANE = 'FR_GUYANE',
  FR_HAUTS_DE_FRANCE = 'FR_HAUTS_DE_FRANCE',
  FR_ILE_DE_FRANCE = 'FR_ILE_DE_FRANCE',
  FR_LA_REUNION = 'FR_LA_REUNION',
  FR_MARTINIQUE = 'FR_MARTINIQUE',
  FR_MAYOTTE = 'FR_MAYOTTE',
  FR_NORMANDIE = 'FR_NORMANDIE',
  FR_NOUVELLE_AQUITAINE = 'FR_NOUVELLE_AQUITAINE',
  FR_OCCITANIE = 'FR_OCCITANIE',
  FR_PAYS_DE_LA_LOIRE = 'FR_PAYS_DE_LA_LOIRE',
  FR_PROVENCE_ALPES_COTE_D_AZUR = 'FR_PROVENCE_ALPES_COTE_D_AZUR',
  PL_GREATER_POLAND = 'PL_GREATER_POLAND',
  PL_HOLY_CROSS = 'PL_HOLY_CROSS',
  PL_KUYAVIAN_POMERANIAN = 'PL_KUYAVIAN_POMERANIAN',
  PL_LESSER_POLAND = 'PL_LESSER_POLAND',
  PL_LODZ = 'PL_LODZ',
  PL_LOWER_SILESIAN = 'PL_LOWER_SILESIAN',
  PL_LUBLIN = 'PL_LUBLIN',
  PL_LUBUSZ = 'PL_LUBUSZ',
  PL_MASOVIAN = 'PL_MASOVIAN',
  PL_OPOLE = 'PL_OPOLE',
  PL_PODLASKIE = 'PL_PODLASKIE',
  PL_POMERANIAN = 'PL_POMERANIAN',
  PL_SILESIAN = 'PL_SILESIAN',
  PL_SUBCARPATHIAN = 'PL_SUBCARPATHIAN',
  PL_WARMIAN_MASURIAN = 'PL_WARMIAN_MASURIAN',
  PL_WEST_POMERANIAN = 'PL_WEST_POMERANIAN',
  UK_EAST_MIDLANDS = 'UK_EAST_MIDLANDS',
  UK_EAST_OF_ENGLAND = 'UK_EAST_OF_ENGLAND',
  UK_LONDON = 'UK_LONDON',
  UK_NORTHERN_IRELAND = 'UK_NORTHERN_IRELAND',
  UK_NORTH_EAST = 'UK_NORTH_EAST',
  UK_NORTH_WEST = 'UK_NORTH_WEST',
  UK_SCOTLAND = 'UK_SCOTLAND',
  UK_SOUTH_EAST = 'UK_SOUTH_EAST',
  UK_SOUTH_WEST = 'UK_SOUTH_WEST',
  UK_WALES = 'UK_WALES',
  UK_WEST_MIDLANDS = 'UK_WEST_MIDLANDS',
  UK_YORKSHIRE_AND_THE_HUMBER = 'UK_YORKSHIRE_AND_THE_HUMBER',
  UNKNOWN = 'UNKNOWN',
}

/** Boolean expression to compare columns of type "country_state_enum". All fields are combined with logical 'AND'. */
export type country_state_enum_comparison_exp = {
  _eq?: InputMaybe<country_state_enum>;
  _in?: InputMaybe<Array<country_state_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<country_state_enum>;
  _nin?: InputMaybe<Array<country_state_enum>>;
};

export enum crrem_path_graph_type_enum {
  CO2_GRAPH = 'CO2_GRAPH',
  ENERGY_GRAPH = 'ENERGY_GRAPH',
  EXCESS_EMISSION_COST = 'EXCESS_EMISSION_COST',
  STRANDING_YEAR = 'STRANDING_YEAR',
}

export enum crrem_version_type_enum {
  V2_05 = 'V2_05',
  V2_07 = 'V2_07',
}

/** ordering argument of a cursor */
export enum cursor_ordering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC',
}

export enum custom_action_type_enum {
  ENERGY_SOURCE = 'ENERGY_SOURCE',
  SYSTEM = 'SYSTEM',
}

/** Boolean expression to compare columns of type "custom_action_type_enum". All fields are combined with logical 'AND'. */
export type custom_action_type_enum_comparison_exp = {
  _eq?: InputMaybe<custom_action_type_enum>;
  _in?: InputMaybe<Array<custom_action_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<custom_action_type_enum>;
  _nin?: InputMaybe<Array<custom_action_type_enum>>;
};

/** Organization-defined custom metadata field that extends a specific entity type with additional data. */
export type custom_field = {
  /** Which entity type this field extends (e.g., BUILDING, ECONOMIC_UNIT). */
  entity_type: custom_field_entity_enum;
  id: Scalars['Int']['output'];
  /** Unique machine-readable key for the custom field within the organization and entity type. */
  key: Scalars['String']['output'];
  /** Display name of the custom field. */
  name: Scalars['String']['output'];
  /** Organization that defined this custom field. */
  org_id: Scalars['Int']['output'];
  /** Whether this custom property is displayed in the analysis header. Capped at 3 concurrently-enabled fields per org and entity level (enforced in the backend). */
  show_in_analysis: Scalars['Boolean']['output'];
  /** Free-text suffix shown next to the value in the UI (e.g. a unit like "€", "m²", "%"). Nullable. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** Data type of the field (e.g., TEXT, NUMBER, DATE). */
  type_id: custom_field_type_enum;
};

/** Boolean expression to filter rows from the table "custom_field". All fields are combined with a logical 'AND'. */
export type custom_field_bool_exp = {
  _and?: InputMaybe<Array<custom_field_bool_exp>>;
  _not?: InputMaybe<custom_field_bool_exp>;
  _or?: InputMaybe<Array<custom_field_bool_exp>>;
  entity_type?: InputMaybe<custom_field_entity_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  key?: InputMaybe<String_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  show_in_analysis?: InputMaybe<Boolean_comparison_exp>;
  suffix?: InputMaybe<String_comparison_exp>;
  type_id?: InputMaybe<custom_field_type_enum_comparison_exp>;
};

export enum custom_field_entity_enum {
  BUILDING = 'BUILDING',
  ECONOMIC_UNIT = 'ECONOMIC_UNIT',
}

/** Boolean expression to compare columns of type "custom_field_entity_enum". All fields are combined with logical 'AND'. */
export type custom_field_entity_enum_comparison_exp = {
  _eq?: InputMaybe<custom_field_entity_enum>;
  _in?: InputMaybe<Array<custom_field_entity_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<custom_field_entity_enum>;
  _nin?: InputMaybe<Array<custom_field_entity_enum>>;
};

/** Ordering options when selecting data from "custom_field". */
export type custom_field_order_by = {
  entity_type?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  key?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  org_id?: InputMaybe<order_by>;
  show_in_analysis?: InputMaybe<order_by>;
  suffix?: InputMaybe<order_by>;
  type_id?: InputMaybe<order_by>;
};

/** select columns of table "custom_field" */
export enum custom_field_select_column {
  /** column name */
  entity_type = 'entity_type',
  /** column name */
  id = 'id',
  /** column name */
  key = 'key',
  /** column name */
  name = 'name',
  /** column name */
  org_id = 'org_id',
  /** column name */
  show_in_analysis = 'show_in_analysis',
  /** column name */
  suffix = 'suffix',
  /** column name */
  type_id = 'type_id',
}

/** Streaming cursor of the table "custom_field" */
export type custom_field_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: custom_field_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type custom_field_stream_cursor_value_input = {
  /** Which entity type this field extends (e.g., BUILDING, ECONOMIC_UNIT). */
  entity_type?: InputMaybe<custom_field_entity_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Unique machine-readable key for the custom field within the organization and entity type. */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the custom field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Organization that defined this custom field. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this custom property is displayed in the analysis header. Capped at 3 concurrently-enabled fields per org and entity level (enforced in the backend). */
  show_in_analysis?: InputMaybe<Scalars['Boolean']['input']>;
  /** Free-text suffix shown next to the value in the UI (e.g. a unit like "€", "m²", "%"). Nullable. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** Data type of the field (e.g., TEXT, NUMBER, DATE). */
  type_id?: InputMaybe<custom_field_type_enum>;
};

export enum custom_field_type_enum {
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
}

/** Boolean expression to compare columns of type "custom_field_type_enum". All fields are combined with logical 'AND'. */
export type custom_field_type_enum_comparison_exp = {
  _eq?: InputMaybe<custom_field_type_enum>;
  _in?: InputMaybe<Array<custom_field_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<custom_field_type_enum>;
  _nin?: InputMaybe<Array<custom_field_type_enum>>;
};

export enum data_source_type_enum {
  APPROXIMATED = 'APPROXIMATED',
  GEOSPATIAL = 'GEOSPATIAL',
  GOOGLE_MESH = 'GOOGLE_MESH',
  GOOGLE_SOLAR_API = 'GOOGLE_SOLAR_API',
  GOOGLE_STREET_VIEW = 'GOOGLE_STREET_VIEW',
  MANUAL = 'MANUAL',
  TABULA = 'TABULA',
}

/** Boolean expression to compare columns of type "data_source_type_enum". All fields are combined with logical 'AND'. */
export type data_source_type_enum_comparison_exp = {
  _eq?: InputMaybe<data_source_type_enum>;
  _in?: InputMaybe<Array<data_source_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<data_source_type_enum>;
  _nin?: InputMaybe<Array<data_source_type_enum>>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type date_comparison_exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

export enum draft_status_enum {
  COMPLETE = 'COMPLETE',
  INCOMPLETE = 'INCOMPLETE',
  OCR_FAILED = 'OCR_FAILED',
  OCR_IN_PROGRESS = 'OCR_IN_PROGRESS',
  OCR_REVIEW = 'OCR_REVIEW',
  UPLOADING = 'UPLOADING',
}

/** Boolean expression to compare columns of type "draft_status_enum". All fields are combined with logical 'AND'. */
export type draft_status_enum_comparison_exp = {
  _eq?: InputMaybe<draft_status_enum>;
  _in?: InputMaybe<Array<draft_status_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<draft_status_enum>;
  _nin?: InputMaybe<Array<draft_status_enum>>;
};

/** An optional grouping of buildings within a portfolio for structural organization (Wirtschaftseinheit). If not explicitly defined, one is automatically created per building using the building's address. */
export type economic_unit = {
  associatedBuildingsAndDrafts: EconomicUnitAmount;
  /** An array relationship */
  building_drafts: Array<building_draft>;
  /** An aggregate relationship */
  building_drafts_aggregate: building_draft_aggregate;
  /** An array relationship */
  buildings: Array<building>;
  /** An aggregate relationship */
  buildings_aggregate: building_aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** JSON object holding customer-defined custom fields for this economic unit. */
  custom_data: Scalars['jsonb']['output'];
  /** External identifier assigned by the customer for this economic unit, used for cross-system referencing. */
  customer_economic_unit_id?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  /** An object relationship */
  folder?: Maybe<folder>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  inactive_buildings: Array<inactive_buildings>;
  name: Scalars['String']['output'];
  /** An object relationship */
  portfolio: portfolio;
  /** The portfolio this economic unit belongs to. */
  portfolio_id: Scalars['Int']['output'];
  /** An object relationship */
  responsible_user?: Maybe<user>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** An optional grouping of buildings within a portfolio for structural organization (Wirtschaftseinheit). If not explicitly defined, one is automatically created per building using the building's address. */
export type economic_unitbuilding_draftsArgs = {
  distinct_on?: InputMaybe<Array<building_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_order_by>>;
  where?: InputMaybe<building_draft_bool_exp>;
};

/** An optional grouping of buildings within a portfolio for structural organization (Wirtschaftseinheit). If not explicitly defined, one is automatically created per building using the building's address. */
export type economic_unitbuilding_drafts_aggregateArgs = {
  distinct_on?: InputMaybe<Array<building_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_order_by>>;
  where?: InputMaybe<building_draft_bool_exp>;
};

/** An optional grouping of buildings within a portfolio for structural organization (Wirtschaftseinheit). If not explicitly defined, one is automatically created per building using the building's address. */
export type economic_unitbuildingsArgs = {
  distinct_on?: InputMaybe<Array<building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_order_by>>;
  where?: InputMaybe<building_bool_exp>;
};

/** An optional grouping of buildings within a portfolio for structural organization (Wirtschaftseinheit). If not explicitly defined, one is automatically created per building using the building's address. */
export type economic_unitbuildings_aggregateArgs = {
  distinct_on?: InputMaybe<Array<building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_order_by>>;
  where?: InputMaybe<building_bool_exp>;
};

/** An optional grouping of buildings within a portfolio for structural organization (Wirtschaftseinheit). If not explicitly defined, one is automatically created per building using the building's address. */
export type economic_unitcustom_dataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** An optional grouping of buildings within a portfolio for structural organization (Wirtschaftseinheit). If not explicitly defined, one is automatically created per building using the building's address. */
export type economic_unitinactive_buildingsArgs = {
  distinct_on?: InputMaybe<Array<inactive_buildings_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<inactive_buildings_order_by>>;
  where?: InputMaybe<inactive_buildings_bool_exp>;
};

/** aggregated selection of "economic_unit" */
export type economic_unit_aggregate = {
  aggregate?: Maybe<economic_unit_aggregate_fields>;
  nodes: Array<economic_unit>;
};

export type economic_unit_aggregate_bool_exp = {
  count?: InputMaybe<economic_unit_aggregate_bool_exp_count>;
};

export type economic_unit_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<economic_unit_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<economic_unit_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "economic_unit" */
export type economic_unit_aggregate_fields = {
  avg?: Maybe<economic_unit_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<economic_unit_max_fields>;
  min?: Maybe<economic_unit_min_fields>;
  stddev?: Maybe<economic_unit_stddev_fields>;
  stddev_pop?: Maybe<economic_unit_stddev_pop_fields>;
  stddev_samp?: Maybe<economic_unit_stddev_samp_fields>;
  sum?: Maybe<economic_unit_sum_fields>;
  var_pop?: Maybe<economic_unit_var_pop_fields>;
  var_samp?: Maybe<economic_unit_var_samp_fields>;
  variance?: Maybe<economic_unit_variance_fields>;
};

/** aggregate fields of "economic_unit" */
export type economic_unit_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<economic_unit_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "economic_unit" */
export type economic_unit_aggregate_order_by = {
  avg?: InputMaybe<economic_unit_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<economic_unit_max_order_by>;
  min?: InputMaybe<economic_unit_min_order_by>;
  stddev?: InputMaybe<economic_unit_stddev_order_by>;
  stddev_pop?: InputMaybe<economic_unit_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<economic_unit_stddev_samp_order_by>;
  sum?: InputMaybe<economic_unit_sum_order_by>;
  var_pop?: InputMaybe<economic_unit_var_pop_order_by>;
  var_samp?: InputMaybe<economic_unit_var_samp_order_by>;
  variance?: InputMaybe<economic_unit_variance_order_by>;
};

/** aggregate avg on columns */
export type economic_unit_avg_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "economic_unit" */
export type economic_unit_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "economic_unit". All fields are combined with a logical 'AND'. */
export type economic_unit_bool_exp = {
  _and?: InputMaybe<Array<economic_unit_bool_exp>>;
  _not?: InputMaybe<economic_unit_bool_exp>;
  _or?: InputMaybe<Array<economic_unit_bool_exp>>;
  building_drafts?: InputMaybe<building_draft_bool_exp>;
  building_drafts_aggregate?: InputMaybe<building_draft_aggregate_bool_exp>;
  buildings?: InputMaybe<building_bool_exp>;
  buildings_aggregate?: InputMaybe<building_aggregate_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  custom_data?: InputMaybe<jsonb_comparison_exp>;
  customer_economic_unit_id?: InputMaybe<String_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  folder?: InputMaybe<folder_bool_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  inactive_buildings?: InputMaybe<inactive_buildings_bool_exp>;
  name?: InputMaybe<String_comparison_exp>;
  portfolio?: InputMaybe<portfolio_bool_exp>;
  portfolio_id?: InputMaybe<Int_comparison_exp>;
  responsible_user?: InputMaybe<user_bool_exp>;
  responsible_user_id?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "economic_unit" */
export enum economic_unit_constraint {
  /** unique or primary key constraint on columns "id" */
  economic_unit_pkey = 'economic_unit_pkey',
}

/** input type for incrementing numeric columns in table "economic_unit" */
export type economic_unit_inc_input = {
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "economic_unit" */
export type economic_unit_insert_input = {
  building_drafts?: InputMaybe<building_draft_arr_rel_insert_input>;
  /** External identifier assigned by the customer for this economic unit, used for cross-system referencing. */
  customer_economic_unit_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type economic_unit_max_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** External identifier assigned by the customer for this economic unit, used for cross-system referencing. */
  customer_economic_unit_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "economic_unit" */
export type economic_unit_max_order_by = {
  created_at?: InputMaybe<order_by>;
  /** External identifier assigned by the customer for this economic unit, used for cross-system referencing. */
  customer_economic_unit_id?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type economic_unit_min_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** External identifier assigned by the customer for this economic unit, used for cross-system referencing. */
  customer_economic_unit_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "economic_unit" */
export type economic_unit_min_order_by = {
  created_at?: InputMaybe<order_by>;
  /** External identifier assigned by the customer for this economic unit, used for cross-system referencing. */
  customer_economic_unit_id?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** response of any mutation on the table "economic_unit" */
export type economic_unit_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<economic_unit>;
};

/** input type for inserting object relation for remote table "economic_unit" */
export type economic_unit_obj_rel_insert_input = {
  data: economic_unit_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<economic_unit_on_conflict>;
};

/** on_conflict condition type for table "economic_unit" */
export type economic_unit_on_conflict = {
  constraint: economic_unit_constraint;
  update_columns?: Array<economic_unit_update_column>;
  where?: InputMaybe<economic_unit_bool_exp>;
};

/** Ordering options when selecting data from "economic_unit". */
export type economic_unit_order_by = {
  building_drafts_aggregate?: InputMaybe<building_draft_aggregate_order_by>;
  buildings_aggregate?: InputMaybe<building_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  custom_data?: InputMaybe<order_by>;
  customer_economic_unit_id?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  folder?: InputMaybe<folder_order_by>;
  id?: InputMaybe<order_by>;
  inactive_buildings_aggregate?: InputMaybe<inactive_buildings_aggregate_order_by>;
  name?: InputMaybe<order_by>;
  portfolio?: InputMaybe<portfolio_order_by>;
  portfolio_id?: InputMaybe<order_by>;
  responsible_user?: InputMaybe<user_order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** primary key columns input for table: economic_unit */
export type economic_unit_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "economic_unit" */
export enum economic_unit_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  custom_data = 'custom_data',
  /** column name */
  customer_economic_unit_id = 'customer_economic_unit_id',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  portfolio_id = 'portfolio_id',
  /** column name */
  responsible_user_id = 'responsible_user_id',
  /** column name */
  updated_at = 'updated_at',
}

/** input type for updating data in table "economic_unit" */
export type economic_unit_set_input = {
  /** External identifier assigned by the customer for this economic unit, used for cross-system referencing. */
  customer_economic_unit_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type economic_unit_stddev_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "economic_unit" */
export type economic_unit_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type economic_unit_stddev_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "economic_unit" */
export type economic_unit_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type economic_unit_stddev_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "economic_unit" */
export type economic_unit_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "economic_unit" */
export type economic_unit_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: economic_unit_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type economic_unit_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** JSON object holding customer-defined custom fields for this economic unit. */
  custom_data?: InputMaybe<Scalars['jsonb']['input']>;
  /** External identifier assigned by the customer for this economic unit, used for cross-system referencing. */
  customer_economic_unit_id?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type economic_unit_sum_fields = {
  id?: Maybe<Scalars['Int']['output']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "economic_unit" */
export type economic_unit_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** update columns of table "economic_unit" */
export enum economic_unit_update_column {
  /** column name */
  customer_economic_unit_id = 'customer_economic_unit_id',
  /** column name */
  description = 'description',
  /** column name */
  name = 'name',
  /** column name */
  portfolio_id = 'portfolio_id',
  /** column name */
  responsible_user_id = 'responsible_user_id',
}

export type economic_unit_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<economic_unit_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<economic_unit_set_input>;
  /** filter the rows which have to be updated */
  where: economic_unit_bool_exp;
};

/** aggregate var_pop on columns */
export type economic_unit_var_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "economic_unit" */
export type economic_unit_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type economic_unit_var_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "economic_unit" */
export type economic_unit_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type economic_unit_variance_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "economic_unit" */
export type economic_unit_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio this economic unit belongs to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user assigned as the primary contact or manager for this economic unit. */
  responsible_user_id?: InputMaybe<order_by>;
};

export enum efficiency_class_enum {
  A = 'A',
  AA = 'AA',
  AAA = 'AAA',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  UNKNOWN = 'UNKNOWN',
}

/** Boolean expression to compare columns of type "efficiency_class_enum". All fields are combined with logical 'AND'. */
export type efficiency_class_enum_comparison_exp = {
  _eq?: InputMaybe<efficiency_class_enum>;
  _in?: InputMaybe<Array<efficiency_class_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<efficiency_class_enum>;
  _nin?: InputMaybe<Array<efficiency_class_enum>>;
};

/** An energy supplier record (Energielieferant) with certified emission and/or primary energy factors for district heating or electricity, allowing building-specific factors to override portfolio defaults. */
export type emission_certificate = {
  associated_action_plans: AssociatedActionPlansOutput;
  associated_buildings: AssociatedBuildingsOutput;
  created_at: Scalars['timestamptz']['output'];
  /** Type of certificate document. */
  emission_certificate_document_type_id?: Maybe<emission_certificate_document_type_enum>;
  /** Energy source type this certificate applies to (e.g., district heating). */
  emission_certificate_energy_source_type_id?: Maybe<emission_certificate_energy_source_type_enum>;
  /** An object relationship */
  emission_certificate_value_path?: Maybe<emission_certificate_value_path>;
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor: Scalars['float8']['output'];
  /** Whether the emission factor is a static value or follows a time-based path. */
  emission_factor_active_value_type: energy_supplier_value_type_enum;
  /** An array relationship */
  energy_system_consumer_routes: Array<energy_system_consumer_route>;
  /** An object relationship */
  file?: Maybe<file>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Name of the energy supplier that issued the certificate. */
  issuer: Scalars['String']['output'];
  /** An object relationship */
  org: org;
  /** Organization that owns this certificate. */
  org_id: Scalars['Int']['output'];
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['float8']['output']>;
  /** Whether the primary energy factor is a static value or follows a time-based path. */
  primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
  /** An array relationship */
  primary_energy_factor_energy_system_consumer_routes: Array<energy_system_consumer_route>;
  updated_at: Scalars['timestamptz']['output'];
  /** Start date of the certificate validity period. */
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  /** Expiration date of the certificate. */
  valid_until?: Maybe<Scalars['timestamptz']['output']>;
};

/** An energy supplier record (Energielieferant) with certified emission and/or primary energy factors for district heating or electricity, allowing building-specific factors to override portfolio defaults. */
export type emission_certificateassociated_action_plansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** An energy supplier record (Energielieferant) with certified emission and/or primary energy factors for district heating or electricity, allowing building-specific factors to override portfolio defaults. */
export type emission_certificateassociated_buildingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** An energy supplier record (Energielieferant) with certified emission and/or primary energy factors for district heating or electricity, allowing building-specific factors to override portfolio defaults. */
export type emission_certificateenergy_system_consumer_routesArgs = {
  distinct_on?: InputMaybe<Array<energy_system_consumer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_consumer_route_order_by>>;
  where?: InputMaybe<energy_system_consumer_route_bool_exp>;
};

/** An energy supplier record (Energielieferant) with certified emission and/or primary energy factors for district heating or electricity, allowing building-specific factors to override portfolio defaults. */
export type emission_certificateprimary_energy_factor_energy_system_consumer_routesArgs = {
  distinct_on?: InputMaybe<Array<energy_system_consumer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_consumer_route_order_by>>;
  where?: InputMaybe<energy_system_consumer_route_bool_exp>;
};

/** aggregated selection of "emission_certificate" */
export type emission_certificate_aggregate = {
  aggregate?: Maybe<emission_certificate_aggregate_fields>;
  nodes: Array<emission_certificate>;
};

export type emission_certificate_aggregate_bool_exp = {
  avg?: InputMaybe<emission_certificate_aggregate_bool_exp_avg>;
  corr?: InputMaybe<emission_certificate_aggregate_bool_exp_corr>;
  count?: InputMaybe<emission_certificate_aggregate_bool_exp_count>;
  covar_samp?: InputMaybe<emission_certificate_aggregate_bool_exp_covar_samp>;
  max?: InputMaybe<emission_certificate_aggregate_bool_exp_max>;
  min?: InputMaybe<emission_certificate_aggregate_bool_exp_min>;
  stddev_samp?: InputMaybe<emission_certificate_aggregate_bool_exp_stddev_samp>;
  sum?: InputMaybe<emission_certificate_aggregate_bool_exp_sum>;
  var_samp?: InputMaybe<emission_certificate_aggregate_bool_exp_var_samp>;
};

export type emission_certificate_aggregate_bool_exp_avg = {
  arguments: emission_certificate_select_column_emission_certificate_aggregate_bool_exp_avg_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<emission_certificate_bool_exp>;
  predicate: float8_comparison_exp;
};

export type emission_certificate_aggregate_bool_exp_corr = {
  arguments: emission_certificate_aggregate_bool_exp_corr_arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<emission_certificate_bool_exp>;
  predicate: float8_comparison_exp;
};

export type emission_certificate_aggregate_bool_exp_corr_arguments = {
  X: emission_certificate_select_column_emission_certificate_aggregate_bool_exp_corr_arguments_columns;
  Y: emission_certificate_select_column_emission_certificate_aggregate_bool_exp_corr_arguments_columns;
};

export type emission_certificate_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<emission_certificate_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<emission_certificate_bool_exp>;
  predicate: Int_comparison_exp;
};

export type emission_certificate_aggregate_bool_exp_covar_samp = {
  arguments: emission_certificate_aggregate_bool_exp_covar_samp_arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<emission_certificate_bool_exp>;
  predicate: float8_comparison_exp;
};

export type emission_certificate_aggregate_bool_exp_covar_samp_arguments = {
  X: emission_certificate_select_column_emission_certificate_aggregate_bool_exp_covar_samp_arguments_columns;
  Y: emission_certificate_select_column_emission_certificate_aggregate_bool_exp_covar_samp_arguments_columns;
};

export type emission_certificate_aggregate_bool_exp_max = {
  arguments: emission_certificate_select_column_emission_certificate_aggregate_bool_exp_max_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<emission_certificate_bool_exp>;
  predicate: float8_comparison_exp;
};

export type emission_certificate_aggregate_bool_exp_min = {
  arguments: emission_certificate_select_column_emission_certificate_aggregate_bool_exp_min_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<emission_certificate_bool_exp>;
  predicate: float8_comparison_exp;
};

export type emission_certificate_aggregate_bool_exp_stddev_samp = {
  arguments: emission_certificate_select_column_emission_certificate_aggregate_bool_exp_stddev_samp_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<emission_certificate_bool_exp>;
  predicate: float8_comparison_exp;
};

export type emission_certificate_aggregate_bool_exp_sum = {
  arguments: emission_certificate_select_column_emission_certificate_aggregate_bool_exp_sum_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<emission_certificate_bool_exp>;
  predicate: float8_comparison_exp;
};

export type emission_certificate_aggregate_bool_exp_var_samp = {
  arguments: emission_certificate_select_column_emission_certificate_aggregate_bool_exp_var_samp_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<emission_certificate_bool_exp>;
  predicate: float8_comparison_exp;
};

/** aggregate fields of "emission_certificate" */
export type emission_certificate_aggregate_fields = {
  avg?: Maybe<emission_certificate_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<emission_certificate_max_fields>;
  min?: Maybe<emission_certificate_min_fields>;
  stddev?: Maybe<emission_certificate_stddev_fields>;
  stddev_pop?: Maybe<emission_certificate_stddev_pop_fields>;
  stddev_samp?: Maybe<emission_certificate_stddev_samp_fields>;
  sum?: Maybe<emission_certificate_sum_fields>;
  var_pop?: Maybe<emission_certificate_var_pop_fields>;
  var_samp?: Maybe<emission_certificate_var_samp_fields>;
  variance?: Maybe<emission_certificate_variance_fields>;
};

/** aggregate fields of "emission_certificate" */
export type emission_certificate_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<emission_certificate_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "emission_certificate" */
export type emission_certificate_aggregate_order_by = {
  avg?: InputMaybe<emission_certificate_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<emission_certificate_max_order_by>;
  min?: InputMaybe<emission_certificate_min_order_by>;
  stddev?: InputMaybe<emission_certificate_stddev_order_by>;
  stddev_pop?: InputMaybe<emission_certificate_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<emission_certificate_stddev_samp_order_by>;
  sum?: InputMaybe<emission_certificate_sum_order_by>;
  var_pop?: InputMaybe<emission_certificate_var_pop_order_by>;
  var_samp?: InputMaybe<emission_certificate_var_samp_order_by>;
  variance?: InputMaybe<emission_certificate_variance_order_by>;
};

/** aggregate avg on columns */
export type emission_certificate_avg_fields = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this certificate. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "emission_certificate" */
export type emission_certificate_avg_order_by = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "emission_certificate". All fields are combined with a logical 'AND'. */
export type emission_certificate_bool_exp = {
  _and?: InputMaybe<Array<emission_certificate_bool_exp>>;
  _not?: InputMaybe<emission_certificate_bool_exp>;
  _or?: InputMaybe<Array<emission_certificate_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  emission_certificate_document_type_id?: InputMaybe<emission_certificate_document_type_enum_comparison_exp>;
  emission_certificate_energy_source_type_id?: InputMaybe<emission_certificate_energy_source_type_enum_comparison_exp>;
  emission_certificate_value_path?: InputMaybe<emission_certificate_value_path_bool_exp>;
  emission_factor?: InputMaybe<float8_comparison_exp>;
  emission_factor_active_value_type?: InputMaybe<energy_supplier_value_type_enum_comparison_exp>;
  energy_system_consumer_routes?: InputMaybe<energy_system_consumer_route_bool_exp>;
  file?: InputMaybe<file_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  issuer?: InputMaybe<String_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  primary_energy_factor?: InputMaybe<float8_comparison_exp>;
  primary_energy_factor_active_value_type?: InputMaybe<energy_supplier_value_type_enum_comparison_exp>;
  primary_energy_factor_energy_system_consumer_routes?: InputMaybe<energy_system_consumer_route_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  valid_from?: InputMaybe<timestamptz_comparison_exp>;
  valid_until?: InputMaybe<timestamptz_comparison_exp>;
};

export enum emission_certificate_document_type_enum {
  CERTIFICATE_OF_ORIGIN = 'CERTIFICATE_OF_ORIGIN',
  EMISSION_CERTIFICATE = 'EMISSION_CERTIFICATE',
  OTHER = 'OTHER',
}

/** Boolean expression to compare columns of type "emission_certificate_document_type_enum". All fields are combined with logical 'AND'. */
export type emission_certificate_document_type_enum_comparison_exp = {
  _eq?: InputMaybe<emission_certificate_document_type_enum>;
  _in?: InputMaybe<Array<emission_certificate_document_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<emission_certificate_document_type_enum>;
  _nin?: InputMaybe<Array<emission_certificate_document_type_enum>>;
};

/** Draft version of an emission certificate, used during creation or editing before finalization. */
export type emission_certificate_draft = {
  /** An object relationship */
  file?: Maybe<file>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  org: org;
};

/** order by aggregate values of table "emission_certificate_draft" */
export type emission_certificate_draft_aggregate_order_by = {
  avg?: InputMaybe<emission_certificate_draft_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<emission_certificate_draft_max_order_by>;
  min?: InputMaybe<emission_certificate_draft_min_order_by>;
  stddev?: InputMaybe<emission_certificate_draft_stddev_order_by>;
  stddev_pop?: InputMaybe<emission_certificate_draft_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<emission_certificate_draft_stddev_samp_order_by>;
  sum?: InputMaybe<emission_certificate_draft_sum_order_by>;
  var_pop?: InputMaybe<emission_certificate_draft_var_pop_order_by>;
  var_samp?: InputMaybe<emission_certificate_draft_var_samp_order_by>;
  variance?: InputMaybe<emission_certificate_draft_variance_order_by>;
};

/** order by avg() on columns of table "emission_certificate_draft" */
export type emission_certificate_draft_avg_order_by = {
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "emission_certificate_draft". All fields are combined with a logical 'AND'. */
export type emission_certificate_draft_bool_exp = {
  _and?: InputMaybe<Array<emission_certificate_draft_bool_exp>>;
  _not?: InputMaybe<emission_certificate_draft_bool_exp>;
  _or?: InputMaybe<Array<emission_certificate_draft_bool_exp>>;
  file?: InputMaybe<file_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
};

/** order by max() on columns of table "emission_certificate_draft" */
export type emission_certificate_draft_max_order_by = {
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "emission_certificate_draft" */
export type emission_certificate_draft_min_order_by = {
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** response of any mutation on the table "emission_certificate_draft" */
export type emission_certificate_draft_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<emission_certificate_draft>;
};

/** Ordering options when selecting data from "emission_certificate_draft". */
export type emission_certificate_draft_order_by = {
  file?: InputMaybe<file_order_by>;
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
};

/** select columns of table "emission_certificate_draft" */
export enum emission_certificate_draft_select_column {
  /** column name */
  file_id = 'file_id',
  /** column name */
  id = 'id',
}

/** order by stddev() on columns of table "emission_certificate_draft" */
export type emission_certificate_draft_stddev_order_by = {
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "emission_certificate_draft" */
export type emission_certificate_draft_stddev_pop_order_by = {
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "emission_certificate_draft" */
export type emission_certificate_draft_stddev_samp_order_by = {
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "emission_certificate_draft" */
export type emission_certificate_draft_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: emission_certificate_draft_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type emission_certificate_draft_stream_cursor_value_input = {
  file_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "emission_certificate_draft" */
export type emission_certificate_draft_sum_order_by = {
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "emission_certificate_draft" */
export type emission_certificate_draft_var_pop_order_by = {
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "emission_certificate_draft" */
export type emission_certificate_draft_var_samp_order_by = {
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "emission_certificate_draft" */
export type emission_certificate_draft_variance_order_by = {
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

export enum emission_certificate_energy_source_type_enum {
  DISTRICT_HEATING = 'DISTRICT_HEATING',
  ELECTRICITY_GREEN = 'ELECTRICITY_GREEN',
  ELECTRICITY_MIX = 'ELECTRICITY_MIX',
}

/** Boolean expression to compare columns of type "emission_certificate_energy_source_type_enum". All fields are combined with logical 'AND'. */
export type emission_certificate_energy_source_type_enum_comparison_exp = {
  _eq?: InputMaybe<emission_certificate_energy_source_type_enum>;
  _in?: InputMaybe<Array<emission_certificate_energy_source_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<emission_certificate_energy_source_type_enum>;
  _nin?: InputMaybe<Array<emission_certificate_energy_source_type_enum>>;
};

/** aggregate max on columns */
export type emission_certificate_max_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: Maybe<Scalars['float8']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Name of the energy supplier that issued the certificate. */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Organization that owns this certificate. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Start date of the certificate validity period. */
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  /** Expiration date of the certificate. */
  valid_until?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "emission_certificate" */
export type emission_certificate_max_order_by = {
  created_at?: InputMaybe<order_by>;
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Name of the energy supplier that issued the certificate. */
  issuer?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Start date of the certificate validity period. */
  valid_from?: InputMaybe<order_by>;
  /** Expiration date of the certificate. */
  valid_until?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type emission_certificate_min_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: Maybe<Scalars['float8']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Name of the energy supplier that issued the certificate. */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Organization that owns this certificate. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Start date of the certificate validity period. */
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  /** Expiration date of the certificate. */
  valid_until?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "emission_certificate" */
export type emission_certificate_min_order_by = {
  created_at?: InputMaybe<order_by>;
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Name of the energy supplier that issued the certificate. */
  issuer?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Start date of the certificate validity period. */
  valid_from?: InputMaybe<order_by>;
  /** Expiration date of the certificate. */
  valid_until?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "emission_certificate". */
export type emission_certificate_order_by = {
  created_at?: InputMaybe<order_by>;
  emission_certificate_document_type_id?: InputMaybe<order_by>;
  emission_certificate_energy_source_type_id?: InputMaybe<order_by>;
  emission_certificate_value_path?: InputMaybe<emission_certificate_value_path_order_by>;
  emission_factor?: InputMaybe<order_by>;
  emission_factor_active_value_type?: InputMaybe<order_by>;
  energy_system_consumer_routes_aggregate?: InputMaybe<energy_system_consumer_route_aggregate_order_by>;
  file?: InputMaybe<file_order_by>;
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  issuer?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  primary_energy_factor?: InputMaybe<order_by>;
  primary_energy_factor_active_value_type?: InputMaybe<order_by>;
  primary_energy_factor_energy_system_consumer_routes_aggregate?: InputMaybe<energy_system_consumer_route_aggregate_order_by>;
  updated_at?: InputMaybe<order_by>;
  valid_from?: InputMaybe<order_by>;
  valid_until?: InputMaybe<order_by>;
};

/** select columns of table "emission_certificate" */
export enum emission_certificate_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  emission_certificate_document_type_id = 'emission_certificate_document_type_id',
  /** column name */
  emission_certificate_energy_source_type_id = 'emission_certificate_energy_source_type_id',
  /** column name */
  emission_factor = 'emission_factor',
  /** column name */
  emission_factor_active_value_type = 'emission_factor_active_value_type',
  /** column name */
  file_id = 'file_id',
  /** column name */
  id = 'id',
  /** column name */
  issuer = 'issuer',
  /** column name */
  org_id = 'org_id',
  /** column name */
  primary_energy_factor = 'primary_energy_factor',
  /** column name */
  primary_energy_factor_active_value_type = 'primary_energy_factor_active_value_type',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  valid_from = 'valid_from',
  /** column name */
  valid_until = 'valid_until',
}

/** select "emission_certificate_aggregate_bool_exp_avg_arguments_columns" columns of table "emission_certificate" */
export enum emission_certificate_select_column_emission_certificate_aggregate_bool_exp_avg_arguments_columns {
  /** column name */
  emission_factor = 'emission_factor',
  /** column name */
  primary_energy_factor = 'primary_energy_factor',
}

/** select "emission_certificate_aggregate_bool_exp_corr_arguments_columns" columns of table "emission_certificate" */
export enum emission_certificate_select_column_emission_certificate_aggregate_bool_exp_corr_arguments_columns {
  /** column name */
  emission_factor = 'emission_factor',
  /** column name */
  primary_energy_factor = 'primary_energy_factor',
}

/** select "emission_certificate_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "emission_certificate" */
export enum emission_certificate_select_column_emission_certificate_aggregate_bool_exp_covar_samp_arguments_columns {
  /** column name */
  emission_factor = 'emission_factor',
  /** column name */
  primary_energy_factor = 'primary_energy_factor',
}

/** select "emission_certificate_aggregate_bool_exp_max_arguments_columns" columns of table "emission_certificate" */
export enum emission_certificate_select_column_emission_certificate_aggregate_bool_exp_max_arguments_columns {
  /** column name */
  emission_factor = 'emission_factor',
  /** column name */
  primary_energy_factor = 'primary_energy_factor',
}

/** select "emission_certificate_aggregate_bool_exp_min_arguments_columns" columns of table "emission_certificate" */
export enum emission_certificate_select_column_emission_certificate_aggregate_bool_exp_min_arguments_columns {
  /** column name */
  emission_factor = 'emission_factor',
  /** column name */
  primary_energy_factor = 'primary_energy_factor',
}

/** select "emission_certificate_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "emission_certificate" */
export enum emission_certificate_select_column_emission_certificate_aggregate_bool_exp_stddev_samp_arguments_columns {
  /** column name */
  emission_factor = 'emission_factor',
  /** column name */
  primary_energy_factor = 'primary_energy_factor',
}

/** select "emission_certificate_aggregate_bool_exp_sum_arguments_columns" columns of table "emission_certificate" */
export enum emission_certificate_select_column_emission_certificate_aggregate_bool_exp_sum_arguments_columns {
  /** column name */
  emission_factor = 'emission_factor',
  /** column name */
  primary_energy_factor = 'primary_energy_factor',
}

/** select "emission_certificate_aggregate_bool_exp_var_samp_arguments_columns" columns of table "emission_certificate" */
export enum emission_certificate_select_column_emission_certificate_aggregate_bool_exp_var_samp_arguments_columns {
  /** column name */
  emission_factor = 'emission_factor',
  /** column name */
  primary_energy_factor = 'primary_energy_factor',
}

/** aggregate stddev on columns */
export type emission_certificate_stddev_fields = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this certificate. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "emission_certificate" */
export type emission_certificate_stddev_order_by = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type emission_certificate_stddev_pop_fields = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this certificate. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "emission_certificate" */
export type emission_certificate_stddev_pop_order_by = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type emission_certificate_stddev_samp_fields = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this certificate. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "emission_certificate" */
export type emission_certificate_stddev_samp_order_by = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "emission_certificate" */
export type emission_certificate_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: emission_certificate_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type emission_certificate_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Type of certificate document. */
  emission_certificate_document_type_id?: InputMaybe<emission_certificate_document_type_enum>;
  /** Energy source type this certificate applies to (e.g., district heating). */
  emission_certificate_energy_source_type_id?: InputMaybe<emission_certificate_energy_source_type_enum>;
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<Scalars['float8']['input']>;
  /** Whether the emission factor is a static value or follows a time-based path. */
  emission_factor_active_value_type?: InputMaybe<energy_supplier_value_type_enum>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the energy supplier that issued the certificate. */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<Scalars['float8']['input']>;
  /** Whether the primary energy factor is a static value or follows a time-based path. */
  primary_energy_factor_active_value_type?: InputMaybe<energy_supplier_value_type_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Start date of the certificate validity period. */
  valid_from?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Expiration date of the certificate. */
  valid_until?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type emission_certificate_sum_fields = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: Maybe<Scalars['float8']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization that owns this certificate. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "emission_certificate" */
export type emission_certificate_sum_order_by = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<order_by>;
};

/** Time-series path for emission and primary energy factors that change year-by-year up to 2050, representing the decarbonization trajectory of the energy supplier. */
export type emission_certificate_value_path = {
  /** An object relationship */
  emission_certificate: emission_certificate;
  /** Year-by-year emission factor values (kg CO2/kWh), indexed by year position starting from TARGET_PATH_FIRST_YEAR. */
  emission_factor: Array<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  /** Year-by-year primary energy factor values, indexed by year position starting from TARGET_PATH_FIRST_YEAR. */
  primary_energy_factor: Array<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "emission_certificate_value_path". All fields are combined with a logical 'AND'. */
export type emission_certificate_value_path_bool_exp = {
  _and?: InputMaybe<Array<emission_certificate_value_path_bool_exp>>;
  _not?: InputMaybe<emission_certificate_value_path_bool_exp>;
  _or?: InputMaybe<Array<emission_certificate_value_path_bool_exp>>;
  emission_certificate?: InputMaybe<emission_certificate_bool_exp>;
  emission_factor?: InputMaybe<Float_array_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  primary_energy_factor?: InputMaybe<Float_array_comparison_exp>;
};

/** Ordering options when selecting data from "emission_certificate_value_path". */
export type emission_certificate_value_path_order_by = {
  emission_certificate?: InputMaybe<emission_certificate_order_by>;
  emission_factor?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  primary_energy_factor?: InputMaybe<order_by>;
};

/** select columns of table "emission_certificate_value_path" */
export enum emission_certificate_value_path_select_column {
  /** column name */
  emission_factor = 'emission_factor',
  /** column name */
  id = 'id',
  /** column name */
  primary_energy_factor = 'primary_energy_factor',
}

/** Streaming cursor of the table "emission_certificate_value_path" */
export type emission_certificate_value_path_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: emission_certificate_value_path_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type emission_certificate_value_path_stream_cursor_value_input = {
  /** Year-by-year emission factor values (kg CO2/kWh), indexed by year position starting from TARGET_PATH_FIRST_YEAR. */
  emission_factor?: InputMaybe<Array<Scalars['Float']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Year-by-year primary energy factor values, indexed by year position starting from TARGET_PATH_FIRST_YEAR. */
  primary_energy_factor?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** aggregate var_pop on columns */
export type emission_certificate_var_pop_fields = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this certificate. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "emission_certificate" */
export type emission_certificate_var_pop_order_by = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type emission_certificate_var_samp_fields = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this certificate. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "emission_certificate" */
export type emission_certificate_var_samp_order_by = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type emission_certificate_variance_fields = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: Maybe<Scalars['Float']['output']>;
  /** Reference to the uploaded certificate document. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this certificate. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "emission_certificate" */
export type emission_certificate_variance_order_by = {
  /** CO2 emission factor in kg CO2/kWh as certified by the supplier. */
  emission_factor?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Primary energy factor as certified by the supplier. */
  primary_energy_factor?: InputMaybe<order_by>;
};

export enum emission_factor_source_enum {
  ARBEITSHILFE_85 = 'ARBEITSHILFE_85',
  GEMIS = 'GEMIS',
  NATIONAL_ENERGY_LAW = 'NATIONAL_ENERGY_LAW',
  UBA = 'UBA',
}

export enum emission_factor_type_enum {
  CRREM = 'CRREM',
  CRREM_GEG = 'CRREM_GEG',
  NATIONAL_ENERGY_LAW = 'NATIONAL_ENERGY_LAW',
}

/** Boolean expression to compare columns of type "emission_factor_type_enum". All fields are combined with logical 'AND'. */
export type emission_factor_type_enum_comparison_exp = {
  _eq?: InputMaybe<emission_factor_type_enum>;
  _in?: InputMaybe<Array<emission_factor_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<emission_factor_type_enum>;
  _nin?: InputMaybe<Array<emission_factor_type_enum>>;
};

/** Energy performance certificate (Energieausweis) for a building, containing energy demand/consumption metrics and efficiency classification. */
export type energy_certificate = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: Maybe<Scalars['numeric']['output']>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  building?: Maybe<building>;
  /** An object relationship */
  building_draft?: Maybe<building_draft>;
  /** An array relationship */
  building_draft_areas: Array<building_draft_area>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: Maybe<Scalars['Int']['output']>;
  /** The building this certificate belongs to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** City of the building on the certificate. */
  city?: Maybe<Scalars['String']['output']>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: Maybe<Scalars['numeric']['output']>;
  /** Country where the building is located. */
  country_id: country_enum;
  /** Federal state/region where the building is located. */
  country_state_id: country_state_enum;
  created_at: Scalars['timestamptz']['output'];
  /** Energy efficiency class (e.g., A+, A, B, C through H). */
  efficiency_class: efficiency_class_enum;
  /** An array relationship */
  energy_certificate_consumers: Array<energy_certificate_consumer>;
  /** DEMAND (Bedarfsausweis) or CONSUMPTION (Verbrauchsausweis) certificate type. */
  energy_certificate_type: energy_certificate_type_enum;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: Maybe<Scalars['numeric']['output']>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: Maybe<Scalars['numeric']['output']>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: Maybe<Scalars['numeric']['output']>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: Maybe<Scalars['numeric']['output']>;
  energy_rating_score?: Maybe<Scalars['numeric']['output']>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: Maybe<Scalars['Int']['output']>;
  /** Date when the energy certificate expires. */
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  file?: Maybe<file>;
  /** Reference to the uploaded certificate document file. */
  file_id?: Maybe<Scalars['Int']['output']>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  org: org;
  /** Organization that owns this certificate. */
  org_id: Scalars['Int']['output'];
  /** Postal code of the building on the certificate. */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: Maybe<Scalars['numeric']['output']>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: Maybe<Scalars['numeric']['output']>;
  /** Processing state of the certificate (e.g., draft, verified). */
  state?: Maybe<Scalars['String']['output']>;
  /** Street address of the building on the certificate. */
  street?: Maybe<Scalars['String']['output']>;
  /** Primary usage type of the building (e.g., residential, office). */
  type_of_use_id: type_of_use_enum;
  /** Number of commercial units in the building. */
  units_commercial?: Maybe<Scalars['Int']['output']>;
  /** Number of residential units in the building. */
  units_residential?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** Year the building was constructed. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
  /** Year of the most recent major renovation. */
  year_renovated?: Maybe<Scalars['Int']['output']>;
};

/** Energy performance certificate (Energieausweis) for a building, containing energy demand/consumption metrics and efficiency classification. */
export type energy_certificatebuilding_draft_areasArgs = {
  distinct_on?: InputMaybe<Array<building_draft_area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_area_order_by>>;
  where?: InputMaybe<building_draft_area_bool_exp>;
};

/** Energy performance certificate (Energieausweis) for a building, containing energy demand/consumption metrics and efficiency classification. */
export type energy_certificateenergy_certificate_consumersArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_consumer_order_by>>;
  where?: InputMaybe<energy_certificate_consumer_bool_exp>;
};

/** order by aggregate values of table "energy_certificate" */
export type energy_certificate_aggregate_order_by = {
  avg?: InputMaybe<energy_certificate_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<energy_certificate_max_order_by>;
  min?: InputMaybe<energy_certificate_min_order_by>;
  stddev?: InputMaybe<energy_certificate_stddev_order_by>;
  stddev_pop?: InputMaybe<energy_certificate_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<energy_certificate_stddev_samp_order_by>;
  sum?: InputMaybe<energy_certificate_sum_order_by>;
  var_pop?: InputMaybe<energy_certificate_var_pop_order_by>;
  var_samp?: InputMaybe<energy_certificate_var_samp_order_by>;
  variance?: InputMaybe<energy_certificate_variance_order_by>;
};

/** order by avg() on columns of table "energy_certificate" */
export type energy_certificate_avg_order_by = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<order_by>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<order_by>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<order_by>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<order_by>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<order_by>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<order_by>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<order_by>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<order_by>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<order_by>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<order_by>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "energy_certificate". All fields are combined with a logical 'AND'. */
export type energy_certificate_bool_exp = {
  _and?: InputMaybe<Array<energy_certificate_bool_exp>>;
  _not?: InputMaybe<energy_certificate_bool_exp>;
  _or?: InputMaybe<Array<energy_certificate_bool_exp>>;
  area_gross?: InputMaybe<numeric_comparison_exp>;
  area_usable?: InputMaybe<numeric_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_draft?: InputMaybe<building_draft_bool_exp>;
  building_draft_areas?: InputMaybe<building_draft_area_bool_exp>;
  building_draft_id?: InputMaybe<Int_comparison_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  city?: InputMaybe<String_comparison_exp>;
  co2_emissions?: InputMaybe<numeric_comparison_exp>;
  country_id?: InputMaybe<country_enum_comparison_exp>;
  country_state_id?: InputMaybe<country_state_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  efficiency_class?: InputMaybe<efficiency_class_enum_comparison_exp>;
  energy_certificate_consumers?: InputMaybe<energy_certificate_consumer_bool_exp>;
  energy_certificate_type?: InputMaybe<energy_certificate_type_enum_comparison_exp>;
  energy_final_consumption?: InputMaybe<numeric_comparison_exp>;
  energy_final_demand?: InputMaybe<numeric_comparison_exp>;
  energy_primary_consumption?: InputMaybe<numeric_comparison_exp>;
  energy_primary_demand?: InputMaybe<numeric_comparison_exp>;
  energy_rating_score?: InputMaybe<numeric_comparison_exp>;
  enev_year?: InputMaybe<Int_comparison_exp>;
  expiry_date?: InputMaybe<timestamptz_comparison_exp>;
  file?: InputMaybe<file_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  geg_reference_value?: InputMaybe<numeric_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  postal_code?: InputMaybe<String_comparison_exp>;
  reference_value_electricity?: InputMaybe<numeric_comparison_exp>;
  reference_value_heating_hot_water?: InputMaybe<numeric_comparison_exp>;
  state?: InputMaybe<String_comparison_exp>;
  street?: InputMaybe<String_comparison_exp>;
  type_of_use_id?: InputMaybe<type_of_use_enum_comparison_exp>;
  units_commercial?: InputMaybe<Int_comparison_exp>;
  units_residential?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  year_constructed?: InputMaybe<Int_comparison_exp>;
  year_renovated?: InputMaybe<Int_comparison_exp>;
};

/** An energy consumption entry from an energy certificate, recording the final energy usage for a specific energy source and system type. */
export type energy_certificate_consumer = {
  /** An object relationship */
  energy_certificate?: Maybe<energy_certificate>;
  /** An object relationship */
  energy_certificate_draft?: Maybe<energy_certificate_draft>;
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: Maybe<Scalars['Int']['output']>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: Maybe<Scalars['Int']['output']>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final: Scalars['Float']['output'];
  /** The energy source for this consumption entry (e.g., NATURAL_GAS, ELECTRICITY). */
  energy_source_type_id: energy_source_type_enum;
  /** The energy system purpose for this consumption entry (HEATING, COOLING, HOT_WATER, etc.). */
  energy_system_type_id: energy_system_type_enum;
  id: Scalars['Int']['output'];
};

/** order by aggregate values of table "energy_certificate_consumer" */
export type energy_certificate_consumer_aggregate_order_by = {
  avg?: InputMaybe<energy_certificate_consumer_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<energy_certificate_consumer_max_order_by>;
  min?: InputMaybe<energy_certificate_consumer_min_order_by>;
  stddev?: InputMaybe<energy_certificate_consumer_stddev_order_by>;
  stddev_pop?: InputMaybe<energy_certificate_consumer_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<energy_certificate_consumer_stddev_samp_order_by>;
  sum?: InputMaybe<energy_certificate_consumer_sum_order_by>;
  var_pop?: InputMaybe<energy_certificate_consumer_var_pop_order_by>;
  var_samp?: InputMaybe<energy_certificate_consumer_var_samp_order_by>;
  variance?: InputMaybe<energy_certificate_consumer_variance_order_by>;
};

/** order by avg() on columns of table "energy_certificate_consumer" */
export type energy_certificate_consumer_avg_order_by = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "energy_certificate_consumer". All fields are combined with a logical 'AND'. */
export type energy_certificate_consumer_bool_exp = {
  _and?: InputMaybe<Array<energy_certificate_consumer_bool_exp>>;
  _not?: InputMaybe<energy_certificate_consumer_bool_exp>;
  _or?: InputMaybe<Array<energy_certificate_consumer_bool_exp>>;
  energy_certificate?: InputMaybe<energy_certificate_bool_exp>;
  energy_certificate_draft?: InputMaybe<energy_certificate_draft_bool_exp>;
  energy_certificate_draft_id?: InputMaybe<Int_comparison_exp>;
  energy_certificate_id?: InputMaybe<Int_comparison_exp>;
  energy_final?: InputMaybe<Float_comparison_exp>;
  energy_source_type_id?: InputMaybe<energy_source_type_enum_comparison_exp>;
  energy_system_type_id?: InputMaybe<energy_system_type_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "energy_certificate_consumer" */
export enum energy_certificate_consumer_constraint {
  /** unique or primary key constraint on columns "id" */
  energy_certificate_consumer_pkey = 'energy_certificate_consumer_pkey',
}

/** input type for incrementing numeric columns in table "energy_certificate_consumer" */
export type energy_certificate_consumer_inc_input = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "energy_certificate_consumer" */
export type energy_certificate_consumer_insert_input = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<Scalars['Float']['input']>;
  /** The energy source for this consumption entry (e.g., NATURAL_GAS, ELECTRICITY). */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  /** The energy system purpose for this consumption entry (HEATING, COOLING, HOT_WATER, etc.). */
  energy_system_type_id?: InputMaybe<energy_system_type_enum>;
};

/** order by max() on columns of table "energy_certificate_consumer" */
export type energy_certificate_consumer_max_order_by = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "energy_certificate_consumer" */
export type energy_certificate_consumer_min_order_by = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** response of any mutation on the table "energy_certificate_consumer" */
export type energy_certificate_consumer_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<energy_certificate_consumer>;
};

/** on_conflict condition type for table "energy_certificate_consumer" */
export type energy_certificate_consumer_on_conflict = {
  constraint: energy_certificate_consumer_constraint;
  update_columns?: Array<energy_certificate_consumer_update_column>;
  where?: InputMaybe<energy_certificate_consumer_bool_exp>;
};

/** Ordering options when selecting data from "energy_certificate_consumer". */
export type energy_certificate_consumer_order_by = {
  energy_certificate?: InputMaybe<energy_certificate_order_by>;
  energy_certificate_draft?: InputMaybe<energy_certificate_draft_order_by>;
  energy_certificate_draft_id?: InputMaybe<order_by>;
  energy_certificate_id?: InputMaybe<order_by>;
  energy_final?: InputMaybe<order_by>;
  energy_source_type_id?: InputMaybe<order_by>;
  energy_system_type_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** primary key columns input for table: energy_certificate_consumer */
export type energy_certificate_consumer_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "energy_certificate_consumer" */
export enum energy_certificate_consumer_select_column {
  /** column name */
  energy_certificate_draft_id = 'energy_certificate_draft_id',
  /** column name */
  energy_certificate_id = 'energy_certificate_id',
  /** column name */
  energy_final = 'energy_final',
  /** column name */
  energy_source_type_id = 'energy_source_type_id',
  /** column name */
  energy_system_type_id = 'energy_system_type_id',
  /** column name */
  id = 'id',
}

/** input type for updating data in table "energy_certificate_consumer" */
export type energy_certificate_consumer_set_input = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<Scalars['Float']['input']>;
  /** The energy source for this consumption entry (e.g., NATURAL_GAS, ELECTRICITY). */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  /** The energy system purpose for this consumption entry (HEATING, COOLING, HOT_WATER, etc.). */
  energy_system_type_id?: InputMaybe<energy_system_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "energy_certificate_consumer" */
export type energy_certificate_consumer_stddev_order_by = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "energy_certificate_consumer" */
export type energy_certificate_consumer_stddev_pop_order_by = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "energy_certificate_consumer" */
export type energy_certificate_consumer_stddev_samp_order_by = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "energy_certificate_consumer" */
export type energy_certificate_consumer_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: energy_certificate_consumer_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type energy_certificate_consumer_stream_cursor_value_input = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<Scalars['Float']['input']>;
  /** The energy source for this consumption entry (e.g., NATURAL_GAS, ELECTRICITY). */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  /** The energy system purpose for this consumption entry (HEATING, COOLING, HOT_WATER, etc.). */
  energy_system_type_id?: InputMaybe<energy_system_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "energy_certificate_consumer" */
export type energy_certificate_consumer_sum_order_by = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** update columns of table "energy_certificate_consumer" */
export enum energy_certificate_consumer_update_column {
  /** column name */
  energy_certificate_draft_id = 'energy_certificate_draft_id',
  /** column name */
  energy_certificate_id = 'energy_certificate_id',
  /** column name */
  energy_final = 'energy_final',
  /** column name */
  energy_source_type_id = 'energy_source_type_id',
  /** column name */
  energy_system_type_id = 'energy_system_type_id',
  /** column name */
  id = 'id',
}

export type energy_certificate_consumer_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<energy_certificate_consumer_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<energy_certificate_consumer_set_input>;
  /** filter the rows which have to be updated */
  where: energy_certificate_consumer_bool_exp;
};

/** order by var_pop() on columns of table "energy_certificate_consumer" */
export type energy_certificate_consumer_var_pop_order_by = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "energy_certificate_consumer" */
export type energy_certificate_consumer_var_samp_order_by = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "energy_certificate_consumer" */
export type energy_certificate_consumer_variance_order_by = {
  /** Reference to a draft energy certificate, used when the certificate is still being processed. */
  energy_certificate_draft_id?: InputMaybe<order_by>;
  /** Reference to the parent energy certificate this consumption entry belongs to. */
  energy_certificate_id?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2a) as stated on the energy certificate. */
  energy_final?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Draft energy certificate being processed, typically from AI-based document extraction before user verification. */
export type energy_certificate_draft = {
  area_gross?: Maybe<Scalars['numeric']['output']>;
  area_usable?: Maybe<Scalars['numeric']['output']>;
  building_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** An object relationship */
  building_draft: building_draft;
  building_state_id?: Maybe<building_state_enum>;
  city?: Maybe<Scalars['String']['output']>;
  class_of_use_id?: Maybe<class_of_use_enum>;
  co2_emissions?: Maybe<Scalars['numeric']['output']>;
  country_id: country_enum;
  country_state_id?: Maybe<country_state_enum>;
  created_at: Scalars['timestamptz']['output'];
  customer_external_identifier?: Maybe<Scalars['String']['output']>;
  draft_status_id: draft_status_enum;
  /** An object relationship */
  economic_unit?: Maybe<economic_unit>;
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  efficiency_class_id?: Maybe<efficiency_class_enum>;
  /** An array relationship */
  energy_certificate_consumers: Array<energy_certificate_consumer>;
  /** An array relationship */
  energy_certificate_draft_valuations: Array<building_draft_valuation>;
  energy_certificate_file_id: Scalars['Int']['output'];
  energy_certificate_type_id?: Maybe<energy_certificate_type_enum>;
  energy_final_consumption?: Maybe<Scalars['numeric']['output']>;
  energy_final_demand?: Maybe<Scalars['numeric']['output']>;
  energy_primary_consumption?: Maybe<Scalars['numeric']['output']>;
  energy_primary_demand?: Maybe<Scalars['numeric']['output']>;
  energy_rating_score?: Maybe<Scalars['numeric']['output']>;
  enev_year?: Maybe<Scalars['Int']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  file: file;
  floors?: Maybe<Scalars['numeric']['output']>;
  geg_reference_value?: Maybe<Scalars['numeric']['output']>;
  heritage_district: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['numeric']['output']>;
  leasehold: Scalars['Boolean']['output'];
  longitude?: Maybe<Scalars['numeric']['output']>;
  mapbox_building_ids?: Maybe<Array<Scalars['String']['output']>>;
  milieu_protection: Scalars['Boolean']['output'];
  monument_protection: Scalars['Boolean']['output'];
  neighbor_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  postal_code?: Maybe<Scalars['String']['output']>;
  reference_value_electricity?: Maybe<Scalars['numeric']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['numeric']['output']>;
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type_of_use_id?: Maybe<type_of_use_enum>;
  units?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<user>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
  year_renovated?: Maybe<Scalars['Int']['output']>;
};

/** Draft energy certificate being processed, typically from AI-based document extraction before user verification. */
export type energy_certificate_draftenergy_certificate_consumersArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_consumer_order_by>>;
  where?: InputMaybe<energy_certificate_consumer_bool_exp>;
};

/** Draft energy certificate being processed, typically from AI-based document extraction before user verification. */
export type energy_certificate_draftenergy_certificate_draft_valuationsArgs = {
  distinct_on?: InputMaybe<Array<building_draft_valuation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_valuation_order_by>>;
  where?: InputMaybe<building_draft_valuation_bool_exp>;
};

/** aggregated selection of "energy_certificate_draft" */
export type energy_certificate_draft_aggregate = {
  aggregate?: Maybe<energy_certificate_draft_aggregate_fields>;
  nodes: Array<energy_certificate_draft>;
};

export type energy_certificate_draft_aggregate_bool_exp = {
  bool_and?: InputMaybe<energy_certificate_draft_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<energy_certificate_draft_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<energy_certificate_draft_aggregate_bool_exp_count>;
};

export type energy_certificate_draft_aggregate_bool_exp_bool_and = {
  arguments: energy_certificate_draft_select_column_energy_certificate_draft_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<energy_certificate_draft_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type energy_certificate_draft_aggregate_bool_exp_bool_or = {
  arguments: energy_certificate_draft_select_column_energy_certificate_draft_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<energy_certificate_draft_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type energy_certificate_draft_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<energy_certificate_draft_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<energy_certificate_draft_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "energy_certificate_draft" */
export type energy_certificate_draft_aggregate_fields = {
  avg?: Maybe<energy_certificate_draft_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<energy_certificate_draft_max_fields>;
  min?: Maybe<energy_certificate_draft_min_fields>;
  stddev?: Maybe<energy_certificate_draft_stddev_fields>;
  stddev_pop?: Maybe<energy_certificate_draft_stddev_pop_fields>;
  stddev_samp?: Maybe<energy_certificate_draft_stddev_samp_fields>;
  sum?: Maybe<energy_certificate_draft_sum_fields>;
  var_pop?: Maybe<energy_certificate_draft_var_pop_fields>;
  var_samp?: Maybe<energy_certificate_draft_var_samp_fields>;
  variance?: Maybe<energy_certificate_draft_variance_fields>;
};

/** aggregate fields of "energy_certificate_draft" */
export type energy_certificate_draft_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<energy_certificate_draft_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "energy_certificate_draft" */
export type energy_certificate_draft_aggregate_order_by = {
  avg?: InputMaybe<energy_certificate_draft_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<energy_certificate_draft_max_order_by>;
  min?: InputMaybe<energy_certificate_draft_min_order_by>;
  stddev?: InputMaybe<energy_certificate_draft_stddev_order_by>;
  stddev_pop?: InputMaybe<energy_certificate_draft_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<energy_certificate_draft_stddev_samp_order_by>;
  sum?: InputMaybe<energy_certificate_draft_sum_order_by>;
  var_pop?: InputMaybe<energy_certificate_draft_var_pop_order_by>;
  var_samp?: InputMaybe<energy_certificate_draft_var_samp_order_by>;
  variance?: InputMaybe<energy_certificate_draft_variance_order_by>;
};

/** aggregate avg on columns */
export type energy_certificate_draft_avg_fields = {
  area_gross?: Maybe<Scalars['Float']['output']>;
  area_usable?: Maybe<Scalars['Float']['output']>;
  co2_emissions?: Maybe<Scalars['Float']['output']>;
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  energy_certificate_file_id?: Maybe<Scalars['Float']['output']>;
  energy_final_consumption?: Maybe<Scalars['Float']['output']>;
  energy_final_demand?: Maybe<Scalars['Float']['output']>;
  energy_primary_consumption?: Maybe<Scalars['Float']['output']>;
  energy_primary_demand?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  enev_year?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
  year_renovated?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "energy_certificate_draft" */
export type energy_certificate_draft_avg_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "energy_certificate_draft". All fields are combined with a logical 'AND'. */
export type energy_certificate_draft_bool_exp = {
  _and?: InputMaybe<Array<energy_certificate_draft_bool_exp>>;
  _not?: InputMaybe<energy_certificate_draft_bool_exp>;
  _or?: InputMaybe<Array<energy_certificate_draft_bool_exp>>;
  area_gross?: InputMaybe<numeric_comparison_exp>;
  area_usable?: InputMaybe<numeric_comparison_exp>;
  building_citydb_gml_ids?: InputMaybe<String_array_comparison_exp>;
  building_draft?: InputMaybe<building_draft_bool_exp>;
  building_state_id?: InputMaybe<building_state_enum_comparison_exp>;
  city?: InputMaybe<String_comparison_exp>;
  class_of_use_id?: InputMaybe<class_of_use_enum_comparison_exp>;
  co2_emissions?: InputMaybe<numeric_comparison_exp>;
  country_id?: InputMaybe<country_enum_comparison_exp>;
  country_state_id?: InputMaybe<country_state_enum_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  customer_external_identifier?: InputMaybe<String_comparison_exp>;
  draft_status_id?: InputMaybe<draft_status_enum_comparison_exp>;
  economic_unit?: InputMaybe<economic_unit_bool_exp>;
  economic_unit_id?: InputMaybe<Int_comparison_exp>;
  efficiency_class_id?: InputMaybe<efficiency_class_enum_comparison_exp>;
  energy_certificate_consumers?: InputMaybe<energy_certificate_consumer_bool_exp>;
  energy_certificate_draft_valuations?: InputMaybe<building_draft_valuation_bool_exp>;
  energy_certificate_file_id?: InputMaybe<Int_comparison_exp>;
  energy_certificate_type_id?: InputMaybe<energy_certificate_type_enum_comparison_exp>;
  energy_final_consumption?: InputMaybe<numeric_comparison_exp>;
  energy_final_demand?: InputMaybe<numeric_comparison_exp>;
  energy_primary_consumption?: InputMaybe<numeric_comparison_exp>;
  energy_primary_demand?: InputMaybe<numeric_comparison_exp>;
  energy_rating_score?: InputMaybe<numeric_comparison_exp>;
  enev_year?: InputMaybe<Int_comparison_exp>;
  expiry_date?: InputMaybe<timestamptz_comparison_exp>;
  file?: InputMaybe<file_bool_exp>;
  floors?: InputMaybe<numeric_comparison_exp>;
  geg_reference_value?: InputMaybe<numeric_comparison_exp>;
  heritage_district?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  latitude?: InputMaybe<numeric_comparison_exp>;
  leasehold?: InputMaybe<Boolean_comparison_exp>;
  longitude?: InputMaybe<numeric_comparison_exp>;
  mapbox_building_ids?: InputMaybe<String_array_comparison_exp>;
  milieu_protection?: InputMaybe<Boolean_comparison_exp>;
  monument_protection?: InputMaybe<Boolean_comparison_exp>;
  neighbor_citydb_gml_ids?: InputMaybe<String_array_comparison_exp>;
  postal_code?: InputMaybe<String_comparison_exp>;
  reference_value_electricity?: InputMaybe<numeric_comparison_exp>;
  reference_value_heating_hot_water?: InputMaybe<numeric_comparison_exp>;
  responsible_user_id?: InputMaybe<Int_comparison_exp>;
  street?: InputMaybe<String_comparison_exp>;
  type_of_use_id?: InputMaybe<type_of_use_enum_comparison_exp>;
  units?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  year_constructed?: InputMaybe<Int_comparison_exp>;
  year_renovated?: InputMaybe<Int_comparison_exp>;
};

/** input type for incrementing numeric columns in table "energy_certificate_draft" */
export type energy_certificate_draft_inc_input = {
  area_gross?: InputMaybe<Scalars['numeric']['input']>;
  area_usable?: InputMaybe<Scalars['numeric']['input']>;
  co2_emissions?: InputMaybe<Scalars['numeric']['input']>;
  economic_unit_id?: InputMaybe<Scalars['Int']['input']>;
  energy_final_consumption?: InputMaybe<Scalars['numeric']['input']>;
  energy_final_demand?: InputMaybe<Scalars['numeric']['input']>;
  energy_primary_consumption?: InputMaybe<Scalars['numeric']['input']>;
  energy_primary_demand?: InputMaybe<Scalars['numeric']['input']>;
  energy_rating_score?: InputMaybe<Scalars['numeric']['input']>;
  enev_year?: InputMaybe<Scalars['Int']['input']>;
  floors?: InputMaybe<Scalars['numeric']['input']>;
  geg_reference_value?: InputMaybe<Scalars['numeric']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  reference_value_electricity?: InputMaybe<Scalars['numeric']['input']>;
  reference_value_heating_hot_water?: InputMaybe<Scalars['numeric']['input']>;
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  units?: InputMaybe<Scalars['Int']['input']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<Scalars['Int']['input']>;
  year_renovated?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type energy_certificate_draft_max_fields = {
  area_gross?: Maybe<Scalars['numeric']['output']>;
  area_usable?: Maybe<Scalars['numeric']['output']>;
  building_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  co2_emissions?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_external_identifier?: Maybe<Scalars['String']['output']>;
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_file_id?: Maybe<Scalars['Int']['output']>;
  energy_final_consumption?: Maybe<Scalars['numeric']['output']>;
  energy_final_demand?: Maybe<Scalars['numeric']['output']>;
  energy_primary_consumption?: Maybe<Scalars['numeric']['output']>;
  energy_primary_demand?: Maybe<Scalars['numeric']['output']>;
  energy_rating_score?: Maybe<Scalars['numeric']['output']>;
  enev_year?: Maybe<Scalars['Int']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  floors?: Maybe<Scalars['numeric']['output']>;
  geg_reference_value?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  mapbox_building_ids?: Maybe<Array<Scalars['String']['output']>>;
  neighbor_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  postal_code?: Maybe<Scalars['String']['output']>;
  reference_value_electricity?: Maybe<Scalars['numeric']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['numeric']['output']>;
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
  year_renovated?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "energy_certificate_draft" */
export type energy_certificate_draft_max_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  building_citydb_gml_ids?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  customer_external_identifier?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  expiry_date?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  mapbox_building_ids?: InputMaybe<order_by>;
  neighbor_citydb_gml_ids?: InputMaybe<order_by>;
  postal_code?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type energy_certificate_draft_min_fields = {
  area_gross?: Maybe<Scalars['numeric']['output']>;
  area_usable?: Maybe<Scalars['numeric']['output']>;
  building_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  co2_emissions?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_external_identifier?: Maybe<Scalars['String']['output']>;
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_file_id?: Maybe<Scalars['Int']['output']>;
  energy_final_consumption?: Maybe<Scalars['numeric']['output']>;
  energy_final_demand?: Maybe<Scalars['numeric']['output']>;
  energy_primary_consumption?: Maybe<Scalars['numeric']['output']>;
  energy_primary_demand?: Maybe<Scalars['numeric']['output']>;
  energy_rating_score?: Maybe<Scalars['numeric']['output']>;
  enev_year?: Maybe<Scalars['Int']['output']>;
  expiry_date?: Maybe<Scalars['timestamptz']['output']>;
  floors?: Maybe<Scalars['numeric']['output']>;
  geg_reference_value?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  mapbox_building_ids?: Maybe<Array<Scalars['String']['output']>>;
  neighbor_citydb_gml_ids?: Maybe<Array<Scalars['String']['output']>>;
  postal_code?: Maybe<Scalars['String']['output']>;
  reference_value_electricity?: Maybe<Scalars['numeric']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['numeric']['output']>;
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
  year_renovated?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "energy_certificate_draft" */
export type energy_certificate_draft_min_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  building_citydb_gml_ids?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  customer_external_identifier?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  expiry_date?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  mapbox_building_ids?: InputMaybe<order_by>;
  neighbor_citydb_gml_ids?: InputMaybe<order_by>;
  postal_code?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** response of any mutation on the table "energy_certificate_draft" */
export type energy_certificate_draft_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<energy_certificate_draft>;
};

/** Ordering options when selecting data from "energy_certificate_draft". */
export type energy_certificate_draft_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  building_citydb_gml_ids?: InputMaybe<order_by>;
  building_draft?: InputMaybe<building_draft_order_by>;
  building_state_id?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  class_of_use_id?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  country_id?: InputMaybe<order_by>;
  country_state_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  customer_external_identifier?: InputMaybe<order_by>;
  draft_status_id?: InputMaybe<order_by>;
  economic_unit?: InputMaybe<economic_unit_order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  efficiency_class_id?: InputMaybe<order_by>;
  energy_certificate_consumers_aggregate?: InputMaybe<energy_certificate_consumer_aggregate_order_by>;
  energy_certificate_draft_valuations_aggregate?: InputMaybe<building_draft_valuation_aggregate_order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_certificate_type_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  expiry_date?: InputMaybe<order_by>;
  file?: InputMaybe<file_order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  heritage_district?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  leasehold?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  mapbox_building_ids?: InputMaybe<order_by>;
  milieu_protection?: InputMaybe<order_by>;
  monument_protection?: InputMaybe<order_by>;
  neighbor_citydb_gml_ids?: InputMaybe<order_by>;
  postal_code?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
  type_of_use_id?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** primary key columns input for table: energy_certificate_draft */
export type energy_certificate_draft_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "energy_certificate_draft" */
export enum energy_certificate_draft_select_column {
  /** column name */
  area_gross = 'area_gross',
  /** column name */
  area_usable = 'area_usable',
  /** column name */
  building_citydb_gml_ids = 'building_citydb_gml_ids',
  /** column name */
  building_state_id = 'building_state_id',
  /** column name */
  city = 'city',
  /** column name */
  class_of_use_id = 'class_of_use_id',
  /** column name */
  co2_emissions = 'co2_emissions',
  /** column name */
  country_id = 'country_id',
  /** column name */
  country_state_id = 'country_state_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  customer_external_identifier = 'customer_external_identifier',
  /** column name */
  draft_status_id = 'draft_status_id',
  /** column name */
  economic_unit_id = 'economic_unit_id',
  /** column name */
  efficiency_class_id = 'efficiency_class_id',
  /** column name */
  energy_certificate_file_id = 'energy_certificate_file_id',
  /** column name */
  energy_certificate_type_id = 'energy_certificate_type_id',
  /** column name */
  energy_final_consumption = 'energy_final_consumption',
  /** column name */
  energy_final_demand = 'energy_final_demand',
  /** column name */
  energy_primary_consumption = 'energy_primary_consumption',
  /** column name */
  energy_primary_demand = 'energy_primary_demand',
  /** column name */
  energy_rating_score = 'energy_rating_score',
  /** column name */
  enev_year = 'enev_year',
  /** column name */
  expiry_date = 'expiry_date',
  /** column name */
  floors = 'floors',
  /** column name */
  geg_reference_value = 'geg_reference_value',
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  id = 'id',
  /** column name */
  latitude = 'latitude',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  longitude = 'longitude',
  /** column name */
  mapbox_building_ids = 'mapbox_building_ids',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
  /** column name */
  neighbor_citydb_gml_ids = 'neighbor_citydb_gml_ids',
  /** column name */
  postal_code = 'postal_code',
  /** column name */
  reference_value_electricity = 'reference_value_electricity',
  /** column name */
  reference_value_heating_hot_water = 'reference_value_heating_hot_water',
  /** column name */
  responsible_user_id = 'responsible_user_id',
  /** column name */
  street = 'street',
  /** column name */
  type_of_use_id = 'type_of_use_id',
  /** column name */
  units = 'units',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  year_constructed = 'year_constructed',
  /** column name */
  year_renovated = 'year_renovated',
}

/** select "energy_certificate_draft_aggregate_bool_exp_bool_and_arguments_columns" columns of table "energy_certificate_draft" */
export enum energy_certificate_draft_select_column_energy_certificate_draft_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
}

/** select "energy_certificate_draft_aggregate_bool_exp_bool_or_arguments_columns" columns of table "energy_certificate_draft" */
export enum energy_certificate_draft_select_column_energy_certificate_draft_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
}

/** input type for updating data in table "energy_certificate_draft" */
export type energy_certificate_draft_set_input = {
  area_gross?: InputMaybe<Scalars['numeric']['input']>;
  area_usable?: InputMaybe<Scalars['numeric']['input']>;
  building_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  building_state_id?: InputMaybe<building_state_enum>;
  city?: InputMaybe<Scalars['String']['input']>;
  class_of_use_id?: InputMaybe<class_of_use_enum>;
  co2_emissions?: InputMaybe<Scalars['numeric']['input']>;
  country_id?: InputMaybe<country_enum>;
  country_state_id?: InputMaybe<country_state_enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_external_identifier?: InputMaybe<Scalars['String']['input']>;
  draft_status_id?: InputMaybe<draft_status_enum>;
  economic_unit_id?: InputMaybe<Scalars['Int']['input']>;
  efficiency_class_id?: InputMaybe<efficiency_class_enum>;
  energy_certificate_type_id?: InputMaybe<energy_certificate_type_enum>;
  energy_final_consumption?: InputMaybe<Scalars['numeric']['input']>;
  energy_final_demand?: InputMaybe<Scalars['numeric']['input']>;
  energy_primary_consumption?: InputMaybe<Scalars['numeric']['input']>;
  energy_primary_demand?: InputMaybe<Scalars['numeric']['input']>;
  energy_rating_score?: InputMaybe<Scalars['numeric']['input']>;
  enev_year?: InputMaybe<Scalars['Int']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  floors?: InputMaybe<Scalars['numeric']['input']>;
  geg_reference_value?: InputMaybe<Scalars['numeric']['input']>;
  heritage_district?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  leasehold?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  mapbox_building_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  milieu_protection?: InputMaybe<Scalars['Boolean']['input']>;
  monument_protection?: InputMaybe<Scalars['Boolean']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  reference_value_electricity?: InputMaybe<Scalars['numeric']['input']>;
  reference_value_heating_hot_water?: InputMaybe<Scalars['numeric']['input']>;
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type_of_use_id?: InputMaybe<type_of_use_enum>;
  units?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<Scalars['Int']['input']>;
  year_renovated?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type energy_certificate_draft_stddev_fields = {
  area_gross?: Maybe<Scalars['Float']['output']>;
  area_usable?: Maybe<Scalars['Float']['output']>;
  co2_emissions?: Maybe<Scalars['Float']['output']>;
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  energy_certificate_file_id?: Maybe<Scalars['Float']['output']>;
  energy_final_consumption?: Maybe<Scalars['Float']['output']>;
  energy_final_demand?: Maybe<Scalars['Float']['output']>;
  energy_primary_consumption?: Maybe<Scalars['Float']['output']>;
  energy_primary_demand?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  enev_year?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
  year_renovated?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "energy_certificate_draft" */
export type energy_certificate_draft_stddev_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type energy_certificate_draft_stddev_pop_fields = {
  area_gross?: Maybe<Scalars['Float']['output']>;
  area_usable?: Maybe<Scalars['Float']['output']>;
  co2_emissions?: Maybe<Scalars['Float']['output']>;
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  energy_certificate_file_id?: Maybe<Scalars['Float']['output']>;
  energy_final_consumption?: Maybe<Scalars['Float']['output']>;
  energy_final_demand?: Maybe<Scalars['Float']['output']>;
  energy_primary_consumption?: Maybe<Scalars['Float']['output']>;
  energy_primary_demand?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  enev_year?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
  year_renovated?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "energy_certificate_draft" */
export type energy_certificate_draft_stddev_pop_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type energy_certificate_draft_stddev_samp_fields = {
  area_gross?: Maybe<Scalars['Float']['output']>;
  area_usable?: Maybe<Scalars['Float']['output']>;
  co2_emissions?: Maybe<Scalars['Float']['output']>;
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  energy_certificate_file_id?: Maybe<Scalars['Float']['output']>;
  energy_final_consumption?: Maybe<Scalars['Float']['output']>;
  energy_final_demand?: Maybe<Scalars['Float']['output']>;
  energy_primary_consumption?: Maybe<Scalars['Float']['output']>;
  energy_primary_demand?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  enev_year?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
  year_renovated?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "energy_certificate_draft" */
export type energy_certificate_draft_stddev_samp_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "energy_certificate_draft" */
export type energy_certificate_draft_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: energy_certificate_draft_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type energy_certificate_draft_stream_cursor_value_input = {
  area_gross?: InputMaybe<Scalars['numeric']['input']>;
  area_usable?: InputMaybe<Scalars['numeric']['input']>;
  building_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  building_state_id?: InputMaybe<building_state_enum>;
  city?: InputMaybe<Scalars['String']['input']>;
  class_of_use_id?: InputMaybe<class_of_use_enum>;
  co2_emissions?: InputMaybe<Scalars['numeric']['input']>;
  country_id?: InputMaybe<country_enum>;
  country_state_id?: InputMaybe<country_state_enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_external_identifier?: InputMaybe<Scalars['String']['input']>;
  draft_status_id?: InputMaybe<draft_status_enum>;
  economic_unit_id?: InputMaybe<Scalars['Int']['input']>;
  efficiency_class_id?: InputMaybe<efficiency_class_enum>;
  energy_certificate_file_id?: InputMaybe<Scalars['Int']['input']>;
  energy_certificate_type_id?: InputMaybe<energy_certificate_type_enum>;
  energy_final_consumption?: InputMaybe<Scalars['numeric']['input']>;
  energy_final_demand?: InputMaybe<Scalars['numeric']['input']>;
  energy_primary_consumption?: InputMaybe<Scalars['numeric']['input']>;
  energy_primary_demand?: InputMaybe<Scalars['numeric']['input']>;
  energy_rating_score?: InputMaybe<Scalars['numeric']['input']>;
  enev_year?: InputMaybe<Scalars['Int']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  floors?: InputMaybe<Scalars['numeric']['input']>;
  geg_reference_value?: InputMaybe<Scalars['numeric']['input']>;
  heritage_district?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  leasehold?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
  mapbox_building_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  milieu_protection?: InputMaybe<Scalars['Boolean']['input']>;
  monument_protection?: InputMaybe<Scalars['Boolean']['input']>;
  neighbor_citydb_gml_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  reference_value_electricity?: InputMaybe<Scalars['numeric']['input']>;
  reference_value_heating_hot_water?: InputMaybe<Scalars['numeric']['input']>;
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  type_of_use_id?: InputMaybe<type_of_use_enum>;
  units?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<Scalars['Int']['input']>;
  year_renovated?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type energy_certificate_draft_sum_fields = {
  area_gross?: Maybe<Scalars['numeric']['output']>;
  area_usable?: Maybe<Scalars['numeric']['output']>;
  co2_emissions?: Maybe<Scalars['numeric']['output']>;
  economic_unit_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_file_id?: Maybe<Scalars['Int']['output']>;
  energy_final_consumption?: Maybe<Scalars['numeric']['output']>;
  energy_final_demand?: Maybe<Scalars['numeric']['output']>;
  energy_primary_consumption?: Maybe<Scalars['numeric']['output']>;
  energy_primary_demand?: Maybe<Scalars['numeric']['output']>;
  energy_rating_score?: Maybe<Scalars['numeric']['output']>;
  enev_year?: Maybe<Scalars['Int']['output']>;
  floors?: Maybe<Scalars['numeric']['output']>;
  geg_reference_value?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
  reference_value_electricity?: Maybe<Scalars['numeric']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['numeric']['output']>;
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  units?: Maybe<Scalars['Int']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Int']['output']>;
  year_renovated?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "energy_certificate_draft" */
export type energy_certificate_draft_sum_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

export type energy_certificate_draft_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<energy_certificate_draft_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<energy_certificate_draft_set_input>;
  /** filter the rows which have to be updated */
  where: energy_certificate_draft_bool_exp;
};

/** aggregate var_pop on columns */
export type energy_certificate_draft_var_pop_fields = {
  area_gross?: Maybe<Scalars['Float']['output']>;
  area_usable?: Maybe<Scalars['Float']['output']>;
  co2_emissions?: Maybe<Scalars['Float']['output']>;
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  energy_certificate_file_id?: Maybe<Scalars['Float']['output']>;
  energy_final_consumption?: Maybe<Scalars['Float']['output']>;
  energy_final_demand?: Maybe<Scalars['Float']['output']>;
  energy_primary_consumption?: Maybe<Scalars['Float']['output']>;
  energy_primary_demand?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  enev_year?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
  year_renovated?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "energy_certificate_draft" */
export type energy_certificate_draft_var_pop_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type energy_certificate_draft_var_samp_fields = {
  area_gross?: Maybe<Scalars['Float']['output']>;
  area_usable?: Maybe<Scalars['Float']['output']>;
  co2_emissions?: Maybe<Scalars['Float']['output']>;
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  energy_certificate_file_id?: Maybe<Scalars['Float']['output']>;
  energy_final_consumption?: Maybe<Scalars['Float']['output']>;
  energy_final_demand?: Maybe<Scalars['Float']['output']>;
  energy_primary_consumption?: Maybe<Scalars['Float']['output']>;
  energy_primary_demand?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  enev_year?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
  year_renovated?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "energy_certificate_draft" */
export type energy_certificate_draft_var_samp_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type energy_certificate_draft_variance_fields = {
  area_gross?: Maybe<Scalars['Float']['output']>;
  area_usable?: Maybe<Scalars['Float']['output']>;
  co2_emissions?: Maybe<Scalars['Float']['output']>;
  economic_unit_id?: Maybe<Scalars['Float']['output']>;
  energy_certificate_file_id?: Maybe<Scalars['Float']['output']>;
  energy_final_consumption?: Maybe<Scalars['Float']['output']>;
  energy_final_demand?: Maybe<Scalars['Float']['output']>;
  energy_primary_consumption?: Maybe<Scalars['Float']['output']>;
  energy_primary_demand?: Maybe<Scalars['Float']['output']>;
  energy_rating_score?: Maybe<Scalars['Float']['output']>;
  enev_year?: Maybe<Scalars['Float']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  geg_reference_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  reference_value_electricity?: Maybe<Scalars['Float']['output']>;
  reference_value_heating_hot_water?: Maybe<Scalars['Float']['output']>;
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: Maybe<Scalars['Float']['output']>;
  year_renovated?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "energy_certificate_draft" */
export type energy_certificate_draft_variance_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  energy_certificate_file_id?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  floors?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  latitude?: InputMaybe<order_by>;
  longitude?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  units?: InputMaybe<order_by>;
  /** The year the building was constructed or is planned to be completed. A future year indicates planned new construction. */
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** order by max() on columns of table "energy_certificate" */
export type energy_certificate_max_order_by = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<order_by>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<order_by>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<order_by>;
  /** City of the building on the certificate. */
  city?: InputMaybe<order_by>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<order_by>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<order_by>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<order_by>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<order_by>;
  /** Date when the energy certificate expires. */
  expiry_date?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<order_by>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Postal code of the building on the certificate. */
  postal_code?: InputMaybe<order_by>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Processing state of the certificate (e.g., draft, verified). */
  state?: InputMaybe<order_by>;
  /** Street address of the building on the certificate. */
  street?: InputMaybe<order_by>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<order_by>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<order_by>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<order_by>;
};

/** order by min() on columns of table "energy_certificate" */
export type energy_certificate_min_order_by = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<order_by>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<order_by>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<order_by>;
  /** City of the building on the certificate. */
  city?: InputMaybe<order_by>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<order_by>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<order_by>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<order_by>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<order_by>;
  /** Date when the energy certificate expires. */
  expiry_date?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<order_by>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Postal code of the building on the certificate. */
  postal_code?: InputMaybe<order_by>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Processing state of the certificate (e.g., draft, verified). */
  state?: InputMaybe<order_by>;
  /** Street address of the building on the certificate. */
  street?: InputMaybe<order_by>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<order_by>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<order_by>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<order_by>;
};

/** response of any mutation on the table "energy_certificate" */
export type energy_certificate_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<energy_certificate>;
};

/** Ordering options when selecting data from "energy_certificate". */
export type energy_certificate_order_by = {
  area_gross?: InputMaybe<order_by>;
  area_usable?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  building_draft?: InputMaybe<building_draft_order_by>;
  building_draft_areas_aggregate?: InputMaybe<building_draft_area_aggregate_order_by>;
  building_draft_id?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  city?: InputMaybe<order_by>;
  co2_emissions?: InputMaybe<order_by>;
  country_id?: InputMaybe<order_by>;
  country_state_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  efficiency_class?: InputMaybe<order_by>;
  energy_certificate_consumers_aggregate?: InputMaybe<energy_certificate_consumer_aggregate_order_by>;
  energy_certificate_type?: InputMaybe<order_by>;
  energy_final_consumption?: InputMaybe<order_by>;
  energy_final_demand?: InputMaybe<order_by>;
  energy_primary_consumption?: InputMaybe<order_by>;
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  enev_year?: InputMaybe<order_by>;
  expiry_date?: InputMaybe<order_by>;
  file?: InputMaybe<file_order_by>;
  file_id?: InputMaybe<order_by>;
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  postal_code?: InputMaybe<order_by>;
  reference_value_electricity?: InputMaybe<order_by>;
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
  type_of_use_id?: InputMaybe<order_by>;
  units_commercial?: InputMaybe<order_by>;
  units_residential?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
  year_renovated?: InputMaybe<order_by>;
};

/** select columns of table "energy_certificate" */
export enum energy_certificate_select_column {
  /** column name */
  area_gross = 'area_gross',
  /** column name */
  area_usable = 'area_usable',
  /** column name */
  building_draft_id = 'building_draft_id',
  /** column name */
  building_id = 'building_id',
  /** column name */
  city = 'city',
  /** column name */
  co2_emissions = 'co2_emissions',
  /** column name */
  country_id = 'country_id',
  /** column name */
  country_state_id = 'country_state_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  efficiency_class = 'efficiency_class',
  /** column name */
  energy_certificate_type = 'energy_certificate_type',
  /** column name */
  energy_final_consumption = 'energy_final_consumption',
  /** column name */
  energy_final_demand = 'energy_final_demand',
  /** column name */
  energy_primary_consumption = 'energy_primary_consumption',
  /** column name */
  energy_primary_demand = 'energy_primary_demand',
  /** column name */
  energy_rating_score = 'energy_rating_score',
  /** column name */
  enev_year = 'enev_year',
  /** column name */
  expiry_date = 'expiry_date',
  /** column name */
  file_id = 'file_id',
  /** column name */
  geg_reference_value = 'geg_reference_value',
  /** column name */
  id = 'id',
  /** column name */
  org_id = 'org_id',
  /** column name */
  postal_code = 'postal_code',
  /** column name */
  reference_value_electricity = 'reference_value_electricity',
  /** column name */
  reference_value_heating_hot_water = 'reference_value_heating_hot_water',
  /** column name */
  state = 'state',
  /** column name */
  street = 'street',
  /** column name */
  type_of_use_id = 'type_of_use_id',
  /** column name */
  units_commercial = 'units_commercial',
  /** column name */
  units_residential = 'units_residential',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  year_constructed = 'year_constructed',
  /** column name */
  year_renovated = 'year_renovated',
}

/** order by stddev() on columns of table "energy_certificate" */
export type energy_certificate_stddev_order_by = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<order_by>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<order_by>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<order_by>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<order_by>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<order_by>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<order_by>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<order_by>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<order_by>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<order_by>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<order_by>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "energy_certificate" */
export type energy_certificate_stddev_pop_order_by = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<order_by>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<order_by>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<order_by>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<order_by>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<order_by>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<order_by>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<order_by>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<order_by>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<order_by>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<order_by>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "energy_certificate" */
export type energy_certificate_stddev_samp_order_by = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<order_by>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<order_by>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<order_by>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<order_by>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<order_by>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<order_by>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<order_by>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<order_by>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<order_by>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<order_by>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "energy_certificate" */
export type energy_certificate_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: energy_certificate_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type energy_certificate_stream_cursor_value_input = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<Scalars['numeric']['input']>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<Scalars['numeric']['input']>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<Scalars['Int']['input']>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** City of the building on the certificate. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<Scalars['numeric']['input']>;
  /** Country where the building is located. */
  country_id?: InputMaybe<country_enum>;
  /** Federal state/region where the building is located. */
  country_state_id?: InputMaybe<country_state_enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Energy efficiency class (e.g., A+, A, B, C through H). */
  efficiency_class?: InputMaybe<efficiency_class_enum>;
  /** DEMAND (Bedarfsausweis) or CONSUMPTION (Verbrauchsausweis) certificate type. */
  energy_certificate_type?: InputMaybe<energy_certificate_type_enum>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<Scalars['numeric']['input']>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<Scalars['numeric']['input']>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<Scalars['numeric']['input']>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<Scalars['numeric']['input']>;
  energy_rating_score?: InputMaybe<Scalars['numeric']['input']>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<Scalars['Int']['input']>;
  /** Date when the energy certificate expires. */
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Postal code of the building on the certificate. */
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<Scalars['numeric']['input']>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<Scalars['numeric']['input']>;
  /** Processing state of the certificate (e.g., draft, verified). */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Street address of the building on the certificate. */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Primary usage type of the building (e.g., residential, office). */
  type_of_use_id?: InputMaybe<type_of_use_enum>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<Scalars['Int']['input']>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<Scalars['Int']['input']>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "energy_certificate" */
export type energy_certificate_sum_order_by = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<order_by>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<order_by>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<order_by>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<order_by>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<order_by>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<order_by>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<order_by>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<order_by>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<order_by>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<order_by>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<order_by>;
};

export enum energy_certificate_type_enum {
  CONSUMPTION = 'CONSUMPTION',
  DEMAND = 'DEMAND',
}

/** Boolean expression to compare columns of type "energy_certificate_type_enum". All fields are combined with logical 'AND'. */
export type energy_certificate_type_enum_comparison_exp = {
  _eq?: InputMaybe<energy_certificate_type_enum>;
  _in?: InputMaybe<Array<energy_certificate_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<energy_certificate_type_enum>;
  _nin?: InputMaybe<Array<energy_certificate_type_enum>>;
};

/** order by var_pop() on columns of table "energy_certificate" */
export type energy_certificate_var_pop_order_by = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<order_by>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<order_by>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<order_by>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<order_by>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<order_by>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<order_by>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<order_by>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<order_by>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<order_by>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<order_by>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "energy_certificate" */
export type energy_certificate_var_samp_order_by = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<order_by>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<order_by>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<order_by>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<order_by>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<order_by>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<order_by>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<order_by>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<order_by>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<order_by>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<order_by>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "energy_certificate" */
export type energy_certificate_variance_order_by = {
  /** Gross floor area (Bruttogrundflaeche) in m2. */
  area_gross?: InputMaybe<order_by>;
  /** Usable area (Nutzflaeche) in m2 as stated on the certificate. */
  area_usable?: InputMaybe<order_by>;
  /** Associated building draft, if the certificate is part of an ongoing import. */
  building_draft_id?: InputMaybe<order_by>;
  /** The building this certificate belongs to. */
  building_id?: InputMaybe<order_by>;
  /** CO2 emissions in kg CO2/(m2.a) as stated on the certificate. */
  co2_emissions?: InputMaybe<order_by>;
  /** Final energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_final_consumption?: InputMaybe<order_by>;
  /** Final energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_final_demand?: InputMaybe<order_by>;
  /** Primary energy consumption in kWh/(m2.a) for consumption-based certificates. */
  energy_primary_consumption?: InputMaybe<order_by>;
  /** Primary energy demand in kWh/(m2.a) for demand-based certificates. */
  energy_primary_demand?: InputMaybe<order_by>;
  energy_rating_score?: InputMaybe<order_by>;
  /** EnEV/GEG standard version year the certificate was issued under. */
  enev_year?: InputMaybe<order_by>;
  /** Reference to the uploaded certificate document file. */
  file_id?: InputMaybe<order_by>;
  /** GEG (Gebaeudeenergiegesetz) reference value for energy performance comparison. */
  geg_reference_value?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Organization that owns this certificate. */
  org_id?: InputMaybe<order_by>;
  /** Reference value for electricity consumption in kWh/(m2.a). */
  reference_value_electricity?: InputMaybe<order_by>;
  /** Reference value for heating and hot water energy consumption in kWh/(m2.a). */
  reference_value_heating_hot_water?: InputMaybe<order_by>;
  /** Number of commercial units in the building. */
  units_commercial?: InputMaybe<order_by>;
  /** Number of residential units in the building. */
  units_residential?: InputMaybe<order_by>;
  /** Year the building was constructed. */
  year_constructed?: InputMaybe<order_by>;
  /** Year of the most recent major renovation. */
  year_renovated?: InputMaybe<order_by>;
};

/** An energy-consuming device that converts energy into useful output for building occupants (e.g., boilers, radiators, lighting fixtures, ventilation units). Efficiency is measured as Aufwandszahl. */
export type energy_consumer = {
  /** An object relationship */
  building_model: building_model;
  /** Reference to the building model this consumer belongs to. */
  building_model_id: Scalars['Int']['output'];
  /** Year this consumer was installed or last replaced. */
  construction_year?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: Maybe<Scalars['Float']['output']>;
  /** Specific technology used by this consumer (e.g., GAS_BOILER, HEAT_PUMP). */
  energy_consumer_technology_type_id?: Maybe<energy_consumer_technology_type_enum>;
  /** General category of energy consumption (HEATING, COOLING, LIGHTING, etc.). */
  energy_consumer_type_id: energy_consumer_type_enum;
  /** An array relationship */
  energy_system_consumer_routes: Array<energy_system_consumer_route>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  source_renovations?: Maybe<renovation_energy_consumer>;
  /** An array relationship */
  target_renovations: Array<renovation_energy_consumer>;
  updated_at: Scalars['timestamptz']['output'];
};

/** An energy-consuming device that converts energy into useful output for building occupants (e.g., boilers, radiators, lighting fixtures, ventilation units). Efficiency is measured as Aufwandszahl. */
export type energy_consumerenergy_system_consumer_routesArgs = {
  distinct_on?: InputMaybe<Array<energy_system_consumer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_consumer_route_order_by>>;
  where?: InputMaybe<energy_system_consumer_route_bool_exp>;
};

/** An energy-consuming device that converts energy into useful output for building occupants (e.g., boilers, radiators, lighting fixtures, ventilation units). Efficiency is measured as Aufwandszahl. */
export type energy_consumertarget_renovationsArgs = {
  distinct_on?: InputMaybe<Array<renovation_energy_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_energy_consumer_order_by>>;
  where?: InputMaybe<renovation_energy_consumer_bool_exp>;
};

/** order by aggregate values of table "energy_consumer" */
export type energy_consumer_aggregate_order_by = {
  avg?: InputMaybe<energy_consumer_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<energy_consumer_max_order_by>;
  min?: InputMaybe<energy_consumer_min_order_by>;
  stddev?: InputMaybe<energy_consumer_stddev_order_by>;
  stddev_pop?: InputMaybe<energy_consumer_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<energy_consumer_stddev_samp_order_by>;
  sum?: InputMaybe<energy_consumer_sum_order_by>;
  var_pop?: InputMaybe<energy_consumer_var_pop_order_by>;
  var_samp?: InputMaybe<energy_consumer_var_samp_order_by>;
  variance?: InputMaybe<energy_consumer_variance_order_by>;
};

/** order by avg() on columns of table "energy_consumer" */
export type energy_consumer_avg_order_by = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "energy_consumer". All fields are combined with a logical 'AND'. */
export type energy_consumer_bool_exp = {
  _and?: InputMaybe<Array<energy_consumer_bool_exp>>;
  _not?: InputMaybe<energy_consumer_bool_exp>;
  _or?: InputMaybe<Array<energy_consumer_bool_exp>>;
  building_model?: InputMaybe<building_model_bool_exp>;
  building_model_id?: InputMaybe<Int_comparison_exp>;
  construction_year?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  efficiency?: InputMaybe<Float_comparison_exp>;
  energy_consumer_technology_type_id?: InputMaybe<energy_consumer_technology_type_enum_comparison_exp>;
  energy_consumer_type_id?: InputMaybe<energy_consumer_type_enum_comparison_exp>;
  energy_system_consumer_routes?: InputMaybe<energy_system_consumer_route_bool_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  source_renovations?: InputMaybe<renovation_energy_consumer_bool_exp>;
  target_renovations?: InputMaybe<renovation_energy_consumer_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "energy_consumer" */
export type energy_consumer_max_order_by = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "energy_consumer" */
export type energy_consumer_min_order_by = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "energy_consumer". */
export type energy_consumer_order_by = {
  building_model?: InputMaybe<building_model_order_by>;
  building_model_id?: InputMaybe<order_by>;
  construction_year?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  efficiency?: InputMaybe<order_by>;
  energy_consumer_technology_type_id?: InputMaybe<order_by>;
  energy_consumer_type_id?: InputMaybe<order_by>;
  energy_system_consumer_routes_aggregate?: InputMaybe<energy_system_consumer_route_aggregate_order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  source_renovations?: InputMaybe<renovation_energy_consumer_order_by>;
  target_renovations_aggregate?: InputMaybe<renovation_energy_consumer_aggregate_order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "energy_consumer" */
export enum energy_consumer_select_column {
  /** column name */
  building_model_id = 'building_model_id',
  /** column name */
  construction_year = 'construction_year',
  /** column name */
  created_at = 'created_at',
  /** column name */
  efficiency = 'efficiency',
  /** column name */
  energy_consumer_technology_type_id = 'energy_consumer_technology_type_id',
  /** column name */
  energy_consumer_type_id = 'energy_consumer_type_id',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  updated_at = 'updated_at',
}

/** order by stddev() on columns of table "energy_consumer" */
export type energy_consumer_stddev_order_by = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "energy_consumer" */
export type energy_consumer_stddev_pop_order_by = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "energy_consumer" */
export type energy_consumer_stddev_samp_order_by = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "energy_consumer" */
export type energy_consumer_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: energy_consumer_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type energy_consumer_stream_cursor_value_input = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<Scalars['Int']['input']>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<Scalars['Float']['input']>;
  /** Specific technology used by this consumer (e.g., GAS_BOILER, HEAT_PUMP). */
  energy_consumer_technology_type_id?: InputMaybe<energy_consumer_technology_type_enum>;
  /** General category of energy consumption (HEATING, COOLING, LIGHTING, etc.). */
  energy_consumer_type_id?: InputMaybe<energy_consumer_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "energy_consumer" */
export type energy_consumer_sum_order_by = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

export enum energy_consumer_technology_type_enum {
  CENTRAL_AIR_CONDITIONING = 'CENTRAL_AIR_CONDITIONING',
  CENTRAL_ELECTRIC_STORAGE = 'CENTRAL_ELECTRIC_STORAGE',
  CENTRAL_EXHAUST = 'CENTRAL_EXHAUST',
  CENTRAL_SUPPLY_EXHAUST_WITHOUT_HRU = 'CENTRAL_SUPPLY_EXHAUST_WITHOUT_HRU',
  CENTRAL_SUPPLY_EXHAUST_WITH_HRU = 'CENTRAL_SUPPLY_EXHAUST_WITH_HRU',
  COAL_FURNACE = 'COAL_FURNACE',
  CONDENSING_BOILER = 'CONDENSING_BOILER',
  DECENTRAL_SINGLE_ROOM_VENTILATION_UNITS_WITHOUT_HRU = 'DECENTRAL_SINGLE_ROOM_VENTILATION_UNITS_WITHOUT_HRU',
  DECENTRAL_SINGLE_ROOM_VENTILATION_UNITS_WITH_HRU = 'DECENTRAL_SINGLE_ROOM_VENTILATION_UNITS_WITH_HRU',
  DIRECT_ELECTRICITY_HEATING = 'DIRECT_ELECTRICITY_HEATING',
  DISTRICT_HEATING_WITHOUT_KWK = 'DISTRICT_HEATING_WITHOUT_KWK',
  DISTRICT_HEATING_WITH_KWK = 'DISTRICT_HEATING_WITH_KWK',
  ELECTRICITY_MISCELLANEOUS = 'ELECTRICITY_MISCELLANEOUS',
  ELECTRIC_FLOW_HEATER = 'ELECTRIC_FLOW_HEATER',
  ELECTRIC_HEAT_PUMP_AIR = 'ELECTRIC_HEAT_PUMP_AIR',
  ELECTRIC_HEAT_PUMP_GEO = 'ELECTRIC_HEAT_PUMP_GEO',
  ELECTRIC_IMMERSION_HEATER = 'ELECTRIC_IMMERSION_HEATER',
  FLUORESCENT_LAMPS = 'FLUORESCENT_LAMPS',
  GAS_CONDENSING_BOILER = 'GAS_CONDENSING_BOILER',
  GAS_FLOOR_HEATING = 'GAS_FLOOR_HEATING',
  GAS_FLOW_HEATER = 'GAS_FLOW_HEATER',
  GAS_NON_CONDENSING_BOILER = 'GAS_NON_CONDENSING_BOILER',
  GAS_ROOM_HEATER = 'GAS_ROOM_HEATER',
  HALOGEN_LAMPS = 'HALOGEN_LAMPS',
  INCANDESCENT_LAMPS = 'INCANDESCENT_LAMPS',
  LED = 'LED',
  LOW_TEMPERATURE_BOILER = 'LOW_TEMPERATURE_BOILER',
  OIL_FURNACE = 'OIL_FURNACE',
  REVERSIBLE_AIR_WATER_HEAT_PUMP = 'REVERSIBLE_AIR_WATER_HEAT_PUMP',
  REVERSIBLE_BRINE_WATER_HEAT_PUMP = 'REVERSIBLE_BRINE_WATER_HEAT_PUMP',
  ROOM_AIR_CONDITIONING = 'ROOM_AIR_CONDITIONING',
  SMALL_ELECTRIC_STORAGE = 'SMALL_ELECTRIC_STORAGE',
  SOLAR_PLANT = 'SOLAR_PLANT',
  STANDARD_BOILER = 'STANDARD_BOILER',
  WOOD_BOILER = 'WOOD_BOILER',
  WOOD_FURNACE = 'WOOD_FURNACE',
}

/** Boolean expression to compare columns of type "energy_consumer_technology_type_enum". All fields are combined with logical 'AND'. */
export type energy_consumer_technology_type_enum_comparison_exp = {
  _eq?: InputMaybe<energy_consumer_technology_type_enum>;
  _in?: InputMaybe<Array<energy_consumer_technology_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<energy_consumer_technology_type_enum>;
  _nin?: InputMaybe<Array<energy_consumer_technology_type_enum>>;
};

export enum energy_consumer_type_enum {
  COOLING = 'COOLING',
  ELECTRICITY = 'ELECTRICITY',
  GENERAL = 'GENERAL',
  HEATING = 'HEATING',
  HOT_WATER = 'HOT_WATER',
  LIGHTING = 'LIGHTING',
  VENTILATION = 'VENTILATION',
}

/** Boolean expression to compare columns of type "energy_consumer_type_enum". All fields are combined with logical 'AND'. */
export type energy_consumer_type_enum_comparison_exp = {
  _eq?: InputMaybe<energy_consumer_type_enum>;
  _in?: InputMaybe<Array<energy_consumer_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<energy_consumer_type_enum>;
  _nin?: InputMaybe<Array<energy_consumer_type_enum>>;
};

/** order by var_pop() on columns of table "energy_consumer" */
export type energy_consumer_var_pop_order_by = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "energy_consumer" */
export type energy_consumer_var_samp_order_by = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "energy_consumer" */
export type energy_consumer_variance_order_by = {
  /** Reference to the building model this consumer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this consumer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the consumer. Values >= 1 where higher values indicate greater losses. Used as divisor: useful_output = energy_final / efficiency. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

export enum energy_consumption_type_enum {
  ENERGY = 'ENERGY',
  WASTE = 'WASTE',
  WATER = 'WATER',
}

/** The distribution infrastructure (pipes, ducts) that transports energy from producers to consumers within a building. */
export type energy_distribution = {
  /** Whether the hydraulic balancing included component-level adjustments (e.g., individual radiator valves). */
  balancing_with_components: Scalars['Boolean']['output'];
  /** An object relationship */
  building_model?: Maybe<building_model>;
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: Maybe<Scalars['Int']['output']>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: Maybe<Scalars['Int']['output']>;
  /** Type of distribution system (e.g., hot water pipes, air ducts). */
  energy_distribution_type_id: energy_distribution_type_enum;
  /** An array relationship */
  energy_system_consumer_routes: Array<energy_system_consumer_route>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss: Scalars['Float']['output'];
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  /** Indicates that hydraulic balancing has never been performed on this system. */
  last_balancing_set_to_never: Scalars['Boolean']['output'];
  /** Date when hydraulic balancing was last performed to optimize flow distribution. */
  last_hydraulic_balancing?: Maybe<Scalars['timestamptz']['output']>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: Maybe<Scalars['Float']['output']>;
};

/** The distribution infrastructure (pipes, ducts) that transports energy from producers to consumers within a building. */
export type energy_distributionenergy_system_consumer_routesArgs = {
  distinct_on?: InputMaybe<Array<energy_system_consumer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_consumer_route_order_by>>;
  where?: InputMaybe<energy_system_consumer_route_bool_exp>;
};

/** order by aggregate values of table "energy_distribution" */
export type energy_distribution_aggregate_order_by = {
  avg?: InputMaybe<energy_distribution_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<energy_distribution_max_order_by>;
  min?: InputMaybe<energy_distribution_min_order_by>;
  stddev?: InputMaybe<energy_distribution_stddev_order_by>;
  stddev_pop?: InputMaybe<energy_distribution_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<energy_distribution_stddev_samp_order_by>;
  sum?: InputMaybe<energy_distribution_sum_order_by>;
  var_pop?: InputMaybe<energy_distribution_var_pop_order_by>;
  var_samp?: InputMaybe<energy_distribution_var_samp_order_by>;
  variance?: InputMaybe<energy_distribution_variance_order_by>;
};

/** order by avg() on columns of table "energy_distribution" */
export type energy_distribution_avg_order_by = {
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<order_by>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "energy_distribution". All fields are combined with a logical 'AND'. */
export type energy_distribution_bool_exp = {
  _and?: InputMaybe<Array<energy_distribution_bool_exp>>;
  _not?: InputMaybe<energy_distribution_bool_exp>;
  _or?: InputMaybe<Array<energy_distribution_bool_exp>>;
  balancing_with_components?: InputMaybe<Boolean_comparison_exp>;
  building_model?: InputMaybe<building_model_bool_exp>;
  building_model_id?: InputMaybe<Int_comparison_exp>;
  construction_year?: InputMaybe<Int_comparison_exp>;
  energy_distribution_type_id?: InputMaybe<energy_distribution_type_enum_comparison_exp>;
  energy_system_consumer_routes?: InputMaybe<energy_system_consumer_route_bool_exp>;
  heat_distribution_loss?: InputMaybe<Float_comparison_exp>;
  heat_transfer_loss?: InputMaybe<Float_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  last_balancing_set_to_never?: InputMaybe<Boolean_comparison_exp>;
  last_hydraulic_balancing?: InputMaybe<timestamptz_comparison_exp>;
  recoverable_heat_loss?: InputMaybe<Float_comparison_exp>;
};

/** order by max() on columns of table "energy_distribution" */
export type energy_distribution_max_order_by = {
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<order_by>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Date when hydraulic balancing was last performed to optimize flow distribution. */
  last_hydraulic_balancing?: InputMaybe<order_by>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** order by min() on columns of table "energy_distribution" */
export type energy_distribution_min_order_by = {
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<order_by>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Date when hydraulic balancing was last performed to optimize flow distribution. */
  last_hydraulic_balancing?: InputMaybe<order_by>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "energy_distribution". */
export type energy_distribution_order_by = {
  balancing_with_components?: InputMaybe<order_by>;
  building_model?: InputMaybe<building_model_order_by>;
  building_model_id?: InputMaybe<order_by>;
  construction_year?: InputMaybe<order_by>;
  energy_distribution_type_id?: InputMaybe<order_by>;
  energy_system_consumer_routes_aggregate?: InputMaybe<energy_system_consumer_route_aggregate_order_by>;
  heat_distribution_loss?: InputMaybe<order_by>;
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  last_balancing_set_to_never?: InputMaybe<order_by>;
  last_hydraulic_balancing?: InputMaybe<order_by>;
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** select columns of table "energy_distribution" */
export enum energy_distribution_select_column {
  /** column name */
  balancing_with_components = 'balancing_with_components',
  /** column name */
  building_model_id = 'building_model_id',
  /** column name */
  construction_year = 'construction_year',
  /** column name */
  energy_distribution_type_id = 'energy_distribution_type_id',
  /** column name */
  heat_distribution_loss = 'heat_distribution_loss',
  /** column name */
  heat_transfer_loss = 'heat_transfer_loss',
  /** column name */
  id = 'id',
  /** column name */
  last_balancing_set_to_never = 'last_balancing_set_to_never',
  /** column name */
  last_hydraulic_balancing = 'last_hydraulic_balancing',
  /** column name */
  recoverable_heat_loss = 'recoverable_heat_loss',
}

/** order by stddev() on columns of table "energy_distribution" */
export type energy_distribution_stddev_order_by = {
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<order_by>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "energy_distribution" */
export type energy_distribution_stddev_pop_order_by = {
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<order_by>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "energy_distribution" */
export type energy_distribution_stddev_samp_order_by = {
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<order_by>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "energy_distribution" */
export type energy_distribution_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: energy_distribution_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type energy_distribution_stream_cursor_value_input = {
  /** Whether the hydraulic balancing included component-level adjustments (e.g., individual radiator valves). */
  balancing_with_components?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<Scalars['Int']['input']>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  /** Type of distribution system (e.g., hot water pipes, air ducts). */
  energy_distribution_type_id?: InputMaybe<energy_distribution_type_enum>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<Scalars['Float']['input']>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates that hydraulic balancing has never been performed on this system. */
  last_balancing_set_to_never?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date when hydraulic balancing was last performed to optimize flow distribution. */
  last_hydraulic_balancing?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<Scalars['Float']['input']>;
};

/** order by sum() on columns of table "energy_distribution" */
export type energy_distribution_sum_order_by = {
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<order_by>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

export enum energy_distribution_type_enum {
  AIR_DUCTS_INTERNAL = 'AIR_DUCTS_INTERNAL',
  CENTRAL_CIRCULATION_INSIDE = 'CENTRAL_CIRCULATION_INSIDE',
  CENTRAL_CIRCULATION_OUTSIDE = 'CENTRAL_CIRCULATION_OUTSIDE',
  CENTRAL_INSIDE = 'CENTRAL_INSIDE',
  CENTRAL_NO_CIRCULATION_INSIDE = 'CENTRAL_NO_CIRCULATION_INSIDE',
  CENTRAL_NO_CIRCULATION_OUTSIDE = 'CENTRAL_NO_CIRCULATION_OUTSIDE',
  CENTRAL_OUTSIDE = 'CENTRAL_OUTSIDE',
  DECENTRAL = 'DECENTRAL',
  FAN = 'FAN',
  THERMAL_COMPONENT_ACTIVATION = 'THERMAL_COMPONENT_ACTIVATION',
}

/** Boolean expression to compare columns of type "energy_distribution_type_enum". All fields are combined with logical 'AND'. */
export type energy_distribution_type_enum_comparison_exp = {
  _eq?: InputMaybe<energy_distribution_type_enum>;
  _in?: InputMaybe<Array<energy_distribution_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<energy_distribution_type_enum>;
  _nin?: InputMaybe<Array<energy_distribution_type_enum>>;
};

/** order by var_pop() on columns of table "energy_distribution" */
export type energy_distribution_var_pop_order_by = {
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<order_by>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "energy_distribution" */
export type energy_distribution_var_samp_order_by = {
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<order_by>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "energy_distribution" */
export type energy_distribution_variance_order_by = {
  /** Reference to the building model this distribution system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this distribution system was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Heat loss fraction in the distribution network (pipes/ducts). Dimensionless ratio, default 0. */
  heat_distribution_loss?: InputMaybe<order_by>;
  /** Heat loss fraction at the point of transfer to the consumer (e.g., at radiators). Dimensionless ratio, default 0. */
  heat_transfer_loss?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of distribution heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** An energy-producing device that generates or converts energy for building use (e.g., boilers, heat pumps, PV panels). */
export type energy_producer = {
  /** An object relationship */
  building_model: building_model;
  /** Reference to the building model this producer belongs to. */
  building_model_id: Scalars['Int']['output'];
  /** Year this producer was installed or last replaced. */
  construction_year?: Maybe<Scalars['Int']['output']>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: Maybe<Scalars['Float']['output']>;
  /** Primary energy source used by this producer (e.g., NATURAL_GAS, ELECTRICITY, DISTRICT_HEATING). */
  energy_source_type_id: energy_source_type_enum;
  /** An array relationship */
  energy_system_producer_routes: Array<energy_system_producer_route>;
  id: Scalars['Int']['output'];
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: Maybe<Scalars['Float']['output']>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: Maybe<Scalars['Float']['output']>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: Maybe<Scalars['Float']['output']>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: Maybe<Scalars['Float']['output']>;
};

/** An energy-producing device that generates or converts energy for building use (e.g., boilers, heat pumps, PV panels). */
export type energy_producerenergy_system_producer_routesArgs = {
  distinct_on?: InputMaybe<Array<energy_system_producer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_producer_route_order_by>>;
  where?: InputMaybe<energy_system_producer_route_bool_exp>;
};

/** order by aggregate values of table "energy_producer" */
export type energy_producer_aggregate_order_by = {
  avg?: InputMaybe<energy_producer_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<energy_producer_max_order_by>;
  min?: InputMaybe<energy_producer_min_order_by>;
  stddev?: InputMaybe<energy_producer_stddev_order_by>;
  stddev_pop?: InputMaybe<energy_producer_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<energy_producer_stddev_samp_order_by>;
  sum?: InputMaybe<energy_producer_sum_order_by>;
  var_pop?: InputMaybe<energy_producer_var_pop_order_by>;
  var_samp?: InputMaybe<energy_producer_var_samp_order_by>;
  variance?: InputMaybe<energy_producer_variance_order_by>;
};

/** order by avg() on columns of table "energy_producer" */
export type energy_producer_avg_order_by = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<order_by>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<order_by>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<order_by>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<order_by>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "energy_producer". All fields are combined with a logical 'AND'. */
export type energy_producer_bool_exp = {
  _and?: InputMaybe<Array<energy_producer_bool_exp>>;
  _not?: InputMaybe<energy_producer_bool_exp>;
  _or?: InputMaybe<Array<energy_producer_bool_exp>>;
  building_model?: InputMaybe<building_model_bool_exp>;
  building_model_id?: InputMaybe<Int_comparison_exp>;
  construction_year?: InputMaybe<Int_comparison_exp>;
  efficiency?: InputMaybe<Float_comparison_exp>;
  energy_source_type_id?: InputMaybe<energy_source_type_enum_comparison_exp>;
  energy_system_producer_routes?: InputMaybe<energy_system_producer_route_bool_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  module_angle?: InputMaybe<Float_comparison_exp>;
  module_peak_power?: InputMaybe<Float_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  nominal_power?: InputMaybe<Float_comparison_exp>;
  roof_area_ratio?: InputMaybe<Float_comparison_exp>;
  solar_active_area?: InputMaybe<Float_comparison_exp>;
};

/** order by max() on columns of table "energy_producer" */
export type energy_producer_max_order_by = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<order_by>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<order_by>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<order_by>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<order_by>;
};

/** order by min() on columns of table "energy_producer" */
export type energy_producer_min_order_by = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<order_by>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<order_by>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<order_by>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "energy_producer". */
export type energy_producer_order_by = {
  building_model?: InputMaybe<building_model_order_by>;
  building_model_id?: InputMaybe<order_by>;
  construction_year?: InputMaybe<order_by>;
  efficiency?: InputMaybe<order_by>;
  energy_source_type_id?: InputMaybe<order_by>;
  energy_system_producer_routes_aggregate?: InputMaybe<energy_system_producer_route_aggregate_order_by>;
  id?: InputMaybe<order_by>;
  module_angle?: InputMaybe<order_by>;
  module_peak_power?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  nominal_power?: InputMaybe<order_by>;
  roof_area_ratio?: InputMaybe<order_by>;
  solar_active_area?: InputMaybe<order_by>;
};

/** select columns of table "energy_producer" */
export enum energy_producer_select_column {
  /** column name */
  building_model_id = 'building_model_id',
  /** column name */
  construction_year = 'construction_year',
  /** column name */
  efficiency = 'efficiency',
  /** column name */
  energy_source_type_id = 'energy_source_type_id',
  /** column name */
  id = 'id',
  /** column name */
  module_angle = 'module_angle',
  /** column name */
  module_peak_power = 'module_peak_power',
  /** column name */
  name = 'name',
  /** column name */
  nominal_power = 'nominal_power',
  /** column name */
  roof_area_ratio = 'roof_area_ratio',
  /** column name */
  solar_active_area = 'solar_active_area',
}

/** order by stddev() on columns of table "energy_producer" */
export type energy_producer_stddev_order_by = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<order_by>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<order_by>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<order_by>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<order_by>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "energy_producer" */
export type energy_producer_stddev_pop_order_by = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<order_by>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<order_by>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<order_by>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<order_by>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "energy_producer" */
export type energy_producer_stddev_samp_order_by = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<order_by>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<order_by>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<order_by>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<order_by>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "energy_producer" */
export type energy_producer_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: energy_producer_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type energy_producer_stream_cursor_value_input = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<Scalars['Int']['input']>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<Scalars['Float']['input']>;
  /** Primary energy source used by this producer (e.g., NATURAL_GAS, ELECTRICITY, DISTRICT_HEATING). */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<Scalars['Float']['input']>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<Scalars['Float']['input']>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<Scalars['Float']['input']>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<Scalars['Float']['input']>;
};

/** order by sum() on columns of table "energy_producer" */
export type energy_producer_sum_order_by = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<order_by>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<order_by>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<order_by>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<order_by>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "energy_producer" */
export type energy_producer_var_pop_order_by = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<order_by>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<order_by>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<order_by>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<order_by>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "energy_producer" */
export type energy_producer_var_samp_order_by = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<order_by>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<order_by>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<order_by>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<order_by>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "energy_producer" */
export type energy_producer_variance_order_by = {
  /** Reference to the building model this producer belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this producer was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  /** Aufwandszahl (expenditure number) of the producer. Values >= 1 where higher values indicate greater losses. */
  efficiency?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of solar modules in degrees from horizontal. Only applicable to solar energy producers. */
  module_angle?: InputMaybe<order_by>;
  /** Peak power output per photovoltaic module in kWp. Only applicable to solar energy producers. */
  module_peak_power?: InputMaybe<order_by>;
  /** Rated maximum power output of the producer in kW. */
  nominal_power?: InputMaybe<order_by>;
  /** Fraction of available roof area used by this solar installation (0 to 1). */
  roof_area_ratio?: InputMaybe<order_by>;
  /** Total active collector area in m2 for solar thermal or PV systems. */
  solar_active_area?: InputMaybe<order_by>;
};

export enum energy_source_type_enum {
  BIO_GAS = 'BIO_GAS',
  COAL = 'COAL',
  DISTRICT_HEATING_CHP_FOSSIL_COAL = 'DISTRICT_HEATING_CHP_FOSSIL_COAL',
  DISTRICT_HEATING_CHP_FOSSIL_GAS = 'DISTRICT_HEATING_CHP_FOSSIL_GAS',
  DISTRICT_HEATING_CHP_RENEWABLE = 'DISTRICT_HEATING_CHP_RENEWABLE',
  DISTRICT_HEATING_PLANTS_FOSSIL_COAL = 'DISTRICT_HEATING_PLANTS_FOSSIL_COAL',
  DISTRICT_HEATING_PLANTS_FOSSIL_GAS = 'DISTRICT_HEATING_PLANTS_FOSSIL_GAS',
  DISTRICT_HEATING_PLANTS_RENEWABLE = 'DISTRICT_HEATING_PLANTS_RENEWABLE',
  ELECTRICITY_GREEN = 'ELECTRICITY_GREEN',
  ELECTRICITY_MIX = 'ELECTRICITY_MIX',
  FUEL_OIL = 'FUEL_OIL',
  LIGNITE = 'LIGNITE',
  LPG = 'LPG',
  NATURAL_GAS = 'NATURAL_GAS',
  SOLAR = 'SOLAR',
  UNSPECIFIED = 'UNSPECIFIED',
  WOOD = 'WOOD',
  WOODEN_PELLETS = 'WOODEN_PELLETS',
}

/** Boolean expression to compare columns of type "energy_source_type_enum". All fields are combined with logical 'AND'. */
export type energy_source_type_enum_comparison_exp = {
  _eq?: InputMaybe<energy_source_type_enum>;
  _in?: InputMaybe<Array<energy_source_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<energy_source_type_enum>;
  _nin?: InputMaybe<Array<energy_source_type_enum>>;
};

/** An energy storage device within the building (e.g., thermal hot water tanks, batteries). */
export type energy_storage = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  building_model?: Maybe<building_model>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: Maybe<Scalars['Int']['output']>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: Maybe<Scalars['Int']['output']>;
  /** Type of energy storage (e.g., thermal tank, battery). */
  energy_storage_type_id: energy_storage_type_enum;
  /** An array relationship */
  energy_system_consumer_routes: Array<energy_system_consumer_route>;
  id: Scalars['Int']['output'];
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: Maybe<Scalars['Float']['output']>;
};

/** An energy storage device within the building (e.g., thermal hot water tanks, batteries). */
export type energy_storageenergy_system_consumer_routesArgs = {
  distinct_on?: InputMaybe<Array<energy_system_consumer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_consumer_route_order_by>>;
  where?: InputMaybe<energy_system_consumer_route_bool_exp>;
};

/** order by aggregate values of table "energy_storage" */
export type energy_storage_aggregate_order_by = {
  avg?: InputMaybe<energy_storage_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<energy_storage_max_order_by>;
  min?: InputMaybe<energy_storage_min_order_by>;
  stddev?: InputMaybe<energy_storage_stddev_order_by>;
  stddev_pop?: InputMaybe<energy_storage_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<energy_storage_stddev_samp_order_by>;
  sum?: InputMaybe<energy_storage_sum_order_by>;
  var_pop?: InputMaybe<energy_storage_var_pop_order_by>;
  var_samp?: InputMaybe<energy_storage_var_samp_order_by>;
  variance?: InputMaybe<energy_storage_variance_order_by>;
};

/** order by avg() on columns of table "energy_storage" */
export type energy_storage_avg_order_by = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<order_by>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "energy_storage". All fields are combined with a logical 'AND'. */
export type energy_storage_bool_exp = {
  _and?: InputMaybe<Array<energy_storage_bool_exp>>;
  _not?: InputMaybe<energy_storage_bool_exp>;
  _or?: InputMaybe<Array<energy_storage_bool_exp>>;
  annual_heat_loss?: InputMaybe<Float_comparison_exp>;
  building_model?: InputMaybe<building_model_bool_exp>;
  building_model_id?: InputMaybe<Int_comparison_exp>;
  construction_year?: InputMaybe<Int_comparison_exp>;
  energy_storage_type_id?: InputMaybe<energy_storage_type_enum_comparison_exp>;
  energy_system_consumer_routes?: InputMaybe<energy_system_consumer_route_bool_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  recoverable_heat_loss?: InputMaybe<Float_comparison_exp>;
};

/** order by max() on columns of table "energy_storage" */
export type energy_storage_max_order_by = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<order_by>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** order by min() on columns of table "energy_storage" */
export type energy_storage_min_order_by = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<order_by>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "energy_storage". */
export type energy_storage_order_by = {
  annual_heat_loss?: InputMaybe<order_by>;
  building_model?: InputMaybe<building_model_order_by>;
  building_model_id?: InputMaybe<order_by>;
  construction_year?: InputMaybe<order_by>;
  energy_storage_type_id?: InputMaybe<order_by>;
  energy_system_consumer_routes_aggregate?: InputMaybe<energy_system_consumer_route_aggregate_order_by>;
  id?: InputMaybe<order_by>;
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** select columns of table "energy_storage" */
export enum energy_storage_select_column {
  /** column name */
  annual_heat_loss = 'annual_heat_loss',
  /** column name */
  building_model_id = 'building_model_id',
  /** column name */
  construction_year = 'construction_year',
  /** column name */
  energy_storage_type_id = 'energy_storage_type_id',
  /** column name */
  id = 'id',
  /** column name */
  recoverable_heat_loss = 'recoverable_heat_loss',
}

/** order by stddev() on columns of table "energy_storage" */
export type energy_storage_stddev_order_by = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<order_by>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "energy_storage" */
export type energy_storage_stddev_pop_order_by = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<order_by>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "energy_storage" */
export type energy_storage_stddev_samp_order_by = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<order_by>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "energy_storage" */
export type energy_storage_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: energy_storage_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type energy_storage_stream_cursor_value_input = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<Scalars['Float']['input']>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<Scalars['Int']['input']>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  /** Type of energy storage (e.g., thermal tank, battery). */
  energy_storage_type_id?: InputMaybe<energy_storage_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<Scalars['Float']['input']>;
};

/** order by sum() on columns of table "energy_storage" */
export type energy_storage_sum_order_by = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<order_by>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

export enum energy_storage_type_enum {
  BUFFER_STORAGE = 'BUFFER_STORAGE',
  BUFFER_STORAGE_ELECTRIC = 'BUFFER_STORAGE_ELECTRIC',
  CENTRAL_INSIDE = 'CENTRAL_INSIDE',
  CENTRAL_OUTSIDE = 'CENTRAL_OUTSIDE',
}

/** Boolean expression to compare columns of type "energy_storage_type_enum". All fields are combined with logical 'AND'. */
export type energy_storage_type_enum_comparison_exp = {
  _eq?: InputMaybe<energy_storage_type_enum>;
  _in?: InputMaybe<Array<energy_storage_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<energy_storage_type_enum>;
  _nin?: InputMaybe<Array<energy_storage_type_enum>>;
};

/** order by var_pop() on columns of table "energy_storage" */
export type energy_storage_var_pop_order_by = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<order_by>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "energy_storage" */
export type energy_storage_var_samp_order_by = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<order_by>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "energy_storage" */
export type energy_storage_variance_order_by = {
  /** Total heat lost from storage over a year in kWh/a due to standing losses. */
  annual_heat_loss?: InputMaybe<order_by>;
  /** Reference to the building model this storage belongs to. */
  building_model_id?: InputMaybe<order_by>;
  /** Year this storage device was installed or last replaced. */
  construction_year?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Fraction of storage heat loss that can be recovered to offset heating demand (0 to 1). */
  recoverable_heat_loss?: InputMaybe<order_by>;
};

export enum energy_supplier_value_type_enum {
  PROGRESSIVE = 'PROGRESSIVE',
  STATIC = 'STATIC',
}

/** Boolean expression to compare columns of type "energy_supplier_value_type_enum". All fields are combined with logical 'AND'. */
export type energy_supplier_value_type_enum_comparison_exp = {
  _eq?: InputMaybe<energy_supplier_value_type_enum>;
  _in?: InputMaybe<Array<energy_supplier_value_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<energy_supplier_value_type_enum>;
  _nin?: InputMaybe<Array<energy_supplier_value_type_enum>>;
};

/** A logical grouping that connects energy producers, consumers, distribution, and storage into a complete energy supply chain for a specific purpose (heating, cooling, etc.). */
export type energy_system = {
  /** An object relationship */
  building_model: building_model;
  /** Reference to the building model this energy system belongs to. */
  building_model_id: Scalars['Int']['output'];
  /** How this energy system data was obtained (e.g., manual entry, energy certificate, estimation). */
  data_source_type_id: data_source_type_enum;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  energy_system_consumer_routes: Array<energy_system_consumer_route>;
  /** An array relationship */
  energy_system_producer_routes: Array<energy_system_producer_route>;
  /** Purpose of this energy system (HEATING, COOLING, LIGHTING, VENTILATION, HOT_WATER). */
  energy_system_type_id: energy_system_type_enum;
  id: Scalars['Int']['output'];
  /** Stable UUID used to correlate this system across building model versions and imports. */
  secondary_id: Scalars['uuid']['output'];
};

/** A logical grouping that connects energy producers, consumers, distribution, and storage into a complete energy supply chain for a specific purpose (heating, cooling, etc.). */
export type energy_systemenergy_system_consumer_routesArgs = {
  distinct_on?: InputMaybe<Array<energy_system_consumer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_consumer_route_order_by>>;
  where?: InputMaybe<energy_system_consumer_route_bool_exp>;
};

/** A logical grouping that connects energy producers, consumers, distribution, and storage into a complete energy supply chain for a specific purpose (heating, cooling, etc.). */
export type energy_systemenergy_system_producer_routesArgs = {
  distinct_on?: InputMaybe<Array<energy_system_producer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_producer_route_order_by>>;
  where?: InputMaybe<energy_system_producer_route_bool_exp>;
};

/** order by aggregate values of table "energy_system" */
export type energy_system_aggregate_order_by = {
  avg?: InputMaybe<energy_system_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<energy_system_max_order_by>;
  min?: InputMaybe<energy_system_min_order_by>;
  stddev?: InputMaybe<energy_system_stddev_order_by>;
  stddev_pop?: InputMaybe<energy_system_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<energy_system_stddev_samp_order_by>;
  sum?: InputMaybe<energy_system_sum_order_by>;
  var_pop?: InputMaybe<energy_system_var_pop_order_by>;
  var_samp?: InputMaybe<energy_system_var_samp_order_by>;
  variance?: InputMaybe<energy_system_variance_order_by>;
};

/** order by avg() on columns of table "energy_system" */
export type energy_system_avg_order_by = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "energy_system". All fields are combined with a logical 'AND'. */
export type energy_system_bool_exp = {
  _and?: InputMaybe<Array<energy_system_bool_exp>>;
  _not?: InputMaybe<energy_system_bool_exp>;
  _or?: InputMaybe<Array<energy_system_bool_exp>>;
  building_model?: InputMaybe<building_model_bool_exp>;
  building_model_id?: InputMaybe<Int_comparison_exp>;
  data_source_type_id?: InputMaybe<data_source_type_enum_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  energy_system_consumer_routes?: InputMaybe<energy_system_consumer_route_bool_exp>;
  energy_system_producer_routes?: InputMaybe<energy_system_producer_route_bool_exp>;
  energy_system_type_id?: InputMaybe<energy_system_type_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  secondary_id?: InputMaybe<uuid_comparison_exp>;
};

/** A complete energy delivery path from an energy system through optional distribution and storage to a consumer, with computed energy values at each stage. */
export type energy_system_consumer_route = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  emission_certificate?: Maybe<emission_certificate>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  energy_consumer?: Maybe<energy_consumer>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  energy_distribution?: Maybe<energy_distribution>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: Maybe<Scalars['Int']['output']>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: Maybe<Scalars['Float']['output']>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final: Scalars['Float']['output'];
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: Maybe<Scalars['Float']['output']>;
  /** The energy source used in this route (e.g., NATURAL_GAS, ELECTRICITY). */
  energy_source_type_id: energy_source_type_enum;
  /** An object relationship */
  energy_storage?: Maybe<energy_storage>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  energy_system: energy_system;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  primary_energy_factor_emission_certificate?: Maybe<emission_certificate>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: Maybe<Scalars['Int']['output']>;
  /** Stable UUID used to correlate this route across building model versions and imports. */
  secondary_id: Scalars['uuid']['output'];
  /** Whether this route uses renewable energy sources for energy calculations. */
  use_renewable_energy: Scalars['Boolean']['output'];
};

/** order by aggregate values of table "energy_system_consumer_route" */
export type energy_system_consumer_route_aggregate_order_by = {
  avg?: InputMaybe<energy_system_consumer_route_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<energy_system_consumer_route_max_order_by>;
  min?: InputMaybe<energy_system_consumer_route_min_order_by>;
  stddev?: InputMaybe<energy_system_consumer_route_stddev_order_by>;
  stddev_pop?: InputMaybe<energy_system_consumer_route_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<energy_system_consumer_route_stddev_samp_order_by>;
  sum?: InputMaybe<energy_system_consumer_route_sum_order_by>;
  var_pop?: InputMaybe<energy_system_consumer_route_var_pop_order_by>;
  var_samp?: InputMaybe<energy_system_consumer_route_var_samp_order_by>;
  variance?: InputMaybe<energy_system_consumer_route_variance_order_by>;
};

/** order by avg() on columns of table "energy_system_consumer_route" */
export type energy_system_consumer_route_avg_order_by = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<order_by>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<order_by>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<order_by>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<order_by>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<order_by>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<order_by>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "energy_system_consumer_route". All fields are combined with a logical 'AND'. */
export type energy_system_consumer_route_bool_exp = {
  _and?: InputMaybe<Array<energy_system_consumer_route_bool_exp>>;
  _not?: InputMaybe<energy_system_consumer_route_bool_exp>;
  _or?: InputMaybe<Array<energy_system_consumer_route_bool_exp>>;
  area_id?: InputMaybe<Int_comparison_exp>;
  emission_certificate?: InputMaybe<emission_certificate_bool_exp>;
  emission_certificate_id?: InputMaybe<Int_comparison_exp>;
  energy_consumer?: InputMaybe<energy_consumer_bool_exp>;
  energy_consumer_id?: InputMaybe<Int_comparison_exp>;
  energy_distribution?: InputMaybe<energy_distribution_bool_exp>;
  energy_distribution_id?: InputMaybe<Int_comparison_exp>;
  energy_effective?: InputMaybe<Float_comparison_exp>;
  energy_final?: InputMaybe<Float_comparison_exp>;
  energy_primary?: InputMaybe<Float_comparison_exp>;
  energy_source_type_id?: InputMaybe<energy_source_type_enum_comparison_exp>;
  energy_storage?: InputMaybe<energy_storage_bool_exp>;
  energy_storage_id?: InputMaybe<Int_comparison_exp>;
  energy_system?: InputMaybe<energy_system_bool_exp>;
  energy_system_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  primary_energy_factor_emission_certificate?: InputMaybe<emission_certificate_bool_exp>;
  primary_energy_factor_emission_certificate_id?: InputMaybe<Int_comparison_exp>;
  secondary_id?: InputMaybe<uuid_comparison_exp>;
  use_renewable_energy?: InputMaybe<Boolean_comparison_exp>;
};

/** order by max() on columns of table "energy_system_consumer_route" */
export type energy_system_consumer_route_max_order_by = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<order_by>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<order_by>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<order_by>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<order_by>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<order_by>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<order_by>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
  /** Stable UUID used to correlate this route across building model versions and imports. */
  secondary_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "energy_system_consumer_route" */
export type energy_system_consumer_route_min_order_by = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<order_by>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<order_by>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<order_by>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<order_by>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<order_by>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<order_by>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
  /** Stable UUID used to correlate this route across building model versions and imports. */
  secondary_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "energy_system_consumer_route". */
export type energy_system_consumer_route_order_by = {
  area_id?: InputMaybe<order_by>;
  emission_certificate?: InputMaybe<emission_certificate_order_by>;
  emission_certificate_id?: InputMaybe<order_by>;
  energy_consumer?: InputMaybe<energy_consumer_order_by>;
  energy_consumer_id?: InputMaybe<order_by>;
  energy_distribution?: InputMaybe<energy_distribution_order_by>;
  energy_distribution_id?: InputMaybe<order_by>;
  energy_effective?: InputMaybe<order_by>;
  energy_final?: InputMaybe<order_by>;
  energy_primary?: InputMaybe<order_by>;
  energy_source_type_id?: InputMaybe<order_by>;
  energy_storage?: InputMaybe<energy_storage_order_by>;
  energy_storage_id?: InputMaybe<order_by>;
  energy_system?: InputMaybe<energy_system_order_by>;
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  primary_energy_factor_emission_certificate?: InputMaybe<emission_certificate_order_by>;
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
  secondary_id?: InputMaybe<order_by>;
  use_renewable_energy?: InputMaybe<order_by>;
};

/** select columns of table "energy_system_consumer_route" */
export enum energy_system_consumer_route_select_column {
  /** column name */
  area_id = 'area_id',
  /** column name */
  emission_certificate_id = 'emission_certificate_id',
  /** column name */
  energy_consumer_id = 'energy_consumer_id',
  /** column name */
  energy_distribution_id = 'energy_distribution_id',
  /** column name */
  energy_effective = 'energy_effective',
  /** column name */
  energy_final = 'energy_final',
  /** column name */
  energy_primary = 'energy_primary',
  /** column name */
  energy_source_type_id = 'energy_source_type_id',
  /** column name */
  energy_storage_id = 'energy_storage_id',
  /** column name */
  energy_system_id = 'energy_system_id',
  /** column name */
  id = 'id',
  /** column name */
  primary_energy_factor_emission_certificate_id = 'primary_energy_factor_emission_certificate_id',
  /** column name */
  secondary_id = 'secondary_id',
  /** column name */
  use_renewable_energy = 'use_renewable_energy',
}

/** order by stddev() on columns of table "energy_system_consumer_route" */
export type energy_system_consumer_route_stddev_order_by = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<order_by>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<order_by>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<order_by>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<order_by>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<order_by>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<order_by>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "energy_system_consumer_route" */
export type energy_system_consumer_route_stddev_pop_order_by = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<order_by>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<order_by>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<order_by>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<order_by>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<order_by>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<order_by>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "energy_system_consumer_route" */
export type energy_system_consumer_route_stddev_samp_order_by = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<order_by>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<order_by>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<order_by>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<order_by>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<order_by>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<order_by>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "energy_system_consumer_route" */
export type energy_system_consumer_route_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: energy_system_consumer_route_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type energy_system_consumer_route_stream_cursor_value_input = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<Scalars['Int']['input']>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<Scalars['Float']['input']>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<Scalars['Float']['input']>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<Scalars['Float']['input']>;
  /** The energy source used in this route (e.g., NATURAL_GAS, ELECTRICITY). */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<Scalars['Int']['input']>;
  /** Stable UUID used to correlate this route across building model versions and imports. */
  secondary_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Whether this route uses renewable energy sources for energy calculations. */
  use_renewable_energy?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "energy_system_consumer_route" */
export type energy_system_consumer_route_sum_order_by = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<order_by>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<order_by>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<order_by>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<order_by>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<order_by>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<order_by>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "energy_system_consumer_route" */
export type energy_system_consumer_route_var_pop_order_by = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<order_by>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<order_by>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<order_by>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<order_by>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<order_by>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<order_by>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "energy_system_consumer_route" */
export type energy_system_consumer_route_var_samp_order_by = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<order_by>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<order_by>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<order_by>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<order_by>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<order_by>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<order_by>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "energy_system_consumer_route" */
export type energy_system_consumer_route_variance_order_by = {
  /** Reference to a specific building area this route serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing custom emission factors for this route. */
  emission_certificate_id?: InputMaybe<order_by>;
  /** Reference to the consumer at the end of this delivery path. */
  energy_consumer_id?: InputMaybe<order_by>;
  /** Reference to the distribution system in this route, if any. */
  energy_distribution_id?: InputMaybe<order_by>;
  /** Effective (useful) energy delivered along this route in kWh/a. */
  energy_effective?: InputMaybe<order_by>;
  /** Final energy consumed along this route in kWh/a, the energy delivered at the building boundary. */
  energy_final?: InputMaybe<order_by>;
  /** Primary energy consumed along this route in kWh/a, including upstream extraction and delivery losses. */
  energy_primary?: InputMaybe<order_by>;
  /** Reference to the storage device in this route, if any. */
  energy_storage_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Reference to an emission certificate providing a custom primary energy factor for this route. */
  primary_energy_factor_emission_certificate_id?: InputMaybe<order_by>;
};

/** order by max() on columns of table "energy_system" */
export type energy_system_max_order_by = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Stable UUID used to correlate this system across building model versions and imports. */
  secondary_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "energy_system" */
export type energy_system_min_order_by = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Stable UUID used to correlate this system across building model versions and imports. */
  secondary_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "energy_system". */
export type energy_system_order_by = {
  building_model?: InputMaybe<building_model_order_by>;
  building_model_id?: InputMaybe<order_by>;
  data_source_type_id?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  energy_system_consumer_routes_aggregate?: InputMaybe<energy_system_consumer_route_aggregate_order_by>;
  energy_system_producer_routes_aggregate?: InputMaybe<energy_system_producer_route_aggregate_order_by>;
  energy_system_type_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  secondary_id?: InputMaybe<order_by>;
};

/** A link between an energy system and one of its energy producers, with computed production values. */
export type energy_system_producer_route = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: Maybe<Scalars['Int']['output']>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: Maybe<Scalars['Float']['output']>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced: Scalars['Float']['output'];
  /** An object relationship */
  energy_producer: energy_producer;
  /** Reference to the energy producer in this route. */
  energy_producer_id: Scalars['Int']['output'];
  /** The energy source consumed by this producer (e.g., NATURAL_GAS, ELECTRICITY). */
  energy_source_type_id: energy_source_type_enum;
  /** An object relationship */
  energy_system: energy_system;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

/** order by aggregate values of table "energy_system_producer_route" */
export type energy_system_producer_route_aggregate_order_by = {
  avg?: InputMaybe<energy_system_producer_route_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<energy_system_producer_route_max_order_by>;
  min?: InputMaybe<energy_system_producer_route_min_order_by>;
  stddev?: InputMaybe<energy_system_producer_route_stddev_order_by>;
  stddev_pop?: InputMaybe<energy_system_producer_route_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<energy_system_producer_route_stddev_samp_order_by>;
  sum?: InputMaybe<energy_system_producer_route_sum_order_by>;
  var_pop?: InputMaybe<energy_system_producer_route_var_pop_order_by>;
  var_samp?: InputMaybe<energy_system_producer_route_var_samp_order_by>;
  variance?: InputMaybe<energy_system_producer_route_variance_order_by>;
};

/** order by avg() on columns of table "energy_system_producer_route" */
export type energy_system_producer_route_avg_order_by = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<order_by>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "energy_system_producer_route". All fields are combined with a logical 'AND'. */
export type energy_system_producer_route_bool_exp = {
  _and?: InputMaybe<Array<energy_system_producer_route_bool_exp>>;
  _not?: InputMaybe<energy_system_producer_route_bool_exp>;
  _or?: InputMaybe<Array<energy_system_producer_route_bool_exp>>;
  area_id?: InputMaybe<Int_comparison_exp>;
  energy_effective?: InputMaybe<Float_comparison_exp>;
  energy_produced?: InputMaybe<Float_comparison_exp>;
  energy_producer?: InputMaybe<energy_producer_bool_exp>;
  energy_producer_id?: InputMaybe<Int_comparison_exp>;
  energy_source_type_id?: InputMaybe<energy_source_type_enum_comparison_exp>;
  energy_system?: InputMaybe<energy_system_bool_exp>;
  energy_system_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
};

/** order by max() on columns of table "energy_system_producer_route" */
export type energy_system_producer_route_max_order_by = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<order_by>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "energy_system_producer_route" */
export type energy_system_producer_route_min_order_by = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<order_by>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "energy_system_producer_route". */
export type energy_system_producer_route_order_by = {
  area_id?: InputMaybe<order_by>;
  energy_effective?: InputMaybe<order_by>;
  energy_produced?: InputMaybe<order_by>;
  energy_producer?: InputMaybe<energy_producer_order_by>;
  energy_producer_id?: InputMaybe<order_by>;
  energy_source_type_id?: InputMaybe<order_by>;
  energy_system?: InputMaybe<energy_system_order_by>;
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** select columns of table "energy_system_producer_route" */
export enum energy_system_producer_route_select_column {
  /** column name */
  area_id = 'area_id',
  /** column name */
  energy_effective = 'energy_effective',
  /** column name */
  energy_produced = 'energy_produced',
  /** column name */
  energy_producer_id = 'energy_producer_id',
  /** column name */
  energy_source_type_id = 'energy_source_type_id',
  /** column name */
  energy_system_id = 'energy_system_id',
  /** column name */
  id = 'id',
}

/** order by stddev() on columns of table "energy_system_producer_route" */
export type energy_system_producer_route_stddev_order_by = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<order_by>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "energy_system_producer_route" */
export type energy_system_producer_route_stddev_pop_order_by = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<order_by>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "energy_system_producer_route" */
export type energy_system_producer_route_stddev_samp_order_by = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<order_by>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "energy_system_producer_route" */
export type energy_system_producer_route_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: energy_system_producer_route_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type energy_system_producer_route_stream_cursor_value_input = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<Scalars['Int']['input']>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<Scalars['Float']['input']>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<Scalars['Float']['input']>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<Scalars['Int']['input']>;
  /** The energy source consumed by this producer (e.g., NATURAL_GAS, ELECTRICITY). */
  energy_source_type_id?: InputMaybe<energy_source_type_enum>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "energy_system_producer_route" */
export type energy_system_producer_route_sum_order_by = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<order_by>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "energy_system_producer_route" */
export type energy_system_producer_route_var_pop_order_by = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<order_by>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "energy_system_producer_route" */
export type energy_system_producer_route_var_samp_order_by = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<order_by>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "energy_system_producer_route" */
export type energy_system_producer_route_variance_order_by = {
  /** Reference to a specific building area this producer serves, if energy is allocated by zone. */
  area_id?: InputMaybe<order_by>;
  /** Effective (useful) energy output from this producer in kWh/a after accounting for losses. */
  energy_effective?: InputMaybe<order_by>;
  /** Total energy produced by this producer in kWh/a. */
  energy_produced?: InputMaybe<order_by>;
  /** Reference to the energy producer in this route. */
  energy_producer_id?: InputMaybe<order_by>;
  /** Reference to the parent energy system this producer route belongs to. */
  energy_system_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** select columns of table "energy_system" */
export enum energy_system_select_column {
  /** column name */
  building_model_id = 'building_model_id',
  /** column name */
  data_source_type_id = 'data_source_type_id',
  /** column name */
  description = 'description',
  /** column name */
  energy_system_type_id = 'energy_system_type_id',
  /** column name */
  id = 'id',
  /** column name */
  secondary_id = 'secondary_id',
}

/** order by stddev() on columns of table "energy_system" */
export type energy_system_stddev_order_by = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "energy_system" */
export type energy_system_stddev_pop_order_by = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "energy_system" */
export type energy_system_stddev_samp_order_by = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "energy_system" */
export type energy_system_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: energy_system_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type energy_system_stream_cursor_value_input = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<Scalars['Int']['input']>;
  /** How this energy system data was obtained (e.g., manual entry, energy certificate, estimation). */
  data_source_type_id?: InputMaybe<data_source_type_enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Purpose of this energy system (HEATING, COOLING, LIGHTING, VENTILATION, HOT_WATER). */
  energy_system_type_id?: InputMaybe<energy_system_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Stable UUID used to correlate this system across building model versions and imports. */
  secondary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "energy_system" */
export type energy_system_sum_order_by = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

export enum energy_system_type_enum {
  COOLING = 'COOLING',
  ELECTRICITY = 'ELECTRICITY',
  GENERAL = 'GENERAL',
  HEATING = 'HEATING',
  HOT_WATER = 'HOT_WATER',
  LIGHTING = 'LIGHTING',
  SOLAR = 'SOLAR',
  VENTILATION = 'VENTILATION',
}

/** Boolean expression to compare columns of type "energy_system_type_enum". All fields are combined with logical 'AND'. */
export type energy_system_type_enum_comparison_exp = {
  _eq?: InputMaybe<energy_system_type_enum>;
  _in?: InputMaybe<Array<energy_system_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<energy_system_type_enum>;
  _nin?: InputMaybe<Array<energy_system_type_enum>>;
};

/** order by var_pop() on columns of table "energy_system" */
export type energy_system_var_pop_order_by = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "energy_system" */
export type energy_system_var_samp_order_by = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "energy_system" */
export type energy_system_variance_order_by = {
  /** Reference to the building model this energy system belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
};

export enum entity_state_type_enum {
  /** the entitiy is accesible to the user */
  ACTIVE = 'ACTIVE',
  /** The entitiy is ignored by analysis and can not be updated by the user. An inactive entity can be re-activated. */
  INACTIVE = 'INACTIVE',
}

/** Boolean expression to compare columns of type "entity_state_type_enum". All fields are combined with logical 'AND'. */
export type entity_state_type_enum_comparison_exp = {
  _eq?: InputMaybe<entity_state_type_enum>;
  _in?: InputMaybe<Array<entity_state_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<entity_state_type_enum>;
  _nin?: InputMaybe<Array<entity_state_type_enum>>;
};

/** A physical component of the building envelope (wall, roof, window, floor) with its thermal and material properties. */
export type envelope = {
  /** Surface area of this envelope component in m2. */
  area: Scalars['Float']['output'];
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: Maybe<Scalars['Float']['output']>;
  /** Name of the base construction material before insulation (e.g., concrete, brick). */
  base_construction_material_name?: Maybe<Scalars['String']['output']>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  building_model: building_model;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id: Scalars['Int']['output'];
  /** How this envelope data was obtained (e.g., manual entry, energy certificate, estimation). */
  data_source_type_id: data_source_type_enum;
  description?: Maybe<Scalars['String']['output']>;
  /** Type of envelope component (WALL, ROOF, WINDOW, FLOOR, etc.). */
  envelope_type_id: envelope_type_enum;
  id: Scalars['Int']['output'];
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: Maybe<Scalars['Float']['output']>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: Maybe<Scalars['Float']['output']>;
  /** Category of insulation material applied (e.g., mineral wool, EPS, polyurethane). */
  insulation_material_category_id?: Maybe<insulation_material_category_enum>;
  /** Name of the insulation material applied to this component. */
  insulation_material_name?: Maybe<Scalars['String']['output']>;
  /** Method of insulation application (e.g., external wall insulation, cavity insulation). */
  insulation_method_id?: Maybe<insulation_method_enum>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: Maybe<Scalars['Float']['output']>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: Maybe<Scalars['Float']['output']>;
  /** Stable UUID used to correlate this component across building model versions and imports. */
  secondary_id: Scalars['uuid']['output'];
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: Maybe<Scalars['Float']['output']>;
};

/** order by aggregate values of table "envelope" */
export type envelope_aggregate_order_by = {
  avg?: InputMaybe<envelope_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<envelope_max_order_by>;
  min?: InputMaybe<envelope_min_order_by>;
  stddev?: InputMaybe<envelope_stddev_order_by>;
  stddev_pop?: InputMaybe<envelope_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<envelope_stddev_samp_order_by>;
  sum?: InputMaybe<envelope_sum_order_by>;
  var_pop?: InputMaybe<envelope_var_pop_order_by>;
  var_samp?: InputMaybe<envelope_var_samp_order_by>;
  variance?: InputMaybe<envelope_variance_order_by>;
};

/** order by avg() on columns of table "envelope" */
export type envelope_avg_order_by = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<order_by>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<order_by>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<order_by>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<order_by>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<order_by>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "envelope". All fields are combined with a logical 'AND'. */
export type envelope_bool_exp = {
  _and?: InputMaybe<Array<envelope_bool_exp>>;
  _not?: InputMaybe<envelope_bool_exp>;
  _or?: InputMaybe<Array<envelope_bool_exp>>;
  area?: InputMaybe<Float_comparison_exp>;
  base_construction_lambda?: InputMaybe<Float_comparison_exp>;
  base_construction_material_name?: InputMaybe<String_comparison_exp>;
  base_construction_thickness?: InputMaybe<Float_comparison_exp>;
  building_model?: InputMaybe<building_model_bool_exp>;
  building_model_id?: InputMaybe<Int_comparison_exp>;
  data_source_type_id?: InputMaybe<data_source_type_enum_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  envelope_type_id?: InputMaybe<envelope_type_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  inclination?: InputMaybe<Float_comparison_exp>;
  insulation_lambda?: InputMaybe<Float_comparison_exp>;
  insulation_material_category_id?: InputMaybe<insulation_material_category_enum_comparison_exp>;
  insulation_material_name?: InputMaybe<String_comparison_exp>;
  insulation_method_id?: InputMaybe<insulation_method_enum_comparison_exp>;
  insulation_thickness?: InputMaybe<Float_comparison_exp>;
  orientation?: InputMaybe<Float_comparison_exp>;
  secondary_id?: InputMaybe<uuid_comparison_exp>;
  u_value?: InputMaybe<Float_comparison_exp>;
};

/** order by max() on columns of table "envelope" */
export type envelope_max_order_by = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<order_by>;
  /** Name of the base construction material before insulation (e.g., concrete, brick). */
  base_construction_material_name?: InputMaybe<order_by>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<order_by>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<order_by>;
  /** Name of the insulation material applied to this component. */
  insulation_material_name?: InputMaybe<order_by>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<order_by>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<order_by>;
  /** Stable UUID used to correlate this component across building model versions and imports. */
  secondary_id?: InputMaybe<order_by>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<order_by>;
};

/** order by min() on columns of table "envelope" */
export type envelope_min_order_by = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<order_by>;
  /** Name of the base construction material before insulation (e.g., concrete, brick). */
  base_construction_material_name?: InputMaybe<order_by>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<order_by>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<order_by>;
  /** Name of the insulation material applied to this component. */
  insulation_material_name?: InputMaybe<order_by>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<order_by>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<order_by>;
  /** Stable UUID used to correlate this component across building model versions and imports. */
  secondary_id?: InputMaybe<order_by>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "envelope". */
export type envelope_order_by = {
  area?: InputMaybe<order_by>;
  base_construction_lambda?: InputMaybe<order_by>;
  base_construction_material_name?: InputMaybe<order_by>;
  base_construction_thickness?: InputMaybe<order_by>;
  building_model?: InputMaybe<building_model_order_by>;
  building_model_id?: InputMaybe<order_by>;
  data_source_type_id?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  envelope_type_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  inclination?: InputMaybe<order_by>;
  insulation_lambda?: InputMaybe<order_by>;
  insulation_material_category_id?: InputMaybe<order_by>;
  insulation_material_name?: InputMaybe<order_by>;
  insulation_method_id?: InputMaybe<order_by>;
  insulation_thickness?: InputMaybe<order_by>;
  orientation?: InputMaybe<order_by>;
  secondary_id?: InputMaybe<order_by>;
  u_value?: InputMaybe<order_by>;
};

/** select columns of table "envelope" */
export enum envelope_select_column {
  /** column name */
  area = 'area',
  /** column name */
  base_construction_lambda = 'base_construction_lambda',
  /** column name */
  base_construction_material_name = 'base_construction_material_name',
  /** column name */
  base_construction_thickness = 'base_construction_thickness',
  /** column name */
  building_model_id = 'building_model_id',
  /** column name */
  data_source_type_id = 'data_source_type_id',
  /** column name */
  description = 'description',
  /** column name */
  envelope_type_id = 'envelope_type_id',
  /** column name */
  id = 'id',
  /** column name */
  inclination = 'inclination',
  /** column name */
  insulation_lambda = 'insulation_lambda',
  /** column name */
  insulation_material_category_id = 'insulation_material_category_id',
  /** column name */
  insulation_material_name = 'insulation_material_name',
  /** column name */
  insulation_method_id = 'insulation_method_id',
  /** column name */
  insulation_thickness = 'insulation_thickness',
  /** column name */
  orientation = 'orientation',
  /** column name */
  secondary_id = 'secondary_id',
  /** column name */
  u_value = 'u_value',
}

/** order by stddev() on columns of table "envelope" */
export type envelope_stddev_order_by = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<order_by>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<order_by>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<order_by>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<order_by>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<order_by>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "envelope" */
export type envelope_stddev_pop_order_by = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<order_by>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<order_by>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<order_by>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<order_by>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<order_by>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "envelope" */
export type envelope_stddev_samp_order_by = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<order_by>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<order_by>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<order_by>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<order_by>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<order_by>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "envelope" */
export type envelope_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: envelope_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type envelope_stream_cursor_value_input = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<Scalars['Float']['input']>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the base construction material before insulation (e.g., concrete, brick). */
  base_construction_material_name?: InputMaybe<Scalars['String']['input']>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<Scalars['Float']['input']>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<Scalars['Int']['input']>;
  /** How this envelope data was obtained (e.g., manual entry, energy certificate, estimation). */
  data_source_type_id?: InputMaybe<data_source_type_enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Type of envelope component (WALL, ROOF, WINDOW, FLOOR, etc.). */
  envelope_type_id?: InputMaybe<envelope_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<Scalars['Float']['input']>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<Scalars['Float']['input']>;
  /** Category of insulation material applied (e.g., mineral wool, EPS, polyurethane). */
  insulation_material_category_id?: InputMaybe<insulation_material_category_enum>;
  /** Name of the insulation material applied to this component. */
  insulation_material_name?: InputMaybe<Scalars['String']['input']>;
  /** Method of insulation application (e.g., external wall insulation, cavity insulation). */
  insulation_method_id?: InputMaybe<insulation_method_enum>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<Scalars['Float']['input']>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<Scalars['Float']['input']>;
  /** Stable UUID used to correlate this component across building model versions and imports. */
  secondary_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<Scalars['Float']['input']>;
};

/** order by sum() on columns of table "envelope" */
export type envelope_sum_order_by = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<order_by>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<order_by>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<order_by>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<order_by>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<order_by>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<order_by>;
};

export enum envelope_type_enum {
  BASEMENT_CEILING = 'BASEMENT_CEILING',
  DOOR = 'DOOR',
  FLAT_ROOF = 'FLAT_ROOF',
  FLOOR = 'FLOOR',
  PITCHED_ROOF = 'PITCHED_ROOF',
  TOP_FLOOR_CEILING = 'TOP_FLOOR_CEILING',
  WALL = 'WALL',
  WINDOW = 'WINDOW',
}

/** Boolean expression to compare columns of type "envelope_type_enum". All fields are combined with logical 'AND'. */
export type envelope_type_enum_comparison_exp = {
  _eq?: InputMaybe<envelope_type_enum>;
  _in?: InputMaybe<Array<envelope_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<envelope_type_enum>;
  _nin?: InputMaybe<Array<envelope_type_enum>>;
};

/** order by var_pop() on columns of table "envelope" */
export type envelope_var_pop_order_by = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<order_by>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<order_by>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<order_by>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<order_by>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<order_by>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "envelope" */
export type envelope_var_samp_order_by = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<order_by>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<order_by>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<order_by>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<order_by>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<order_by>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "envelope" */
export type envelope_variance_order_by = {
  /** Surface area of this envelope component in m2. */
  area?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the base construction material in W/(mK). */
  base_construction_lambda?: InputMaybe<order_by>;
  /** Thickness of the base construction layer in meters. */
  base_construction_thickness?: InputMaybe<order_by>;
  /** Reference to the building model this envelope component belongs to. */
  building_model_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Tilt angle of the component in degrees from horizontal (0degrees  = horizontal, 90degrees  = vertical). */
  inclination?: InputMaybe<order_by>;
  /** Thermal conductivity (lambda) of the insulation material in W/(mK). */
  insulation_lambda?: InputMaybe<order_by>;
  /** Thickness of the insulation layer in meters. */
  insulation_thickness?: InputMaybe<order_by>;
  /** Compass orientation of the component in degrees, relevant for solar gain calculations. */
  orientation?: InputMaybe<order_by>;
  /** Thermal transmittance (U-value) in W/(m2K), measuring how much heat passes through this component. Lower values indicate better insulation. */
  u_value?: InputMaybe<order_by>;
};

export enum eu_taxonomy_compliance_enum {
  COMPLIANT = 'COMPLIANT',
  MEETS_DNSH_CRITERIA = 'MEETS_DNSH_CRITERIA',
  NON_COMPLIANT = 'NON_COMPLIANT',
  UNKNOWN = 'UNKNOWN',
}

export enum eu_taxonomy_datasource_enum {
  DEFAULT_INDEX = 'DEFAULT_INDEX',
  DREES_UND_SOMMER = 'DREES_UND_SOMMER',
}

/** Organization-specific template for generating Excel or PDF exports with custom formatting. */
export type export_template = {
  /** Type of export this template produces. */
  export_type_id: export_template_type_enum;
  id: Scalars['Int']['output'];
  /** Display name of the export template. */
  name: Scalars['String']['output'];
  /** An object relationship */
  org?: Maybe<org>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "export_template" */
export type export_template_aggregate = {
  aggregate?: Maybe<export_template_aggregate_fields>;
  nodes: Array<export_template>;
};

/** aggregate fields of "export_template" */
export type export_template_aggregate_fields = {
  avg?: Maybe<export_template_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<export_template_max_fields>;
  min?: Maybe<export_template_min_fields>;
  stddev?: Maybe<export_template_stddev_fields>;
  stddev_pop?: Maybe<export_template_stddev_pop_fields>;
  stddev_samp?: Maybe<export_template_stddev_samp_fields>;
  sum?: Maybe<export_template_sum_fields>;
  var_pop?: Maybe<export_template_var_pop_fields>;
  var_samp?: Maybe<export_template_var_samp_fields>;
  variance?: Maybe<export_template_variance_fields>;
};

/** aggregate fields of "export_template" */
export type export_template_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<export_template_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type export_template_avg_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "export_template". All fields are combined with a logical 'AND'. */
export type export_template_bool_exp = {
  _and?: InputMaybe<Array<export_template_bool_exp>>;
  _not?: InputMaybe<export_template_bool_exp>;
  _or?: InputMaybe<Array<export_template_bool_exp>>;
  export_type_id?: InputMaybe<export_template_type_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
};

/** aggregate max on columns */
export type export_template_max_fields = {
  id?: Maybe<Scalars['Int']['output']>;
  /** Display name of the export template. */
  name?: Maybe<Scalars['String']['output']>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type export_template_min_fields = {
  id?: Maybe<Scalars['Int']['output']>;
  /** Display name of the export template. */
  name?: Maybe<Scalars['String']['output']>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "export_template". */
export type export_template_order_by = {
  export_type_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
};

/** select columns of table "export_template" */
export enum export_template_select_column {
  /** column name */
  export_type_id = 'export_type_id',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  org_id = 'org_id',
}

/** aggregate stddev on columns */
export type export_template_stddev_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type export_template_stddev_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type export_template_stddev_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "export_template" */
export type export_template_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: export_template_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type export_template_stream_cursor_value_input = {
  /** Type of export this template produces. */
  export_type_id?: InputMaybe<export_template_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Display name of the export template. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Organization that owns this template. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type export_template_sum_fields = {
  id?: Maybe<Scalars['Int']['output']>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Int']['output']>;
};

export enum export_template_type_enum {
  CUSTOM_EXPORT = 'CUSTOM_EXPORT',
  STANDARD_EXPORT = 'STANDARD_EXPORT',
}

/** Boolean expression to compare columns of type "export_template_type_enum". All fields are combined with logical 'AND'. */
export type export_template_type_enum_comparison_exp = {
  _eq?: InputMaybe<export_template_type_enum>;
  _in?: InputMaybe<Array<export_template_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<export_template_type_enum>;
  _nin?: InputMaybe<Array<export_template_type_enum>>;
};

/** aggregate var_pop on columns */
export type export_template_var_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type export_template_var_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type export_template_variance_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Organization that owns this template. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type file = {
  /** An array relationship */
  areas: Array<area>;
  /** An aggregate relationship */
  areas_aggregate: area_aggregate;
  /** An array relationship */
  cbi_exports: Array<cbi_export>;
  /** An aggregate relationship */
  cbi_exports_aggregate: cbi_export_aggregate;
  /** An array relationship */
  cbi_invoices: Array<cbi_invoice>;
  /** An aggregate relationship */
  cbi_invoices_aggregate: cbi_invoice_aggregate;
  /** An array relationship */
  certificates: Array<certificate>;
  /** An aggregate relationship */
  certificates_aggregate: certificate_aggregate;
  /** An object relationship */
  climate_risk_v2?: Maybe<climate_risk_v2>;
  /** An array relationship */
  consumption_drafts: Array<consumption_draft>;
  /** An aggregate relationship */
  consumption_drafts_aggregate: consumption_draft_aggregate;
  /** An array relationship */
  consumption_invoice_drafts: Array<consumption_invoice_draft>;
  /** An array relationship */
  consumption_invoices: Array<consumption_invoice>;
  /** An array relationship */
  consumptions: Array<consumption>;
  /** An aggregate relationship */
  consumptions_aggregate: consumption_aggregate;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl: Scalars['String']['output'];
  /** An array relationship */
  emission_certificate_drafts: Array<emission_certificate_draft>;
  /** An array relationship */
  emission_certificates: Array<emission_certificate>;
  /** An aggregate relationship */
  emission_certificates_aggregate: emission_certificate_aggregate;
  /** An array relationship */
  energy_certificate_drafts: Array<energy_certificate_draft>;
  /** An aggregate relationship */
  energy_certificate_drafts_aggregate: energy_certificate_draft_aggregate;
  /** An array relationship */
  energy_certificates: Array<energy_certificate>;
  /** An array relationship */
  file_chunk_links: Array<file_chunk_file_link>;
  /** What kind of document this is. Set by FileService on write; never inferred from relations or the filename. */
  file_type_id: file_type_enum;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  org?: Maybe<org>;
  /** An array relationship */
  report_evidences: Array<report_evidence>;
  /** An array relationship */
  report_export: Array<report>;
  /** An aggregate relationship */
  report_export_aggregate: report_aggregate;
  /** The S3 object key used to retrieve this file from AWS S3. */
  s3_key: Scalars['uuid']['output'];
  /** Whether the file is currently being uploaded. Used to prevent access to incomplete uploads. */
  uploading: Scalars['Boolean']['output'];
  /** An object relationship */
  user?: Maybe<user>;
  /** The user who uploaded this file. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileareasArgs = {
  distinct_on?: InputMaybe<Array<area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<area_order_by>>;
  where?: InputMaybe<area_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileareas_aggregateArgs = {
  distinct_on?: InputMaybe<Array<area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<area_order_by>>;
  where?: InputMaybe<area_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type filecbi_exportsArgs = {
  distinct_on?: InputMaybe<Array<cbi_export_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_export_order_by>>;
  where?: InputMaybe<cbi_export_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type filecbi_exports_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_export_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_export_order_by>>;
  where?: InputMaybe<cbi_export_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type filecbi_invoicesArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_order_by>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type filecbi_invoices_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_order_by>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type filecertificatesArgs = {
  distinct_on?: InputMaybe<Array<certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<certificate_order_by>>;
  where?: InputMaybe<certificate_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type filecertificates_aggregateArgs = {
  distinct_on?: InputMaybe<Array<certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<certificate_order_by>>;
  where?: InputMaybe<certificate_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileconsumption_draftsArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_order_by>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileconsumption_drafts_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_order_by>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileconsumption_invoice_draftsArgs = {
  distinct_on?: InputMaybe<Array<consumption_invoice_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_invoice_draft_order_by>>;
  where?: InputMaybe<consumption_invoice_draft_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileconsumption_invoicesArgs = {
  distinct_on?: InputMaybe<Array<consumption_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_invoice_order_by>>;
  where?: InputMaybe<consumption_invoice_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileconsumptionsArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileconsumptions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileemission_certificate_draftsArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_draft_order_by>>;
  where?: InputMaybe<emission_certificate_draft_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileemission_certificatesArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_order_by>>;
  where?: InputMaybe<emission_certificate_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileemission_certificates_aggregateArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_order_by>>;
  where?: InputMaybe<emission_certificate_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileenergy_certificate_draftsArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_draft_order_by>>;
  where?: InputMaybe<energy_certificate_draft_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileenergy_certificate_drafts_aggregateArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_draft_order_by>>;
  where?: InputMaybe<energy_certificate_draft_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type fileenergy_certificatesArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_order_by>>;
  where?: InputMaybe<energy_certificate_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type filefile_chunk_linksArgs = {
  distinct_on?: InputMaybe<Array<file_chunk_file_link_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<file_chunk_file_link_order_by>>;
  where?: InputMaybe<file_chunk_file_link_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type filereport_evidencesArgs = {
  distinct_on?: InputMaybe<Array<report_evidence_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_evidence_order_by>>;
  where?: InputMaybe<report_evidence_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type filereport_exportArgs = {
  distinct_on?: InputMaybe<Array<report_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_order_by>>;
  where?: InputMaybe<report_bool_exp>;
};

/** Metadata for a file uploaded to S3, such as documents, logos, or reports. */
export type filereport_export_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_order_by>>;
  where?: InputMaybe<report_bool_exp>;
};

/** Boolean expression to filter rows from the table "file". All fields are combined with a logical 'AND'. */
export type file_bool_exp = {
  _and?: InputMaybe<Array<file_bool_exp>>;
  _not?: InputMaybe<file_bool_exp>;
  _or?: InputMaybe<Array<file_bool_exp>>;
  areas?: InputMaybe<area_bool_exp>;
  areas_aggregate?: InputMaybe<area_aggregate_bool_exp>;
  cbi_exports?: InputMaybe<cbi_export_bool_exp>;
  cbi_exports_aggregate?: InputMaybe<cbi_export_aggregate_bool_exp>;
  cbi_invoices?: InputMaybe<cbi_invoice_bool_exp>;
  cbi_invoices_aggregate?: InputMaybe<cbi_invoice_aggregate_bool_exp>;
  certificates?: InputMaybe<certificate_bool_exp>;
  certificates_aggregate?: InputMaybe<certificate_aggregate_bool_exp>;
  climate_risk_v2?: InputMaybe<climate_risk_v2_bool_exp>;
  consumption_drafts?: InputMaybe<consumption_draft_bool_exp>;
  consumption_drafts_aggregate?: InputMaybe<consumption_draft_aggregate_bool_exp>;
  consumption_invoice_drafts?: InputMaybe<consumption_invoice_draft_bool_exp>;
  consumption_invoices?: InputMaybe<consumption_invoice_bool_exp>;
  consumptions?: InputMaybe<consumption_bool_exp>;
  consumptions_aggregate?: InputMaybe<consumption_aggregate_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  emission_certificate_drafts?: InputMaybe<emission_certificate_draft_bool_exp>;
  emission_certificates?: InputMaybe<emission_certificate_bool_exp>;
  emission_certificates_aggregate?: InputMaybe<emission_certificate_aggregate_bool_exp>;
  energy_certificate_drafts?: InputMaybe<energy_certificate_draft_bool_exp>;
  energy_certificate_drafts_aggregate?: InputMaybe<energy_certificate_draft_aggregate_bool_exp>;
  energy_certificates?: InputMaybe<energy_certificate_bool_exp>;
  file_chunk_links?: InputMaybe<file_chunk_file_link_bool_exp>;
  file_type_id?: InputMaybe<file_type_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  report_evidences?: InputMaybe<report_evidence_bool_exp>;
  report_export?: InputMaybe<report_bool_exp>;
  report_export_aggregate?: InputMaybe<report_aggregate_bool_exp>;
  s3_key?: InputMaybe<uuid_comparison_exp>;
  uploading?: InputMaybe<Boolean_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<Int_comparison_exp>;
};

/** Unstructured-shaped chunks written by the Unstructured Postgres destination connector. Column list is the canonical Extended + pgvector + include_original_elements shape — verified against a live Unstructured embedding-workflow output (embedded_elements). The link back to public.file lives in public.file_chunk_file_link, populated by a downstream linker. */
export type file_chunk = {
  element_id?: Maybe<Scalars['String']['output']>;
  /** OpenAI text-embedding-3-small vector emitted by Unstructured (dim 1536). Null while ingestion is in flight; queryable rows must be non-null. */
  embeddings?: Maybe<Scalars['vector']['output']>;
  /** An object relationship */
  file_link?: Maybe<file_chunk_file_link>;
  filetype?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  image_mime_type?: Maybe<Scalars['String']['output']>;
  is_extracted?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  layout_height?: Maybe<Scalars['Int']['output']>;
  layout_width?: Maybe<Scalars['Int']['output']>;
  /** Populated only when the Unstructured chunker runs with include_original_elements=true. Holds the base64-gzipped JSON of the source elements that were merged into this chunk; opaque to retrieval — kept for citation / attribution and so the connector's INSERT column list is satisfied. */
  orig_elements?: Maybe<Scalars['String']['output']>;
  page_number?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['jsonb']['output']>;
  record_id?: Maybe<Scalars['String']['output']>;
  record_locator?: Maybe<Scalars['jsonb']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Unstructured-shaped chunks written by the Unstructured Postgres destination connector. Column list is the canonical Extended + pgvector + include_original_elements shape — verified against a live Unstructured embedding-workflow output (embedded_elements). The link back to public.file lives in public.file_chunk_file_link, populated by a downstream linker. */
export type file_chunkpointsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Unstructured-shaped chunks written by the Unstructured Postgres destination connector. Column list is the canonical Extended + pgvector + include_original_elements shape — verified against a live Unstructured embedding-workflow output (embedded_elements). The link back to public.file lives in public.file_chunk_file_link, populated by a downstream linker. */
export type file_chunkrecord_locatorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "file_chunk". All fields are combined with a logical 'AND'. */
export type file_chunk_bool_exp = {
  _and?: InputMaybe<Array<file_chunk_bool_exp>>;
  _not?: InputMaybe<file_chunk_bool_exp>;
  _or?: InputMaybe<Array<file_chunk_bool_exp>>;
  element_id?: InputMaybe<String_comparison_exp>;
  embeddings?: InputMaybe<vector_comparison_exp>;
  file_link?: InputMaybe<file_chunk_file_link_bool_exp>;
  filetype?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<uuid_comparison_exp>;
  image_mime_type?: InputMaybe<String_comparison_exp>;
  is_extracted?: InputMaybe<String_comparison_exp>;
  languages?: InputMaybe<String_array_comparison_exp>;
  layout_height?: InputMaybe<Int_comparison_exp>;
  layout_width?: InputMaybe<Int_comparison_exp>;
  orig_elements?: InputMaybe<String_comparison_exp>;
  page_number?: InputMaybe<String_comparison_exp>;
  points?: InputMaybe<jsonb_comparison_exp>;
  record_id?: InputMaybe<String_comparison_exp>;
  record_locator?: InputMaybe<jsonb_comparison_exp>;
  system?: InputMaybe<String_comparison_exp>;
  text?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<String_comparison_exp>;
  url?: InputMaybe<String_comparison_exp>;
};

/** Maps Unstructured-emitted file_chunk rows back to the originating public.file row. Populated by a downstream linker, not by the Unstructured Postgres destination connector itself. */
export type file_chunk_file_link = {
  chunk_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: file;
  /** An object relationship */
  file_chunk: file_chunk;
  file_id: Scalars['Int']['output'];
};

/** order by aggregate values of table "file_chunk_file_link" */
export type file_chunk_file_link_aggregate_order_by = {
  avg?: InputMaybe<file_chunk_file_link_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<file_chunk_file_link_max_order_by>;
  min?: InputMaybe<file_chunk_file_link_min_order_by>;
  stddev?: InputMaybe<file_chunk_file_link_stddev_order_by>;
  stddev_pop?: InputMaybe<file_chunk_file_link_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<file_chunk_file_link_stddev_samp_order_by>;
  sum?: InputMaybe<file_chunk_file_link_sum_order_by>;
  var_pop?: InputMaybe<file_chunk_file_link_var_pop_order_by>;
  var_samp?: InputMaybe<file_chunk_file_link_var_samp_order_by>;
  variance?: InputMaybe<file_chunk_file_link_variance_order_by>;
};

/** order by avg() on columns of table "file_chunk_file_link" */
export type file_chunk_file_link_avg_order_by = {
  file_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "file_chunk_file_link". All fields are combined with a logical 'AND'. */
export type file_chunk_file_link_bool_exp = {
  _and?: InputMaybe<Array<file_chunk_file_link_bool_exp>>;
  _not?: InputMaybe<file_chunk_file_link_bool_exp>;
  _or?: InputMaybe<Array<file_chunk_file_link_bool_exp>>;
  chunk_id?: InputMaybe<uuid_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  file?: InputMaybe<file_bool_exp>;
  file_chunk?: InputMaybe<file_chunk_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
};

/** order by max() on columns of table "file_chunk_file_link" */
export type file_chunk_file_link_max_order_by = {
  chunk_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "file_chunk_file_link" */
export type file_chunk_file_link_min_order_by = {
  chunk_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "file_chunk_file_link". */
export type file_chunk_file_link_order_by = {
  chunk_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  file?: InputMaybe<file_order_by>;
  file_chunk?: InputMaybe<file_chunk_order_by>;
  file_id?: InputMaybe<order_by>;
};

/** select columns of table "file_chunk_file_link" */
export enum file_chunk_file_link_select_column {
  /** column name */
  chunk_id = 'chunk_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  file_id = 'file_id',
}

/** order by stddev() on columns of table "file_chunk_file_link" */
export type file_chunk_file_link_stddev_order_by = {
  file_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "file_chunk_file_link" */
export type file_chunk_file_link_stddev_pop_order_by = {
  file_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "file_chunk_file_link" */
export type file_chunk_file_link_stddev_samp_order_by = {
  file_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "file_chunk_file_link" */
export type file_chunk_file_link_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: file_chunk_file_link_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type file_chunk_file_link_stream_cursor_value_input = {
  chunk_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  file_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "file_chunk_file_link" */
export type file_chunk_file_link_sum_order_by = {
  file_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "file_chunk_file_link" */
export type file_chunk_file_link_var_pop_order_by = {
  file_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "file_chunk_file_link" */
export type file_chunk_file_link_var_samp_order_by = {
  file_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "file_chunk_file_link" */
export type file_chunk_file_link_variance_order_by = {
  file_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "file_chunk". */
export type file_chunk_order_by = {
  element_id?: InputMaybe<order_by>;
  embeddings?: InputMaybe<order_by>;
  file_link?: InputMaybe<file_chunk_file_link_order_by>;
  filetype?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  image_mime_type?: InputMaybe<order_by>;
  is_extracted?: InputMaybe<order_by>;
  languages?: InputMaybe<order_by>;
  layout_height?: InputMaybe<order_by>;
  layout_width?: InputMaybe<order_by>;
  orig_elements?: InputMaybe<order_by>;
  page_number?: InputMaybe<order_by>;
  points?: InputMaybe<order_by>;
  record_id?: InputMaybe<order_by>;
  record_locator?: InputMaybe<order_by>;
  system?: InputMaybe<order_by>;
  text?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  url?: InputMaybe<order_by>;
};

/** select columns of table "file_chunk" */
export enum file_chunk_select_column {
  /** column name */
  element_id = 'element_id',
  /** column name */
  embeddings = 'embeddings',
  /** column name */
  filetype = 'filetype',
  /** column name */
  id = 'id',
  /** column name */
  image_mime_type = 'image_mime_type',
  /** column name */
  is_extracted = 'is_extracted',
  /** column name */
  languages = 'languages',
  /** column name */
  layout_height = 'layout_height',
  /** column name */
  layout_width = 'layout_width',
  /** column name */
  orig_elements = 'orig_elements',
  /** column name */
  page_number = 'page_number',
  /** column name */
  points = 'points',
  /** column name */
  record_id = 'record_id',
  /** column name */
  record_locator = 'record_locator',
  /** column name */
  system = 'system',
  /** column name */
  text = 'text',
  /** column name */
  type = 'type',
  /** column name */
  url = 'url',
}

/** Streaming cursor of the table "file_chunk" */
export type file_chunk_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: file_chunk_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type file_chunk_stream_cursor_value_input = {
  element_id?: InputMaybe<Scalars['String']['input']>;
  /** OpenAI text-embedding-3-small vector emitted by Unstructured (dim 1536). Null while ingestion is in flight; queryable rows must be non-null. */
  embeddings?: InputMaybe<Scalars['vector']['input']>;
  filetype?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_mime_type?: InputMaybe<Scalars['String']['input']>;
  is_extracted?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  layout_height?: InputMaybe<Scalars['Int']['input']>;
  layout_width?: InputMaybe<Scalars['Int']['input']>;
  /** Populated only when the Unstructured chunker runs with include_original_elements=true. Holds the base64-gzipped JSON of the source elements that were merged into this chunk; opaque to retrieval — kept for citation / attribution and so the connector's INSERT column list is satisfied. */
  orig_elements?: InputMaybe<Scalars['String']['input']>;
  page_number?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['jsonb']['input']>;
  record_id?: InputMaybe<Scalars['String']['input']>;
  record_locator?: InputMaybe<Scalars['jsonb']['input']>;
  system?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** unique or primary key constraints on table "file" */
export enum file_constraint {
  /** unique or primary key constraint on columns "id" */
  file_pkey = 'file_pkey',
  /** unique or primary key constraint on columns "s3_key" */
  file_s3_key_key = 'file_s3_key_key',
}

/** input type for inserting data into table "file" */
export type file_insert_input = {
  name?: InputMaybe<Scalars['String']['input']>;
  report_evidences?: InputMaybe<report_evidence_arr_rel_insert_input>;
  /** Whether the file is currently being uploaded. Used to prevent access to incomplete uploads. */
  uploading?: InputMaybe<Scalars['Boolean']['input']>;
};

/** response of any mutation on the table "file" */
export type file_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<file>;
};

/** input type for inserting object relation for remote table "file" */
export type file_obj_rel_insert_input = {
  data: file_insert_input;
  /** upsert condition */
  on_conflict?: InputMaybe<file_on_conflict>;
};

/** on_conflict condition type for table "file" */
export type file_on_conflict = {
  constraint: file_constraint;
  update_columns?: Array<file_update_column>;
  where?: InputMaybe<file_bool_exp>;
};

/** Ordering options when selecting data from "file". */
export type file_order_by = {
  areas_aggregate?: InputMaybe<area_aggregate_order_by>;
  cbi_exports_aggregate?: InputMaybe<cbi_export_aggregate_order_by>;
  cbi_invoices_aggregate?: InputMaybe<cbi_invoice_aggregate_order_by>;
  certificates_aggregate?: InputMaybe<certificate_aggregate_order_by>;
  climate_risk_v2?: InputMaybe<climate_risk_v2_order_by>;
  consumption_drafts_aggregate?: InputMaybe<consumption_draft_aggregate_order_by>;
  consumption_invoice_drafts_aggregate?: InputMaybe<consumption_invoice_draft_aggregate_order_by>;
  consumption_invoices_aggregate?: InputMaybe<consumption_invoice_aggregate_order_by>;
  consumptions_aggregate?: InputMaybe<consumption_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  emission_certificate_drafts_aggregate?: InputMaybe<emission_certificate_draft_aggregate_order_by>;
  emission_certificates_aggregate?: InputMaybe<emission_certificate_aggregate_order_by>;
  energy_certificate_drafts_aggregate?: InputMaybe<energy_certificate_draft_aggregate_order_by>;
  energy_certificates_aggregate?: InputMaybe<energy_certificate_aggregate_order_by>;
  file_chunk_links_aggregate?: InputMaybe<file_chunk_file_link_aggregate_order_by>;
  file_type_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  report_evidences_aggregate?: InputMaybe<report_evidence_aggregate_order_by>;
  report_export_aggregate?: InputMaybe<report_aggregate_order_by>;
  s3_key?: InputMaybe<order_by>;
  uploading?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_id?: InputMaybe<order_by>;
};

/** primary key columns input for table: file */
export type file_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "file" */
export enum file_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  file_type_id = 'file_type_id',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  s3_key = 's3_key',
  /** column name */
  uploading = 'uploading',
  /** column name */
  user_id = 'user_id',
}

/** input type for updating data in table "file" */
export type file_set_input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "file" */
export type file_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: file_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type file_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** What kind of document this is. Set by FileService on write; never inferred from relations or the filename. */
  file_type_id?: InputMaybe<file_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The S3 object key used to retrieve this file from AWS S3. */
  s3_key?: InputMaybe<Scalars['uuid']['input']>;
  /** Whether the file is currently being uploaded. Used to prevent access to incomplete uploads. */
  uploading?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user who uploaded this file. */
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export enum file_type_enum {
  ACTION_PLAN_PDF_EXPORT = 'ACTION_PLAN_PDF_EXPORT',
  ACTION_PLAN_PDF_EXPORT_LEGACY = 'ACTION_PLAN_PDF_EXPORT_LEGACY',
  BATCH_ESG_ANALYSIS_ZIP_EXPORT = 'BATCH_ESG_ANALYSIS_ZIP_EXPORT',
  BUILDING_CERTIFICATE = 'BUILDING_CERTIFICATE',
  BUILDING_EXCEL_EXPORT = 'BUILDING_EXCEL_EXPORT',
  BUILDING_EXCEL_EXPORT_LEGACY = 'BUILDING_EXCEL_EXPORT_LEGACY',
  CBI_EMAIL_ATTACHMENT_UNMATCHED = 'CBI_EMAIL_ATTACHMENT_UNMATCHED',
  CBI_INVOICE = 'CBI_INVOICE',
  CBI_ZIA_EXCEL_EXPORT = 'CBI_ZIA_EXCEL_EXPORT',
  CLIMATE_RISK_API_RESPONSE = 'CLIMATE_RISK_API_RESPONSE',
  CONSUMPTION_INVOICE = 'CONSUMPTION_INVOICE',
  CONSUMPTION_INVOICE_DEPRECATED = 'CONSUMPTION_INVOICE_DEPRECATED',
  DRIVE_CONSUMPTION_INVOICE = 'DRIVE_CONSUMPTION_INVOICE',
  DRIVE_CONTEXT_DOCUMENT = 'DRIVE_CONTEXT_DOCUMENT',
  DRIVE_EMISSION_CERTIFICATE = 'DRIVE_EMISSION_CERTIFICATE',
  DRIVE_ENERGY_CERTIFICATE = 'DRIVE_ENERGY_CERTIFICATE',
  DRIVE_USER_DOCUMENT = 'DRIVE_USER_DOCUMENT',
  EMAIL_ATTACHMENT_IMAGE = 'EMAIL_ATTACHMENT_IMAGE',
  EMISSION_CERTIFICATE = 'EMISSION_CERTIFICATE',
  ENERGY_CERTIFICATE = 'ENERGY_CERTIFICATE',
  ONE_PAGER_PDF_EXPORT = 'ONE_PAGER_PDF_EXPORT',
  ONE_PAGER_PDF_EXPORT_LEGACY = 'ONE_PAGER_PDF_EXPORT_LEGACY',
  ORG_LOGO = 'ORG_LOGO',
  REPORT_EVIDENCE = 'REPORT_EVIDENCE',
  REPORT_PDF_EXPORT = 'REPORT_PDF_EXPORT',
  SCENARIO_EXCEL_EXPORT = 'SCENARIO_EXCEL_EXPORT',
  SCENARIO_EXCEL_EXPORT_LEGACY = 'SCENARIO_EXCEL_EXPORT_LEGACY',
  UNKNOWN = 'UNKNOWN',
}

/** Boolean expression to compare columns of type "file_type_enum". All fields are combined with logical 'AND'. */
export type file_type_enum_comparison_exp = {
  _eq?: InputMaybe<file_type_enum>;
  _in?: InputMaybe<Array<file_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<file_type_enum>;
  _nin?: InputMaybe<Array<file_type_enum>>;
};

/** update columns of table "file" */
export enum file_update_column {
  /** column name */
  name = 'name',
}

export type file_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<file_set_input>;
  /** filter the rows which have to be updated */
  where: file_bool_exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type float8_comparison_exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "folder" */
export type folder = {
  /** An object relationship */
  building?: Maybe<building>;
  /** An array relationship */
  child_folders: Array<folder>;
  /** An object relationship */
  created_by_user?: Maybe<user>;
  /** An object relationship */
  economic_unit?: Maybe<economic_unit>;
  /** An object relationship */
  folder_type: folder_type;
  id: Scalars['Int']['output'];
  /** An object relationship */
  org: org;
  /** An object relationship */
  parent_folder?: Maybe<folder>;
  /** An object relationship */
  portfolio?: Maybe<portfolio>;
};

/** columns and relationships of "folder" */
export type folderchild_foldersArgs = {
  distinct_on?: InputMaybe<Array<folder_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<folder_order_by>>;
  where?: InputMaybe<folder_bool_exp>;
};

/** order by aggregate values of table "folder" */
export type folder_aggregate_order_by = {
  avg?: InputMaybe<folder_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<folder_max_order_by>;
  min?: InputMaybe<folder_min_order_by>;
  stddev?: InputMaybe<folder_stddev_order_by>;
  stddev_pop?: InputMaybe<folder_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<folder_stddev_samp_order_by>;
  sum?: InputMaybe<folder_sum_order_by>;
  var_pop?: InputMaybe<folder_var_pop_order_by>;
  var_samp?: InputMaybe<folder_var_samp_order_by>;
  variance?: InputMaybe<folder_variance_order_by>;
};

/** order by avg() on columns of table "folder" */
export type folder_avg_order_by = {
  id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "folder". All fields are combined with a logical 'AND'. */
export type folder_bool_exp = {
  _and?: InputMaybe<Array<folder_bool_exp>>;
  _not?: InputMaybe<folder_bool_exp>;
  _or?: InputMaybe<Array<folder_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  child_folders?: InputMaybe<folder_bool_exp>;
  created_by_user?: InputMaybe<user_bool_exp>;
  economic_unit?: InputMaybe<economic_unit_bool_exp>;
  folder_type?: InputMaybe<folder_type_bool_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  parent_folder?: InputMaybe<folder_bool_exp>;
  portfolio?: InputMaybe<portfolio_bool_exp>;
};

/** order by max() on columns of table "folder" */
export type folder_max_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "folder" */
export type folder_min_order_by = {
  id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "folder". */
export type folder_order_by = {
  building?: InputMaybe<building_order_by>;
  child_folders_aggregate?: InputMaybe<folder_aggregate_order_by>;
  created_by_user?: InputMaybe<user_order_by>;
  economic_unit?: InputMaybe<economic_unit_order_by>;
  folder_type?: InputMaybe<folder_type_order_by>;
  id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  parent_folder?: InputMaybe<folder_order_by>;
  portfolio?: InputMaybe<portfolio_order_by>;
};

/** select columns of table "folder" */
export enum folder_select_column {
  /** column name */
  id = 'id',
}

/** order by stddev() on columns of table "folder" */
export type folder_stddev_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "folder" */
export type folder_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "folder" */
export type folder_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "folder" */
export type folder_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: folder_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type folder_stream_cursor_value_input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "folder" */
export type folder_sum_order_by = {
  id?: InputMaybe<order_by>;
};

/** columns and relationships of "folder_type" */
export type folder_type = {
  id: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "folder_type". All fields are combined with a logical 'AND'. */
export type folder_type_bool_exp = {
  _and?: InputMaybe<Array<folder_type_bool_exp>>;
  _not?: InputMaybe<folder_type_bool_exp>;
  _or?: InputMaybe<Array<folder_type_bool_exp>>;
  id?: InputMaybe<String_comparison_exp>;
};

/** Ordering options when selecting data from "folder_type". */
export type folder_type_order_by = {
  id?: InputMaybe<order_by>;
};

/** select columns of table "folder_type" */
export enum folder_type_select_column {
  /** column name */
  id = 'id',
}

/** Streaming cursor of the table "folder_type" */
export type folder_type_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: folder_type_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type folder_type_stream_cursor_value_input = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** order by var_pop() on columns of table "folder" */
export type folder_var_pop_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "folder" */
export type folder_var_samp_order_by = {
  id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "folder" */
export type folder_variance_order_by = {
  id?: InputMaybe<order_by>;
};

/** View: Buildings with a soft-deleted (DELETED) state, used for admin/recovery purposes. */
export type inactive_buildings = {
  /** An object relationship */
  active_building_model?: Maybe<building_model>;
  active_building_model_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  address?: Maybe<address>;
  address_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  areas: Array<area>;
  /** An aggregate relationship */
  areas_aggregate: area_aggregate;
  building_state_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  building_valuations: Array<building_valuation>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  customer_external_identifier?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  economic_unit: economic_unit;
  economic_unit_id: Scalars['Int']['output'];
  /** A computed field, executes function "has_inactive_building_write_permission" */
  has_write_permission?: Maybe<Scalars['Boolean']['output']>;
  heritage_district?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  leasehold?: Maybe<Scalars['Boolean']['output']>;
  milieu_protection?: Maybe<Scalars['Boolean']['output']>;
  monument_protection?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  responsible_user?: Maybe<user>;
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_permissions: Array<building_permissions>;
  year_constructed?: Maybe<Scalars['Int']['output']>;
};

/** View: Buildings with a soft-deleted (DELETED) state, used for admin/recovery purposes. */
export type inactive_buildingsareasArgs = {
  distinct_on?: InputMaybe<Array<area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<area_order_by>>;
  where?: InputMaybe<area_bool_exp>;
};

/** View: Buildings with a soft-deleted (DELETED) state, used for admin/recovery purposes. */
export type inactive_buildingsareas_aggregateArgs = {
  distinct_on?: InputMaybe<Array<area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<area_order_by>>;
  where?: InputMaybe<area_bool_exp>;
};

/** View: Buildings with a soft-deleted (DELETED) state, used for admin/recovery purposes. */
export type inactive_buildingsbuilding_valuationsArgs = {
  distinct_on?: InputMaybe<Array<building_valuation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_valuation_order_by>>;
  where?: InputMaybe<building_valuation_bool_exp>;
};

/** View: Buildings with a soft-deleted (DELETED) state, used for admin/recovery purposes. */
export type inactive_buildingsuser_permissionsArgs = {
  distinct_on?: InputMaybe<Array<building_permissions_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_permissions_order_by>>;
  where?: InputMaybe<building_permissions_bool_exp>;
};

/** order by aggregate values of table "inactive_buildings" */
export type inactive_buildings_aggregate_order_by = {
  avg?: InputMaybe<inactive_buildings_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<inactive_buildings_max_order_by>;
  min?: InputMaybe<inactive_buildings_min_order_by>;
  stddev?: InputMaybe<inactive_buildings_stddev_order_by>;
  stddev_pop?: InputMaybe<inactive_buildings_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<inactive_buildings_stddev_samp_order_by>;
  sum?: InputMaybe<inactive_buildings_sum_order_by>;
  var_pop?: InputMaybe<inactive_buildings_var_pop_order_by>;
  var_samp?: InputMaybe<inactive_buildings_var_samp_order_by>;
  variance?: InputMaybe<inactive_buildings_variance_order_by>;
};

/** order by avg() on columns of table "inactive_buildings" */
export type inactive_buildings_avg_order_by = {
  active_building_model_id?: InputMaybe<order_by>;
  address_id?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "inactive_buildings". All fields are combined with a logical 'AND'. */
export type inactive_buildings_bool_exp = {
  _and?: InputMaybe<Array<inactive_buildings_bool_exp>>;
  _not?: InputMaybe<inactive_buildings_bool_exp>;
  _or?: InputMaybe<Array<inactive_buildings_bool_exp>>;
  active_building_model?: InputMaybe<building_model_bool_exp>;
  active_building_model_id?: InputMaybe<Int_comparison_exp>;
  address?: InputMaybe<address_bool_exp>;
  address_id?: InputMaybe<Int_comparison_exp>;
  areas?: InputMaybe<area_bool_exp>;
  areas_aggregate?: InputMaybe<area_aggregate_bool_exp>;
  building_state_id?: InputMaybe<String_comparison_exp>;
  building_valuations?: InputMaybe<building_valuation_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  customer_external_identifier?: InputMaybe<String_comparison_exp>;
  economic_unit?: InputMaybe<economic_unit_bool_exp>;
  economic_unit_id?: InputMaybe<Int_comparison_exp>;
  has_write_permission?: InputMaybe<Boolean_comparison_exp>;
  heritage_district?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  leasehold?: InputMaybe<Boolean_comparison_exp>;
  milieu_protection?: InputMaybe<Boolean_comparison_exp>;
  monument_protection?: InputMaybe<Boolean_comparison_exp>;
  responsible_user?: InputMaybe<user_bool_exp>;
  responsible_user_id?: InputMaybe<Int_comparison_exp>;
  state?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_permissions?: InputMaybe<building_permissions_bool_exp>;
  year_constructed?: InputMaybe<Int_comparison_exp>;
};

/** order by max() on columns of table "inactive_buildings" */
export type inactive_buildings_max_order_by = {
  active_building_model_id?: InputMaybe<order_by>;
  address_id?: InputMaybe<order_by>;
  building_state_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  customer_external_identifier?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
};

/** order by min() on columns of table "inactive_buildings" */
export type inactive_buildings_min_order_by = {
  active_building_model_id?: InputMaybe<order_by>;
  address_id?: InputMaybe<order_by>;
  building_state_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  customer_external_identifier?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
};

/** response of any mutation on the table "inactive_buildings" */
export type inactive_buildings_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<inactive_buildings>;
};

/** Ordering options when selecting data from "inactive_buildings". */
export type inactive_buildings_order_by = {
  active_building_model?: InputMaybe<building_model_order_by>;
  active_building_model_id?: InputMaybe<order_by>;
  address?: InputMaybe<address_order_by>;
  address_id?: InputMaybe<order_by>;
  areas_aggregate?: InputMaybe<area_aggregate_order_by>;
  building_state_id?: InputMaybe<order_by>;
  building_valuations_aggregate?: InputMaybe<building_valuation_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  customer_external_identifier?: InputMaybe<order_by>;
  economic_unit?: InputMaybe<economic_unit_order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  has_write_permission?: InputMaybe<order_by>;
  heritage_district?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  leasehold?: InputMaybe<order_by>;
  milieu_protection?: InputMaybe<order_by>;
  monument_protection?: InputMaybe<order_by>;
  responsible_user?: InputMaybe<user_order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  state?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_permissions_aggregate?: InputMaybe<building_permissions_aggregate_order_by>;
  year_constructed?: InputMaybe<order_by>;
};

/** select columns of table "inactive_buildings" */
export enum inactive_buildings_select_column {
  /** column name */
  active_building_model_id = 'active_building_model_id',
  /** column name */
  address_id = 'address_id',
  /** column name */
  building_state_id = 'building_state_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  customer_external_identifier = 'customer_external_identifier',
  /** column name */
  economic_unit_id = 'economic_unit_id',
  /** column name */
  heritage_district = 'heritage_district',
  /** column name */
  id = 'id',
  /** column name */
  leasehold = 'leasehold',
  /** column name */
  milieu_protection = 'milieu_protection',
  /** column name */
  monument_protection = 'monument_protection',
  /** column name */
  responsible_user_id = 'responsible_user_id',
  /** column name */
  state = 'state',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  year_constructed = 'year_constructed',
}

/** input type for updating data in table "inactive_buildings" */
export type inactive_buildings_set_input = {
  state?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "inactive_buildings" */
export type inactive_buildings_stddev_order_by = {
  active_building_model_id?: InputMaybe<order_by>;
  address_id?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "inactive_buildings" */
export type inactive_buildings_stddev_pop_order_by = {
  active_building_model_id?: InputMaybe<order_by>;
  address_id?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "inactive_buildings" */
export type inactive_buildings_stddev_samp_order_by = {
  active_building_model_id?: InputMaybe<order_by>;
  address_id?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "inactive_buildings" */
export type inactive_buildings_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: inactive_buildings_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type inactive_buildings_stream_cursor_value_input = {
  active_building_model_id?: InputMaybe<Scalars['Int']['input']>;
  address_id?: InputMaybe<Scalars['Int']['input']>;
  building_state_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customer_external_identifier?: InputMaybe<Scalars['String']['input']>;
  economic_unit_id?: InputMaybe<Scalars['Int']['input']>;
  heritage_district?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  leasehold?: InputMaybe<Scalars['Boolean']['input']>;
  milieu_protection?: InputMaybe<Scalars['Boolean']['input']>;
  monument_protection?: InputMaybe<Scalars['Boolean']['input']>;
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  year_constructed?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "inactive_buildings" */
export type inactive_buildings_sum_order_by = {
  active_building_model_id?: InputMaybe<order_by>;
  address_id?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
};

export type inactive_buildings_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<inactive_buildings_set_input>;
  /** filter the rows which have to be updated */
  where: inactive_buildings_bool_exp;
};

/** order by var_pop() on columns of table "inactive_buildings" */
export type inactive_buildings_var_pop_order_by = {
  active_building_model_id?: InputMaybe<order_by>;
  address_id?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "inactive_buildings" */
export type inactive_buildings_var_samp_order_by = {
  active_building_model_id?: InputMaybe<order_by>;
  address_id?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "inactive_buildings" */
export type inactive_buildings_variance_order_by = {
  active_building_model_id?: InputMaybe<order_by>;
  address_id?: InputMaybe<order_by>;
  economic_unit_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  year_constructed?: InputMaybe<order_by>;
};

export enum insulation_material_category_enum {
  MINERAL = 'MINERAL',
  MIXED = 'MIXED',
  RENEWABLE = 'RENEWABLE',
  SYNTHETIC = 'SYNTHETIC',
}

/** Boolean expression to compare columns of type "insulation_material_category_enum". All fields are combined with logical 'AND'. */
export type insulation_material_category_enum_comparison_exp = {
  _eq?: InputMaybe<insulation_material_category_enum>;
  _in?: InputMaybe<Array<insulation_material_category_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<insulation_material_category_enum>;
  _nin?: InputMaybe<Array<insulation_material_category_enum>>;
};

export enum insulation_method_enum {
  ABOVE_RAFTER = 'ABOVE_RAFTER',
  BELOW_RAFTER = 'BELOW_RAFTER',
  BETWEEN_RAFTER = 'BETWEEN_RAFTER',
  BLOW_IN_INSULATION = 'BLOW_IN_INSULATION',
  COLD_ROOF_BETWEEN_RAFTER = 'COLD_ROOF_BETWEEN_RAFTER',
  CORE_INSULATION_BOARDS = 'CORE_INSULATION_BOARDS',
  FACING_SHELL = 'FACING_SHELL',
  FROM_BELOW = 'FROM_BELOW',
  INSULATION_BOARDS = 'INSULATION_BOARDS',
  INSULATION_BOARDS_WALKABLE = 'INSULATION_BOARDS_WALKABLE',
  INSULATION_BOARDS_WITHOUT_CLADDING = 'INSULATION_BOARDS_WITHOUT_CLADDING',
  INSULATION_BOARDS_WITH_CLADDING = 'INSULATION_BOARDS_WITH_CLADDING',
  INSULATION_GRADIENT = 'INSULATION_GRADIENT',
  INSULATION_MATS = 'INSULATION_MATS',
  INTERIOR_PLASTER_SYSTEM = 'INTERIOR_PLASTER_SYSTEM',
  INVERTED_ROOF = 'INVERTED_ROOF',
  ON_RAFTER = 'ON_RAFTER',
  VHF = 'VHF',
  WARM_ROOF = 'WARM_ROOF',
  WDVS = 'WDVS',
}

/** Boolean expression to compare columns of type "insulation_method_enum". All fields are combined with logical 'AND'. */
export type insulation_method_enum_comparison_exp = {
  _eq?: InputMaybe<insulation_method_enum>;
  _in?: InputMaybe<Array<insulation_method_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<insulation_method_enum>;
  _nin?: InputMaybe<Array<insulation_method_enum>>;
};

export enum invoice_payer_type_enum {
  OWNER = 'OWNER',
  TENANT = 'TENANT',
}

/** Boolean expression to compare columns of type "invoice_payer_type_enum". All fields are combined with logical 'AND'. */
export type invoice_payer_type_enum_comparison_exp = {
  _eq?: InputMaybe<invoice_payer_type_enum>;
  _in?: InputMaybe<Array<invoice_payer_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<invoice_payer_type_enum>;
  _nin?: InputMaybe<Array<invoice_payer_type_enum>>;
};

export type jsonb_cast_exp = {
  String?: InputMaybe<String_comparison_exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type jsonb_comparison_exp = {
  _cast?: InputMaybe<jsonb_cast_exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export enum language_enum {
  /** the main language and fallback of the application */
  deDE = 'deDE',
  enGB = 'enGB',
}

/** Boolean expression to compare columns of type "language_enum". All fields are combined with logical 'AND'. */
export type language_enum_comparison_exp = {
  _eq?: InputMaybe<language_enum>;
  _in?: InputMaybe<Array<language_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<language_enum>;
  _nin?: InputMaybe<Array<language_enum>>;
};

export enum main_energy_source_type_enum {
  DISTRICT_HEATING = 'DISTRICT_HEATING',
  ELECTRICITY = 'ELECTRICITY',
  GAS = 'GAS',
  OIL = 'OIL',
  OTHER = 'OTHER',
}

/** mutation root */
export type mutation_root = {
  acceptAutofillReport: AcceptAutofillReportOutput;
  answerQuestions: AnswerQuestionsOutput;
  applyBuildingModelMutations: ApplyBuildingModelMutationsOutput;
  archiveIntegrationBuilding: SmartMeterIntegrationBuildingOutput;
  archiveMeter: SmartMeterOutput;
  archiveScenario: ScenarioMutationOutput;
  bulkDeleteActionPlans: BulkDeleteActionPlansResponse;
  confirmDriveUpload: ConfirmDriveUploadOutput;
  confirmFileUpload: ConfirmFileUploadOutput;
  convertFileToEnergyCertificate: ConvertFileToEnergyCertificateOutput;
  convertFilesToEnergyCertificates: ConvertFilesToEnergyCertificatesOutput;
  createActionPlan: CreateActionPlanResponse;
  createBuildingFromBuildingDraft: BuildingCreationFromBuildingDraftOutput;
  createBuildingModelTwin: CreateBuildingModelTwinOutput;
  createBulkAction: Scalars['Int']['output'];
  createCertificateFileUploadURL: CreateCertificateFileResponse;
  createConsumptionDraft?: Maybe<ConsumptionDraftMutationOutput>;
  createConsumptionFromDraft?: Maybe<ConsumptionMutationOutput>;
  createConsumptionInvoiceDraft: CreateConsumptionInvoiceDraftOutput;
  createConsumptionInvoiceFromDraft: CreateConsumptionInvoiceFromDraftOutput;
  createConsumptionWasteDetails?: Maybe<ConsumptionWasteDetailsMutationOutput>;
  createConsumptionWasteDetailsDraft?: Maybe<ConsumptionWasteDetailsDraftMutationOutput>;
  createCustomField: CreateCustomFieldOutput;
  createCustomTarget: CustomTarget;
  createEmissionCertificate: CreateEmissionCertificateOutput;
  createEmissionCertificateDraftWithFile: CreateEmissionCertificateDraftWithFileOutput;
  createEmissionCertificateDraftWithoutFile: CreateEmissionCertificateDraftWithoutFileOutput;
  createEvidenceFromFile: CreateEvidenceOutput;
  createExclusionNote: ImplementActionOutput;
  createExtractionsForFailedSnapshots: Array<InvoiceSnapshotOutput>;
  createExtractionsForNeedsReviewSnapshots: Array<InvoiceSnapshotOutput>;
  createFolder: FolderMutationOutput;
  createInbox: CBIInboxConfiguration;
  createInvoiceSnapshot: InvoiceSnapshotOutput;
  createManualConsumption?: Maybe<ConsumptionMutationOutput>;
  createManualInvoiceSnapshot: InvoiceSnapshotOutput;
  createPortfolio: Scalars['Int']['output'];
  createReport: CreateReportOutput;
  createScenario: ScenarioMutationOutput;
  createSharedBuildingSnapshot: SharedBuildingSnapshotOutput;
  createUser: UserId;
  deleteAction: EditActionOutput;
  deleteActionPlan: DeleteActionPlanResponse;
  deleteAllBuildings: DeleteAllBuildingsOutput;
  deleteBuildingModelTwin: DeleteBuildingModelTwinOutput;
  deleteBulkAction: Scalars['Boolean']['output'];
  deleteCBIInvoice: Scalars['Boolean']['output'];
  deleteCustomField: DeleteCustomFieldOutput;
  deleteCustomTarget: Scalars['Boolean']['output'];
  deleteEmissionCertificate: DeleteEmissionCertificateOutput;
  deleteFolder: FolderMutationOutput;
  deleteScenario: ScenarioMutationOutput;
  deleteSmartMeterIntegration: SmartMeterIntegrationOutput;
  deleteTwinBuildingModel: DeleteTwinBuildingModelOutput;
  deleteUser: UserId;
  /** delete data from the table: "building" */
  delete_building?: Maybe<building_mutation_response>;
  /** delete single row from the table: "building" */
  delete_building_by_pk?: Maybe<building>;
  /** delete data from the table: "building_district_heating_availability" */
  delete_building_district_heating_availability?: Maybe<building_district_heating_availability_mutation_response>;
  /** delete single row from the table: "building_district_heating_availability" */
  delete_building_district_heating_availability_by_pk?: Maybe<building_district_heating_availability>;
  /** delete data from the table: "building_draft" */
  delete_building_draft?: Maybe<building_draft_mutation_response>;
  /** delete data from the table: "building_draft_area" */
  delete_building_draft_area?: Maybe<building_draft_area_mutation_response>;
  /** delete single row from the table: "building_draft_area" */
  delete_building_draft_area_by_pk?: Maybe<building_draft_area>;
  /** delete single row from the table: "building_draft" */
  delete_building_draft_by_pk?: Maybe<building_draft>;
  /** delete data from the table: "building_draft_consumer" */
  delete_building_draft_consumer?: Maybe<building_draft_consumer_mutation_response>;
  /** delete single row from the table: "building_draft_consumer" */
  delete_building_draft_consumer_by_pk?: Maybe<building_draft_consumer>;
  /** delete data from the table: "building_draft_valuation" */
  delete_building_draft_valuation?: Maybe<building_draft_valuation_mutation_response>;
  /** delete single row from the table: "building_draft_valuation" */
  delete_building_draft_valuation_by_pk?: Maybe<building_draft_valuation>;
  /** delete data from the table: "building_valuation" */
  delete_building_valuation?: Maybe<building_valuation_mutation_response>;
  /** delete single row from the table: "building_valuation" */
  delete_building_valuation_by_pk?: Maybe<building_valuation>;
  /** delete data from the table: "consumption" */
  delete_consumption?: Maybe<consumption_mutation_response>;
  /** delete single row from the table: "consumption" */
  delete_consumption_by_pk?: Maybe<consumption>;
  /** delete data from the table: "consumption_draft" */
  delete_consumption_draft?: Maybe<consumption_draft_mutation_response>;
  /** delete single row from the table: "consumption_draft" */
  delete_consumption_draft_by_pk?: Maybe<consumption_draft>;
  /** delete data from the table: "consumption_invoice" */
  delete_consumption_invoice?: Maybe<consumption_invoice_mutation_response>;
  /** delete single row from the table: "consumption_invoice" */
  delete_consumption_invoice_by_pk?: Maybe<consumption_invoice>;
  /** delete data from the table: "consumption_invoice_draft" */
  delete_consumption_invoice_draft?: Maybe<consumption_invoice_draft_mutation_response>;
  /** delete single row from the table: "consumption_invoice_draft" */
  delete_consumption_invoice_draft_by_pk?: Maybe<consumption_invoice_draft>;
  /** delete data from the table: "consumption_waste_details" */
  delete_consumption_waste_details?: Maybe<consumption_waste_details_mutation_response>;
  /** delete single row from the table: "consumption_waste_details" */
  delete_consumption_waste_details_by_pk?: Maybe<consumption_waste_details>;
  /** delete data from the table: "consumption_waste_details_draft" */
  delete_consumption_waste_details_draft?: Maybe<consumption_waste_details_draft_mutation_response>;
  /** delete single row from the table: "consumption_waste_details_draft" */
  delete_consumption_waste_details_draft_by_pk?: Maybe<consumption_waste_details_draft>;
  /** delete data from the table: "economic_unit" */
  delete_economic_unit?: Maybe<economic_unit_mutation_response>;
  /** delete single row from the table: "economic_unit" */
  delete_economic_unit_by_pk?: Maybe<economic_unit>;
  /** delete data from the table: "emission_certificate_draft" */
  delete_emission_certificate_draft?: Maybe<emission_certificate_draft_mutation_response>;
  /** delete single row from the table: "emission_certificate_draft" */
  delete_emission_certificate_draft_by_pk?: Maybe<emission_certificate_draft>;
  /** delete data from the table: "energy_certificate" */
  delete_energy_certificate?: Maybe<energy_certificate_mutation_response>;
  /** delete single row from the table: "energy_certificate" */
  delete_energy_certificate_by_pk?: Maybe<energy_certificate>;
  /** delete data from the table: "energy_certificate_consumer" */
  delete_energy_certificate_consumer?: Maybe<energy_certificate_consumer_mutation_response>;
  /** delete single row from the table: "energy_certificate_consumer" */
  delete_energy_certificate_consumer_by_pk?: Maybe<energy_certificate_consumer>;
  /** delete data from the table: "energy_certificate_draft" */
  delete_energy_certificate_draft?: Maybe<energy_certificate_draft_mutation_response>;
  /** delete single row from the table: "energy_certificate_draft" */
  delete_energy_certificate_draft_by_pk?: Maybe<energy_certificate_draft>;
  /** delete data from the table: "file" */
  delete_file?: Maybe<file_mutation_response>;
  /** delete single row from the table: "file" */
  delete_file_by_pk?: Maybe<file>;
  /** delete data from the table: "inactive_buildings" */
  delete_inactive_buildings?: Maybe<inactive_buildings_mutation_response>;
  /** delete data from the table: "portfolio" */
  delete_portfolio?: Maybe<portfolio_mutation_response>;
  /** delete single row from the table: "portfolio" */
  delete_portfolio_by_pk?: Maybe<portfolio>;
  /** delete data from the table: "report" */
  delete_report?: Maybe<report_mutation_response>;
  /** delete single row from the table: "report" */
  delete_report_by_pk?: Maybe<report>;
  /** delete data from the table: "report_evidence" */
  delete_report_evidence?: Maybe<report_evidence_mutation_response>;
  /** delete single row from the table: "report_evidence" */
  delete_report_evidence_by_pk?: Maybe<report_evidence>;
  /** delete data from the table: "report_question_evidence" */
  delete_report_question_evidence?: Maybe<report_question_evidence_mutation_response>;
  /** delete single row from the table: "report_question_evidence" */
  delete_report_question_evidence_by_pk?: Maybe<report_question_evidence>;
  /** delete data from the table: "smart_meter" */
  delete_smart_meter?: Maybe<smart_meter_mutation_response>;
  /** delete single row from the table: "smart_meter" */
  delete_smart_meter_by_pk?: Maybe<smart_meter>;
  /** delete data from the table: "smart_meter_integration_building" */
  delete_smart_meter_integration_building?: Maybe<smart_meter_integration_building_mutation_response>;
  /** delete single row from the table: "smart_meter_integration_building" */
  delete_smart_meter_integration_building_by_pk?: Maybe<smart_meter_integration_building>;
  /** delete data from the table: "user_building_permission" */
  delete_user_building_permission?: Maybe<user_building_permission_mutation_response>;
  /** delete single row from the table: "user_building_permission" */
  delete_user_building_permission_by_pk?: Maybe<user_building_permission>;
  /** delete data from the table: "user_portfolio_permission" */
  delete_user_portfolio_permission?: Maybe<user_portfolio_permission_mutation_response>;
  /** delete single row from the table: "user_portfolio_permission" */
  delete_user_portfolio_permission_by_pk?: Maybe<user_portfolio_permission>;
  duplicateBuildingModelVersionTwin: BuildingModelTwinOutput;
  duplicateScenario: Scalars['Boolean']['output'];
  editAction: EditActionOutput;
  editAddressAssignments: CBIAddressOutput;
  editAreas: AreaUpdateResponse;
  editBulkAction: EditBulkActionOutput;
  editCertificates: EditCertificateResponse;
  editCustomField: EditCustomFieldOutput;
  editExclusionNote: EditActionOutput;
  editSnapshot: InvoiceSnapshotOutput;
  exportClimateRiskV2Report: ExportClimateRiskV2ReportOutput;
  exportFile: ExportFileOutput;
  exportReportAsExcel: ExcelExportOutput;
  exportReportAsPdfAsync: ExportReportAsPdfAsyncOutput;
  exportScenarioAsExcel: ExcelExportOutput;
  fillBuildingDraft: FillBuildingDraftOutput;
  implementAction: ImplementActionOutput;
  /** insert data into the table: "building_district_heating_availability" */
  insert_building_district_heating_availability?: Maybe<building_district_heating_availability_mutation_response>;
  /** insert a single row into the table: "building_district_heating_availability" */
  insert_building_district_heating_availability_one?: Maybe<building_district_heating_availability>;
  /** insert data into the table: "building_draft" */
  insert_building_draft?: Maybe<building_draft_mutation_response>;
  /** insert data into the table: "building_draft_area" */
  insert_building_draft_area?: Maybe<building_draft_area_mutation_response>;
  /** insert a single row into the table: "building_draft_area" */
  insert_building_draft_area_one?: Maybe<building_draft_area>;
  /** insert data into the table: "building_draft_consumer" */
  insert_building_draft_consumer?: Maybe<building_draft_consumer_mutation_response>;
  /** insert a single row into the table: "building_draft_consumer" */
  insert_building_draft_consumer_one?: Maybe<building_draft_consumer>;
  /** insert a single row into the table: "building_draft" */
  insert_building_draft_one?: Maybe<building_draft>;
  /** insert data into the table: "building_draft_valuation" */
  insert_building_draft_valuation?: Maybe<building_draft_valuation_mutation_response>;
  /** insert a single row into the table: "building_draft_valuation" */
  insert_building_draft_valuation_one?: Maybe<building_draft_valuation>;
  /** insert data into the table: "building_valuation" */
  insert_building_valuation?: Maybe<building_valuation_mutation_response>;
  /** insert a single row into the table: "building_valuation" */
  insert_building_valuation_one?: Maybe<building_valuation>;
  /** insert data into the table: "economic_unit" */
  insert_economic_unit?: Maybe<economic_unit_mutation_response>;
  /** insert a single row into the table: "economic_unit" */
  insert_economic_unit_one?: Maybe<economic_unit>;
  /** insert data into the table: "energy_certificate_consumer" */
  insert_energy_certificate_consumer?: Maybe<energy_certificate_consumer_mutation_response>;
  /** insert a single row into the table: "energy_certificate_consumer" */
  insert_energy_certificate_consumer_one?: Maybe<energy_certificate_consumer>;
  /** insert data into the table: "file" */
  insert_file?: Maybe<file_mutation_response>;
  /** insert a single row into the table: "file" */
  insert_file_one?: Maybe<file>;
  /** insert data into the table: "report_evidence" */
  insert_report_evidence?: Maybe<report_evidence_mutation_response>;
  /** insert a single row into the table: "report_evidence" */
  insert_report_evidence_one?: Maybe<report_evidence>;
  /** insert data into the table: "user_building_permission" */
  insert_user_building_permission?: Maybe<user_building_permission_mutation_response>;
  /** insert a single row into the table: "user_building_permission" */
  insert_user_building_permission_one?: Maybe<user_building_permission>;
  /** insert data into the table: "user_portfolio_permission" */
  insert_user_portfolio_permission?: Maybe<user_portfolio_permission_mutation_response>;
  /** insert a single row into the table: "user_portfolio_permission" */
  insert_user_portfolio_permission_one?: Maybe<user_portfolio_permission>;
  internalExportBuilding: BuildingExportOutput;
  internalImportBuilding: BuildingImportOutput;
  linkSmartMeter: SmartMeterOutput;
  linkSmartMeterIntegrationBuilding: SmartMeterIntegrationBuildingOutput;
  matchBuildingAddresses: InvoiceSnapshotOutput;
  moveAllBuildings: MoveAllBuildingsOutput;
  moveFileToFolder: DriveMutationOutput;
  moveFolder: FolderMutationOutput;
  previewEditAreas: AreaUpdateResponse;
  queueBatchEsgAnalysisPdfExport: QueueBatchEsgAnalysisPdfExportOutput;
  queueEconomicUnitEsgAnalysisPdfExport: QueueEsgAnalysisPdfExportOutput;
  queueEsgAnalysisPdfExport: QueueEsgAnalysisPdfExportOutput;
  queueExportActionPlanAsPdf: QueuedExportActionPlanAsPdfOutput;
  queueSummaryOnePagerPdfExport: QueueSummaryOnePagerPdfExportOutput;
  removeEmptyEconomicUnits: EconomicUnitOutput;
  removeFileFromFolder: DriveMutationOutput;
  renameFile: DriveMutationOutput;
  renameFolder: FolderMutationOutput;
  resetAnswers: ReportQuestionId;
  resetBuildingDraft: ResetBuildingDraftOutput;
  resetSandboxFeatureFlags: Scalars['Boolean']['output'];
  revalidateNeedsReview: RevalidateNeedsReviewOutput;
  revertToAutoAssignedAssignments: CBIAddressOutput;
  setActiveBuildingModel: SetActiveBuildingModelOutput;
  setActiveInvoiceSnapshot: InvoiceSnapshotOutput;
  setCommonOrgPreferences: OrgPreferences;
  setCustomTargetActive: Scalars['Boolean']['output'];
  setDuplicateAsOriginalInvoice: InvoiceOutput;
  setOrgCo2PriceCurve?: Maybe<Co2PriceCurveConfig>;
  setOrgEmissionFactorPreferences: OrgPreferences;
  setOrgEuTaxonomyDatasource: OrgPreferences;
  setSmartMeterIntegrationState: SmartMeterIntegrationOutput;
  setupMeterIntegration: Array<SmartMeterIntegrationOutput>;
  simulateAction: SimulateActionOutput;
  simulateEditAction: SimulateActionOutput;
  syncConsumptionsForCbiInvoice: SyncConsumptionsForCbiInvoiceResult;
  syncMeterIntegration: SmartMeterIntegrationOutput;
  transformEnergyCertificateDraftToEnergyCertificate: EnergyCertificateDraftTransformOutput;
  triggerCbiExport: CBIExportOutput;
  unarchiveIntegrationBuilding: SmartMeterIntegrationBuildingOutput;
  unarchiveMeter: SmartMeterOutput;
  unarchiveScenario: ScenarioMutationOutput;
  unlinkSmartMeter: SmartMeterOutput;
  unlinkSmartMeterIntegrationBuilding: SmartMeterIntegrationBuildingOutput;
  updateBuildingCustomData: UpdateCustomDataResponse;
  updateBuildingLocation: UpdateSelectedIdsOutput;
  updateBuildingModelTwin: BuildingModelTwinOutput;
  updateConsumption?: Maybe<ConsumptionMutationOutput>;
  updateConsumptionDraft?: Maybe<ConsumptionDraftMutationOutput>;
  updateConsumptionInvoice: UpdateConsumptionInvoiceOutput;
  updateConsumptionInvoiceDraft: UpdateConsumptionInvoiceDraftOutput;
  updateConsumptionState?: Maybe<ConsumptionMutationOutput>;
  updateConsumptionWasteDetails?: Maybe<ConsumptionWasteDetailsMutationOutput>;
  updateConsumptionWasteDetailsDraft?: Maybe<ConsumptionWasteDetailsDraftMutationOutput>;
  updateCustomTarget: CustomTarget;
  updateDuplicateInvoice: InvoiceOutput;
  updateEconomicUnitCustomData: UpdateCustomDataResponse;
  updateEmissionCertificateDraftWithFile: UpdateEmissionCertificateDraftWithFileOutput;
  updateEmissionCertificateDraftWithoutFile: UpdateEmissionCertificateDraftWithoutFileOutput;
  updateEmissionCertificateFile: UpdateEmissionCertificateFileOutput;
  updateEmissionCertificateWithoutFile: UpdateEmissionCertificateWithoutFileOutput;
  updateInbox: CBIInboxConfiguration;
  updatePortfolio: Scalars['Boolean']['output'];
  updateSandboxFeatureFlag: Scalars['Boolean']['output'];
  updateScenario: ScenarioMutationOutput;
  updateScenarioToLatestVersion: Scalars['Boolean']['output'];
  updateSelectedIds: UpdateSelectedIdsOutput;
  updateSmartMeterIntegration: SmartMeterIntegrationOutput;
  /** update data of the table: "address" */
  update_address?: Maybe<address_mutation_response>;
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<address>;
  /** update multiples rows of table: "address" */
  update_address_many?: Maybe<Array<Maybe<address_mutation_response>>>;
  /** update data of the table: "building" */
  update_building?: Maybe<building_mutation_response>;
  /** update single row of the table: "building" */
  update_building_by_pk?: Maybe<building>;
  /** update data of the table: "building_district_heating_availability" */
  update_building_district_heating_availability?: Maybe<building_district_heating_availability_mutation_response>;
  /** update single row of the table: "building_district_heating_availability" */
  update_building_district_heating_availability_by_pk?: Maybe<building_district_heating_availability>;
  /** update multiples rows of table: "building_district_heating_availability" */
  update_building_district_heating_availability_many?: Maybe<
    Array<Maybe<building_district_heating_availability_mutation_response>>
  >;
  /** update data of the table: "building_draft" */
  update_building_draft?: Maybe<building_draft_mutation_response>;
  /** update data of the table: "building_draft_area" */
  update_building_draft_area?: Maybe<building_draft_area_mutation_response>;
  /** update single row of the table: "building_draft_area" */
  update_building_draft_area_by_pk?: Maybe<building_draft_area>;
  /** update multiples rows of table: "building_draft_area" */
  update_building_draft_area_many?: Maybe<Array<Maybe<building_draft_area_mutation_response>>>;
  /** update single row of the table: "building_draft" */
  update_building_draft_by_pk?: Maybe<building_draft>;
  /** update data of the table: "building_draft_consumer" */
  update_building_draft_consumer?: Maybe<building_draft_consumer_mutation_response>;
  /** update single row of the table: "building_draft_consumer" */
  update_building_draft_consumer_by_pk?: Maybe<building_draft_consumer>;
  /** update multiples rows of table: "building_draft_consumer" */
  update_building_draft_consumer_many?: Maybe<Array<Maybe<building_draft_consumer_mutation_response>>>;
  /** update multiples rows of table: "building_draft" */
  update_building_draft_many?: Maybe<Array<Maybe<building_draft_mutation_response>>>;
  /** update data of the table: "building_draft_valuation" */
  update_building_draft_valuation?: Maybe<building_draft_valuation_mutation_response>;
  /** update single row of the table: "building_draft_valuation" */
  update_building_draft_valuation_by_pk?: Maybe<building_draft_valuation>;
  /** update multiples rows of table: "building_draft_valuation" */
  update_building_draft_valuation_many?: Maybe<Array<Maybe<building_draft_valuation_mutation_response>>>;
  /** update multiples rows of table: "building" */
  update_building_many?: Maybe<Array<Maybe<building_mutation_response>>>;
  /** update data of the table: "building_valuation" */
  update_building_valuation?: Maybe<building_valuation_mutation_response>;
  /** update single row of the table: "building_valuation" */
  update_building_valuation_by_pk?: Maybe<building_valuation>;
  /** update multiples rows of table: "building_valuation" */
  update_building_valuation_many?: Maybe<Array<Maybe<building_valuation_mutation_response>>>;
  /** update data of the table: "consumption_invoice_draft" */
  update_consumption_invoice_draft?: Maybe<consumption_invoice_draft_mutation_response>;
  /** update single row of the table: "consumption_invoice_draft" */
  update_consumption_invoice_draft_by_pk?: Maybe<consumption_invoice_draft>;
  /** update multiples rows of table: "consumption_invoice_draft" */
  update_consumption_invoice_draft_many?: Maybe<Array<Maybe<consumption_invoice_draft_mutation_response>>>;
  /** update data of the table: "economic_unit" */
  update_economic_unit?: Maybe<economic_unit_mutation_response>;
  /** update single row of the table: "economic_unit" */
  update_economic_unit_by_pk?: Maybe<economic_unit>;
  /** update multiples rows of table: "economic_unit" */
  update_economic_unit_many?: Maybe<Array<Maybe<economic_unit_mutation_response>>>;
  /** update data of the table: "energy_certificate_consumer" */
  update_energy_certificate_consumer?: Maybe<energy_certificate_consumer_mutation_response>;
  /** update single row of the table: "energy_certificate_consumer" */
  update_energy_certificate_consumer_by_pk?: Maybe<energy_certificate_consumer>;
  /** update multiples rows of table: "energy_certificate_consumer" */
  update_energy_certificate_consumer_many?: Maybe<Array<Maybe<energy_certificate_consumer_mutation_response>>>;
  /** update data of the table: "energy_certificate_draft" */
  update_energy_certificate_draft?: Maybe<energy_certificate_draft_mutation_response>;
  /** update single row of the table: "energy_certificate_draft" */
  update_energy_certificate_draft_by_pk?: Maybe<energy_certificate_draft>;
  /** update multiples rows of table: "energy_certificate_draft" */
  update_energy_certificate_draft_many?: Maybe<Array<Maybe<energy_certificate_draft_mutation_response>>>;
  /** update data of the table: "file" */
  update_file?: Maybe<file_mutation_response>;
  /** update single row of the table: "file" */
  update_file_by_pk?: Maybe<file>;
  /** update multiples rows of table: "file" */
  update_file_many?: Maybe<Array<Maybe<file_mutation_response>>>;
  /** update data of the table: "inactive_buildings" */
  update_inactive_buildings?: Maybe<inactive_buildings_mutation_response>;
  /** update multiples rows of table: "inactive_buildings" */
  update_inactive_buildings_many?: Maybe<Array<Maybe<inactive_buildings_mutation_response>>>;
  /** update data of the table: "notification" */
  update_notification?: Maybe<notification_mutation_response>;
  /** update single row of the table: "notification" */
  update_notification_by_pk?: Maybe<notification>;
  /** update multiples rows of table: "notification" */
  update_notification_many?: Maybe<Array<Maybe<notification_mutation_response>>>;
  /** update data of the table: "renovation" */
  update_renovation?: Maybe<renovation_mutation_response>;
  /** update single row of the table: "renovation" */
  update_renovation_by_pk?: Maybe<renovation>;
  /** update multiples rows of table: "renovation" */
  update_renovation_many?: Maybe<Array<Maybe<renovation_mutation_response>>>;
  /** update data of the table: "report" */
  update_report?: Maybe<report_mutation_response>;
  /** update single row of the table: "report" */
  update_report_by_pk?: Maybe<report>;
  /** update multiples rows of table: "report" */
  update_report_many?: Maybe<Array<Maybe<report_mutation_response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<user_mutation_response>;
  /** update data of the table: "user_building_permission" */
  update_user_building_permission?: Maybe<user_building_permission_mutation_response>;
  /** update single row of the table: "user_building_permission" */
  update_user_building_permission_by_pk?: Maybe<user_building_permission>;
  /** update multiples rows of table: "user_building_permission" */
  update_user_building_permission_many?: Maybe<Array<Maybe<user_building_permission_mutation_response>>>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<user>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<user_mutation_response>>>;
  /** update data of the table: "user_portfolio_permission" */
  update_user_portfolio_permission?: Maybe<user_portfolio_permission_mutation_response>;
  /** update single row of the table: "user_portfolio_permission" */
  update_user_portfolio_permission_by_pk?: Maybe<user_portfolio_permission>;
  /** update multiples rows of table: "user_portfolio_permission" */
  update_user_portfolio_permission_many?: Maybe<Array<Maybe<user_portfolio_permission_mutation_response>>>;
  uploadEnergyCertificateDraft: UploadEnergyCertificateDraftOutput;
  uploadFileToDriveFolder: UploadFileToDriveFolderOutput;
  upsertEconomicUnitWithBuildings: UpsertEconomicUnitWithBuildingsExternalOutput;
};

/** mutation root */
export type mutation_rootacceptAutofillReportArgs = {
  report_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootanswerQuestionsArgs = {
  answers: Array<AnswerParamsInput>;
  building_id?: InputMaybe<Scalars['Int']['input']>;
  report_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootapplyBuildingModelMutationsArgs = {
  building_model_id: Scalars['Int']['input'];
  building_model_mutation: BuildingModelMutation;
  dry_run: Scalars['Boolean']['input'];
  energy_consumer_mutations: Array<EnergyConsumerMutation>;
  energy_distribution_mutations: Array<EnergyDistributionMutation>;
  energy_producer_mutations: Array<EnergyProducerMutation>;
  energy_storage_mutations: Array<EnergyStorageMutation>;
  energy_system_mutations: Array<EnergySystemMutation>;
  envelope_mutations: Array<EnvelopeMutation>;
  save_invalid_state: Scalars['Boolean']['input'];
};

/** mutation root */
export type mutation_rootarchiveIntegrationBuildingArgs = {
  integration_building_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootarchiveMeterArgs = {
  meter_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootarchiveScenarioArgs = {
  scenario_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootbulkDeleteActionPlansArgs = {
  input: BulkDeleteActionPlansInput;
};

/** mutation root */
export type mutation_rootconfirmDriveUploadArgs = {
  input: ConfirmDriveUploadInput;
};

/** mutation root */
export type mutation_rootconfirmFileUploadArgs = {
  input: ConfirmFileUploadInput;
};

/** mutation root */
export type mutation_rootconvertFileToEnergyCertificateArgs = {
  input: ConvertFileToEnergyCertificateInput;
};

/** mutation root */
export type mutation_rootconvertFilesToEnergyCertificatesArgs = {
  autoCreateBuildings?: InputMaybe<Scalars['Boolean']['input']>;
  input: Array<ConvertFilesToEnergyCertificatesInput>;
};

/** mutation root */
export type mutation_rootcreateActionPlanArgs = {
  input: CreateActionPlanInput;
};

/** mutation root */
export type mutation_rootcreateBuildingFromBuildingDraftArgs = {
  buildingDraftId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootcreateBuildingModelTwinArgs = {
  buildingId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootcreateBulkActionArgs = {
  input: BulkActionInput;
};

/** mutation root */
export type mutation_rootcreateCertificateFileUploadURLArgs = {
  buildingDraftId?: InputMaybe<Scalars['Int']['input']>;
  buildingId?: InputMaybe<Scalars['Int']['input']>;
  fileName: Scalars['String']['input'];
};

/** mutation root */
export type mutation_rootcreateConsumptionDraftArgs = {
  areaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  buildingId: Scalars['Int']['input'];
  consumptionTypeId?: InputMaybe<consumption_type_enum>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  sourceTypeId: consumption_source_type_enum;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** mutation root */
export type mutation_rootcreateConsumptionFromDraftArgs = {
  areaIds: Array<Scalars['Int']['input']>;
  buildingId: Scalars['Int']['input'];
  consumptionDraftId: Scalars['Int']['input'];
  consumptionTypeId: consumption_type_enum;
  cost?: InputMaybe<Scalars['Float']['input']>;
  createdByUserId: Scalars['Int']['input'];
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  from: Scalars['DateTime']['input'];
  provider: Scalars['String']['input'];
  sourceTypeId: consumption_source_type_enum;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
  to: Scalars['DateTime']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** mutation root */
export type mutation_rootcreateConsumptionInvoiceDraftArgs = {
  building_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootcreateConsumptionInvoiceFromDraftArgs = {
  consumption_invoice_draft_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootcreateConsumptionWasteDetailsArgs = {
  amount: Scalars['Float']['input'];
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
  frequency: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
  volume: Scalars['Float']['input'];
};

/** mutation root */
export type mutation_rootcreateConsumptionWasteDetailsDraftArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  consumptionDraftId: Scalars['Int']['input'];
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
  frequency?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

/** mutation root */
export type mutation_rootcreateCustomFieldArgs = {
  entity: custom_field_entity_enum;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  suffix?: InputMaybe<Scalars['String']['input']>;
  type: custom_field_type_enum;
};

/** mutation root */
export type mutation_rootcreateCustomTargetArgs = {
  name: Scalars['String']['input'];
  target_definitions: Array<TargetDefinitionInput>;
};

/** mutation root */
export type mutation_rootcreateEmissionCertificateArgs = {
  emissionCertificate: CreateEmissionCertificateInput;
};

/** mutation root */
export type mutation_rootcreateEmissionCertificateDraftWithFileArgs = {
  emissionCertificateDraftWithoutFile: CreateEmissionCertificateDraftWithoutFileInput;
};

/** mutation root */
export type mutation_rootcreateEmissionCertificateDraftWithoutFileArgs = {
  emissionCertificateDraftWithoutFile: CreateEmissionCertificateDraftWithoutFileInput;
};

/** mutation root */
export type mutation_rootcreateEvidenceFromFileArgs = {
  report_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootcreateExclusionNoteArgs = {
  action_plan_stable_id: Scalars['Int']['input'];
  implementation_to: Scalars['DateTime']['input'];
  note: Scalars['String']['input'];
};

/** mutation root */
export type mutation_rootcreateExtractionsForFailedSnapshotsArgs = {
  nonBillableInternal?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type mutation_rootcreateExtractionsForNeedsReviewSnapshotsArgs = {
  nonBillableInternal?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type mutation_rootcreateFolderArgs = {
  input: CreateFolderInput;
};

/** mutation root */
export type mutation_rootcreateInboxArgs = {
  allowedSenders?: InputMaybe<Array<Scalars['String']['input']>>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  receiverEmail: Scalars['String']['input'];
};

/** mutation root */
export type mutation_rootcreateInvoiceSnapshotArgs = {
  extractionType: cbi_extraction_type_enum;
  invoiceId: Scalars['Int']['input'];
  nonBillableInternal?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  setActive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** mutation root */
export type mutation_rootcreateManualConsumptionArgs = {
  areaIds: Array<Scalars['Int']['input']>;
  buildingId: Scalars['Int']['input'];
  consumptionTypeId: consumption_type_enum;
  cost?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  from: Scalars['DateTime']['input'];
  provider: Scalars['String']['input'];
  sourceTypeId: ManualConsumptionSourceTypeEnum;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
  to: Scalars['DateTime']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
  wasteDetails?: InputMaybe<WasteDetailsInlineInput>;
};

/** mutation root */
export type mutation_rootcreateManualInvoiceSnapshotArgs = {
  fromSnapshotId?: InputMaybe<Scalars['Int']['input']>;
  invoiceId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootcreatePortfolioArgs = {
  baseEmissionFactorType?: InputMaybe<emission_factor_type_enum>;
  configId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** mutation root */
export type mutation_rootcreateReportArgs = {
  parameters: ReportInstantiationOptionsInput;
};

/** mutation root */
export type mutation_rootcreateScenarioArgs = {
  input: CreateScenarioInput;
};

/** mutation root */
export type mutation_rootcreateSharedBuildingSnapshotArgs = {
  buildingId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootcreateUserArgs = {
  auth0_user_id?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  org_id?: InputMaybe<Scalars['Int']['input']>;
  role: role_enum;
  role_description?: InputMaybe<Scalars['String']['input']>;
};

/** mutation root */
export type mutation_rootdeleteActionArgs = {
  action_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdeleteActionPlanArgs = {
  stableId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdeleteAllBuildingsArgs = {
  filters?: InputMaybe<BuildingWhere>;
  keepEmptyEconomicUnits?: InputMaybe<Scalars['Boolean']['input']>;
};

/** mutation root */
export type mutation_rootdeleteBuildingModelTwinArgs = {
  buildingModelId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdeleteBulkActionArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdeleteCBIInvoiceArgs = {
  invoiceId: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type mutation_rootdeleteCustomFieldArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdeleteCustomTargetArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdeleteEmissionCertificateArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdeleteFolderArgs = {
  input: DeleteFolderInput;
};

/** mutation root */
export type mutation_rootdeleteScenarioArgs = {
  input: DeleteScenarioInput;
};

/** mutation root */
export type mutation_rootdeleteSmartMeterIntegrationArgs = {
  integration_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdeleteTwinBuildingModelArgs = {
  buildingId: Scalars['Int']['input'];
  buildingModelId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdeleteUserArgs = {
  transfer_ownership_to_user_id?: InputMaybe<Scalars['Int']['input']>;
  user_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_buildingArgs = {
  where: building_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_building_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_building_district_heating_availabilityArgs = {
  where: building_district_heating_availability_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_building_district_heating_availability_by_pkArgs = {
  building_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_building_draftArgs = {
  where: building_draft_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_building_draft_areaArgs = {
  where: building_draft_area_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_building_draft_area_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_building_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_building_draft_consumerArgs = {
  where: building_draft_consumer_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_building_draft_consumer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_building_draft_valuationArgs = {
  where: building_draft_valuation_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_building_draft_valuation_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_building_valuationArgs = {
  where: building_valuation_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_building_valuation_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_consumptionArgs = {
  where: consumption_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_consumption_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_consumption_draftArgs = {
  where: consumption_draft_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_consumption_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_consumption_invoiceArgs = {
  where: consumption_invoice_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_consumption_invoice_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_consumption_invoice_draftArgs = {
  where: consumption_invoice_draft_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_consumption_invoice_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_consumption_waste_detailsArgs = {
  where: consumption_waste_details_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_consumption_waste_details_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_consumption_waste_details_draftArgs = {
  where: consumption_waste_details_draft_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_consumption_waste_details_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_economic_unitArgs = {
  where: economic_unit_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_economic_unit_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_emission_certificate_draftArgs = {
  where: emission_certificate_draft_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_emission_certificate_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_energy_certificateArgs = {
  where: energy_certificate_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_energy_certificate_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_energy_certificate_consumerArgs = {
  where: energy_certificate_consumer_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_energy_certificate_consumer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_energy_certificate_draftArgs = {
  where: energy_certificate_draft_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_energy_certificate_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_fileArgs = {
  where: file_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_file_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_inactive_buildingsArgs = {
  where: inactive_buildings_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_portfolioArgs = {
  where: portfolio_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_portfolio_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_reportArgs = {
  where: report_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_report_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_report_evidenceArgs = {
  where: report_evidence_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_report_evidence_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_report_question_evidenceArgs = {
  where: report_question_evidence_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_report_question_evidence_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_smart_meterArgs = {
  where: smart_meter_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_smart_meter_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_smart_meter_integration_buildingArgs = {
  where: smart_meter_integration_building_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_smart_meter_integration_building_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_user_building_permissionArgs = {
  where: user_building_permission_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_user_building_permission_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootdelete_user_portfolio_permissionArgs = {
  where: user_portfolio_permission_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_user_portfolio_permission_by_pkArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootduplicateBuildingModelVersionTwinArgs = {
  buildingId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  validFrom: Scalars['DateTime']['input'];
};

/** mutation root */
export type mutation_rootduplicateScenarioArgs = {
  input: DuplicateScenarioInput;
};

/** mutation root */
export type mutation_rooteditActionArgs = {
  action_id: Scalars['Int']['input'];
  create_ventilation_renovation_parameter?: InputMaybe<CreateVentilationRenovationParameterInput>;
  customCost?: InputMaybe<CustomCostInput>;
  custom_action_renovation_parameter?: InputMaybe<CustomActionRenovationParameterInput>;
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  energy_system_route_renovation_parameter?: InputMaybe<EnergySystemRouteRenovationParameterInput>;
  envelope_renovation_parameter?: InputMaybe<EnvelopeRenovationParameterInput>;
  hydraulic_balancing_renovation_parameter?: InputMaybe<HydraulicBalancingRenovationParameterInput>;
  implementation_to: Scalars['DateTime']['input'];
  maintenance_action_parameter?: InputMaybe<MaintenanceActionParameterInput>;
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
  solar_renovation_parameter?: InputMaybe<SolarRenovationParameterInput>;
  subsidies?: InputMaybe<Array<SubsidyInput>>;
  system_renovation_parameter?: InputMaybe<SystemRenovationParameterInput>;
  ventilation_renovation_parameter?: InputMaybe<VentilationRenovationParameterInput>;
};

/** mutation root */
export type mutation_rooteditAddressAssignmentsArgs = {
  assignments: Array<AssignBuildingAddressInput>;
  id: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type mutation_rooteditAreasArgs = {
  areas: Array<AreaUpdateInput>;
  buildingId: Scalars['Int']['input'];
  saveInvalidState: Scalars['Boolean']['input'];
};

/** mutation root */
export type mutation_rooteditBulkActionArgs = {
  input: BulkActionEditInput;
};

/** mutation root */
export type mutation_rooteditCertificatesArgs = {
  buildingDraftId?: InputMaybe<Scalars['Int']['input']>;
  buildingId?: InputMaybe<Scalars['Int']['input']>;
  deleteCertificates: Array<DeleteCertificate>;
  insertCertificates: Array<CreateCertificate>;
  updateCertificates: Array<EditCertificate>;
};

/** mutation root */
export type mutation_rooteditCustomFieldArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  showInAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

/** mutation root */
export type mutation_rooteditExclusionNoteArgs = {
  action_id: Scalars['Int']['input'];
  implementation_to: Scalars['DateTime']['input'];
  note: Scalars['String']['input'];
};

/** mutation root */
export type mutation_rooteditSnapshotArgs = {
  data?: InputMaybe<EditInvoiceSnapshotData>;
  editReason?: InputMaybe<Scalars['String']['input']>;
  extractionState: cbi_manual_review_state_enum;
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootexportClimateRiskV2ReportArgs = {
  buildingId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootexportFileArgs = {
  input: ExportFileInput;
};

/** mutation root */
export type mutation_rootexportReportAsExcelArgs = {
  report_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootexportReportAsPdfAsyncArgs = {
  report_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootexportScenarioAsExcelArgs = {
  action_plan_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  scenario_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootfillBuildingDraftArgs = {
  buildingDraftId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootimplementActionArgs = {
  action_plan_stable_id: Scalars['Int']['input'];
  create_ventilation_renovation_parameter?: InputMaybe<CreateVentilationRenovationParameterInput>;
  customCost?: InputMaybe<CustomCostInput>;
  custom_action_renovation_parameter?: InputMaybe<CustomActionRenovationParameterInput>;
  energy_system_route_renovation_parameter?: InputMaybe<EnergySystemRouteRenovationParameterInput>;
  envelope_renovation_parameter?: InputMaybe<EnvelopeRenovationParameterInput>;
  hydraulic_balancing_renovation_parameter?: InputMaybe<HydraulicBalancingRenovationParameterInput>;
  implementation_from: Scalars['DateTime']['input'];
  implementation_to: Scalars['DateTime']['input'];
  maintenance_action_parameter?: InputMaybe<MaintenanceActionParameterInput>;
  solar_renovation_parameter?: InputMaybe<SolarRenovationParameterInput>;
  subsidies?: Array<SubsidyInput>;
  system_renovation_parameter?: InputMaybe<SystemRenovationParameterInput>;
  ventilation_renovation_parameter?: InputMaybe<VentilationRenovationParameterInput>;
};

/** mutation root */
export type mutation_rootinsert_building_district_heating_availabilityArgs = {
  objects: Array<building_district_heating_availability_insert_input>;
  on_conflict?: InputMaybe<building_district_heating_availability_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_district_heating_availability_oneArgs = {
  object: building_district_heating_availability_insert_input;
  on_conflict?: InputMaybe<building_district_heating_availability_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_draftArgs = {
  objects: Array<building_draft_insert_input>;
  on_conflict?: InputMaybe<building_draft_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_draft_areaArgs = {
  objects: Array<building_draft_area_insert_input>;
  on_conflict?: InputMaybe<building_draft_area_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_draft_area_oneArgs = {
  object: building_draft_area_insert_input;
  on_conflict?: InputMaybe<building_draft_area_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_draft_consumerArgs = {
  objects: Array<building_draft_consumer_insert_input>;
  on_conflict?: InputMaybe<building_draft_consumer_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_draft_consumer_oneArgs = {
  object: building_draft_consumer_insert_input;
  on_conflict?: InputMaybe<building_draft_consumer_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_draft_oneArgs = {
  object: building_draft_insert_input;
  on_conflict?: InputMaybe<building_draft_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_draft_valuationArgs = {
  objects: Array<building_draft_valuation_insert_input>;
  on_conflict?: InputMaybe<building_draft_valuation_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_draft_valuation_oneArgs = {
  object: building_draft_valuation_insert_input;
  on_conflict?: InputMaybe<building_draft_valuation_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_valuationArgs = {
  objects: Array<building_valuation_insert_input>;
  on_conflict?: InputMaybe<building_valuation_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_building_valuation_oneArgs = {
  object: building_valuation_insert_input;
  on_conflict?: InputMaybe<building_valuation_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_economic_unitArgs = {
  objects: Array<economic_unit_insert_input>;
  on_conflict?: InputMaybe<economic_unit_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_economic_unit_oneArgs = {
  object: economic_unit_insert_input;
  on_conflict?: InputMaybe<economic_unit_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_energy_certificate_consumerArgs = {
  objects: Array<energy_certificate_consumer_insert_input>;
  on_conflict?: InputMaybe<energy_certificate_consumer_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_energy_certificate_consumer_oneArgs = {
  object: energy_certificate_consumer_insert_input;
  on_conflict?: InputMaybe<energy_certificate_consumer_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_fileArgs = {
  objects: Array<file_insert_input>;
  on_conflict?: InputMaybe<file_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_file_oneArgs = {
  object: file_insert_input;
  on_conflict?: InputMaybe<file_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_report_evidenceArgs = {
  objects: Array<report_evidence_insert_input>;
  on_conflict?: InputMaybe<report_evidence_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_report_evidence_oneArgs = {
  object: report_evidence_insert_input;
  on_conflict?: InputMaybe<report_evidence_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_building_permissionArgs = {
  objects: Array<user_building_permission_insert_input>;
  on_conflict?: InputMaybe<user_building_permission_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_building_permission_oneArgs = {
  object: user_building_permission_insert_input;
  on_conflict?: InputMaybe<user_building_permission_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_portfolio_permissionArgs = {
  objects: Array<user_portfolio_permission_insert_input>;
  on_conflict?: InputMaybe<user_portfolio_permission_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_portfolio_permission_oneArgs = {
  object: user_portfolio_permission_insert_input;
  on_conflict?: InputMaybe<user_portfolio_permission_on_conflict>;
};

/** mutation root */
export type mutation_rootinternalExportBuildingArgs = {
  buildingId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootinternalImportBuildingArgs = {
  body: Scalars['String']['input'];
  economicUnitId: Scalars['Int']['input'];
  responsibleUserId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootlinkSmartMeterArgs = {
  area_id: Scalars['Int']['input'];
  meter_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootlinkSmartMeterIntegrationBuildingArgs = {
  building_id: Scalars['Int']['input'];
  integration_building_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootmatchBuildingAddressesArgs = {
  snapshot: InvoiceSnapshotInput;
};

/** mutation root */
export type mutation_rootmoveAllBuildingsArgs = {
  destinationEconomicUnitId: Scalars['Int']['input'];
  filters?: InputMaybe<BuildingWhere>;
  keepEmptyEconomicUnits?: InputMaybe<Scalars['Boolean']['input']>;
};

/** mutation root */
export type mutation_rootmoveFileToFolderArgs = {
  input: MoveFileToFolderInput;
};

/** mutation root */
export type mutation_rootmoveFolderArgs = {
  input: MoveFolderInput;
};

/** mutation root */
export type mutation_rootpreviewEditAreasArgs = {
  areas: Array<AreaUpdateInput>;
  buildingId: Scalars['Int']['input'];
  saveInvalidState: Scalars['Boolean']['input'];
};

/** mutation root */
export type mutation_rootqueueBatchEsgAnalysisPdfExportArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  economicUnitId?: InputMaybe<Scalars['Int']['input']>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  useCustomTargetPath?: InputMaybe<Scalars['Boolean']['input']>;
};

/** mutation root */
export type mutation_rootqueueEconomicUnitEsgAnalysisPdfExportArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  economicUnitId: Scalars['Int']['input'];
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  useCustomTargetPath?: InputMaybe<Scalars['Boolean']['input']>;
};

/** mutation root */
export type mutation_rootqueueEsgAnalysisPdfExportArgs = {
  buildingId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  useCustomTargetPath?: InputMaybe<Scalars['Boolean']['input']>;
};

/** mutation root */
export type mutation_rootqueueExportActionPlanAsPdfArgs = {
  actionPlanStableId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  useCustomTargetPath?: InputMaybe<Scalars['Boolean']['input']>;
};

/** mutation root */
export type mutation_rootqueueSummaryOnePagerPdfExportArgs = {
  benchmarkPortfolioId?: InputMaybe<Scalars['Int']['input']>;
  buildingId: Scalars['Int']['input'];
  classOfUse?: InputMaybe<class_of_use_enum>;
  consumptionScopePerspective?: InputMaybe<scope_perspective_enum>;
  crremPathGraphType?: InputMaybe<crrem_path_graph_type_enum>;
  crremPathsType?: InputMaybe<Scalars['String']['input']>;
  demandScopePerspective?: InputMaybe<scope_perspective_enum>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  displayBase?: InputMaybe<Scalars['String']['input']>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear?: InputMaybe<Scalars['Int']['input']>;
  tab?: InputMaybe<status_quo_pdf_export_tab_enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  typeOfUse?: InputMaybe<type_of_use_enum>;
};

/** mutation root */
export type mutation_rootremoveEmptyEconomicUnitsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

/** mutation root */
export type mutation_rootremoveFileFromFolderArgs = {
  input: RemoveFileFromFolderInput;
};

/** mutation root */
export type mutation_rootrenameFileArgs = {
  input: RenameFileInput;
};

/** mutation root */
export type mutation_rootrenameFolderArgs = {
  input: RenameFolderInput;
};

/** mutation root */
export type mutation_rootresetAnswersArgs = {
  building_id?: InputMaybe<Scalars['Int']['input']>;
  report_id: Scalars['Int']['input'];
  root_question_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootresetBuildingDraftArgs = {
  buildingDraftId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootrevertToAutoAssignedAssignmentsArgs = {
  address: CBIAddressInput;
};

/** mutation root */
export type mutation_rootsetActiveBuildingModelArgs = {
  buildingId: Scalars['Int']['input'];
  buildingModelId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootsetActiveInvoiceSnapshotArgs = {
  snapshotId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootsetCommonOrgPreferencesArgs = {
  input: SetCommonOrgPreferencesInput;
};

/** mutation root */
export type mutation_rootsetCustomTargetActiveArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type mutation_rootsetDuplicateAsOriginalInvoiceArgs = {
  invoiceId: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type mutation_rootsetOrgCo2PriceCurveArgs = {
  input: SetOrgCo2PriceCurveInput;
};

/** mutation root */
export type mutation_rootsetOrgEmissionFactorPreferencesArgs = {
  input: SetOrgEmissionFactorPreferencesInput;
};

/** mutation root */
export type mutation_rootsetOrgEuTaxonomyDatasourceArgs = {
  input: SetOrgEuTaxonomyDatasourceInput;
};

/** mutation root */
export type mutation_rootsetSmartMeterIntegrationStateArgs = {
  integration_id: Scalars['Int']['input'];
  state: SmartMeterIntegrationRunState;
};

/** mutation root */
export type mutation_rootsetupMeterIntegrationArgs = {
  api_key: Scalars['String']['input'];
  api_secret: Scalars['String']['input'];
  integration_type: smart_meter_integration_type_enum;
  sync_interval_id: smart_meter_sync_interval_enum;
};

/** mutation root */
export type mutation_rootsimulateActionArgs = {
  action_plan_stable_id: Scalars['Int']['input'];
  create_ventilation_renovation_parameter?: InputMaybe<CreateVentilationRenovationParameterInput>;
  custom_action_renovation_parameter?: InputMaybe<CustomActionRenovationParameterInput>;
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  energy_system_route_renovation_parameter?: InputMaybe<EnergySystemRouteRenovationParameterInput>;
  envelope_renovation_parameter?: InputMaybe<EnvelopeRenovationParameterInput>;
  hydraulic_balancing_renovation_parameter?: InputMaybe<HydraulicBalancingRenovationParameterInput>;
  implementation_to: Scalars['DateTime']['input'];
  maintenance_action_parameter?: InputMaybe<MaintenanceActionParameterInput>;
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
  solar_renovation_parameter?: InputMaybe<SolarRenovationParameterInput>;
  subsidies?: InputMaybe<Array<SubsidyInput>>;
  system_renovation_parameter?: InputMaybe<SystemRenovationParameterInput>;
  ventilation_renovation_parameter?: InputMaybe<VentilationRenovationParameterInput>;
};

/** mutation root */
export type mutation_rootsimulateEditActionArgs = {
  action_id: Scalars['Int']['input'];
  create_ventilation_renovation_parameter?: InputMaybe<CreateVentilationRenovationParameterInput>;
  customCost?: InputMaybe<CustomCostInput>;
  custom_action_renovation_parameter?: InputMaybe<CustomActionRenovationParameterInput>;
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  energy_system_route_renovation_parameter?: InputMaybe<EnergySystemRouteRenovationParameterInput>;
  envelope_renovation_parameter?: InputMaybe<EnvelopeRenovationParameterInput>;
  hydraulic_balancing_renovation_parameter?: InputMaybe<HydraulicBalancingRenovationParameterInput>;
  implementation_to: Scalars['DateTime']['input'];
  maintenance_action_parameter?: InputMaybe<MaintenanceActionParameterInput>;
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
  solar_renovation_parameter?: InputMaybe<SolarRenovationParameterInput>;
  subsidies?: InputMaybe<Array<SubsidyInput>>;
  system_renovation_parameter?: InputMaybe<SystemRenovationParameterInput>;
  ventilation_renovation_parameter?: InputMaybe<VentilationRenovationParameterInput>;
};

/** mutation root */
export type mutation_rootsyncConsumptionsForCbiInvoiceArgs = {
  invoiceId: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type mutation_rootsyncMeterIntegrationArgs = {
  integration_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_roottransformEnergyCertificateDraftToEnergyCertificateArgs = {
  energyCertificateDraftId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_roottriggerCbiExportArgs = {
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type mutation_rootunarchiveIntegrationBuildingArgs = {
  integration_building_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootunarchiveMeterArgs = {
  meter_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootunarchiveScenarioArgs = {
  scenario_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootunlinkSmartMeterArgs = {
  meter_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootunlinkSmartMeterIntegrationBuildingArgs = {
  integration_building_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootupdateBuildingCustomDataArgs = {
  buildingId: Scalars['Int']['input'];
  customData: Scalars['JSON']['input'];
};

/** mutation root */
export type mutation_rootupdateBuildingLocationArgs = {
  approximate: Scalars['Boolean']['input'];
  buildingCitydbGmlIds?: InputMaybe<Array<Scalars['String']['input']>>;
  buildingId: Scalars['Float']['input'];
  coordinates?: InputMaybe<Coordinates>;
  lod1BuildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  neighborCitydbGmlIds?: InputMaybe<Array<Scalars['String']['input']>>;
  neighborLod1Ids?: InputMaybe<Array<Scalars['String']['input']>>;
  selectedIds: Array<Scalars['String']['input']>;
};

/** mutation root */
export type mutation_rootupdateBuildingModelTwinArgs = {
  buildingModelId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  validFrom: Scalars['DateTime']['input'];
};

/** mutation root */
export type mutation_rootupdateConsumptionArgs = {
  areaIds: Array<Scalars['Int']['input']>;
  consumptionId: Scalars['Int']['input'];
  consumptionTypeId: consumption_type_enum;
  cost?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  from: Scalars['DateTime']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
  to: Scalars['DateTime']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** mutation root */
export type mutation_rootupdateConsumptionDraftArgs = {
  areaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  consumptionDraftId: Scalars['Int']['input'];
  consumptionTypeId?: InputMaybe<consumption_type_enum>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** mutation root */
export type mutation_rootupdateConsumptionInvoiceArgs = {
  buildingId: Scalars['Int']['input'];
  consumptions: Array<ConsumptionInput>;
  invoiceDate: Scalars['DateTime']['input'];
  invoiceId: Scalars['Int']['input'];
  invoicePayer: invoice_payer_type_enum;
};

/** mutation root */
export type mutation_rootupdateConsumptionInvoiceDraftArgs = {
  buildingId: Scalars['Int']['input'];
  consumptionDrafts: Array<ConsumptionDraftInput>;
  draftStatus: draft_status_enum;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDraftId: Scalars['Int']['input'];
  invoicePayer?: InputMaybe<invoice_payer_type_enum>;
};

/** mutation root */
export type mutation_rootupdateConsumptionStateArgs = {
  consumptionId: Scalars['Int']['input'];
  state: consumption_state_enum;
};

/** mutation root */
export type mutation_rootupdateConsumptionWasteDetailsArgs = {
  amount: Scalars['Float']['input'];
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
  frequency: Scalars['Float']['input'];
  id: Scalars['Int']['input'];
  price: Scalars['Float']['input'];
  volume: Scalars['Float']['input'];
};

/** mutation root */
export type mutation_rootupdateConsumptionWasteDetailsDraftArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
  frequency?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

/** mutation root */
export type mutation_rootupdateCustomTargetArgs = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  target_definitions: Array<TargetDefinitionInput>;
};

/** mutation root */
export type mutation_rootupdateDuplicateInvoiceArgs = {
  duplicate?: InputMaybe<UpdateDuplicate>;
  invoiceId: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
};

/** mutation root */
export type mutation_rootupdateEconomicUnitCustomDataArgs = {
  customData: Scalars['JSON']['input'];
  economicUnitId: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootupdateEmissionCertificateDraftWithFileArgs = {
  emissionCertificateDraftWithoutFile: UpdateEmissionCertificateDraftWithoutFileInput;
};

/** mutation root */
export type mutation_rootupdateEmissionCertificateDraftWithoutFileArgs = {
  emissionCertificateDraftWithoutFile: UpdateEmissionCertificateDraftWithoutFileInput;
};

/** mutation root */
export type mutation_rootupdateEmissionCertificateFileArgs = {
  emission_certificate_id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootupdateEmissionCertificateWithoutFileArgs = {
  emissionCertificate: UpdateEmissionCertificateWithoutFileInput;
};

/** mutation root */
export type mutation_rootupdateInboxArgs = {
  allowedSenders?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
  receiverEmail: Scalars['String']['input'];
};

/** mutation root */
export type mutation_rootupdatePortfolioArgs = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  settings?: InputMaybe<UpdatePortfolioSettingsType>;
};

/** mutation root */
export type mutation_rootupdateSandboxFeatureFlagArgs = {
  flag: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

/** mutation root */
export type mutation_rootupdateScenarioArgs = {
  input: UpdateScenarioInput;
};

/** mutation root */
export type mutation_rootupdateScenarioToLatestVersionArgs = {
  id: Scalars['Int']['input'];
};

/** mutation root */
export type mutation_rootupdateSelectedIdsArgs = {
  buildingCitydbGmlIds?: InputMaybe<Array<Scalars['String']['input']>>;
  buildingId: Scalars['Float']['input'];
  coordinates?: InputMaybe<Coordinates>;
  expandSelection: Scalars['Boolean']['input'];
  lod1BuildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  neighborCitydbGmlIds?: InputMaybe<Array<Scalars['String']['input']>>;
  neighborLod1Ids?: InputMaybe<Array<Scalars['String']['input']>>;
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** mutation root */
export type mutation_rootupdateSmartMeterIntegrationArgs = {
  api_key?: InputMaybe<Scalars['String']['input']>;
  api_secret?: InputMaybe<Scalars['String']['input']>;
  integration_id: Scalars['Int']['input'];
  should_resume_integration?: InputMaybe<Scalars['Boolean']['input']>;
  sync_interval_id?: InputMaybe<smart_meter_sync_interval_enum>;
};

/** mutation root */
export type mutation_rootupdate_addressArgs = {
  _set?: InputMaybe<address_set_input>;
  where: address_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_address_by_pkArgs = {
  _set?: InputMaybe<address_set_input>;
  pk_columns: address_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_address_manyArgs = {
  updates: Array<address_updates>;
};

/** mutation root */
export type mutation_rootupdate_buildingArgs = {
  _inc?: InputMaybe<building_inc_input>;
  _set?: InputMaybe<building_set_input>;
  where: building_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_building_by_pkArgs = {
  _inc?: InputMaybe<building_inc_input>;
  _set?: InputMaybe<building_set_input>;
  pk_columns: building_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_building_district_heating_availabilityArgs = {
  _inc?: InputMaybe<building_district_heating_availability_inc_input>;
  _set?: InputMaybe<building_district_heating_availability_set_input>;
  where: building_district_heating_availability_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_building_district_heating_availability_by_pkArgs = {
  _inc?: InputMaybe<building_district_heating_availability_inc_input>;
  _set?: InputMaybe<building_district_heating_availability_set_input>;
  pk_columns: building_district_heating_availability_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_building_district_heating_availability_manyArgs = {
  updates: Array<building_district_heating_availability_updates>;
};

/** mutation root */
export type mutation_rootupdate_building_draftArgs = {
  _inc?: InputMaybe<building_draft_inc_input>;
  _set?: InputMaybe<building_draft_set_input>;
  where: building_draft_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_building_draft_areaArgs = {
  _inc?: InputMaybe<building_draft_area_inc_input>;
  _set?: InputMaybe<building_draft_area_set_input>;
  where: building_draft_area_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_building_draft_area_by_pkArgs = {
  _inc?: InputMaybe<building_draft_area_inc_input>;
  _set?: InputMaybe<building_draft_area_set_input>;
  pk_columns: building_draft_area_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_building_draft_area_manyArgs = {
  updates: Array<building_draft_area_updates>;
};

/** mutation root */
export type mutation_rootupdate_building_draft_by_pkArgs = {
  _inc?: InputMaybe<building_draft_inc_input>;
  _set?: InputMaybe<building_draft_set_input>;
  pk_columns: building_draft_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_building_draft_consumerArgs = {
  _inc?: InputMaybe<building_draft_consumer_inc_input>;
  _set?: InputMaybe<building_draft_consumer_set_input>;
  where: building_draft_consumer_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_building_draft_consumer_by_pkArgs = {
  _inc?: InputMaybe<building_draft_consumer_inc_input>;
  _set?: InputMaybe<building_draft_consumer_set_input>;
  pk_columns: building_draft_consumer_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_building_draft_consumer_manyArgs = {
  updates: Array<building_draft_consumer_updates>;
};

/** mutation root */
export type mutation_rootupdate_building_draft_manyArgs = {
  updates: Array<building_draft_updates>;
};

/** mutation root */
export type mutation_rootupdate_building_draft_valuationArgs = {
  _inc?: InputMaybe<building_draft_valuation_inc_input>;
  _set?: InputMaybe<building_draft_valuation_set_input>;
  where: building_draft_valuation_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_building_draft_valuation_by_pkArgs = {
  _inc?: InputMaybe<building_draft_valuation_inc_input>;
  _set?: InputMaybe<building_draft_valuation_set_input>;
  pk_columns: building_draft_valuation_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_building_draft_valuation_manyArgs = {
  updates: Array<building_draft_valuation_updates>;
};

/** mutation root */
export type mutation_rootupdate_building_manyArgs = {
  updates: Array<building_updates>;
};

/** mutation root */
export type mutation_rootupdate_building_valuationArgs = {
  _inc?: InputMaybe<building_valuation_inc_input>;
  _set?: InputMaybe<building_valuation_set_input>;
  where: building_valuation_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_building_valuation_by_pkArgs = {
  _inc?: InputMaybe<building_valuation_inc_input>;
  _set?: InputMaybe<building_valuation_set_input>;
  pk_columns: building_valuation_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_building_valuation_manyArgs = {
  updates: Array<building_valuation_updates>;
};

/** mutation root */
export type mutation_rootupdate_consumption_invoice_draftArgs = {
  _set?: InputMaybe<consumption_invoice_draft_set_input>;
  where: consumption_invoice_draft_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_consumption_invoice_draft_by_pkArgs = {
  _set?: InputMaybe<consumption_invoice_draft_set_input>;
  pk_columns: consumption_invoice_draft_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_consumption_invoice_draft_manyArgs = {
  updates: Array<consumption_invoice_draft_updates>;
};

/** mutation root */
export type mutation_rootupdate_economic_unitArgs = {
  _inc?: InputMaybe<economic_unit_inc_input>;
  _set?: InputMaybe<economic_unit_set_input>;
  where: economic_unit_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_economic_unit_by_pkArgs = {
  _inc?: InputMaybe<economic_unit_inc_input>;
  _set?: InputMaybe<economic_unit_set_input>;
  pk_columns: economic_unit_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_economic_unit_manyArgs = {
  updates: Array<economic_unit_updates>;
};

/** mutation root */
export type mutation_rootupdate_energy_certificate_consumerArgs = {
  _inc?: InputMaybe<energy_certificate_consumer_inc_input>;
  _set?: InputMaybe<energy_certificate_consumer_set_input>;
  where: energy_certificate_consumer_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_energy_certificate_consumer_by_pkArgs = {
  _inc?: InputMaybe<energy_certificate_consumer_inc_input>;
  _set?: InputMaybe<energy_certificate_consumer_set_input>;
  pk_columns: energy_certificate_consumer_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_energy_certificate_consumer_manyArgs = {
  updates: Array<energy_certificate_consumer_updates>;
};

/** mutation root */
export type mutation_rootupdate_energy_certificate_draftArgs = {
  _inc?: InputMaybe<energy_certificate_draft_inc_input>;
  _set?: InputMaybe<energy_certificate_draft_set_input>;
  where: energy_certificate_draft_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_energy_certificate_draft_by_pkArgs = {
  _inc?: InputMaybe<energy_certificate_draft_inc_input>;
  _set?: InputMaybe<energy_certificate_draft_set_input>;
  pk_columns: energy_certificate_draft_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_energy_certificate_draft_manyArgs = {
  updates: Array<energy_certificate_draft_updates>;
};

/** mutation root */
export type mutation_rootupdate_fileArgs = {
  _set?: InputMaybe<file_set_input>;
  where: file_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_file_by_pkArgs = {
  _set?: InputMaybe<file_set_input>;
  pk_columns: file_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_file_manyArgs = {
  updates: Array<file_updates>;
};

/** mutation root */
export type mutation_rootupdate_inactive_buildingsArgs = {
  _set?: InputMaybe<inactive_buildings_set_input>;
  where: inactive_buildings_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_inactive_buildings_manyArgs = {
  updates: Array<inactive_buildings_updates>;
};

/** mutation root */
export type mutation_rootupdate_notificationArgs = {
  _set?: InputMaybe<notification_set_input>;
  where: notification_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_notification_by_pkArgs = {
  _set?: InputMaybe<notification_set_input>;
  pk_columns: notification_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_notification_manyArgs = {
  updates: Array<notification_updates>;
};

/** mutation root */
export type mutation_rootupdate_renovationArgs = {
  _inc?: InputMaybe<renovation_inc_input>;
  _set?: InputMaybe<renovation_set_input>;
  where: renovation_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_renovation_by_pkArgs = {
  _inc?: InputMaybe<renovation_inc_input>;
  _set?: InputMaybe<renovation_set_input>;
  pk_columns: renovation_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_renovation_manyArgs = {
  updates: Array<renovation_updates>;
};

/** mutation root */
export type mutation_rootupdate_reportArgs = {
  _set?: InputMaybe<report_set_input>;
  where: report_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_report_by_pkArgs = {
  _set?: InputMaybe<report_set_input>;
  pk_columns: report_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_report_manyArgs = {
  updates: Array<report_updates>;
};

/** mutation root */
export type mutation_rootupdate_userArgs = {
  _set?: InputMaybe<user_set_input>;
  where: user_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_user_building_permissionArgs = {
  _set?: InputMaybe<user_building_permission_set_input>;
  where: user_building_permission_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_user_building_permission_by_pkArgs = {
  _set?: InputMaybe<user_building_permission_set_input>;
  pk_columns: user_building_permission_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_user_building_permission_manyArgs = {
  updates: Array<user_building_permission_updates>;
};

/** mutation root */
export type mutation_rootupdate_user_by_pkArgs = {
  _set?: InputMaybe<user_set_input>;
  pk_columns: user_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_user_manyArgs = {
  updates: Array<user_updates>;
};

/** mutation root */
export type mutation_rootupdate_user_portfolio_permissionArgs = {
  _set?: InputMaybe<user_portfolio_permission_set_input>;
  where: user_portfolio_permission_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_user_portfolio_permission_by_pkArgs = {
  _set?: InputMaybe<user_portfolio_permission_set_input>;
  pk_columns: user_portfolio_permission_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_user_portfolio_permission_manyArgs = {
  updates: Array<user_portfolio_permission_updates>;
};

/** mutation root */
export type mutation_rootuploadEnergyCertificateDraftArgs = {
  buildingDraftId: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
};

/** mutation root */
export type mutation_rootuploadFileToDriveFolderArgs = {
  input: UploadFileToDriveFolderInput;
};

/** mutation root */
export type mutation_rootupsertEconomicUnitWithBuildingsArgs = {
  buildings: Array<BuildingInput>;
  economicUnitData: Scalars['JSON']['input'];
  externalEconomicUnitId: Scalars['String']['input'];
  portfolioNamePrefix: Scalars['String']['input'];
};

/** A notification instance delivered to a specific user, based on a notification template. */
export type notification = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  notification_template: notification_template;
  /** Whether the user has read/acknowledged this notification. */
  read: Scalars['Boolean']['output'];
  /** The notification template defining the content and type. */
  template_id: Scalars['Int']['output'];
  /** An object relationship */
  user: user;
  /** The user who receives this notification. */
  user_id: Scalars['Int']['output'];
};

/** order by aggregate values of table "notification" */
export type notification_aggregate_order_by = {
  avg?: InputMaybe<notification_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<notification_max_order_by>;
  min?: InputMaybe<notification_min_order_by>;
  stddev?: InputMaybe<notification_stddev_order_by>;
  stddev_pop?: InputMaybe<notification_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<notification_stddev_samp_order_by>;
  sum?: InputMaybe<notification_sum_order_by>;
  var_pop?: InputMaybe<notification_var_pop_order_by>;
  var_samp?: InputMaybe<notification_var_samp_order_by>;
  variance?: InputMaybe<notification_variance_order_by>;
};

/** order by avg() on columns of table "notification" */
export type notification_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<order_by>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "notification". All fields are combined with a logical 'AND'. */
export type notification_bool_exp = {
  _and?: InputMaybe<Array<notification_bool_exp>>;
  _not?: InputMaybe<notification_bool_exp>;
  _or?: InputMaybe<Array<notification_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  notification_template?: InputMaybe<notification_template_bool_exp>;
  read?: InputMaybe<Boolean_comparison_exp>;
  template_id?: InputMaybe<Int_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<Int_comparison_exp>;
};

/** order by max() on columns of table "notification" */
export type notification_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<order_by>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "notification" */
export type notification_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<order_by>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<order_by>;
};

/** response of any mutation on the table "notification" */
export type notification_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<notification>;
};

/** Ordering options when selecting data from "notification". */
export type notification_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  notification_template?: InputMaybe<notification_template_order_by>;
  read?: InputMaybe<order_by>;
  template_id?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_id?: InputMaybe<order_by>;
};

/** primary key columns input for table: notification */
export type notification_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "notification" */
export enum notification_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  read = 'read',
  /** column name */
  template_id = 'template_id',
  /** column name */
  user_id = 'user_id',
}

/** input type for updating data in table "notification" */
export type notification_set_input = {
  /** Whether the user has read/acknowledged this notification. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "notification" */
export type notification_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<order_by>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "notification" */
export type notification_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<order_by>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "notification" */
export type notification_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<order_by>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "notification" */
export type notification_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: notification_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type notification_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user has read/acknowledged this notification. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<Scalars['Int']['input']>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "notification" */
export type notification_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<order_by>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<order_by>;
};

/** Template defining the content and routing for a notification event within an organization. */
export type notification_template = {
  /** Notification body text with details about the event. */
  description: Scalars['String']['output'];
  /** Deep link URL within the application to navigate the user to the relevant context. */
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  notifications: Array<notification>;
  /** Organization this notification belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** Notification title displayed to the user. */
  title: Scalars['String']['output'];
  /** Notification category (e.g., CBI_INVOICE_READY, REPORT_DUE). */
  type: notification_type_enum;
};

/** Template defining the content and routing for a notification event within an organization. */
export type notification_templatenotificationsArgs = {
  distinct_on?: InputMaybe<Array<notification_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<notification_order_by>>;
  where?: InputMaybe<notification_bool_exp>;
};

/** Boolean expression to filter rows from the table "notification_template". All fields are combined with a logical 'AND'. */
export type notification_template_bool_exp = {
  _and?: InputMaybe<Array<notification_template_bool_exp>>;
  _not?: InputMaybe<notification_template_bool_exp>;
  _or?: InputMaybe<Array<notification_template_bool_exp>>;
  description?: InputMaybe<String_comparison_exp>;
  href?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  notifications?: InputMaybe<notification_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  title?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<notification_type_enum_comparison_exp>;
};

/** Ordering options when selecting data from "notification_template". */
export type notification_template_order_by = {
  description?: InputMaybe<order_by>;
  href?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  notifications_aggregate?: InputMaybe<notification_aggregate_order_by>;
  org_id?: InputMaybe<order_by>;
  title?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
};

/** select columns of table "notification_template" */
export enum notification_template_select_column {
  /** column name */
  description = 'description',
  /** column name */
  href = 'href',
  /** column name */
  id = 'id',
  /** column name */
  org_id = 'org_id',
  /** column name */
  title = 'title',
  /** column name */
  type = 'type',
}

/** Streaming cursor of the table "notification_template" */
export type notification_template_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: notification_template_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type notification_template_stream_cursor_value_input = {
  /** Notification body text with details about the event. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Deep link URL within the application to navigate the user to the relevant context. */
  href?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization this notification belongs to. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Notification title displayed to the user. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Notification category (e.g., CBI_INVOICE_READY, REPORT_DUE). */
  type?: InputMaybe<notification_type_enum>;
};

export enum notification_type_enum {
  /** notification type for all users */
  GLOBAL_NOTIFICATION = 'GLOBAL_NOTIFICATION',
  /** notification type specific to a whole organisation */
  ORG_NOTIFICATION = 'ORG_NOTIFICATION',
  /** notification type specific to a single user */
  USER_NOTIFICATION = 'USER_NOTIFICATION',
}

/** Boolean expression to compare columns of type "notification_type_enum". All fields are combined with logical 'AND'. */
export type notification_type_enum_comparison_exp = {
  _eq?: InputMaybe<notification_type_enum>;
  _in?: InputMaybe<Array<notification_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<notification_type_enum>;
  _nin?: InputMaybe<Array<notification_type_enum>>;
};

export type notification_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<notification_set_input>;
  /** filter the rows which have to be updated */
  where: notification_bool_exp;
};

/** order by var_pop() on columns of table "notification" */
export type notification_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<order_by>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "notification" */
export type notification_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<order_by>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "notification" */
export type notification_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** The notification template defining the content and type. */
  template_id?: InputMaybe<order_by>;
  /** The user who receives this notification. */
  user_id?: InputMaybe<order_by>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type numeric_comparison_exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum order_by {
  /** in ascending order, nulls last */
  asc = 'asc',
  /** in ascending order, nulls first */
  asc_nulls_first = 'asc_nulls_first',
  /** in ascending order, nulls last */
  asc_nulls_last = 'asc_nulls_last',
  /** in descending order, nulls first */
  desc = 'desc',
  /** in descending order, nulls first */
  desc_nulls_first = 'desc_nulls_first',
  /** in descending order, nulls last */
  desc_nulls_last = 'desc_nulls_last',
}

/** Top-level tenant organization. All data in the platform is scoped to an org for multi-tenant isolation. */
export type org = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  logo?: Maybe<file>;
  /** Reference to the uploaded logo image file for this organization. */
  logo_file_id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Industry sector the organization operates in. References org_sector_type. */
  org_sector_type_id: org_sector_type_enum;
  /** Classification of the organization (e.g. CUSTOMER). References org_type. */
  org_type_id: org_type_enum;
  /** An array relationship */
  portfolios: Array<portfolio>;
  /** An aggregate relationship */
  portfolios_aggregate: portfolio_aggregate;
  /** Current lifecycle status of the organization (e.g. active, suspended). References org_status_type. */
  status_type_id: org_status_type_enum;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  users: Array<user>;
};

/** Top-level tenant organization. All data in the platform is scoped to an org for multi-tenant isolation. */
export type orgportfoliosArgs = {
  distinct_on?: InputMaybe<Array<portfolio_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<portfolio_order_by>>;
  where?: InputMaybe<portfolio_bool_exp>;
};

/** Top-level tenant organization. All data in the platform is scoped to an org for multi-tenant isolation. */
export type orgportfolios_aggregateArgs = {
  distinct_on?: InputMaybe<Array<portfolio_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<portfolio_order_by>>;
  where?: InputMaybe<portfolio_bool_exp>;
};

/** Top-level tenant organization. All data in the platform is scoped to an org for multi-tenant isolation. */
export type orgusersArgs = {
  distinct_on?: InputMaybe<Array<user_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_order_by>>;
  where?: InputMaybe<user_bool_exp>;
};

/** Boolean expression to filter rows from the table "org". All fields are combined with a logical 'AND'. */
export type org_bool_exp = {
  _and?: InputMaybe<Array<org_bool_exp>>;
  _not?: InputMaybe<org_bool_exp>;
  _or?: InputMaybe<Array<org_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  logo?: InputMaybe<file_bool_exp>;
  logo_file_id?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  org_sector_type_id?: InputMaybe<org_sector_type_enum_comparison_exp>;
  org_type_id?: InputMaybe<org_type_enum_comparison_exp>;
  portfolios?: InputMaybe<portfolio_bool_exp>;
  portfolios_aggregate?: InputMaybe<portfolio_aggregate_bool_exp>;
  status_type_id?: InputMaybe<org_status_type_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  users?: InputMaybe<user_bool_exp>;
};

/** Ordering options when selecting data from "org". */
export type org_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  logo?: InputMaybe<file_order_by>;
  logo_file_id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  org_sector_type_id?: InputMaybe<order_by>;
  org_type_id?: InputMaybe<order_by>;
  portfolios_aggregate?: InputMaybe<portfolio_aggregate_order_by>;
  status_type_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  users_aggregate?: InputMaybe<user_aggregate_order_by>;
};

export enum org_sector_type_enum {
  BANKING = 'BANKING',
  STANDARD = 'STANDARD',
}

/** Boolean expression to compare columns of type "org_sector_type_enum". All fields are combined with logical 'AND'. */
export type org_sector_type_enum_comparison_exp = {
  _eq?: InputMaybe<org_sector_type_enum>;
  _in?: InputMaybe<Array<org_sector_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<org_sector_type_enum>;
  _nin?: InputMaybe<Array<org_sector_type_enum>>;
};

/** select columns of table "org" */
export enum org_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  logo_file_id = 'logo_file_id',
  /** column name */
  name = 'name',
  /** column name */
  org_sector_type_id = 'org_sector_type_id',
  /** column name */
  org_type_id = 'org_type_id',
  /** column name */
  status_type_id = 'status_type_id',
  /** column name */
  updated_at = 'updated_at',
}

export enum org_status_type_enum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

/** Boolean expression to compare columns of type "org_status_type_enum". All fields are combined with logical 'AND'. */
export type org_status_type_enum_comparison_exp = {
  _eq?: InputMaybe<org_status_type_enum>;
  _in?: InputMaybe<Array<org_status_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<org_status_type_enum>;
  _nin?: InputMaybe<Array<org_status_type_enum>>;
};

/** Streaming cursor of the table "org" */
export type org_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: org_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type org_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Reference to the uploaded logo image file for this organization. */
  logo_file_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Industry sector the organization operates in. References org_sector_type. */
  org_sector_type_id?: InputMaybe<org_sector_type_enum>;
  /** Classification of the organization (e.g. CUSTOMER). References org_type. */
  org_type_id?: InputMaybe<org_type_enum>;
  /** Current lifecycle status of the organization (e.g. active, suspended). References org_status_type. */
  status_type_id?: InputMaybe<org_status_type_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export enum org_type_enum {
  CUSTOMER = 'CUSTOMER',
  DEMO = 'DEMO',
  INTERNAL = 'INTERNAL',
  TEMPLATE = 'TEMPLATE',
}

/** Boolean expression to compare columns of type "org_type_enum". All fields are combined with logical 'AND'. */
export type org_type_enum_comparison_exp = {
  _eq?: InputMaybe<org_type_enum>;
  _in?: InputMaybe<Array<org_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<org_type_enum>;
  _nin?: InputMaybe<Array<org_type_enum>>;
};

/** A named grouping of economic units and buildings within an organization, used for benchmarking and reporting. */
export type portfolio = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  economic_units: Array<economic_unit>;
  /** An aggregate relationship */
  economic_units_aggregate: economic_unit_aggregate;
  /** Which emission factor dataset to use for carbon calculations across this portfolio. */
  emission_factor_type_id?: Maybe<emission_factor_type_enum>;
  /** An object relationship */
  folder?: Maybe<folder>;
  /** A computed field, executes function "has_portfolio_write_permission" */
  has_write_permission: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  org: org;
  /** The organization this portfolio belongs to. */
  org_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_permissions: Array<user_portfolio_permission>;
  /** An aggregate relationship */
  user_permissions_aggregate: user_portfolio_permission_aggregate;
};

/** A named grouping of economic units and buildings within an organization, used for benchmarking and reporting. */
export type portfolioeconomic_unitsArgs = {
  distinct_on?: InputMaybe<Array<economic_unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<economic_unit_order_by>>;
  where?: InputMaybe<economic_unit_bool_exp>;
};

/** A named grouping of economic units and buildings within an organization, used for benchmarking and reporting. */
export type portfolioeconomic_units_aggregateArgs = {
  distinct_on?: InputMaybe<Array<economic_unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<economic_unit_order_by>>;
  where?: InputMaybe<economic_unit_bool_exp>;
};

/** A named grouping of economic units and buildings within an organization, used for benchmarking and reporting. */
export type portfoliouser_permissionsArgs = {
  distinct_on?: InputMaybe<Array<user_portfolio_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_portfolio_permission_order_by>>;
  where?: InputMaybe<user_portfolio_permission_bool_exp>;
};

/** A named grouping of economic units and buildings within an organization, used for benchmarking and reporting. */
export type portfoliouser_permissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<user_portfolio_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_portfolio_permission_order_by>>;
  where?: InputMaybe<user_portfolio_permission_bool_exp>;
};

/** aggregated selection of "portfolio" */
export type portfolio_aggregate = {
  aggregate?: Maybe<portfolio_aggregate_fields>;
  nodes: Array<portfolio>;
};

export type portfolio_aggregate_bool_exp = {
  count?: InputMaybe<portfolio_aggregate_bool_exp_count>;
};

export type portfolio_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<portfolio_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<portfolio_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "portfolio" */
export type portfolio_aggregate_fields = {
  avg?: Maybe<portfolio_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<portfolio_max_fields>;
  min?: Maybe<portfolio_min_fields>;
  stddev?: Maybe<portfolio_stddev_fields>;
  stddev_pop?: Maybe<portfolio_stddev_pop_fields>;
  stddev_samp?: Maybe<portfolio_stddev_samp_fields>;
  sum?: Maybe<portfolio_sum_fields>;
  var_pop?: Maybe<portfolio_var_pop_fields>;
  var_samp?: Maybe<portfolio_var_samp_fields>;
  variance?: Maybe<portfolio_variance_fields>;
};

/** aggregate fields of "portfolio" */
export type portfolio_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<portfolio_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "portfolio" */
export type portfolio_aggregate_order_by = {
  avg?: InputMaybe<portfolio_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<portfolio_max_order_by>;
  min?: InputMaybe<portfolio_min_order_by>;
  stddev?: InputMaybe<portfolio_stddev_order_by>;
  stddev_pop?: InputMaybe<portfolio_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<portfolio_stddev_samp_order_by>;
  sum?: InputMaybe<portfolio_sum_order_by>;
  var_pop?: InputMaybe<portfolio_var_pop_order_by>;
  var_samp?: InputMaybe<portfolio_var_samp_order_by>;
  variance?: InputMaybe<portfolio_variance_order_by>;
};

/** aggregate avg on columns */
export type portfolio_avg_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this portfolio belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "portfolio" */
export type portfolio_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "portfolio". All fields are combined with a logical 'AND'. */
export type portfolio_bool_exp = {
  _and?: InputMaybe<Array<portfolio_bool_exp>>;
  _not?: InputMaybe<portfolio_bool_exp>;
  _or?: InputMaybe<Array<portfolio_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  economic_units?: InputMaybe<economic_unit_bool_exp>;
  economic_units_aggregate?: InputMaybe<economic_unit_aggregate_bool_exp>;
  emission_factor_type_id?: InputMaybe<emission_factor_type_enum_comparison_exp>;
  folder?: InputMaybe<folder_bool_exp>;
  has_write_permission?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_permissions?: InputMaybe<user_portfolio_permission_bool_exp>;
  user_permissions_aggregate?: InputMaybe<user_portfolio_permission_aggregate_bool_exp>;
};

/** aggregate max on columns */
export type portfolio_max_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The organization this portfolio belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "portfolio" */
export type portfolio_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type portfolio_min_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The organization this portfolio belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "portfolio" */
export type portfolio_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** response of any mutation on the table "portfolio" */
export type portfolio_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<portfolio>;
};

/** Ordering options when selecting data from "portfolio". */
export type portfolio_order_by = {
  created_at?: InputMaybe<order_by>;
  economic_units_aggregate?: InputMaybe<economic_unit_aggregate_order_by>;
  emission_factor_type_id?: InputMaybe<order_by>;
  folder?: InputMaybe<folder_order_by>;
  has_write_permission?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_permissions_aggregate?: InputMaybe<user_portfolio_permission_aggregate_order_by>;
};

/** select columns of table "portfolio" */
export enum portfolio_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  emission_factor_type_id = 'emission_factor_type_id',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  org_id = 'org_id',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate stddev on columns */
export type portfolio_stddev_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this portfolio belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "portfolio" */
export type portfolio_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type portfolio_stddev_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this portfolio belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "portfolio" */
export type portfolio_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type portfolio_stddev_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this portfolio belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "portfolio" */
export type portfolio_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "portfolio" */
export type portfolio_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: portfolio_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type portfolio_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Which emission factor dataset to use for carbon calculations across this portfolio. */
  emission_factor_type_id?: InputMaybe<emission_factor_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type portfolio_sum_fields = {
  id?: Maybe<Scalars['Int']['output']>;
  /** The organization this portfolio belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "portfolio" */
export type portfolio_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type portfolio_var_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this portfolio belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "portfolio" */
export type portfolio_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type portfolio_var_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this portfolio belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "portfolio" */
export type portfolio_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type portfolio_variance_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this portfolio belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "portfolio" */
export type portfolio_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this portfolio belongs to. */
  org_id?: InputMaybe<order_by>;
};

export type query_root = {
  /** fetch data from the table: "action" */
  action: Array<action>;
  /** fetch aggregated fields from the table: "action" */
  action_aggregate: action_aggregate;
  /** fetch data from the table: "action" using primary key columns */
  action_by_pk?: Maybe<action>;
  /** fetch data from the table: "action_plan" */
  action_plan: Array<action_plan>;
  /** fetch data from the table: "action_subsidy" */
  action_subsidy: Array<action_subsidy>;
  /** fetch data from the table: "action_subsidy" using primary key columns */
  action_subsidy_by_pk?: Maybe<action_subsidy>;
  /** An array relationship */
  active_action_plans: Array<active_action_plans>;
  /** An aggregate relationship */
  active_action_plans_aggregate: active_action_plans_aggregate;
  /** fetch data from the table: "active_bulk_actions" */
  active_bulk_actions: Array<active_bulk_actions>;
  /** fetch aggregated fields from the table: "active_bulk_actions" */
  active_bulk_actions_aggregate: active_bulk_actions_aggregate;
  /** fetch data from the table: "address" */
  address: Array<address>;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<address>;
  /** fetch data from the table: "alpha_prompt_interaction" */
  alpha_prompt_interaction: Array<alpha_prompt_interaction>;
  /** fetch data from the table: "alpha_prompt_interaction" using primary key columns */
  alpha_prompt_interaction_by_pk?: Maybe<alpha_prompt_interaction>;
  /** fetch data from the table: "area" */
  area: Array<area>;
  /** fetch aggregated fields from the table: "area" */
  area_aggregate: area_aggregate;
  /** fetch data from the table: "area" using primary key columns */
  area_by_pk?: Maybe<area>;
  associatedBuildingsAndDrafts: EconomicUnitAmount;
  /** fetch data from the table: "async_job" */
  async_job: Array<async_job>;
  /** fetch aggregated fields from the table: "async_job" */
  async_job_aggregate: async_job_aggregate;
  /** fetch data from the table: "async_job" using primary key columns */
  async_job_by_pk?: Maybe<async_job>;
  /** fetch data from the table: "building" */
  building: Array<building>;
  /** fetch aggregated fields from the table: "building" */
  building_aggregate: building_aggregate;
  /** fetch data from the table: "building" using primary key columns */
  building_by_pk?: Maybe<building>;
  /** fetch data from the table: "building_district_heating_availability" */
  building_district_heating_availability: Array<building_district_heating_availability>;
  /** fetch data from the table: "building_district_heating_availability" using primary key columns */
  building_district_heating_availability_by_pk?: Maybe<building_district_heating_availability>;
  /** fetch data from the table: "building_draft" */
  building_draft: Array<building_draft>;
  /** fetch aggregated fields from the table: "building_draft" */
  building_draft_aggregate: building_draft_aggregate;
  /** fetch data from the table: "building_draft_area" */
  building_draft_area: Array<building_draft_area>;
  /** fetch data from the table: "building_draft_area" using primary key columns */
  building_draft_area_by_pk?: Maybe<building_draft_area>;
  /** fetch data from the table: "building_draft" using primary key columns */
  building_draft_by_pk?: Maybe<building_draft>;
  /** fetch data from the table: "building_draft_consumer" */
  building_draft_consumer: Array<building_draft_consumer>;
  /** fetch data from the table: "building_draft_consumer" using primary key columns */
  building_draft_consumer_by_pk?: Maybe<building_draft_consumer>;
  /** fetch data from the table: "building_draft_valuation" */
  building_draft_valuation: Array<building_draft_valuation>;
  /** fetch data from the table: "building_draft_valuation" using primary key columns */
  building_draft_valuation_by_pk?: Maybe<building_draft_valuation>;
  /** fetch data from the table: "building_model" */
  building_model: Array<building_model>;
  /** fetch data from the table: "building_model" using primary key columns */
  building_model_by_pk?: Maybe<building_model>;
  /** fetch data from the table: "building_permissions" */
  building_permissions: Array<building_permissions>;
  /** fetch data from the table: "building_subsidy" */
  building_subsidy: Array<building_subsidy>;
  /** fetch data from the table: "building_valuation" */
  building_valuation: Array<building_valuation>;
  /** fetch data from the table: "building_valuation" using primary key columns */
  building_valuation_by_pk?: Maybe<building_valuation>;
  /** fetch data from the table: "building_with_district_heating_status" */
  building_with_district_heating_status: Array<building_with_district_heating_status>;
  /** fetch data from the table: "bulk_action" */
  bulk_action: Array<bulk_action>;
  /** fetch aggregated fields from the table: "bulk_action" */
  bulk_action_aggregate: bulk_action_aggregate;
  /** fetch data from the table: "bulk_action" using primary key columns */
  bulk_action_by_pk?: Maybe<bulk_action>;
  /** fetch data from the table: "bulk_action_summary" */
  bulk_action_summary: Array<bulk_action_summary>;
  /** fetch aggregated fields from the table: "bulk_action_summary" */
  bulk_action_summary_aggregate: bulk_action_summary_aggregate;
  /** fetch data from the table: "bulk_actions_overview" */
  bulk_actions_overview: Array<bulk_actions_overview>;
  /** fetch aggregated fields from the table: "bulk_actions_overview" */
  bulk_actions_overview_aggregate: bulk_actions_overview_aggregate;
  canDeleteBulkAction: Scalars['Boolean']['output'];
  canEditBulkAction: Scalars['Boolean']['output'];
  cbiSnapshotIssues: CBISnapshotIssues;
  /** fetch data from the table: "cbi_address" */
  cbi_address: Array<cbi_address>;
  /** fetch aggregated fields from the table: "cbi_address" */
  cbi_address_aggregate: cbi_address_aggregate;
  /** fetch data from the table: "cbi_address_assignment" */
  cbi_address_assignment: Array<cbi_address_assignment>;
  /** fetch aggregated fields from the table: "cbi_address_assignment" */
  cbi_address_assignment_aggregate: cbi_address_assignment_aggregate;
  /** fetch data from the table: "cbi_address_assignment" using primary key columns */
  cbi_address_assignment_by_pk?: Maybe<cbi_address_assignment>;
  /** fetch data from the table: "cbi_address" using primary key columns */
  cbi_address_by_pk?: Maybe<cbi_address>;
  /** fetch data from the table: "cbi_billable_event" */
  cbi_billable_event: Array<cbi_billable_event>;
  /** fetch aggregated fields from the table: "cbi_billable_event" */
  cbi_billable_event_aggregate: cbi_billable_event_aggregate;
  /** fetch data from the table: "cbi_billable_event" using primary key columns */
  cbi_billable_event_by_pk?: Maybe<cbi_billable_event>;
  /** fetch data from the table: "cbi_billing_increment_event" */
  cbi_billing_increment_event: Array<cbi_billing_increment_event>;
  /** fetch aggregated fields from the table: "cbi_billing_increment_event" */
  cbi_billing_increment_event_aggregate: cbi_billing_increment_event_aggregate;
  /** fetch data from the table: "cbi_billing_increment_event" using primary key columns */
  cbi_billing_increment_event_by_pk?: Maybe<cbi_billing_increment_event>;
  /** fetch data from the table: "cbi_billing_period" */
  cbi_billing_period: Array<cbi_billing_period>;
  /** fetch aggregated fields from the table: "cbi_billing_period" */
  cbi_billing_period_aggregate: cbi_billing_period_aggregate;
  /** fetch data from the table: "cbi_billing_period" using primary key columns */
  cbi_billing_period_by_pk?: Maybe<cbi_billing_period>;
  /** fetch data from the table: "cbi_consumption_line" */
  cbi_consumption_line: Array<cbi_consumption_line>;
  /** fetch aggregated fields from the table: "cbi_consumption_line" */
  cbi_consumption_line_aggregate: cbi_consumption_line_aggregate;
  /** fetch data from the table: "cbi_consumption_line" using primary key columns */
  cbi_consumption_line_by_pk?: Maybe<cbi_consumption_line>;
  /** fetch data from the table: "cbi_email" */
  cbi_email: Array<cbi_email>;
  /** fetch data from the table: "cbi_email" using primary key columns */
  cbi_email_by_pk?: Maybe<cbi_email>;
  /** fetch data from the table: "cbi_export" */
  cbi_export: Array<cbi_export>;
  /** fetch aggregated fields from the table: "cbi_export" */
  cbi_export_aggregate: cbi_export_aggregate;
  /** fetch data from the table: "cbi_export" using primary key columns */
  cbi_export_by_pk?: Maybe<cbi_export>;
  /** fetch data from the table: "cbi_inbox" */
  cbi_inbox: Array<cbi_inbox>;
  /** fetch data from the table: "cbi_inbox" using primary key columns */
  cbi_inbox_by_pk?: Maybe<cbi_inbox>;
  /** fetch data from the table: "cbi_invoice" */
  cbi_invoice: Array<cbi_invoice>;
  /** fetch aggregated fields from the table: "cbi_invoice" */
  cbi_invoice_aggregate: cbi_invoice_aggregate;
  /** fetch data from the table: "cbi_invoice" using primary key columns */
  cbi_invoice_by_pk?: Maybe<cbi_invoice>;
  /** fetch data from the table: "cbi_invoice_snapshot" */
  cbi_invoice_snapshot: Array<cbi_invoice_snapshot>;
  /** fetch aggregated fields from the table: "cbi_invoice_snapshot" */
  cbi_invoice_snapshot_aggregate: cbi_invoice_snapshot_aggregate;
  /** fetch data from the table: "cbi_invoice_snapshot" using primary key columns */
  cbi_invoice_snapshot_by_pk?: Maybe<cbi_invoice_snapshot>;
  /** fetch data from the table: "cbi_potential_building_match" */
  cbi_potential_building_match: Array<cbi_potential_building_match>;
  /** fetch data from the table: "cbi_potential_building_match" using primary key columns */
  cbi_potential_building_match_by_pk?: Maybe<cbi_potential_building_match>;
  /** fetch data from the table: "certificate" */
  certificate: Array<certificate>;
  /** fetch aggregated fields from the table: "certificate" */
  certificate_aggregate: certificate_aggregate;
  /** fetch data from the table: "certificate" using primary key columns */
  certificate_by_pk?: Maybe<certificate>;
  /** fetch data from the table: "climate_risk" */
  climate_risk: Array<climate_risk>;
  /** fetch aggregated fields from the table: "climate_risk" */
  climate_risk_aggregate: climate_risk_aggregate;
  /** fetch data from the table: "climate_risk" using primary key columns */
  climate_risk_by_pk?: Maybe<climate_risk>;
  /** fetch data from the table: "climate_risk_v2" */
  climate_risk_v2: Array<climate_risk_v2>;
  /** fetch aggregated fields from the table: "climate_risk_v2" */
  climate_risk_v2_aggregate: climate_risk_v2_aggregate;
  /** fetch data from the table: "climate_risk_v2" using primary key columns */
  climate_risk_v2_by_pk?: Maybe<climate_risk_v2>;
  completeBuilding: BuildingCompleteOutput;
  /** fetch data from the table: "consumption" */
  consumption: Array<consumption>;
  /** fetch aggregated fields from the table: "consumption" */
  consumption_aggregate: consumption_aggregate;
  /** fetch data from the table: "consumption_area" */
  consumption_area: Array<consumption_area>;
  /** fetch data from the table: "consumption_area" using primary key columns */
  consumption_area_by_pk?: Maybe<consumption_area>;
  /** fetch data from the table: "consumption" using primary key columns */
  consumption_by_pk?: Maybe<consumption>;
  /** fetch data from the table: "consumption_draft" */
  consumption_draft: Array<consumption_draft>;
  /** fetch aggregated fields from the table: "consumption_draft" */
  consumption_draft_aggregate: consumption_draft_aggregate;
  /** fetch data from the table: "consumption_draft_area" */
  consumption_draft_area: Array<consumption_draft_area>;
  /** fetch data from the table: "consumption_draft_area" using primary key columns */
  consumption_draft_area_by_pk?: Maybe<consumption_draft_area>;
  /** fetch data from the table: "consumption_draft" using primary key columns */
  consumption_draft_by_pk?: Maybe<consumption_draft>;
  /** fetch data from the table: "consumption_frequency_type" */
  consumption_frequency_type: Array<consumption_frequency_type>;
  /** fetch data from the table: "consumption_frequency_type" using primary key columns */
  consumption_frequency_type_by_pk?: Maybe<consumption_frequency_type>;
  /** fetch data from the table: "consumption_invoice" */
  consumption_invoice: Array<consumption_invoice>;
  /** fetch data from the table: "consumption_invoice" using primary key columns */
  consumption_invoice_by_pk?: Maybe<consumption_invoice>;
  /** fetch data from the table: "consumption_invoice_draft" */
  consumption_invoice_draft: Array<consumption_invoice_draft>;
  /** fetch data from the table: "consumption_invoice_draft" using primary key columns */
  consumption_invoice_draft_by_pk?: Maybe<consumption_invoice_draft>;
  /** fetch data from the table: "consumption_waste_details" */
  consumption_waste_details: Array<consumption_waste_details>;
  /** fetch data from the table: "consumption_waste_details" using primary key columns */
  consumption_waste_details_by_pk?: Maybe<consumption_waste_details>;
  /** fetch data from the table: "consumption_waste_details_draft" */
  consumption_waste_details_draft: Array<consumption_waste_details_draft>;
  /** fetch data from the table: "consumption_waste_details_draft" using primary key columns */
  consumption_waste_details_draft_by_pk?: Maybe<consumption_waste_details_draft>;
  /** fetch data from the table: "cost_version" */
  cost_version: Array<cost_version>;
  /** fetch data from the table: "cost_version" using primary key columns */
  cost_version_by_pk?: Maybe<cost_version>;
  /** fetch data from the table: "custom_field" */
  custom_field: Array<custom_field>;
  /** fetch data from the table: "custom_field" using primary key columns */
  custom_field_by_pk?: Maybe<custom_field>;
  /** Danger: you probably want getActionPlanByStableId */
  danger_action_plan_by_pk?: Maybe<action_plan>;
  /** fetch data from the table: "economic_unit" */
  economic_unit: Array<economic_unit>;
  /** fetch aggregated fields from the table: "economic_unit" */
  economic_unit_aggregate: economic_unit_aggregate;
  /** fetch data from the table: "economic_unit" using primary key columns */
  economic_unit_by_pk?: Maybe<economic_unit>;
  /** fetch data from the table: "emission_certificate" */
  emission_certificate: Array<emission_certificate>;
  /** fetch aggregated fields from the table: "emission_certificate" */
  emission_certificate_aggregate: emission_certificate_aggregate;
  /** fetch data from the table: "emission_certificate" using primary key columns */
  emission_certificate_by_pk?: Maybe<emission_certificate>;
  /** fetch data from the table: "emission_certificate_draft" */
  emission_certificate_draft: Array<emission_certificate_draft>;
  /** fetch data from the table: "emission_certificate_draft" using primary key columns */
  emission_certificate_draft_by_pk?: Maybe<emission_certificate_draft>;
  /** fetch data from the table: "emission_certificate_value_path" */
  emission_certificate_value_path: Array<emission_certificate_value_path>;
  /** fetch data from the table: "emission_certificate_value_path" using primary key columns */
  emission_certificate_value_path_by_pk?: Maybe<emission_certificate_value_path>;
  /** fetch data from the table: "energy_certificate" */
  energy_certificate: Array<energy_certificate>;
  /** fetch data from the table: "energy_certificate" using primary key columns */
  energy_certificate_by_pk?: Maybe<energy_certificate>;
  /** fetch data from the table: "energy_certificate_consumer" */
  energy_certificate_consumer: Array<energy_certificate_consumer>;
  /** fetch data from the table: "energy_certificate_consumer" using primary key columns */
  energy_certificate_consumer_by_pk?: Maybe<energy_certificate_consumer>;
  /** fetch data from the table: "energy_certificate_draft" */
  energy_certificate_draft: Array<energy_certificate_draft>;
  /** fetch aggregated fields from the table: "energy_certificate_draft" */
  energy_certificate_draft_aggregate: energy_certificate_draft_aggregate;
  /** fetch data from the table: "energy_certificate_draft" using primary key columns */
  energy_certificate_draft_by_pk?: Maybe<energy_certificate_draft>;
  /** fetch data from the table: "energy_consumer" */
  energy_consumer: Array<energy_consumer>;
  /** fetch data from the table: "energy_consumer" using primary key columns */
  energy_consumer_by_pk?: Maybe<energy_consumer>;
  /** fetch data from the table: "energy_distribution" */
  energy_distribution: Array<energy_distribution>;
  /** fetch data from the table: "energy_distribution" using primary key columns */
  energy_distribution_by_pk?: Maybe<energy_distribution>;
  /** fetch data from the table: "energy_producer" */
  energy_producer: Array<energy_producer>;
  /** fetch data from the table: "energy_producer" using primary key columns */
  energy_producer_by_pk?: Maybe<energy_producer>;
  /** fetch data from the table: "energy_storage" */
  energy_storage: Array<energy_storage>;
  /** fetch data from the table: "energy_storage" using primary key columns */
  energy_storage_by_pk?: Maybe<energy_storage>;
  /** fetch data from the table: "energy_system" */
  energy_system: Array<energy_system>;
  /** fetch data from the table: "energy_system" using primary key columns */
  energy_system_by_pk?: Maybe<energy_system>;
  /** fetch data from the table: "energy_system_consumer_route" */
  energy_system_consumer_route: Array<energy_system_consumer_route>;
  /** fetch data from the table: "energy_system_consumer_route" using primary key columns */
  energy_system_consumer_route_by_pk?: Maybe<energy_system_consumer_route>;
  /** fetch data from the table: "energy_system_producer_route" */
  energy_system_producer_route: Array<energy_system_producer_route>;
  /** fetch data from the table: "energy_system_producer_route" using primary key columns */
  energy_system_producer_route_by_pk?: Maybe<energy_system_producer_route>;
  /** fetch data from the table: "envelope" */
  envelope: Array<envelope>;
  /** fetch data from the table: "envelope" using primary key columns */
  envelope_by_pk?: Maybe<envelope>;
  /** fetch data from the table: "export_template" */
  export_template: Array<export_template>;
  /** fetch aggregated fields from the table: "export_template" */
  export_template_aggregate: export_template_aggregate;
  /** fetch data from the table: "export_template" using primary key columns */
  export_template_by_pk?: Maybe<export_template>;
  fetchEmissionFactors: EmissionFactorsObject;
  fetchLastUsedTypesOfUse: FetchLastUsedTypesOfUseOutput;
  /** fetch data from the table: "file" */
  file: Array<file>;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk?: Maybe<file>;
  /** fetch data from the table: "file_chunk" */
  file_chunk: Array<file_chunk>;
  /** fetch data from the table: "file_chunk" using primary key columns */
  file_chunk_by_pk?: Maybe<file_chunk>;
  /** fetch data from the table: "file_chunk_file_link" */
  file_chunk_file_link: Array<file_chunk_file_link>;
  /** fetch data from the table: "file_chunk_file_link" using primary key columns */
  file_chunk_file_link_by_pk?: Maybe<file_chunk_file_link>;
  /** fetch data from the table: "folder" */
  folder: Array<folder>;
  /** fetch data from the table: "folder" using primary key columns */
  folder_by_pk?: Maybe<folder>;
  /** fetch data from the table: "folder_type" */
  folder_type: Array<folder_type>;
  /** fetch data from the table: "folder_type" using primary key columns */
  folder_type_by_pk?: Maybe<folder_type>;
  getActionParameters: ActionParametersUnion;
  getActionPlanByStableId: GetActionPlanByStableIdResponse;
  getActionPlanCustomTargetPath: CustomTargetPathLineOutput;
  getActionPlanImpactTrends: ActionPlanImpactTrendsOutput;
  getActionPlanInvestmentCost: InvestmentCostOutput;
  getActionPlanIsInconsistent: ActionPlanInconsistenciesOutput;
  getActionPlanList: ActionPlanListOutput;
  getActionPlanMetrics: ActionPlanMetricsOutput;
  getActiveCustomTarget?: Maybe<CustomTarget>;
  getAllCustomTargets: Array<CustomTarget>;
  getAllLatestReportTemplates: Array<Maybe<ReportTemplateOutput>>;
  getAnalyzedBuilding?: Maybe<AnalyzeBuildingOutputUnion>;
  getAnalyzedBuildingsAnalysis: AnalyzeBuildingsAnalysisOutputUnion;
  getAnalyzedBuildingsByEfficiencyClass: Array<BuildingsByEfficiencyClassOutput>;
  getAnalyzedBuildingsByEnergySourceType: Array<BuildingsByEnergySourceTypeOutput>;
  getAnalyzedBuildingsByTaxBracket: Array<BuildingsByTaxBracketOutput>;
  getAnalyzedBuildingsClimateRisks: Array<ClimateRiskOutput>;
  getAnalyzedBuildingsCore: AnalyzeBuildingsCoreOutput;
  getAnalyzedBuildingsCostPaths: AnalyzeBuildingsCostPathsOutput;
  getAnalyzedBuildingsEnergyData: Array<EnergyConsumerBuildingDataOutput>;
  getAnalyzedBuildingsEuTaxonomy: Array<BuildingsByEUTaxonomyComplianceOutput>;
  getAnalyzedBuildingsGeneralData: Array<BuildingsGeneralDataOutput>;
  getAnalyzedBuildingsKpis: AnalyzeBuildingsKpisOutput;
  getAnalyzedBuildingsSlfCompliance: AnalyzeBuildingsSlfComplianceOutput;
  getAnalyzedScenario: AnalyzeScenarioOutput;
  getAssociatedActionPlans: AssociatedActionPlansOutput;
  getAssociatedBuildings: AssociatedBuildingsOutput;
  getBatchEsgAnalysisPdfExportDownloadUrl: Scalars['String']['output'];
  getBenchmark: BuildingsBenchmarkOutputUnion;
  getBuildingCRREMConsumptionAnalysis?: Maybe<GetBuildingCRREMConsumptionAnalysisOutput>;
  getBuildingFolder: GetBuildingFolderOutput;
  getBuildingList: BuildingListOutput;
  getBuildingModelEfficiencyClass?: Maybe<efficiency_class_enum>;
  getBuildingModelEuTaxonomyCompliance?: Maybe<eu_taxonomy_compliance_enum>;
  getBuildingModelMutationAvailability: GetBuildingModelMutationAvailabilityOutput;
  getBuildingModelTaxBracket?: Maybe<tax_bracket_enum>;
  getBuildingPdfFiles: GetBuildingPdfFilesOutput;
  getBulkActionParameter: BulkActionParametersUnion;
  getCBIDownloadUrl: Scalars['String']['output'];
  getCo2EmissionsImpactTrend?: Maybe<Co2EmissionsImpactTrendOutput>;
  getConsumptionAllocation: ConsumptionAllocation;
  getConsumptionAllocationByScope123Perspective: ConsumptionAllocationByPerspective;
  getConsumptionAnalysis: ConsumptionAnalysis;
  getConsumptionBuildingList: ConsumptionBuildingListOutput;
  getConsumptionCO2IntensityDevelopment: Array<ConsumptionCO2IntensityDevelopmentItem>;
  getConsumptionCRREMPaths?: Maybe<ConsumptionCRREMPathsOutput>;
  getConsumptionCoverage: ConsumptionCoverageOutput;
  getConsumptionDeviationFromDemand: ConsumptionDeviationFromDemandOutput;
  getConsumptionDisplayValue?: Maybe<Scalars['Float']['output']>;
  getConsumptionDraftDisplayValue?: Maybe<Scalars['Float']['output']>;
  getConsumptionEnergySourcesByBuildingCount: Array<ConsumptionEnergySourceBuildingCountItem>;
  getConsumptionEnergySourcesByCO2Intensity: Array<ConsumptionEnergySourceBreakdownItem>;
  getConsumptionEnergySourcesByFinalEnergy: Array<ConsumptionEnergySourceBreakdownItem>;
  getConsumptionFinalEnergyDevelopment: Array<ConsumptionFinalEnergyDevelopmentItem>;
  getConsumptionGapMatrix: ConsumptionGapMatrixOutput;
  getConsumptionOverview: ConsumptionOverviewListOutput;
  getConsumptionPortfolioKPIs: ConsumptionPortfolioKPIsOutput;
  getCostByRenovationCategory?: Maybe<CostByRenovationCategoryOutput>;
  getCreateStatusQuo: SimulateActionStatusQuoOutput;
  getDefaultFeatureFlagValues: Array<Scalars['String']['output']>;
  getEconomicUnits: EconomicUnitsOutput;
  getEditStatusQuo: SimulateActionStatusQuoOutput;
  getEfficiencyClassSplitDevelopment?: Maybe<EfficiencyClassSplitDevelopmentOutput>;
  getEmissionCertificateDraft: EmissionCertificateDraftWithConvertedValues;
  getEmissionCertificateDrafts: EmissionCertificateDraftListOutput;
  getEmissionCertificates: EmissionCertificateListOutput;
  getEsgConsumptionAnalysisKPIs: EsgConsumptionAnalysis;
  getFileDownloadUrl: Scalars['String']['output'];
  getFileIdByAsyncJobId?: Maybe<GetFileIdByAsyncJobIdOutput>;
  getFilePreview: FilePreviewOutput;
  getFinalEnergyImpactTrend?: Maybe<FinalEnergyImpactTrendOutput>;
  getFloorAreaDevelopment: FloorAreaDevelopmentOutput;
  getFolderBreadcrumb: FolderBreadcrumbOutput;
  getFolderChildren: GetFolderChildrenOutput;
  getFolderContents: GetFolderContentsOutput;
  getGlbAccessCookies: GlbAccessResponse;
  getHeatTransferByVentilation: Scalars['Float']['output'];
  getHeatingEnergySourceDevelopment?: Maybe<HeatingEnergySourceDevelopmentOutput>;
  getOrgCustomFields: GetOrgCustomFieldsOutput;
  getOrgPreferences: OrgPreferences;
  getPrimaryEnergyImpactTrend?: Maybe<PrimaryEnergyImpactTrendOutput>;
  getReportMaxScore?: Maybe<Scalars['Float']['output']>;
  getRootFolderForTree: GetRootFolderForTreeOutput;
  getScenario: ScenarioOutput;
  getScenarioActionPlanAndActionsCounts: ScenarioActionPlanAndActionsCountsOutput;
  getScenarioCustomTargetPath: CustomTargetPathLineOutput;
  getScenarioInvestmentCost: InvestmentCostOutput;
  getScenarioList: ScenarioListOutput;
  getSessionData: GetSessionDataOutput;
  getSharedBuildingSnapshot?: Maybe<SharedBuildingSnapshotDataOutput>;
  getStrandingYearDistribution: StrandingYearDistributionOutput;
  getUserFeatureFlags: Array<Scalars['String']['output']>;
  getUserLoginHistory: GetUserLoginHistoryOutput;
  getYearlyConsumptionSummary: ConsumptionSummary;
  hasSingleBuildingOrDraft: Scalars['Boolean']['output'];
  /** An array relationship */
  inactive_buildings: Array<inactive_buildings>;
  /** fetch data from the table: "notification" */
  notification: Array<notification>;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<notification>;
  /** fetch data from the table: "notification_template" */
  notification_template: Array<notification_template>;
  /** fetch data from the table: "notification_template" using primary key columns */
  notification_template_by_pk?: Maybe<notification_template>;
  /** fetch data from the table: "org" */
  org: Array<org>;
  /** fetch data from the table: "org" using primary key columns */
  org_by_pk?: Maybe<org>;
  /** fetch data from the table: "portfolio" */
  portfolio: Array<portfolio>;
  /** fetch aggregated fields from the table: "portfolio" */
  portfolio_aggregate: portfolio_aggregate;
  /** fetch data from the table: "portfolio" using primary key columns */
  portfolio_by_pk?: Maybe<portfolio>;
  readClimateRiskV2Asset: ReadClimateRiskV2AssetOutput;
  readClimateRiskV2Report: ReadClimateRiskV2ReportOutput;
  recommendActions: RecommendActionsOutput;
  /** fetch data from the table: "renovation" */
  renovation: Array<renovation>;
  /** fetch data from the table: "renovation" using primary key columns */
  renovation_by_pk?: Maybe<renovation>;
  /** fetch data from the table: "renovation_energy_consumer" */
  renovation_energy_consumer: Array<renovation_energy_consumer>;
  /** fetch data from the table: "renovation_energy_producer" */
  renovation_energy_producer: Array<renovation_energy_producer>;
  /** fetch data from the table: "renovation_energy_system_route" */
  renovation_energy_system_route: Array<renovation_energy_system_route>;
  /** fetch data from the table: "renovation_envelope" */
  renovation_envelope: Array<renovation_envelope>;
  /** fetch data from the table: "report" */
  report: Array<report>;
  /** fetch aggregated fields from the table: "report" */
  report_aggregate: report_aggregate;
  /** fetch data from the table: "report_answer" */
  report_answer: Array<report_answer>;
  /** fetch aggregated fields from the table: "report_answer" */
  report_answer_aggregate: report_answer_aggregate;
  /** fetch data from the table: "report_answer_autofill_option" */
  report_answer_autofill_option: Array<report_answer_autofill_option>;
  /** fetch data from the table: "report_answer_autofill_option" using primary key columns */
  report_answer_autofill_option_by_pk?: Maybe<report_answer_autofill_option>;
  /** fetch data from the table: "report_answer" using primary key columns */
  report_answer_by_pk?: Maybe<report_answer>;
  /** fetch data from the table: "report_answer_chosen_option" */
  report_answer_chosen_option: Array<report_answer_chosen_option>;
  /** fetch data from the table: "report_answer_chosen_option" using primary key columns */
  report_answer_chosen_option_by_pk?: Maybe<report_answer_chosen_option>;
  /** fetch data from the table: "report_building" */
  report_building: Array<report_building>;
  /** fetch aggregated fields from the table: "report_building" */
  report_building_aggregate: report_building_aggregate;
  /** fetch data from the table: "report_building" using primary key columns */
  report_building_by_pk?: Maybe<report_building>;
  /** An array relationship */
  report_building_details: Array<report_building_details>;
  /** An aggregate relationship */
  report_building_details_aggregate: report_building_details_aggregate;
  /** fetch data from the table: "report" using primary key columns */
  report_by_pk?: Maybe<report>;
  /** fetch data from the table: "report_evidence" */
  report_evidence: Array<report_evidence>;
  /** fetch data from the table: "report_evidence" using primary key columns */
  report_evidence_by_pk?: Maybe<report_evidence>;
  /** fetch data from the table: "report_overview" */
  report_overview: Array<report_overview>;
  /** fetch data from the table: "report_question_evidence" */
  report_question_evidence: Array<report_question_evidence>;
  /** fetch data from the table: "report_question_evidence" using primary key columns */
  report_question_evidence_by_pk?: Maybe<report_question_evidence>;
  /** fetch data from the table: "report_score" */
  report_score: Array<report_score>;
  /** fetch data from the table: "report_score" using primary key columns */
  report_score_by_pk?: Maybe<report_score>;
  /** fetch data from the table: "report_section_progress" */
  report_section_progress: Array<report_section_progress>;
  /** fetch data from the table: "report_section_progress" using primary key columns */
  report_section_progress_by_pk?: Maybe<report_section_progress>;
  /** fetch data from the table: "report_template" */
  report_template: Array<report_template>;
  /** fetch data from the table: "report_template" using primary key columns */
  report_template_by_pk?: Maybe<report_template>;
  /** fetch data from the table: "report_template_question" */
  report_template_question: Array<report_template_question>;
  /** fetch aggregated fields from the table: "report_template_question" */
  report_template_question_aggregate: report_template_question_aggregate;
  /** fetch data from the table: "report_template_question" using primary key columns */
  report_template_question_by_pk?: Maybe<report_template_question>;
  /** fetch data from the table: "report_template_question_option" */
  report_template_question_option: Array<report_template_question_option>;
  /** fetch data from the table: "report_template_question_option" using primary key columns */
  report_template_question_option_by_pk?: Maybe<report_template_question_option>;
  /** fetch data from the table: "report_template_score" */
  report_template_score: Array<report_template_score>;
  /** fetch data from the table: "report_template_score" using primary key columns */
  report_template_score_by_pk?: Maybe<report_template_score>;
  /** fetch data from the table: "report_template_section" */
  report_template_section: Array<report_template_section>;
  /** fetch data from the table: "report_template_section" using primary key columns */
  report_template_section_by_pk?: Maybe<report_template_section>;
  /** fetch data from the table: "scenario" */
  scenario: Array<scenario>;
  /** fetch aggregated fields from the table: "scenario" */
  scenario_aggregate: scenario_aggregate;
  /** fetch data from the table: "scenario" using primary key columns */
  scenario_by_pk?: Maybe<scenario>;
  /** fetch data from the table: "scenario_version" */
  scenario_version: Array<scenario_version>;
  /** fetch aggregated fields from the table: "scenario_version" */
  scenario_version_aggregate: scenario_version_aggregate;
  /** fetch data from the table: "scenario_version" using primary key columns */
  scenario_version_by_pk?: Maybe<scenario_version>;
  searchBuildings: BuildingSearchListOutput;
  searchBuildingsForCreateActionPlan: BuildingCreateActionPlanSearchListOutput;
  /** fetch data from the table: "smart_meter" */
  smart_meter: Array<smart_meter>;
  /** fetch data from the table: "smart_meter" using primary key columns */
  smart_meter_by_pk?: Maybe<smart_meter>;
  /** fetch data from the table: "smart_meter_integration" */
  smart_meter_integration: Array<smart_meter_integration>;
  /** fetch data from the table: "smart_meter_integration_building" */
  smart_meter_integration_building: Array<smart_meter_integration_building>;
  /** fetch data from the table: "smart_meter_integration_building" using primary key columns */
  smart_meter_integration_building_by_pk?: Maybe<smart_meter_integration_building>;
  /** fetch data from the table: "smart_meter_integration" using primary key columns */
  smart_meter_integration_by_pk?: Maybe<smart_meter_integration>;
  /** fetch data from the table: "smart_meter_sync_checkpoint" */
  smart_meter_sync_checkpoint: Array<smart_meter_sync_checkpoint>;
  /** fetch data from the table: "smart_meter_sync_checkpoint" using primary key columns */
  smart_meter_sync_checkpoint_by_pk?: Maybe<smart_meter_sync_checkpoint>;
  /** fetch data from the table: "subsidy" */
  subsidy: Array<subsidy>;
  /** fetch data from the table: "subsidy" using primary key columns */
  subsidy_by_pk?: Maybe<subsidy>;
  /** fetch data from the table: "subsidy_subsidy_category" */
  subsidy_subsidy_category: Array<subsidy_subsidy_category>;
  /** fetch data from the table: "user" */
  user: Array<user>;
  /** fetch data from the table: "user_building_permission" */
  user_building_permission: Array<user_building_permission>;
  /** fetch data from the table: "user_building_permission" using primary key columns */
  user_building_permission_by_pk?: Maybe<user_building_permission>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<user>;
  /** fetch data from the table: "user_portfolio_permission" */
  user_portfolio_permission: Array<user_portfolio_permission>;
  /** fetch aggregated fields from the table: "user_portfolio_permission" */
  user_portfolio_permission_aggregate: user_portfolio_permission_aggregate;
  /** fetch data from the table: "user_portfolio_permission" using primary key columns */
  user_portfolio_permission_by_pk?: Maybe<user_portfolio_permission>;
};

export type query_rootactionArgs = {
  distinct_on?: InputMaybe<Array<action_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_order_by>>;
  where?: InputMaybe<action_bool_exp>;
};

export type query_rootaction_aggregateArgs = {
  distinct_on?: InputMaybe<Array<action_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_order_by>>;
  where?: InputMaybe<action_bool_exp>;
};

export type query_rootaction_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootaction_planArgs = {
  distinct_on?: InputMaybe<Array<action_plan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_plan_order_by>>;
  where?: InputMaybe<action_plan_bool_exp>;
};

export type query_rootaction_subsidyArgs = {
  distinct_on?: InputMaybe<Array<action_subsidy_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_subsidy_order_by>>;
  where?: InputMaybe<action_subsidy_bool_exp>;
};

export type query_rootaction_subsidy_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootactive_action_plansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_action_plans_order_by>>;
  where?: InputMaybe<active_action_plans_bool_exp>;
};

export type query_rootactive_action_plans_aggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_action_plans_order_by>>;
  where?: InputMaybe<active_action_plans_bool_exp>;
};

export type query_rootactive_bulk_actionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_bulk_actions_order_by>>;
  where?: InputMaybe<active_bulk_actions_bool_exp>;
};

export type query_rootactive_bulk_actions_aggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_bulk_actions_order_by>>;
  where?: InputMaybe<active_bulk_actions_bool_exp>;
};

export type query_rootaddressArgs = {
  distinct_on?: InputMaybe<Array<address_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<address_order_by>>;
  where?: InputMaybe<address_bool_exp>;
};

export type query_rootaddress_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootalpha_prompt_interactionArgs = {
  distinct_on?: InputMaybe<Array<alpha_prompt_interaction_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<alpha_prompt_interaction_order_by>>;
  where?: InputMaybe<alpha_prompt_interaction_bool_exp>;
};

export type query_rootalpha_prompt_interaction_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootareaArgs = {
  distinct_on?: InputMaybe<Array<area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<area_order_by>>;
  where?: InputMaybe<area_bool_exp>;
};

export type query_rootarea_aggregateArgs = {
  distinct_on?: InputMaybe<Array<area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<area_order_by>>;
  where?: InputMaybe<area_bool_exp>;
};

export type query_rootarea_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootassociatedBuildingsAndDraftsArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootasync_jobArgs = {
  distinct_on?: InputMaybe<Array<async_job_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<async_job_order_by>>;
  where?: InputMaybe<async_job_bool_exp>;
};

export type query_rootasync_job_aggregateArgs = {
  distinct_on?: InputMaybe<Array<async_job_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<async_job_order_by>>;
  where?: InputMaybe<async_job_bool_exp>;
};

export type query_rootasync_job_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootbuildingArgs = {
  distinct_on?: InputMaybe<Array<building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_order_by>>;
  where?: InputMaybe<building_bool_exp>;
};

export type query_rootbuilding_aggregateArgs = {
  distinct_on?: InputMaybe<Array<building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_order_by>>;
  where?: InputMaybe<building_bool_exp>;
};

export type query_rootbuilding_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootbuilding_district_heating_availabilityArgs = {
  distinct_on?: InputMaybe<Array<building_district_heating_availability_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_district_heating_availability_order_by>>;
  where?: InputMaybe<building_district_heating_availability_bool_exp>;
};

export type query_rootbuilding_district_heating_availability_by_pkArgs = {
  building_id: Scalars['Int']['input'];
};

export type query_rootbuilding_draftArgs = {
  distinct_on?: InputMaybe<Array<building_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_order_by>>;
  where?: InputMaybe<building_draft_bool_exp>;
};

export type query_rootbuilding_draft_aggregateArgs = {
  distinct_on?: InputMaybe<Array<building_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_order_by>>;
  where?: InputMaybe<building_draft_bool_exp>;
};

export type query_rootbuilding_draft_areaArgs = {
  distinct_on?: InputMaybe<Array<building_draft_area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_area_order_by>>;
  where?: InputMaybe<building_draft_area_bool_exp>;
};

export type query_rootbuilding_draft_area_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootbuilding_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootbuilding_draft_consumerArgs = {
  distinct_on?: InputMaybe<Array<building_draft_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_consumer_order_by>>;
  where?: InputMaybe<building_draft_consumer_bool_exp>;
};

export type query_rootbuilding_draft_consumer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootbuilding_draft_valuationArgs = {
  distinct_on?: InputMaybe<Array<building_draft_valuation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_valuation_order_by>>;
  where?: InputMaybe<building_draft_valuation_bool_exp>;
};

export type query_rootbuilding_draft_valuation_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootbuilding_modelArgs = {
  distinct_on?: InputMaybe<Array<building_model_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_model_order_by>>;
  where?: InputMaybe<building_model_bool_exp>;
};

export type query_rootbuilding_model_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootbuilding_permissionsArgs = {
  distinct_on?: InputMaybe<Array<building_permissions_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_permissions_order_by>>;
  where?: InputMaybe<building_permissions_bool_exp>;
};

export type query_rootbuilding_subsidyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_subsidy_order_by>>;
  where?: InputMaybe<building_subsidy_bool_exp>;
};

export type query_rootbuilding_valuationArgs = {
  distinct_on?: InputMaybe<Array<building_valuation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_valuation_order_by>>;
  where?: InputMaybe<building_valuation_bool_exp>;
};

export type query_rootbuilding_valuation_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootbuilding_with_district_heating_statusArgs = {
  distinct_on?: InputMaybe<Array<building_with_district_heating_status_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_with_district_heating_status_order_by>>;
  where?: InputMaybe<building_with_district_heating_status_bool_exp>;
};

export type query_rootbulk_actionArgs = {
  distinct_on?: InputMaybe<Array<bulk_action_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_action_order_by>>;
  where?: InputMaybe<bulk_action_bool_exp>;
};

export type query_rootbulk_action_aggregateArgs = {
  distinct_on?: InputMaybe<Array<bulk_action_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_action_order_by>>;
  where?: InputMaybe<bulk_action_bool_exp>;
};

export type query_rootbulk_action_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootbulk_action_summaryArgs = {
  distinct_on?: InputMaybe<Array<bulk_action_summary_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_action_summary_order_by>>;
  where?: InputMaybe<bulk_action_summary_bool_exp>;
};

export type query_rootbulk_action_summary_aggregateArgs = {
  distinct_on?: InputMaybe<Array<bulk_action_summary_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_action_summary_order_by>>;
  where?: InputMaybe<bulk_action_summary_bool_exp>;
};

export type query_rootbulk_actions_overviewArgs = {
  distinct_on?: InputMaybe<Array<bulk_actions_overview_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_actions_overview_order_by>>;
  where?: InputMaybe<bulk_actions_overview_bool_exp>;
};

export type query_rootbulk_actions_overview_aggregateArgs = {
  distinct_on?: InputMaybe<Array<bulk_actions_overview_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_actions_overview_order_by>>;
  where?: InputMaybe<bulk_actions_overview_bool_exp>;
};

export type query_rootcanDeleteBulkActionArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcanEditBulkActionArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbiSnapshotIssuesArgs = {
  snapshotId: Scalars['Int']['input'];
};

export type query_rootcbi_addressArgs = {
  distinct_on?: InputMaybe<Array<cbi_address_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_address_order_by>>;
  where?: InputMaybe<cbi_address_bool_exp>;
};

export type query_rootcbi_address_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_address_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_address_order_by>>;
  where?: InputMaybe<cbi_address_bool_exp>;
};

export type query_rootcbi_address_assignmentArgs = {
  distinct_on?: InputMaybe<Array<cbi_address_assignment_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_address_assignment_order_by>>;
  where?: InputMaybe<cbi_address_assignment_bool_exp>;
};

export type query_rootcbi_address_assignment_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_address_assignment_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_address_assignment_order_by>>;
  where?: InputMaybe<cbi_address_assignment_bool_exp>;
};

export type query_rootcbi_address_assignment_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_address_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_billable_eventArgs = {
  distinct_on?: InputMaybe<Array<cbi_billable_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billable_event_order_by>>;
  where?: InputMaybe<cbi_billable_event_bool_exp>;
};

export type query_rootcbi_billable_event_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_billable_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billable_event_order_by>>;
  where?: InputMaybe<cbi_billable_event_bool_exp>;
};

export type query_rootcbi_billable_event_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_billing_increment_eventArgs = {
  distinct_on?: InputMaybe<Array<cbi_billing_increment_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billing_increment_event_order_by>>;
  where?: InputMaybe<cbi_billing_increment_event_bool_exp>;
};

export type query_rootcbi_billing_increment_event_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_billing_increment_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billing_increment_event_order_by>>;
  where?: InputMaybe<cbi_billing_increment_event_bool_exp>;
};

export type query_rootcbi_billing_increment_event_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_billing_periodArgs = {
  distinct_on?: InputMaybe<Array<cbi_billing_period_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billing_period_order_by>>;
  where?: InputMaybe<cbi_billing_period_bool_exp>;
};

export type query_rootcbi_billing_period_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_billing_period_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billing_period_order_by>>;
  where?: InputMaybe<cbi_billing_period_bool_exp>;
};

export type query_rootcbi_billing_period_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_consumption_lineArgs = {
  distinct_on?: InputMaybe<Array<cbi_consumption_line_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_consumption_line_order_by>>;
  where?: InputMaybe<cbi_consumption_line_bool_exp>;
};

export type query_rootcbi_consumption_line_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_consumption_line_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_consumption_line_order_by>>;
  where?: InputMaybe<cbi_consumption_line_bool_exp>;
};

export type query_rootcbi_consumption_line_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_emailArgs = {
  distinct_on?: InputMaybe<Array<cbi_email_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_email_order_by>>;
  where?: InputMaybe<cbi_email_bool_exp>;
};

export type query_rootcbi_email_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_exportArgs = {
  distinct_on?: InputMaybe<Array<cbi_export_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_export_order_by>>;
  where?: InputMaybe<cbi_export_bool_exp>;
};

export type query_rootcbi_export_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_export_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_export_order_by>>;
  where?: InputMaybe<cbi_export_bool_exp>;
};

export type query_rootcbi_export_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_inboxArgs = {
  distinct_on?: InputMaybe<Array<cbi_inbox_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_inbox_order_by>>;
  where?: InputMaybe<cbi_inbox_bool_exp>;
};

export type query_rootcbi_inbox_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_invoiceArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_order_by>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

export type query_rootcbi_invoice_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_order_by>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

export type query_rootcbi_invoice_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_invoice_snapshotArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_snapshot_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_snapshot_order_by>>;
  where?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
};

export type query_rootcbi_invoice_snapshot_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_snapshot_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_snapshot_order_by>>;
  where?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
};

export type query_rootcbi_invoice_snapshot_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcbi_potential_building_matchArgs = {
  distinct_on?: InputMaybe<Array<cbi_potential_building_match_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_potential_building_match_order_by>>;
  where?: InputMaybe<cbi_potential_building_match_bool_exp>;
};

export type query_rootcbi_potential_building_match_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcertificateArgs = {
  distinct_on?: InputMaybe<Array<certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<certificate_order_by>>;
  where?: InputMaybe<certificate_bool_exp>;
};

export type query_rootcertificate_aggregateArgs = {
  distinct_on?: InputMaybe<Array<certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<certificate_order_by>>;
  where?: InputMaybe<certificate_bool_exp>;
};

export type query_rootcertificate_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootclimate_riskArgs = {
  distinct_on?: InputMaybe<Array<climate_risk_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_order_by>>;
  where?: InputMaybe<climate_risk_bool_exp>;
};

export type query_rootclimate_risk_aggregateArgs = {
  distinct_on?: InputMaybe<Array<climate_risk_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_order_by>>;
  where?: InputMaybe<climate_risk_bool_exp>;
};

export type query_rootclimate_risk_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootclimate_risk_v2Args = {
  distinct_on?: InputMaybe<Array<climate_risk_v2_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_v2_order_by>>;
  where?: InputMaybe<climate_risk_v2_bool_exp>;
};

export type query_rootclimate_risk_v2_aggregateArgs = {
  distinct_on?: InputMaybe<Array<climate_risk_v2_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_v2_order_by>>;
  where?: InputMaybe<climate_risk_v2_bool_exp>;
};

export type query_rootclimate_risk_v2_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcompleteBuildingArgs = {
  areaUsable?: InputMaybe<Scalars['Float']['input']>;
  buildingGmlIds?: InputMaybe<Array<Scalars['String']['input']>>;
  buildingLOD1Ids?: InputMaybe<Array<Scalars['String']['input']>>;
  energyData?: InputMaybe<Array<EnergyDataInput>>;
  geolocation?: InputMaybe<BuildingCompleteGeolocation>;
  typeOfUse?: InputMaybe<type_of_use_enum>;
  units?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type query_rootconsumptionArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

export type query_rootconsumption_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

export type query_rootconsumption_areaArgs = {
  distinct_on?: InputMaybe<Array<consumption_area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_area_order_by>>;
  where?: InputMaybe<consumption_area_bool_exp>;
};

export type query_rootconsumption_area_by_pkArgs = {
  area_id: Scalars['Int']['input'];
  building_id: Scalars['Int']['input'];
  consumption_id: Scalars['Int']['input'];
};

export type query_rootconsumption_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootconsumption_draftArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_order_by>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

export type query_rootconsumption_draft_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_order_by>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

export type query_rootconsumption_draft_areaArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_area_order_by>>;
  where?: InputMaybe<consumption_draft_area_bool_exp>;
};

export type query_rootconsumption_draft_area_by_pkArgs = {
  area_id: Scalars['Int']['input'];
  building_id: Scalars['Int']['input'];
  consumption_draft_id: Scalars['Int']['input'];
};

export type query_rootconsumption_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootconsumption_frequency_typeArgs = {
  distinct_on?: InputMaybe<Array<consumption_frequency_type_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_frequency_type_order_by>>;
  where?: InputMaybe<consumption_frequency_type_bool_exp>;
};

export type query_rootconsumption_frequency_type_by_pkArgs = {
  id: Scalars['String']['input'];
};

export type query_rootconsumption_invoiceArgs = {
  distinct_on?: InputMaybe<Array<consumption_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_invoice_order_by>>;
  where?: InputMaybe<consumption_invoice_bool_exp>;
};

export type query_rootconsumption_invoice_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootconsumption_invoice_draftArgs = {
  distinct_on?: InputMaybe<Array<consumption_invoice_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_invoice_draft_order_by>>;
  where?: InputMaybe<consumption_invoice_draft_bool_exp>;
};

export type query_rootconsumption_invoice_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootconsumption_waste_detailsArgs = {
  distinct_on?: InputMaybe<Array<consumption_waste_details_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_waste_details_order_by>>;
  where?: InputMaybe<consumption_waste_details_bool_exp>;
};

export type query_rootconsumption_waste_details_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootconsumption_waste_details_draftArgs = {
  distinct_on?: InputMaybe<Array<consumption_waste_details_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_waste_details_draft_order_by>>;
  where?: InputMaybe<consumption_waste_details_draft_bool_exp>;
};

export type query_rootconsumption_waste_details_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcost_versionArgs = {
  distinct_on?: InputMaybe<Array<cost_version_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cost_version_order_by>>;
  where?: InputMaybe<cost_version_bool_exp>;
};

export type query_rootcost_version_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootcustom_fieldArgs = {
  distinct_on?: InputMaybe<Array<custom_field_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<custom_field_order_by>>;
  where?: InputMaybe<custom_field_bool_exp>;
};

export type query_rootcustom_field_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootdanger_action_plan_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rooteconomic_unitArgs = {
  distinct_on?: InputMaybe<Array<economic_unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<economic_unit_order_by>>;
  where?: InputMaybe<economic_unit_bool_exp>;
};

export type query_rooteconomic_unit_aggregateArgs = {
  distinct_on?: InputMaybe<Array<economic_unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<economic_unit_order_by>>;
  where?: InputMaybe<economic_unit_bool_exp>;
};

export type query_rooteconomic_unit_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootemission_certificateArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_order_by>>;
  where?: InputMaybe<emission_certificate_bool_exp>;
};

export type query_rootemission_certificate_aggregateArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_order_by>>;
  where?: InputMaybe<emission_certificate_bool_exp>;
};

export type query_rootemission_certificate_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootemission_certificate_draftArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_draft_order_by>>;
  where?: InputMaybe<emission_certificate_draft_bool_exp>;
};

export type query_rootemission_certificate_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootemission_certificate_value_pathArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_value_path_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_value_path_order_by>>;
  where?: InputMaybe<emission_certificate_value_path_bool_exp>;
};

export type query_rootemission_certificate_value_path_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenergy_certificateArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_order_by>>;
  where?: InputMaybe<energy_certificate_bool_exp>;
};

export type query_rootenergy_certificate_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenergy_certificate_consumerArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_consumer_order_by>>;
  where?: InputMaybe<energy_certificate_consumer_bool_exp>;
};

export type query_rootenergy_certificate_consumer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenergy_certificate_draftArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_draft_order_by>>;
  where?: InputMaybe<energy_certificate_draft_bool_exp>;
};

export type query_rootenergy_certificate_draft_aggregateArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_draft_order_by>>;
  where?: InputMaybe<energy_certificate_draft_bool_exp>;
};

export type query_rootenergy_certificate_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenergy_consumerArgs = {
  distinct_on?: InputMaybe<Array<energy_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_consumer_order_by>>;
  where?: InputMaybe<energy_consumer_bool_exp>;
};

export type query_rootenergy_consumer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenergy_distributionArgs = {
  distinct_on?: InputMaybe<Array<energy_distribution_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_distribution_order_by>>;
  where?: InputMaybe<energy_distribution_bool_exp>;
};

export type query_rootenergy_distribution_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenergy_producerArgs = {
  distinct_on?: InputMaybe<Array<energy_producer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_producer_order_by>>;
  where?: InputMaybe<energy_producer_bool_exp>;
};

export type query_rootenergy_producer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenergy_storageArgs = {
  distinct_on?: InputMaybe<Array<energy_storage_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_storage_order_by>>;
  where?: InputMaybe<energy_storage_bool_exp>;
};

export type query_rootenergy_storage_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenergy_systemArgs = {
  distinct_on?: InputMaybe<Array<energy_system_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_order_by>>;
  where?: InputMaybe<energy_system_bool_exp>;
};

export type query_rootenergy_system_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenergy_system_consumer_routeArgs = {
  distinct_on?: InputMaybe<Array<energy_system_consumer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_consumer_route_order_by>>;
  where?: InputMaybe<energy_system_consumer_route_bool_exp>;
};

export type query_rootenergy_system_consumer_route_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenergy_system_producer_routeArgs = {
  distinct_on?: InputMaybe<Array<energy_system_producer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_producer_route_order_by>>;
  where?: InputMaybe<energy_system_producer_route_bool_exp>;
};

export type query_rootenergy_system_producer_route_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootenvelopeArgs = {
  distinct_on?: InputMaybe<Array<envelope_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<envelope_order_by>>;
  where?: InputMaybe<envelope_bool_exp>;
};

export type query_rootenvelope_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootexport_templateArgs = {
  distinct_on?: InputMaybe<Array<export_template_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<export_template_order_by>>;
  where?: InputMaybe<export_template_bool_exp>;
};

export type query_rootexport_template_aggregateArgs = {
  distinct_on?: InputMaybe<Array<export_template_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<export_template_order_by>>;
  where?: InputMaybe<export_template_bool_exp>;
};

export type query_rootexport_template_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootfetchEmissionFactorsArgs = {
  buildingId: Scalars['Float']['input'];
};

export type query_rootfileArgs = {
  distinct_on?: InputMaybe<Array<file_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<file_order_by>>;
  where?: InputMaybe<file_bool_exp>;
};

export type query_rootfile_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootfile_chunkArgs = {
  distinct_on?: InputMaybe<Array<file_chunk_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<file_chunk_order_by>>;
  where?: InputMaybe<file_chunk_bool_exp>;
};

export type query_rootfile_chunk_by_pkArgs = {
  id: Scalars['uuid']['input'];
};

export type query_rootfile_chunk_file_linkArgs = {
  distinct_on?: InputMaybe<Array<file_chunk_file_link_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<file_chunk_file_link_order_by>>;
  where?: InputMaybe<file_chunk_file_link_bool_exp>;
};

export type query_rootfile_chunk_file_link_by_pkArgs = {
  chunk_id: Scalars['uuid']['input'];
};

export type query_rootfolderArgs = {
  distinct_on?: InputMaybe<Array<folder_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<folder_order_by>>;
  where?: InputMaybe<folder_bool_exp>;
};

export type query_rootfolder_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootfolder_typeArgs = {
  distinct_on?: InputMaybe<Array<folder_type_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<folder_type_order_by>>;
  where?: InputMaybe<folder_type_bool_exp>;
};

export type query_rootfolder_type_by_pkArgs = {
  id: Scalars['String']['input'];
};

export type query_rootgetActionParametersArgs = {
  actionId: Scalars['Int']['input'];
};

export type query_rootgetActionPlanByStableIdArgs = {
  stableId: Scalars['Int']['input'];
};

export type query_rootgetActionPlanCustomTargetPathArgs = {
  stable_id: Scalars['Int']['input'];
};

export type query_rootgetActionPlanImpactTrendsArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  stableId: Scalars['Int']['input'];
};

export type query_rootgetActionPlanInvestmentCostArgs = {
  stable_id: Scalars['Int']['input'];
};

export type query_rootgetActionPlanIsInconsistentArgs = {
  stableId: Scalars['Int']['input'];
};

export type query_rootgetActionPlanListArgs = {
  buildingWhere?: InputMaybe<BuildingWhere>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionPlanListOrderByInput>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenarioId: Scalars['Int']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type query_rootgetActionPlanMetricsArgs = {
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
  stable_id: Scalars['Int']['input'];
};

export type query_rootgetActiveCustomTargetArgs = {
  target_definition_type?: InputMaybe<target_definition_type_enum>;
};

export type query_rootgetAnalyzedBuildingArgs = {
  building_id: Scalars['Int']['input'];
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  year: Scalars['Int']['input'];
};

export type query_rootgetAnalyzedBuildingsAnalysisArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsByEfficiencyClassArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsByEnergySourceTypeArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsByTaxBracketArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsClimateRisksArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsCoreArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsCostPathsArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsEnergyDataArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsEuTaxonomyArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsGeneralDataArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsKpisArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedBuildingsSlfComplianceArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetAnalyzedScenarioArgs = {
  comparison_year?: InputMaybe<Scalars['Int']['input']>;
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetAssociatedActionPlansArgs = {
  emissionCertificateId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type query_rootgetAssociatedBuildingsArgs = {
  emissionCertificateId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type query_rootgetBatchEsgAnalysisPdfExportDownloadUrlArgs = {
  asyncJobId: Scalars['Int']['input'];
};

export type query_rootgetBenchmarkArgs = {
  classOfUse?: InputMaybe<class_of_use_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  typeOfUse?: InputMaybe<type_of_use_enum>;
};

export type query_rootgetBuildingCRREMConsumptionAnalysisArgs = {
  building_id: Scalars['Int']['input'];
  perspective?: InputMaybe<scope_perspective_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  year: Scalars['Int']['input'];
};

export type query_rootgetBuildingFolderArgs = {
  buildingId: Scalars['Int']['input'];
};

export type query_rootgetBuildingListArgs = {
  checkAccess?: InputMaybe<CheckAccess>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BuildingOrderByInput>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  where: BuildingWhere;
};

export type query_rootgetBuildingModelEfficiencyClassArgs = {
  buildingModelId: Scalars['Int']['input'];
};

export type query_rootgetBuildingModelEuTaxonomyComplianceArgs = {
  buildingModelId: Scalars['Int']['input'];
};

export type query_rootgetBuildingModelMutationAvailabilityArgs = {
  building_model_id: Scalars['Int']['input'];
};

export type query_rootgetBuildingModelTaxBracketArgs = {
  buildingModelId: Scalars['Int']['input'];
};

export type query_rootgetBuildingPdfFilesArgs = {
  buildingId: Scalars['Int']['input'];
};

export type query_rootgetBulkActionParameterArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootgetCBIDownloadUrlArgs = {
  file_id: Scalars['Float']['input'];
};

export type query_rootgetCo2EmissionsImpactTrendArgs = {
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetConsumptionAllocationArgs = {
  building_id: Scalars['Int']['input'];
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  perspective?: InputMaybe<scope_perspective_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  year: Scalars['Int']['input'];
};

export type query_rootgetConsumptionAllocationByScope123PerspectiveArgs = {
  building_id: Scalars['Int']['input'];
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  perspective?: InputMaybe<scope_perspective_enum>;
  year: Scalars['Int']['input'];
};

export type query_rootgetConsumptionAnalysisArgs = {
  building_id: Scalars['Int']['input'];
  fromYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  toYear: Scalars['Int']['input'];
};

export type query_rootgetConsumptionBuildingListArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<ConsumptionBuildingOrderByInput>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear: Scalars['Int']['input'];
  where: BuildingWhere;
};

export type query_rootgetConsumptionCO2IntensityDevelopmentArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear: Scalars['Int']['input'];
  where: BuildingWhere;
};

export type query_rootgetConsumptionCRREMPathsArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear: Scalars['Int']['input'];
  where: BuildingWhere;
};

export type query_rootgetConsumptionCoverageArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear: Scalars['Int']['input'];
  where: BuildingWhere;
};

export type query_rootgetConsumptionDeviationFromDemandArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear: Scalars['Int']['input'];
  where: BuildingWhere;
};

export type query_rootgetConsumptionDisplayValueArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootgetConsumptionDraftDisplayValueArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootgetConsumptionEnergySourcesByBuildingCountArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear: Scalars['Int']['input'];
  where: BuildingWhere;
};

export type query_rootgetConsumptionEnergySourcesByCO2IntensityArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear: Scalars['Int']['input'];
  where: BuildingWhere;
};

export type query_rootgetConsumptionEnergySourcesByFinalEnergyArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear: Scalars['Int']['input'];
  where: BuildingWhere;
};

export type query_rootgetConsumptionFinalEnergyDevelopmentArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear: Scalars['Int']['input'];
  where: BuildingWhere;
};

export type query_rootgetConsumptionGapMatrixArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  reportingYear?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<BuildingWhere>;
};

export type query_rootgetConsumptionOverviewArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<ConsumptionOverviewOrderByInput>;
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  reportingYear?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConsumptionOverviewWhere>;
};

export type query_rootgetConsumptionPortfolioKPIsArgs = {
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  reportingYear: Scalars['Int']['input'];
  where: BuildingWhere;
};

export type query_rootgetCostByRenovationCategoryArgs = {
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetCreateStatusQuoArgs = {
  action_plan_stable_id: Scalars['Int']['input'];
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  new_date: Scalars['DateTime']['input'];
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
};

export type query_rootgetEconomicUnitsArgs = {
  checkAccess?: InputMaybe<CheckAccess>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EconomicUnitsOrderByInput>;
  where: BuildingWhere;
};

export type query_rootgetEditStatusQuoArgs = {
  action_id: Scalars['Int']['input'];
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  new_date: Scalars['DateTime']['input'];
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
};

export type query_rootgetEfficiencyClassSplitDevelopmentArgs = {
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetEmissionCertificateDraftArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootgetEmissionCertificateDraftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmissionCertificateDraftOrderByInput>;
  where?: InputMaybe<EmissionCertificateDraftWhereInput>;
};

export type query_rootgetEmissionCertificatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EmissionCertificateOrderByInput>;
  where?: InputMaybe<EmissionCertificateWhereInput>;
};

export type query_rootgetEsgConsumptionAnalysisKPIsArgs = {
  buildingId: Scalars['Int']['input'];
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  year: Scalars['Int']['input'];
};

export type query_rootgetFileDownloadUrlArgs = {
  id: Scalars['Float']['input'];
};

export type query_rootgetFileIdByAsyncJobIdArgs = {
  asyncJobId: Scalars['Int']['input'];
};

export type query_rootgetFilePreviewArgs = {
  fileId: Scalars['Int']['input'];
};

export type query_rootgetFinalEnergyImpactTrendArgs = {
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetFloorAreaDevelopmentArgs = {
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetFolderBreadcrumbArgs = {
  folderId: Scalars['Int']['input'];
};

export type query_rootgetFolderChildrenArgs = {
  parentIds: Array<Scalars['Int']['input']>;
};

export type query_rootgetFolderContentsArgs = {
  folderId: Scalars['Int']['input'];
};

export type query_rootgetGlbAccessCookiesArgs = {
  glbPath?: InputMaybe<Scalars['String']['input']>;
};

export type query_rootgetHeatTransferByVentilationArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootgetHeatingEnergySourceDevelopmentArgs = {
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetPrimaryEnergyImpactTrendArgs = {
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetReportMaxScoreArgs = {
  reportScoreId: Scalars['Int']['input'];
};

export type query_rootgetScenarioArgs = {
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetScenarioActionPlanAndActionsCountsArgs = {
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetScenarioCustomTargetPathArgs = {
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetScenarioInvestmentCostArgs = {
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetScenarioListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScenarioOrderByInput>;
  where?: InputMaybe<ScenarioWhere>;
};

export type query_rootgetSessionDataArgs = {
  args: SessionDataInput;
};

export type query_rootgetSharedBuildingSnapshotArgs = {
  hash: Scalars['String']['input'];
};

export type query_rootgetStrandingYearDistributionArgs = {
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  scenario_id: Scalars['Int']['input'];
};

export type query_rootgetUserLoginHistoryArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  user_id: Scalars['Int']['input'];
};

export type query_rootgetYearlyConsumptionSummaryArgs = {
  building_id: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type query_roothasSingleBuildingOrDraftArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type query_rootinactive_buildingsArgs = {
  distinct_on?: InputMaybe<Array<inactive_buildings_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<inactive_buildings_order_by>>;
  where?: InputMaybe<inactive_buildings_bool_exp>;
};

export type query_rootnotificationArgs = {
  distinct_on?: InputMaybe<Array<notification_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<notification_order_by>>;
  where?: InputMaybe<notification_bool_exp>;
};

export type query_rootnotification_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootnotification_templateArgs = {
  distinct_on?: InputMaybe<Array<notification_template_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<notification_template_order_by>>;
  where?: InputMaybe<notification_template_bool_exp>;
};

export type query_rootnotification_template_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootorgArgs = {
  distinct_on?: InputMaybe<Array<org_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<org_order_by>>;
  where?: InputMaybe<org_bool_exp>;
};

export type query_rootorg_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootportfolioArgs = {
  distinct_on?: InputMaybe<Array<portfolio_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<portfolio_order_by>>;
  where?: InputMaybe<portfolio_bool_exp>;
};

export type query_rootportfolio_aggregateArgs = {
  distinct_on?: InputMaybe<Array<portfolio_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<portfolio_order_by>>;
  where?: InputMaybe<portfolio_bool_exp>;
};

export type query_rootportfolio_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreadClimateRiskV2AssetArgs = {
  buildingId: Scalars['Int']['input'];
};

export type query_rootreadClimateRiskV2ReportArgs = {
  buildingId: Scalars['Int']['input'];
  language?: Scalars['String']['input'];
};

export type query_rootrecommendActionsArgs = {
  action_plan_stable_id: Scalars['Int']['input'];
  emission_source_type?: InputMaybe<emission_factor_source_enum>;
  implementation_date: Scalars['DateTime']['input'];
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
  sorting: recommended_action_sorting_enum;
};

export type query_rootrenovationArgs = {
  distinct_on?: InputMaybe<Array<renovation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_order_by>>;
  where?: InputMaybe<renovation_bool_exp>;
};

export type query_rootrenovation_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootrenovation_energy_consumerArgs = {
  distinct_on?: InputMaybe<Array<renovation_energy_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_energy_consumer_order_by>>;
  where?: InputMaybe<renovation_energy_consumer_bool_exp>;
};

export type query_rootrenovation_energy_producerArgs = {
  distinct_on?: InputMaybe<Array<renovation_energy_producer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_energy_producer_order_by>>;
  where?: InputMaybe<renovation_energy_producer_bool_exp>;
};

export type query_rootrenovation_energy_system_routeArgs = {
  distinct_on?: InputMaybe<Array<renovation_energy_system_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_energy_system_route_order_by>>;
  where?: InputMaybe<renovation_energy_system_route_bool_exp>;
};

export type query_rootrenovation_envelopeArgs = {
  distinct_on?: InputMaybe<Array<renovation_envelope_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_envelope_order_by>>;
  where?: InputMaybe<renovation_envelope_bool_exp>;
};

export type query_rootreportArgs = {
  distinct_on?: InputMaybe<Array<report_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_order_by>>;
  where?: InputMaybe<report_bool_exp>;
};

export type query_rootreport_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_order_by>>;
  where?: InputMaybe<report_bool_exp>;
};

export type query_rootreport_answerArgs = {
  distinct_on?: InputMaybe<Array<report_answer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_order_by>>;
  where?: InputMaybe<report_answer_bool_exp>;
};

export type query_rootreport_answer_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_answer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_order_by>>;
  where?: InputMaybe<report_answer_bool_exp>;
};

export type query_rootreport_answer_autofill_optionArgs = {
  distinct_on?: InputMaybe<Array<report_answer_autofill_option_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_autofill_option_order_by>>;
  where?: InputMaybe<report_answer_autofill_option_bool_exp>;
};

export type query_rootreport_answer_autofill_option_by_pkArgs = {
  report_answer_id: Scalars['Int']['input'];
  report_template_question_option_id: Scalars['Int']['input'];
};

export type query_rootreport_answer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreport_answer_chosen_optionArgs = {
  distinct_on?: InputMaybe<Array<report_answer_chosen_option_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_chosen_option_order_by>>;
  where?: InputMaybe<report_answer_chosen_option_bool_exp>;
};

export type query_rootreport_answer_chosen_option_by_pkArgs = {
  report_answer_id: Scalars['Int']['input'];
  report_template_question_option_id: Scalars['Int']['input'];
};

export type query_rootreport_buildingArgs = {
  distinct_on?: InputMaybe<Array<report_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_order_by>>;
  where?: InputMaybe<report_building_bool_exp>;
};

export type query_rootreport_building_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_order_by>>;
  where?: InputMaybe<report_building_bool_exp>;
};

export type query_rootreport_building_by_pkArgs = {
  building_id: Scalars['Int']['input'];
  report_id: Scalars['Int']['input'];
};

export type query_rootreport_building_detailsArgs = {
  distinct_on?: InputMaybe<Array<report_building_details_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_details_order_by>>;
  where?: InputMaybe<report_building_details_bool_exp>;
};

export type query_rootreport_building_details_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_building_details_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_details_order_by>>;
  where?: InputMaybe<report_building_details_bool_exp>;
};

export type query_rootreport_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreport_evidenceArgs = {
  distinct_on?: InputMaybe<Array<report_evidence_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_evidence_order_by>>;
  where?: InputMaybe<report_evidence_bool_exp>;
};

export type query_rootreport_evidence_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreport_overviewArgs = {
  distinct_on?: InputMaybe<Array<report_overview_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_overview_order_by>>;
  where?: InputMaybe<report_overview_bool_exp>;
};

export type query_rootreport_question_evidenceArgs = {
  distinct_on?: InputMaybe<Array<report_question_evidence_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_question_evidence_order_by>>;
  where?: InputMaybe<report_question_evidence_bool_exp>;
};

export type query_rootreport_question_evidence_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreport_scoreArgs = {
  distinct_on?: InputMaybe<Array<report_score_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_score_order_by>>;
  where?: InputMaybe<report_score_bool_exp>;
};

export type query_rootreport_score_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreport_section_progressArgs = {
  distinct_on?: InputMaybe<Array<report_section_progress_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_section_progress_order_by>>;
  where?: InputMaybe<report_section_progress_bool_exp>;
};

export type query_rootreport_section_progress_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreport_templateArgs = {
  distinct_on?: InputMaybe<Array<report_template_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_order_by>>;
  where?: InputMaybe<report_template_bool_exp>;
};

export type query_rootreport_template_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreport_template_questionArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_order_by>>;
  where?: InputMaybe<report_template_question_bool_exp>;
};

export type query_rootreport_template_question_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_order_by>>;
  where?: InputMaybe<report_template_question_bool_exp>;
};

export type query_rootreport_template_question_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreport_template_question_optionArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_option_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_option_order_by>>;
  where?: InputMaybe<report_template_question_option_bool_exp>;
};

export type query_rootreport_template_question_option_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreport_template_scoreArgs = {
  distinct_on?: InputMaybe<Array<report_template_score_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_score_order_by>>;
  where?: InputMaybe<report_template_score_bool_exp>;
};

export type query_rootreport_template_score_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootreport_template_sectionArgs = {
  distinct_on?: InputMaybe<Array<report_template_section_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_section_order_by>>;
  where?: InputMaybe<report_template_section_bool_exp>;
};

export type query_rootreport_template_section_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootscenarioArgs = {
  distinct_on?: InputMaybe<Array<scenario_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_order_by>>;
  where?: InputMaybe<scenario_bool_exp>;
};

export type query_rootscenario_aggregateArgs = {
  distinct_on?: InputMaybe<Array<scenario_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_order_by>>;
  where?: InputMaybe<scenario_bool_exp>;
};

export type query_rootscenario_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootscenario_versionArgs = {
  distinct_on?: InputMaybe<Array<scenario_version_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_version_order_by>>;
  where?: InputMaybe<scenario_version_bool_exp>;
};

export type query_rootscenario_version_aggregateArgs = {
  distinct_on?: InputMaybe<Array<scenario_version_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_version_order_by>>;
  where?: InputMaybe<scenario_version_bool_exp>;
};

export type query_rootscenario_version_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootsearchBuildingsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<BuildingOrderByInput>;
  portfolio_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  search_string?: InputMaybe<Scalars['String']['input']>;
};

export type query_rootsearchBuildingsForCreateActionPlanArgs = {
  include_new_construction?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<BuildingOrderByInput>;
  portfolio_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  scenario_id: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
};

export type query_rootsmart_meterArgs = {
  distinct_on?: InputMaybe<Array<smart_meter_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<smart_meter_order_by>>;
  where?: InputMaybe<smart_meter_bool_exp>;
};

export type query_rootsmart_meter_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootsmart_meter_integrationArgs = {
  distinct_on?: InputMaybe<Array<smart_meter_integration_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<smart_meter_integration_order_by>>;
  where?: InputMaybe<smart_meter_integration_bool_exp>;
};

export type query_rootsmart_meter_integration_buildingArgs = {
  distinct_on?: InputMaybe<Array<smart_meter_integration_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<smart_meter_integration_building_order_by>>;
  where?: InputMaybe<smart_meter_integration_building_bool_exp>;
};

export type query_rootsmart_meter_integration_building_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootsmart_meter_integration_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootsmart_meter_sync_checkpointArgs = {
  distinct_on?: InputMaybe<Array<smart_meter_sync_checkpoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<smart_meter_sync_checkpoint_order_by>>;
  where?: InputMaybe<smart_meter_sync_checkpoint_bool_exp>;
};

export type query_rootsmart_meter_sync_checkpoint_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootsubsidyArgs = {
  distinct_on?: InputMaybe<Array<subsidy_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<subsidy_order_by>>;
  where?: InputMaybe<subsidy_bool_exp>;
};

export type query_rootsubsidy_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootsubsidy_subsidy_categoryArgs = {
  distinct_on?: InputMaybe<Array<subsidy_subsidy_category_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<subsidy_subsidy_category_order_by>>;
  where?: InputMaybe<subsidy_subsidy_category_bool_exp>;
};

export type query_rootuserArgs = {
  distinct_on?: InputMaybe<Array<user_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_order_by>>;
  where?: InputMaybe<user_bool_exp>;
};

export type query_rootuser_building_permissionArgs = {
  distinct_on?: InputMaybe<Array<user_building_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_building_permission_order_by>>;
  where?: InputMaybe<user_building_permission_bool_exp>;
};

export type query_rootuser_building_permission_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootuser_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type query_rootuser_portfolio_permissionArgs = {
  distinct_on?: InputMaybe<Array<user_portfolio_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_portfolio_permission_order_by>>;
  where?: InputMaybe<user_portfolio_permission_bool_exp>;
};

export type query_rootuser_portfolio_permission_aggregateArgs = {
  distinct_on?: InputMaybe<Array<user_portfolio_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_portfolio_permission_order_by>>;
  where?: InputMaybe<user_portfolio_permission_bool_exp>;
};

export type query_rootuser_portfolio_permission_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export enum recommended_action_sorting_enum {
  CO2 = 'CO2',
  COST_CO2 = 'COST_CO2',
  COST_FINAL_ENERGY = 'COST_FINAL_ENERGY',
  COST_PRIMARY_ENERGY = 'COST_PRIMARY_ENERGY',
  FINAL_ENERGY = 'FINAL_ENERGY',
  PRIMARY_ENERGY = 'PRIMARY_ENERGY',
}

/** A specific component-level change within an action, such as replacing an envelope element or swapping an energy system. Contains references to both the old and new building component. */
export type renovation = {
  /** An object relationship */
  action: action;
  /** Reference to the action this renovation belongs to. */
  action_id: Scalars['Int']['output'];
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: Maybe<Scalars['Float']['output']>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: Maybe<Scalars['Float']['output']>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: Maybe<Scalars['Int']['output']>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: Maybe<Scalars['Int']['output']>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: Maybe<Scalars['Int']['output']>;
  /** Type of renovation being performed (e.g., envelope insulation, system replacement). */
  renovation_type_id: renovation_type_enum;
  /** Whether to use the user-provided custom cost instead of the system-calculated cost. */
  use_custom_cost: Scalars['Boolean']['output'];
};

/** order by aggregate values of table "renovation" */
export type renovation_aggregate_order_by = {
  avg?: InputMaybe<renovation_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<renovation_max_order_by>;
  min?: InputMaybe<renovation_min_order_by>;
  stddev?: InputMaybe<renovation_stddev_order_by>;
  stddev_pop?: InputMaybe<renovation_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<renovation_stddev_samp_order_by>;
  sum?: InputMaybe<renovation_sum_order_by>;
  var_pop?: InputMaybe<renovation_var_pop_order_by>;
  var_samp?: InputMaybe<renovation_var_samp_order_by>;
  variance?: InputMaybe<renovation_variance_order_by>;
};

/** order by avg() on columns of table "renovation" */
export type renovation_avg_order_by = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<order_by>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<order_by>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<order_by>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<order_by>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<order_by>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "renovation". All fields are combined with a logical 'AND'. */
export type renovation_bool_exp = {
  _and?: InputMaybe<Array<renovation_bool_exp>>;
  _not?: InputMaybe<renovation_bool_exp>;
  _or?: InputMaybe<Array<renovation_bool_exp>>;
  action?: InputMaybe<action_bool_exp>;
  action_id?: InputMaybe<Int_comparison_exp>;
  cost_total?: InputMaybe<Float_comparison_exp>;
  cost_total_custom?: InputMaybe<Float_comparison_exp>;
  cost_total_predium?: InputMaybe<Float_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  new_entity_id?: InputMaybe<Int_comparison_exp>;
  old_entity_id?: InputMaybe<Int_comparison_exp>;
  order?: InputMaybe<Int_comparison_exp>;
  renovation_type_id?: InputMaybe<renovation_type_enum_comparison_exp>;
  use_custom_cost?: InputMaybe<Boolean_comparison_exp>;
};

export enum renovation_category_enum {
  CUSTOM = 'CUSTOM',
  ENERGY_SOURCE = 'ENERGY_SOURCE',
  ENVELOPE = 'ENVELOPE',
  TECHNOLOGY = 'TECHNOLOGY',
}

/** View: Renovations filtered to energy consumer replacements, joining renovation with old/new entity details. */
export type renovation_energy_consumer = {
  /** An object relationship */
  action?: Maybe<action>;
  action_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  new_energy_consumer?: Maybe<energy_consumer>;
  new_entity_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  old_energy_consumer?: Maybe<energy_consumer>;
  old_entity_id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  renovation_type_id?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "renovation_energy_consumer" */
export type renovation_energy_consumer_aggregate_order_by = {
  avg?: InputMaybe<renovation_energy_consumer_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<renovation_energy_consumer_max_order_by>;
  min?: InputMaybe<renovation_energy_consumer_min_order_by>;
  stddev?: InputMaybe<renovation_energy_consumer_stddev_order_by>;
  stddev_pop?: InputMaybe<renovation_energy_consumer_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<renovation_energy_consumer_stddev_samp_order_by>;
  sum?: InputMaybe<renovation_energy_consumer_sum_order_by>;
  var_pop?: InputMaybe<renovation_energy_consumer_var_pop_order_by>;
  var_samp?: InputMaybe<renovation_energy_consumer_var_samp_order_by>;
  variance?: InputMaybe<renovation_energy_consumer_variance_order_by>;
};

/** order by avg() on columns of table "renovation_energy_consumer" */
export type renovation_energy_consumer_avg_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "renovation_energy_consumer". All fields are combined with a logical 'AND'. */
export type renovation_energy_consumer_bool_exp = {
  _and?: InputMaybe<Array<renovation_energy_consumer_bool_exp>>;
  _not?: InputMaybe<renovation_energy_consumer_bool_exp>;
  _or?: InputMaybe<Array<renovation_energy_consumer_bool_exp>>;
  action?: InputMaybe<action_bool_exp>;
  action_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  new_energy_consumer?: InputMaybe<energy_consumer_bool_exp>;
  new_entity_id?: InputMaybe<Int_comparison_exp>;
  old_energy_consumer?: InputMaybe<energy_consumer_bool_exp>;
  old_entity_id?: InputMaybe<Int_comparison_exp>;
  order?: InputMaybe<Int_comparison_exp>;
  renovation_type_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "renovation_energy_consumer" */
export type renovation_energy_consumer_max_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "renovation_energy_consumer" */
export type renovation_energy_consumer_min_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "renovation_energy_consumer". */
export type renovation_energy_consumer_order_by = {
  action?: InputMaybe<action_order_by>;
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_energy_consumer?: InputMaybe<energy_consumer_order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_energy_consumer?: InputMaybe<energy_consumer_order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** select columns of table "renovation_energy_consumer" */
export enum renovation_energy_consumer_select_column {
  /** column name */
  action_id = 'action_id',
  /** column name */
  id = 'id',
  /** column name */
  new_entity_id = 'new_entity_id',
  /** column name */
  old_entity_id = 'old_entity_id',
  /** column name */
  order = 'order',
  /** column name */
  renovation_type_id = 'renovation_type_id',
}

/** order by stddev() on columns of table "renovation_energy_consumer" */
export type renovation_energy_consumer_stddev_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "renovation_energy_consumer" */
export type renovation_energy_consumer_stddev_pop_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "renovation_energy_consumer" */
export type renovation_energy_consumer_stddev_samp_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "renovation_energy_consumer" */
export type renovation_energy_consumer_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: renovation_energy_consumer_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type renovation_energy_consumer_stream_cursor_value_input = {
  action_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  new_entity_id?: InputMaybe<Scalars['Int']['input']>;
  old_entity_id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  renovation_type_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "renovation_energy_consumer" */
export type renovation_energy_consumer_sum_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "renovation_energy_consumer" */
export type renovation_energy_consumer_var_pop_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "renovation_energy_consumer" */
export type renovation_energy_consumer_var_samp_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "renovation_energy_consumer" */
export type renovation_energy_consumer_variance_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** View: Renovations filtered to energy producer replacements. */
export type renovation_energy_producer = {
  /** An object relationship */
  action?: Maybe<action>;
  action_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  new_energy_producer?: Maybe<energy_producer>;
  new_entity_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  old_energy_producer?: Maybe<energy_producer>;
  old_entity_id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  renovation_type_id?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "renovation_energy_producer" */
export type renovation_energy_producer_aggregate_order_by = {
  avg?: InputMaybe<renovation_energy_producer_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<renovation_energy_producer_max_order_by>;
  min?: InputMaybe<renovation_energy_producer_min_order_by>;
  stddev?: InputMaybe<renovation_energy_producer_stddev_order_by>;
  stddev_pop?: InputMaybe<renovation_energy_producer_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<renovation_energy_producer_stddev_samp_order_by>;
  sum?: InputMaybe<renovation_energy_producer_sum_order_by>;
  var_pop?: InputMaybe<renovation_energy_producer_var_pop_order_by>;
  var_samp?: InputMaybe<renovation_energy_producer_var_samp_order_by>;
  variance?: InputMaybe<renovation_energy_producer_variance_order_by>;
};

/** order by avg() on columns of table "renovation_energy_producer" */
export type renovation_energy_producer_avg_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "renovation_energy_producer". All fields are combined with a logical 'AND'. */
export type renovation_energy_producer_bool_exp = {
  _and?: InputMaybe<Array<renovation_energy_producer_bool_exp>>;
  _not?: InputMaybe<renovation_energy_producer_bool_exp>;
  _or?: InputMaybe<Array<renovation_energy_producer_bool_exp>>;
  action?: InputMaybe<action_bool_exp>;
  action_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  new_energy_producer?: InputMaybe<energy_producer_bool_exp>;
  new_entity_id?: InputMaybe<Int_comparison_exp>;
  old_energy_producer?: InputMaybe<energy_producer_bool_exp>;
  old_entity_id?: InputMaybe<Int_comparison_exp>;
  order?: InputMaybe<Int_comparison_exp>;
  renovation_type_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "renovation_energy_producer" */
export type renovation_energy_producer_max_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "renovation_energy_producer" */
export type renovation_energy_producer_min_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "renovation_energy_producer". */
export type renovation_energy_producer_order_by = {
  action?: InputMaybe<action_order_by>;
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_energy_producer?: InputMaybe<energy_producer_order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_energy_producer?: InputMaybe<energy_producer_order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** select columns of table "renovation_energy_producer" */
export enum renovation_energy_producer_select_column {
  /** column name */
  action_id = 'action_id',
  /** column name */
  id = 'id',
  /** column name */
  new_entity_id = 'new_entity_id',
  /** column name */
  old_entity_id = 'old_entity_id',
  /** column name */
  order = 'order',
  /** column name */
  renovation_type_id = 'renovation_type_id',
}

/** order by stddev() on columns of table "renovation_energy_producer" */
export type renovation_energy_producer_stddev_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "renovation_energy_producer" */
export type renovation_energy_producer_stddev_pop_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "renovation_energy_producer" */
export type renovation_energy_producer_stddev_samp_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "renovation_energy_producer" */
export type renovation_energy_producer_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: renovation_energy_producer_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type renovation_energy_producer_stream_cursor_value_input = {
  action_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  new_entity_id?: InputMaybe<Scalars['Int']['input']>;
  old_entity_id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  renovation_type_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "renovation_energy_producer" */
export type renovation_energy_producer_sum_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "renovation_energy_producer" */
export type renovation_energy_producer_var_pop_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "renovation_energy_producer" */
export type renovation_energy_producer_var_samp_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "renovation_energy_producer" */
export type renovation_energy_producer_variance_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** View: Renovations filtered to energy system route changes. */
export type renovation_energy_system_route = {
  /** An object relationship */
  action?: Maybe<action>;
  action_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  new_energy_system_route?: Maybe<energy_system_consumer_route>;
  new_entity_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  old_energy_system_route?: Maybe<energy_system_consumer_route>;
  old_entity_id?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  renovation_type_id?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "renovation_energy_system_route" */
export type renovation_energy_system_route_aggregate_order_by = {
  avg?: InputMaybe<renovation_energy_system_route_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<renovation_energy_system_route_max_order_by>;
  min?: InputMaybe<renovation_energy_system_route_min_order_by>;
  stddev?: InputMaybe<renovation_energy_system_route_stddev_order_by>;
  stddev_pop?: InputMaybe<renovation_energy_system_route_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<renovation_energy_system_route_stddev_samp_order_by>;
  sum?: InputMaybe<renovation_energy_system_route_sum_order_by>;
  var_pop?: InputMaybe<renovation_energy_system_route_var_pop_order_by>;
  var_samp?: InputMaybe<renovation_energy_system_route_var_samp_order_by>;
  variance?: InputMaybe<renovation_energy_system_route_variance_order_by>;
};

/** order by avg() on columns of table "renovation_energy_system_route" */
export type renovation_energy_system_route_avg_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "renovation_energy_system_route". All fields are combined with a logical 'AND'. */
export type renovation_energy_system_route_bool_exp = {
  _and?: InputMaybe<Array<renovation_energy_system_route_bool_exp>>;
  _not?: InputMaybe<renovation_energy_system_route_bool_exp>;
  _or?: InputMaybe<Array<renovation_energy_system_route_bool_exp>>;
  action?: InputMaybe<action_bool_exp>;
  action_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  new_energy_system_route?: InputMaybe<energy_system_consumer_route_bool_exp>;
  new_entity_id?: InputMaybe<Int_comparison_exp>;
  old_energy_system_route?: InputMaybe<energy_system_consumer_route_bool_exp>;
  old_entity_id?: InputMaybe<Int_comparison_exp>;
  order?: InputMaybe<Int_comparison_exp>;
  renovation_type_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "renovation_energy_system_route" */
export type renovation_energy_system_route_max_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "renovation_energy_system_route" */
export type renovation_energy_system_route_min_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "renovation_energy_system_route". */
export type renovation_energy_system_route_order_by = {
  action?: InputMaybe<action_order_by>;
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_energy_system_route?: InputMaybe<energy_system_consumer_route_order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_energy_system_route?: InputMaybe<energy_system_consumer_route_order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** select columns of table "renovation_energy_system_route" */
export enum renovation_energy_system_route_select_column {
  /** column name */
  action_id = 'action_id',
  /** column name */
  id = 'id',
  /** column name */
  new_entity_id = 'new_entity_id',
  /** column name */
  old_entity_id = 'old_entity_id',
  /** column name */
  order = 'order',
  /** column name */
  renovation_type_id = 'renovation_type_id',
}

/** order by stddev() on columns of table "renovation_energy_system_route" */
export type renovation_energy_system_route_stddev_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "renovation_energy_system_route" */
export type renovation_energy_system_route_stddev_pop_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "renovation_energy_system_route" */
export type renovation_energy_system_route_stddev_samp_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "renovation_energy_system_route" */
export type renovation_energy_system_route_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: renovation_energy_system_route_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type renovation_energy_system_route_stream_cursor_value_input = {
  action_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  new_entity_id?: InputMaybe<Scalars['Int']['input']>;
  old_entity_id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  renovation_type_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "renovation_energy_system_route" */
export type renovation_energy_system_route_sum_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "renovation_energy_system_route" */
export type renovation_energy_system_route_var_pop_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "renovation_energy_system_route" */
export type renovation_energy_system_route_var_samp_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "renovation_energy_system_route" */
export type renovation_energy_system_route_variance_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** View: Renovations filtered to envelope (wall, roof, window, floor) changes. */
export type renovation_envelope = {
  /** An object relationship */
  action?: Maybe<action>;
  action_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  new_entity_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  new_envelope?: Maybe<envelope>;
  old_entity_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  old_envelope?: Maybe<envelope>;
  order?: Maybe<Scalars['Int']['output']>;
  renovation_type_id?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "renovation_envelope" */
export type renovation_envelope_aggregate_order_by = {
  avg?: InputMaybe<renovation_envelope_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<renovation_envelope_max_order_by>;
  min?: InputMaybe<renovation_envelope_min_order_by>;
  stddev?: InputMaybe<renovation_envelope_stddev_order_by>;
  stddev_pop?: InputMaybe<renovation_envelope_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<renovation_envelope_stddev_samp_order_by>;
  sum?: InputMaybe<renovation_envelope_sum_order_by>;
  var_pop?: InputMaybe<renovation_envelope_var_pop_order_by>;
  var_samp?: InputMaybe<renovation_envelope_var_samp_order_by>;
  variance?: InputMaybe<renovation_envelope_variance_order_by>;
};

/** order by avg() on columns of table "renovation_envelope" */
export type renovation_envelope_avg_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "renovation_envelope". All fields are combined with a logical 'AND'. */
export type renovation_envelope_bool_exp = {
  _and?: InputMaybe<Array<renovation_envelope_bool_exp>>;
  _not?: InputMaybe<renovation_envelope_bool_exp>;
  _or?: InputMaybe<Array<renovation_envelope_bool_exp>>;
  action?: InputMaybe<action_bool_exp>;
  action_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  new_entity_id?: InputMaybe<Int_comparison_exp>;
  new_envelope?: InputMaybe<envelope_bool_exp>;
  old_entity_id?: InputMaybe<Int_comparison_exp>;
  old_envelope?: InputMaybe<envelope_bool_exp>;
  order?: InputMaybe<Int_comparison_exp>;
  renovation_type_id?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "renovation_envelope" */
export type renovation_envelope_max_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "renovation_envelope" */
export type renovation_envelope_min_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "renovation_envelope". */
export type renovation_envelope_order_by = {
  action?: InputMaybe<action_order_by>;
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  new_envelope?: InputMaybe<envelope_order_by>;
  old_entity_id?: InputMaybe<order_by>;
  old_envelope?: InputMaybe<envelope_order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
};

/** select columns of table "renovation_envelope" */
export enum renovation_envelope_select_column {
  /** column name */
  action_id = 'action_id',
  /** column name */
  id = 'id',
  /** column name */
  new_entity_id = 'new_entity_id',
  /** column name */
  old_entity_id = 'old_entity_id',
  /** column name */
  order = 'order',
  /** column name */
  renovation_type_id = 'renovation_type_id',
}

/** order by stddev() on columns of table "renovation_envelope" */
export type renovation_envelope_stddev_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "renovation_envelope" */
export type renovation_envelope_stddev_pop_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "renovation_envelope" */
export type renovation_envelope_stddev_samp_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "renovation_envelope" */
export type renovation_envelope_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: renovation_envelope_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type renovation_envelope_stream_cursor_value_input = {
  action_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  new_entity_id?: InputMaybe<Scalars['Int']['input']>;
  old_entity_id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  renovation_type_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "renovation_envelope" */
export type renovation_envelope_sum_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "renovation_envelope" */
export type renovation_envelope_var_pop_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "renovation_envelope" */
export type renovation_envelope_var_samp_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "renovation_envelope" */
export type renovation_envelope_variance_order_by = {
  action_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
};

/** input type for incrementing numeric columns in table "renovation" */
export type renovation_inc_input = {
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<Scalars['Float']['input']>;
};

/** order by max() on columns of table "renovation" */
export type renovation_max_order_by = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<order_by>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<order_by>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<order_by>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<order_by>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<order_by>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<order_by>;
};

/** order by min() on columns of table "renovation" */
export type renovation_min_order_by = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<order_by>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<order_by>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<order_by>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<order_by>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<order_by>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<order_by>;
};

/** response of any mutation on the table "renovation" */
export type renovation_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<renovation>;
};

/** Ordering options when selecting data from "renovation". */
export type renovation_order_by = {
  action?: InputMaybe<action_order_by>;
  action_id?: InputMaybe<order_by>;
  cost_total?: InputMaybe<order_by>;
  cost_total_custom?: InputMaybe<order_by>;
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  new_entity_id?: InputMaybe<order_by>;
  old_entity_id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  renovation_type_id?: InputMaybe<order_by>;
  use_custom_cost?: InputMaybe<order_by>;
};

/** primary key columns input for table: renovation */
export type renovation_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "renovation" */
export enum renovation_select_column {
  /** column name */
  action_id = 'action_id',
  /** column name */
  cost_total = 'cost_total',
  /** column name */
  cost_total_custom = 'cost_total_custom',
  /** column name */
  cost_total_predium = 'cost_total_predium',
  /** column name */
  id = 'id',
  /** column name */
  new_entity_id = 'new_entity_id',
  /** column name */
  old_entity_id = 'old_entity_id',
  /** column name */
  order = 'order',
  /** column name */
  renovation_type_id = 'renovation_type_id',
  /** column name */
  use_custom_cost = 'use_custom_cost',
}

/** input type for updating data in table "renovation" */
export type renovation_set_input = {
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<Scalars['Float']['input']>;
  /** Whether to use the user-provided custom cost instead of the system-calculated cost. */
  use_custom_cost?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "renovation" */
export type renovation_stddev_order_by = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<order_by>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<order_by>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<order_by>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<order_by>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<order_by>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "renovation" */
export type renovation_stddev_pop_order_by = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<order_by>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<order_by>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<order_by>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<order_by>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<order_by>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "renovation" */
export type renovation_stddev_samp_order_by = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<order_by>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<order_by>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<order_by>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<order_by>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<order_by>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "renovation" */
export type renovation_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: renovation_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type renovation_stream_cursor_value_input = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<Scalars['Int']['input']>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<Scalars['Float']['input']>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<Scalars['Float']['input']>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<Scalars['Int']['input']>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Type of renovation being performed (e.g., envelope insulation, system replacement). */
  renovation_type_id?: InputMaybe<renovation_type_enum>;
  /** Whether to use the user-provided custom cost instead of the system-calculated cost. */
  use_custom_cost?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "renovation" */
export type renovation_sum_order_by = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<order_by>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<order_by>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<order_by>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<order_by>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<order_by>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<order_by>;
};

export enum renovation_type_enum {
  CREATE_VENTILATION = 'CREATE_VENTILATION',
  CUSTOM = 'CUSTOM',
  ENERGY_CONSUMER = 'ENERGY_CONSUMER',
  ENERGY_SYSTEM_ROUTE = 'ENERGY_SYSTEM_ROUTE',
  ENVELOPE = 'ENVELOPE',
  EXCLUSION_NOTE = 'EXCLUSION_NOTE',
  EXISTING_VENTILATION = 'EXISTING_VENTILATION',
  HYDRAULIC_BALANCING = 'HYDRAULIC_BALANCING',
  MAINTENANCE = 'MAINTENANCE',
  SOLAR_PLANT = 'SOLAR_PLANT',
}

/** Boolean expression to compare columns of type "renovation_type_enum". All fields are combined with logical 'AND'. */
export type renovation_type_enum_comparison_exp = {
  _eq?: InputMaybe<renovation_type_enum>;
  _in?: InputMaybe<Array<renovation_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<renovation_type_enum>;
  _nin?: InputMaybe<Array<renovation_type_enum>>;
};

export type renovation_updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<renovation_inc_input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<renovation_set_input>;
  /** filter the rows which have to be updated */
  where: renovation_bool_exp;
};

/** order by var_pop() on columns of table "renovation" */
export type renovation_var_pop_order_by = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<order_by>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<order_by>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<order_by>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<order_by>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<order_by>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "renovation" */
export type renovation_var_samp_order_by = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<order_by>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<order_by>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<order_by>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<order_by>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<order_by>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "renovation" */
export type renovation_variance_order_by = {
  /** Reference to the action this renovation belongs to. */
  action_id?: InputMaybe<order_by>;
  /** Resolved total cost in EUR: equals cost_total_custom if use_custom_cost is true, otherwise cost_total_predium. */
  cost_total?: InputMaybe<order_by>;
  /** User-provided custom total cost of the renovation in EUR, overriding the system estimate. */
  cost_total_custom?: InputMaybe<order_by>;
  /** System-estimated total cost of the renovation in EUR, calculated by Predium. */
  cost_total_predium?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** ID of the replacement entity after this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  new_entity_id?: InputMaybe<order_by>;
  /** ID of the entity before this renovation. The entity type is determined by renovation_type_id (envelope, energy_consumer, or energy_system_consumer_route). */
  old_entity_id?: InputMaybe<order_by>;
  /** Execution sequence within the action; lower numbers are applied first. */
  order?: InputMaybe<order_by>;
};

/** An instance of a report template being filled out for a specific set of buildings over a defined period. */
export type report = {
  /** Whether the report has been finalized. */
  completed: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** Deadline for completing the report. */
  due_date: Scalars['timestamptz']['output'];
  /** End of the reporting period. */
  end_date: Scalars['timestamptz']['output'];
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  org: org;
  /** A computed field, executes function "get_report_portfolios" */
  portfolios?: Maybe<Array<portfolio>>;
  /** Overall completion percentage (0 to 1). */
  progress: Scalars['Float']['output'];
  /** An array relationship */
  report_answers: Array<report_answer>;
  /** An aggregate relationship */
  report_answers_aggregate: report_answer_aggregate;
  /** An array relationship */
  report_building_details: Array<report_building_details>;
  /** An aggregate relationship */
  report_building_details_aggregate: report_building_details_aggregate;
  /** An array relationship */
  report_buildings: Array<report_building>;
  /** An aggregate relationship */
  report_buildings_aggregate: report_building_aggregate;
  /** An array relationship */
  report_scores: Array<report_score>;
  /** An array relationship */
  report_sections_progress: Array<report_section_progress>;
  /** An object relationship */
  report_template: report_template;
  /** The template this report is based on. */
  report_template_id: Scalars['Int']['output'];
  /** An object relationship */
  responsible_user?: Maybe<user>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  /** Start of the reporting period. */
  start_date: Scalars['timestamptz']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** An instance of a report template being filled out for a specific set of buildings over a defined period. */
export type reportportfoliosArgs = {
  distinct_on?: InputMaybe<Array<portfolio_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<portfolio_order_by>>;
  where?: InputMaybe<portfolio_bool_exp>;
};

/** An instance of a report template being filled out for a specific set of buildings over a defined period. */
export type reportreport_answersArgs = {
  distinct_on?: InputMaybe<Array<report_answer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_order_by>>;
  where?: InputMaybe<report_answer_bool_exp>;
};

/** An instance of a report template being filled out for a specific set of buildings over a defined period. */
export type reportreport_answers_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_answer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_order_by>>;
  where?: InputMaybe<report_answer_bool_exp>;
};

/** An instance of a report template being filled out for a specific set of buildings over a defined period. */
export type reportreport_building_detailsArgs = {
  distinct_on?: InputMaybe<Array<report_building_details_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_details_order_by>>;
  where?: InputMaybe<report_building_details_bool_exp>;
};

/** An instance of a report template being filled out for a specific set of buildings over a defined period. */
export type reportreport_building_details_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_building_details_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_details_order_by>>;
  where?: InputMaybe<report_building_details_bool_exp>;
};

/** An instance of a report template being filled out for a specific set of buildings over a defined period. */
export type reportreport_buildingsArgs = {
  distinct_on?: InputMaybe<Array<report_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_order_by>>;
  where?: InputMaybe<report_building_bool_exp>;
};

/** An instance of a report template being filled out for a specific set of buildings over a defined period. */
export type reportreport_buildings_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_order_by>>;
  where?: InputMaybe<report_building_bool_exp>;
};

/** An instance of a report template being filled out for a specific set of buildings over a defined period. */
export type reportreport_scoresArgs = {
  distinct_on?: InputMaybe<Array<report_score_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_score_order_by>>;
  where?: InputMaybe<report_score_bool_exp>;
};

/** An instance of a report template being filled out for a specific set of buildings over a defined period. */
export type reportreport_sections_progressArgs = {
  distinct_on?: InputMaybe<Array<report_section_progress_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_section_progress_order_by>>;
  where?: InputMaybe<report_section_progress_bool_exp>;
};

/** aggregated selection of "report" */
export type report_aggregate = {
  aggregate?: Maybe<report_aggregate_fields>;
  nodes: Array<report>;
};

export type report_aggregate_bool_exp = {
  bool_and?: InputMaybe<report_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<report_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<report_aggregate_bool_exp_count>;
};

export type report_aggregate_bool_exp_bool_and = {
  arguments: report_select_column_report_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<report_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type report_aggregate_bool_exp_bool_or = {
  arguments: report_select_column_report_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<report_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type report_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<report_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<report_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "report" */
export type report_aggregate_fields = {
  avg?: Maybe<report_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<report_max_fields>;
  min?: Maybe<report_min_fields>;
  stddev?: Maybe<report_stddev_fields>;
  stddev_pop?: Maybe<report_stddev_pop_fields>;
  stddev_samp?: Maybe<report_stddev_samp_fields>;
  sum?: Maybe<report_sum_fields>;
  var_pop?: Maybe<report_var_pop_fields>;
  var_samp?: Maybe<report_var_samp_fields>;
  variance?: Maybe<report_variance_fields>;
};

/** aggregate fields of "report" */
export type report_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<report_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "report" */
export type report_aggregate_order_by = {
  avg?: InputMaybe<report_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_max_order_by>;
  min?: InputMaybe<report_min_order_by>;
  stddev?: InputMaybe<report_stddev_order_by>;
  stddev_pop?: InputMaybe<report_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_stddev_samp_order_by>;
  sum?: InputMaybe<report_sum_order_by>;
  var_pop?: InputMaybe<report_var_pop_order_by>;
  var_samp?: InputMaybe<report_var_samp_order_by>;
  variance?: InputMaybe<report_variance_order_by>;
};

/** A user-provided or autofilled answer to a report question for a specific report instance. */
export type report_answer = {
  /** The computed result of evaluating the question's autofill expression against building data. Stored as a string. */
  autofill?: Maybe<Scalars['String']['output']>;
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  report: report;
  /** An array relationship */
  report_answer_autofill_options: Array<report_answer_autofill_option>;
  /** An array relationship */
  report_answer_chosen_options: Array<report_answer_chosen_option>;
  /** The report instance this answer belongs to. */
  report_id: Scalars['Int']['output'];
  /** The template question being answered. */
  report_question_id: Scalars['Int']['output'];
  /** An object relationship */
  report_template_question: report_template_question;
  /** Answer state (e.g., UNANSWERED, ANSWERED). */
  state: report_answer_state_enum;
  updated_at: Scalars['timestamptz']['output'];
  /** Free-text or numeric answer value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A user-provided or autofilled answer to a report question for a specific report instance. */
export type report_answerreport_answer_autofill_optionsArgs = {
  distinct_on?: InputMaybe<Array<report_answer_autofill_option_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_autofill_option_order_by>>;
  where?: InputMaybe<report_answer_autofill_option_bool_exp>;
};

/** A user-provided or autofilled answer to a report question for a specific report instance. */
export type report_answerreport_answer_chosen_optionsArgs = {
  distinct_on?: InputMaybe<Array<report_answer_chosen_option_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_chosen_option_order_by>>;
  where?: InputMaybe<report_answer_chosen_option_bool_exp>;
};

/** aggregated selection of "report_answer" */
export type report_answer_aggregate = {
  aggregate?: Maybe<report_answer_aggregate_fields>;
  nodes: Array<report_answer>;
};

export type report_answer_aggregate_bool_exp = {
  count?: InputMaybe<report_answer_aggregate_bool_exp_count>;
};

export type report_answer_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<report_answer_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<report_answer_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "report_answer" */
export type report_answer_aggregate_fields = {
  avg?: Maybe<report_answer_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<report_answer_max_fields>;
  min?: Maybe<report_answer_min_fields>;
  stddev?: Maybe<report_answer_stddev_fields>;
  stddev_pop?: Maybe<report_answer_stddev_pop_fields>;
  stddev_samp?: Maybe<report_answer_stddev_samp_fields>;
  sum?: Maybe<report_answer_sum_fields>;
  var_pop?: Maybe<report_answer_var_pop_fields>;
  var_samp?: Maybe<report_answer_var_samp_fields>;
  variance?: Maybe<report_answer_variance_fields>;
};

/** aggregate fields of "report_answer" */
export type report_answer_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<report_answer_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "report_answer" */
export type report_answer_aggregate_order_by = {
  avg?: InputMaybe<report_answer_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_answer_max_order_by>;
  min?: InputMaybe<report_answer_min_order_by>;
  stddev?: InputMaybe<report_answer_stddev_order_by>;
  stddev_pop?: InputMaybe<report_answer_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_answer_stddev_samp_order_by>;
  sum?: InputMaybe<report_answer_sum_order_by>;
  var_pop?: InputMaybe<report_answer_var_pop_order_by>;
  var_samp?: InputMaybe<report_answer_var_samp_order_by>;
  variance?: InputMaybe<report_answer_variance_order_by>;
};

/** Junction table linking a report answer to the option(s) that were automatically suggested by the autofill logic. */
export type report_answer_autofill_option = {
  /** An object relationship */
  report_answer: report_answer;
  /** The answer record. */
  report_answer_id: Scalars['Int']['output'];
  /** An object relationship */
  report_template_question_option: report_template_question_option;
  /** The autofilled option. */
  report_template_question_option_id: Scalars['Int']['output'];
};

/** order by aggregate values of table "report_answer_autofill_option" */
export type report_answer_autofill_option_aggregate_order_by = {
  avg?: InputMaybe<report_answer_autofill_option_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_answer_autofill_option_max_order_by>;
  min?: InputMaybe<report_answer_autofill_option_min_order_by>;
  stddev?: InputMaybe<report_answer_autofill_option_stddev_order_by>;
  stddev_pop?: InputMaybe<report_answer_autofill_option_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_answer_autofill_option_stddev_samp_order_by>;
  sum?: InputMaybe<report_answer_autofill_option_sum_order_by>;
  var_pop?: InputMaybe<report_answer_autofill_option_var_pop_order_by>;
  var_samp?: InputMaybe<report_answer_autofill_option_var_samp_order_by>;
  variance?: InputMaybe<report_answer_autofill_option_variance_order_by>;
};

/** order by avg() on columns of table "report_answer_autofill_option" */
export type report_answer_autofill_option_avg_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_answer_autofill_option". All fields are combined with a logical 'AND'. */
export type report_answer_autofill_option_bool_exp = {
  _and?: InputMaybe<Array<report_answer_autofill_option_bool_exp>>;
  _not?: InputMaybe<report_answer_autofill_option_bool_exp>;
  _or?: InputMaybe<Array<report_answer_autofill_option_bool_exp>>;
  report_answer?: InputMaybe<report_answer_bool_exp>;
  report_answer_id?: InputMaybe<Int_comparison_exp>;
  report_template_question_option?: InputMaybe<report_template_question_option_bool_exp>;
  report_template_question_option_id?: InputMaybe<Int_comparison_exp>;
};

/** order by max() on columns of table "report_answer_autofill_option" */
export type report_answer_autofill_option_max_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "report_answer_autofill_option" */
export type report_answer_autofill_option_min_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_answer_autofill_option". */
export type report_answer_autofill_option_order_by = {
  report_answer?: InputMaybe<report_answer_order_by>;
  report_answer_id?: InputMaybe<order_by>;
  report_template_question_option?: InputMaybe<report_template_question_option_order_by>;
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** select columns of table "report_answer_autofill_option" */
export enum report_answer_autofill_option_select_column {
  /** column name */
  report_answer_id = 'report_answer_id',
  /** column name */
  report_template_question_option_id = 'report_template_question_option_id',
}

/** order by stddev() on columns of table "report_answer_autofill_option" */
export type report_answer_autofill_option_stddev_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "report_answer_autofill_option" */
export type report_answer_autofill_option_stddev_pop_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "report_answer_autofill_option" */
export type report_answer_autofill_option_stddev_samp_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_answer_autofill_option" */
export type report_answer_autofill_option_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_answer_autofill_option_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_answer_autofill_option_stream_cursor_value_input = {
  /** The answer record. */
  report_answer_id?: InputMaybe<Scalars['Int']['input']>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "report_answer_autofill_option" */
export type report_answer_autofill_option_sum_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "report_answer_autofill_option" */
export type report_answer_autofill_option_var_pop_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "report_answer_autofill_option" */
export type report_answer_autofill_option_var_samp_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "report_answer_autofill_option" */
export type report_answer_autofill_option_variance_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The autofilled option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** aggregate avg on columns */
export type report_answer_avg_fields = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The report instance this answer belongs to. */
  report_id?: Maybe<Scalars['Float']['output']>;
  /** The template question being answered. */
  report_question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "report_answer" */
export type report_answer_avg_order_by = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<order_by>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_answer". All fields are combined with a logical 'AND'. */
export type report_answer_bool_exp = {
  _and?: InputMaybe<Array<report_answer_bool_exp>>;
  _not?: InputMaybe<report_answer_bool_exp>;
  _or?: InputMaybe<Array<report_answer_bool_exp>>;
  autofill?: InputMaybe<String_comparison_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  report?: InputMaybe<report_bool_exp>;
  report_answer_autofill_options?: InputMaybe<report_answer_autofill_option_bool_exp>;
  report_answer_chosen_options?: InputMaybe<report_answer_chosen_option_bool_exp>;
  report_id?: InputMaybe<Int_comparison_exp>;
  report_question_id?: InputMaybe<Int_comparison_exp>;
  report_template_question?: InputMaybe<report_template_question_bool_exp>;
  state?: InputMaybe<report_answer_state_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

/** Junction table linking a report answer to the user-selected option(s) for choice-type questions. */
export type report_answer_chosen_option = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  report_answer: report_answer;
  /** The answer record. */
  report_answer_id: Scalars['Int']['output'];
  /** An object relationship */
  report_template_question_option: report_template_question_option;
  /** The selected option. */
  report_template_question_option_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "report_answer_chosen_option" */
export type report_answer_chosen_option_aggregate_order_by = {
  avg?: InputMaybe<report_answer_chosen_option_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_answer_chosen_option_max_order_by>;
  min?: InputMaybe<report_answer_chosen_option_min_order_by>;
  stddev?: InputMaybe<report_answer_chosen_option_stddev_order_by>;
  stddev_pop?: InputMaybe<report_answer_chosen_option_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_answer_chosen_option_stddev_samp_order_by>;
  sum?: InputMaybe<report_answer_chosen_option_sum_order_by>;
  var_pop?: InputMaybe<report_answer_chosen_option_var_pop_order_by>;
  var_samp?: InputMaybe<report_answer_chosen_option_var_samp_order_by>;
  variance?: InputMaybe<report_answer_chosen_option_variance_order_by>;
};

/** order by avg() on columns of table "report_answer_chosen_option" */
export type report_answer_chosen_option_avg_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_answer_chosen_option". All fields are combined with a logical 'AND'. */
export type report_answer_chosen_option_bool_exp = {
  _and?: InputMaybe<Array<report_answer_chosen_option_bool_exp>>;
  _not?: InputMaybe<report_answer_chosen_option_bool_exp>;
  _or?: InputMaybe<Array<report_answer_chosen_option_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  report_answer?: InputMaybe<report_answer_bool_exp>;
  report_answer_id?: InputMaybe<Int_comparison_exp>;
  report_template_question_option?: InputMaybe<report_template_question_option_bool_exp>;
  report_template_question_option_id?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "report_answer_chosen_option" */
export type report_answer_chosen_option_max_order_by = {
  created_at?: InputMaybe<order_by>;
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "report_answer_chosen_option" */
export type report_answer_chosen_option_min_order_by = {
  created_at?: InputMaybe<order_by>;
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_answer_chosen_option". */
export type report_answer_chosen_option_order_by = {
  created_at?: InputMaybe<order_by>;
  report_answer?: InputMaybe<report_answer_order_by>;
  report_answer_id?: InputMaybe<order_by>;
  report_template_question_option?: InputMaybe<report_template_question_option_order_by>;
  report_template_question_option_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "report_answer_chosen_option" */
export enum report_answer_chosen_option_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  report_answer_id = 'report_answer_id',
  /** column name */
  report_template_question_option_id = 'report_template_question_option_id',
  /** column name */
  updated_at = 'updated_at',
}

/** order by stddev() on columns of table "report_answer_chosen_option" */
export type report_answer_chosen_option_stddev_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "report_answer_chosen_option" */
export type report_answer_chosen_option_stddev_pop_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "report_answer_chosen_option" */
export type report_answer_chosen_option_stddev_samp_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_answer_chosen_option" */
export type report_answer_chosen_option_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_answer_chosen_option_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_answer_chosen_option_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The answer record. */
  report_answer_id?: InputMaybe<Scalars['Int']['input']>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "report_answer_chosen_option" */
export type report_answer_chosen_option_sum_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "report_answer_chosen_option" */
export type report_answer_chosen_option_var_pop_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "report_answer_chosen_option" */
export type report_answer_chosen_option_var_samp_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "report_answer_chosen_option" */
export type report_answer_chosen_option_variance_order_by = {
  /** The answer record. */
  report_answer_id?: InputMaybe<order_by>;
  /** The selected option. */
  report_template_question_option_id?: InputMaybe<order_by>;
};

/** aggregate max on columns */
export type report_answer_max_fields = {
  /** The computed result of evaluating the question's autofill expression against building data. Stored as a string. */
  autofill?: Maybe<Scalars['String']['output']>;
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The report instance this answer belongs to. */
  report_id?: Maybe<Scalars['Int']['output']>;
  /** The template question being answered. */
  report_question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Free-text or numeric answer value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "report_answer" */
export type report_answer_max_order_by = {
  /** The computed result of evaluating the question's autofill expression against building data. Stored as a string. */
  autofill?: InputMaybe<order_by>;
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<order_by>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Free-text or numeric answer value. */
  value?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type report_answer_min_fields = {
  /** The computed result of evaluating the question's autofill expression against building data. Stored as a string. */
  autofill?: Maybe<Scalars['String']['output']>;
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The report instance this answer belongs to. */
  report_id?: Maybe<Scalars['Int']['output']>;
  /** The template question being answered. */
  report_question_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Free-text or numeric answer value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "report_answer" */
export type report_answer_min_order_by = {
  /** The computed result of evaluating the question's autofill expression against building data. Stored as a string. */
  autofill?: InputMaybe<order_by>;
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<order_by>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** Free-text or numeric answer value. */
  value?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_answer". */
export type report_answer_order_by = {
  autofill?: InputMaybe<order_by>;
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  report?: InputMaybe<report_order_by>;
  report_answer_autofill_options_aggregate?: InputMaybe<report_answer_autofill_option_aggregate_order_by>;
  report_answer_chosen_options_aggregate?: InputMaybe<report_answer_chosen_option_aggregate_order_by>;
  report_id?: InputMaybe<order_by>;
  report_question_id?: InputMaybe<order_by>;
  report_template_question?: InputMaybe<report_template_question_order_by>;
  state?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "report_answer" */
export enum report_answer_select_column {
  /** column name */
  autofill = 'autofill',
  /** column name */
  building_id = 'building_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  report_id = 'report_id',
  /** column name */
  report_question_id = 'report_question_id',
  /** column name */
  state = 'state',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  value = 'value',
}

export enum report_answer_state_enum {
  ANSWERED = 'ANSWERED',
  REVIEWED = 'REVIEWED',
  UNANSWERED = 'UNANSWERED',
}

/** Boolean expression to compare columns of type "report_answer_state_enum". All fields are combined with logical 'AND'. */
export type report_answer_state_enum_comparison_exp = {
  _eq?: InputMaybe<report_answer_state_enum>;
  _in?: InputMaybe<Array<report_answer_state_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<report_answer_state_enum>;
  _nin?: InputMaybe<Array<report_answer_state_enum>>;
};

/** aggregate stddev on columns */
export type report_answer_stddev_fields = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The report instance this answer belongs to. */
  report_id?: Maybe<Scalars['Float']['output']>;
  /** The template question being answered. */
  report_question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "report_answer" */
export type report_answer_stddev_order_by = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<order_by>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type report_answer_stddev_pop_fields = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The report instance this answer belongs to. */
  report_id?: Maybe<Scalars['Float']['output']>;
  /** The template question being answered. */
  report_question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "report_answer" */
export type report_answer_stddev_pop_order_by = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<order_by>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type report_answer_stddev_samp_fields = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The report instance this answer belongs to. */
  report_id?: Maybe<Scalars['Float']['output']>;
  /** The template question being answered. */
  report_question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "report_answer" */
export type report_answer_stddev_samp_order_by = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<order_by>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_answer" */
export type report_answer_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_answer_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_answer_stream_cursor_value_input = {
  /** The computed result of evaluating the question's autofill expression against building data. Stored as a string. */
  autofill?: InputMaybe<Scalars['String']['input']>;
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<Scalars['Int']['input']>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<Scalars['Int']['input']>;
  /** Answer state (e.g., UNANSWERED, ANSWERED). */
  state?: InputMaybe<report_answer_state_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Free-text or numeric answer value. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type report_answer_sum_fields = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The report instance this answer belongs to. */
  report_id?: Maybe<Scalars['Int']['output']>;
  /** The template question being answered. */
  report_question_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "report_answer" */
export type report_answer_sum_order_by = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<order_by>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type report_answer_var_pop_fields = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The report instance this answer belongs to. */
  report_id?: Maybe<Scalars['Float']['output']>;
  /** The template question being answered. */
  report_question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "report_answer" */
export type report_answer_var_pop_order_by = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<order_by>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type report_answer_var_samp_fields = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The report instance this answer belongs to. */
  report_id?: Maybe<Scalars['Float']['output']>;
  /** The template question being answered. */
  report_question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "report_answer" */
export type report_answer_var_samp_order_by = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<order_by>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type report_answer_variance_fields = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The report instance this answer belongs to. */
  report_id?: Maybe<Scalars['Float']['output']>;
  /** The template question being answered. */
  report_question_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "report_answer" */
export type report_answer_variance_order_by = {
  /** For building-level questions, the specific building this answer applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this answer belongs to. */
  report_id?: InputMaybe<order_by>;
  /** The template question being answered. */
  report_question_id?: InputMaybe<order_by>;
};

/** aggregate avg on columns */
export type report_avg_fields = {
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Overall completion percentage (0 to 1). */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The template this report is based on. */
  report_template_id?: Maybe<Scalars['Float']['output']>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "report" */
export type report_avg_order_by = {
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<order_by>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<order_by>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report". All fields are combined with a logical 'AND'. */
export type report_bool_exp = {
  _and?: InputMaybe<Array<report_bool_exp>>;
  _not?: InputMaybe<report_bool_exp>;
  _or?: InputMaybe<Array<report_bool_exp>>;
  completed?: InputMaybe<Boolean_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  due_date?: InputMaybe<timestamptz_comparison_exp>;
  end_date?: InputMaybe<timestamptz_comparison_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  portfolios?: InputMaybe<portfolio_bool_exp>;
  progress?: InputMaybe<Float_comparison_exp>;
  report_answers?: InputMaybe<report_answer_bool_exp>;
  report_answers_aggregate?: InputMaybe<report_answer_aggregate_bool_exp>;
  report_building_details?: InputMaybe<report_building_details_bool_exp>;
  report_building_details_aggregate?: InputMaybe<report_building_details_aggregate_bool_exp>;
  report_buildings?: InputMaybe<report_building_bool_exp>;
  report_buildings_aggregate?: InputMaybe<report_building_aggregate_bool_exp>;
  report_scores?: InputMaybe<report_score_bool_exp>;
  report_sections_progress?: InputMaybe<report_section_progress_bool_exp>;
  report_template?: InputMaybe<report_template_bool_exp>;
  report_template_id?: InputMaybe<Int_comparison_exp>;
  responsible_user?: InputMaybe<user_bool_exp>;
  responsible_user_id?: InputMaybe<Int_comparison_exp>;
  start_date?: InputMaybe<timestamptz_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Junction table linking buildings to a report instance for portfolio-level assessments. */
export type report_building = {
  /** An object relationship */
  building: building;
  /** A building included in this report. */
  building_id: Scalars['Int']['output'];
  /** An object relationship */
  report: report;
  /** The report instance. */
  report_id: Scalars['Int']['output'];
  /** An array relationship */
  report_sections_progress: Array<report_section_progress>;
};

/** Junction table linking buildings to a report instance for portfolio-level assessments. */
export type report_buildingreport_sections_progressArgs = {
  distinct_on?: InputMaybe<Array<report_section_progress_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_section_progress_order_by>>;
  where?: InputMaybe<report_section_progress_bool_exp>;
};

/** aggregated selection of "report_building" */
export type report_building_aggregate = {
  aggregate?: Maybe<report_building_aggregate_fields>;
  nodes: Array<report_building>;
};

export type report_building_aggregate_bool_exp = {
  count?: InputMaybe<report_building_aggregate_bool_exp_count>;
};

export type report_building_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<report_building_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<report_building_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "report_building" */
export type report_building_aggregate_fields = {
  avg?: Maybe<report_building_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<report_building_max_fields>;
  min?: Maybe<report_building_min_fields>;
  stddev?: Maybe<report_building_stddev_fields>;
  stddev_pop?: Maybe<report_building_stddev_pop_fields>;
  stddev_samp?: Maybe<report_building_stddev_samp_fields>;
  sum?: Maybe<report_building_sum_fields>;
  var_pop?: Maybe<report_building_var_pop_fields>;
  var_samp?: Maybe<report_building_var_samp_fields>;
  variance?: Maybe<report_building_variance_fields>;
};

/** aggregate fields of "report_building" */
export type report_building_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<report_building_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "report_building" */
export type report_building_aggregate_order_by = {
  avg?: InputMaybe<report_building_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_building_max_order_by>;
  min?: InputMaybe<report_building_min_order_by>;
  stddev?: InputMaybe<report_building_stddev_order_by>;
  stddev_pop?: InputMaybe<report_building_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_building_stddev_samp_order_by>;
  sum?: InputMaybe<report_building_sum_order_by>;
  var_pop?: InputMaybe<report_building_var_pop_order_by>;
  var_samp?: InputMaybe<report_building_var_samp_order_by>;
  variance?: InputMaybe<report_building_variance_order_by>;
};

/** aggregate avg on columns */
export type report_building_avg_fields = {
  /** A building included in this report. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The report instance. */
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "report_building" */
export type report_building_avg_order_by = {
  /** A building included in this report. */
  building_id?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_building". All fields are combined with a logical 'AND'. */
export type report_building_bool_exp = {
  _and?: InputMaybe<Array<report_building_bool_exp>>;
  _not?: InputMaybe<report_building_bool_exp>;
  _or?: InputMaybe<Array<report_building_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  report?: InputMaybe<report_bool_exp>;
  report_id?: InputMaybe<Int_comparison_exp>;
  report_sections_progress?: InputMaybe<report_section_progress_bool_exp>;
};

/** columns and relationships of "report_building_details" */
export type report_building_details = {
  building_id?: Maybe<Scalars['Int']['output']>;
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  portfolio_name?: Maybe<Scalars['String']['output']>;
  report_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  report_sections_progress: Array<report_section_progress>;
  street?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "report_building_details" */
export type report_building_detailsreport_sections_progressArgs = {
  distinct_on?: InputMaybe<Array<report_section_progress_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_section_progress_order_by>>;
  where?: InputMaybe<report_section_progress_bool_exp>;
};

/** aggregated selection of "report_building_details" */
export type report_building_details_aggregate = {
  aggregate?: Maybe<report_building_details_aggregate_fields>;
  nodes: Array<report_building_details>;
};

export type report_building_details_aggregate_bool_exp = {
  count?: InputMaybe<report_building_details_aggregate_bool_exp_count>;
};

export type report_building_details_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<report_building_details_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<report_building_details_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "report_building_details" */
export type report_building_details_aggregate_fields = {
  avg?: Maybe<report_building_details_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<report_building_details_max_fields>;
  min?: Maybe<report_building_details_min_fields>;
  stddev?: Maybe<report_building_details_stddev_fields>;
  stddev_pop?: Maybe<report_building_details_stddev_pop_fields>;
  stddev_samp?: Maybe<report_building_details_stddev_samp_fields>;
  sum?: Maybe<report_building_details_sum_fields>;
  var_pop?: Maybe<report_building_details_var_pop_fields>;
  var_samp?: Maybe<report_building_details_var_samp_fields>;
  variance?: Maybe<report_building_details_variance_fields>;
};

/** aggregate fields of "report_building_details" */
export type report_building_details_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<report_building_details_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "report_building_details" */
export type report_building_details_aggregate_order_by = {
  avg?: InputMaybe<report_building_details_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_building_details_max_order_by>;
  min?: InputMaybe<report_building_details_min_order_by>;
  stddev?: InputMaybe<report_building_details_stddev_order_by>;
  stddev_pop?: InputMaybe<report_building_details_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_building_details_stddev_samp_order_by>;
  sum?: InputMaybe<report_building_details_sum_order_by>;
  var_pop?: InputMaybe<report_building_details_var_pop_order_by>;
  var_samp?: InputMaybe<report_building_details_var_samp_order_by>;
  variance?: InputMaybe<report_building_details_variance_order_by>;
};

/** aggregate avg on columns */
export type report_building_details_avg_fields = {
  building_id?: Maybe<Scalars['Float']['output']>;
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "report_building_details" */
export type report_building_details_avg_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_building_details". All fields are combined with a logical 'AND'. */
export type report_building_details_bool_exp = {
  _and?: InputMaybe<Array<report_building_details_bool_exp>>;
  _not?: InputMaybe<report_building_details_bool_exp>;
  _or?: InputMaybe<Array<report_building_details_bool_exp>>;
  building_id?: InputMaybe<Int_comparison_exp>;
  portfolio_id?: InputMaybe<Int_comparison_exp>;
  portfolio_name?: InputMaybe<String_comparison_exp>;
  report_id?: InputMaybe<Int_comparison_exp>;
  report_sections_progress?: InputMaybe<report_section_progress_bool_exp>;
  street?: InputMaybe<String_comparison_exp>;
};

/** aggregate max on columns */
export type report_building_details_max_fields = {
  building_id?: Maybe<Scalars['Int']['output']>;
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  portfolio_name?: Maybe<Scalars['String']['output']>;
  report_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "report_building_details" */
export type report_building_details_max_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  portfolio_name?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type report_building_details_min_fields = {
  building_id?: Maybe<Scalars['Int']['output']>;
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  portfolio_name?: Maybe<Scalars['String']['output']>;
  report_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "report_building_details" */
export type report_building_details_min_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  portfolio_name?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
  street?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_building_details". */
export type report_building_details_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  portfolio_name?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
  report_sections_progress_aggregate?: InputMaybe<report_section_progress_aggregate_order_by>;
  street?: InputMaybe<order_by>;
};

/** select columns of table "report_building_details" */
export enum report_building_details_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  portfolio_id = 'portfolio_id',
  /** column name */
  portfolio_name = 'portfolio_name',
  /** column name */
  report_id = 'report_id',
  /** column name */
  street = 'street',
}

/** aggregate stddev on columns */
export type report_building_details_stddev_fields = {
  building_id?: Maybe<Scalars['Float']['output']>;
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "report_building_details" */
export type report_building_details_stddev_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type report_building_details_stddev_pop_fields = {
  building_id?: Maybe<Scalars['Float']['output']>;
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "report_building_details" */
export type report_building_details_stddev_pop_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type report_building_details_stddev_samp_fields = {
  building_id?: Maybe<Scalars['Float']['output']>;
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "report_building_details" */
export type report_building_details_stddev_samp_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_building_details" */
export type report_building_details_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_building_details_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_building_details_stream_cursor_value_input = {
  building_id?: InputMaybe<Scalars['Int']['input']>;
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  portfolio_name?: InputMaybe<Scalars['String']['input']>;
  report_id?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type report_building_details_sum_fields = {
  building_id?: Maybe<Scalars['Int']['output']>;
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  report_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "report_building_details" */
export type report_building_details_sum_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type report_building_details_var_pop_fields = {
  building_id?: Maybe<Scalars['Float']['output']>;
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "report_building_details" */
export type report_building_details_var_pop_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type report_building_details_var_samp_fields = {
  building_id?: Maybe<Scalars['Float']['output']>;
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "report_building_details" */
export type report_building_details_var_samp_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type report_building_details_variance_fields = {
  building_id?: Maybe<Scalars['Float']['output']>;
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "report_building_details" */
export type report_building_details_variance_order_by = {
  building_id?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
};

/** aggregate max on columns */
export type report_building_max_fields = {
  /** A building included in this report. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** The report instance. */
  report_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "report_building" */
export type report_building_max_order_by = {
  /** A building included in this report. */
  building_id?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type report_building_min_fields = {
  /** A building included in this report. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** The report instance. */
  report_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "report_building" */
export type report_building_min_order_by = {
  /** A building included in this report. */
  building_id?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_building". */
export type report_building_order_by = {
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  report?: InputMaybe<report_order_by>;
  report_id?: InputMaybe<order_by>;
  report_sections_progress_aggregate?: InputMaybe<report_section_progress_aggregate_order_by>;
};

/** select columns of table "report_building" */
export enum report_building_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  report_id = 'report_id',
}

/** aggregate stddev on columns */
export type report_building_stddev_fields = {
  /** A building included in this report. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The report instance. */
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "report_building" */
export type report_building_stddev_order_by = {
  /** A building included in this report. */
  building_id?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type report_building_stddev_pop_fields = {
  /** A building included in this report. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The report instance. */
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "report_building" */
export type report_building_stddev_pop_order_by = {
  /** A building included in this report. */
  building_id?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type report_building_stddev_samp_fields = {
  /** A building included in this report. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The report instance. */
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "report_building" */
export type report_building_stddev_samp_order_by = {
  /** A building included in this report. */
  building_id?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_building" */
export type report_building_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_building_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_building_stream_cursor_value_input = {
  /** A building included in this report. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** The report instance. */
  report_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type report_building_sum_fields = {
  /** A building included in this report. */
  building_id?: Maybe<Scalars['Int']['output']>;
  /** The report instance. */
  report_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "report_building" */
export type report_building_sum_order_by = {
  /** A building included in this report. */
  building_id?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type report_building_var_pop_fields = {
  /** A building included in this report. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The report instance. */
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "report_building" */
export type report_building_var_pop_order_by = {
  /** A building included in this report. */
  building_id?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type report_building_var_samp_fields = {
  /** A building included in this report. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The report instance. */
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "report_building" */
export type report_building_var_samp_order_by = {
  /** A building included in this report. */
  building_id?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type report_building_variance_fields = {
  /** A building included in this report. */
  building_id?: Maybe<Scalars['Float']['output']>;
  /** The report instance. */
  report_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "report_building" */
export type report_building_variance_order_by = {
  /** A building included in this report. */
  building_id?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
};

/** An evidence document (file or URL) uploaded to support answers in a report. */
export type report_evidence = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  file?: Maybe<file>;
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  report: report;
  /** The report instance this evidence belongs to. */
  report_id: Scalars['Int']['output'];
  /** An array relationship */
  report_question_evidences: Array<report_question_evidence>;
  updated_at: Scalars['timestamptz']['output'];
  /** External URL for the evidence. Null if evidence is an uploaded file. */
  url?: Maybe<Scalars['String']['output']>;
};

/** An evidence document (file or URL) uploaded to support answers in a report. */
export type report_evidencereport_question_evidencesArgs = {
  distinct_on?: InputMaybe<Array<report_question_evidence_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_question_evidence_order_by>>;
  where?: InputMaybe<report_question_evidence_bool_exp>;
};

/** order by aggregate values of table "report_evidence" */
export type report_evidence_aggregate_order_by = {
  avg?: InputMaybe<report_evidence_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_evidence_max_order_by>;
  min?: InputMaybe<report_evidence_min_order_by>;
  stddev?: InputMaybe<report_evidence_stddev_order_by>;
  stddev_pop?: InputMaybe<report_evidence_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_evidence_stddev_samp_order_by>;
  sum?: InputMaybe<report_evidence_sum_order_by>;
  var_pop?: InputMaybe<report_evidence_var_pop_order_by>;
  var_samp?: InputMaybe<report_evidence_var_samp_order_by>;
  variance?: InputMaybe<report_evidence_variance_order_by>;
};

/** input type for inserting array relation for remote table "report_evidence" */
export type report_evidence_arr_rel_insert_input = {
  data: Array<report_evidence_insert_input>;
  /** upsert condition */
  on_conflict?: InputMaybe<report_evidence_on_conflict>;
};

/** order by avg() on columns of table "report_evidence" */
export type report_evidence_avg_order_by = {
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_evidence". All fields are combined with a logical 'AND'. */
export type report_evidence_bool_exp = {
  _and?: InputMaybe<Array<report_evidence_bool_exp>>;
  _not?: InputMaybe<report_evidence_bool_exp>;
  _or?: InputMaybe<Array<report_evidence_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  file?: InputMaybe<file_bool_exp>;
  file_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  report?: InputMaybe<report_bool_exp>;
  report_id?: InputMaybe<Int_comparison_exp>;
  report_question_evidences?: InputMaybe<report_question_evidence_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  url?: InputMaybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "report_evidence" */
export enum report_evidence_constraint {
  /** unique or primary key constraint on columns "id" */
  report_evidence_pkey = 'report_evidence_pkey',
}

/** input type for inserting data into table "report_evidence" */
export type report_evidence_insert_input = {
  file?: InputMaybe<file_obj_rel_insert_input>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<Scalars['Int']['input']>;
  /** External URL for the evidence. Null if evidence is an uploaded file. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "report_evidence" */
export type report_evidence_max_order_by = {
  created_at?: InputMaybe<order_by>;
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** External URL for the evidence. Null if evidence is an uploaded file. */
  url?: InputMaybe<order_by>;
};

/** order by min() on columns of table "report_evidence" */
export type report_evidence_min_order_by = {
  created_at?: InputMaybe<order_by>;
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** External URL for the evidence. Null if evidence is an uploaded file. */
  url?: InputMaybe<order_by>;
};

/** response of any mutation on the table "report_evidence" */
export type report_evidence_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<report_evidence>;
};

/** on_conflict condition type for table "report_evidence" */
export type report_evidence_on_conflict = {
  constraint: report_evidence_constraint;
  update_columns?: Array<report_evidence_update_column>;
  where?: InputMaybe<report_evidence_bool_exp>;
};

/** Ordering options when selecting data from "report_evidence". */
export type report_evidence_order_by = {
  created_at?: InputMaybe<order_by>;
  file?: InputMaybe<file_order_by>;
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  report?: InputMaybe<report_order_by>;
  report_id?: InputMaybe<order_by>;
  report_question_evidences_aggregate?: InputMaybe<report_question_evidence_aggregate_order_by>;
  updated_at?: InputMaybe<order_by>;
  url?: InputMaybe<order_by>;
};

/** select columns of table "report_evidence" */
export enum report_evidence_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  file_id = 'file_id',
  /** column name */
  id = 'id',
  /** column name */
  report_id = 'report_id',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  url = 'url',
}

/** order by stddev() on columns of table "report_evidence" */
export type report_evidence_stddev_order_by = {
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "report_evidence" */
export type report_evidence_stddev_pop_order_by = {
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "report_evidence" */
export type report_evidence_stddev_samp_order_by = {
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_evidence" */
export type report_evidence_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_evidence_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_evidence_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** External URL for the evidence. Null if evidence is an uploaded file. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "report_evidence" */
export type report_evidence_sum_order_by = {
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<order_by>;
};

/** placeholder for update columns of table "report_evidence" (current role has no relevant permissions) */
export enum report_evidence_update_column {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER',
}

/** order by var_pop() on columns of table "report_evidence" */
export type report_evidence_var_pop_order_by = {
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "report_evidence" */
export type report_evidence_var_samp_order_by = {
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "report_evidence" */
export type report_evidence_variance_order_by = {
  /** Reference to the uploaded evidence file. Null if evidence is a URL. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The report instance this evidence belongs to. */
  report_id?: InputMaybe<order_by>;
};

/** aggregate max on columns */
export type report_max_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Deadline for completing the report. */
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  /** End of the reporting period. */
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Overall completion percentage (0 to 1). */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The template this report is based on. */
  report_template_id?: Maybe<Scalars['Int']['output']>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  /** Start of the reporting period. */
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "report" */
export type report_max_order_by = {
  created_at?: InputMaybe<order_by>;
  /** Deadline for completing the report. */
  due_date?: InputMaybe<order_by>;
  /** End of the reporting period. */
  end_date?: InputMaybe<order_by>;
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<order_by>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<order_by>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Start of the reporting period. */
  start_date?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type report_min_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Deadline for completing the report. */
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  /** End of the reporting period. */
  end_date?: Maybe<Scalars['timestamptz']['output']>;
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Overall completion percentage (0 to 1). */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The template this report is based on. */
  report_template_id?: Maybe<Scalars['Int']['output']>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  /** Start of the reporting period. */
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "report" */
export type report_min_order_by = {
  created_at?: InputMaybe<order_by>;
  /** Deadline for completing the report. */
  due_date?: InputMaybe<order_by>;
  /** End of the reporting period. */
  end_date?: InputMaybe<order_by>;
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<order_by>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<order_by>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<order_by>;
  /** Start of the reporting period. */
  start_date?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** response of any mutation on the table "report" */
export type report_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<report>;
};

/** Ordering options when selecting data from "report". */
export type report_order_by = {
  completed?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  due_date?: InputMaybe<order_by>;
  end_date?: InputMaybe<order_by>;
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  portfolios_aggregate?: InputMaybe<portfolio_aggregate_order_by>;
  progress?: InputMaybe<order_by>;
  report_answers_aggregate?: InputMaybe<report_answer_aggregate_order_by>;
  report_building_details_aggregate?: InputMaybe<report_building_details_aggregate_order_by>;
  report_buildings_aggregate?: InputMaybe<report_building_aggregate_order_by>;
  report_scores_aggregate?: InputMaybe<report_score_aggregate_order_by>;
  report_sections_progress_aggregate?: InputMaybe<report_section_progress_aggregate_order_by>;
  report_template?: InputMaybe<report_template_order_by>;
  report_template_id?: InputMaybe<order_by>;
  responsible_user?: InputMaybe<user_order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  start_date?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** columns and relationships of "report_overview" */
export type report_overview = {
  completed?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  portfolio_name?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  report_id?: Maybe<Scalars['Int']['output']>;
  report_template_excel_path_de?: Maybe<Scalars['String']['output']>;
  report_template_excel_path_en?: Maybe<Scalars['String']['output']>;
  report_template_id?: Maybe<Scalars['Int']['output']>;
  report_template_title?: Maybe<Scalars['String']['output']>;
  responsible_user_first_name?: Maybe<Scalars['String']['output']>;
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
  responsible_user_last_name?: Maybe<Scalars['String']['output']>;
  streets?: Maybe<Array<Scalars['String']['output']>>;
};

/** Boolean expression to filter rows from the table "report_overview". All fields are combined with a logical 'AND'. */
export type report_overview_bool_exp = {
  _and?: InputMaybe<Array<report_overview_bool_exp>>;
  _not?: InputMaybe<report_overview_bool_exp>;
  _or?: InputMaybe<Array<report_overview_bool_exp>>;
  completed?: InputMaybe<Boolean_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  portfolio_id?: InputMaybe<Int_comparison_exp>;
  portfolio_name?: InputMaybe<String_comparison_exp>;
  progress?: InputMaybe<Float_comparison_exp>;
  report_id?: InputMaybe<Int_comparison_exp>;
  report_template_excel_path_de?: InputMaybe<String_comparison_exp>;
  report_template_excel_path_en?: InputMaybe<String_comparison_exp>;
  report_template_id?: InputMaybe<Int_comparison_exp>;
  report_template_title?: InputMaybe<String_comparison_exp>;
  responsible_user_first_name?: InputMaybe<String_comparison_exp>;
  responsible_user_id?: InputMaybe<Int_comparison_exp>;
  responsible_user_last_name?: InputMaybe<String_comparison_exp>;
  streets?: InputMaybe<String_array_comparison_exp>;
};

/** Ordering options when selecting data from "report_overview". */
export type report_overview_order_by = {
  completed?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  portfolio_id?: InputMaybe<order_by>;
  portfolio_name?: InputMaybe<order_by>;
  progress?: InputMaybe<order_by>;
  report_id?: InputMaybe<order_by>;
  report_template_excel_path_de?: InputMaybe<order_by>;
  report_template_excel_path_en?: InputMaybe<order_by>;
  report_template_id?: InputMaybe<order_by>;
  report_template_title?: InputMaybe<order_by>;
  responsible_user_first_name?: InputMaybe<order_by>;
  responsible_user_id?: InputMaybe<order_by>;
  responsible_user_last_name?: InputMaybe<order_by>;
  streets?: InputMaybe<order_by>;
};

/** select columns of table "report_overview" */
export enum report_overview_select_column {
  /** column name */
  completed = 'completed',
  /** column name */
  created_at = 'created_at',
  /** column name */
  portfolio_id = 'portfolio_id',
  /** column name */
  portfolio_name = 'portfolio_name',
  /** column name */
  progress = 'progress',
  /** column name */
  report_id = 'report_id',
  /** column name */
  report_template_excel_path_de = 'report_template_excel_path_de',
  /** column name */
  report_template_excel_path_en = 'report_template_excel_path_en',
  /** column name */
  report_template_id = 'report_template_id',
  /** column name */
  report_template_title = 'report_template_title',
  /** column name */
  responsible_user_first_name = 'responsible_user_first_name',
  /** column name */
  responsible_user_id = 'responsible_user_id',
  /** column name */
  responsible_user_last_name = 'responsible_user_last_name',
  /** column name */
  streets = 'streets',
}

/** Streaming cursor of the table "report_overview" */
export type report_overview_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_overview_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_overview_stream_cursor_value_input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  portfolio_name?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Float']['input']>;
  report_id?: InputMaybe<Scalars['Int']['input']>;
  report_template_excel_path_de?: InputMaybe<Scalars['String']['input']>;
  report_template_excel_path_en?: InputMaybe<Scalars['String']['input']>;
  report_template_id?: InputMaybe<Scalars['Int']['input']>;
  report_template_title?: InputMaybe<Scalars['String']['input']>;
  responsible_user_first_name?: InputMaybe<Scalars['String']['input']>;
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  responsible_user_last_name?: InputMaybe<Scalars['String']['input']>;
  streets?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** primary key columns input for table: report */
export type report_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** Links an evidence document to a specific report question, with an optional description. */
export type report_question_evidence = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** User-provided description of how this evidence relates to the question. */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  report_evidence: report_evidence;
  /** The evidence document. */
  report_evidence_id: Scalars['Int']['output'];
  /** An object relationship */
  report_template_question: report_template_question;
  /** The question this evidence supports. */
  report_template_question_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "report_question_evidence" */
export type report_question_evidence_aggregate_order_by = {
  avg?: InputMaybe<report_question_evidence_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_question_evidence_max_order_by>;
  min?: InputMaybe<report_question_evidence_min_order_by>;
  stddev?: InputMaybe<report_question_evidence_stddev_order_by>;
  stddev_pop?: InputMaybe<report_question_evidence_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_question_evidence_stddev_samp_order_by>;
  sum?: InputMaybe<report_question_evidence_sum_order_by>;
  var_pop?: InputMaybe<report_question_evidence_var_pop_order_by>;
  var_samp?: InputMaybe<report_question_evidence_var_samp_order_by>;
  variance?: InputMaybe<report_question_evidence_variance_order_by>;
};

/** order by avg() on columns of table "report_question_evidence" */
export type report_question_evidence_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<order_by>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_question_evidence". All fields are combined with a logical 'AND'. */
export type report_question_evidence_bool_exp = {
  _and?: InputMaybe<Array<report_question_evidence_bool_exp>>;
  _not?: InputMaybe<report_question_evidence_bool_exp>;
  _or?: InputMaybe<Array<report_question_evidence_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  report_evidence?: InputMaybe<report_evidence_bool_exp>;
  report_evidence_id?: InputMaybe<Int_comparison_exp>;
  report_template_question?: InputMaybe<report_template_question_bool_exp>;
  report_template_question_id?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "report_question_evidence" */
export type report_question_evidence_max_order_by = {
  created_at?: InputMaybe<order_by>;
  /** User-provided description of how this evidence relates to the question. */
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<order_by>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "report_question_evidence" */
export type report_question_evidence_min_order_by = {
  created_at?: InputMaybe<order_by>;
  /** User-provided description of how this evidence relates to the question. */
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<order_by>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** response of any mutation on the table "report_question_evidence" */
export type report_question_evidence_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<report_question_evidence>;
};

/** Ordering options when selecting data from "report_question_evidence". */
export type report_question_evidence_order_by = {
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  report_evidence?: InputMaybe<report_evidence_order_by>;
  report_evidence_id?: InputMaybe<order_by>;
  report_template_question?: InputMaybe<report_template_question_order_by>;
  report_template_question_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "report_question_evidence" */
export enum report_question_evidence_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  report_evidence_id = 'report_evidence_id',
  /** column name */
  report_template_question_id = 'report_template_question_id',
  /** column name */
  updated_at = 'updated_at',
}

/** order by stddev() on columns of table "report_question_evidence" */
export type report_question_evidence_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<order_by>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "report_question_evidence" */
export type report_question_evidence_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<order_by>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "report_question_evidence" */
export type report_question_evidence_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<order_by>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_question_evidence" */
export type report_question_evidence_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_question_evidence_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_question_evidence_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** User-provided description of how this evidence relates to the question. */
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<Scalars['Int']['input']>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "report_question_evidence" */
export type report_question_evidence_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<order_by>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "report_question_evidence" */
export type report_question_evidence_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<order_by>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "report_question_evidence" */
export type report_question_evidence_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<order_by>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "report_question_evidence" */
export type report_question_evidence_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** The evidence document. */
  report_evidence_id?: InputMaybe<order_by>;
  /** The question this evidence supports. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** Calculated score for a specific scoring dimension within a report instance. */
export type report_score = {
  id: Scalars['Int']['output'];
  max_score?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  report: report;
  /** The report instance this score belongs to. */
  report_id: Scalars['Int']['output'];
  /** An object relationship */
  report_template_score: report_template_score;
  /** Computed score value. */
  value: Scalars['Float']['output'];
};

/** order by aggregate values of table "report_score" */
export type report_score_aggregate_order_by = {
  avg?: InputMaybe<report_score_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_score_max_order_by>;
  min?: InputMaybe<report_score_min_order_by>;
  stddev?: InputMaybe<report_score_stddev_order_by>;
  stddev_pop?: InputMaybe<report_score_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_score_stddev_samp_order_by>;
  sum?: InputMaybe<report_score_sum_order_by>;
  var_pop?: InputMaybe<report_score_var_pop_order_by>;
  var_samp?: InputMaybe<report_score_var_samp_order_by>;
  variance?: InputMaybe<report_score_variance_order_by>;
};

/** order by avg() on columns of table "report_score" */
export type report_score_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<order_by>;
  /** Computed score value. */
  value?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_score". All fields are combined with a logical 'AND'. */
export type report_score_bool_exp = {
  _and?: InputMaybe<Array<report_score_bool_exp>>;
  _not?: InputMaybe<report_score_bool_exp>;
  _or?: InputMaybe<Array<report_score_bool_exp>>;
  id?: InputMaybe<Int_comparison_exp>;
  report?: InputMaybe<report_bool_exp>;
  report_id?: InputMaybe<Int_comparison_exp>;
  report_template_score?: InputMaybe<report_template_score_bool_exp>;
  value?: InputMaybe<Float_comparison_exp>;
};

/** order by max() on columns of table "report_score" */
export type report_score_max_order_by = {
  id?: InputMaybe<order_by>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<order_by>;
  /** Computed score value. */
  value?: InputMaybe<order_by>;
};

/** order by min() on columns of table "report_score" */
export type report_score_min_order_by = {
  id?: InputMaybe<order_by>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<order_by>;
  /** Computed score value. */
  value?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_score". */
export type report_score_order_by = {
  id?: InputMaybe<order_by>;
  report?: InputMaybe<report_order_by>;
  report_id?: InputMaybe<order_by>;
  report_template_score?: InputMaybe<report_template_score_order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "report_score" */
export enum report_score_select_column {
  /** column name */
  id = 'id',
  /** column name */
  report_id = 'report_id',
  /** column name */
  value = 'value',
}

/** order by stddev() on columns of table "report_score" */
export type report_score_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<order_by>;
  /** Computed score value. */
  value?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "report_score" */
export type report_score_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<order_by>;
  /** Computed score value. */
  value?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "report_score" */
export type report_score_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<order_by>;
  /** Computed score value. */
  value?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_score" */
export type report_score_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_score_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_score_stream_cursor_value_input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<Scalars['Int']['input']>;
  /** Computed score value. */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** order by sum() on columns of table "report_score" */
export type report_score_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<order_by>;
  /** Computed score value. */
  value?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "report_score" */
export type report_score_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<order_by>;
  /** Computed score value. */
  value?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "report_score" */
export type report_score_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<order_by>;
  /** Computed score value. */
  value?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "report_score" */
export type report_score_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** The report instance this score belongs to. */
  report_id?: InputMaybe<order_by>;
  /** Computed score value. */
  value?: InputMaybe<order_by>;
};

/** Tracks completion progress for a specific section within a report, optionally per building. */
export type report_section_progress = {
  /** An object relationship */
  building?: Maybe<building>;
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  /** Completion percentage (0 to 1) for this section. */
  progress: Scalars['Float']['output'];
  /** An object relationship */
  report: report;
  /** The report instance. */
  report_id: Scalars['Int']['output'];
  /** An object relationship */
  report_template_section: report_template_section;
  /** The section being tracked. */
  report_template_section_id: Scalars['Int']['output'];
};

/** order by aggregate values of table "report_section_progress" */
export type report_section_progress_aggregate_order_by = {
  avg?: InputMaybe<report_section_progress_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_section_progress_max_order_by>;
  min?: InputMaybe<report_section_progress_min_order_by>;
  stddev?: InputMaybe<report_section_progress_stddev_order_by>;
  stddev_pop?: InputMaybe<report_section_progress_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_section_progress_stddev_samp_order_by>;
  sum?: InputMaybe<report_section_progress_sum_order_by>;
  var_pop?: InputMaybe<report_section_progress_var_pop_order_by>;
  var_samp?: InputMaybe<report_section_progress_var_samp_order_by>;
  variance?: InputMaybe<report_section_progress_variance_order_by>;
};

/** order by avg() on columns of table "report_section_progress" */
export type report_section_progress_avg_order_by = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_section_progress". All fields are combined with a logical 'AND'. */
export type report_section_progress_bool_exp = {
  _and?: InputMaybe<Array<report_section_progress_bool_exp>>;
  _not?: InputMaybe<report_section_progress_bool_exp>;
  _or?: InputMaybe<Array<report_section_progress_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  progress?: InputMaybe<Float_comparison_exp>;
  report?: InputMaybe<report_bool_exp>;
  report_id?: InputMaybe<Int_comparison_exp>;
  report_template_section?: InputMaybe<report_template_section_bool_exp>;
  report_template_section_id?: InputMaybe<Int_comparison_exp>;
};

/** order by max() on columns of table "report_section_progress" */
export type report_section_progress_max_order_by = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "report_section_progress" */
export type report_section_progress_min_order_by = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_section_progress". */
export type report_section_progress_order_by = {
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  progress?: InputMaybe<order_by>;
  report?: InputMaybe<report_order_by>;
  report_id?: InputMaybe<order_by>;
  report_template_section?: InputMaybe<report_template_section_order_by>;
  report_template_section_id?: InputMaybe<order_by>;
};

/** select columns of table "report_section_progress" */
export enum report_section_progress_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  id = 'id',
  /** column name */
  progress = 'progress',
  /** column name */
  report_id = 'report_id',
  /** column name */
  report_template_section_id = 'report_template_section_id',
}

/** order by stddev() on columns of table "report_section_progress" */
export type report_section_progress_stddev_order_by = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "report_section_progress" */
export type report_section_progress_stddev_pop_order_by = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "report_section_progress" */
export type report_section_progress_stddev_samp_order_by = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_section_progress" */
export type report_section_progress_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_section_progress_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_section_progress_stream_cursor_value_input = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<Scalars['Float']['input']>;
  /** The report instance. */
  report_id?: InputMaybe<Scalars['Int']['input']>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "report_section_progress" */
export type report_section_progress_sum_order_by = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "report_section_progress" */
export type report_section_progress_var_pop_order_by = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "report_section_progress" */
export type report_section_progress_var_samp_order_by = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "report_section_progress" */
export type report_section_progress_variance_order_by = {
  /** For building-level sections, the specific building this progress applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Completion percentage (0 to 1) for this section. */
  progress?: InputMaybe<order_by>;
  /** The report instance. */
  report_id?: InputMaybe<order_by>;
  /** The section being tracked. */
  report_template_section_id?: InputMaybe<order_by>;
};

/** select columns of table "report" */
export enum report_select_column {
  /** column name */
  completed = 'completed',
  /** column name */
  created_at = 'created_at',
  /** column name */
  due_date = 'due_date',
  /** column name */
  end_date = 'end_date',
  /** column name */
  file_id = 'file_id',
  /** column name */
  id = 'id',
  /** column name */
  progress = 'progress',
  /** column name */
  report_template_id = 'report_template_id',
  /** column name */
  responsible_user_id = 'responsible_user_id',
  /** column name */
  start_date = 'start_date',
  /** column name */
  updated_at = 'updated_at',
}

/** select "report_aggregate_bool_exp_bool_and_arguments_columns" columns of table "report" */
export enum report_select_column_report_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  completed = 'completed',
}

/** select "report_aggregate_bool_exp_bool_or_arguments_columns" columns of table "report" */
export enum report_select_column_report_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  completed = 'completed',
}

/** input type for updating data in table "report" */
export type report_set_input = {
  /** Whether the report has been finalized. */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type report_stddev_fields = {
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Overall completion percentage (0 to 1). */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The template this report is based on. */
  report_template_id?: Maybe<Scalars['Float']['output']>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "report" */
export type report_stddev_order_by = {
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<order_by>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<order_by>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type report_stddev_pop_fields = {
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Overall completion percentage (0 to 1). */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The template this report is based on. */
  report_template_id?: Maybe<Scalars['Float']['output']>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "report" */
export type report_stddev_pop_order_by = {
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<order_by>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<order_by>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type report_stddev_samp_fields = {
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Overall completion percentage (0 to 1). */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The template this report is based on. */
  report_template_id?: Maybe<Scalars['Float']['output']>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "report" */
export type report_stddev_samp_order_by = {
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<order_by>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<order_by>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report" */
export type report_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_stream_cursor_value_input = {
  /** Whether the report has been finalized. */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Deadline for completing the report. */
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  /** End of the reporting period. */
  end_date?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<Scalars['Float']['input']>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<Scalars['Int']['input']>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Start of the reporting period. */
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type report_sum_fields = {
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Overall completion percentage (0 to 1). */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The template this report is based on. */
  report_template_id?: Maybe<Scalars['Int']['output']>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "report" */
export type report_sum_order_by = {
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<order_by>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<order_by>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** Defines a reusable report structure (e.g., ECORE ESG assessment) with sections, questions, and scoring rules. */
export type report_template = {
  created_at: Scalars['timestamptz']['output'];
  /** Explanation of the report template purpose and scope. */
  description: Scalars['String']['output'];
  description_en?: Maybe<Scalars['String']['output']>;
  /** S3 path to the Excel template used for exporting reports based on this template. */
  excel_template_path_de?: Maybe<Scalars['String']['output']>;
  excel_template_path_en?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Organization that owns this template. Null for system-wide templates. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  report_sections: Array<report_template_section>;
  /** An array relationship */
  report_template_scores: Array<report_template_score>;
  /** If true, reports from this template assess one building at a time rather than a portfolio. */
  single_building: Scalars['Boolean']['output'];
  /** Display name of the report template. */
  title: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Defines a reusable report structure (e.g., ECORE ESG assessment) with sections, questions, and scoring rules. */
export type report_templatereport_sectionsArgs = {
  distinct_on?: InputMaybe<Array<report_template_section_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_section_order_by>>;
  where?: InputMaybe<report_template_section_bool_exp>;
};

/** Defines a reusable report structure (e.g., ECORE ESG assessment) with sections, questions, and scoring rules. */
export type report_templatereport_template_scoresArgs = {
  distinct_on?: InputMaybe<Array<report_template_score_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_score_order_by>>;
  where?: InputMaybe<report_template_score_bool_exp>;
};

/** Boolean expression to filter rows from the table "report_template". All fields are combined with a logical 'AND'. */
export type report_template_bool_exp = {
  _and?: InputMaybe<Array<report_template_bool_exp>>;
  _not?: InputMaybe<report_template_bool_exp>;
  _or?: InputMaybe<Array<report_template_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  description_en?: InputMaybe<String_comparison_exp>;
  excel_template_path_de?: InputMaybe<String_comparison_exp>;
  excel_template_path_en?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  report_sections?: InputMaybe<report_template_section_bool_exp>;
  report_template_scores?: InputMaybe<report_template_score_bool_exp>;
  single_building?: InputMaybe<Boolean_comparison_exp>;
  title?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Ordering options when selecting data from "report_template". */
export type report_template_order_by = {
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  description_en?: InputMaybe<order_by>;
  excel_template_path_de?: InputMaybe<order_by>;
  excel_template_path_en?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  org_id?: InputMaybe<order_by>;
  report_sections_aggregate?: InputMaybe<report_template_section_aggregate_order_by>;
  report_template_scores_aggregate?: InputMaybe<report_template_score_aggregate_order_by>;
  single_building?: InputMaybe<order_by>;
  title?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** A question within a report template section. Supports various types (text, numeric, single/multi-choice) with optional scoring and autofill. */
export type report_template_question = {
  created_at: Scalars['timestamptz']['output'];
  /** Help text or guidance for answering the question. */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the user must upload evidence documents when answering this question. */
  evidence_required?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** Sort order within the parent section or option. */
  order: Scalars['Int']['output'];
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Int']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Int']['output']>;
  /** The question text displayed to the user. */
  question: Scalars['String']['output'];
  /** An array relationship */
  report_answers: Array<report_answer>;
  /** An aggregate relationship */
  report_answers_aggregate: report_answer_aggregate;
  /** An object relationship */
  report_template_parent_option?: Maybe<report_template_question_option>;
  /** An array relationship */
  report_template_question_options: Array<report_template_question_option>;
  /** An object relationship */
  report_template_section?: Maybe<report_template_section>;
  /** Question type (e.g., TEXT, NUMBER, SINGLE_CHOICE, MULTI_CHOICE). */
  type: report_template_question_type_enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** A question within a report template section. Supports various types (text, numeric, single/multi-choice) with optional scoring and autofill. */
export type report_template_questionreport_answersArgs = {
  distinct_on?: InputMaybe<Array<report_answer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_order_by>>;
  where?: InputMaybe<report_answer_bool_exp>;
};

/** A question within a report template section. Supports various types (text, numeric, single/multi-choice) with optional scoring and autofill. */
export type report_template_questionreport_answers_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_answer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_order_by>>;
  where?: InputMaybe<report_answer_bool_exp>;
};

/** A question within a report template section. Supports various types (text, numeric, single/multi-choice) with optional scoring and autofill. */
export type report_template_questionreport_template_question_optionsArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_option_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_option_order_by>>;
  where?: InputMaybe<report_template_question_option_bool_exp>;
};

/** aggregated selection of "report_template_question" */
export type report_template_question_aggregate = {
  aggregate?: Maybe<report_template_question_aggregate_fields>;
  nodes: Array<report_template_question>;
};

export type report_template_question_aggregate_bool_exp = {
  bool_and?: InputMaybe<report_template_question_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<report_template_question_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<report_template_question_aggregate_bool_exp_count>;
};

export type report_template_question_aggregate_bool_exp_bool_and = {
  arguments: report_template_question_select_column_report_template_question_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<report_template_question_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type report_template_question_aggregate_bool_exp_bool_or = {
  arguments: report_template_question_select_column_report_template_question_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<report_template_question_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type report_template_question_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<report_template_question_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<report_template_question_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "report_template_question" */
export type report_template_question_aggregate_fields = {
  avg?: Maybe<report_template_question_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<report_template_question_max_fields>;
  min?: Maybe<report_template_question_min_fields>;
  stddev?: Maybe<report_template_question_stddev_fields>;
  stddev_pop?: Maybe<report_template_question_stddev_pop_fields>;
  stddev_samp?: Maybe<report_template_question_stddev_samp_fields>;
  sum?: Maybe<report_template_question_sum_fields>;
  var_pop?: Maybe<report_template_question_var_pop_fields>;
  var_samp?: Maybe<report_template_question_var_samp_fields>;
  variance?: Maybe<report_template_question_variance_fields>;
};

/** aggregate fields of "report_template_question" */
export type report_template_question_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<report_template_question_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "report_template_question" */
export type report_template_question_aggregate_order_by = {
  avg?: InputMaybe<report_template_question_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_template_question_max_order_by>;
  min?: InputMaybe<report_template_question_min_order_by>;
  stddev?: InputMaybe<report_template_question_stddev_order_by>;
  stddev_pop?: InputMaybe<report_template_question_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_template_question_stddev_samp_order_by>;
  sum?: InputMaybe<report_template_question_sum_order_by>;
  var_pop?: InputMaybe<report_template_question_var_pop_order_by>;
  var_samp?: InputMaybe<report_template_question_var_samp_order_by>;
  variance?: InputMaybe<report_template_question_variance_order_by>;
};

/** aggregate avg on columns */
export type report_template_question_avg_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Sort order within the parent section or option. */
  order?: Maybe<Scalars['Float']['output']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Float']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "report_template_question" */
export type report_template_question_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<order_by>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<order_by>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_template_question". All fields are combined with a logical 'AND'. */
export type report_template_question_bool_exp = {
  _and?: InputMaybe<Array<report_template_question_bool_exp>>;
  _not?: InputMaybe<report_template_question_bool_exp>;
  _or?: InputMaybe<Array<report_template_question_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  evidence_required?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  order?: InputMaybe<Int_comparison_exp>;
  parent_option_id?: InputMaybe<Int_comparison_exp>;
  parent_section_id?: InputMaybe<Int_comparison_exp>;
  question?: InputMaybe<String_comparison_exp>;
  report_answers?: InputMaybe<report_answer_bool_exp>;
  report_answers_aggregate?: InputMaybe<report_answer_aggregate_bool_exp>;
  report_template_parent_option?: InputMaybe<report_template_question_option_bool_exp>;
  report_template_question_options?: InputMaybe<report_template_question_option_bool_exp>;
  report_template_section?: InputMaybe<report_template_section_bool_exp>;
  type?: InputMaybe<report_template_question_type_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type report_template_question_max_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Help text or guidance for answering the question. */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Sort order within the parent section or option. */
  order?: Maybe<Scalars['Int']['output']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Int']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Int']['output']>;
  /** The question text displayed to the user. */
  question?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "report_template_question" */
export type report_template_question_max_order_by = {
  created_at?: InputMaybe<order_by>;
  /** Help text or guidance for answering the question. */
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<order_by>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<order_by>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<order_by>;
  /** The question text displayed to the user. */
  question?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type report_template_question_min_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Help text or guidance for answering the question. */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Sort order within the parent section or option. */
  order?: Maybe<Scalars['Int']['output']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Int']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Int']['output']>;
  /** The question text displayed to the user. */
  question?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "report_template_question" */
export type report_template_question_min_order_by = {
  created_at?: InputMaybe<order_by>;
  /** Help text or guidance for answering the question. */
  description?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<order_by>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<order_by>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<order_by>;
  /** The question text displayed to the user. */
  question?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** A selectable answer option for a single-choice or multi-choice report question. */
export type report_template_question_option = {
  id: Scalars['Int']['output'];
  /** Sort order among sibling options. */
  order: Scalars['Int']['output'];
  /** An array relationship */
  report_template_child_questions: Array<report_template_question>;
  /** An aggregate relationship */
  report_template_child_questions_aggregate: report_template_question_aggregate;
  /** An object relationship */
  report_template_question: report_template_question;
  /** The question this option belongs to. */
  report_template_question_id: Scalars['Int']['output'];
  /** Display text for this option. */
  value: Scalars['String']['output'];
};

/** A selectable answer option for a single-choice or multi-choice report question. */
export type report_template_question_optionreport_template_child_questionsArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_order_by>>;
  where?: InputMaybe<report_template_question_bool_exp>;
};

/** A selectable answer option for a single-choice or multi-choice report question. */
export type report_template_question_optionreport_template_child_questions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_order_by>>;
  where?: InputMaybe<report_template_question_bool_exp>;
};

/** order by aggregate values of table "report_template_question_option" */
export type report_template_question_option_aggregate_order_by = {
  avg?: InputMaybe<report_template_question_option_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_template_question_option_max_order_by>;
  min?: InputMaybe<report_template_question_option_min_order_by>;
  stddev?: InputMaybe<report_template_question_option_stddev_order_by>;
  stddev_pop?: InputMaybe<report_template_question_option_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_template_question_option_stddev_samp_order_by>;
  sum?: InputMaybe<report_template_question_option_sum_order_by>;
  var_pop?: InputMaybe<report_template_question_option_var_pop_order_by>;
  var_samp?: InputMaybe<report_template_question_option_var_samp_order_by>;
  variance?: InputMaybe<report_template_question_option_variance_order_by>;
};

/** order by avg() on columns of table "report_template_question_option" */
export type report_template_question_option_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order among sibling options. */
  order?: InputMaybe<order_by>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_template_question_option". All fields are combined with a logical 'AND'. */
export type report_template_question_option_bool_exp = {
  _and?: InputMaybe<Array<report_template_question_option_bool_exp>>;
  _not?: InputMaybe<report_template_question_option_bool_exp>;
  _or?: InputMaybe<Array<report_template_question_option_bool_exp>>;
  id?: InputMaybe<Int_comparison_exp>;
  order?: InputMaybe<Int_comparison_exp>;
  report_template_child_questions?: InputMaybe<report_template_question_bool_exp>;
  report_template_child_questions_aggregate?: InputMaybe<report_template_question_aggregate_bool_exp>;
  report_template_question?: InputMaybe<report_template_question_bool_exp>;
  report_template_question_id?: InputMaybe<Int_comparison_exp>;
  value?: InputMaybe<String_comparison_exp>;
};

/** order by max() on columns of table "report_template_question_option" */
export type report_template_question_option_max_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order among sibling options. */
  order?: InputMaybe<order_by>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<order_by>;
  /** Display text for this option. */
  value?: InputMaybe<order_by>;
};

/** order by min() on columns of table "report_template_question_option" */
export type report_template_question_option_min_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order among sibling options. */
  order?: InputMaybe<order_by>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<order_by>;
  /** Display text for this option. */
  value?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_template_question_option". */
export type report_template_question_option_order_by = {
  id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  report_template_child_questions_aggregate?: InputMaybe<report_template_question_aggregate_order_by>;
  report_template_question?: InputMaybe<report_template_question_order_by>;
  report_template_question_id?: InputMaybe<order_by>;
  value?: InputMaybe<order_by>;
};

/** select columns of table "report_template_question_option" */
export enum report_template_question_option_select_column {
  /** column name */
  id = 'id',
  /** column name */
  order = 'order',
  /** column name */
  report_template_question_id = 'report_template_question_id',
  /** column name */
  value = 'value',
}

/** order by stddev() on columns of table "report_template_question_option" */
export type report_template_question_option_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order among sibling options. */
  order?: InputMaybe<order_by>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "report_template_question_option" */
export type report_template_question_option_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order among sibling options. */
  order?: InputMaybe<order_by>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "report_template_question_option" */
export type report_template_question_option_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order among sibling options. */
  order?: InputMaybe<order_by>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_template_question_option" */
export type report_template_question_option_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_template_question_option_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_template_question_option_stream_cursor_value_input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Sort order among sibling options. */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<Scalars['Int']['input']>;
  /** Display text for this option. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "report_template_question_option" */
export type report_template_question_option_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order among sibling options. */
  order?: InputMaybe<order_by>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "report_template_question_option" */
export type report_template_question_option_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order among sibling options. */
  order?: InputMaybe<order_by>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "report_template_question_option" */
export type report_template_question_option_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order among sibling options. */
  order?: InputMaybe<order_by>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "report_template_question_option" */
export type report_template_question_option_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order among sibling options. */
  order?: InputMaybe<order_by>;
  /** The question this option belongs to. */
  report_template_question_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_template_question". */
export type report_template_question_order_by = {
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  evidence_required?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  parent_option_id?: InputMaybe<order_by>;
  parent_section_id?: InputMaybe<order_by>;
  question?: InputMaybe<order_by>;
  report_answers_aggregate?: InputMaybe<report_answer_aggregate_order_by>;
  report_template_parent_option?: InputMaybe<report_template_question_option_order_by>;
  report_template_question_options_aggregate?: InputMaybe<report_template_question_option_aggregate_order_by>;
  report_template_section?: InputMaybe<report_template_section_order_by>;
  type?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "report_template_question" */
export enum report_template_question_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  evidence_required = 'evidence_required',
  /** column name */
  id = 'id',
  /** column name */
  order = 'order',
  /** column name */
  parent_option_id = 'parent_option_id',
  /** column name */
  parent_section_id = 'parent_section_id',
  /** column name */
  question = 'question',
  /** column name */
  type = 'type',
  /** column name */
  updated_at = 'updated_at',
}

/** select "report_template_question_aggregate_bool_exp_bool_and_arguments_columns" columns of table "report_template_question" */
export enum report_template_question_select_column_report_template_question_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  evidence_required = 'evidence_required',
}

/** select "report_template_question_aggregate_bool_exp_bool_or_arguments_columns" columns of table "report_template_question" */
export enum report_template_question_select_column_report_template_question_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  evidence_required = 'evidence_required',
}

/** aggregate stddev on columns */
export type report_template_question_stddev_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Sort order within the parent section or option. */
  order?: Maybe<Scalars['Float']['output']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Float']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "report_template_question" */
export type report_template_question_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<order_by>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<order_by>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type report_template_question_stddev_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Sort order within the parent section or option. */
  order?: Maybe<Scalars['Float']['output']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Float']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "report_template_question" */
export type report_template_question_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<order_by>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<order_by>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type report_template_question_stddev_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Sort order within the parent section or option. */
  order?: Maybe<Scalars['Float']['output']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Float']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "report_template_question" */
export type report_template_question_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<order_by>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<order_by>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_template_question" */
export type report_template_question_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_template_question_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_template_question_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Help text or guidance for answering the question. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user must upload evidence documents when answering this question. */
  evidence_required?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<Scalars['Int']['input']>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<Scalars['Int']['input']>;
  /** The question text displayed to the user. */
  question?: InputMaybe<Scalars['String']['input']>;
  /** Question type (e.g., TEXT, NUMBER, SINGLE_CHOICE, MULTI_CHOICE). */
  type?: InputMaybe<report_template_question_type_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type report_template_question_sum_fields = {
  id?: Maybe<Scalars['Int']['output']>;
  /** Sort order within the parent section or option. */
  order?: Maybe<Scalars['Int']['output']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Int']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "report_template_question" */
export type report_template_question_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<order_by>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<order_by>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<order_by>;
};

export enum report_template_question_type_enum {
  DATE = 'DATE',
  FLOAT = 'FLOAT',
  INTEGER = 'INTEGER',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  PERCENTAGE = 'PERCENTAGE',
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  TEXT = 'TEXT',
  YEAR = 'YEAR',
}

/** Boolean expression to compare columns of type "report_template_question_type_enum". All fields are combined with logical 'AND'. */
export type report_template_question_type_enum_comparison_exp = {
  _eq?: InputMaybe<report_template_question_type_enum>;
  _in?: InputMaybe<Array<report_template_question_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<report_template_question_type_enum>;
  _nin?: InputMaybe<Array<report_template_question_type_enum>>;
};

/** aggregate var_pop on columns */
export type report_template_question_var_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Sort order within the parent section or option. */
  order?: Maybe<Scalars['Float']['output']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Float']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "report_template_question" */
export type report_template_question_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<order_by>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<order_by>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type report_template_question_var_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Sort order within the parent section or option. */
  order?: Maybe<Scalars['Float']['output']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Float']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "report_template_question" */
export type report_template_question_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<order_by>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<order_by>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type report_template_question_variance_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** Sort order within the parent section or option. */
  order?: Maybe<Scalars['Float']['output']>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: Maybe<Scalars['Float']['output']>;
  /** The section this question belongs to. */
  parent_section_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "report_template_question" */
export type report_template_question_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or option. */
  order?: InputMaybe<order_by>;
  /** If set, this question is a follow-up shown only when the parent option is selected. */
  parent_option_id?: InputMaybe<order_by>;
  /** The section this question belongs to. */
  parent_section_id?: InputMaybe<order_by>;
};

/** Defines a scoring dimension within a report template (e.g., overall ESG score, governance subscore). */
export type report_template_score = {
  /** Whether this score is shown to users in the report UI. */
  display: Scalars['Boolean']['output'];
  /** How to render the score (e.g., percentage, absolute, grade). */
  display_type: report_template_score_display_type_enum;
  id: Scalars['Int']['output'];
  /** Maximum achievable value for this score. */
  max_score?: Maybe<Scalars['Float']['output']>;
  /** Display name of the score (e.g., "ESG Score", "Governance"). */
  name: Scalars['String']['output'];
  /** Sort order for display. */
  order: Scalars['Int']['output'];
  /** An array relationship */
  report_scores: Array<report_score>;
  /** An object relationship */
  report_template: report_template;
};

/** Defines a scoring dimension within a report template (e.g., overall ESG score, governance subscore). */
export type report_template_scorereport_scoresArgs = {
  distinct_on?: InputMaybe<Array<report_score_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_score_order_by>>;
  where?: InputMaybe<report_score_bool_exp>;
};

/** order by aggregate values of table "report_template_score" */
export type report_template_score_aggregate_order_by = {
  avg?: InputMaybe<report_template_score_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_template_score_max_order_by>;
  min?: InputMaybe<report_template_score_min_order_by>;
  stddev?: InputMaybe<report_template_score_stddev_order_by>;
  stddev_pop?: InputMaybe<report_template_score_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_template_score_stddev_samp_order_by>;
  sum?: InputMaybe<report_template_score_sum_order_by>;
  var_pop?: InputMaybe<report_template_score_var_pop_order_by>;
  var_samp?: InputMaybe<report_template_score_var_samp_order_by>;
  variance?: InputMaybe<report_template_score_variance_order_by>;
};

/** order by avg() on columns of table "report_template_score" */
export type report_template_score_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<order_by>;
  /** Sort order for display. */
  order?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_template_score". All fields are combined with a logical 'AND'. */
export type report_template_score_bool_exp = {
  _and?: InputMaybe<Array<report_template_score_bool_exp>>;
  _not?: InputMaybe<report_template_score_bool_exp>;
  _or?: InputMaybe<Array<report_template_score_bool_exp>>;
  display?: InputMaybe<Boolean_comparison_exp>;
  display_type?: InputMaybe<report_template_score_display_type_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  max_score?: InputMaybe<Float_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  order?: InputMaybe<Int_comparison_exp>;
  report_scores?: InputMaybe<report_score_bool_exp>;
  report_template?: InputMaybe<report_template_bool_exp>;
};

export enum report_template_score_display_type_enum {
  BOOLEAN = 'BOOLEAN',
  PERCENTAGE = 'PERCENTAGE',
  POINTS = 'POINTS',
}

/** Boolean expression to compare columns of type "report_template_score_display_type_enum". All fields are combined with logical 'AND'. */
export type report_template_score_display_type_enum_comparison_exp = {
  _eq?: InputMaybe<report_template_score_display_type_enum>;
  _in?: InputMaybe<Array<report_template_score_display_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<report_template_score_display_type_enum>;
  _nin?: InputMaybe<Array<report_template_score_display_type_enum>>;
};

/** order by max() on columns of table "report_template_score" */
export type report_template_score_max_order_by = {
  id?: InputMaybe<order_by>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<order_by>;
  /** Display name of the score (e.g., "ESG Score", "Governance"). */
  name?: InputMaybe<order_by>;
  /** Sort order for display. */
  order?: InputMaybe<order_by>;
};

/** order by min() on columns of table "report_template_score" */
export type report_template_score_min_order_by = {
  id?: InputMaybe<order_by>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<order_by>;
  /** Display name of the score (e.g., "ESG Score", "Governance"). */
  name?: InputMaybe<order_by>;
  /** Sort order for display. */
  order?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_template_score". */
export type report_template_score_order_by = {
  display?: InputMaybe<order_by>;
  display_type?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  max_score?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  report_scores_aggregate?: InputMaybe<report_score_aggregate_order_by>;
  report_template?: InputMaybe<report_template_order_by>;
};

/** select columns of table "report_template_score" */
export enum report_template_score_select_column {
  /** column name */
  display = 'display',
  /** column name */
  display_type = 'display_type',
  /** column name */
  id = 'id',
  /** column name */
  max_score = 'max_score',
  /** column name */
  name = 'name',
  /** column name */
  order = 'order',
}

/** order by stddev() on columns of table "report_template_score" */
export type report_template_score_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<order_by>;
  /** Sort order for display. */
  order?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "report_template_score" */
export type report_template_score_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<order_by>;
  /** Sort order for display. */
  order?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "report_template_score" */
export type report_template_score_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<order_by>;
  /** Sort order for display. */
  order?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_template_score" */
export type report_template_score_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_template_score_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_template_score_stream_cursor_value_input = {
  /** Whether this score is shown to users in the report UI. */
  display?: InputMaybe<Scalars['Boolean']['input']>;
  /** How to render the score (e.g., percentage, absolute, grade). */
  display_type?: InputMaybe<report_template_score_display_type_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<Scalars['Float']['input']>;
  /** Display name of the score (e.g., "ESG Score", "Governance"). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sort order for display. */
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "report_template_score" */
export type report_template_score_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<order_by>;
  /** Sort order for display. */
  order?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "report_template_score" */
export type report_template_score_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<order_by>;
  /** Sort order for display. */
  order?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "report_template_score" */
export type report_template_score_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<order_by>;
  /** Sort order for display. */
  order?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "report_template_score" */
export type report_template_score_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** Maximum achievable value for this score. */
  max_score?: InputMaybe<order_by>;
  /** Sort order for display. */
  order?: InputMaybe<order_by>;
};

/** A hierarchical section within a report template. Sections can be nested and contain questions. */
export type report_template_section = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** Display name of the section. */
  name: Scalars['String']['output'];
  /** Sort order within the parent section or template. */
  order: Scalars['Int']['output'];
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  report_template: report_template;
  /** The template this section belongs to. */
  report_template_id: Scalars['Int']['output'];
  /** An object relationship */
  report_template_parent_section?: Maybe<report_template_section>;
  /** An array relationship */
  report_template_questions: Array<report_template_question>;
  /** An aggregate relationship */
  report_template_questions_aggregate: report_template_question_aggregate;
  /** Whether this section targets BUILDING-level or PORTFOLIO-level assessment. */
  target?: Maybe<report_template_section_target_enum>;
  updated_at: Scalars['timestamptz']['output'];
};

/** A hierarchical section within a report template. Sections can be nested and contain questions. */
export type report_template_sectionreport_template_questionsArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_order_by>>;
  where?: InputMaybe<report_template_question_bool_exp>;
};

/** A hierarchical section within a report template. Sections can be nested and contain questions. */
export type report_template_sectionreport_template_questions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_order_by>>;
  where?: InputMaybe<report_template_question_bool_exp>;
};

/** order by aggregate values of table "report_template_section" */
export type report_template_section_aggregate_order_by = {
  avg?: InputMaybe<report_template_section_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<report_template_section_max_order_by>;
  min?: InputMaybe<report_template_section_min_order_by>;
  stddev?: InputMaybe<report_template_section_stddev_order_by>;
  stddev_pop?: InputMaybe<report_template_section_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<report_template_section_stddev_samp_order_by>;
  sum?: InputMaybe<report_template_section_sum_order_by>;
  var_pop?: InputMaybe<report_template_section_var_pop_order_by>;
  var_samp?: InputMaybe<report_template_section_var_samp_order_by>;
  variance?: InputMaybe<report_template_section_variance_order_by>;
};

/** order by avg() on columns of table "report_template_section" */
export type report_template_section_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<order_by>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<order_by>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "report_template_section". All fields are combined with a logical 'AND'. */
export type report_template_section_bool_exp = {
  _and?: InputMaybe<Array<report_template_section_bool_exp>>;
  _not?: InputMaybe<report_template_section_bool_exp>;
  _or?: InputMaybe<Array<report_template_section_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  order?: InputMaybe<Int_comparison_exp>;
  parent_section_id?: InputMaybe<Int_comparison_exp>;
  report_template?: InputMaybe<report_template_bool_exp>;
  report_template_id?: InputMaybe<Int_comparison_exp>;
  report_template_parent_section?: InputMaybe<report_template_section_bool_exp>;
  report_template_questions?: InputMaybe<report_template_question_bool_exp>;
  report_template_questions_aggregate?: InputMaybe<report_template_question_aggregate_bool_exp>;
  target?: InputMaybe<report_template_section_target_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "report_template_section" */
export type report_template_section_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Display name of the section. */
  name?: InputMaybe<order_by>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<order_by>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<order_by>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "report_template_section" */
export type report_template_section_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Display name of the section. */
  name?: InputMaybe<order_by>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<order_by>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<order_by>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "report_template_section". */
export type report_template_section_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  order?: InputMaybe<order_by>;
  parent_section_id?: InputMaybe<order_by>;
  report_template?: InputMaybe<report_template_order_by>;
  report_template_id?: InputMaybe<order_by>;
  report_template_parent_section?: InputMaybe<report_template_section_order_by>;
  report_template_questions_aggregate?: InputMaybe<report_template_question_aggregate_order_by>;
  target?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "report_template_section" */
export enum report_template_section_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  order = 'order',
  /** column name */
  parent_section_id = 'parent_section_id',
  /** column name */
  report_template_id = 'report_template_id',
  /** column name */
  target = 'target',
  /** column name */
  updated_at = 'updated_at',
}

/** order by stddev() on columns of table "report_template_section" */
export type report_template_section_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<order_by>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<order_by>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "report_template_section" */
export type report_template_section_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<order_by>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<order_by>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "report_template_section" */
export type report_template_section_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<order_by>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<order_by>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "report_template_section" */
export type report_template_section_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_template_section_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_template_section_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Display name of the section. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<Scalars['Int']['input']>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether this section targets BUILDING-level or PORTFOLIO-level assessment. */
  target?: InputMaybe<report_template_section_target_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "report_template_section" */
export type report_template_section_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<order_by>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<order_by>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<order_by>;
};

export enum report_template_section_target_enum {
  BUILDING = 'BUILDING',
  ORG = 'ORG',
  PORTFOLIO = 'PORTFOLIO',
}

/** Boolean expression to compare columns of type "report_template_section_target_enum". All fields are combined with logical 'AND'. */
export type report_template_section_target_enum_comparison_exp = {
  _eq?: InputMaybe<report_template_section_target_enum>;
  _in?: InputMaybe<Array<report_template_section_target_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<report_template_section_target_enum>;
  _nin?: InputMaybe<Array<report_template_section_target_enum>>;
};

/** order by var_pop() on columns of table "report_template_section" */
export type report_template_section_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<order_by>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<order_by>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "report_template_section" */
export type report_template_section_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<order_by>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<order_by>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "report_template_section" */
export type report_template_section_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** Sort order within the parent section or template. */
  order?: InputMaybe<order_by>;
  /** Parent section for nesting. Null for top-level sections. */
  parent_section_id?: InputMaybe<order_by>;
  /** The template this section belongs to. */
  report_template_id?: InputMaybe<order_by>;
};

/** select columns of table "report_template" */
export enum report_template_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  description_en = 'description_en',
  /** column name */
  excel_template_path_de = 'excel_template_path_de',
  /** column name */
  excel_template_path_en = 'excel_template_path_en',
  /** column name */
  id = 'id',
  /** column name */
  org_id = 'org_id',
  /** column name */
  single_building = 'single_building',
  /** column name */
  title = 'title',
  /** column name */
  updated_at = 'updated_at',
}

/** Streaming cursor of the table "report_template" */
export type report_template_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: report_template_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type report_template_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Explanation of the report template purpose and scope. */
  description?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  /** S3 path to the Excel template used for exporting reports based on this template. */
  excel_template_path_de?: InputMaybe<Scalars['String']['input']>;
  excel_template_path_en?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Organization that owns this template. Null for system-wide templates. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** If true, reports from this template assess one building at a time rather than a portfolio. */
  single_building?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name of the report template. */
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type report_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<report_set_input>;
  /** filter the rows which have to be updated */
  where: report_bool_exp;
};

/** aggregate var_pop on columns */
export type report_var_pop_fields = {
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Overall completion percentage (0 to 1). */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The template this report is based on. */
  report_template_id?: Maybe<Scalars['Float']['output']>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "report" */
export type report_var_pop_order_by = {
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<order_by>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<order_by>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type report_var_samp_fields = {
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Overall completion percentage (0 to 1). */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The template this report is based on. */
  report_template_id?: Maybe<Scalars['Float']['output']>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "report" */
export type report_var_samp_order_by = {
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<order_by>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<order_by>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type report_variance_fields = {
  /** Reference to the exported report file, if generated. */
  file_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** Overall completion percentage (0 to 1). */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The template this report is based on. */
  report_template_id?: Maybe<Scalars['Float']['output']>;
  /** User assigned to complete this report. */
  responsible_user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "report" */
export type report_variance_order_by = {
  /** Reference to the exported report file, if generated. */
  file_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Overall completion percentage (0 to 1). */
  progress?: InputMaybe<order_by>;
  /** The template this report is based on. */
  report_template_id?: InputMaybe<order_by>;
  /** User assigned to complete this report. */
  responsible_user_id?: InputMaybe<order_by>;
};

export enum role_enum {
  API_READ = 'API_READ',
  API_WRITE = 'API_WRITE',
  BANKING_USER = 'BANKING_USER',
  DANGER_PUBLIC_ROLE = 'DANGER_PUBLIC_ROLE',
  ORG_ADMIN = 'ORG_ADMIN',
  RETOOL_ADMIN = 'RETOOL_ADMIN',
  RETOOL_USER = 'RETOOL_USER',
  UNAUTHORIZED = 'UNAUTHORIZED',
  USER = 'USER',
  admin = 'admin',
}

/** Boolean expression to compare columns of type "role_enum". All fields are combined with logical 'AND'. */
export type role_enum_comparison_exp = {
  _eq?: InputMaybe<role_enum>;
  _in?: InputMaybe<Array<role_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<role_enum>;
  _nin?: InputMaybe<Array<role_enum>>;
};

/** A named collection of action plans for buildings within a portfolio or organization, representing an overarching renovation strategy (e.g., CO2 neutrality by 2050). */
export type scenario = {
  /** An array relationship */
  active_action_plans: Array<active_action_plans>;
  /** An aggregate relationship */
  active_action_plans_aggregate: active_action_plans_aggregate;
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Whether a background cost recalculation is currently running for this scenario. */
  cost_update_in_progress: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  /** Whether this scenario is currently being duplicated. */
  duplication_in_progress: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  org: org;
  /** The organization this scenario belongs to. */
  org_id: Scalars['Int']['output'];
  /** An object relationship */
  owner: user;
  /** The user who created this scenario. */
  owner_id: Scalars['Int']['output'];
  /** An object relationship */
  portfolio?: Maybe<portfolio>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  scenario_versions: Array<scenario_version>;
  /** An aggregate relationship */
  scenario_versions_aggregate: scenario_version_aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** A named collection of action plans for buildings within a portfolio or organization, representing an overarching renovation strategy (e.g., CO2 neutrality by 2050). */
export type scenarioactive_action_plansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_action_plans_order_by>>;
  where?: InputMaybe<active_action_plans_bool_exp>;
};

/** A named collection of action plans for buildings within a portfolio or organization, representing an overarching renovation strategy (e.g., CO2 neutrality by 2050). */
export type scenarioactive_action_plans_aggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_action_plans_order_by>>;
  where?: InputMaybe<active_action_plans_bool_exp>;
};

/** A named collection of action plans for buildings within a portfolio or organization, representing an overarching renovation strategy (e.g., CO2 neutrality by 2050). */
export type scenarioscenario_versionsArgs = {
  distinct_on?: InputMaybe<Array<scenario_version_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_version_order_by>>;
  where?: InputMaybe<scenario_version_bool_exp>;
};

/** A named collection of action plans for buildings within a portfolio or organization, representing an overarching renovation strategy (e.g., CO2 neutrality by 2050). */
export type scenarioscenario_versions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<scenario_version_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_version_order_by>>;
  where?: InputMaybe<scenario_version_bool_exp>;
};

/** aggregated selection of "scenario" */
export type scenario_aggregate = {
  aggregate?: Maybe<scenario_aggregate_fields>;
  nodes: Array<scenario>;
};

/** aggregate fields of "scenario" */
export type scenario_aggregate_fields = {
  avg?: Maybe<scenario_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<scenario_max_fields>;
  min?: Maybe<scenario_min_fields>;
  stddev?: Maybe<scenario_stddev_fields>;
  stddev_pop?: Maybe<scenario_stddev_pop_fields>;
  stddev_samp?: Maybe<scenario_stddev_samp_fields>;
  sum?: Maybe<scenario_sum_fields>;
  var_pop?: Maybe<scenario_var_pop_fields>;
  var_samp?: Maybe<scenario_var_samp_fields>;
  variance?: Maybe<scenario_variance_fields>;
};

/** aggregate fields of "scenario" */
export type scenario_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<scenario_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type scenario_avg_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this scenario belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** The user who created this scenario. */
  owner_id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "scenario". All fields are combined with a logical 'AND'. */
export type scenario_bool_exp = {
  _and?: InputMaybe<Array<scenario_bool_exp>>;
  _not?: InputMaybe<scenario_bool_exp>;
  _or?: InputMaybe<Array<scenario_bool_exp>>;
  active_action_plans?: InputMaybe<active_action_plans_bool_exp>;
  archived_at?: InputMaybe<timestamptz_comparison_exp>;
  cost_update_in_progress?: InputMaybe<Boolean_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  duplication_in_progress?: InputMaybe<Boolean_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  name?: InputMaybe<String_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  owner?: InputMaybe<user_bool_exp>;
  owner_id?: InputMaybe<Int_comparison_exp>;
  portfolio?: InputMaybe<portfolio_bool_exp>;
  portfolio_id?: InputMaybe<Int_comparison_exp>;
  scenario_versions?: InputMaybe<scenario_version_bool_exp>;
  scenario_versions_aggregate?: InputMaybe<scenario_version_aggregate_bool_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type scenario_max_fields = {
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The organization this scenario belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** The user who created this scenario. */
  owner_id?: Maybe<Scalars['Int']['output']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type scenario_min_fields = {
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The organization this scenario belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** The user who created this scenario. */
  owner_id?: Maybe<Scalars['Int']['output']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "scenario". */
export type scenario_order_by = {
  active_action_plans_aggregate?: InputMaybe<active_action_plans_aggregate_order_by>;
  archived_at?: InputMaybe<order_by>;
  cost_update_in_progress?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  duplication_in_progress?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  name?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  owner?: InputMaybe<user_order_by>;
  owner_id?: InputMaybe<order_by>;
  portfolio?: InputMaybe<portfolio_order_by>;
  portfolio_id?: InputMaybe<order_by>;
  scenario_versions_aggregate?: InputMaybe<scenario_version_aggregate_order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "scenario" */
export enum scenario_select_column {
  /** column name */
  archived_at = 'archived_at',
  /** column name */
  cost_update_in_progress = 'cost_update_in_progress',
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  duplication_in_progress = 'duplication_in_progress',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  org_id = 'org_id',
  /** column name */
  owner_id = 'owner_id',
  /** column name */
  portfolio_id = 'portfolio_id',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate stddev on columns */
export type scenario_stddev_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this scenario belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** The user who created this scenario. */
  owner_id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type scenario_stddev_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this scenario belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** The user who created this scenario. */
  owner_id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type scenario_stddev_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this scenario belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** The user who created this scenario. */
  owner_id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "scenario" */
export type scenario_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: scenario_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type scenario_stream_cursor_value_input = {
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Whether a background cost recalculation is currently running for this scenario. */
  cost_update_in_progress?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether this scenario is currently being duplicated. */
  duplication_in_progress?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The organization this scenario belongs to. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** The user who created this scenario. */
  owner_id?: InputMaybe<Scalars['Int']['input']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type scenario_sum_fields = {
  id?: Maybe<Scalars['Int']['output']>;
  /** The organization this scenario belongs to. */
  org_id?: Maybe<Scalars['Int']['output']>;
  /** The user who created this scenario. */
  owner_id?: Maybe<Scalars['Int']['output']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type scenario_var_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this scenario belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** The user who created this scenario. */
  owner_id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type scenario_var_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this scenario belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** The user who created this scenario. */
  owner_id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type scenario_variance_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The organization this scenario belongs to. */
  org_id?: Maybe<Scalars['Float']['output']>;
  /** The user who created this scenario. */
  owner_id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio whose buildings are covered by this scenario. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
};

/** A point-in-time version of a scenario, linking it to a specific cost version and containing the set of action plans. */
export type scenario_version = {
  /** An array relationship */
  action_plans: Array<action_plan>;
  /** An object relationship */
  cost_version: cost_version;
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  scenario: scenario;
  /** The parent scenario this version belongs to. */
  scenario_id: Scalars['Int']['output'];
  /** The lifecycle status of this scenario version. */
  status: scenario_version_status_enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** A point-in-time version of a scenario, linking it to a specific cost version and containing the set of action plans. */
export type scenario_versionaction_plansArgs = {
  distinct_on?: InputMaybe<Array<action_plan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_plan_order_by>>;
  where?: InputMaybe<action_plan_bool_exp>;
};

/** aggregated selection of "scenario_version" */
export type scenario_version_aggregate = {
  aggregate?: Maybe<scenario_version_aggregate_fields>;
  nodes: Array<scenario_version>;
};

export type scenario_version_aggregate_bool_exp = {
  count?: InputMaybe<scenario_version_aggregate_bool_exp_count>;
};

export type scenario_version_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<scenario_version_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<scenario_version_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "scenario_version" */
export type scenario_version_aggregate_fields = {
  avg?: Maybe<scenario_version_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<scenario_version_max_fields>;
  min?: Maybe<scenario_version_min_fields>;
  stddev?: Maybe<scenario_version_stddev_fields>;
  stddev_pop?: Maybe<scenario_version_stddev_pop_fields>;
  stddev_samp?: Maybe<scenario_version_stddev_samp_fields>;
  sum?: Maybe<scenario_version_sum_fields>;
  var_pop?: Maybe<scenario_version_var_pop_fields>;
  var_samp?: Maybe<scenario_version_var_samp_fields>;
  variance?: Maybe<scenario_version_variance_fields>;
};

/** aggregate fields of "scenario_version" */
export type scenario_version_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<scenario_version_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "scenario_version" */
export type scenario_version_aggregate_order_by = {
  avg?: InputMaybe<scenario_version_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<scenario_version_max_order_by>;
  min?: InputMaybe<scenario_version_min_order_by>;
  stddev?: InputMaybe<scenario_version_stddev_order_by>;
  stddev_pop?: InputMaybe<scenario_version_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<scenario_version_stddev_samp_order_by>;
  sum?: InputMaybe<scenario_version_sum_order_by>;
  var_pop?: InputMaybe<scenario_version_var_pop_order_by>;
  var_samp?: InputMaybe<scenario_version_var_samp_order_by>;
  variance?: InputMaybe<scenario_version_variance_order_by>;
};

/** aggregate avg on columns */
export type scenario_version_avg_fields = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "scenario_version" */
export type scenario_version_avg_order_by = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "scenario_version". All fields are combined with a logical 'AND'. */
export type scenario_version_bool_exp = {
  _and?: InputMaybe<Array<scenario_version_bool_exp>>;
  _not?: InputMaybe<scenario_version_bool_exp>;
  _or?: InputMaybe<Array<scenario_version_bool_exp>>;
  action_plans?: InputMaybe<action_plan_bool_exp>;
  cost_version?: InputMaybe<cost_version_bool_exp>;
  cost_version_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  scenario?: InputMaybe<scenario_bool_exp>;
  scenario_id?: InputMaybe<Int_comparison_exp>;
  status?: InputMaybe<scenario_version_status_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** aggregate max on columns */
export type scenario_version_max_fields = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "scenario_version" */
export type scenario_version_max_order_by = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type scenario_version_min_fields = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "scenario_version" */
export type scenario_version_min_order_by = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "scenario_version". */
export type scenario_version_order_by = {
  action_plans_aggregate?: InputMaybe<action_plan_aggregate_order_by>;
  cost_version?: InputMaybe<cost_version_order_by>;
  cost_version_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  scenario?: InputMaybe<scenario_order_by>;
  scenario_id?: InputMaybe<order_by>;
  status?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "scenario_version" */
export enum scenario_version_select_column {
  /** column name */
  cost_version_id = 'cost_version_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  scenario_id = 'scenario_id',
  /** column name */
  status = 'status',
  /** column name */
  updated_at = 'updated_at',
}

export enum scenario_version_status_enum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INVALIDATED = 'INVALIDATED',
  PENDING = 'PENDING',
}

/** Boolean expression to compare columns of type "scenario_version_status_enum". All fields are combined with logical 'AND'. */
export type scenario_version_status_enum_comparison_exp = {
  _eq?: InputMaybe<scenario_version_status_enum>;
  _in?: InputMaybe<Array<scenario_version_status_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<scenario_version_status_enum>;
  _nin?: InputMaybe<Array<scenario_version_status_enum>>;
};

/** aggregate stddev on columns */
export type scenario_version_stddev_fields = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "scenario_version" */
export type scenario_version_stddev_order_by = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type scenario_version_stddev_pop_fields = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "scenario_version" */
export type scenario_version_stddev_pop_order_by = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type scenario_version_stddev_samp_fields = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "scenario_version" */
export type scenario_version_stddev_samp_order_by = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "scenario_version" */
export type scenario_version_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: scenario_version_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type scenario_version_stream_cursor_value_input = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<Scalars['Int']['input']>;
  /** The lifecycle status of this scenario version. */
  status?: InputMaybe<scenario_version_status_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type scenario_version_sum_fields = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "scenario_version" */
export type scenario_version_sum_order_by = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<order_by>;
};

/** aggregate var_pop on columns */
export type scenario_version_var_pop_fields = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "scenario_version" */
export type scenario_version_var_pop_order_by = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type scenario_version_var_samp_fields = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "scenario_version" */
export type scenario_version_var_samp_order_by = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type scenario_version_variance_fields = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  /** The parent scenario this version belongs to. */
  scenario_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "scenario_version" */
export type scenario_version_variance_order_by = {
  /** The cost version used to calculate renovation costs in this scenario version. */
  cost_version_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The parent scenario this version belongs to. */
  scenario_id?: InputMaybe<order_by>;
};

export enum scope_perspective_enum {
  OC_LANDLORD = 'OC_LANDLORD',
  OC_TENANT = 'OC_TENANT',
  WHOLE_BUILDING = 'WHOLE_BUILDING',
}

export enum slf_compliance_factor_enum {
  CERTIFICATE = 'CERTIFICATE',
  EFFICIENCY_CLASS = 'EFFICIENCY_CLASS',
  EU_TAXONOMY = 'EU_TAXONOMY',
  REPORT = 'REPORT',
}

/** A physical or virtual meter that automatically records consumption data via an external integration. */
export type smart_meter = {
  /** Reason this meter was archived. */
  archive_reason_id?: Maybe<smart_meter_archive_reason_enum>;
  /** Timestamp when this meter was archived. */
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  area?: Maybe<area>;
  /** Optional link to a specific building area this meter measures. */
  area_id?: Maybe<Scalars['Int']['output']>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count: Scalars['Int']['output'];
  /** How often this meter records readings (e.g. MONTHLY, YEARLY). */
  consumption_frequency_type_id: consumption_frequency_type_enum;
  /** What this meter measures: HEATING, ELECTRICITY, WATER, or WASTE. */
  consumption_type_id: consumption_type_enum;
  /** Measurement unit of the meter readings (e.g. kWh, m3). */
  consumption_unit_id: consumption_unit_enum;
  /** An array relationship */
  consumptions: Array<consumption>;
  /** An aggregate relationship */
  consumptions_aggregate: consumption_aggregate;
  created_at: Scalars['timestamptz']['output'];
  /** Human-readable label or description for identifying this meter. */
  description: Scalars['String']['output'];
  /** Unique identifier for this meter in the external metering provider system. */
  external_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Last timestamp this meter was present in the provider API response. */
  last_seen_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  smart_meter_integration_building: smart_meter_integration_building;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** A physical or virtual meter that automatically records consumption data via an external integration. */
export type smart_meterconsumptionsArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

/** A physical or virtual meter that automatically records consumption data via an external integration. */
export type smart_meterconsumptions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

/** order by aggregate values of table "smart_meter" */
export type smart_meter_aggregate_order_by = {
  avg?: InputMaybe<smart_meter_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<smart_meter_max_order_by>;
  min?: InputMaybe<smart_meter_min_order_by>;
  stddev?: InputMaybe<smart_meter_stddev_order_by>;
  stddev_pop?: InputMaybe<smart_meter_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<smart_meter_stddev_samp_order_by>;
  sum?: InputMaybe<smart_meter_sum_order_by>;
  var_pop?: InputMaybe<smart_meter_var_pop_order_by>;
  var_samp?: InputMaybe<smart_meter_var_samp_order_by>;
  variance?: InputMaybe<smart_meter_variance_order_by>;
};

export enum smart_meter_archive_reason_enum {
  MANUALLY_ARCHIVED = 'MANUALLY_ARCHIVED',
  NOT_FOUND_IN_PROVIDER = 'NOT_FOUND_IN_PROVIDER',
}

/** Boolean expression to compare columns of type "smart_meter_archive_reason_enum". All fields are combined with logical 'AND'. */
export type smart_meter_archive_reason_enum_comparison_exp = {
  _eq?: InputMaybe<smart_meter_archive_reason_enum>;
  _in?: InputMaybe<Array<smart_meter_archive_reason_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<smart_meter_archive_reason_enum>;
  _nin?: InputMaybe<Array<smart_meter_archive_reason_enum>>;
};

/** order by avg() on columns of table "smart_meter" */
export type smart_meter_avg_order_by = {
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<order_by>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "smart_meter". All fields are combined with a logical 'AND'. */
export type smart_meter_bool_exp = {
  _and?: InputMaybe<Array<smart_meter_bool_exp>>;
  _not?: InputMaybe<smart_meter_bool_exp>;
  _or?: InputMaybe<Array<smart_meter_bool_exp>>;
  archive_reason_id?: InputMaybe<smart_meter_archive_reason_enum_comparison_exp>;
  archived_at?: InputMaybe<timestamptz_comparison_exp>;
  area?: InputMaybe<area_bool_exp>;
  area_id?: InputMaybe<Int_comparison_exp>;
  consecutive_failure_count?: InputMaybe<Int_comparison_exp>;
  consumption_frequency_type_id?: InputMaybe<consumption_frequency_type_enum_comparison_exp>;
  consumption_type_id?: InputMaybe<consumption_type_enum_comparison_exp>;
  consumption_unit_id?: InputMaybe<consumption_unit_enum_comparison_exp>;
  consumptions?: InputMaybe<consumption_bool_exp>;
  consumptions_aggregate?: InputMaybe<consumption_aggregate_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  description?: InputMaybe<String_comparison_exp>;
  external_id?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  last_seen_at?: InputMaybe<timestamptz_comparison_exp>;
  smart_meter_integration_building?: InputMaybe<smart_meter_integration_building_bool_exp>;
  smart_meter_integration_building_id?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

export enum smart_meter_health_status_enum {
  AUTH_FAILED = 'AUTH_FAILED',
  HEALTHY = 'HEALTHY',
  PROVIDER_UNAVAILABLE = 'PROVIDER_UNAVAILABLE',
  RATE_LIMITED = 'RATE_LIMITED',
  UNKNOWN = 'UNKNOWN',
}

/** Boolean expression to compare columns of type "smart_meter_health_status_enum". All fields are combined with logical 'AND'. */
export type smart_meter_health_status_enum_comparison_exp = {
  _eq?: InputMaybe<smart_meter_health_status_enum>;
  _in?: InputMaybe<Array<smart_meter_health_status_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<smart_meter_health_status_enum>;
  _nin?: InputMaybe<Array<smart_meter_health_status_enum>>;
};

/** Configuration for connecting an organization to an external metering service provider. */
export type smart_meter_integration = {
  /** API key for authenticating with the external metering provider. */
  api_key: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** Incremented on each credential rotation to invalidate cached tokens. */
  credential_version: Scalars['Int']['output'];
  /** When true, the integration is paused and will not be synced. */
  disabled: Scalars['Boolean']['output'];
  /** Current health status of the integration. NULL means status is unknown. */
  health_status_id?: Maybe<smart_meter_health_status_enum>;
  id: Scalars['Int']['output'];
  /** Timestamp of the last synchronization attempt with the external provider. */
  last_sync: Scalars['timestamp']['output'];
  /** An array relationship */
  meter_integration_buildings: Array<smart_meter_integration_building>;
  /** The external metering provider type. */
  meter_integration_type_id: smart_meter_integration_type_enum;
  /** An object relationship */
  org: org;
  /** The organization that owns this integration. */
  org_id: Scalars['Int']['output'];
  sync_interval_id: smart_meter_sync_interval_enum;
  /** Overall synchronization status of this integration. */
  sync_state_id: smart_meter_sync_state_enum;
  /** External tenant identifier from the provider. */
  tenant_id?: Maybe<Scalars['String']['output']>;
  /** Human-readable tenant name from the provider. */
  tenant_name?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Configuration for connecting an organization to an external metering service provider. */
export type smart_meter_integrationmeter_integration_buildingsArgs = {
  distinct_on?: InputMaybe<Array<smart_meter_integration_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<smart_meter_integration_building_order_by>>;
  where?: InputMaybe<smart_meter_integration_building_bool_exp>;
};

/** Boolean expression to filter rows from the table "smart_meter_integration". All fields are combined with a logical 'AND'. */
export type smart_meter_integration_bool_exp = {
  _and?: InputMaybe<Array<smart_meter_integration_bool_exp>>;
  _not?: InputMaybe<smart_meter_integration_bool_exp>;
  _or?: InputMaybe<Array<smart_meter_integration_bool_exp>>;
  api_key?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  credential_version?: InputMaybe<Int_comparison_exp>;
  disabled?: InputMaybe<Boolean_comparison_exp>;
  health_status_id?: InputMaybe<smart_meter_health_status_enum_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  last_sync?: InputMaybe<timestamp_comparison_exp>;
  meter_integration_buildings?: InputMaybe<smart_meter_integration_building_bool_exp>;
  meter_integration_type_id?: InputMaybe<smart_meter_integration_type_enum_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  sync_interval_id?: InputMaybe<smart_meter_sync_interval_enum_comparison_exp>;
  sync_state_id?: InputMaybe<smart_meter_sync_state_enum_comparison_exp>;
  tenant_id?: InputMaybe<String_comparison_exp>;
  tenant_name?: InputMaybe<String_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Links a building to an external metering integration, mapping the Predium building to its external representation. */
export type smart_meter_integration_building = {
  /** Reason this record was archived. */
  archive_reason_id?: Maybe<smart_meter_archive_reason_enum>;
  /** Timestamp when this record was archived. */
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  building?: Maybe<building>;
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** Unique identifier for this building in the external metering provider system. */
  external_id: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Last timestamp this building record was present in the provider API response. */
  last_seen_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Method used to link this record to a Predium building. NULL when unlinked. */
  link_method_id?: Maybe<smart_meter_link_method_enum>;
  /** Linking state of this provider building record: UNLINKED | LINKED | ARCHIVED. */
  link_state_id: smart_meter_link_state_enum;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: Maybe<Scalars['float8']['output']>;
  /** Provider-specific building properties stored as JSON. */
  properties: Scalars['jsonb']['output'];
  /** An object relationship */
  smart_meter_integration: smart_meter_integration;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id: Scalars['Int']['output'];
  /** An array relationship */
  smart_meters: Array<smart_meter>;
  /** An object relationship */
  suggested_building?: Maybe<building>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** Links a building to an external metering integration, mapping the Predium building to its external representation. */
export type smart_meter_integration_buildingpropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Links a building to an external metering integration, mapping the Predium building to its external representation. */
export type smart_meter_integration_buildingsmart_metersArgs = {
  distinct_on?: InputMaybe<Array<smart_meter_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<smart_meter_order_by>>;
  where?: InputMaybe<smart_meter_bool_exp>;
};

/** order by aggregate values of table "smart_meter_integration_building" */
export type smart_meter_integration_building_aggregate_order_by = {
  avg?: InputMaybe<smart_meter_integration_building_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<smart_meter_integration_building_max_order_by>;
  min?: InputMaybe<smart_meter_integration_building_min_order_by>;
  stddev?: InputMaybe<smart_meter_integration_building_stddev_order_by>;
  stddev_pop?: InputMaybe<smart_meter_integration_building_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<smart_meter_integration_building_stddev_samp_order_by>;
  sum?: InputMaybe<smart_meter_integration_building_sum_order_by>;
  var_pop?: InputMaybe<smart_meter_integration_building_var_pop_order_by>;
  var_samp?: InputMaybe<smart_meter_integration_building_var_samp_order_by>;
  variance?: InputMaybe<smart_meter_integration_building_variance_order_by>;
};

/** order by avg() on columns of table "smart_meter_integration_building" */
export type smart_meter_integration_building_avg_order_by = {
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<order_by>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<order_by>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "smart_meter_integration_building". All fields are combined with a logical 'AND'. */
export type smart_meter_integration_building_bool_exp = {
  _and?: InputMaybe<Array<smart_meter_integration_building_bool_exp>>;
  _not?: InputMaybe<smart_meter_integration_building_bool_exp>;
  _or?: InputMaybe<Array<smart_meter_integration_building_bool_exp>>;
  archive_reason_id?: InputMaybe<smart_meter_archive_reason_enum_comparison_exp>;
  archived_at?: InputMaybe<timestamptz_comparison_exp>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  external_id?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  last_seen_at?: InputMaybe<timestamptz_comparison_exp>;
  link_method_id?: InputMaybe<smart_meter_link_method_enum_comparison_exp>;
  link_state_id?: InputMaybe<smart_meter_link_state_enum_comparison_exp>;
  match_score?: InputMaybe<float8_comparison_exp>;
  properties?: InputMaybe<jsonb_comparison_exp>;
  smart_meter_integration?: InputMaybe<smart_meter_integration_bool_exp>;
  smart_meter_integration_id?: InputMaybe<Int_comparison_exp>;
  smart_meters?: InputMaybe<smart_meter_bool_exp>;
  suggested_building?: InputMaybe<building_bool_exp>;
  suggested_building_id?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** order by max() on columns of table "smart_meter_integration_building" */
export type smart_meter_integration_building_max_order_by = {
  /** Timestamp when this record was archived. */
  archived_at?: InputMaybe<order_by>;
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Unique identifier for this building in the external metering provider system. */
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Last timestamp this building record was present in the provider API response. */
  last_seen_at?: InputMaybe<order_by>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<order_by>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<order_by>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "smart_meter_integration_building" */
export type smart_meter_integration_building_min_order_by = {
  /** Timestamp when this record was archived. */
  archived_at?: InputMaybe<order_by>;
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Unique identifier for this building in the external metering provider system. */
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Last timestamp this building record was present in the provider API response. */
  last_seen_at?: InputMaybe<order_by>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<order_by>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<order_by>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** response of any mutation on the table "smart_meter_integration_building" */
export type smart_meter_integration_building_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<smart_meter_integration_building>;
};

/** Ordering options when selecting data from "smart_meter_integration_building". */
export type smart_meter_integration_building_order_by = {
  archive_reason_id?: InputMaybe<order_by>;
  archived_at?: InputMaybe<order_by>;
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  last_seen_at?: InputMaybe<order_by>;
  link_method_id?: InputMaybe<order_by>;
  link_state_id?: InputMaybe<order_by>;
  match_score?: InputMaybe<order_by>;
  properties?: InputMaybe<order_by>;
  smart_meter_integration?: InputMaybe<smart_meter_integration_order_by>;
  smart_meter_integration_id?: InputMaybe<order_by>;
  smart_meters_aggregate?: InputMaybe<smart_meter_aggregate_order_by>;
  suggested_building?: InputMaybe<building_order_by>;
  suggested_building_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "smart_meter_integration_building" */
export enum smart_meter_integration_building_select_column {
  /** column name */
  archive_reason_id = 'archive_reason_id',
  /** column name */
  archived_at = 'archived_at',
  /** column name */
  building_id = 'building_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  external_id = 'external_id',
  /** column name */
  id = 'id',
  /** column name */
  last_seen_at = 'last_seen_at',
  /** column name */
  link_method_id = 'link_method_id',
  /** column name */
  link_state_id = 'link_state_id',
  /** column name */
  match_score = 'match_score',
  /** column name */
  properties = 'properties',
  /** column name */
  smart_meter_integration_id = 'smart_meter_integration_id',
  /** column name */
  suggested_building_id = 'suggested_building_id',
  /** column name */
  updated_at = 'updated_at',
}

/** order by stddev() on columns of table "smart_meter_integration_building" */
export type smart_meter_integration_building_stddev_order_by = {
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<order_by>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<order_by>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "smart_meter_integration_building" */
export type smart_meter_integration_building_stddev_pop_order_by = {
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<order_by>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<order_by>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "smart_meter_integration_building" */
export type smart_meter_integration_building_stddev_samp_order_by = {
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<order_by>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<order_by>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "smart_meter_integration_building" */
export type smart_meter_integration_building_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: smart_meter_integration_building_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type smart_meter_integration_building_stream_cursor_value_input = {
  /** Reason this record was archived. */
  archive_reason_id?: InputMaybe<smart_meter_archive_reason_enum>;
  /** Timestamp when this record was archived. */
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Unique identifier for this building in the external metering provider system. */
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Last timestamp this building record was present in the provider API response. */
  last_seen_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Method used to link this record to a Predium building. NULL when unlinked. */
  link_method_id?: InputMaybe<smart_meter_link_method_enum>;
  /** Linking state of this provider building record: UNLINKED | LINKED | ARCHIVED. */
  link_state_id?: InputMaybe<smart_meter_link_state_enum>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<Scalars['float8']['input']>;
  /** Provider-specific building properties stored as JSON. */
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<Scalars['Int']['input']>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "smart_meter_integration_building" */
export type smart_meter_integration_building_sum_order_by = {
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<order_by>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<order_by>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<order_by>;
};

/** order by var_pop() on columns of table "smart_meter_integration_building" */
export type smart_meter_integration_building_var_pop_order_by = {
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<order_by>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<order_by>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "smart_meter_integration_building" */
export type smart_meter_integration_building_var_samp_order_by = {
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<order_by>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<order_by>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "smart_meter_integration_building" */
export type smart_meter_integration_building_variance_order_by = {
  /** The Predium building linked to this external metering entity. Nullable if not yet mapped. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Confidence (0-1) for suggested_building_id; same never-cleared semantics. */
  match_score?: InputMaybe<order_by>;
  /** The parent integration this building mapping belongs to. */
  smart_meter_integration_id?: InputMaybe<order_by>;
  /** Address matcher's proposal at last sync (RED-2786). Never cleared by link()/unlink(); a live suggestion only while link_state_id = 'UNLINKED', otherwise history (compare vs building_id). */
  suggested_building_id?: InputMaybe<order_by>;
};

/** Ordering options when selecting data from "smart_meter_integration". */
export type smart_meter_integration_order_by = {
  api_key?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  credential_version?: InputMaybe<order_by>;
  disabled?: InputMaybe<order_by>;
  health_status_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  last_sync?: InputMaybe<order_by>;
  meter_integration_buildings_aggregate?: InputMaybe<smart_meter_integration_building_aggregate_order_by>;
  meter_integration_type_id?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  sync_interval_id?: InputMaybe<order_by>;
  sync_state_id?: InputMaybe<order_by>;
  tenant_id?: InputMaybe<order_by>;
  tenant_name?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "smart_meter_integration" */
export enum smart_meter_integration_select_column {
  /** column name */
  api_key = 'api_key',
  /** column name */
  created_at = 'created_at',
  /** column name */
  credential_version = 'credential_version',
  /** column name */
  disabled = 'disabled',
  /** column name */
  health_status_id = 'health_status_id',
  /** column name */
  id = 'id',
  /** column name */
  last_sync = 'last_sync',
  /** column name */
  meter_integration_type_id = 'meter_integration_type_id',
  /** column name */
  org_id = 'org_id',
  /** column name */
  sync_interval_id = 'sync_interval_id',
  /** column name */
  sync_state_id = 'sync_state_id',
  /** column name */
  tenant_id = 'tenant_id',
  /** column name */
  tenant_name = 'tenant_name',
  /** column name */
  updated_at = 'updated_at',
}

/** Streaming cursor of the table "smart_meter_integration" */
export type smart_meter_integration_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: smart_meter_integration_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type smart_meter_integration_stream_cursor_value_input = {
  /** API key for authenticating with the external metering provider. */
  api_key?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Incremented on each credential rotation to invalidate cached tokens. */
  credential_version?: InputMaybe<Scalars['Int']['input']>;
  /** When true, the integration is paused and will not be synced. */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current health status of the integration. NULL means status is unknown. */
  health_status_id?: InputMaybe<smart_meter_health_status_enum>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Timestamp of the last synchronization attempt with the external provider. */
  last_sync?: InputMaybe<Scalars['timestamp']['input']>;
  /** The external metering provider type. */
  meter_integration_type_id?: InputMaybe<smart_meter_integration_type_enum>;
  /** The organization that owns this integration. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  sync_interval_id?: InputMaybe<smart_meter_sync_interval_enum>;
  /** Overall synchronization status of this integration. */
  sync_state_id?: InputMaybe<smart_meter_sync_state_enum>;
  /** External tenant identifier from the provider. */
  tenant_id?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable tenant name from the provider. */
  tenant_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export enum smart_meter_integration_type_enum {
  BASCLOUD = 'BASCLOUD',
  QIVALO = 'QIVALO',
}

/** Boolean expression to compare columns of type "smart_meter_integration_type_enum". All fields are combined with logical 'AND'. */
export type smart_meter_integration_type_enum_comparison_exp = {
  _eq?: InputMaybe<smart_meter_integration_type_enum>;
  _in?: InputMaybe<Array<smart_meter_integration_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<smart_meter_integration_type_enum>;
  _nin?: InputMaybe<Array<smart_meter_integration_type_enum>>;
};

export enum smart_meter_link_method_enum {
  MANUAL = 'MANUAL',
}

/** Boolean expression to compare columns of type "smart_meter_link_method_enum". All fields are combined with logical 'AND'. */
export type smart_meter_link_method_enum_comparison_exp = {
  _eq?: InputMaybe<smart_meter_link_method_enum>;
  _in?: InputMaybe<Array<smart_meter_link_method_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<smart_meter_link_method_enum>;
  _nin?: InputMaybe<Array<smart_meter_link_method_enum>>;
};

export enum smart_meter_link_state_enum {
  LINKED = 'LINKED',
  UNLINKED = 'UNLINKED',
}

/** Boolean expression to compare columns of type "smart_meter_link_state_enum". All fields are combined with logical 'AND'. */
export type smart_meter_link_state_enum_comparison_exp = {
  _eq?: InputMaybe<smart_meter_link_state_enum>;
  _in?: InputMaybe<Array<smart_meter_link_state_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<smart_meter_link_state_enum>;
  _nin?: InputMaybe<Array<smart_meter_link_state_enum>>;
};

/** order by max() on columns of table "smart_meter" */
export type smart_meter_max_order_by = {
  /** Timestamp when this meter was archived. */
  archived_at?: InputMaybe<order_by>;
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<order_by>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Human-readable label or description for identifying this meter. */
  description?: InputMaybe<order_by>;
  /** Unique identifier for this meter in the external metering provider system. */
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Last timestamp this meter was present in the provider API response. */
  last_seen_at?: InputMaybe<order_by>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "smart_meter" */
export type smart_meter_min_order_by = {
  /** Timestamp when this meter was archived. */
  archived_at?: InputMaybe<order_by>;
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<order_by>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  /** Human-readable label or description for identifying this meter. */
  description?: InputMaybe<order_by>;
  /** Unique identifier for this meter in the external metering provider system. */
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** Last timestamp this meter was present in the provider API response. */
  last_seen_at?: InputMaybe<order_by>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** response of any mutation on the table "smart_meter" */
export type smart_meter_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<smart_meter>;
};

/** Ordering options when selecting data from "smart_meter". */
export type smart_meter_order_by = {
  archive_reason_id?: InputMaybe<order_by>;
  archived_at?: InputMaybe<order_by>;
  area?: InputMaybe<area_order_by>;
  area_id?: InputMaybe<order_by>;
  consecutive_failure_count?: InputMaybe<order_by>;
  consumption_frequency_type_id?: InputMaybe<order_by>;
  consumption_type_id?: InputMaybe<order_by>;
  consumption_unit_id?: InputMaybe<order_by>;
  consumptions_aggregate?: InputMaybe<consumption_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  description?: InputMaybe<order_by>;
  external_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  last_seen_at?: InputMaybe<order_by>;
  smart_meter_integration_building?: InputMaybe<smart_meter_integration_building_order_by>;
  smart_meter_integration_building_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "smart_meter" */
export enum smart_meter_select_column {
  /** column name */
  archive_reason_id = 'archive_reason_id',
  /** column name */
  archived_at = 'archived_at',
  /** column name */
  area_id = 'area_id',
  /** column name */
  consecutive_failure_count = 'consecutive_failure_count',
  /** column name */
  consumption_frequency_type_id = 'consumption_frequency_type_id',
  /** column name */
  consumption_type_id = 'consumption_type_id',
  /** column name */
  consumption_unit_id = 'consumption_unit_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  external_id = 'external_id',
  /** column name */
  id = 'id',
  /** column name */
  last_seen_at = 'last_seen_at',
  /** column name */
  smart_meter_integration_building_id = 'smart_meter_integration_building_id',
  /** column name */
  updated_at = 'updated_at',
}

/** order by stddev() on columns of table "smart_meter" */
export type smart_meter_stddev_order_by = {
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<order_by>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "smart_meter" */
export type smart_meter_stddev_pop_order_by = {
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<order_by>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "smart_meter" */
export type smart_meter_stddev_samp_order_by = {
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<order_by>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "smart_meter" */
export type smart_meter_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: smart_meter_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type smart_meter_stream_cursor_value_input = {
  /** Reason this meter was archived. */
  archive_reason_id?: InputMaybe<smart_meter_archive_reason_enum>;
  /** Timestamp when this meter was archived. */
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<Scalars['Int']['input']>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<Scalars['Int']['input']>;
  /** How often this meter records readings (e.g. MONTHLY, YEARLY). */
  consumption_frequency_type_id?: InputMaybe<consumption_frequency_type_enum>;
  /** What this meter measures: HEATING, ELECTRICITY, WATER, or WASTE. */
  consumption_type_id?: InputMaybe<consumption_type_enum>;
  /** Measurement unit of the meter readings (e.g. kWh, m3). */
  consumption_unit_id?: InputMaybe<consumption_unit_enum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Human-readable label or description for identifying this meter. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for this meter in the external metering provider system. */
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Last timestamp this meter was present in the provider API response. */
  last_seen_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "smart_meter" */
export type smart_meter_sum_order_by = {
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<order_by>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<order_by>;
};

/** Tracks the last successfully synced timestamp per smart meter. */
export type smart_meter_sync_checkpoint = {
  id: Scalars['Int']['output'];
  /** Upper bound of the last successfully synced time range. NULL means never synced. */
  last_synced_to?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  smart_meter: smart_meter;
  smart_meter_id: Scalars['Int']['output'];
  /** Timestamp of the last upsert to this checkpoint record. */
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "smart_meter_sync_checkpoint". All fields are combined with a logical 'AND'. */
export type smart_meter_sync_checkpoint_bool_exp = {
  _and?: InputMaybe<Array<smart_meter_sync_checkpoint_bool_exp>>;
  _not?: InputMaybe<smart_meter_sync_checkpoint_bool_exp>;
  _or?: InputMaybe<Array<smart_meter_sync_checkpoint_bool_exp>>;
  id?: InputMaybe<Int_comparison_exp>;
  last_synced_to?: InputMaybe<timestamptz_comparison_exp>;
  smart_meter?: InputMaybe<smart_meter_bool_exp>;
  smart_meter_id?: InputMaybe<Int_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
};

/** Ordering options when selecting data from "smart_meter_sync_checkpoint". */
export type smart_meter_sync_checkpoint_order_by = {
  id?: InputMaybe<order_by>;
  last_synced_to?: InputMaybe<order_by>;
  smart_meter?: InputMaybe<smart_meter_order_by>;
  smart_meter_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** select columns of table "smart_meter_sync_checkpoint" */
export enum smart_meter_sync_checkpoint_select_column {
  /** column name */
  id = 'id',
  /** column name */
  last_synced_to = 'last_synced_to',
  /** column name */
  smart_meter_id = 'smart_meter_id',
  /** column name */
  updated_at = 'updated_at',
}

/** Streaming cursor of the table "smart_meter_sync_checkpoint" */
export type smart_meter_sync_checkpoint_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: smart_meter_sync_checkpoint_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type smart_meter_sync_checkpoint_stream_cursor_value_input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Upper bound of the last successfully synced time range. NULL means never synced. */
  last_synced_to?: InputMaybe<Scalars['timestamptz']['input']>;
  smart_meter_id?: InputMaybe<Scalars['Int']['input']>;
  /** Timestamp of the last upsert to this checkpoint record. */
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export enum smart_meter_sync_interval_enum {
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}

/** Boolean expression to compare columns of type "smart_meter_sync_interval_enum". All fields are combined with logical 'AND'. */
export type smart_meter_sync_interval_enum_comparison_exp = {
  _eq?: InputMaybe<smart_meter_sync_interval_enum>;
  _in?: InputMaybe<Array<smart_meter_sync_interval_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<smart_meter_sync_interval_enum>;
  _nin?: InputMaybe<Array<smart_meter_sync_interval_enum>>;
};

export enum smart_meter_sync_state_enum {
  IN_SYNC = 'IN_SYNC',
  OUT_OF_SYNC = 'OUT_OF_SYNC',
  SYNCING = 'SYNCING',
}

/** Boolean expression to compare columns of type "smart_meter_sync_state_enum". All fields are combined with logical 'AND'. */
export type smart_meter_sync_state_enum_comparison_exp = {
  _eq?: InputMaybe<smart_meter_sync_state_enum>;
  _in?: InputMaybe<Array<smart_meter_sync_state_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<smart_meter_sync_state_enum>;
  _nin?: InputMaybe<Array<smart_meter_sync_state_enum>>;
};

/** order by var_pop() on columns of table "smart_meter" */
export type smart_meter_var_pop_order_by = {
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<order_by>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "smart_meter" */
export type smart_meter_var_samp_order_by = {
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<order_by>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "smart_meter" */
export type smart_meter_variance_order_by = {
  /** Optional link to a specific building area this meter measures. */
  area_id?: InputMaybe<order_by>;
  /** Number of consecutive polling failures. Resets to 0 on successful poll. */
  consecutive_failure_count?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The building-level integration this meter belongs to. */
  smart_meter_integration_building_id?: InputMaybe<order_by>;
};

export enum source_consumption_enum {
  ESTIMATION = 'ESTIMATION',
  INVOICE = 'INVOICE',
  MANUAL_ENTRY = 'MANUAL_ENTRY',
  SMART_METER = 'SMART_METER',
}

export enum status_consumption_enum {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DUPLICATED = 'DUPLICATED',
  FAILED = 'FAILED',
  INACTIVE = 'INACTIVE',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  PROCESSING = 'PROCESSING',
}

export enum status_quo_pdf_export_tab_enum {
  CONSUMPTION = 'CONSUMPTION',
  DEMAND = 'DEMAND',
}

export type subscription_root = {
  /** fetch data from the table: "action" */
  action: Array<action>;
  /** fetch aggregated fields from the table: "action" */
  action_aggregate: action_aggregate;
  /** fetch data from the table: "action" using primary key columns */
  action_by_pk?: Maybe<action>;
  /** fetch data from the table: "action_plan" */
  action_plan: Array<action_plan>;
  /** fetch data from the table in a streaming manner: "action_plan" */
  action_plan_stream: Array<action_plan>;
  /** fetch data from the table in a streaming manner: "action" */
  action_stream: Array<action>;
  /** fetch data from the table: "action_subsidy" */
  action_subsidy: Array<action_subsidy>;
  /** fetch data from the table: "action_subsidy" using primary key columns */
  action_subsidy_by_pk?: Maybe<action_subsidy>;
  /** fetch data from the table in a streaming manner: "action_subsidy" */
  action_subsidy_stream: Array<action_subsidy>;
  /** An array relationship */
  active_action_plans: Array<active_action_plans>;
  /** An aggregate relationship */
  active_action_plans_aggregate: active_action_plans_aggregate;
  /** fetch data from the table: "active_bulk_actions" */
  active_bulk_actions: Array<active_bulk_actions>;
  /** fetch aggregated fields from the table: "active_bulk_actions" */
  active_bulk_actions_aggregate: active_bulk_actions_aggregate;
  /** fetch data from the table: "address" */
  address: Array<address>;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<address>;
  /** fetch data from the table in a streaming manner: "address" */
  address_stream: Array<address>;
  /** fetch data from the table: "alpha_prompt_interaction" */
  alpha_prompt_interaction: Array<alpha_prompt_interaction>;
  /** fetch data from the table: "alpha_prompt_interaction" using primary key columns */
  alpha_prompt_interaction_by_pk?: Maybe<alpha_prompt_interaction>;
  /** fetch data from the table in a streaming manner: "alpha_prompt_interaction" */
  alpha_prompt_interaction_stream: Array<alpha_prompt_interaction>;
  /** fetch data from the table: "area" */
  area: Array<area>;
  /** fetch aggregated fields from the table: "area" */
  area_aggregate: area_aggregate;
  /** fetch data from the table: "area" using primary key columns */
  area_by_pk?: Maybe<area>;
  /** fetch data from the table in a streaming manner: "area" */
  area_stream: Array<area>;
  /** fetch data from the table: "async_job" */
  async_job: Array<async_job>;
  /** fetch aggregated fields from the table: "async_job" */
  async_job_aggregate: async_job_aggregate;
  /** fetch data from the table: "async_job" using primary key columns */
  async_job_by_pk?: Maybe<async_job>;
  /** fetch data from the table in a streaming manner: "async_job" */
  async_job_stream: Array<async_job>;
  /** fetch data from the table: "building" */
  building: Array<building>;
  /** fetch aggregated fields from the table: "building" */
  building_aggregate: building_aggregate;
  /** fetch data from the table: "building" using primary key columns */
  building_by_pk?: Maybe<building>;
  /** fetch data from the table: "building_district_heating_availability" */
  building_district_heating_availability: Array<building_district_heating_availability>;
  /** fetch data from the table: "building_district_heating_availability" using primary key columns */
  building_district_heating_availability_by_pk?: Maybe<building_district_heating_availability>;
  /** fetch data from the table in a streaming manner: "building_district_heating_availability" */
  building_district_heating_availability_stream: Array<building_district_heating_availability>;
  /** fetch data from the table: "building_draft" */
  building_draft: Array<building_draft>;
  /** fetch aggregated fields from the table: "building_draft" */
  building_draft_aggregate: building_draft_aggregate;
  /** fetch data from the table: "building_draft_area" */
  building_draft_area: Array<building_draft_area>;
  /** fetch data from the table: "building_draft_area" using primary key columns */
  building_draft_area_by_pk?: Maybe<building_draft_area>;
  /** fetch data from the table in a streaming manner: "building_draft_area" */
  building_draft_area_stream: Array<building_draft_area>;
  /** fetch data from the table: "building_draft" using primary key columns */
  building_draft_by_pk?: Maybe<building_draft>;
  /** fetch data from the table: "building_draft_consumer" */
  building_draft_consumer: Array<building_draft_consumer>;
  /** fetch data from the table: "building_draft_consumer" using primary key columns */
  building_draft_consumer_by_pk?: Maybe<building_draft_consumer>;
  /** fetch data from the table in a streaming manner: "building_draft_consumer" */
  building_draft_consumer_stream: Array<building_draft_consumer>;
  /** fetch data from the table in a streaming manner: "building_draft" */
  building_draft_stream: Array<building_draft>;
  /** fetch data from the table: "building_draft_valuation" */
  building_draft_valuation: Array<building_draft_valuation>;
  /** fetch data from the table: "building_draft_valuation" using primary key columns */
  building_draft_valuation_by_pk?: Maybe<building_draft_valuation>;
  /** fetch data from the table in a streaming manner: "building_draft_valuation" */
  building_draft_valuation_stream: Array<building_draft_valuation>;
  /** fetch data from the table: "building_model" */
  building_model: Array<building_model>;
  /** fetch data from the table: "building_model" using primary key columns */
  building_model_by_pk?: Maybe<building_model>;
  /** fetch data from the table in a streaming manner: "building_model" */
  building_model_stream: Array<building_model>;
  /** fetch data from the table: "building_permissions" */
  building_permissions: Array<building_permissions>;
  /** fetch data from the table in a streaming manner: "building_permissions" */
  building_permissions_stream: Array<building_permissions>;
  /** fetch data from the table in a streaming manner: "building" */
  building_stream: Array<building>;
  /** fetch data from the table: "building_subsidy" */
  building_subsidy: Array<building_subsidy>;
  /** fetch data from the table: "building_valuation" */
  building_valuation: Array<building_valuation>;
  /** fetch data from the table: "building_valuation" using primary key columns */
  building_valuation_by_pk?: Maybe<building_valuation>;
  /** fetch data from the table in a streaming manner: "building_valuation" */
  building_valuation_stream: Array<building_valuation>;
  /** fetch data from the table: "building_with_district_heating_status" */
  building_with_district_heating_status: Array<building_with_district_heating_status>;
  /** fetch data from the table in a streaming manner: "building_with_district_heating_status" */
  building_with_district_heating_status_stream: Array<building_with_district_heating_status>;
  /** fetch data from the table: "bulk_action" */
  bulk_action: Array<bulk_action>;
  /** fetch aggregated fields from the table: "bulk_action" */
  bulk_action_aggregate: bulk_action_aggregate;
  /** fetch data from the table: "bulk_action" using primary key columns */
  bulk_action_by_pk?: Maybe<bulk_action>;
  /** fetch data from the table in a streaming manner: "bulk_action" */
  bulk_action_stream: Array<bulk_action>;
  /** fetch data from the table: "bulk_action_summary" */
  bulk_action_summary: Array<bulk_action_summary>;
  /** fetch aggregated fields from the table: "bulk_action_summary" */
  bulk_action_summary_aggregate: bulk_action_summary_aggregate;
  /** fetch data from the table in a streaming manner: "bulk_action_summary" */
  bulk_action_summary_stream: Array<bulk_action_summary>;
  /** fetch data from the table: "bulk_actions_overview" */
  bulk_actions_overview: Array<bulk_actions_overview>;
  /** fetch aggregated fields from the table: "bulk_actions_overview" */
  bulk_actions_overview_aggregate: bulk_actions_overview_aggregate;
  /** fetch data from the table in a streaming manner: "bulk_actions_overview" */
  bulk_actions_overview_stream: Array<bulk_actions_overview>;
  /** fetch data from the table: "cbi_address" */
  cbi_address: Array<cbi_address>;
  /** fetch aggregated fields from the table: "cbi_address" */
  cbi_address_aggregate: cbi_address_aggregate;
  /** fetch data from the table: "cbi_address_assignment" */
  cbi_address_assignment: Array<cbi_address_assignment>;
  /** fetch aggregated fields from the table: "cbi_address_assignment" */
  cbi_address_assignment_aggregate: cbi_address_assignment_aggregate;
  /** fetch data from the table: "cbi_address_assignment" using primary key columns */
  cbi_address_assignment_by_pk?: Maybe<cbi_address_assignment>;
  /** fetch data from the table in a streaming manner: "cbi_address_assignment" */
  cbi_address_assignment_stream: Array<cbi_address_assignment>;
  /** fetch data from the table: "cbi_address" using primary key columns */
  cbi_address_by_pk?: Maybe<cbi_address>;
  /** fetch data from the table in a streaming manner: "cbi_address" */
  cbi_address_stream: Array<cbi_address>;
  /** fetch data from the table: "cbi_billable_event" */
  cbi_billable_event: Array<cbi_billable_event>;
  /** fetch aggregated fields from the table: "cbi_billable_event" */
  cbi_billable_event_aggregate: cbi_billable_event_aggregate;
  /** fetch data from the table: "cbi_billable_event" using primary key columns */
  cbi_billable_event_by_pk?: Maybe<cbi_billable_event>;
  /** fetch data from the table in a streaming manner: "cbi_billable_event" */
  cbi_billable_event_stream: Array<cbi_billable_event>;
  /** fetch data from the table: "cbi_billing_increment_event" */
  cbi_billing_increment_event: Array<cbi_billing_increment_event>;
  /** fetch aggregated fields from the table: "cbi_billing_increment_event" */
  cbi_billing_increment_event_aggregate: cbi_billing_increment_event_aggregate;
  /** fetch data from the table: "cbi_billing_increment_event" using primary key columns */
  cbi_billing_increment_event_by_pk?: Maybe<cbi_billing_increment_event>;
  /** fetch data from the table in a streaming manner: "cbi_billing_increment_event" */
  cbi_billing_increment_event_stream: Array<cbi_billing_increment_event>;
  /** fetch data from the table: "cbi_billing_period" */
  cbi_billing_period: Array<cbi_billing_period>;
  /** fetch aggregated fields from the table: "cbi_billing_period" */
  cbi_billing_period_aggregate: cbi_billing_period_aggregate;
  /** fetch data from the table: "cbi_billing_period" using primary key columns */
  cbi_billing_period_by_pk?: Maybe<cbi_billing_period>;
  /** fetch data from the table in a streaming manner: "cbi_billing_period" */
  cbi_billing_period_stream: Array<cbi_billing_period>;
  /** fetch data from the table: "cbi_consumption_line" */
  cbi_consumption_line: Array<cbi_consumption_line>;
  /** fetch aggregated fields from the table: "cbi_consumption_line" */
  cbi_consumption_line_aggregate: cbi_consumption_line_aggregate;
  /** fetch data from the table: "cbi_consumption_line" using primary key columns */
  cbi_consumption_line_by_pk?: Maybe<cbi_consumption_line>;
  /** fetch data from the table in a streaming manner: "cbi_consumption_line" */
  cbi_consumption_line_stream: Array<cbi_consumption_line>;
  /** fetch data from the table: "cbi_email" */
  cbi_email: Array<cbi_email>;
  /** fetch data from the table: "cbi_email" using primary key columns */
  cbi_email_by_pk?: Maybe<cbi_email>;
  /** fetch data from the table in a streaming manner: "cbi_email" */
  cbi_email_stream: Array<cbi_email>;
  /** fetch data from the table: "cbi_export" */
  cbi_export: Array<cbi_export>;
  /** fetch aggregated fields from the table: "cbi_export" */
  cbi_export_aggregate: cbi_export_aggregate;
  /** fetch data from the table: "cbi_export" using primary key columns */
  cbi_export_by_pk?: Maybe<cbi_export>;
  /** fetch data from the table in a streaming manner: "cbi_export" */
  cbi_export_stream: Array<cbi_export>;
  /** fetch data from the table: "cbi_inbox" */
  cbi_inbox: Array<cbi_inbox>;
  /** fetch data from the table: "cbi_inbox" using primary key columns */
  cbi_inbox_by_pk?: Maybe<cbi_inbox>;
  /** fetch data from the table in a streaming manner: "cbi_inbox" */
  cbi_inbox_stream: Array<cbi_inbox>;
  /** fetch data from the table: "cbi_invoice" */
  cbi_invoice: Array<cbi_invoice>;
  /** fetch aggregated fields from the table: "cbi_invoice" */
  cbi_invoice_aggregate: cbi_invoice_aggregate;
  /** fetch data from the table: "cbi_invoice" using primary key columns */
  cbi_invoice_by_pk?: Maybe<cbi_invoice>;
  /** fetch data from the table: "cbi_invoice_snapshot" */
  cbi_invoice_snapshot: Array<cbi_invoice_snapshot>;
  /** fetch aggregated fields from the table: "cbi_invoice_snapshot" */
  cbi_invoice_snapshot_aggregate: cbi_invoice_snapshot_aggregate;
  /** fetch data from the table: "cbi_invoice_snapshot" using primary key columns */
  cbi_invoice_snapshot_by_pk?: Maybe<cbi_invoice_snapshot>;
  /** fetch data from the table in a streaming manner: "cbi_invoice_snapshot" */
  cbi_invoice_snapshot_stream: Array<cbi_invoice_snapshot>;
  /** fetch data from the table in a streaming manner: "cbi_invoice" */
  cbi_invoice_stream: Array<cbi_invoice>;
  /** fetch data from the table: "cbi_potential_building_match" */
  cbi_potential_building_match: Array<cbi_potential_building_match>;
  /** fetch data from the table: "cbi_potential_building_match" using primary key columns */
  cbi_potential_building_match_by_pk?: Maybe<cbi_potential_building_match>;
  /** fetch data from the table in a streaming manner: "cbi_potential_building_match" */
  cbi_potential_building_match_stream: Array<cbi_potential_building_match>;
  /** fetch data from the table: "certificate" */
  certificate: Array<certificate>;
  /** fetch aggregated fields from the table: "certificate" */
  certificate_aggregate: certificate_aggregate;
  /** fetch data from the table: "certificate" using primary key columns */
  certificate_by_pk?: Maybe<certificate>;
  /** fetch data from the table in a streaming manner: "certificate" */
  certificate_stream: Array<certificate>;
  /** fetch data from the table: "climate_risk" */
  climate_risk: Array<climate_risk>;
  /** fetch aggregated fields from the table: "climate_risk" */
  climate_risk_aggregate: climate_risk_aggregate;
  /** fetch data from the table: "climate_risk" using primary key columns */
  climate_risk_by_pk?: Maybe<climate_risk>;
  /** fetch data from the table in a streaming manner: "climate_risk" */
  climate_risk_stream: Array<climate_risk>;
  /** fetch data from the table: "climate_risk_v2" */
  climate_risk_v2: Array<climate_risk_v2>;
  /** fetch aggregated fields from the table: "climate_risk_v2" */
  climate_risk_v2_aggregate: climate_risk_v2_aggregate;
  /** fetch data from the table: "climate_risk_v2" using primary key columns */
  climate_risk_v2_by_pk?: Maybe<climate_risk_v2>;
  /** fetch data from the table in a streaming manner: "climate_risk_v2" */
  climate_risk_v2_stream: Array<climate_risk_v2>;
  /** fetch data from the table: "consumption" */
  consumption: Array<consumption>;
  /** fetch aggregated fields from the table: "consumption" */
  consumption_aggregate: consumption_aggregate;
  /** fetch data from the table: "consumption_area" */
  consumption_area: Array<consumption_area>;
  /** fetch data from the table: "consumption_area" using primary key columns */
  consumption_area_by_pk?: Maybe<consumption_area>;
  /** fetch data from the table in a streaming manner: "consumption_area" */
  consumption_area_stream: Array<consumption_area>;
  /** fetch data from the table: "consumption" using primary key columns */
  consumption_by_pk?: Maybe<consumption>;
  /** fetch data from the table: "consumption_draft" */
  consumption_draft: Array<consumption_draft>;
  /** fetch aggregated fields from the table: "consumption_draft" */
  consumption_draft_aggregate: consumption_draft_aggregate;
  /** fetch data from the table: "consumption_draft_area" */
  consumption_draft_area: Array<consumption_draft_area>;
  /** fetch data from the table: "consumption_draft_area" using primary key columns */
  consumption_draft_area_by_pk?: Maybe<consumption_draft_area>;
  /** fetch data from the table in a streaming manner: "consumption_draft_area" */
  consumption_draft_area_stream: Array<consumption_draft_area>;
  /** fetch data from the table: "consumption_draft" using primary key columns */
  consumption_draft_by_pk?: Maybe<consumption_draft>;
  /** fetch data from the table in a streaming manner: "consumption_draft" */
  consumption_draft_stream: Array<consumption_draft>;
  /** fetch data from the table: "consumption_frequency_type" */
  consumption_frequency_type: Array<consumption_frequency_type>;
  /** fetch data from the table: "consumption_frequency_type" using primary key columns */
  consumption_frequency_type_by_pk?: Maybe<consumption_frequency_type>;
  /** fetch data from the table in a streaming manner: "consumption_frequency_type" */
  consumption_frequency_type_stream: Array<consumption_frequency_type>;
  /** fetch data from the table: "consumption_invoice" */
  consumption_invoice: Array<consumption_invoice>;
  /** fetch data from the table: "consumption_invoice" using primary key columns */
  consumption_invoice_by_pk?: Maybe<consumption_invoice>;
  /** fetch data from the table: "consumption_invoice_draft" */
  consumption_invoice_draft: Array<consumption_invoice_draft>;
  /** fetch data from the table: "consumption_invoice_draft" using primary key columns */
  consumption_invoice_draft_by_pk?: Maybe<consumption_invoice_draft>;
  /** fetch data from the table in a streaming manner: "consumption_invoice_draft" */
  consumption_invoice_draft_stream: Array<consumption_invoice_draft>;
  /** fetch data from the table in a streaming manner: "consumption_invoice" */
  consumption_invoice_stream: Array<consumption_invoice>;
  /** fetch data from the table in a streaming manner: "consumption" */
  consumption_stream: Array<consumption>;
  /** fetch data from the table: "consumption_waste_details" */
  consumption_waste_details: Array<consumption_waste_details>;
  /** fetch data from the table: "consumption_waste_details" using primary key columns */
  consumption_waste_details_by_pk?: Maybe<consumption_waste_details>;
  /** fetch data from the table: "consumption_waste_details_draft" */
  consumption_waste_details_draft: Array<consumption_waste_details_draft>;
  /** fetch data from the table: "consumption_waste_details_draft" using primary key columns */
  consumption_waste_details_draft_by_pk?: Maybe<consumption_waste_details_draft>;
  /** fetch data from the table in a streaming manner: "consumption_waste_details_draft" */
  consumption_waste_details_draft_stream: Array<consumption_waste_details_draft>;
  /** fetch data from the table in a streaming manner: "consumption_waste_details" */
  consumption_waste_details_stream: Array<consumption_waste_details>;
  /** fetch data from the table: "cost_version" */
  cost_version: Array<cost_version>;
  /** fetch data from the table: "cost_version" using primary key columns */
  cost_version_by_pk?: Maybe<cost_version>;
  /** fetch data from the table in a streaming manner: "cost_version" */
  cost_version_stream: Array<cost_version>;
  /** fetch data from the table: "custom_field" */
  custom_field: Array<custom_field>;
  /** fetch data from the table: "custom_field" using primary key columns */
  custom_field_by_pk?: Maybe<custom_field>;
  /** fetch data from the table in a streaming manner: "custom_field" */
  custom_field_stream: Array<custom_field>;
  /** Danger: you probably want getActionPlanByStableId */
  danger_action_plan_by_pk?: Maybe<action_plan>;
  /** fetch data from the table: "economic_unit" */
  economic_unit: Array<economic_unit>;
  /** fetch aggregated fields from the table: "economic_unit" */
  economic_unit_aggregate: economic_unit_aggregate;
  /** fetch data from the table: "economic_unit" using primary key columns */
  economic_unit_by_pk?: Maybe<economic_unit>;
  /** fetch data from the table in a streaming manner: "economic_unit" */
  economic_unit_stream: Array<economic_unit>;
  /** fetch data from the table: "emission_certificate" */
  emission_certificate: Array<emission_certificate>;
  /** fetch aggregated fields from the table: "emission_certificate" */
  emission_certificate_aggregate: emission_certificate_aggregate;
  /** fetch data from the table: "emission_certificate" using primary key columns */
  emission_certificate_by_pk?: Maybe<emission_certificate>;
  /** fetch data from the table: "emission_certificate_draft" */
  emission_certificate_draft: Array<emission_certificate_draft>;
  /** fetch data from the table: "emission_certificate_draft" using primary key columns */
  emission_certificate_draft_by_pk?: Maybe<emission_certificate_draft>;
  /** fetch data from the table in a streaming manner: "emission_certificate_draft" */
  emission_certificate_draft_stream: Array<emission_certificate_draft>;
  /** fetch data from the table in a streaming manner: "emission_certificate" */
  emission_certificate_stream: Array<emission_certificate>;
  /** fetch data from the table: "emission_certificate_value_path" */
  emission_certificate_value_path: Array<emission_certificate_value_path>;
  /** fetch data from the table: "emission_certificate_value_path" using primary key columns */
  emission_certificate_value_path_by_pk?: Maybe<emission_certificate_value_path>;
  /** fetch data from the table in a streaming manner: "emission_certificate_value_path" */
  emission_certificate_value_path_stream: Array<emission_certificate_value_path>;
  /** fetch data from the table: "energy_certificate" */
  energy_certificate: Array<energy_certificate>;
  /** fetch data from the table: "energy_certificate" using primary key columns */
  energy_certificate_by_pk?: Maybe<energy_certificate>;
  /** fetch data from the table: "energy_certificate_consumer" */
  energy_certificate_consumer: Array<energy_certificate_consumer>;
  /** fetch data from the table: "energy_certificate_consumer" using primary key columns */
  energy_certificate_consumer_by_pk?: Maybe<energy_certificate_consumer>;
  /** fetch data from the table in a streaming manner: "energy_certificate_consumer" */
  energy_certificate_consumer_stream: Array<energy_certificate_consumer>;
  /** fetch data from the table: "energy_certificate_draft" */
  energy_certificate_draft: Array<energy_certificate_draft>;
  /** fetch aggregated fields from the table: "energy_certificate_draft" */
  energy_certificate_draft_aggregate: energy_certificate_draft_aggregate;
  /** fetch data from the table: "energy_certificate_draft" using primary key columns */
  energy_certificate_draft_by_pk?: Maybe<energy_certificate_draft>;
  /** fetch data from the table in a streaming manner: "energy_certificate_draft" */
  energy_certificate_draft_stream: Array<energy_certificate_draft>;
  /** fetch data from the table in a streaming manner: "energy_certificate" */
  energy_certificate_stream: Array<energy_certificate>;
  /** fetch data from the table: "energy_consumer" */
  energy_consumer: Array<energy_consumer>;
  /** fetch data from the table: "energy_consumer" using primary key columns */
  energy_consumer_by_pk?: Maybe<energy_consumer>;
  /** fetch data from the table in a streaming manner: "energy_consumer" */
  energy_consumer_stream: Array<energy_consumer>;
  /** fetch data from the table: "energy_distribution" */
  energy_distribution: Array<energy_distribution>;
  /** fetch data from the table: "energy_distribution" using primary key columns */
  energy_distribution_by_pk?: Maybe<energy_distribution>;
  /** fetch data from the table in a streaming manner: "energy_distribution" */
  energy_distribution_stream: Array<energy_distribution>;
  /** fetch data from the table: "energy_producer" */
  energy_producer: Array<energy_producer>;
  /** fetch data from the table: "energy_producer" using primary key columns */
  energy_producer_by_pk?: Maybe<energy_producer>;
  /** fetch data from the table in a streaming manner: "energy_producer" */
  energy_producer_stream: Array<energy_producer>;
  /** fetch data from the table: "energy_storage" */
  energy_storage: Array<energy_storage>;
  /** fetch data from the table: "energy_storage" using primary key columns */
  energy_storage_by_pk?: Maybe<energy_storage>;
  /** fetch data from the table in a streaming manner: "energy_storage" */
  energy_storage_stream: Array<energy_storage>;
  /** fetch data from the table: "energy_system" */
  energy_system: Array<energy_system>;
  /** fetch data from the table: "energy_system" using primary key columns */
  energy_system_by_pk?: Maybe<energy_system>;
  /** fetch data from the table: "energy_system_consumer_route" */
  energy_system_consumer_route: Array<energy_system_consumer_route>;
  /** fetch data from the table: "energy_system_consumer_route" using primary key columns */
  energy_system_consumer_route_by_pk?: Maybe<energy_system_consumer_route>;
  /** fetch data from the table in a streaming manner: "energy_system_consumer_route" */
  energy_system_consumer_route_stream: Array<energy_system_consumer_route>;
  /** fetch data from the table: "energy_system_producer_route" */
  energy_system_producer_route: Array<energy_system_producer_route>;
  /** fetch data from the table: "energy_system_producer_route" using primary key columns */
  energy_system_producer_route_by_pk?: Maybe<energy_system_producer_route>;
  /** fetch data from the table in a streaming manner: "energy_system_producer_route" */
  energy_system_producer_route_stream: Array<energy_system_producer_route>;
  /** fetch data from the table in a streaming manner: "energy_system" */
  energy_system_stream: Array<energy_system>;
  /** fetch data from the table: "envelope" */
  envelope: Array<envelope>;
  /** fetch data from the table: "envelope" using primary key columns */
  envelope_by_pk?: Maybe<envelope>;
  /** fetch data from the table in a streaming manner: "envelope" */
  envelope_stream: Array<envelope>;
  /** fetch data from the table: "export_template" */
  export_template: Array<export_template>;
  /** fetch aggregated fields from the table: "export_template" */
  export_template_aggregate: export_template_aggregate;
  /** fetch data from the table: "export_template" using primary key columns */
  export_template_by_pk?: Maybe<export_template>;
  /** fetch data from the table in a streaming manner: "export_template" */
  export_template_stream: Array<export_template>;
  /** fetch data from the table: "file" */
  file: Array<file>;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk?: Maybe<file>;
  /** fetch data from the table: "file_chunk" */
  file_chunk: Array<file_chunk>;
  /** fetch data from the table: "file_chunk" using primary key columns */
  file_chunk_by_pk?: Maybe<file_chunk>;
  /** fetch data from the table: "file_chunk_file_link" */
  file_chunk_file_link: Array<file_chunk_file_link>;
  /** fetch data from the table: "file_chunk_file_link" using primary key columns */
  file_chunk_file_link_by_pk?: Maybe<file_chunk_file_link>;
  /** fetch data from the table in a streaming manner: "file_chunk_file_link" */
  file_chunk_file_link_stream: Array<file_chunk_file_link>;
  /** fetch data from the table in a streaming manner: "file_chunk" */
  file_chunk_stream: Array<file_chunk>;
  /** fetch data from the table in a streaming manner: "file" */
  file_stream: Array<file>;
  /** fetch data from the table: "folder" */
  folder: Array<folder>;
  /** fetch data from the table: "folder" using primary key columns */
  folder_by_pk?: Maybe<folder>;
  /** fetch data from the table in a streaming manner: "folder" */
  folder_stream: Array<folder>;
  /** fetch data from the table: "folder_type" */
  folder_type: Array<folder_type>;
  /** fetch data from the table: "folder_type" using primary key columns */
  folder_type_by_pk?: Maybe<folder_type>;
  /** fetch data from the table in a streaming manner: "folder_type" */
  folder_type_stream: Array<folder_type>;
  /** An array relationship */
  inactive_buildings: Array<inactive_buildings>;
  /** fetch data from the table in a streaming manner: "inactive_buildings" */
  inactive_buildings_stream: Array<inactive_buildings>;
  /** fetch data from the table: "notification" */
  notification: Array<notification>;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<notification>;
  /** fetch data from the table in a streaming manner: "notification" */
  notification_stream: Array<notification>;
  /** fetch data from the table: "notification_template" */
  notification_template: Array<notification_template>;
  /** fetch data from the table: "notification_template" using primary key columns */
  notification_template_by_pk?: Maybe<notification_template>;
  /** fetch data from the table in a streaming manner: "notification_template" */
  notification_template_stream: Array<notification_template>;
  /** fetch data from the table: "org" */
  org: Array<org>;
  /** fetch data from the table: "org" using primary key columns */
  org_by_pk?: Maybe<org>;
  /** fetch data from the table in a streaming manner: "org" */
  org_stream: Array<org>;
  /** fetch data from the table: "portfolio" */
  portfolio: Array<portfolio>;
  /** fetch aggregated fields from the table: "portfolio" */
  portfolio_aggregate: portfolio_aggregate;
  /** fetch data from the table: "portfolio" using primary key columns */
  portfolio_by_pk?: Maybe<portfolio>;
  /** fetch data from the table in a streaming manner: "portfolio" */
  portfolio_stream: Array<portfolio>;
  /** fetch data from the table: "renovation" */
  renovation: Array<renovation>;
  /** fetch data from the table: "renovation" using primary key columns */
  renovation_by_pk?: Maybe<renovation>;
  /** fetch data from the table: "renovation_energy_consumer" */
  renovation_energy_consumer: Array<renovation_energy_consumer>;
  /** fetch data from the table in a streaming manner: "renovation_energy_consumer" */
  renovation_energy_consumer_stream: Array<renovation_energy_consumer>;
  /** fetch data from the table: "renovation_energy_producer" */
  renovation_energy_producer: Array<renovation_energy_producer>;
  /** fetch data from the table in a streaming manner: "renovation_energy_producer" */
  renovation_energy_producer_stream: Array<renovation_energy_producer>;
  /** fetch data from the table: "renovation_energy_system_route" */
  renovation_energy_system_route: Array<renovation_energy_system_route>;
  /** fetch data from the table in a streaming manner: "renovation_energy_system_route" */
  renovation_energy_system_route_stream: Array<renovation_energy_system_route>;
  /** fetch data from the table: "renovation_envelope" */
  renovation_envelope: Array<renovation_envelope>;
  /** fetch data from the table in a streaming manner: "renovation_envelope" */
  renovation_envelope_stream: Array<renovation_envelope>;
  /** fetch data from the table in a streaming manner: "renovation" */
  renovation_stream: Array<renovation>;
  /** fetch data from the table: "report" */
  report: Array<report>;
  /** fetch aggregated fields from the table: "report" */
  report_aggregate: report_aggregate;
  /** fetch data from the table: "report_answer" */
  report_answer: Array<report_answer>;
  /** fetch aggregated fields from the table: "report_answer" */
  report_answer_aggregate: report_answer_aggregate;
  /** fetch data from the table: "report_answer_autofill_option" */
  report_answer_autofill_option: Array<report_answer_autofill_option>;
  /** fetch data from the table: "report_answer_autofill_option" using primary key columns */
  report_answer_autofill_option_by_pk?: Maybe<report_answer_autofill_option>;
  /** fetch data from the table in a streaming manner: "report_answer_autofill_option" */
  report_answer_autofill_option_stream: Array<report_answer_autofill_option>;
  /** fetch data from the table: "report_answer" using primary key columns */
  report_answer_by_pk?: Maybe<report_answer>;
  /** fetch data from the table: "report_answer_chosen_option" */
  report_answer_chosen_option: Array<report_answer_chosen_option>;
  /** fetch data from the table: "report_answer_chosen_option" using primary key columns */
  report_answer_chosen_option_by_pk?: Maybe<report_answer_chosen_option>;
  /** fetch data from the table in a streaming manner: "report_answer_chosen_option" */
  report_answer_chosen_option_stream: Array<report_answer_chosen_option>;
  /** fetch data from the table in a streaming manner: "report_answer" */
  report_answer_stream: Array<report_answer>;
  /** fetch data from the table: "report_building" */
  report_building: Array<report_building>;
  /** fetch aggregated fields from the table: "report_building" */
  report_building_aggregate: report_building_aggregate;
  /** fetch data from the table: "report_building" using primary key columns */
  report_building_by_pk?: Maybe<report_building>;
  /** An array relationship */
  report_building_details: Array<report_building_details>;
  /** An aggregate relationship */
  report_building_details_aggregate: report_building_details_aggregate;
  /** fetch data from the table in a streaming manner: "report_building_details" */
  report_building_details_stream: Array<report_building_details>;
  /** fetch data from the table in a streaming manner: "report_building" */
  report_building_stream: Array<report_building>;
  /** fetch data from the table: "report" using primary key columns */
  report_by_pk?: Maybe<report>;
  /** fetch data from the table: "report_evidence" */
  report_evidence: Array<report_evidence>;
  /** fetch data from the table: "report_evidence" using primary key columns */
  report_evidence_by_pk?: Maybe<report_evidence>;
  /** fetch data from the table in a streaming manner: "report_evidence" */
  report_evidence_stream: Array<report_evidence>;
  /** fetch data from the table: "report_overview" */
  report_overview: Array<report_overview>;
  /** fetch data from the table in a streaming manner: "report_overview" */
  report_overview_stream: Array<report_overview>;
  /** fetch data from the table: "report_question_evidence" */
  report_question_evidence: Array<report_question_evidence>;
  /** fetch data from the table: "report_question_evidence" using primary key columns */
  report_question_evidence_by_pk?: Maybe<report_question_evidence>;
  /** fetch data from the table in a streaming manner: "report_question_evidence" */
  report_question_evidence_stream: Array<report_question_evidence>;
  /** fetch data from the table: "report_score" */
  report_score: Array<report_score>;
  /** fetch data from the table: "report_score" using primary key columns */
  report_score_by_pk?: Maybe<report_score>;
  /** fetch data from the table in a streaming manner: "report_score" */
  report_score_stream: Array<report_score>;
  /** fetch data from the table: "report_section_progress" */
  report_section_progress: Array<report_section_progress>;
  /** fetch data from the table: "report_section_progress" using primary key columns */
  report_section_progress_by_pk?: Maybe<report_section_progress>;
  /** fetch data from the table in a streaming manner: "report_section_progress" */
  report_section_progress_stream: Array<report_section_progress>;
  /** fetch data from the table in a streaming manner: "report" */
  report_stream: Array<report>;
  /** fetch data from the table: "report_template" */
  report_template: Array<report_template>;
  /** fetch data from the table: "report_template" using primary key columns */
  report_template_by_pk?: Maybe<report_template>;
  /** fetch data from the table: "report_template_question" */
  report_template_question: Array<report_template_question>;
  /** fetch aggregated fields from the table: "report_template_question" */
  report_template_question_aggregate: report_template_question_aggregate;
  /** fetch data from the table: "report_template_question" using primary key columns */
  report_template_question_by_pk?: Maybe<report_template_question>;
  /** fetch data from the table: "report_template_question_option" */
  report_template_question_option: Array<report_template_question_option>;
  /** fetch data from the table: "report_template_question_option" using primary key columns */
  report_template_question_option_by_pk?: Maybe<report_template_question_option>;
  /** fetch data from the table in a streaming manner: "report_template_question_option" */
  report_template_question_option_stream: Array<report_template_question_option>;
  /** fetch data from the table in a streaming manner: "report_template_question" */
  report_template_question_stream: Array<report_template_question>;
  /** fetch data from the table: "report_template_score" */
  report_template_score: Array<report_template_score>;
  /** fetch data from the table: "report_template_score" using primary key columns */
  report_template_score_by_pk?: Maybe<report_template_score>;
  /** fetch data from the table in a streaming manner: "report_template_score" */
  report_template_score_stream: Array<report_template_score>;
  /** fetch data from the table: "report_template_section" */
  report_template_section: Array<report_template_section>;
  /** fetch data from the table: "report_template_section" using primary key columns */
  report_template_section_by_pk?: Maybe<report_template_section>;
  /** fetch data from the table in a streaming manner: "report_template_section" */
  report_template_section_stream: Array<report_template_section>;
  /** fetch data from the table in a streaming manner: "report_template" */
  report_template_stream: Array<report_template>;
  /** fetch data from the table: "scenario" */
  scenario: Array<scenario>;
  /** fetch aggregated fields from the table: "scenario" */
  scenario_aggregate: scenario_aggregate;
  /** fetch data from the table: "scenario" using primary key columns */
  scenario_by_pk?: Maybe<scenario>;
  /** fetch data from the table in a streaming manner: "scenario" */
  scenario_stream: Array<scenario>;
  /** fetch data from the table: "scenario_version" */
  scenario_version: Array<scenario_version>;
  /** fetch aggregated fields from the table: "scenario_version" */
  scenario_version_aggregate: scenario_version_aggregate;
  /** fetch data from the table: "scenario_version" using primary key columns */
  scenario_version_by_pk?: Maybe<scenario_version>;
  /** fetch data from the table in a streaming manner: "scenario_version" */
  scenario_version_stream: Array<scenario_version>;
  /** fetch data from the table: "smart_meter" */
  smart_meter: Array<smart_meter>;
  /** fetch data from the table: "smart_meter" using primary key columns */
  smart_meter_by_pk?: Maybe<smart_meter>;
  /** fetch data from the table: "smart_meter_integration" */
  smart_meter_integration: Array<smart_meter_integration>;
  /** fetch data from the table: "smart_meter_integration_building" */
  smart_meter_integration_building: Array<smart_meter_integration_building>;
  /** fetch data from the table: "smart_meter_integration_building" using primary key columns */
  smart_meter_integration_building_by_pk?: Maybe<smart_meter_integration_building>;
  /** fetch data from the table in a streaming manner: "smart_meter_integration_building" */
  smart_meter_integration_building_stream: Array<smart_meter_integration_building>;
  /** fetch data from the table: "smart_meter_integration" using primary key columns */
  smart_meter_integration_by_pk?: Maybe<smart_meter_integration>;
  /** fetch data from the table in a streaming manner: "smart_meter_integration" */
  smart_meter_integration_stream: Array<smart_meter_integration>;
  /** fetch data from the table in a streaming manner: "smart_meter" */
  smart_meter_stream: Array<smart_meter>;
  /** fetch data from the table: "smart_meter_sync_checkpoint" */
  smart_meter_sync_checkpoint: Array<smart_meter_sync_checkpoint>;
  /** fetch data from the table: "smart_meter_sync_checkpoint" using primary key columns */
  smart_meter_sync_checkpoint_by_pk?: Maybe<smart_meter_sync_checkpoint>;
  /** fetch data from the table in a streaming manner: "smart_meter_sync_checkpoint" */
  smart_meter_sync_checkpoint_stream: Array<smart_meter_sync_checkpoint>;
  /** fetch data from the table: "subsidy" */
  subsidy: Array<subsidy>;
  /** fetch data from the table: "subsidy" using primary key columns */
  subsidy_by_pk?: Maybe<subsidy>;
  /** fetch data from the table in a streaming manner: "subsidy" */
  subsidy_stream: Array<subsidy>;
  /** fetch data from the table: "subsidy_subsidy_category" */
  subsidy_subsidy_category: Array<subsidy_subsidy_category>;
  /** fetch data from the table in a streaming manner: "subsidy_subsidy_category" */
  subsidy_subsidy_category_stream: Array<subsidy_subsidy_category>;
  /** fetch data from the table: "user" */
  user: Array<user>;
  /** fetch data from the table: "user_building_permission" */
  user_building_permission: Array<user_building_permission>;
  /** fetch data from the table: "user_building_permission" using primary key columns */
  user_building_permission_by_pk?: Maybe<user_building_permission>;
  /** fetch data from the table in a streaming manner: "user_building_permission" */
  user_building_permission_stream: Array<user_building_permission>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<user>;
  /** fetch data from the table: "user_portfolio_permission" */
  user_portfolio_permission: Array<user_portfolio_permission>;
  /** fetch aggregated fields from the table: "user_portfolio_permission" */
  user_portfolio_permission_aggregate: user_portfolio_permission_aggregate;
  /** fetch data from the table: "user_portfolio_permission" using primary key columns */
  user_portfolio_permission_by_pk?: Maybe<user_portfolio_permission>;
  /** fetch data from the table in a streaming manner: "user_portfolio_permission" */
  user_portfolio_permission_stream: Array<user_portfolio_permission>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<user>;
};

export type subscription_rootactionArgs = {
  distinct_on?: InputMaybe<Array<action_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_order_by>>;
  where?: InputMaybe<action_bool_exp>;
};

export type subscription_rootaction_aggregateArgs = {
  distinct_on?: InputMaybe<Array<action_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_order_by>>;
  where?: InputMaybe<action_bool_exp>;
};

export type subscription_rootaction_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootaction_planArgs = {
  distinct_on?: InputMaybe<Array<action_plan_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_plan_order_by>>;
  where?: InputMaybe<action_plan_bool_exp>;
};

export type subscription_rootaction_plan_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<action_plan_stream_cursor_input>>;
  where?: InputMaybe<action_plan_bool_exp>;
};

export type subscription_rootaction_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<action_stream_cursor_input>>;
  where?: InputMaybe<action_bool_exp>;
};

export type subscription_rootaction_subsidyArgs = {
  distinct_on?: InputMaybe<Array<action_subsidy_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_subsidy_order_by>>;
  where?: InputMaybe<action_subsidy_bool_exp>;
};

export type subscription_rootaction_subsidy_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootaction_subsidy_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<action_subsidy_stream_cursor_input>>;
  where?: InputMaybe<action_subsidy_bool_exp>;
};

export type subscription_rootactive_action_plansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_action_plans_order_by>>;
  where?: InputMaybe<active_action_plans_bool_exp>;
};

export type subscription_rootactive_action_plans_aggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_action_plans_order_by>>;
  where?: InputMaybe<active_action_plans_bool_exp>;
};

export type subscription_rootactive_bulk_actionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_bulk_actions_order_by>>;
  where?: InputMaybe<active_bulk_actions_bool_exp>;
};

export type subscription_rootactive_bulk_actions_aggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<active_bulk_actions_order_by>>;
  where?: InputMaybe<active_bulk_actions_bool_exp>;
};

export type subscription_rootaddressArgs = {
  distinct_on?: InputMaybe<Array<address_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<address_order_by>>;
  where?: InputMaybe<address_bool_exp>;
};

export type subscription_rootaddress_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootaddress_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<address_stream_cursor_input>>;
  where?: InputMaybe<address_bool_exp>;
};

export type subscription_rootalpha_prompt_interactionArgs = {
  distinct_on?: InputMaybe<Array<alpha_prompt_interaction_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<alpha_prompt_interaction_order_by>>;
  where?: InputMaybe<alpha_prompt_interaction_bool_exp>;
};

export type subscription_rootalpha_prompt_interaction_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootalpha_prompt_interaction_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<alpha_prompt_interaction_stream_cursor_input>>;
  where?: InputMaybe<alpha_prompt_interaction_bool_exp>;
};

export type subscription_rootareaArgs = {
  distinct_on?: InputMaybe<Array<area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<area_order_by>>;
  where?: InputMaybe<area_bool_exp>;
};

export type subscription_rootarea_aggregateArgs = {
  distinct_on?: InputMaybe<Array<area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<area_order_by>>;
  where?: InputMaybe<area_bool_exp>;
};

export type subscription_rootarea_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootarea_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<area_stream_cursor_input>>;
  where?: InputMaybe<area_bool_exp>;
};

export type subscription_rootasync_jobArgs = {
  distinct_on?: InputMaybe<Array<async_job_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<async_job_order_by>>;
  where?: InputMaybe<async_job_bool_exp>;
};

export type subscription_rootasync_job_aggregateArgs = {
  distinct_on?: InputMaybe<Array<async_job_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<async_job_order_by>>;
  where?: InputMaybe<async_job_bool_exp>;
};

export type subscription_rootasync_job_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootasync_job_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<async_job_stream_cursor_input>>;
  where?: InputMaybe<async_job_bool_exp>;
};

export type subscription_rootbuildingArgs = {
  distinct_on?: InputMaybe<Array<building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_order_by>>;
  where?: InputMaybe<building_bool_exp>;
};

export type subscription_rootbuilding_aggregateArgs = {
  distinct_on?: InputMaybe<Array<building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_order_by>>;
  where?: InputMaybe<building_bool_exp>;
};

export type subscription_rootbuilding_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootbuilding_district_heating_availabilityArgs = {
  distinct_on?: InputMaybe<Array<building_district_heating_availability_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_district_heating_availability_order_by>>;
  where?: InputMaybe<building_district_heating_availability_bool_exp>;
};

export type subscription_rootbuilding_district_heating_availability_by_pkArgs = {
  building_id: Scalars['Int']['input'];
};

export type subscription_rootbuilding_district_heating_availability_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<building_district_heating_availability_stream_cursor_input>>;
  where?: InputMaybe<building_district_heating_availability_bool_exp>;
};

export type subscription_rootbuilding_draftArgs = {
  distinct_on?: InputMaybe<Array<building_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_order_by>>;
  where?: InputMaybe<building_draft_bool_exp>;
};

export type subscription_rootbuilding_draft_aggregateArgs = {
  distinct_on?: InputMaybe<Array<building_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_order_by>>;
  where?: InputMaybe<building_draft_bool_exp>;
};

export type subscription_rootbuilding_draft_areaArgs = {
  distinct_on?: InputMaybe<Array<building_draft_area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_area_order_by>>;
  where?: InputMaybe<building_draft_area_bool_exp>;
};

export type subscription_rootbuilding_draft_area_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootbuilding_draft_area_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<building_draft_area_stream_cursor_input>>;
  where?: InputMaybe<building_draft_area_bool_exp>;
};

export type subscription_rootbuilding_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootbuilding_draft_consumerArgs = {
  distinct_on?: InputMaybe<Array<building_draft_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_consumer_order_by>>;
  where?: InputMaybe<building_draft_consumer_bool_exp>;
};

export type subscription_rootbuilding_draft_consumer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootbuilding_draft_consumer_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<building_draft_consumer_stream_cursor_input>>;
  where?: InputMaybe<building_draft_consumer_bool_exp>;
};

export type subscription_rootbuilding_draft_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<building_draft_stream_cursor_input>>;
  where?: InputMaybe<building_draft_bool_exp>;
};

export type subscription_rootbuilding_draft_valuationArgs = {
  distinct_on?: InputMaybe<Array<building_draft_valuation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_draft_valuation_order_by>>;
  where?: InputMaybe<building_draft_valuation_bool_exp>;
};

export type subscription_rootbuilding_draft_valuation_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootbuilding_draft_valuation_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<building_draft_valuation_stream_cursor_input>>;
  where?: InputMaybe<building_draft_valuation_bool_exp>;
};

export type subscription_rootbuilding_modelArgs = {
  distinct_on?: InputMaybe<Array<building_model_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_model_order_by>>;
  where?: InputMaybe<building_model_bool_exp>;
};

export type subscription_rootbuilding_model_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootbuilding_model_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<building_model_stream_cursor_input>>;
  where?: InputMaybe<building_model_bool_exp>;
};

export type subscription_rootbuilding_permissionsArgs = {
  distinct_on?: InputMaybe<Array<building_permissions_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_permissions_order_by>>;
  where?: InputMaybe<building_permissions_bool_exp>;
};

export type subscription_rootbuilding_permissions_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<building_permissions_stream_cursor_input>>;
  where?: InputMaybe<building_permissions_bool_exp>;
};

export type subscription_rootbuilding_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<building_stream_cursor_input>>;
  where?: InputMaybe<building_bool_exp>;
};

export type subscription_rootbuilding_subsidyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_subsidy_order_by>>;
  where?: InputMaybe<building_subsidy_bool_exp>;
};

export type subscription_rootbuilding_valuationArgs = {
  distinct_on?: InputMaybe<Array<building_valuation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_valuation_order_by>>;
  where?: InputMaybe<building_valuation_bool_exp>;
};

export type subscription_rootbuilding_valuation_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootbuilding_valuation_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<building_valuation_stream_cursor_input>>;
  where?: InputMaybe<building_valuation_bool_exp>;
};

export type subscription_rootbuilding_with_district_heating_statusArgs = {
  distinct_on?: InputMaybe<Array<building_with_district_heating_status_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_with_district_heating_status_order_by>>;
  where?: InputMaybe<building_with_district_heating_status_bool_exp>;
};

export type subscription_rootbuilding_with_district_heating_status_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<building_with_district_heating_status_stream_cursor_input>>;
  where?: InputMaybe<building_with_district_heating_status_bool_exp>;
};

export type subscription_rootbulk_actionArgs = {
  distinct_on?: InputMaybe<Array<bulk_action_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_action_order_by>>;
  where?: InputMaybe<bulk_action_bool_exp>;
};

export type subscription_rootbulk_action_aggregateArgs = {
  distinct_on?: InputMaybe<Array<bulk_action_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_action_order_by>>;
  where?: InputMaybe<bulk_action_bool_exp>;
};

export type subscription_rootbulk_action_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootbulk_action_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<bulk_action_stream_cursor_input>>;
  where?: InputMaybe<bulk_action_bool_exp>;
};

export type subscription_rootbulk_action_summaryArgs = {
  distinct_on?: InputMaybe<Array<bulk_action_summary_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_action_summary_order_by>>;
  where?: InputMaybe<bulk_action_summary_bool_exp>;
};

export type subscription_rootbulk_action_summary_aggregateArgs = {
  distinct_on?: InputMaybe<Array<bulk_action_summary_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_action_summary_order_by>>;
  where?: InputMaybe<bulk_action_summary_bool_exp>;
};

export type subscription_rootbulk_action_summary_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<bulk_action_summary_stream_cursor_input>>;
  where?: InputMaybe<bulk_action_summary_bool_exp>;
};

export type subscription_rootbulk_actions_overviewArgs = {
  distinct_on?: InputMaybe<Array<bulk_actions_overview_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_actions_overview_order_by>>;
  where?: InputMaybe<bulk_actions_overview_bool_exp>;
};

export type subscription_rootbulk_actions_overview_aggregateArgs = {
  distinct_on?: InputMaybe<Array<bulk_actions_overview_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<bulk_actions_overview_order_by>>;
  where?: InputMaybe<bulk_actions_overview_bool_exp>;
};

export type subscription_rootbulk_actions_overview_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<bulk_actions_overview_stream_cursor_input>>;
  where?: InputMaybe<bulk_actions_overview_bool_exp>;
};

export type subscription_rootcbi_addressArgs = {
  distinct_on?: InputMaybe<Array<cbi_address_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_address_order_by>>;
  where?: InputMaybe<cbi_address_bool_exp>;
};

export type subscription_rootcbi_address_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_address_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_address_order_by>>;
  where?: InputMaybe<cbi_address_bool_exp>;
};

export type subscription_rootcbi_address_assignmentArgs = {
  distinct_on?: InputMaybe<Array<cbi_address_assignment_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_address_assignment_order_by>>;
  where?: InputMaybe<cbi_address_assignment_bool_exp>;
};

export type subscription_rootcbi_address_assignment_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_address_assignment_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_address_assignment_order_by>>;
  where?: InputMaybe<cbi_address_assignment_bool_exp>;
};

export type subscription_rootcbi_address_assignment_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_address_assignment_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_address_assignment_stream_cursor_input>>;
  where?: InputMaybe<cbi_address_assignment_bool_exp>;
};

export type subscription_rootcbi_address_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_address_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_address_stream_cursor_input>>;
  where?: InputMaybe<cbi_address_bool_exp>;
};

export type subscription_rootcbi_billable_eventArgs = {
  distinct_on?: InputMaybe<Array<cbi_billable_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billable_event_order_by>>;
  where?: InputMaybe<cbi_billable_event_bool_exp>;
};

export type subscription_rootcbi_billable_event_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_billable_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billable_event_order_by>>;
  where?: InputMaybe<cbi_billable_event_bool_exp>;
};

export type subscription_rootcbi_billable_event_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_billable_event_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_billable_event_stream_cursor_input>>;
  where?: InputMaybe<cbi_billable_event_bool_exp>;
};

export type subscription_rootcbi_billing_increment_eventArgs = {
  distinct_on?: InputMaybe<Array<cbi_billing_increment_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billing_increment_event_order_by>>;
  where?: InputMaybe<cbi_billing_increment_event_bool_exp>;
};

export type subscription_rootcbi_billing_increment_event_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_billing_increment_event_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billing_increment_event_order_by>>;
  where?: InputMaybe<cbi_billing_increment_event_bool_exp>;
};

export type subscription_rootcbi_billing_increment_event_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_billing_increment_event_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_billing_increment_event_stream_cursor_input>>;
  where?: InputMaybe<cbi_billing_increment_event_bool_exp>;
};

export type subscription_rootcbi_billing_periodArgs = {
  distinct_on?: InputMaybe<Array<cbi_billing_period_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billing_period_order_by>>;
  where?: InputMaybe<cbi_billing_period_bool_exp>;
};

export type subscription_rootcbi_billing_period_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_billing_period_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_billing_period_order_by>>;
  where?: InputMaybe<cbi_billing_period_bool_exp>;
};

export type subscription_rootcbi_billing_period_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_billing_period_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_billing_period_stream_cursor_input>>;
  where?: InputMaybe<cbi_billing_period_bool_exp>;
};

export type subscription_rootcbi_consumption_lineArgs = {
  distinct_on?: InputMaybe<Array<cbi_consumption_line_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_consumption_line_order_by>>;
  where?: InputMaybe<cbi_consumption_line_bool_exp>;
};

export type subscription_rootcbi_consumption_line_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_consumption_line_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_consumption_line_order_by>>;
  where?: InputMaybe<cbi_consumption_line_bool_exp>;
};

export type subscription_rootcbi_consumption_line_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_consumption_line_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_consumption_line_stream_cursor_input>>;
  where?: InputMaybe<cbi_consumption_line_bool_exp>;
};

export type subscription_rootcbi_emailArgs = {
  distinct_on?: InputMaybe<Array<cbi_email_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_email_order_by>>;
  where?: InputMaybe<cbi_email_bool_exp>;
};

export type subscription_rootcbi_email_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_email_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_email_stream_cursor_input>>;
  where?: InputMaybe<cbi_email_bool_exp>;
};

export type subscription_rootcbi_exportArgs = {
  distinct_on?: InputMaybe<Array<cbi_export_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_export_order_by>>;
  where?: InputMaybe<cbi_export_bool_exp>;
};

export type subscription_rootcbi_export_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_export_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_export_order_by>>;
  where?: InputMaybe<cbi_export_bool_exp>;
};

export type subscription_rootcbi_export_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_export_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_export_stream_cursor_input>>;
  where?: InputMaybe<cbi_export_bool_exp>;
};

export type subscription_rootcbi_inboxArgs = {
  distinct_on?: InputMaybe<Array<cbi_inbox_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_inbox_order_by>>;
  where?: InputMaybe<cbi_inbox_bool_exp>;
};

export type subscription_rootcbi_inbox_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_inbox_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_inbox_stream_cursor_input>>;
  where?: InputMaybe<cbi_inbox_bool_exp>;
};

export type subscription_rootcbi_invoiceArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_order_by>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

export type subscription_rootcbi_invoice_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_order_by>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

export type subscription_rootcbi_invoice_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_invoice_snapshotArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_snapshot_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_snapshot_order_by>>;
  where?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
};

export type subscription_rootcbi_invoice_snapshot_aggregateArgs = {
  distinct_on?: InputMaybe<Array<cbi_invoice_snapshot_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_invoice_snapshot_order_by>>;
  where?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
};

export type subscription_rootcbi_invoice_snapshot_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_invoice_snapshot_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_invoice_snapshot_stream_cursor_input>>;
  where?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
};

export type subscription_rootcbi_invoice_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_invoice_stream_cursor_input>>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
};

export type subscription_rootcbi_potential_building_matchArgs = {
  distinct_on?: InputMaybe<Array<cbi_potential_building_match_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cbi_potential_building_match_order_by>>;
  where?: InputMaybe<cbi_potential_building_match_bool_exp>;
};

export type subscription_rootcbi_potential_building_match_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcbi_potential_building_match_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cbi_potential_building_match_stream_cursor_input>>;
  where?: InputMaybe<cbi_potential_building_match_bool_exp>;
};

export type subscription_rootcertificateArgs = {
  distinct_on?: InputMaybe<Array<certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<certificate_order_by>>;
  where?: InputMaybe<certificate_bool_exp>;
};

export type subscription_rootcertificate_aggregateArgs = {
  distinct_on?: InputMaybe<Array<certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<certificate_order_by>>;
  where?: InputMaybe<certificate_bool_exp>;
};

export type subscription_rootcertificate_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcertificate_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<certificate_stream_cursor_input>>;
  where?: InputMaybe<certificate_bool_exp>;
};

export type subscription_rootclimate_riskArgs = {
  distinct_on?: InputMaybe<Array<climate_risk_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_order_by>>;
  where?: InputMaybe<climate_risk_bool_exp>;
};

export type subscription_rootclimate_risk_aggregateArgs = {
  distinct_on?: InputMaybe<Array<climate_risk_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_order_by>>;
  where?: InputMaybe<climate_risk_bool_exp>;
};

export type subscription_rootclimate_risk_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootclimate_risk_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<climate_risk_stream_cursor_input>>;
  where?: InputMaybe<climate_risk_bool_exp>;
};

export type subscription_rootclimate_risk_v2Args = {
  distinct_on?: InputMaybe<Array<climate_risk_v2_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_v2_order_by>>;
  where?: InputMaybe<climate_risk_v2_bool_exp>;
};

export type subscription_rootclimate_risk_v2_aggregateArgs = {
  distinct_on?: InputMaybe<Array<climate_risk_v2_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<climate_risk_v2_order_by>>;
  where?: InputMaybe<climate_risk_v2_bool_exp>;
};

export type subscription_rootclimate_risk_v2_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootclimate_risk_v2_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<climate_risk_v2_stream_cursor_input>>;
  where?: InputMaybe<climate_risk_v2_bool_exp>;
};

export type subscription_rootconsumptionArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

export type subscription_rootconsumption_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_order_by>>;
  where?: InputMaybe<consumption_bool_exp>;
};

export type subscription_rootconsumption_areaArgs = {
  distinct_on?: InputMaybe<Array<consumption_area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_area_order_by>>;
  where?: InputMaybe<consumption_area_bool_exp>;
};

export type subscription_rootconsumption_area_by_pkArgs = {
  area_id: Scalars['Int']['input'];
  building_id: Scalars['Int']['input'];
  consumption_id: Scalars['Int']['input'];
};

export type subscription_rootconsumption_area_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<consumption_area_stream_cursor_input>>;
  where?: InputMaybe<consumption_area_bool_exp>;
};

export type subscription_rootconsumption_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootconsumption_draftArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_order_by>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

export type subscription_rootconsumption_draft_aggregateArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_order_by>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

export type subscription_rootconsumption_draft_areaArgs = {
  distinct_on?: InputMaybe<Array<consumption_draft_area_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_draft_area_order_by>>;
  where?: InputMaybe<consumption_draft_area_bool_exp>;
};

export type subscription_rootconsumption_draft_area_by_pkArgs = {
  area_id: Scalars['Int']['input'];
  building_id: Scalars['Int']['input'];
  consumption_draft_id: Scalars['Int']['input'];
};

export type subscription_rootconsumption_draft_area_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<consumption_draft_area_stream_cursor_input>>;
  where?: InputMaybe<consumption_draft_area_bool_exp>;
};

export type subscription_rootconsumption_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootconsumption_draft_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<consumption_draft_stream_cursor_input>>;
  where?: InputMaybe<consumption_draft_bool_exp>;
};

export type subscription_rootconsumption_frequency_typeArgs = {
  distinct_on?: InputMaybe<Array<consumption_frequency_type_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_frequency_type_order_by>>;
  where?: InputMaybe<consumption_frequency_type_bool_exp>;
};

export type subscription_rootconsumption_frequency_type_by_pkArgs = {
  id: Scalars['String']['input'];
};

export type subscription_rootconsumption_frequency_type_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<consumption_frequency_type_stream_cursor_input>>;
  where?: InputMaybe<consumption_frequency_type_bool_exp>;
};

export type subscription_rootconsumption_invoiceArgs = {
  distinct_on?: InputMaybe<Array<consumption_invoice_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_invoice_order_by>>;
  where?: InputMaybe<consumption_invoice_bool_exp>;
};

export type subscription_rootconsumption_invoice_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootconsumption_invoice_draftArgs = {
  distinct_on?: InputMaybe<Array<consumption_invoice_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_invoice_draft_order_by>>;
  where?: InputMaybe<consumption_invoice_draft_bool_exp>;
};

export type subscription_rootconsumption_invoice_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootconsumption_invoice_draft_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<consumption_invoice_draft_stream_cursor_input>>;
  where?: InputMaybe<consumption_invoice_draft_bool_exp>;
};

export type subscription_rootconsumption_invoice_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<consumption_invoice_stream_cursor_input>>;
  where?: InputMaybe<consumption_invoice_bool_exp>;
};

export type subscription_rootconsumption_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<consumption_stream_cursor_input>>;
  where?: InputMaybe<consumption_bool_exp>;
};

export type subscription_rootconsumption_waste_detailsArgs = {
  distinct_on?: InputMaybe<Array<consumption_waste_details_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_waste_details_order_by>>;
  where?: InputMaybe<consumption_waste_details_bool_exp>;
};

export type subscription_rootconsumption_waste_details_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootconsumption_waste_details_draftArgs = {
  distinct_on?: InputMaybe<Array<consumption_waste_details_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<consumption_waste_details_draft_order_by>>;
  where?: InputMaybe<consumption_waste_details_draft_bool_exp>;
};

export type subscription_rootconsumption_waste_details_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootconsumption_waste_details_draft_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<consumption_waste_details_draft_stream_cursor_input>>;
  where?: InputMaybe<consumption_waste_details_draft_bool_exp>;
};

export type subscription_rootconsumption_waste_details_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<consumption_waste_details_stream_cursor_input>>;
  where?: InputMaybe<consumption_waste_details_bool_exp>;
};

export type subscription_rootcost_versionArgs = {
  distinct_on?: InputMaybe<Array<cost_version_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<cost_version_order_by>>;
  where?: InputMaybe<cost_version_bool_exp>;
};

export type subscription_rootcost_version_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcost_version_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<cost_version_stream_cursor_input>>;
  where?: InputMaybe<cost_version_bool_exp>;
};

export type subscription_rootcustom_fieldArgs = {
  distinct_on?: InputMaybe<Array<custom_field_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<custom_field_order_by>>;
  where?: InputMaybe<custom_field_bool_exp>;
};

export type subscription_rootcustom_field_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootcustom_field_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<custom_field_stream_cursor_input>>;
  where?: InputMaybe<custom_field_bool_exp>;
};

export type subscription_rootdanger_action_plan_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rooteconomic_unitArgs = {
  distinct_on?: InputMaybe<Array<economic_unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<economic_unit_order_by>>;
  where?: InputMaybe<economic_unit_bool_exp>;
};

export type subscription_rooteconomic_unit_aggregateArgs = {
  distinct_on?: InputMaybe<Array<economic_unit_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<economic_unit_order_by>>;
  where?: InputMaybe<economic_unit_bool_exp>;
};

export type subscription_rooteconomic_unit_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rooteconomic_unit_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<economic_unit_stream_cursor_input>>;
  where?: InputMaybe<economic_unit_bool_exp>;
};

export type subscription_rootemission_certificateArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_order_by>>;
  where?: InputMaybe<emission_certificate_bool_exp>;
};

export type subscription_rootemission_certificate_aggregateArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_order_by>>;
  where?: InputMaybe<emission_certificate_bool_exp>;
};

export type subscription_rootemission_certificate_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootemission_certificate_draftArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_draft_order_by>>;
  where?: InputMaybe<emission_certificate_draft_bool_exp>;
};

export type subscription_rootemission_certificate_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootemission_certificate_draft_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<emission_certificate_draft_stream_cursor_input>>;
  where?: InputMaybe<emission_certificate_draft_bool_exp>;
};

export type subscription_rootemission_certificate_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<emission_certificate_stream_cursor_input>>;
  where?: InputMaybe<emission_certificate_bool_exp>;
};

export type subscription_rootemission_certificate_value_pathArgs = {
  distinct_on?: InputMaybe<Array<emission_certificate_value_path_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<emission_certificate_value_path_order_by>>;
  where?: InputMaybe<emission_certificate_value_path_bool_exp>;
};

export type subscription_rootemission_certificate_value_path_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootemission_certificate_value_path_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<emission_certificate_value_path_stream_cursor_input>>;
  where?: InputMaybe<emission_certificate_value_path_bool_exp>;
};

export type subscription_rootenergy_certificateArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_order_by>>;
  where?: InputMaybe<energy_certificate_bool_exp>;
};

export type subscription_rootenergy_certificate_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenergy_certificate_consumerArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_consumer_order_by>>;
  where?: InputMaybe<energy_certificate_consumer_bool_exp>;
};

export type subscription_rootenergy_certificate_consumer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenergy_certificate_consumer_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<energy_certificate_consumer_stream_cursor_input>>;
  where?: InputMaybe<energy_certificate_consumer_bool_exp>;
};

export type subscription_rootenergy_certificate_draftArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_draft_order_by>>;
  where?: InputMaybe<energy_certificate_draft_bool_exp>;
};

export type subscription_rootenergy_certificate_draft_aggregateArgs = {
  distinct_on?: InputMaybe<Array<energy_certificate_draft_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_certificate_draft_order_by>>;
  where?: InputMaybe<energy_certificate_draft_bool_exp>;
};

export type subscription_rootenergy_certificate_draft_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenergy_certificate_draft_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<energy_certificate_draft_stream_cursor_input>>;
  where?: InputMaybe<energy_certificate_draft_bool_exp>;
};

export type subscription_rootenergy_certificate_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<energy_certificate_stream_cursor_input>>;
  where?: InputMaybe<energy_certificate_bool_exp>;
};

export type subscription_rootenergy_consumerArgs = {
  distinct_on?: InputMaybe<Array<energy_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_consumer_order_by>>;
  where?: InputMaybe<energy_consumer_bool_exp>;
};

export type subscription_rootenergy_consumer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenergy_consumer_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<energy_consumer_stream_cursor_input>>;
  where?: InputMaybe<energy_consumer_bool_exp>;
};

export type subscription_rootenergy_distributionArgs = {
  distinct_on?: InputMaybe<Array<energy_distribution_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_distribution_order_by>>;
  where?: InputMaybe<energy_distribution_bool_exp>;
};

export type subscription_rootenergy_distribution_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenergy_distribution_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<energy_distribution_stream_cursor_input>>;
  where?: InputMaybe<energy_distribution_bool_exp>;
};

export type subscription_rootenergy_producerArgs = {
  distinct_on?: InputMaybe<Array<energy_producer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_producer_order_by>>;
  where?: InputMaybe<energy_producer_bool_exp>;
};

export type subscription_rootenergy_producer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenergy_producer_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<energy_producer_stream_cursor_input>>;
  where?: InputMaybe<energy_producer_bool_exp>;
};

export type subscription_rootenergy_storageArgs = {
  distinct_on?: InputMaybe<Array<energy_storage_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_storage_order_by>>;
  where?: InputMaybe<energy_storage_bool_exp>;
};

export type subscription_rootenergy_storage_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenergy_storage_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<energy_storage_stream_cursor_input>>;
  where?: InputMaybe<energy_storage_bool_exp>;
};

export type subscription_rootenergy_systemArgs = {
  distinct_on?: InputMaybe<Array<energy_system_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_order_by>>;
  where?: InputMaybe<energy_system_bool_exp>;
};

export type subscription_rootenergy_system_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenergy_system_consumer_routeArgs = {
  distinct_on?: InputMaybe<Array<energy_system_consumer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_consumer_route_order_by>>;
  where?: InputMaybe<energy_system_consumer_route_bool_exp>;
};

export type subscription_rootenergy_system_consumer_route_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenergy_system_consumer_route_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<energy_system_consumer_route_stream_cursor_input>>;
  where?: InputMaybe<energy_system_consumer_route_bool_exp>;
};

export type subscription_rootenergy_system_producer_routeArgs = {
  distinct_on?: InputMaybe<Array<energy_system_producer_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<energy_system_producer_route_order_by>>;
  where?: InputMaybe<energy_system_producer_route_bool_exp>;
};

export type subscription_rootenergy_system_producer_route_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenergy_system_producer_route_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<energy_system_producer_route_stream_cursor_input>>;
  where?: InputMaybe<energy_system_producer_route_bool_exp>;
};

export type subscription_rootenergy_system_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<energy_system_stream_cursor_input>>;
  where?: InputMaybe<energy_system_bool_exp>;
};

export type subscription_rootenvelopeArgs = {
  distinct_on?: InputMaybe<Array<envelope_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<envelope_order_by>>;
  where?: InputMaybe<envelope_bool_exp>;
};

export type subscription_rootenvelope_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootenvelope_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<envelope_stream_cursor_input>>;
  where?: InputMaybe<envelope_bool_exp>;
};

export type subscription_rootexport_templateArgs = {
  distinct_on?: InputMaybe<Array<export_template_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<export_template_order_by>>;
  where?: InputMaybe<export_template_bool_exp>;
};

export type subscription_rootexport_template_aggregateArgs = {
  distinct_on?: InputMaybe<Array<export_template_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<export_template_order_by>>;
  where?: InputMaybe<export_template_bool_exp>;
};

export type subscription_rootexport_template_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootexport_template_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<export_template_stream_cursor_input>>;
  where?: InputMaybe<export_template_bool_exp>;
};

export type subscription_rootfileArgs = {
  distinct_on?: InputMaybe<Array<file_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<file_order_by>>;
  where?: InputMaybe<file_bool_exp>;
};

export type subscription_rootfile_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootfile_chunkArgs = {
  distinct_on?: InputMaybe<Array<file_chunk_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<file_chunk_order_by>>;
  where?: InputMaybe<file_chunk_bool_exp>;
};

export type subscription_rootfile_chunk_by_pkArgs = {
  id: Scalars['uuid']['input'];
};

export type subscription_rootfile_chunk_file_linkArgs = {
  distinct_on?: InputMaybe<Array<file_chunk_file_link_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<file_chunk_file_link_order_by>>;
  where?: InputMaybe<file_chunk_file_link_bool_exp>;
};

export type subscription_rootfile_chunk_file_link_by_pkArgs = {
  chunk_id: Scalars['uuid']['input'];
};

export type subscription_rootfile_chunk_file_link_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<file_chunk_file_link_stream_cursor_input>>;
  where?: InputMaybe<file_chunk_file_link_bool_exp>;
};

export type subscription_rootfile_chunk_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<file_chunk_stream_cursor_input>>;
  where?: InputMaybe<file_chunk_bool_exp>;
};

export type subscription_rootfile_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<file_stream_cursor_input>>;
  where?: InputMaybe<file_bool_exp>;
};

export type subscription_rootfolderArgs = {
  distinct_on?: InputMaybe<Array<folder_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<folder_order_by>>;
  where?: InputMaybe<folder_bool_exp>;
};

export type subscription_rootfolder_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootfolder_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<folder_stream_cursor_input>>;
  where?: InputMaybe<folder_bool_exp>;
};

export type subscription_rootfolder_typeArgs = {
  distinct_on?: InputMaybe<Array<folder_type_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<folder_type_order_by>>;
  where?: InputMaybe<folder_type_bool_exp>;
};

export type subscription_rootfolder_type_by_pkArgs = {
  id: Scalars['String']['input'];
};

export type subscription_rootfolder_type_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<folder_type_stream_cursor_input>>;
  where?: InputMaybe<folder_type_bool_exp>;
};

export type subscription_rootinactive_buildingsArgs = {
  distinct_on?: InputMaybe<Array<inactive_buildings_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<inactive_buildings_order_by>>;
  where?: InputMaybe<inactive_buildings_bool_exp>;
};

export type subscription_rootinactive_buildings_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<inactive_buildings_stream_cursor_input>>;
  where?: InputMaybe<inactive_buildings_bool_exp>;
};

export type subscription_rootnotificationArgs = {
  distinct_on?: InputMaybe<Array<notification_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<notification_order_by>>;
  where?: InputMaybe<notification_bool_exp>;
};

export type subscription_rootnotification_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootnotification_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<notification_stream_cursor_input>>;
  where?: InputMaybe<notification_bool_exp>;
};

export type subscription_rootnotification_templateArgs = {
  distinct_on?: InputMaybe<Array<notification_template_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<notification_template_order_by>>;
  where?: InputMaybe<notification_template_bool_exp>;
};

export type subscription_rootnotification_template_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootnotification_template_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<notification_template_stream_cursor_input>>;
  where?: InputMaybe<notification_template_bool_exp>;
};

export type subscription_rootorgArgs = {
  distinct_on?: InputMaybe<Array<org_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<org_order_by>>;
  where?: InputMaybe<org_bool_exp>;
};

export type subscription_rootorg_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootorg_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<org_stream_cursor_input>>;
  where?: InputMaybe<org_bool_exp>;
};

export type subscription_rootportfolioArgs = {
  distinct_on?: InputMaybe<Array<portfolio_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<portfolio_order_by>>;
  where?: InputMaybe<portfolio_bool_exp>;
};

export type subscription_rootportfolio_aggregateArgs = {
  distinct_on?: InputMaybe<Array<portfolio_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<portfolio_order_by>>;
  where?: InputMaybe<portfolio_bool_exp>;
};

export type subscription_rootportfolio_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootportfolio_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<portfolio_stream_cursor_input>>;
  where?: InputMaybe<portfolio_bool_exp>;
};

export type subscription_rootrenovationArgs = {
  distinct_on?: InputMaybe<Array<renovation_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_order_by>>;
  where?: InputMaybe<renovation_bool_exp>;
};

export type subscription_rootrenovation_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootrenovation_energy_consumerArgs = {
  distinct_on?: InputMaybe<Array<renovation_energy_consumer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_energy_consumer_order_by>>;
  where?: InputMaybe<renovation_energy_consumer_bool_exp>;
};

export type subscription_rootrenovation_energy_consumer_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<renovation_energy_consumer_stream_cursor_input>>;
  where?: InputMaybe<renovation_energy_consumer_bool_exp>;
};

export type subscription_rootrenovation_energy_producerArgs = {
  distinct_on?: InputMaybe<Array<renovation_energy_producer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_energy_producer_order_by>>;
  where?: InputMaybe<renovation_energy_producer_bool_exp>;
};

export type subscription_rootrenovation_energy_producer_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<renovation_energy_producer_stream_cursor_input>>;
  where?: InputMaybe<renovation_energy_producer_bool_exp>;
};

export type subscription_rootrenovation_energy_system_routeArgs = {
  distinct_on?: InputMaybe<Array<renovation_energy_system_route_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_energy_system_route_order_by>>;
  where?: InputMaybe<renovation_energy_system_route_bool_exp>;
};

export type subscription_rootrenovation_energy_system_route_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<renovation_energy_system_route_stream_cursor_input>>;
  where?: InputMaybe<renovation_energy_system_route_bool_exp>;
};

export type subscription_rootrenovation_envelopeArgs = {
  distinct_on?: InputMaybe<Array<renovation_envelope_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<renovation_envelope_order_by>>;
  where?: InputMaybe<renovation_envelope_bool_exp>;
};

export type subscription_rootrenovation_envelope_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<renovation_envelope_stream_cursor_input>>;
  where?: InputMaybe<renovation_envelope_bool_exp>;
};

export type subscription_rootrenovation_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<renovation_stream_cursor_input>>;
  where?: InputMaybe<renovation_bool_exp>;
};

export type subscription_rootreportArgs = {
  distinct_on?: InputMaybe<Array<report_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_order_by>>;
  where?: InputMaybe<report_bool_exp>;
};

export type subscription_rootreport_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_order_by>>;
  where?: InputMaybe<report_bool_exp>;
};

export type subscription_rootreport_answerArgs = {
  distinct_on?: InputMaybe<Array<report_answer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_order_by>>;
  where?: InputMaybe<report_answer_bool_exp>;
};

export type subscription_rootreport_answer_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_answer_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_order_by>>;
  where?: InputMaybe<report_answer_bool_exp>;
};

export type subscription_rootreport_answer_autofill_optionArgs = {
  distinct_on?: InputMaybe<Array<report_answer_autofill_option_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_autofill_option_order_by>>;
  where?: InputMaybe<report_answer_autofill_option_bool_exp>;
};

export type subscription_rootreport_answer_autofill_option_by_pkArgs = {
  report_answer_id: Scalars['Int']['input'];
  report_template_question_option_id: Scalars['Int']['input'];
};

export type subscription_rootreport_answer_autofill_option_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_answer_autofill_option_stream_cursor_input>>;
  where?: InputMaybe<report_answer_autofill_option_bool_exp>;
};

export type subscription_rootreport_answer_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_answer_chosen_optionArgs = {
  distinct_on?: InputMaybe<Array<report_answer_chosen_option_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_answer_chosen_option_order_by>>;
  where?: InputMaybe<report_answer_chosen_option_bool_exp>;
};

export type subscription_rootreport_answer_chosen_option_by_pkArgs = {
  report_answer_id: Scalars['Int']['input'];
  report_template_question_option_id: Scalars['Int']['input'];
};

export type subscription_rootreport_answer_chosen_option_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_answer_chosen_option_stream_cursor_input>>;
  where?: InputMaybe<report_answer_chosen_option_bool_exp>;
};

export type subscription_rootreport_answer_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_answer_stream_cursor_input>>;
  where?: InputMaybe<report_answer_bool_exp>;
};

export type subscription_rootreport_buildingArgs = {
  distinct_on?: InputMaybe<Array<report_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_order_by>>;
  where?: InputMaybe<report_building_bool_exp>;
};

export type subscription_rootreport_building_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_order_by>>;
  where?: InputMaybe<report_building_bool_exp>;
};

export type subscription_rootreport_building_by_pkArgs = {
  building_id: Scalars['Int']['input'];
  report_id: Scalars['Int']['input'];
};

export type subscription_rootreport_building_detailsArgs = {
  distinct_on?: InputMaybe<Array<report_building_details_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_details_order_by>>;
  where?: InputMaybe<report_building_details_bool_exp>;
};

export type subscription_rootreport_building_details_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_building_details_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_building_details_order_by>>;
  where?: InputMaybe<report_building_details_bool_exp>;
};

export type subscription_rootreport_building_details_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_building_details_stream_cursor_input>>;
  where?: InputMaybe<report_building_details_bool_exp>;
};

export type subscription_rootreport_building_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_building_stream_cursor_input>>;
  where?: InputMaybe<report_building_bool_exp>;
};

export type subscription_rootreport_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_evidenceArgs = {
  distinct_on?: InputMaybe<Array<report_evidence_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_evidence_order_by>>;
  where?: InputMaybe<report_evidence_bool_exp>;
};

export type subscription_rootreport_evidence_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_evidence_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_evidence_stream_cursor_input>>;
  where?: InputMaybe<report_evidence_bool_exp>;
};

export type subscription_rootreport_overviewArgs = {
  distinct_on?: InputMaybe<Array<report_overview_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_overview_order_by>>;
  where?: InputMaybe<report_overview_bool_exp>;
};

export type subscription_rootreport_overview_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_overview_stream_cursor_input>>;
  where?: InputMaybe<report_overview_bool_exp>;
};

export type subscription_rootreport_question_evidenceArgs = {
  distinct_on?: InputMaybe<Array<report_question_evidence_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_question_evidence_order_by>>;
  where?: InputMaybe<report_question_evidence_bool_exp>;
};

export type subscription_rootreport_question_evidence_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_question_evidence_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_question_evidence_stream_cursor_input>>;
  where?: InputMaybe<report_question_evidence_bool_exp>;
};

export type subscription_rootreport_scoreArgs = {
  distinct_on?: InputMaybe<Array<report_score_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_score_order_by>>;
  where?: InputMaybe<report_score_bool_exp>;
};

export type subscription_rootreport_score_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_score_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_score_stream_cursor_input>>;
  where?: InputMaybe<report_score_bool_exp>;
};

export type subscription_rootreport_section_progressArgs = {
  distinct_on?: InputMaybe<Array<report_section_progress_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_section_progress_order_by>>;
  where?: InputMaybe<report_section_progress_bool_exp>;
};

export type subscription_rootreport_section_progress_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_section_progress_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_section_progress_stream_cursor_input>>;
  where?: InputMaybe<report_section_progress_bool_exp>;
};

export type subscription_rootreport_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_stream_cursor_input>>;
  where?: InputMaybe<report_bool_exp>;
};

export type subscription_rootreport_templateArgs = {
  distinct_on?: InputMaybe<Array<report_template_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_order_by>>;
  where?: InputMaybe<report_template_bool_exp>;
};

export type subscription_rootreport_template_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_template_questionArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_order_by>>;
  where?: InputMaybe<report_template_question_bool_exp>;
};

export type subscription_rootreport_template_question_aggregateArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_order_by>>;
  where?: InputMaybe<report_template_question_bool_exp>;
};

export type subscription_rootreport_template_question_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_template_question_optionArgs = {
  distinct_on?: InputMaybe<Array<report_template_question_option_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_question_option_order_by>>;
  where?: InputMaybe<report_template_question_option_bool_exp>;
};

export type subscription_rootreport_template_question_option_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_template_question_option_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_template_question_option_stream_cursor_input>>;
  where?: InputMaybe<report_template_question_option_bool_exp>;
};

export type subscription_rootreport_template_question_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_template_question_stream_cursor_input>>;
  where?: InputMaybe<report_template_question_bool_exp>;
};

export type subscription_rootreport_template_scoreArgs = {
  distinct_on?: InputMaybe<Array<report_template_score_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_score_order_by>>;
  where?: InputMaybe<report_template_score_bool_exp>;
};

export type subscription_rootreport_template_score_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_template_score_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_template_score_stream_cursor_input>>;
  where?: InputMaybe<report_template_score_bool_exp>;
};

export type subscription_rootreport_template_sectionArgs = {
  distinct_on?: InputMaybe<Array<report_template_section_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<report_template_section_order_by>>;
  where?: InputMaybe<report_template_section_bool_exp>;
};

export type subscription_rootreport_template_section_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootreport_template_section_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_template_section_stream_cursor_input>>;
  where?: InputMaybe<report_template_section_bool_exp>;
};

export type subscription_rootreport_template_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<report_template_stream_cursor_input>>;
  where?: InputMaybe<report_template_bool_exp>;
};

export type subscription_rootscenarioArgs = {
  distinct_on?: InputMaybe<Array<scenario_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_order_by>>;
  where?: InputMaybe<scenario_bool_exp>;
};

export type subscription_rootscenario_aggregateArgs = {
  distinct_on?: InputMaybe<Array<scenario_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_order_by>>;
  where?: InputMaybe<scenario_bool_exp>;
};

export type subscription_rootscenario_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootscenario_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<scenario_stream_cursor_input>>;
  where?: InputMaybe<scenario_bool_exp>;
};

export type subscription_rootscenario_versionArgs = {
  distinct_on?: InputMaybe<Array<scenario_version_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_version_order_by>>;
  where?: InputMaybe<scenario_version_bool_exp>;
};

export type subscription_rootscenario_version_aggregateArgs = {
  distinct_on?: InputMaybe<Array<scenario_version_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<scenario_version_order_by>>;
  where?: InputMaybe<scenario_version_bool_exp>;
};

export type subscription_rootscenario_version_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootscenario_version_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<scenario_version_stream_cursor_input>>;
  where?: InputMaybe<scenario_version_bool_exp>;
};

export type subscription_rootsmart_meterArgs = {
  distinct_on?: InputMaybe<Array<smart_meter_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<smart_meter_order_by>>;
  where?: InputMaybe<smart_meter_bool_exp>;
};

export type subscription_rootsmart_meter_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootsmart_meter_integrationArgs = {
  distinct_on?: InputMaybe<Array<smart_meter_integration_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<smart_meter_integration_order_by>>;
  where?: InputMaybe<smart_meter_integration_bool_exp>;
};

export type subscription_rootsmart_meter_integration_buildingArgs = {
  distinct_on?: InputMaybe<Array<smart_meter_integration_building_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<smart_meter_integration_building_order_by>>;
  where?: InputMaybe<smart_meter_integration_building_bool_exp>;
};

export type subscription_rootsmart_meter_integration_building_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootsmart_meter_integration_building_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smart_meter_integration_building_stream_cursor_input>>;
  where?: InputMaybe<smart_meter_integration_building_bool_exp>;
};

export type subscription_rootsmart_meter_integration_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootsmart_meter_integration_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smart_meter_integration_stream_cursor_input>>;
  where?: InputMaybe<smart_meter_integration_bool_exp>;
};

export type subscription_rootsmart_meter_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smart_meter_stream_cursor_input>>;
  where?: InputMaybe<smart_meter_bool_exp>;
};

export type subscription_rootsmart_meter_sync_checkpointArgs = {
  distinct_on?: InputMaybe<Array<smart_meter_sync_checkpoint_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<smart_meter_sync_checkpoint_order_by>>;
  where?: InputMaybe<smart_meter_sync_checkpoint_bool_exp>;
};

export type subscription_rootsmart_meter_sync_checkpoint_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootsmart_meter_sync_checkpoint_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<smart_meter_sync_checkpoint_stream_cursor_input>>;
  where?: InputMaybe<smart_meter_sync_checkpoint_bool_exp>;
};

export type subscription_rootsubsidyArgs = {
  distinct_on?: InputMaybe<Array<subsidy_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<subsidy_order_by>>;
  where?: InputMaybe<subsidy_bool_exp>;
};

export type subscription_rootsubsidy_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootsubsidy_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<subsidy_stream_cursor_input>>;
  where?: InputMaybe<subsidy_bool_exp>;
};

export type subscription_rootsubsidy_subsidy_categoryArgs = {
  distinct_on?: InputMaybe<Array<subsidy_subsidy_category_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<subsidy_subsidy_category_order_by>>;
  where?: InputMaybe<subsidy_subsidy_category_bool_exp>;
};

export type subscription_rootsubsidy_subsidy_category_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<subsidy_subsidy_category_stream_cursor_input>>;
  where?: InputMaybe<subsidy_subsidy_category_bool_exp>;
};

export type subscription_rootuserArgs = {
  distinct_on?: InputMaybe<Array<user_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_order_by>>;
  where?: InputMaybe<user_bool_exp>;
};

export type subscription_rootuser_building_permissionArgs = {
  distinct_on?: InputMaybe<Array<user_building_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_building_permission_order_by>>;
  where?: InputMaybe<user_building_permission_bool_exp>;
};

export type subscription_rootuser_building_permission_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootuser_building_permission_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<user_building_permission_stream_cursor_input>>;
  where?: InputMaybe<user_building_permission_bool_exp>;
};

export type subscription_rootuser_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootuser_portfolio_permissionArgs = {
  distinct_on?: InputMaybe<Array<user_portfolio_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_portfolio_permission_order_by>>;
  where?: InputMaybe<user_portfolio_permission_bool_exp>;
};

export type subscription_rootuser_portfolio_permission_aggregateArgs = {
  distinct_on?: InputMaybe<Array<user_portfolio_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_portfolio_permission_order_by>>;
  where?: InputMaybe<user_portfolio_permission_bool_exp>;
};

export type subscription_rootuser_portfolio_permission_by_pkArgs = {
  id: Scalars['Int']['input'];
};

export type subscription_rootuser_portfolio_permission_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<user_portfolio_permission_stream_cursor_input>>;
  where?: InputMaybe<user_portfolio_permission_bool_exp>;
};

export type subscription_rootuser_streamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<user_stream_cursor_input>>;
  where?: InputMaybe<user_bool_exp>;
};

/** A government incentive program (Foerderung) for energy renovations, with provider details and eligibility information. */
export type subsidy = {
  /** An array relationship */
  actions: Array<action_subsidy>;
  /** Human-readable description of the subsidy amount and conditions. */
  amount_description: Scalars['String']['output'];
  /** An array relationship */
  building_subsidies: Array<building_subsidy>;
  /** An array relationship */
  categories: Array<subsidy_subsidy_category>;
  created_at: Scalars['timestamptz']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Name of the organization providing this subsidy (e.g., BAFA, KfW). */
  provider: Scalars['String']['output'];
  /** External identifier assigned by the subsidy provider. */
  provider_id: Scalars['String']['output'];
  /** Timestamp of the last update from the subsidy provider's data source. */
  provider_updated_at: Scalars['timestamptz']['output'];
  /** Geographic scope of the subsidy (federal, state, municipal). */
  region_type: subsidy_region_type_enum;
  title: Scalars['String']['output'];
  /** The type of subsidy instrument (grant, loan, etc.). */
  type: subsidy_type_enum;
  url?: Maybe<Scalars['String']['output']>;
};

/** A government incentive program (Foerderung) for energy renovations, with provider details and eligibility information. */
export type subsidyactionsArgs = {
  distinct_on?: InputMaybe<Array<action_subsidy_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<action_subsidy_order_by>>;
  where?: InputMaybe<action_subsidy_bool_exp>;
};

/** A government incentive program (Foerderung) for energy renovations, with provider details and eligibility information. */
export type subsidybuilding_subsidiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<building_subsidy_order_by>>;
  where?: InputMaybe<building_subsidy_bool_exp>;
};

/** A government incentive program (Foerderung) for energy renovations, with provider details and eligibility information. */
export type subsidycategoriesArgs = {
  distinct_on?: InputMaybe<Array<subsidy_subsidy_category_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<subsidy_subsidy_category_order_by>>;
  where?: InputMaybe<subsidy_subsidy_category_bool_exp>;
};

/** Boolean expression to filter rows from the table "subsidy". All fields are combined with a logical 'AND'. */
export type subsidy_bool_exp = {
  _and?: InputMaybe<Array<subsidy_bool_exp>>;
  _not?: InputMaybe<subsidy_bool_exp>;
  _or?: InputMaybe<Array<subsidy_bool_exp>>;
  actions?: InputMaybe<action_subsidy_bool_exp>;
  amount_description?: InputMaybe<String_comparison_exp>;
  building_subsidies?: InputMaybe<building_subsidy_bool_exp>;
  categories?: InputMaybe<subsidy_subsidy_category_bool_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  provider?: InputMaybe<String_comparison_exp>;
  provider_id?: InputMaybe<String_comparison_exp>;
  provider_updated_at?: InputMaybe<timestamptz_comparison_exp>;
  region_type?: InputMaybe<subsidy_region_type_enum_comparison_exp>;
  title?: InputMaybe<String_comparison_exp>;
  type?: InputMaybe<subsidy_type_enum_comparison_exp>;
  url?: InputMaybe<String_comparison_exp>;
};

export enum subsidy_category_type_enum {
  ENVELOPE_CEILING = 'ENVELOPE_CEILING',
  ENVELOPE_FLOOR = 'ENVELOPE_FLOOR',
  ENVELOPE_ROOF = 'ENVELOPE_ROOF',
  ENVELOPE_UNCLASSIFIED = 'ENVELOPE_UNCLASSIFIED',
  ENVELOPE_WALL = 'ENVELOPE_WALL',
  ENVELOPE_WINDOW = 'ENVELOPE_WINDOW',
  SYSTEMS_HEATING = 'SYSTEMS_HEATING',
  SYSTEMS_PV = 'SYSTEMS_PV',
  SYSTEMS_VENTILATION = 'SYSTEMS_VENTILATION',
}

/** Boolean expression to compare columns of type "subsidy_category_type_enum". All fields are combined with logical 'AND'. */
export type subsidy_category_type_enum_comparison_exp = {
  _eq?: InputMaybe<subsidy_category_type_enum>;
  _in?: InputMaybe<Array<subsidy_category_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<subsidy_category_type_enum>;
  _nin?: InputMaybe<Array<subsidy_category_type_enum>>;
};

/** Ordering options when selecting data from "subsidy". */
export type subsidy_order_by = {
  actions_aggregate?: InputMaybe<action_subsidy_aggregate_order_by>;
  amount_description?: InputMaybe<order_by>;
  building_subsidies_aggregate?: InputMaybe<building_subsidy_aggregate_order_by>;
  categories_aggregate?: InputMaybe<subsidy_subsidy_category_aggregate_order_by>;
  created_at?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  provider?: InputMaybe<order_by>;
  provider_id?: InputMaybe<order_by>;
  provider_updated_at?: InputMaybe<order_by>;
  region_type?: InputMaybe<order_by>;
  title?: InputMaybe<order_by>;
  type?: InputMaybe<order_by>;
  url?: InputMaybe<order_by>;
};

export enum subsidy_region_type_enum {
  FEDERAL = 'FEDERAL',
  LOCAL = 'LOCAL',
  OTHER = 'OTHER',
  STATE = 'STATE',
}

/** Boolean expression to compare columns of type "subsidy_region_type_enum". All fields are combined with logical 'AND'. */
export type subsidy_region_type_enum_comparison_exp = {
  _eq?: InputMaybe<subsidy_region_type_enum>;
  _in?: InputMaybe<Array<subsidy_region_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<subsidy_region_type_enum>;
  _nin?: InputMaybe<Array<subsidy_region_type_enum>>;
};

/** select columns of table "subsidy" */
export enum subsidy_select_column {
  /** column name */
  amount_description = 'amount_description',
  /** column name */
  created_at = 'created_at',
  /** column name */
  email = 'email',
  /** column name */
  id = 'id',
  /** column name */
  provider = 'provider',
  /** column name */
  provider_id = 'provider_id',
  /** column name */
  provider_updated_at = 'provider_updated_at',
  /** column name */
  region_type = 'region_type',
  /** column name */
  title = 'title',
  /** column name */
  type = 'type',
  /** column name */
  url = 'url',
}

/** Streaming cursor of the table "subsidy" */
export type subsidy_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: subsidy_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type subsidy_stream_cursor_value_input = {
  /** Human-readable description of the subsidy amount and conditions. */
  amount_description?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the organization providing this subsidy (e.g., BAFA, KfW). */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** External identifier assigned by the subsidy provider. */
  provider_id?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp of the last update from the subsidy provider's data source. */
  provider_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Geographic scope of the subsidy (federal, state, municipal). */
  region_type?: InputMaybe<subsidy_region_type_enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** The type of subsidy instrument (grant, loan, etc.). */
  type?: InputMaybe<subsidy_type_enum>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Junction table linking subsidies to their applicable renovation categories. */
export type subsidy_subsidy_category = {
  /** An object relationship */
  subsidy: subsidy;
  subsidy_category_type: subsidy_category_type_enum;
};

/** order by aggregate values of table "subsidy_subsidy_category" */
export type subsidy_subsidy_category_aggregate_order_by = {
  count?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "subsidy_subsidy_category". All fields are combined with a logical 'AND'. */
export type subsidy_subsidy_category_bool_exp = {
  _and?: InputMaybe<Array<subsidy_subsidy_category_bool_exp>>;
  _not?: InputMaybe<subsidy_subsidy_category_bool_exp>;
  _or?: InputMaybe<Array<subsidy_subsidy_category_bool_exp>>;
  subsidy?: InputMaybe<subsidy_bool_exp>;
  subsidy_category_type?: InputMaybe<subsidy_category_type_enum_comparison_exp>;
};

/** Ordering options when selecting data from "subsidy_subsidy_category". */
export type subsidy_subsidy_category_order_by = {
  subsidy?: InputMaybe<subsidy_order_by>;
  subsidy_category_type?: InputMaybe<order_by>;
};

/** select columns of table "subsidy_subsidy_category" */
export enum subsidy_subsidy_category_select_column {
  /** column name */
  subsidy_category_type = 'subsidy_category_type',
}

/** Streaming cursor of the table "subsidy_subsidy_category" */
export type subsidy_subsidy_category_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: subsidy_subsidy_category_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type subsidy_subsidy_category_stream_cursor_value_input = {
  subsidy_category_type?: InputMaybe<subsidy_category_type_enum>;
};

export enum subsidy_type_enum {
  BOND = 'BOND',
  GRANT = 'GRANT',
  LOAN = 'LOAN',
}

/** Boolean expression to compare columns of type "subsidy_type_enum". All fields are combined with logical 'AND'. */
export type subsidy_type_enum_comparison_exp = {
  _eq?: InputMaybe<subsidy_type_enum>;
  _in?: InputMaybe<Array<subsidy_type_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<subsidy_type_enum>;
  _nin?: InputMaybe<Array<subsidy_type_enum>>;
};

export enum target_definition_type_enum {
  CO2_INTENSITY = 'CO2_INTENSITY',
  FINAL_ENERGY = 'FINAL_ENERGY',
  PRIMARY_ENERGY = 'PRIMARY_ENERGY',
}

export enum tax_bracket_enum {
  _10_90 = '_10_90',
  _20_80 = '_20_80',
  _30_70 = '_30_70',
  _40_60 = '_40_60',
  _50_50 = '_50_50',
  _60_40 = '_60_40',
  _70_30 = '_70_30',
  _80_20 = '_80_20',
  _90_10 = '_90_10',
  _100_0 = '_100_0',
}

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type timestamp_comparison_exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type timestamptz_comparison_exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export enum type_of_use_enum {
  ADMINISTRATIVE_BUILDING = 'ADMINISTRATIVE_BUILDING',
  CAFETERIA = 'CAFETERIA',
  CENTRAL_SERVICE_BUILDING = 'CENTRAL_SERVICE_BUILDING',
  COLD_WAREHOUSE = 'COLD_WAREHOUSE',
  COMMUNAL_ACCOMMODATION = 'COMMUNAL_ACCOMMODATION',
  DATA_CENTER = 'DATA_CENTER',
  DOCTOR_OFFICE = 'DOCTOR_OFFICE',
  DORM = 'DORM',
  EDUCATION_INSTITUTION = 'EDUCATION_INSTITUTION',
  ELDERLY_DAYCARE_CENTER = 'ELDERLY_DAYCARE_CENTER',
  EVENT_HALL = 'EVENT_HALL',
  EXHIBITION_BUILDING = 'EXHIBITION_BUILDING',
  EXHIBITION_HALL = 'EXHIBITION_HALL',
  FIRE_DEPARTMENT = 'FIRE_DEPARTMENT',
  GYM = 'GYM',
  HOTEL = 'HOTEL',
  LABORATORY_AND_RESEARCH_BUILDING = 'LABORATORY_AND_RESEARCH_BUILDING',
  LECTURE_AND_TEACHING_BUILDING = 'LECTURE_AND_TEACHING_BUILDING',
  LEISURE_AND_COMMUNITY_FACILITY = 'LEISURE_AND_COMMUNITY_FACILITY',
  LIBRARY = 'LIBRARY',
  LOGISTIC_STORAGE_OPERATION_BUILDING = 'LOGISTIC_STORAGE_OPERATION_BUILDING',
  MEDICAL_AND_NURSING_FACILITY = 'MEDICAL_AND_NURSING_FACILITY',
  MFH = 'MFH',
  OUTDOOR_SPORT_FACILITY = 'OUTDOOR_SPORT_FACILITY',
  PARKING_GARAGE = 'PARKING_GARAGE',
  POLICE_STATION = 'POLICE_STATION',
  PRODUCTION_AND_WORKSHOP_BUILDING = 'PRODUCTION_AND_WORKSHOP_BUILDING',
  REHABILITATION_CENTER = 'REHABILITATION_CENTER',
  RESTAURANT = 'RESTAURANT',
  RETAIL_FOOD = 'RETAIL_FOOD',
  RETAIL_NON_FOOD = 'RETAIL_NON_FOOD',
  RIDING_AND_ICE_SPORT_HALL = 'RIDING_AND_ICE_SPORT_HALL',
  SFH = 'SFH',
  SHOPPING_CENTER = 'SHOPPING_CENTER',
  SPORT_AND_LEISURE_BUILDING = 'SPORT_AND_LEISURE_BUILDING',
  TRANSPORT_TERMINAL = 'TRANSPORT_TERMINAL',
  UNIVERSITY_AND_RESEARCH_INSTITUTION = 'UNIVERSITY_AND_RESEARCH_INSTITUTION',
  UTILITY_AND_INFRASTRUCTURE_BUILDING = 'UTILITY_AND_INFRASTRUCTURE_BUILDING',
  UTILITY_SERVICE_BUILDING = 'UTILITY_SERVICE_BUILDING',
  VEHICLE_FLEET_FACILITY = 'VEHICLE_FLEET_FACILITY',
  VEHICLE_SERVICE_AND_INSPECTION_FACILITY = 'VEHICLE_SERVICE_AND_INSPECTION_FACILITY',
  VEHICLE_STORAGE_HALL = 'VEHICLE_STORAGE_HALL',
  YOUTH_CENTER = 'YOUTH_CENTER',
}

/** Boolean expression to compare columns of type "type_of_use_enum". All fields are combined with logical 'AND'. */
export type type_of_use_enum_comparison_exp = {
  _eq?: InputMaybe<type_of_use_enum>;
  _in?: InputMaybe<Array<type_of_use_enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<type_of_use_enum>;
  _nin?: InputMaybe<Array<type_of_use_enum>>;
};

/** A platform user who belongs to an organization and can manage buildings and portfolios. */
export type user = {
  /** Unique identifier from Auth0, linking this user to their authentication identity. */
  auth0_id: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  email?: Maybe<Scalars['String']['output']>;
  featureFlags: Array<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Whether the user account is active. Inactive users cannot log in. */
  is_active: Scalars['Boolean']['output'];
  /** Preferred UI language for this user. References language. */
  language: language_enum;
  last_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  org: org;
  /** The organization this user belongs to. */
  org_id: Scalars['Int']['output'];
  /** Free-text job title or role description provided by the user. */
  role_description?: Maybe<Scalars['String']['output']>;
  role_id: role_enum;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_portfolio_permissions: Array<user_portfolio_permission>;
  /** An aggregate relationship */
  user_portfolio_permissions_aggregate: user_portfolio_permission_aggregate;
};

/** A platform user who belongs to an organization and can manage buildings and portfolios. */
export type useruser_portfolio_permissionsArgs = {
  distinct_on?: InputMaybe<Array<user_portfolio_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_portfolio_permission_order_by>>;
  where?: InputMaybe<user_portfolio_permission_bool_exp>;
};

/** A platform user who belongs to an organization and can manage buildings and portfolios. */
export type useruser_portfolio_permissions_aggregateArgs = {
  distinct_on?: InputMaybe<Array<user_portfolio_permission_select_column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<user_portfolio_permission_order_by>>;
  where?: InputMaybe<user_portfolio_permission_bool_exp>;
};

/** order by aggregate values of table "user" */
export type user_aggregate_order_by = {
  avg?: InputMaybe<user_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_max_order_by>;
  min?: InputMaybe<user_min_order_by>;
  stddev?: InputMaybe<user_stddev_order_by>;
  stddev_pop?: InputMaybe<user_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<user_stddev_samp_order_by>;
  sum?: InputMaybe<user_sum_order_by>;
  var_pop?: InputMaybe<user_var_pop_order_by>;
  var_samp?: InputMaybe<user_var_samp_order_by>;
  variance?: InputMaybe<user_variance_order_by>;
};

/** order by avg() on columns of table "user" */
export type user_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type user_bool_exp = {
  _and?: InputMaybe<Array<user_bool_exp>>;
  _not?: InputMaybe<user_bool_exp>;
  _or?: InputMaybe<Array<user_bool_exp>>;
  auth0_id?: InputMaybe<String_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  email?: InputMaybe<String_comparison_exp>;
  first_name?: InputMaybe<String_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  is_active?: InputMaybe<Boolean_comparison_exp>;
  language?: InputMaybe<language_enum_comparison_exp>;
  last_name?: InputMaybe<String_comparison_exp>;
  org?: InputMaybe<org_bool_exp>;
  org_id?: InputMaybe<Int_comparison_exp>;
  role_description?: InputMaybe<String_comparison_exp>;
  role_id?: InputMaybe<role_enum_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user_portfolio_permissions?: InputMaybe<user_portfolio_permission_bool_exp>;
  user_portfolio_permissions_aggregate?: InputMaybe<user_portfolio_permission_aggregate_bool_exp>;
};

/** Grants a specific user read and/or write access to an individual building. */
export type user_building_permission = {
  /** An object relationship */
  building: building;
  /** The building the permission applies to. */
  building_id: Scalars['Int']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** Whether the user can view this building. */
  read: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: user;
  /** The user being granted permission. */
  user_id: Scalars['Int']['output'];
  /** Whether the user can modify this building. */
  write: Scalars['Boolean']['output'];
};

/** order by aggregate values of table "user_building_permission" */
export type user_building_permission_aggregate_order_by = {
  avg?: InputMaybe<user_building_permission_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_building_permission_max_order_by>;
  min?: InputMaybe<user_building_permission_min_order_by>;
  stddev?: InputMaybe<user_building_permission_stddev_order_by>;
  stddev_pop?: InputMaybe<user_building_permission_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<user_building_permission_stddev_samp_order_by>;
  sum?: InputMaybe<user_building_permission_sum_order_by>;
  var_pop?: InputMaybe<user_building_permission_var_pop_order_by>;
  var_samp?: InputMaybe<user_building_permission_var_samp_order_by>;
  variance?: InputMaybe<user_building_permission_variance_order_by>;
};

/** order by avg() on columns of table "user_building_permission" */
export type user_building_permission_avg_order_by = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user_building_permission". All fields are combined with a logical 'AND'. */
export type user_building_permission_bool_exp = {
  _and?: InputMaybe<Array<user_building_permission_bool_exp>>;
  _not?: InputMaybe<user_building_permission_bool_exp>;
  _or?: InputMaybe<Array<user_building_permission_bool_exp>>;
  building?: InputMaybe<building_bool_exp>;
  building_id?: InputMaybe<Int_comparison_exp>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  read?: InputMaybe<Boolean_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<Int_comparison_exp>;
  write?: InputMaybe<Boolean_comparison_exp>;
};

/** unique or primary key constraints on table "user_building_permission" */
export enum user_building_permission_constraint {
  /** unique or primary key constraint on columns "id" */
  user_building_permission_pkey = 'user_building_permission_pkey',
  /** unique or primary key constraint on columns "user_id", "building_id" */
  user_building_permission_user_id_building_id_key = 'user_building_permission_user_id_building_id_key',
}

/** input type for inserting data into table "user_building_permission" */
export type user_building_permission_insert_input = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user can view this building. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user being granted permission. */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user can modify this building. */
  write?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by max() on columns of table "user_building_permission" */
export type user_building_permission_max_order_by = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user_building_permission" */
export type user_building_permission_min_order_by = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** response of any mutation on the table "user_building_permission" */
export type user_building_permission_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<user_building_permission>;
};

/** on_conflict condition type for table "user_building_permission" */
export type user_building_permission_on_conflict = {
  constraint: user_building_permission_constraint;
  update_columns?: Array<user_building_permission_update_column>;
  where?: InputMaybe<user_building_permission_bool_exp>;
};

/** Ordering options when selecting data from "user_building_permission". */
export type user_building_permission_order_by = {
  building?: InputMaybe<building_order_by>;
  building_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  read?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_id?: InputMaybe<order_by>;
  write?: InputMaybe<order_by>;
};

/** primary key columns input for table: user_building_permission */
export type user_building_permission_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_building_permission" */
export enum user_building_permission_select_column {
  /** column name */
  building_id = 'building_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  read = 'read',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  user_id = 'user_id',
  /** column name */
  write = 'write',
}

/** input type for updating data in table "user_building_permission" */
export type user_building_permission_set_input = {
  /** Whether the user can view this building. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user can modify this building. */
  write?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "user_building_permission" */
export type user_building_permission_stddev_order_by = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "user_building_permission" */
export type user_building_permission_stddev_pop_order_by = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "user_building_permission" */
export type user_building_permission_stddev_samp_order_by = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "user_building_permission" */
export type user_building_permission_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: user_building_permission_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type user_building_permission_stream_cursor_value_input = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user can view this building. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The user being granted permission. */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user can modify this building. */
  write?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "user_building_permission" */
export type user_building_permission_sum_order_by = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** update columns of table "user_building_permission" */
export enum user_building_permission_update_column {
  /** column name */
  read = 'read',
  /** column name */
  write = 'write',
}

export type user_building_permission_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<user_building_permission_set_input>;
  /** filter the rows which have to be updated */
  where: user_building_permission_bool_exp;
};

/** order by var_pop() on columns of table "user_building_permission" */
export type user_building_permission_var_pop_order_by = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "user_building_permission" */
export type user_building_permission_var_samp_order_by = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "user_building_permission" */
export type user_building_permission_variance_order_by = {
  /** The building the permission applies to. */
  building_id?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** order by max() on columns of table "user" */
export type user_max_order_by = {
  /** Unique identifier from Auth0, linking this user to their authentication identity. */
  auth0_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  first_name?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  last_name?: InputMaybe<order_by>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<order_by>;
  /** Free-text job title or role description provided by the user. */
  role_description?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** order by min() on columns of table "user" */
export type user_min_order_by = {
  /** Unique identifier from Auth0, linking this user to their authentication identity. */
  auth0_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  first_name?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  last_name?: InputMaybe<order_by>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<order_by>;
  /** Free-text job title or role description provided by the user. */
  role_description?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
};

/** response of any mutation on the table "user" */
export type user_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<user>;
};

/** Ordering options when selecting data from "user". */
export type user_order_by = {
  auth0_id?: InputMaybe<order_by>;
  created_at?: InputMaybe<order_by>;
  email?: InputMaybe<order_by>;
  first_name?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  is_active?: InputMaybe<order_by>;
  language?: InputMaybe<order_by>;
  last_name?: InputMaybe<order_by>;
  org?: InputMaybe<org_order_by>;
  org_id?: InputMaybe<order_by>;
  role_description?: InputMaybe<order_by>;
  role_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user_portfolio_permissions_aggregate?: InputMaybe<user_portfolio_permission_aggregate_order_by>;
};

/** primary key columns input for table: user */
export type user_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** Grants a specific user read and/or write access to an entire portfolio of buildings. */
export type user_portfolio_permission = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  portfolio: portfolio;
  /** The portfolio the permission applies to. */
  portfolio_id: Scalars['Int']['output'];
  /** Whether the user can view buildings in this portfolio. */
  read: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: user;
  /** The user being granted permission. */
  user_id: Scalars['Int']['output'];
  /** Whether the user can modify buildings in this portfolio. */
  write: Scalars['Boolean']['output'];
};

/** aggregated selection of "user_portfolio_permission" */
export type user_portfolio_permission_aggregate = {
  aggregate?: Maybe<user_portfolio_permission_aggregate_fields>;
  nodes: Array<user_portfolio_permission>;
};

export type user_portfolio_permission_aggregate_bool_exp = {
  bool_and?: InputMaybe<user_portfolio_permission_aggregate_bool_exp_bool_and>;
  bool_or?: InputMaybe<user_portfolio_permission_aggregate_bool_exp_bool_or>;
  count?: InputMaybe<user_portfolio_permission_aggregate_bool_exp_count>;
};

export type user_portfolio_permission_aggregate_bool_exp_bool_and = {
  arguments: user_portfolio_permission_select_column_user_portfolio_permission_aggregate_bool_exp_bool_and_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<user_portfolio_permission_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type user_portfolio_permission_aggregate_bool_exp_bool_or = {
  arguments: user_portfolio_permission_select_column_user_portfolio_permission_aggregate_bool_exp_bool_or_arguments_columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<user_portfolio_permission_bool_exp>;
  predicate: Boolean_comparison_exp;
};

export type user_portfolio_permission_aggregate_bool_exp_count = {
  arguments?: InputMaybe<Array<user_portfolio_permission_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<user_portfolio_permission_bool_exp>;
  predicate: Int_comparison_exp;
};

/** aggregate fields of "user_portfolio_permission" */
export type user_portfolio_permission_aggregate_fields = {
  avg?: Maybe<user_portfolio_permission_avg_fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<user_portfolio_permission_max_fields>;
  min?: Maybe<user_portfolio_permission_min_fields>;
  stddev?: Maybe<user_portfolio_permission_stddev_fields>;
  stddev_pop?: Maybe<user_portfolio_permission_stddev_pop_fields>;
  stddev_samp?: Maybe<user_portfolio_permission_stddev_samp_fields>;
  sum?: Maybe<user_portfolio_permission_sum_fields>;
  var_pop?: Maybe<user_portfolio_permission_var_pop_fields>;
  var_samp?: Maybe<user_portfolio_permission_var_samp_fields>;
  variance?: Maybe<user_portfolio_permission_variance_fields>;
};

/** aggregate fields of "user_portfolio_permission" */
export type user_portfolio_permission_aggregate_fieldscountArgs = {
  columns?: InputMaybe<Array<user_portfolio_permission_select_column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_portfolio_permission" */
export type user_portfolio_permission_aggregate_order_by = {
  avg?: InputMaybe<user_portfolio_permission_avg_order_by>;
  count?: InputMaybe<order_by>;
  max?: InputMaybe<user_portfolio_permission_max_order_by>;
  min?: InputMaybe<user_portfolio_permission_min_order_by>;
  stddev?: InputMaybe<user_portfolio_permission_stddev_order_by>;
  stddev_pop?: InputMaybe<user_portfolio_permission_stddev_pop_order_by>;
  stddev_samp?: InputMaybe<user_portfolio_permission_stddev_samp_order_by>;
  sum?: InputMaybe<user_portfolio_permission_sum_order_by>;
  var_pop?: InputMaybe<user_portfolio_permission_var_pop_order_by>;
  var_samp?: InputMaybe<user_portfolio_permission_var_samp_order_by>;
  variance?: InputMaybe<user_portfolio_permission_variance_order_by>;
};

/** aggregate avg on columns */
export type user_portfolio_permission_avg_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user being granted permission. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_portfolio_permission" */
export type user_portfolio_permission_avg_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** Boolean expression to filter rows from the table "user_portfolio_permission". All fields are combined with a logical 'AND'. */
export type user_portfolio_permission_bool_exp = {
  _and?: InputMaybe<Array<user_portfolio_permission_bool_exp>>;
  _not?: InputMaybe<user_portfolio_permission_bool_exp>;
  _or?: InputMaybe<Array<user_portfolio_permission_bool_exp>>;
  created_at?: InputMaybe<timestamptz_comparison_exp>;
  id?: InputMaybe<Int_comparison_exp>;
  portfolio?: InputMaybe<portfolio_bool_exp>;
  portfolio_id?: InputMaybe<Int_comparison_exp>;
  read?: InputMaybe<Boolean_comparison_exp>;
  updated_at?: InputMaybe<timestamptz_comparison_exp>;
  user?: InputMaybe<user_bool_exp>;
  user_id?: InputMaybe<Int_comparison_exp>;
  write?: InputMaybe<Boolean_comparison_exp>;
};

/** unique or primary key constraints on table "user_portfolio_permission" */
export enum user_portfolio_permission_constraint {
  /** unique or primary key constraint on columns "id" */
  user_portfolio_permission_pkey = 'user_portfolio_permission_pkey',
  /** unique or primary key constraint on columns "user_id", "portfolio_id" */
  user_portfolio_permission_user_id_portfolio_id_key = 'user_portfolio_permission_user_id_portfolio_id_key',
}

/** input type for inserting data into table "user_portfolio_permission" */
export type user_portfolio_permission_insert_input = {
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user can view buildings in this portfolio. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user being granted permission. */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user can modify buildings in this portfolio. */
  write?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type user_portfolio_permission_max_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The user being granted permission. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "user_portfolio_permission" */
export type user_portfolio_permission_max_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate min on columns */
export type user_portfolio_permission_min_fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The user being granted permission. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "user_portfolio_permission" */
export type user_portfolio_permission_min_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** response of any mutation on the table "user_portfolio_permission" */
export type user_portfolio_permission_mutation_response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<user_portfolio_permission>;
};

/** on_conflict condition type for table "user_portfolio_permission" */
export type user_portfolio_permission_on_conflict = {
  constraint: user_portfolio_permission_constraint;
  update_columns?: Array<user_portfolio_permission_update_column>;
  where?: InputMaybe<user_portfolio_permission_bool_exp>;
};

/** Ordering options when selecting data from "user_portfolio_permission". */
export type user_portfolio_permission_order_by = {
  created_at?: InputMaybe<order_by>;
  id?: InputMaybe<order_by>;
  portfolio?: InputMaybe<portfolio_order_by>;
  portfolio_id?: InputMaybe<order_by>;
  read?: InputMaybe<order_by>;
  updated_at?: InputMaybe<order_by>;
  user?: InputMaybe<user_order_by>;
  user_id?: InputMaybe<order_by>;
  write?: InputMaybe<order_by>;
};

/** primary key columns input for table: user_portfolio_permission */
export type user_portfolio_permission_pk_columns_input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_portfolio_permission" */
export enum user_portfolio_permission_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  portfolio_id = 'portfolio_id',
  /** column name */
  read = 'read',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  user_id = 'user_id',
  /** column name */
  write = 'write',
}

/** select "user_portfolio_permission_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_portfolio_permission" */
export enum user_portfolio_permission_select_column_user_portfolio_permission_aggregate_bool_exp_bool_and_arguments_columns {
  /** column name */
  read = 'read',
  /** column name */
  write = 'write',
}

/** select "user_portfolio_permission_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_portfolio_permission" */
export enum user_portfolio_permission_select_column_user_portfolio_permission_aggregate_bool_exp_bool_or_arguments_columns {
  /** column name */
  read = 'read',
  /** column name */
  write = 'write',
}

/** input type for updating data in table "user_portfolio_permission" */
export type user_portfolio_permission_set_input = {
  /** Whether the user can view buildings in this portfolio. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user can modify buildings in this portfolio. */
  write?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type user_portfolio_permission_stddev_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user being granted permission. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_portfolio_permission" */
export type user_portfolio_permission_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type user_portfolio_permission_stddev_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user being granted permission. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_portfolio_permission" */
export type user_portfolio_permission_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type user_portfolio_permission_stddev_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user being granted permission. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_portfolio_permission" */
export type user_portfolio_permission_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "user_portfolio_permission" */
export type user_portfolio_permission_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: user_portfolio_permission_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type user_portfolio_permission_stream_cursor_value_input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user can view buildings in this portfolio. */
  read?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The user being granted permission. */
  user_id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user can modify buildings in this portfolio. */
  write?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type user_portfolio_permission_sum_fields = {
  id?: Maybe<Scalars['Int']['output']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: Maybe<Scalars['Int']['output']>;
  /** The user being granted permission. */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_portfolio_permission" */
export type user_portfolio_permission_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** update columns of table "user_portfolio_permission" */
export enum user_portfolio_permission_update_column {
  /** column name */
  read = 'read',
  /** column name */
  write = 'write',
}

export type user_portfolio_permission_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<user_portfolio_permission_set_input>;
  /** filter the rows which have to be updated */
  where: user_portfolio_permission_bool_exp;
};

/** aggregate var_pop on columns */
export type user_portfolio_permission_var_pop_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user being granted permission. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_portfolio_permission" */
export type user_portfolio_permission_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate var_samp on columns */
export type user_portfolio_permission_var_samp_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user being granted permission. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_portfolio_permission" */
export type user_portfolio_permission_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** aggregate variance on columns */
export type user_portfolio_permission_variance_fields = {
  id?: Maybe<Scalars['Float']['output']>;
  /** The portfolio the permission applies to. */
  portfolio_id?: Maybe<Scalars['Float']['output']>;
  /** The user being granted permission. */
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_portfolio_permission" */
export type user_portfolio_permission_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** The portfolio the permission applies to. */
  portfolio_id?: InputMaybe<order_by>;
  /** The user being granted permission. */
  user_id?: InputMaybe<order_by>;
};

/** select columns of table "user" */
export enum user_select_column {
  /** column name */
  auth0_id = 'auth0_id',
  /** column name */
  created_at = 'created_at',
  /** column name */
  email = 'email',
  /** column name */
  first_name = 'first_name',
  /** column name */
  id = 'id',
  /** column name */
  is_active = 'is_active',
  /** column name */
  language = 'language',
  /** column name */
  last_name = 'last_name',
  /** column name */
  org_id = 'org_id',
  /** column name */
  role_description = 'role_description',
  /** column name */
  role_id = 'role_id',
  /** column name */
  updated_at = 'updated_at',
}

/** input type for updating data in table "user" */
export type user_set_input = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** Preferred UI language for this user. References language. */
  language?: InputMaybe<language_enum>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  /** Free-text job title or role description provided by the user. */
  role_description?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<role_enum>;
};

/** order by stddev() on columns of table "user" */
export type user_stddev_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** order by stddev_pop() on columns of table "user" */
export type user_stddev_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** order by stddev_samp() on columns of table "user" */
export type user_stddev_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** Streaming cursor of the table "user" */
export type user_stream_cursor_input = {
  /** Stream column input with initial value */
  initial_value: user_stream_cursor_value_input;
  /** cursor ordering */
  ordering?: InputMaybe<cursor_ordering>;
};

/** Initial value of the column from where the streaming should start */
export type user_stream_cursor_value_input = {
  /** Unique identifier from Auth0, linking this user to their authentication identity. */
  auth0_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user account is active. Inactive users cannot log in. */
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Preferred UI language for this user. References language. */
  language?: InputMaybe<language_enum>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<Scalars['Int']['input']>;
  /** Free-text job title or role description provided by the user. */
  role_description?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<role_enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "user" */
export type user_sum_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<order_by>;
};

export type user_updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<user_set_input>;
  /** filter the rows which have to be updated */
  where: user_bool_exp;
};

/** order by var_pop() on columns of table "user" */
export type user_var_pop_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** order by var_samp() on columns of table "user" */
export type user_var_samp_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** order by variance() on columns of table "user" */
export type user_variance_order_by = {
  id?: InputMaybe<order_by>;
  /** The organization this user belongs to. */
  org_id?: InputMaybe<order_by>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type uuid_comparison_exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export type vector_comparison_exp = {
  _eq?: InputMaybe<Scalars['vector']['input']>;
  _gt?: InputMaybe<Scalars['vector']['input']>;
  _gte?: InputMaybe<Scalars['vector']['input']>;
  _in?: InputMaybe<Array<Scalars['vector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['vector']['input']>;
  _lte?: InputMaybe<Scalars['vector']['input']>;
  _neq?: InputMaybe<Scalars['vector']['input']>;
  _nin?: InputMaybe<Array<Scalars['vector']['input']>>;
};

export enum ventilation_supported_technology_enum {
  CENTRAL_EXHAUST = 'CENTRAL_EXHAUST',
  CENTRAL_SUPPLY_EXHAUST_WITH_HRU = 'CENTRAL_SUPPLY_EXHAUST_WITH_HRU',
  DECENTRAL_SINGLE_ROOM_VENTILATION_UNITS_WITH_HRU = 'DECENTRAL_SINGLE_ROOM_VENTILATION_UNITS_WITH_HRU',
}

export type ActionPlanningActionDeleteActionPlanMutationVariables = Exact<{
  actionPlanStableId: Scalars['Int']['input'];
}>;

export type ActionPlanningActionDeleteActionPlanMutation = {
  deleteActionPlan: { __typename: 'DeleteActionPlanResponse'; stable_id: number };
};

export type BulkDeleteActionPlansMutationVariables = Exact<{
  input: BulkDeleteActionPlansInput;
}>;

export type BulkDeleteActionPlansMutation = {
  bulkDeleteActionPlans: { __typename: 'BulkDeleteActionPlansResponse'; deletedCount: number };
};

export type DeleteActionMutationVariables = Exact<{
  actionId: Scalars['Int']['input'];
}>;

export type DeleteActionMutation = {
  deleteAction: { message?: string | null; error?: action_mutation_error_enum | null };
};

export type BaseEnergyValuesCrremOutputFragment = {
  analysisType: emission_factor_type_enum;
  energy_final: number;
  energy_final_total: number;
  energy_primary: number;
  energy_primary_total: number;
  heating_demand?: number | null;
  heating_demand_total?: number | null;
  co2_emissions: number;
  co2_emissions_total: number;
  stranding_date: DateTime;
  efficiency_class: efficiency_class_enum;
  renovation_costs?: number | null;
  energy_final_cost: number;
  co2_tax_cost: number;
};

export type BaseEnergyValuesNationalEnergyLawOutputFragment = {
  analysisType: emission_factor_type_enum;
  energy_final: number;
  energy_final_total: number;
  energy_primary: number;
  energy_primary_total: number;
  heating_demand?: number | null;
  heating_demand_total?: number | null;
  co2_emissions: number;
  co2_emissions_total: number;
  efficiency_class: efficiency_class_enum;
  renovation_costs?: number | null;
  energy_final_cost: number;
  co2_tax_cost: number;
};

export type EnergyValuesCrremOutputFragment = {
  analysisType: emission_factor_type_enum;
  energy_final: number;
  energy_final_total: number;
  energy_primary: number;
  energy_primary_total: number;
  heating_demand?: number | null;
  heating_demand_total?: number | null;
  co2_emissions: number;
  co2_emissions_total: number;
  stranding_date: DateTime;
  efficiency_class: efficiency_class_enum;
  renovation_costs?: number | null;
  energy_final_cost: number;
  co2_tax_cost: number;
  payback_period: number;
  co2_abatement_costs: number;
};

export type EnergyValuesNationalEnergyLawOutputFragment = {
  analysisType: emission_factor_type_enum;
  energy_final: number;
  energy_final_total: number;
  energy_primary: number;
  energy_primary_total: number;
  heating_demand?: number | null;
  heating_demand_total?: number | null;
  co2_emissions: number;
  co2_emissions_total: number;
  efficiency_class: efficiency_class_enum;
  renovation_costs?: number | null;
  energy_final_cost: number;
  co2_tax_cost: number;
  payback_period: number;
  co2_abatement_costs: number;
};

type BaseEnergyValuesOutputResponse_BaseEnergyValuesCRREMOutput_Fragment = {
  analysisType: emission_factor_type_enum;
  energy_final: number;
  energy_final_total: number;
  energy_primary: number;
  energy_primary_total: number;
  heating_demand?: number | null;
  heating_demand_total?: number | null;
  co2_emissions: number;
  co2_emissions_total: number;
  stranding_date: DateTime;
  efficiency_class: efficiency_class_enum;
  renovation_costs?: number | null;
  energy_final_cost: number;
  co2_tax_cost: number;
};

type BaseEnergyValuesOutputResponse_BaseEnergyValuesNationalEnergyLawOutput_Fragment = {
  analysisType: emission_factor_type_enum;
  energy_final: number;
  energy_final_total: number;
  energy_primary: number;
  energy_primary_total: number;
  heating_demand?: number | null;
  heating_demand_total?: number | null;
  co2_emissions: number;
  co2_emissions_total: number;
  efficiency_class: efficiency_class_enum;
  renovation_costs?: number | null;
  energy_final_cost: number;
  co2_tax_cost: number;
};

export type BaseEnergyValuesOutputResponseFragment =
  | BaseEnergyValuesOutputResponse_BaseEnergyValuesCRREMOutput_Fragment
  | BaseEnergyValuesOutputResponse_BaseEnergyValuesNationalEnergyLawOutput_Fragment;

type EnergyValuesOutputResponse_EnergyValuesCRREMOutput_Fragment = {
  analysisType: emission_factor_type_enum;
  energy_final: number;
  energy_final_total: number;
  energy_primary: number;
  energy_primary_total: number;
  heating_demand?: number | null;
  heating_demand_total?: number | null;
  co2_emissions: number;
  co2_emissions_total: number;
  stranding_date: DateTime;
  efficiency_class: efficiency_class_enum;
  renovation_costs?: number | null;
  energy_final_cost: number;
  co2_tax_cost: number;
  payback_period: number;
  co2_abatement_costs: number;
};

type EnergyValuesOutputResponse_EnergyValuesNationalEnergyLawOutput_Fragment = {
  analysisType: emission_factor_type_enum;
  energy_final: number;
  energy_final_total: number;
  energy_primary: number;
  energy_primary_total: number;
  heating_demand?: number | null;
  heating_demand_total?: number | null;
  co2_emissions: number;
  co2_emissions_total: number;
  efficiency_class: efficiency_class_enum;
  renovation_costs?: number | null;
  energy_final_cost: number;
  co2_tax_cost: number;
  payback_period: number;
  co2_abatement_costs: number;
};

export type EnergyValuesOutputResponseFragment =
  | EnergyValuesOutputResponse_EnergyValuesCRREMOutput_Fragment
  | EnergyValuesOutputResponse_EnergyValuesNationalEnergyLawOutput_Fragment;

export type SimulateActionOutputResponseFragment = {
  error?: action_mutation_error_enum | null;
  result?:
    | {
        analysisType: emission_factor_type_enum;
        energy_final: number;
        energy_final_total: number;
        energy_primary: number;
        energy_primary_total: number;
        heating_demand?: number | null;
        heating_demand_total?: number | null;
        co2_emissions: number;
        co2_emissions_total: number;
        stranding_date: DateTime;
        efficiency_class: efficiency_class_enum;
        renovation_costs?: number | null;
        energy_final_cost: number;
        co2_tax_cost: number;
        payback_period: number;
        co2_abatement_costs: number;
      }
    | {
        analysisType: emission_factor_type_enum;
        energy_final: number;
        energy_final_total: number;
        energy_primary: number;
        energy_primary_total: number;
        heating_demand?: number | null;
        heating_demand_total?: number | null;
        co2_emissions: number;
        co2_emissions_total: number;
        efficiency_class: efficiency_class_enum;
        renovation_costs?: number | null;
        energy_final_cost: number;
        co2_tax_cost: number;
        payback_period: number;
        co2_abatement_costs: number;
      }
    | null;
};

export type SimulateActionStatusQuoOutputResponseFragment = {
  error?: action_mutation_error_enum | null;
  result?:
    | {
        analysisType: emission_factor_type_enum;
        energy_final: number;
        energy_final_total: number;
        energy_primary: number;
        energy_primary_total: number;
        heating_demand?: number | null;
        heating_demand_total?: number | null;
        co2_emissions: number;
        co2_emissions_total: number;
        stranding_date: DateTime;
        efficiency_class: efficiency_class_enum;
        renovation_costs?: number | null;
        energy_final_cost: number;
        co2_tax_cost: number;
      }
    | {
        analysisType: emission_factor_type_enum;
        energy_final: number;
        energy_final_total: number;
        energy_primary: number;
        energy_primary_total: number;
        heating_demand?: number | null;
        heating_demand_total?: number | null;
        co2_emissions: number;
        co2_emissions_total: number;
        efficiency_class: efficiency_class_enum;
        renovation_costs?: number | null;
        energy_final_cost: number;
        co2_tax_cost: number;
      }
    | null;
};

export type EditActionOutputResponseFragment = { error?: action_mutation_error_enum | null; message?: string | null };

export type SimulateTechnologyActionMutationVariables = Exact<{
  action_plan_stable_id: Scalars['Int']['input'];
  envelope_renovation_parameter?: InputMaybe<EnvelopeRenovationParameterInput>;
  system_renovation_parameter?: InputMaybe<SystemRenovationParameterInput>;
  energy_system_route_renovation_parameter?: InputMaybe<EnergySystemRouteRenovationParameterInput>;
  hydraulic_balancing_renovation_parameter?: InputMaybe<HydraulicBalancingRenovationParameterInput>;
  solar_renovation_parameter?: InputMaybe<SolarRenovationParameterInput>;
  custom_action_renovation_parameter?: InputMaybe<CustomActionRenovationParameterInput>;
  maintenance_action_parameter?: InputMaybe<MaintenanceActionParameterInput>;
  create_ventilation_renovation_parameter?: InputMaybe<CreateVentilationRenovationParameterInput>;
  ventilation_renovation_parameter?: InputMaybe<VentilationRenovationParameterInput>;
  subsidies: Array<SubsidyInput> | SubsidyInput;
  implementation_to: Scalars['DateTime']['input'];
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
}>;

export type SimulateTechnologyActionMutation = {
  simulateAction: {
    error?: action_mutation_error_enum | null;
    result?:
      | {
          analysisType: emission_factor_type_enum;
          energy_final: number;
          energy_final_total: number;
          energy_primary: number;
          energy_primary_total: number;
          heating_demand?: number | null;
          heating_demand_total?: number | null;
          co2_emissions: number;
          co2_emissions_total: number;
          stranding_date: DateTime;
          efficiency_class: efficiency_class_enum;
          renovation_costs?: number | null;
          energy_final_cost: number;
          co2_tax_cost: number;
          payback_period: number;
          co2_abatement_costs: number;
        }
      | {
          analysisType: emission_factor_type_enum;
          energy_final: number;
          energy_final_total: number;
          energy_primary: number;
          energy_primary_total: number;
          heating_demand?: number | null;
          heating_demand_total?: number | null;
          co2_emissions: number;
          co2_emissions_total: number;
          efficiency_class: efficiency_class_enum;
          renovation_costs?: number | null;
          energy_final_cost: number;
          co2_tax_cost: number;
          payback_period: number;
          co2_abatement_costs: number;
        }
      | null;
  };
};

export type ImplementActionMutationVariables = Exact<{
  action_plan_stable_id: Scalars['Int']['input'];
  implementation_from: Scalars['DateTime']['input'];
  implementation_to: Scalars['DateTime']['input'];
  envelope_renovation_parameter?: InputMaybe<EnvelopeRenovationParameterInput>;
  system_renovation_parameter?: InputMaybe<SystemRenovationParameterInput>;
  energy_system_route_renovation_parameter?: InputMaybe<EnergySystemRouteRenovationParameterInput>;
  hydraulic_balancing_renovation_parameter?: InputMaybe<HydraulicBalancingRenovationParameterInput>;
  solar_renovation_parameter?: InputMaybe<SolarRenovationParameterInput>;
  custom_action_renovation_parameter?: InputMaybe<CustomActionRenovationParameterInput>;
  maintenance_action_parameter?: InputMaybe<MaintenanceActionParameterInput>;
  create_ventilation_renovation_parameter?: InputMaybe<CreateVentilationRenovationParameterInput>;
  ventilation_renovation_parameter?: InputMaybe<VentilationRenovationParameterInput>;
  subsidies: Array<SubsidyInput> | SubsidyInput;
  customCost?: InputMaybe<CustomCostInput>;
}>;

export type ImplementActionMutation = { implementAction: { action_id: number } };

export type SimulateEditActionMutationVariables = Exact<{
  action_id: Scalars['Int']['input'];
  envelope_renovation_parameter?: InputMaybe<EnvelopeRenovationParameterInput>;
  system_renovation_parameter?: InputMaybe<SystemRenovationParameterInput>;
  energy_system_route_renovation_parameter?: InputMaybe<EnergySystemRouteRenovationParameterInput>;
  hydraulic_balancing_renovation_parameter?: InputMaybe<HydraulicBalancingRenovationParameterInput>;
  solar_renovation_parameter?: InputMaybe<SolarRenovationParameterInput>;
  custom_action_renovation_parameter?: InputMaybe<CustomActionRenovationParameterInput>;
  maintenance_action_parameter?: InputMaybe<MaintenanceActionParameterInput>;
  create_ventilation_renovation_parameter?: InputMaybe<CreateVentilationRenovationParameterInput>;
  ventilation_renovation_parameter?: InputMaybe<VentilationRenovationParameterInput>;
  subsidies: Array<SubsidyInput> | SubsidyInput;
  customCost?: InputMaybe<CustomCostInput>;
  implementation_to: Scalars['DateTime']['input'];
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
}>;

export type SimulateEditActionMutation = {
  simulateEditAction: {
    error?: action_mutation_error_enum | null;
    result?:
      | {
          analysisType: emission_factor_type_enum;
          energy_final: number;
          energy_final_total: number;
          energy_primary: number;
          energy_primary_total: number;
          heating_demand?: number | null;
          heating_demand_total?: number | null;
          co2_emissions: number;
          co2_emissions_total: number;
          stranding_date: DateTime;
          efficiency_class: efficiency_class_enum;
          renovation_costs?: number | null;
          energy_final_cost: number;
          co2_tax_cost: number;
          payback_period: number;
          co2_abatement_costs: number;
        }
      | {
          analysisType: emission_factor_type_enum;
          energy_final: number;
          energy_final_total: number;
          energy_primary: number;
          energy_primary_total: number;
          heating_demand?: number | null;
          heating_demand_total?: number | null;
          co2_emissions: number;
          co2_emissions_total: number;
          efficiency_class: efficiency_class_enum;
          renovation_costs?: number | null;
          energy_final_cost: number;
          co2_tax_cost: number;
          payback_period: number;
          co2_abatement_costs: number;
        }
      | null;
  };
};

export type EditActionMutationVariables = Exact<{
  action_id: Scalars['Int']['input'];
  envelope_renovation_parameter?: InputMaybe<EnvelopeRenovationParameterInput>;
  system_renovation_parameter?: InputMaybe<SystemRenovationParameterInput>;
  energy_system_route_renovation_parameter?: InputMaybe<EnergySystemRouteRenovationParameterInput>;
  hydraulic_balancing_renovation_parameter?: InputMaybe<HydraulicBalancingRenovationParameterInput>;
  solar_renovation_parameter?: InputMaybe<SolarRenovationParameterInput>;
  custom_action_renovation_parameter?: InputMaybe<CustomActionRenovationParameterInput>;
  maintenance_action_parameter?: InputMaybe<MaintenanceActionParameterInput>;
  create_ventilation_renovation_parameter?: InputMaybe<CreateVentilationRenovationParameterInput>;
  ventilation_renovation_parameter?: InputMaybe<VentilationRenovationParameterInput>;
  subsidies: Array<SubsidyInput> | SubsidyInput;
  customCost?: InputMaybe<CustomCostInput>;
  implementation_to: Scalars['DateTime']['input'];
}>;

export type EditActionMutation = { editAction: { error?: action_mutation_error_enum | null; message?: string | null } };

export type CreateActionPlanModalCreateActionPlanMutationVariables = Exact<{
  scenario_id: Scalars['Int']['input'];
  building_id: Scalars['Int']['input'];
}>;

export type CreateActionPlanModalCreateActionPlanMutation = { createActionPlan: { stable_id: number } };

export type CreateScenarioModalCreateScenarioMutationVariables = Exact<{
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  portfolio_id?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CreateScenarioModalCreateScenarioMutation = { createScenario: { id: number } };

export type ActionPlanningScenarioDeleteScenarioMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type ActionPlanningScenarioDeleteScenarioMutation = { deleteScenario: { id: number } };

export type ActionPlanningScenarioArchiveScenarioMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type ActionPlanningScenarioArchiveScenarioMutation = { archiveScenario: { id: number } };

export type ActionPlanningScenarioUnarchiveScenarioMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type ActionPlanningScenarioUnarchiveScenarioMutation = { unarchiveScenario: { id: number } };

export type UpdateScenarioMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateScenarioMutation = { updateScenario: { id: number } };

export type DuplicateScenarioMutationVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
  copyNameSuffix: Scalars['String']['input'];
}>;

export type DuplicateScenarioMutation = { duplicateScenario: boolean };

export type UpdateScenarioToLatestVersionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type UpdateScenarioToLatestVersionMutation = { updateScenarioToLatestVersion: boolean };

export type CreateBulkActionMutationVariables = Exact<{
  input: BulkActionInput;
}>;

export type CreateBulkActionMutation = { bulkActionId: number };

export type EditBulkActionMutationVariables = Exact<{
  input: BulkActionEditInput;
}>;

export type EditBulkActionMutation = { editBulkAction: { message: string } };

export type DeleteBulkActionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteBulkActionMutation = { deleteBulkAction: boolean };

export type CreateExclusionNoteMutationVariables = Exact<{
  actionPlanStableId: Scalars['Int']['input'];
  implementationTo: Scalars['DateTime']['input'];
  note: Scalars['String']['input'];
}>;

export type CreateExclusionNoteMutation = { createExclusionNote: { action_id: number } };

export type EditExclusionNoteMutationVariables = Exact<{
  actionId: Scalars['Int']['input'];
  implementationTo: Scalars['DateTime']['input'];
  note: Scalars['String']['input'];
}>;

export type EditExclusionNoteMutation = { editExclusionNote: { message?: string | null } };

export type CostByRenovationCategoryFragment = {
  startYear: number;
  series: Array<{ name: renovation_category_enum; data: { values: Array<number>; actionsCount: Array<number> } }>;
  legend: Array<{ name: renovation_category_enum; value: number; percentage: number; actionsCount: number }>;
};

export type EnvelopeUnitFragment = {
  id: number;
  secondary_id: string;
  area: number;
  envelope_type_id: envelope_type_enum;
  insulation_material_name?: string | null;
  u_value?: number | null;
  insulation_thickness?: number | null;
  orientation?: number | null;
  inclination?: number | null;
};

export type EnergyConsumerForActionFragment = {
  name?: string | null;
  id: number;
  energy_consumer_type_id: energy_consumer_type_enum;
  energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
  construction_year?: number | null;
  efficiency?: number | null;
  energy_system_consumer_routes: Array<{
    id: number;
    secondary_id: string;
    energy_source_type_id: energy_source_type_enum;
    energy_final: number;
    energy_system: { energy_system_type_id: energy_system_type_enum };
  }>;
};

export type EnergySystemFragment = {
  id: number;
  secondary_id: string;
  energy_system_type_id: energy_system_type_enum;
  energy_system_consumer_routes: Array<{
    id: number;
    secondary_id: string;
    energy_final: number;
    energy_source_type_id: energy_source_type_enum;
    energy_consumer?: {
      name?: string | null;
      id: number;
      energy_consumer_type_id: energy_consumer_type_enum;
      energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
      construction_year?: number | null;
      efficiency?: number | null;
      energy_system_consumer_routes: Array<{
        id: number;
        secondary_id: string;
        energy_source_type_id: energy_source_type_enum;
        energy_final: number;
        energy_system: { energy_system_type_id: energy_system_type_enum };
      }>;
    } | null;
    energy_distribution?: {
      id: number;
      last_hydraulic_balancing?: string | null;
      last_balancing_set_to_never: boolean;
      heat_transfer_loss: number;
      balancing_with_components: boolean;
    } | null;
  }>;
  energy_system_producer_routes: Array<{
    energy_source_type_id: energy_source_type_enum;
    energy_producer: { nominal_power?: number | null };
  }>;
};

export type BuildingModelFragment = {
  id: number;
  energy_final?: number | null;
  energy_primary?: number | null;
  heating_demand?: number | null;
  heat_transfer_by_ventilation: number;
  building?: { id: number; year_constructed: number } | null;
  envelope_units: Array<{
    id: number;
    secondary_id: string;
    area: number;
    envelope_type_id: envelope_type_enum;
    insulation_material_name?: string | null;
    u_value?: number | null;
    insulation_thickness?: number | null;
    orientation?: number | null;
    inclination?: number | null;
  }>;
  energy_consumers: Array<{
    id: number;
    energy_consumer_type_id: energy_consumer_type_enum;
    energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
    efficiency?: number | null;
    energy_system_consumer_routes: Array<{
      energy_final: number;
      energy_system: { energy_system_type_id: energy_system_type_enum };
    }>;
  }>;
  energy_distributions: Array<{
    id: number;
    heat_transfer_loss: number;
    last_hydraulic_balancing?: string | null;
    last_balancing_set_to_never: boolean;
    balancing_with_components: boolean;
  }>;
  energy_systems: Array<{
    id: number;
    secondary_id: string;
    energy_system_type_id: energy_system_type_enum;
    energy_system_consumer_routes: Array<{
      id: number;
      secondary_id: string;
      energy_final: number;
      energy_source_type_id: energy_source_type_enum;
      energy_consumer?: {
        name?: string | null;
        id: number;
        energy_consumer_type_id: energy_consumer_type_enum;
        energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
        construction_year?: number | null;
        efficiency?: number | null;
        energy_system_consumer_routes: Array<{
          id: number;
          secondary_id: string;
          energy_source_type_id: energy_source_type_enum;
          energy_final: number;
          energy_system: { energy_system_type_id: energy_system_type_enum };
        }>;
      } | null;
      energy_distribution?: {
        id: number;
        last_hydraulic_balancing?: string | null;
        last_balancing_set_to_never: boolean;
        heat_transfer_loss: number;
        balancing_with_components: boolean;
      } | null;
    }>;
    energy_system_producer_routes: Array<{
      energy_source_type_id: energy_source_type_enum;
      energy_producer: { nominal_power?: number | null };
    }>;
  }>;
};

export type EnvelopeRenovationFragment = {
  old_entity_id?: number | null;
  new_envelope?: {
    id: number;
    secondary_id: string;
    area: number;
    envelope_type_id: envelope_type_enum;
    insulation_material_name?: string | null;
    u_value?: number | null;
    insulation_lambda?: number | null;
    insulation_method_id?: insulation_method_enum | null;
    insulation_thickness?: number | null;
    insulation_material_category_id?: insulation_material_category_enum | null;
  } | null;
  old_envelope?: {
    id: number;
    secondary_id: string;
    building_model: {
      envelope_units: Array<{
        id: number;
        secondary_id: string;
        area: number;
        envelope_type_id: envelope_type_enum;
        insulation_material_name?: string | null;
        u_value?: number | null;
        insulation_thickness?: number | null;
        orientation?: number | null;
        inclination?: number | null;
      }>;
    };
  } | null;
};

export type ActionParametersFragment = {
  parameters:
    | {
        __typename: 'CreateVentilationRenovationParametersUnionMember';
        createVentilationRenovationParameters: {
          consumer_technology_type: ventilation_supported_technology_enum;
          final_energy: number;
          efficiency?: number | null;
          number_of_units?: number | null;
        };
      }
    | {
        __typename: 'CustomActionParametersUnionMember';
        customActionParameters:
          | {
              __typename: 'EnergySourceCustomActionParametersUnionMember';
              energySourceCustomActionParameters: {
                custom_name: string;
                renovation_ids?: Array<string> | null;
                fraction: number;
                energy_source_type: energy_source_type_enum;
              };
            }
          | {
              __typename: 'SystemCustomActionParametersUnionMember';
              systemCustomActionParameters: {
                system_type: energy_system_type_enum;
                renovation_ids?: Array<string> | null;
                fraction: number;
                custom_name: string;
              };
            };
      }
    | {
        __typename: 'EnergySystemRouteParametersUnionMember';
        energySystemRouteParameters: {
          energy_source_type: energy_source_type_enum;
          emission_certificate_id?: number | null;
        };
      }
    | {
        __typename: 'EnvelopeParametersUnionMember';
        envelopeParameters: {
          u_value?: number | null;
          renovation_ids?: Array<string> | null;
          material_name: string;
          insulation_thickness?: number | null;
          insulation_method?: insulation_method_enum | null;
          insulation_material_category?: insulation_material_category_enum | null;
          insulation_lambda?: number | null;
          envelope_type: envelope_type_enum;
        };
      }
    | { __typename: 'ExclusionNoteParametersUnionMember'; exclusionNoteParameters: { note: string } }
    | {
        __typename: 'HydraulicBalancingParametersUnionMember';
        hydraulicBalancingParameters: { last_hydraulic_balancing: DateTime; costs_with_components?: boolean | null };
      }
    | { __typename: 'MaintenanceActionParametersUnionMember'; maintenanceActionParameters: { custom_name: string } }
    | {
        __typename: 'SolarParametersUnionMember';
        solarParameters: {
          technology_name: string;
          solar_active_area: number;
          roof_area_ratio: number;
          module_peak_power: number;
          module_angle: number;
        };
      }
    | {
        __typename: 'SystemParametersUnionMember';
        systemParameters: {
          consumer_technology_type: energy_consumer_technology_type_enum;
          efficiency: number;
          energy_source_type: energy_source_type_enum;
          renovation_ids?: Array<string> | null;
          system_type: energy_system_type_enum;
          technology_name: string;
          emission_certificate_id?: number | null;
        };
      }
    | {
        __typename: 'VentilationRenovationParametersUnionMember';
        ventilationRenovationParameters: {
          renovation_ids?: Array<string> | null;
          consumer_technology_type: ventilation_supported_technology_enum;
          final_energy: number;
          efficiency?: number | null;
          number_of_units?: number | null;
        };
      };
};

export type ActionFragment = {
  id: number;
  created_at: string;
  implementation_to: string;
  order: number;
  custom_action_type_id?: custom_action_type_enum | null;
  custom_name?: string | null;
  custom_saving_fraction?: number | null;
  bulk_action_id?: number | null;
  bulk_action?: { name: string } | null;
  renovations: Array<{
    renovation_type_id: renovation_type_enum;
    cost_total?: number | null;
    cost_total_predium?: number | null;
    cost_total_custom?: number | null;
    use_custom_cost: boolean;
  }>;
  renovations_energy_consumer: Array<{
    new_energy_consumer?: {
      name?: string | null;
      id: number;
      energy_consumer_type_id: energy_consumer_type_enum;
      energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
      construction_year?: number | null;
      efficiency?: number | null;
      energy_system_consumer_routes: Array<{
        id: number;
        secondary_id: string;
        energy_source_type_id: energy_source_type_enum;
        energy_final: number;
        energy_system: { energy_system_type_id: energy_system_type_enum };
      }>;
    } | null;
    old_energy_consumer?: {
      name?: string | null;
      id: number;
      energy_consumer_type_id: energy_consumer_type_enum;
      energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
      construction_year?: number | null;
      efficiency?: number | null;
      energy_system_consumer_routes: Array<{
        id: number;
        secondary_id: string;
        energy_source_type_id: energy_source_type_enum;
        energy_final: number;
        energy_system: { energy_system_type_id: energy_system_type_enum };
      }>;
    } | null;
  }>;
  renovations_envelope: Array<{
    old_entity_id?: number | null;
    new_envelope?: {
      id: number;
      secondary_id: string;
      area: number;
      envelope_type_id: envelope_type_enum;
      insulation_material_name?: string | null;
      u_value?: number | null;
      insulation_lambda?: number | null;
      insulation_method_id?: insulation_method_enum | null;
      insulation_thickness?: number | null;
      insulation_material_category_id?: insulation_material_category_enum | null;
    } | null;
    old_envelope?: {
      id: number;
      secondary_id: string;
      building_model: {
        envelope_units: Array<{
          id: number;
          secondary_id: string;
          area: number;
          envelope_type_id: envelope_type_enum;
          insulation_material_name?: string | null;
          u_value?: number | null;
          insulation_thickness?: number | null;
          orientation?: number | null;
          inclination?: number | null;
        }>;
      };
    } | null;
  }>;
  renovations_energy_routes: Array<{
    new_energy_system_route?: {
      id: number;
      energy_source_type_id: energy_source_type_enum;
      energy_system: { energy_system_type_id: energy_system_type_enum };
    } | null;
    old_energy_system_route?: {
      id: number;
      energy_source_type_id: energy_source_type_enum;
      energy_system: { energy_system_type_id: energy_system_type_enum };
    } | null;
  }>;
  renovations_energy_producer: Array<{
    new_energy_producer?: {
      name?: string | null;
      nominal_power?: number | null;
      module_peak_power?: number | null;
      module_angle?: number | null;
      solar_active_area?: number | null;
      roof_area_ratio?: number | null;
    } | null;
  }>;
  building_models: Array<{
    id: number;
    energy_final?: number | null;
    energy_primary?: number | null;
    heating_demand?: number | null;
    heat_transfer_by_ventilation: number;
    building?: { id: number; year_constructed: number } | null;
    envelope_units: Array<{
      id: number;
      secondary_id: string;
      area: number;
      envelope_type_id: envelope_type_enum;
      insulation_material_name?: string | null;
      u_value?: number | null;
      insulation_thickness?: number | null;
      orientation?: number | null;
      inclination?: number | null;
    }>;
    energy_consumers: Array<{
      id: number;
      energy_consumer_type_id: energy_consumer_type_enum;
      energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
      efficiency?: number | null;
      energy_system_consumer_routes: Array<{
        energy_final: number;
        energy_system: { energy_system_type_id: energy_system_type_enum };
      }>;
    }>;
    energy_distributions: Array<{
      id: number;
      heat_transfer_loss: number;
      last_hydraulic_balancing?: string | null;
      last_balancing_set_to_never: boolean;
      balancing_with_components: boolean;
    }>;
    energy_systems: Array<{
      id: number;
      secondary_id: string;
      energy_system_type_id: energy_system_type_enum;
      energy_system_consumer_routes: Array<{
        id: number;
        secondary_id: string;
        energy_final: number;
        energy_source_type_id: energy_source_type_enum;
        energy_consumer?: {
          name?: string | null;
          id: number;
          energy_consumer_type_id: energy_consumer_type_enum;
          energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
          construction_year?: number | null;
          efficiency?: number | null;
          energy_system_consumer_routes: Array<{
            id: number;
            secondary_id: string;
            energy_source_type_id: energy_source_type_enum;
            energy_final: number;
            energy_system: { energy_system_type_id: energy_system_type_enum };
          }>;
        } | null;
        energy_distribution?: {
          id: number;
          last_hydraulic_balancing?: string | null;
          last_balancing_set_to_never: boolean;
          heat_transfer_loss: number;
          balancing_with_components: boolean;
        } | null;
      }>;
      energy_system_producer_routes: Array<{
        energy_source_type_id: energy_source_type_enum;
        energy_producer: { nominal_power?: number | null };
      }>;
    }>;
  }>;
  parameters:
    | {
        __typename: 'CreateVentilationRenovationParametersUnionMember';
        createVentilationRenovationParameters: {
          consumer_technology_type: ventilation_supported_technology_enum;
          final_energy: number;
          efficiency?: number | null;
          number_of_units?: number | null;
        };
      }
    | {
        __typename: 'CustomActionParametersUnionMember';
        customActionParameters:
          | {
              __typename: 'EnergySourceCustomActionParametersUnionMember';
              energySourceCustomActionParameters: {
                custom_name: string;
                renovation_ids?: Array<string> | null;
                fraction: number;
                energy_source_type: energy_source_type_enum;
              };
            }
          | {
              __typename: 'SystemCustomActionParametersUnionMember';
              systemCustomActionParameters: {
                system_type: energy_system_type_enum;
                renovation_ids?: Array<string> | null;
                fraction: number;
                custom_name: string;
              };
            };
      }
    | {
        __typename: 'EnergySystemRouteParametersUnionMember';
        energySystemRouteParameters: {
          energy_source_type: energy_source_type_enum;
          emission_certificate_id?: number | null;
        };
      }
    | {
        __typename: 'EnvelopeParametersUnionMember';
        envelopeParameters: {
          u_value?: number | null;
          renovation_ids?: Array<string> | null;
          material_name: string;
          insulation_thickness?: number | null;
          insulation_method?: insulation_method_enum | null;
          insulation_material_category?: insulation_material_category_enum | null;
          insulation_lambda?: number | null;
          envelope_type: envelope_type_enum;
        };
      }
    | { __typename: 'ExclusionNoteParametersUnionMember'; exclusionNoteParameters: { note: string } }
    | {
        __typename: 'HydraulicBalancingParametersUnionMember';
        hydraulicBalancingParameters: { last_hydraulic_balancing: DateTime; costs_with_components?: boolean | null };
      }
    | { __typename: 'MaintenanceActionParametersUnionMember'; maintenanceActionParameters: { custom_name: string } }
    | {
        __typename: 'SolarParametersUnionMember';
        solarParameters: {
          technology_name: string;
          solar_active_area: number;
          roof_area_ratio: number;
          module_peak_power: number;
          module_angle: number;
        };
      }
    | {
        __typename: 'SystemParametersUnionMember';
        systemParameters: {
          consumer_technology_type: energy_consumer_technology_type_enum;
          efficiency: number;
          energy_source_type: energy_source_type_enum;
          renovation_ids?: Array<string> | null;
          system_type: energy_system_type_enum;
          technology_name: string;
          emission_certificate_id?: number | null;
        };
      }
    | {
        __typename: 'VentilationRenovationParametersUnionMember';
        ventilationRenovationParameters: {
          renovation_ids?: Array<string> | null;
          consumer_technology_type: ventilation_supported_technology_enum;
          final_energy: number;
          efficiency?: number | null;
          number_of_units?: number | null;
        };
      };
};

export type EnergySystemRouteRenovationParameterObjectFragment = {
  energy_source_type: energy_source_type_enum;
  emission_certificate_id?: number | null;
};

export type EnvelopeRenovationParameterObjectFragment = {
  u_value?: number | null;
  renovation_ids?: Array<string> | null;
  material_name: string;
  insulation_thickness?: number | null;
  insulation_method?: insulation_method_enum | null;
  insulation_material_category?: insulation_material_category_enum | null;
  insulation_lambda?: number | null;
  envelope_type: envelope_type_enum;
};

export type HydraulicBalancingRenovationParameterObjectFragment = {
  last_hydraulic_balancing: DateTime;
  costs_with_components?: boolean | null;
};

export type SolarRenovationParameterObjectFragment = {
  technology_name: string;
  solar_active_area: number;
  roof_area_ratio: number;
  module_peak_power: number;
  module_angle: number;
};

export type SystemRenovationParameterObjectFragment = {
  consumer_technology_type: energy_consumer_technology_type_enum;
  efficiency: number;
  energy_source_type: energy_source_type_enum;
  renovation_ids?: Array<string> | null;
  system_type: energy_system_type_enum;
  technology_name: string;
  emission_certificate_id?: number | null;
};

export type CreateVentilationRenovationParameterObjectFragment = {
  consumer_technology_type: ventilation_supported_technology_enum;
  final_energy: number;
  efficiency?: number | null;
  number_of_units?: number | null;
};

export type VentilationRenovationParameterObjectFragment = {
  renovation_ids?: Array<string> | null;
  consumer_technology_type: ventilation_supported_technology_enum;
  final_energy: number;
  efficiency?: number | null;
  number_of_units?: number | null;
};

export type ExclusionNoteParameterObjectFragment = { note: string };

export type ActionForRecommendedActionFragment = {
  id: number;
  implementation_to: string;
  renovations: Array<{ renovation_type_id: renovation_type_enum }>;
};

export type ActionPlanningActionSubsidyFragment = {
  id: number;
  type: action_subsidy_value_type_enum;
  value: number;
  subsidy: { id: number; title: string; categories: Array<{ subsidy_category_type: subsidy_category_type_enum }> };
  action: {
    id: number;
    renovations: Array<{
      cost_total?: number | null;
      cost_total_predium?: number | null;
      renovation_type_id: renovation_type_enum;
    }>;
  };
};

export type BeforeAfterImpactFragment = {
  after?: number | null;
  after_total?: number | null;
  before?: number | null;
  before_total?: number | null;
  impact?: number | null;
  impact_total?: number | null;
};

export type ModificationImpactCrremFragment = {
  analysisType: emission_factor_type_enum;
  co2_emissions: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  final_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  primary_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
  stranding_date: { before: DateTime; after?: DateTime | null; impact?: number | null };
  energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  heating_demand?: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  } | null;
};

export type ModificationImpactsNationalEnergyLawFragment = {
  analysisType: emission_factor_type_enum;
  co2_emissions: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  final_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  primary_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
  energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  heating_demand?: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  } | null;
};

export type RecommendedActionImpactOutputFragment = {
  analysisType: emission_factor_type_enum;
  total_estimated_cost: number;
  co2_abatement_costs: number;
  payback_period: number;
  co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  co2_emissions: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  efficiency_class: { after?: efficiency_class_enum | null; before?: efficiency_class_enum | null };
  energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  final_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  primary_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  stranding_date: { after?: DateTime | null; before: DateTime; impact?: number | null };
  heating_demand?: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  } | null;
};

export type RecommendedActionImpactNationalEnergyLawOutputFragment = {
  analysisType: emission_factor_type_enum;
  total_estimated_cost: number;
  co2_abatement_costs: number;
  payback_period: number;
  co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  co2_emissions: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  efficiency_class: { after?: efficiency_class_enum | null; before?: efficiency_class_enum | null };
  energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  final_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  primary_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  heating_demand?: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  } | null;
};

type RecommendedActionImpact_RecommendedActionImpactCrremOutput_Fragment = {
  analysisType: emission_factor_type_enum;
  total_estimated_cost: number;
  co2_abatement_costs: number;
  payback_period: number;
  co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  co2_emissions: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  efficiency_class: { after?: efficiency_class_enum | null; before?: efficiency_class_enum | null };
  energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  final_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  primary_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  stranding_date: { after?: DateTime | null; before: DateTime; impact?: number | null };
  heating_demand?: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  } | null;
};

type RecommendedActionImpact_RecommendedActionImpactNationalEnergyLawOutput_Fragment = {
  analysisType: emission_factor_type_enum;
  total_estimated_cost: number;
  co2_abatement_costs: number;
  payback_period: number;
  co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  co2_emissions: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  efficiency_class: { after?: efficiency_class_enum | null; before?: efficiency_class_enum | null };
  energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  final_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  primary_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  heating_demand?: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  } | null;
};

export type RecommendedActionImpactFragment =
  | RecommendedActionImpact_RecommendedActionImpactCrremOutput_Fragment
  | RecommendedActionImpact_RecommendedActionImpactNationalEnergyLawOutput_Fragment;

type ModificationImpacts_ModificationImpactCrrem_Fragment = {
  analysisType: emission_factor_type_enum;
  co2_emissions: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  final_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  primary_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
  stranding_date: { before: DateTime; after?: DateTime | null; impact?: number | null };
  energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  heating_demand?: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  } | null;
};

type ModificationImpacts_ModificationImpactNationalEnergyLaw_Fragment = {
  analysisType: emission_factor_type_enum;
  co2_emissions: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  final_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  primary_energy: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  };
  efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
  energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
  heating_demand?: {
    after?: number | null;
    after_total?: number | null;
    before?: number | null;
    before_total?: number | null;
    impact?: number | null;
    impact_total?: number | null;
  } | null;
};

export type ModificationImpactsFragment =
  | ModificationImpacts_ModificationImpactCrrem_Fragment
  | ModificationImpacts_ModificationImpactNationalEnergyLaw_Fragment;

export type ActionImpactDataOutputFragment = {
  action_id: number;
  total_renovation_cost: number;
  total_subsidy_cost: number;
  total_estimated_cost: number;
  total_floor_area?: number | null;
  payback_period: number;
  co2_abatement_costs: number;
  modification_impact:
    | {
        analysisType: emission_factor_type_enum;
        co2_emissions: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        final_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        primary_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
        stranding_date: { before: DateTime; after?: DateTime | null; impact?: number | null };
        energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        heating_demand?: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        } | null;
      }
    | {
        analysisType: emission_factor_type_enum;
        co2_emissions: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        final_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        primary_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
        energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        heating_demand?: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        } | null;
      };
};

export type ActionPlanImpactDataOutputFragment = {
  total_renovation_cost: number;
  total_subsidy_cost: number;
  total_estimated_cost: number;
  total_floor_area?: number | null;
  cost_by_renovation_category?: {
    startYear: number;
    series: Array<{ name: renovation_category_enum; data: { values: Array<number>; actionsCount: Array<number> } }>;
    legend: Array<{ name: renovation_category_enum; value: number; percentage: number; actionsCount: number }>;
  } | null;
  modification_impact:
    | {
        analysisType: emission_factor_type_enum;
        co2_emissions: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        final_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        primary_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
        stranding_date: { before: DateTime; after?: DateTime | null; impact?: number | null };
        energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        heating_demand?: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        } | null;
      }
    | {
        analysisType: emission_factor_type_enum;
        co2_emissions: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        final_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        primary_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
        energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        heating_demand?: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        } | null;
      };
};

export type ActionPlanMetricsFragment = {
  action_plan: {
    total_renovation_cost: number;
    total_subsidy_cost: number;
    total_estimated_cost: number;
    total_floor_area?: number | null;
    cost_by_renovation_category?: {
      startYear: number;
      series: Array<{ name: renovation_category_enum; data: { values: Array<number>; actionsCount: Array<number> } }>;
      legend: Array<{ name: renovation_category_enum; value: number; percentage: number; actionsCount: number }>;
    } | null;
    modification_impact:
      | {
          analysisType: emission_factor_type_enum;
          co2_emissions: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          final_energy: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          primary_energy: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
          stranding_date: { before: DateTime; after?: DateTime | null; impact?: number | null };
          energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
          co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
          heating_demand?: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          } | null;
        }
      | {
          analysisType: emission_factor_type_enum;
          co2_emissions: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          final_energy: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          primary_energy: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
          energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
          co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
          heating_demand?: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          } | null;
        };
  };
  actions: Array<{
    action_id: number;
    total_renovation_cost: number;
    total_subsidy_cost: number;
    total_estimated_cost: number;
    total_floor_area?: number | null;
    payback_period: number;
    co2_abatement_costs: number;
    modification_impact:
      | {
          analysisType: emission_factor_type_enum;
          co2_emissions: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          final_energy: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          primary_energy: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
          stranding_date: { before: DateTime; after?: DateTime | null; impact?: number | null };
          energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
          co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
          heating_demand?: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          } | null;
        }
      | {
          analysisType: emission_factor_type_enum;
          co2_emissions: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          final_energy: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          primary_energy: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          };
          efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
          energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
          co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
          heating_demand?: {
            after?: number | null;
            after_total?: number | null;
            before?: number | null;
            before_total?: number | null;
            impact?: number | null;
            impact_total?: number | null;
          } | null;
        };
  }>;
};

export type ActionPlanningActionPlanActionPlanForCompareFragment = {
  stable_id: number;
  created_at: string;
  scenario_version: {
    cost_version: { status: cost_version_status_enum; version: string; valid_from: string };
    scenario: {
      name: string;
      id: number;
      owner: { first_name?: string | null; last_name?: string | null; id: number };
      portfolio?: { id: number; name: string } | null;
    };
  };
  building: { id: number; address: { street: string; postal_code: string; city: string } };
};

export type ActionPlanningActionPlanActionPlanFragment = {
  stable_id: number;
  created_at: string;
  scenario_version: { scenario: { id: number } };
  action_plan_inconsistencies: { energy_supplier_inconsistencies: Array<emission_certificate_energy_source_type_enum> };
  building: {
    id: number;
    description: string;
    monument_protection: boolean;
    year_constructed: number;
    units: number;
    address: { street: string; city: string; country_id: country_enum; postal_code: string };
    areas: Array<{
      value: number;
      type_of_use_id: type_of_use_enum;
      area_type_id: area_type_enum;
      class_of_use_id: class_of_use_enum;
    }>;
    active_building_model?: {
      id: number;
      energy_final?: number | null;
      energy_primary?: number | null;
      heating_demand?: number | null;
      heat_transfer_by_ventilation: number;
      building?: { id: number; year_constructed: number } | null;
      envelope_units: Array<{
        id: number;
        secondary_id: string;
        area: number;
        envelope_type_id: envelope_type_enum;
        insulation_material_name?: string | null;
        u_value?: number | null;
        insulation_thickness?: number | null;
        orientation?: number | null;
        inclination?: number | null;
      }>;
      energy_consumers: Array<{
        id: number;
        energy_consumer_type_id: energy_consumer_type_enum;
        energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
        efficiency?: number | null;
        energy_system_consumer_routes: Array<{
          energy_final: number;
          energy_system: { energy_system_type_id: energy_system_type_enum };
        }>;
      }>;
      energy_distributions: Array<{
        id: number;
        heat_transfer_loss: number;
        last_hydraulic_balancing?: string | null;
        last_balancing_set_to_never: boolean;
        balancing_with_components: boolean;
      }>;
      energy_systems: Array<{
        id: number;
        secondary_id: string;
        energy_system_type_id: energy_system_type_enum;
        energy_system_consumer_routes: Array<{
          id: number;
          secondary_id: string;
          energy_final: number;
          energy_source_type_id: energy_source_type_enum;
          energy_consumer?: {
            name?: string | null;
            id: number;
            energy_consumer_type_id: energy_consumer_type_enum;
            energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
            construction_year?: number | null;
            efficiency?: number | null;
            energy_system_consumer_routes: Array<{
              id: number;
              secondary_id: string;
              energy_source_type_id: energy_source_type_enum;
              energy_final: number;
              energy_system: { energy_system_type_id: energy_system_type_enum };
            }>;
          } | null;
          energy_distribution?: {
            id: number;
            last_hydraulic_balancing?: string | null;
            last_balancing_set_to_never: boolean;
            heat_transfer_loss: number;
            balancing_with_components: boolean;
          } | null;
        }>;
        energy_system_producer_routes: Array<{
          energy_source_type_id: energy_source_type_enum;
          energy_producer: { nominal_power?: number | null };
        }>;
      }>;
    } | null;
    base_emission_factors: {
      BIO_GAS: Array<{ factor: number; year: number }>;
      COAL: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_CHP_FOSSIL_COAL: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_CHP_FOSSIL_GAS: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_CHP_RENEWABLE: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_PLANTS_FOSSIL_COAL: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_PLANTS_FOSSIL_GAS: Array<{ factor: number; year: number }>;
      ELECTRICITY_GREEN: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_PLANTS_RENEWABLE: Array<{ factor: number; year: number }>;
      ELECTRICITY_MIX: Array<{ factor: number; year: number }>;
      WOODEN_PELLETS: Array<{ factor: number; year: number }>;
      WOOD: Array<{ factor: number; year: number }>;
      UNSPECIFIED: Array<{ factor: number; year: number }>;
      SOLAR: Array<{ factor: number; year: number }>;
      LPG: Array<{ factor: number; year: number }>;
      NATURAL_GAS: Array<{ factor: number; year: number }>;
      LIGNITE: Array<{ factor: number; year: number }>;
      FUEL_OIL: Array<{ factor: number; year: number }>;
    };
    subsidies: Array<{
      subsidy: {
        __typename: 'subsidy';
        id: number;
        email?: string | null;
        amount_description: string;
        provider_updated_at: string;
        region_type: subsidy_region_type_enum;
        title: string;
        type: subsidy_type_enum;
        url?: string | null;
        categories: Array<{ subsidy_category_type: subsidy_category_type_enum }>;
      };
    }>;
    district_heating_availability_status?: {
      district_heating_status?: string | null;
      district_heating_year?: number | null;
      id?: number | null;
    } | null;
    economic_unit: { portfolio: { name: string } };
  };
};

export type EnergySystemRouteRenovationParameterFragment = {
  __typename: 'EnergySystemRouteRenovationParameterOutput';
  energy_source_type: energy_source_type_enum;
};

export type EnvelopeRenovationParameterFragment = {
  __typename: 'EnvelopeRenovationParameterOutput';
  envelope_type: envelope_type_enum;
  insulation_lambda?: number | null;
  insulation_material_category?: insulation_material_category_enum | null;
  insulation_method?: insulation_method_enum | null;
  insulation_thickness?: number | null;
  material_name: string;
  u_value?: number | null;
};

export type HydraulicBalancingRenovationParameterFragment = {
  __typename: 'HydraulicBalancingRenovationParameterOutput';
  costs_with_components?: boolean | null;
  last_hydraulic_balancing: DateTime;
};

export type CreateVentilationRenovationParameterFragment = {
  __typename: 'CreateVentilationRenovationParameterOutput';
  ventilation_consumer_technology_type: ventilation_supported_technology_enum;
  final_energy: number;
  ventilation_efficiency?: number | null;
  number_of_units?: number | null;
};

export type UpdateVentilationRenovationParameterFragment = {
  __typename: 'UpdateVentilationRenovationParameterOutput';
  renovation_ids?: Array<string> | null;
  ventilation_consumer_technology_type: ventilation_supported_technology_enum;
  final_energy: number;
  ventilation_efficiency?: number | null;
  number_of_units?: number | null;
};

export type SolarRenovationParameterFragment = {
  __typename: 'SolarRenovationParameterOutput';
  module_angle: number;
  module_peak_power: number;
  roof_area_ratio: number;
  solar_active_area: number;
  technology_name: string;
};

export type SystemRenovationParameterFragment = {
  __typename: 'SystemRenovationParameterOutput';
  consumer_technology_type: energy_consumer_technology_type_enum;
  efficiency: number;
  energy_source_type: energy_source_type_enum;
  system_type: energy_system_type_enum;
  technology_name: string;
};

export type RecommendedActionFragment = {
  __typename: 'RecommendedAction';
  actionImpact:
    | {
        analysisType: emission_factor_type_enum;
        total_estimated_cost: number;
        co2_abatement_costs: number;
        payback_period: number;
        co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        co2_emissions: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        efficiency_class: { after?: efficiency_class_enum | null; before?: efficiency_class_enum | null };
        energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        final_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        primary_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        stranding_date: { after?: DateTime | null; before: DateTime; impact?: number | null };
        heating_demand?: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        } | null;
      }
    | {
        analysisType: emission_factor_type_enum;
        total_estimated_cost: number;
        co2_abatement_costs: number;
        payback_period: number;
        co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        co2_emissions: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        efficiency_class: { after?: efficiency_class_enum | null; before?: efficiency_class_enum | null };
        energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
        final_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        primary_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        heating_demand?: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        } | null;
      };
  parameters:
    | {
        __typename: 'CreateVentilationRenovationParameterOutput';
        ventilation_consumer_technology_type: ventilation_supported_technology_enum;
        final_energy: number;
        ventilation_efficiency?: number | null;
        number_of_units?: number | null;
      }
    | { __typename: 'EnergySystemRouteRenovationParameterOutput'; energy_source_type: energy_source_type_enum }
    | {
        __typename: 'EnvelopeRenovationParameterOutput';
        envelope_type: envelope_type_enum;
        insulation_lambda?: number | null;
        insulation_material_category?: insulation_material_category_enum | null;
        insulation_method?: insulation_method_enum | null;
        insulation_thickness?: number | null;
        material_name: string;
        u_value?: number | null;
      }
    | {
        __typename: 'HydraulicBalancingRenovationParameterOutput';
        costs_with_components?: boolean | null;
        last_hydraulic_balancing: DateTime;
      }
    | {
        __typename: 'SolarRenovationParameterOutput';
        module_angle: number;
        module_peak_power: number;
        roof_area_ratio: number;
        solar_active_area: number;
        technology_name: string;
      }
    | {
        __typename: 'SystemRenovationParameterOutput';
        consumer_technology_type: energy_consumer_technology_type_enum;
        efficiency: number;
        energy_source_type: energy_source_type_enum;
        system_type: energy_system_type_enum;
        technology_name: string;
      }
    | {
        __typename: 'UpdateVentilationRenovationParameterOutput';
        renovation_ids?: Array<string> | null;
        ventilation_consumer_technology_type: ventilation_supported_technology_enum;
        final_energy: number;
        ventilation_efficiency?: number | null;
        number_of_units?: number | null;
      };
};

export type AnalyzedScenarioFragment = {
  building_count?: number | null;
  cost_total?: number | null;
  co2_abatement_cost?: number | null;
  total_floor_area?: number | null;
  modification_impact: {
    final_energy: {
      after?: number | null;
      after_total?: number | null;
      before?: number | null;
      before_total?: number | null;
      impact?: number | null;
      impact_total?: number | null;
    };
    co2_emissions: {
      after?: number | null;
      after_total?: number | null;
      before?: number | null;
      before_total?: number | null;
      impact?: number | null;
      impact_total?: number | null;
    };
    primary_energy: {
      after?: number | null;
      after_total?: number | null;
      before?: number | null;
      before_total?: number | null;
      impact?: number | null;
      impact_total?: number | null;
    };
  };
};

export type BulkActionParametersFragment = {
  custom_costs?: number | null;
  custom_costs_per_m2?: number | null;
  params:
    | {
        __typename: 'CreateVentilationRenovationParametersUnionMember';
        createVentilationRenovationParameters: {
          consumer_technology_type: ventilation_supported_technology_enum;
          efficiency?: number | null;
          final_energy: number;
          number_of_units?: number | null;
        };
      }
    | {
        __typename: 'CustomBulkActionParametersUnionMember';
        customActionParameters:
          | {
              __typename: 'EnergySourceCustomBulkActionParametersUnionMember';
              energySourceCustomActionParameters: {
                custom_name: string;
                energy_source_type: energy_source_type_enum;
                fraction: number;
              };
            }
          | {
              __typename: 'SystemCustomBulkActionParametersUnionMember';
              systemCustomActionParameters: {
                custom_name: string;
                fraction: number;
                system_type: energy_system_type_enum;
              };
            };
      }
    | {
        __typename: 'EnergySystemRouteParametersBulkUnionMember';
        energySystemRouteParameters: {
          energy_source_type: energy_source_type_enum;
          emission_certificate_id?: number | null;
        };
      }
    | {
        __typename: 'EnvelopeParametersBulkUnionMember';
        envelopeParameters: {
          envelope_type: envelope_type_enum;
          insulation_lambda?: number | null;
          insulation_material_category?: insulation_material_category_enum | null;
          insulation_method?: insulation_method_enum | null;
          insulation_thickness?: number | null;
          material_name: string;
          u_value?: number | null;
        };
      }
    | { __typename: 'ExclusionNoteParametersUnionMember'; exclusionNoteParameters: { note: string } }
    | {
        __typename: 'HydraulicBalancingParametersBulkUnionMember';
        hydraulicBalancingParameters: { costs_with_components?: boolean | null; last_hydraulic_balancing: DateTime };
      }
    | { __typename: 'LightingParametersBulkUnionMember'; lightingParameters: { efficiency: number } }
    | { __typename: 'MaintenanceActionParametersUnionMember'; maintenanceActionParameters: { custom_name: string } }
    | {
        __typename: 'SolarParametersBulkUnionMember';
        solarParameters: {
          module_angle: number;
          module_peak_power: number;
          roof_area_ratio: number;
          technology_name: string;
        };
      }
    | {
        __typename: 'SystemParametersBulkUnionMember';
        systemParameters: {
          consumer_technology_type: energy_consumer_technology_type_enum;
          efficiency: number;
          energy_source_type: energy_source_type_enum;
          system_type: energy_system_type_enum;
          technology_name: string;
          emission_certificate_id?: number | null;
        };
      }
    | {
        __typename: 'VentilationRenovationParametersUnionMember';
        ventilationRenovationParameters: {
          consumer_technology_type: ventilation_supported_technology_enum;
          efficiency?: number | null;
          final_energy: number;
          number_of_units?: number | null;
          renovation_ids?: Array<string> | null;
        };
      };
};

export type BulkActionParametersForTableFragment = {
  params:
    | { __typename: 'CreateVentilationRenovationParametersUnionMember' }
    | {
        __typename: 'CustomBulkActionParametersUnionMember';
        customActionParameters:
          | {
              __typename: 'EnergySourceCustomBulkActionParametersUnionMember';
              energySourceCustomActionParameters: { custom_name: string };
            }
          | {
              __typename: 'SystemCustomBulkActionParametersUnionMember';
              systemCustomActionParameters: { custom_name: string };
            };
      }
    | {
        __typename: 'EnergySystemRouteParametersBulkUnionMember';
        energySystemRouteParameters: { energy_source_type: energy_source_type_enum };
      }
    | { __typename: 'EnvelopeParametersBulkUnionMember'; envelopeParameters: { envelope_type: envelope_type_enum } }
    | { __typename: 'ExclusionNoteParametersUnionMember'; exclusionNoteParameters: { note: string } }
    | { __typename: 'HydraulicBalancingParametersBulkUnionMember' }
    | { __typename: 'LightingParametersBulkUnionMember' }
    | { __typename: 'MaintenanceActionParametersUnionMember'; maintenanceActionParameters: { custom_name: string } }
    | { __typename: 'SolarParametersBulkUnionMember' }
    | {
        __typename: 'SystemParametersBulkUnionMember';
        systemParameters: { system_type: energy_system_type_enum; technology_name: string };
      }
    | { __typename: 'VentilationRenovationParametersUnionMember' };
};

export type ActionPlanImpactTrendsWithTargetPathOutputFragment = {
  type: action_plan_impact_type_enum;
  after_actions_path: Array<number>;
  before_actions_path: Array<number>;
  target_path: Array<number>;
  exclusion_note_implementation_year?: number | null;
  annotations: Array<{
    action_id?: number | null;
    annotation_type: action_plan_impact_trends_annotation_enum;
    value: number;
    year: number;
  }>;
  stranding_ranges: Array<{ end_year: number; start_year: number }>;
};

export type ActionPlanImpactTrendsWithoutTargetPathOutputFragment = {
  type: action_plan_impact_type_enum;
  after_actions_path: Array<number>;
  before_actions_path: Array<number>;
  exclusion_note_implementation_year?: number | null;
  annotations: Array<{
    action_id?: number | null;
    annotation_type: action_plan_impact_trends_annotation_enum;
    value: number;
    year: number;
  }>;
};

export type EmissionCertificateFragment = {
  issuer: string;
  emission_factor: number;
  primary_energy_factor?: number | null;
  id: number;
  emission_certificate_energy_source_type_id?: emission_certificate_energy_source_type_enum | null;
  created_at: string;
};

export type GetSearchBuildingsForCreateActionPlanQueryVariables = Exact<{
  search_string?: InputMaybe<Scalars['String']['input']>;
  portfolio_ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<BuildingOrderByInput>;
  scenario_id: Scalars['Int']['input'];
  include_new_construction?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetSearchBuildingsForCreateActionPlanQuery = {
  searchBuildingsForCreateActionPlan: {
    count: number;
    buildings: Array<{
      id: number;
      street: string;
      city: string;
      postal_code: string;
      is_new_construction: boolean;
      has_energy_data: boolean;
      action_planning_available: boolean;
      efficiency_class?: efficiency_class_enum | null;
    }>;
  };
};

export type ActionPlanningActionPlanGetActionPlanQueryVariables = Exact<{
  actionPlanStableId: Scalars['Int']['input'];
}>;

export type ActionPlanningActionPlanGetActionPlanQuery = {
  getActionPlanByStableId: {
    action_plan?: {
      stable_id: number;
      created_at: string;
      scenario_version: { scenario: { id: number } };
      action_plan_inconsistencies: {
        energy_supplier_inconsistencies: Array<emission_certificate_energy_source_type_enum>;
      };
      building: {
        id: number;
        description: string;
        monument_protection: boolean;
        year_constructed: number;
        units: number;
        address: { street: string; city: string; country_id: country_enum; postal_code: string };
        areas: Array<{
          value: number;
          type_of_use_id: type_of_use_enum;
          area_type_id: area_type_enum;
          class_of_use_id: class_of_use_enum;
        }>;
        active_building_model?: {
          id: number;
          energy_final?: number | null;
          energy_primary?: number | null;
          heating_demand?: number | null;
          heat_transfer_by_ventilation: number;
          building?: { id: number; year_constructed: number } | null;
          envelope_units: Array<{
            id: number;
            secondary_id: string;
            area: number;
            envelope_type_id: envelope_type_enum;
            insulation_material_name?: string | null;
            u_value?: number | null;
            insulation_thickness?: number | null;
            orientation?: number | null;
            inclination?: number | null;
          }>;
          energy_consumers: Array<{
            id: number;
            energy_consumer_type_id: energy_consumer_type_enum;
            energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
            efficiency?: number | null;
            energy_system_consumer_routes: Array<{
              energy_final: number;
              energy_system: { energy_system_type_id: energy_system_type_enum };
            }>;
          }>;
          energy_distributions: Array<{
            id: number;
            heat_transfer_loss: number;
            last_hydraulic_balancing?: string | null;
            last_balancing_set_to_never: boolean;
            balancing_with_components: boolean;
          }>;
          energy_systems: Array<{
            id: number;
            secondary_id: string;
            energy_system_type_id: energy_system_type_enum;
            energy_system_consumer_routes: Array<{
              id: number;
              secondary_id: string;
              energy_final: number;
              energy_source_type_id: energy_source_type_enum;
              energy_consumer?: {
                name?: string | null;
                id: number;
                energy_consumer_type_id: energy_consumer_type_enum;
                energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
                construction_year?: number | null;
                efficiency?: number | null;
                energy_system_consumer_routes: Array<{
                  id: number;
                  secondary_id: string;
                  energy_source_type_id: energy_source_type_enum;
                  energy_final: number;
                  energy_system: { energy_system_type_id: energy_system_type_enum };
                }>;
              } | null;
              energy_distribution?: {
                id: number;
                last_hydraulic_balancing?: string | null;
                last_balancing_set_to_never: boolean;
                heat_transfer_loss: number;
                balancing_with_components: boolean;
              } | null;
            }>;
            energy_system_producer_routes: Array<{
              energy_source_type_id: energy_source_type_enum;
              energy_producer: { nominal_power?: number | null };
            }>;
          }>;
        } | null;
        base_emission_factors: {
          BIO_GAS: Array<{ factor: number; year: number }>;
          COAL: Array<{ factor: number; year: number }>;
          DISTRICT_HEATING_CHP_FOSSIL_COAL: Array<{ factor: number; year: number }>;
          DISTRICT_HEATING_CHP_FOSSIL_GAS: Array<{ factor: number; year: number }>;
          DISTRICT_HEATING_CHP_RENEWABLE: Array<{ factor: number; year: number }>;
          DISTRICT_HEATING_PLANTS_FOSSIL_COAL: Array<{ factor: number; year: number }>;
          DISTRICT_HEATING_PLANTS_FOSSIL_GAS: Array<{ factor: number; year: number }>;
          ELECTRICITY_GREEN: Array<{ factor: number; year: number }>;
          DISTRICT_HEATING_PLANTS_RENEWABLE: Array<{ factor: number; year: number }>;
          ELECTRICITY_MIX: Array<{ factor: number; year: number }>;
          WOODEN_PELLETS: Array<{ factor: number; year: number }>;
          WOOD: Array<{ factor: number; year: number }>;
          UNSPECIFIED: Array<{ factor: number; year: number }>;
          SOLAR: Array<{ factor: number; year: number }>;
          LPG: Array<{ factor: number; year: number }>;
          NATURAL_GAS: Array<{ factor: number; year: number }>;
          LIGNITE: Array<{ factor: number; year: number }>;
          FUEL_OIL: Array<{ factor: number; year: number }>;
        };
        subsidies: Array<{
          subsidy: {
            __typename: 'subsidy';
            id: number;
            email?: string | null;
            amount_description: string;
            provider_updated_at: string;
            region_type: subsidy_region_type_enum;
            title: string;
            type: subsidy_type_enum;
            url?: string | null;
            categories: Array<{ subsidy_category_type: subsidy_category_type_enum }>;
          };
        }>;
        district_heating_availability_status?: {
          district_heating_status?: string | null;
          district_heating_year?: number | null;
          id?: number | null;
        } | null;
        economic_unit: { portfolio: { name: string } };
      };
    } | null;
  };
};

export type ActionPlanningActionPlanGetActionPlanForCompareQueryVariables = Exact<{
  actionPlanStableId: Scalars['Int']['input'];
}>;

export type ActionPlanningActionPlanGetActionPlanForCompareQuery = {
  getActionPlanByStableId: {
    action_plan?: {
      stable_id: number;
      created_at: string;
      scenario_version: {
        cost_version: { status: cost_version_status_enum; version: string; valid_from: string };
        scenario: {
          name: string;
          id: number;
          owner: { first_name?: string | null; last_name?: string | null; id: number };
          portfolio?: { id: number; name: string } | null;
        };
      };
      building: { id: number; address: { street: string; postal_code: string; city: string } };
    } | null;
  };
};

export type ActionPlanProcessingSubscriptionSubscriptionVariables = Exact<{
  actionPlanIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type ActionPlanProcessingSubscriptionSubscription = {
  action_plan: Array<{ stable_id: number; processing: boolean }>;
};

export type ActionPlanningGetSubsidiesQueryVariables = Exact<{
  actionPlanStableId: Scalars['Int']['input'];
}>;

export type ActionPlanningGetSubsidiesQuery = {
  getActionPlanByStableId: {
    action_plan?: {
      actions: Array<{
        subsidies: Array<{
          id: number;
          type: action_subsidy_value_type_enum;
          value: number;
          subsidy: {
            id: number;
            title: string;
            categories: Array<{ subsidy_category_type: subsidy_category_type_enum }>;
          };
          action: {
            id: number;
            renovations: Array<{
              cost_total?: number | null;
              cost_total_predium?: number | null;
              renovation_type_id: renovation_type_enum;
            }>;
          };
        }>;
      }>;
    } | null;
  };
};

export type ActionPlanningScenarioGetScenarioCostUpdateSubscriptionSubscriptionVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
}>;

export type ActionPlanningScenarioGetScenarioCostUpdateSubscriptionSubscription = {
  scenario_by_pk?: {
    cost_update_in_progress: boolean;
    scenario_versions: Array<{ cost_version: { version: string; status: cost_version_status_enum } }>;
  } | null;
};

export type DuplicateScenarioSubscriptionSubscriptionVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
}>;

export type DuplicateScenarioSubscriptionSubscription = {
  scenario_by_pk?: { duplication_in_progress: boolean } | null;
};

export type GetActionPlanListQueryVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ActionPlanListOrderByInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  buildingWhere?: InputMaybe<BuildingWhere>;
}>;

export type GetActionPlanListQuery = {
  getActionPlanList: {
    count: number;
    action_plans: Array<{
      id: number;
      modification_impact: {
        co2_emissions: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        final_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        primary_energy: {
          after?: number | null;
          after_total?: number | null;
          before?: number | null;
          before_total?: number | null;
          impact?: number | null;
          impact_total?: number | null;
        };
        efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
      };
      action_plan?: {
        processing: boolean;
        stable_id: number;
        created_at: string;
        active_scenario?: { scenario?: { portfolio_id?: number | null } | null } | null;
        building: {
          id: number;
          description: string;
          has_write_permission: boolean;
          address: { street: string; city: string; postal_code: string; country_id: country_enum };
          areas: Array<{
            area_type_id: area_type_enum;
            type_of_use_id: type_of_use_enum;
            class_of_use_id: class_of_use_enum;
            value: number;
          }>;
          economic_unit: { portfolio_id: number };
        };
        actions_aggregate: {
          aggregate?: {
            count: number;
            max?: { updated_at?: string | null } | null;
            sum?: { cost_total?: number | null } | null;
          } | null;
          nodes: Array<{ implementation_to: string; renovations: Array<{ renovation_type_id: renovation_type_enum }> }>;
        };
      } | null;
    }>;
  };
};

export type ActionPlanningScenariosScenarioFragment = {
  id: number;
  name: string;
  action_plan_count: number;
  created_at: DateTime;
  description?: string | null;
  duplication_in_progress: boolean;
  is_archived: boolean;
  can_edit: boolean;
  total_investment?: number | null;
  owner: { id: number; first_name?: string | null; last_name?: string | null };
  portfolio?: { id: number; name: string } | null;
};

export type ActionPlanningScenariosAllScenariosQueryVariables = Exact<{
  where?: InputMaybe<ScenarioWhere>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ScenarioOrderByInput>;
}>;

export type ActionPlanningScenariosAllScenariosQuery = {
  getScenarioList: {
    count: number;
    scenarios: Array<{
      id: number;
      name: string;
      action_plan_count: number;
      created_at: DateTime;
      description?: string | null;
      duplication_in_progress: boolean;
      is_archived: boolean;
      can_edit: boolean;
      total_investment?: number | null;
      owner: { id: number; first_name?: string | null; last_name?: string | null };
      portfolio?: { id: number; name: string } | null;
    }>;
  };
};

export type ActionPlanningScenarioGetScenarioQueryVariables = Exact<{
  scenario_id: Scalars['Int']['input'];
}>;

export type ActionPlanningScenarioGetScenarioQuery = {
  getScenario: {
    id: number;
    name: string;
    description?: string | null;
    created_at: DateTime;
    updated_at: DateTime;
    duplication_in_progress: boolean;
    is_archived: boolean;
    building_count?: number | null;
    can_edit: boolean;
    owner: { id: number; first_name?: string | null; last_name?: string | null };
    portfolio?: { id: number; name: string } | null;
    scenario_versions: Array<{
      id: number;
      status: scenario_version_status_enum;
      cost_version?: { version: string; status: string; valid_from: DateTime } | null;
    }>;
  };
};

export type ActionPlanningScenariosByPortfolioIdQueryVariables = Exact<{
  where: scenario_bool_exp;
}>;

export type ActionPlanningScenariosByPortfolioIdQuery = { scenarios: Array<{ id: number; name: string }> };

export type GetScenarioActionPlanAndActionsCountsQueryVariables = Exact<{
  scenario_id: Scalars['Int']['input'];
}>;

export type GetScenarioActionPlanAndActionsCountsQuery = {
  getScenarioActionPlanAndActionsCounts: { action_plan_count: number; scenario_actions_count: number };
};

export type ActionPlanningScenariosGetPortfoliosWithScenariosQueryVariables = Exact<{ [key: string]: never }>;

export type ActionPlanningScenariosGetPortfoliosWithScenariosQuery = {
  scenario: Array<{ portfolio?: { id: number; name: string } | null }>;
};

export type ActionPlanningScenariosGetPortfoliosWithArchivedScenariosQueryVariables = Exact<{ [key: string]: never }>;

export type ActionPlanningScenariosGetPortfoliosWithArchivedScenariosQuery = {
  scenario: Array<{ portfolio?: { id: number; name: string } | null }>;
};

export type ActionPlanningScenariosNamesQueryVariables = Exact<{ [key: string]: never }>;

export type ActionPlanningScenariosNamesQuery = { scenario: Array<{ name: string; id: number }> };

export type SearchScenarioFragment = { id: number; name: string };

export type SearchActionPlanFragment = {
  stable_id: number;
  scenario_version: { scenario: { id: number; name: string } };
  building: {
    id: number;
    customer_external_identifier?: string | null;
    address: { street: string; city: string; postal_code: string };
  };
};

export type SearchScenariosQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  text: Scalars['String']['input'];
}>;

export type SearchScenariosQuery = { scenario: Array<{ id: number; name: string }> };

export type SearchActionPlansQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  text: Scalars['String']['input'];
}>;

export type SearchActionPlansQuery = {
  action_plan: Array<{
    stable_id: number;
    scenario_version: { scenario: { id: number; name: string } };
    building: {
      id: number;
      customer_external_identifier?: string | null;
      address: { street: string; city: string; postal_code: string };
    };
  }>;
};

export type GetAnalyzeScenarioQueryVariables = Exact<{
  scenario_id: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetAnalyzeScenarioQuery = {
  getAnalyzedScenario: {
    building_count?: number | null;
    cost_total?: number | null;
    co2_abatement_cost?: number | null;
    total_floor_area?: number | null;
    modification_impact: {
      final_energy: {
        after?: number | null;
        after_total?: number | null;
        before?: number | null;
        before_total?: number | null;
        impact?: number | null;
        impact_total?: number | null;
      };
      co2_emissions: {
        after?: number | null;
        after_total?: number | null;
        before?: number | null;
        before_total?: number | null;
        impact?: number | null;
        impact_total?: number | null;
      };
      primary_energy: {
        after?: number | null;
        after_total?: number | null;
        before?: number | null;
        before_total?: number | null;
        impact?: number | null;
        impact_total?: number | null;
      };
    };
  };
};

export type CreateActionPlanModalGetBuildingsQueryVariables = Exact<{
  where: building_bool_exp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<building_order_by> | building_order_by>;
}>;

export type CreateActionPlanModalGetBuildingsQuery = {
  building: Array<{
    __typename: 'building';
    id: number;
    address: {
      __typename: 'address';
      id: number;
      street: string;
      city: string;
      postal_code: string;
      country_id: country_enum;
    };
    active_building_model?: {
      id: number;
      action_planning_available: boolean;
      efficiency_class_id?: efficiency_class_enum | null;
    } | null;
  }>;
  building_aggregate: { aggregate?: { count: number } | null };
};

export type QueueExportActionPlanPdfMutationVariables = Exact<{
  actionPlanStableId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  useCustomTargetPath?: InputMaybe<Scalars['Boolean']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type QueueExportActionPlanPdfMutation = { queueExportActionPlanAsPdf: { asyncJobId: number } };

export type GetActionsPlanMetricsQueryVariables = Exact<{
  actionPlanStableId: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetActionsPlanMetricsQuery = {
  getActionPlanMetrics: {
    action_plan: {
      total_renovation_cost: number;
      total_subsidy_cost: number;
      total_estimated_cost: number;
      total_floor_area?: number | null;
      cost_by_renovation_category?: {
        startYear: number;
        series: Array<{ name: renovation_category_enum; data: { values: Array<number>; actionsCount: Array<number> } }>;
        legend: Array<{ name: renovation_category_enum; value: number; percentage: number; actionsCount: number }>;
      } | null;
      modification_impact:
        | {
            analysisType: emission_factor_type_enum;
            co2_emissions: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            final_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            primary_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
            stranding_date: { before: DateTime; after?: DateTime | null; impact?: number | null };
            energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            heating_demand?: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            } | null;
          }
        | {
            analysisType: emission_factor_type_enum;
            co2_emissions: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            final_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            primary_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
            energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            heating_demand?: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            } | null;
          };
    };
    actions: Array<{
      action_id: number;
      total_renovation_cost: number;
      total_subsidy_cost: number;
      total_estimated_cost: number;
      total_floor_area?: number | null;
      payback_period: number;
      co2_abatement_costs: number;
      modification_impact:
        | {
            analysisType: emission_factor_type_enum;
            co2_emissions: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            final_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            primary_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
            stranding_date: { before: DateTime; after?: DateTime | null; impact?: number | null };
            energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            heating_demand?: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            } | null;
          }
        | {
            analysisType: emission_factor_type_enum;
            co2_emissions: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            final_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            primary_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            efficiency_class: { before?: efficiency_class_enum | null; after?: efficiency_class_enum | null };
            energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            heating_demand?: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            } | null;
          };
    }>;
  };
};

export type GetActionsPlanImpactTrendsQueryVariables = Exact<{
  actionPlanStableId: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetActionsPlanImpactTrendsQuery = {
  getActionPlanImpactTrends: {
    trend_start_year: number;
    total_investment_cost: number;
    co2_emissions:
      | {
          type: action_plan_impact_type_enum;
          after_actions_path: Array<number>;
          before_actions_path: Array<number>;
          target_path: Array<number>;
          exclusion_note_implementation_year?: number | null;
          annotations: Array<{
            action_id?: number | null;
            annotation_type: action_plan_impact_trends_annotation_enum;
            value: number;
            year: number;
          }>;
          stranding_ranges: Array<{ end_year: number; start_year: number }>;
        }
      | {
          type: action_plan_impact_type_enum;
          after_actions_path: Array<number>;
          before_actions_path: Array<number>;
          exclusion_note_implementation_year?: number | null;
          annotations: Array<{
            action_id?: number | null;
            annotation_type: action_plan_impact_trends_annotation_enum;
            value: number;
            year: number;
          }>;
        };
    primary_energy: {
      after_actions_path: Array<number>;
      before_actions_path: Array<number>;
      exclusion_note_implementation_year?: number | null;
      annotations: Array<{
        action_id?: number | null;
        annotation_type: action_plan_impact_trends_annotation_enum;
        value: number;
        year: number;
      }>;
    };
    final_energy:
      | {
          type: action_plan_impact_type_enum;
          after_actions_path: Array<number>;
          before_actions_path: Array<number>;
          target_path: Array<number>;
          exclusion_note_implementation_year?: number | null;
          annotations: Array<{
            action_id?: number | null;
            annotation_type: action_plan_impact_trends_annotation_enum;
            value: number;
            year: number;
          }>;
          stranding_ranges: Array<{ end_year: number; start_year: number }>;
        }
      | {
          type: action_plan_impact_type_enum;
          after_actions_path: Array<number>;
          before_actions_path: Array<number>;
          exclusion_note_implementation_year?: number | null;
          annotations: Array<{
            action_id?: number | null;
            annotation_type: action_plan_impact_trends_annotation_enum;
            value: number;
            year: number;
          }>;
        };
    custom_targets?: {
      name: string;
      final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
      primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
      co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
    } | null;
  };
};

export type GetActionsForActionPlanQueryVariables = Exact<{
  actionPlanStableId: Scalars['Int']['input'];
}>;

export type GetActionsForActionPlanQuery = {
  getActionPlanByStableId: {
    action_plan?: {
      actions: Array<{
        id: number;
        created_at: string;
        implementation_to: string;
        order: number;
        custom_action_type_id?: custom_action_type_enum | null;
        custom_name?: string | null;
        custom_saving_fraction?: number | null;
        bulk_action_id?: number | null;
        bulk_action?: { name: string } | null;
        renovations: Array<{
          renovation_type_id: renovation_type_enum;
          cost_total?: number | null;
          cost_total_predium?: number | null;
          cost_total_custom?: number | null;
          use_custom_cost: boolean;
        }>;
        renovations_energy_consumer: Array<{
          new_energy_consumer?: {
            name?: string | null;
            id: number;
            energy_consumer_type_id: energy_consumer_type_enum;
            energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
            construction_year?: number | null;
            efficiency?: number | null;
            energy_system_consumer_routes: Array<{
              id: number;
              secondary_id: string;
              energy_source_type_id: energy_source_type_enum;
              energy_final: number;
              energy_system: { energy_system_type_id: energy_system_type_enum };
            }>;
          } | null;
          old_energy_consumer?: {
            name?: string | null;
            id: number;
            energy_consumer_type_id: energy_consumer_type_enum;
            energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
            construction_year?: number | null;
            efficiency?: number | null;
            energy_system_consumer_routes: Array<{
              id: number;
              secondary_id: string;
              energy_source_type_id: energy_source_type_enum;
              energy_final: number;
              energy_system: { energy_system_type_id: energy_system_type_enum };
            }>;
          } | null;
        }>;
        renovations_envelope: Array<{
          old_entity_id?: number | null;
          new_envelope?: {
            id: number;
            secondary_id: string;
            area: number;
            envelope_type_id: envelope_type_enum;
            insulation_material_name?: string | null;
            u_value?: number | null;
            insulation_lambda?: number | null;
            insulation_method_id?: insulation_method_enum | null;
            insulation_thickness?: number | null;
            insulation_material_category_id?: insulation_material_category_enum | null;
          } | null;
          old_envelope?: {
            id: number;
            secondary_id: string;
            building_model: {
              envelope_units: Array<{
                id: number;
                secondary_id: string;
                area: number;
                envelope_type_id: envelope_type_enum;
                insulation_material_name?: string | null;
                u_value?: number | null;
                insulation_thickness?: number | null;
                orientation?: number | null;
                inclination?: number | null;
              }>;
            };
          } | null;
        }>;
        renovations_energy_routes: Array<{
          new_energy_system_route?: {
            id: number;
            energy_source_type_id: energy_source_type_enum;
            energy_system: { energy_system_type_id: energy_system_type_enum };
          } | null;
          old_energy_system_route?: {
            id: number;
            energy_source_type_id: energy_source_type_enum;
            energy_system: { energy_system_type_id: energy_system_type_enum };
          } | null;
        }>;
        renovations_energy_producer: Array<{
          new_energy_producer?: {
            name?: string | null;
            nominal_power?: number | null;
            module_peak_power?: number | null;
            module_angle?: number | null;
            solar_active_area?: number | null;
            roof_area_ratio?: number | null;
          } | null;
        }>;
        building_models: Array<{
          id: number;
          energy_final?: number | null;
          energy_primary?: number | null;
          heating_demand?: number | null;
          heat_transfer_by_ventilation: number;
          building?: { id: number; year_constructed: number } | null;
          envelope_units: Array<{
            id: number;
            secondary_id: string;
            area: number;
            envelope_type_id: envelope_type_enum;
            insulation_material_name?: string | null;
            u_value?: number | null;
            insulation_thickness?: number | null;
            orientation?: number | null;
            inclination?: number | null;
          }>;
          energy_consumers: Array<{
            id: number;
            energy_consumer_type_id: energy_consumer_type_enum;
            energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
            efficiency?: number | null;
            energy_system_consumer_routes: Array<{
              energy_final: number;
              energy_system: { energy_system_type_id: energy_system_type_enum };
            }>;
          }>;
          energy_distributions: Array<{
            id: number;
            heat_transfer_loss: number;
            last_hydraulic_balancing?: string | null;
            last_balancing_set_to_never: boolean;
            balancing_with_components: boolean;
          }>;
          energy_systems: Array<{
            id: number;
            secondary_id: string;
            energy_system_type_id: energy_system_type_enum;
            energy_system_consumer_routes: Array<{
              id: number;
              secondary_id: string;
              energy_final: number;
              energy_source_type_id: energy_source_type_enum;
              energy_consumer?: {
                name?: string | null;
                id: number;
                energy_consumer_type_id: energy_consumer_type_enum;
                energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
                construction_year?: number | null;
                efficiency?: number | null;
                energy_system_consumer_routes: Array<{
                  id: number;
                  secondary_id: string;
                  energy_source_type_id: energy_source_type_enum;
                  energy_final: number;
                  energy_system: { energy_system_type_id: energy_system_type_enum };
                }>;
              } | null;
              energy_distribution?: {
                id: number;
                last_hydraulic_balancing?: string | null;
                last_balancing_set_to_never: boolean;
                heat_transfer_loss: number;
                balancing_with_components: boolean;
              } | null;
            }>;
            energy_system_producer_routes: Array<{
              energy_source_type_id: energy_source_type_enum;
              energy_producer: { nominal_power?: number | null };
            }>;
          }>;
        }>;
        parameters:
          | {
              __typename: 'CreateVentilationRenovationParametersUnionMember';
              createVentilationRenovationParameters: {
                consumer_technology_type: ventilation_supported_technology_enum;
                final_energy: number;
                efficiency?: number | null;
                number_of_units?: number | null;
              };
            }
          | {
              __typename: 'CustomActionParametersUnionMember';
              customActionParameters:
                | {
                    __typename: 'EnergySourceCustomActionParametersUnionMember';
                    energySourceCustomActionParameters: {
                      custom_name: string;
                      renovation_ids?: Array<string> | null;
                      fraction: number;
                      energy_source_type: energy_source_type_enum;
                    };
                  }
                | {
                    __typename: 'SystemCustomActionParametersUnionMember';
                    systemCustomActionParameters: {
                      system_type: energy_system_type_enum;
                      renovation_ids?: Array<string> | null;
                      fraction: number;
                      custom_name: string;
                    };
                  };
            }
          | {
              __typename: 'EnergySystemRouteParametersUnionMember';
              energySystemRouteParameters: {
                energy_source_type: energy_source_type_enum;
                emission_certificate_id?: number | null;
              };
            }
          | {
              __typename: 'EnvelopeParametersUnionMember';
              envelopeParameters: {
                u_value?: number | null;
                renovation_ids?: Array<string> | null;
                material_name: string;
                insulation_thickness?: number | null;
                insulation_method?: insulation_method_enum | null;
                insulation_material_category?: insulation_material_category_enum | null;
                insulation_lambda?: number | null;
                envelope_type: envelope_type_enum;
              };
            }
          | { __typename: 'ExclusionNoteParametersUnionMember'; exclusionNoteParameters: { note: string } }
          | {
              __typename: 'HydraulicBalancingParametersUnionMember';
              hydraulicBalancingParameters: {
                last_hydraulic_balancing: DateTime;
                costs_with_components?: boolean | null;
              };
            }
          | {
              __typename: 'MaintenanceActionParametersUnionMember';
              maintenanceActionParameters: { custom_name: string };
            }
          | {
              __typename: 'SolarParametersUnionMember';
              solarParameters: {
                technology_name: string;
                solar_active_area: number;
                roof_area_ratio: number;
                module_peak_power: number;
                module_angle: number;
              };
            }
          | {
              __typename: 'SystemParametersUnionMember';
              systemParameters: {
                consumer_technology_type: energy_consumer_technology_type_enum;
                efficiency: number;
                energy_source_type: energy_source_type_enum;
                renovation_ids?: Array<string> | null;
                system_type: energy_system_type_enum;
                technology_name: string;
                emission_certificate_id?: number | null;
              };
            }
          | {
              __typename: 'VentilationRenovationParametersUnionMember';
              ventilationRenovationParameters: {
                renovation_ids?: Array<string> | null;
                consumer_technology_type: ventilation_supported_technology_enum;
                final_energy: number;
                efficiency?: number | null;
                number_of_units?: number | null;
              };
            };
      }>;
    } | null;
  };
};

export type GetStrandingYearDistributionQueryVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetStrandingYearDistributionQuery = {
  getStrandingYearDistribution: {
    after: Array<number>;
    before: Array<number>;
    buildingCounts: Array<number>;
    startYear: number;
  };
};

export type GetHeatingEnergySourceDevelopmentQueryVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetHeatingEnergySourceDevelopmentQuery = {
  getHeatingEnergySourceDevelopment?: {
    startYear: number;
    data: Array<{ type: main_energy_source_type_enum; path: Array<number> }>;
  } | null;
};

export type GetFloorAreaDevelopmentQueryVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetFloorAreaDevelopmentQuery = {
  getFloorAreaDevelopment: {
    area: Array<number>;
    totalBuildings: Array<number>;
    newConstructionBuildings: Array<number>;
    excludedSincePreviousYear: Array<number>;
    startYear: number;
  };
};

export type GetEfficiencyClassSplitDevelopmentQueryVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetEfficiencyClassSplitDevelopmentQuery = {
  getEfficiencyClassSplitDevelopment?: {
    startYear: number;
    data: Array<{ efficiencyClass: efficiency_class_enum; path: Array<number> }>;
  } | null;
};

export type GetActionsForRecommendedActionsQueryVariables = Exact<{
  actionPlanStableId: Scalars['Int']['input'];
}>;

export type GetActionsForRecommendedActionsQuery = {
  getActionPlanByStableId: {
    action_plan?: {
      actions: Array<{
        id: number;
        implementation_to: string;
        renovations: Array<{ renovation_type_id: renovation_type_enum }>;
      }>;
    } | null;
  };
};

export type GetRecommendedActionsForBuildingModelQueryVariables = Exact<{
  action_plan_stable_id: Scalars['Int']['input'];
  implementation_date: Scalars['DateTime']['input'];
  sorting: recommended_action_sorting_enum;
  emission_source_type?: InputMaybe<emission_factor_source_enum>;
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
}>;

export type GetRecommendedActionsForBuildingModelQuery = {
  recommendActions: {
    recommendedActions: Array<{
      __typename: 'RecommendedAction';
      actionImpact:
        | {
            analysisType: emission_factor_type_enum;
            total_estimated_cost: number;
            co2_abatement_costs: number;
            payback_period: number;
            co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            co2_emissions: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            efficiency_class: { after?: efficiency_class_enum | null; before?: efficiency_class_enum | null };
            energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            final_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            primary_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            stranding_date: { after?: DateTime | null; before: DateTime; impact?: number | null };
            heating_demand?: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            } | null;
          }
        | {
            analysisType: emission_factor_type_enum;
            total_estimated_cost: number;
            co2_abatement_costs: number;
            payback_period: number;
            co2_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            co2_emissions: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            efficiency_class: { after?: efficiency_class_enum | null; before?: efficiency_class_enum | null };
            energy_cost_total: { after?: number | null; before?: number | null; impact?: number | null };
            final_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            primary_energy: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            };
            heating_demand?: {
              after?: number | null;
              after_total?: number | null;
              before?: number | null;
              before_total?: number | null;
              impact?: number | null;
              impact_total?: number | null;
            } | null;
          };
      parameters:
        | {
            __typename: 'CreateVentilationRenovationParameterOutput';
            ventilation_consumer_technology_type: ventilation_supported_technology_enum;
            final_energy: number;
            ventilation_efficiency?: number | null;
            number_of_units?: number | null;
          }
        | { __typename: 'EnergySystemRouteRenovationParameterOutput'; energy_source_type: energy_source_type_enum }
        | {
            __typename: 'EnvelopeRenovationParameterOutput';
            envelope_type: envelope_type_enum;
            insulation_lambda?: number | null;
            insulation_material_category?: insulation_material_category_enum | null;
            insulation_method?: insulation_method_enum | null;
            insulation_thickness?: number | null;
            material_name: string;
            u_value?: number | null;
          }
        | {
            __typename: 'HydraulicBalancingRenovationParameterOutput';
            costs_with_components?: boolean | null;
            last_hydraulic_balancing: DateTime;
          }
        | {
            __typename: 'SolarRenovationParameterOutput';
            module_angle: number;
            module_peak_power: number;
            roof_area_ratio: number;
            solar_active_area: number;
            technology_name: string;
          }
        | {
            __typename: 'SystemRenovationParameterOutput';
            consumer_technology_type: energy_consumer_technology_type_enum;
            efficiency: number;
            energy_source_type: energy_source_type_enum;
            system_type: energy_system_type_enum;
            technology_name: string;
          }
        | {
            __typename: 'UpdateVentilationRenovationParameterOutput';
            renovation_ids?: Array<string> | null;
            ventilation_consumer_technology_type: ventilation_supported_technology_enum;
            final_energy: number;
            ventilation_efficiency?: number | null;
            number_of_units?: number | null;
          };
    }>;
  };
};

export type GetEditActionStatusQuoQueryVariables = Exact<{
  action_id: Scalars['Int']['input'];
  implementation_to: Scalars['DateTime']['input'];
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
}>;

export type GetEditActionStatusQuoQuery = {
  getEditStatusQuo: {
    error?: action_mutation_error_enum | null;
    result?:
      | {
          analysisType: emission_factor_type_enum;
          energy_final: number;
          energy_final_total: number;
          energy_primary: number;
          energy_primary_total: number;
          heating_demand?: number | null;
          heating_demand_total?: number | null;
          co2_emissions: number;
          co2_emissions_total: number;
          stranding_date: DateTime;
          efficiency_class: efficiency_class_enum;
          renovation_costs?: number | null;
          energy_final_cost: number;
          co2_tax_cost: number;
        }
      | {
          analysisType: emission_factor_type_enum;
          energy_final: number;
          energy_final_total: number;
          energy_primary: number;
          energy_primary_total: number;
          heating_demand?: number | null;
          heating_demand_total?: number | null;
          co2_emissions: number;
          co2_emissions_total: number;
          efficiency_class: efficiency_class_enum;
          renovation_costs?: number | null;
          energy_final_cost: number;
          co2_tax_cost: number;
        }
      | null;
  };
};

export type GetCreateActionStatusQuoQueryVariables = Exact<{
  action_plan_stable_id: Scalars['Int']['input'];
  implementation_to: Scalars['DateTime']['input'];
  emission_factor_source?: InputMaybe<emission_factor_source_enum>;
  reference_area_type?: InputMaybe<analysis_reference_area_enum>;
}>;

export type GetCreateActionStatusQuoQuery = {
  getCreateStatusQuo: {
    error?: action_mutation_error_enum | null;
    result?:
      | {
          analysisType: emission_factor_type_enum;
          energy_final: number;
          energy_final_total: number;
          energy_primary: number;
          energy_primary_total: number;
          heating_demand?: number | null;
          heating_demand_total?: number | null;
          co2_emissions: number;
          co2_emissions_total: number;
          stranding_date: DateTime;
          efficiency_class: efficiency_class_enum;
          renovation_costs?: number | null;
          energy_final_cost: number;
          co2_tax_cost: number;
        }
      | {
          analysisType: emission_factor_type_enum;
          energy_final: number;
          energy_final_total: number;
          energy_primary: number;
          energy_primary_total: number;
          heating_demand?: number | null;
          heating_demand_total?: number | null;
          co2_emissions: number;
          co2_emissions_total: number;
          efficiency_class: efficiency_class_enum;
          renovation_costs?: number | null;
          energy_final_cost: number;
          co2_tax_cost: number;
        }
      | null;
  };
};

export type GetBulkActionItemsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<bulk_actions_overview_bool_exp>;
  orderBy?: InputMaybe<Array<bulk_actions_overview_order_by> | bulk_actions_overview_order_by>;
}>;

export type GetBulkActionItemsQuery = {
  bulk_actions_overview: Array<{
    action_plan_status?: string | null;
    bulk_action_id?: number | null;
    id?: number | null;
    action_plan?: {
      stable_id: number;
      building: { id: number; address: { city: string; postal_code: string; street: string } };
    } | null;
  }>;
  bulk_actions_overview_aggregate: { aggregate?: { count: number } | null };
};

export type GetBulkActionParametersQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetBulkActionParametersQuery = {
  bulk_actions_overview: Array<{
    bulk_action?: {
      name: string;
      implementation_date: string;
      custom_costs?: number | null;
      custom_costs_per_m2?: number | null;
      params:
        | {
            __typename: 'CreateVentilationRenovationParametersUnionMember';
            createVentilationRenovationParameters: {
              consumer_technology_type: ventilation_supported_technology_enum;
              efficiency?: number | null;
              final_energy: number;
              number_of_units?: number | null;
            };
          }
        | {
            __typename: 'CustomBulkActionParametersUnionMember';
            customActionParameters:
              | {
                  __typename: 'EnergySourceCustomBulkActionParametersUnionMember';
                  energySourceCustomActionParameters: {
                    custom_name: string;
                    energy_source_type: energy_source_type_enum;
                    fraction: number;
                  };
                }
              | {
                  __typename: 'SystemCustomBulkActionParametersUnionMember';
                  systemCustomActionParameters: {
                    custom_name: string;
                    fraction: number;
                    system_type: energy_system_type_enum;
                  };
                };
          }
        | {
            __typename: 'EnergySystemRouteParametersBulkUnionMember';
            energySystemRouteParameters: {
              energy_source_type: energy_source_type_enum;
              emission_certificate_id?: number | null;
            };
          }
        | {
            __typename: 'EnvelopeParametersBulkUnionMember';
            envelopeParameters: {
              envelope_type: envelope_type_enum;
              insulation_lambda?: number | null;
              insulation_material_category?: insulation_material_category_enum | null;
              insulation_method?: insulation_method_enum | null;
              insulation_thickness?: number | null;
              material_name: string;
              u_value?: number | null;
            };
          }
        | { __typename: 'ExclusionNoteParametersUnionMember'; exclusionNoteParameters: { note: string } }
        | {
            __typename: 'HydraulicBalancingParametersBulkUnionMember';
            hydraulicBalancingParameters: {
              costs_with_components?: boolean | null;
              last_hydraulic_balancing: DateTime;
            };
          }
        | { __typename: 'LightingParametersBulkUnionMember'; lightingParameters: { efficiency: number } }
        | { __typename: 'MaintenanceActionParametersUnionMember'; maintenanceActionParameters: { custom_name: string } }
        | {
            __typename: 'SolarParametersBulkUnionMember';
            solarParameters: {
              module_angle: number;
              module_peak_power: number;
              roof_area_ratio: number;
              technology_name: string;
            };
          }
        | {
            __typename: 'SystemParametersBulkUnionMember';
            systemParameters: {
              consumer_technology_type: energy_consumer_technology_type_enum;
              efficiency: number;
              energy_source_type: energy_source_type_enum;
              system_type: energy_system_type_enum;
              technology_name: string;
              emission_certificate_id?: number | null;
            };
          }
        | {
            __typename: 'VentilationRenovationParametersUnionMember';
            ventilationRenovationParameters: {
              consumer_technology_type: ventilation_supported_technology_enum;
              efficiency?: number | null;
              final_energy: number;
              number_of_units?: number | null;
              renovation_ids?: Array<string> | null;
            };
          };
    } | null;
  }>;
  total_count: { aggregate?: { count: number } | null };
  planned_count: { aggregate?: { count: number } | null };
  not_planned_count: { aggregate?: { count: number } | null };
  deletion_failled_count: { aggregate?: { count: number } | null };
};

export type GetActionPlanTabsCountQueryVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
}>;

export type GetActionPlanTabsCountQuery = {
  active_action_plans_aggregate: { aggregate?: { count: number } | null };
  active_bulk_actions_aggregate: { aggregate?: { count: number } | null };
};

export type GetBulkActionsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<active_bulk_actions_bool_exp>;
  orderBy?: InputMaybe<Array<active_bulk_actions_order_by> | active_bulk_actions_order_by>;
}>;

export type GetBulkActionsQuery = {
  active_bulk_actions: Array<{
    bulk_action?: {
      id: number;
      name: string;
      implementation_date: string;
      summary?: {
        total_cost?: number | null;
        total_count?: number | null;
        planned_count?: number | null;
        pending_count?: number | null;
        failed_count?: number | null;
        deletion_pending_count?: number | null;
        deletion_failed_count?: number | null;
      } | null;
      params:
        | { __typename: 'CreateVentilationRenovationParametersUnionMember' }
        | {
            __typename: 'CustomBulkActionParametersUnionMember';
            customActionParameters:
              | {
                  __typename: 'EnergySourceCustomBulkActionParametersUnionMember';
                  energySourceCustomActionParameters: { custom_name: string };
                }
              | {
                  __typename: 'SystemCustomBulkActionParametersUnionMember';
                  systemCustomActionParameters: { custom_name: string };
                };
          }
        | {
            __typename: 'EnergySystemRouteParametersBulkUnionMember';
            energySystemRouteParameters: { energy_source_type: energy_source_type_enum };
          }
        | { __typename: 'EnvelopeParametersBulkUnionMember'; envelopeParameters: { envelope_type: envelope_type_enum } }
        | { __typename: 'ExclusionNoteParametersUnionMember'; exclusionNoteParameters: { note: string } }
        | { __typename: 'HydraulicBalancingParametersBulkUnionMember' }
        | { __typename: 'LightingParametersBulkUnionMember' }
        | { __typename: 'MaintenanceActionParametersUnionMember'; maintenanceActionParameters: { custom_name: string } }
        | { __typename: 'SolarParametersBulkUnionMember' }
        | {
            __typename: 'SystemParametersBulkUnionMember';
            systemParameters: { system_type: energy_system_type_enum; technology_name: string };
          }
        | { __typename: 'VentilationRenovationParametersUnionMember' };
    } | null;
  }>;
  active_bulk_actions_aggregate: { aggregate?: { count: number } | null };
};

export type GetBulkActionSummarySubscriptionVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetBulkActionSummarySubscription = {
  bulk_action: Array<{
    summary?: {
      total_count?: number | null;
      planned_count?: number | null;
      failed_count?: number | null;
      total_cost?: number | null;
      pending_count?: number | null;
      deletion_pending_count?: number | null;
      deletion_failed_count?: number | null;
    } | null;
  }>;
};

export type GetActionPlanProcessingStatusSubscriptionVariables = Exact<{
  stableId: Scalars['Int']['input'];
}>;

export type GetActionPlanProcessingStatusSubscription = {
  bulk_actions_overview: Array<{ action_plan_status?: string | null }>;
};

export type GetScenarioBulkActionProcessingStatusSubscriptionVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
}>;

export type GetScenarioBulkActionProcessingStatusSubscription = {
  active_bulk_actions: Array<{
    bulk_action?: { summary?: { pending_count?: number | null; deletion_pending_count?: number | null } | null } | null;
  }>;
};

export type getDistrictHeatingEmissionCertificatesQueryVariables = Exact<{ [key: string]: never }>;

export type getDistrictHeatingEmissionCertificatesQuery = {
  emission_certificate: Array<{
    issuer: string;
    emission_factor: number;
    primary_energy_factor?: number | null;
    id: number;
    emission_certificate_energy_source_type_id?: emission_certificate_energy_source_type_enum | null;
    created_at: string;
  }>;
};

export type getGreenElectricityEmissionCertificatesQueryVariables = Exact<{ [key: string]: never }>;

export type getGreenElectricityEmissionCertificatesQuery = {
  emission_certificate: Array<{
    issuer: string;
    emission_factor: number;
    primary_energy_factor?: number | null;
    id: number;
    emission_certificate_energy_source_type_id?: emission_certificate_energy_source_type_enum | null;
    created_at: string;
  }>;
};

export type GetActionPlansForBuildingQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type GetActionPlansForBuildingQuery = {
  active_action_plans: Array<{
    action_plan?: { stable_id: number; building_id: number; created_at: string; id: number } | null;
    scenario?: {
      id: number;
      name: string;
      owner: { id: number; first_name?: string | null; last_name?: string | null };
    } | null;
  }>;
};

export type GetBuildingsForBulkActionQueryVariables = Exact<{
  buildingWhere: BuildingWhere;
  buildingWhereDisabled?: BuildingWhere;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BuildingOrderByInput>;
  skipDisabled?: Scalars['Boolean']['input'];
}>;

export type GetBuildingsForBulkActionQuery = {
  getBuildingList: {
    count: number;
    buildings: Array<{
      id: number;
      is_new_construction: boolean;
      energy_data?: { energy_final: number } | null;
      building: {
        id: number;
        address: { id: number; street: string; city: string; postal_code: string; country_id: country_enum };
        areas: Array<{ id: number; type_of_use_id: type_of_use_enum }>;
        economic_unit: { portfolio: { name: string } };
      };
    }>;
  };
  getBuildingList_disabled?: { buildings: Array<{ id: number }> };
};

export type GetBuildingsForRecreateTableSelectionQueryVariables = Exact<{
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  bulkActionId: Scalars['Int']['input'];
}>;

export type GetBuildingsForRecreateTableSelectionQuery = {
  getBuildingList: { buildings: Array<{ id: number }> };
  getBuildingList_disabled: { buildings: Array<{ id: number }> };
  bulk_actions_overview: Array<{ action_plan?: { building_id: number } | null }>;
};

export type GetCo2EmissionsImpactTrendQueryVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetCo2EmissionsImpactTrendQuery = {
  getCo2EmissionsImpactTrend?: {
    after: Array<number>;
    before: Array<number>;
    startYear: number;
    target_path: Array<number>;
    custom_target: Array<{ year: number; reached: boolean; targetValue: number }>;
  } | null;
};

export type GetFinalEnergyImpactTrendQueryVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetFinalEnergyImpactTrendQuery = {
  getFinalEnergyImpactTrend?: {
    after: Array<number>;
    before: Array<number>;
    startYear: number;
    target_path: Array<number>;
    custom_target: Array<{ year: number; reached: boolean; targetValue: number }>;
  } | null;
};

export type GetPrimaryEnergyImpactTrendQueryVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
  includeNewConstruction?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetPrimaryEnergyImpactTrendQuery = {
  getPrimaryEnergyImpactTrend?: {
    after: Array<number>;
    before: Array<number>;
    startYear: number;
    custom_target: Array<{ year: number; reached: boolean; targetValue: number }>;
  } | null;
};

export type GetCostByRenovationCategoryQueryVariables = Exact<{
  scenarioId: Scalars['Int']['input'];
}>;

export type GetCostByRenovationCategoryQuery = {
  getCostByRenovationCategory?: {
    startYear: number;
    series: Array<{ name: renovation_category_enum; data: { values: Array<number>; actionsCount: Array<number> } }>;
    legend: Array<{ name: renovation_category_enum; value: number; percentage: number; actionsCount: number }>;
  } | null;
};

export type CanDeleteBulkActionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type CanDeleteBulkActionQuery = { canDeleteBulkAction: boolean };

export type CanEditBulkActionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type CanEditBulkActionQuery = { canEditBulkAction: boolean };

export type GetScenarioInvestmentCostQueryVariables = Exact<{
  scenario_id: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionSourceType?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetScenarioInvestmentCostQuery = { getScenarioInvestmentCost: { cost: Array<number>; startYear: number } };

export type GetActionPlanInvestmentCostQueryVariables = Exact<{
  stable_id: Scalars['Int']['input'];
}>;

export type GetActionPlanInvestmentCostQuery = {
  getActionPlanInvestmentCost: { cost: Array<number>; startYear: number };
};

export type GetScenarioCustomTargetPathQueryVariables = Exact<{
  scenario_id: Scalars['Int']['input'];
}>;

export type GetScenarioCustomTargetPathQuery = { getScenarioCustomTargetPath: { targetPath?: Array<number> | null } };

export type GetActionPlanCustomTargetPathQueryVariables = Exact<{
  stable_id: Scalars['Int']['input'];
}>;

export type GetActionPlanCustomTargetPathQuery = {
  getActionPlanCustomTargetPath: { targetPath?: Array<number> | null };
};

export type deleteCBIInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['Int']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type deleteCBIInvoiceMutation = { deleteCBIInvoice: boolean };

export type EditSnapshotMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  extractionState: cbi_manual_review_state_enum;
  data?: InputMaybe<EditInvoiceSnapshotData>;
  editReason?: InputMaybe<Scalars['String']['input']>;
}>;

export type EditSnapshotMutation = { editSnapshot: { id: number } };

export type EditAddressAssignmentsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  assignments: Array<AssignBuildingAddressInput> | AssignBuildingAddressInput;
}>;

export type EditAddressAssignmentsMutation = { editAddressAssignments: { id: number } };

export type FlagDuplicateInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['Int']['input'];
  duplicate?: InputMaybe<UpdateDuplicate>;
}>;

export type FlagDuplicateInvoiceMutation = { updateDuplicateInvoice: { invoiceId: number } };

export type TriggerCbiExportMutationVariables = Exact<{ [key: string]: never }>;

export type TriggerCbiExportMutation = { triggerCbiExport: { id: number } };

export type CbiExportStatusSubscriptionSubscriptionVariables = Exact<{
  exportId: Scalars['Int']['input'];
}>;

export type CbiExportStatusSubscriptionSubscription = {
  cbi_export_by_pk?: { id: number; status_id: cbi_export_status_type_enum } | null;
};

export type GetCbiExportDownloadUrlQueryVariables = Exact<{
  exportId: Scalars['Int']['input'];
}>;

export type GetCbiExportDownloadUrlQuery = { cbi_export_by_pk?: { id: number; downloadUrl: string } | null };

export type CreateInvoiceSnapshotMutationVariables = Exact<{
  invoiceId: Scalars['Int']['input'];
  extractionType: cbi_extraction_type_enum;
  orgId?: InputMaybe<Scalars['Int']['input']>;
  setActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateInvoiceSnapshotMutation = { createInvoiceSnapshot: { id: number } };

export type SetAsOriginalInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['Int']['input'];
}>;

export type SetAsOriginalInvoiceMutation = { setDuplicateAsOriginalInvoice: { invoiceId: number } };

export type CbiPotentialBuildingMatchFragment = {
  id: number;
  is_auto_assigned: boolean;
  building: {
    id: number;
    economic_unit: { id: number; name: string; portfolio: { id: number; name: string } };
    address: { id: number; street: string; postal_code: string; city: string };
  };
};

export type AlphaPromptInteractionFragmentFragment = {
  id: number;
  analysis_id?: string | null;
  filename?: string | null;
  started_at?: string | null;
  analysis_started_at?: string | null;
  uploaded_at?: string | null;
  created_at: string;
  extracted_raw_data?: any | null;
};

export type GetConsumptionInvoicesInProgressQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<cbi_invoice_order_by> | cbi_invoice_order_by>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
}>;

export type GetConsumptionInvoicesInProgressQuery = {
  cbi_invoice: Array<{
    id: number;
    email?: { id: number; subject?: string | null; received_at?: string | null; created_at: string } | null;
    file: { id: number; name?: string | null };
    cbi_invoice_snapshots: Array<{ id: number; extraction_state: cbi_extraction_state_enum }>;
  }>;
  cbi_invoice_aggregate: { aggregate?: { count: number } | null };
};

export type GetConsumptionInvoicesOverviewQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<cbi_invoice_snapshot_order_by> | cbi_invoice_snapshot_order_by>;
  where?: InputMaybe<cbi_invoice_snapshot_bool_exp>;
}>;

export type GetConsumptionInvoicesOverviewQuery = {
  cbi_invoice_snapshot: Array<{
    id: number;
    extraction_state: cbi_extraction_state_enum;
    invoice_number?: string | null;
    provider?: string | null;
    invoice_date?: string | null;
    cbi_invoice: {
      id: number;
      file: { id: number; name?: string | null };
      email?: { id: number; subject?: string | null; received_at?: string | null; created_at: string } | null;
    };
    cbi_consumption_lines: Array<{ id: number; building_address?: string | null }>;
  }>;
  cbi_invoice_snapshot_aggregate: { aggregate?: { count: number } | null };
};

export type GetSnapshotConsumptionLinesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<cbi_consumption_line_order_by> | cbi_consumption_line_order_by>;
  where?: InputMaybe<cbi_consumption_line_bool_exp>;
}>;

export type GetSnapshotConsumptionLinesQuery = {
  cbi_consumption_line: Array<{
    id: number;
    building_address?: string | null;
    consumption_type?: consumption_type_enum | null;
    consumption_start_date?: string | null;
    consumption_end_date?: string | null;
    cbi_invoice_snapshot: {
      id: number;
      cbi_invoice_id: number;
      invoice_type?: cbi_invoice_type_enum | null;
      cbi_invoice: { email?: { id: number; received_at?: string | null; created_at: string } | null };
    };
  }>;
  cbi_consumption_line_aggregate: { aggregate?: { count: number } | null };
};

export type GetConsumptionSnapshotQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetConsumptionSnapshotQuery = {
  cbi_invoice_snapshot: Array<{
    id: number;
    invoice_number?: string | null;
    invoice_reference?: string | null;
    provider?: string | null;
    invoice_date?: string | null;
    extraction_state: cbi_extraction_state_enum;
    is_active: boolean;
    edit_reason?: string | null;
    extraction_type: cbi_extraction_type_enum;
    extraction_needs_review_reason?: any | null;
    created_at: string;
    invoice_type?: cbi_invoice_type_enum | null;
    total_cost_net?: number | null;
    total_cost_gross?: number | null;
    vat_percentage?: number | null;
    vat_amount?: number | null;
    advance_payments?: number | null;
    outstanding_balance?: number | null;
    credit_amount?: number | null;
    co2_fee_net?: number | null;
    co2_fee_gross?: number | null;
    amount_payable?: number | null;
    operational_control?: cbi_operational_control_enum | null;
    user?: { id: number; first_name?: string | null; last_name?: string | null; email?: string | null } | null;
    cbi_invoice: {
      id: number;
      duplicate_of_id?: number | null;
      duplicate_reason?: string | null;
      duplicate_reason_type?: cbi_duplicate_reason_type_enum | null;
      downloadUrl: string;
      file: { id: number; name?: string | null };
      email?: { id: number; subject?: string | null; received_at?: string | null } | null;
      duplicates: Array<{
        id: number;
        duplicate_reason?: string | null;
        duplicate_reason_type?: cbi_duplicate_reason_type_enum | null;
        file: { id: number; name?: string | null };
      }>;
    };
    cbi_consumption_lines: Array<{
      id: number;
      line_index: number;
      building_address?: string | null;
      cbi_address_id?: number | null;
      cbi_invoice_snapshot_id: number;
      water_sub_type?: cbi_water_sub_type_enum | null;
      consumption_type?: consumption_type_enum | null;
      consumption_start_date?: string | null;
      consumption_end_date?: string | null;
      consumption_amount?: number | null;
      meter_number?: string | null;
      unit?: cbi_consumption_unit_enum | null;
      cost_net?: number | null;
      cost_gross?: number | null;
      vat_percentage?: number | null;
      vat_amount?: number | null;
      position?: number | null;
      advance_payments?: number | null;
      outstanding_balance?: number | null;
      credit_amount?: number | null;
      amount_payable?: number | null;
      base_price_net?: number | null;
      working_price_net?: number | null;
      co2_fee_net?: number | null;
      co2_fee_gross?: number | null;
      other_charges_net?: number | null;
      waste_sub_type?: cbi_waste_sub_type_enum | null;
      waste_quantity?: number | null;
      waste_quantity_unit?: cbi_waste_quantity_unit_enum | null;
      waste_container_size?: number | null;
      waste_container_size_unit?: cbi_waste_container_size_unit_enum | null;
      waste_container_count?: number | null;
      waste_collection_frequency?: number | null;
      waste_collection_frequency_raw?: string | null;
      waste_collection_frequency_period?: cbi_waste_container_frequency_period_enum | null;
      waste_collections_total?: number | null;
      waste_ewc_code?: string | null;
      reference_area?: cbi_reference_area_enum | null;
      is_estimated?: boolean | null;
      is_advance_payment?: boolean | null;
      market_location_id?: string | null;
      emission_factor_market_based?: number | null;
      energy_source?: cbi_energy_source_type_enum | null;
      renewable_energy_percentage?: number | null;
      cbi_address?: {
        id: number;
        address_string: string;
        assignments: Array<{
          building_id: number;
          area_id?: number | null;
          building: {
            id: number;
            customer_external_identifier?: string | null;
            address: { id: number; street: string; postal_code: string; city: string };
            economic_unit: {
              id: number;
              name: string;
              customer_economic_unit_id?: string | null;
              portfolio: { id: number; name: string };
            };
          };
        }>;
      } | null;
    }>;
    validationIssues: {
      invoice: Array<{ field: CBIInvoiceField; type: CBIValidationIssueType; ruleName: CBIInvoiceRuleName }>;
      lines: Array<{ field: CBILineField; lineIndex: number; type: CBIValidationIssueType; ruleName: CBILineRuleName }>;
    };
    alpha_prompt_interactions: Array<{
      id: number;
      analysis_id?: string | null;
      filename?: string | null;
      started_at?: string | null;
      analysis_started_at?: string | null;
      uploaded_at?: string | null;
      created_at: string;
      extracted_raw_data?: any | null;
    }>;
  }>;
  cbi_invoice_by_pk?: {
    id: number;
    duplicate_of_id?: number | null;
    duplicate_reason?: string | null;
    duplicate_reason_type?: cbi_duplicate_reason_type_enum | null;
    downloadUrl: string;
    file: { id: number; name?: string | null };
    email?: { id: number; subject?: string | null; received_at?: string | null } | null;
  } | null;
};

export type GetConsumptionAddressesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<cbi_address_order_by> | cbi_address_order_by>;
  where?: InputMaybe<cbi_address_bool_exp>;
}>;

export type GetConsumptionAddressesQuery = {
  cbi_address: Array<{
    id: number;
    address_string: string;
    assignment_count: { aggregate?: { count: number } | null };
    assignments: Array<{
      id: number;
      building_id: number;
      building: {
        id: number;
        address: { id: number; street: string; postal_code: string; country_id: country_enum; city: string };
      };
    }>;
    potential_matches: Array<{
      id: number;
      is_auto_assigned: boolean;
      building: {
        id: number;
        economic_unit: { id: number; name: string; portfolio: { id: number; name: string } };
        address: { id: number; street: string; postal_code: string; city: string };
      };
    }>;
  }>;
  cbi_address_aggregate: { aggregate?: { count: number } | null };
};

export type GetCbiAddressByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetCbiAddressByIdQuery = {
  cbi_address: Array<{
    id: number;
    address_string: string;
    assignments: Array<{
      building_id: number;
      area_id?: number | null;
      building: { id: number; address: { street: string; postal_code: string; city: string } };
    }>;
    potential_matches: Array<{
      id: number;
      is_auto_assigned: boolean;
      building: {
        id: number;
        economic_unit: { id: number; name: string; portfolio: { id: number; name: string } };
        address: { id: number; street: string; postal_code: string; city: string };
      };
    }>;
  }>;
};

export type GetInvoicesForDuplicateSearchQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where?: InputMaybe<cbi_invoice_bool_exp>;
}>;

export type GetInvoicesForDuplicateSearchQuery = {
  cbi_invoice: Array<{
    id: number;
    file: { id: number; name?: string | null };
    cbi_invoice_snapshots: Array<{ id: number; invoice_number?: string | null; provider?: string | null }>;
  }>;
  cbi_invoice_aggregate: { aggregate?: { count: number } | null };
};

export type GetDuplicateInvoicesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<cbi_invoice_order_by> | cbi_invoice_order_by>;
  where?: InputMaybe<cbi_invoice_bool_exp>;
}>;

export type GetDuplicateInvoicesQuery = {
  cbi_invoice: Array<{
    id: number;
    duplicate_of_id?: number | null;
    duplicate_reason?: string | null;
    duplicate_reason_type?: cbi_duplicate_reason_type_enum | null;
    file: { id: number; name?: string | null };
    email?: { id: number; subject?: string | null; received_at?: string | null; created_at: string } | null;
    cbi_invoice_snapshots: Array<{
      id: number;
      invoice_number?: string | null;
      provider?: string | null;
      invoice_date?: string | null;
      extraction_state: cbi_extraction_state_enum;
      cbi_consumption_lines: Array<{ id: number; building_address?: string | null }>;
    }>;
  }>;
  cbi_invoice_aggregate: { aggregate?: { count: number } | null };
};

export type GetAssociatedInvoicesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<cbi_invoice_order_by> | cbi_invoice_order_by>;
  cbiAddressId: Scalars['Int']['input'];
}>;

export type GetAssociatedInvoicesQuery = {
  cbi_invoice: Array<{
    id: number;
    file: { id: number; name?: string | null };
    email?: { id: number; subject?: string | null } | null;
    cbi_invoice_snapshots: Array<{ id: number; provider?: string | null; invoice_number?: string | null }>;
  }>;
  cbi_invoice_aggregate: { aggregate?: { count: number } | null };
};

export type GetConsumptionOverviewQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<ConsumptionOverviewOrderByInput>;
  where?: InputMaybe<ConsumptionOverviewWhere>;
}>;

export type GetConsumptionOverviewQuery = {
  getConsumptionOverview: {
    count: number;
    rows: Array<{
      consumptionId?: number | null;
      cbiInvoiceId?: number | null;
      buildingId?: number | null;
      street?: string | null;
      postalCode?: string | null;
      city?: string | null;
      economicUnitName?: string | null;
      status: status_consumption_enum;
      source: source_consumption_enum;
      sourceName?: string | null;
      fileName?: string | null;
      invoiceType?: cbi_invoice_type_enum | null;
      invoiceNumber?: string | null;
      provider?: string | null;
      consumptionType?: consumption_type_enum | null;
      subType?: consumption_sub_type_enum | null;
      energySourceType?: energy_source_type_enum | null;
      from?: DateTime | null;
      to?: DateTime | null;
      value?: number | null;
      lastEdited?: DateTime | null;
      referenceAreaType?: cbi_reference_area_enum | null;
      areaName?: string | null;
    }>;
  };
};

export type GetManualConsumptionEntryDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetManualConsumptionEntryDetailsQuery = {
  consumption_by_pk?: {
    id: number;
    provider?: string | null;
    from: string;
    to: string;
    source_type_id: consumption_source_type_enum;
    consumption_type_id: consumption_type_enum;
    sub_type_id?: consumption_sub_type_enum | null;
    energy_source_type_id?: energy_source_type_enum | null;
    cost?: number | null;
    displayValue?: number | null;
    display_unit_value?: consumption_unit_enum | null;
    building: { id: number };
    consumption_areas: Array<{ area_id: number }>;
    consumption_waste_detail?: {
      id: number;
      volume: number;
      display_unit_volume?: consumption_unit_enum | null;
      frequency: number;
      display_unit_frequency?: consumption_frequency_type_enum | null;
      amount: number;
      price: number;
    } | null;
  } | null;
};

export type GetWritableBuildingOptionsQueryVariables = Exact<{
  orgId: Scalars['Int']['input'];
}>;

export type GetWritableBuildingOptionsQuery = {
  building: Array<{ id: number; address: { id: number; city: string; street: string; postal_code: string } }>;
};

export type GetManualEntryBuildingDetailsQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type GetManualEntryBuildingDetailsQuery = {
  building_by_pk?: {
    id: number;
    areas: Array<{ id: number; external_id: string; description: string; area_type_id: area_type_enum; value: number }>;
    building_models: Array<{
      id: number;
      energy_systems: Array<{ id: number; energy_system_type_id: energy_system_type_enum }>;
    }>;
  } | null;
};

export type GetConsumptionGapMatrixQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetConsumptionGapMatrixQuery = {
  getConsumptionGapMatrix: {
    count: number;
    buildings: Array<{
      buildingId: number;
      completeness: number;
      building?: { id: number; address: { id: number; street: string; city: string; postal_code: string } } | null;
      coverage: { electricity: number; heating: number; water: number; waste: number };
      areas: Array<{ areaId: number }>;
      gaps: Array<{ from: DateTime; to: DateTime; consumptionType: consumption_type_enum; areaId: number }>;
    }>;
  };
};

export type GetBuildingConsumptionGapAreasQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type GetBuildingConsumptionGapAreasQuery = {
  getConsumptionGapMatrix: {
    buildings: Array<{
      buildingId: number;
      completeness: number;
      areas: Array<{
        areaId: number;
        areaName: string;
        areaType: area_type_enum;
        completeness: number;
        coverage: { electricity: number; heating: number; water: number; waste: number };
        gaps: {
          electricity: Array<{ from: DateTime; to: DateTime }>;
          heating: Array<{ from: DateTime; to: DateTime }>;
          water: Array<{ from: DateTime; to: DateTime }>;
          waste: Array<{ from: DateTime; to: DateTime }>;
        };
      }>;
    }>;
  };
};

export type DataCollectionAddEconomicUnitMutationVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  customerEconomicUnitId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  responsibleUserId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DataCollectionAddEconomicUnitMutation = {
  insert_economic_unit_one?: { __typename: 'economic_unit'; id: number } | null;
};

export type DataCollectionEditEconomicUnitMutationVariables = Exact<{
  economicUnitId: Scalars['Int']['input'];
  economicUnitName: Scalars['String']['input'];
  customerEconomicUnitId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['Int']['input'];
  responsibleUserId?: InputMaybe<Scalars['Int']['input']>;
  customData: Scalars['JSON']['input'];
  includeCustomData: Scalars['Boolean']['input'];
}>;

export type DataCollectionEditEconomicUnitMutation = {
  update_economic_unit_by_pk?: {
    id: number;
    name: string;
    portfolio_id: number;
    responsible_user_id?: number | null;
    customer_economic_unit_id?: string | null;
    description: string;
    responsible_user?: { id: number; first_name?: string | null; last_name?: string | null } | null;
  } | null;
  updateEconomicUnitCustomData?: { success: boolean; errorMessage?: string | null };
};

export type DataCollectionDeleteEconomicUnitMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DataCollectionDeleteEconomicUnitMutation = {
  delete_economic_unit_by_pk?: { __typename: 'economic_unit'; id: number; buildings: Array<{ id: number }> } | null;
};

export type DataCollectionDeleteEconomicUnitsMutationVariables = Exact<{
  where: economic_unit_bool_exp;
}>;

export type DataCollectionDeleteEconomicUnitsMutation = {
  delete_economic_unit?: {
    affected_rows: number;
    returning: Array<{ __typename: 'economic_unit'; id: number }>;
  } | null;
};

export type DataCollectionDeleteBuildingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DataCollectionDeleteBuildingMutation = {
  delete_building_by_pk?: {
    id: number;
    economic_unit: { id: number; associatedBuildingsAndDrafts: { amount: number } };
  } | null;
};

export type DataCollectionDeleteInactiveBuildingsByIdMutationVariables = Exact<{
  buildingIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type DataCollectionDeleteInactiveBuildingsByIdMutation = {
  delete_inactive_buildings?: {
    affected_rows: number;
    returning: Array<{ id: number; economic_unit: { id: number; associatedBuildingsAndDrafts: { amount: number } } }>;
  } | null;
};

export type UpdateBuildingLocationMutationVariables = Exact<{
  buildingId: Scalars['Float']['input'];
  coordinates?: InputMaybe<Coordinates>;
  selectedIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  approximate: Scalars['Boolean']['input'];
  buildingCitydbGmlIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  neighborCitydbGmlIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lod1BuildingIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  neighborLod1Ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type UpdateBuildingLocationMutation = {
  updateBuildingLocation: {
    message?: string | null;
    success: boolean;
    building?: {
      id: number;
      address: {
        id: number;
        mapbox_building_ids: Array<string>;
        building_citydb_gml_ids?: Array<string> | null;
        building_lod1_ids?: Array<string> | null;
        latitude?: number | null;
        longitude?: number | null;
      };
    } | null;
  };
};

export type DataCollectionBuildingDraftsListDeleteBuildingDraftsMutationVariables = Exact<{
  where: building_draft_bool_exp;
}>;

export type DataCollectionBuildingDraftsListDeleteBuildingDraftsMutation = {
  delete_building_draft?: { affected_rows: number } | null;
};

export type UploadEnergyCertificateDraftMutationVariables = Exact<{
  buildingDraftId: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
}>;

export type UploadEnergyCertificateDraftMutation = {
  uploadEnergyCertificateDraft: {
    uploadUrl?: string | null;
    energyCertificateDraftId?: number | null;
    UploadEnergyCertificateDraftId?: {
      __typename: 'energy_certificate_draft';
      id: number;
      street?: string | null;
      draft_status_id: draft_status_enum;
      postal_code?: string | null;
      city?: string | null;
      country_id: country_enum;
      country_state_id?: country_state_enum | null;
      year_constructed?: number | null;
      area_usable?: number | null;
      type_of_use_id?: type_of_use_enum | null;
      energy_certificate_type_id?: energy_certificate_type_enum | null;
      expiry_date?: string | null;
      units?: number | null;
      geg_reference_value?: number | null;
      energy_rating_score?: number | null;
      co2_emissions?: number | null;
      reference_value_heating_hot_water?: number | null;
      reference_value_electricity?: number | null;
      enev_year?: number | null;
      file: { id: number; name?: string | null; downloadUrl: string; uploading: boolean };
      energy_certificate_consumers: Array<{
        id: number;
        energy_system_type_id: energy_system_type_enum;
        energy_source_type_id: energy_source_type_enum;
        energy_final: number;
      }>;
    } | null;
  };
};

export type DeleteEnergyCertificateDraftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteEnergyCertificateDraftMutation = { delete_energy_certificate_draft_by_pk?: { id: number } | null };

export type DeleteEnergyCertificateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteEnergyCertificateMutation = { delete_energy_certificate_by_pk?: { id: number } | null };

export type DataCollectionSaveConsumptionInvoiceDraftMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  consumptionInvoiceDraftId: Scalars['Int']['input'];
  invoicePayer?: InputMaybe<invoice_payer_type_enum>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  draftStatus: draft_status_enum;
  consumptionDrafts: Array<ConsumptionDraftInput> | ConsumptionDraftInput;
}>;

export type DataCollectionSaveConsumptionInvoiceDraftMutation = {
  updateConsumptionInvoiceDraft: {
    UpdateConsumptionInvoiceDraftOutput?: {
      id: number;
      date?: string | null;
      invoice_payer?: invoice_payer_type_enum | null;
      draft_status: draft_status_enum;
      building: { id: number };
      consumption_drafts: Array<{
        id: number;
        from?: string | null;
        to?: string | null;
        provider?: string | null;
        value?: number | null;
        display_unit_value?: consumption_unit_enum | null;
        cost?: number | null;
        consumption_type_id?: consumption_type_enum | null;
        energy_source_type_id?: energy_source_type_enum | null;
        sub_type_id?: consumption_sub_type_enum | null;
        consumption_waste_details_draft?: {
          id: number;
          volume?: number | null;
          display_unit_volume?: consumption_unit_enum | null;
          frequency?: number | null;
          display_unit_frequency?: consumption_frequency_type_enum | null;
          amount?: number | null;
          price?: number | null;
        } | null;
      }>;
    } | null;
  };
};

export type DataCollectionAreaConsumptionDraftCreateConsumptionFromDraftMutationVariables = Exact<{
  consumptionInvoiceDraftId: Scalars['Int']['input'];
}>;

export type DataCollectionAreaConsumptionDraftCreateConsumptionFromDraftMutation = {
  createConsumptionInvoiceFromDraft: { consumption_invoice_id: number };
};

export type DataCollectionConsumptionDraftStatusSubscriptionSubscriptionVariables = Exact<{
  consumptionInvoiceDraftId: Scalars['Int']['input'];
}>;

export type DataCollectionConsumptionDraftStatusSubscriptionSubscription = {
  consumption_invoice_draft_by_pk?: { id: number; draft_status: draft_status_enum; updated_at: string } | null;
};

export type DataCollectionAreaConsumptionInvoiceDraftSetOcrFailedMutationVariables = Exact<{
  consumptionInvoiceDraftId: Scalars['Int']['input'];
}>;

export type DataCollectionAreaConsumptionInvoiceDraftSetOcrFailedMutation = {
  update_consumption_invoice_draft_by_pk?: { id: number } | null;
};

export type UploadConsumptionDraftModalCreateConsumptionDraftMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type UploadConsumptionDraftModalCreateConsumptionDraftMutation = {
  createConsumptionInvoiceDraft: {
    upload_url: string;
    CreateConsumptionInvoiceDraftOutput?: { id: number; file_id?: number | null; created_at: string } | null;
  };
};

export type ApplyBuildingModelMutationsMutationVariables = Exact<{
  buildingModelId: Scalars['Int']['input'];
  buildingModelMutation: BuildingModelMutation;
  envelopeMutations: Array<EnvelopeMutation> | EnvelopeMutation;
  energySystemMutations: Array<EnergySystemMutation> | EnergySystemMutation;
  energySystemConsumerMutations: Array<EnergyConsumerMutation> | EnergyConsumerMutation;
  energyProducerMutations: Array<EnergyProducerMutation> | EnergyProducerMutation;
  energySystemStorageMutations: Array<EnergyStorageMutation> | EnergyStorageMutation;
  energySystemDistributionMutations: Array<EnergyDistributionMutation> | EnergyDistributionMutation;
  saveInvalidState: Scalars['Boolean']['input'];
  dryRun?: Scalars['Boolean']['input'];
}>;

export type ApplyBuildingModelMutationsMutation = {
  applyBuildingModelMutations: {
    scaling_successful: boolean;
    final_energy: number;
    final_energy_scaled: number;
    heating_demand_envelope?: number | null;
    heating_demand_system?: number | null;
  };
};

export type DataCollectionSaveConsumptionInvoiceMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  consumptionInvoiceId: Scalars['Int']['input'];
  invoicePayer: invoice_payer_type_enum;
  invoiceDate: Scalars['DateTime']['input'];
  consumptions: Array<ConsumptionInput> | ConsumptionInput;
}>;

export type DataCollectionSaveConsumptionInvoiceMutation = {
  updateConsumptionInvoice: {
    UpdateConsumptionInvoiceOutput?: {
      id: number;
      date: string;
      invoice_payer: invoice_payer_type_enum;
      building: { id: number };
      consumptions: Array<{
        id: number;
        from: string;
        to: string;
        provider?: string | null;
        value?: number | null;
        display_unit_value?: consumption_unit_enum | null;
        cost?: number | null;
        consumption_type_id: consumption_type_enum;
        energy_source_type_id?: energy_source_type_enum | null;
        sub_type_id?: consumption_sub_type_enum | null;
        consumption_waste_detail?: {
          id: number;
          volume: number;
          display_unit_volume?: consumption_unit_enum | null;
          frequency: number;
          display_unit_frequency?: consumption_frequency_type_enum | null;
          amount: number;
          price: number;
        } | null;
      }>;
    } | null;
  };
};

export type DataCollectionInsertConsumptionDraftMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  areaIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  sourceTypeId: consumption_source_type_enum;
  consumptionTypeId?: InputMaybe<consumption_type_enum>;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
  userId: Scalars['Int']['input'];
}>;

export type DataCollectionInsertConsumptionDraftMutation = {
  createConsumptionDraft?: {
    id: number;
    consumption_draft?: {
      id: number;
      building_id: number;
      consumption_type_id?: consumption_type_enum | null;
      cost?: number | null;
      created_by_user_id?: number | null;
      energy_source_type_id?: energy_source_type_enum | null;
      from?: string | null;
      provider?: string | null;
      source_type_id: consumption_source_type_enum;
      sub_type_id?: consumption_sub_type_enum | null;
      to?: string | null;
      displayValue?: number | null;
      display_unit_value?: consumption_unit_enum | null;
    } | null;
  } | null;
};

export type DataCollectionInsertConsumptionWasteDetailsDraftMutationVariables = Exact<{
  consumptionDraftId: Scalars['Int']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<Scalars['Float']['input']>;
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  price?: InputMaybe<Scalars['Float']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
}>;

export type DataCollectionInsertConsumptionWasteDetailsDraftMutation = {
  createConsumptionWasteDetailsDraft?: {
    id: number;
    consumption_waste_details_draft?: {
      id: number;
      amount?: number | null;
      frequency?: number | null;
      display_unit_frequency?: consumption_frequency_type_enum | null;
      price?: number | null;
      volume?: number | null;
      display_unit_volume?: consumption_unit_enum | null;
    } | null;
  } | null;
};

export type DataCollectionSaveConsumptionDraftMutationVariables = Exact<{
  consumptionDraftId: Scalars['Int']['input'];
  areaIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  consumptionTypeId?: InputMaybe<consumption_type_enum>;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
}>;

export type DataCollectionSaveConsumptionDraftMutation = {
  updateConsumptionDraft?: {
    id: number;
    consumption_draft?: {
      id: number;
      building_id: number;
      consumption_type_id?: consumption_type_enum | null;
      cost?: number | null;
      created_by_user_id?: number | null;
      energy_source_type_id?: energy_source_type_enum | null;
      from?: string | null;
      provider?: string | null;
      source_type_id: consumption_source_type_enum;
      sub_type_id?: consumption_sub_type_enum | null;
      to?: string | null;
      value?: number | null;
      displayValue?: number | null;
      display_unit_value?: consumption_unit_enum | null;
      consumption_waste_details_draft?: { id: number } | null;
    } | null;
  } | null;
};

export type DataCollectionUpdateConsumptionWasteDetailsDraftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<Scalars['Float']['input']>;
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  price?: InputMaybe<Scalars['Float']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
}>;

export type DataCollectionUpdateConsumptionWasteDetailsDraftMutation = {
  updateConsumptionWasteDetailsDraft?: {
    id: number;
    consumption_waste_details_draft?: {
      id: number;
      amount?: number | null;
      frequency?: number | null;
      display_unit_frequency?: consumption_frequency_type_enum | null;
      price?: number | null;
      volume?: number | null;
      display_unit_volume?: consumption_unit_enum | null;
    } | null;
  } | null;
};

export type DataCollectionDeleteConsumptionWasteDetailsDraftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DataCollectionDeleteConsumptionWasteDetailsDraftMutation = {
  delete_consumption_waste_details_draft_by_pk?: { id: number } | null;
};

export type DataCollectionCreateManualConsumptionMutationVariables = Exact<{
  areaIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  buildingId: Scalars['Int']['input'];
  consumptionTypeId: consumption_type_enum;
  cost?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  from: Scalars['DateTime']['input'];
  provider: Scalars['String']['input'];
  sourceTypeId: ManualConsumptionSourceTypeEnum;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
  to: Scalars['DateTime']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
  wasteDetails?: InputMaybe<WasteDetailsInlineInput>;
}>;

export type DataCollectionCreateManualConsumptionMutation = { createManualConsumption?: { id: number } | null };

export type DataCollectionInsertConsumptionMutationVariables = Exact<{
  consumptionDraftId: Scalars['Int']['input'];
  areaIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  buildingId: Scalars['Int']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  provider: Scalars['String']['input'];
  sourceTypeId: consumption_source_type_enum;
  consumptionTypeId: consumption_type_enum;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
  createdByUserId: Scalars['Int']['input'];
}>;

export type DataCollectionInsertConsumptionMutation = {
  createConsumptionFromDraft?: {
    id: number;
    consumption?: {
      id: number;
      consumption_type_id: consumption_type_enum;
      cost?: number | null;
      created_by_user_id?: number | null;
      energy_source_type_id?: energy_source_type_enum | null;
      from: string;
      provider?: string | null;
      source_type_id: consumption_source_type_enum;
      sub_type_id?: consumption_sub_type_enum | null;
      to: string;
      value?: number | null;
      display_unit_value?: consumption_unit_enum | null;
    } | null;
  } | null;
};

export type DataCollectionInsertConsumptionWasteDetailsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  frequency: Scalars['Float']['input'];
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  price: Scalars['Float']['input'];
  volume: Scalars['Float']['input'];
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
}>;

export type DataCollectionInsertConsumptionWasteDetailsMutation = {
  createConsumptionWasteDetails?: {
    id: number;
    consumption_waste_details?: {
      id: number;
      amount: number;
      frequency: number;
      display_unit_frequency?: consumption_frequency_type_enum | null;
      price: number;
      volume: number;
      display_unit_volume?: consumption_unit_enum | null;
    } | null;
  } | null;
};

export type DataCollectionSaveConsumptionMutationVariables = Exact<{
  consumptionId: Scalars['Int']['input'];
  areaIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
  displayUnitValue?: InputMaybe<consumption_unit_enum>;
  cost?: InputMaybe<Scalars['Float']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  consumptionTypeId: consumption_type_enum;
  energySourceTypeId?: InputMaybe<energy_source_type_enum>;
  subTypeId?: InputMaybe<consumption_sub_type_enum>;
}>;

export type DataCollectionSaveConsumptionMutation = {
  updateConsumption?: {
    id: number;
    consumption?: {
      id: number;
      consumption_type_id: consumption_type_enum;
      cost?: number | null;
      created_by_user_id?: number | null;
      energy_source_type_id?: energy_source_type_enum | null;
      from: string;
      provider?: string | null;
      source_type_id: consumption_source_type_enum;
      sub_type_id?: consumption_sub_type_enum | null;
      to: string;
      value?: number | null;
      display_unit_value?: consumption_unit_enum | null;
      consumption_waste_detail?: { id: number } | null;
    } | null;
  } | null;
};

export type DataCollectionUpdateConsumptionWasteDetailsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  amount: Scalars['Float']['input'];
  frequency: Scalars['Float']['input'];
  displayUnitFrequency?: InputMaybe<consumption_frequency_type_enum>;
  price: Scalars['Float']['input'];
  volume: Scalars['Float']['input'];
  displayUnitVolume?: InputMaybe<consumption_unit_enum>;
}>;

export type DataCollectionUpdateConsumptionWasteDetailsMutation = {
  updateConsumptionWasteDetails?: {
    id: number;
    consumption_waste_details?: {
      id: number;
      amount: number;
      frequency: number;
      display_unit_frequency?: consumption_frequency_type_enum | null;
      price: number;
      volume: number;
      display_unit_volume?: consumption_unit_enum | null;
    } | null;
  } | null;
};

export type DataCollectionDeleteConsumptionWasteDetailsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DataCollectionDeleteConsumptionWasteDetailsMutation = {
  delete_consumption_waste_details_by_pk?: { id: number } | null;
};

export type DeleteConsumptionInvoiceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteConsumptionInvoiceMutation = {
  delete_consumption_invoice_by_pk?: { __typename: 'consumption_invoice'; id: number } | null;
};

export type DeleteConsumptionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteConsumptionMutation = { delete_consumption_by_pk?: { __typename: 'consumption'; id: number } | null };

export type DeleteConsumptionInvoiceDraftMutationVariables = Exact<{
  invoiceDraftId: Scalars['Int']['input'];
}>;

export type DeleteConsumptionInvoiceDraftMutation = {
  delete_consumption_invoice_draft_by_pk?: {
    __typename: 'consumption_invoice_draft';
    id: number;
    consumption_drafts: Array<{ __typename: 'consumption_draft'; id: number }>;
  } | null;
};

export type DataCollectionAreaConsumptionDraftDeleteConsumptionDraftMutationVariables = Exact<{
  consumptionDraftId: Scalars['Int']['input'];
}>;

export type DataCollectionAreaConsumptionDraftDeleteConsumptionDraftMutation = {
  delete_consumption_draft_by_pk?: { __typename: 'consumption_draft'; id: number } | null;
};

export type CreateEmissionCertificateDraftWithoutFileMutationVariables = Exact<{
  emissionCertificateDraftWithoutFile: CreateEmissionCertificateDraftWithoutFileInput;
}>;

export type CreateEmissionCertificateDraftWithoutFileMutation = {
  createEmissionCertificateDraftWithoutFile: { emission_certificate_draft_id: number };
};

export type CreateEmissionCertificateDraftWithFileMutationVariables = Exact<{
  emissionCertificateDraftWithoutFile: CreateEmissionCertificateDraftWithoutFileInput;
}>;

export type CreateEmissionCertificateDraftWithFileMutation = {
  createEmissionCertificateDraftWithFile: { fileUrl: string; fileId: number };
};

export type UpdateEmissionCertificateDraftWithoutFileMutationVariables = Exact<{
  emissionCertificateDraftWithoutFile: UpdateEmissionCertificateDraftWithoutFileInput;
}>;

export type UpdateEmissionCertificateDraftWithoutFileMutation = {
  updateEmissionCertificateDraftWithoutFile: { emission_certificate_draft_id: number };
};

export type UpdateEmissionCertificateDraftWithFileMutationVariables = Exact<{
  emissionCertificateDraftWithoutFile: UpdateEmissionCertificateDraftWithoutFileInput;
}>;

export type UpdateEmissionCertificateDraftWithFileMutation = {
  updateEmissionCertificateDraftWithFile: { fileUrl: string; fileId: number };
};

export type CreateEmissionCertificateMutationVariables = Exact<{
  emissionCertificate: CreateEmissionCertificateInput;
}>;

export type CreateEmissionCertificateMutation = { createEmissionCertificate: { emission_certificate_id: number } };

export type UpdateEmissionCertificateWithoutFileMutationVariables = Exact<{
  emissionCertificate: UpdateEmissionCertificateWithoutFileInput;
}>;

export type UpdateEmissionCertificateWithoutFileMutation = {
  updateEmissionCertificateWithoutFile: { success: boolean };
};

export type UpdateEmissionCertificateFileMutationVariables = Exact<{
  emissionCertificateId: Scalars['Int']['input'];
}>;

export type UpdateEmissionCertificateFileMutation = {
  updateEmissionCertificateFile: { fileUrl: string; fileId: number };
};

export type DeleteEmissionCertificateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteEmissionCertificateMutation = { deleteEmissionCertificate: { success: boolean } };

export type DeleteEmissionCertificateDraftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteEmissionCertificateDraftMutation = {
  delete_emission_certificate_draft_by_pk?: { __typename: 'emission_certificate_draft'; id: number } | null;
};

export type EditAreasMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  areas: Array<AreaUpdateInput> | AreaUpdateInput;
  saveInvalidState: Scalars['Boolean']['input'];
}>;

export type EditAreasMutation = {
  editAreas: {
    success: boolean;
    scalingResult?: { final_energy: number; final_energy_scaled: number; scaling_successful: boolean } | null;
    efficiencyClassDeviation?: {
      previousEfficiencyClass: efficiency_class_enum;
      newEfficiencyClass: efficiency_class_enum;
    } | null;
  };
};

export type PreviewEditAreasMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  areas: Array<AreaUpdateInput> | AreaUpdateInput;
  saveInvalidState: Scalars['Boolean']['input'];
}>;

export type PreviewEditAreasMutation = {
  previewEditAreas: {
    success: boolean;
    efficiencyClassDeviation?: {
      previousEfficiencyClass: efficiency_class_enum;
      newEfficiencyClass: efficiency_class_enum;
    } | null;
  };
};

export type MoveBuildingsToEconomicUnitMutationVariables = Exact<{
  destinationEconomicUnitId: Scalars['Int']['input'];
  keepEmptyEconomicUnits: Scalars['Boolean']['input'];
  buildingWhere: BuildingWhere;
}>;

export type MoveBuildingsToEconomicUnitMutation = { moveAllBuildings: { success: boolean } };

export type ExportFileMutationVariables = Exact<{
  input: ExportFileInput;
}>;

export type ExportFileMutation = { exportFile: { fileName: string; jobId: string; status: string } };

export type DeleteBuildingsMutationVariables = Exact<{
  buildingWhere: BuildingWhere;
  keepEmptyEconomicUnits: Scalars['Boolean']['input'];
}>;

export type DeleteBuildingsMutation = { deleteAllBuildings: { success: boolean } };

export type EditBuildingDataMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  buildingData: building_set_input;
  addressId: Scalars['Int']['input'];
  addressData: address_set_input;
  valuations: Array<building_valuation_insert_input> | building_valuation_insert_input;
  deletedValuationIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  shouldDeleteDistrictHeating: Scalars['Boolean']['input'];
  shouldUpsertDistrictHeating: Scalars['Boolean']['input'];
  districtHeatingYear?: InputMaybe<Scalars['Int']['input']>;
  insertCertificates: Array<CreateCertificate> | CreateCertificate;
  updateCertificates: Array<EditCertificate> | EditCertificate;
  deleteCertificates: Array<DeleteCertificate> | DeleteCertificate;
}>;

export type EditBuildingDataMutation = {
  update_building_by_pk?: {
    id: number;
    building_state_id: building_state_enum;
    monument_protection: boolean;
    leasehold: boolean;
    heritage_district: boolean;
    milieu_protection: boolean;
    customer_external_identifier?: string | null;
    description: string;
    units: number;
    units_data_source: data_source_type_enum;
  } | null;
  update_address_by_pk?: { id: number; street: string; postal_code: string; city: string } | null;
  insert_building_valuation?: {
    returning: Array<{ id: number; valuation_at: string; value: number; building_id: number }>;
  } | null;
  delete_building_valuation?: { affected_rows: number } | null;
  delete_building_district_heating_availability?: { affected_rows: number } | null;
  insert_building_district_heating_availability_one?: {
    id: number;
    building: {
      id: number;
      district_heating_availability_status?: {
        district_heating_status?: string | null;
        district_heating_year?: number | null;
        updated_at?: string | null;
        id?: number | null;
      } | null;
    };
  } | null;
  editCertificates: { certificates: Array<{ id: number }> };
};

export type UpdateBuildingCustomDataMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  customData: Scalars['JSON']['input'];
}>;

export type UpdateBuildingCustomDataMutation = {
  updateBuildingCustomData: { success: boolean; errorMessage?: string | null };
};

export type CreateBuildingDraftMutationVariables = Exact<{
  buildingDraft: building_draft_insert_input;
}>;

export type CreateBuildingDraftMutation = {
  insert_building_draft_one?: {
    id: number;
    year_constructed?: number | null;
    responsible_user_id?: number | null;
    postal_code: string;
    building_state_id?: building_state_enum | null;
    city: string;
    country_id: country_enum;
    economic_unit_id?: number | null;
    heritage_district: boolean;
    monument_protection: boolean;
    milieu_protection: boolean;
    leasehold: boolean;
    portfolio_id: number;
    floors?: number | null;
    external_id?: string | null;
    street: string;
    units?: number | null;
    latitude?: number | null;
    longitude?: number | null;
    mapbox_building_ids?: Array<string> | null;
    building_citydb_gml_ids?: Array<string> | null;
    neighbor_citydb_gml_ids?: Array<string> | null;
    building_lod1_ids?: Array<string> | null;
    neighbor_lod1_ids?: Array<string> | null;
    custom_data: any;
    assign_responsible_user_as_transaction_manager?: boolean | null;
    building_draft_valuations: Array<{ id: number; value: number; valuation_at: string }>;
    building_draft_consumers: Array<{
      id: number;
      energy_source_type_id?: energy_source_type_enum | null;
      energy_final?: number | null;
      energy_system_type_id: energy_system_type_enum;
      building_draft_area_id?: number | null;
    }>;
    building_draft_areas: Array<{
      id: number;
      name: string;
      type_of_use_id?: type_of_use_enum | null;
      value?: number | null;
      energy_certificate_id?: number | null;
      geg_reference_value?: number | null;
      energy_rating_score?: number | null;
      reference_value_heating_hot_water?: number | null;
      reference_value_electricity?: number | null;
      enev_year?: number | null;
    }>;
    energy_certificate_drafts: Array<{
      __typename: 'energy_certificate_draft';
      id: number;
      street?: string | null;
      draft_status_id: draft_status_enum;
      postal_code?: string | null;
      city?: string | null;
      country_id: country_enum;
      country_state_id?: country_state_enum | null;
      year_constructed?: number | null;
      area_usable?: number | null;
      type_of_use_id?: type_of_use_enum | null;
      energy_certificate_type_id?: energy_certificate_type_enum | null;
      expiry_date?: string | null;
      units?: number | null;
      geg_reference_value?: number | null;
      energy_rating_score?: number | null;
      co2_emissions?: number | null;
      reference_value_heating_hot_water?: number | null;
      reference_value_electricity?: number | null;
      enev_year?: number | null;
      file: { id: number; name?: string | null; downloadUrl: string; uploading: boolean };
      energy_certificate_consumers: Array<{
        id: number;
        energy_system_type_id: energy_system_type_enum;
        energy_source_type_id: energy_source_type_enum;
        energy_final: number;
      }>;
    }>;
    energy_certificates: Array<{
      __typename: 'energy_certificate';
      id: number;
      updated_at: string;
      street?: string | null;
      postal_code?: string | null;
      city?: string | null;
      country_id: country_enum;
      year_constructed?: number | null;
      area_usable?: number | null;
      type_of_use_id: type_of_use_enum;
      energy_certificate_type: energy_certificate_type_enum;
      expiry_date?: string | null;
      units_commercial?: number | null;
      units_residential?: number | null;
      geg_reference_value?: number | null;
      energy_rating_score?: number | null;
      co2_emissions?: number | null;
      reference_value_heating_hot_water?: number | null;
      reference_value_electricity?: number | null;
      enev_year?: number | null;
      energy_certificate_consumers: Array<{
        id: number;
        energy_system_type_id: energy_system_type_enum;
        energy_source_type_id: energy_source_type_enum;
        energy_final: number;
      }>;
      file?: { id: number; name?: string | null; uploading: boolean; downloadUrl: string } | null;
    }>;
    certificates: Array<{
      id: number;
      certificate_level_type?: certificate_level_type_enum | null;
      certificate_score?: number | null;
      certificate_type: certificate_type_enum;
      file?: { id: number; name?: string | null } | null;
    }>;
  } | null;
};

export type UpdateBuildingDraftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  buildingDraft?: building_draft_set_input;
  valuationInserts?: Array<building_draft_valuation_insert_input> | building_draft_valuation_insert_input;
  valuationUpdates?: Array<building_draft_valuation_updates> | building_draft_valuation_updates;
  valuationDeletedIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  consumerInserts?: Array<building_draft_consumer_insert_input> | building_draft_consumer_insert_input;
  consumerUpdates?: Array<building_draft_consumer_updates> | building_draft_consumer_updates;
  consumerDeletedIds?: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  areaInserts?: Array<building_draft_area_insert_input> | building_draft_area_insert_input;
  areaUpdates?: Array<building_draft_area_updates> | building_draft_area_updates;
  areaDeletedIds?: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  deleteCertificates?: Array<DeleteCertificate> | DeleteCertificate;
  insertCertificates?: Array<CreateCertificate> | CreateCertificate;
  updateCertificates?: Array<EditCertificate> | EditCertificate;
}>;

export type UpdateBuildingDraftMutation = {
  update_building_draft_by_pk?: { id: number } | null;
  insert_building_draft_valuation?: { affected_rows: number } | null;
  update_building_draft_valuation_many?: Array<{ affected_rows: number } | null> | null;
  delete_building_draft_valuation?: { affected_rows: number } | null;
  insert_building_draft_consumer?: { affected_rows: number } | null;
  update_building_draft_consumer_many?: Array<{ affected_rows: number } | null> | null;
  delete_building_draft_consumer?: { affected_rows: number } | null;
  insert_building_draft_area?: { affected_rows: number } | null;
  update_building_draft_area_many?: Array<{ affected_rows: number } | null> | null;
  delete_building_draft_area?: { affected_rows: number } | null;
  update_building_draft_consumer?: { affected_rows: number } | null;
  editCertificates: { certificates: Array<{ id: number }> };
};

export type CreateBuildingFromBuildingDraftMutationVariables = Exact<{
  buildingDraftId: Scalars['Int']['input'];
}>;

export type CreateBuildingFromBuildingDraftMutation = {
  createBuildingFromBuildingDraft: { buildingId: number; success: boolean };
};

export type ExportClimateRiskV2ReportMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type ExportClimateRiskV2ReportMutation = { exportClimateRiskV2Report: { body: string } };

export type UpdateEnergyCertificateDraftMutationVariables = Exact<{
  obj: energy_certificate_draft_set_input;
  id: Scalars['Int']['input'];
  insertConsumers: Array<energy_certificate_consumer_insert_input> | energy_certificate_consumer_insert_input;
  updateConsumers: Array<energy_certificate_consumer_updates> | energy_certificate_consumer_updates;
  deleteConsumers: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type UpdateEnergyCertificateDraftMutation = {
  update_energy_certificate_draft_by_pk?: { id: number } | null;
  insert_energy_certificate_consumer?: { affected_rows: number } | null;
  update_energy_certificate_consumer_many?: Array<{ affected_rows: number } | null> | null;
  delete_energy_certificate_consumer?: { affected_rows: number } | null;
};

export type CreateEPCFromDraftMutationVariables = Exact<{
  energyCertificateDraftId: Scalars['Int']['input'];
}>;

export type CreateEPCFromDraftMutation = {
  transformEnergyCertificateDraftToEnergyCertificate: {
    success: boolean;
    energyCertificateId?: number | null;
    EnergyCertificateDraftTransformOutput?: {
      __typename: 'energy_certificate';
      id: number;
      updated_at: string;
      street?: string | null;
      postal_code?: string | null;
      city?: string | null;
      country_id: country_enum;
      year_constructed?: number | null;
      area_usable?: number | null;
      type_of_use_id: type_of_use_enum;
      energy_certificate_type: energy_certificate_type_enum;
      expiry_date?: string | null;
      units_commercial?: number | null;
      units_residential?: number | null;
      geg_reference_value?: number | null;
      energy_rating_score?: number | null;
      co2_emissions?: number | null;
      reference_value_heating_hot_water?: number | null;
      reference_value_electricity?: number | null;
      enev_year?: number | null;
      energy_certificate_consumers: Array<{
        id: number;
        energy_system_type_id: energy_system_type_enum;
        energy_source_type_id: energy_source_type_enum;
        energy_final: number;
      }>;
      file?: { id: number; name?: string | null; uploading: boolean; downloadUrl: string } | null;
    } | null;
  };
};

export type FillBuildingDraftMutationVariables = Exact<{
  buildingDraftId: Scalars['Int']['input'];
}>;

export type FillBuildingDraftMutation = {
  fillBuildingDraft: {
    success: boolean;
    BuildingDraftId: Array<{
      id: number;
      year_constructed?: number | null;
      responsible_user_id?: number | null;
      postal_code: string;
      building_state_id?: building_state_enum | null;
      city: string;
      country_id: country_enum;
      economic_unit_id?: number | null;
      heritage_district: boolean;
      monument_protection: boolean;
      milieu_protection: boolean;
      leasehold: boolean;
      portfolio_id: number;
      floors?: number | null;
      external_id?: string | null;
      street: string;
      units?: number | null;
      latitude?: number | null;
      longitude?: number | null;
      mapbox_building_ids?: Array<string> | null;
      building_citydb_gml_ids?: Array<string> | null;
      neighbor_citydb_gml_ids?: Array<string> | null;
      building_lod1_ids?: Array<string> | null;
      neighbor_lod1_ids?: Array<string> | null;
      custom_data: any;
      assign_responsible_user_as_transaction_manager?: boolean | null;
      building_draft_valuations: Array<{ id: number; value: number; valuation_at: string }>;
      building_draft_consumers: Array<{
        id: number;
        energy_source_type_id?: energy_source_type_enum | null;
        energy_final?: number | null;
        energy_system_type_id: energy_system_type_enum;
        building_draft_area_id?: number | null;
      }>;
      building_draft_areas: Array<{
        id: number;
        name: string;
        type_of_use_id?: type_of_use_enum | null;
        value?: number | null;
        energy_certificate_id?: number | null;
        geg_reference_value?: number | null;
        energy_rating_score?: number | null;
        reference_value_heating_hot_water?: number | null;
        reference_value_electricity?: number | null;
        enev_year?: number | null;
      }>;
      energy_certificate_drafts: Array<{
        __typename: 'energy_certificate_draft';
        id: number;
        street?: string | null;
        draft_status_id: draft_status_enum;
        postal_code?: string | null;
        city?: string | null;
        country_id: country_enum;
        country_state_id?: country_state_enum | null;
        year_constructed?: number | null;
        area_usable?: number | null;
        type_of_use_id?: type_of_use_enum | null;
        energy_certificate_type_id?: energy_certificate_type_enum | null;
        expiry_date?: string | null;
        units?: number | null;
        geg_reference_value?: number | null;
        energy_rating_score?: number | null;
        co2_emissions?: number | null;
        reference_value_heating_hot_water?: number | null;
        reference_value_electricity?: number | null;
        enev_year?: number | null;
        file: { id: number; name?: string | null; downloadUrl: string; uploading: boolean };
        energy_certificate_consumers: Array<{
          id: number;
          energy_system_type_id: energy_system_type_enum;
          energy_source_type_id: energy_source_type_enum;
          energy_final: number;
        }>;
      }>;
      energy_certificates: Array<{
        __typename: 'energy_certificate';
        id: number;
        updated_at: string;
        street?: string | null;
        postal_code?: string | null;
        city?: string | null;
        country_id: country_enum;
        year_constructed?: number | null;
        area_usable?: number | null;
        type_of_use_id: type_of_use_enum;
        energy_certificate_type: energy_certificate_type_enum;
        expiry_date?: string | null;
        units_commercial?: number | null;
        units_residential?: number | null;
        geg_reference_value?: number | null;
        energy_rating_score?: number | null;
        co2_emissions?: number | null;
        reference_value_heating_hot_water?: number | null;
        reference_value_electricity?: number | null;
        enev_year?: number | null;
        energy_certificate_consumers: Array<{
          id: number;
          energy_system_type_id: energy_system_type_enum;
          energy_source_type_id: energy_source_type_enum;
          energy_final: number;
        }>;
        file?: { id: number; name?: string | null; uploading: boolean; downloadUrl: string } | null;
      }>;
      certificates: Array<{
        id: number;
        certificate_level_type?: certificate_level_type_enum | null;
        certificate_score?: number | null;
        certificate_type: certificate_type_enum;
        file?: { id: number; name?: string | null } | null;
      }>;
    }>;
  };
};

export type ResetBuildingDraftMutationVariables = Exact<{
  buildingDraftId: Scalars['Int']['input'];
}>;

export type ResetBuildingDraftMutation = {
  resetBuildingDraft: {
    success: boolean;
    buildingDraft?: {
      id: number;
      year_constructed?: number | null;
      responsible_user_id?: number | null;
      postal_code: string;
      building_state_id?: building_state_enum | null;
      city: string;
      country_id: country_enum;
      economic_unit_id?: number | null;
      heritage_district: boolean;
      monument_protection: boolean;
      milieu_protection: boolean;
      leasehold: boolean;
      portfolio_id: number;
      floors?: number | null;
      external_id?: string | null;
      street: string;
      units?: number | null;
      latitude?: number | null;
      longitude?: number | null;
      mapbox_building_ids?: Array<string> | null;
      building_citydb_gml_ids?: Array<string> | null;
      neighbor_citydb_gml_ids?: Array<string> | null;
      building_lod1_ids?: Array<string> | null;
      neighbor_lod1_ids?: Array<string> | null;
      custom_data: any;
      assign_responsible_user_as_transaction_manager?: boolean | null;
      building_draft_valuations: Array<{ id: number; value: number; valuation_at: string }>;
      building_draft_consumers: Array<{
        id: number;
        energy_source_type_id?: energy_source_type_enum | null;
        energy_final?: number | null;
        energy_system_type_id: energy_system_type_enum;
        building_draft_area_id?: number | null;
      }>;
      building_draft_areas: Array<{
        id: number;
        name: string;
        type_of_use_id?: type_of_use_enum | null;
        value?: number | null;
        energy_certificate_id?: number | null;
        geg_reference_value?: number | null;
        energy_rating_score?: number | null;
        reference_value_heating_hot_water?: number | null;
        reference_value_electricity?: number | null;
        enev_year?: number | null;
      }>;
      energy_certificate_drafts: Array<{
        __typename: 'energy_certificate_draft';
        id: number;
        street?: string | null;
        draft_status_id: draft_status_enum;
        postal_code?: string | null;
        city?: string | null;
        country_id: country_enum;
        country_state_id?: country_state_enum | null;
        year_constructed?: number | null;
        area_usable?: number | null;
        type_of_use_id?: type_of_use_enum | null;
        energy_certificate_type_id?: energy_certificate_type_enum | null;
        expiry_date?: string | null;
        units?: number | null;
        geg_reference_value?: number | null;
        energy_rating_score?: number | null;
        co2_emissions?: number | null;
        reference_value_heating_hot_water?: number | null;
        reference_value_electricity?: number | null;
        enev_year?: number | null;
        file: { id: number; name?: string | null; downloadUrl: string; uploading: boolean };
        energy_certificate_consumers: Array<{
          id: number;
          energy_system_type_id: energy_system_type_enum;
          energy_source_type_id: energy_source_type_enum;
          energy_final: number;
        }>;
      }>;
      energy_certificates: Array<{
        __typename: 'energy_certificate';
        id: number;
        updated_at: string;
        street?: string | null;
        postal_code?: string | null;
        city?: string | null;
        country_id: country_enum;
        year_constructed?: number | null;
        area_usable?: number | null;
        type_of_use_id: type_of_use_enum;
        energy_certificate_type: energy_certificate_type_enum;
        expiry_date?: string | null;
        units_commercial?: number | null;
        units_residential?: number | null;
        geg_reference_value?: number | null;
        energy_rating_score?: number | null;
        co2_emissions?: number | null;
        reference_value_heating_hot_water?: number | null;
        reference_value_electricity?: number | null;
        enev_year?: number | null;
        energy_certificate_consumers: Array<{
          id: number;
          energy_system_type_id: energy_system_type_enum;
          energy_source_type_id: energy_source_type_enum;
          energy_final: number;
        }>;
        file?: { id: number; name?: string | null; uploading: boolean; downloadUrl: string } | null;
      }>;
      certificates: Array<{
        id: number;
        certificate_level_type?: certificate_level_type_enum | null;
        certificate_score?: number | null;
        certificate_type: certificate_type_enum;
        file?: { id: number; name?: string | null } | null;
      }>;
    } | null;
  };
};

export type CreateBuildingModelTwinMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type CreateBuildingModelTwinMutation = {
  createBuildingModelTwin: { success: boolean; errorMessage?: string | null; buildingModelId?: number | null };
};

export type SetActiveBuildingModelMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  buildingModelId: Scalars['Int']['input'];
}>;

export type SetActiveBuildingModelMutation = { setActiveBuildingModel: { success: boolean } };

export type DeleteBuildingModelDraftMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  buildingModelId: Scalars['Int']['input'];
}>;

export type DeleteBuildingModelDraftMutation = { deleteTwinBuildingModel: { success: boolean } };

export type CreateCertificateFileUploadURLMutationVariables = Exact<{
  buildingId?: InputMaybe<Scalars['Int']['input']>;
  buildingDraftId?: InputMaybe<Scalars['Int']['input']>;
  fileName: Scalars['String']['input'];
}>;

export type CreateCertificateFileUploadURLMutation = {
  createCertificateFileUploadURL: { fileId: number; uploadURL: string };
};

export type SetBuildingInactiveMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type SetBuildingInactiveMutation = {
  update_building_by_pk?: {
    id: number;
    state: entity_state_type_enum;
    economic_unit: { id: number; associatedBuildingsAndDrafts: { amount: number } };
  } | null;
};

export type SetBuildingActiveMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type SetBuildingActiveMutation = {
  update_inactive_buildings?: {
    returning: Array<{
      id: number;
      state?: string | null;
      economic_unit: { id: number; associatedBuildingsAndDrafts: { amount: number } };
    }>;
  } | null;
};

export type UpdateBuildingModelTwinMutationVariables = Exact<{
  buildingModelId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  validFrom: Scalars['DateTime']['input'];
}>;

export type UpdateBuildingModelTwinMutation = { updateBuildingModelTwin: { buildingModelId: number } };

export type DuplicateBuildingModelVersionTwinMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  validFrom: Scalars['DateTime']['input'];
}>;

export type DuplicateBuildingModelVersionTwinMutation = {
  duplicateBuildingModelVersionTwin: { buildingModelId: number };
};

export type DeleteBuildingModelTwinMutationVariables = Exact<{
  buildingModelId: Scalars['Int']['input'];
}>;

export type DeleteBuildingModelTwinMutation = {
  deleteBuildingModelTwin: { buildingModelId: number; newBuildingModelId?: number | null };
};

export type DataCollectionConsumptionFragment = {
  id: number;
  provider?: string | null;
  to: string;
  from: string;
  cost?: number | null;
  display_unit_value?: consumption_unit_enum | null;
  displayValue?: number | null;
  created_at?: string | null;
  consumption_type_id: consumption_type_enum;
  source_type_id: consumption_source_type_enum;
  invoice_id?: number | null;
  energy_source_type_id?: energy_source_type_enum | null;
  sub_type_id?: consumption_sub_type_enum | null;
  created_by_user?: { first_name?: string | null; last_name?: string | null } | null;
  consumption_waste_detail?: {
    id: number;
    volume: number;
    display_unit_volume?: consumption_unit_enum | null;
    frequency: number;
    display_unit_frequency?: consumption_frequency_type_enum | null;
    amount: number;
    price: number;
  } | null;
  consumption_areas: Array<{ area_id: number }>;
};

export type DataCollectionAreaConsumptionDraftFragment = {
  id: number;
  provider?: string | null;
  to?: string | null;
  from?: string | null;
  cost?: number | null;
  display_unit_value?: consumption_unit_enum | null;
  displayValue?: number | null;
  created_at?: string | null;
  consumption_type_id?: consumption_type_enum | null;
  source_type_id: consumption_source_type_enum;
  energy_source_type_id?: energy_source_type_enum | null;
  sub_type_id?: consumption_sub_type_enum | null;
  created_by_user?: { first_name?: string | null; last_name?: string | null } | null;
  consumption_invoice_draft?: { id: number; draft_status: draft_status_enum } | null;
  consumption_waste_details_draft?: {
    id: number;
    volume?: number | null;
    display_unit_volume?: consumption_unit_enum | null;
    frequency?: number | null;
    display_unit_frequency?: consumption_frequency_type_enum | null;
    amount?: number | null;
    price?: number | null;
  } | null;
  consumption_draft_areas: Array<{ area_id: number }>;
};

export type DataCollectionBuildingSubsidyFragment = {
  __typename: 'subsidy';
  id: number;
  email?: string | null;
  amount_description: string;
  provider_updated_at: string;
  region_type: subsidy_region_type_enum;
  title: string;
  type: subsidy_type_enum;
  url?: string | null;
  categories: Array<{ subsidy_category_type: subsidy_category_type_enum }>;
};

export type DataCollectionBuildingEnvelopeFragment = {
  id: number;
  data_source_type_id: data_source_type_enum;
  description?: string | null;
  inclination?: number | null;
  orientation?: number | null;
  envelope_type_id: envelope_type_enum;
  insulation_thickness?: number | null;
  insulation_material_name?: string | null;
  insulation_material_category_id?: insulation_material_category_enum | null;
  insulation_method_id?: insulation_method_enum | null;
  insulation_lambda?: number | null;
  base_construction_thickness?: number | null;
  base_construction_material_name?: string | null;
  base_construction_lambda?: number | null;
  area: number;
  u_value?: number | null;
};

export type DataCollectionBuildingEnergySystemConsumerRouteFragment = {
  id: number;
  secondary_id: string;
  area_id?: number | null;
  energy_final: number;
  energy_effective?: number | null;
  energy_source_type_id: energy_source_type_enum;
  energy_primary?: number | null;
  emission_certificate_id?: number | null;
  use_renewable_energy: boolean;
  primary_energy_factor_emission_certificate_id?: number | null;
  emission_certificate?: {
    emission_factor: number;
    emission_factor_active_value_type: energy_supplier_value_type_enum;
    emission_certificate_value_path?: { emission_factor: Array<number> } | null;
  } | null;
  primary_energy_factor_emission_certificate?: {
    primary_energy_factor?: number | null;
    primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
    emission_certificate_value_path?: { primary_energy_factor: Array<number> } | null;
  } | null;
  energy_consumer?: {
    id: number;
    energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
    energy_consumer_type_id: energy_consumer_type_enum;
    efficiency?: number | null;
    construction_year?: number | null;
  } | null;
  energy_distribution?: {
    id: number;
    energy_distribution_type_id: energy_distribution_type_enum;
    heat_distribution_loss: number;
    heat_transfer_loss: number;
    last_hydraulic_balancing?: string | null;
    last_balancing_set_to_never: boolean;
    construction_year?: number | null;
  } | null;
  energy_storage?: {
    id: number;
    energy_storage_type_id: energy_storage_type_enum;
    annual_heat_loss?: number | null;
    construction_year?: number | null;
  } | null;
};

export type DataCollectionBuildingEnergySystemProducerRouteFragment = {
  id: number;
  area_id?: number | null;
  energy_effective?: number | null;
  energy_produced: number;
  energy_source_type_id: energy_source_type_enum;
  energy_producer: {
    id: number;
    name?: string | null;
    module_angle?: number | null;
    nominal_power?: number | null;
    construction_year?: number | null;
    solar_active_area?: number | null;
  };
};

export type DataCollectionBuildingEnergySystemFragment = {
  id: number;
  energy_system_type_id: energy_system_type_enum;
  data_source_type_id: data_source_type_enum;
  description?: string | null;
  energy_system_consumer_routes: Array<{
    id: number;
    secondary_id: string;
    area_id?: number | null;
    energy_final: number;
    energy_effective?: number | null;
    energy_source_type_id: energy_source_type_enum;
    energy_primary?: number | null;
    emission_certificate_id?: number | null;
    use_renewable_energy: boolean;
    primary_energy_factor_emission_certificate_id?: number | null;
    emission_certificate?: {
      emission_factor: number;
      emission_factor_active_value_type: energy_supplier_value_type_enum;
      emission_certificate_value_path?: { emission_factor: Array<number> } | null;
    } | null;
    primary_energy_factor_emission_certificate?: {
      primary_energy_factor?: number | null;
      primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
      emission_certificate_value_path?: { primary_energy_factor: Array<number> } | null;
    } | null;
    energy_consumer?: {
      id: number;
      energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
      energy_consumer_type_id: energy_consumer_type_enum;
      efficiency?: number | null;
      construction_year?: number | null;
    } | null;
    energy_distribution?: {
      id: number;
      energy_distribution_type_id: energy_distribution_type_enum;
      heat_distribution_loss: number;
      heat_transfer_loss: number;
      last_hydraulic_balancing?: string | null;
      last_balancing_set_to_never: boolean;
      construction_year?: number | null;
    } | null;
    energy_storage?: {
      id: number;
      energy_storage_type_id: energy_storage_type_enum;
      annual_heat_loss?: number | null;
      construction_year?: number | null;
    } | null;
  }>;
  energy_system_producer_routes: Array<{
    id: number;
    area_id?: number | null;
    energy_effective?: number | null;
    energy_produced: number;
    energy_source_type_id: energy_source_type_enum;
    energy_producer: {
      id: number;
      name?: string | null;
      module_angle?: number | null;
      nominal_power?: number | null;
      construction_year?: number | null;
      solar_active_area?: number | null;
    };
  }>;
};

export type DataCollectionBuildingModelFragment = {
  id: number;
  description: string;
  valid_from: string;
  created_at: string;
  is_draft: boolean;
  processing: boolean;
  energy_final?: number | null;
  action_planning_available: boolean;
  heating_demand?: number | null;
  internal_temperature: number;
  annual_heating_days: number;
  envelope_units: Array<{
    id: number;
    data_source_type_id: data_source_type_enum;
    description?: string | null;
    inclination?: number | null;
    orientation?: number | null;
    envelope_type_id: envelope_type_enum;
    insulation_thickness?: number | null;
    insulation_material_name?: string | null;
    insulation_material_category_id?: insulation_material_category_enum | null;
    insulation_method_id?: insulation_method_enum | null;
    insulation_lambda?: number | null;
    base_construction_thickness?: number | null;
    base_construction_material_name?: string | null;
    base_construction_lambda?: number | null;
    area: number;
    u_value?: number | null;
  }>;
  energy_systems: Array<{
    id: number;
    energy_system_type_id: energy_system_type_enum;
    data_source_type_id: data_source_type_enum;
    description?: string | null;
    energy_system_consumer_routes: Array<{
      id: number;
      secondary_id: string;
      area_id?: number | null;
      energy_final: number;
      energy_effective?: number | null;
      energy_source_type_id: energy_source_type_enum;
      energy_primary?: number | null;
      emission_certificate_id?: number | null;
      use_renewable_energy: boolean;
      primary_energy_factor_emission_certificate_id?: number | null;
      emission_certificate?: {
        emission_factor: number;
        emission_factor_active_value_type: energy_supplier_value_type_enum;
        emission_certificate_value_path?: { emission_factor: Array<number> } | null;
      } | null;
      primary_energy_factor_emission_certificate?: {
        primary_energy_factor?: number | null;
        primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
        emission_certificate_value_path?: { primary_energy_factor: Array<number> } | null;
      } | null;
      energy_consumer?: {
        id: number;
        energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
        energy_consumer_type_id: energy_consumer_type_enum;
        efficiency?: number | null;
        construction_year?: number | null;
      } | null;
      energy_distribution?: {
        id: number;
        energy_distribution_type_id: energy_distribution_type_enum;
        heat_distribution_loss: number;
        heat_transfer_loss: number;
        last_hydraulic_balancing?: string | null;
        last_balancing_set_to_never: boolean;
        construction_year?: number | null;
      } | null;
      energy_storage?: {
        id: number;
        energy_storage_type_id: energy_storage_type_enum;
        annual_heat_loss?: number | null;
        construction_year?: number | null;
      } | null;
    }>;
    energy_system_producer_routes: Array<{
      id: number;
      area_id?: number | null;
      energy_effective?: number | null;
      energy_produced: number;
      energy_source_type_id: energy_source_type_enum;
      energy_producer: {
        id: number;
        name?: string | null;
        module_angle?: number | null;
        nominal_power?: number | null;
        construction_year?: number | null;
        solar_active_area?: number | null;
      };
    }>;
  }>;
};

export type ProgressiveFactorResponseFragment = { factor: number; year: number };

export type EmissionFactorsPerEnergySourceFragment = {
  BIO_GAS: Array<{ factor: number; year: number }>;
  COAL: Array<{ factor: number; year: number }>;
  DISTRICT_HEATING_CHP_FOSSIL_COAL: Array<{ factor: number; year: number }>;
  DISTRICT_HEATING_CHP_FOSSIL_GAS: Array<{ factor: number; year: number }>;
  DISTRICT_HEATING_CHP_RENEWABLE: Array<{ factor: number; year: number }>;
  DISTRICT_HEATING_PLANTS_FOSSIL_COAL: Array<{ factor: number; year: number }>;
  DISTRICT_HEATING_PLANTS_FOSSIL_GAS: Array<{ factor: number; year: number }>;
  ELECTRICITY_GREEN: Array<{ factor: number; year: number }>;
  DISTRICT_HEATING_PLANTS_RENEWABLE: Array<{ factor: number; year: number }>;
  ELECTRICITY_MIX: Array<{ factor: number; year: number }>;
  WOODEN_PELLETS: Array<{ factor: number; year: number }>;
  WOOD: Array<{ factor: number; year: number }>;
  UNSPECIFIED: Array<{ factor: number; year: number }>;
  SOLAR: Array<{ factor: number; year: number }>;
  LPG: Array<{ factor: number; year: number }>;
  NATURAL_GAS: Array<{ factor: number; year: number }>;
  LIGNITE: Array<{ factor: number; year: number }>;
  FUEL_OIL: Array<{ factor: number; year: number }>;
};

export type DataCollectionBuildingFragment = {
  __typename: 'building';
  id: number;
  has_write_permission: boolean;
  customer_external_identifier?: string | null;
  description: string;
  year_constructed: number;
  is_new_construction: boolean;
  is_missing_energy_data?: boolean | null;
  year_data_source: data_source_type_enum;
  building_state_id: building_state_enum;
  monument_protection: boolean;
  leasehold: boolean;
  milieu_protection: boolean;
  heritage_district: boolean;
  custom_data: any;
  units: number;
  units_data_source: data_source_type_enum;
  subsidies_updated_at?: string | null;
  active_building_model_id?: number | null;
  address: {
    id: number;
    street: string;
    city: string;
    postal_code: string;
    country_state_id: country_state_enum;
    country_id: country_enum;
    mapbox_building_ids: Array<string>;
    building_citydb_gml_ids?: Array<string> | null;
    neighbor_citydb_gml_ids?: Array<string> | null;
    building_lod1_ids?: Array<string> | null;
    neighbor_lod1_ids?: Array<string> | null;
    mapbox_pitch?: number | null;
    mapbox_bearing?: number | null;
    mapbox_zoom?: number | null;
    latitude?: number | null;
    longitude?: number | null;
    has_gml_ids?: boolean | null;
  };
  areas: Array<{
    id: number;
    area_type_id: area_type_enum;
    area_system_id: area_system_type_enum;
    is_rented: boolean;
    class_of_use_id: class_of_use_enum;
    data_source_id: data_source_type_enum;
    value: number;
    type_of_use_id: type_of_use_enum;
    description: string;
    external_id: string;
    energy_certificate_id?: number | null;
    file_id?: number | null;
    geg_reference_value?: number | null;
    energy_rating_score?: number | null;
    reference_value_heating_hot_water?: number | null;
    reference_value_electricity?: number | null;
    enev_year?: number | null;
  }>;
  responsible_user: { first_name?: string | null; last_name?: string | null };
  energy_certificates: Array<{
    id: number;
    energy_certificate_type: energy_certificate_type_enum;
    geg_reference_value?: number | null;
    energy_rating_score?: number | null;
    co2_emissions?: number | null;
    reference_value_heating_hot_water?: number | null;
    reference_value_electricity?: number | null;
    enev_year?: number | null;
  }>;
  subsidies: Array<{
    subsidy: {
      __typename: 'subsidy';
      id: number;
      email?: string | null;
      amount_description: string;
      provider_updated_at: string;
      region_type: subsidy_region_type_enum;
      title: string;
      type: subsidy_type_enum;
      url?: string | null;
      categories: Array<{ subsidy_category_type: subsidy_category_type_enum }>;
    };
  }>;
  economic_unit: {
    __typename: 'economic_unit';
    id: number;
    name: string;
    associatedBuildingsAndDrafts: { amount: number };
    portfolio: { __typename: 'portfolio'; id: number; name: string };
  };
  active_building_model?: {
    efficiency_class_id?: efficiency_class_enum | null;
    id: number;
    description: string;
    valid_from: string;
    created_at: string;
    is_draft: boolean;
    processing: boolean;
    energy_final?: number | null;
    action_planning_available: boolean;
    heating_demand?: number | null;
    internal_temperature: number;
    annual_heating_days: number;
    envelope_units: Array<{
      id: number;
      data_source_type_id: data_source_type_enum;
      description?: string | null;
      inclination?: number | null;
      orientation?: number | null;
      envelope_type_id: envelope_type_enum;
      insulation_thickness?: number | null;
      insulation_material_name?: string | null;
      insulation_material_category_id?: insulation_material_category_enum | null;
      insulation_method_id?: insulation_method_enum | null;
      insulation_lambda?: number | null;
      base_construction_thickness?: number | null;
      base_construction_material_name?: string | null;
      base_construction_lambda?: number | null;
      area: number;
      u_value?: number | null;
    }>;
    energy_systems: Array<{
      id: number;
      energy_system_type_id: energy_system_type_enum;
      data_source_type_id: data_source_type_enum;
      description?: string | null;
      energy_system_consumer_routes: Array<{
        id: number;
        secondary_id: string;
        area_id?: number | null;
        energy_final: number;
        energy_effective?: number | null;
        energy_source_type_id: energy_source_type_enum;
        energy_primary?: number | null;
        emission_certificate_id?: number | null;
        use_renewable_energy: boolean;
        primary_energy_factor_emission_certificate_id?: number | null;
        emission_certificate?: {
          emission_factor: number;
          emission_factor_active_value_type: energy_supplier_value_type_enum;
          emission_certificate_value_path?: { emission_factor: Array<number> } | null;
        } | null;
        primary_energy_factor_emission_certificate?: {
          primary_energy_factor?: number | null;
          primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
          emission_certificate_value_path?: { primary_energy_factor: Array<number> } | null;
        } | null;
        energy_consumer?: {
          id: number;
          energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
          energy_consumer_type_id: energy_consumer_type_enum;
          efficiency?: number | null;
          construction_year?: number | null;
        } | null;
        energy_distribution?: {
          id: number;
          energy_distribution_type_id: energy_distribution_type_enum;
          heat_distribution_loss: number;
          heat_transfer_loss: number;
          last_hydraulic_balancing?: string | null;
          last_balancing_set_to_never: boolean;
          construction_year?: number | null;
        } | null;
        energy_storage?: {
          id: number;
          energy_storage_type_id: energy_storage_type_enum;
          annual_heat_loss?: number | null;
          construction_year?: number | null;
        } | null;
      }>;
      energy_system_producer_routes: Array<{
        id: number;
        area_id?: number | null;
        energy_effective?: number | null;
        energy_produced: number;
        energy_source_type_id: energy_source_type_enum;
        energy_producer: {
          id: number;
          name?: string | null;
          module_angle?: number | null;
          nominal_power?: number | null;
          construction_year?: number | null;
          solar_active_area?: number | null;
        };
      }>;
    }>;
  } | null;
  climate_risks: Array<{
    value: number;
    uncertainty: number;
    type: climate_risk_type_enum;
    timespan?: string | null;
    created_at?: string | null;
  }>;
  climate_risks_aggregate: { aggregate?: { max?: { created_at?: string | null } | null } | null };
  active_action_plans_aggregate: { aggregate?: { count: number } | null };
  action_plans_with_action_aggregate: { aggregate?: { count: number } | null };
  building_valuations: Array<{ id: number; value: number; valuation_at: string }>;
  climate_risks_v2_aggregate: { aggregate?: { count: number } | null };
  base_emission_factors: {
    BIO_GAS: Array<{ factor: number; year: number }>;
    COAL: Array<{ factor: number; year: number }>;
    DISTRICT_HEATING_CHP_FOSSIL_COAL: Array<{ factor: number; year: number }>;
    DISTRICT_HEATING_CHP_FOSSIL_GAS: Array<{ factor: number; year: number }>;
    DISTRICT_HEATING_CHP_RENEWABLE: Array<{ factor: number; year: number }>;
    DISTRICT_HEATING_PLANTS_FOSSIL_COAL: Array<{ factor: number; year: number }>;
    DISTRICT_HEATING_PLANTS_FOSSIL_GAS: Array<{ factor: number; year: number }>;
    ELECTRICITY_GREEN: Array<{ factor: number; year: number }>;
    DISTRICT_HEATING_PLANTS_RENEWABLE: Array<{ factor: number; year: number }>;
    ELECTRICITY_MIX: Array<{ factor: number; year: number }>;
    WOODEN_PELLETS: Array<{ factor: number; year: number }>;
    WOOD: Array<{ factor: number; year: number }>;
    UNSPECIFIED: Array<{ factor: number; year: number }>;
    SOLAR: Array<{ factor: number; year: number }>;
    LPG: Array<{ factor: number; year: number }>;
    NATURAL_GAS: Array<{ factor: number; year: number }>;
    LIGNITE: Array<{ factor: number; year: number }>;
    FUEL_OIL: Array<{ factor: number; year: number }>;
  };
  district_heating_availability_status?: {
    updated_at?: string | null;
    district_heating_status?: string | null;
    district_heating_year?: number | null;
    id?: number | null;
  } | null;
  building_models: Array<{
    action_id?: number | null;
    id: number;
    description: string;
    valid_from: string;
    created_at: string;
    is_draft: boolean;
    processing: boolean;
    energy_final?: number | null;
    action_planning_available: boolean;
    heating_demand?: number | null;
    internal_temperature: number;
    annual_heating_days: number;
    envelope_units: Array<{
      id: number;
      data_source_type_id: data_source_type_enum;
      description?: string | null;
      inclination?: number | null;
      orientation?: number | null;
      envelope_type_id: envelope_type_enum;
      insulation_thickness?: number | null;
      insulation_material_name?: string | null;
      insulation_material_category_id?: insulation_material_category_enum | null;
      insulation_method_id?: insulation_method_enum | null;
      insulation_lambda?: number | null;
      base_construction_thickness?: number | null;
      base_construction_material_name?: string | null;
      base_construction_lambda?: number | null;
      area: number;
      u_value?: number | null;
    }>;
    energy_systems: Array<{
      id: number;
      energy_system_type_id: energy_system_type_enum;
      data_source_type_id: data_source_type_enum;
      description?: string | null;
      energy_system_consumer_routes: Array<{
        id: number;
        secondary_id: string;
        area_id?: number | null;
        energy_final: number;
        energy_effective?: number | null;
        energy_source_type_id: energy_source_type_enum;
        energy_primary?: number | null;
        emission_certificate_id?: number | null;
        use_renewable_energy: boolean;
        primary_energy_factor_emission_certificate_id?: number | null;
        emission_certificate?: {
          emission_factor: number;
          emission_factor_active_value_type: energy_supplier_value_type_enum;
          emission_certificate_value_path?: { emission_factor: Array<number> } | null;
        } | null;
        primary_energy_factor_emission_certificate?: {
          primary_energy_factor?: number | null;
          primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
          emission_certificate_value_path?: { primary_energy_factor: Array<number> } | null;
        } | null;
        energy_consumer?: {
          id: number;
          energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
          energy_consumer_type_id: energy_consumer_type_enum;
          efficiency?: number | null;
          construction_year?: number | null;
        } | null;
        energy_distribution?: {
          id: number;
          energy_distribution_type_id: energy_distribution_type_enum;
          heat_distribution_loss: number;
          heat_transfer_loss: number;
          last_hydraulic_balancing?: string | null;
          last_balancing_set_to_never: boolean;
          construction_year?: number | null;
        } | null;
        energy_storage?: {
          id: number;
          energy_storage_type_id: energy_storage_type_enum;
          annual_heat_loss?: number | null;
          construction_year?: number | null;
        } | null;
      }>;
      energy_system_producer_routes: Array<{
        id: number;
        area_id?: number | null;
        energy_effective?: number | null;
        energy_produced: number;
        energy_source_type_id: energy_source_type_enum;
        energy_producer: {
          id: number;
          name?: string | null;
          module_angle?: number | null;
          nominal_power?: number | null;
          construction_year?: number | null;
          solar_active_area?: number | null;
        };
      }>;
    }>;
  }>;
  certificates: Array<{
    id: number;
    certificate_level_type?: certificate_level_type_enum | null;
    certificate_score?: number | null;
    certificate_type: certificate_type_enum;
    file?: { id: number; name?: string | null } | null;
  }>;
};

export type DataCollectionYearlyConsumptionFragment = {
  value: number;
  providers: Array<string>;
  cost: number;
  consumption_type: consumption_type_enum;
};

export type DataCollectionConsumptionDraftConsumptionDraftFragment = {
  id: number;
  from?: string | null;
  to?: string | null;
  displayValue?: number | null;
  cost?: number | null;
  consumption_type_id?: consumption_type_enum | null;
  display_unit_value?: consumption_unit_enum | null;
  energy_source_type_id?: energy_source_type_enum | null;
  sub_type_id?: consumption_sub_type_enum | null;
  provider?: string | null;
  consumption_waste_details_draft?: {
    id: number;
    frequency?: number | null;
    display_unit_frequency?: consumption_frequency_type_enum | null;
    volume?: number | null;
    display_unit_volume?: consumption_unit_enum | null;
    amount?: number | null;
    price?: number | null;
  } | null;
  consumption_draft_areas: Array<{ area_id: number }>;
};

export type DataCollectionFileFragment = {
  __typename: 'file';
  id: number;
  name?: string | null;
  created_at: string;
  downloadUrl: string;
};

export type DataCollectionEconomicUnitFragment = {
  __typename: 'economic_unit';
  id: number;
  name: string;
  customer_economic_unit_id?: string | null;
};

export type BuildingModelMutationAvailabilityFragment = {
  affected_action_plans: Array<{
    id: number;
    scenario_id: number;
    scenario_name: string;
    scenario_updated_at?: DateTime | null;
  }>;
};

export type DataCollectionEmissionCertificateDraftFragment = {
  id: number;
  issuer: string;
  emission_factor_active_value_type: string;
  primary_energy_factor_active_value_type: string;
  emission_factor?: number | null;
  primary_energy_factor?: number | null;
  emission_certificate_energy_source_type_id?: string | null;
  emission_certificate_document_type_id?: string | null;
  valid_from?: DateTime | null;
  valid_until?: DateTime | null;
  created_at: DateTime;
  updated_at: DateTime;
  org_id: number;
  emission_factor_progressive?: Array<{ year: number; value?: number | null }> | null;
  primary_energy_factor_progressive?: Array<{ year: number; value?: number | null }> | null;
  file?: { id: number; name?: string | null; downloadUrl: string; created_at: DateTime } | null;
};

export type DataCollectionEmissionCertificateFragment = {
  __typename: 'emission_certificate';
  emission_factor_active_value_type: energy_supplier_value_type_enum;
  primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
  created_at: string;
  updated_at: string;
  issuer: string;
  emission_factor: number;
  primary_energy_factor?: number | null;
  file_id?: number | null;
  org_id: number;
  id: number;
  valid_from?: string | null;
  valid_until?: string | null;
  emission_certificate_energy_source_type_id?: emission_certificate_energy_source_type_enum | null;
  emission_certificate_document_type_id?: emission_certificate_document_type_enum | null;
  emission_certificate_value_path?: {
    id: number;
    emission_factor: Array<number>;
    primary_energy_factor: Array<number>;
  } | null;
  file?: { downloadUrl: string; id: number; name?: string | null; created_at: string } | null;
  org: { name: string };
};

export type DataCollectionDocumentDraftFragment = {
  downloadUrl: string;
  id: number;
  name?: string | null;
  created_at: string;
};

export type DataCollectionEmissionCertificateListItemFragment = {
  emission_factor_active_value_type: energy_supplier_value_type_enum;
  primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
  created_at: DateTime;
  issuer: string;
  emission_factor: number;
  primary_energy_factor?: number | null;
  id: number;
  valid_until?: DateTime | null;
  emission_certificate_energy_source_type_id?: emission_certificate_energy_source_type_enum | null;
  associated_action_plans_count?: number | null;
  associated_buildings_count?: number | null;
  emission_certificate_value_path?: {
    id: number;
    emission_factor: Array<number>;
    primary_energy_factor: Array<number>;
  } | null;
};

export type EnergySupplierAssociatedBuildingFragment = {
  id: number;
  address: { street: string; city: string; postal_code: string };
};

export type getAssociatedBuildingsForEnergySupplierQueryVariables = Exact<{
  emissionCertificateId: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type getAssociatedBuildingsForEnergySupplierQuery = {
  getAssociatedBuildings: {
    count: number;
    buildings: Array<{
      building?: { id: number; address: { street: string; city: string; postal_code: string } } | null;
    }>;
  };
};

export type getAssociatedActionPlansForEnergySupplierQueryVariables = Exact<{
  emissionCertificateId: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type getAssociatedActionPlansForEnergySupplierQuery = {
  getAssociatedActionPlans: {
    count: number;
    action_plans: Array<{
      stable_id: number;
      scenario_id: number;
      building?: { id: number; address: { street: string; city: string; postal_code: string } } | null;
    }>;
  };
};

export type EmissionCertificateWithProgressiveFragment = {
  emission_factor: number;
  emission_factor_active_value_type: energy_supplier_value_type_enum;
  emission_certificate_value_path?: { emission_factor: Array<number> } | null;
};

export type PrimaryEnergyFactorCertificateWithProgressiveFragment = {
  primary_energy_factor?: number | null;
  primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
  emission_certificate_value_path?: { primary_energy_factor: Array<number> } | null;
};

export type DataCollectionGetEconomicUnitsQueryVariables = Exact<{
  where?: InputMaybe<economic_unit_bool_exp>;
}>;

export type DataCollectionGetEconomicUnitsQuery = {
  economic_unit: Array<{
    id: number;
    name: string;
    customer_economic_unit_id?: string | null;
    portfolio: { id: number; name: string };
  }>;
};

export type DataCollectionGetEconomicUnitsByIdsForSelectionQueryVariables = Exact<{
  where: economic_unit_bool_exp;
}>;

export type DataCollectionGetEconomicUnitsByIdsForSelectionQuery = {
  economic_unit: Array<{ id: number; name: string; responsible_user_id?: number | null }>;
};

export type DataCollectionGetEconomicUnitsAggregateCountQueryVariables = Exact<{
  where: economic_unit_bool_exp;
}>;

export type DataCollectionGetEconomicUnitsAggregateCountQuery = {
  economic_unit_aggregate: { aggregate?: { count: number } | null };
};

export type DataCollectionGetEconomicUnitsBySearchQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: economic_unit_bool_exp;
}>;

export type DataCollectionGetEconomicUnitsBySearchQuery = { economic_unit: Array<{ id: number; name: string }> };

export type EconomicUnitsListQueryVariables = Exact<{
  where: BuildingWhere;
  orderBy?: InputMaybe<EconomicUnitsOrderByInput>;
  fetchInactiveBuildings?: InputMaybe<Scalars['Boolean']['input']>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;

export type EconomicUnitsListQuery = {
  getEconomicUnits: {
    count: number;
    economicUnits: Array<{
      id: number;
      economicUnit: {
        id: number;
        name: string;
        customer_economic_unit_id?: string | null;
        description: string;
        created_at: string;
        updated_at: string;
        custom_data: any;
        responsible_user?: { id: number; first_name?: string | null; last_name?: string | null } | null;
        portfolio: { id: number; name: string; has_write_permission: boolean };
        first_building: Array<{ id: number; address: { city: string; postal_code: string } }>;
        first_inactive_building?: Array<{ id: number; address?: { city: string; postal_code: string } | null }>;
      };
    }>;
  };
};

export type EconomicUnitsWithBuildingWhereQueryVariables = Exact<{
  where: BuildingWhere;
}>;

export type EconomicUnitsWithBuildingWhereQuery = { getEconomicUnits: { economicUnits: Array<{ id: number }> } };

export type EconomicUnitBuildingsIdsQueryVariables = Exact<{
  where: economic_unit_bool_exp;
}>;

export type EconomicUnitBuildingsIdsQuery = {
  economic_unit: Array<{
    id: number;
    name: string;
    portfolio: { id: number; has_write_permission: boolean };
    buildings: Array<{ id: number }>;
    inactive_buildings: Array<{ id: number }>;
    building_drafts_aggregate: { aggregate?: { count: number } | null };
  }>;
};

export type DataCollectionBuildingGetBuildingQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type DataCollectionBuildingGetBuildingQuery = {
  building_by_pk?: {
    __typename: 'building';
    id: number;
    has_write_permission: boolean;
    customer_external_identifier?: string | null;
    description: string;
    year_constructed: number;
    is_new_construction: boolean;
    is_missing_energy_data?: boolean | null;
    year_data_source: data_source_type_enum;
    building_state_id: building_state_enum;
    monument_protection: boolean;
    leasehold: boolean;
    milieu_protection: boolean;
    heritage_district: boolean;
    custom_data: any;
    units: number;
    units_data_source: data_source_type_enum;
    subsidies_updated_at?: string | null;
    active_building_model_id?: number | null;
    address: {
      id: number;
      street: string;
      city: string;
      postal_code: string;
      country_state_id: country_state_enum;
      country_id: country_enum;
      mapbox_building_ids: Array<string>;
      building_citydb_gml_ids?: Array<string> | null;
      neighbor_citydb_gml_ids?: Array<string> | null;
      building_lod1_ids?: Array<string> | null;
      neighbor_lod1_ids?: Array<string> | null;
      mapbox_pitch?: number | null;
      mapbox_bearing?: number | null;
      mapbox_zoom?: number | null;
      latitude?: number | null;
      longitude?: number | null;
      has_gml_ids?: boolean | null;
    };
    areas: Array<{
      id: number;
      area_type_id: area_type_enum;
      area_system_id: area_system_type_enum;
      is_rented: boolean;
      class_of_use_id: class_of_use_enum;
      data_source_id: data_source_type_enum;
      value: number;
      type_of_use_id: type_of_use_enum;
      description: string;
      external_id: string;
      energy_certificate_id?: number | null;
      file_id?: number | null;
      geg_reference_value?: number | null;
      energy_rating_score?: number | null;
      reference_value_heating_hot_water?: number | null;
      reference_value_electricity?: number | null;
      enev_year?: number | null;
    }>;
    responsible_user: { first_name?: string | null; last_name?: string | null };
    energy_certificates: Array<{
      id: number;
      energy_certificate_type: energy_certificate_type_enum;
      geg_reference_value?: number | null;
      energy_rating_score?: number | null;
      co2_emissions?: number | null;
      reference_value_heating_hot_water?: number | null;
      reference_value_electricity?: number | null;
      enev_year?: number | null;
    }>;
    subsidies: Array<{
      subsidy: {
        __typename: 'subsidy';
        id: number;
        email?: string | null;
        amount_description: string;
        provider_updated_at: string;
        region_type: subsidy_region_type_enum;
        title: string;
        type: subsidy_type_enum;
        url?: string | null;
        categories: Array<{ subsidy_category_type: subsidy_category_type_enum }>;
      };
    }>;
    economic_unit: {
      __typename: 'economic_unit';
      id: number;
      name: string;
      associatedBuildingsAndDrafts: { amount: number };
      portfolio: { __typename: 'portfolio'; id: number; name: string };
    };
    active_building_model?: {
      efficiency_class_id?: efficiency_class_enum | null;
      id: number;
      description: string;
      valid_from: string;
      created_at: string;
      is_draft: boolean;
      processing: boolean;
      energy_final?: number | null;
      action_planning_available: boolean;
      heating_demand?: number | null;
      internal_temperature: number;
      annual_heating_days: number;
      envelope_units: Array<{
        id: number;
        data_source_type_id: data_source_type_enum;
        description?: string | null;
        inclination?: number | null;
        orientation?: number | null;
        envelope_type_id: envelope_type_enum;
        insulation_thickness?: number | null;
        insulation_material_name?: string | null;
        insulation_material_category_id?: insulation_material_category_enum | null;
        insulation_method_id?: insulation_method_enum | null;
        insulation_lambda?: number | null;
        base_construction_thickness?: number | null;
        base_construction_material_name?: string | null;
        base_construction_lambda?: number | null;
        area: number;
        u_value?: number | null;
      }>;
      energy_systems: Array<{
        id: number;
        energy_system_type_id: energy_system_type_enum;
        data_source_type_id: data_source_type_enum;
        description?: string | null;
        energy_system_consumer_routes: Array<{
          id: number;
          secondary_id: string;
          area_id?: number | null;
          energy_final: number;
          energy_effective?: number | null;
          energy_source_type_id: energy_source_type_enum;
          energy_primary?: number | null;
          emission_certificate_id?: number | null;
          use_renewable_energy: boolean;
          primary_energy_factor_emission_certificate_id?: number | null;
          emission_certificate?: {
            emission_factor: number;
            emission_factor_active_value_type: energy_supplier_value_type_enum;
            emission_certificate_value_path?: { emission_factor: Array<number> } | null;
          } | null;
          primary_energy_factor_emission_certificate?: {
            primary_energy_factor?: number | null;
            primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
            emission_certificate_value_path?: { primary_energy_factor: Array<number> } | null;
          } | null;
          energy_consumer?: {
            id: number;
            energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
            energy_consumer_type_id: energy_consumer_type_enum;
            efficiency?: number | null;
            construction_year?: number | null;
          } | null;
          energy_distribution?: {
            id: number;
            energy_distribution_type_id: energy_distribution_type_enum;
            heat_distribution_loss: number;
            heat_transfer_loss: number;
            last_hydraulic_balancing?: string | null;
            last_balancing_set_to_never: boolean;
            construction_year?: number | null;
          } | null;
          energy_storage?: {
            id: number;
            energy_storage_type_id: energy_storage_type_enum;
            annual_heat_loss?: number | null;
            construction_year?: number | null;
          } | null;
        }>;
        energy_system_producer_routes: Array<{
          id: number;
          area_id?: number | null;
          energy_effective?: number | null;
          energy_produced: number;
          energy_source_type_id: energy_source_type_enum;
          energy_producer: {
            id: number;
            name?: string | null;
            module_angle?: number | null;
            nominal_power?: number | null;
            construction_year?: number | null;
            solar_active_area?: number | null;
          };
        }>;
      }>;
    } | null;
    climate_risks: Array<{
      value: number;
      uncertainty: number;
      type: climate_risk_type_enum;
      timespan?: string | null;
      created_at?: string | null;
    }>;
    climate_risks_aggregate: { aggregate?: { max?: { created_at?: string | null } | null } | null };
    active_action_plans_aggregate: { aggregate?: { count: number } | null };
    action_plans_with_action_aggregate: { aggregate?: { count: number } | null };
    building_valuations: Array<{ id: number; value: number; valuation_at: string }>;
    climate_risks_v2_aggregate: { aggregate?: { count: number } | null };
    base_emission_factors: {
      BIO_GAS: Array<{ factor: number; year: number }>;
      COAL: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_CHP_FOSSIL_COAL: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_CHP_FOSSIL_GAS: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_CHP_RENEWABLE: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_PLANTS_FOSSIL_COAL: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_PLANTS_FOSSIL_GAS: Array<{ factor: number; year: number }>;
      ELECTRICITY_GREEN: Array<{ factor: number; year: number }>;
      DISTRICT_HEATING_PLANTS_RENEWABLE: Array<{ factor: number; year: number }>;
      ELECTRICITY_MIX: Array<{ factor: number; year: number }>;
      WOODEN_PELLETS: Array<{ factor: number; year: number }>;
      WOOD: Array<{ factor: number; year: number }>;
      UNSPECIFIED: Array<{ factor: number; year: number }>;
      SOLAR: Array<{ factor: number; year: number }>;
      LPG: Array<{ factor: number; year: number }>;
      NATURAL_GAS: Array<{ factor: number; year: number }>;
      LIGNITE: Array<{ factor: number; year: number }>;
      FUEL_OIL: Array<{ factor: number; year: number }>;
    };
    district_heating_availability_status?: {
      updated_at?: string | null;
      district_heating_status?: string | null;
      district_heating_year?: number | null;
      id?: number | null;
    } | null;
    building_models: Array<{
      action_id?: number | null;
      id: number;
      description: string;
      valid_from: string;
      created_at: string;
      is_draft: boolean;
      processing: boolean;
      energy_final?: number | null;
      action_planning_available: boolean;
      heating_demand?: number | null;
      internal_temperature: number;
      annual_heating_days: number;
      envelope_units: Array<{
        id: number;
        data_source_type_id: data_source_type_enum;
        description?: string | null;
        inclination?: number | null;
        orientation?: number | null;
        envelope_type_id: envelope_type_enum;
        insulation_thickness?: number | null;
        insulation_material_name?: string | null;
        insulation_material_category_id?: insulation_material_category_enum | null;
        insulation_method_id?: insulation_method_enum | null;
        insulation_lambda?: number | null;
        base_construction_thickness?: number | null;
        base_construction_material_name?: string | null;
        base_construction_lambda?: number | null;
        area: number;
        u_value?: number | null;
      }>;
      energy_systems: Array<{
        id: number;
        energy_system_type_id: energy_system_type_enum;
        data_source_type_id: data_source_type_enum;
        description?: string | null;
        energy_system_consumer_routes: Array<{
          id: number;
          secondary_id: string;
          area_id?: number | null;
          energy_final: number;
          energy_effective?: number | null;
          energy_source_type_id: energy_source_type_enum;
          energy_primary?: number | null;
          emission_certificate_id?: number | null;
          use_renewable_energy: boolean;
          primary_energy_factor_emission_certificate_id?: number | null;
          emission_certificate?: {
            emission_factor: number;
            emission_factor_active_value_type: energy_supplier_value_type_enum;
            emission_certificate_value_path?: { emission_factor: Array<number> } | null;
          } | null;
          primary_energy_factor_emission_certificate?: {
            primary_energy_factor?: number | null;
            primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
            emission_certificate_value_path?: { primary_energy_factor: Array<number> } | null;
          } | null;
          energy_consumer?: {
            id: number;
            energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
            energy_consumer_type_id: energy_consumer_type_enum;
            efficiency?: number | null;
            construction_year?: number | null;
          } | null;
          energy_distribution?: {
            id: number;
            energy_distribution_type_id: energy_distribution_type_enum;
            heat_distribution_loss: number;
            heat_transfer_loss: number;
            last_hydraulic_balancing?: string | null;
            last_balancing_set_to_never: boolean;
            construction_year?: number | null;
          } | null;
          energy_storage?: {
            id: number;
            energy_storage_type_id: energy_storage_type_enum;
            annual_heat_loss?: number | null;
            construction_year?: number | null;
          } | null;
        }>;
        energy_system_producer_routes: Array<{
          id: number;
          area_id?: number | null;
          energy_effective?: number | null;
          energy_produced: number;
          energy_source_type_id: energy_source_type_enum;
          energy_producer: {
            id: number;
            name?: string | null;
            module_angle?: number | null;
            nominal_power?: number | null;
            construction_year?: number | null;
            solar_active_area?: number | null;
          };
        }>;
      }>;
    }>;
    certificates: Array<{
      id: number;
      certificate_level_type?: certificate_level_type_enum | null;
      certificate_score?: number | null;
      certificate_type: certificate_type_enum;
      file?: { id: number; name?: string | null } | null;
    }>;
  } | null;
};

export type DataCollectionGetBuildingConsumptionsQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type DataCollectionGetBuildingConsumptionsQuery = {
  building: Array<{
    consumptions: Array<{
      id: number;
      provider?: string | null;
      to: string;
      from: string;
      cost?: number | null;
      display_unit_value?: consumption_unit_enum | null;
      displayValue?: number | null;
      created_at?: string | null;
      consumption_type_id: consumption_type_enum;
      source_type_id: consumption_source_type_enum;
      invoice_id?: number | null;
      energy_source_type_id?: energy_source_type_enum | null;
      sub_type_id?: consumption_sub_type_enum | null;
      created_by_user?: { first_name?: string | null; last_name?: string | null } | null;
      consumption_waste_detail?: {
        id: number;
        volume: number;
        display_unit_volume?: consumption_unit_enum | null;
        frequency: number;
        display_unit_frequency?: consumption_frequency_type_enum | null;
        amount: number;
        price: number;
      } | null;
      consumption_areas: Array<{ area_id: number }>;
    }>;
  }>;
};

export type DataCollectionGetBuildingConsumptionDraftsQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type DataCollectionGetBuildingConsumptionDraftsQuery = {
  consumption_draft: Array<{
    id: number;
    provider?: string | null;
    to?: string | null;
    from?: string | null;
    cost?: number | null;
    display_unit_value?: consumption_unit_enum | null;
    displayValue?: number | null;
    created_at?: string | null;
    consumption_type_id?: consumption_type_enum | null;
    source_type_id: consumption_source_type_enum;
    energy_source_type_id?: energy_source_type_enum | null;
    sub_type_id?: consumption_sub_type_enum | null;
    created_by_user?: { first_name?: string | null; last_name?: string | null } | null;
    consumption_invoice_draft?: { id: number; draft_status: draft_status_enum } | null;
    consumption_waste_details_draft?: {
      id: number;
      volume?: number | null;
      display_unit_volume?: consumption_unit_enum | null;
      frequency?: number | null;
      display_unit_frequency?: consumption_frequency_type_enum | null;
      amount?: number | null;
      price?: number | null;
    } | null;
    consumption_draft_areas: Array<{ area_id: number }>;
  }>;
};

export type EconomicUnitAssociatedBuildingsAndDraftsQueryVariables = Exact<{
  economicUnitId: Scalars['Int']['input'];
}>;

export type EconomicUnitAssociatedBuildingsAndDraftsQuery = {
  economic_unit_by_pk?: { id: number; associatedBuildingsAndDrafts: { amount: number } } | null;
};

export type DataCollectionGetAllBuildingsTableWithBuildingWhereQueryVariables = Exact<{
  buildingWhere: BuildingWhere;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BuildingOrderByInput>;
}>;

export type DataCollectionGetAllBuildingsTableWithBuildingWhereQuery = {
  getBuildingList: {
    count: number;
    buildings: Array<{
      id: number;
      energy_certificate_types: Array<energy_certificate_type_enum>;
      types_of_use: Array<type_of_use_enum>;
      has_gml_ids: boolean;
      energy_data?: { energy_final: number } | null;
      inactive_building?: {
        id: number;
        customer_external_identifier?: string | null;
        monument_protection?: boolean | null;
        milieu_protection?: boolean | null;
        leasehold?: boolean | null;
        heritage_district?: boolean | null;
        state?: string | null;
        has_write_permission?: boolean | null;
        year_constructed?: number | null;
        created_at?: string | null;
        active_building_model_id?: number | null;
        address?: {
          id: number;
          street: string;
          city: string;
          postal_code: string;
          country_id: country_enum;
          has_gml_ids?: boolean | null;
        } | null;
        responsible_user?: { id: number; first_name?: string | null; last_name?: string | null } | null;
        building_valuations: Array<{ id: number; value: number; valuation_at: string }>;
        areas: Array<{ id: number; value: number; area_type_id: area_type_enum }>;
        economic_unit: { id: number; name: string; portfolio: { id: number; name: string } };
        active_building_model?: {
          id: number;
          processing: boolean;
          energy_systems: Array<{
            id: number;
            energy_system_consumer_routes: Array<{
              id: number;
              energy_final: number;
              energy_source_type_id: energy_source_type_enum;
              energy_primary?: number | null;
            }>;
          }>;
        } | null;
      } | null;
      building: {
        id: number;
        customer_external_identifier?: string | null;
        monument_protection: boolean;
        milieu_protection: boolean;
        leasehold: boolean;
        heritage_district: boolean;
        has_write_permission: boolean;
        state: entity_state_type_enum;
        custom_data: any;
        year_constructed: number;
        is_new_construction: boolean;
        created_at: string;
        active_building_model_id?: number | null;
        address: {
          id: number;
          street: string;
          city: string;
          postal_code: string;
          country_id: country_enum;
          has_gml_ids?: boolean | null;
        };
        responsible_user: { id: number; first_name?: string | null; last_name?: string | null };
        building_valuations: Array<{ id: number; value: number; valuation_at: string }>;
        areas: Array<{ id: number; value: number; area_type_id: area_type_enum }>;
        economic_unit: { id: number; name: string; portfolio: { id: number; name: string } };
        active_building_model?: {
          id: number;
          processing: boolean;
          energy_systems: Array<{
            id: number;
            energy_system_consumer_routes: Array<{
              id: number;
              energy_final: number;
              energy_source_type_id: energy_source_type_enum;
              energy_primary?: number | null;
            }>;
          }>;
        } | null;
      };
    }>;
  };
};

export type EmissionCertificateDropdownFieldsFragment = {
  id: number;
  issuer: string;
  created_at: string;
  emission_factor: number;
  emission_factor_active_value_type: energy_supplier_value_type_enum;
  primary_energy_factor?: number | null;
  primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
  emission_certificate_energy_source_type_id?: emission_certificate_energy_source_type_enum | null;
  emission_certificate_value_path?: { emission_factor: Array<number>; primary_energy_factor: Array<number> } | null;
};

export type DataCollectionGetAllEmissionCertificatesDropdownQueryVariables = Exact<{ [key: string]: never }>;

export type DataCollectionGetAllEmissionCertificatesDropdownQuery = {
  emission_certificate: Array<{
    id: number;
    issuer: string;
    created_at: string;
    emission_factor: number;
    emission_factor_active_value_type: energy_supplier_value_type_enum;
    primary_energy_factor?: number | null;
    primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
    emission_certificate_energy_source_type_id?: emission_certificate_energy_source_type_enum | null;
    emission_certificate_value_path?: { emission_factor: Array<number>; primary_energy_factor: Array<number> } | null;
  }>;
};

export type ExportTemplatesQueryVariables = Exact<{
  orgId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ExportTemplatesQuery = {
  export_template: Array<{ id: number; name: string; export_type_id: export_template_type_enum }>;
};

export type AssociatedEntitiesByBuildingIdQueryVariables = Exact<{
  buildingIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type AssociatedEntitiesByBuildingIdQuery = {
  report_building: Array<{
    report: {
      id: number;
      progress: number;
      report_buildings: Array<{ building_id: number }>;
      report_template: { title: string };
    };
  }>;
  active_action_plans_aggregate: { aggregate?: { count: number } | null };
  action_aggregate: { aggregate?: { count: number } | null };
  consumption_aggregate: { aggregate?: { count: number } | null };
  consumption_draft_aggregate: { aggregate?: { count: number } | null };
};

export type DataCollectionGetConsumptionSummariesQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
}>;

export type DataCollectionGetConsumptionSummariesQuery = {
  getYearlyConsumptionSummary: {
    consumptionCategories: Array<{
      value: number;
      providers: Array<string>;
      cost: number;
      consumption_type: consumption_type_enum;
    }>;
  };
};

export type GetAllBuildingDraftsQueryVariables = Exact<{
  where: building_draft_bool_exp;
  orderBy: Array<building_draft_order_by> | building_draft_order_by;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAllBuildingDraftsQuery = {
  building_draft: Array<{
    id: number;
    street: string;
    city: string;
    external_id?: string | null;
    created_at: string;
    custom_data: any;
    user?: { id: number; first_name?: string | null; last_name?: string | null } | null;
    energy_certificate_drafts: Array<{
      id: number;
      draft_status_id: draft_status_enum;
      file: { id: number; name?: string | null };
    }>;
    energy_certificates: Array<{ id: number; file?: { id: number; name?: string | null } | null }>;
  }>;
  building_draft_aggregate: { aggregate?: { count: number } | null };
};

export type GetAllBuildingDraftsPortfoliosAndEconomicUnitsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllBuildingDraftsPortfoliosAndEconomicUnitsQuery = {
  portfolio: Array<{ id: number; name: string }>;
  economic_unit: Array<{ id: number; name: string }>;
};

export type GetBuildingDraftIdsByEpcNameQueryVariables = Exact<{
  nameLike: Scalars['String']['input'];
}>;

export type GetBuildingDraftIdsByEpcNameQuery = {
  energy_certificate_draft: Array<{ building_draft: { id: number } }>;
  energy_certificate: Array<{ building_draft?: { id: number } | null }>;
};

export type DataCollectionGetConsumptionInvoiceQueryVariables = Exact<{
  consumptionInvoiceId: Scalars['Int']['input'];
}>;

export type DataCollectionGetConsumptionInvoiceQuery = {
  consumption_invoice_by_pk?: {
    id: number;
    date: string;
    invoice_payer: invoice_payer_type_enum;
    file?: { downloadUrl: string; name?: string | null } | null;
    consumptions: Array<{
      id: number;
      provider?: string | null;
      to: string;
      from: string;
      cost?: number | null;
      display_unit_value?: consumption_unit_enum | null;
      displayValue?: number | null;
      created_at?: string | null;
      consumption_type_id: consumption_type_enum;
      source_type_id: consumption_source_type_enum;
      invoice_id?: number | null;
      energy_source_type_id?: energy_source_type_enum | null;
      sub_type_id?: consumption_sub_type_enum | null;
      created_by_user?: { first_name?: string | null; last_name?: string | null } | null;
      consumption_waste_detail?: {
        id: number;
        volume: number;
        display_unit_volume?: consumption_unit_enum | null;
        frequency: number;
        display_unit_frequency?: consumption_frequency_type_enum | null;
        amount: number;
        price: number;
      } | null;
      consumption_areas: Array<{ area_id: number }>;
    }>;
    building: {
      id: number;
      has_write_permission: boolean;
      address: { id: number; street: string; city: string; postal_code: string };
      areas: Array<{ id: number; external_id: string; description: string; area_type_id: area_type_enum }>;
    };
  } | null;
};

export type DataCollectionAreaConsumptionGetConsumptionsQueryVariables = Exact<{
  buildingId?: Scalars['Int']['input'];
}>;

export type DataCollectionAreaConsumptionGetConsumptionsQuery = { consumption_invoice: Array<{ id: number }> };

export type CountBuildingConsumptionsByAreaTypeQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  areaTypeId: area_type_enum;
}>;

export type CountBuildingConsumptionsByAreaTypeQuery = {
  building: Array<{ consumptions_aggregate: { aggregate?: { count: number } | null } }>;
};

export type DataCollectionGetBuildingConsumptionPreconditionQueryVariables = Exact<{
  orgId: Scalars['Int']['input'];
}>;

export type DataCollectionGetBuildingConsumptionPreconditionQuery = {
  building: Array<{
    id: number;
    has_write_permission: boolean;
    address: { id: number; city: string; street: string; postal_code: string };
    building_models: Array<{
      id: number;
      energy_systems: Array<{ id: number; energy_system_type_id: energy_system_type_enum }>;
    }>;
    areas: Array<{ id: number; external_id: string; description: string; area_type_id: area_type_enum; value: number }>;
    economic_unit: { id: number; portfolio: { id: number; has_write_permission: boolean } };
  }>;
};

export type DataCollectionGetConsumptionInvoiceDraftQueryVariables = Exact<{
  consumptionInvoiceDraftId: Scalars['Int']['input'];
}>;

export type DataCollectionGetConsumptionInvoiceDraftQuery = {
  consumption_invoice_draft_by_pk?: {
    id: number;
    date?: string | null;
    draft_status: draft_status_enum;
    invoice_payer?: invoice_payer_type_enum | null;
    file?: { downloadUrl: string; name?: string | null } | null;
    building: {
      id: number;
      address: { id: number; street: string; city: string; postal_code: string };
      areas: Array<{ id: number; external_id: string; description: string; area_type_id: area_type_enum }>;
    };
    consumption_drafts: Array<{
      id: number;
      from?: string | null;
      to?: string | null;
      displayValue?: number | null;
      cost?: number | null;
      consumption_type_id?: consumption_type_enum | null;
      display_unit_value?: consumption_unit_enum | null;
      energy_source_type_id?: energy_source_type_enum | null;
      sub_type_id?: consumption_sub_type_enum | null;
      provider?: string | null;
      consumption_waste_details_draft?: {
        id: number;
        frequency?: number | null;
        display_unit_frequency?: consumption_frequency_type_enum | null;
        volume?: number | null;
        display_unit_volume?: consumption_unit_enum | null;
        amount?: number | null;
        price?: number | null;
      } | null;
      consumption_draft_areas: Array<{ area_id: number }>;
    }>;
  } | null;
};

export type DataCollectionAreaGetConsumptionDraftsQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type DataCollectionAreaGetConsumptionDraftsQuery = { consumption_invoice_draft: Array<{ id: number }> };

export type GetBuildingPdfFilesQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type GetBuildingPdfFilesQuery = {
  getBuildingPdfFiles: {
    files: Array<{
      id: number;
      name?: string | null;
      uploading: boolean;
      createdAt: string;
      downloadUrl?: string | null;
      energyCertificateId?: number | null;
    }>;
  };
};

export type getBuildingModelMutationAvailabilityQueryVariables = Exact<{
  buildingModelId: Scalars['Int']['input'];
}>;

export type getBuildingModelMutationAvailabilityQuery = {
  getBuildingModelMutationAvailability: {
    affected_action_plans: Array<{
      id: number;
      scenario_id: number;
      scenario_name: string;
      scenario_updated_at?: DateTime | null;
    }>;
  };
};

export type getEmissionCertificatesQueryVariables = Exact<{
  where?: InputMaybe<EmissionCertificateWhereInput>;
  orderBy?: InputMaybe<EmissionCertificateOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type getEmissionCertificatesQuery = {
  getEmissionCertificates: {
    count: number;
    certificates: Array<{
      emission_factor_active_value_type: energy_supplier_value_type_enum;
      primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
      created_at: DateTime;
      issuer: string;
      emission_factor: number;
      primary_energy_factor?: number | null;
      id: number;
      valid_until?: DateTime | null;
      emission_certificate_energy_source_type_id?: emission_certificate_energy_source_type_enum | null;
      associated_action_plans_count?: number | null;
      associated_buildings_count?: number | null;
      emission_certificate_value_path?: {
        id: number;
        emission_factor: Array<number>;
        primary_energy_factor: Array<number>;
      } | null;
    }>;
  };
};

export type getEmissionCertificateTabCountsQueryVariables = Exact<{
  now: Scalars['timestamptz']['input'];
}>;

export type getEmissionCertificateTabCountsQuery = {
  all: { aggregate?: { count: number } | null };
  valid: { aggregate?: { count: number } | null };
  expired: { aggregate?: { count: number } | null };
};

export type getEmissionCertificateQueryVariables = Exact<{
  emissionCertificateId: Scalars['Int']['input'];
}>;

export type getEmissionCertificateQuery = {
  emission_certificate_by_pk?: {
    __typename: 'emission_certificate';
    emission_factor_active_value_type: energy_supplier_value_type_enum;
    primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
    created_at: string;
    updated_at: string;
    issuer: string;
    emission_factor: number;
    primary_energy_factor?: number | null;
    file_id?: number | null;
    org_id: number;
    id: number;
    valid_from?: string | null;
    valid_until?: string | null;
    emission_certificate_energy_source_type_id?: emission_certificate_energy_source_type_enum | null;
    emission_certificate_document_type_id?: emission_certificate_document_type_enum | null;
    emission_certificate_value_path?: {
      id: number;
      emission_factor: Array<number>;
      primary_energy_factor: Array<number>;
    } | null;
    file?: { downloadUrl: string; id: number; name?: string | null; created_at: string } | null;
    org: { name: string };
  } | null;
};

export type getEmissionCertificateDraftsQueryVariables = Exact<{
  where?: InputMaybe<EmissionCertificateDraftWhereInput>;
  orderBy?: InputMaybe<EmissionCertificateDraftOrderByInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type getEmissionCertificateDraftsQuery = {
  getEmissionCertificateDrafts: {
    count: number;
    drafts: Array<{
      id: number;
      issuer: string;
      emission_factor_active_value_type: string;
      primary_energy_factor_active_value_type: string;
      emission_factor?: number | null;
      primary_energy_factor?: number | null;
      emission_certificate_energy_source_type_id?: string | null;
      emission_certificate_document_type_id?: string | null;
      valid_from?: DateTime | null;
      valid_until?: DateTime | null;
      created_at: DateTime;
      updated_at: DateTime;
      org_id: number;
      emission_factor_progressive?: Array<{ year: number; value?: number | null }> | null;
      primary_energy_factor_progressive?: Array<{ year: number; value?: number | null }> | null;
      file?: { id: number; name?: string | null; downloadUrl: string; created_at: DateTime } | null;
    }>;
  };
};

export type getEmissionCertificateDraftQueryVariables = Exact<{
  emissionCertificateDraftId: Scalars['Int']['input'];
}>;

export type getEmissionCertificateDraftQuery = {
  getEmissionCertificateDraft: {
    id: number;
    issuer: string;
    emission_factor_active_value_type: string;
    primary_energy_factor_active_value_type: string;
    emission_factor?: number | null;
    primary_energy_factor?: number | null;
    emission_certificate_energy_source_type_id?: string | null;
    emission_certificate_document_type_id?: string | null;
    valid_from?: DateTime | null;
    valid_until?: DateTime | null;
    created_at: DateTime;
    updated_at: DateTime;
    org_id: number;
    emission_factor_progressive?: Array<{ year: number; value?: number | null }> | null;
    primary_energy_factor_progressive?: Array<{ year: number; value?: number | null }> | null;
    file?: { id: number; name?: string | null; downloadUrl: string; created_at: DateTime } | null;
  };
};

export type getEmissionCertificateDraftByFileQueryVariables = Exact<{
  emissionCertificateDraftFileId: Scalars['Int']['input'];
}>;

export type getEmissionCertificateDraftByFileQuery = { emission_certificate_draft: Array<{ id: number }> };

export type getAssociatedActionPlansAndReportsFromEmissionCertificateQueryVariables = Exact<{
  emissionCertificateId: Scalars['Int']['input'];
}>;

export type getAssociatedActionPlansAndReportsFromEmissionCertificateQuery = {
  emission_factor_buildings: Array<{
    id: number;
    active_action_plans_aggregate: { aggregate?: { count: number } | null };
    report_buildings: Array<{ report_id: number }>;
  }>;
  primary_energy_factor_buildings: Array<{
    id: number;
    active_action_plans_aggregate: { aggregate?: { count: number } | null };
    report_buildings: Array<{ report_id: number }>;
  }>;
};

export type BuildingModelSubscriptionSubscriptionVariables = Exact<{
  buildingModelId: Scalars['Int']['input'];
}>;

export type BuildingModelSubscriptionSubscription = {
  building_model_by_pk?: {
    id: number;
    description: string;
    valid_from: string;
    created_at: string;
    is_draft: boolean;
    processing: boolean;
    energy_final?: number | null;
    action_planning_available: boolean;
    heating_demand?: number | null;
    internal_temperature: number;
    annual_heating_days: number;
    envelope_units: Array<{
      id: number;
      data_source_type_id: data_source_type_enum;
      description?: string | null;
      inclination?: number | null;
      orientation?: number | null;
      envelope_type_id: envelope_type_enum;
      insulation_thickness?: number | null;
      insulation_material_name?: string | null;
      insulation_material_category_id?: insulation_material_category_enum | null;
      insulation_method_id?: insulation_method_enum | null;
      insulation_lambda?: number | null;
      base_construction_thickness?: number | null;
      base_construction_material_name?: string | null;
      base_construction_lambda?: number | null;
      area: number;
      u_value?: number | null;
    }>;
    energy_systems: Array<{
      id: number;
      energy_system_type_id: energy_system_type_enum;
      data_source_type_id: data_source_type_enum;
      description?: string | null;
      energy_system_consumer_routes: Array<{
        id: number;
        secondary_id: string;
        area_id?: number | null;
        energy_final: number;
        energy_effective?: number | null;
        energy_source_type_id: energy_source_type_enum;
        energy_primary?: number | null;
        emission_certificate_id?: number | null;
        use_renewable_energy: boolean;
        primary_energy_factor_emission_certificate_id?: number | null;
        emission_certificate?: {
          emission_factor: number;
          emission_factor_active_value_type: energy_supplier_value_type_enum;
          emission_certificate_value_path?: { emission_factor: Array<number> } | null;
        } | null;
        primary_energy_factor_emission_certificate?: {
          primary_energy_factor?: number | null;
          primary_energy_factor_active_value_type: energy_supplier_value_type_enum;
          emission_certificate_value_path?: { primary_energy_factor: Array<number> } | null;
        } | null;
        energy_consumer?: {
          id: number;
          energy_consumer_technology_type_id?: energy_consumer_technology_type_enum | null;
          energy_consumer_type_id: energy_consumer_type_enum;
          efficiency?: number | null;
          construction_year?: number | null;
        } | null;
        energy_distribution?: {
          id: number;
          energy_distribution_type_id: energy_distribution_type_enum;
          heat_distribution_loss: number;
          heat_transfer_loss: number;
          last_hydraulic_balancing?: string | null;
          last_balancing_set_to_never: boolean;
          construction_year?: number | null;
        } | null;
        energy_storage?: {
          id: number;
          energy_storage_type_id: energy_storage_type_enum;
          annual_heat_loss?: number | null;
          construction_year?: number | null;
        } | null;
      }>;
      energy_system_producer_routes: Array<{
        id: number;
        area_id?: number | null;
        energy_effective?: number | null;
        energy_produced: number;
        energy_source_type_id: energy_source_type_enum;
        energy_producer: {
          id: number;
          name?: string | null;
          module_angle?: number | null;
          nominal_power?: number | null;
          construction_year?: number | null;
          solar_active_area?: number | null;
        };
      }>;
    }>;
  } | null;
};

export type BuildingProcessingSubscriptionSubscriptionVariables = Exact<{
  buildingModelId: Scalars['Int']['input'];
}>;

export type BuildingProcessingSubscriptionSubscription = {
  building_model_by_pk?: { id: number; processing: boolean } | null;
};

export type hasSingleBuildingOrDraftQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type hasSingleBuildingOrDraftQuery = { hasSingleBuildingOrDraft: boolean };

export type UserHasWriteAccessToAllBuildingsQueryVariables = Exact<{
  buildingWhere: BuildingWhere;
}>;

export type UserHasWriteAccessToAllBuildingsQuery = { getBuildingList: { count: number } };

export type GetBuildingsByEconomicUnitIdQueryVariables = Exact<{
  economicUnitId: Scalars['Int']['input'];
}>;

export type GetBuildingsByEconomicUnitIdQuery = {
  building: Array<{
    id: number;
    state: entity_state_type_enum;
    has_write_permission: boolean;
    building_state_id: building_state_enum;
    year_constructed: number;
    is_new_construction: boolean;
    is_missing_energy_data?: boolean | null;
    areas: Array<{ id: number; type_of_use_id: type_of_use_enum; area_type_id: area_type_enum; value: number }>;
    address: { id: number; street: string };
  }>;
};

export type GetInactiveBuildingsByEconomicUnitIdQueryVariables = Exact<{
  economicUnitId: Scalars['Int']['input'];
}>;

export type GetInactiveBuildingsByEconomicUnitIdQuery = {
  inactive_buildings: Array<{
    id: number;
    state?: string | null;
    has_write_permission?: boolean | null;
    building_state_id?: string | null;
    year_constructed?: number | null;
    areas: Array<{ id: number; type_of_use_id: type_of_use_enum; area_type_id: area_type_enum; value: number }>;
    address?: { id: number; street: string } | null;
  }>;
};

export type GetBuildingsHasWritePermissionQueryVariables = Exact<{
  buildingIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type GetBuildingsHasWritePermissionQuery = { building: Array<{ id: number; has_write_permission: boolean }> };

export type GetExportedBuildingNamesQueryVariables = Exact<{
  buildingWhere: BuildingWhere;
  limit: Scalars['Int']['input'];
}>;

export type GetExportedBuildingNamesQuery = {
  getBuildingList: {
    buildings: Array<{
      id: number;
      building: { id: number; address: { id: number; street: string } };
      inactive_building?: { id: number; address?: { id: number; street: string } | null } | null;
    }>;
  };
};

export type GetUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetUsersQuery = { user: Array<{ id: number; first_name?: string | null; last_name?: string | null }> };

export type EPCFragmentFragment = {
  __typename: 'energy_certificate';
  id: number;
  updated_at: string;
  street?: string | null;
  postal_code?: string | null;
  city?: string | null;
  country_id: country_enum;
  year_constructed?: number | null;
  area_usable?: number | null;
  type_of_use_id: type_of_use_enum;
  energy_certificate_type: energy_certificate_type_enum;
  expiry_date?: string | null;
  units_commercial?: number | null;
  units_residential?: number | null;
  geg_reference_value?: number | null;
  energy_rating_score?: number | null;
  co2_emissions?: number | null;
  reference_value_heating_hot_water?: number | null;
  reference_value_electricity?: number | null;
  enev_year?: number | null;
  energy_certificate_consumers: Array<{
    id: number;
    energy_system_type_id: energy_system_type_enum;
    energy_source_type_id: energy_source_type_enum;
    energy_final: number;
  }>;
  file?: { id: number; name?: string | null; uploading: boolean; downloadUrl: string } | null;
};

export type EPCDraftFragmentFragment = {
  __typename: 'energy_certificate_draft';
  id: number;
  street?: string | null;
  draft_status_id: draft_status_enum;
  postal_code?: string | null;
  city?: string | null;
  country_id: country_enum;
  country_state_id?: country_state_enum | null;
  year_constructed?: number | null;
  area_usable?: number | null;
  type_of_use_id?: type_of_use_enum | null;
  energy_certificate_type_id?: energy_certificate_type_enum | null;
  expiry_date?: string | null;
  units?: number | null;
  geg_reference_value?: number | null;
  energy_rating_score?: number | null;
  co2_emissions?: number | null;
  reference_value_heating_hot_water?: number | null;
  reference_value_electricity?: number | null;
  enev_year?: number | null;
  file: { id: number; name?: string | null; uploading: boolean };
  energy_certificate_consumers: Array<{
    id: number;
    energy_system_type_id: energy_system_type_enum;
    energy_source_type_id: energy_source_type_enum;
    energy_final: number;
  }>;
};

export type EPCDraftWithFileURLFragmentFragment = {
  __typename: 'energy_certificate_draft';
  id: number;
  street?: string | null;
  draft_status_id: draft_status_enum;
  postal_code?: string | null;
  city?: string | null;
  country_id: country_enum;
  country_state_id?: country_state_enum | null;
  year_constructed?: number | null;
  area_usable?: number | null;
  type_of_use_id?: type_of_use_enum | null;
  energy_certificate_type_id?: energy_certificate_type_enum | null;
  expiry_date?: string | null;
  units?: number | null;
  geg_reference_value?: number | null;
  energy_rating_score?: number | null;
  co2_emissions?: number | null;
  reference_value_heating_hot_water?: number | null;
  reference_value_electricity?: number | null;
  enev_year?: number | null;
  file: { id: number; name?: string | null; downloadUrl: string; uploading: boolean };
  energy_certificate_consumers: Array<{
    id: number;
    energy_system_type_id: energy_system_type_enum;
    energy_source_type_id: energy_source_type_enum;
    energy_final: number;
  }>;
};

export type GetBuildingDraftFragmentFragment = {
  id: number;
  year_constructed?: number | null;
  responsible_user_id?: number | null;
  postal_code: string;
  building_state_id?: building_state_enum | null;
  city: string;
  country_id: country_enum;
  economic_unit_id?: number | null;
  heritage_district: boolean;
  monument_protection: boolean;
  milieu_protection: boolean;
  leasehold: boolean;
  portfolio_id: number;
  floors?: number | null;
  external_id?: string | null;
  street: string;
  units?: number | null;
  latitude?: number | null;
  longitude?: number | null;
  mapbox_building_ids?: Array<string> | null;
  building_citydb_gml_ids?: Array<string> | null;
  neighbor_citydb_gml_ids?: Array<string> | null;
  building_lod1_ids?: Array<string> | null;
  neighbor_lod1_ids?: Array<string> | null;
  custom_data: any;
  assign_responsible_user_as_transaction_manager?: boolean | null;
  building_draft_valuations: Array<{ id: number; value: number; valuation_at: string }>;
  building_draft_consumers: Array<{
    id: number;
    energy_source_type_id?: energy_source_type_enum | null;
    energy_final?: number | null;
    energy_system_type_id: energy_system_type_enum;
    building_draft_area_id?: number | null;
  }>;
  building_draft_areas: Array<{
    id: number;
    name: string;
    type_of_use_id?: type_of_use_enum | null;
    value?: number | null;
    energy_certificate_id?: number | null;
    geg_reference_value?: number | null;
    energy_rating_score?: number | null;
    reference_value_heating_hot_water?: number | null;
    reference_value_electricity?: number | null;
    enev_year?: number | null;
  }>;
  energy_certificate_drafts: Array<{
    __typename: 'energy_certificate_draft';
    id: number;
    street?: string | null;
    draft_status_id: draft_status_enum;
    postal_code?: string | null;
    city?: string | null;
    country_id: country_enum;
    country_state_id?: country_state_enum | null;
    year_constructed?: number | null;
    area_usable?: number | null;
    type_of_use_id?: type_of_use_enum | null;
    energy_certificate_type_id?: energy_certificate_type_enum | null;
    expiry_date?: string | null;
    units?: number | null;
    geg_reference_value?: number | null;
    energy_rating_score?: number | null;
    co2_emissions?: number | null;
    reference_value_heating_hot_water?: number | null;
    reference_value_electricity?: number | null;
    enev_year?: number | null;
    file: { id: number; name?: string | null; downloadUrl: string; uploading: boolean };
    energy_certificate_consumers: Array<{
      id: number;
      energy_system_type_id: energy_system_type_enum;
      energy_source_type_id: energy_source_type_enum;
      energy_final: number;
    }>;
  }>;
  energy_certificates: Array<{
    __typename: 'energy_certificate';
    id: number;
    updated_at: string;
    street?: string | null;
    postal_code?: string | null;
    city?: string | null;
    country_id: country_enum;
    year_constructed?: number | null;
    area_usable?: number | null;
    type_of_use_id: type_of_use_enum;
    energy_certificate_type: energy_certificate_type_enum;
    expiry_date?: string | null;
    units_commercial?: number | null;
    units_residential?: number | null;
    geg_reference_value?: number | null;
    energy_rating_score?: number | null;
    co2_emissions?: number | null;
    reference_value_heating_hot_water?: number | null;
    reference_value_electricity?: number | null;
    enev_year?: number | null;
    energy_certificate_consumers: Array<{
      id: number;
      energy_system_type_id: energy_system_type_enum;
      energy_source_type_id: energy_source_type_enum;
      energy_final: number;
    }>;
    file?: { id: number; name?: string | null; uploading: boolean; downloadUrl: string } | null;
  }>;
  certificates: Array<{
    id: number;
    certificate_level_type?: certificate_level_type_enum | null;
    certificate_score?: number | null;
    certificate_type: certificate_type_enum;
    file?: { id: number; name?: string | null } | null;
  }>;
};

export type GetBuildingDraftQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetBuildingDraftQuery = {
  building_draft_by_pk?: {
    id: number;
    year_constructed?: number | null;
    responsible_user_id?: number | null;
    postal_code: string;
    building_state_id?: building_state_enum | null;
    city: string;
    country_id: country_enum;
    economic_unit_id?: number | null;
    heritage_district: boolean;
    monument_protection: boolean;
    milieu_protection: boolean;
    leasehold: boolean;
    portfolio_id: number;
    floors?: number | null;
    external_id?: string | null;
    street: string;
    units?: number | null;
    latitude?: number | null;
    longitude?: number | null;
    mapbox_building_ids?: Array<string> | null;
    building_citydb_gml_ids?: Array<string> | null;
    neighbor_citydb_gml_ids?: Array<string> | null;
    building_lod1_ids?: Array<string> | null;
    neighbor_lod1_ids?: Array<string> | null;
    custom_data: any;
    assign_responsible_user_as_transaction_manager?: boolean | null;
    building_draft_valuations: Array<{ id: number; value: number; valuation_at: string }>;
    building_draft_consumers: Array<{
      id: number;
      energy_source_type_id?: energy_source_type_enum | null;
      energy_final?: number | null;
      energy_system_type_id: energy_system_type_enum;
      building_draft_area_id?: number | null;
    }>;
    building_draft_areas: Array<{
      id: number;
      name: string;
      type_of_use_id?: type_of_use_enum | null;
      value?: number | null;
      energy_certificate_id?: number | null;
      geg_reference_value?: number | null;
      energy_rating_score?: number | null;
      reference_value_heating_hot_water?: number | null;
      reference_value_electricity?: number | null;
      enev_year?: number | null;
    }>;
    energy_certificate_drafts: Array<{
      __typename: 'energy_certificate_draft';
      id: number;
      street?: string | null;
      draft_status_id: draft_status_enum;
      postal_code?: string | null;
      city?: string | null;
      country_id: country_enum;
      country_state_id?: country_state_enum | null;
      year_constructed?: number | null;
      area_usable?: number | null;
      type_of_use_id?: type_of_use_enum | null;
      energy_certificate_type_id?: energy_certificate_type_enum | null;
      expiry_date?: string | null;
      units?: number | null;
      geg_reference_value?: number | null;
      energy_rating_score?: number | null;
      co2_emissions?: number | null;
      reference_value_heating_hot_water?: number | null;
      reference_value_electricity?: number | null;
      enev_year?: number | null;
      file: { id: number; name?: string | null; downloadUrl: string; uploading: boolean };
      energy_certificate_consumers: Array<{
        id: number;
        energy_system_type_id: energy_system_type_enum;
        energy_source_type_id: energy_source_type_enum;
        energy_final: number;
      }>;
    }>;
    energy_certificates: Array<{
      __typename: 'energy_certificate';
      id: number;
      updated_at: string;
      street?: string | null;
      postal_code?: string | null;
      city?: string | null;
      country_id: country_enum;
      year_constructed?: number | null;
      area_usable?: number | null;
      type_of_use_id: type_of_use_enum;
      energy_certificate_type: energy_certificate_type_enum;
      expiry_date?: string | null;
      units_commercial?: number | null;
      units_residential?: number | null;
      geg_reference_value?: number | null;
      energy_rating_score?: number | null;
      co2_emissions?: number | null;
      reference_value_heating_hot_water?: number | null;
      reference_value_electricity?: number | null;
      enev_year?: number | null;
      energy_certificate_consumers: Array<{
        id: number;
        energy_system_type_id: energy_system_type_enum;
        energy_source_type_id: energy_source_type_enum;
        energy_final: number;
      }>;
      file?: { id: number; name?: string | null; uploading: boolean; downloadUrl: string } | null;
    }>;
    certificates: Array<{
      id: number;
      certificate_level_type?: certificate_level_type_enum | null;
      certificate_score?: number | null;
      certificate_type: certificate_type_enum;
      file?: { id: number; name?: string | null } | null;
    }>;
  } | null;
};

export type CompleteBuildingQueryVariables = Exact<{
  areaUsable?: InputMaybe<Scalars['Float']['input']>;
  energyData: Array<EnergyDataInput> | EnergyDataInput;
  typeOfUse?: InputMaybe<type_of_use_enum>;
  geolocation?: InputMaybe<BuildingCompleteGeolocation>;
  buildingGmlIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  buildingLOD1Ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  units?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
}>;

export type CompleteBuildingQuery = {
  completeBuilding: {
    areaUsable: number;
    areaUsableDataSource: data_source_type_enum;
    energyDataSource: data_source_type_enum;
    typeOfUse: type_of_use_enum;
    typeOfUseDataSource: data_source_type_enum;
    units: number;
    unitsDataSource: data_source_type_enum;
    yearConstructed: number;
    yearConstructedDataSource: data_source_type_enum;
    energyData: Array<{
      energySource: energy_source_type_enum;
      energySystemType: energy_system_type_enum;
      finalEnergyDemand: number;
    }>;
  };
};

export type DataCollectionBuildingDraftCountQueryVariables = Exact<{ [key: string]: never }>;

export type DataCollectionBuildingDraftCountQuery = {
  building_draft_aggregate: { aggregate?: { count: number } | null };
};

export type GetClimateRiskV2ReportQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type GetClimateRiskV2ReportQuery = {
  readClimateRiskV2Report: {
    success: boolean;
    data?: {
      id: string;
      status: api_response_status_enum;
      createdAt?: DateTime | null;
      modelVersion?: string | null;
      files: Array<{ name: string; path: string; publicPath: string }>;
      scenarios: Array<{
        type: string;
        risks: Array<{
          riskName: string;
          periods: Array<{ percentage: number; range: string; severity: string; valuationAtRisk?: number | null }>;
        }>;
      }>;
    } | null;
  };
};

export type EnergyCertificateDraftsSubscriptionSubscriptionVariables = Exact<{
  buildingDraftId: Scalars['Int']['input'];
}>;

export type EnergyCertificateDraftsSubscriptionSubscription = {
  energy_certificate_draft: Array<{
    __typename: 'energy_certificate_draft';
    id: number;
    street?: string | null;
    draft_status_id: draft_status_enum;
    postal_code?: string | null;
    city?: string | null;
    country_id: country_enum;
    country_state_id?: country_state_enum | null;
    year_constructed?: number | null;
    area_usable?: number | null;
    type_of_use_id?: type_of_use_enum | null;
    energy_certificate_type_id?: energy_certificate_type_enum | null;
    expiry_date?: string | null;
    units?: number | null;
    geg_reference_value?: number | null;
    energy_rating_score?: number | null;
    co2_emissions?: number | null;
    reference_value_heating_hot_water?: number | null;
    reference_value_electricity?: number | null;
    enev_year?: number | null;
    file: { id: number; name?: string | null; uploading: boolean };
    energy_certificate_consumers: Array<{
      id: number;
      energy_system_type_id: energy_system_type_enum;
      energy_source_type_id: energy_source_type_enum;
      energy_final: number;
    }>;
  }>;
};

export type PortfolioForBuildingDraftQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type PortfolioForBuildingDraftQuery = {
  building: Array<{ id: number; economic_unit: { portfolio: { id: number } } }>;
  portfolio: Array<{ id: number }>;
};

export type PortfolioForMultipleBuildingDraftsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type PortfolioForMultipleBuildingDraftsQuery = {
  portfolio: Array<{
    id: number;
    name: string;
    economic_units: Array<{ id: number; name: string; customer_economic_unit_id?: string | null }>;
  }>;
};

export type GetGlbAccessCookiesQueryVariables = Exact<{
  glbPath?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetGlbAccessCookiesQuery = { getGlbAccessCookies: { success: boolean; signedUrl?: string | null } };

export type ValidateBuildingIdsQueryVariables = Exact<{
  where: building_bool_exp;
}>;

export type ValidateBuildingIdsQuery = { building: Array<{ id: number }> };

export type GetLastTypesOfUseQueryVariables = Exact<{ [key: string]: never }>;

export type GetLastTypesOfUseQuery = { fetchLastUsedTypesOfUse: { data: Array<type_of_use_enum> } };

export type GetCustomFieldsByOrgQueryVariables = Exact<{
  orgId: Scalars['Int']['input'];
  entityType: custom_field_entity_enum;
}>;

export type GetCustomFieldsByOrgQuery = {
  custom_field: Array<{
    id: number;
    name: string;
    key: string;
    type_id: custom_field_type_enum;
    suffix?: string | null;
  }>;
};

export type OngoingExportsSubscriptionVariables = Exact<{
  userId: Scalars['Int']['input'];
  pendingJobIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type OngoingExportsSubscription = {
  async_job: Array<{
    __typename: 'async_job';
    id: number;
    title: string;
    description?: string | null;
    status_id: async_job_status_type_enum;
    created_at?: string | null;
    user_id?: number | null;
    org_id?: number | null;
    total_jobs_created: number;
    total_jobs_finished: number;
  }>;
};

export type UserFilesListQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type UserFilesListQuery = {
  file: Array<{
    __typename: 'file';
    id: number;
    name?: string | null;
    description?: string | null;
    created_at: string;
  }>;
};

export type GetFileDownloadUrlQueryVariables = Exact<{
  fileId: Scalars['Int']['input'];
}>;

export type GetFileDownloadUrlQuery = {
  file_by_pk?: { __typename: 'file'; id: number; name?: string | null; downloadUrl: string } | null;
};

export type GetFilePreviewQueryVariables = Exact<{
  fileId: Scalars['Int']['input'];
}>;

export type GetFilePreviewQuery = { getFilePreview: { id: number; name?: string | null; downloadUrl: string } };

export type DeleteUserFileMutationVariables = Exact<{
  fileId: Scalars['Int']['input'];
}>;

export type DeleteUserFileMutation = { delete_file_by_pk?: { __typename: 'file'; id: number } | null };

export type ReadNotificationsMutationVariables = Exact<{
  notificationIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type ReadNotificationsMutation = {
  update_notification?: { returning: Array<{ __typename: 'notification'; id: number; read: boolean }> } | null;
};

export type GetFileIdByAsyncJobIdQueryVariables = Exact<{
  asyncJobId: Scalars['Int']['input'];
}>;

export type GetFileIdByAsyncJobIdQuery = {
  async_job_by_pk?: { id: number; exportedFileId?: { fileId: number } | null } | null;
};

export type GetBatchEsgAnalysisPdfExportDownloadUrlQueryVariables = Exact<{
  asyncJobId: Scalars['Int']['input'];
}>;

export type GetBatchEsgAnalysisPdfExportDownloadUrlQuery = { getBatchEsgAnalysisPdfExportDownloadUrl: string };

export type CompletedBatchExportsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
}>;

export type CompletedBatchExportsQuery = {
  async_job: Array<{
    __typename: 'async_job';
    id: number;
    title: string;
    description?: string | null;
    created_at?: string | null;
  }>;
};

export type CreateDriveFolderMutationVariables = Exact<{
  input: CreateFolderInput;
}>;

export type CreateDriveFolderMutation = { createFolder: { folderId: number } };

export type RenameDriveFolderMutationVariables = Exact<{
  input: RenameFolderInput;
}>;

export type RenameDriveFolderMutation = { renameFolder: { folderId: number } };

export type MoveDriveFolderMutationVariables = Exact<{
  input: MoveFolderInput;
}>;

export type MoveDriveFolderMutation = { moveFolder: { folderId: number } };

export type DeleteDriveFolderMutationVariables = Exact<{
  input: DeleteFolderInput;
}>;

export type DeleteDriveFolderMutation = { deleteFolder: { folderId: number } };

export type MoveFileToFolderMutationVariables = Exact<{
  input: MoveFileToFolderInput;
}>;

export type MoveFileToFolderMutation = { moveFileToFolder: { fileId: number } };

export type RenameDriveFileMutationVariables = Exact<{
  input: RenameFileInput;
}>;

export type RenameDriveFileMutation = { renameFile: { fileId: number } };

export type RemoveFileFromFolderMutationVariables = Exact<{
  input: RemoveFileFromFolderInput;
}>;

export type RemoveFileFromFolderMutation = { removeFileFromFolder: { fileId: number } };

export type UploadFileToDriveFolderMutationVariables = Exact<{
  input: UploadFileToDriveFolderInput;
}>;

export type UploadFileToDriveFolderMutation = { uploadFileToDriveFolder: { fileId: number; uploadUrl: string } };

export type ConfirmDriveUploadMutationVariables = Exact<{
  input: ConfirmDriveUploadInput;
}>;

export type ConfirmDriveUploadMutation = { confirmDriveUpload: { fileId: number } };

export type ConvertFileToEnergyCertificateMutationVariables = Exact<{
  input: ConvertFileToEnergyCertificateInput;
}>;

export type ConvertFileToEnergyCertificateMutation = {
  convertFileToEnergyCertificate: { buildingDraftId: number; energyCertificateDraftId: number };
};

export type ConvertFilesToEnergyCertificatesMutationVariables = Exact<{
  input: Array<ConvertFilesToEnergyCertificatesInput> | ConvertFilesToEnergyCertificatesInput;
  autoCreateBuildings?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ConvertFilesToEnergyCertificatesMutation = { convertFilesToEnergyCertificates: { success: boolean } };

export type GetDriveFolderChildrenQueryVariables = Exact<{
  parentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type GetDriveFolderChildrenQuery = {
  getFolderChildren: {
    folders: Array<{ id: number; name: string; parentId?: number | null; folderTypeId: string; childCount: number }>;
  };
};

export type GetDriveRootFolderForTreeQueryVariables = Exact<{ [key: string]: never }>;

export type GetDriveRootFolderForTreeQuery = {
  getRootFolderForTree: {
    rootFolder?: {
      id: number;
      name: string;
      parentId?: number | null;
      folderTypeId: string;
      childCount: number;
    } | null;
  };
};

export type GetBuildingFolderQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type GetBuildingFolderQuery = { getBuildingFolder: { folderId?: number | null } };

export type GetDriveFolderContentsQueryVariables = Exact<{
  folderId: Scalars['Int']['input'];
}>;

export type GetDriveFolderContentsQuery = {
  getFolderContents: {
    folders: Array<{
      id: number;
      name: string;
      parentId?: number | null;
      orgId: number;
      folderTypeId: string;
      portfolioId?: number | null;
      economicUnitId?: number | null;
      buildingId?: number | null;
      createdAt: string;
      updatedAt: string;
    }>;
    fileMemberships: Array<{
      id: number;
      fileId: number;
      folderId: number;
      createdAt: string;
      file: {
        id: number;
        name?: string | null;
        createdAt: string;
        uploading: boolean;
        energyCertificates: Array<{ id: number; buildingId?: number | null; buildingDraftId?: number | null }>;
        consumptionInvoices: Array<{ id: number; buildingId: number }>;
        emissionCertificates: Array<{ id: number }>;
        energyCertificateDrafts: Array<{ id: number; buildingDraft: { id: number } }>;
        consumptionInvoiceDrafts: Array<{ id: number; buildingId: number }>;
        emissionCertificateDrafts: Array<{ id: number }>;
      };
    }>;
  };
};

export type GetDriveFolderBreadcrumbQueryVariables = Exact<{
  folderId: Scalars['Int']['input'];
}>;

export type GetDriveFolderBreadcrumbQuery = {
  getFolderBreadcrumb: { breadcrumb: Array<{ id: number; name: string; folderTypeId: string }> };
};

export type CreateCustomTargetMutationVariables = Exact<{
  name: Scalars['String']['input'];
  target_definitions: Array<TargetDefinitionInput> | TargetDefinitionInput;
}>;

export type CreateCustomTargetMutation = {
  createCustomTarget: {
    active: boolean;
    id: number;
    name: string;
    target_definitions: Array<{
      id: number;
      target_definition_type: target_definition_type_enum;
      value: number;
      year: number;
    }>;
  };
};

export type UpdateCustomTargetMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  target_definitions: Array<TargetDefinitionInput> | TargetDefinitionInput;
}>;

export type UpdateCustomTargetMutation = {
  updateCustomTarget: {
    active: boolean;
    id: number;
    name: string;
    target_definitions: Array<{
      id: number;
      target_definition_type: target_definition_type_enum;
      value: number;
      year: number;
    }>;
  };
};

export type DeleteCustomTargetMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteCustomTargetMutation = { deleteCustomTarget: boolean };

export type SetCustomTargetActiveMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SetCustomTargetActiveMutation = { setCustomTargetActive: boolean };

export type CreateCustomFieldMutationVariables = Exact<{
  entity: custom_field_entity_enum;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: custom_field_type_enum;
  suffix?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateCustomFieldMutation = { createCustomField: { id: number } };

export type EditCustomFieldMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  showInAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
}>;

export type EditCustomFieldMutation = { editCustomField: { id: number } };

export type DeleteCustomFieldMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteCustomFieldMutation = { deleteCustomField: { success: boolean } };

export type CustomTargetFragment = {
  active: boolean;
  id: number;
  name: string;
  target_definitions: Array<{
    id: number;
    target_definition_type: target_definition_type_enum;
    value: number;
    year: number;
  }>;
};

export type GetAllCustomTargetsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllCustomTargetsQuery = {
  getAllCustomTargets: Array<{
    active: boolean;
    id: number;
    name: string;
    target_definitions: Array<{
      id: number;
      target_definition_type: target_definition_type_enum;
      value: number;
      year: number;
    }>;
  }>;
};

export type GetActiveCustomTargetQueryVariables = Exact<{ [key: string]: never }>;

export type GetActiveCustomTargetQuery = {
  getActiveCustomTarget?: {
    active: boolean;
    id: number;
    name: string;
    target_definitions: Array<{
      id: number;
      target_definition_type: target_definition_type_enum;
      value: number;
      year: number;
    }>;
  } | null;
};

export type GetAllCustomFieldsQueryVariables = Exact<{
  entityType: custom_field_entity_enum;
}>;

export type GetAllCustomFieldsQuery = {
  custom_field: Array<{
    id: number;
    key: string;
    name: string;
    type_id: custom_field_type_enum;
    entity_type: custom_field_entity_enum;
    suffix?: string | null;
    show_in_analysis: boolean;
  }>;
};

export type GetPortfolioAndBuildingTableEntriesPermissionsQueryVariables = Exact<{
  user_id: Scalars['Int']['input'];
}>;

export type GetPortfolioAndBuildingTableEntriesPermissionsQuery = {
  user_portfolio_permission: Array<{ portfolio_id: number; read: boolean; write: boolean; id: number }>;
  user_building_permission: Array<{ building_id: number; read: boolean; write: boolean; id: number }>;
};

export type PortfolioManagementCreatePortfolioMutationVariables = Exact<{
  name: Scalars['String']['input'];
  baseEmissionFactorType?: InputMaybe<emission_factor_type_enum>;
  configId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type PortfolioManagementCreatePortfolioMutation = { createPortfolio: number };

export type PortfolioManagementDeletePortfolioMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type PortfolioManagementDeletePortfolioMutation = {
  delete_portfolio_by_pk?: { __typename: 'portfolio'; id: number } | null;
};

export type PortfolioManagementUpdatePortfolioMutationVariables = Exact<{
  name: Scalars['String']['input'];
  settings?: InputMaybe<UpdatePortfolioSettingsType>;
  id: Scalars['Int']['input'];
}>;

export type PortfolioManagementUpdatePortfolioMutation = { updatePortfolio: boolean };

export type PortfolioManagementPortfolioFragment = {
  __typename: 'portfolio';
  id: number;
  has_write_permission: boolean;
  name: string;
  created_at?: string | null;
  updated_at?: string | null;
  economic_units_with_buildings: Array<{ buildings: Array<{ id: number }> }>;
};

export type PortfolioManagementGetAllPortfoliosQueryVariables = Exact<{ [key: string]: never }>;

export type PortfolioManagementGetAllPortfoliosQuery = {
  portfolio: Array<{
    __typename: 'portfolio';
    id: number;
    has_write_permission: boolean;
    name: string;
    created_at?: string | null;
    updated_at?: string | null;
    economic_units_with_buildings: Array<{ buildings: Array<{ id: number }> }>;
  }>;
};

export type PortfolioManagementGetAllPortfoliosWithWritePermissionsQueryVariables = Exact<{
  user_id: Scalars['Int']['input'];
}>;

export type PortfolioManagementGetAllPortfoliosWithWritePermissionsQuery = {
  portfolio: Array<{
    __typename: 'portfolio';
    id: number;
    has_write_permission: boolean;
    name: string;
    created_at?: string | null;
    updated_at?: string | null;
    economic_units_with_buildings: Array<{ buildings: Array<{ id: number }> }>;
  }>;
};

export type PortfolioObjectsAggregateQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
}>;

export type PortfolioObjectsAggregateQuery = {
  building_aggregate: { aggregate?: { count: number } | null };
  report_aggregate: { aggregate?: { count: number } | null };
  scenario_aggregate: { aggregate?: { count: number } | null };
  building_draft_aggregate: { aggregate?: { count: number } | null };
  economic_unit_aggregate: { aggregate?: { count: number } | null };
  active_action_plans_aggregate: { aggregate?: { count: number } | null };
  action_aggregate: { aggregate?: { count: number } | null };
  consumption_aggregate: { aggregate?: { count: number } | null };
  consumption_draft_aggregate: { aggregate?: { count: number } | null };
};

export type GetPortfoliosAndEconomicUnitsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPortfoliosAndEconomicUnitsQuery = {
  portfolio: Array<{
    id: number;
    has_write_permission: boolean;
    name: string;
    economic_units: Array<{ id: number; name: string; responsible_user_id?: number | null }>;
  }>;
};

export type ReportDeleteReportMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type ReportDeleteReportMutation = { delete_report_by_pk?: { __typename: 'report'; id: number } | null };

export type CreateReportMutationVariables = Exact<{
  buildings: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  due_date: Scalars['DateTime']['input'];
  end_date: Scalars['DateTime']['input'];
  report_template_id: Scalars['Int']['input'];
  responsible_user_id?: InputMaybe<Scalars['Int']['input']>;
  start_date: Scalars['DateTime']['input'];
}>;

export type CreateReportMutation = { createReport: { report_id: number } };

export type ResetReportAnswerMutationVariables = Exact<{
  reportId: Scalars['Int']['input'];
  buildingId?: InputMaybe<Scalars['Int']['input']>;
  rootQuestionId: Scalars['Int']['input'];
}>;

export type ResetReportAnswerMutation = { resetAnswers: { id: number } };

export type completeReportMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type completeReportMutation = {
  update_report_by_pk?: { __typename: 'report'; id: number; completed: boolean } | null;
};

export type AcceptAutofillReportMutationVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type AcceptAutofillReportMutation = { acceptAutofillReport: { report_question_ids: Array<{ id: number }> } };

export type AnswerQuestionsMutationVariables = Exact<{
  answers: Array<AnswerParamsInput> | AnswerParamsInput;
  report_id: Scalars['Int']['input'];
  building_id?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AnswerQuestionsMutation = {
  answerQuestions: {
    report_answer_ids: Array<{ ReportAnswerId?: { __typename: 'report_answer'; id: number } | null }>;
  };
};

export type createEvidenceFromFileMutationVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type createEvidenceFromFileMutation = {
  createEvidenceFromFile: {
    upload_url: string;
    CreateEvidenceOutput: Array<{ __typename: 'report_evidence'; id: number; file?: { id: number } | null }>;
  };
};

export type createEvidenceMutationVariables = Exact<{
  reportId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
}>;

export type createEvidenceMutation = {
  insert_report_evidence_one?: { __typename: 'report_evidence'; id: number; url?: string | null } | null;
};

export type deleteEvidenceMutationVariables = Exact<{
  evidenceId: Scalars['Int']['input'];
}>;

export type deleteEvidenceMutation = {
  delete_report_evidence_by_pk?: { __typename: 'report_evidence'; id: number } | null;
};

export type ExportReportAsPdfAsyncMutationVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type ExportReportAsPdfAsyncMutation = { exportReportAsPdfAsync: { asyncJobId: number } };

export type ExportReportAsExcelMutationVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type ExportReportAsExcelMutation = { exportReportAsExcel: { body: string } };

export type ReportGetReportByPkReportTemplateSectionsFragment = {
  __typename: 'report_template_section';
  id: number;
  name: string;
  order: number;
  parent_section_id?: number | null;
  target?: report_template_section_target_enum | null;
};

export type ReportGetReportByPkReportTemplateFragment = {
  single_building: boolean;
  title: string;
  excel_template_path_de?: string | null;
  excel_template_path_en?: string | null;
  report_sections: Array<{
    __typename: 'report_template_section';
    id: number;
    name: string;
    order: number;
    parent_section_id?: number | null;
    target?: report_template_section_target_enum | null;
  }>;
};

export type ReportGetReportByPkResponsibleUserFragment = {
  __typename: 'user';
  id: number;
  last_name?: string | null;
  first_name?: string | null;
};

export type ReportGetReportByPkFragment = {
  __typename: 'report';
  id: number;
  end_date: string;
  start_date: string;
  due_date: string;
  created_at: string;
  completed: boolean;
  report_template: {
    single_building: boolean;
    title: string;
    excel_template_path_de?: string | null;
    excel_template_path_en?: string | null;
    report_sections: Array<{
      __typename: 'report_template_section';
      id: number;
      name: string;
      order: number;
      parent_section_id?: number | null;
      target?: report_template_section_target_enum | null;
    }>;
  };
  responsible_user?: { __typename: 'user'; id: number; last_name?: string | null; first_name?: string | null } | null;
  report_building_details: Array<{
    building_id?: number | null;
    street?: string | null;
    portfolio_id?: number | null;
    portfolio_name?: string | null;
  }>;
  report_building_details_aggregate: { aggregate?: { count: number } | null };
  report_answers: Array<{
    __typename: 'report_answer';
    id: number;
    report_template_question: { evidence_required?: boolean | null };
  }>;
};

export type ReportSectionGetRootQuestionsAndAnswersAnswersFragment = {
  __typename: 'report_answer';
  id: number;
  report_question_id: number;
  value?: string | null;
  state: report_answer_state_enum;
  autofill?: string | null;
  report_template_question: {
    __typename: 'report_template_question';
    id: number;
    question: string;
    description?: string | null;
    type: report_template_question_type_enum;
    evidence_required?: boolean | null;
  };
  report_answer_autofill_options: Array<{
    report_template_question_option: { __typename: 'report_template_question_option'; id: number; value: string };
  }>;
  report_answer_chosen_options: Array<{
    updated_at: string;
    report_template_question_option: { id: number; value: string };
  }>;
};

export type CreateReportModalGetAllTemplatesTemplateFragment = {
  __typename: 'ReportTemplateOutput';
  id: number;
  description: string;
  description_en?: string | null;
  org_id?: number | null;
  title: string;
  single_building: boolean;
  version: string;
};

export type ReportGetReportQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type ReportGetReportQuery = {
  report_by_pk?: {
    __typename: 'report';
    id: number;
    end_date: string;
    start_date: string;
    due_date: string;
    created_at: string;
    completed: boolean;
    report_template: {
      single_building: boolean;
      title: string;
      excel_template_path_de?: string | null;
      excel_template_path_en?: string | null;
      report_sections: Array<{
        __typename: 'report_template_section';
        id: number;
        name: string;
        order: number;
        parent_section_id?: number | null;
        target?: report_template_section_target_enum | null;
      }>;
    };
    responsible_user?: { __typename: 'user'; id: number; last_name?: string | null; first_name?: string | null } | null;
    report_building_details: Array<{
      building_id?: number | null;
      street?: string | null;
      portfolio_id?: number | null;
      portfolio_name?: string | null;
    }>;
    report_building_details_aggregate: { aggregate?: { count: number } | null };
    report_answers: Array<{
      __typename: 'report_answer';
      id: number;
      report_template_question: { evidence_required?: boolean | null };
    }>;
  } | null;
};

export type ReportingReportsQueryVariables = Exact<{ [key: string]: never }>;

export type ReportingReportsQuery = {
  report_overview: Array<{
    report_id?: number | null;
    report_template_id?: number | null;
    report_template_title?: string | null;
    report_template_excel_path_de?: string | null;
    report_template_excel_path_en?: string | null;
    responsible_user_id?: number | null;
    responsible_user_first_name?: string | null;
    responsible_user_last_name?: string | null;
    progress?: number | null;
    completed?: boolean | null;
    created_at?: string | null;
    portfolio_id?: number | null;
    portfolio_name?: string | null;
    streets?: Array<string> | null;
  }>;
};

export type CreateReportGetAllTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type CreateReportGetAllTemplatesQuery = {
  report_template: Array<{
    __typename: 'ReportTemplateOutput';
    id: number;
    description: string;
    description_en?: string | null;
    org_id?: number | null;
    title: string;
    single_building: boolean;
    version: string;
  } | null>;
};

export type CreateReportModalAllUsersQueryVariables = Exact<{ [key: string]: never }>;

export type CreateReportModalAllUsersQuery = {
  user: Array<{ __typename: 'user'; id: number; last_name?: string | null; first_name?: string | null }>;
};

export type CreateReportModalBuildingsInPortfolioQueryVariables = Exact<{
  where: building_bool_exp;
}>;

export type CreateReportModalBuildingsInPortfolioQuery = {
  building: Array<{
    __typename: 'building';
    id: number;
    address: { street: string; city: string; postal_code: string };
    areas: Array<{
      id: number;
      area_type_id: area_type_enum;
      class_of_use_id: class_of_use_enum;
      type_of_use_id: type_of_use_enum;
    }>;
  }>;
};

export type ReportAnswerForAutofillFragment = {
  building_id?: number | null;
  autofill?: string | null;
  report_question_id: number;
  report_answer_autofill_options: Array<{ report_template_question_option: { id: number } }>;
};

export type AllReportAutofillQuestionsQueryVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type AllReportAutofillQuestionsQuery = {
  report_by_pk?: {
    report_answers: Array<{
      building_id?: number | null;
      autofill?: string | null;
      report_question_id: number;
      report_answer_autofill_options: Array<{ report_template_question_option: { id: number } }>;
    }>;
  } | null;
};

export type GetReportCompletionQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetReportCompletionQuery = {
  report_by_pk?: { __typename: 'report'; id: number; progress: number; completed: boolean } | null;
};

export type ReportAnswersStateFragment = {
  id: number;
  building_id?: number | null;
  state: report_answer_state_enum;
  report_template_question: { report_template_section?: { id: number } | null };
};

export type GetSectionsAnswerCountQueryVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type GetSectionsAnswerCountQuery = {
  report_answer: Array<{
    id: number;
    building_id?: number | null;
    state: report_answer_state_enum;
    report_template_question: { report_template_section?: { id: number } | null };
  }>;
};

export type ReportSectionsProgressFragment = {
  id: number;
  report_template_section_id: number;
  building_id?: number | null;
  progress: number;
};

export type GetSectionsProgressQueryVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type GetSectionsProgressQuery = {
  report_section_progress: Array<{
    id: number;
    report_template_section_id: number;
    building_id?: number | null;
    progress: number;
  }>;
};

export type ReportQuestionGetOptionsWithSubquestionsQueryVariables = Exact<{
  questionId: Scalars['Int']['input'];
}>;

export type ReportQuestionGetOptionsWithSubquestionsQuery = {
  report_template_question_by_pk?: {
    id: number;
    report_template_question_options: Array<{
      __typename: 'report_template_question_option';
      id: number;
      order: number;
      value: string;
      report_template_child_questions: Array<{
        __typename: 'report_template_question';
        id: number;
        type: report_template_question_type_enum;
        question: string;
        order: number;
        parent_option_id?: number | null;
      }>;
    }>;
  } | null;
};

export type SubsectionProgressFragment = {
  __typename: 'report_section_progress';
  progress: number;
  report_template_section: { id: number; target?: report_template_section_target_enum | null };
};

export type SubsectionsProgressQueryVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type SubsectionsProgressQuery = {
  report_by_pk?: {
    __typename: 'report';
    id: number;
    report_building_details: Array<{
      __typename: 'report_building_details';
      building_id?: number | null;
      street?: string | null;
      report_sections_progress: Array<{
        __typename: 'report_section_progress';
        progress: number;
        report_template_section: { id: number; target?: report_template_section_target_enum | null };
      }>;
    }>;
    report_sections_progress: Array<{
      __typename: 'report_section_progress';
      progress: number;
      report_template_section: { id: number; target?: report_template_section_target_enum | null };
    }>;
  } | null;
};

export type ReportSectionGetRootQuestionsAndAnswersQueryVariables = Exact<{
  sectionId: Scalars['Int']['input'];
  reportId: Scalars['Int']['input'];
  buildingWhere?: InputMaybe<Int_comparison_exp>;
}>;

export type ReportSectionGetRootQuestionsAndAnswersQuery = {
  report_by_pk?: {
    report_answers: Array<{
      __typename: 'report_answer';
      id: number;
      report_question_id: number;
      value?: string | null;
      state: report_answer_state_enum;
      autofill?: string | null;
      report_template_question: {
        __typename: 'report_template_question';
        id: number;
        question: string;
        description?: string | null;
        type: report_template_question_type_enum;
        evidence_required?: boolean | null;
      };
      report_answer_autofill_options: Array<{
        report_template_question_option: { __typename: 'report_template_question_option'; id: number; value: string };
      }>;
      report_answer_chosen_options: Array<{
        updated_at: string;
        report_template_question_option: { id: number; value: string };
      }>;
    }>;
  } | null;
};

export type ReportSectionGetRootQuestionAndAnswerQueryVariables = Exact<{
  questionId: Scalars['Int']['input'];
  reportId: Scalars['Int']['input'];
}>;

export type ReportSectionGetRootQuestionAndAnswerQuery = {
  report_template_question_by_pk?: {
    report_answers: Array<{
      __typename: 'report_answer';
      id: number;
      report_question_id: number;
      value?: string | null;
      state: report_answer_state_enum;
      autofill?: string | null;
      report_template_question: {
        __typename: 'report_template_question';
        id: number;
        question: string;
        description?: string | null;
        type: report_template_question_type_enum;
        evidence_required?: boolean | null;
      };
      report_answer_autofill_options: Array<{
        report_template_question_option: { __typename: 'report_template_question_option'; id: number; value: string };
      }>;
      report_answer_chosen_options: Array<{
        updated_at: string;
        report_template_question_option: { id: number; value: string };
      }>;
    }>;
  } | null;
};

export type GET_NESTED_QUESTION_ANSWERQueryVariables = Exact<{
  reportId: Scalars['Int']['input'];
  questionId: Scalars['Int']['input'];
}>;

export type GET_NESTED_QUESTION_ANSWERQuery = {
  report_by_pk?: {
    report_answers: Array<{
      __typename: 'report_answer';
      id: number;
      report_question_id: number;
      value?: string | null;
      state: report_answer_state_enum;
      autofill?: string | null;
      report_template_question: {
        __typename: 'report_template_question';
        id: number;
        question: string;
        description?: string | null;
        type: report_template_question_type_enum;
        evidence_required?: boolean | null;
      };
      report_answer_autofill_options: Array<{
        report_template_question_option: { __typename: 'report_template_question_option'; id: number; value: string };
      }>;
      report_answer_chosen_options: Array<{
        updated_at: string;
        report_template_question_option: { id: number; value: string };
      }>;
    }>;
  } | null;
};

export type ReportHeadGetReportScoresSubscriptionVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type ReportHeadGetReportScoresSubscription = {
  report_by_pk?: {
    report_template: {
      report_template_scores: Array<{
        __typename: 'report_template_score';
        id: number;
        name: string;
        display_type: report_template_score_display_type_enum;
        max_score?: number | null;
        report_scores: Array<{ value: number; max_score?: number | null }>;
      }>;
    };
  } | null;
};

export type ReportScoreAsyncJobSubscriptionVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type ReportScoreAsyncJobSubscription = { async_job_aggregate: { aggregate?: { count: number } | null } };

export type ReportHeadGetReportProgressQueryVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type ReportHeadGetReportProgressQuery = {
  report_by_pk?: {
    __typename: 'report';
    id: number;
    progress: number;
    report_sections_progress: Array<{ progress: number; report_template_section: { id: number; name: string } }>;
  } | null;
};

export type GET_ALL_EVIDENCESQueryVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type GET_ALL_EVIDENCESQuery = {
  report_evidence: Array<{
    __typename: 'report_evidence';
    id: number;
    url?: string | null;
    file?: { __typename: 'file'; id: number; name?: string | null; downloadUrl: string } | null;
  }>;
};

export type GET_QUESTION_EVIDENCESQueryVariables = Exact<{
  reportId: Scalars['Int']['input'];
  questionId: Scalars['Int']['input'];
}>;

export type GET_QUESTION_EVIDENCESQuery = {
  report_question_evidence: Array<{
    __typename: 'report_question_evidence';
    id: number;
    description?: string | null;
    report_evidence: {
      __typename: 'report_evidence';
      id: number;
      url?: string | null;
      file?: { id: number; name?: string | null; downloadUrl: string } | null;
    };
  }>;
};

export type GET_All_EVIDENCESQueryVariables = Exact<{
  reportId: Scalars['Int']['input'];
}>;

export type GET_All_EVIDENCESQuery = {
  report_evidence: Array<{
    __typename: 'report_evidence';
    id: number;
    url?: string | null;
    file?: { id: number; name?: string | null; downloadUrl: string } | null;
    report_question_evidences: Array<{ id: number; report_template_question: { id: number; question: string } }>;
  }>;
};

export type UpdateSandboxFeatureFlagMutationVariables = Exact<{
  flag: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
}>;

export type UpdateSandboxFeatureFlagMutation = { updateSandboxFeatureFlag: boolean };

export type ResetSandboxFeatureFlagsMutationVariables = Exact<{ [key: string]: never }>;

export type ResetSandboxFeatureFlagsMutation = { resetSandboxFeatureFlags: boolean };

export type GetDefaultFeatureFlagValuesQueryVariables = Exact<{ [key: string]: never }>;

export type GetDefaultFeatureFlagValuesQuery = { featureFlagDefaultValues: Array<string> };

export type StatusQuoAnalysisPortfolioFragment = { id: number; name: string };

export type SearchBuildingFragment = {
  id: number;
  customer_external_identifier?: string | null;
  is_new_construction: boolean;
  is_missing_energy_data?: boolean | null;
  address: { street: string; city: string; postal_code: string };
  folder?: { id: number } | null;
};

export type BuildingsBenchmarkCrremFragment = {
  analysisType: emission_factor_type_enum;
  averageFinalEnergy: number;
  averagePrimaryEnergy: number;
  averageHeatingDemand?: number | null;
  averageCo2Costs: number;
  averageEnergyCosts: number;
  crremAnalysis: { averageCo2Emissions: number; strandingYear?: number | null; yearOfExcedance?: number | null };
};

export type BuildingsBenchmarkNationalEnergyLawFragment = {
  analysisType: emission_factor_type_enum;
  averageFinalEnergy: number;
  averagePrimaryEnergy: number;
  averageHeatingDemand?: number | null;
  averageCo2Costs: number;
  averageEnergyCosts: number;
  nationalEnergyLawAnalysis: { averageCo2Emissions: number };
};

export type StatusQuoAnalysisBuildingBasicDetailsFragment = {
  id: number;
  year_constructed: number;
  is_new_construction: boolean;
  is_missing_energy_data?: boolean | null;
  description: string;
  custom_data: any;
  address: {
    street: string;
    postal_code: string;
    city: string;
    country_id: country_enum;
    mapbox_building_ids: Array<string>;
    building_citydb_gml_ids?: Array<string> | null;
    building_lod1_ids?: Array<string> | null;
  };
  economic_unit: { id: number; name: string; portfolio: { id: number; name: string } };
  responsible_user: { first_name?: string | null; last_name?: string | null };
  areas: Array<{
    id: number;
    value: number;
    area_type_id: area_type_enum;
    type_of_use_id: type_of_use_enum;
    class_of_use_id: class_of_use_enum;
  }>;
  building_valuations: Array<{ id: number; value: number; valuation_at: string }>;
};

export type AnalyzeBuildingsCrremAnalysisFragment = {
  averageCo2Emissions: number;
  co2TargetPath: Array<number>;
  energyTargetPath: Array<number>;
  strandingYear?: number | null;
  yearOfExcedance?: number | null;
  cumulativeExcessEmissions: number;
  excessEmissionCostPath: Array<number>;
  co2Path: { m2: Array<number> };
  energyPath: { m2: Array<number> };
  scope123Co2Emissions: {
    wholeBuilding?: {
      scope1: { co2Emissions: number; co2EmissionsTotal: number };
      scope2: { co2Emissions: number; co2EmissionsTotal: number };
      scope3: { co2Emissions: number; co2EmissionsTotal: number };
    } | null;
    landlord?: {
      scope1: { co2Emissions: number; co2EmissionsTotal: number };
      scope2: { co2Emissions: number; co2EmissionsTotal: number };
      scope3: { co2Emissions: number; co2EmissionsTotal: number };
    } | null;
    tenant?: {
      scope1: { co2Emissions: number; co2EmissionsTotal: number };
      scope2: { co2Emissions: number; co2EmissionsTotal: number };
      scope3: { co2Emissions: number; co2EmissionsTotal: number };
    } | null;
  };
  strandingData: Array<{ year: number; count: number }>;
};

export type AnalyzeBuildingsNationalEnergyLawAnalysisFragment = {
  averageCo2Emissions: number;
  co2Path: { m2: Array<number> };
  energyPath: { m2: Array<number> };
};

export type CustomTargetsFragment = {
  name: string;
  final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
  primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
  co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
};

export type AnalyzeBuildingCrremFragment = {
  analysisType: emission_factor_type_enum;
  taxBracket: tax_bracket_enum;
  efficiencyClass: efficiency_class_enum;
  euTaxonomyCompliance: eu_taxonomy_compliance_enum;
  finalEnergy: number;
  primaryEnergy: number;
  heatingDemand?: number | null;
  co2CostPath: { total: Array<number>; m2: Array<number> };
  co2CostDistributionPath: {
    landlordPath: { total: Array<number>; m2: Array<number> };
    tenantPath: { total: Array<number>; m2: Array<number> };
  };
  energyCostPath: { total: Array<number>; m2: Array<number> };
  energyConsumers: Array<{
    energySourceType: energy_source_type_enum;
    energyConsumptionM2: number;
    energyConsumptionTotal: number;
  }>;
  climateRisks: Array<{ timespan?: string | null; type: climate_risk_type_enum; value: number }>;
  floorAreaByClassOfUse: Array<{ classOfUse: class_of_use_enum; area: number }>;
  crremAnalysis: {
    co2Emissions: number;
    co2TargetPath: Array<number>;
    energyTargetPath: Array<number>;
    strandingYear?: number | null;
    yearOfExcedance?: number | null;
    cumulativeExcessEmissions: number;
    excessEmissionCostPath: Array<number>;
    co2Path: { m2: Array<number> };
    energyPath: { m2: Array<number> };
    buildingModelTransitions: Array<{ validFrom: DateTime; co2Intensity: number; energyIntensity: number }>;
    scope123Co2Emissions: {
      wholeBuilding?: {
        scope1: { co2Emissions: number; co2EmissionsTotal: number };
        scope2: { co2Emissions: number; co2EmissionsTotal: number };
        scope3: { co2Emissions: number; co2EmissionsTotal: number };
      } | null;
      landlord?: {
        scope1: { co2Emissions: number; co2EmissionsTotal: number };
        scope2: { co2Emissions: number; co2EmissionsTotal: number };
        scope3: { co2Emissions: number; co2EmissionsTotal: number };
      } | null;
      tenant?: {
        scope1: { co2Emissions: number; co2EmissionsTotal: number };
        scope2: { co2Emissions: number; co2EmissionsTotal: number };
        scope3: { co2Emissions: number; co2EmissionsTotal: number };
      } | null;
    };
  };
  customTargets?: {
    name: string;
    final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
  } | null;
  slfAnalysis: {
    ongoingReportId?: string | null;
    lastSlfReport?: { reportId: string; value: number; issuedAt: DateTime } | null;
    compliantFactors: Array<
      | {
          certificateType: certificate_type_enum;
          level?: certificate_level_type_enum | null;
          score?: number | null;
          type: slf_compliance_factor_enum;
        }
      | { efficiencyClass: efficiency_class_enum; type: slf_compliance_factor_enum }
      | { euTaxonomyCompliance: eu_taxonomy_compliance_enum; type: slf_compliance_factor_enum }
      | { reportId: string; type: slf_compliance_factor_enum; issuedAt: DateTime }
    >;
    notCompliantFactors: Array<{
      level?: certificate_level_type_enum | null;
      score?: number | null;
      certificateType: certificate_type_enum;
    }>;
  };
  customTargetPath?: { co2?: { targetPath: Array<number>; intersectionYear: number } | null } | null;
};

export type AnalyzeBuildingNationalEnergyLawFragment = {
  analysisType: emission_factor_type_enum;
  taxBracket: tax_bracket_enum;
  efficiencyClass: efficiency_class_enum;
  euTaxonomyCompliance: eu_taxonomy_compliance_enum;
  finalEnergy: number;
  primaryEnergy: number;
  heatingDemand?: number | null;
  co2CostPath: { total: Array<number>; m2: Array<number> };
  co2CostDistributionPath: {
    landlordPath: { total: Array<number>; m2: Array<number> };
    tenantPath: { total: Array<number>; m2: Array<number> };
  };
  energyCostPath: { total: Array<number>; m2: Array<number> };
  energyConsumers: Array<{
    energySourceType: energy_source_type_enum;
    energyConsumptionM2: number;
    energyConsumptionTotal: number;
  }>;
  climateRisks: Array<{ timespan?: string | null; type: climate_risk_type_enum; value: number }>;
  floorAreaByClassOfUse: Array<{ classOfUse: class_of_use_enum; area: number }>;
  nationalEnergyLawAnalysis: {
    co2Emissions: number;
    co2Path: { m2: Array<number>; total: Array<number> };
    energyPath: { m2: Array<number>; total: Array<number> };
    buildingModelTransitions: Array<{ validFrom: DateTime; co2Intensity: number; energyIntensity: number }>;
  };
  customTargets?: {
    name: string;
    final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
  } | null;
  slfAnalysis: {
    ongoingReportId?: string | null;
    lastSlfReport?: { reportId: string; value: number; issuedAt: DateTime } | null;
    compliantFactors: Array<
      | {
          certificateType: certificate_type_enum;
          level?: certificate_level_type_enum | null;
          score?: number | null;
          type: slf_compliance_factor_enum;
        }
      | { efficiencyClass: efficiency_class_enum; type: slf_compliance_factor_enum }
      | { euTaxonomyCompliance: eu_taxonomy_compliance_enum; type: slf_compliance_factor_enum }
      | { reportId: string; type: slf_compliance_factor_enum; issuedAt: DateTime }
    >;
    notCompliantFactors: Array<{
      level?: certificate_level_type_enum | null;
      score?: number | null;
      certificateType: certificate_type_enum;
    }>;
  };
};

export type BuildingCRREMConsumptionAnalysisOutputFragment = {
  co2TargetPath: Array<number>;
  energyTargetPath: Array<number>;
  strandingYear?: number | null;
  yearOfExcedance?: number | null;
  cumulativeExcessEmissions: number;
  excessEmissionCostPath: Array<number>;
  co2Path: { m2: Array<number> };
  energyPath: { m2: Array<number> };
};

export type StrandingDataFragment = { year: number; count: number };

export type BuildingModelTransitionFragment = { validFrom: DateTime; co2Intensity: number; energyIntensity: number };

export type Scope123Co2EmissionsFragment = {
  scope1: { co2Emissions: number; co2EmissionsTotal: number };
  scope2: { co2Emissions: number; co2EmissionsTotal: number };
  scope3: { co2Emissions: number; co2EmissionsTotal: number };
};

export type BuildingDetailsFragment = {
  id: number;
  street: string;
  postal_code: string;
  city: string;
  country: country_enum;
  types_of_use: Array<type_of_use_enum>;
  first_stranding_year?: number | null;
  is_new_construction: boolean;
  building: { id: number; description: string };
  energy_data?: {
    co2_emissions: number;
    co2_emissions_total: number;
    co2_costs: number;
    co2_costs_total: number;
    energy_primary: number;
    energy_primary_total: number;
    energy_final: number;
    energy_final_total: number;
    efficiency_class: efficiency_class_enum;
    eu_taxonomy_compliance: eu_taxonomy_compliance_enum;
    slf_compliant?: {
      quick_check: boolean;
      full_check?: { report_id: string; value: number; issued_at: DateTime } | null;
    } | null;
  } | null;
};

type AnalyzedBuilding_AnalyzeBuildingCrremOutput_Fragment = {
  analysisType: emission_factor_type_enum;
  taxBracket: tax_bracket_enum;
  efficiencyClass: efficiency_class_enum;
  euTaxonomyCompliance: eu_taxonomy_compliance_enum;
  finalEnergy: number;
  primaryEnergy: number;
  heatingDemand?: number | null;
  co2CostPath: { total: Array<number>; m2: Array<number> };
  co2CostDistributionPath: {
    landlordPath: { total: Array<number>; m2: Array<number> };
    tenantPath: { total: Array<number>; m2: Array<number> };
  };
  energyCostPath: { total: Array<number>; m2: Array<number> };
  energyConsumers: Array<{
    energySourceType: energy_source_type_enum;
    energyConsumptionM2: number;
    energyConsumptionTotal: number;
  }>;
  climateRisks: Array<{ timespan?: string | null; type: climate_risk_type_enum; value: number }>;
  floorAreaByClassOfUse: Array<{ classOfUse: class_of_use_enum; area: number }>;
  crremAnalysis: {
    co2Emissions: number;
    co2TargetPath: Array<number>;
    energyTargetPath: Array<number>;
    strandingYear?: number | null;
    yearOfExcedance?: number | null;
    cumulativeExcessEmissions: number;
    excessEmissionCostPath: Array<number>;
    co2Path: { m2: Array<number> };
    energyPath: { m2: Array<number> };
    buildingModelTransitions: Array<{ validFrom: DateTime; co2Intensity: number; energyIntensity: number }>;
    scope123Co2Emissions: {
      wholeBuilding?: {
        scope1: { co2Emissions: number; co2EmissionsTotal: number };
        scope2: { co2Emissions: number; co2EmissionsTotal: number };
        scope3: { co2Emissions: number; co2EmissionsTotal: number };
      } | null;
      landlord?: {
        scope1: { co2Emissions: number; co2EmissionsTotal: number };
        scope2: { co2Emissions: number; co2EmissionsTotal: number };
        scope3: { co2Emissions: number; co2EmissionsTotal: number };
      } | null;
      tenant?: {
        scope1: { co2Emissions: number; co2EmissionsTotal: number };
        scope2: { co2Emissions: number; co2EmissionsTotal: number };
        scope3: { co2Emissions: number; co2EmissionsTotal: number };
      } | null;
    };
  };
  customTargets?: {
    name: string;
    final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
  } | null;
  slfAnalysis: {
    ongoingReportId?: string | null;
    lastSlfReport?: { reportId: string; value: number; issuedAt: DateTime } | null;
    compliantFactors: Array<
      | {
          certificateType: certificate_type_enum;
          level?: certificate_level_type_enum | null;
          score?: number | null;
          type: slf_compliance_factor_enum;
        }
      | { efficiencyClass: efficiency_class_enum; type: slf_compliance_factor_enum }
      | { euTaxonomyCompliance: eu_taxonomy_compliance_enum; type: slf_compliance_factor_enum }
      | { reportId: string; type: slf_compliance_factor_enum; issuedAt: DateTime }
    >;
    notCompliantFactors: Array<{
      level?: certificate_level_type_enum | null;
      score?: number | null;
      certificateType: certificate_type_enum;
    }>;
  };
  customTargetPath?: { co2?: { targetPath: Array<number>; intersectionYear: number } | null } | null;
};

type AnalyzedBuilding_AnalyzeBuildingNationalEnergyLawOutput_Fragment = {
  analysisType: emission_factor_type_enum;
  taxBracket: tax_bracket_enum;
  efficiencyClass: efficiency_class_enum;
  euTaxonomyCompliance: eu_taxonomy_compliance_enum;
  finalEnergy: number;
  primaryEnergy: number;
  heatingDemand?: number | null;
  co2CostPath: { total: Array<number>; m2: Array<number> };
  co2CostDistributionPath: {
    landlordPath: { total: Array<number>; m2: Array<number> };
    tenantPath: { total: Array<number>; m2: Array<number> };
  };
  energyCostPath: { total: Array<number>; m2: Array<number> };
  energyConsumers: Array<{
    energySourceType: energy_source_type_enum;
    energyConsumptionM2: number;
    energyConsumptionTotal: number;
  }>;
  climateRisks: Array<{ timespan?: string | null; type: climate_risk_type_enum; value: number }>;
  floorAreaByClassOfUse: Array<{ classOfUse: class_of_use_enum; area: number }>;
  nationalEnergyLawAnalysis: {
    co2Emissions: number;
    co2Path: { m2: Array<number>; total: Array<number> };
    energyPath: { m2: Array<number>; total: Array<number> };
    buildingModelTransitions: Array<{ validFrom: DateTime; co2Intensity: number; energyIntensity: number }>;
  };
  customTargets?: {
    name: string;
    final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
  } | null;
  slfAnalysis: {
    ongoingReportId?: string | null;
    lastSlfReport?: { reportId: string; value: number; issuedAt: DateTime } | null;
    compliantFactors: Array<
      | {
          certificateType: certificate_type_enum;
          level?: certificate_level_type_enum | null;
          score?: number | null;
          type: slf_compliance_factor_enum;
        }
      | { efficiencyClass: efficiency_class_enum; type: slf_compliance_factor_enum }
      | { euTaxonomyCompliance: eu_taxonomy_compliance_enum; type: slf_compliance_factor_enum }
      | { reportId: string; type: slf_compliance_factor_enum; issuedAt: DateTime }
    >;
    notCompliantFactors: Array<{
      level?: certificate_level_type_enum | null;
      score?: number | null;
      certificateType: certificate_type_enum;
    }>;
  };
};

export type AnalyzedBuildingFragment =
  | AnalyzedBuilding_AnalyzeBuildingCrremOutput_Fragment
  | AnalyzedBuilding_AnalyzeBuildingNationalEnergyLawOutput_Fragment;

type AnalyzedBuildingsBenchMark_BuildingsBenchmarkCrremOutput_Fragment = {
  analysisType: emission_factor_type_enum;
  averageFinalEnergy: number;
  averagePrimaryEnergy: number;
  averageHeatingDemand?: number | null;
  averageCo2Costs: number;
  averageEnergyCosts: number;
  crremAnalysis: { averageCo2Emissions: number; strandingYear?: number | null; yearOfExcedance?: number | null };
};

type AnalyzedBuildingsBenchMark_BuildingsBenchmarkNationalEnergyLawOutput_Fragment = {
  analysisType: emission_factor_type_enum;
  averageFinalEnergy: number;
  averagePrimaryEnergy: number;
  averageHeatingDemand?: number | null;
  averageCo2Costs: number;
  averageEnergyCosts: number;
  nationalEnergyLawAnalysis: { averageCo2Emissions: number };
};

export type AnalyzedBuildingsBenchMarkFragment =
  | AnalyzedBuildingsBenchMark_BuildingsBenchmarkCrremOutput_Fragment
  | AnalyzedBuildingsBenchMark_BuildingsBenchmarkNationalEnergyLawOutput_Fragment;

export type ConsumptionAllocationNationalEnergyLawCarbonEmissionFragment = {
  analysisType: emission_factor_type_enum;
  intensity: number;
  intensityAbsolute: number;
};

export type ConsumptionAllocationCrremCarbonEmissionFragment = {
  analysisType: emission_factor_type_enum;
  intensity: number;
  intensityAbsolute: number;
  scope1: { percentage: number; value: number };
  scope2: { percentage: number; value: number };
  scope3: { percentage: number; value: number };
};

export type SLFAnalysisFragment = {
  ongoingReportId?: string | null;
  lastSlfReport?: { reportId: string; value: number; issuedAt: DateTime } | null;
  compliantFactors: Array<
    | {
        certificateType: certificate_type_enum;
        level?: certificate_level_type_enum | null;
        score?: number | null;
        type: slf_compliance_factor_enum;
      }
    | { efficiencyClass: efficiency_class_enum; type: slf_compliance_factor_enum }
    | { euTaxonomyCompliance: eu_taxonomy_compliance_enum; type: slf_compliance_factor_enum }
    | { reportId: string; type: slf_compliance_factor_enum; issuedAt: DateTime }
  >;
  notCompliantFactors: Array<{
    level?: certificate_level_type_enum | null;
    score?: number | null;
    certificateType: certificate_type_enum;
  }>;
};

export type StatusQuoAnalysisGetFilteredBuildingsQueryVariables = Exact<{
  buildingWhere: building_bool_exp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type StatusQuoAnalysisGetFilteredBuildingsQuery = {
  building: Array<{
    id: number;
    customer_external_identifier?: string | null;
    is_new_construction: boolean;
    is_missing_energy_data?: boolean | null;
    address: { street: string; city: string; postal_code: string };
    folder?: { id: number } | null;
  }>;
  building_aggregate: { aggregate?: { count: number } | null };
};

export type StatusQuoAnalysisGetFilteredBuildingsFromViewQueryVariables = Exact<{
  buildingWhere: BuildingWhere;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BuildingOrderByInput>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetFilteredBuildingsFromViewQuery = {
  getBuildingList: {
    count: number;
    buildings: Array<{
      id: number;
      street: string;
      postal_code: string;
      city: string;
      country: country_enum;
      types_of_use: Array<type_of_use_enum>;
      first_stranding_year?: number | null;
      is_new_construction: boolean;
      building: { id: number; description: string };
      energy_data?: {
        co2_emissions: number;
        co2_emissions_total: number;
        co2_costs: number;
        co2_costs_total: number;
        energy_primary: number;
        energy_primary_total: number;
        energy_final: number;
        energy_final_total: number;
        efficiency_class: efficiency_class_enum;
        eu_taxonomy_compliance: eu_taxonomy_compliance_enum;
        slf_compliant?: {
          quick_check: boolean;
          full_check?: { report_id: string; value: number; issued_at: DateTime } | null;
        } | null;
      } | null;
    }>;
  };
};

export type StatusQuoAnalysisGetBenchmarkQueryVariables = Exact<{
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  classOfUse?: InputMaybe<class_of_use_enum>;
  typeOfUse?: InputMaybe<type_of_use_enum>;
}>;

export type StatusQuoAnalysisGetBenchmarkQuery = {
  getBenchmark:
    | {
        analysisType: emission_factor_type_enum;
        averageFinalEnergy: number;
        averagePrimaryEnergy: number;
        averageHeatingDemand?: number | null;
        averageCo2Costs: number;
        averageEnergyCosts: number;
        crremAnalysis: { averageCo2Emissions: number; strandingYear?: number | null; yearOfExcedance?: number | null };
      }
    | {
        analysisType: emission_factor_type_enum;
        averageFinalEnergy: number;
        averagePrimaryEnergy: number;
        averageHeatingDemand?: number | null;
        averageCo2Costs: number;
        averageEnergyCosts: number;
        nationalEnergyLawAnalysis: { averageCo2Emissions: number };
      };
};

export type StatusQuoAnalysisGetAnalyzedBuildingsCoreQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsCoreQuery = {
  getAnalyzedBuildingsCore: {
    analysisType: emission_factor_type_enum;
    analyzedBuildingsCount: number;
    buildingsWithoutEnergyPaths: number;
    economicUnitsCount: number;
    minConstructionYear?: number | null;
    floorAreaByClassOfUse: Array<{ classOfUse: class_of_use_enum; area: number }>;
  };
};

export type StatusQuoAnalysisGetAnalyzedBuildingsSlfComplianceQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsSlfComplianceQuery = {
  getAnalyzedBuildingsSlfCompliance: {
    slfCompliantBuildingsCount: number;
    slfCompliantEconomicUnitsCount: number;
    slfFullAssessmentBuildingsCount: number;
  };
};

export type StatusQuoAnalysisGetAnalyzedBuildingsGeneralDataQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsGeneralDataQuery = {
  getAnalyzedBuildingsGeneralData: Array<{
    area: number;
    address: string;
    country: country_enum;
    buildingId: number;
    economicUnitId: number;
    co2Intensity: number;
    typeOfUse: Array<type_of_use_enum>;
    finalEnergy: number;
    year: number;
    mainEnergySourceType: energy_source_type_enum;
  }>;
};

export type StatusQuoAnalysisGetAnalyzedBuildingsClimateRisksQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsClimateRisksQuery = {
  getAnalyzedBuildingsClimateRisks: Array<{ type: climate_risk_type_enum; timespan?: string | null; value: number }>;
};

export type StatusQuoAnalysisGetAnalyzedBuildingsKpisQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsKpisQuery = {
  getAnalyzedBuildingsKpis: {
    averageFinalEnergy: number;
    averagePrimaryEnergy: number;
    averageHeatingDemand?: number | null;
    averageCo2Emissions: number;
    co2CostAtYear: number;
  };
};

export type StatusQuoAnalysisGetAnalyzedBuildingsCostPathsQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsCostPathsQuery = {
  getAnalyzedBuildingsCostPaths: {
    energyCostPath: { total: Array<number>; m2: Array<number> };
    co2CostDistributionPath: {
      landlordPath: { total: Array<number>; m2: Array<number> };
      tenantPath: { total: Array<number>; m2: Array<number> };
    };
  };
};

export type StatusQuoAnalysisGetAnalyzedBuildingsByTaxBracketQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsByTaxBracketQuery = {
  getAnalyzedBuildingsByTaxBracket: Array<{ taxBracket: tax_bracket_enum; count: number }>;
};

export type StatusQuoAnalysisGetAnalyzedBuildingsByEfficiencyClassQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsByEfficiencyClassQuery = {
  getAnalyzedBuildingsByEfficiencyClass: Array<{ efficiencyClass: efficiency_class_enum; count: number }>;
};

export type StatusQuoAnalysisGetAnalyzedBuildingsEuTaxonomyQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsEuTaxonomyQuery = {
  getAnalyzedBuildingsEuTaxonomy: Array<{ euTaxonomyCompliance: eu_taxonomy_compliance_enum; count: number }>;
};

export type StatusQuoAnalysisGetAnalyzedBuildingsByEnergySourceTypeQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsByEnergySourceTypeQuery = {
  getAnalyzedBuildingsByEnergySourceType: Array<{ energySourceType: energy_source_type_enum; count: number }>;
};

export type StatusQuoAnalysisGetAnalyzedBuildingsEnergyDataQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsEnergyDataQuery = {
  getAnalyzedBuildingsEnergyData: Array<{
    energySourceType: energy_source_type_enum;
    energyConsumptionTotal: number;
    energyConsumptionM2: number;
  }>;
};

export type AnalyzeBuildingsCrremAnalysisResultFragment = {
  analysisType: emission_factor_type_enum;
  crremAnalysis: {
    averageCo2Emissions: number;
    co2TargetPath: Array<number>;
    energyTargetPath: Array<number>;
    strandingYear?: number | null;
    yearOfExcedance?: number | null;
    cumulativeExcessEmissions: number;
    excessEmissionCostPath: Array<number>;
    co2Path: { m2: Array<number> };
    energyPath: { m2: Array<number> };
    scope123Co2Emissions: {
      wholeBuilding?: {
        scope1: { co2Emissions: number; co2EmissionsTotal: number };
        scope2: { co2Emissions: number; co2EmissionsTotal: number };
        scope3: { co2Emissions: number; co2EmissionsTotal: number };
      } | null;
      landlord?: {
        scope1: { co2Emissions: number; co2EmissionsTotal: number };
        scope2: { co2Emissions: number; co2EmissionsTotal: number };
        scope3: { co2Emissions: number; co2EmissionsTotal: number };
      } | null;
      tenant?: {
        scope1: { co2Emissions: number; co2EmissionsTotal: number };
        scope2: { co2Emissions: number; co2EmissionsTotal: number };
        scope3: { co2Emissions: number; co2EmissionsTotal: number };
      } | null;
    };
    strandingData: Array<{ year: number; count: number }>;
  };
  customTargets?: {
    name: string;
    final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
  } | null;
  customTargetPath?: { co2?: { targetPath: Array<number>; intersectionYear: number } | null } | null;
};

export type AnalyzeBuildingsNationalEnergyLawAnalysisResultFragment = {
  analysisType: emission_factor_type_enum;
  nationalEnergyLawAnalysis: {
    averageCo2Emissions: number;
    co2Path: { m2: Array<number> };
    energyPath: { m2: Array<number> };
  };
  customTargets?: {
    name: string;
    final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
    co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
  } | null;
};

export type StatusQuoAnalysisGetAnalyzedBuildingsAnalysisQueryVariables = Exact<{
  where: BuildingWhere;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisGetAnalyzedBuildingsAnalysisQuery = {
  getAnalyzedBuildingsAnalysis:
    | {
        analysisType: emission_factor_type_enum;
        crremAnalysis: {
          averageCo2Emissions: number;
          co2TargetPath: Array<number>;
          energyTargetPath: Array<number>;
          strandingYear?: number | null;
          yearOfExcedance?: number | null;
          cumulativeExcessEmissions: number;
          excessEmissionCostPath: Array<number>;
          co2Path: { m2: Array<number> };
          energyPath: { m2: Array<number> };
          scope123Co2Emissions: {
            wholeBuilding?: {
              scope1: { co2Emissions: number; co2EmissionsTotal: number };
              scope2: { co2Emissions: number; co2EmissionsTotal: number };
              scope3: { co2Emissions: number; co2EmissionsTotal: number };
            } | null;
            landlord?: {
              scope1: { co2Emissions: number; co2EmissionsTotal: number };
              scope2: { co2Emissions: number; co2EmissionsTotal: number };
              scope3: { co2Emissions: number; co2EmissionsTotal: number };
            } | null;
            tenant?: {
              scope1: { co2Emissions: number; co2EmissionsTotal: number };
              scope2: { co2Emissions: number; co2EmissionsTotal: number };
              scope3: { co2Emissions: number; co2EmissionsTotal: number };
            } | null;
          };
          strandingData: Array<{ year: number; count: number }>;
        };
        customTargets?: {
          name: string;
          final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
          primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
          co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
        } | null;
        customTargetPath?: { co2?: { targetPath: Array<number>; intersectionYear: number } | null } | null;
      }
    | {
        analysisType: emission_factor_type_enum;
        nationalEnergyLawAnalysis: {
          averageCo2Emissions: number;
          co2Path: { m2: Array<number> };
          energyPath: { m2: Array<number> };
        };
        customTargets?: {
          name: string;
          final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
          primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
          co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
        } | null;
      };
};

export type StatusQuoAnalysisBuildingGetBuildingQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisBuildingGetBuildingQuery = {
  getAnalyzedBuilding?:
    | {
        analysisType: emission_factor_type_enum;
        taxBracket: tax_bracket_enum;
        efficiencyClass: efficiency_class_enum;
        euTaxonomyCompliance: eu_taxonomy_compliance_enum;
        finalEnergy: number;
        primaryEnergy: number;
        heatingDemand?: number | null;
        co2CostPath: { total: Array<number>; m2: Array<number> };
        co2CostDistributionPath: {
          landlordPath: { total: Array<number>; m2: Array<number> };
          tenantPath: { total: Array<number>; m2: Array<number> };
        };
        energyCostPath: { total: Array<number>; m2: Array<number> };
        energyConsumers: Array<{
          energySourceType: energy_source_type_enum;
          energyConsumptionM2: number;
          energyConsumptionTotal: number;
        }>;
        climateRisks: Array<{ timespan?: string | null; type: climate_risk_type_enum; value: number }>;
        floorAreaByClassOfUse: Array<{ classOfUse: class_of_use_enum; area: number }>;
        crremAnalysis: {
          co2Emissions: number;
          co2TargetPath: Array<number>;
          energyTargetPath: Array<number>;
          strandingYear?: number | null;
          yearOfExcedance?: number | null;
          cumulativeExcessEmissions: number;
          excessEmissionCostPath: Array<number>;
          co2Path: { m2: Array<number> };
          energyPath: { m2: Array<number> };
          buildingModelTransitions: Array<{ validFrom: DateTime; co2Intensity: number; energyIntensity: number }>;
          scope123Co2Emissions: {
            wholeBuilding?: {
              scope1: { co2Emissions: number; co2EmissionsTotal: number };
              scope2: { co2Emissions: number; co2EmissionsTotal: number };
              scope3: { co2Emissions: number; co2EmissionsTotal: number };
            } | null;
            landlord?: {
              scope1: { co2Emissions: number; co2EmissionsTotal: number };
              scope2: { co2Emissions: number; co2EmissionsTotal: number };
              scope3: { co2Emissions: number; co2EmissionsTotal: number };
            } | null;
            tenant?: {
              scope1: { co2Emissions: number; co2EmissionsTotal: number };
              scope2: { co2Emissions: number; co2EmissionsTotal: number };
              scope3: { co2Emissions: number; co2EmissionsTotal: number };
            } | null;
          };
        };
        customTargets?: {
          name: string;
          final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
          primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
          co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
        } | null;
        slfAnalysis: {
          ongoingReportId?: string | null;
          lastSlfReport?: { reportId: string; value: number; issuedAt: DateTime } | null;
          compliantFactors: Array<
            | {
                certificateType: certificate_type_enum;
                level?: certificate_level_type_enum | null;
                score?: number | null;
                type: slf_compliance_factor_enum;
              }
            | { efficiencyClass: efficiency_class_enum; type: slf_compliance_factor_enum }
            | { euTaxonomyCompliance: eu_taxonomy_compliance_enum; type: slf_compliance_factor_enum }
            | { reportId: string; type: slf_compliance_factor_enum; issuedAt: DateTime }
          >;
          notCompliantFactors: Array<{
            level?: certificate_level_type_enum | null;
            score?: number | null;
            certificateType: certificate_type_enum;
          }>;
        };
        customTargetPath?: { co2?: { targetPath: Array<number>; intersectionYear: number } | null } | null;
      }
    | {
        analysisType: emission_factor_type_enum;
        taxBracket: tax_bracket_enum;
        efficiencyClass: efficiency_class_enum;
        euTaxonomyCompliance: eu_taxonomy_compliance_enum;
        finalEnergy: number;
        primaryEnergy: number;
        heatingDemand?: number | null;
        co2CostPath: { total: Array<number>; m2: Array<number> };
        co2CostDistributionPath: {
          landlordPath: { total: Array<number>; m2: Array<number> };
          tenantPath: { total: Array<number>; m2: Array<number> };
        };
        energyCostPath: { total: Array<number>; m2: Array<number> };
        energyConsumers: Array<{
          energySourceType: energy_source_type_enum;
          energyConsumptionM2: number;
          energyConsumptionTotal: number;
        }>;
        climateRisks: Array<{ timespan?: string | null; type: climate_risk_type_enum; value: number }>;
        floorAreaByClassOfUse: Array<{ classOfUse: class_of_use_enum; area: number }>;
        nationalEnergyLawAnalysis: {
          co2Emissions: number;
          co2Path: { m2: Array<number>; total: Array<number> };
          energyPath: { m2: Array<number>; total: Array<number> };
          buildingModelTransitions: Array<{ validFrom: DateTime; co2Intensity: number; energyIntensity: number }>;
        };
        customTargets?: {
          name: string;
          final_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
          primary_energy: Array<{ reached: boolean; year: number; targetValue: number }>;
          co2_emissions: Array<{ reached: boolean; year: number; targetValue: number }>;
        } | null;
        slfAnalysis: {
          ongoingReportId?: string | null;
          lastSlfReport?: { reportId: string; value: number; issuedAt: DateTime } | null;
          compliantFactors: Array<
            | {
                certificateType: certificate_type_enum;
                level?: certificate_level_type_enum | null;
                score?: number | null;
                type: slf_compliance_factor_enum;
              }
            | { efficiencyClass: efficiency_class_enum; type: slf_compliance_factor_enum }
            | { euTaxonomyCompliance: eu_taxonomy_compliance_enum; type: slf_compliance_factor_enum }
            | { reportId: string; type: slf_compliance_factor_enum; issuedAt: DateTime }
          >;
          notCompliantFactors: Array<{
            level?: certificate_level_type_enum | null;
            score?: number | null;
            certificateType: certificate_type_enum;
          }>;
        };
      }
    | null;
};

export type QueueStatusQuoAnalysisPdfExportMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  useCustomTargetPath?: InputMaybe<Scalars['Boolean']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type QueueStatusQuoAnalysisPdfExportMutation = { queueEsgAnalysisPdfExport: { asyncJobId: number } };

export type QueueSummaryOnePagerPdfExportMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tab?: InputMaybe<status_quo_pdf_export_tab_enum>;
  reportingYear?: InputMaybe<Scalars['Int']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  displayBase?: InputMaybe<Scalars['String']['input']>;
  benchmarkPortfolioId?: InputMaybe<Scalars['Int']['input']>;
  classOfUse?: InputMaybe<class_of_use_enum>;
  typeOfUse?: InputMaybe<type_of_use_enum>;
  crremPathGraphType?: InputMaybe<crrem_path_graph_type_enum>;
  crremPathsType?: InputMaybe<Scalars['String']['input']>;
  demandScopePerspective?: InputMaybe<scope_perspective_enum>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  consumptionScopePerspective?: InputMaybe<scope_perspective_enum>;
}>;

export type QueueSummaryOnePagerPdfExportMutation = { queueSummaryOnePagerPdfExport: { asyncJobId: number } };

export type QueueEconomicUnitEsgAnalysisPdfExportMutationVariables = Exact<{
  economicUnitId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  useCustomTargetPath?: InputMaybe<Scalars['Boolean']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type QueueEconomicUnitEsgAnalysisPdfExportMutation = {
  queueEconomicUnitEsgAnalysisPdfExport: { asyncJobId: number };
};

export type QueueBatchEsgAnalysisPdfExportMutationVariables = Exact<{
  economicUnitId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  useCustomTargetPath?: InputMaybe<Scalars['Boolean']['input']>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type QueueBatchEsgAnalysisPdfExportMutation = {
  queueBatchEsgAnalysisPdfExport: { asyncJobId: number; totalBuildings: number };
};

export type StatusQuoAnalysisConsumptionAnalysisQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  fromYear: Scalars['Int']['input'];
  toYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
}>;

export type StatusQuoAnalysisConsumptionAnalysisQuery = {
  getConsumptionAnalysis: {
    data: Array<{
      averageAbsolute: number;
      average: number;
      type: consumption_type_enum;
      series: Array<{ count: number; from: number; to: number; sumAbsolute: number; sum: number }>;
    }>;
  };
};

export type StatusQuoAnalysisConsumptionAllocationQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  perspective?: InputMaybe<scope_perspective_enum>;
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type StatusQuoAnalysisConsumptionAllocationQuery = {
  getConsumptionAllocation: {
    carbonEmissions?:
      | {
          analysisType: emission_factor_type_enum;
          intensity: number;
          intensityAbsolute: number;
          scope1: { percentage: number; value: number };
          scope2: { percentage: number; value: number };
          scope3: { percentage: number; value: number };
        }
      | { analysisType: emission_factor_type_enum; intensity: number; intensityAbsolute: number }
      | null;
    co2Tax?: {
      costShare: number;
      total: number;
      totalAbsolute: number;
      forecastItems: Array<{
        landlordShare: number;
        landlordShareAbsolute: number;
        landlordSharePercentage: number;
        tenantShare: number;
        tenantShareAbsolute: number;
        tenantSharePercentage: number;
        year: number;
      }>;
    } | null;
    energyConsumptions: Array<{
      total: number;
      totalAbsolute: number;
      type: energy_consumption_type_enum;
      items: Array<{ percentage: number; type: string; value: number; valueAbsolute: number }>;
    }>;
  };
};

export type GetConsumptionAllocationByScope123PerspectiveQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  perspective?: InputMaybe<scope_perspective_enum>;
}>;

export type GetConsumptionAllocationByScope123PerspectiveQuery = {
  getConsumptionAllocationByScope123Perspective: {
    carbonEmissions?:
      | {
          analysisType: emission_factor_type_enum;
          intensity: number;
          intensityAbsolute: number;
          scope1: { percentage: number; value: number };
          scope2: { percentage: number; value: number };
          scope3: { percentage: number; value: number };
        }
      | { analysisType: emission_factor_type_enum; intensity: number; intensityAbsolute: number }
      | null;
  };
};

export type getBuildingCRREMConsumptionAnalysisQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
}>;

export type getBuildingCRREMConsumptionAnalysisQuery = {
  getBuildingCRREMConsumptionAnalysis?: {
    co2TargetPath: Array<number>;
    energyTargetPath: Array<number>;
    strandingYear?: number | null;
    yearOfExcedance?: number | null;
    cumulativeExcessEmissions: number;
    excessEmissionCostPath: Array<number>;
    co2Path: { m2: Array<number> };
    energyPath: { m2: Array<number> };
  } | null;
};

export type GetConsumptionCoverageQueryVariables = Exact<{
  where: BuildingWhere;
  reportingYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetConsumptionCoverageQuery = {
  getConsumptionCoverage: { buildingsWithoutConsumptionData: number; totalBuildings: number };
};

export type GetConsumptionFinalEnergyDevelopmentQueryVariables = Exact<{
  where: BuildingWhere;
  reportingYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetConsumptionFinalEnergyDevelopmentQuery = {
  getConsumptionFinalEnergyDevelopment: Array<{
    year: number;
    totalAbsolute: number;
    totalRelative: number;
    heatingBreakdown: { percentage: number; valueRelative: number; valueAbsolute: number };
    electricityBreakdown: { percentage: number; valueRelative: number; valueAbsolute: number };
  }>;
};

export type GetConsumptionDeviationFromDemandQueryVariables = Exact<{
  where: BuildingWhere;
  reportingYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetConsumptionDeviationFromDemandQuery = {
  getConsumptionDeviationFromDemand: {
    lt_neg_30: number;
    neg_30_neg_10: number;
    neg_10_10: number;
    pos_10_30: number;
    gt_30: number;
  };
};

export type GetConsumptionEnergySourcesByFinalEnergyQueryVariables = Exact<{
  where: BuildingWhere;
  reportingYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetConsumptionEnergySourcesByFinalEnergyQuery = {
  getConsumptionEnergySourcesByFinalEnergy: Array<{
    energySourceType: energy_source_type_enum;
    percentage: number;
    valueAbsolute: number;
    valueRelative: number;
  }>;
};

export type GetConsumptionEnergySourcesByCO2IntensityQueryVariables = Exact<{
  where: BuildingWhere;
  reportingYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetConsumptionEnergySourcesByCO2IntensityQuery = {
  getConsumptionEnergySourcesByCO2Intensity: Array<{
    energySourceType: energy_source_type_enum;
    percentage: number;
    valueAbsolute: number;
    valueRelative: number;
  }>;
};

export type GetConsumptionEnergySourcesByBuildingCountQueryVariables = Exact<{
  where: BuildingWhere;
  reportingYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetConsumptionEnergySourcesByBuildingCountQuery = {
  getConsumptionEnergySourcesByBuildingCount: Array<{ energySourceType: energy_source_type_enum; count: number }>;
};

export type GetConsumptionCO2IntensityDevelopmentQueryVariables = Exact<{
  where: BuildingWhere;
  reportingYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetConsumptionCO2IntensityDevelopmentQuery = {
  getConsumptionCO2IntensityDevelopment: Array<{ year: number; valueRelative: number; valueAbsolute: number }>;
};

export type GetConsumptionCRREMPathsQueryVariables = Exact<{
  where: BuildingWhere;
  reportingYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetConsumptionCRREMPathsQuery = {
  getConsumptionCRREMPaths?: {
    co2PathRelative: Array<number>;
    co2TargetPathRelative: Array<number>;
    energyPathRelative: Array<number>;
    energyTargetPathRelative: Array<number>;
    excessEmissionCostPath: Array<number>;
    strandingYear?: number | null;
    yearOfExcedance?: number | null;
    strandingData: Array<{ year: number; count: number }>;
  } | null;
};

export type GetConsumptionPortfolioKPIsQueryVariables = Exact<{
  where: BuildingWhere;
  reportingYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type GetConsumptionPortfolioKPIsQuery = {
  getConsumptionPortfolioKPIs: {
    finalEnergyRelative?: number | null;
    finalEnergyTotal?: number | null;
    primaryEnergyRelative?: number | null;
    primaryEnergyTotal?: number | null;
    co2Relative?: number | null;
    co2Total?: number | null;
    energyCostRelative?: number | null;
    energyCostTotal?: number | null;
    co2TaxRelative?: number | null;
    co2TaxTotal?: number | null;
  };
};

export type getStatusQuoConsumptionAnalysisKPIsQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
}>;

export type getStatusQuoConsumptionAnalysisKPIsQuery = {
  getEsgConsumptionAnalysisKPIs: {
    co2Intensity?: number | null;
    co2IntensityAbsolute?: number | null;
    co2Tax?: number | null;
    co2TaxAbsolute?: number | null;
    efficiencyClass?: efficiency_class_enum | null;
    energyCost?: number | null;
    energyCostAbsolute?: number | null;
    euTaxonomy?: eu_taxonomy_compliance_enum | null;
    finalEnergy?: number | null;
    finalEnergyAbsolute?: number | null;
    primaryEnergy?: number | null;
    primaryEnergyAbsolute?: number | null;
  };
};

export type PortfolioBasicDetailsFragment = { id: number; name: string };

export type EconomicUnitBasicDetailsFragment = {
  id: number;
  name: string;
  description: string;
  custom_data: any;
  customer_economic_unit_id?: string | null;
  portfolio: { id: number };
  buildings: Array<{ address: { country_id: country_enum } }>;
};

export type PortfolioCountQueryVariables = Exact<{ [key: string]: never }>;

export type PortfolioCountQuery = { portfolio_aggregate: { aggregate?: { count: number } | null } };

export type getPortfoliosAggregateCountQueryVariables = Exact<{
  where: portfolio_bool_exp;
}>;

export type getPortfoliosAggregateCountQuery = { portfolio_aggregate: { aggregate?: { count: number } | null } };

export type EconomicUnitCountQueryVariables = Exact<{ [key: string]: never }>;

export type EconomicUnitCountQuery = { economic_unit_aggregate: { aggregate?: { count: number } | null } };

export type getPortfolioByIdsQueryVariables = Exact<{
  where: portfolio_bool_exp;
}>;

export type getPortfolioByIdsQuery = { portfolio: Array<{ id: number; name: string }> };

export type getPortfoliosBySearchStringQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: portfolio_bool_exp;
}>;

export type getPortfoliosBySearchStringQuery = { portfolio: Array<{ id: number; name: string }> };

export type SearchBuildingsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  text: Scalars['String']['input'];
}>;

export type SearchBuildingsQuery = {
  building: Array<{
    id: number;
    customer_external_identifier?: string | null;
    is_new_construction: boolean;
    is_missing_energy_data?: boolean | null;
    address: { street: string; city: string; postal_code: string };
    folder?: { id: number } | null;
  }>;
};

export type getSingleBuildingBuildingQueryVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type getSingleBuildingBuildingQuery = {
  building_by_pk?: {
    id: number;
    year_constructed: number;
    is_new_construction: boolean;
    is_missing_energy_data?: boolean | null;
    description: string;
    custom_data: any;
    address: {
      street: string;
      postal_code: string;
      city: string;
      country_id: country_enum;
      mapbox_building_ids: Array<string>;
      building_citydb_gml_ids?: Array<string> | null;
      building_lod1_ids?: Array<string> | null;
    };
    economic_unit: { id: number; name: string; portfolio: { id: number; name: string } };
    responsible_user: { first_name?: string | null; last_name?: string | null };
    areas: Array<{
      id: number;
      value: number;
      area_type_id: area_type_enum;
      type_of_use_id: type_of_use_enum;
      class_of_use_id: class_of_use_enum;
    }>;
    building_valuations: Array<{ id: number; value: number; valuation_at: string }>;
  } | null;
};

export type getEconomicUnitsBySearchStringQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  text: Scalars['String']['input'];
}>;

export type getEconomicUnitsBySearchStringQuery = {
  economic_unit: Array<{
    id: number;
    name: string;
    description: string;
    custom_data: any;
    customer_economic_unit_id?: string | null;
    portfolio: { id: number };
    buildings: Array<{ address: { country_id: country_enum } }>;
  }>;
};

export type getEconomicUnitsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type getEconomicUnitsByIdsQuery = {
  economic_unit: Array<{
    id: number;
    name: string;
    description: string;
    custom_data: any;
    customer_economic_unit_id?: string | null;
    portfolio: { id: number };
    buildings: Array<{ address: { country_id: country_enum } }>;
  }>;
};

export type getBuildingsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type getBuildingsByIdsQuery = {
  building: Array<{
    id: number;
    customer_external_identifier?: string | null;
    is_new_construction: boolean;
    is_missing_energy_data?: boolean | null;
    address: { street: string; city: string; postal_code: string };
    folder?: { id: number } | null;
  }>;
};

export type SearchPortfoliosQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  text: Scalars['String']['input'];
}>;

export type SearchPortfoliosQuery = { portfolio: Array<{ id: number; name: string; folder?: { id: number } | null }> };

export type SearchEconomicUnitsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  text: Scalars['String']['input'];
}>;

export type SearchEconomicUnitsQuery = {
  economic_unit: Array<{ id: number; name: string; folder?: { id: number } | null }>;
};

export type CreateSharedBuildingSnapshotMutationVariables = Exact<{
  buildingId: Scalars['Int']['input'];
}>;

export type CreateSharedBuildingSnapshotMutation = { createSharedBuildingSnapshot: { hash: string } };

export type GetSharedBuildingSnapshotQueryVariables = Exact<{
  hash: Scalars['String']['input'];
}>;

export type GetSharedBuildingSnapshotQuery = { getSharedBuildingSnapshot?: { data: any; created_at: DateTime } | null };

export type GetConsumptionBuildingListQueryVariables = Exact<{
  where: BuildingWhere;
  reportingYear: Scalars['Int']['input'];
  referenceAreaType?: InputMaybe<analysis_reference_area_enum>;
  emissionFactorSource?: InputMaybe<emission_factor_source_enum>;
  orderBy?: InputMaybe<ConsumptionBuildingOrderByInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type GetConsumptionBuildingListQuery = {
  getConsumptionBuildingList: {
    count: number;
    buildings: Array<{
      id: number;
      street: string;
      postalCode: string;
      city: string;
      country: country_enum;
      typesOfUse: Array<type_of_use_enum>;
      isNewConstruction: boolean;
      co2Relative?: number | null;
      co2Total?: number | null;
      co2TaxRelative?: number | null;
      co2TaxTotal?: number | null;
      primaryEnergyRelative?: number | null;
      primaryEnergyTotal?: number | null;
      finalEnergyRelative?: number | null;
      finalEnergyTotal?: number | null;
      deviationFromDemand?: number | null;
    }>;
  };
};

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  role: role_enum;
  role_description?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateUserMutation = { createUser: { user_id?: number | null } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  role: role_enum;
  role_description?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateUserMutation = { update_user_by_pk?: { created_at: string } | null };

export type ChangeUserLanguageMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  language: language_enum;
}>;

export type ChangeUserLanguageMutation = { update_user_by_pk?: { id: number; language: language_enum } | null };

export type DeleteUserAndtransferOwnershipMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  transferOwnershipToUserId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DeleteUserAndtransferOwnershipMutation = {
  deleteUser: { UserId?: { __typename: 'user'; id: number } | null };
};

export type UpsertBuildingPermissionsMutationVariables = Exact<{
  objects?: InputMaybe<Array<user_building_permission_insert_input> | user_building_permission_insert_input>;
}>;

export type UpsertBuildingPermissionsMutation = {
  insert_user_building_permission?: {
    returning: Array<{ building_id: number; read: boolean; write: boolean; id: number }>;
  } | null;
};

export type UpsertPortfolioPermissionsMutationVariables = Exact<{
  objects?: InputMaybe<Array<user_portfolio_permission_insert_input> | user_portfolio_permission_insert_input>;
}>;

export type UpsertPortfolioPermissionsMutation = {
  insert_user_portfolio_permission?: {
    returning: Array<{ portfolio_id: number; read: boolean; write: boolean; id: number }>;
  } | null;
};

export type GetSessionDataOrgFragment = {
  id: number;
  name: string;
  status_type_id: org_status_type_enum;
  org_type_id: org_type_enum;
  org_sector_type_id: org_sector_type_enum;
  logo?: { id: number; downloadUrl: string } | null;
};

export type GetSessionDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetSessionDataQuery = {
  getSessionData: {
    enabledFeatureFlags: Array<string>;
    isAdmin: boolean;
    firstBuildingId?: number | null;
    hasPortfolioWithWriteAccess: boolean;
    user: {
      id: number;
      email?: string | null;
      firstName: string;
      lastName: string;
      createdAt: DateTime;
      language: language_enum;
      roleDescription: string;
      isActive: boolean;
      role: role_enum;
    };
    org: {
      id: number;
      logoUrl?: string | null;
      name: string;
      orgTypeId: org_type_enum;
      statusTypeId: org_status_type_enum;
      userLogoutIdleTimeout?: number | null;
      isEconomicUnitsToggled: boolean;
      orgSector: org_sector_type_enum;
    };
  };
};

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllUsersQuery = {
  user: Array<{
    id: number;
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    created_at: string;
    role_id: role_enum;
  }>;
};

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type GetUserByIdQuery = {
  user_by_pk?: {
    id: number;
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    role_description?: string | null;
    created_at: string;
    role_id: role_enum;
    org: { id: number };
  } | null;
};

export type GetAllUserObjectsAggregateQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type GetAllUserObjectsAggregateQuery = {
  report_aggregate: { aggregate?: { count: number } | null };
  scenario_aggregate: { aggregate?: { count: number } | null };
  building_aggregate: { aggregate?: { count: number } | null };
  building_draft_aggregate: { aggregate?: { count: number } | null };
  energy_certificate_draft_aggregate: { aggregate?: { count: number } | null };
  active_action_plans_aggregate: { aggregate?: { count: number } | null };
  action_aggregate: { aggregate?: { count: number } | null };
  consumption_aggregate: { aggregate?: { count: number } | null };
  consumption_draft_aggregate: { aggregate?: { count: number } | null };
};

export type GetNotificationsQueryVariables = Exact<{
  user_id: Scalars['Int']['input'];
}>;

export type GetNotificationsQuery = {
  notification: Array<{
    __typename: 'notification';
    id: number;
    read: boolean;
    created_at: string;
    notification_template: {
      __typename: 'notification_template';
      id: number;
      title: string;
      description: string;
      href?: string | null;
    };
  }>;
};

export type GetCurrentFeatureFlagsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentFeatureFlagsQuery = { getUserFeatureFlags: Array<string> };

export type GetUserLoginHistoryQueryVariables = Exact<{
  user_id: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;

export type GetUserLoginHistoryQuery = {
  getUserLoginHistory: {
    lastLogin?: DateTime | null;
    lastIp?: string | null;
    loginsCount?: number | null;
    events: Array<{
      date: DateTime;
      ip?: string | null;
      userAgent?: string | null;
      clientName?: string | null;
      locationInfo?: { city?: string | null; country?: string | null } | null;
    }>;
  };
};

export type GetUsersListWithFullnameQueryVariables = Exact<{ [key: string]: never }>;

export type GetUsersListWithFullnameQuery = {
  user: Array<{ id: number; first_name?: string | null; last_name?: string | null }>;
};

export type UpdateOrgPreferenceForEconomicUnitMutationVariables = Exact<{
  economicUnitEnabled: Scalars['Boolean']['input'];
}>;

export type UpdateOrgPreferenceForEconomicUnitMutation = {
  setCommonOrgPreferences: { isEconomicUnitsToggled: boolean };
};

export type UpdateOrgPreferenceForAutomaticActionCostUpdateMutationVariables = Exact<{
  automaticActionCostUpdateEnabled: Scalars['Boolean']['input'];
}>;

export type UpdateOrgPreferenceForAutomaticActionCostUpdateMutation = {
  setCommonOrgPreferences: { isAutomaticActionCostUpdateToggled: boolean };
};

export type UpdateOrgPreferenceForEconomicUnitInFileDriveMutationVariables = Exact<{
  economicUnitInFileDriveEnabled: Scalars['Boolean']['input'];
}>;

export type UpdateOrgPreferenceForEconomicUnitInFileDriveMutation = {
  setCommonOrgPreferences: { isEconomicUnitsInFileDriveToggled: boolean };
};

export type SetOrgCo2PriceCurveMutationVariables = Exact<{
  input: SetOrgCo2PriceCurveInput;
}>;

export type SetOrgCo2PriceCurveMutation = {
  setOrgCo2PriceCurve?: {
    kind: co2_price_curve_kind_enum;
    growthStartValue?: number | null;
    growthAnnualPercent?: number | null;
    anchors?: Array<{ year: number; pricePerTon: number }> | null;
  } | null;
};

export type SetOrgEuTaxonomyDatasourceMutationVariables = Exact<{
  input: SetOrgEuTaxonomyDatasourceInput;
}>;

export type SetOrgEuTaxonomyDatasourceMutation = {
  setOrgEuTaxonomyDatasource: { euTaxonomyDatasource: eu_taxonomy_datasource_enum };
};

export type SetOrgEmissionFactorPreferencesMutationVariables = Exact<{
  input: SetOrgEmissionFactorPreferencesInput;
}>;

export type SetOrgEmissionFactorPreferencesMutation = {
  setOrgEmissionFactorPreferences: {
    availableReportingYears: Array<number>;
    activeEmissionFactorPreferences:
      | {
          emissionFactorType: emission_factor_type_enum;
          crremVersion: crrem_version_type_enum;
          activeCRREMConfiguration:
            | {
                __typename: 'CRREMCustomConfigurationObject';
                id: number;
                title: string;
                setFor: { org: boolean; portfolios: Array<{ id: number }> };
              }
            | {
                __typename: 'CRREMDefaultConfigurationObject';
                emissionFactorType: emission_factor_type_enum;
                setFor: { org: boolean; portfolios: Array<{ id: number }> };
              };
        }
      | { emissionFactorType: emission_factor_type_enum };
  };
};

export type ConfirmFileUploadMutationVariables = Exact<{
  fileId: Scalars['Int']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
}>;

export type ConfirmFileUploadMutation = { confirmFileUpload: { fileId: number; name?: string | null } };

export type CRREMDefaultConfigurationFragment = {
  __typename: 'CRREMDefaultConfigurationObject';
  emissionFactorType: emission_factor_type_enum;
  setFor: { org: boolean; portfolios: Array<{ id: number }> };
};

export type CRREMCustomConfigurationFragment = {
  __typename: 'CRREMCustomConfigurationObject';
  id: number;
  title: string;
  setFor: { org: boolean; portfolios: Array<{ id: number }> };
};

export type AsyncJobFragment = {
  description?: string | null;
  title: string;
  entity_id?: number | null;
  status_id: async_job_status_type_enum;
  user_id?: number | null;
  org_id?: number | null;
};

export type AccessRightsPortfolioFragment = { created_at?: string | null; id: number; name: string };

export type AccessRightsBuildingFragment = {
  created_at: string;
  id: number;
  is_new_construction: boolean;
  is_missing_energy_data?: boolean | null;
  address: { city: string; country_id: country_enum; postal_code: string; street: string };
  areas: Array<{ __typename: 'area'; value: number; type_of_use_id: type_of_use_enum; area_type_id: area_type_enum }>;
  economic_unit: { portfolio: { name: string; id: number } };
};

export type GetAllPortfoliosAndBuildingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllPortfoliosAndBuildingsQuery = {
  portfolio: Array<{ created_at?: string | null; id: number; name: string }>;
  building: Array<{
    created_at: string;
    id: number;
    is_new_construction: boolean;
    is_missing_energy_data?: boolean | null;
    address: { city: string; country_id: country_enum; postal_code: string; street: string };
    areas: Array<{ __typename: 'area'; value: number; type_of_use_id: type_of_use_enum; area_type_id: area_type_enum }>;
    economic_unit: { portfolio: { name: string; id: number } };
  }>;
};

export type GetOrgPreferencesQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrgPreferencesQuery = {
  getOrgPreferences: {
    co2PriceDefaultCurve: Array<number>;
    isEconomicUnitsInFileDriveToggled: boolean;
    isAutomaticActionCostUpdateToggled: boolean;
    isSSOEnabled: boolean;
    isSSOAutoCreateUser: boolean;
    availableReportingYears: Array<number>;
    euTaxonomyDatasource: eu_taxonomy_datasource_enum;
    co2PriceCurveConfig?: {
      kind: co2_price_curve_kind_enum;
      growthStartValue?: number | null;
      growthAnnualPercent?: number | null;
      anchors?: Array<{ year: number; pricePerTon: number }> | null;
    } | null;
    crremConfigurations: Array<
      | {
          __typename: 'CRREMCustomConfigurationObject';
          id: number;
          title: string;
          setFor: { org: boolean; portfolios: Array<{ id: number }> };
        }
      | {
          __typename: 'CRREMDefaultConfigurationObject';
          emissionFactorType: emission_factor_type_enum;
          setFor: { org: boolean; portfolios: Array<{ id: number }> };
        }
    >;
    activeEmissionFactorPreferences:
      | {
          __typename: 'CrremOrgPreferences';
          emissionFactorType: emission_factor_type_enum;
          crremVersion: crrem_version_type_enum;
          activeCRREMConfiguration:
            | {
                __typename: 'CRREMCustomConfigurationObject';
                id: number;
                title: string;
                setFor: { org: boolean; portfolios: Array<{ id: number }> };
              }
            | {
                __typename: 'CRREMDefaultConfigurationObject';
                emissionFactorType: emission_factor_type_enum;
                setFor: { org: boolean; portfolios: Array<{ id: number }> };
              };
        }
      | { __typename: 'NationalEnergyLawOrgPreferences'; emissionFactorType: emission_factor_type_enum };
  };
};

export type AsyncJobSubscriptionOrgSubscriptionVariables = Exact<{
  title: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AsyncJobSubscriptionOrgSubscription = {
  async_job: Array<{
    description?: string | null;
    title: string;
    entity_id?: number | null;
    status_id: async_job_status_type_enum;
    user_id?: number | null;
    org_id?: number | null;
  }>;
};

export type AsyncJobSubscriptionSubscriptionVariables = Exact<{
  title: Scalars['String']['input'];
  entityId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AsyncJobSubscriptionSubscription = {
  async_job: Array<{
    description?: string | null;
    title: string;
    entity_id?: number | null;
    status_id: async_job_status_type_enum;
    user_id?: number | null;
    org_id?: number | null;
  }>;
};

export type GetSearchBuildingsQueryVariables = Exact<{
  search_string?: InputMaybe<Scalars['String']['input']>;
  portfolio_ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<BuildingOrderByInput>;
}>;

export type GetSearchBuildingsQuery = {
  searchBuildings: {
    count: number;
    buildings: Array<{
      id: number;
      street: string;
      city: string;
      postal_code: string;
      is_new_construction: boolean;
      has_energy_data: boolean;
    }>;
  };
};

export const BaseEnergyValuesCrremOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesCrremOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesCRREMOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stranding_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BaseEnergyValuesCrremOutputFragment, unknown>;
export const BaseEnergyValuesNationalEnergyLawOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BaseEnergyValuesNationalEnergyLawOutputFragment, unknown>;
export const BaseEnergyValuesOutputResponseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesOutputResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesOutputUnion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BaseEnergyValuesCrremOutput' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesCrremOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesCRREMOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stranding_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BaseEnergyValuesOutputResponseFragment, unknown>;
export const EnergyValuesCrremOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesCrremOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesCRREMOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stranding_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnergyValuesCrremOutputFragment, unknown>;
export const EnergyValuesNationalEnergyLawOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnergyValuesNationalEnergyLawOutputFragment, unknown>;
export const EnergyValuesOutputResponseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesOutputResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesOutputUnion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyValuesCrremOutput' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesCrremOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesCRREMOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stranding_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnergyValuesOutputResponseFragment, unknown>;
export const SimulateActionOutputResponseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SimulateActionOutputResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SimulateActionOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'error' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyValuesCrremOutput' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesCrremOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesCRREMOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stranding_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SimulateActionOutputResponseFragment, unknown>;
export const SimulateActionStatusQuoOutputResponseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SimulateActionStatusQuoOutputResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SimulateActionStatusQuoOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'error' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BaseEnergyValuesCrremOutput' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesCrremOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesCRREMOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stranding_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SimulateActionStatusQuoOutputResponseFragment, unknown>;
export const EditActionOutputResponseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EditActionOutputResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EditActionOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'error' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditActionOutputResponseFragment, unknown>;
export const EnergySystemRouteRenovationParameterObjectFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnergySystemRouteRenovationParameterObjectFragment, unknown>;
export const SystemRenovationParameterObjectFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SystemRenovationParameterObjectFragment, unknown>;
export const SolarRenovationParameterObjectFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SolarRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SolarRenovationParameterObjectFragment, unknown>;
export const HydraulicBalancingRenovationParameterObjectFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'costs_with_components' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HydraulicBalancingRenovationParameterObjectFragment, unknown>;
export const EnvelopeRenovationParameterObjectFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnvelopeRenovationParameterObjectFragment, unknown>;
export const VentilationRenovationParameterObjectFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VentilationRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VentilationRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VentilationRenovationParameterObjectFragment, unknown>;
export const CreateVentilationRenovationParameterObjectFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateVentilationRenovationParameterObjectFragment, unknown>;
export const ExclusionNoteParameterObjectFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExclusionNoteParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExclusionNoteParameterObject' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'note' } }] },
    },
  ],
} as unknown as DocumentNode<ExclusionNoteParameterObjectFragment, unknown>;
export const ActionParametersFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionParameters' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parameters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CustomActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'EnergySourceCustomActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'energySourceCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fraction' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SystemCustomActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'systemCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fraction' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnergySystemRouteParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energySystemRouteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemParametersUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'SystemRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarParametersUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'solarParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SolarRenovationParameterObject' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HydraulicBalancingParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hydraulicBalancingParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeParametersUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'envelopeParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MaintenanceActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maintenanceActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ventilationRenovationParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'VentilationRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateVentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createVentilationRenovationParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ExclusionNoteParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exclusionNoteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExclusionNoteParameterObject' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SolarRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'costs_with_components' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VentilationRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VentilationRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExclusionNoteParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExclusionNoteParameterObject' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'note' } }] },
    },
  ],
} as unknown as DocumentNode<ActionParametersFragment, unknown>;
export const EnergyConsumerForActionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyConsumerForAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_consumer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnergyConsumerForActionFragment, unknown>;
export const EnvelopeUnitFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeUnit' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnvelopeUnitFragment, unknown>;
export const EnvelopeRenovationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeRenovation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'renovation_envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'new_envelope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_method_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'old_entity_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'old_envelope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building_model' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'envelope_units' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'id' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeUnit' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeUnit' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnvelopeRenovationFragment, unknown>;
export const EnergySystemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'energy_consumer_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_consumer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyConsumerForAction' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_distribution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_producer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyConsumerForAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_consumer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnergySystemFragment, unknown>;
export const BuildingModelFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_model' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'envelope_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeUnit' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system_consumer_routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_system' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distributions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_systems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergySystem' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_by_ventilation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyConsumerForAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_consumer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeUnit' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'energy_consumer_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_consumer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyConsumerForAction' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_distribution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_producer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildingModelFragment, unknown>;
export const ActionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Action' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'implementation_to' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_action_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_saving_fraction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bulk_action_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulk_action' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'renovation_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost_total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost_total_predium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost_total_custom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'use_custom_cost' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionParameters' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations_energy_consumer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'new_energy_consumer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyConsumerForAction' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'old_energy_consumer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyConsumerForAction' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations_envelope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeRenovation' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations_energy_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'new_energy_system_route' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_system' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'old_energy_system_route' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_system' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations_energy_producer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'new_energy_producer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_models' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModel' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SolarRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'costs_with_components' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VentilationRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VentilationRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExclusionNoteParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExclusionNoteParameterObject' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'note' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeUnit' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyConsumerForAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_consumer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'energy_consumer_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_consumer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyConsumerForAction' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_distribution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_producer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionParameters' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parameters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CustomActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'EnergySourceCustomActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'energySourceCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fraction' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SystemCustomActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'systemCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fraction' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnergySystemRouteParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energySystemRouteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemParametersUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'SystemRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarParametersUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'solarParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SolarRenovationParameterObject' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HydraulicBalancingParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hydraulicBalancingParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeParametersUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'envelopeParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MaintenanceActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maintenanceActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ventilationRenovationParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'VentilationRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateVentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createVentilationRenovationParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ExclusionNoteParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exclusionNoteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExclusionNoteParameterObject' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeRenovation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'renovation_envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'new_envelope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_method_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'old_entity_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'old_envelope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building_model' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'envelope_units' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'id' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeUnit' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_model' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'envelope_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeUnit' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system_consumer_routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_system' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distributions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_systems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergySystem' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_by_ventilation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionFragment, unknown>;
export const ActionForRecommendedActionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionForRecommendedAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'implementation_to' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'renovation_type_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionForRecommendedActionFragment, unknown>;
export const ActionPlanningActionSubsidyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanningActionSubsidy' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action_subsidy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subsidy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subsidy_category_type' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renovations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cost_total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cost_total_predium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'renovation_type_id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanningActionSubsidyFragment, unknown>;
export const BeforeAfterImpactFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BeforeAfterImpactFragment, unknown>;
export const RecommendedActionImpactOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedActionImpactOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RecommendedActionImpactCrremOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_date' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecommendedActionImpactOutputFragment, unknown>;
export const RecommendedActionImpactNationalEnergyLawOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecommendedActionImpactNationalEnergyLawOutputFragment, unknown>;
export const RecommendedActionImpactFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedActionImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RecommendedActionImpactUnion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RecommendedActionImpactOutput' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedActionImpactOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RecommendedActionImpactCrremOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_date' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecommendedActionImpactFragment, unknown>;
export const ModificationImpactCrremFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_date' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ModificationImpactCrremFragment, unknown>;
export const ModificationImpactsNationalEnergyLawFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactNationalEnergyLaw' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ModificationImpactsNationalEnergyLawFragment, unknown>;
export const ModificationImpactsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpacts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactUnion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_date' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactNationalEnergyLaw' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ModificationImpactsFragment, unknown>;
export const CostByRenovationCategoryFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CostByRenovationCategory' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CostByRenovationCategoryOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'series' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'values' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actionsCount' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legend' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionsCount' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CostByRenovationCategoryFragment, unknown>;
export const ActionPlanImpactDataOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanImpactDataOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionPlanImpactDataOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'total_renovation_cost' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cost_by_renovation_category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CostByRenovationCategory' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_subsidy_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_floor_area' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modification_impact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CostByRenovationCategory' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CostByRenovationCategoryOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'series' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'values' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actionsCount' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legend' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionsCount' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_date' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactNationalEnergyLaw' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanImpactDataOutputFragment, unknown>;
export const ActionImpactDataOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionImpactDataOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionImpactDataOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_renovation_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_subsidy_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_floor_area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modification_impact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_date' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactNationalEnergyLaw' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionImpactDataOutputFragment, unknown>;
export const ActionPlanMetricsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanMetrics' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionPlanMetricsOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action_plan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionPlanImpactDataOutput' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionImpactDataOutput' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CostByRenovationCategory' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CostByRenovationCategoryOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'series' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'values' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actionsCount' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legend' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionsCount' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_date' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactNationalEnergyLaw' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanImpactDataOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionPlanImpactDataOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'total_renovation_cost' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cost_by_renovation_category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CostByRenovationCategory' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_subsidy_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_floor_area' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modification_impact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionImpactDataOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionImpactDataOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_renovation_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_subsidy_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_floor_area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modification_impact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanMetricsFragment, unknown>;
export const ActionPlanningActionPlanActionPlanForCompareFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanningActionPlanActionPlanForCompare' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action_plan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario_version' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cost_version' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scenario' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portfolio' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanningActionPlanActionPlanForCompareFragment, unknown>;
export const ProgressiveFactorResponseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgressiveFactorResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressiveFactor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProgressiveFactorResponseFragment, unknown>;
export const EmissionFactorsPerEnergySourceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionFactorsPerEnergySource' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionFactorsObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'BIO_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_FOSSIL_COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_FOSSIL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_RENEWABLE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_FOSSIL_COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_FOSSIL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ELECTRICITY_GREEN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_RENEWABLE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ELECTRICITY_MIX' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'WOODEN_PELLETS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'WOOD' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'UNSPECIFIED' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'SOLAR' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'LPG' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'NATURAL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'LIGNITE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'FUEL_OIL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgressiveFactorResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressiveFactor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmissionFactorsPerEnergySourceFragment, unknown>;
export const DataCollectionBuildingSubsidyFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingSubsidy' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'subsidy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount_description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider_updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subsidy_category_type' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionBuildingSubsidyFragment, unknown>;
export const ActionPlanningActionPlanActionPlanFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanningActionPlanActionPlan' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action_plan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario_version' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scenario' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action_plan_inconsistencies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_supplier_inconsistencies' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'class_of_use_id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'active_building_model' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModel' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'base_emission_factors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionFactorsPerEnergySource' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'units' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subsidies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subsidy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingSubsidy' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'district_heating_availability_status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'building_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'district_heating_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'district_heating_year' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_unit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portfolio' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeUnit' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyConsumerForAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_consumer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'energy_consumer_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_consumer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyConsumerForAction' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_distribution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_producer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgressiveFactorResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressiveFactor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_model' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'envelope_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeUnit' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system_consumer_routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_system' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distributions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_systems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergySystem' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_by_ventilation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionFactorsPerEnergySource' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionFactorsObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'BIO_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_FOSSIL_COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_FOSSIL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_RENEWABLE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_FOSSIL_COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_FOSSIL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ELECTRICITY_GREEN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_RENEWABLE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ELECTRICITY_MIX' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'WOODEN_PELLETS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'WOOD' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'UNSPECIFIED' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'SOLAR' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'LPG' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'NATURAL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'LIGNITE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'FUEL_OIL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingSubsidy' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'subsidy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount_description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider_updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subsidy_category_type' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanningActionPlanActionPlanFragment, unknown>;
export const EnergySystemRouteRenovationParameterFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnergySystemRouteRenovationParameterFragment, unknown>;
export const SystemRenovationParameterFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SystemRenovationParameterFragment, unknown>;
export const SolarRenovationParameterFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SolarRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SolarRenovationParameterFragment, unknown>;
export const HydraulicBalancingRenovationParameterFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameter' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'costs_with_components' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HydraulicBalancingRenovationParameterFragment, unknown>;
export const EnvelopeRenovationParameterFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnvelopeRenovationParameterFragment, unknown>;
export const CreateVentilationRenovationParameterFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateVentilationRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateVentilationRenovationParameterFragment, unknown>;
export const UpdateVentilationRenovationParameterFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdateVentilationRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateVentilationRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateVentilationRenovationParameterFragment, unknown>;
export const RecommendedActionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RecommendedAction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actionImpact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RecommendedActionImpactOutput' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parameters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameter' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SystemRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SystemRenovationParameter' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterOutput' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SolarRenovationParameter' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameter' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnvelopeRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeRenovationParameter' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateVentilationRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CreateVentilationRenovationParameter' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateVentilationRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UpdateVentilationRenovationParameter' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedActionImpactOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RecommendedActionImpactCrremOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_date' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SolarRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameter' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'costs_with_components' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateVentilationRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdateVentilationRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateVentilationRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecommendedActionFragment, unknown>;
export const AnalyzedScenarioFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzedScenario' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeScenarioOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'building_count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_floor_area' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modification_impact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'final_energy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2_emissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primary_energy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnalyzedScenarioFragment, unknown>;
export const BulkActionParametersFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BulkActionParameters' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'bulk_action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'params' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CustomBulkActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'EnergySourceCustomBulkActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'energySourceCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fraction' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SystemCustomBulkActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'systemCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fraction' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnergySystemRouteParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energySystemRouteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnvelopeParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'envelopeParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insulation_method' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'material_name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HydraulicBalancingParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hydraulicBalancingParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'costs_with_components' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LightingParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lightingParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'efficiency' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarParametersBulkUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'solarParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SystemParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateVentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createVentilationRenovationParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MaintenanceActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maintenanceActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ventilationRenovationParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ExclusionNoteParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exclusionNoteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'note' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_costs_per_m2' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkActionParametersFragment, unknown>;
export const BulkActionParametersForTableFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BulkActionParametersForTable' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'bulk_action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'params' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CustomBulkActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'EnergySourceCustomBulkActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'energySourceCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SystemCustomBulkActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'systemCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnergySystemRouteParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energySystemRouteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnvelopeParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'envelopeParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HydraulicBalancingParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LightingParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarParametersBulkUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SystemParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateVentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MaintenanceActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maintenanceActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ExclusionNoteParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exclusionNoteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'note' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkActionParametersForTableFragment, unknown>;
export const ActionPlanImpactTrendsWithTargetPathOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithTargetPathOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithTargetPathOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_actions_path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_actions_path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'target_path' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'annotations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'annotation_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'end_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start_year' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exclusion_note_implementation_year' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanImpactTrendsWithTargetPathOutputFragment, unknown>;
export const ActionPlanImpactTrendsWithoutTargetPathOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithoutTargetPathOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithoutTargetPathOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_actions_path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_actions_path' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'annotations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'annotation_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exclusion_note_implementation_year' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanImpactTrendsWithoutTargetPathOutputFragment, unknown>;
export const EmissionCertificateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmissionCertificateFragment, unknown>;
export const ActionPlanningScenariosScenarioFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanningScenariosScenario' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ScenarioListItemOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action_plan_count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duplication_in_progress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'can_edit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_investment' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanningScenariosScenarioFragment, unknown>;
export const SearchScenarioFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SearchScenario' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'scenario' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchScenarioFragment, unknown>;
export const SearchActionPlanFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SearchActionPlan' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action_plan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario_version' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scenario' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchActionPlanFragment, unknown>;
export const CbiPotentialBuildingMatchFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CbiPotentialBuildingMatch' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_potential_building_match' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_auto_assigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_unit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portfolio' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CbiPotentialBuildingMatchFragment, unknown>;
export const AlphaPromptInteractionFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AlphaPromptInteractionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'alpha_prompt_interaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analysis_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'started_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analysis_started_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploaded_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'extracted_raw_data' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AlphaPromptInteractionFragmentFragment, unknown>;
export const DataCollectionConsumptionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionConsumption' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'to' } },
          { kind: 'Field', name: { kind: 'Name', value: 'from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayValue' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'created_by_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'invoice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_waste_detail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_areas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'area_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionConsumptionFragment, unknown>;
export const DataCollectionAreaConsumptionDraftFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionAreaConsumptionDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'to' } },
          { kind: 'Field', name: { kind: 'Name', value: 'from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayValue' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'created_by_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_invoice_draft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'draft_status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_waste_details_draft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_draft_areas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'area_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionAreaConsumptionDraftFragment, unknown>;
export const DataCollectionBuildingEnvelopeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnvelope' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionBuildingEnvelopeFragment, unknown>;
export const EmissionCertificateWithProgressiveFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmissionCertificateWithProgressiveFragment, unknown>;
export const PrimaryEnergyFactorCertificateWithProgressiveFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PrimaryEnergyFactorCertificateWithProgressiveFragment, unknown>;
export const DataCollectionBuildingEnergySystemConsumerRouteFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_consumer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'use_renewable_energy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distribution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_distribution_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_distribution_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_storage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_storage_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'annual_heat_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionBuildingEnergySystemConsumerRouteFragment, unknown>;
export const DataCollectionBuildingEnergySystemProducerRouteFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_producer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_produced' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_producer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionBuildingEnergySystemProducerRouteFragment, unknown>;
export const DataCollectionBuildingEnergySystemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_consumer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'use_renewable_energy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distribution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_distribution_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_distribution_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_storage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_storage_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'annual_heat_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_producer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_produced' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_producer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionBuildingEnergySystemFragment, unknown>;
export const DataCollectionBuildingModelFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingModel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_model' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_draft' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action_planning_available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'internal_temperature' } },
          { kind: 'Field', name: { kind: 'Name', value: 'annual_heating_days' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'envelope_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingEnvelope' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_systems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'energy_system_type_id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystem' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_consumer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'use_renewable_energy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distribution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_distribution_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_distribution_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_storage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_storage_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'annual_heat_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_producer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_produced' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_producer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnvelope' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionBuildingModelFragment, unknown>;
export const DataCollectionBuildingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_data_source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leasehold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milieu_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heritage_district' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mapbox_building_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_citydb_gml_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neighbor_citydb_gml_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_lod1_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neighbor_lod1_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mapbox_pitch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mapbox_bearing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mapbox_zoom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'has_gml_ids' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'area_system_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'EnumValue', value: 'PREDIUM_2024' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area_system_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'is_rented' } },
                { kind: 'Field', name: { kind: 'Name', value: 'class_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data_source_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'file_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsible_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_data_source' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subsidies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subsidy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingSubsidy' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subsidies_updated_at' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'associatedBuildingsAndDrafts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_building_model' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'active_building_model_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climate_risks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uncertainty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timespan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climate_risks_aggregate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'max' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_action_plans_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'archived_at' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_is_null' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'action_plans_with_action_aggregate' },
            name: { kind: 'Name', value: 'active_action_plans_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'archived_at' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_is_null' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'actions_aggregate' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'count' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'predicate' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_gt' },
                                              value: { kind: 'IntValue', value: '0' },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_valuations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climate_risks_v2_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'api_response_status_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_neq' },
                            value: { kind: 'EnumValue', value: 'NOT_INITIALIZED' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'base_emission_factors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionFactorsPerEnergySource' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'district_heating_availability_status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'building_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'district_heating_status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'district_heating_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_models' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'id' },
                          value: { kind: 'EnumValue', value: 'asc' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_level_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnvelope' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_consumer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'use_renewable_energy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distribution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_distribution_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_distribution_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_storage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_storage_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'annual_heat_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_producer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_produced' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_producer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgressiveFactorResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressiveFactor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingSubsidy' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'subsidy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount_description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider_updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subsidy_category_type' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingModel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_model' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_draft' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action_planning_available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'internal_temperature' } },
          { kind: 'Field', name: { kind: 'Name', value: 'annual_heating_days' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'envelope_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingEnvelope' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_systems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'energy_system_type_id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystem' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionFactorsPerEnergySource' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionFactorsObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'BIO_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_FOSSIL_COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_FOSSIL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_RENEWABLE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_FOSSIL_COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_FOSSIL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ELECTRICITY_GREEN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_RENEWABLE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ELECTRICITY_MIX' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'WOODEN_PELLETS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'WOOD' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'UNSPECIFIED' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'SOLAR' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'LPG' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'NATURAL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'LIGNITE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'FUEL_OIL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionBuildingFragment, unknown>;
export const DataCollectionYearlyConsumptionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionYearlyConsumption' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'YearlyConsumption' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'providers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumption_type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionYearlyConsumptionFragment, unknown>;
export const DataCollectionConsumptionDraftConsumptionDraftFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionConsumptionDraftConsumptionDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'to' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_waste_details_draft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_draft_areas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'area_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionConsumptionDraftConsumptionDraftFragment, unknown>;
export const DataCollectionFileFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'file' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionFileFragment, unknown>;
export const DataCollectionEconomicUnitFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionEconomicUnit' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'economic_unit' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customer_economic_unit_id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionEconomicUnitFragment, unknown>;
export const BuildingModelMutationAvailabilityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModelMutationAvailability' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GetBuildingModelMutationAvailabilityOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affected_action_plans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scenario_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scenario_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scenario_updated_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildingModelMutationAvailabilityFragment, unknown>;
export const DataCollectionEmissionCertificateDraftFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionEmissionCertificateDraft' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmissionCertificateDraftWithConvertedValues' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_document_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_until' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_factor_progressive' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy_factor_progressive' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionEmissionCertificateDraftFragment, unknown>;
export const DataCollectionDocumentDraftFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionDocumentDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'file' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionDocumentDraftFragment, unknown>;
export const DataCollectionEmissionCertificateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionEmissionCertificate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'file_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionDocumentDraft' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'org' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_until' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_document_type_id' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionDocumentDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'file' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionEmissionCertificateFragment, unknown>;
export const DataCollectionEmissionCertificateListItemFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionEmissionCertificateListItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionCertificateListItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_until' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associated_action_plans_count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associated_buildings_count' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionEmissionCertificateListItemFragment, unknown>;
export const EnergySupplierAssociatedBuildingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySupplierAssociatedBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EnergySupplierAssociatedBuildingFragment, unknown>;
export const EmissionCertificateDropdownFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificateDropdownFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmissionCertificateDropdownFieldsFragment, unknown>;
export const EPCDraftFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft_status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EPCDraftFragmentFragment, unknown>;
export const EPCDraftWithFileURLFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft_status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EPCDraftWithFileURLFragmentFragment, unknown>;
export const EPCFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_commercial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_residential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EPCFragmentFragment, unknown>;
export const GetBuildingDraftFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetBuildingDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'economic_unit_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heritage_district' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milieu_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leasehold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mapbox_building_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_citydb_gml_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'neighbor_citydb_gml_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_lod1_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'neighbor_lod1_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assign_responsible_user_as_transaction_manager' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_valuations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_consumers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_draft_area_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_areas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_drafts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_level_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft_status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_commercial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_residential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBuildingDraftFragmentFragment, unknown>;
export const CustomTargetFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTarget' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTarget' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'target_definitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target_definition_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomTargetFragment, unknown>;
export const PortfolioManagementPortfolioFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PortfolioManagementPortfolio' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'economic_units_with_buildings' },
            name: { kind: 'Name', value: 'economic_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'buildings_aggregate' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'count' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'predicate' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_gt' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortfolioManagementPortfolioFragment, unknown>;
export const ReportGetReportByPkReportTemplateSectionsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplateSections' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_template_section' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parent_section_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'target' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportGetReportByPkReportTemplateSectionsFragment, unknown>;
export const ReportGetReportByPkReportTemplateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_template' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'single_building' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excel_template_path_de' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excel_template_path_en' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_sections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'order' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplateSections' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplateSections' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_template_section' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parent_section_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'target' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportGetReportByPkReportTemplateFragment, unknown>;
export const ReportGetReportByPkResponsibleUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkResponsibleUser' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'user' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportGetReportByPkResponsibleUserFragment, unknown>;
export const ReportGetReportByPkFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPk' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'end_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'start_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'due_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsible_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportGetReportByPkResponsibleUser' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_building_details' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portfolio_name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_building_details_aggregate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_and' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'state' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_eq' },
                                      value: { kind: 'EnumValue', value: 'UNANSWERED' },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: '_or' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'autofill' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: '_is_null' },
                                                value: { kind: 'BooleanValue', value: false },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'report_answer_autofill_options' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'report_template_question_option' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'value' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: '_is_null' },
                                                            value: { kind: 'BooleanValue', value: false },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'evidence_required' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplateSections' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_template_section' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parent_section_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'target' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_template' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'single_building' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excel_template_path_de' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excel_template_path_en' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_sections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'order' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplateSections' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkResponsibleUser' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'user' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportGetReportByPkFragment, unknown>;
export const ReportSectionGetRootQuestionsAndAnswersAnswersFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportSectionGetRootQuestionsAndAnswersAnswers' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_answer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'report_question_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autofill' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template_question' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'evidence_required' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer_autofill_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_option' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer_chosen_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_option' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportSectionGetRootQuestionsAndAnswersAnswersFragment, unknown>;
export const CreateReportModalGetAllTemplatesTemplateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateReportModalGetAllTemplatesTemplate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ReportTemplateOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description_en' } },
          { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'single_building' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateReportModalGetAllTemplatesTemplateFragment, unknown>;
export const ReportAnswerForAutofillFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportAnswerForAutofill' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_answer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autofill' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer_autofill_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_option' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'report_question_id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportAnswerForAutofillFragment, unknown>;
export const ReportAnswersStateFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportAnswersState' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_answer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template_question' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_section' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportAnswersStateFragment, unknown>;
export const ReportSectionsProgressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportSectionsProgress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_section_progress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'report_template_section_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportSectionsProgressFragment, unknown>;
export const SubsectionProgressFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubsectionProgress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_section_progress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template_section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubsectionProgressFragment, unknown>;
export const SearchBuildingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SearchBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'folder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchBuildingFragment, unknown>;
export const StatusQuoAnalysisPortfolioFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusQuoAnalysisPortfolio' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatusQuoAnalysisPortfolioFragment, unknown>;
export const StatusQuoAnalysisBuildingBasicDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusQuoAnalysisBuildingBasicDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mapbox_building_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_citydb_gml_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_lod1_ids' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StatusQuoAnalysisPortfolio' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsible_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'class_of_use_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_valuations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'valuation_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusQuoAnalysisPortfolio' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatusQuoAnalysisBuildingBasicDetailsFragment, unknown>;
export const BuildingCRREMConsumptionAnalysisOutputFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingCRREMConsumptionAnalysisOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GetBuildingCRREMConsumptionAnalysisOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'co2TargetPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energyTargetPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2Path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cumulativeExcessEmissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excessEmissionCostPath' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildingCRREMConsumptionAnalysisOutputFragment, unknown>;
export const BuildingDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingRowOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'types_of_use' } },
          { kind: 'Field', name: { kind: 'Name', value: 'first_stranding_year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_data' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2_costs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2_costs_total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eu_taxonomy_compliance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slf_compliant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'quick_check' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'full_check' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'report_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issued_at' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildingDetailsFragment, unknown>;
export const BuildingModelTransitionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModelTransition' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingModelTransitionOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2Intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energyIntensity' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildingModelTransitionFragment, unknown>;
export const Scope123Co2EmissionsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Scope123Co2Emissions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Scope123Co2EmissionsOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<Scope123Co2EmissionsFragment, unknown>;
export const CustomTargetsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTargets' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTargetResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomTargetsFragment, unknown>;
export const SLFAnalysisFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SLFAnalysis' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SlfComplianceAnalysisOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastSlfReport' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issuedAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ongoingReportId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'compliantFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CertificateSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EfficiencyClassSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EuTaxonomyComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issuedAt' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notCompliantFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SLFAnalysisFragment, unknown>;
export const AnalyzeBuildingCrremFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingCrremOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostDistributionPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'landlordPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenantPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyCostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyConsumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionM2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionTotal' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taxBracket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
          { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'finalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heatingDemand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climateRisks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timespan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'floorAreaByClassOfUse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'classOfUse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crremAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2TargetPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyTargetPath' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2Path' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energyPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cumulativeExcessEmissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excessEmissionCostPath' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildingModelTransitions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModelTransition' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scope123Co2Emissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wholeBuilding' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'landlord' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slfAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SLFAnalysis' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargetPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'targetPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'intersectionYear' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModelTransition' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingModelTransitionOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2Intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energyIntensity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Scope123Co2Emissions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Scope123Co2EmissionsOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTargets' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTargetResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SLFAnalysis' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SlfComplianceAnalysisOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastSlfReport' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issuedAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ongoingReportId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'compliantFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CertificateSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EfficiencyClassSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EuTaxonomyComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issuedAt' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notCompliantFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnalyzeBuildingCrremFragment, unknown>;
export const AnalyzeBuildingNationalEnergyLawFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostDistributionPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'landlordPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenantPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyCostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyConsumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionM2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionTotal' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taxBracket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
          { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'finalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heatingDemand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climateRisks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timespan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'floorAreaByClassOfUse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'classOfUse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nationalEnergyLawAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2Path' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energyPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildingModelTransitions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModelTransition' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slfAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SLFAnalysis' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModelTransition' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingModelTransitionOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2Intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energyIntensity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTargets' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTargetResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SLFAnalysis' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SlfComplianceAnalysisOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastSlfReport' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issuedAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ongoingReportId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'compliantFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CertificateSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EfficiencyClassSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EuTaxonomyComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issuedAt' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notCompliantFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnalyzeBuildingNationalEnergyLawFragment, unknown>;
export const AnalyzedBuildingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzedBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingOutputUnion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingCrremOutput' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyzeBuildingCrrem' } }],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AnalyzeBuildingNationalEnergyLawOutput' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyzeBuildingNationalEnergyLaw' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModelTransition' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingModelTransitionOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2Intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energyIntensity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Scope123Co2Emissions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Scope123Co2EmissionsOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTargets' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTargetResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SLFAnalysis' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SlfComplianceAnalysisOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastSlfReport' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issuedAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ongoingReportId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'compliantFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CertificateSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EfficiencyClassSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EuTaxonomyComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issuedAt' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notCompliantFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingCrremOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostDistributionPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'landlordPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenantPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyCostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyConsumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionM2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionTotal' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taxBracket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
          { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'finalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heatingDemand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climateRisks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timespan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'floorAreaByClassOfUse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'classOfUse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crremAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2TargetPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyTargetPath' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2Path' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energyPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cumulativeExcessEmissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excessEmissionCostPath' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildingModelTransitions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModelTransition' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scope123Co2Emissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wholeBuilding' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'landlord' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slfAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SLFAnalysis' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargetPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'targetPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'intersectionYear' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostDistributionPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'landlordPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenantPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyCostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyConsumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionM2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionTotal' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taxBracket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
          { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'finalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heatingDemand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climateRisks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timespan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'floorAreaByClassOfUse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'classOfUse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nationalEnergyLawAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2Path' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energyPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildingModelTransitions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModelTransition' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slfAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SLFAnalysis' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnalyzedBuildingFragment, unknown>;
export const BuildingsBenchmarkCrremFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingsBenchmarkCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingsBenchmarkCrremOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageFinalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averagePrimaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageHeatingDemand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageEnergyCosts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crremAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildingsBenchmarkCrremFragment, unknown>;
export const BuildingsBenchmarkNationalEnergyLawFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingsBenchmarkNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingsBenchmarkNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageFinalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averagePrimaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageHeatingDemand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageEnergyCosts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nationalEnergyLawAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildingsBenchmarkNationalEnergyLawFragment, unknown>;
export const AnalyzedBuildingsBenchMarkFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzedBuildingsBenchMark' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingsBenchmarkOutputUnion' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingsBenchmarkCrremOutput' } },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingsBenchmarkCrrem' } }],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BuildingsBenchmarkNationalEnergyLawOutput' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingsBenchmarkNationalEnergyLaw' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingsBenchmarkCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingsBenchmarkCrremOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageFinalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averagePrimaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageHeatingDemand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageEnergyCosts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crremAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingsBenchmarkNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingsBenchmarkNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageFinalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averagePrimaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageHeatingDemand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageEnergyCosts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nationalEnergyLawAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnalyzedBuildingsBenchMarkFragment, unknown>;
export const ConsumptionAllocationNationalEnergyLawCarbonEmissionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConsumptionAllocationNationalEnergyLawCarbonEmission' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConsumptionAllocationNationalEnergyLawCarbonEmission' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensityAbsolute' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConsumptionAllocationNationalEnergyLawCarbonEmissionFragment, unknown>;
export const ConsumptionAllocationCrremCarbonEmissionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConsumptionAllocationCrremCarbonEmission' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsumptionAllocationCrremCarbonEmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensityAbsolute' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConsumptionAllocationCrremCarbonEmissionFragment, unknown>;
export const StrandingDataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StrandingData' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StrandingDataOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StrandingDataFragment, unknown>;
export const AnalyzeBuildingsCrremAnalysisFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysis' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysisOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2TargetPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energyTargetPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2Path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cumulativeExcessEmissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excessEmissionCostPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope123Co2Emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'wholeBuilding' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'landlord' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strandingData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StrandingData' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Scope123Co2Emissions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Scope123Co2EmissionsOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StrandingData' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StrandingDataOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnalyzeBuildingsCrremAnalysisFragment, unknown>;
export const AnalyzeBuildingsCrremAnalysisResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysisResult' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysisResultOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crremAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysis' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargetPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'targetPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'intersectionYear' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Scope123Co2Emissions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Scope123Co2EmissionsOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StrandingData' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StrandingDataOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysis' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysisOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2TargetPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energyTargetPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2Path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cumulativeExcessEmissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excessEmissionCostPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope123Co2Emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'wholeBuilding' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'landlord' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strandingData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StrandingData' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTargets' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTargetResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnalyzeBuildingsCrremAnalysisResultFragment, unknown>;
export const AnalyzeBuildingsNationalEnergyLawAnalysisFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysis' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysisOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2Path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnalyzeBuildingsNationalEnergyLawAnalysisFragment, unknown>;
export const AnalyzeBuildingsNationalEnergyLawAnalysisResultFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysisResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysisResultOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nationalEnergyLawAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysis' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysis' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysisOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2Path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTargets' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTargetResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnalyzeBuildingsNationalEnergyLawAnalysisResultFragment, unknown>;
export const PortfolioBasicDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PortfolioBasicDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortfolioBasicDetailsFragment, unknown>;
export const EconomicUnitBasicDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EconomicUnitBasicDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'economic_unit' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customer_economic_unit_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'country_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EconomicUnitBasicDetailsFragment, unknown>;
export const GetSessionDataOrgFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetSessionDataOrg' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'org' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'org_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'org_sector_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSessionDataOrgFragment, unknown>;
export const CRREMDefaultConfigurationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CRREMDefaultConfiguration' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CRREMDefaultConfigurationObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emissionFactorType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setFor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'org' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolios' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CRREMDefaultConfigurationFragment, unknown>;
export const CRREMCustomConfigurationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CRREMCustomConfiguration' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CRREMCustomConfigurationObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setFor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'org' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolios' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CRREMCustomConfigurationFragment, unknown>;
export const AsyncJobFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AsyncJob' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'async_job' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entity_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AsyncJobFragment, unknown>;
export const AccessRightsPortfolioFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccessRightsPortfolio' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccessRightsPortfolioFragment, unknown>;
export const AccessRightsBuildingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccessRightsBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'area_type_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'EnumValue', value: 'EBF' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccessRightsBuildingFragment, unknown>;
export const ActionPlanningActionDeleteActionPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionPlanningActionDeleteActionPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteActionPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stableId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningActionDeleteActionPlanMutation,
  ActionPlanningActionDeleteActionPlanMutationVariables
>;
export const BulkDeleteActionPlansDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BulkDeleteActionPlans' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BulkDeleteActionPlansInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkDeleteActionPlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'deletedCount' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkDeleteActionPlansMutation, BulkDeleteActionPlansMutationVariables>;
export const DeleteActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteActionMutation, DeleteActionMutationVariables>;
export const SimulateTechnologyActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SimulateTechnologyAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'action_plan_stable_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'envelope_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'system_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'solar_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'custom_action_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomActionRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'maintenance_action_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MaintenanceActionParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ventilation_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'VentilationRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subsidies' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubsidyInput' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emission_factor_source' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reference_area_type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simulateAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action_plan_stable_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'action_plan_stable_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'custom_action_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'custom_action_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'envelope_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'envelope_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'system_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'system_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'solar_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'solar_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'maintenance_action_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'maintenance_action_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ventilation_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ventilation_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subsidies' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subsidies' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'implementation_to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emission_factor_source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emission_factor_source' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reference_area_type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reference_area_type' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SimulateActionOutputResponse' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesCrremOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesCRREMOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stranding_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SimulateActionOutputResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SimulateActionOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'error' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyValuesCrremOutput' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SimulateTechnologyActionMutation, SimulateTechnologyActionMutationVariables>;
export const ImplementActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ImplementAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'action_plan_stable_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_from' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'envelope_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'system_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'solar_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'custom_action_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomActionRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'maintenance_action_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MaintenanceActionParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ventilation_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'VentilationRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subsidies' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubsidyInput' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customCost' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomCostInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'implementAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action_plan_stable_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'action_plan_stable_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'implementation_from' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_from' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'implementation_to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'envelope_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'envelope_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'system_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'system_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'solar_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'solar_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'custom_action_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'custom_action_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'maintenance_action_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'maintenance_action_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ventilation_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ventilation_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subsidies' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subsidies' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customCost' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customCost' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'action_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImplementActionMutation, ImplementActionMutationVariables>;
export const SimulateEditActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SimulateEditAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'action_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'envelope_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'system_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'solar_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'custom_action_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomActionRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'maintenance_action_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MaintenanceActionParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ventilation_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'VentilationRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subsidies' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubsidyInput' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customCost' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomCostInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emission_factor_source' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reference_area_type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'simulateEditAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'action_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'implementation_to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'envelope_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'envelope_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'system_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'system_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'solar_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'solar_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'custom_action_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'custom_action_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'maintenance_action_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'maintenance_action_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ventilation_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ventilation_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subsidies' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subsidies' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customCost' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customCost' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emission_factor_source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emission_factor_source' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reference_area_type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reference_area_type' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SimulateActionOutputResponse' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesCrremOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesCRREMOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stranding_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SimulateActionOutputResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SimulateActionOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'error' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyValuesCrremOutput' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyValuesNationalEnergyLawOutput' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SimulateEditActionMutation, SimulateEditActionMutationVariables>;
export const EditActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'action_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'envelope_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'system_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'solar_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'custom_action_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomActionRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'maintenance_action_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MaintenanceActionParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ventilation_renovation_parameter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'VentilationRenovationParameterInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subsidies' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubsidyInput' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customCost' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomCostInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'action_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'implementation_to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'envelope_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'envelope_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'system_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'system_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energy_system_route_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hydraulic_balancing_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'solar_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'solar_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'custom_action_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'custom_action_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'maintenance_action_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'maintenance_action_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'create_ventilation_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ventilation_renovation_parameter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ventilation_renovation_parameter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subsidies' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subsidies' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customCost' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customCost' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EditActionOutputResponse' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EditActionOutputResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EditActionOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'error' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditActionMutation, EditActionMutationVariables>;
export const CreateActionPlanModalCreateActionPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateActionPlanModalCreateActionPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'building_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createActionPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'building_id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'stable_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateActionPlanModalCreateActionPlanMutation,
  CreateActionPlanModalCreateActionPlanMutationVariables
>;
export const CreateScenarioModalCreateScenarioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateScenarioModalCreateScenario' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portfolio_id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createScenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portfolio_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolio_id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'description' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateScenarioModalCreateScenarioMutation,
  CreateScenarioModalCreateScenarioMutationVariables
>;
export const ActionPlanningScenarioDeleteScenarioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionPlanningScenarioDeleteScenario' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteScenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningScenarioDeleteScenarioMutation,
  ActionPlanningScenarioDeleteScenarioMutationVariables
>;
export const ActionPlanningScenarioArchiveScenarioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionPlanningScenarioArchiveScenario' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archiveScenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningScenarioArchiveScenarioMutation,
  ActionPlanningScenarioArchiveScenarioMutationVariables
>;
export const ActionPlanningScenarioUnarchiveScenarioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActionPlanningScenarioUnarchiveScenario' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unarchiveScenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningScenarioUnarchiveScenarioMutation,
  ActionPlanningScenarioUnarchiveScenarioMutationVariables
>;
export const UpdateScenarioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateScenario' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateScenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'description' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateScenarioMutation, UpdateScenarioMutationVariables>;
export const DuplicateScenarioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DuplicateScenario' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'copyNameSuffix' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicateScenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'copy_name_suffix' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'copyNameSuffix' } },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DuplicateScenarioMutation, DuplicateScenarioMutationVariables>;
export const UpdateScenarioToLatestVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateScenarioToLatestVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateScenarioToLatestVersion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateScenarioToLatestVersionMutation, UpdateScenarioToLatestVersionMutationVariables>;
export const CreateBulkActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBulkAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BulkActionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'bulkActionId' },
            name: { kind: 'Name', value: 'createBulkAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBulkActionMutation, CreateBulkActionMutationVariables>;
export const EditBulkActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditBulkAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BulkActionEditInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editBulkAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditBulkActionMutation, EditBulkActionMutationVariables>;
export const DeleteBulkActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBulkAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBulkAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteBulkActionMutation, DeleteBulkActionMutationVariables>;
export const CreateExclusionNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateExclusionNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'implementationTo' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createExclusionNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action_plan_stable_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'implementation_to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'implementationTo' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'note' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'action_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateExclusionNoteMutation, CreateExclusionNoteMutationVariables>;
export const EditExclusionNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditExclusionNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'implementationTo' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editExclusionNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'implementation_to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'implementationTo' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'note' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditExclusionNoteMutation, EditExclusionNoteMutationVariables>;
export const GetSearchBuildingsForCreateActionPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSearchBuildingsForCreateActionPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search_string' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portfolio_ids' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
          },
          defaultValue: { kind: 'NullValue' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingOrderByInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'include_new_construction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBuildingsForCreateActionPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'portfolio_ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolio_ids' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search_string' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search_string' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'include_new_construction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'include_new_construction' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'has_energy_data' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action_planning_available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSearchBuildingsForCreateActionPlanQuery,
  GetSearchBuildingsForCreateActionPlanQueryVariables
>;
export const ActionPlanningActionPlanGetActionPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionPlanningActionPlanGetActionPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActionPlanByStableId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stableId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action_plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionPlanningActionPlanActionPlan' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeUnit' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyConsumerForAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_consumer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'energy_consumer_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_consumer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyConsumerForAction' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_distribution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_producer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_model' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'envelope_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeUnit' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system_consumer_routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_system' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distributions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_systems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergySystem' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_by_ventilation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgressiveFactorResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressiveFactor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionFactorsPerEnergySource' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionFactorsObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'BIO_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_FOSSIL_COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_FOSSIL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_RENEWABLE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_FOSSIL_COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_FOSSIL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ELECTRICITY_GREEN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_RENEWABLE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ELECTRICITY_MIX' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'WOODEN_PELLETS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'WOOD' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'UNSPECIFIED' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'SOLAR' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'LPG' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'NATURAL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'LIGNITE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'FUEL_OIL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingSubsidy' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'subsidy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount_description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider_updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subsidy_category_type' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanningActionPlanActionPlan' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action_plan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario_version' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scenario' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action_plan_inconsistencies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_supplier_inconsistencies' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'class_of_use_id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'active_building_model' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModel' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'base_emission_factors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionFactorsPerEnergySource' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'units' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subsidies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subsidy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingSubsidy' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'district_heating_availability_status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'building_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'district_heating_status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'district_heating_year' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_unit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portfolio' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningActionPlanGetActionPlanQuery,
  ActionPlanningActionPlanGetActionPlanQueryVariables
>;
export const ActionPlanningActionPlanGetActionPlanForCompareDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionPlanningActionPlanGetActionPlanForCompare' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActionPlanByStableId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stableId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action_plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ActionPlanningActionPlanActionPlanForCompare' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanningActionPlanActionPlanForCompare' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action_plan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario_version' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cost_version' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scenario' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portfolio' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningActionPlanGetActionPlanForCompareQuery,
  ActionPlanningActionPlanGetActionPlanForCompareQueryVariables
>;
export const ActionPlanProcessingSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ActionPlanProcessingSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action_plan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'stable_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanProcessingSubscriptionSubscription,
  ActionPlanProcessingSubscriptionSubscriptionVariables
>;
export const ActionPlanningGetSubsidiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionPlanningGetSubsidies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActionPlanByStableId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stableId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action_plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subsidies' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ActionPlanningActionSubsidy' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanningActionSubsidy' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action_subsidy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subsidy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subsidy_category_type' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'renovations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cost_total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cost_total_predium' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'renovation_type_id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanningGetSubsidiesQuery, ActionPlanningGetSubsidiesQueryVariables>;
export const ActionPlanningScenarioGetScenarioCostUpdateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ActionPlanningScenarioGetScenarioCostUpdateSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cost_update_in_progress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scenario_versions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'status' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'EnumValue', value: 'ACTIVE' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cost_version' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningScenarioGetScenarioCostUpdateSubscriptionSubscription,
  ActionPlanningScenarioGetScenarioCostUpdateSubscriptionSubscriptionVariables
>;
export const DuplicateScenarioSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'DuplicateScenarioSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'duplication_in_progress' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DuplicateScenarioSubscriptionSubscription,
  DuplicateScenarioSubscriptionSubscriptionVariables
>;
export const GetActionPlanListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActionPlanList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionPlanListOrderByInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchString' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActionPlanList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenarioId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchString' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchString' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingWhere' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action_plans' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modification_impact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'co2_emissions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'final_energy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primary_energy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'efficiency_class' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'action_plan' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active_scenario' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'scenario' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'building' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'areas' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'where' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: 'area_type_id' },
                                              value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                  {
                                                    kind: 'ObjectField',
                                                    name: { kind: 'Name', value: '_eq' },
                                                    value: { kind: 'EnumValue', value: 'EBF' },
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'class_of_use_id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'economic_unit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actions_aggregate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'aggregate' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'max' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sum' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'cost_total' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'renovations' },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: { kind: 'Name', value: 'limit' },
                                              value: { kind: 'IntValue', value: '1' },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'renovation_type_id' } },
                                            ],
                                          },
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'implementation_to' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActionPlanListQuery, GetActionPlanListQueryVariables>;
export const ActionPlanningScenariosAllScenariosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionPlanningScenariosAllScenarios' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ScenarioWhere' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ScenarioOrderByInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getScenarioList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scenarios' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionPlanningScenariosScenario' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanningScenariosScenario' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ScenarioListItemOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action_plan_count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'duplication_in_progress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_archived' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'can_edit' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_investment' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningScenariosAllScenariosQuery,
  ActionPlanningScenariosAllScenariosQueryVariables
>;
export const ActionPlanningScenarioGetScenarioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionPlanningScenarioGetScenario' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getScenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duplication_in_progress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'is_archived' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scenario_versions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cost_version' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'building_count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'can_edit' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanningScenarioGetScenarioQuery, ActionPlanningScenarioGetScenarioQueryVariables>;
export const ActionPlanningScenariosByPortfolioIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionPlanningScenariosByPortfolioId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'scenario_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'scenarios' },
            name: { kind: 'Name', value: 'scenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningScenariosByPortfolioIdQuery,
  ActionPlanningScenariosByPortfolioIdQueryVariables
>;
export const GetScenarioActionPlanAndActionsCountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScenarioActionPlanAndActionsCounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getScenarioActionPlanAndActionsCounts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'action_plan_count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scenario_actions_count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetScenarioActionPlanAndActionsCountsQuery,
  GetScenarioActionPlanAndActionsCountsQueryVariables
>;
export const ActionPlanningScenariosGetPortfoliosWithScenariosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionPlanningScenariosGetPortfoliosWithScenarios' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'archived_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'distinct_on' },
                value: { kind: 'EnumValue', value: 'portfolio_id' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portfolio_id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningScenariosGetPortfoliosWithScenariosQuery,
  ActionPlanningScenariosGetPortfoliosWithScenariosQueryVariables
>;
export const ActionPlanningScenariosGetPortfoliosWithArchivedScenariosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionPlanningScenariosGetPortfoliosWithArchivedScenarios' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'archived_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'distinct_on' },
                value: { kind: 'EnumValue', value: 'portfolio_id' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portfolio_id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActionPlanningScenariosGetPortfoliosWithArchivedScenariosQuery,
  ActionPlanningScenariosGetPortfoliosWithArchivedScenariosQueryVariables
>;
export const ActionPlanningScenariosNamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActionPlanningScenariosNames' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'archived_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActionPlanningScenariosNamesQuery, ActionPlanningScenariosNamesQueryVariables>;
export const SearchScenariosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchScenarios' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_ilike' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'archived_at' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SearchScenario' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SearchScenario' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'scenario' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchScenariosQuery, SearchScenariosQueryVariables>;
export const SearchActionPlansDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchActionPlans' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action_plan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'building' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'address' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'street' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_ilike' },
                                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'building' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'address' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'city' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_ilike' },
                                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'building' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'address' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'postal_code' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_ilike' },
                                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'building' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'customer_external_identifier' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_ilike' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'distinct_on' },
                value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'stable_id' }] },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'stable_id' },
                          value: { kind: 'EnumValue', value: 'asc' },
                        },
                      ],
                    },
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'building' },
                          value: {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'address' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'street' },
                                      value: { kind: 'EnumValue', value: 'asc' },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SearchActionPlan' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SearchActionPlan' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action_plan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario_version' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scenario' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchActionPlansQuery, SearchActionPlansQueryVariables>;
export const GetAnalyzeScenarioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAnalyzeScenario' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emission_factor_source' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNewConstruction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedScenario' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emission_factor_source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emission_factor_source' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeNewConstruction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNewConstruction' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyzedScenario' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzedScenario' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeScenarioOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'building_count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_floor_area' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modification_impact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'final_energy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2_emissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primary_energy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAnalyzeScenarioQuery, GetAnalyzeScenarioQueryVariables>;
export const CreateActionPlanModalGetBuildingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateActionPlanModalGetBuildings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_bool_exp' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_order_by' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'active_building_model' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action_planning_available' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class_id' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateActionPlanModalGetBuildingsQuery, CreateActionPlanModalGetBuildingsQueryVariables>;
export const QueueExportActionPlanPdfDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'QueueExportActionPlanPdf' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'useCustomTargetPath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'queueExportActionPlanAsPdf' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'actionPlanStableId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'useCustomTargetPath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'useCustomTargetPath' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'asyncJobId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueueExportActionPlanPdfMutation, QueueExportActionPlanPdfMutationVariables>;
export const GetActionsPlanMetricsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActionsPlanMetrics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActionPlanMetrics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stable_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reference_area_type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emission_factor_source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionPlanMetrics' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CostByRenovationCategory' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CostByRenovationCategoryOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'series' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'values' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actionsCount' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legend' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionsCount' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_date' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ModificationImpactNationalEnergyLaw' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanImpactDataOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionPlanImpactDataOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'total_renovation_cost' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cost_by_renovation_category' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CostByRenovationCategory' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_subsidy_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_floor_area' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modification_impact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionImpactDataOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionImpactDataOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_renovation_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_subsidy_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total_floor_area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'modification_impact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactCrrem' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ModificationImpactsNationalEnergyLaw' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanMetrics' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionPlanMetricsOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action_plan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionPlanImpactDataOutput' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionImpactDataOutput' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActionsPlanMetricsQuery, GetActionsPlanMetricsQueryVariables>;
export const GetActionsPlanImpactTrendsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActionsPlanImpactTrends' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActionPlanImpactTrends' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stableId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2_emissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithTargetPathOutput' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithoutTargetPathOutput' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primary_energy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'after_actions_path' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'before_actions_path' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'annotations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'annotation_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'exclusion_note_implementation_year' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'final_energy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithTargetPathOutput' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithoutTargetPathOutput' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'trend_start_year' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custom_targets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total_investment_cost' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithTargetPathOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithTargetPathOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_actions_path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_actions_path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'target_path' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'annotations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'annotation_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_ranges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'end_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start_year' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exclusion_note_implementation_year' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithoutTargetPathOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ActionPlanImpactTrendsWithoutTargetPathOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_actions_path' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_actions_path' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'annotations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'annotation_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'exclusion_note_implementation_year' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTargets' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTargetResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActionsPlanImpactTrendsQuery, GetActionsPlanImpactTrendsQueryVariables>;
export const GetActionsForActionPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActionsForActionPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActionPlanByStableId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stableId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action_plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actions' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'order' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Action' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SolarRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'costs_with_components' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'VentilationRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VentilationRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExclusionNoteParameterObject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ExclusionNoteParameterObject' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'note' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionParameters' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parameters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CustomActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'EnergySourceCustomActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'energySourceCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fraction' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SystemCustomActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'systemCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fraction' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnergySystemRouteParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energySystemRouteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemParametersUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'SystemRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarParametersUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'solarParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SolarRenovationParameterObject' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HydraulicBalancingParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hydraulicBalancingParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeParametersUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'envelopeParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'EnvelopeRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MaintenanceActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maintenanceActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ventilationRenovationParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'VentilationRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateVentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createVentilationRenovationParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'CreateVentilationRenovationParameterObject' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ExclusionNoteParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exclusionNoteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ExclusionNoteParameterObject' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergyConsumerForAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_consumer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeUnit' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeRenovation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'renovation_envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'new_envelope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_method_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
                { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'old_entity_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'old_envelope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building_model' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'envelope_units' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'id' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeUnit' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'energy_consumer_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_consumer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyConsumerForAction' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_distribution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_producer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_model' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'envelope_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeUnit' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_system_consumer_routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_system' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distributions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'balancing_with_components' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_systems' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergySystem' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_by_ventilation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Action' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'implementation_to' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_action_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_saving_fraction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bulk_action_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulk_action' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'renovation_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost_total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost_total_predium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost_total_custom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'use_custom_cost' } },
              ],
            },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionParameters' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations_energy_consumer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'new_energy_consumer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyConsumerForAction' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'old_energy_consumer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergyConsumerForAction' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations_envelope' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeRenovation' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations_energy_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'new_energy_system_route' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_system' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'old_energy_system_route' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_system' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations_energy_producer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'new_energy_producer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_models' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModel' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActionsForActionPlanQuery, GetActionsForActionPlanQueryVariables>;
export const GetStrandingYearDistributionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetStrandingYearDistribution' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getStrandingYearDistribution' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionSourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buildingCounts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetStrandingYearDistributionQuery, GetStrandingYearDistributionQueryVariables>;
export const GetHeatingEnergySourceDevelopmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetHeatingEnergySourceDevelopment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getHeatingEnergySourceDevelopment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionSourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetHeatingEnergySourceDevelopmentQuery, GetHeatingEnergySourceDevelopmentQueryVariables>;
export const GetFloorAreaDevelopmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFloorAreaDevelopment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNewConstruction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFloorAreaDevelopment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionSourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeNewConstruction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNewConstruction' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalBuildings' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newConstructionBuildings' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excludedSincePreviousYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFloorAreaDevelopmentQuery, GetFloorAreaDevelopmentQueryVariables>;
export const GetEfficiencyClassSplitDevelopmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEfficiencyClassSplitDevelopment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEfficiencyClassSplitDevelopment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionSourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEfficiencyClassSplitDevelopmentQuery, GetEfficiencyClassSplitDevelopmentQueryVariables>;
export const GetActionsForRecommendedActionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActionsForRecommendedActions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActionPlanByStableId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stableId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'actionPlanStableId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action_plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actions' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'order' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ActionForRecommendedAction' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionForRecommendedAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'implementation_to' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renovations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'renovation_type_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActionsForRecommendedActionsQuery, GetActionsForRecommendedActionsQueryVariables>;
export const GetRecommendedActionsForBuildingModelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRecommendedActionsForBuildingModel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'action_plan_stable_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_date' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sorting' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'recommended_action_sorting_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emission_source_type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reference_area_type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendActions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action_plan_stable_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'action_plan_stable_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'implementation_date' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_date' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sorting' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sorting' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emission_source_type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emission_source_type' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reference_area_type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reference_area_type' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendedActions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RecommendedAction' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BeforeAfterImpact' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BeforeAfterDataWithImpactOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'after' } },
          { kind: 'Field', name: { kind: 'Name', value: 'after_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before' } },
          { kind: 'Field', name: { kind: 'Name', value: 'before_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
          { kind: 'Field', name: { kind: 'Name', value: 'impact_total' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedActionImpactOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RecommendedActionImpactCrremOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stranding_date' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'efficiency_class' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_cost_total' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'impact' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heating_demand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BeforeAfterImpact' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'total_estimated_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_abatement_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payback_period' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SystemRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SystemRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SolarRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
          { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameter' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'costs_with_components' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnvelopeRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateVentilationRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateVentilationRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UpdateVentilationRenovationParameter' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateVentilationRenovationParameterOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_consumer_technology_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ventilation_efficiency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecommendedAction' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RecommendedAction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actionImpact' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RecommendedActionImpactOutput' } },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RecommendedActionImpactNationalEnergyLawOutput' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'parameters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnergySystemRouteRenovationParameter' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SystemRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SystemRenovationParameter' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarRenovationParameterOutput' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SolarRenovationParameter' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'HydraulicBalancingRenovationParameter' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnvelopeRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EnvelopeRenovationParameter' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateVentilationRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CreateVentilationRenovationParameter' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'UpdateVentilationRenovationParameterOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'UpdateVentilationRenovationParameter' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRecommendedActionsForBuildingModelQuery,
  GetRecommendedActionsForBuildingModelQueryVariables
>;
export const GetEditActionStatusQuoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEditActionStatusQuo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'action_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emission_factor_source' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reference_area_type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEditStatusQuo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'action_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'new_date' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emission_factor_source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emission_factor_source' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reference_area_type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reference_area_type' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SimulateActionStatusQuoOutputResponse' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesCrremOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesCRREMOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stranding_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SimulateActionStatusQuoOutputResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SimulateActionStatusQuoOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'error' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BaseEnergyValuesCrremOutput' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEditActionStatusQuoQuery, GetEditActionStatusQuoQueryVariables>;
export const GetCreateActionStatusQuoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCreateActionStatusQuo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'action_plan_stable_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emission_factor_source' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reference_area_type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCreateStatusQuo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action_plan_stable_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'action_plan_stable_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'new_date' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'implementation_to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emission_factor_source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emission_factor_source' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reference_area_type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reference_area_type' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SimulateActionStatusQuoOutputResponse' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesCrremOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesCRREMOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stranding_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
          { kind: 'Field', name: { kind: 'Name', value: 'renovation_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final_cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_tax_cost' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SimulateActionStatusQuoOutputResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SimulateActionStatusQuoOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'error' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BaseEnergyValuesCrremOutput' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BaseEnergyValuesNationalEnergyLawOutput' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCreateActionStatusQuoQuery, GetCreateActionStatusQuoQueryVariables>;
export const GetBulkActionItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBulkActionItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'bulk_actions_overview_bool_exp' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'bulk_actions_overview_order_by' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulk_actions_overview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'action_plan_id' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'action_plan_status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bulk_action_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action_plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulk_actions_overview_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBulkActionItemsQuery, GetBulkActionItemsQueryVariables>;
export const GetBulkActionParametersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBulkActionParameters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulk_actions_overview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bulk_action_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bulk_action' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BulkActionParameters' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'implementation_date' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'total_count' },
            name: { kind: 'Name', value: 'bulk_actions_overview_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bulk_action_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'planned_count' },
            name: { kind: 'Name', value: 'bulk_actions_overview_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bulk_action_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan_status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'StringValue', value: 'PLANNED', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'not_planned_count' },
            name: { kind: 'Name', value: 'bulk_actions_overview_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bulk_action_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan_status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'StringValue', value: 'FAILED', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'deletion_failled_count' },
            name: { kind: 'Name', value: 'bulk_actions_overview_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bulk_action_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan_status' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'StringValue', value: 'DELETION_FAILED', block: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BulkActionParameters' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'bulk_action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'params' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CustomBulkActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'EnergySourceCustomBulkActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'energySourceCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fraction' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SystemCustomBulkActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'systemCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'custom_name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fraction' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnergySystemRouteParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energySystemRouteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnvelopeParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'envelopeParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insulation_method' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'material_name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HydraulicBalancingParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hydraulicBalancingParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'costs_with_components' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LightingParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lightingParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'efficiency' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarParametersBulkUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'solarParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'module_peak_power' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roof_area_ratio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SystemParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateVentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createVentilationRenovationParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MaintenanceActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maintenanceActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ventilationRenovationParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'consumer_technology_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number_of_units' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'renovation_ids' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ExclusionNoteParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exclusionNoteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'note' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_costs_per_m2' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBulkActionParametersQuery, GetBulkActionParametersQueryVariables>;
export const GetActionPlanTabsCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActionPlanTabsCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_action_plans_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_bulk_actions_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActionPlanTabsCountQuery, GetActionPlanTabsCountQueryVariables>;
export const GetBulkActionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBulkActions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'active_bulk_actions_bool_exp' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'active_bulk_actions_order_by' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_bulk_actions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bulk_action' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'implementation_date' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'total_cost' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'total_count' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'planned_count' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pending_count' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'failed_count' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deletion_pending_count' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deletion_failed_count' } },
                          ],
                        },
                      },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BulkActionParametersForTable' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_bulk_actions_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BulkActionParametersForTable' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'bulk_action' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'params' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CustomBulkActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'EnergySourceCustomBulkActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'energySourceCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'SystemCustomBulkActionParametersUnionMember' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'systemCustomActionParameters' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnergySystemRouteParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energySystemRouteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_source_type' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EnvelopeParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'envelopeParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'envelope_type' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'HydraulicBalancingParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'LightingParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SolarParametersBulkUnionMember' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SystemParametersBulkUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'system_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'technology_name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CreateVentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MaintenanceActionParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'maintenanceActionParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'custom_name' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'VentilationRenovationParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ExclusionNoteParametersUnionMember' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exclusionNoteParameters' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'note' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBulkActionsQuery, GetBulkActionsQueryVariables>;
export const GetBulkActionSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'GetBulkActionSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulk_action' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'summary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total_count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'planned_count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'failed_count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total_cost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pending_count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deletion_pending_count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deletion_failed_count' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBulkActionSummarySubscription, GetBulkActionSummarySubscriptionVariables>;
export const GetActionPlanProcessingStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'GetActionPlanProcessingStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulk_actions_overview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'stable_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'stableId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'action_plan_status' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetActionPlanProcessingStatusSubscription,
  GetActionPlanProcessingStatusSubscriptionVariables
>;
export const GetScenarioBulkActionProcessingStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'GetScenarioBulkActionProcessingStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_bulk_actions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bulk_action' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'pending_count' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'deletion_pending_count' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetScenarioBulkActionProcessingStatusSubscription,
  GetScenarioBulkActionProcessingStatusSubscriptionVariables
>;
export const getDistrictHeatingEmissionCertificatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDistrictHeatingEmissionCertificates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'EnumValue', value: 'DISTRICT_HEATING' },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'emission_factor' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'primary_energy_factor' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionCertificate' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getDistrictHeatingEmissionCertificatesQuery,
  getDistrictHeatingEmissionCertificatesQueryVariables
>;
export const getGreenElectricityEmissionCertificatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getGreenElectricityEmissionCertificates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'EnumValue', value: 'ELECTRICITY_GREEN' },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'emission_factor' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'primary_energy_factor' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionCertificate' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getGreenElectricityEmissionCertificatesQuery,
  getGreenElectricityEmissionCertificatesQueryVariables
>;
export const GetActionPlansForBuildingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActionPlansForBuilding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_action_plans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'archived_at' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_is_null' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'created_at' },
                            value: { kind: 'EnumValue', value: 'desc' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action_plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'stable_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scenario' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'owner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActionPlansForBuildingQuery, GetActionPlansForBuildingQueryVariables>;
export const GetBuildingsForBulkActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBuildingsForBulkAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhereDisabled' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingOrderByInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skipDisabled' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBuildingList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_final' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'where' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'area_type_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: { kind: 'EnumValue', value: 'EBF' },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'economic_unit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'portfolio' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'getBuildingList_disabled' },
            name: { kind: 'Name', value: 'getBuildingList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhereDisabled' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'skip' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'skipDisabled' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBuildingsForBulkActionQuery, GetBuildingsForBulkActionQueryVariables>;
export const GetBuildingsForRecreateTableSelectionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBuildingsForRecreateTableSelection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bulkActionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBuildingList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portfolio_ids' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioIds' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'getBuildingList_disabled' },
            name: { kind: 'Name', value: 'getBuildingList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portfolio_ids' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioIds' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_planning_available' },
                      value: { kind: 'ListValue', values: [{ kind: 'BooleanValue', value: false }] },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulk_actions_overview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bulk_action_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'bulkActionId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action_plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'building_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBuildingsForRecreateTableSelectionQuery,
  GetBuildingsForRecreateTableSelectionQueryVariables
>;
export const GetCo2EmissionsImpactTrendDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCo2EmissionsImpactTrend' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNewConstruction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCo2EmissionsImpactTrend' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionSourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeNewConstruction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNewConstruction' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target_path' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custom_target' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCo2EmissionsImpactTrendQuery, GetCo2EmissionsImpactTrendQueryVariables>;
export const GetFinalEnergyImpactTrendDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFinalEnergyImpactTrend' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNewConstruction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFinalEnergyImpactTrend' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionSourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeNewConstruction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNewConstruction' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target_path' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custom_target' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFinalEnergyImpactTrendQuery, GetFinalEnergyImpactTrendQueryVariables>;
export const GetPrimaryEnergyImpactTrendDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPrimaryEnergyImpactTrend' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeNewConstruction' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPrimaryEnergyImpactTrend' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionSourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeNewConstruction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeNewConstruction' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'after' } },
                { kind: 'Field', name: { kind: 'Name', value: 'before' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custom_target' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPrimaryEnergyImpactTrendQuery, GetPrimaryEnergyImpactTrendQueryVariables>;
export const GetCostByRenovationCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCostByRenovationCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCostByRenovationCategory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenarioId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CostByRenovationCategory' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CostByRenovationCategory' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CostByRenovationCategoryOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'series' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'values' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'actionsCount' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'legend' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actionsCount' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCostByRenovationCategoryQuery, GetCostByRenovationCategoryQueryVariables>;
export const CanDeleteBulkActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CanDeleteBulkAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canDeleteBulkAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CanDeleteBulkActionQuery, CanDeleteBulkActionQueryVariables>;
export const CanEditBulkActionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CanEditBulkAction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canEditBulkAction' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CanEditBulkActionQuery, CanEditBulkActionQueryVariables>;
export const GetScenarioInvestmentCostDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScenarioInvestmentCost' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getScenarioInvestmentCost' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionSourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionSourceType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetScenarioInvestmentCostQuery, GetScenarioInvestmentCostQueryVariables>;
export const GetActionPlanInvestmentCostDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActionPlanInvestmentCost' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stable_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActionPlanInvestmentCost' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stable_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'stable_id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startYear' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActionPlanInvestmentCostQuery, GetActionPlanInvestmentCostQueryVariables>;
export const GetScenarioCustomTargetPathDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScenarioCustomTargetPath' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getScenarioCustomTargetPath' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scenario_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scenario_id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'targetPath' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetScenarioCustomTargetPathQuery, GetScenarioCustomTargetPathQueryVariables>;
export const GetActionPlanCustomTargetPathDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActionPlanCustomTargetPath' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stable_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActionPlanCustomTargetPath' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stable_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'stable_id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'targetPath' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActionPlanCustomTargetPathQuery, GetActionPlanCustomTargetPathQueryVariables>;
export const deleteCBIInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteCBIInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCBIInvoice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invoiceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orgId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<deleteCBIInvoiceMutation, deleteCBIInvoiceMutationVariables>;
export const EditSnapshotDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditSnapshot' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'extractionState' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_manual_review_state_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EditInvoiceSnapshotData' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'editReason' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editSnapshot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'extractionState' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'extractionState' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'editReason' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'editReason' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditSnapshotMutation, EditSnapshotMutationVariables>;
export const EditAddressAssignmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditAddressAssignments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assignments' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignBuildingAddressInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editAddressAssignments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assignments' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'assignments' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditAddressAssignmentsMutation, EditAddressAssignmentsMutationVariables>;
export const FlagDuplicateInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FlagDuplicateInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'duplicate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateDuplicate' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDuplicateInvoice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invoiceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'duplicate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'duplicate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'invoiceId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FlagDuplicateInvoiceMutation, FlagDuplicateInvoiceMutationVariables>;
export const TriggerCbiExportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TriggerCbiExport' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerCbiExport' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TriggerCbiExportMutation, TriggerCbiExportMutationVariables>;
export const CbiExportStatusSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'CbiExportStatusSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'exportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_export_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'exportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CbiExportStatusSubscriptionSubscription, CbiExportStatusSubscriptionSubscriptionVariables>;
export const GetCbiExportDownloadUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCbiExportDownloadUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'exportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_export_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'exportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCbiExportDownloadUrlQuery, GetCbiExportDownloadUrlQueryVariables>;
export const CreateInvoiceSnapshotDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateInvoiceSnapshot' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'extractionType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_extraction_type_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'setActive' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createInvoiceSnapshot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invoiceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'extractionType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'extractionType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orgId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'setActive' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'setActive' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateInvoiceSnapshotMutation, CreateInvoiceSnapshotMutationVariables>;
export const SetAsOriginalInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAsOriginalInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setDuplicateAsOriginalInvoice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invoiceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'invoiceId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetAsOriginalInvoiceMutation, SetAsOriginalInvoiceMutationVariables>;
export const GetConsumptionInvoicesInProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionInvoicesInProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_invoice_order_by' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_invoice_bool_exp' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'email' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'received_at' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cbi_invoice_snapshots' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'extraction_state' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionInvoicesInProgressQuery, GetConsumptionInvoicesInProgressQueryVariables>;
export const GetConsumptionInvoicesOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionInvoicesOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_invoice_snapshot_order_by' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_invoice_snapshot_bool_exp' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice_snapshot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extraction_state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invoice_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invoice_date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cbi_invoice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'file' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'email' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'received_at' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cbi_consumption_lines' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'building_address' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice_snapshot_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionInvoicesOverviewQuery, GetConsumptionInvoicesOverviewQueryVariables>;
export const GetSnapshotConsumptionLinesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSnapshotConsumptionLines' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_consumption_line_order_by' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_consumption_line_bool_exp' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_consumption_line' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consumption_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consumption_start_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consumption_end_date' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cbi_invoice_snapshot' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cbi_invoice_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoice_type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cbi_invoice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'received_at' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_consumption_line_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSnapshotConsumptionLinesQuery, GetSnapshotConsumptionLinesQueryVariables>;
export const GetConsumptionSnapshotDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionSnapshot' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice_snapshot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cbi_invoice' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'is_active' },
                          value: { kind: 'EnumValue', value: 'desc' },
                        },
                      ],
                    },
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'id' },
                          value: { kind: 'EnumValue', value: 'desc' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invoice_number' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invoice_reference' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invoice_date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extraction_state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'is_active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'edit_reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extraction_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extraction_needs_review_reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'invoice_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_cost_net' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_cost_gross' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vat_percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vat_amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'advance_payments' } },
                { kind: 'Field', name: { kind: 'Name', value: 'outstanding_balance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'credit_amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2_fee_net' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2_fee_gross' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount_payable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'operational_control' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cbi_invoice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duplicate_of_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duplicate_reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duplicate_reason_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'file' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'email' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'received_at' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'duplicates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duplicate_reason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duplicate_reason_type' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'file' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cbi_consumption_lines' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'line_index' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'line_index' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'building_address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cbi_address_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cbi_invoice_snapshot_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'water_sub_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consumption_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consumption_start_date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consumption_end_date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consumption_amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'meter_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cost_net' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cost_gross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vat_percentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vat_amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'advance_payments' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'outstanding_balance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'credit_amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount_payable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'base_price_net' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'working_price_net' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'co2_fee_net' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'co2_fee_gross' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'other_charges_net' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_sub_type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_quantity_unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_container_size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_container_size_unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_container_count' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_collection_frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_collection_frequency_raw' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_collection_frequency_period' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_collections_total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'waste_ewc_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reference_area' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'is_estimated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'is_advance_payment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'market_location_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_market_based' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'renewable_energy_percentage' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cbi_address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address_string' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'assignments' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'building' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'address' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'customer_external_identifier' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'economic_unit' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'customer_economic_unit_id' },
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'portfolio' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validationIssues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'invoice' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ruleName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'field' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lineIndex' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'ruleName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'alpha_prompt_interactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AlphaPromptInteractionFragment' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duplicate_of_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duplicate_reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duplicate_reason_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'email' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'received_at' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AlphaPromptInteractionFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'alpha_prompt_interaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analysis_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'started_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'analysis_started_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploaded_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'extracted_raw_data' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionSnapshotQuery, GetConsumptionSnapshotQueryVariables>;
export const GetConsumptionAddressesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionAddresses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_address_order_by' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_address_bool_exp' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_address' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address_string' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'assignment_count' },
                  name: { kind: 'Name', value: 'assignments_aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aggregate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignments' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'building' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'address' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'street' },
                                        value: { kind: 'EnumValue', value: 'asc' },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'potential_matches' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CbiPotentialBuildingMatch' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_address_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CbiPotentialBuildingMatch' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_potential_building_match' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_auto_assigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_unit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portfolio' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionAddressesQuery, GetConsumptionAddressesQueryVariables>;
export const GetCbiAddressByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCbiAddressById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_address' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address_string' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'potential_matches' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'building' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'address' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'street' },
                                        value: { kind: 'EnumValue', value: 'asc' },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CbiPotentialBuildingMatch' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CbiPotentialBuildingMatch' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_potential_building_match' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_auto_assigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_unit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portfolio' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCbiAddressByIdQuery, GetCbiAddressByIdQueryVariables>;
export const GetInvoicesForDuplicateSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetInvoicesForDuplicateSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_invoice_bool_exp' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cbi_invoice_snapshots' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'is_active' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoice_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetInvoicesForDuplicateSearchQuery, GetInvoicesForDuplicateSearchQueryVariables>;
export const GetDuplicateInvoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDuplicateInvoices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_invoice_order_by' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_invoice_bool_exp' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duplicate_of_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duplicate_reason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duplicate_reason_type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'email' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'received_at' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cbi_invoice_snapshots' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'is_active' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoice_number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoice_date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'extraction_state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cbi_consumption_lines' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'building_address' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDuplicateInvoicesQuery, GetDuplicateInvoicesQueryVariables>;
export const GetAssociatedInvoicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAssociatedInvoices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'cbi_invoice_order_by' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cbiAddressId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'duplicate_of_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cbi_invoice_snapshots' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'is_active' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cbi_consumption_lines' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'cbi_address' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'cbiAddressId' },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'email' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cbi_invoice_snapshots' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'is_active' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoice_number' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cbi_invoice_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'duplicate_of_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cbi_invoice_snapshots' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cbi_consumption_lines' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'cbi_address' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'cbiAddressId' },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAssociatedInvoicesQuery, GetAssociatedInvoicesQueryVariables>;
export const GetConsumptionOverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsumptionOverviewOrderByInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsumptionOverviewWhere' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionOverview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rows' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'consumptionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cbiInvoiceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'economicUnitName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sourceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoiceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoiceNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consumptionType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastEdited' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'referenceAreaType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'areaName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionOverviewQuery, GetConsumptionOverviewQueryVariables>;
export const GetManualConsumptionEntryDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetManualConsumptionEntryDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption_areas' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'area_id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption_waste_detail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetManualConsumptionEntryDetailsQuery, GetManualConsumptionEntryDetailsQueryVariables>;
export const GetWritableBuildingOptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetWritableBuildingOptions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'economic_unit' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'portfolio' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'org' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'has_write_permission' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_eq' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'economic_unit' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'portfolio' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'has_write_permission' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'BooleanValue', value: true },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'address' },
                          value: {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'street' },
                                value: { kind: 'EnumValue', value: 'asc' },
                              },
                            ],
                          },
                        },
                      ],
                    },
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'address' },
                          value: {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'postal_code' },
                                value: { kind: 'EnumValue', value: 'asc' },
                              },
                            ],
                          },
                        },
                      ],
                    },
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'address' },
                          value: {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'city' },
                                value: { kind: 'EnumValue', value: 'asc' },
                              },
                            ],
                          },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWritableBuildingOptionsQuery, GetWritableBuildingOptionsQueryVariables>;
export const GetManualEntryBuildingDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetManualEntryBuildingDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'area_type_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_in' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      { kind: 'EnumValue', value: 'MF' },
                                      { kind: 'EnumValue', value: 'AF' },
                                      { kind: 'EnumValue', value: 'NGF' },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building_models' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_systems' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetManualEntryBuildingDetailsQuery, GetManualEntryBuildingDetailsQueryVariables>;
export const GetConsumptionGapMatrixDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionGapMatrix' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionGapMatrix' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildingId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'completeness' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coverage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'electricity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heating' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'water' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'waste' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'areas' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'areaId' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gaps' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'consumptionType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'areaId' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionGapMatrixQuery, GetConsumptionGapMatrixQueryVariables>;
export const GetBuildingConsumptionGapAreasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBuildingConsumptionGapAreas' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionGapMatrix' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_ids' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } }],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'buildingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completeness' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'areas' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'areaId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'areaName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'areaType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completeness' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coverage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'electricity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'heating' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'water' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'waste' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gaps' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'electricity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'heating' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'water' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'waste' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBuildingConsumptionGapAreasQuery, GetBuildingConsumptionGapAreasQueryVariables>;
export const DataCollectionAddEconomicUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionAddEconomicUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customerEconomicUnitId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'responsibleUserId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_economic_unit_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portfolio_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'customer_economic_unit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'customerEconomicUnitId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'description' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'responsible_user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'responsibleUserId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionAddEconomicUnitMutation, DataCollectionAddEconomicUnitMutationVariables>;
export const DataCollectionEditEconomicUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionEditEconomicUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customerEconomicUnitId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'responsibleUserId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customData' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeCustomData' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_economic_unit_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitName' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'customer_economic_unit_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'customerEconomicUnitId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'description' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portfolio_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'responsible_user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'responsibleUserId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customer_economic_unit_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'responsible_user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEconomicUnitCustomData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'economicUnitId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customData' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customData' } },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeCustomData' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionEditEconomicUnitMutation, DataCollectionEditEconomicUnitMutationVariables>;
export const DataCollectionDeleteEconomicUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionDeleteEconomicUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_economic_unit_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionDeleteEconomicUnitMutation,
  DataCollectionDeleteEconomicUnitMutationVariables
>;
export const DataCollectionDeleteEconomicUnitsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionDeleteEconomicUnits' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'economic_unit_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_economic_unit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionDeleteEconomicUnitsMutation,
  DataCollectionDeleteEconomicUnitsMutationVariables
>;
export const DataCollectionDeleteBuildingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionDeleteBuilding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_building_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_unit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'associatedBuildingsAndDrafts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionDeleteBuildingMutation, DataCollectionDeleteBuildingMutationVariables>;
export const DataCollectionDeleteInactiveBuildingsByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionDeleteInactiveBuildingsById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_inactive_buildings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'economic_unit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'associatedBuildingsAndDrafts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionDeleteInactiveBuildingsByIdMutation,
  DataCollectionDeleteInactiveBuildingsByIdMutationVariables
>;
export const UpdateBuildingLocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBuildingLocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinates' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Coordinates' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approximate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingCitydbGmlIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'neighborCitydbGmlIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lod1BuildingIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'neighborLod1Ids' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBuildingLocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'coordinates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinates' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'selectedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approximate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approximate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingCitydbGmlIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingCitydbGmlIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'neighborCitydbGmlIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'neighborCitydbGmlIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lod1BuildingIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lod1BuildingIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'neighborLod1Ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'neighborLod1Ids' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mapbox_building_ids' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'building_citydb_gml_ids' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'building_lod1_ids' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBuildingLocationMutation, UpdateBuildingLocationMutationVariables>;
export const DataCollectionBuildingDraftsListDeleteBuildingDraftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionBuildingDraftsListDeleteBuildingDrafts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_building_draft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionBuildingDraftsListDeleteBuildingDraftsMutation,
  DataCollectionBuildingDraftsListDeleteBuildingDraftsMutationVariables
>;
export const UploadEnergyCertificateDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UploadEnergyCertificateDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadEnergyCertificateDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fileName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'uploadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyCertificateDraftId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'UploadEnergyCertificateDraftId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft_status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadEnergyCertificateDraftMutation, UploadEnergyCertificateDraftMutationVariables>;
export const DeleteEnergyCertificateDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteEnergyCertificateDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_energy_certificate_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteEnergyCertificateDraftMutation, DeleteEnergyCertificateDraftMutationVariables>;
export const DeleteEnergyCertificateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteEnergyCertificate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_energy_certificate_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteEnergyCertificateMutation, DeleteEnergyCertificateMutationVariables>;
export const DataCollectionSaveConsumptionInvoiceDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionSaveConsumptionInvoiceDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'invoicePayer' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'invoice_payer_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'draftStatus' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'draft_status_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionDrafts' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsumptionDraftInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConsumptionInvoiceDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invoiceDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceDraftId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invoiceDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invoicePayer' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'invoicePayer' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'draftStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'draftStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionDrafts' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionDrafts' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'UpdateConsumptionInvoiceDraftOutput' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoice_payer' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'draft_status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consumption_drafts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'consumption_waste_details_draft' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionSaveConsumptionInvoiceDraftMutation,
  DataCollectionSaveConsumptionInvoiceDraftMutationVariables
>;
export const DataCollectionAreaConsumptionDraftCreateConsumptionFromDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionAreaConsumptionDraftCreateConsumptionFromDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConsumptionInvoiceFromDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumption_invoice_draft_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceDraftId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'consumption_invoice_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionAreaConsumptionDraftCreateConsumptionFromDraftMutation,
  DataCollectionAreaConsumptionDraftCreateConsumptionFromDraftMutationVariables
>;
export const DataCollectionConsumptionDraftStatusSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'DataCollectionConsumptionDraftStatusSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_invoice_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceDraftId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'draft_status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionConsumptionDraftStatusSubscriptionSubscription,
  DataCollectionConsumptionDraftStatusSubscriptionSubscriptionVariables
>;
export const DataCollectionAreaConsumptionInvoiceDraftSetOcrFailedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionAreaConsumptionInvoiceDraftSetOcrFailed' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_consumption_invoice_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceDraftId' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'draft_status' },
                      value: { kind: 'EnumValue', value: 'OCR_FAILED' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionAreaConsumptionInvoiceDraftSetOcrFailedMutation,
  DataCollectionAreaConsumptionInvoiceDraftSetOcrFailedMutationVariables
>;
export const UploadConsumptionDraftModalCreateConsumptionDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UploadConsumptionDraftModalCreateConsumptionDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConsumptionInvoiceDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'CreateConsumptionInvoiceDraftOutput' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'file_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'upload_url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UploadConsumptionDraftModalCreateConsumptionDraftMutation,
  UploadConsumptionDraftModalCreateConsumptionDraftMutationVariables
>;
export const ApplyBuildingModelMutationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplyBuildingModelMutations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelMutation' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingModelMutation' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'envelopeMutations' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnvelopeMutation' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energySystemMutations' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergySystemMutation' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energySystemConsumerMutations' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyConsumerMutation' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energyProducerMutations' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyProducerMutation' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energySystemStorageMutations' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyStorageMutation' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energySystemDistributionMutations' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyDistributionMutation' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'saveInvalidState' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dryRun' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyBuildingModelMutations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_model_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_model_mutation' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelMutation' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'envelope_mutations' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'envelopeMutations' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energy_system_mutations' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energySystemMutations' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energy_consumer_mutations' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energySystemConsumerMutations' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energy_producer_mutations' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energyProducerMutations' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energy_storage_mutations' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energySystemStorageMutations' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energy_distribution_mutations' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energySystemDistributionMutations' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'save_invalid_state' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'saveInvalidState' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dry_run' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dryRun' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scaling_successful' } },
                { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'final_energy_scaled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_envelope' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heating_demand_system' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplyBuildingModelMutationsMutation, ApplyBuildingModelMutationsMutationVariables>;
export const DataCollectionSaveConsumptionInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionSaveConsumptionInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'invoicePayer' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'invoice_payer_type_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptions' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsumptionInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConsumptionInvoice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invoiceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invoiceDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invoicePayer' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'invoicePayer' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptions' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'UpdateConsumptionInvoiceOutput' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoice_payer' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consumptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'consumption_waste_detail' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionSaveConsumptionInvoiceMutation,
  DataCollectionSaveConsumptionInvoiceMutationVariables
>;
export const DataCollectionInsertConsumptionDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionInsertConsumptionDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitValue' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_unit_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cost' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceTypeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_source_type_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energySourceTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_source_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_sub_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConsumptionDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'areaIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areaIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitValue' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitValue' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cost' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cost' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'provider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energySourceTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energySourceTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption_draft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_by_user_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionInsertConsumptionDraftMutation,
  DataCollectionInsertConsumptionDraftMutationVariables
>;
export const DataCollectionInsertConsumptionWasteDetailsDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionInsertConsumptionWasteDetailsDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'frequency' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitFrequency' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_frequency_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'price' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'volume' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitVolume' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_unit_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConsumptionWasteDetailsDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionDraftId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'frequency' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'frequency' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitFrequency' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitFrequency' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'price' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'price' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'volume' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'volume' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitVolume' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitVolume' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption_waste_details_draft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionInsertConsumptionWasteDetailsDraftMutation,
  DataCollectionInsertConsumptionWasteDetailsDraftMutationVariables
>;
export const DataCollectionSaveConsumptionDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionSaveConsumptionDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitValue' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_unit_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cost' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energySourceTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_source_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_sub_type_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConsumptionDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionDraftId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'areaIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areaIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitValue' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitValue' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cost' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cost' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'provider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energySourceTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energySourceTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subTypeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption_draft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_by_user_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consumption_waste_details_draft' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionSaveConsumptionDraftMutation,
  DataCollectionSaveConsumptionDraftMutationVariables
>;
export const DataCollectionUpdateConsumptionWasteDetailsDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionUpdateConsumptionWasteDetailsDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'frequency' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitFrequency' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_frequency_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'price' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'volume' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitVolume' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_unit_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConsumptionWasteDetailsDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'frequency' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'frequency' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitFrequency' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitFrequency' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'price' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'price' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'volume' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'volume' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitVolume' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitVolume' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption_waste_details_draft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionUpdateConsumptionWasteDetailsDraftMutation,
  DataCollectionUpdateConsumptionWasteDetailsDraftMutationVariables
>;
export const DataCollectionDeleteConsumptionWasteDetailsDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionDeleteConsumptionWasteDetailsDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_consumption_waste_details_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionDeleteConsumptionWasteDetailsDraftMutation,
  DataCollectionDeleteConsumptionWasteDetailsDraftMutationVariables
>;
export const DataCollectionCreateManualConsumptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionCreateManualConsumption' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionTypeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_type_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cost' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitValue' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_unit_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energySourceTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_source_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceTypeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ManualConsumptionSourceTypeEnum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_sub_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'wasteDetails' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'WasteDetailsInlineInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createManualConsumption' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'areaIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areaIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cost' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cost' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitValue' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitValue' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energySourceTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energySourceTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'provider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'wasteDetails' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'wasteDetails' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionCreateManualConsumptionMutation,
  DataCollectionCreateManualConsumptionMutationVariables
>;
export const DataCollectionInsertConsumptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionInsertConsumption' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitValue' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_unit_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cost' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceTypeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_source_type_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionTypeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_type_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energySourceTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_source_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_sub_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdByUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConsumptionFromDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionDraftId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'areaIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areaIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitValue' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitValue' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cost' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cost' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'provider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energySourceTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energySourceTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdByUserId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createdByUserId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_by_user_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionInsertConsumptionMutation, DataCollectionInsertConsumptionMutationVariables>;
export const DataCollectionInsertConsumptionWasteDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionInsertConsumptionWasteDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'frequency' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitFrequency' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_frequency_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'price' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'volume' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitVolume' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_unit_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createConsumptionWasteDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'frequency' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'frequency' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitFrequency' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitFrequency' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'price' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'price' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'volume' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'volume' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitVolume' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitVolume' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption_waste_details' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionInsertConsumptionWasteDetailsMutation,
  DataCollectionInsertConsumptionWasteDetailsMutationVariables
>;
export const DataCollectionSaveConsumptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionSaveConsumption' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitValue' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_unit_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cost' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionTypeId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_type_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energySourceTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_source_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subTypeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_sub_type_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConsumption' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'areaIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areaIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'from' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'to' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitValue' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitValue' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cost' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cost' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'provider' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'provider' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energySourceTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energySourceTypeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subTypeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subTypeId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'created_by_user_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'consumption_waste_detail' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionSaveConsumptionMutation, DataCollectionSaveConsumptionMutationVariables>;
export const DataCollectionUpdateConsumptionWasteDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionUpdateConsumptionWasteDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'frequency' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitFrequency' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_frequency_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'price' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'volume' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitVolume' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_unit_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConsumptionWasteDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amount' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'amount' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'frequency' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'frequency' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitFrequency' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitFrequency' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'price' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'price' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'volume' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'volume' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayUnitVolume' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayUnitVolume' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption_waste_details' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionUpdateConsumptionWasteDetailsMutation,
  DataCollectionUpdateConsumptionWasteDetailsMutationVariables
>;
export const DataCollectionDeleteConsumptionWasteDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionDeleteConsumptionWasteDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_consumption_waste_details_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionDeleteConsumptionWasteDetailsMutation,
  DataCollectionDeleteConsumptionWasteDetailsMutationVariables
>;
export const DeleteConsumptionInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteConsumptionInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_consumption_invoice_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteConsumptionInvoiceMutation, DeleteConsumptionInvoiceMutationVariables>;
export const DeleteConsumptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteConsumption' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_consumption_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteConsumptionMutation, DeleteConsumptionMutationVariables>;
export const DeleteConsumptionInvoiceDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteConsumptionInvoiceDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_consumption_invoice_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'invoiceDraftId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption_drafts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteConsumptionInvoiceDraftMutation, DeleteConsumptionInvoiceDraftMutationVariables>;
export const DataCollectionAreaConsumptionDraftDeleteConsumptionDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DataCollectionAreaConsumptionDraftDeleteConsumptionDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_consumption_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionDraftId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionAreaConsumptionDraftDeleteConsumptionDraftMutation,
  DataCollectionAreaConsumptionDraftDeleteConsumptionDraftMutationVariables
>;
export const CreateEmissionCertificateDraftWithoutFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEmissionCertificateDraftWithoutFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateEmissionCertificateDraftWithoutFileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEmissionCertificateDraftWithoutFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_draft_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateEmissionCertificateDraftWithoutFileMutation,
  CreateEmissionCertificateDraftWithoutFileMutationVariables
>;
export const CreateEmissionCertificateDraftWithFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEmissionCertificateDraftWithFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateEmissionCertificateDraftWithoutFileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEmissionCertificateDraftWithFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'fileUrl' },
                  name: { kind: 'Name', value: 'upload_url' },
                },
                { kind: 'Field', alias: { kind: 'Name', value: 'fileId' }, name: { kind: 'Name', value: 'file_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateEmissionCertificateDraftWithFileMutation,
  CreateEmissionCertificateDraftWithFileMutationVariables
>;
export const UpdateEmissionCertificateDraftWithoutFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEmissionCertificateDraftWithoutFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateEmissionCertificateDraftWithoutFileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEmissionCertificateDraftWithoutFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_draft_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateEmissionCertificateDraftWithoutFileMutation,
  UpdateEmissionCertificateDraftWithoutFileMutationVariables
>;
export const UpdateEmissionCertificateDraftWithFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEmissionCertificateDraftWithFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateEmissionCertificateDraftWithoutFileInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEmissionCertificateDraftWithFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftWithoutFile' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'fileUrl' },
                  name: { kind: 'Name', value: 'upload_url' },
                },
                { kind: 'Field', alias: { kind: 'Name', value: 'fileId' }, name: { kind: 'Name', value: 'file_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateEmissionCertificateDraftWithFileMutation,
  UpdateEmissionCertificateDraftWithFileMutationVariables
>;
export const CreateEmissionCertificateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEmissionCertificate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateEmissionCertificateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEmissionCertificate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionCertificate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateEmissionCertificateMutation, CreateEmissionCertificateMutationVariables>;
export const UpdateEmissionCertificateWithoutFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEmissionCertificateWithoutFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEmissionCertificateWithoutFileInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEmissionCertificateWithoutFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionCertificate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateEmissionCertificateWithoutFileMutation,
  UpdateEmissionCertificateWithoutFileMutationVariables
>;
export const UpdateEmissionCertificateFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEmissionCertificateFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEmissionCertificateFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emission_certificate_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'fileUrl' },
                  name: { kind: 'Name', value: 'upload_url' },
                },
                { kind: 'Field', alias: { kind: 'Name', value: 'fileId' }, name: { kind: 'Name', value: 'file_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEmissionCertificateFileMutation, UpdateEmissionCertificateFileMutationVariables>;
export const DeleteEmissionCertificateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteEmissionCertificate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteEmissionCertificate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteEmissionCertificateMutation, DeleteEmissionCertificateMutationVariables>;
export const DeleteEmissionCertificateDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteEmissionCertificateDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_emission_certificate_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteEmissionCertificateDraftMutation, DeleteEmissionCertificateDraftMutationVariables>;
export const EditAreasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditAreas' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areas' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AreaUpdateInput' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'saveInvalidState' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editAreas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'areas' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areas' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'saveInvalidState' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'saveInvalidState' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scalingResult' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'final_energy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'final_energy_scaled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scaling_successful' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'efficiencyClassDeviation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'previousEfficiencyClass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newEfficiencyClass' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditAreasMutation, EditAreasMutationVariables>;
export const PreviewEditAreasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PreviewEditAreas' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areas' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AreaUpdateInput' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'saveInvalidState' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previewEditAreas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'areas' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areas' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'saveInvalidState' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'saveInvalidState' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'efficiencyClassDeviation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'previousEfficiencyClass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'newEfficiencyClass' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PreviewEditAreasMutation, PreviewEditAreasMutationVariables>;
export const MoveBuildingsToEconomicUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MoveBuildingsToEconomicUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'destinationEconomicUnitId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keepEmptyEconomicUnits' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'moveAllBuildings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'destinationEconomicUnitId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'destinationEconomicUnitId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'keepEmptyEconomicUnits' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'keepEmptyEconomicUnits' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MoveBuildingsToEconomicUnitMutation, MoveBuildingsToEconomicUnitMutationVariables>;
export const ExportFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExportFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ExportFileInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportFileMutation, ExportFileMutationVariables>;
export const DeleteBuildingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBuildings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'keepEmptyEconomicUnits' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAllBuildings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'keepEmptyEconomicUnits' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'keepEmptyEconomicUnits' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteBuildingsMutation, DeleteBuildingsMutationVariables>;
export const EditBuildingDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditBuildingData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingData' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_set_input' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addressId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addressData' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'address_set_input' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'valuations' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_valuation_insert_input' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deletedValuationIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shouldDeleteDistrictHeating' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shouldUpsertDistrictHeating' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'districtHeatingYear' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'insertCertificates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCertificate' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateCertificates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'EditCertificate' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteCertificates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteCertificate' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_building_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingData' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_state_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leasehold' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heritage_district' } },
                { kind: 'Field', name: { kind: 'Name', value: 'milieu_protection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'units' } },
                { kind: 'Field', name: { kind: 'Name', value: 'units_data_source' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_address_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'addressId' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'addressData' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_building_valuation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'valuations' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'building_valuation_pkey' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'valuation_at' },
                          { kind: 'EnumValue', value: 'value' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_building_valuation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'deletedValuationIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_building_district_heating_availability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'shouldDeleteDistrictHeating' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_building_district_heating_availability_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'availability_year' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'districtHeatingYear' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'building_district_heating_availability_pkey' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'availability_year' }] },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'shouldUpsertDistrictHeating' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'building_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'district_heating_availability_status' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'building_id' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'district_heating_status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'district_heating_year' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editCertificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deleteCertificates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteCertificates' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'insertCertificates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'insertCertificates' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updateCertificates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updateCertificates' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'certificates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditBuildingDataMutation, EditBuildingDataMutationVariables>;
export const UpdateBuildingCustomDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBuildingCustomData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'customData' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBuildingCustomData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'customData' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'customData' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBuildingCustomDataMutation, UpdateBuildingCustomDataMutationVariables>;
export const CreateBuildingDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBuildingDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraft' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_insert_input' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_building_draft_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GetBuildingDraftFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft_status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_commercial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_residential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetBuildingDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'economic_unit_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heritage_district' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milieu_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leasehold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mapbox_building_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_citydb_gml_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'neighbor_citydb_gml_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_lod1_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'neighbor_lod1_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assign_responsible_user_as_transaction_manager' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_valuations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_consumers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_draft_area_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_areas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_drafts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_level_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBuildingDraftMutation, CreateBuildingDraftMutationVariables>;
export const UpdateBuildingDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBuildingDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraft' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_set_input' } },
          },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'valuationInserts' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_valuation_insert_input' } },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'valuationUpdates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_valuation_updates' } },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'valuationDeletedIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumerInserts' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_consumer_insert_input' } },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumerUpdates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_consumer_updates' } },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumerDeletedIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaInserts' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_area_insert_input' } },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaUpdates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_area_updates' } },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaDeletedIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteCertificates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteCertificate' } },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'insertCertificates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCertificate' } },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateCertificates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'EditCertificate' } },
              },
            },
          },
          defaultValue: { kind: 'ListValue', values: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_building_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraft' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_building_draft_valuation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'valuationInserts' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_building_draft_valuation_many' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'valuationUpdates' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_building_draft_valuation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'valuationDeletedIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_building_draft_consumer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumerInserts' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_building_draft_consumer_many' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumerUpdates' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_building_draft_consumer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'consumerDeletedIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_building_draft_area' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areaInserts' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_building_draft_area_many' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areaUpdates' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_building_draft_area' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'areaDeletedIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_building_draft_consumer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_draft_area_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'areaDeletedIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_draft_area_id' },
                      value: { kind: 'NullValue' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editCertificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deleteCertificates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteCertificates' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'insertCertificates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'insertCertificates' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updateCertificates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updateCertificates' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'certificates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBuildingDraftMutation, UpdateBuildingDraftMutationVariables>;
export const CreateBuildingFromBuildingDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBuildingFromBuildingDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBuildingFromBuildingDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'buildingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBuildingFromBuildingDraftMutation, CreateBuildingFromBuildingDraftMutationVariables>;
export const ExportClimateRiskV2ReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExportClimateRiskV2Report' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportClimateRiskV2Report' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'body' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportClimateRiskV2ReportMutation, ExportClimateRiskV2ReportMutationVariables>;
export const UpdateEnergyCertificateDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEnergyCertificateDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'obj' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft_set_input' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'insertConsumers' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_consumer_insert_input' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateConsumers' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_consumer_updates' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteConsumers' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_energy_certificate_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'obj' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_energy_certificate_consumer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'insertConsumers' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_energy_certificate_consumer_many' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updateConsumers' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_energy_certificate_consumer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteConsumers' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'affected_rows' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEnergyCertificateDraftMutation, UpdateEnergyCertificateDraftMutationVariables>;
export const CreateEPCFromDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateEPCFromDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energyCertificateDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transformEnergyCertificateDraftToEnergyCertificate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energyCertificateDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energyCertificateDraftId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyCertificateId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'EnergyCertificateDraftTransformOutput' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_commercial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_residential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateEPCFromDraftMutation, CreateEPCFromDraftMutationVariables>;
export const FillBuildingDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'FillBuildingDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fillBuildingDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'BuildingDraftId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GetBuildingDraftFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft_status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_commercial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_residential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetBuildingDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'economic_unit_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heritage_district' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milieu_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leasehold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mapbox_building_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_citydb_gml_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'neighbor_citydb_gml_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_lod1_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'neighbor_lod1_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assign_responsible_user_as_transaction_manager' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_valuations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_consumers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_draft_area_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_areas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_drafts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_level_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FillBuildingDraftMutation, FillBuildingDraftMutationVariables>;
export const ResetBuildingDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetBuildingDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetBuildingDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildingDraft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GetBuildingDraftFragment' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft_status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_commercial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_residential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetBuildingDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'economic_unit_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heritage_district' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milieu_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leasehold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mapbox_building_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_citydb_gml_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'neighbor_citydb_gml_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_lod1_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'neighbor_lod1_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assign_responsible_user_as_transaction_manager' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_valuations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_consumers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_draft_area_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_areas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_drafts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_level_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetBuildingDraftMutation, ResetBuildingDraftMutationVariables>;
export const CreateBuildingModelTwinDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBuildingModelTwin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBuildingModelTwin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buildingModelId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBuildingModelTwinMutation, CreateBuildingModelTwinMutationVariables>;
export const SetActiveBuildingModelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetActiveBuildingModel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setActiveBuildingModel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingModelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetActiveBuildingModelMutation, SetActiveBuildingModelMutationVariables>;
export const DeleteBuildingModelDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBuildingModelDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteTwinBuildingModel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingModelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteBuildingModelDraftMutation, DeleteBuildingModelDraftMutationVariables>;
export const CreateCertificateFileUploadURLDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCertificateFileUploadURL' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCertificateFileUploadURL' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingDraftId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fileName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadURL' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCertificateFileUploadURLMutation, CreateCertificateFileUploadURLMutationVariables>;
export const SetBuildingInactiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetBuildingInactive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_building_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: { kind: 'EnumValue', value: 'INACTIVE' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_unit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'associatedBuildingsAndDrafts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetBuildingInactiveMutation, SetBuildingInactiveMutationVariables>;
export const SetBuildingActiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetBuildingActive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_inactive_buildings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: { kind: 'StringValue', value: 'ACTIVE', block: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'economic_unit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'associatedBuildingsAndDrafts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetBuildingActiveMutation, SetBuildingActiveMutationVariables>;
export const UpdateBuildingModelTwinDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateBuildingModelTwin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'validFrom' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBuildingModelTwin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingModelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'validFrom' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'validFrom' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'buildingModelId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateBuildingModelTwinMutation, UpdateBuildingModelTwinMutationVariables>;
export const DuplicateBuildingModelVersionTwinDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DuplicateBuildingModelVersionTwin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'validFrom' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'duplicateBuildingModelVersionTwin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'validFrom' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'validFrom' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'buildingModelId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DuplicateBuildingModelVersionTwinMutation,
  DuplicateBuildingModelVersionTwinMutationVariables
>;
export const DeleteBuildingModelTwinDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteBuildingModelTwin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteBuildingModelTwin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingModelId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'buildingModelId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'newBuildingModelId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteBuildingModelTwinMutation, DeleteBuildingModelTwinMutationVariables>;
export const getAssociatedBuildingsForEnergySupplierDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAssociatedBuildingsForEnergySupplier' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAssociatedBuildings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionCertificateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'EnergySupplierAssociatedBuilding' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySupplierAssociatedBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getAssociatedBuildingsForEnergySupplierQuery,
  getAssociatedBuildingsForEnergySupplierQueryVariables
>;
export const getAssociatedActionPlansForEnergySupplierDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAssociatedActionPlansForEnergySupplier' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAssociatedActionPlans' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionCertificateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'action_plans' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'stable_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'scenario_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'EnergySupplierAssociatedBuilding' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EnergySupplierAssociatedBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getAssociatedActionPlansForEnergySupplierQuery,
  getAssociatedActionPlansForEnergySupplierQueryVariables
>;
export const DataCollectionGetEconomicUnitsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetEconomicUnits' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'economic_unit_bool_exp' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customer_economic_unit_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionGetEconomicUnitsQuery, DataCollectionGetEconomicUnitsQueryVariables>;
export const DataCollectionGetEconomicUnitsByIdsForSelectionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetEconomicUnitsByIdsForSelection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'economic_unit_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetEconomicUnitsByIdsForSelectionQuery,
  DataCollectionGetEconomicUnitsByIdsForSelectionQueryVariables
>;
export const DataCollectionGetEconomicUnitsAggregateCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetEconomicUnitsAggregateCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'economic_unit_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetEconomicUnitsAggregateCountQuery,
  DataCollectionGetEconomicUnitsAggregateCountQueryVariables
>;
export const DataCollectionGetEconomicUnitsBySearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetEconomicUnitsBySearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'economic_unit_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetEconomicUnitsBySearchQuery,
  DataCollectionGetEconomicUnitsBySearchQueryVariables
>;
export const EconomicUnitsListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EconomicUnitsList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EconomicUnitsOrderByInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fetchInactiveBuildings' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEconomicUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economicUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'economicUnit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'customer_economic_unit_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'responsible_user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'portfolio' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'first_building' },
                              name: { kind: 'Name', value: 'buildings' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'limit' },
                                  value: { kind: 'IntValue', value: '1' },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'first_inactive_building' },
                              name: { kind: 'Name', value: 'inactive_buildings' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'limit' },
                                  value: { kind: 'IntValue', value: '1' },
                                },
                              ],
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'fetchInactiveBuildings' },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EconomicUnitsListQuery, EconomicUnitsListQueryVariables>;
export const EconomicUnitsWithBuildingWhereDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EconomicUnitsWithBuildingWhere' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEconomicUnits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economicUnits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EconomicUnitsWithBuildingWhereQuery, EconomicUnitsWithBuildingWhereQueryVariables>;
export const EconomicUnitBuildingsIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EconomicUnitBuildingsIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'economic_unit_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inactive_buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building_drafts_aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aggregate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EconomicUnitBuildingsIdsQuery, EconomicUnitBuildingsIdsQueryVariables>;
export const DataCollectionBuildingGetBuildingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionBuildingGetBuilding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuilding' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingSubsidy' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'subsidy' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount_description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider_updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'subsidy_category_type' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnvelope' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_consumer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'use_renewable_energy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distribution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_distribution_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_distribution_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_storage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_storage_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'annual_heat_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_producer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_produced' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_producer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingModel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_model' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_draft' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action_planning_available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'internal_temperature' } },
          { kind: 'Field', name: { kind: 'Name', value: 'annual_heating_days' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'envelope_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingEnvelope' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_systems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'energy_system_type_id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystem' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProgressiveFactorResponse' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProgressiveFactor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionFactorsPerEnergySource' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionFactorsObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'BIO_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_FOSSIL_COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_FOSSIL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_CHP_RENEWABLE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_FOSSIL_COAL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_FOSSIL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ELECTRICITY_GREEN' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'DISTRICT_HEATING_PLANTS_RENEWABLE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ELECTRICITY_MIX' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'WOODEN_PELLETS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'WOOD' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'UNSPECIFIED' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'SOLAR' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'LPG' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'NATURAL_GAS' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'LIGNITE' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'FUEL_OIL' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProgressiveFactorResponse' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_data_source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leasehold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milieu_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heritage_district' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mapbox_building_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_citydb_gml_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neighbor_citydb_gml_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_lod1_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neighbor_lod1_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mapbox_pitch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mapbox_bearing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mapbox_zoom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'has_gml_ids' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'area_system_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'EnumValue', value: 'PREDIUM_2024' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area_system_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'is_rented' } },
                { kind: 'Field', name: { kind: 'Name', value: 'class_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'data_source_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'file_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsible_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_data_source' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subsidies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subsidy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingSubsidy' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subsidies_updated_at' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'associatedBuildingsAndDrafts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_building_model' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'active_building_model_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climate_risks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uncertainty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timespan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climate_risks_aggregate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'max' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_action_plans_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'archived_at' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_is_null' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'action_plans_with_action_aggregate' },
            name: { kind: 'Name', value: 'active_action_plans_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'archived_at' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_is_null' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'actions_aggregate' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'count' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'predicate' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_gt' },
                                              value: { kind: 'IntValue', value: '0' },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_valuations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climate_risks_v2_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'api_response_status_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_neq' },
                            value: { kind: 'EnumValue', value: 'NOT_INITIALIZED' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'base_emission_factors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionFactorsPerEnergySource' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'district_heating_availability_status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'building_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'district_heating_status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'district_heating_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_models' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_is_null' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingModel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'id' },
                          value: { kind: 'EnumValue', value: 'asc' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_level_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionBuildingGetBuildingQuery, DataCollectionBuildingGetBuildingQueryVariables>;
export const DataCollectionGetBuildingConsumptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetBuildingConsumptions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumptions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'created_at' },
                            value: { kind: 'EnumValue', value: 'desc' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionConsumption' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionConsumption' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'to' } },
          { kind: 'Field', name: { kind: 'Name', value: 'from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayValue' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'created_by_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'invoice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_waste_detail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_areas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'area_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetBuildingConsumptionsQuery,
  DataCollectionGetBuildingConsumptionsQueryVariables
>;
export const DataCollectionGetBuildingConsumptionDraftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetBuildingConsumptionDrafts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_draft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionAreaConsumptionDraft' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionAreaConsumptionDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'to' } },
          { kind: 'Field', name: { kind: 'Name', value: 'from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayValue' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'created_by_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_invoice_draft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'draft_status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_waste_details_draft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_draft_areas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'area_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetBuildingConsumptionDraftsQuery,
  DataCollectionGetBuildingConsumptionDraftsQueryVariables
>;
export const EconomicUnitAssociatedBuildingsAndDraftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EconomicUnitAssociatedBuildingsAndDrafts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'associatedBuildingsAndDrafts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EconomicUnitAssociatedBuildingsAndDraftsQuery,
  EconomicUnitAssociatedBuildingsAndDraftsQueryVariables
>;
export const DataCollectionGetAllBuildingsTableWithBuildingWhereDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetAllBuildingsTableWithBuildingWhere' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingOrderByInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBuildingList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_data' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'energy_final' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_types' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'types_of_use' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inactive_building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'milieu_protection' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'leasehold' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heritage_district' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'has_gml_ids' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'responsible_user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'building_valuations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'where' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'area_type_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: { kind: 'EnumValue', value: 'EBF' },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'economic_unit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'portfolio' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'active_building_model_id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active_building_model' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'energy_systems' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'energy_system_consumer_routes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'milieu_protection' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'leasehold' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'heritage_district' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'has_gml_ids' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'responsible_user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'building_valuations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'areas' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'where' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'area_type_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: { kind: 'EnumValue', value: 'EBF' },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'economic_unit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'portfolio' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'active_building_model_id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active_building_model' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'energy_systems' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'energy_system_consumer_routes' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'has_gml_ids' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetAllBuildingsTableWithBuildingWhereQuery,
  DataCollectionGetAllBuildingsTableWithBuildingWhereQueryVariables
>;
export const DataCollectionGetAllEmissionCertificatesDropdownDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetAllEmissionCertificatesDropdown' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionCertificateDropdownFields' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificateDropdownFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetAllEmissionCertificatesDropdownQuery,
  DataCollectionGetAllEmissionCertificatesDropdownQueryVariables
>;
export const ExportTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'export_template' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'org_id' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_eq' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'org_id' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_is_null' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'export_type_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportTemplatesQuery, ExportTemplatesQueryVariables>;
export const AssociatedEntitiesByBuildingIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AssociatedEntitiesByBuildingId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report_buildings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'building_id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report_template' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_action_plans_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'active_scenario' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'action_plan' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'building_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_in' },
                                              value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingIds' } },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'active_scenario' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'action_plan' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'building_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_in' },
                                              value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingIds' } },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_draft_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_in' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingIds' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssociatedEntitiesByBuildingIdQuery, AssociatedEntitiesByBuildingIdQueryVariables>;
export const DataCollectionGetConsumptionSummariesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetConsumptionSummaries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getYearlyConsumptionSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumptionCategories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionYearlyConsumption' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionYearlyConsumption' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'YearlyConsumption' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'providers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumption_type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetConsumptionSummariesQuery,
  DataCollectionGetConsumptionSummariesQueryVariables
>;
export const GetAllBuildingDraftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllBuildingDrafts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_bool_exp' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft_order_by' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_certificate_drafts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'draft_status_id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'file' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energy_certificates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'file' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllBuildingDraftsQuery, GetAllBuildingDraftsQueryVariables>;
export const GetAllBuildingDraftsPortfoliosAndEconomicUnitsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllBuildingDraftsPortfoliosAndEconomicUnits' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllBuildingDraftsPortfoliosAndEconomicUnitsQuery,
  GetAllBuildingDraftsPortfoliosAndEconomicUnitsQueryVariables
>;
export const GetBuildingDraftIdsByEpcNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBuildingDraftIdsByEpcName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nameLike' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_draft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'file' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'name' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_ilike' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'nameLike' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building_draft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'file' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'name' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_ilike' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'nameLike' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_draft' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_is_null' },
                                  value: { kind: 'BooleanValue', value: false },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building_draft' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBuildingDraftIdsByEpcNameQuery, GetBuildingDraftIdsByEpcNameQueryVariables>;
export const DataCollectionGetConsumptionInvoiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetConsumptionInvoice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_invoice_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invoice_payer' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionConsumption' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'areas' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'where' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'area_type_id' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_in' },
                                        value: {
                                          kind: 'ListValue',
                                          values: [
                                            { kind: 'EnumValue', value: 'MF' },
                                            { kind: 'EnumValue', value: 'AF' },
                                            { kind: 'EnumValue', value: 'NGF' },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionConsumption' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          { kind: 'Field', name: { kind: 'Name', value: 'to' } },
          { kind: 'Field', name: { kind: 'Name', value: 'from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayValue' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'created_by_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'invoice_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_waste_detail' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_areas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'area_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetConsumptionInvoiceQuery,
  DataCollectionGetConsumptionInvoiceQueryVariables
>;
export const DataCollectionAreaConsumptionGetConsumptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionAreaConsumptionGetConsumptions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
          defaultValue: { kind: 'IntValue', value: '1' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_invoice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionAreaConsumptionGetConsumptionsQuery,
  DataCollectionAreaConsumptionGetConsumptionsQueryVariables
>;
export const CountBuildingConsumptionsByAreaTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CountBuildingConsumptionsByAreaType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaTypeId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'area_type_enum' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumptions_aggregate' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'building_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'consumption_areas' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'area' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'area_type_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: { kind: 'Variable', name: { kind: 'Name', value: 'areaTypeId' } },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aggregate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CountBuildingConsumptionsByAreaTypeQuery,
  CountBuildingConsumptionsByAreaTypeQueryVariables
>;
export const DataCollectionGetBuildingConsumptionPreconditionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetBuildingConsumptionPrecondition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'economic_unit' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'portfolio' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'org' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building_models' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'energy_systems' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'area_type_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_in' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      { kind: 'EnumValue', value: 'MF' },
                                      { kind: 'EnumValue', value: 'AF' },
                                      { kind: 'EnumValue', value: 'NGF' },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_unit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portfolio' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetBuildingConsumptionPreconditionQuery,
  DataCollectionGetBuildingConsumptionPreconditionQueryVariables
>;
export const DataCollectionGetConsumptionInvoiceDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionGetConsumptionInvoiceDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_invoice_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionInvoiceDraftId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'draft_status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invoice_payer' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'building' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'areas' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'consumption_drafts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'DataCollectionConsumptionDraftConsumptionDraft' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionConsumptionDraftConsumptionDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'consumption_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'to' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
          { kind: 'Field', name: { kind: 'Name', value: 'consumption_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'display_unit_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sub_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_waste_details_draft' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_frequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display_unit_volume' } },
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_draft_areas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'area_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionGetConsumptionInvoiceDraftQuery,
  DataCollectionGetConsumptionInvoiceDraftQueryVariables
>;
export const DataCollectionAreaGetConsumptionDraftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionAreaGetConsumptionDrafts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_invoice_draft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DataCollectionAreaGetConsumptionDraftsQuery,
  DataCollectionAreaGetConsumptionDraftsQueryVariables
>;
export const GetBuildingPdfFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBuildingPdfFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBuildingPdfFiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energyCertificateId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBuildingPdfFilesQuery, GetBuildingPdfFilesQueryVariables>;
export const getBuildingModelMutationAvailabilityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getBuildingModelMutationAvailability' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBuildingModelMutationAvailability' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_model_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModelMutationAvailability' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModelMutationAvailability' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GetBuildingModelMutationAvailabilityOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affected_action_plans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scenario_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scenario_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scenario_updated_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getBuildingModelMutationAvailabilityQuery,
  getBuildingModelMutationAvailabilityQueryVariables
>;
export const getEmissionCertificatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEmissionCertificates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionCertificateWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionCertificateOrderByInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEmissionCertificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'certificates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'DataCollectionEmissionCertificateListItem' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionEmissionCertificateListItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionCertificateListItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_until' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associated_action_plans_count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associated_buildings_count' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getEmissionCertificatesQuery, getEmissionCertificatesQueryVariables>;
export const getEmissionCertificateTabCountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEmissionCertificateTabCounts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'now' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'timestamptz' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'all' },
            name: { kind: 'Name', value: 'emission_certificate_aggregate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'valid' },
            name: { kind: 'Name', value: 'emission_certificate_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'valid_until' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_gte' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'now' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'valid_until' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_is_null' },
                                      value: { kind: 'BooleanValue', value: true },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'expired' },
            name: { kind: 'Name', value: 'emission_certificate_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'valid_until' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_lt' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'now' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getEmissionCertificateTabCountsQuery, getEmissionCertificateTabCountsQueryVariables>;
export const getEmissionCertificateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEmissionCertificate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionEmissionCertificate' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionDocumentDraft' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'file' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionEmissionCertificate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'file_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionDocumentDraft' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'org' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_until' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_document_type_id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getEmissionCertificateQuery, getEmissionCertificateQueryVariables>;
export const getEmissionCertificateDraftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEmissionCertificateDrafts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionCertificateDraftWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmissionCertificateDraftOrderByInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEmissionCertificateDrafts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'drafts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'DataCollectionEmissionCertificateDraft' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionEmissionCertificateDraft' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmissionCertificateDraftWithConvertedValues' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_document_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_until' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_factor_progressive' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy_factor_progressive' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getEmissionCertificateDraftsQuery, getEmissionCertificateDraftsQueryVariables>;
export const getEmissionCertificateDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEmissionCertificateDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEmissionCertificateDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionEmissionCertificateDraft' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionEmissionCertificateDraft' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'EmissionCertificateDraftWithConvertedValues' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'issuer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_document_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_until' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_factor_progressive' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy_factor_progressive' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getEmissionCertificateDraftQuery, getEmissionCertificateDraftQueryVariables>;
export const getEmissionCertificateDraftByFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEmissionCertificateDraftByFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateDraftFileId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_draft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'file_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'emissionCertificateDraftFileId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getEmissionCertificateDraftByFileQuery, getEmissionCertificateDraftByFileQueryVariables>;
export const getAssociatedActionPlansAndReportsFromEmissionCertificateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAssociatedActionPlansAndReportsFromEmissionCertificate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionCertificateId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'emission_factor_buildings' },
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_models' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'energy_systems' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'energy_system_consumer_routes' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'emission_certificate_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'emissionCertificateId' },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'active_action_plans_aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aggregate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'report_id' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'primary_energy_factor_buildings' },
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_models' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'energy_systems' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'energy_system_consumer_routes' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'emissionCertificateId' },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'active_action_plans_aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aggregate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'report_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getAssociatedActionPlansAndReportsFromEmissionCertificateQuery,
  getAssociatedActionPlansAndReportsFromEmissionCertificateQueryVariables
>;
export const BuildingModelSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'BuildingModelSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_model_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingModel' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnvelope' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'envelope' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'inclination' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'envelope_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_material_category_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_method_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'insulation_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_thickness' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_material_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'base_construction_lambda' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area' } },
          { kind: 'Field', name: { kind: 'Name', value: 'u_value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emission_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_active_value_type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate_value_path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_consumer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'secondary_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emission_certificate_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'use_renewable_energy' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EmissionCertificateWithProgressive' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy_factor_emission_certificate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PrimaryEnergyFactorCertificateWithProgressive' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_consumer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_technology_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_consumer_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_distribution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_distribution_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_distribution_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heat_transfer_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_hydraulic_balancing' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_balancing_set_to_never' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_storage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_storage_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'annual_heat_loss' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system_producer_route' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_effective' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_produced' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_producer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'module_angle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nominal_power' } },
                { kind: 'Field', name: { kind: 'Name', value: 'construction_year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'solar_active_area' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_system' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'data_source_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_consumer_routes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemConsumerRoute' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_system_producer_routes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystemProducerRoute' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DataCollectionBuildingModel' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_model' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'valid_from' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_draft' } },
          { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
          { kind: 'Field', name: { kind: 'Name', value: 'action_planning_available' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heating_demand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'internal_temperature' } },
          { kind: 'Field', name: { kind: 'Name', value: 'annual_heating_days' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'envelope_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingEnvelope' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_systems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'energy_system_type_id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DataCollectionBuildingEnergySystem' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildingModelSubscriptionSubscription, BuildingModelSubscriptionSubscriptionVariables>;
export const BuildingProcessingSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'BuildingProcessingSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_model_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingModelId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processing' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BuildingProcessingSubscriptionSubscription,
  BuildingProcessingSubscriptionSubscriptionVariables
>;
export const hasSingleBuildingOrDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'hasSingleBuildingOrDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasSingleBuildingOrDraft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<hasSingleBuildingOrDraftQuery, hasSingleBuildingOrDraftQueryVariables>;
export const UserHasWriteAccessToAllBuildingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserHasWriteAccessToAllBuildings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBuildingList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkAccess' },
                value: { kind: 'EnumValue', value: 'WRITE' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserHasWriteAccessToAllBuildingsQuery, UserHasWriteAccessToAllBuildingsQueryVariables>;
export const GetBuildingsByEconomicUnitIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBuildingsByEconomicUnitId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'economic_unit_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_state_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'area_type_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'EnumValue', value: 'EBF' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBuildingsByEconomicUnitIdQuery, GetBuildingsByEconomicUnitIdQueryVariables>;
export const GetInactiveBuildingsByEconomicUnitIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetInactiveBuildingsByEconomicUnitId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inactive_buildings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'economic_unit_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_state_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'area_type_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'EnumValue', value: 'EBF' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInactiveBuildingsByEconomicUnitIdQuery,
  GetInactiveBuildingsByEconomicUnitIdQueryVariables
>;
export const GetBuildingsHasWritePermissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBuildingsHasWritePermission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBuildingsHasWritePermissionQuery, GetBuildingsHasWritePermissionQueryVariables>;
export const GetExportedBuildingNamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetExportedBuildingNames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBuildingList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inactive_building' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetExportedBuildingNamesQuery, GetExportedBuildingNamesQueryVariables>;
export const GetUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUsers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetBuildingDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBuildingDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GetBuildingDraftFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft_status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftFragment' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_commercial' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units_residential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GetBuildingDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'economic_unit_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heritage_district' } },
          { kind: 'Field', name: { kind: 'Name', value: 'monument_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milieu_protection' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leasehold' } },
          { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'external_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mapbox_building_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_citydb_gml_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'neighbor_citydb_gml_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_lod1_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'neighbor_lod1_ids' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'assign_responsible_user_as_transaction_manager' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_valuations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_consumers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_draft_area_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_areas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_drafts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftWithFileURLFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCFragment' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'certificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_level_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificate_type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBuildingDraftQuery, GetBuildingDraftQueryVariables>;
export const CompleteBuildingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompleteBuilding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'areaUsable' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'energyData' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'EnergyDataInput' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typeOfUse' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'type_of_use_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'geolocation' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingCompleteGeolocation' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingGmlIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingLOD1Ids' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'units' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeBuilding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'areaUsable' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'areaUsable' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'energyData' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'energyData' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'geolocation' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'geolocation' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingGmlIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingGmlIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingLOD1Ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingLOD1Ids' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typeOfUse' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typeOfUse' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'units' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'units' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'areaUsable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'areaUsableDataSource' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energyData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'energySource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'energySystemType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finalEnergyDemand' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'energyDataSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeOfUse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeOfUseDataSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'units' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unitsDataSource' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearConstructed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearConstructedDataSource' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteBuildingQuery, CompleteBuildingQueryVariables>;
export const DataCollectionBuildingDraftCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DataCollectionBuildingDraftCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_aggregate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DataCollectionBuildingDraftCountQuery, DataCollectionBuildingDraftCountQueryVariables>;
export const GetClimateRiskV2ReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetClimateRiskV2Report' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'readClimateRiskV2Report' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'modelVersion' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'files' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'path' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'publicPath' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scenarios' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'risks' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'riskName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'periods' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'range' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'valuationAtRisk' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClimateRiskV2ReportQuery, GetClimateRiskV2ReportQueryVariables>;
export const EnergyCertificateDraftsSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'EnergyCertificateDraftsSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_draft' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building_draft' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingDraftId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EPCDraftFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EPCDraftFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'energy_certificate_draft' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'draft_status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country_state_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'area_usable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_certificate_type_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expiry_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'units' } },
          { kind: 'Field', name: { kind: 'Name', value: 'geg_reference_value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energy_rating_score' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_heating_hot_water' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reference_value_electricity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enev_year' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_consumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_system_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_source_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EnergyCertificateDraftsSubscriptionSubscription,
  EnergyCertificateDraftsSubscriptionSubscriptionVariables
>;
export const PortfolioForBuildingDraftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PortfolioForBuildingDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'economic_unit' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'portfolio' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_or' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'org' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: 'users' },
                                                  value: {
                                                    kind: 'ObjectValue',
                                                    fields: [
                                                      {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'id' },
                                                        value: {
                                                          kind: 'ObjectValue',
                                                          fields: [
                                                            {
                                                              kind: 'ObjectField',
                                                              name: { kind: 'Name', value: '_eq' },
                                                              value: {
                                                                kind: 'Variable',
                                                                name: { kind: 'Name', value: 'userId' },
                                                              },
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'role_id' },
                                                        value: {
                                                          kind: 'ObjectValue',
                                                          fields: [
                                                            {
                                                              kind: 'ObjectField',
                                                              name: { kind: 'Name', value: '_eq' },
                                                              value: { kind: 'EnumValue', value: 'ORG_ADMIN' },
                                                            },
                                                          ],
                                                        },
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'user_permissions' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_and' },
                                                  value: {
                                                    kind: 'ObjectValue',
                                                    fields: [
                                                      {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'write' },
                                                        value: {
                                                          kind: 'ObjectValue',
                                                          fields: [
                                                            {
                                                              kind: 'ObjectField',
                                                              name: { kind: 'Name', value: '_eq' },
                                                              value: { kind: 'BooleanValue', value: true },
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'user_id' },
                                                        value: {
                                                          kind: 'ObjectValue',
                                                          fields: [
                                                            {
                                                              kind: 'ObjectField',
                                                              name: { kind: 'Name', value: '_eq' },
                                                              value: {
                                                                kind: 'Variable',
                                                                name: { kind: 'Name', value: 'userId' },
                                                              },
                                                            },
                                                          ],
                                                        },
                                                      },
                                                    ],
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_unit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portfolio' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'org' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'users' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'role_id' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'EnumValue', value: 'ORG_ADMIN' },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'user_permissions' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_and' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'write' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'BooleanValue', value: true },
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'user_id' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortfolioForBuildingDraftQuery, PortfolioForBuildingDraftQueryVariables>;
export const PortfolioForMultipleBuildingDraftsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PortfolioForMultipleBuildingDrafts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'org' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'users' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'role_id' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'EnumValue', value: 'ORG_ADMIN' },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'user_permissions' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_and' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'write' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'BooleanValue', value: true },
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'user_id' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_units' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'customer_economic_unit_id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortfolioForMultipleBuildingDraftsQuery, PortfolioForMultipleBuildingDraftsQueryVariables>;
export const GetGlbAccessCookiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGlbAccessCookies' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'glbPath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getGlbAccessCookies' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'glbPath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'glbPath' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signedUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetGlbAccessCookiesQuery, GetGlbAccessCookiesQueryVariables>;
export const ValidateBuildingIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ValidateBuildingIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ValidateBuildingIdsQuery, ValidateBuildingIdsQueryVariables>;
export const GetLastTypesOfUseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLastTypesOfUse' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchLastUsedTypesOfUse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'data' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLastTypesOfUseQuery, GetLastTypesOfUseQueryVariables>;
export const GetCustomFieldsByOrgDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCustomFieldsByOrg' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'custom_field_entity_enum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'custom_field' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entity_type' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'org_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomFieldsByOrgQuery, GetCustomFieldsByOrgQueryVariables>;
export const OngoingExportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'OngoingExports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pendingJobIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'async_job' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'pendingJobIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_jobs_created' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total_jobs_finished' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OngoingExportsSubscription, OngoingExportsSubscriptionVariables>;
export const UserFilesListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserFilesList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uploading' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFilesListQuery, UserFilesListQueryVariables>;
export const GetFileDownloadUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFileDownloadUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'file_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFileDownloadUrlQuery, GetFileDownloadUrlQueryVariables>;
export const GetFilePreviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFilePreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFilePreview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fileId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFilePreviewQuery, GetFilePreviewQueryVariables>;
export const DeleteUserFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteUserFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_file_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserFileMutation, DeleteUserFileMutationVariables>;
export const ReadNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReadNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notificationIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_notification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'notificationIds' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'read' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReadNotificationsMutation, ReadNotificationsMutationVariables>;
export const GetFileIdByAsyncJobIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetFileIdByAsyncJobId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'asyncJobId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'async_job_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'asyncJobId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exportedFileId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fileId' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFileIdByAsyncJobIdQuery, GetFileIdByAsyncJobIdQueryVariables>;
export const GetBatchEsgAnalysisPdfExportDownloadUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBatchEsgAnalysisPdfExportDownloadUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'asyncJobId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBatchEsgAnalysisPdfExportDownloadUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'asyncJobId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'asyncJobId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBatchEsgAnalysisPdfExportDownloadUrlQuery,
  GetBatchEsgAnalysisPdfExportDownloadUrlQueryVariables
>;
export const CompletedBatchExportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompletedBatchExports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'async_job' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'EnumValue', value: 'COMPLETED' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '25' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompletedBatchExportsQuery, CompletedBatchExportsQueryVariables>;
export const CreateDriveFolderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateDriveFolder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateFolderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFolder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'folderId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDriveFolderMutation, CreateDriveFolderMutationVariables>;
export const RenameDriveFolderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RenameDriveFolder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RenameFolderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renameFolder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'folderId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RenameDriveFolderMutation, RenameDriveFolderMutationVariables>;
export const MoveDriveFolderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MoveDriveFolder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'MoveFolderInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'moveFolder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'folderId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MoveDriveFolderMutation, MoveDriveFolderMutationVariables>;
export const DeleteDriveFolderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDriveFolder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeleteFolderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteFolder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'folderId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDriveFolderMutation, DeleteDriveFolderMutationVariables>;
export const MoveFileToFolderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MoveFileToFolder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MoveFileToFolderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'moveFileToFolder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fileId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MoveFileToFolderMutation, MoveFileToFolderMutationVariables>;
export const RenameDriveFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RenameDriveFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'RenameFileInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'renameFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fileId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RenameDriveFileMutation, RenameDriveFileMutationVariables>;
export const RemoveFileFromFolderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveFileFromFolder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RemoveFileFromFolderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeFileFromFolder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fileId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveFileFromFolderMutation, RemoveFileFromFolderMutationVariables>;
export const UploadFileToDriveFolderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UploadFileToDriveFolder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadFileToDriveFolderInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadFileToDriveFolder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadFileToDriveFolderMutation, UploadFileToDriveFolderMutationVariables>;
export const ConfirmDriveUploadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConfirmDriveUpload' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConfirmDriveUploadInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'confirmDriveUpload' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'fileId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConfirmDriveUploadMutation, ConfirmDriveUploadMutationVariables>;
export const ConvertFileToEnergyCertificateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConvertFileToEnergyCertificate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConvertFileToEnergyCertificateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'convertFileToEnergyCertificate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'buildingDraftId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyCertificateDraftId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConvertFileToEnergyCertificateMutation, ConvertFileToEnergyCertificateMutationVariables>;
export const ConvertFilesToEnergyCertificatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConvertFilesToEnergyCertificates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConvertFilesToEnergyCertificatesInput' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'autoCreateBuildings' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'convertFilesToEnergyCertificates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'autoCreateBuildings' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'autoCreateBuildings' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConvertFilesToEnergyCertificatesMutation,
  ConvertFilesToEnergyCertificatesMutationVariables
>;
export const GetDriveFolderChildrenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDriveFolderChildren' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'parentIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFolderChildren' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'parentIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'parentIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'folders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'folderTypeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'childCount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDriveFolderChildrenQuery, GetDriveFolderChildrenQueryVariables>;
export const GetDriveRootFolderForTreeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDriveRootFolderForTree' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRootFolderForTree' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rootFolder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'folderTypeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'childCount' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDriveRootFolderForTreeQuery, GetDriveRootFolderForTreeQueryVariables>;
export const GetBuildingFolderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBuildingFolder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBuildingFolder' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'folderId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetBuildingFolderQuery, GetBuildingFolderQueryVariables>;
export const GetDriveFolderContentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDriveFolderContents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'folderId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFolderContents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'folderId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'folderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'folders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parentId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'folderTypeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'portfolioId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'economicUnitId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'buildingId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fileMemberships' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'folderId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'file' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uploading' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'energyCertificates' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildingId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildingDraftId' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'consumptionInvoices' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildingId' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'emissionCertificates' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'energyCertificateDrafts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'buildingDraft' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'consumptionInvoiceDrafts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'buildingId' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'emissionCertificateDrafts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDriveFolderContentsQuery, GetDriveFolderContentsQueryVariables>;
export const GetDriveFolderBreadcrumbDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDriveFolderBreadcrumb' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'folderId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFolderBreadcrumb' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'folderId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'folderId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'breadcrumb' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'folderTypeId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDriveFolderBreadcrumbQuery, GetDriveFolderBreadcrumbQueryVariables>;
export const CreateCustomTargetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCustomTarget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'target_definitions' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'TargetDefinitionInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCustomTarget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'target_definitions' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'target_definitions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTarget' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTarget' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTarget' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'target_definitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target_definition_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCustomTargetMutation, CreateCustomTargetMutationVariables>;
export const UpdateCustomTargetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCustomTarget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'target_definitions' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'TargetDefinitionInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCustomTarget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'target_definitions' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'target_definitions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTarget' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTarget' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTarget' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'target_definitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target_definition_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCustomTargetMutation, UpdateCustomTargetMutationVariables>;
export const DeleteCustomTargetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCustomTarget' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCustomTarget' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCustomTargetMutation, DeleteCustomTargetMutationVariables>;
export const SetCustomTargetActiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetCustomTargetActive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCustomTargetActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetCustomTargetActiveMutation, SetCustomTargetActiveMutationVariables>;
export const CreateCustomFieldDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCustomField' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'custom_field_entity_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'custom_field_type_enum' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'suffix' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCustomField' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'key' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'key' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'suffix' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'suffix' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>;
export const EditCustomFieldDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EditCustomField' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'showInAnalysis' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'suffix' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'editCustomField' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'showInAnalysis' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'showInAnalysis' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'suffix' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'suffix' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EditCustomFieldMutation, EditCustomFieldMutationVariables>;
export const DeleteCustomFieldDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteCustomField' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCustomField' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'success' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCustomFieldMutation, DeleteCustomFieldMutationVariables>;
export const GetAllCustomTargetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllCustomTargets' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAllCustomTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTarget' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTarget' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTarget' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'target_definitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target_definition_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllCustomTargetsQuery, GetAllCustomTargetsQueryVariables>;
export const GetActiveCustomTargetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetActiveCustomTarget' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActiveCustomTarget' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTarget' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTarget' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTarget' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'target_definitions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target_definition_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActiveCustomTargetQuery, GetActiveCustomTargetQueryVariables>;
export const GetAllCustomFieldsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllCustomFields' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'custom_field_entity_enum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'custom_field' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entity_type' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entity_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'suffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'show_in_analysis' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllCustomFieldsQuery, GetAllCustomFieldsQueryVariables>;
export const GetPortfolioAndBuildingTableEntriesPermissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPortfolioAndBuildingTableEntriesPermissions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_portfolio_permission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'portfolio_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'write' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_building_permission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'building_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'write' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPortfolioAndBuildingTableEntriesPermissionsQuery,
  GetPortfolioAndBuildingTableEntriesPermissionsQueryVariables
>;
export const PortfolioManagementCreatePortfolioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PortfolioManagementCreatePortfolio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'baseEmissionFactorType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'configId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPortfolio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'configId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'configId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'baseEmissionFactorType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'baseEmissionFactorType' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PortfolioManagementCreatePortfolioMutation,
  PortfolioManagementCreatePortfolioMutationVariables
>;
export const PortfolioManagementDeletePortfolioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PortfolioManagementDeletePortfolio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_portfolio_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PortfolioManagementDeletePortfolioMutation,
  PortfolioManagementDeletePortfolioMutationVariables
>;
export const PortfolioManagementUpdatePortfolioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'PortfolioManagementUpdatePortfolio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'settings' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePortfolioSettingsType' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePortfolio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'settings' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'settings' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PortfolioManagementUpdatePortfolioMutation,
  PortfolioManagementUpdatePortfolioMutationVariables
>;
export const PortfolioManagementGetAllPortfoliosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PortfolioManagementGetAllPortfolios' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PortfolioManagementPortfolio' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PortfolioManagementPortfolio' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'economic_units_with_buildings' },
            name: { kind: 'Name', value: 'economic_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'buildings_aggregate' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'count' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'predicate' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_gt' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PortfolioManagementGetAllPortfoliosQuery,
  PortfolioManagementGetAllPortfoliosQueryVariables
>;
export const PortfolioManagementGetAllPortfoliosWithWritePermissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PortfolioManagementGetAllPortfoliosWithWritePermissions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'org' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'users' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'id' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'role_id' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'EnumValue', value: 'ORG_ADMIN' },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'user_permissions' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_and' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'write' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'BooleanValue', value: true },
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'user_id' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_eq' },
                                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PortfolioManagementPortfolio' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PortfolioManagementPortfolio' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'economic_units_with_buildings' },
            name: { kind: 'Name', value: 'economic_units' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'buildings_aggregate' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'count' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'predicate' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_gt' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PortfolioManagementGetAllPortfoliosWithWritePermissionsQuery,
  PortfolioManagementGetAllPortfoliosWithWritePermissionsQueryVariables
>;
export const PortfolioObjectsAggregateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PortfolioObjectsAggregate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'economic_unit' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'portfolio_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'report_buildings' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'building' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'economic_unit' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'portfolio_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portfolio_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portfolio_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'portfolio_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_action_plans_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'portfolio_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'active_scenario' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'scenario' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'portfolio_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'economic_unit' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'portfolio_id' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_eq' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_draft_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'building' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'economic_unit' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'portfolio_id' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_eq' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortfolioObjectsAggregateQuery, PortfolioObjectsAggregateQueryVariables>;
export const GetPortfoliosAndEconomicUnitsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPortfoliosAndEconomicUnits' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'has_write_permission' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'economic_units' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPortfoliosAndEconomicUnitsQuery, GetPortfoliosAndEconomicUnitsQueryVariables>;
export const ReportDeleteReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReportDeleteReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_report_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportDeleteReportMutation, ReportDeleteReportMutationVariables>;
export const CreateReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildings' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'due_date' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'end_date' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'report_template_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'responsible_user_id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'start_date' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DateTime' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'parameters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'buildings' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'buildings' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'due_date' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'due_date' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'end_date' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'end_date' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'report_template_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'report_template_id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'start_date' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'start_date' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'responsible_user_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'responsible_user_id' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'report_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateReportMutation, CreateReportMutationVariables>;
export const ResetReportAnswerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetReportAnswer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rootQuestionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetAnswers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'report_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'root_question_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rootQuestionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetReportAnswerMutation, ResetReportAnswerMutationVariables>;
export const completeReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'completeReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_report_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'completed' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<completeReportMutation, completeReportMutationVariables>;
export const AcceptAutofillReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AcceptAutofillReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptAutofillReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'report_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_question_ids' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptAutofillReportMutation, AcceptAutofillReportMutationVariables>;
export const AnswerQuestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AnswerQuestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'answers' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AnswerParamsInput' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'report_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'building_id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'answerQuestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'report_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'report_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'answers' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'answers' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'building_id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_answer_ids' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ReportAnswerId' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AnswerQuestionsMutation, AnswerQuestionsMutationVariables>;
export const createEvidenceFromFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEvidenceFromFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEvidenceFromFile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'report_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'CreateEvidenceOutput' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'file' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'upload_url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<createEvidenceFromFileMutation, createEvidenceFromFileMutationVariables>;
export const createEvidenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEvidence' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_report_evidence_one' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'object' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'report_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'url' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'url' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<createEvidenceMutation, createEvidenceMutationVariables>;
export const deleteEvidenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteEvidence' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'evidenceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'delete_report_evidence_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'evidenceId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<deleteEvidenceMutation, deleteEvidenceMutationVariables>;
export const ExportReportAsPdfAsyncDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExportReportAsPdfAsync' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportReportAsPdfAsync' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'report_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'asyncJobId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportReportAsPdfAsyncMutation, ExportReportAsPdfAsyncMutationVariables>;
export const ExportReportAsExcelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExportReportAsExcel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'exportReportAsExcel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'report_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'body' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportReportAsExcelMutation, ExportReportAsExcelMutationVariables>;
export const ReportGetReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReportGetReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportGetReportByPk' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplateSections' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_template_section' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'order' } },
          { kind: 'Field', name: { kind: 'Name', value: 'parent_section_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'target' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_template' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'single_building' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excel_template_path_de' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excel_template_path_en' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_sections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'order' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplateSections' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkResponsibleUser' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'user' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPk' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'end_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'start_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'due_date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportGetReportByPkReportTemplate' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsible_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportGetReportByPkResponsibleUser' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_building_details' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portfolio_name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_building_details_aggregate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_and' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'state' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_eq' },
                                      value: { kind: 'EnumValue', value: 'UNANSWERED' },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: '_or' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'autofill' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: '_is_null' },
                                                value: { kind: 'BooleanValue', value: false },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: { kind: 'Name', value: 'report_answer_autofill_options' },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'report_template_question_option' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'value' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: '_is_null' },
                                                            value: { kind: 'BooleanValue', value: false },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'evidence_required' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportGetReportQuery, ReportGetReportQueryVariables>;
export const ReportingReportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReportingReports' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_overview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'report_id' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'report_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'report_template_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'report_template_title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'report_template_excel_path_de' } },
                { kind: 'Field', name: { kind: 'Name', value: 'report_template_excel_path_en' } },
                { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'responsible_user_last_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'portfolio_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'streets' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportingReportsQuery, ReportingReportsQueryVariables>;
export const CreateReportGetAllTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateReportGetAllTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'report_template' },
            name: { kind: 'Name', value: 'getAllLatestReportTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CreateReportModalGetAllTemplatesTemplate' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CreateReportModalGetAllTemplatesTemplate' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ReportTemplateOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description_en' } },
          { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'single_building' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateReportGetAllTemplatesQuery, CreateReportGetAllTemplatesQueryVariables>;
export const CreateReportModalAllUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateReportModalAllUsers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'first_name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportGetReportByPkResponsibleUser' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportGetReportByPkResponsibleUser' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'user' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateReportModalAllUsersQuery, CreateReportModalAllUsersQueryVariables>;
export const CreateReportModalBuildingsInPortfolioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CreateReportModalBuildingsInPortfolio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'areas' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'area_type_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'EnumValue', value: 'EBF' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'class_of_use_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateReportModalBuildingsInPortfolioQuery,
  CreateReportModalBuildingsInPortfolioQueryVariables
>;
export const AllReportAutofillQuestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllReportAutofillQuestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_answers' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_and' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'state' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_eq' },
                                            value: { kind: 'EnumValue', value: 'UNANSWERED' },
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'report_template_question' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'evidence_required' },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: { kind: 'Name', value: '_neq' },
                                                  value: { kind: 'BooleanValue', value: true },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_or' },
                                      value: {
                                        kind: 'ListValue',
                                        values: [
                                          {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'autofill' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: '_is_null' },
                                                      value: { kind: 'BooleanValue', value: false },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                          {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: { kind: 'Name', value: 'report_answer_autofill_options' },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: { kind: 'Name', value: 'report_template_question_option' },
                                                      value: {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                          {
                                                            kind: 'ObjectField',
                                                            name: { kind: 'Name', value: 'value' },
                                                            value: {
                                                              kind: 'ObjectValue',
                                                              fields: [
                                                                {
                                                                  kind: 'ObjectField',
                                                                  name: { kind: 'Name', value: '_is_null' },
                                                                  value: { kind: 'BooleanValue', value: false },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportAnswerForAutofill' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportAnswerForAutofill' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_answer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autofill' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer_autofill_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_option' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'report_question_id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllReportAutofillQuestionsQuery, AllReportAutofillQuestionsQueryVariables>;
export const GetReportCompletionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetReportCompletion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReportCompletionQuery, GetReportCompletionQueryVariables>;
export const GetSectionsAnswerCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSectionsAnswerCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'report_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportAnswersState' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportAnswersState' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_answer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template_question' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_section' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSectionsAnswerCountQuery, GetSectionsAnswerCountQueryVariables>;
export const GetSectionsProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSectionsProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_section_progress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'report_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ReportSectionsProgress' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportSectionsProgress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_section_progress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'report_template_section_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSectionsProgressQuery, GetSectionsProgressQueryVariables>;
export const ReportQuestionGetOptionsWithSubquestionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReportQuestionGetOptionsWithSubquestions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template_question_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report_template_child_questions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'order' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'parent_option_id' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReportQuestionGetOptionsWithSubquestionsQuery,
  ReportQuestionGetOptionsWithSubquestionsQueryVariables
>;
export const SubsectionsProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SubsectionsProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_building_details' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report_sections_progress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'SubsectionProgress' } },
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_sections_progress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SubsectionProgress' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SubsectionProgress' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_section_progress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template_section' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'target' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubsectionsProgressQuery, SubsectionsProgressQueryVariables>;
export const ReportSectionGetRootQuestionsAndAnswersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReportSectionGetRootQuestionsAndAnswers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int_comparison_exp' } },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_answers' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'report_template_question' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'parent_section_id' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_eq' },
                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'sectionId' } },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'building_id' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'report_template_question' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'order' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ReportSectionGetRootQuestionsAndAnswersAnswers' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportSectionGetRootQuestionsAndAnswersAnswers' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_answer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'report_question_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autofill' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template_question' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'evidence_required' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer_autofill_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_option' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer_chosen_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_option' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReportSectionGetRootQuestionsAndAnswersQuery,
  ReportSectionGetRootQuestionsAndAnswersQueryVariables
>;
export const ReportSectionGetRootQuestionAndAnswerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReportSectionGetRootQuestionAndAnswer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template_question_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_answers' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'report_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'report_template_question' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'order' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ReportSectionGetRootQuestionsAndAnswersAnswers' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportSectionGetRootQuestionsAndAnswersAnswers' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_answer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'report_question_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autofill' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template_question' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'evidence_required' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer_autofill_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_option' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer_chosen_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_option' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReportSectionGetRootQuestionAndAnswerQuery,
  ReportSectionGetRootQuestionAndAnswerQueryVariables
>;
export const GET_NESTED_QUESTION_ANSWERDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_NESTED_QUESTION_ANSWER' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_answers' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'report_question_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ReportSectionGetRootQuestionsAndAnswersAnswers' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ReportSectionGetRootQuestionsAndAnswersAnswers' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'report_answer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'report_question_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'autofill' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_template_question' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'evidence_required' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer_autofill_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_option' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_answer_chosen_options' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'updated_at' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template_question_option' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GET_NESTED_QUESTION_ANSWERQuery, GET_NESTED_QUESTION_ANSWERQueryVariables>;
export const ReportHeadGetReportScoresDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ReportHeadGetReportScores' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_template' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report_template_scores' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'where' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'display' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_eq' },
                                        value: { kind: 'BooleanValue', value: true },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'order_by' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'order' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'display_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'max_score' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'report_scores' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'where' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'report_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'max_score' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportHeadGetReportScoresSubscription, ReportHeadGetReportScoresSubscriptionVariables>;
export const ReportScoreAsyncJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'ReportScoreAsyncJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'async_job_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'StringValue', value: 'REFRESH_REPORT_SCORES', block: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entity_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'EnumValue', value: 'PENDING' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportScoreAsyncJobSubscription, ReportScoreAsyncJobSubscriptionVariables>;
export const ReportHeadGetReportProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReportHeadGetReportProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_sections_progress' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_and' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'report_template_section' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'parent_section_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_is_null' },
                                              value: { kind: 'BooleanValue', value: true },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'building_id' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: '_is_null' },
                                        value: { kind: 'BooleanValue', value: true },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'order_by' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'report_template_section' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'order' },
                                  value: { kind: 'EnumValue', value: 'asc' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report_template_section' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReportHeadGetReportProgressQuery, ReportHeadGetReportProgressQueryVariables>;
export const GET_ALL_EVIDENCESDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_ALL_EVIDENCES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_evidence' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'report_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GET_ALL_EVIDENCESQuery, GET_ALL_EVIDENCESQueryVariables>;
export const GET_QUESTION_EVIDENCESDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_QUESTION_EVIDENCES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_question_evidence' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_and' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'report_evidence' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'report_id' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_eq' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'report_template_question_id' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_eq' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'questionId' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_evidence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'file' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GET_QUESTION_EVIDENCESQuery, GET_QUESTION_EVIDENCESQueryVariables>;
export const GET_All_EVIDENCESDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GET_All_EVIDENCES' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_evidence' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'report_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'file' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'report_question_evidences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'report_template_question' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GET_All_EVIDENCESQuery, GET_All_EVIDENCESQueryVariables>;
export const UpdateSandboxFeatureFlagDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSandboxFeatureFlag' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSandboxFeatureFlag' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'flag' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSandboxFeatureFlagMutation, UpdateSandboxFeatureFlagMutationVariables>;
export const ResetSandboxFeatureFlagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetSandboxFeatureFlags' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'resetSandboxFeatureFlags' } }],
      },
    },
  ],
} as unknown as DocumentNode<ResetSandboxFeatureFlagsMutation, ResetSandboxFeatureFlagsMutationVariables>;
export const GetDefaultFeatureFlagValuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetDefaultFeatureFlagValues' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'featureFlagDefaultValues' },
            name: { kind: 'Name', value: 'getDefaultFeatureFlagValues' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDefaultFeatureFlagValuesQuery, GetDefaultFeatureFlagValuesQueryVariables>;
export const StatusQuoAnalysisGetFilteredBuildingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetFilteredBuildings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'building_bool_exp' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'address' },
                          value: {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'street' },
                                value: { kind: 'EnumValue', value: 'asc' },
                              },
                            ],
                          },
                        },
                      ],
                    },
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'id' },
                          value: { kind: 'EnumValue', value: 'asc' },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SearchBuilding' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SearchBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'folder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetFilteredBuildingsQuery,
  StatusQuoAnalysisGetFilteredBuildingsQueryVariables
>;
export const StatusQuoAnalysisGetFilteredBuildingsFromViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetFilteredBuildingsFromView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingOrderByInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBuildingList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingWhere' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingDetails' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingRowOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'types_of_use' } },
          { kind: 'Field', name: { kind: 'Name', value: 'first_stranding_year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_data' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2_emissions_total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2_costs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2_costs_total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_primary' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_primary_total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energy_final_total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiency_class' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eu_taxonomy_compliance' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slf_compliant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'quick_check' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'full_check' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'report_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issued_at' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetFilteredBuildingsFromViewQuery,
  StatusQuoAnalysisGetFilteredBuildingsFromViewQueryVariables
>;
export const StatusQuoAnalysisGetBenchmarkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetBenchmark' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'classOfUse' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'class_of_use_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typeOfUse' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'type_of_use_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBenchmark' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'portfolioId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'classOfUse' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'classOfUse' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typeOfUse' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typeOfUse' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingsBenchmarkCrremOutput' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingsBenchmarkCrrem' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'BuildingsBenchmarkNationalEnergyLawOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingsBenchmarkNationalEnergyLaw' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingsBenchmarkCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingsBenchmarkCrremOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageFinalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averagePrimaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageHeatingDemand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageEnergyCosts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crremAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingsBenchmarkNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingsBenchmarkNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageFinalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averagePrimaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageHeatingDemand' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Costs' } },
          { kind: 'Field', name: { kind: 'Name', value: 'averageEnergyCosts' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nationalEnergyLawAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StatusQuoAnalysisGetBenchmarkQuery, StatusQuoAnalysisGetBenchmarkQueryVariables>;
export const StatusQuoAnalysisGetAnalyzedBuildingsCoreDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsCore' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsCore' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'analyzedBuildingsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buildingsWithoutEnergyPaths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'economicUnitsCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'floorAreaByClassOfUse' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'classOfUse' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'minConstructionYear' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsCoreQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsCoreQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsSlfComplianceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsSlfCompliance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsSlfCompliance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slfCompliantBuildingsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slfCompliantEconomicUnitsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slfFullAssessmentBuildingsCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsSlfComplianceQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsSlfComplianceQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsGeneralDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsGeneralData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsGeneralData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'buildingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'economicUnitId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2Intensity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typeOfUse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'finalEnergy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainEnergySourceType' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsGeneralDataQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsGeneralDataQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsClimateRisksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsClimateRisks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsClimateRisks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timespan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsClimateRisksQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsClimateRisksQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsKpisDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsKpis' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsKpis' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'averageFinalEnergy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averagePrimaryEnergy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageHeatingDemand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2CostAtYear' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsKpisQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsKpisQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsCostPathsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsCostPaths' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsCostPaths' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energyCostPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2CostDistributionPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'landlordPath' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenantPath' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsCostPathsQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsCostPathsQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsByTaxBracketDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsByTaxBracket' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsByTaxBracket' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'taxBracket' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsByTaxBracketQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsByTaxBracketQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsByEfficiencyClassDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsByEfficiencyClass' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsByEfficiencyClass' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsByEfficiencyClassQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsByEfficiencyClassQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsEuTaxonomyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsEuTaxonomy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsEuTaxonomy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsEuTaxonomyQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsEuTaxonomyQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsByEnergySourceTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsByEnergySourceType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsByEnergySourceType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsByEnergySourceTypeQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsByEnergySourceTypeQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsEnergyDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsEnergyData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsEnergyData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionM2' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsEnergyDataQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsEnergyDataQueryVariables
>;
export const StatusQuoAnalysisGetAnalyzedBuildingsAnalysisDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisGetAnalyzedBuildingsAnalysis' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuildingsAnalysis' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysisResultOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysisResult' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysisResultOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysisResult' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Scope123Co2Emissions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Scope123Co2EmissionsOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StrandingData' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StrandingDataOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'year' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysis' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysisOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2TargetPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energyTargetPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2Path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cumulativeExcessEmissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excessEmissionCostPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope123Co2Emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'wholeBuilding' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'landlord' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'strandingData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StrandingData' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTargets' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTargetResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysis' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysisOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'averageCo2Emissions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2Path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysisResult' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysisResultOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crremAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyzeBuildingsCrremAnalysis' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargetPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'targetPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'intersectionYear' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysisResult' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysisResultOutput' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nationalEnergyLawAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyzeBuildingsNationalEnergyLawAnalysis' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisGetAnalyzedBuildingsAnalysisQuery,
  StatusQuoAnalysisGetAnalyzedBuildingsAnalysisQueryVariables
>;
export const StatusQuoAnalysisBuildingGetBuildingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisBuildingGetBuilding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAnalyzedBuilding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingCrremOutput' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyzeBuildingCrrem' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'AnalyzeBuildingNationalEnergyLawOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AnalyzeBuildingNationalEnergyLaw' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingModelTransition' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingModelTransitionOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
          { kind: 'Field', name: { kind: 'Name', value: 'co2Intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energyIntensity' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Scope123Co2Emissions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Scope123Co2EmissionsOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2EmissionsTotal' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTargets' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTargetResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'final_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primary_energy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2_emissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reached' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetValue' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SLFAnalysis' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SlfComplianceAnalysisOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastSlfReport' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issuedAt' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'ongoingReportId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'compliantFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CertificateSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EfficiencyClassSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'EuTaxonomyComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ReportSlfComplianceAnalysisOutput' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issuedAt' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notCompliantFactors' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'level' } },
                { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                { kind: 'Field', name: { kind: 'Name', value: 'certificateType' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingCrrem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingCrremOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostDistributionPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'landlordPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenantPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyCostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyConsumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionM2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionTotal' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taxBracket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
          { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'finalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heatingDemand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climateRisks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timespan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'floorAreaByClassOfUse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'classOfUse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'crremAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2TargetPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyTargetPath' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2Path' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energyPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cumulativeExcessEmissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'excessEmissionCostPath' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildingModelTransitions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModelTransition' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'scope123Co2Emissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'wholeBuilding' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'landlord' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tenant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Scope123Co2Emissions' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slfAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SLFAnalysis' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargetPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'targetPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'intersectionYear' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AnalyzeBuildingNationalEnergyLaw' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AnalyzeBuildingNationalEnergyLawOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2CostDistributionPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'landlordPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tenantPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyCostPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyConsumers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionM2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyConsumptionTotal' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'taxBracket' } },
          { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
          { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyCompliance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'finalEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heatingDemand' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'climateRisks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'timespan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'floorAreaByClassOfUse' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'classOfUse' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nationalEnergyLawAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Emissions' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2Path' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energyPath' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'm2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildingModelTransitions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingModelTransition' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTargets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTargets' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slfAnalysis' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SLFAnalysis' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisBuildingGetBuildingQuery,
  StatusQuoAnalysisBuildingGetBuildingQueryVariables
>;
export const QueueStatusQuoAnalysisPdfExportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'QueueStatusQuoAnalysisPdfExport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'useCustomTargetPath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'queueEsgAnalysisPdfExport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'useCustomTargetPath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'useCustomTargetPath' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'asyncJobId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueueStatusQuoAnalysisPdfExportMutation, QueueStatusQuoAnalysisPdfExportMutationVariables>;
export const QueueSummaryOnePagerPdfExportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'QueueSummaryOnePagerPdfExport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tab' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'status_quo_pdf_export_tab_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayBase' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'benchmarkPortfolioId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'classOfUse' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'class_of_use_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typeOfUse' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'type_of_use_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'crremPathGraphType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'crrem_path_graph_type_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'crremPathsType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'demandScopePerspective' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'scope_perspective_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'discountRate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionScopePerspective' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'scope_perspective_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'queueSummaryOnePagerPdfExport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tab' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tab' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'displayBase' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayBase' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'benchmarkPortfolioId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'benchmarkPortfolioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'classOfUse' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'classOfUse' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'typeOfUse' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'typeOfUse' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'crremPathGraphType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'crremPathGraphType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'crremPathsType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'crremPathsType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'demandScopePerspective' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'demandScopePerspective' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'discountRate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'discountRate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'consumptionScopePerspective' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'consumptionScopePerspective' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'asyncJobId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueueSummaryOnePagerPdfExportMutation, QueueSummaryOnePagerPdfExportMutationVariables>;
export const QueueEconomicUnitEsgAnalysisPdfExportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'QueueEconomicUnitEsgAnalysisPdfExport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'useCustomTargetPath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'queueEconomicUnitEsgAnalysisPdfExport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'economicUnitId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'useCustomTargetPath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'useCustomTargetPath' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'asyncJobId' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  QueueEconomicUnitEsgAnalysisPdfExportMutation,
  QueueEconomicUnitEsgAnalysisPdfExportMutationVariables
>;
export const QueueBatchEsgAnalysisPdfExportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'QueueBatchEsgAnalysisPdfExport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'useCustomTargetPath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'queueBatchEsgAnalysisPdfExport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'economicUnitId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'portfolioId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolioId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'useCustomTargetPath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'useCustomTargetPath' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'asyncJobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalBuildings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QueueBatchEsgAnalysisPdfExportMutation, QueueBatchEsgAnalysisPdfExportMutationVariables>;
export const StatusQuoAnalysisConsumptionAnalysisDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisConsumptionAnalysis' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fromYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'toYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionAnalysis' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fromYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fromYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'toYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'toYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'averageAbsolute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'average' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'series' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'from' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'to' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sumAbsolute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'sum' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisConsumptionAnalysisQuery,
  StatusQuoAnalysisConsumptionAnalysisQueryVariables
>;
export const StatusQuoAnalysisConsumptionAllocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StatusQuoAnalysisConsumptionAllocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perspective' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'scope_perspective_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionAllocation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perspective' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perspective' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carbonEmissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConsumptionAllocationCrremCarbonEmission' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConsumptionAllocationNationalEnergyLawCarbonEmission' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2Tax' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'costShare' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalAbsolute' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'forecastItems' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'landlordShare' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'landlordShareAbsolute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'landlordSharePercentage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tenantShare' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tenantShareAbsolute' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tenantSharePercentage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'energyConsumptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'valueAbsolute' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalAbsolute' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConsumptionAllocationCrremCarbonEmission' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsumptionAllocationCrremCarbonEmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensityAbsolute' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConsumptionAllocationNationalEnergyLawCarbonEmission' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConsumptionAllocationNationalEnergyLawCarbonEmission' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensityAbsolute' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StatusQuoAnalysisConsumptionAllocationQuery,
  StatusQuoAnalysisConsumptionAllocationQueryVariables
>;
export const GetConsumptionAllocationByScope123PerspectiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionAllocationByScope123Perspective' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perspective' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'scope_perspective_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionAllocationByScope123Perspective' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perspective' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perspective' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'carbonEmissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConsumptionAllocationCrremCarbonEmission' },
                      },
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ConsumptionAllocationNationalEnergyLawCarbonEmission' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConsumptionAllocationCrremCarbonEmission' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsumptionAllocationCrremCarbonEmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensityAbsolute' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scope3' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConsumptionAllocationNationalEnergyLawCarbonEmission' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ConsumptionAllocationNationalEnergyLawCarbonEmission' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'analysisType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'intensityAbsolute' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConsumptionAllocationByScope123PerspectiveQuery,
  GetConsumptionAllocationByScope123PerspectiveQueryVariables
>;
export const getBuildingCRREMConsumptionAnalysisDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getBuildingCRREMConsumptionAnalysis' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getBuildingCRREMConsumptionAnalysis' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'building_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BuildingCRREMConsumptionAnalysisOutput' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BuildingCRREMConsumptionAnalysisOutput' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GetBuildingCRREMConsumptionAnalysisOutput' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'co2TargetPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'energyTargetPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'co2Path' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energyPath' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'm2' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
          { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cumulativeExcessEmissions' } },
          { kind: 'Field', name: { kind: 'Name', value: 'excessEmissionCostPath' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getBuildingCRREMConsumptionAnalysisQuery,
  getBuildingCRREMConsumptionAnalysisQueryVariables
>;
export const GetConsumptionCoverageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionCoverage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionCoverage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'buildingsWithoutConsumptionData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalBuildings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionCoverageQuery, GetConsumptionCoverageQueryVariables>;
export const GetConsumptionFinalEnergyDevelopmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionFinalEnergyDevelopment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionFinalEnergyDevelopment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'heatingBreakdown' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueRelative' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueAbsolute' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'electricityBreakdown' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueRelative' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueAbsolute' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAbsolute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRelative' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConsumptionFinalEnergyDevelopmentQuery,
  GetConsumptionFinalEnergyDevelopmentQueryVariables
>;
export const GetConsumptionDeviationFromDemandDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionDeviationFromDemand' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionDeviationFromDemand' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lt_neg_30' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neg_30_neg_10' } },
                { kind: 'Field', name: { kind: 'Name', value: 'neg_10_10' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pos_10_30' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gt_30' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionDeviationFromDemandQuery, GetConsumptionDeviationFromDemandQueryVariables>;
export const GetConsumptionEnergySourcesByFinalEnergyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionEnergySourcesByFinalEnergy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionEnergySourcesByFinalEnergy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueAbsolute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueRelative' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConsumptionEnergySourcesByFinalEnergyQuery,
  GetConsumptionEnergySourcesByFinalEnergyQueryVariables
>;
export const GetConsumptionEnergySourcesByCO2IntensityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionEnergySourcesByCO2Intensity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionEnergySourcesByCO2Intensity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueAbsolute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueRelative' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConsumptionEnergySourcesByCO2IntensityQuery,
  GetConsumptionEnergySourcesByCO2IntensityQueryVariables
>;
export const GetConsumptionEnergySourcesByBuildingCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionEnergySourcesByBuildingCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionEnergySourcesByBuildingCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'energySourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConsumptionEnergySourcesByBuildingCountQuery,
  GetConsumptionEnergySourcesByBuildingCountQueryVariables
>;
export const GetConsumptionCO2IntensityDevelopmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionCO2IntensityDevelopment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionCO2IntensityDevelopment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueRelative' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valueAbsolute' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetConsumptionCO2IntensityDevelopmentQuery,
  GetConsumptionCO2IntensityDevelopmentQueryVariables
>;
export const GetConsumptionCRREMPathsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionCRREMPaths' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionCRREMPaths' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2PathRelative' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2TargetPathRelative' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyPathRelative' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyTargetPathRelative' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'strandingData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'excessEmissionCostPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'strandingYear' } },
                { kind: 'Field', name: { kind: 'Name', value: 'yearOfExcedance' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionCRREMPathsQuery, GetConsumptionCRREMPathsQueryVariables>;
export const GetConsumptionPortfolioKPIsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionPortfolioKPIs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionPortfolioKPIs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'finalEnergyRelative' } },
                { kind: 'Field', name: { kind: 'Name', value: 'finalEnergyTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergyRelative' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergyTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2Relative' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2Total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyCostRelative' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyCostTotal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2TaxRelative' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2TaxTotal' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionPortfolioKPIsQuery, GetConsumptionPortfolioKPIsQueryVariables>;
export const getStatusQuoConsumptionAnalysisKPIsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getStatusQuoConsumptionAnalysisKPIs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEsgConsumptionAnalysisKPIs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'year' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'year' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'co2Intensity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2IntensityAbsolute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2Tax' } },
                { kind: 'Field', name: { kind: 'Name', value: 'co2TaxAbsolute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'efficiencyClass' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyCost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'energyCostAbsolute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'finalEnergy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'finalEnergyAbsolute' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergy' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergyAbsolute' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  getStatusQuoConsumptionAnalysisKPIsQuery,
  getStatusQuoConsumptionAnalysisKPIsQueryVariables
>;
export const PortfolioCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PortfolioCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio_aggregate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PortfolioCountQuery, PortfolioCountQueryVariables>;
export const getPortfoliosAggregateCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPortfoliosAggregateCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getPortfoliosAggregateCountQuery, getPortfoliosAggregateCountQueryVariables>;
export const EconomicUnitCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EconomicUnitCount' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'buildings' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'state' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'EnumValue', value: 'ACTIVE' },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EconomicUnitCountQuery, EconomicUnitCountQueryVariables>;
export const getPortfolioByIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPortfolioByIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PortfolioBasicDetails' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PortfolioBasicDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getPortfolioByIdsQuery, getPortfolioByIdsQueryVariables>;
export const getPortfoliosBySearchStringDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPortfoliosBySearchString' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio_bool_exp' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PortfolioBasicDetails' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PortfolioBasicDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getPortfoliosBySearchStringQuery, getPortfoliosBySearchStringQueryVariables>;
export const SearchBuildingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchBuildings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'address' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'street' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_ilike' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'address' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'city' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_ilike' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'address' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'postal_code' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_ilike' },
                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'customer_external_identifier' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_ilike' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'address' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'street' },
                            value: { kind: 'EnumValue', value: 'asc' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SearchBuilding' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SearchBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'folder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchBuildingsQuery, SearchBuildingsQueryVariables>;
export const getSingleBuildingBuildingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSingleBuildingBuilding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StatusQuoAnalysisBuildingBasicDetails' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusQuoAnalysisPortfolio' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StatusQuoAnalysisBuildingBasicDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'year_constructed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mapbox_building_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_citydb_gml_ids' } },
                { kind: 'Field', name: { kind: 'Name', value: 'building_lod1_ids' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StatusQuoAnalysisPortfolio' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responsible_user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areas' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'class_of_use_id' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_valuations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'valuation_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'valuation_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getSingleBuildingBuildingQuery, getSingleBuildingBuildingQueryVariables>;
export const getEconomicUnitsBySearchStringDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEconomicUnitsBySearchString' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_and' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'name' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_ilike' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'buildings' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'state' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_eq' },
                                            value: { kind: 'EnumValue', value: 'ACTIVE' },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EconomicUnitBasicDetails' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EconomicUnitBasicDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'economic_unit' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customer_economic_unit_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'country_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getEconomicUnitsBySearchStringQuery, getEconomicUnitsBySearchStringQueryVariables>;
export const getEconomicUnitsByIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEconomicUnitsByIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: '_and' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: '_in' },
                                      value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'buildings' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'state' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_eq' },
                                            value: { kind: 'EnumValue', value: 'ACTIVE' },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EconomicUnitBasicDetails' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EconomicUnitBasicDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'economic_unit' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'custom_data' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customer_economic_unit_id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'country_id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getEconomicUnitsByIdsQuery, getEconomicUnitsByIdsQueryVariables>;
export const getBuildingsByIdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getBuildingsByIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_in' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SearchBuilding' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SearchBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customer_external_identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'folder' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<getBuildingsByIdsQuery, getBuildingsByIdsQueryVariables>;
export const SearchPortfoliosDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchPortfolios' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_ilike' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'folder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchPortfoliosQuery, SearchPortfoliosQueryVariables>;
export const SearchEconomicUnitsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchEconomicUnits' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_ilike' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'folder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchEconomicUnitsQuery, SearchEconomicUnitsQueryVariables>;
export const CreateSharedBuildingSnapshotDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSharedBuildingSnapshot' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSharedBuildingSnapshot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'buildingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'buildingId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hash' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSharedBuildingSnapshotMutation, CreateSharedBuildingSnapshotMutationVariables>;
export const GetSharedBuildingSnapshotDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSharedBuildingSnapshot' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hash' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSharedBuildingSnapshot' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hash' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hash' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'data' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSharedBuildingSnapshotQuery, GetSharedBuildingSnapshotQueryVariables>;
export const GetConsumptionBuildingListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetConsumptionBuildingList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingWhere' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'analysis_reference_area_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'emission_factor_source_enum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConsumptionBuildingOrderByInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConsumptionBuildingList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportingYear' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportingYear' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'referenceAreaType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'referenceAreaType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emissionFactorSource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emissionFactorSource' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'typesOfUse' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isNewConstruction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'co2Relative' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'co2Total' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'co2TaxRelative' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'co2TaxTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergyRelative' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryEnergyTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finalEnergyRelative' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'finalEnergyTotal' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviationFromDemand' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConsumptionBuildingListQuery, GetConsumptionBuildingListQueryVariables>;
export const CreateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first_name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last_name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'role_enum' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role_description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first_name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first_name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last_name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last_name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'role' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'role_description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'role_description' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'user_id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first_name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last_name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'role_enum' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role_description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_user_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'first_name' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'first_name' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'last_name' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'last_name' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role_description' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'role_description' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'role_id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'created_at' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const ChangeUserLanguageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeUserLanguage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'language_enum' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'update_user_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pk_columns' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: '_set' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'language' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'language' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangeUserLanguageMutation, ChangeUserLanguageMutationVariables>;
export const DeleteUserAndtransferOwnershipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteUserAndtransferOwnership' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'transferOwnershipToUserId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'user_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'transfer_ownership_to_user_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'transferOwnershipToUserId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'UserId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserAndtransferOwnershipMutation, DeleteUserAndtransferOwnershipMutationVariables>;
export const UpsertBuildingPermissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertBuildingPermissions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'objects' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'user_building_permission_insert_input' } },
            },
          },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_building_permission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'objects' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_building_permission_user_id_building_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'read' },
                          { kind: 'EnumValue', value: 'write' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'building_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'building_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'write' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertBuildingPermissionsMutation, UpsertBuildingPermissionsMutationVariables>;
export const UpsertPortfolioPermissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertPortfolioPermissions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'objects' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'user_portfolio_permission_insert_input' } },
            },
          },
          defaultValue: { kind: 'ObjectValue', fields: [] },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insert_user_portfolio_permission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'objects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'objects' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'on_conflict' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'constraint' },
                      value: { kind: 'EnumValue', value: 'user_portfolio_permission_user_id_portfolio_id_key' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'update_columns' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          { kind: 'EnumValue', value: 'read' },
                          { kind: 'EnumValue', value: 'write' },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'returning' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'portfolio_id' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'portfolio_id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'write' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpsertPortfolioPermissionsMutation, UpsertPortfolioPermissionsMutationVariables>;
export const GetSessionDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSessionData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSessionData' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'args' }, value: { kind: 'ObjectValue', fields: [] } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'role' },
                        name: { kind: 'Name', value: 'userRole' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roleDescription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'org' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'orgSector' },
                        name: { kind: 'Name', value: 'orgSectorTypeId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgTypeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusTypeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userLogoutIdleTimeout' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEconomicUnitsToggled' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'enabledFeatureFlags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAdmin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstBuildingId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPortfolioWithWriteAccess' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSessionDataQuery, GetSessionDataQueryVariables>;
export const GetAllUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllUsers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role_id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const GetUserByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user_by_pk' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role_description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role_id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'org' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetAllUserObjectsAggregateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllUserObjectsAggregate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'report_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'responsible_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'scenario_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'owner_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'responsible_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building_draft_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'responsible_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'energy_certificate_draft_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'responsible_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'active_action_plans_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'scenario' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'owner_id' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: '_eq' },
                                  value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'action_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'action_plan' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'active_scenario' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'scenario' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'owner_id' },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: { kind: 'Name', value: '_eq' },
                                              value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_by_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'consumption_draft_aggregate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_by_user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'aggregate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'count' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllUserObjectsAggregateQuery, GetAllUserObjectsAggregateQueryVariables>;
export const GetNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetNotifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'user_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notification_template' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'href' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetCurrentFeatureFlagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCurrentFeatureFlags' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'getUserFeatureFlags' } }],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentFeatureFlagsQuery, GetCurrentFeatureFlagsQueryVariables>;
export const GetUserLoginHistoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserLoginHistory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserLoginHistory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'user_id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'user_id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'events' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ip' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locationInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'userAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastIp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'loginsCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserLoginHistoryQuery, GetUserLoginHistoryQueryVariables>;
export const GetUsersListWithFullnameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUsersListWithFullname' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'first_name' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'first_name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'last_name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUsersListWithFullnameQuery, GetUsersListWithFullnameQueryVariables>;
export const UpdateOrgPreferenceForEconomicUnitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOrgPreferenceForEconomicUnit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitEnabled' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCommonOrgPreferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isEconomicUnitsToggled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isEconomicUnitsToggled' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrgPreferenceForEconomicUnitMutation,
  UpdateOrgPreferenceForEconomicUnitMutationVariables
>;
export const UpdateOrgPreferenceForAutomaticActionCostUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOrgPreferenceForAutomaticActionCostUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'automaticActionCostUpdateEnabled' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCommonOrgPreferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isAutomaticActionCostUpdateToggled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'automaticActionCostUpdateEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isAutomaticActionCostUpdateToggled' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrgPreferenceForAutomaticActionCostUpdateMutation,
  UpdateOrgPreferenceForAutomaticActionCostUpdateMutationVariables
>;
export const UpdateOrgPreferenceForEconomicUnitInFileDriveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateOrgPreferenceForEconomicUnitInFileDrive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitInFileDriveEnabled' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setCommonOrgPreferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isEconomicUnitsInFileDriveToggled' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'economicUnitInFileDriveEnabled' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isEconomicUnitsInFileDriveToggled' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrgPreferenceForEconomicUnitInFileDriveMutation,
  UpdateOrgPreferenceForEconomicUnitInFileDriveMutationVariables
>;
export const SetOrgCo2PriceCurveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetOrgCo2PriceCurve' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetOrgCo2PriceCurveInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setOrgCo2PriceCurve' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'growthStartValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'growthAnnualPercent' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'anchors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pricePerTon' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetOrgCo2PriceCurveMutation, SetOrgCo2PriceCurveMutationVariables>;
export const SetOrgEuTaxonomyDatasourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetOrgEuTaxonomyDatasource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetOrgEuTaxonomyDatasourceInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setOrgEuTaxonomyDatasource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyDatasource' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetOrgEuTaxonomyDatasourceMutation, SetOrgEuTaxonomyDatasourceMutationVariables>;
export const SetOrgEmissionFactorPreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetOrgEmissionFactorPreferences' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetOrgEmissionFactorPreferencesInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setOrgEmissionFactorPreferences' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeEmissionFactorPreferences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CrremOrgPreferences' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'emissionFactorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'crremVersion' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'activeCRREMConfiguration' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'CRREMDefaultConfigurationObject' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'CRREMDefaultConfiguration' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'CRREMCustomConfigurationObject' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'CRREMCustomConfiguration' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'NationalEnergyLawOrgPreferences' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emissionFactorType' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'availableReportingYears' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CRREMDefaultConfiguration' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CRREMDefaultConfigurationObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emissionFactorType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setFor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'org' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolios' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CRREMCustomConfiguration' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CRREMCustomConfigurationObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setFor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'org' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolios' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetOrgEmissionFactorPreferencesMutation, SetOrgEmissionFactorPreferencesMutationVariables>;
export const ConfirmFileUploadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConfirmFileUpload' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'confirmFileUpload' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fileId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'fileId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fileName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConfirmFileUploadMutation, ConfirmFileUploadMutationVariables>;
export const GetAllPortfoliosAndBuildingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllPortfoliosAndBuildings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'portfolio' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccessRightsPortfolio' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'building' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AccessRightsBuilding' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccessRightsPortfolio' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'portfolio' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccessRightsBuilding' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'building' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'areas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'area_type_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'EnumValue', value: 'EBF' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type_of_use_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area_type_id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'created_at' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
          { kind: 'Field', name: { kind: 'Name', value: 'is_missing_energy_data' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'economic_unit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllPortfoliosAndBuildingsQuery, GetAllPortfoliosAndBuildingsQueryVariables>;
export const GetOrgPreferencesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOrgPreferences' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOrgPreferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'co2PriceCurveConfig' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'growthStartValue' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'growthAnnualPercent' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'anchors' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pricePerTon' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'co2PriceDefaultCurve' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEconomicUnitsInFileDriveToggled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isAutomaticActionCostUpdateToggled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSSOEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSSOAutoCreateUser' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'crremConfigurations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CRREMDefaultConfigurationObject' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CRREMDefaultConfiguration' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CRREMCustomConfigurationObject' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CRREMCustomConfiguration' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'availableReportingYears' } },
                { kind: 'Field', name: { kind: 'Name', value: 'euTaxonomyDatasource' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeEmissionFactorPreferences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CrremOrgPreferences' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emissionFactorType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'crremVersion' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'activeCRREMConfiguration' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'CRREMDefaultConfigurationObject' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'CRREMDefaultConfiguration' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: { kind: 'Name', value: 'CRREMCustomConfigurationObject' },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'CRREMCustomConfiguration' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'NationalEnergyLawOrgPreferences' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emissionFactorType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CRREMDefaultConfiguration' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CRREMDefaultConfigurationObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emissionFactorType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setFor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'org' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolios' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CRREMCustomConfiguration' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CRREMCustomConfigurationObject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setFor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'org' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'portfolios' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOrgPreferencesQuery, GetOrgPreferencesQueryVariables>;
export const AsyncJobSubscriptionOrgDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'AsyncJobSubscriptionOrg' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'async_job' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'org_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'orgId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AsyncJob' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AsyncJob' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'async_job' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entity_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AsyncJobSubscriptionOrgSubscription, AsyncJobSubscriptionOrgSubscriptionVariables>;
export const AsyncJobSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'AsyncJobSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'async_job' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entity_id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'entityId' } },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: '_eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order_by' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'created_at' },
                      value: { kind: 'EnumValue', value: 'desc' },
                    },
                  ],
                },
              },
              { kind: 'Argument', name: { kind: 'Name', value: 'limit' }, value: { kind: 'IntValue', value: '1' } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AsyncJob' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AsyncJob' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'async_job' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entity_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'user_id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'org_id' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AsyncJobSubscriptionSubscription, AsyncJobSubscriptionSubscriptionVariables>;
export const GetSearchBuildingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetSearchBuildings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search_string' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'portfolio_ids' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
          },
          defaultValue: { kind: 'NullValue' },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BuildingOrderByInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchBuildings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'portfolio_ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'portfolio_ids' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search_string' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search_string' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buildings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postal_code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'is_new_construction' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'has_energy_data' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSearchBuildingsQuery, GetSearchBuildingsQueryVariables>;
